/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(737);
	module.exports = __webpack_require__(511);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(47);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(622)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.23.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(59)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var self = module.exports = {
	
	  nullOrUndefined: function nullOrUndefined(obj) {
	    if (obj === undefined || obj === null) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	
	  parseStringParam: function parseStringParam(str, param) {
	    if (!str || !str.includes("?")) {
	      return null;
	    }
	    var split = str.split("?")[1].split("&");
	    var match = null;
	    _lodash2.default.forEach(split, function (p) {
	      if (p.split("=")[0] === param) {
	        match = p.split("=")[1];
	        return;
	      }
	    });
	    return match;
	  },
	
	  flexibleBool: function flexibleBool(entry) {
	    if (typeof entry === 'string' || entry instanceof String) {
	      entry = entry.toLowerCase();
	    }
	    if (entry === true || entry === "true") {
	      return true;
	    }
	    if (entry === false || entry === "false") {
	      return false;
	    }
	    return false;
	  },
	
	  shallowEqual: function shallowEqual(objA, objB) {
	    if (objA === objB) {
	      return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	      return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	      return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	      if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	        return false;
	      }
	    }
	
	    return true;
	  },
	
	  //check for required data or reroute to the start if updated
	  checkData: function checkData(data, entry_point) {
	    if (!data) {
	      var loc = window.location.href;
	      var root = loc.substring(0, loc.lastIndexOf('/'));
	      window.location = root + entry_point;
	    }
	  },
	
	  dpath: function dpath(mode, filepath, filename, webkey) {
	    if (mode === "local") {
	      return filepath + filename;
	    }
	    var stra = filepath.split(/[/]/);
	    var data = {};
	    for (var i = 0; i < stra.length; i++) {
	      if (stra[i] === "companies") {
	        data.company = stra[i + 1];
	      }
	      if (stra[i] === "projects") {
	        data.project = stra[i + 1];
	        data.folder = stra[i + 2];
	      }
	    }
	    return _config2.default.WEB_SERVER + "/protectedfile/download?company=" + data.company + "&project=" + data.project + "&subdir=" + data.folder + "&file=" + filename + "&mode=" + mode + "&webkey=" + webkey;
	  },
	
	  dp: function dp(screen, image, defaultImage, resProtected) {
	    var isProtected = resProtected;
	    if (isProtected === undefined) {
	      isProtected = true;
	    }
	
	    var imageFinal = image;
	
	    if (image === null || image === undefined) {
	      isProtected = false;
	      if (!defaultImage) {
	        imageFinal = { path: '/img/ui/', file_name: 'empty.png' };
	      } else {
	        //blank image path
	        imageFinal = defaultImage;
	      }
	    }
	
	    if (screen.mode === "local" || isProtected === false && screen.mode !== "local") {
	      imageFinal = imageFinal.path + imageFinal.file_name;
	      if (imageFinal.charAt(0) !== "/" && imageFinal.charAt(0) !== "\\") {
	        return "/" + imageFinal;
	      } else {
	        return imageFinal;
	      }
	    }
	
	    var stra = imageFinal.path.split(/[/]/);
	    var data = {};
	    for (var i = 0; i < stra.length; i++) {
	      if (stra[i] === "companies") {
	        data.company = stra[i + 1];
	      }
	      if (stra[i] === "projects") {
	        data.project = stra[i + 1];
	        data.folder = stra[i + 2];
	      }
	    }
	
	    // If the resource is a video that has been converted, use that resource.
	    var fileType = module.exports.getFileType(imageFinal.file_name);
	    var fileName = imageFinal.file_name;
	    if (imageFinal.conversion_status && imageFinal.conversion_status === "finished" && fileType === "video") {
	      if (imageFinal.preview_video_name) {
	        fileName = imageFinal.preview_video_name;
	      }
	    }
	
	    return _config2.default.WEB_SERVER + "/protectedfile/download?company=" + data.company + "&project=" + data.project + "&subdir=" + data.folder + "&file=" + fileName + "&mode=" + screen.mode + "&webkey=" + screen.webkey;
	  },
	
	  videoType: function videoType(file_name) {
	    if (!file_name) {
	      return null;
	    }
	    var videoExt = file_name.split('.').pop();
	    switch (videoExt) {
	      case 'mov':
	      case 'mp4':
	        return "video/mp4";
	      case 'webm':
	        return "video/webm";
	      case "ogg":
	        return "video/ogg";
	      default:
	        return null;
	    }
	  },
	
	  presetDp: function presetDp(name, image, screen) {
	    var defaultImg = { path: '/img/ui/', file_name: 'image_default.png' };
	    if (!image || !image.presets) {
	      return self.dp(screen, image, defaultImg);
	    } else {
	      var thumbImg = _lodash2.default.find(image.presets, function (preset) {
	        return preset.file_name.includes(name);
	      });
	      if (thumbImg) {
	        return self.dp(screen, thumbImg, defaultImg);
	      } else {
	        return self.dp(screen, image, defaultImg);
	      }
	    }
	  },
	
	  // donorsIncluded: function (donorCategories, include_categories) {
	  //     if (donorCategories.length === 0) {
	  //         return [];
	  //     }
	  //     let donorsGrouped = [];
	  //     _.forEach(donorCategories, (category) => {
	  //         if (category.donors.length > 0) {
	  //             _.forEach(include_categories, (icat) => {
	  //                 if (icat === category.id) {
	  //                     let pushGroup = { id: category.id, name: category.name, subheader: category.subheader, donors: category.donors, parent_category: category.parent_category, description: category.description };
	  //                     donorsGrouped.push(pushGroup);
	  //                 }
	  //             });
	  //         }
	  //     });
	  //     donorsGrouped = _.orderBy(donorsGrouped, 'rank', 'asc');
	  //     return donorsGrouped
	  // },
	
	  randomRangeFloat: function randomRangeFloat(min, max) {
	    if (max === undefined) {
	      max = min;
	      min = 0;
	    }
	
	    if (typeof min !== 'number' || typeof max !== 'number') {
	      throw new TypeError('Expected all arguments to be numbers');
	    }
	
	    return Math.random() * (max - min) + min;
	  },
	
	  getRandomInt: function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  },
	
	  loopIndex: function loopIndex(currentIndex, min, max, direction) {
	    if (direction === "forward") {
	      var result = currentIndex + 1;
	      if (result > max) {
	        return min;
	      }
	      return result;
	    } else {
	      var _result = currentIndex - 1;
	      if (_result < min) {
	        return max;
	      }
	      return _result;
	    }
	  },
	
	  getFileType: function getFileType(str) {
	    str = str.split('.');
	    var lowercaseExt = str[str.length - 1].toLowerCase();
	    var audioExtensions = ['mp3', 'wav', 'ogg', 'aac'];
	    var imageExtensions = ['jpg', 'jpeg', 'png', 'tiff', 'svg', 'gif'];
	    var videoExtensions = ['webm', 'mp4', 'mov'];
	
	    if (audioExtensions.indexOf(lowercaseExt) > -1) {
	      return "audio";
	    }
	
	    if (imageExtensions.indexOf(lowercaseExt) > -1) {
	      return "image";
	    }
	
	    if (videoExtensions.indexOf(lowercaseExt) > -1) {
	      return "video";
	    }
	
	    return "unsupported";
	  },
	
	
	  getUniqueFolderModules: function getUniqueFolderModules(folderModules, donorCategories, stories, folderId) {
	    var donors = self.getAllDonors(donorCategories);
	    var modules = (0, _lodash2.default)(folderModules).filter(function (fm) {
	      return fm.folder === Number(folderId);
	    }).uniqBy(function (fm) {
	      return [fm.module_id, fm.model].join();
	    }).map(function (fm) {
	      var module = [];
	      switch (fm.model) {
	        case "story":
	          module = _lodash2.default.find(stories, { id: fm.module_id });
	          break;
	        case "donor":
	          module = _lodash2.default.find(donors, { id: fm.module_id });
	          break;
	        default:
	          break;
	      }
	      if (module) {
	        module.rank = fm.rank;
	        module.folder_module = fm;
	      }
	      return module;
	    }).orderBy(['rank'], ['asc']).value();
	
	    return _lodash2.default.compact(modules);
	  },
	
	  getAllFolderModules: function getAllFolderModules(folderModules, donorCategories, stories, folderId) {
	    var donors = donorCategories ? self.getAllDonors(donorCategories) : [];
	    var modules = (0, _lodash2.default)(folderModules).filter(function (fm) {
	      return fm.folder === Number(folderId);
	    }).map(function (fm) {
	      var module = void 0;
	      switch (fm.model) {
	        case "story":
	          module = _lodash2.default.find(stories, { id: fm.module_id });
	          break;
	        case "donor":
	          module = _lodash2.default.find(donors, { id: fm.module_id });
	          break;
	        default:
	          break;
	      }
	      return Object.assign({}, module, { rank: fm.rank, folder_module: fm });
	    }).orderBy(['rank'], ['asc']).value();
	
	    return modules;
	  },
	
	  getAllDonors: function getAllDonors(donorCategories) {
	    var allDonors = [];
	    for (var i = 0; i < donorCategories.donorCategories.length; i++) {
	      if (donorCategories.donorCategories[i].donors.length > 0) {
	        allDonors = allDonors.concat(donorCategories.donorCategories[i].donors);
	      }
	    }
	
	    return allDonors;
	  },
	
	  createFolderTree: function createFolderTree(folders, folderModules, parent, allStories, activeModules, mainMenuName, sortingField, direction) {
	    if (self.nullOrUndefined(parent)) {
	      var mainName = void 0,
	          main = void 0;
	      if (typeof mainMenuName === "number") {
	        main = _lodash2.default.find(folders, { id: mainMenuName });
	      } else {
	        mainName = self.nullOrUndefined(mainMenuName) ? "Main" : mainMenuName;
	        main = _lodash2.default.find(folders, { name: mainName });
	      }
	      var children = self.createFolderTree(folders, folderModules, main, allStories, activeModules, mainMenuName, sortingField, direction);
	      main.children = children;
	      return main;
	    } else {
	      var _children = folders.filter(function (fl) {
	        return fl.parent_category === parent.id;
	      }).sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	      if (_children.length > 0) {
	        for (var i = 0; i < _children.length; i++) {
	          _children[i].children = self.createFolderTree(folders, folderModules, _children[i], allStories, activeModules, mainMenuName, sortingField, direction = "asc");
	        }
	        return _children;
	      } else {
	        var modules = [];
	        var folderFolderModules = _lodash2.default.filter(folderModules, { folder: parent.id });
	        var stories = [];
	        var foldersToPush = [];
	        var displayModules = [];
	
	        _lodash2.default.forEach(folderFolderModules, function (fm) {
	          switch (fm.model) {
	            case "display_module":
	              var dm = _lodash2.default.find(activeModules, { id: fm.module_id });
	              if (dm) {
	                var dmToPush = _lodash2.default.cloneDeep(dm);
	                dmToPush.node_type = 'display_module';
	                dmToPush.folder_module_id = fm.id;
	                dmToPush.rank = fm.rank;
	                displayModules.push(dmToPush);
	              }
	              break;
	            case "story":
	              var story = _lodash2.default.find(allStories, { id: fm.module_id });
	              if (story) {
	                var storyToPush = _lodash2.default.cloneDeep(story);
	                storyToPush.node_type = 'story';
	                storyToPush.folder_module_id = fm.id;
	                storyToPush.rank = fm.rank;
	                stories.push(storyToPush);
	              }
	              break;
	
	            case "folder":
	              var folder = _lodash2.default.find(folders, { id: fm.module_id });
	              if (folder) {
	                var folderToPush = _lodash2.default.cloneDeep(folder);
	                folderToPush.node_type = 'folder';
	                folderToPush.folder_module_id = fm.id;
	                folderToPush.rank = fm.rank;
	                foldersToPush.push(folderToPush);
	              }
	              break;
	
	            default:
	              break;
	          }
	        });
	
	        if (sortingField && sortingField !== "rank") {
	          if (sortingField.includes(".")) {
	            var arraySortingField = sortingField.split(".");
	            var sortingFieldName = arraySortingField[arraySortingField.length - 1];
	            stories = stories.map(function (st) {
	              var value = _lodash2.default.get(st, sortingField, null);
	              st[sortingFieldName] = value;
	              return st;
	            });
	
	            stories = _lodash2.default.orderBy(stories, [sortingFieldName], [direction]);
	          } else {
	            stories = _lodash2.default.orderBy(stories, [sortingField], [direction]);
	          }
	        }
	
	        if (stories.length > 0) {
	          modules = modules.concat(stories);
	        }
	
	        if (displayModules.length > 0) {
	          modules = modules.concat(displayModules);
	        }
	
	        if (foldersToPush.length > 0) {
	          modules = modules.concat(foldersToPush);
	        }
	
	        if (sortingField && sortingField === "rank") {
	          modules = modules.sort(function (a, b) {
	            if (direction === "asc") {
	              return b.rank - a.rank;
	            }
	            return a.rank - b.rank;
	          });
	        }
	
	        return modules;
	      }
	    }
	  },
	
	  createFolderTreeV2: function createFolderTreeV2(folders, folderModules, parent, allStories, activeModules, mainMenuName, sortingField) {
	    // console.log("calling");
	    if (self.nullOrUndefined(parent)) {
	      // console.log("here 1");
	      var mainName = self.nullOrUndefined(mainMenuName) ? "Main" : mainMenuName;
	      var main = _lodash2.default.find(folders, { name: mainName });
	      var children = self.createFolderTree(folders, folderModules, main, allStories, activeModules, mainMenuName, sortingField);
	      main.children = children;
	      return main;
	    } else {
	      // console.log("here 2");
	      var _children2 = folders.filter(function (fl) {
	        return fl.parent_category === parent.id;
	      }).sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	      if (_children2.length > 0) {
	        // console.log("here 3");
	        for (var i = 0; i < _children2.length; i++) {
	          _children2[i].children = self.createFolderTree(folders, folderModules, _children2[i], allStories, activeModules, mainMenuName, sortingField);
	        }
	        return _children2;
	      } else {
	        // console.log("here 4");
	        var modules = [];
	        var folderFolderModules = _lodash2.default.filter(folderModules, { folder: parent.id });
	        folderFolderModules = _lodash2.default.orderBy(folderFolderModules, "rank", "desc");
	        // console.log("folderFolderModules?", folderFolderModules)
	        _lodash2.default.forEach(folderFolderModules, function (fm) {
	          switch (fm.model) {
	            case "display_module":
	              var dm = _lodash2.default.find(activeModules, { id: fm.module_id });
	              if (dm) {
	                var dmToPush = _lodash2.default.cloneDeep(dm);
	                dmToPush.node_type = 'display_module';
	                dmToPush.folder_module_id = fm.id;
	                modules.push(dmToPush);
	              }
	              break;
	            case "story":
	              var story = _lodash2.default.find(allStories, { id: fm.module_id });
	              if (story) {
	                var storyToPush = _lodash2.default.cloneDeep(story);
	                storyToPush.node_type = 'story';
	                storyToPush.folder_module_id = fm.id;
	                modules.push(storyToPush);
	              }
	              break;
	
	            case "folder":
	              var folder = _lodash2.default.find(folders, { id: fm.module_id });
	              if (folder) {
	                var folderToPush = _lodash2.default.cloneDeep(folder);
	                folderToPush.node_type = 'folder';
	                folderToPush.folder_module_id = fm.id;
	                modules.push(folderToPush);
	              }
	              break;
	
	            default:
	              break;
	          }
	        });
	
	        if (sortingField) {
	          if (sortingField.includes(".")) {
	            var arraySortingField = sortingField.split(".");
	            var sortingFieldName = arraySortingField[arraySortingField.length - 1];
	            modules = modules.map(function (st) {
	              var value = _lodash2.default.get(st, sortingField, null);
	              st[sortingFieldName] = value;
	              return st;
	            });
	            modules = _lodash2.default.orderBy(modules, [sortingFieldName], ['asc']);
	          } else {
	            modules = _lodash2.default.orderBy(modules, [sortingField], ['asc']);
	          }
	        }
	        return modules;
	      }
	    }
	  },
	
	  getSubfoldersIdsRecursively: function getSubfoldersIdsRecursively(folders, parent) {
	    var results = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var foundFolders = folders.filter(function (fl) {
	      return fl.parent_category === parent;
	    }).map(function (fl) {
	      return fl.id;
	    });
	    results = results.concat(foundFolders);
	    if (foundFolders.length > 0) {
	      for (var i = 0; i < foundFolders.length; i++) {
	        results = self.getSubfoldersIdsRecursively(folders, foundFolders[i], results);
	      }
	      return results;
	    } else {
	      return results;
	    }
	  },
	
	  getRandomStr: function getRandomStr() {
	    var text = "";
	    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	
	    for (var i = 0; i < 5; i++) {
	      text += possible.charAt(Math.floor(Math.random() * possible.length));
	    }return text;
	  },
	
	  appendPrependQuillOps: function appendPrependQuillOps(ops, append, prepend) {
	    if (ops[0] && ops[0].attributes) {
	      append.attributes = ops[0].attributes;
	      prepend.attributes = ops[0].attributes;
	    }
	
	    ops.unshift(prepend);
	    ops.push({});
	    ops[ops.length - 2] = ops[ops.length - 1];
	    ops[ops.length - 1] = append;
	
	    return ops;
	  },
	
	  parseTextStyling: function parseTextStyling(style) {
	    if (!style) {
	      return null;
	    }
	
	    var fontFamily = _lodash2.default.get(style, 'font', _lodash2.default.get(style, 'default.font', null));
	    var color = _lodash2.default.get(style, 'fontColor', _lodash2.default.get(style, 'default.fontColor', null));
	    var fontSize = _lodash2.default.get(style, 'fontSize', _lodash2.default.get(style, 'default.fontSize', null));
	    var fontStyle = _lodash2.default.get(style, 'fontStyle', _lodash2.default.get(style, 'default.fontStyle', null));
	    var fontWeight = _lodash2.default.get(style, 'fontWeight', _lodash2.default.get(style, 'default.fontWeight', null));
	    var textAlign = _lodash2.default.get(style, 'justification', _lodash2.default.get(style, 'default.justification', null));
	    var lineHeight = _lodash2.default.get(style, 'height', _lodash2.default.get(style, 'default.height', null));
	    var visibility = _lodash2.default.get(style, 'visible', _lodash2.default.get(style, 'default.visible', null));
	
	    return {
	      fontFamily: fontFamily,
	      color: color,
	      fontSize: fontSize + 'vh',
	      fontStyle: fontStyle,
	      fontWeight: fontWeight,
	      textAlign: textAlign,
	      lineHeight: lineHeight + 'vh',
	      visibility: visibility ? "visible" : "hidden"
	    };
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	var _interopRequireWildcard = __webpack_require__(369);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(709));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(343));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(710));
	
	exports.connect = _connect.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(749);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(748);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 8 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _deepEqual = __webpack_require__(526);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var excludePropNames = ['defer', 'iScroll', 'onRefresh', 'options'];
	
	// Events available on iScroll instance
	// {`react component event name`: `iScroll event name`}
	var availableEventNames = {};
	var iScrollEventNames = ['beforeScrollStart', 'scrollCancel', 'scrollStart', 'scroll', 'scrollEnd', 'flick', 'zoomStart', 'zoomEnd'];
	
	for (var i = 0, len = iScrollEventNames.length; i < len; i++) {
	  var iScrollEventName = iScrollEventNames[i];
	  var reactEventName = 'on' + iScrollEventName[0].toUpperCase() + iScrollEventName.slice(1);
	  availableEventNames[reactEventName] = iScrollEventName;
	  excludePropNames.push(reactEventName);
	}
	
	var ReactIScroll = function (_React$Component) {
	  _inherits(ReactIScroll, _React$Component);
	
	  function ReactIScroll(props) {
	    _classCallCheck(this, ReactIScroll);
	
	    var _this = _possibleConstructorReturn(this, (ReactIScroll.__proto__ || Object.getPrototypeOf(ReactIScroll)).call(this, props));
	
	    _this._isMounted = false;
	    _this._initializeTimeout = null;
	    _this._queuedCallbacks = [];
	    _this._iScrollBindedEvents = {};
	    return _this;
	  }
	
	  _createClass(ReactIScroll, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this._initializeIScroll();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      this._teardownIScroll();
	    }
	
	    // There is no state, we can compare only props.
	
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextContext) {
	      return !(0, _deepEqual2.default)(this.props, nextProps) || !(0, _deepEqual2.default)(this.context, nextContext);
	    }
	
	    // Check if iScroll options has changed and recreate instance with new one
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      // If options are same, iScroll behaviour will not change. Just refresh events and trigger refresh
	      if ((0, _deepEqual2.default)(prevProps.options, this.props.options)) {
	        this._updateIScrollEvents(prevProps, this.props);
	        this.refresh();
	
	        // If options changed, we will destroy iScroll instance and create new one with same scroll position
	        // TODO test if this will work with indicators
	      } else {
	        this.withIScroll(true, function (iScrollInstance) {
	          // Save current state
	          var x = iScrollInstance.x,
	              y = iScrollInstance.y,
	              scale = iScrollInstance.scale;
	
	          // Destroy current and Create new instance of iScroll
	
	          _this2._teardownIScroll();
	          _this2._initializeIScroll();
	
	          _this2.withIScroll(true, function (newIScrollInstance) {
	            // Restore previous state
	            if (scale && newIScrollInstance.zoom) {
	              newIScrollInstance.zoom(scale, 0, 0, 0);
	            }
	
	            newIScrollInstance.scrollTo(x, y);
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getIScroll',
	    value: function getIScroll() {
	      return this._iScrollInstance;
	    }
	  }, {
	    key: 'getIScrollInstance',
	    value: function getIScrollInstance() {
	      console.warn("Function 'getIScrollInstance' is deprecated. Instead use 'getIScroll'");
	      return this._iScrollInstance;
	    }
	  }, {
	    key: 'withIScroll',
	    value: function withIScroll(waitForInit, callback) {
	      if (!callback && typeof waitForInit == 'function') {
	        callback = waitForInit;
	      }
	
	      if (this.getIScroll()) {
	        callback(this.getIScroll());
	      } else if (waitForInit === true) {
	        this._queuedCallbacks.push(callback);
	      }
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.withIScroll(function (iScrollInstance) {
	        return iScrollInstance.refresh();
	      });
	    }
	  }, {
	    key: '_runInitializeIScroll',
	    value: function _runInitializeIScroll() {
	      var _this3 = this;
	
	      var _props = this.props,
	          iScroll = _props.iScroll,
	          options = _props.options;
	
	      // Create iScroll instance with given options
	
	      var iScrollInstance = new iScroll(_reactDom2.default.findDOMNode(this), options);
	      this._iScrollInstance = iScrollInstance;
	
	      // TODO there should be new event 'onInitialize'
	      this._triggerRefreshEvent();
	
	      // Patch iScroll instance .refresh() function to trigger our onRefresh event
	      iScrollInstance.originalRefresh = iScrollInstance.refresh;
	
	      iScrollInstance.refresh = function () {
	        iScrollInstance.originalRefresh.apply(iScrollInstance);
	        _this3._triggerRefreshEvent();
	      };
	
	      // Bind iScroll events
	      this._bindIScrollEvents();
	
	      this._callQueuedCallbacks();
	    }
	  }, {
	    key: '_initializeIScroll',
	    value: function _initializeIScroll() {
	      var _this4 = this;
	
	      if (this._isMounted === false) {
	        return;
	      }
	
	      var defer = this.props.defer;
	
	
	      if (defer === false) {
	        this._runInitializeIScroll();
	      } else {
	        var timeout = defer === true ? 0 : defer;
	        this._initializeTimeout = setTimeout(function () {
	          return _this4._runInitializeIScroll();
	        }, timeout);
	      }
	    }
	  }, {
	    key: '_callQueuedCallbacks',
	    value: function _callQueuedCallbacks() {
	      var callbacks = this._queuedCallbacks,
	          len = callbacks.length;
	
	      this._queuedCallbacks = [];
	
	      for (var _i = 0; _i < len; _i++) {
	        callbacks[_i](this.getIScroll());
	      }
	    }
	  }, {
	    key: '_teardownIScroll',
	    value: function _teardownIScroll() {
	      this._clearInitializeTimeout();
	
	      if (this._iScrollInstance) {
	        this._iScrollInstance.destroy();
	        this._iScrollInstance = undefined;
	      }
	
	      this._iScrollBindedEvents = {};
	      this._queuedCallbacks = [];
	    }
	  }, {
	    key: '_clearInitializeTimeout',
	    value: function _clearInitializeTimeout() {
	      if (this._initializeTimeout !== null) {
	        clearTimeout(this._initializeTimeout);
	        this._initializeTimeout = null;
	      }
	    }
	  }, {
	    key: '_bindIScrollEvents',
	    value: function _bindIScrollEvents() {
	      // Bind events on iScroll instance
	      this._iScrollBindedEvents = {};
	      this._updateIScrollEvents({}, this.props);
	    }
	
	    // Iterate through available events and update one by one
	
	  }, {
	    key: '_updateIScrollEvents',
	    value: function _updateIScrollEvents(prevProps, nextProps) {
	      for (var _reactEventName in availableEventNames) {
	        this._updateIScrollEvent(availableEventNames[_reactEventName], prevProps[_reactEventName], nextProps[_reactEventName]);
	      }
	    }
	
	    // Unbind and/or Bind event if it was changed during update
	
	  }, {
	    key: '_updateIScrollEvent',
	    value: function _updateIScrollEvent(iScrollEventName, prevPropEvent, currentPropEvent) {
	      if (prevPropEvent !== currentPropEvent) {
	        var currentEvents = this._iScrollBindedEvents;
	
	        this.withIScroll(true, function (iScrollInstance) {
	          if (prevPropEvent !== undefined) {
	            iScrollInstance.off(iScrollEventName, currentEvents[iScrollEventName]);
	            currentEvents[iScrollEventName] = undefined;
	          }
	
	          if (currentPropEvent !== undefined) {
	            var wrappedCallback = function wrappedCallback() {
	              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	              }
	
	              currentPropEvent.apply(undefined, [iScrollInstance].concat(args));
	            };
	
	            iScrollInstance.on(iScrollEventName, wrappedCallback);
	            currentEvents[iScrollEventName] = wrappedCallback;
	          }
	        });
	      }
	    }
	  }, {
	    key: '_triggerRefreshEvent',
	    value: function _triggerRefreshEvent() {
	      var onRefresh = this.props.onRefresh;
	
	
	      if (typeof onRefresh === 'function') {
	        this.withIScroll(function (iScrollInstance) {
	          return onRefresh(iScrollInstance);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Keep only non ReactIScroll properties
	      var props = {};
	
	      for (var prop in this.props) {
	        if (!~excludePropNames.indexOf(prop)) {
	          props[prop] = this.props[prop];
	        }
	      }
	
	      return _react2.default.createElement('div', props);
	    }
	  }]);
	
	  return ReactIScroll;
	}(_react2.default.Component);
	
	ReactIScroll.displayName = 'ReactIScroll';
	ReactIScroll.defaultProps = {
	  defer: true,
	  options: {},
	  style: {
	    position: 'relative',
	    height: '100%',
	    width: '100%',
	    overflow: 'hidden'
	  }
	};
	exports.default = ReactIScroll;
	
	
	if (false) {
	  var propTypesMaker = require('./prop_types').default;
	  ReactIScroll.propTypes = propTypesMaker(availableEventNames);
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BRSpan = function BRSpan(props) {
	
	  var className = "";
	  if (props.preWrap) {
	    className += "whiteSpaceAndBreaks";
	  }
	
	  var splitStr = function splitStr() {
	    var str = props.str;
	    if (!str) {
	      return _react2.default.createElement("span", null);
	    }
	    var splitline = false;
	    if (str.includes("<br>")) {
	      str = str.split("<br>");
	      splitline = true;
	    } else if (str.includes("<BR>")) {
	      str = str.split("<BR>");
	      splitline = true;
	    }
	    if (splitline === false) {
	      return _react2.default.createElement(
	        "span",
	        { className: className },
	        str
	      );
	    } else {
	      return str.map(function (row, i) {
	        return _react2.default.createElement(
	          "span",
	          { className: className, key: i },
	          row,
	          i < str.length ? _react2.default.createElement("br", null) : _react2.default.createElement("span", null)
	        );
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    "span",
	    { className: className },
	    splitStr()
	  );
	};
	
	exports.default = BRSpan;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
	(function (window, document, Math) {
	var rAF = window.requestAnimationFrame	||
		window.webkitRequestAnimationFrame	||
		window.mozRequestAnimationFrame		||
		window.oRequestAnimationFrame		||
		window.msRequestAnimationFrame		||
		function (callback) { window.setTimeout(callback, 1000 / 60); };
	
	var utils = (function () {
		var me = {};
	
		var _elementStyle = document.createElement('div').style;
		var _vendor = (function () {
			var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
				transform,
				i = 0,
				l = vendors.length;
	
			for ( ; i < l; i++ ) {
				transform = vendors[i] + 'ransform';
				if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
			}
	
			return false;
		})();
	
		function _prefixStyle (style) {
			if ( _vendor === false ) return false;
			if ( _vendor === '' ) return style;
			return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
		}
	
		me.getTime = Date.now || function getTime () { return new Date().getTime(); };
	
		me.extend = function (target, obj) {
			for ( var i in obj ) {
				target[i] = obj[i];
			}
		};
	
		me.addEvent = function (el, type, fn, capture) {
			el.addEventListener(type, fn, !!capture);
		};
	
		me.removeEvent = function (el, type, fn, capture) {
			el.removeEventListener(type, fn, !!capture);
		};
	
		me.prefixPointerEvent = function (pointerEvent) {
			return window.MSPointerEvent ?
				'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
				pointerEvent;
		};
	
		me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
			var distance = current - start,
				speed = Math.abs(distance) / time,
				destination,
				duration;
	
			deceleration = deceleration === undefined ? 0.0006 : deceleration;
	
			destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
			duration = speed / deceleration;
	
			if ( destination < lowerMargin ) {
				destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
				distance = Math.abs(destination - current);
				duration = distance / speed;
			} else if ( destination > 0 ) {
				destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
				distance = Math.abs(current) + destination;
				duration = distance / speed;
			}
	
			return {
				destination: Math.round(destination),
				duration: duration
			};
		};
	
		var _transform = _prefixStyle('transform');
	
		me.extend(me, {
			hasTransform: _transform !== false,
			hasPerspective: _prefixStyle('perspective') in _elementStyle,
			hasTouch: 'ontouchstart' in window,
			hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
			hasTransition: _prefixStyle('transition') in _elementStyle
		});
	
		/*
		This should find all Android browsers lower than build 535.19 (both stock browser and webview)
		- galaxy S2 is ok
	    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
	    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S3 is badAndroid (stock brower, webview)
	     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S4 is badAndroid (stock brower, webview)
	     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S5 is OK
	     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
	   - galaxy S6 is OK
	     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
	  */
		me.isBadAndroid = (function() {
			var appVersion = window.navigator.appVersion;
			// Android browser is not a chrome browser.
			if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
				var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
				if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
					return parseFloat(safariVersion[1]) < 535.19;
				} else {
					return true;
				}
			} else {
				return false;
			}
		})();
	
		me.extend(me.style = {}, {
			transform: _transform,
			transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
			transitionDuration: _prefixStyle('transitionDuration'),
			transitionDelay: _prefixStyle('transitionDelay'),
			transformOrigin: _prefixStyle('transformOrigin')
		});
	
		me.hasClass = function (e, c) {
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
			return re.test(e.className);
		};
	
		me.addClass = function (e, c) {
			if ( me.hasClass(e, c) ) {
				return;
			}
	
			var newclass = e.className.split(' ');
			newclass.push(c);
			e.className = newclass.join(' ');
		};
	
		me.removeClass = function (e, c) {
			if ( !me.hasClass(e, c) ) {
				return;
			}
	
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
			e.className = e.className.replace(re, ' ');
		};
	
		me.offset = function (el) {
			var left = -el.offsetLeft,
				top = -el.offsetTop;
	
			// jshint -W084
			while (el = el.offsetParent) {
				left -= el.offsetLeft;
				top -= el.offsetTop;
			}
			// jshint +W084
	
			return {
				left: left,
				top: top
			};
		};
	
		me.preventDefaultException = function (el, exceptions) {
			for ( var i in exceptions ) {
				if ( exceptions[i].test(el[i]) ) {
					return true;
				}
			}
	
			return false;
		};
	
		me.extend(me.eventType = {}, {
			touchstart: 1,
			touchmove: 1,
			touchend: 1,
	
			mousedown: 2,
			mousemove: 2,
			mouseup: 2,
	
			pointerdown: 3,
			pointermove: 3,
			pointerup: 3,
	
			MSPointerDown: 3,
			MSPointerMove: 3,
			MSPointerUp: 3
		});
	
		me.extend(me.ease = {}, {
			quadratic: {
				style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
				fn: function (k) {
					return k * ( 2 - k );
				}
			},
			circular: {
				style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
				fn: function (k) {
					return Math.sqrt( 1 - ( --k * k ) );
				}
			},
			back: {
				style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
				fn: function (k) {
					var b = 4;
					return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
				}
			},
			bounce: {
				style: '',
				fn: function (k) {
					if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
						return 7.5625 * k * k;
					} else if ( k < ( 2 / 2.75 ) ) {
						return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
					} else if ( k < ( 2.5 / 2.75 ) ) {
						return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
					} else {
						return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
					}
				}
			},
			elastic: {
				style: '',
				fn: function (k) {
					var f = 0.22,
						e = 0.4;
	
					if ( k === 0 ) { return 0; }
					if ( k == 1 ) { return 1; }
	
					return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
				}
			}
		});
	
		me.tap = function (e, eventName) {
			var ev = document.createEvent('Event');
			ev.initEvent(eventName, true, true);
			ev.pageX = e.pageX;
			ev.pageY = e.pageY;
			e.target.dispatchEvent(ev);
		};
	
		me.click = function (e) {
			var target = e.target,
				ev;
	
			if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
				ev = document.createEvent('MouseEvents');
				ev.initMouseEvent('click', true, true, e.view, 1,
					target.screenX, target.screenY, target.clientX, target.clientY,
					e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
					0, null);
	
				ev._constructed = true;
				target.dispatchEvent(ev);
			}
		};
	
		return me;
	})();
	function IScroll (el, options) {
		this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
		this.scroller = this.wrapper.children[0];
		this.scrollerStyle = this.scroller.style;		// cache style for better performance
	
		this.options = {
	
			resizeScrollbars: true,
	
			mouseWheelSpeed: 20,
	
			snapThreshold: 0.334,
	
	// INSERT POINT: OPTIONS
			disablePointer : !utils.hasPointer,
			disableTouch : utils.hasPointer || !utils.hasTouch,
			disableMouse : utils.hasPointer || utils.hasTouch,
			startX: 0,
			startY: 0,
			scrollY: true,
			directionLockThreshold: 5,
			momentum: true,
	
			bounce: true,
			bounceTime: 600,
			bounceEasing: '',
	
			preventDefault: true,
			preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },
	
			HWCompositing: true,
			useTransition: true,
			useTransform: true,
			bindToWrapper: typeof window.onmousedown === "undefined"
		};
	
		for ( var i in options ) {
			this.options[i] = options[i];
		}
	
		// Normalize options
		this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
	
		this.options.useTransition = utils.hasTransition && this.options.useTransition;
		this.options.useTransform = utils.hasTransform && this.options.useTransform;
	
		this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
		this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
	
		// If you want eventPassthrough I have to lock one of the axes
		this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
		this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
	
		// With eventPassthrough we also need lockDirection mechanism
		this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
		this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
	
		this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
	
		this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
	
		if ( this.options.tap === true ) {
			this.options.tap = 'tap';
		}
	
		if ( this.options.shrinkScrollbars == 'scale' ) {
			this.options.useTransition = false;
		}
	
		this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
	
	// INSERT POINT: NORMALIZATION
	
		// Some defaults
		this.x = 0;
		this.y = 0;
		this.directionX = 0;
		this.directionY = 0;
		this._events = {};
	
	// INSERT POINT: DEFAULTS
	
		this._init();
		this.refresh();
	
		this.scrollTo(this.options.startX, this.options.startY);
		this.enable();
	}
	
	IScroll.prototype = {
		version: '5.2.0',
	
		_init: function () {
			this._initEvents();
	
			if ( this.options.scrollbars || this.options.indicators ) {
				this._initIndicators();
			}
	
			if ( this.options.mouseWheel ) {
				this._initWheel();
			}
	
			if ( this.options.snap ) {
				this._initSnap();
			}
	
			if ( this.options.keyBindings ) {
				this._initKeys();
			}
	
	// INSERT POINT: _init
	
		},
	
		destroy: function () {
			this._initEvents(true);
			clearTimeout(this.resizeTimeout);
	 		this.resizeTimeout = null;
			this._execEvent('destroy');
		},
	
		_transitionEnd: function (e) {
			if ( e.target != this.scroller || !this.isInTransition ) {
				return;
			}
	
			this._transitionTime();
			if ( !this.resetPosition(this.options.bounceTime) ) {
				this.isInTransition = false;
				this._execEvent('scrollEnd');
			}
		},
	
		_start: function (e) {
			// React to left mouse button only
			if ( utils.eventType[e.type] != 1 ) {
			  // for button property
			  // http://unixpapa.com/js/mouse.html
			  var button;
		    if (!e.which) {
		      /* IE case */
		      button = (e.button < 2) ? 0 :
		               ((e.button == 4) ? 1 : 2);
		    } else {
		      /* All others */
		      button = e.button;
		    }
				if ( button !== 0 ) {
					return;
				}
			}
	
			if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
				return;
			}
	
			if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
				e.preventDefault();
			}
	
			var point = e.touches ? e.touches[0] : e,
				pos;
	
			this.initiated	= utils.eventType[e.type];
			this.moved		= false;
			this.distX		= 0;
			this.distY		= 0;
			this.directionX = 0;
			this.directionY = 0;
			this.directionLocked = 0;
	
			this.startTime = utils.getTime();
	
			if ( this.options.useTransition && this.isInTransition ) {
				this._transitionTime();
				this.isInTransition = false;
				pos = this.getComputedPosition();
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this._execEvent('scrollEnd');
			} else if ( !this.options.useTransition && this.isAnimating ) {
				this.isAnimating = false;
				this._execEvent('scrollEnd');
			}
	
			this.startX    = this.x;
			this.startY    = this.y;
			this.absStartX = this.x;
			this.absStartY = this.y;
			this.pointX    = point.pageX;
			this.pointY    = point.pageY;
	
			this._execEvent('beforeScrollStart');
		},
	
		_move: function (e) {
			if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
				return;
			}
	
			if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
				e.preventDefault();
			}
	
			var point		= e.touches ? e.touches[0] : e,
				deltaX		= point.pageX - this.pointX,
				deltaY		= point.pageY - this.pointY,
				timestamp	= utils.getTime(),
				newX, newY,
				absDistX, absDistY;
	
			this.pointX		= point.pageX;
			this.pointY		= point.pageY;
	
			this.distX		+= deltaX;
			this.distY		+= deltaY;
			absDistX		= Math.abs(this.distX);
			absDistY		= Math.abs(this.distY);
	
			// We need to move at least 10 pixels for the scrolling to initiate
			if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
				return;
			}
	
			// If you are scrolling in one direction lock the other
			if ( !this.directionLocked && !this.options.freeScroll ) {
				if ( absDistX > absDistY + this.options.directionLockThreshold ) {
					this.directionLocked = 'h';		// lock horizontally
				} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
					this.directionLocked = 'v';		// lock vertically
				} else {
					this.directionLocked = 'n';		// no lock
				}
			}
	
			if ( this.directionLocked == 'h' ) {
				if ( this.options.eventPassthrough == 'vertical' ) {
					e.preventDefault();
				} else if ( this.options.eventPassthrough == 'horizontal' ) {
					this.initiated = false;
					return;
				}
	
				deltaY = 0;
			} else if ( this.directionLocked == 'v' ) {
				if ( this.options.eventPassthrough == 'horizontal' ) {
					e.preventDefault();
				} else if ( this.options.eventPassthrough == 'vertical' ) {
					this.initiated = false;
					return;
				}
	
				deltaX = 0;
			}
	
			deltaX = this.hasHorizontalScroll ? deltaX : 0;
			deltaY = this.hasVerticalScroll ? deltaY : 0;
	
			newX = this.x + deltaX;
			newY = this.y + deltaY;
	
			// Slow down if outside of the boundaries
			if ( newX > 0 || newX < this.maxScrollX ) {
				newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
			}
			if ( newY > 0 || newY < this.maxScrollY ) {
				newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
			}
	
			this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
			this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
	
			if ( !this.moved ) {
				this._execEvent('scrollStart');
			}
	
			this.moved = true;
	
			this._translate(newX, newY);
	
	/* REPLACE START: _move */
	
			if ( timestamp - this.startTime > 300 ) {
				this.startTime = timestamp;
				this.startX = this.x;
				this.startY = this.y;
			}
	
	/* REPLACE END: _move */
	
		},
	
		_end: function (e) {
			if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
				return;
			}
	
			if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
				e.preventDefault();
			}
	
			var point = e.changedTouches ? e.changedTouches[0] : e,
				momentumX,
				momentumY,
				duration = utils.getTime() - this.startTime,
				newX = Math.round(this.x),
				newY = Math.round(this.y),
				distanceX = Math.abs(newX - this.startX),
				distanceY = Math.abs(newY - this.startY),
				time = 0,
				easing = '';
	
			this.isInTransition = 0;
			this.initiated = 0;
			this.endTime = utils.getTime();
	
			// reset if we are outside of the boundaries
			if ( this.resetPosition(this.options.bounceTime) ) {
				return;
			}
	
			this.scrollTo(newX, newY);	// ensures that the last position is rounded
	
			// we scrolled less than 10 pixels
			if ( !this.moved ) {
				if ( this.options.tap ) {
					utils.tap(e, this.options.tap);
				}
	
				if ( this.options.click ) {
					utils.click(e);
				}
	
				this._execEvent('scrollCancel');
				return;
			}
	
			if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
				this._execEvent('flick');
				return;
			}
	
			// start momentum animation if needed
			if ( this.options.momentum && duration < 300 ) {
				momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
				momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
				newX = momentumX.destination;
				newY = momentumY.destination;
				time = Math.max(momentumX.duration, momentumY.duration);
				this.isInTransition = 1;
			}
	
	
			if ( this.options.snap ) {
				var snap = this._nearestSnap(newX, newY);
				this.currentPage = snap;
				time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(newX - snap.x), 1000),
							Math.min(Math.abs(newY - snap.y), 1000)
						), 300);
				newX = snap.x;
				newY = snap.y;
	
				this.directionX = 0;
				this.directionY = 0;
				easing = this.options.bounceEasing;
			}
	
	// INSERT POINT: _end
	
			if ( newX != this.x || newY != this.y ) {
				// change easing function when scroller goes out of the boundaries
				if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
					easing = utils.ease.quadratic;
				}
	
				this.scrollTo(newX, newY, time, easing);
				return;
			}
	
			this._execEvent('scrollEnd');
		},
	
		_resize: function () {
			var that = this;
	
			clearTimeout(this.resizeTimeout);
	
			this.resizeTimeout = setTimeout(function () {
				that.refresh();
			}, this.options.resizePolling);
		},
	
		resetPosition: function (time) {
			var x = this.x,
				y = this.y;
	
			time = time || 0;
	
			if ( !this.hasHorizontalScroll || this.x > 0 ) {
				x = 0;
			} else if ( this.x < this.maxScrollX ) {
				x = this.maxScrollX;
			}
	
			if ( !this.hasVerticalScroll || this.y > 0 ) {
				y = 0;
			} else if ( this.y < this.maxScrollY ) {
				y = this.maxScrollY;
			}
	
			if ( x == this.x && y == this.y ) {
				return false;
			}
	
			this.scrollTo(x, y, time, this.options.bounceEasing);
	
			return true;
		},
	
		disable: function () {
			this.enabled = false;
		},
	
		enable: function () {
			this.enabled = true;
		},
	
		refresh: function () {
			var rf = this.wrapper.offsetHeight;		// Force reflow
	
			this.wrapperWidth	= this.wrapper.clientWidth;
			this.wrapperHeight	= this.wrapper.clientHeight;
	
	/* REPLACE START: refresh */
	
			this.scrollerWidth	= this.scroller.offsetWidth;
			this.scrollerHeight	= this.scroller.offsetHeight;
	
			this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
			this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;
	
	/* REPLACE END: refresh */
	
			this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
			this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;
	
			if ( !this.hasHorizontalScroll ) {
				this.maxScrollX = 0;
				this.scrollerWidth = this.wrapperWidth;
			}
	
			if ( !this.hasVerticalScroll ) {
				this.maxScrollY = 0;
				this.scrollerHeight = this.wrapperHeight;
			}
	
			this.endTime = 0;
			this.directionX = 0;
			this.directionY = 0;
	
			this.wrapperOffset = utils.offset(this.wrapper);
	
			this._execEvent('refresh');
	
			this.resetPosition();
	
	// INSERT POINT: _refresh
	
		},
	
		on: function (type, fn) {
			if ( !this._events[type] ) {
				this._events[type] = [];
			}
	
			this._events[type].push(fn);
		},
	
		off: function (type, fn) {
			if ( !this._events[type] ) {
				return;
			}
	
			var index = this._events[type].indexOf(fn);
	
			if ( index > -1 ) {
				this._events[type].splice(index, 1);
			}
		},
	
		_execEvent: function (type) {
			if ( !this._events[type] ) {
				return;
			}
	
			var i = 0,
				l = this._events[type].length;
	
			if ( !l ) {
				return;
			}
	
			for ( ; i < l; i++ ) {
				this._events[type][i].apply(this, [].slice.call(arguments, 1));
			}
		},
	
		scrollBy: function (x, y, time, easing) {
			x = this.x + x;
			y = this.y + y;
			time = time || 0;
	
			this.scrollTo(x, y, time, easing);
		},
	
		scrollTo: function (x, y, time, easing) {
			easing = easing || utils.ease.circular;
	
			this.isInTransition = this.options.useTransition && time > 0;
			var transitionType = this.options.useTransition && easing.style;
			if ( !time || transitionType ) {
					if(transitionType) {
						this._transitionTimingFunction(easing.style);
						this._transitionTime(time);
					}
				this._translate(x, y);
			} else {
				this._animate(x, y, time, easing.fn);
			}
		},
	
		scrollToElement: function (el, time, offsetX, offsetY, easing) {
			el = el.nodeType ? el : this.scroller.querySelector(el);
	
			if ( !el ) {
				return;
			}
	
			var pos = utils.offset(el);
	
			pos.left -= this.wrapperOffset.left;
			pos.top  -= this.wrapperOffset.top;
	
			// if offsetX/Y are true we center the element to the screen
			if ( offsetX === true ) {
				offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
			}
			if ( offsetY === true ) {
				offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
			}
	
			pos.left -= offsetX || 0;
			pos.top  -= offsetY || 0;
	
			pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
			pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;
	
			time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;
	
			this.scrollTo(pos.left, pos.top, time, easing);
		},
	
		_transitionTime: function (time) {
			time = time || 0;
	
			var durationProp = utils.style.transitionDuration;
			this.scrollerStyle[durationProp] = time + 'ms';
	
			if ( !time && utils.isBadAndroid ) {
				this.scrollerStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function() {
					if(self.scrollerStyle[durationProp] === '0.0001ms') {
						self.scrollerStyle[durationProp] = '0s';
					}
				});
			}
	
	
			if ( this.indicators ) {
				for ( var i = this.indicators.length; i--; ) {
					this.indicators[i].transitionTime(time);
				}
			}
	
	
	// INSERT POINT: _transitionTime
	
		},
	
		_transitionTimingFunction: function (easing) {
			this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
	
	
			if ( this.indicators ) {
				for ( var i = this.indicators.length; i--; ) {
					this.indicators[i].transitionTimingFunction(easing);
				}
			}
	
	
	// INSERT POINT: _transitionTimingFunction
	
		},
	
		_translate: function (x, y) {
			if ( this.options.useTransform ) {
	
	/* REPLACE START: _translate */
	
				this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
	
	/* REPLACE END: _translate */
	
			} else {
				x = Math.round(x);
				y = Math.round(y);
				this.scrollerStyle.left = x + 'px';
				this.scrollerStyle.top = y + 'px';
			}
	
			this.x = x;
			this.y = y;
	
	
		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].updatePosition();
			}
		}
	
	
	// INSERT POINT: _translate
	
		},
	
		_initEvents: function (remove) {
			var eventType = remove ? utils.removeEvent : utils.addEvent,
				target = this.options.bindToWrapper ? this.wrapper : window;
	
			eventType(window, 'orientationchange', this);
			eventType(window, 'resize', this);
	
			if ( this.options.click ) {
				eventType(this.wrapper, 'click', this, true);
			}
	
			if ( !this.options.disableMouse ) {
				eventType(this.wrapper, 'mousedown', this);
				eventType(target, 'mousemove', this);
				eventType(target, 'mousecancel', this);
				eventType(target, 'mouseup', this);
			}
	
			if ( utils.hasPointer && !this.options.disablePointer ) {
				eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
				eventType(target, utils.prefixPointerEvent('pointermove'), this);
				eventType(target, utils.prefixPointerEvent('pointercancel'), this);
				eventType(target, utils.prefixPointerEvent('pointerup'), this);
			}
	
			if ( utils.hasTouch && !this.options.disableTouch ) {
				eventType(this.wrapper, 'touchstart', this);
				eventType(target, 'touchmove', this);
				eventType(target, 'touchcancel', this);
				eventType(target, 'touchend', this);
			}
	
			eventType(this.scroller, 'transitionend', this);
			eventType(this.scroller, 'webkitTransitionEnd', this);
			eventType(this.scroller, 'oTransitionEnd', this);
			eventType(this.scroller, 'MSTransitionEnd', this);
		},
	
		getComputedPosition: function () {
			var matrix = window.getComputedStyle(this.scroller, null),
				x, y;
	
			if ( this.options.useTransform ) {
				matrix = matrix[utils.style.transform].split(')')[0].split(', ');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +matrix.left.replace(/[^-\d.]/g, '');
				y = +matrix.top.replace(/[^-\d.]/g, '');
			}
	
			return { x: x, y: y };
		},
		_initIndicators: function () {
			var interactive = this.options.interactiveScrollbars,
				customStyle = typeof this.options.scrollbars != 'string',
				indicators = [],
				indicator;
	
			var that = this;
	
			this.indicators = [];
	
			if ( this.options.scrollbars ) {
				// Vertical scrollbar
				if ( this.options.scrollY ) {
					indicator = {
						el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenX: false
					};
	
					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
	
				// Horizontal scrollbar
				if ( this.options.scrollX ) {
					indicator = {
						el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenY: false
					};
	
					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
			}
	
			if ( this.options.indicators ) {
				// TODO: check concat compatibility
				indicators = indicators.concat(this.options.indicators);
			}
	
			for ( var i = indicators.length; i--; ) {
				this.indicators.push( new Indicator(this, indicators[i]) );
			}
	
			// TODO: check if we can use array.map (wide compatibility and performance issues)
			function _indicatorsMap (fn) {
				if (that.indicators) {
					for ( var i = that.indicators.length; i--; ) {
						fn.call(that.indicators[i]);
					}
				}
			}
	
			if ( this.options.fadeScrollbars ) {
				this.on('scrollEnd', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});
	
				this.on('scrollCancel', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});
	
				this.on('scrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1);
					});
				});
	
				this.on('beforeScrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1, true);
					});
				});
			}
	
	
			this.on('refresh', function () {
				_indicatorsMap(function () {
					this.refresh();
				});
			});
	
			this.on('destroy', function () {
				_indicatorsMap(function () {
					this.destroy();
				});
	
				delete this.indicators;
			});
		},
	
		_initWheel: function () {
			utils.addEvent(this.wrapper, 'wheel', this);
			utils.addEvent(this.wrapper, 'mousewheel', this);
			utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
	
			this.on('destroy', function () {
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = null;
				utils.removeEvent(this.wrapper, 'wheel', this);
				utils.removeEvent(this.wrapper, 'mousewheel', this);
				utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
			});
		},
	
		_wheel: function (e) {
			if ( !this.enabled ) {
				return;
			}
	
			e.preventDefault();
	
			var wheelDeltaX, wheelDeltaY,
				newX, newY,
				that = this;
	
			if ( this.wheelTimeout === undefined ) {
				that._execEvent('scrollStart');
			}
	
			// Execute the scrollEnd event after 400ms the wheel stopped scrolling
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(function () {
				if(!that.options.snap) {
					that._execEvent('scrollEnd');
				}
				that.wheelTimeout = undefined;
			}, 400);
	
			if ( 'deltaX' in e ) {
				if (e.deltaMode === 1) {
					wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
					wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
				} else {
					wheelDeltaX = -e.deltaX;
					wheelDeltaY = -e.deltaY;
				}
			} else if ( 'wheelDeltaX' in e ) {
				wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
				wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
			} else if ( 'wheelDelta' in e ) {
				wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
			} else if ( 'detail' in e ) {
				wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
			} else {
				return;
			}
	
			wheelDeltaX *= this.options.invertWheelDirection;
			wheelDeltaY *= this.options.invertWheelDirection;
	
			if ( !this.hasVerticalScroll ) {
				wheelDeltaX = wheelDeltaY;
				wheelDeltaY = 0;
			}
	
			if ( this.options.snap ) {
				newX = this.currentPage.pageX;
				newY = this.currentPage.pageY;
	
				if ( wheelDeltaX > 0 ) {
					newX--;
				} else if ( wheelDeltaX < 0 ) {
					newX++;
				}
	
				if ( wheelDeltaY > 0 ) {
					newY--;
				} else if ( wheelDeltaY < 0 ) {
					newY++;
				}
	
				this.goToPage(newX, newY);
	
				return;
			}
	
			newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
			newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
	
			this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
			this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;
	
			if ( newX > 0 ) {
				newX = 0;
			} else if ( newX < this.maxScrollX ) {
				newX = this.maxScrollX;
			}
	
			if ( newY > 0 ) {
				newY = 0;
			} else if ( newY < this.maxScrollY ) {
				newY = this.maxScrollY;
			}
	
			this.scrollTo(newX, newY, 0);
	
	// INSERT POINT: _wheel
		},
	
		_initSnap: function () {
			this.currentPage = {};
	
			if ( typeof this.options.snap == 'string' ) {
				this.options.snap = this.scroller.querySelectorAll(this.options.snap);
			}
	
			this.on('refresh', function () {
				var i = 0, l,
					m = 0, n,
					cx, cy,
					x = 0, y,
					stepX = this.options.snapStepX || this.wrapperWidth,
					stepY = this.options.snapStepY || this.wrapperHeight,
					el;
	
				this.pages = [];
	
				if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
					return;
				}
	
				if ( this.options.snap === true ) {
					cx = Math.round( stepX / 2 );
					cy = Math.round( stepY / 2 );
	
					while ( x > -this.scrollerWidth ) {
						this.pages[i] = [];
						l = 0;
						y = 0;
	
						while ( y > -this.scrollerHeight ) {
							this.pages[i][l] = {
								x: Math.max(x, this.maxScrollX),
								y: Math.max(y, this.maxScrollY),
								width: stepX,
								height: stepY,
								cx: x - cx,
								cy: y - cy
							};
	
							y -= stepY;
							l++;
						}
	
						x -= stepX;
						i++;
					}
				} else {
					el = this.options.snap;
					l = el.length;
					n = -1;
	
					for ( ; i < l; i++ ) {
						if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
							m = 0;
							n++;
						}
	
						if ( !this.pages[m] ) {
							this.pages[m] = [];
						}
	
						x = Math.max(-el[i].offsetLeft, this.maxScrollX);
						y = Math.max(-el[i].offsetTop, this.maxScrollY);
						cx = x - Math.round(el[i].offsetWidth / 2);
						cy = y - Math.round(el[i].offsetHeight / 2);
	
						this.pages[m][n] = {
							x: x,
							y: y,
							width: el[i].offsetWidth,
							height: el[i].offsetHeight,
							cx: cx,
							cy: cy
						};
	
						if ( x > this.maxScrollX ) {
							m++;
						}
					}
				}
	
				this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
	
				// Update snap threshold if needed
				if ( this.options.snapThreshold % 1 === 0 ) {
					this.snapThresholdX = this.options.snapThreshold;
					this.snapThresholdY = this.options.snapThreshold;
				} else {
					this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
					this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
				}
			});
	
			this.on('flick', function () {
				var time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(this.x - this.startX), 1000),
							Math.min(Math.abs(this.y - this.startY), 1000)
						), 300);
	
				this.goToPage(
					this.currentPage.pageX + this.directionX,
					this.currentPage.pageY + this.directionY,
					time
				);
			});
		},
	
		_nearestSnap: function (x, y) {
			if ( !this.pages.length ) {
				return { x: 0, y: 0, pageX: 0, pageY: 0 };
			}
	
			var i = 0,
				l = this.pages.length,
				m = 0;
	
			// Check if we exceeded the snap threshold
			if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
				Math.abs(y - this.absStartY) < this.snapThresholdY ) {
				return this.currentPage;
			}
	
			if ( x > 0 ) {
				x = 0;
			} else if ( x < this.maxScrollX ) {
				x = this.maxScrollX;
			}
	
			if ( y > 0 ) {
				y = 0;
			} else if ( y < this.maxScrollY ) {
				y = this.maxScrollY;
			}
	
			for ( ; i < l; i++ ) {
				if ( x >= this.pages[i][0].cx ) {
					x = this.pages[i][0].x;
					break;
				}
			}
	
			l = this.pages[i].length;
	
			for ( ; m < l; m++ ) {
				if ( y >= this.pages[0][m].cy ) {
					y = this.pages[0][m].y;
					break;
				}
			}
	
			if ( i == this.currentPage.pageX ) {
				i += this.directionX;
	
				if ( i < 0 ) {
					i = 0;
				} else if ( i >= this.pages.length ) {
					i = this.pages.length - 1;
				}
	
				x = this.pages[i][0].x;
			}
	
			if ( m == this.currentPage.pageY ) {
				m += this.directionY;
	
				if ( m < 0 ) {
					m = 0;
				} else if ( m >= this.pages[0].length ) {
					m = this.pages[0].length - 1;
				}
	
				y = this.pages[0][m].y;
			}
	
			return {
				x: x,
				y: y,
				pageX: i,
				pageY: m
			};
		},
	
		goToPage: function (x, y, time, easing) {
			easing = easing || this.options.bounceEasing;
	
			if ( x >= this.pages.length ) {
				x = this.pages.length - 1;
			} else if ( x < 0 ) {
				x = 0;
			}
	
			if ( y >= this.pages[x].length ) {
				y = this.pages[x].length - 1;
			} else if ( y < 0 ) {
				y = 0;
			}
	
			var posX = this.pages[x][y].x,
				posY = this.pages[x][y].y;
	
			time = time === undefined ? this.options.snapSpeed || Math.max(
				Math.max(
					Math.min(Math.abs(posX - this.x), 1000),
					Math.min(Math.abs(posY - this.y), 1000)
				), 300) : time;
	
			this.currentPage = {
				x: posX,
				y: posY,
				pageX: x,
				pageY: y
			};
	
			this.scrollTo(posX, posY, time, easing);
		},
	
		next: function (time, easing) {
			var x = this.currentPage.pageX,
				y = this.currentPage.pageY;
	
			x++;
	
			if ( x >= this.pages.length && this.hasVerticalScroll ) {
				x = 0;
				y++;
			}
	
			this.goToPage(x, y, time, easing);
		},
	
		prev: function (time, easing) {
			var x = this.currentPage.pageX,
				y = this.currentPage.pageY;
	
			x--;
	
			if ( x < 0 && this.hasVerticalScroll ) {
				x = 0;
				y--;
			}
	
			this.goToPage(x, y, time, easing);
		},
	
		_initKeys: function (e) {
			// default key bindings
			var keys = {
				pageUp: 33,
				pageDown: 34,
				end: 35,
				home: 36,
				left: 37,
				up: 38,
				right: 39,
				down: 40
			};
			var i;
	
			// if you give me characters I give you keycode
			if ( typeof this.options.keyBindings == 'object' ) {
				for ( i in this.options.keyBindings ) {
					if ( typeof this.options.keyBindings[i] == 'string' ) {
						this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
					}
				}
			} else {
				this.options.keyBindings = {};
			}
	
			for ( i in keys ) {
				this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
			}
	
			utils.addEvent(window, 'keydown', this);
	
			this.on('destroy', function () {
				utils.removeEvent(window, 'keydown', this);
			});
		},
	
		_key: function (e) {
			if ( !this.enabled ) {
				return;
			}
	
			var snap = this.options.snap,	// we are using this alot, better to cache it
				newX = snap ? this.currentPage.pageX : this.x,
				newY = snap ? this.currentPage.pageY : this.y,
				now = utils.getTime(),
				prevTime = this.keyTime || 0,
				acceleration = 0.250,
				pos;
	
			if ( this.options.useTransition && this.isInTransition ) {
				pos = this.getComputedPosition();
	
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this.isInTransition = false;
			}
	
			this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
	
			switch ( e.keyCode ) {
				case this.options.keyBindings.pageUp:
					if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
						newX += snap ? 1 : this.wrapperWidth;
					} else {
						newY += snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.pageDown:
					if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
						newX -= snap ? 1 : this.wrapperWidth;
					} else {
						newY -= snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.end:
					newX = snap ? this.pages.length-1 : this.maxScrollX;
					newY = snap ? this.pages[0].length-1 : this.maxScrollY;
					break;
				case this.options.keyBindings.home:
					newX = 0;
					newY = 0;
					break;
				case this.options.keyBindings.left:
					newX += snap ? -1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.up:
					newY += snap ? 1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.right:
					newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.down:
					newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
					break;
				default:
					return;
			}
	
			if ( snap ) {
				this.goToPage(newX, newY);
				return;
			}
	
			if ( newX > 0 ) {
				newX = 0;
				this.keyAcceleration = 0;
			} else if ( newX < this.maxScrollX ) {
				newX = this.maxScrollX;
				this.keyAcceleration = 0;
			}
	
			if ( newY > 0 ) {
				newY = 0;
				this.keyAcceleration = 0;
			} else if ( newY < this.maxScrollY ) {
				newY = this.maxScrollY;
				this.keyAcceleration = 0;
			}
	
			this.scrollTo(newX, newY, 0);
	
			this.keyTime = now;
		},
	
		_animate: function (destX, destY, duration, easingFn) {
			var that = this,
				startX = this.x,
				startY = this.y,
				startTime = utils.getTime(),
				destTime = startTime + duration;
	
			function step () {
				var now = utils.getTime(),
					newX, newY,
					easing;
	
				if ( now >= destTime ) {
					that.isAnimating = false;
					that._translate(destX, destY);
	
					if ( !that.resetPosition(that.options.bounceTime) ) {
						that._execEvent('scrollEnd');
					}
	
					return;
				}
	
				now = ( now - startTime ) / duration;
				easing = easingFn(now);
				newX = ( destX - startX ) * easing + startX;
				newY = ( destY - startY ) * easing + startY;
				that._translate(newX, newY);
	
				if ( that.isAnimating ) {
					rAF(step);
				}
			}
	
			this.isAnimating = true;
			step();
		},
		handleEvent: function (e) {
			switch ( e.type ) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
				case 'orientationchange':
				case 'resize':
					this._resize();
					break;
				case 'transitionend':
				case 'webkitTransitionEnd':
				case 'oTransitionEnd':
				case 'MSTransitionEnd':
					this._transitionEnd(e);
					break;
				case 'wheel':
				case 'DOMMouseScroll':
				case 'mousewheel':
					this._wheel(e);
					break;
				case 'keydown':
					this._key(e);
					break;
				case 'click':
					if ( this.enabled && !e._constructed ) {
						e.preventDefault();
						e.stopPropagation();
					}
					break;
			}
		}
	};
	function createDefaultScrollbar (direction, interactive, type) {
		var scrollbar = document.createElement('div'),
			indicator = document.createElement('div');
	
		if ( type === true ) {
			scrollbar.style.cssText = 'position:absolute;z-index:9999';
			indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
		}
	
		indicator.className = 'iScrollIndicator';
	
		if ( direction == 'h' ) {
			if ( type === true ) {
				scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
				indicator.style.height = '100%';
			}
			scrollbar.className = 'iScrollHorizontalScrollbar';
		} else {
			if ( type === true ) {
				scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
				indicator.style.width = '100%';
			}
			scrollbar.className = 'iScrollVerticalScrollbar';
		}
	
		scrollbar.style.cssText += ';overflow:hidden';
	
		if ( !interactive ) {
			scrollbar.style.pointerEvents = 'none';
		}
	
		scrollbar.appendChild(indicator);
	
		return scrollbar;
	}
	
	function Indicator (scroller, options) {
		this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
		this.wrapperStyle = this.wrapper.style;
		this.indicator = this.wrapper.children[0];
		this.indicatorStyle = this.indicator.style;
		this.scroller = scroller;
	
		this.options = {
			listenX: true,
			listenY: true,
			interactive: false,
			resize: true,
			defaultScrollbars: false,
			shrink: false,
			fade: false,
			speedRatioX: 0,
			speedRatioY: 0
		};
	
		for ( var i in options ) {
			this.options[i] = options[i];
		}
	
		this.sizeRatioX = 1;
		this.sizeRatioY = 1;
		this.maxPosX = 0;
		this.maxPosY = 0;
	
		if ( this.options.interactive ) {
			if ( !this.options.disableTouch ) {
				utils.addEvent(this.indicator, 'touchstart', this);
				utils.addEvent(window, 'touchend', this);
			}
			if ( !this.options.disablePointer ) {
				utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
			}
			if ( !this.options.disableMouse ) {
				utils.addEvent(this.indicator, 'mousedown', this);
				utils.addEvent(window, 'mouseup', this);
			}
		}
	
		if ( this.options.fade ) {
			this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
			var durationProp = utils.style.transitionDuration;
			this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
			// remove 0.0001ms
			var self = this;
			if(utils.isBadAndroid) {
				rAF(function() {
					if(self.wrapperStyle[durationProp] === '0.0001ms') {
						self.wrapperStyle[durationProp] = '0s';
					}
				});
			}
			this.wrapperStyle.opacity = '0';
		}
	}
	
	Indicator.prototype = {
		handleEvent: function (e) {
			switch ( e.type ) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
			}
		},
	
		destroy: function () {
			if ( this.options.fadeScrollbars ) {
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
			}
			if ( this.options.interactive ) {
				utils.removeEvent(this.indicator, 'touchstart', this);
				utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.removeEvent(this.indicator, 'mousedown', this);
	
				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);
	
				utils.removeEvent(window, 'touchend', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
				utils.removeEvent(window, 'mouseup', this);
			}
	
			if ( this.options.defaultScrollbars ) {
				this.wrapper.parentNode.removeChild(this.wrapper);
			}
		},
	
		_start: function (e) {
			var point = e.touches ? e.touches[0] : e;
	
			e.preventDefault();
			e.stopPropagation();
	
			this.transitionTime();
	
			this.initiated = true;
			this.moved = false;
			this.lastPointX	= point.pageX;
			this.lastPointY	= point.pageY;
	
			this.startTime	= utils.getTime();
	
			if ( !this.options.disableTouch ) {
				utils.addEvent(window, 'touchmove', this);
			}
			if ( !this.options.disablePointer ) {
				utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
			}
			if ( !this.options.disableMouse ) {
				utils.addEvent(window, 'mousemove', this);
			}
	
			this.scroller._execEvent('beforeScrollStart');
		},
	
		_move: function (e) {
			var point = e.touches ? e.touches[0] : e,
				deltaX, deltaY,
				newX, newY,
				timestamp = utils.getTime();
	
			if ( !this.moved ) {
				this.scroller._execEvent('scrollStart');
			}
	
			this.moved = true;
	
			deltaX = point.pageX - this.lastPointX;
			this.lastPointX = point.pageX;
	
			deltaY = point.pageY - this.lastPointY;
			this.lastPointY = point.pageY;
	
			newX = this.x + deltaX;
			newY = this.y + deltaY;
	
			this._pos(newX, newY);
	
	// INSERT POINT: indicator._move
	
			e.preventDefault();
			e.stopPropagation();
		},
	
		_end: function (e) {
			if ( !this.initiated ) {
				return;
			}
	
			this.initiated = false;
	
			e.preventDefault();
			e.stopPropagation();
	
			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);
	
			if ( this.scroller.options.snap ) {
				var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
	
				var time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(this.scroller.x - snap.x), 1000),
							Math.min(Math.abs(this.scroller.y - snap.y), 1000)
						), 300);
	
				if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
					this.scroller.directionX = 0;
					this.scroller.directionY = 0;
					this.scroller.currentPage = snap;
					this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
				}
			}
	
			if ( this.moved ) {
				this.scroller._execEvent('scrollEnd');
			}
		},
	
		transitionTime: function (time) {
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			this.indicatorStyle[durationProp] = time + 'ms';
	
			if ( !time && utils.isBadAndroid ) {
				this.indicatorStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function() {
					if(self.indicatorStyle[durationProp] === '0.0001ms') {
						self.indicatorStyle[durationProp] = '0s';
					}
				});
			}
		},
	
		transitionTimingFunction: function (easing) {
			this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
		},
	
		refresh: function () {
			this.transitionTime();
	
			if ( this.options.listenX && !this.options.listenY ) {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
			} else if ( this.options.listenY && !this.options.listenX ) {
				this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
			} else {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
			}
	
			if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
				utils.addClass(this.wrapper, 'iScrollBothScrollbars');
				utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
	
				if ( this.options.defaultScrollbars && this.options.customStyle ) {
					if ( this.options.listenX ) {
						this.wrapper.style.right = '8px';
					} else {
						this.wrapper.style.bottom = '8px';
					}
				}
			} else {
				utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
				utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
	
				if ( this.options.defaultScrollbars && this.options.customStyle ) {
					if ( this.options.listenX ) {
						this.wrapper.style.right = '2px';
					} else {
						this.wrapper.style.bottom = '2px';
					}
				}
			}
	
			var r = this.wrapper.offsetHeight;	// force refresh
	
			if ( this.options.listenX ) {
				this.wrapperWidth = this.wrapper.clientWidth;
				if ( this.options.resize ) {
					this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
					this.indicatorStyle.width = this.indicatorWidth + 'px';
				} else {
					this.indicatorWidth = this.indicator.clientWidth;
				}
	
				this.maxPosX = this.wrapperWidth - this.indicatorWidth;
	
				if ( this.options.shrink == 'clip' ) {
					this.minBoundaryX = -this.indicatorWidth + 8;
					this.maxBoundaryX = this.wrapperWidth - 8;
				} else {
					this.minBoundaryX = 0;
					this.maxBoundaryX = this.maxPosX;
				}
	
				this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
			}
	
			if ( this.options.listenY ) {
				this.wrapperHeight = this.wrapper.clientHeight;
				if ( this.options.resize ) {
					this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
					this.indicatorStyle.height = this.indicatorHeight + 'px';
				} else {
					this.indicatorHeight = this.indicator.clientHeight;
				}
	
				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
	
				if ( this.options.shrink == 'clip' ) {
					this.minBoundaryY = -this.indicatorHeight + 8;
					this.maxBoundaryY = this.wrapperHeight - 8;
				} else {
					this.minBoundaryY = 0;
					this.maxBoundaryY = this.maxPosY;
				}
	
				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
				this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
			}
	
			this.updatePosition();
		},
	
		updatePosition: function () {
			var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
				y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
	
			if ( !this.options.ignoreBoundaries ) {
				if ( x < this.minBoundaryX ) {
					if ( this.options.shrink == 'scale' ) {
						this.width = Math.max(this.indicatorWidth + x, 8);
						this.indicatorStyle.width = this.width + 'px';
					}
					x = this.minBoundaryX;
				} else if ( x > this.maxBoundaryX ) {
					if ( this.options.shrink == 'scale' ) {
						this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
						this.indicatorStyle.width = this.width + 'px';
						x = this.maxPosX + this.indicatorWidth - this.width;
					} else {
						x = this.maxBoundaryX;
					}
				} else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
					this.width = this.indicatorWidth;
					this.indicatorStyle.width = this.width + 'px';
				}
	
				if ( y < this.minBoundaryY ) {
					if ( this.options.shrink == 'scale' ) {
						this.height = Math.max(this.indicatorHeight + y * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
					}
					y = this.minBoundaryY;
				} else if ( y > this.maxBoundaryY ) {
					if ( this.options.shrink == 'scale' ) {
						this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
						y = this.maxPosY + this.indicatorHeight - this.height;
					} else {
						y = this.maxBoundaryY;
					}
				} else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
					this.height = this.indicatorHeight;
					this.indicatorStyle.height = this.height + 'px';
				}
			}
	
			this.x = x;
			this.y = y;
	
			if ( this.scroller.options.useTransform ) {
				this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
			} else {
				this.indicatorStyle.left = x + 'px';
				this.indicatorStyle.top = y + 'px';
			}
		},
	
		_pos: function (x, y) {
			if ( x < 0 ) {
				x = 0;
			} else if ( x > this.maxPosX ) {
				x = this.maxPosX;
			}
	
			if ( y < 0 ) {
				y = 0;
			} else if ( y > this.maxPosY ) {
				y = this.maxPosY;
			}
	
			x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
			y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
	
			this.scroller.scrollTo(x, y);
		},
	
		fade: function (val, hold) {
			if ( hold && !this.visible ) {
				return;
			}
	
			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;
	
			var time = val ? 250 : 500,
				delay = val ? 0 : 300;
	
			val = val ? '1' : '0';
	
			this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
	
			this.fadeTimeout = setTimeout((function (val) {
				this.wrapperStyle.opacity = val;
				this.visible = +val;
			}).bind(this, val), delay);
		}
	};
	
	IScroll.utils = utils;
	
	if ( typeof module != 'undefined' && module.exports ) {
		module.exports = IScroll;
	} else if ( true ) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return IScroll; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.IScroll = IScroll;
	}
	
	})(window, document, Math);


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(626)();
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMProperty = __webpack_require__(44);
	var ReactDOMComponentFlags = __webpack_require__(315);
	
	var invariant = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var QuillDeltaToHtmlConverter_1 = __webpack_require__(631);
	module.exports = QuillDeltaToHtmlConverter_1.QuillDeltaToHtmlConverter;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { access } from 'fs';
	
	module.exports = {
	  donorsIncluded: function donorsIncluded(donorCategories, include_categories) {
	    if (donorCategories.length === 0) {
	      console.log("returning null array");
	      return [];
	    }
	
	    //let donorsGrouped = _.filter(donorCategories, {id: include_categories});
	    var donorsGrouped = _lodash2.default.filter(donorCategories, function (v) {
	      return _lodash2.default.includes(include_categories, v.id) && v.donors.length > 0;
	    });
	
	    //restore if required for use elsewhere
	    // donorsGrouped = _.map(donorsGrouped, function (v) {
	    //   return { id: v.id, name: v.name, rank: v.rank, subheader: v.subheader, donors: v.donors, parent_category: v.parent_category, description: v.description }
	    // });
	
	    //depricated
	    // let donorsGrouped = [];
	    // _.forEach(donorCategories, (category) => {
	    //   if (category.donors.length > 0) {
	    //     _.forEach(include_categories, (icat) => {
	    //       if (icat === category.id) {
	    //         let pushGroup = { id: category.id, name: category.name, rank: category.rank, subheader: category.subheader, donors: category.donors, parent_category: category.parent_category, description: category.description };
	    //         donorsGrouped.push(pushGroup);
	    //       }
	    //     });
	    //   }
	    // });
	    donorsGrouped = _lodash2.default.orderBy(donorsGrouped, 'rank', 'asc');
	    return donorsGrouped;
	  },
	
	  searchDonorList: function searchDonorList(content, donors, searchStr) {
	    var donorListsModules = _lodash2.default.filter(content.dm_active, { display_module_type: "Donor List" });
	    var groupedDonorLists = [];
	
	    if (donorListsModules.length > 0) {
	      donorListsModules.forEach(function (dm) {
	        var donorListGrouped = module.exports.donorsIncluded(donors.donorCategories, dm.contents.include_categories);
	        groupedDonorLists.push({
	          module: dm,
	          group: donorListGrouped
	        });
	      });
	    }
	
	    var foundGroups = [];
	    groupedDonorLists.forEach(function (module, i) {
	      if (module.group.length > 0) {
	        module.group.some(function (group, j) {
	          var match = 0;
	          group.donors.forEach(function (donor, k) {
	            if (donor.name.toLowerCase().indexOf(searchStr) !== -1) {
	              match++;
	              return true;
	            }
	          });
	
	          if (match > 0) {
	            foundGroups.push(group);
	            return true;
	          }
	
	          return false;
	        });
	
	        groupedDonorLists[i].group = foundGroups;
	      }
	    });
	
	    return groupedDonorLists;
	  },
	
	  searchInDonorLists: function searchInDonorLists(content, donors, searchStr) {
	    var foundDonors = [];
	    var donorLists = [];
	    var foundDonorsIds = [];
	
	    for (var i = 0; i < donors.donorCategories.length; i++) {
	      if (donors.donorCategories[i].donors && donors.donorCategories[i].donors.length > 0) {
	        var categoryDonors = donors.donorCategories[i].donors;
	        var match = _lodash2.default.filter(categoryDonors, function (donor) {
	          var name = donor.name.toLowerCase();
	          var isIncluded = name.includes(searchStr);
	          if (isIncluded) {
	            foundDonorsIds.push(donor.id);
	          }
	          return isIncluded;
	        });
	        if (match && match.length > 0) {
	          donorLists.push(donors.donorCategories[i].id);
	        }
	        foundDonors = foundDonors.concat(match);
	      }
	    }
	
	    var results = {
	      donorLists: donorLists,
	      foundDonors: foundDonors,
	      foundDonorsIds: foundDonorsIds
	    };
	
	    return results;
	  },
	
	  searchInFolderDonorLists: function searchInFolderDonorLists(folders, donors, searchStr) {
	    var rootFolderId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    // let foundDonors = [];
	    var foundFolders = [];
	    var foundDonorsIds = [];
	    var allDonors = [];
	
	    for (var x = 0; x < donors.donorCategories.length; x++) {
	      if (donors.donorCategories[x].donors && donors.donorCategories[x].donors.length > 0) {
	        allDonors = allDonors.concat(donors.donorCategories[x].donors);
	      }
	    }
	
	    var match = _lodash2.default.filter(allDonors, function (donor) {
	      var name = donor.name.toLowerCase();
	      var isIncluded = name.includes(searchStr);
	      var added = false;
	      if (isIncluded && foundDonorsIds.indexOf(donor.id) === -1) {
	        if (rootFolderId !== null) {
	          if (module.exports.checkIfDonorIsChildOf(donor.folder_module.folder, rootFolderId, folders)) {
	            foundDonorsIds.push(donor.id);
	            if (donor.folder_module) {
	              if (foundFolders.indexOf(donor.folder_module.folder) === -1) {
	                foundFolders.push(donor.folder_module.folder);
	              }
	            }
	            added = true;
	          }
	        } else {
	          foundDonorsIds.push(donor.id);
	          if (donor.folder_module) {
	            if (foundFolders.indexOf(donor.folder_module.folder) === -1) {
	              foundFolders.push(donor.folder_module.folder);
	            }
	          }
	          added = true;
	        }
	      }
	      return added;
	    });
	
	    var results = {
	      foundFolders: foundFolders,
	      foundDonors: match,
	      foundDonorsIds: foundDonorsIds
	    };
	
	    return results;
	  },
	
	  checkIfDonorIsChildOf: function checkIfDonorIsChildOf(childFolderId, parentFolderId, folders) {
	    var childFolder = folders.find(function (f) {
	      return f.id === childFolderId;
	    });
	    if (!childFolder) {
	      return false;
	    }
	    if (childFolder.parent_category === parentFolderId) {
	      return true;
	    }
	    return module.exports.checkIfDonorIsChildOf(childFolder.parent_category, parentFolderId, folders);
	  },
	
	  getDonorsFromFolder: function getDonorsFromFolder(donors, folderModules, folder) {
	    var allDonors = [];
	    for (var i = 0; i < donors.donorCategories.length; i++) {
	      allDonors = allDonors.concat(donors.donorCategories[i].donors);
	    }
	
	    var filteredDonors = folderModules.filter(function (fm) {
	      return fm.folder === folder && fm.model === "donor";
	    }).reduce(function (acc, cur) {
	      var donor = allDonors.find(function (dn) {
	        return dn.id === cur.module_id && cur.model === "donor";
	      });
	      if (donor) {
	        donor.folder_module = cur;
	        acc = acc.concat(donor);
	      }
	
	      return acc;
	    }, []);
	
	    return filteredDonors;
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _screenReaderStyles = __webpack_require__(699);
	
	var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A React component for the font-awesome icon library.
	 *
	 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
	 * @param {Boolean} [border=false] Whether or not to show a border radius
	 * @param {String} [className] An extra set of CSS classes to add to the component
	 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
	 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
	 * @param {String} [flip=false] Flip the icon's orientation.
	 * @param {Boolean} [inverse=false]Inverse the icon's color
	 * @param {String} name Name of the icon to use
	 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
	 * @param {Number} [rotate] The degress to rotate the icon by
	 * @param {String} [size] The icon scaling size
	 * @param {Boolean} [spin=false] Spin the icon
	 * @param {String} [stack] Stack an icon on top of another
	 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
	 * @module FontAwesome
	 * @type {ReactClass}
	 */
	var FontAwesome = function (_React$Component) {
	  _inherits(FontAwesome, _React$Component);
	
	  function FontAwesome() {
	    _classCallCheck(this, FontAwesome);
	
	    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));
	
	    _this.displayName = 'FontAwesome';
	    return _this;
	  }
	
	  _createClass(FontAwesome, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          border = _props.border,
	          cssModule = _props.cssModule,
	          className = _props.className,
	          fixedWidth = _props.fixedWidth,
	          flip = _props.flip,
	          inverse = _props.inverse,
	          name = _props.name,
	          pulse = _props.pulse,
	          rotate = _props.rotate,
	          size = _props.size,
	          spin = _props.spin,
	          stack = _props.stack,
	          _props$tag = _props.tag,
	          tag = _props$tag === undefined ? 'span' : _props$tag,
	          ariaLabel = _props.ariaLabel,
	          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);
	
	      var classNames = [];
	
	      if (cssModule) {
	        classNames.push(cssModule['fa']);
	        classNames.push(cssModule['fa-' + name]);
	        size && classNames.push(cssModule['fa-' + size]);
	        spin && classNames.push(cssModule['fa-spin']);
	        pulse && classNames.push(cssModule['fa-pulse']);
	        border && classNames.push(cssModule['fa-border']);
	        fixedWidth && classNames.push(cssModule['fa-fw']);
	        inverse && classNames.push(cssModule['fa-inverse']);
	        flip && classNames.push(cssModule['fa-flip-' + flip]);
	        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
	        stack && classNames.push(cssModule['fa-stack-' + stack]);
	      } else {
	        classNames.push('fa');
	        classNames.push('fa-' + name);
	        size && classNames.push('fa-' + size);
	        spin && classNames.push('fa-spin');
	        pulse && classNames.push('fa-pulse');
	        border && classNames.push('fa-border');
	        fixedWidth && classNames.push('fa-fw');
	        inverse && classNames.push('fa-inverse');
	        flip && classNames.push('fa-flip-' + flip);
	        rotate && classNames.push('fa-rotate-' + rotate);
	        stack && classNames.push('fa-stack-' + stack);
	      }
	
	      // Add any custom class names at the end.
	      className && classNames.push(className);
	      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
	    }
	  }]);
	
	  return FontAwesome;
	}(_react2.default.Component);
	
	FontAwesome.propTypes = {
	  ariaLabel: _propTypes2.default.string,
	  border: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  cssModule: _propTypes2.default.object,
	  fixedWidth: _propTypes2.default.bool,
	  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  inverse: _propTypes2.default.bool,
	  name: _propTypes2.default.string.isRequired,
	  pulse: _propTypes2.default.bool,
	  rotate: _propTypes2.default.oneOf([90, 180, 270]),
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  spin: _propTypes2.default.bool,
	  stack: _propTypes2.default.oneOf(['1x', '2x']),
	  tag: _propTypes2.default.string
	};
	
	exports.default = FontAwesome;
	module.exports = exports['default'];

/***/ },
/* 20 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	exports.parseEndTime = parseEndTime;
	exports.randomString = randomString;
	exports.queryString = queryString;
	exports.getSDK = getSDK;
	exports.getConfig = getConfig;
	exports.omit = omit;
	exports.callPlayer = callPlayer;
	exports.isObject = isObject;
	exports.isEqual = isEqual;
	exports.isMediaStream = isMediaStream;
	
	var _loadScript = __webpack_require__(579);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _deepmerge = __webpack_require__(529);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _props = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseTimeParam(url, pattern) {
	  var match = url.match(pattern);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseTimeString(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp);
	    }
	  }
	  return undefined;
	}
	
	function parseTimeString(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}
	
	function parseStartTime(url) {
	  return parseTimeParam(url, MATCH_START_QUERY);
	}
	
	function parseEndTime(url) {
	  return parseTimeParam(url, MATCH_END_QUERY);
	}
	
	// http://stackoverflow.com/a/38622545
	function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	}
	
	function queryString(object) {
	  return Object.keys(object).map(function (key) {
	    return key + '=' + object[key];
	  }).join('&');
	}
	
	// Util function to load an external SDK
	// or return the SDK if it is already loaded
	var resolves = {};
	function getSDK(url, sdkGlobal) {
	  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
	    return true;
	  };
	  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript2['default'];
	
	  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
	    return Promise.resolve(window[sdkGlobal]);
	  }
	  return new Promise(function (resolve, reject) {
	    // If we are already loading the SDK, add the resolve
	    // function to the existing array of resolve functions
	    if (resolves[url]) {
	      resolves[url].push(resolve);
	      return;
	    }
	    resolves[url] = [resolve];
	    var onLoaded = function onLoaded(sdk) {
	      // When loaded, resolve all pending promises
	      resolves[url].forEach(function (resolve) {
	        return resolve(sdk);
	      });
	    };
	    if (sdkReady) {
	      var previousOnReady = window[sdkReady];
	      window[sdkReady] = function () {
	        if (previousOnReady) previousOnReady();
	        onLoaded(window[sdkGlobal]);
	      };
	    }
	    fetchScript(url, function (err) {
	      if (err) reject(err);
	      if (!sdkReady) {
	        onLoaded(window[sdkGlobal]);
	      }
	    });
	  });
	}
	
	function getConfig(props, defaultProps, showWarning) {
	  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var p = _step.value;
	
	      if (props[p]) {
	        var key = p.replace(/Config$/, '');
	        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
	        if (showWarning) {
	          var link = 'https://github.com/CookPete/react-player#config-prop';
	          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
	          console.warn(message, 'font-weight: bold', '');
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return config;
	}
	
	function omit(object) {
	  var _ref;
	
	  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    arrays[_key - 1] = arguments[_key];
	  }
	
	  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
	  var output = {};
	  var keys = Object.keys(object);
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var key = _step2.value;
	
	      if (omitKeys.indexOf(key) === -1) {
	        output[key] = object[key];
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	        _iterator2['return']();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return output;
	}
	
	function callPlayer(method) {
	  var _player;
	
	  // Util method for calling a method on this.player
	  // but guard against errors and console.warn instead
	  if (!this.player || !this.player[method]) {
	    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
	    if (!this.player) {
	      message += 'The player was not available';
	    } else if (!this.player[method]) {
	      message += 'The method was not available';
	    }
	    console.warn(message, 'font-weight: bold', '');
	    return null;
	  }
	
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return (_player = this.player)[method].apply(_player, args);
	}
	
	function isObject(val) {
	  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
	}
	
	// Deep comparison of two objects but ignoring
	// functions, for use in shouldComponentUpdate
	function isEqual(a, b) {
	  if (typeof a === 'function' && typeof b === 'function') {
	    return true;
	  }
	  if (a instanceof Array && b instanceof Array) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    for (var i = 0; i !== a.length; i++) {
	      if (!isEqual(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	  if (isObject(a) && isObject(b)) {
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      return false;
	    }
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var key = _step3.value;
	
	        if (!isEqual(a[key], b[key])) {
	          return false;
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	          _iterator3['return']();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    return true;
	  }
	  return a === b;
	}
	
	function isMediaStream(url) {
	  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(150);
	var isBuffer = __webpack_require__(575);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var CallbackQueue = __webpack_require__(313);
	var PooledClass = __webpack_require__(37);
	var ReactFeatureFlags = __webpack_require__(318);
	var ReactReconciler = __webpack_require__(45);
	var Transaction = __webpack_require__(78);
	
	var invariant = __webpack_require__(7);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = createSinglePlayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(81);
	
	var _utils = __webpack_require__(21);
	
	var _Player = __webpack_require__(129);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
	
	function createSinglePlayer(activePlayer) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    _inherits(SinglePlayer, _Component);
	
	    function SinglePlayer() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, SinglePlayer);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
	        if (!_this.player) return null;
	        return _this.player.getDuration();
	      }, _this.getCurrentTime = function () {
	        if (!_this.player) return null;
	        return _this.player.getCurrentTime();
	      }, _this.getSecondsLoaded = function () {
	        if (!_this.player) return null;
	        return _this.player.getSecondsLoaded();
	      }, _this.getInternalPlayer = function () {
	        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	
	        if (!_this.player) return null;
	        return _this.player.getInternalPlayer(key);
	      }, _this.seekTo = function (fraction) {
	        if (!_this.player) return null;
	        _this.player.seekTo(fraction);
	      }, _this.ref = function (player) {
	        _this.player = player;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SinglePlayer, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _utils.isEqual)(this.props, nextProps);
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps) {
	        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _config$file = this.config.file,
	            forceVideo = _config$file.forceVideo,
	            forceAudio = _config$file.forceAudio,
	            forceHLS = _config$file.forceHLS,
	            forceDASH = _config$file.forceDASH;
	
	        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
	        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
	          return null;
	        }
	        var _props = this.props,
	            style = _props.style,
	            width = _props.width,
	            height = _props.height,
	            Wrapper = _props.wrapper;
	
	        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
	        return _react2['default'].createElement(
	          Wrapper,
	          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
	          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
	            ref: this.ref,
	            activePlayer: activePlayer,
	            config: this.config
	          }))
	        );
	      }
	    }]);
	
	    return SinglePlayer;
	  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.switchModuleSuccess = switchModuleSuccess;
	exports.fetchDisplaySuccess = fetchDisplaySuccess;
	exports.setOptionsSuccess = setOptionsSuccess;
	exports.fetchDisplay = fetchDisplay;
	exports.switchModule = switchModule;
	exports.setOptions = setOptions;
	exports.logSuccess = logSuccess;
	exports.logToServer = logToServer;
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(34);
	
	function switchModuleSuccess(id) {
	    return {
	        type: 'SWITCH_MODULE_SUCCESS',
	        active_module: id
	    };
	}
	
	function fetchDisplaySuccess(screen) {
	    return {
	        type: 'FETCH_DISPLAY_SUCCESS',
	        screen: screen
	    };
	}
	
	function setOptionsSuccess(data) {
	    return {
	        type: 'SET_OPTIONS_SUCCESS',
	        options: Object.assign({}, data)
	    };
	}
	
	function fetchDisplay(data) {
	    var screen = {
	        sv: {}
	    };
	    if (data.mode === "preview") {
	        screen.dpath = '/preview/';
	        screen.mode = 'preview';
	    } else if (data.mode === "web") {
	        screen.dpath = "/";
	        screen.mode = "web";
	    } else if (data.mode === "module") {
	        screen.dpath = '/preview/';
	        screen.mode = 'preview';
	    } else {
	        screen.dpath = '/';
	        screen.mode = "local";
	    }
	
	    if (data.webkey) {
	        screen.webkey = data.webkey;
	    } else {
	        data.webkey = null;
	    }
	
	    screen.entry_point = "/";
	    if (data.entry_point) {
	        screen.entry_point = data.entry_point;
	    }
	
	    var w_h = "1x1";
	    var orientation = "h";
	
	    if (data.blocks && data.blocks[0]) {
	        w_h = String(data.blocks[0].width) + "x" + String(data.blocks[0].height);
	        orientation = data.blocks[0].screens[0].orientation;
	    }
	
	    switch (orientation) {
	        case 'v':
	            switch (w_h) {
	                case "2x1":
	                    screen.sv.height = data.screenWidth * 0.8888;
	                    screen.sv.width = data.screenWidth;
	                    screen.sv.top = Math.max(data.screenHeight / 2 - data.screenWidth * 0.4444, 0);
	                    screen.sv.p10 = data.screenWidth * 0.1;
	                    break;
	                case "1x1":
	                    screen.sv.height = data.screenHeight;
	                    screen.sv.width = data.screenHeight * 1.778;
	                    screen.sv.left = data.screenWidth / 2 - data.screenHeight * 0.8888;
	                    screen.sv.p10 = data.screenHeight * 0.1;
	                    break;
	                default:
	                    break;
	            }
	            break;
	        case 'h':
	        default:
	            //console.log("in the horizontal: ", w_h)
	            switch (w_h) {
	                case "3x1":
	                    screen.sv.height = data.screenHeight;
	                    screen.sv.width = data.screenHeight * 5.333333;
	                    screen.sv.left = 0;
	                    screen.sv.p10 = data.screenHeight * 0.1;
	                    break;
	                case "2x1":
	                    screen.sv.height = data.screenHeight;
	                    screen.sv.width = data.screenWidth;
	                    screen.sv.left = data.screenWidth / 2 - data.screenHeight * 0.8888 * 2;
	                    screen.sv.p10 = data.screenHeight * 0.1;
	                    break;
	                case "1x1":
	                    screen.sv.height = data.screenHeight;
	                    screen.sv.width = data.screenHeight * 1.778;
	                    screen.sv.left = data.screenWidth / 2 - data.screenHeight * 0.8888;
	                    screen.sv.p10 = data.screenHeight * 0.1;
	                    break;
	                case "1x2":
	                    screen.sv.height = data.screenHeight;
	                    screen.sv.width = data.screenWidth;
	                    screen.sv.left = 0;
	                    screen.sv.p10 = data.screenHeight * 0.1;
	                    break;
	                default:
	                    break;
	            }
	            break;
	    }
	
	    screen.orientation = "horizontal";
	    if (data.screenWidth < data.screenHeight) {
	        screen.orientation = "vertical";
	    }
	    screen.screenWidth = data.screenWidth;
	    screen.screenHeight = data.screenHeight;
	    var stamp = new Date();
	    screen.timeStamp = stamp.getTime() / 1000;
	
	    //TODO: move to screen.sv values
	    screen.r16_9 = {
	        width: data.screenHeight * 1.778,
	        half: data.screenHeight * 0.8888,
	        left: data.screenWidth / 2 - data.screenHeight * 0.8888,
	        p10: data.screenHeight * 0.1,
	        h10: data.screenHeight * 1.778 * 0.1
	    };
	
	    screen.r9_16 = {
	        height: data.screenWidth * 1.778,
	        half: data.screenWidth * 0.8888,
	        top: data.screenHeight / 2 - data.screenWidth * 0.8888,
	        p10: data.screenWidth * 0.1
	        //console.log("screen: ", screen);
	    };return function (dispatch) {
	        dispatch(fetchDisplaySuccess(screen));
	    };
	}
	
	function switchModule(id) {
	    return function (dispatch) {
	        dispatch(switchModuleSuccess(id));
	    };
	}
	
	function setOptions(data) {
	    return function (dispatch) {
	        dispatch(setOptionsSuccess(data));
	    };
	}
	
	function logSuccess() {
	    return {
	        type: 'LOG_SUCCESS'
	    };
	}
	
	function logToServer(logs, type, display, mode, webkey) {
	    return function (dispatch) {
	        if (mode === "local") {
	            _axios2.default.post(config.WEB_SERVER + "/display/displayLog", {
	                authkey: config.AUTHKEY,
	                logs: logs,
	                display: Number(display),
	                type: type
	            }).then(function () {
	                dispatch(logSuccess());
	            });
	        }
	
	        if (mode === "preview") {
	            _axios2.default.post(config.WEB_SERVER + "/display/webkeyLog", {
	                webkey: webkey,
	                logs: logs,
	                display: Number(display),
	                type: type
	            }).then(function () {
	                dispatch(logSuccess());
	            });
	        }
	    };
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(649);


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var PooledClass = __webpack_require__(37);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(10);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STORY = exports.STORY = "story";
	var FOLDER = exports.FOLDER = "folder";
	var STORY_TEXT_ONLY = exports.STORY_TEXT_ONLY = "text_only";
	var STORY_SINGLE_IMAGE = exports.STORY_SINGLE_IMAGE = "single_image";
	var STORY_DOUBLE_IMAGE = exports.STORY_DOUBLE_IMAGE = "double_image";
	var STORY_FULLSCREEN = exports.STORY_FULLSCREEN = "fullscreen";
	var FOLDER_DONOR_LIST = exports.FOLDER_DONOR_LIST = "donor_list";
	var FOLDER_DONOR_LISTS = exports.FOLDER_DONOR_LISTS = "donor_lists";
	var DEFAULT_CYCLE = exports.DEFAULT_CYCLE = 10;
	var OPACITY_COLOR = exports.OPACITY_COLOR = "#0019e6";
	var OPACITY_PERCENTAGE = exports.OPACITY_PERCENTAGE = 0.85;
	var LOREM_IPSUM = exports.LOREM_IPSUM = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin condimentum nec ex sed varius. Etiam suscipit nulla libero, ac lobortis felis placerat sit amet. Phasellus sed suscipit massa. Vestibulum a convallis arcu. Nullam faucibus dolor et placerat interdum. Nam commodo felis at maximus tristique. Nulla quis sem id mi condimentum fermentum. Nullam cursus massa massa, et eleifend quam finibus nec. \n\n Pellentesque dictum luctus gravida. Etiam non elit non enim tincidunt vulputate ultricies vitae diam. Pellentesque interdum dui at orci malesuada ultrices. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam leo eros, dignissim vel faucibus sit amet, tempor id sem. Aliquam feugiat est in quam auctor euismod. Donec faucibus eu velit in consequat. Vivamus sodales lectus a massa elementum finibus. Mauris ornare sodales posuere. Fusce pulvinar finibus lorem non mollis. Mauris euismod maximus erat, vel fringilla tellus volutpat quis. Aliquam mattis eu arcu in laoreet.";
	var FULLSCREEN = exports.FULLSCREEN = "fullscreen";
	var SCREEN = exports.SCREEN = "screen";
	var ATTRACT_LOOP = exports.ATTRACT_LOOP = "attract_loop";
	var SCREENS_NUMBER = exports.SCREENS_NUMBER = 3;
	var DONOR = exports.DONOR = "donor";
	var FOLDER_ONE_COLUMN_DONOR_LIST = exports.FOLDER_ONE_COLUMN_DONOR_LIST = "donor_list_one_column";
	var FOLDER_TWO_COLUMN_DONOR_LIST = exports.FOLDER_TWO_COLUMN_DONOR_LIST = "donor_list_two_column";
	var FOLDER_THREE_COLUMN_DONOR_LIST = exports.FOLDER_THREE_COLUMN_DONOR_LIST = "donor_list_three_column";
	var FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL = exports.FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL = "donor_list_three_column_capital";
	var FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE = exports.FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE = "donor_list_three_column_cumulative";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = {
	    WEB_SERVER : 'https://beta.pdgcms.com',
	    ENTRY: '',
	    DISPLAY: 1,
	    AUTHKEY: 'jzg2rmttjrqrl8o0xtiqvl',
	    ENV: 'dev',
	    SCREEN_CONFIG:{
	        ORIENTATION: 'horizontal',
	        DISPLAYS_WIDTH: 1,
	        DISPLAYS_HEIGHT: 1,
	        RATIO: '16x9'
	    },
	    sockets: {
		enabled: true
	    }
	}


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    getFileType: function getFileType(str) {
	        var extension = str.substring(str.lastIndexOf(".") + 1);
	        switch (extension) {
	            case "jpg":
	            case "JPG":
	            case "JPEG":
	            case "jpeg":
	            case "png":
	            case "PNG":
	            case "gif":
	            case "GIF":
	                return "Image";
	            case "mp4":
	            case "MP4":
	            case "webm":
	            case "WEBM":
	                return "Video";
	            default:
	                return "Other";
	        }
	    },
	
	    videoType: function videoType(file_name) {
	        var videoExt = file_name.split('.').pop();
	        switch (videoExt) {
	            case 'mov':
	                return "video/mp4";
	            case 'webm':
	                return "video/webm";
	            case "ogg":
	                return "video/ogg";
	            default:
	                return null;
	        }
	    }
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 37 */
[796, 9],
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(719);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(720);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(347);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(721);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(722);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(723);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(724);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(348);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(135);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(725);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(726);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(727);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(728);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(729);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    indexFromInterval: function indexFromInterval(intervalMs, arrLength) {
	        var totalTimePassed = new Date().getTime();
	        var loops = totalTimePassed / intervalMs;
	        return Math.floor(loops % arrLength);
	    },
	
	    elementIndexCurrentSeekTime: function elementIndexCurrentSeekTime(intervalMs) {
	        var totalTimePassed = new Date().getTime();
	        var loops = totalTimePassed / intervalMs;
	        var currentLoop = Math.floor(loops);
	        var currentTimeInInterval = totalTimePassed - currentLoop * intervalMs;
	
	        return currentTimeInInterval;
	    },
	
	    currentSeekTimeArray: function currentSeekTimeArray(intervals) {
	        var intervalsSum = [];
	        intervals.reduce(function (a, b, i) {
	            return intervalsSum[i] = a + b;
	        }, 0);
	
	        var totalTimePassed = new Date().getTime();
	        var totalCycleTime = _lodash2.default.sum(intervals);
	        var loops = totalTimePassed / totalCycleTime;
	        var percentageIntoLoop = loops % 1;
	        var timeIntoLoop = percentageIntoLoop * totalCycleTime;
	
	        var index = _lodash2.default.findIndex(intervalsSum, function (sum) {
	            return timeIntoLoop / sum < 1;
	        });
	
	        return timeIntoLoop % intervals[index];
	    },
	
	    indexFromIntervalArray: function indexFromIntervalArray(intervals) {
	        var intervalsSum = [];
	        intervals.reduce(function (a, b, i) {
	            return intervalsSum[i] = a + b;
	        }, 0);
	
	        var totalTimePassed = new Date().getTime();
	        var totalCycleTime = _lodash2.default.sum(intervals);
	        var loops = totalTimePassed / totalCycleTime;
	        var percentageIntoLoop = loops % 1;
	        var timeIntoLoop = percentageIntoLoop * totalCycleTime;
	
	        var index = _lodash2.default.findIndex(intervalsSum, function (sum) {
	            return timeIntoLoop / sum < 1;
	        });
	        return index;
	    },
	
	    timeIntervalRemainderArrayMS: function timeIntervalRemainderArrayMS(intervals) {
	        var pushToTemp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var intervalsSum = [];
	        var totalTimePassed = new Date().getTime();
	        intervals.reduce(function (a, b, i) {
	            return intervalsSum[i] = a + b;
	        }, 0);
	
	        var totalCycleTime = _lodash2.default.sum(intervals);
	        var loops = totalTimePassed / totalCycleTime;
	        var percentageIntoLoop = loops % 1;
	        var timeIntoLoop = percentageIntoLoop * totalCycleTime;
	
	        var index = _lodash2.default.findIndex(intervalsSum, function (sum) {
	            return timeIntoLoop < sum;
	        });
	
	        if (pushToTemp) {
	            window.tmpLogArray.push(new Date() + " total cycle time: " + totalCycleTime);
	            window.tmpLogArray.push(new Date() + " loops: " + loops);
	            window.tmpLogArray.push(new Date() + " percentageIntoLoop: " + percentageIntoLoop);
	            window.tmpLogArray.push(new Date() + " index calculated: " + timeIntoLoop);
	        }
	
	        return intervalsSum[index] - timeIntoLoop;
	    },
	
	    timeIntervalRemainderPercent: function timeIntervalRemainderPercent(intervalMs) {
	        var totalTimePassed = new Date().getTime();
	        return 1 - totalTimePassed / intervalMs % 1;
	    },
	
	    timeIntervalRemainderMS: function timeIntervalRemainderMS(intervalMs) {
	        return this.timeIntervalRemainderPercent(intervalMs) * intervalMs;
	    },
	
	    diff: function diff(d1, d2, span) {
	        var diff = Math.abs(d2 - d1);
	        switch (span) {
	            case "milliseconds":
	                return diff;
	            case "seconds":
	                return diff / 1000;
	            case "minutes":
	                return diff / 1000 / 60;
	            case "hours":
	                return diff / 1000 / 60 / 60;
	            case "days":
	                return diff / 1000 / 60 / 60 / 24;
	            default:
	                return diff;
	        }
	    }
	
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(543);
	var hasBinary = __webpack_require__(172);
	var sliceBuffer = __webpack_require__(371);
	var after = __webpack_require__(370);
	var utf8 = __webpack_require__(792);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(521);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(522);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(70);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(53);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(570);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(571);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(572);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NewLine = "\n";
	exports.NewLine = NewLine;
	var ListType;
	(function (ListType) {
	    ListType["Ordered"] = "ordered";
	    ListType["Bullet"] = "bullet";
	    ListType["Checked"] = "checked";
	    ListType["Unchecked"] = "unchecked";
	})(ListType || (ListType = {}));
	exports.ListType = ListType;
	var ScriptType;
	(function (ScriptType) {
	    ScriptType["Sub"] = "sub";
	    ScriptType["Super"] = "super";
	})(ScriptType || (ScriptType = {}));
	exports.ScriptType = ScriptType;
	var DirectionType;
	(function (DirectionType) {
	    DirectionType["Rtl"] = "rtl";
	})(DirectionType || (DirectionType = {}));
	exports.DirectionType = DirectionType;
	var AlignType;
	(function (AlignType) {
	    AlignType["Center"] = "center";
	    AlignType["Right"] = "right";
	    AlignType["Justify"] = "justify";
	})(AlignType || (AlignType = {}));
	exports.AlignType = AlignType;
	var DataType;
	(function (DataType) {
	    DataType["Image"] = "image";
	    DataType["Video"] = "video";
	    DataType["Formula"] = "formula";
	    DataType["Text"] = "text";
	})(DataType || (DataType = {}));
	exports.DataType = DataType;
	;
	var GroupType;
	(function (GroupType) {
	    GroupType["Block"] = "block";
	    GroupType["InlineGroup"] = "inline-group";
	    GroupType["List"] = "list";
	    GroupType["Video"] = "video";
	})(GroupType || (GroupType = {}));
	exports.GroupType = GroupType;
	;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(114);
	var setInnerHTML = __webpack_require__(80);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(122);
	var setTextContent = __webpack_require__(331);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(672);
	var ReactInstrumentation = __webpack_require__(23);
	
	var warning = __webpack_require__(10);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(746);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactBaseClasses = __webpack_require__(355);
	var ReactChildren = __webpack_require__(754);
	var ReactDOMFactories = __webpack_require__(755);
	var ReactElement = __webpack_require__(48);
	var ReactPropTypes = __webpack_require__(756);
	var ReactVersion = __webpack_require__(757);
	
	var createReactClass = __webpack_require__(758);
	var onlyChild = __webpack_require__(762);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(31);
	
	var warning = __webpack_require__(10);
	var canDefineProperty = __webpack_require__(359);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(357);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    menuButtonHeight: '5.625vh',
	    backButtonHeight: '5.625vh'
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(97);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StoryMiami = function (_Component) {
	  _inherits(StoryMiami, _Component);
	
	  function StoryMiami(props) {
	    _classCallCheck(this, StoryMiami);
	
	    var _this = _possibleConstructorReturn(this, (StoryMiami.__proto__ || Object.getPrototypeOf(StoryMiami)).call(this, props));
	
	    _this.getBackgroundImage = function () {
	      if (_this._showBackground === false) {
	        return null;
	      }
	      if (_this.props.background) {
	        return _this.props.background;
	      }
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	      if (_this.props.screensNumber === 2) {
	        defaultImg.file_name = 'default_double_screen.jpg';
	      }
	      var folderModule = _this.props.content.folder_modules.find(function (fm) {
	        return fm.id === _this._story.folder_module_id;
	      });
	      var folder = _this.props.content.story_categories.find(function (fl) {
	        return fl.id === folderModule.folder;
	      });
	      return _shared2.default.dp(_this.props.screen, _lodash2.default.get(folder, 'contents.images[2]', null), defaultImg);
	    };
	
	    _this.getSubscribeModule = function () {
	      var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      var rootFolder = _this.props.content.story_categories.find(function (folder) {
	        return folder.id === Number(rootFolderId);
	      });
	      var menu = _this.props.content.story_categories.find(function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return folder.parent_category === Number(rootFolderId) && type === "menu";
	      });
	      var colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	      if (colorPallette === "adaptive") {
	        _this._uiStrip = "/img/miami/general/rainbowuistrip_green.png";
	      }
	      var subscribeModule = _this.props.content.story_categories.find(function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return folder.parent_category === Number(menu.id) && type === "be_the_change";
	      });
	      _this._subscribeModule = subscribeModule;
	    };
	
	    _this.redirect = function () {
	      if (_this._subscribeModule !== null && _this._subscribeModule !== undefined) {
	        _this.props.navRoute('/miami/subscribe', _this._subscribeModule);
	      }
	    };
	
	    _this._subscribeModule = null;
	    _this._showBackground = true;
	    _this._uiStrip = "/img/miami/general/rainbowuistrip.png";
	    _this.getSubscribeModule();
	    if (_this.props.showBackground !== undefined) {
	      _this._showBackground = _this.props.showBackground;
	    }
	
	    if (_this.props.contentIndex !== undefined) {
	      _this._story = _this.props.stories[_this.props.contentIndex];
	    } else {
	      _this._story = _this.props.stories[0];
	    }
	
	    _this.state = {
	      image: null,
	      dimensions: null
	    };
	    return _this;
	  }
	
	  _createClass(StoryMiami, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var imageObj, imagePath, dimensions;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                imageObj = new Image();
	                imagePath = _shared2.default.dp(this.props.screen, this._story.contents.images[0]);
	
	                imageObj.src = imagePath;
	                _context.next = 5;
	                return new Promise(function (resolve, reject) {
	                  imageObj.onload = function () {
	                    return resolve({ width: this.width, height: this.height });
	                  };
	                });
	
	              case 5:
	                dimensions = _context.sent;
	
	                this.setState({
	                  image: imagePath,
	                  dimensions: dimensions
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
	      var maxAbsoluteBlockWidth = this.props.screen.screenWidth / this.props.screensNumber * 0.85 - this.props.screen.screenHeight * 0.0268 * 2;
	      var rootFolderId = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	      var rootFolder = this.props.content.story_categories.find(function (folder) {
	        return folder.id === Number(rootFolderId);
	      });
	      var colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	      var helpButton = "/img/miami/general/help_button.png";
	      if (colorPallette === "adaptive") {
	        helpButton = "/img/miami/general/help_button_green.png";
	      }
	
	      var imageStyle = {
	        height: '33vh',
	        width: '85%',
	        borderTopLeftRadius: "3.125vh",
	        borderTopRightRadius: "3.125vh",
	        margin: "auto",
	        overflow: "hidden"
	        // backgroundSize: "cover",
	        // backgroundPosition:"center",
	        // backgroundRepeat: "no-repeat"
	      };
	
	      var imagePath = _shared2.default.presetDp("story_pill", _lodash2.default.get(this._story, 'contents.images[0]', { path: '/img/ui/', file_name: 'image_default.png' }), this.props.screen);
	
	      var backgroundImage = this.getBackgroundImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	      var bodyRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(this._story, 'contents.custom_fields.body.val.ops', _lodash2.default.get(this._story, 'contents.custom_fields.body.default.ops', null)), {}).convert();
	      var subtitleRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(this._story, 'contents.custom_fields.subtitle.val.ops', _lodash2.default.get(this._story, 'contents.custom_fields.subtitle.default.ops', null)), {}).convert();
	
	      var maxWidth = 0,
	          maxHeight = 0,
	          verticalAlign = "middle";
	      if (this.state.dimensions) {
	        var ratio = this.state.dimensions.width / this.state.dimensions.height;
	        if (this.state.dimensions.width > this.state.dimensions.height) {
	          verticalAlign = "bottom";
	          maxWidth = this.state.dimensions.width;
	          maxHeight = this.state.dimensions.height;
	          if (this.state.dimensions.width > this.props.screen.screenWidth / this.props.screensNumber * .85) {
	            maxWidth = this.props.screen.screenWidth / this.props.screensNumber * .85;
	            maxHeight = maxWidth / ratio;
	          }
	          if (maxHeight > this.props.screen.screenHeight * .33) {
	            maxHeight = this.props.screen.screenHeight * .33;
	            maxWidth = maxHeight * ratio;
	          }
	        } else {
	          maxHeight = this.props.screen.screenHeight * .33;
	          maxWidth = maxHeight * ratio;
	        }
	      }
	
	      var sideText = _lodash2.default.get(this._story, 'contents.custom_fields.side_text.val', null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: this.props.screen.screenWidth / this.props.screensNumber, height: this.props.screen.screenHeight, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	        _react2.default.createElement(
	          'div',
	          { style: { top: "5vh", position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber, height: "100vh" } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "block", margin: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, imageStyle, { backgroundColor: "white", textAlign: "center", display: "table" }) },
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table-cell", verticalAlign: verticalAlign } },
	                _react2.default.createElement('img', { src: imagePath, style: { width: maxWidth, height: maxHeight, margin: "auto", verticalAlign: "bottom" }, alt: '' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { alt: 'Stripe', style: { display: "block", margin: "auto", height: this.props.screen.r9_16.height * .004, width: "85%" }, src: this._uiStrip })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block', margin: "auto", height: '57vh', width: '85%', backgroundColor: 'white', borderBottomLeftRadius: "3.125vh", borderBottomRightRadius: "3.125vh" } },
	            _react2.default.createElement('div', { style: { fontSize: '2.25vh', textAlign: "left", marginLeft: unit * .5, fontFamily: "opensans-bold", color: '#404040' } }),
	            _react2.default.createElement('div', { style: { height: "1.12vh" } }),
	            _react2.default.createElement(
	              'div',
	              { style: { fontFamily: "sans-serif", textAlign: "left", paddingRight: "2.68vh", paddingLeft: "2.68vh", color: "#404040", maxHeight: "9.765625vh", overflowY: "hidden", minHeight: "2.6041666666666666666vh", fontSize: "2.7773vh", marginTop: "2vh" } },
	              this._story.name
	            ),
	            _react2.default.createElement('div', { className: 'miami-subtitle ql-editor ql-size-12px', style: { textAlign: "left", paddingRight: "2.68vh", paddingLeft: "2.68vh", color: "#404040", maxHeight: "9.765625vh", overflowY: "hidden", minHeight: "2.6041666666666666666vh", lineHeight: "1.5vh", paddingTop: "0.5vh", paddingBottom: "0.5vh" }, dangerouslySetInnerHTML: { __html: subtitleRichText } }),
	            _react2.default.createElement(
	              'div',
	              { style: { height: "43vh", paddingTop: "0.4921875vh", paddingLeft: "2.68vh", paddingRight: "2.68vh", paddingBottom: "1.68vh", display: "table", position: "absolute", width: maxAbsoluteBlockWidth } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table-row" } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'miami-bullet', style: { display: "table-cell", width: "65%" } },
	                  _react2.default.createElement('div', { style: { float: "left", color: "#404040", maxHeight: "44vh", lineHeight: 0.01041666666666666667 * this.props.screen.screenHeight + "px", overflowY: 'hidden', fontSize: 0.01041666666666666667 * this.props.screen.screenHeight + "px" }, className: 'ql-editor', dangerouslySetInnerHTML: { __html: bodyRichText } })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: "table-cell", width: "32%", paddingLeft: "0.5vh", paddingRight: "0.5vh", position: "absolute" } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { float: "left" } },
	                    sideText !== null && sideText !== "" ? _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement('img', { alt: 'Stripe', style: { display: "block", margin: "auto", height: this.props.screen.screenHeight * .001, width: "85%" }, src: this._uiStrip }),
	                      _react2.default.createElement(
	                        'div',
	                        { style: { fontFamily: "legacysans-bookitalic", fontSize: '1.2375vh', color: 'black', paddingTop: "1.5625vh", paddingBottom: "1.5625vh", width: "85%", margin: "0 auto", textAlign: "center" } },
	                        sideText
	                      ),
	                      _react2.default.createElement('img', { alt: 'Stripe', style: { display: "block", margin: "auto", height: this.props.screen.screenHeight * .001, width: "85%" }, src: this._uiStrip })
	                    ) : null,
	                    _react2.default.createElement('img', { alt: 'Be The Change', onClick: this.redirect, style: { backgroundColor: 'white', display: "block", margin: "auto", width: "80%", textAlign: "center", paddingTop: "4.17vh" }, src: helpButton })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('br', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoryMiami;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(StoryMiami);

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _donorHelpers2 = _interopRequireDefault(_donorHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import storiesHelpers from './storiesHelpers';
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	module.exports = {
	  combinePathFile: function combinePathFile(obj) {
	    if (!obj) {
	      return null;
	    }
	    return obj.path + obj.file_name;
	  },
	  safeJson: function safeJson(str) {
	    var safe = null;
	    try {
	      safe = JSON.parse(str);
	    } catch (e) {
	      safe = null;
	    }
	    return safe;
	  },
	
	  searchStoriesPills: function searchStoriesPills(dm, stories, searchStr) {
	    var storiesFound = [];
	
	    stories.forEach(function (story) {
	      var match = 0;
	
	      if (Number(dm.contents.story_category) === Number(story.folder)) {
	        if (story.contents.headline.toLowerCase().indexOf(searchStr) !== -1) {
	          match++;
	        }
	
	        if (story.contents.story.toLowerCase().indexOf(searchStr) !== -1) {
	          match++;
	        }
	
	        if (match > 0) {
	          storiesFound.push(story);
	        }
	      }
	    });
	
	    return storiesFound;
	  },
	
	  searchDonorList: function searchDonorList(content, searchStr) {
	    var donorLists = _lodash2.default.filter(content.dm_active, { display_module_type: "Donor List" });
	
	    if (donorLists.length > 0) {
	      var groupedDonorLists = [];
	      donorLists.forEach(function (dm) {
	        var donorListGrouped = _donorHelpers2.default.donorsIncluded(content.donors.donorCategories, dm.content.include_categories);
	        groupedDonorLists.push({
	          module: dm,
	          group: donorListGrouped
	        });
	      });
	    }
	  },
	
	  searchStories: function searchStories(content, searchStr) {
	    var _this = this;
	
	    var timelineModuleType = _lodash2.default.find(content.display_module_types, { name: "Timeline" });
	
	    var storiesModules = [];
	    var timelineModules = [];
	
	    content.dm_active.forEach(function (dm) {
	      if (dm.display_module_type === "Stories") {
	        storiesModules.push(dm);
	      }
	
	      if (dm.display_module_type === timelineModuleType.id) {
	        timelineModules.push(dm);
	      }
	    });
	
	    var results = {};
	    storiesModules.forEach(function (dm) {
	      switch (content.project.theme.name) {
	        case "Miami":
	          if (results[dm.contents.custom_fields.stories_type.val] === undefined) {
	            results[dm.contents.custom_fields.stories_type.val] = [];
	          }
	          results[dm.contents.custom_fields.stories_type.val].push({
	            display_module: dm,
	            stories: _this.searchStoriesPills(dm, content.stories, searchStr)
	          });
	          break;
	        default:
	          results['simple'] = _this.searchStoriesPills(dm, content.stories, searchStr);
	          break;
	      }
	    });
	
	    return results;
	  },
	
	  searchStory: function searchStory(content, searchStr) {
	    var folderExceptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    // Get folders which type is excempted to be searched
	    var exceptionFolders = content.story_categories.filter(function (fl) {
	      var type = _lodash2.default.get(fl, 'contents.custom_fields.folder_type.val.value', null);
	      return type && folderExceptions.indexOf(type) > -1;
	    }).map(function (fl) {
	      return fl.id;
	    });
	    // Get stories ids that are in any of those folders and
	    // exclude them in the search.
	    var excemptedStories = content.folder_modules.filter(function (fm) {
	      return exceptionFolders.indexOf(fm.folder) > -1 && fm.model === 'story';
	    }).map(function (fm) {
	      return fm.module_id;
	    }).filter(function (v, i, a) {
	      return a.indexOf(v) === i;
	    });
	
	    var foundStories = [];
	    for (var i = 0; i < content.stories.length; i++) {
	      var story = content.stories[i];
	      if (excemptedStories.indexOf(story.id) > -1) {
	        continue;
	      }
	      // Remove Stories with a Story Type of "Attract Loop"
	      var storyType = _lodash2.default.get(story, 'contents.custom_fields.story_type.val.value', null);
	      if (storyType === 'checkerboard') {
	        continue;
	      }
	      var match = 0;
	      if (story.name.toLowerCase().indexOf(searchStr) !== -1) {
	        match++;
	      }
	
	      if (_lodash2.default.get(story, 'contents.headline', null) && story.contents.headline.toLowerCase().indexOf(searchStr) !== -1) {
	        match++;
	      }
	
	      var textOps = _lodash2.default.get(story.contents, 'custom_fields.body.val.ops', {});
	      var converter = new QuillDeltaToHtmlConverter(textOps, {});
	      var richText = converter.convert();
	      if (richText.toLowerCase().indexOf(searchStr) !== -1) {
	        match++;
	      }
	
	      if (match > 0) {
	        foundStories.push(story);
	      }
	    }
	
	    return foundStories;
	  }
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventPluginRegistry = __webpack_require__(115);
	var EventPluginUtils = __webpack_require__(116);
	var ReactErrorUtils = __webpack_require__(120);
	
	var accumulateInto = __webpack_require__(324);
	var forEachAccumulated = __webpack_require__(325);
	var invariant = __webpack_require__(7);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(54);
	var EventPluginUtils = __webpack_require__(116);
	
	var accumulateInto = __webpack_require__(324);
	var forEachAccumulated = __webpack_require__(325);
	var warning = __webpack_require__(10);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	var getEventTarget = __webpack_require__(125);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 58 */
9,
/* 59 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonorFullPage = function (_Component) {
	  _inherits(DonorFullPage, _Component);
	
	  function DonorFullPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DonorFullPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DonorFullPage.__proto__ || Object.getPrototypeOf(DonorFullPage)).call.apply(_ref, [this].concat(args))), _this), _this.renderDonorLines = function () {
	      var counter = 0;
	      var h_spacing = _this.props.width / _this.props.columns;
	      var v_spacing = _this.props.height / _this.props.rows;
	      var r_margin = 0;
	      if (_this.props.overrideMarginRight) {
	        r_margin = _this.props.overrideMarginRight;
	      }
	
	      var fontSize = _this.props.overrideFontSize > 0 ? _this.props.overrideFontSize : v_spacing * 0.5;
	
	      var lineHeight = "normal";
	      if (_this.props.overrideLineHeightModifier) {
	        lineHeight = fontSize * _this.props.overrideLineHeightModifier + "px";
	      }
	
	      var previousHasBr = false;
	      var acc = 0;
	      return _this.props.donorData.map(function (row, i) {
	        if (this.props.sort === "row") {
	          return _react2.default.createElement(
	            "span",
	            { className: this.props.fontclass, key: i, style: { fontSize: fontSize, lineHeight: lineHeight } },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  position: "absolute",
	                  left: counter * h_spacing,
	                  width: h_spacing - r_margin,
	                  top: v_spacing * Math.floor(i / this.props.columns)
	                },
	                key: i
	              },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: row.name })
	            ),
	            counter++ === this.props.columns - 1 ? _react2.default.createElement("span", null) : _react2.default.createElement("span", null),
	            _react2.default.createElement(
	              "span",
	              { style: { display: "none" } },
	              counter === this.props.columns ? counter = 0 : null
	            )
	          );
	        } else {
	          //column
	          var top = counter * v_spacing + this.rowBreakPadding(counter);
	          if (this.props.evenVerticalSpace) {
	            if (counter === 0) {
	              acc = 0;
	              previousHasBr = false;
	            }
	
	            if (counter > 0) {
	              top -= acc;
	            }
	
	            previousHasBr = row.name.includes("<br>");
	
	            if (!previousHasBr) {
	              acc += this.props.width * 1.79398148148148148148 / 100;
	            }
	          }
	
	          return _react2.default.createElement(
	            "span",
	            { className: this.props.fontclass, key: i, style: { fontSize: fontSize, lineHeight: lineHeight } },
	            _react2.default.createElement(
	              "span",
	              {
	                style: {
	                  position: "absolute",
	                  left: h_spacing * Math.floor(i / this.props.rows),
	                  width: h_spacing - r_margin,
	                  top: top
	                },
	                key: i
	              },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: row.name })
	            ),
	            counter++ === this.props.rows - 1 ? _react2.default.createElement("span", null) : _react2.default.createElement("span", null),
	            _react2.default.createElement(
	              "span",
	              { style: { display: "none" } },
	              counter === this.props.rows ? counter = 0 : null
	            )
	          );
	        }
	      }, _this);
	    }, _this.rowBreakPadding = function (index, rules) {
	      if (_this.props.custom1x2 && index >= 8) {
	        return _this.props.screen.sv.p10 * 0.65;
	      } else {
	        return 0;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DonorFullPage, [{
	    key: "renderDonorName",
	    value: function renderDonorName(name) {
	      var splitline = false;
	      if (name.includes("<br>")) {
	        name = name.split("<br>");
	        splitline = true;
	      }
	      if (splitline === false) {
	        return name;
	      } else {
	        return name.map(function (row, i) {
	          return _react2.default.createElement(
	            "span",
	            { key: i },
	            row,
	            i < name.length ? _react2.default.createElement("br", null) : _react2.default.createElement("span", null)
	          );
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var dlines = this.renderDonorLines();
	      return _react2.default.createElement(
	        "div",
	        { style: { position: "absolute", top: 0, left: 0 } },
	        dlines
	      );
	    }
	  }]);
	
	  return DonorFullPage;
	}(_react.Component);
	
	exports.default = DonorFullPage;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconArrow = __webpack_require__(784);
	var iconArrowPrimary = __webpack_require__(783);
	
	var BackButtonMiami = function (_Component) {
	  _inherits(BackButtonMiami, _Component);
	
	  function BackButtonMiami() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BackButtonMiami);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BackButtonMiami.__proto__ || Object.getPrototypeOf(BackButtonMiami)).call.apply(_ref, [this].concat(args))), _this), _this.renderBackButton = function () {
	      var icon = iconArrow;
	      var textColor = "#95268e";
	      if (_this.props.colorPallette === "adaptive") {
	        icon = iconArrowPrimary;
	        textColor = "#006699";
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: '1vh', marginLeft: '.3vh', height: "2vh", width: "100%" } },
	          _react2.default.createElement(
	            'span',
	            { style: { position: "absolute", top: "0.208333333vh", fontSize: '.96vh', color: textColor, right: "0.91145833333333333333vh" } },
	            'BACK'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: "2.3vh", marginLeft: '.3vh', marginTop: "0.5vh", left: ".231481481481481481vh", width: "100%" } },
	          _react2.default.createElement('img', { className: 'fliph', alt: 'back', style: { position: "absolute", width: '1.5vh', height: '1.5vh', right: "1.5625vh" }, src: icon })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BackButtonMiami, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.mode === "video" ? _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left } },
	          this.renderBackButton()
	        ) : _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderBackButton()
	          )
	        )
	      );
	    }
	  }]);
	
	  return BackButtonMiami;
	}(_react.Component);
	
	exports.default = BackButtonMiami;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBlock = function (_Component) {
		_inherits(InfoBlock, _Component);
	
		function InfoBlock(props) {
			_classCallCheck(this, InfoBlock);
	
			var _this = _possibleConstructorReturn(this, (InfoBlock.__proto__ || Object.getPrototypeOf(InfoBlock)).call(this, props));
	
			_this._containerStyle = {
				width: _this.props.width,
				height: _this.props.imageHeight + _this.props.infoHeight,
				fontFamily: _this.props.fontFamily,
				fontSize: _this.props.fontSize,
				display: 'inline-block',
				position: 'relative'
			};
	
			_this._imageStyle = {
				display: 'block',
				width: _this.props.width,
				height: _this.props.imageHeight,
				borderTopLeftRadius: _this.props.unit * 0.15,
				borderTopRightRadius: _this.props.unit * 0.15,
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center"
			};
	
			_this._infoBlockStyle = {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				color: _this.props.infoColor,
				backgroundColor: _this.props.infoBackgroundColor,
				height: _this.props.infoHeight,
				minHeight: _this.props.infoHeight,
				borderBottomLeftRadius: _this.props.unit * 0.15,
				borderBottomRightRadius: _this.props.unit * 0.15,
				width: _this.props.width
			};
	
			return _this;
		}
	
		_createClass(InfoBlock, [{
			key: 'render',
			value: function render() {
				var arrowIcon = "/img/miami/ui/icon-arrow-forward.png";
				if (this.props.arrowIcon) {
					arrowIcon = this.props.arrowIcon;
				}
				return _react2.default.createElement(
					'div',
					{ style: this._containerStyle },
					_react2.default.createElement('div', { style: Object.assign({}, this._imageStyle, { backgroundImage: 'url(' + this.props.imgsrc + ')' }) }),
					_react2.default.createElement(
						'div',
						{ style: this._infoBlockStyle },
						_react2.default.createElement(
							'span',
							{ style: { marginLeft: "0.625vh", maxWidth: "78%", textOverflow: "ellipsis", overflow: "hidden", height: "3.38541666666666666667vh" } },
							this.props.text
						),
						_react2.default.createElement(
							'span',
							{ style: { marginRight: "0.625vh" } },
							_react2.default.createElement('img', { alt: 'Forward', src: arrowIcon, style: { display: 'inline-block', textAlign: 'right', width: "1.25vh" } })
						)
					)
				);
			}
		}]);
	
		return InfoBlock;
	}(_react.Component);
	
	module.exports = InfoBlock;
	
	// .DonorInfo h2 {
	//     padding-top: 32px;
	//     color: #44b4c2;
	// }
	// .DonorInfo p {
	//     margin-top: -10px;
	//     color: #333344;
	// }

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollSpacer = function ScrollSpacer(_ref) {
	    var unit = _ref.unit;
	
	    return _react2.default.createElement('div', { style: { height: unit * 2.25, width: '100%' } });
	};
	
	exports.default = ScrollSpacer;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _reactSlick = __webpack_require__(46);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _shared = __webpack_require__(4);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StorySeattle = function (_Component) {
	  _inherits(StorySeattle, _Component);
	
	  function StorySeattle(props) {
	    _classCallCheck(this, StorySeattle);
	
	    var _this = _possibleConstructorReturn(this, (StorySeattle.__proto__ || Object.getPrototypeOf(StorySeattle)).call(this, props));
	
	    _this.intervalCheckSwipeAnimation = function () {
	      if (!_this._contentRef) {
	        setTimeout(function () {
	          _this.intervalCheckSwipeAnimation();
	        }, 100);
	      } else {
	        _this.checkSwipeAnimation();
	      }
	    };
	
	    _this.checkSwipeAnimation = function () {
	      var scrollWrapperHeight = 0.14625 * _this.props.regionWidth;
	      var contentHeight = _this._contentRef.getBoundingClientRect().height;
	      _this.props.handleSwipeAnimation(scrollWrapperHeight, contentHeight);
	    };
	
	    _this.handleScrollStart = function () {
	      _this.props.cancelSwipeAnimation();
	    };
	
	    _this.getSlides = function () {
	      var images = _this.props.item.contents.images;
	      var occupiedSlots = _lodash2.default.filter(images, function (img) {
	        return img !== null;
	      });
	      var slides = [];
	
	      for (var i = 0; i < occupiedSlots.length; i++) {
	        if (occupiedSlots[i]) {
	          _this._totalSlides++;
	        }
	      }
	
	      if (occupiedSlots.length > 0) {
	        slides = occupiedSlots.map(function (media, i) {
	          var imgSrc = (0, _shared.presetDp)('story', media, _this.props.screen);
	          if (media) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, style: { display: "table" } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table-cell", verticalAlign: "middle", height: 0.21375 * _this.props.regionWidth } },
	                _react2.default.createElement('img', { style: { maxWidth: 0.28125 * _this.props.regionWidth, maxHeight: 0.2025 * _this.props.regionWidth, display: "table-cell", verticalAlign: "middle", margin: "auto" }, src: imgSrc, onLoad: function onLoad() {
	                    return _this._imagesStatus[i] = true;
	                  }, onError: function onError() {
	                    return _this._imagesStatus[i] = false;
	                  }, alt: '' })
	              )
	            );
	          }
	
	          return _react2.default.createElement('span', null);
	        });
	      }
	
	      return slides;
	    };
	
	    _this._imagesStatus = [];
	    _this._contentRef = null;
	    return _this;
	  }
	
	  _createClass(StorySeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.intervalCheckSwipeAnimation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var settings = {
	        arrows: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        centerMode: false,
	        useCSS: true,
	        dots: true,
	        dotsClass: "story-seattle-slick"
	      };
	
	      var slides = this.getSlides();
	      if (slides.length <= 1) {
	        settings.dots = false;
	      }
	
	      var textOps = _lodash2.default.get(this.props.item.contents, 'custom_fields.body.val.ops', {});
	      var converter = new QuillDeltaToHtmlConverter(textOps, {});
	      var richText = converter.convert();
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "absolute", display: "table", height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: "table-cell", verticalAlign: "middle" } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: "100%", alignItems: "center", display: "flex", justifyContent: "center", textAlign: "center", minHeight: .027 * this.props.regionWidth, maxHeight: .10 * this.props.regionWidth, overflow: "hidden" } },
	            _react2.default.createElement(
	              'span',
	              { className: 'noselect', style: { fontSize: 0.016875 * this.props.regionWidth, width: "65%" } },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.item.name.toUpperCase() })
	            )
	          ),
	          slides.length === 0 ? null : _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: "100%", height: 0.2475 * this.props.regionWidth, display: "flex" } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", width: 0.30375 * this.props.regionWidth, margin: "auto" } },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                Object.assign({ ref: function ref(el) {
	                    return _this2._slickRef = el;
	                  } }, settings),
	                slides
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'gradient', style: { position: "relative", height: 0.14625 * this.props.regionWidth, width: "100%", touchAction: "none", marginTop: .009 * this.props.regionWidth } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this2.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                onScrollStart: this.handleScrollStart,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.015,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { style: { position: "relative", display: "flex", justifyContent: "center" }, ref: function ref(el) {
	                    return _this2._contentRef = el;
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: 0.30375 * this.props.regionWidth, display: "flex" } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { fontSize: 0.01125 * this.props.regionWidth, textAlign: "left", lineHeight: 0.0225 * this.props.regionWidth + "px", color: "white" } },
	                    _react2.default.createElement('div', { className: 'ql-editor noselect', dangerouslySetInnerHTML: { __html: richText } }),
	                    '\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StorySeattle;
	}(_react.Component);
	
	exports.default = StorySeattle;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonorFullPage = function (_Component) {
	  _inherits(DonorFullPage, _Component);
	
	  function DonorFullPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DonorFullPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DonorFullPage.__proto__ || Object.getPrototypeOf(DonorFullPage)).call.apply(_ref, [this].concat(args))), _this), _this.renderColumns = function () {
	      var sort = _lodash2.default.get(_this.props, 'sort', 'column');
	      var fontSize = .0215053763440860215 * _this.props.width;
	      var columnDonors = [];
	      var columnWidth = _this.props.width / _this.props.columns;
	      if (_this.props.overridePadding) {
	        columnWidth -= _this.props.overridePadding * 2;
	      }
	      if (_this.props.overrideFontSize) {
	        fontSize = _this.props.overrideFontSize;
	      }
	
	      if (sort === "column") {
	        for (var i = 0; i < _this.props.donorData.length; i++) {
	          var columnIndex = i % _this.props.columns;
	          if (!columnDonors[columnIndex]) {
	            columnDonors[columnIndex] = [];
	          }
	          columnDonors[columnIndex].push(_this.props.donorData[i]);
	        }
	      } else {
	        var rest = _this.props.donorData.length % _this.props.columns;
	        var donorsPerColumn = Math.floor(_this.props.donorData.length / _this.props.columns);
	        var lastColumnTakeAway = rest === 0 ? 0 : _this.props.columns - rest;
	        var sumDonorsColumns = 0;
	        for (var _i = 0; _i < _this.props.columns; _i++) {
	          var totalDonorsColumn = donorsPerColumn;
	          if (lastColumnTakeAway > 0 && _i < _this.props.columns - 1) {
	            totalDonorsColumn++;
	          }
	          if (lastColumnTakeAway > 0 && _i === _this.props.columns - 1) {
	            totalDonorsColumn -= lastColumnTakeAway;
	          }
	          columnDonors[_i] = _this.props.donorData.slice(sumDonorsColumns, sumDonorsColumns + totalDonorsColumn);
	          sumDonorsColumns += totalDonorsColumn;
	        }
	      }
	
	      var renderedColumns = columnDonors.map(function (donors, i) {
	        var renderedDonors = donors.map(function (donor, j) {
	          var text1 = _lodash2.default.get(donor.contents, 'texts[0].text', null);
	          return _react2.default.createElement(
	            'div',
	            { key: j },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: fontSize, marginBlockEnd: _this.props.screen.screenWidth * .00462962962962962963 } },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: donor.name })
	            ),
	            text1 ? _react2.default.createElement(
	              'p',
	              { style: { paddingLeft: _this.props.width * .04878615402485770705, fontSize: .0215053763440860215 * _this.props.width, marginBlockStart: 0, marginBlockEnd: _this.props.screen.screenWidth * .02777777777777777778 } },
	              text1
	            ) : null
	          );
	        });
	        var paddingRight = _this.props.overridePadding ? _this.props.overridePadding : 0;
	        var paddingLeft = _this.props.overridePadding ? _this.props.overridePadding : 0;
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: { width: columnWidth, float: "left", paddingLeft: paddingLeft, paddingRight: paddingRight } },
	          renderedDonors
	        );
	      });
	
	      return renderedColumns;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DonorFullPage, [{
	    key: 'render',
	    value: function render() {
	      var columns = this.renderColumns();
	      return _react2.default.createElement(
	        'div',
	        null,
	        columns
	      );
	    }
	  }]);
	
	  return DonorFullPage;
	}(_react.Component);
	
	exports.default = DonorFullPage;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 67 */
/***/ function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ },
/* 68 */
[794, 541],
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(768);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(790);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
	(function (window, document, Math) {
	var rAF = window.requestAnimationFrame	||
		window.webkitRequestAnimationFrame	||
		window.mozRequestAnimationFrame		||
		window.oRequestAnimationFrame		||
		window.msRequestAnimationFrame		||
		function (callback) { window.setTimeout(callback, 1000 / 60); };
	
	var utils = (function () {
		var me = {};
	
		var _elementStyle = document.createElement('div').style;
		var _vendor = (function () {
			var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
				transform,
				i = 0,
				l = vendors.length;
	
			for ( ; i < l; i++ ) {
				transform = vendors[i] + 'ransform';
				if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
			}
	
			return false;
		})();
	
		function _prefixStyle (style) {
			if ( _vendor === false ) return false;
			if ( _vendor === '' ) return style;
			return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
		}
	
		me.getTime = Date.now || function getTime () { return new Date().getTime(); };
	
		me.extend = function (target, obj) {
			for ( var i in obj ) {
				target[i] = obj[i];
			}
		};
	
		me.addEvent = function (el, type, fn, capture) {
			el.addEventListener(type, fn, !!capture);
		};
	
		me.removeEvent = function (el, type, fn, capture) {
			el.removeEventListener(type, fn, !!capture);
		};
	
		me.prefixPointerEvent = function (pointerEvent) {
			return window.MSPointerEvent ?
				'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
				pointerEvent;
		};
	
		me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
			var distance = current - start,
				speed = Math.abs(distance) / time,
				destination,
				duration;
	
			deceleration = deceleration === undefined ? 0.0006 : deceleration;
	
			destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
			duration = speed / deceleration;
	
			if ( destination < lowerMargin ) {
				destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
				distance = Math.abs(destination - current);
				duration = distance / speed;
			} else if ( destination > 0 ) {
				destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
				distance = Math.abs(current) + destination;
				duration = distance / speed;
			}
	
			return {
				destination: Math.round(destination),
				duration: duration
			};
		};
	
		var _transform = _prefixStyle('transform');
	
		me.extend(me, {
			hasTransform: _transform !== false,
			hasPerspective: _prefixStyle('perspective') in _elementStyle,
			hasTouch: 'ontouchstart' in window,
			hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
			hasTransition: _prefixStyle('transition') in _elementStyle
		});
	
		/*
		This should find all Android browsers lower than build 535.19 (both stock browser and webview)
		- galaxy S2 is ok
	    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
	    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S3 is badAndroid (stock brower, webview)
	     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S4 is badAndroid (stock brower, webview)
	     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
	   - galaxy S5 is OK
	     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
	   - galaxy S6 is OK
	     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
	  */
		me.isBadAndroid = (function() {
			var appVersion = window.navigator.appVersion;
			// Android browser is not a chrome browser.
			if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
				var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
				if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
					return parseFloat(safariVersion[1]) < 535.19;
				} else {
					return true;
				}
			} else {
				return false;
			}
		})();
	
		me.extend(me.style = {}, {
			transform: _transform,
			transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
			transitionDuration: _prefixStyle('transitionDuration'),
			transitionDelay: _prefixStyle('transitionDelay'),
			transformOrigin: _prefixStyle('transformOrigin')
		});
	
		me.hasClass = function (e, c) {
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
			return re.test(e.className);
		};
	
		me.addClass = function (e, c) {
			if ( me.hasClass(e, c) ) {
				return;
			}
	
			var newclass = e.className.split(' ');
			newclass.push(c);
			e.className = newclass.join(' ');
		};
	
		me.removeClass = function (e, c) {
			if ( !me.hasClass(e, c) ) {
				return;
			}
	
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
			e.className = e.className.replace(re, ' ');
		};
	
		me.offset = function (el) {
			var left = -el.offsetLeft,
				top = -el.offsetTop;
	
			// jshint -W084
			while (el = el.offsetParent) {
				left -= el.offsetLeft;
				top -= el.offsetTop;
			}
			// jshint +W084
	
			return {
				left: left,
				top: top
			};
		};
	
		me.preventDefaultException = function (el, exceptions) {
			for ( var i in exceptions ) {
				if ( exceptions[i].test(el[i]) ) {
					return true;
				}
			}
	
			return false;
		};
	
		me.extend(me.eventType = {}, {
			touchstart: 1,
			touchmove: 1,
			touchend: 1,
	
			mousedown: 2,
			mousemove: 2,
			mouseup: 2,
	
			pointerdown: 3,
			pointermove: 3,
			pointerup: 3,
	
			MSPointerDown: 3,
			MSPointerMove: 3,
			MSPointerUp: 3
		});
	
		me.extend(me.ease = {}, {
			quadratic: {
				style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
				fn: function (k) {
					return k * ( 2 - k );
				}
			},
			circular: {
				style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
				fn: function (k) {
					return Math.sqrt( 1 - ( --k * k ) );
				}
			},
			back: {
				style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
				fn: function (k) {
					var b = 4;
					return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
				}
			},
			bounce: {
				style: '',
				fn: function (k) {
					if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
						return 7.5625 * k * k;
					} else if ( k < ( 2 / 2.75 ) ) {
						return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
					} else if ( k < ( 2.5 / 2.75 ) ) {
						return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
					} else {
						return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
					}
				}
			},
			elastic: {
				style: '',
				fn: function (k) {
					var f = 0.22,
						e = 0.4;
	
					if ( k === 0 ) { return 0; }
					if ( k == 1 ) { return 1; }
	
					return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
				}
			}
		});
	
		me.tap = function (e, eventName) {
			var ev = document.createEvent('Event');
			ev.initEvent(eventName, true, true);
			ev.pageX = e.pageX;
			ev.pageY = e.pageY;
			e.target.dispatchEvent(ev);
		};
	
		me.click = function (e) {
			var target = e.target,
				ev;
	
			if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
				ev = document.createEvent('MouseEvents');
				ev.initMouseEvent('click', true, true, e.view, 1,
					target.screenX, target.screenY, target.clientX, target.clientY,
					e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
					0, null);
	
				ev._constructed = true;
				target.dispatchEvent(ev);
			}
		};
	
		return me;
	})();
	function IScroll (el, options) {
		this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
		this.scroller = this.wrapper.children[0];
		this.scrollerStyle = this.scroller.style;		// cache style for better performance
	
		this.options = {
	
			resizeScrollbars: true,
	
			mouseWheelSpeed: 20,
	
			snapThreshold: 0.334,
	
	// INSERT POINT: OPTIONS
			disablePointer : !utils.hasPointer,
			disableTouch : utils.hasPointer || !utils.hasTouch,
			disableMouse : utils.hasPointer || utils.hasTouch,
			startX: 0,
			startY: 0,
			scrollY: true,
			directionLockThreshold: 5,
			momentum: true,
	
			bounce: true,
			bounceTime: 600,
			bounceEasing: '',
	
			preventDefault: true,
			preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },
	
			HWCompositing: true,
			useTransition: true,
			useTransform: true,
			bindToWrapper: typeof window.onmousedown === "undefined"
		};
	
		for ( var i in options ) {
			this.options[i] = options[i];
		}
	
		// Normalize options
		this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
	
		this.options.useTransition = utils.hasTransition && this.options.useTransition;
		this.options.useTransform = utils.hasTransform && this.options.useTransform;
	
		this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
		this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
	
		// If you want eventPassthrough I have to lock one of the axes
		this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
		this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
	
		// With eventPassthrough we also need lockDirection mechanism
		this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
		this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
	
		this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
	
		this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
	
		if ( this.options.tap === true ) {
			this.options.tap = 'tap';
		}
	
		if ( this.options.shrinkScrollbars == 'scale' ) {
			this.options.useTransition = false;
		}
	
		this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
	
		if ( this.options.probeType == 3 ) {
			this.options.useTransition = false;	}
	
	// INSERT POINT: NORMALIZATION
	
		// Some defaults
		this.x = 0;
		this.y = 0;
		this.directionX = 0;
		this.directionY = 0;
		this._events = {};
	
	// INSERT POINT: DEFAULTS
	
		this._init();
		this.refresh();
	
		this.scrollTo(this.options.startX, this.options.startY);
		this.enable();
	}
	
	IScroll.prototype = {
		version: '5.2.0',
	
		_init: function () {
			this._initEvents();
	
			if ( this.options.scrollbars || this.options.indicators ) {
				this._initIndicators();
			}
	
			if ( this.options.mouseWheel ) {
				this._initWheel();
			}
	
			if ( this.options.snap ) {
				this._initSnap();
			}
	
			if ( this.options.keyBindings ) {
				this._initKeys();
			}
	
	// INSERT POINT: _init
	
		},
	
		destroy: function () {
			this._initEvents(true);
			clearTimeout(this.resizeTimeout);
	 		this.resizeTimeout = null;
			this._execEvent('destroy');
		},
	
		_transitionEnd: function (e) {
			if ( e.target != this.scroller || !this.isInTransition ) {
				return;
			}
	
			this._transitionTime();
			if ( !this.resetPosition(this.options.bounceTime) ) {
				this.isInTransition = false;
				this._execEvent('scrollEnd');
			}
		},
	
		_start: function (e) {
			// React to left mouse button only
			if ( utils.eventType[e.type] != 1 ) {
			  // for button property
			  // http://unixpapa.com/js/mouse.html
			  var button;
		    if (!e.which) {
		      /* IE case */
		      button = (e.button < 2) ? 0 :
		               ((e.button == 4) ? 1 : 2);
		    } else {
		      /* All others */
		      button = e.button;
		    }
				if ( button !== 0 ) {
					return;
				}
			}
	
			if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
				return;
			}
	
			if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
				e.preventDefault();
			}
	
			var point = e.touches ? e.touches[0] : e,
				pos;
	
			this.initiated	= utils.eventType[e.type];
			this.moved		= false;
			this.distX		= 0;
			this.distY		= 0;
			this.directionX = 0;
			this.directionY = 0;
			this.directionLocked = 0;
	
			this.startTime = utils.getTime();
	
			if ( this.options.useTransition && this.isInTransition ) {
				this._transitionTime();
				this.isInTransition = false;
				pos = this.getComputedPosition();
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this._execEvent('scrollEnd');
			} else if ( !this.options.useTransition && this.isAnimating ) {
				this.isAnimating = false;
				this._execEvent('scrollEnd');
			}
	
			this.startX    = this.x;
			this.startY    = this.y;
			this.absStartX = this.x;
			this.absStartY = this.y;
			this.pointX    = point.pageX;
			this.pointY    = point.pageY;
	
			this._execEvent('beforeScrollStart');
		},
	
		_move: function (e) {
			if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
				return;
			}
	
			if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
				e.preventDefault();
			}
	
			var point		= e.touches ? e.touches[0] : e,
				deltaX		= point.pageX - this.pointX,
				deltaY		= point.pageY - this.pointY,
				timestamp	= utils.getTime(),
				newX, newY,
				absDistX, absDistY;
	
			this.pointX		= point.pageX;
			this.pointY		= point.pageY;
	
			this.distX		+= deltaX;
			this.distY		+= deltaY;
			absDistX		= Math.abs(this.distX);
			absDistY		= Math.abs(this.distY);
	
			// We need to move at least 10 pixels for the scrolling to initiate
			if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
				return;
			}
	
			// If you are scrolling in one direction lock the other
			if ( !this.directionLocked && !this.options.freeScroll ) {
				if ( absDistX > absDistY + this.options.directionLockThreshold ) {
					this.directionLocked = 'h';		// lock horizontally
				} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
					this.directionLocked = 'v';		// lock vertically
				} else {
					this.directionLocked = 'n';		// no lock
				}
			}
	
			if ( this.directionLocked == 'h' ) {
				if ( this.options.eventPassthrough == 'vertical' ) {
					e.preventDefault();
				} else if ( this.options.eventPassthrough == 'horizontal' ) {
					this.initiated = false;
					return;
				}
	
				deltaY = 0;
			} else if ( this.directionLocked == 'v' ) {
				if ( this.options.eventPassthrough == 'horizontal' ) {
					e.preventDefault();
				} else if ( this.options.eventPassthrough == 'vertical' ) {
					this.initiated = false;
					return;
				}
	
				deltaX = 0;
			}
	
			deltaX = this.hasHorizontalScroll ? deltaX : 0;
			deltaY = this.hasVerticalScroll ? deltaY : 0;
	
			newX = this.x + deltaX;
			newY = this.y + deltaY;
	
			// Slow down if outside of the boundaries
			if ( newX > 0 || newX < this.maxScrollX ) {
				newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
			}
			if ( newY > 0 || newY < this.maxScrollY ) {
				newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
			}
	
			this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
			this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
	
			if ( !this.moved ) {
				this._execEvent('scrollStart');
			}
	
			this.moved = true;
	
			this._translate(newX, newY);
	
	/* REPLACE START: _move */
			if ( timestamp - this.startTime > 300 ) {
				this.startTime = timestamp;
				this.startX = this.x;
				this.startY = this.y;
	
				if ( this.options.probeType == 1 ) {
					this._execEvent('scroll');
				}
			}
	
			if ( this.options.probeType > 1 ) {
				this._execEvent('scroll');
			}
	/* REPLACE END: _move */
	
		},
	
		_end: function (e) {
			if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
				return;
			}
	
			if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
				e.preventDefault();
			}
	
			var point = e.changedTouches ? e.changedTouches[0] : e,
				momentumX,
				momentumY,
				duration = utils.getTime() - this.startTime,
				newX = Math.round(this.x),
				newY = Math.round(this.y),
				distanceX = Math.abs(newX - this.startX),
				distanceY = Math.abs(newY - this.startY),
				time = 0,
				easing = '';
	
			this.isInTransition = 0;
			this.initiated = 0;
			this.endTime = utils.getTime();
	
			// reset if we are outside of the boundaries
			if ( this.resetPosition(this.options.bounceTime) ) {
				return;
			}
	
			this.scrollTo(newX, newY);	// ensures that the last position is rounded
	
			// we scrolled less than 10 pixels
			if ( !this.moved ) {
				if ( this.options.tap ) {
					utils.tap(e, this.options.tap);
				}
	
				if ( this.options.click ) {
					utils.click(e);
				}
	
				this._execEvent('scrollCancel');
				return;
			}
	
			if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
				this._execEvent('flick');
				return;
			}
	
			// start momentum animation if needed
			if ( this.options.momentum && duration < 300 ) {
				momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
				momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
				newX = momentumX.destination;
				newY = momentumY.destination;
				time = Math.max(momentumX.duration, momentumY.duration);
				this.isInTransition = 1;
			}
	
	
			if ( this.options.snap ) {
				var snap = this._nearestSnap(newX, newY);
				this.currentPage = snap;
				time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(newX - snap.x), 1000),
							Math.min(Math.abs(newY - snap.y), 1000)
						), 300);
				newX = snap.x;
				newY = snap.y;
	
				this.directionX = 0;
				this.directionY = 0;
				easing = this.options.bounceEasing;
			}
	
	// INSERT POINT: _end
	
			if ( newX != this.x || newY != this.y ) {
				// change easing function when scroller goes out of the boundaries
				if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
					easing = utils.ease.quadratic;
				}
	
				this.scrollTo(newX, newY, time, easing);
				return;
			}
	
			this._execEvent('scrollEnd');
		},
	
		_resize: function () {
			var that = this;
	
			clearTimeout(this.resizeTimeout);
	
			this.resizeTimeout = setTimeout(function () {
				that.refresh();
			}, this.options.resizePolling);
		},
	
		resetPosition: function (time) {
			var x = this.x,
				y = this.y;
	
			time = time || 0;
	
			if ( !this.hasHorizontalScroll || this.x > 0 ) {
				x = 0;
			} else if ( this.x < this.maxScrollX ) {
				x = this.maxScrollX;
			}
	
			if ( !this.hasVerticalScroll || this.y > 0 ) {
				y = 0;
			} else if ( this.y < this.maxScrollY ) {
				y = this.maxScrollY;
			}
	
			if ( x == this.x && y == this.y ) {
				return false;
			}
	
			this.scrollTo(x, y, time, this.options.bounceEasing);
	
			return true;
		},
	
		disable: function () {
			this.enabled = false;
		},
	
		enable: function () {
			this.enabled = true;
		},
	
		refresh: function () {
			var rf = this.wrapper.offsetHeight;		// Force reflow
	
			this.wrapperWidth	= this.wrapper.clientWidth;
			this.wrapperHeight	= this.wrapper.clientHeight;
	
	/* REPLACE START: refresh */
	
			this.scrollerWidth	= this.scroller.offsetWidth;
			this.scrollerHeight	= this.scroller.offsetHeight;
	
			this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
			this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;
	
	/* REPLACE END: refresh */
	
			this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
			this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;
	
			if ( !this.hasHorizontalScroll ) {
				this.maxScrollX = 0;
				this.scrollerWidth = this.wrapperWidth;
			}
	
			if ( !this.hasVerticalScroll ) {
				this.maxScrollY = 0;
				this.scrollerHeight = this.wrapperHeight;
			}
	
			this.endTime = 0;
			this.directionX = 0;
			this.directionY = 0;
	
			this.wrapperOffset = utils.offset(this.wrapper);
	
			this._execEvent('refresh');
	
			this.resetPosition();
	
	// INSERT POINT: _refresh
	
		},
	
		on: function (type, fn) {
			if ( !this._events[type] ) {
				this._events[type] = [];
			}
	
			this._events[type].push(fn);
		},
	
		off: function (type, fn) {
			if ( !this._events[type] ) {
				return;
			}
	
			var index = this._events[type].indexOf(fn);
	
			if ( index > -1 ) {
				this._events[type].splice(index, 1);
			}
		},
	
		_execEvent: function (type) {
			if ( !this._events[type] ) {
				return;
			}
	
			var i = 0,
				l = this._events[type].length;
	
			if ( !l ) {
				return;
			}
	
			for ( ; i < l; i++ ) {
				this._events[type][i].apply(this, [].slice.call(arguments, 1));
			}
		},
	
		scrollBy: function (x, y, time, easing) {
			x = this.x + x;
			y = this.y + y;
			time = time || 0;
	
			this.scrollTo(x, y, time, easing);
		},
	
		scrollTo: function (x, y, time, easing) {
			easing = easing || utils.ease.circular;
	
			this.isInTransition = this.options.useTransition && time > 0;
			var transitionType = this.options.useTransition && easing.style;
			if ( !time || transitionType ) {
					if(transitionType) {
						this._transitionTimingFunction(easing.style);
						this._transitionTime(time);
					}
				this._translate(x, y);
			} else {
				this._animate(x, y, time, easing.fn);
			}
		},
	
		scrollToElement: function (el, time, offsetX, offsetY, easing) {
			el = el.nodeType ? el : this.scroller.querySelector(el);
	
			if ( !el ) {
				return;
			}
	
			var pos = utils.offset(el);
	
			pos.left -= this.wrapperOffset.left;
			pos.top  -= this.wrapperOffset.top;
	
			// if offsetX/Y are true we center the element to the screen
			if ( offsetX === true ) {
				offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
			}
			if ( offsetY === true ) {
				offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
			}
	
			pos.left -= offsetX || 0;
			pos.top  -= offsetY || 0;
	
			pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
			pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;
	
			time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;
	
			this.scrollTo(pos.left, pos.top, time, easing);
		},
	
		_transitionTime: function (time) {
			time = time || 0;
	
			var durationProp = utils.style.transitionDuration;
			this.scrollerStyle[durationProp] = time + 'ms';
	
			if ( !time && utils.isBadAndroid ) {
				this.scrollerStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function() {
					if(self.scrollerStyle[durationProp] === '0.0001ms') {
						self.scrollerStyle[durationProp] = '0s';
					}
				});
			}
	
	
			if ( this.indicators ) {
				for ( var i = this.indicators.length; i--; ) {
					this.indicators[i].transitionTime(time);
				}
			}
	
	
	// INSERT POINT: _transitionTime
	
		},
	
		_transitionTimingFunction: function (easing) {
			this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
	
	
			if ( this.indicators ) {
				for ( var i = this.indicators.length; i--; ) {
					this.indicators[i].transitionTimingFunction(easing);
				}
			}
	
	
	// INSERT POINT: _transitionTimingFunction
	
		},
	
		_translate: function (x, y) {
			if ( this.options.useTransform ) {
	
	/* REPLACE START: _translate */
	
				this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
	
	/* REPLACE END: _translate */
	
			} else {
				x = Math.round(x);
				y = Math.round(y);
				this.scrollerStyle.left = x + 'px';
				this.scrollerStyle.top = y + 'px';
			}
	
			this.x = x;
			this.y = y;
	
	
		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].updatePosition();
			}
		}
	
	
	// INSERT POINT: _translate
	
		},
	
		_initEvents: function (remove) {
			var eventType = remove ? utils.removeEvent : utils.addEvent,
				target = this.options.bindToWrapper ? this.wrapper : window;
	
			eventType(window, 'orientationchange', this);
			eventType(window, 'resize', this);
	
			if ( this.options.click ) {
				eventType(this.wrapper, 'click', this, true);
			}
	
			if ( !this.options.disableMouse ) {
				eventType(this.wrapper, 'mousedown', this);
				eventType(target, 'mousemove', this);
				eventType(target, 'mousecancel', this);
				eventType(target, 'mouseup', this);
			}
	
			if ( utils.hasPointer && !this.options.disablePointer ) {
				eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
				eventType(target, utils.prefixPointerEvent('pointermove'), this);
				eventType(target, utils.prefixPointerEvent('pointercancel'), this);
				eventType(target, utils.prefixPointerEvent('pointerup'), this);
			}
	
			if ( utils.hasTouch && !this.options.disableTouch ) {
				eventType(this.wrapper, 'touchstart', this);
				eventType(target, 'touchmove', this);
				eventType(target, 'touchcancel', this);
				eventType(target, 'touchend', this);
			}
	
			eventType(this.scroller, 'transitionend', this);
			eventType(this.scroller, 'webkitTransitionEnd', this);
			eventType(this.scroller, 'oTransitionEnd', this);
			eventType(this.scroller, 'MSTransitionEnd', this);
		},
	
		getComputedPosition: function () {
			var matrix = window.getComputedStyle(this.scroller, null),
				x, y;
	
			if ( this.options.useTransform ) {
				matrix = matrix[utils.style.transform].split(')')[0].split(', ');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +matrix.left.replace(/[^-\d.]/g, '');
				y = +matrix.top.replace(/[^-\d.]/g, '');
			}
	
			return { x: x, y: y };
		},
		_initIndicators: function () {
			var interactive = this.options.interactiveScrollbars,
				customStyle = typeof this.options.scrollbars != 'string',
				indicators = [],
				indicator;
	
			var that = this;
	
			this.indicators = [];
	
			if ( this.options.scrollbars ) {
				// Vertical scrollbar
				if ( this.options.scrollY ) {
					indicator = {
						el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenX: false
					};
	
					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
	
				// Horizontal scrollbar
				if ( this.options.scrollX ) {
					indicator = {
						el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenY: false
					};
	
					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
			}
	
			if ( this.options.indicators ) {
				// TODO: check concat compatibility
				indicators = indicators.concat(this.options.indicators);
			}
	
			for ( var i = indicators.length; i--; ) {
				this.indicators.push( new Indicator(this, indicators[i]) );
			}
	
			// TODO: check if we can use array.map (wide compatibility and performance issues)
			function _indicatorsMap (fn) {
				if (that.indicators) {
					for ( var i = that.indicators.length; i--; ) {
						fn.call(that.indicators[i]);
					}
				}
			}
	
			if ( this.options.fadeScrollbars ) {
				this.on('scrollEnd', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});
	
				this.on('scrollCancel', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});
	
				this.on('scrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1);
					});
				});
	
				this.on('beforeScrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1, true);
					});
				});
			}
	
	
			this.on('refresh', function () {
				_indicatorsMap(function () {
					this.refresh();
				});
			});
	
			this.on('destroy', function () {
				_indicatorsMap(function () {
					this.destroy();
				});
	
				delete this.indicators;
			});
		},
	
		_initWheel: function () {
			utils.addEvent(this.wrapper, 'wheel', this);
			utils.addEvent(this.wrapper, 'mousewheel', this);
			utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
	
			this.on('destroy', function () {
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = null;
				utils.removeEvent(this.wrapper, 'wheel', this);
				utils.removeEvent(this.wrapper, 'mousewheel', this);
				utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
			});
		},
	
		_wheel: function (e) {
			if ( !this.enabled ) {
				return;
			}
	
			e.preventDefault();
	
			var wheelDeltaX, wheelDeltaY,
				newX, newY,
				that = this;
	
			if ( this.wheelTimeout === undefined ) {
				that._execEvent('scrollStart');
			}
	
			// Execute the scrollEnd event after 400ms the wheel stopped scrolling
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(function () {
				if(!that.options.snap) {
					that._execEvent('scrollEnd');
				}
				that.wheelTimeout = undefined;
			}, 400);
	
			if ( 'deltaX' in e ) {
				if (e.deltaMode === 1) {
					wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
					wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
				} else {
					wheelDeltaX = -e.deltaX;
					wheelDeltaY = -e.deltaY;
				}
			} else if ( 'wheelDeltaX' in e ) {
				wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
				wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
			} else if ( 'wheelDelta' in e ) {
				wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
			} else if ( 'detail' in e ) {
				wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
			} else {
				return;
			}
	
			wheelDeltaX *= this.options.invertWheelDirection;
			wheelDeltaY *= this.options.invertWheelDirection;
	
			if ( !this.hasVerticalScroll ) {
				wheelDeltaX = wheelDeltaY;
				wheelDeltaY = 0;
			}
	
			if ( this.options.snap ) {
				newX = this.currentPage.pageX;
				newY = this.currentPage.pageY;
	
				if ( wheelDeltaX > 0 ) {
					newX--;
				} else if ( wheelDeltaX < 0 ) {
					newX++;
				}
	
				if ( wheelDeltaY > 0 ) {
					newY--;
				} else if ( wheelDeltaY < 0 ) {
					newY++;
				}
	
				this.goToPage(newX, newY);
	
				return;
			}
	
			newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
			newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
	
			this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
			this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;
	
			if ( newX > 0 ) {
				newX = 0;
			} else if ( newX < this.maxScrollX ) {
				newX = this.maxScrollX;
			}
	
			if ( newY > 0 ) {
				newY = 0;
			} else if ( newY < this.maxScrollY ) {
				newY = this.maxScrollY;
			}
	
			this.scrollTo(newX, newY, 0);
	
			if ( this.options.probeType > 1 ) {
				this._execEvent('scroll');
			}
	
	// INSERT POINT: _wheel
		},
	
		_initSnap: function () {
			this.currentPage = {};
	
			if ( typeof this.options.snap == 'string' ) {
				this.options.snap = this.scroller.querySelectorAll(this.options.snap);
			}
	
			this.on('refresh', function () {
				var i = 0, l,
					m = 0, n,
					cx, cy,
					x = 0, y,
					stepX = this.options.snapStepX || this.wrapperWidth,
					stepY = this.options.snapStepY || this.wrapperHeight,
					el;
	
				this.pages = [];
	
				if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
					return;
				}
	
				if ( this.options.snap === true ) {
					cx = Math.round( stepX / 2 );
					cy = Math.round( stepY / 2 );
	
					while ( x > -this.scrollerWidth ) {
						this.pages[i] = [];
						l = 0;
						y = 0;
	
						while ( y > -this.scrollerHeight ) {
							this.pages[i][l] = {
								x: Math.max(x, this.maxScrollX),
								y: Math.max(y, this.maxScrollY),
								width: stepX,
								height: stepY,
								cx: x - cx,
								cy: y - cy
							};
	
							y -= stepY;
							l++;
						}
	
						x -= stepX;
						i++;
					}
				} else {
					el = this.options.snap;
					l = el.length;
					n = -1;
	
					for ( ; i < l; i++ ) {
						if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
							m = 0;
							n++;
						}
	
						if ( !this.pages[m] ) {
							this.pages[m] = [];
						}
	
						x = Math.max(-el[i].offsetLeft, this.maxScrollX);
						y = Math.max(-el[i].offsetTop, this.maxScrollY);
						cx = x - Math.round(el[i].offsetWidth / 2);
						cy = y - Math.round(el[i].offsetHeight / 2);
	
						this.pages[m][n] = {
							x: x,
							y: y,
							width: el[i].offsetWidth,
							height: el[i].offsetHeight,
							cx: cx,
							cy: cy
						};
	
						if ( x > this.maxScrollX ) {
							m++;
						}
					}
				}
	
				this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
	
				// Update snap threshold if needed
				if ( this.options.snapThreshold % 1 === 0 ) {
					this.snapThresholdX = this.options.snapThreshold;
					this.snapThresholdY = this.options.snapThreshold;
				} else {
					this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
					this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
				}
			});
	
			this.on('flick', function () {
				var time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(this.x - this.startX), 1000),
							Math.min(Math.abs(this.y - this.startY), 1000)
						), 300);
	
				this.goToPage(
					this.currentPage.pageX + this.directionX,
					this.currentPage.pageY + this.directionY,
					time
				);
			});
		},
	
		_nearestSnap: function (x, y) {
			if ( !this.pages.length ) {
				return { x: 0, y: 0, pageX: 0, pageY: 0 };
			}
	
			var i = 0,
				l = this.pages.length,
				m = 0;
	
			// Check if we exceeded the snap threshold
			if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
				Math.abs(y - this.absStartY) < this.snapThresholdY ) {
				return this.currentPage;
			}
	
			if ( x > 0 ) {
				x = 0;
			} else if ( x < this.maxScrollX ) {
				x = this.maxScrollX;
			}
	
			if ( y > 0 ) {
				y = 0;
			} else if ( y < this.maxScrollY ) {
				y = this.maxScrollY;
			}
	
			for ( ; i < l; i++ ) {
				if ( x >= this.pages[i][0].cx ) {
					x = this.pages[i][0].x;
					break;
				}
			}
	
			l = this.pages[i].length;
	
			for ( ; m < l; m++ ) {
				if ( y >= this.pages[0][m].cy ) {
					y = this.pages[0][m].y;
					break;
				}
			}
	
			if ( i == this.currentPage.pageX ) {
				i += this.directionX;
	
				if ( i < 0 ) {
					i = 0;
				} else if ( i >= this.pages.length ) {
					i = this.pages.length - 1;
				}
	
				x = this.pages[i][0].x;
			}
	
			if ( m == this.currentPage.pageY ) {
				m += this.directionY;
	
				if ( m < 0 ) {
					m = 0;
				} else if ( m >= this.pages[0].length ) {
					m = this.pages[0].length - 1;
				}
	
				y = this.pages[0][m].y;
			}
	
			return {
				x: x,
				y: y,
				pageX: i,
				pageY: m
			};
		},
	
		goToPage: function (x, y, time, easing) {
			easing = easing || this.options.bounceEasing;
	
			if ( x >= this.pages.length ) {
				x = this.pages.length - 1;
			} else if ( x < 0 ) {
				x = 0;
			}
	
			if ( y >= this.pages[x].length ) {
				y = this.pages[x].length - 1;
			} else if ( y < 0 ) {
				y = 0;
			}
	
			var posX = this.pages[x][y].x,
				posY = this.pages[x][y].y;
	
			time = time === undefined ? this.options.snapSpeed || Math.max(
				Math.max(
					Math.min(Math.abs(posX - this.x), 1000),
					Math.min(Math.abs(posY - this.y), 1000)
				), 300) : time;
	
			this.currentPage = {
				x: posX,
				y: posY,
				pageX: x,
				pageY: y
			};
	
			this.scrollTo(posX, posY, time, easing);
		},
	
		next: function (time, easing) {
			var x = this.currentPage.pageX,
				y = this.currentPage.pageY;
	
			x++;
	
			if ( x >= this.pages.length && this.hasVerticalScroll ) {
				x = 0;
				y++;
			}
	
			this.goToPage(x, y, time, easing);
		},
	
		prev: function (time, easing) {
			var x = this.currentPage.pageX,
				y = this.currentPage.pageY;
	
			x--;
	
			if ( x < 0 && this.hasVerticalScroll ) {
				x = 0;
				y--;
			}
	
			this.goToPage(x, y, time, easing);
		},
	
		_initKeys: function (e) {
			// default key bindings
			var keys = {
				pageUp: 33,
				pageDown: 34,
				end: 35,
				home: 36,
				left: 37,
				up: 38,
				right: 39,
				down: 40
			};
			var i;
	
			// if you give me characters I give you keycode
			if ( typeof this.options.keyBindings == 'object' ) {
				for ( i in this.options.keyBindings ) {
					if ( typeof this.options.keyBindings[i] == 'string' ) {
						this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
					}
				}
			} else {
				this.options.keyBindings = {};
			}
	
			for ( i in keys ) {
				this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
			}
	
			utils.addEvent(window, 'keydown', this);
	
			this.on('destroy', function () {
				utils.removeEvent(window, 'keydown', this);
			});
		},
	
		_key: function (e) {
			if ( !this.enabled ) {
				return;
			}
	
			var snap = this.options.snap,	// we are using this alot, better to cache it
				newX = snap ? this.currentPage.pageX : this.x,
				newY = snap ? this.currentPage.pageY : this.y,
				now = utils.getTime(),
				prevTime = this.keyTime || 0,
				acceleration = 0.250,
				pos;
	
			if ( this.options.useTransition && this.isInTransition ) {
				pos = this.getComputedPosition();
	
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this.isInTransition = false;
			}
	
			this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
	
			switch ( e.keyCode ) {
				case this.options.keyBindings.pageUp:
					if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
						newX += snap ? 1 : this.wrapperWidth;
					} else {
						newY += snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.pageDown:
					if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
						newX -= snap ? 1 : this.wrapperWidth;
					} else {
						newY -= snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.end:
					newX = snap ? this.pages.length-1 : this.maxScrollX;
					newY = snap ? this.pages[0].length-1 : this.maxScrollY;
					break;
				case this.options.keyBindings.home:
					newX = 0;
					newY = 0;
					break;
				case this.options.keyBindings.left:
					newX += snap ? -1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.up:
					newY += snap ? 1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.right:
					newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
					break;
				case this.options.keyBindings.down:
					newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
					break;
				default:
					return;
			}
	
			if ( snap ) {
				this.goToPage(newX, newY);
				return;
			}
	
			if ( newX > 0 ) {
				newX = 0;
				this.keyAcceleration = 0;
			} else if ( newX < this.maxScrollX ) {
				newX = this.maxScrollX;
				this.keyAcceleration = 0;
			}
	
			if ( newY > 0 ) {
				newY = 0;
				this.keyAcceleration = 0;
			} else if ( newY < this.maxScrollY ) {
				newY = this.maxScrollY;
				this.keyAcceleration = 0;
			}
	
			this.scrollTo(newX, newY, 0);
	
			this.keyTime = now;
		},
	
		_animate: function (destX, destY, duration, easingFn) {
			var that = this,
				startX = this.x,
				startY = this.y,
				startTime = utils.getTime(),
				destTime = startTime + duration;
	
			function step () {
				var now = utils.getTime(),
					newX, newY,
					easing;
	
				if ( now >= destTime ) {
					that.isAnimating = false;
					that._translate(destX, destY);
					
					if ( !that.resetPosition(that.options.bounceTime) ) {
						that._execEvent('scrollEnd');
					}
	
					return;
				}
	
				now = ( now - startTime ) / duration;
				easing = easingFn(now);
				newX = ( destX - startX ) * easing + startX;
				newY = ( destY - startY ) * easing + startY;
				that._translate(newX, newY);
	
				if ( that.isAnimating ) {
					rAF(step);
				}
	
				if ( that.options.probeType == 3 ) {
					that._execEvent('scroll');
				}
			}
	
			this.isAnimating = true;
			step();
		},
	
		handleEvent: function (e) {
			switch ( e.type ) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
				case 'orientationchange':
				case 'resize':
					this._resize();
					break;
				case 'transitionend':
				case 'webkitTransitionEnd':
				case 'oTransitionEnd':
				case 'MSTransitionEnd':
					this._transitionEnd(e);
					break;
				case 'wheel':
				case 'DOMMouseScroll':
				case 'mousewheel':
					this._wheel(e);
					break;
				case 'keydown':
					this._key(e);
					break;
				case 'click':
					if ( this.enabled && !e._constructed ) {
						e.preventDefault();
						e.stopPropagation();
					}
					break;
			}
		}
	};
	function createDefaultScrollbar (direction, interactive, type) {
		var scrollbar = document.createElement('div'),
			indicator = document.createElement('div');
	
		if ( type === true ) {
			scrollbar.style.cssText = 'position:absolute;z-index:9999';
			indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
		}
	
		indicator.className = 'iScrollIndicator';
	
		if ( direction == 'h' ) {
			if ( type === true ) {
				scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
				indicator.style.height = '100%';
			}
			scrollbar.className = 'iScrollHorizontalScrollbar';
		} else {
			if ( type === true ) {
				scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
				indicator.style.width = '100%';
			}
			scrollbar.className = 'iScrollVerticalScrollbar';
		}
	
		scrollbar.style.cssText += ';overflow:hidden';
	
		if ( !interactive ) {
			scrollbar.style.pointerEvents = 'none';
		}
	
		scrollbar.appendChild(indicator);
	
		return scrollbar;
	}
	
	function Indicator (scroller, options) {
		this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
		this.wrapperStyle = this.wrapper.style;
		this.indicator = this.wrapper.children[0];
		this.indicatorStyle = this.indicator.style;
		this.scroller = scroller;
	
		this.options = {
			listenX: true,
			listenY: true,
			interactive: false,
			resize: true,
			defaultScrollbars: false,
			shrink: false,
			fade: false,
			speedRatioX: 0,
			speedRatioY: 0
		};
	
		for ( var i in options ) {
			this.options[i] = options[i];
		}
	
		this.sizeRatioX = 1;
		this.sizeRatioY = 1;
		this.maxPosX = 0;
		this.maxPosY = 0;
	
		if ( this.options.interactive ) {
			if ( !this.options.disableTouch ) {
				utils.addEvent(this.indicator, 'touchstart', this);
				utils.addEvent(window, 'touchend', this);
			}
			if ( !this.options.disablePointer ) {
				utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
			}
			if ( !this.options.disableMouse ) {
				utils.addEvent(this.indicator, 'mousedown', this);
				utils.addEvent(window, 'mouseup', this);
			}
		}
	
		if ( this.options.fade ) {
			this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
			var durationProp = utils.style.transitionDuration;
			this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
			// remove 0.0001ms
			var self = this;
			if(utils.isBadAndroid) {
				rAF(function() {
					if(self.wrapperStyle[durationProp] === '0.0001ms') {
						self.wrapperStyle[durationProp] = '0s';
					}
				});
			}
			this.wrapperStyle.opacity = '0';
		}
	}
	
	Indicator.prototype = {
		handleEvent: function (e) {
			switch ( e.type ) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
			}
		},
	
		destroy: function () {
			if ( this.options.fadeScrollbars ) {
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
			}
			if ( this.options.interactive ) {
				utils.removeEvent(this.indicator, 'touchstart', this);
				utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.removeEvent(this.indicator, 'mousedown', this);
	
				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);
	
				utils.removeEvent(window, 'touchend', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
				utils.removeEvent(window, 'mouseup', this);
			}
	
			if ( this.options.defaultScrollbars ) {
				this.wrapper.parentNode.removeChild(this.wrapper);
			}
		},
	
		_start: function (e) {
			var point = e.touches ? e.touches[0] : e;
	
			e.preventDefault();
			e.stopPropagation();
	
			this.transitionTime();
	
			this.initiated = true;
			this.moved = false;
			this.lastPointX	= point.pageX;
			this.lastPointY	= point.pageY;
	
			this.startTime	= utils.getTime();
	
			if ( !this.options.disableTouch ) {
				utils.addEvent(window, 'touchmove', this);
			}
			if ( !this.options.disablePointer ) {
				utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
			}
			if ( !this.options.disableMouse ) {
				utils.addEvent(window, 'mousemove', this);
			}
	
			this.scroller._execEvent('beforeScrollStart');
		},
	
		_move: function (e) {
			var point = e.touches ? e.touches[0] : e,
				deltaX, deltaY,
				newX, newY,
				timestamp = utils.getTime();
	
			if ( !this.moved ) {
				this.scroller._execEvent('scrollStart');
			}
	
			this.moved = true;
	
			deltaX = point.pageX - this.lastPointX;
			this.lastPointX = point.pageX;
	
			deltaY = point.pageY - this.lastPointY;
			this.lastPointY = point.pageY;
	
			newX = this.x + deltaX;
			newY = this.y + deltaY;
	
			this._pos(newX, newY);
	
	
			if ( this.scroller.options.probeType == 1 && timestamp - this.startTime > 300 ) {
				this.startTime = timestamp;
				this.scroller._execEvent('scroll');
			} else if ( this.scroller.options.probeType > 1 ) {
				this.scroller._execEvent('scroll');
			}
	
	
	// INSERT POINT: indicator._move
	
			e.preventDefault();
			e.stopPropagation();
		},
	
		_end: function (e) {
			if ( !this.initiated ) {
				return;
			}
	
			this.initiated = false;
	
			e.preventDefault();
			e.stopPropagation();
	
			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);
	
			if ( this.scroller.options.snap ) {
				var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
	
				var time = this.options.snapSpeed || Math.max(
						Math.max(
							Math.min(Math.abs(this.scroller.x - snap.x), 1000),
							Math.min(Math.abs(this.scroller.y - snap.y), 1000)
						), 300);
	
				if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
					this.scroller.directionX = 0;
					this.scroller.directionY = 0;
					this.scroller.currentPage = snap;
					this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
				}
			}
	
			if ( this.moved ) {
				this.scroller._execEvent('scrollEnd');
			}
		},
	
		transitionTime: function (time) {
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			this.indicatorStyle[durationProp] = time + 'ms';
	
			if ( !time && utils.isBadAndroid ) {
				this.indicatorStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function() {
					if(self.indicatorStyle[durationProp] === '0.0001ms') {
						self.indicatorStyle[durationProp] = '0s';
					}
				});
			}
		},
	
		transitionTimingFunction: function (easing) {
			this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
		},
	
		refresh: function () {
			this.transitionTime();
	
			if ( this.options.listenX && !this.options.listenY ) {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
			} else if ( this.options.listenY && !this.options.listenX ) {
				this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
			} else {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
			}
	
			if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
				utils.addClass(this.wrapper, 'iScrollBothScrollbars');
				utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
	
				if ( this.options.defaultScrollbars && this.options.customStyle ) {
					if ( this.options.listenX ) {
						this.wrapper.style.right = '8px';
					} else {
						this.wrapper.style.bottom = '8px';
					}
				}
			} else {
				utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
				utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
	
				if ( this.options.defaultScrollbars && this.options.customStyle ) {
					if ( this.options.listenX ) {
						this.wrapper.style.right = '2px';
					} else {
						this.wrapper.style.bottom = '2px';
					}
				}
			}
	
			var r = this.wrapper.offsetHeight;	// force refresh
	
			if ( this.options.listenX ) {
				this.wrapperWidth = this.wrapper.clientWidth;
				if ( this.options.resize ) {
					this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
					this.indicatorStyle.width = this.indicatorWidth + 'px';
				} else {
					this.indicatorWidth = this.indicator.clientWidth;
				}
	
				this.maxPosX = this.wrapperWidth - this.indicatorWidth;
	
				if ( this.options.shrink == 'clip' ) {
					this.minBoundaryX = -this.indicatorWidth + 8;
					this.maxBoundaryX = this.wrapperWidth - 8;
				} else {
					this.minBoundaryX = 0;
					this.maxBoundaryX = this.maxPosX;
				}
	
				this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
			}
	
			if ( this.options.listenY ) {
				this.wrapperHeight = this.wrapper.clientHeight;
				if ( this.options.resize ) {
					this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
					this.indicatorStyle.height = this.indicatorHeight + 'px';
				} else {
					this.indicatorHeight = this.indicator.clientHeight;
				}
	
				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
	
				if ( this.options.shrink == 'clip' ) {
					this.minBoundaryY = -this.indicatorHeight + 8;
					this.maxBoundaryY = this.wrapperHeight - 8;
				} else {
					this.minBoundaryY = 0;
					this.maxBoundaryY = this.maxPosY;
				}
	
				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
				this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
			}
	
			this.updatePosition();
		},
	
		updatePosition: function () {
			var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
				y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
	
			if ( !this.options.ignoreBoundaries ) {
				if ( x < this.minBoundaryX ) {
					if ( this.options.shrink == 'scale' ) {
						this.width = Math.max(this.indicatorWidth + x, 8);
						this.indicatorStyle.width = this.width + 'px';
					}
					x = this.minBoundaryX;
				} else if ( x > this.maxBoundaryX ) {
					if ( this.options.shrink == 'scale' ) {
						this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
						this.indicatorStyle.width = this.width + 'px';
						x = this.maxPosX + this.indicatorWidth - this.width;
					} else {
						x = this.maxBoundaryX;
					}
				} else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
					this.width = this.indicatorWidth;
					this.indicatorStyle.width = this.width + 'px';
				}
	
				if ( y < this.minBoundaryY ) {
					if ( this.options.shrink == 'scale' ) {
						this.height = Math.max(this.indicatorHeight + y * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
					}
					y = this.minBoundaryY;
				} else if ( y > this.maxBoundaryY ) {
					if ( this.options.shrink == 'scale' ) {
						this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
						y = this.maxPosY + this.indicatorHeight - this.height;
					} else {
						y = this.maxBoundaryY;
					}
				} else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
					this.height = this.indicatorHeight;
					this.indicatorStyle.height = this.height + 'px';
				}
			}
	
			this.x = x;
			this.y = y;
	
			if ( this.scroller.options.useTransform ) {
				this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
			} else {
				this.indicatorStyle.left = x + 'px';
				this.indicatorStyle.top = y + 'px';
			}
		},
	
		_pos: function (x, y) {
			if ( x < 0 ) {
				x = 0;
			} else if ( x > this.maxPosX ) {
				x = this.maxPosX;
			}
	
			if ( y < 0 ) {
				y = 0;
			} else if ( y > this.maxPosY ) {
				y = this.maxPosY;
			}
	
			x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
			y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
	
			this.scroller.scrollTo(x, y);
		},
	
		fade: function (val, hold) {
			if ( hold && !this.visible ) {
				return;
			}
	
			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;
	
			var time = val ? 250 : 500,
				delay = val ? 0 : 300;
	
			val = val ? '1' : '0';
	
			this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
	
			this.fadeTimeout = setTimeout((function (val) {
				this.wrapperStyle.opacity = val;
				this.visible = +val;
			}).bind(this, val), delay);
		}
	};
	
	IScroll.utils = utils;
	
	if ( typeof module != 'undefined' && module.exports ) {
		module.exports = IScroll;
	} else if ( true ) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return IScroll; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.IScroll = IScroll;
	}
	
	})(window, document, Math);


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(618);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(600);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var EventPluginRegistry = __webpack_require__(115);
	var ReactEventEmitterMixin = __webpack_require__(664);
	var ViewportMetrics = __webpack_require__(323);
	
	var getVendorPrefixedEventName = __webpack_require__(696);
	var isEventSupported = __webpack_require__(126);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	var ViewportMetrics = __webpack_require__(323);
	
	var getEventModifierState = __webpack_require__(124);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	var DOMNamespaces = __webpack_require__(114);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(122);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var string = _propTypes2['default'].string,
	    bool = _propTypes2['default'].bool,
	    number = _propTypes2['default'].number,
	    array = _propTypes2['default'].array,
	    oneOfType = _propTypes2['default'].oneOfType,
	    shape = _propTypes2['default'].shape,
	    object = _propTypes2['default'].object,
	    func = _propTypes2['default'].func;
	var propTypes = exports.propTypes = {
	  url: oneOfType([string, array, object]),
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  muted: bool,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  style: object,
	  progressInterval: number,
	  playsinline: bool,
	  pip: bool,
	  light: oneOfType([bool, string]),
	  wrapper: oneOfType([string, func]),
	  config: shape({
	    soundcloud: shape({
	      options: object
	    }),
	    youtube: shape({
	      playerVars: object,
	      preload: bool
	    }),
	    facebook: shape({
	      appId: string
	    }),
	    dailymotion: shape({
	      params: object,
	      preload: bool
	    }),
	    vimeo: shape({
	      playerOptions: object,
	      preload: bool
	    }),
	    file: shape({
	      attributes: object,
	      tracks: array,
	      forceVideo: bool,
	      forceAudio: bool,
	      forceHLS: bool,
	      forceDASH: bool,
	      hlsOptions: object,
	      hlsVersion: string,
	      dashVersion: string
	    }),
	    wistia: shape({
	      options: object
	    }),
	    mixcloud: shape({
	      options: object
	    }),
	    twitch: shape({
	      options: object
	    })
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onSeek: func,
	  onProgress: func,
	  onEnablePIP: func,
	  onDisablePIP: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: null,
	  muted: false,
	  playbackRate: 1,
	  width: '640px',
	  height: '360px',
	  style: {},
	  progressInterval: 1000,
	  playsinline: false,
	  pip: false,
	  light: false,
	  wrapper: 'div',
	  config: {
	    soundcloud: {
	      options: {
	        visual: true, // Undocumented, but makes player fill container and look better
	        buying: false,
	        liking: false,
	        download: false,
	        sharing: false,
	        show_comments: false,
	        show_playcount: false
	      }
	    },
	    youtube: {
	      playerVars: {
	        playsinline: 1,
	        showinfo: 0,
	        rel: 0,
	        iv_load_policy: 3,
	        modestbranding: 1
	      },
	      preload: false
	    },
	    facebook: {
	      appId: '1309697205772819'
	    },
	    dailymotion: {
	      params: {
	        api: 1,
	        'endscreen-enable': false
	      },
	      preload: false
	    },
	    vimeo: {
	      playerOptions: {
	        autopause: false,
	        byline: false,
	        portrait: false,
	        title: false
	      },
	      preload: false
	    },
	    file: {
	      attributes: {},
	      tracks: [],
	      forceVideo: false,
	      forceAudio: false,
	      forceHLS: false,
	      forceDASH: false,
	      hlsOptions: {},
	      hlsVersion: '0.10.1',
	      dashVersion: '2.9.2'
	    },
	    wistia: {
	      options: {}
	    },
	    mixcloud: {
	      options: {
	        hide_cover: 1
	      }
	    },
	    twitch: {
	      options: {}
	    }
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onSeek: function onSeek() {},
	  onProgress: function onProgress() {},
	  onEnablePIP: function onEnablePIP() {},
	  onDisablePIP: function onDisablePIP() {}
	};
	
	var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ },
/* 82 */
[794, 771],
/* 83 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 84 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(22);
	var normalizeHeaderName = __webpack_require__(387);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(146);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(146);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleImageInfoBlock = function (_Component) {
	    _inherits(CircleImageInfoBlock, _Component);
	
	    function CircleImageInfoBlock() {
	        _classCallCheck(this, CircleImageInfoBlock);
	
	        return _possibleConstructorReturn(this, (CircleImageInfoBlock.__proto__ || Object.getPrototypeOf(CircleImageInfoBlock)).apply(this, arguments));
	    }
	
	    _createClass(CircleImageInfoBlock, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$borderRadius = _props.borderRadius,
	                borderRadius = _props$borderRadius === undefined ? '100%' : _props$borderRadius,
	                src = _props.src,
	                srcset = _props.srcset,
	                name = _props.name,
	                _props$size = _props.size,
	                size = _props$size === undefined ? this.props.size : _props$size,
	                style = _props.style,
	                className = _props.className;
	
	
	            var imageStyle = {
	                display: 'block',
	                borderRadius: borderRadius
	            };
	
	            var innerStyle = {
	                textAlign: 'center',
	                borderRadius: borderRadius
	            };
	
	            imageStyle.width = innerStyle.width = innerStyle.maxWidth = size;
	            imageStyle.height = innerStyle.height = innerStyle.maxHeight = size;
	
	            var inner = void 0,
	                classes = [className, 'DonorAvatar'];
	            if (this.props.image || src || srcset) {
	                inner = _react2.default.createElement('img', { className: 'DonorAvatar-inner', style: imageStyle, src: _shared2.default.dpath(this.props.mode, this.props.image.path, this.props.image.file_name, this.props.webkey), srcSet: srcset, alt: name });
	            } else {
	                inner = _react2.default.createElement('img', { className: 'DonorAvatar-inner', style: imageStyle, src: 'img/ui/default-user.png', srcSet: srcset, alt: name });
	            }
	
	            return _react2.default.createElement(
	                'span',
	                { style: { position: 'relative', zIndex: 30 } },
	                _react2.default.createElement(
	                    'span',
	                    { 'aria-label': name, className: classes.join(' '), style: style },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'DonorAvatar-inner', style: innerStyle },
	                        inner
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CircleImageInfoBlock;
	}(_react.Component);
	
	module.exports = CircleImageInfoBlock;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBlock = function (_Component) {
	    _inherits(InfoBlock, _Component);
	
	    function InfoBlock() {
	        _classCallCheck(this, InfoBlock);
	
	        return _possibleConstructorReturn(this, (InfoBlock.__proto__ || Object.getPrototypeOf(InfoBlock)).apply(this, arguments));
	    }
	
	    _createClass(InfoBlock, [{
	        key: 'render',
	        value: function render() {
	            var unit = this.props.unit;
	            var fontClass = this.props.fontClass ? this.props.fontClass : null;
	            var innerFontFamily = this.props.fontClass ? null : "Ostrich";
	            var spanFontFamily = this.props.fontClass ? null : "aleo-light";
	
	            var _props = this.props,
	                _props$width = _props.width,
	                width = _props$width === undefined ? unit * 5.5 : _props$width,
	                _props$height = _props.height,
	                height = _props$height === undefined ? unit * 1.35 : _props$height;
	
	
	            var innerStyle = {
	                textAlign: 'left',
	                marginTop: unit * -2, //-200,
	                marginLeft: unit * 1.5, //140,
	                marginBottom: unit * 0.6, //60,
	                borderRadius: unit * 0.15, //15,
	                width: width,
	                fontFamily: innerFontFamily,
	                fontSize: unit * 0.2,
	                position: 'absolute',
	                left: 0,
	                top: unit * .5
	            };
	
	            innerStyle.width = innerStyle.maxWidth = width;
	            innerStyle.height = innerStyle.maxHeight = height;
	
	            //let classes = [className, 'DonorInfo'];
	
	            return _react2.default.createElement(
	                'span',
	                { className: fontClass, 'aria-label': this.props.header, style: { position: 'relative', zIndex: 20 } },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'DonorInfo', style: innerStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { height: '100%', width: '80%', marginLeft: '15%' }, className: 'valigner' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'valigner-item' },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: unit * 0.35, color: this.props.headerColor } },
	                                _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.header })
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { fontFamily: spanFontFamily, color: "#333344" } },
	                                _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.text })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InfoBlock;
	}(_react.Component);
	
	module.exports = InfoBlock;
	
	// .DonorInfo h2 {
	//     padding-top: 32px;
	//     color: #44b4c2;
	// }
	// .DonorInfo p {
	//     margin-top: -10px;
	//     color: #333344;
	// }

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactPlayer = __webpack_require__(336);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlayerWrapper = function (_Component) {
	    _inherits(ReactPlayerWrapper, _Component);
	
	    function ReactPlayerWrapper(props) {
	        _classCallCheck(this, ReactPlayerWrapper);
	
	        var _this = _possibleConstructorReturn(this, (ReactPlayerWrapper.__proto__ || Object.getPrototypeOf(ReactPlayerWrapper)).call(this, props));
	
	        _this.wait = function () {
	            clearTimeout(_this._durationTimeout);
	            _this._durationTimeout = setTimeout(function () {
	                var duration = null;
	                if (_this._videoRef) {
	                    duration = _this._videoRef.getDuration();
	                }
	                if (!duration) {
	                    // console.log("no duration")
	                    _this._recursiveDelay += 0.01;
	                    _this.wait();
	                } else {
	                    _this.props.handleVideoDuration(duration, _this._recursiveDelay);
	                }
	            }, 10);
	        };
	
	        _this.state = {};
	        _this._videoRef = null;
	        _this._durationTimeout = null;
	        _this._recursiveDelay = 0;
	        return _this;
	    }
	
	    _createClass(ReactPlayerWrapper, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //console.log("react player wrapper mounted");
	            // console.log(this.props.slide);
	            this.wait();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            //console.log("react player unmounted");
	            clearTimeout(this._durationTimeout);
	            this._durationTimeout = null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(_reactPlayer2.default, {
	                ref: function ref(el) {
	                    return _this2._videoRef = el;
	                },
	                volume: this.props.volume
	                // onEnded={this.props.onEnded} 
	                , url: this.props.url,
	                width: this.props.width,
	                height: this.props.height,
	                playing: this.props.playing, loop: false });
	        }
	    }]);
	
	    return ReactPlayerWrapper;
	}(_react.Component);
	
	exports.default = ReactPlayerWrapper;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkListChicago = function (_Component) {
	    _inherits(LinkListChicago, _Component);
	
	    function LinkListChicago() {
	        _classCallCheck(this, LinkListChicago);
	
	        return _possibleConstructorReturn(this, (LinkListChicago.__proto__ || Object.getPrototypeOf(LinkListChicago)).apply(this, arguments));
	    }
	
	    _createClass(LinkListChicago, [{
	        key: "render",
	        value: function render() {
	
	            var containerFont = this.props.fontClass ? null : "Ostrich";
	            var containerSelectedFont = this.props.fontClass ? null : "Ostrich";
	            var fontClass = this.props.fontClass;
	
	            var containerStyle = {
	                borderRadius: 25,
	                fontFamily: containerFont,
	                width: this.props.screen.sv.p10 * 6,
	                minHeight: this.props.screen.sv.p10 * 1,
	                color: this.props.colorInactive,
	                marginLeft: this.props.screen.sv.p10 * 0.4,
	                letterSpacing: 1
	            };
	
	            var containerStyleSelected = {
	                borderRadius: 25,
	                fontFamily: containerSelectedFont,
	                backgroundColor: '#496778',
	                width: this.props.screen.sv.p10 * 6,
	                minHeight: this.props.screen.sv.p10 * 1,
	                color: 'white',
	                marginLeft: this.props.screen.sv.p10 * 0.4,
	                letterSpacing: 1
	            };
	
	            var innerStyle = {
	                fontSize: this.props.screen.sv.p10 * 0.3,
	                width: this.props.screen.sv.p10 * 2,
	                marginLeft: this.props.screen.sv.p10 * 0.3,
	                marginTop: this.props.screen.r16_9.p10 * 0.5,
	                marginBottom: this.props.screen.r16_9.p10 * 0.5
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { className: fontClass, style: { Display: 'flex', alignItems: "center" } },
	                this.props.links.map(function (row, i) {
	                    var _this2 = this;
	
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "valigner", onClick: function onClick() {
	                                return _this2.props.switchCategory(i);
	                            }, key: i, style: this.props.selectedLinkIndex === i ? containerStyleSelected : containerStyle },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "valigner-item" },
	                            _react2.default.createElement(
	                                "div",
	                                { style: innerStyle },
	                                row.name
	                            )
	                        )
	                    );
	                }, this)
	            );
	        }
	    }]);
	
	    return LinkListChicago;
	}(_react.Component);
	
	exports.default = LinkListChicago;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _reactMoment = __webpack_require__(335);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var backSvg = __webpack_require__(169);
	var forwardSvg = __webpack_require__(171);
	var closeSvg = __webpack_require__(170);
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StoryAnnouncement = function (_Component) {
	  _inherits(StoryAnnouncement, _Component);
	
	  function StoryAnnouncement(props) {
	    _classCallCheck(this, StoryAnnouncement);
	
	    var _this = _possibleConstructorReturn(this, (StoryAnnouncement.__proto__ || Object.getPrototypeOf(StoryAnnouncement)).call(this, props));
	
	    _this.setupStory = function () {
	      var richTextFields = ['paragraph'];
	      var fieldsValues = {};
	      var slideshowModule = {};
	      var slideIndex = _lodash2.default.get(_this.props.story, 'contents.custom_fields.slideshow.child_val.value', 0);
	      var textColor = "#000000";
	      var background = null;
	      var backgroundImage = null;
	      var birthday = _lodash2.default.get(_this.props.story, 'contents.custom_fields.date_of_birth.val', null);
	      var image = null;
	      var imageObj = null;
	
	      for (var i = 0; i < richTextFields.length; i++) {
	        var fieldName = richTextFields[i];
	        var textOps = _lodash2.default.get(_this.props.story.contents, 'custom_fields[' + fieldName + '].val.ops', _lodash2.default.get(_this.props.story.contents, 'custom_fields[' + fieldName + '].default.ops', null));
	        var converter = new QuillDeltaToHtmlConverter(textOps, {});
	        var richText = converter.convert();
	        fieldsValues[fieldName] = richText;
	      }
	
	      var slideshowId = _lodash2.default.get(_this.props.story, 'contents.custom_fields.slideshow.val.value', null);
	      if (slideshowId !== null) {
	        slideshowModule = _lodash2.default.find(_this.props.otherModules, { id: slideshowId, display_module_type: "Slideshow" });
	        if (slideshowModule) {
	          textColor = _lodash2.default.get(slideshowModule, 'contents.color0s[' + slideIndex + ']', '#000000');
	          background = _lodash2.default.get(slideshowModule, 'contents.images[' + slideIndex + ']', null);
	          imageObj = _lodash2.default.get(_this.props.story, 'contents.images[0]', null);
	          if (background) {
	            backgroundImage = _this.getBackground(background);
	          }
	          if (imageObj) {
	            image = _this.getBackground(imageObj);
	          }
	        }
	      }
	
	      _this.setState(Object.assign({}, fieldsValues, {
	        background: backgroundImage,
	        textColor: textColor,
	        image: image,
	        birthday: birthday,
	        line_1: _lodash2.default.get(_this.props.story, 'contents.custom_fields.line_1.val', null),
	        baby_name: _lodash2.default.get(_this.props.story, 'contents.custom_fields.baby_name.val', null)
	      }));
	    };
	
	    _this.getBackground = function (displayImage) {
	      if (displayImage) {
	        return _shared2.default.dp(_this.props.screen, displayImage, null);
	      }
	      return null;
	    };
	
	    _this._normalFontSize = .01 * _this.props.screen.screenWidth;
	    _this._hugeFontSize = .026 * _this.props.screen.screenWidth;
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(StoryAnnouncement, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupStory();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props !== prevProps) {
	        this.setupStory();
	      }
	    }
	  }, {
	    key: 'navarea',
	    value: function navarea() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', width: this.props.width, height: this.props.height - this.props.width / 2, bottom: 0, backgroundColor: '#424958' } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-flex', alignItems: "center", width: '100%', height: '100%' } },
	          _react2.default.createElement(
	            'span',
	            { style: { width: '50%' } },
	            _react2.default.createElement('img', { alt: 'back', onClick: function onClick() {
	                return _this2.props.cycleStory("backward");
	              }, style: { marginLeft: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .024 }, src: backSvg }),
	            _react2.default.createElement('img', { alt: 'forward', onClick: function onClick() {
	                return _this2.props.cycleStory("forward");
	              }, style: { marginLeft: this.props.width * .03, width: this.props.width * .024, height: this.props.width * .024 }, src: forwardSvg })
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { width: '50%', textAlign: 'right' } },
	            _react2.default.createElement('img', { alt: 'close', onClick: function onClick() {
	                return _this2.close();
	              }, style: { marginRight: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .04 }, src: closeSvg })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.props.closeStory();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var type = _lodash2.default.get(this.props.story, 'contents.custom_fields.story_type.val.value', null);
	      if (!type || type !== 'baby_announcement') {
	        return _react2.default.createElement('span', null);
	      }
	      var navarea = this.navarea();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	      var outerDivStyle = {};
	      if (this.props.modal) {
	        backgroundSize = this.props.width + 'px ' + this.props.height + 'px';
	        outerDivStyle = {
	          top: this.props.top,
	          left: this.props.left,
	          height: this.props.height,
	          width: this.props.width,
	          position: "absolute"
	        };
	      } else {
	        outerDivStyle = {
	          top: 0,
	          left: 0,
	          height: this.props.screen.screenHeight,
	          width: this.props.screen.screenWidth
	        };
	      }
	      return _react2.default.createElement(
	        'div',
	        { style: Object.assign({ position: "absolute" }, outerDivStyle, { pointerEvents: 'auto', overflow: "hidden" }) },
	        _react2.default.createElement(
	          'div',
	          { style: { backgroundImage: 'url(' + this.state.background + ')', backgroundSize: backgroundSize, height: outerDivStyle.height, width: outerDivStyle.width, textAlign: "center", position: "absolute" } },
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: "1.30vw", display: "flex", justifyContent: "center", position: "relative", width: "100%", textAlign: "center" }, className: 'ql-editor' },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: "35vw", color: this.state.textColor } },
	              _react2.default.createElement(
	                'span',
	                { className: 'ql-size-24px' },
	                this.state.line_1
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: "1.30vw", display: "flex", justifyContent: "center", position: "relative", width: "100%", textAlign: "center" }, className: 'ql-editor' },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: "35vw", color: "#505052" } },
	              _react2.default.createElement(
	                'em',
	                { className: 'ql-size-20px' },
	                'Joyfully Welcomes'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: "1.30vw", display: "flex", justifyContent: "center", position: "relative", width: "100%", textAlign: "center" }, className: 'ql-editor' },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: "35vw", color: this.state.textColor } },
	              _react2.default.createElement(
	                'span',
	                { className: 'ql-size-24px' },
	                this.state.baby_name
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: "1.30vw", display: "flex", justifyContent: "center", position: "relative", width: "100%", textAlign: "center" }, className: 'ql-editor' },
	            _react2.default.createElement(
	              'div',
	              { style: { maxWidth: "35vw", color: "#505052", fontStyle: "italic", fontSize: "1.45vw" } },
	              _react2.default.createElement(
	                _reactMoment2.default,
	                { format: 'MMMM Do YYYY, h:mm:ss a' },
	                this.state.birthday
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { alt: 'announcement', style: { marginTop: "1.30vw", maxWidth: "30vw", maxHeight: "16.87vw" }, src: this.state.image })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: "1.30vw", display: "flex", justifyContent: "center", position: "relative", width: "100%", textAlign: "center" }, className: 'ql-editor' },
	            _react2.default.createElement('div', { style: { lineHeight: "1.9vw", maxWidth: "35vw", color: "#505052" }, dangerouslySetInnerHTML: { __html: this.state.paragraph } })
	          )
	        ),
	        this.props.modal ? navarea : null
	      );
	    }
	  }]);
	
	  return StoryAnnouncement;
	}(_react.Component);
	
	exports.default = StoryAnnouncement;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactPlayer = __webpack_require__(336);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import _ from 'lodash';
	
	// import Slider from 'react-slick';
	//import { videoType } from '../../utils/fileHelpers';
	
	
	var backSvg = __webpack_require__(169);
	var forwardSvg = __webpack_require__(171);
	var closeSvg = __webpack_require__(170);
	
	var StoryChicago = function (_Component) {
	  _inherits(StoryChicago, _Component);
	
	  function StoryChicago(props) {
	    _classCallCheck(this, StoryChicago);
	
	    var _this = _possibleConstructorReturn(this, (StoryChicago.__proto__ || Object.getPrototypeOf(StoryChicago)).call(this, props));
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "a":
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.playVideo = function () {
	      var videoPlaying = _this.state.videoPlaying;
	      videoPlaying[_this.state.selectedSlide] = true;
	      _this.setState({
	        videoPlaying: videoPlaying
	      });
	      //console.log("playing video");
	    };
	
	    _this.stopVideo = function () {
	      var videoPlaying = _this.state.videoPlaying;
	      videoPlaying[_this.state.selectedSlide] = false;
	      _this.setState({
	        videoPlaying: videoPlaying
	      });
	      //console.log("stopping video");
	    };
	
	    _this.renderSlickAssets = function () {
	      if (!_this.props.slickAssets || _this.props.slickAssets.length === 0) {
	        return _react2.default.createElement('div', null);
	      }
	      //console.log("SLICK ASSETS", this.props.slickAssets)
	      //={this.state.videoPlaying[i]}
	      //let iconStyle = { zIndex: 1000, fontSize: this.props.screen.screenHeight * .1, color: 'rgba(0,0,0, .5' }
	      //console.log(this.props.slickAssets);
	      return _this.props.slickAssets.map(function (row, i) {
	        var _this2 = this;
	
	        switch (row.fileType) {
	          case "Video":
	            return (
	              // <video key={i} className="nodrag" style={this._videoStyle} id={"background-video-"+i} controls muted>
	              //   <source src={row.path} type={row.videoType} />
	              //   Your browser does not support the video tag.
	              // </video>
	              _react2.default.createElement(
	                'div',
	                { key: i },
	                _react2.default.createElement(
	                  'div',
	                  { onMouseDown: this.videoClicked, style: { Display: 'flex' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'valigner', style: { position: 'inline-block', width: this.props.width / 2, height: this.props.width / 2 } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'valigner-item', style: { position: 'inline-block', width: this.props.width / 2 } },
	                      _react2.default.createElement(_reactPlayer2.default, { onEnded: this.videoEnded, ref: function ref(el) {
	                          return _this2._videoRefs[i] = el;
	                        }, key: i, url: row.path, width: this.props.width / 2, height: this.props.width / 2, playing: this.state.videoPlaying[i], loop: false })
	                    )
	                  )
	                ),
	                this.getIsVideoSlide() && !this.getVideoIsPlaying() && !this.state.slideChanging ? _react2.default.createElement(
	                  'div',
	                  { style: { display: 'flex' } },
	                  _react2.default.createElement(
	                    'div',
	                    { onMouseDown: this.playVideo, className: 'valigner', style: { width: this.props.width / 2, height: this.props.width / 2, position: 'absolute', bottom: 0, alignItems: 'center', justifyContent: 'center' } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'valigner-item' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'phand' },
	                        _react2.default.createElement(_reactFontawesome2.default, { style: { fontSize: this.props.width / 8, opacity: .75 }, name: 'play-circle' })
	                      )
	                    )
	                  )
	                ) : null
	              )
	            );
	          case "Image":
	          default:
	            return _react2.default.createElement(
	              'span',
	              { key: i },
	              _react2.default.createElement('img', { alt: 'Detail', style: this._imageStyle, src: row.path })
	            );
	        }
	      }, _this);
	    };
	
	    _this.goToSlide = function (slide) {
	      _this._slickRef.slickGoTo(slide);
	    };
	
	    _this.nextSlide = function () {
	      _this._slickRef.slickNext();
	    };
	
	    _this.lastSlide = function () {
	      _this._slickRef.slickPrev();
	    };
	
	    _this.slideChanged = function (slide) {
	      var videoPlaying = _this.state.videoPlaying;
	      for (var i = 0; i < videoPlaying.length; i++) {
	        videoPlaying[i] = false;
	
	        if (_this._videoRefs[_this.state.selectedSlide]) {
	          //seek previouse slide to 0
	          _this._videoRefs[_this.state.selectedSlide].seekTo(0);
	        }
	      }
	      // if (this._videoRefs[slide]) {
	      //   this._videoRefs[slide].seekTo(0)
	      // }
	      _this.setState({
	        videoPlaying: videoPlaying,
	        selectedSlide: slide,
	        slideChanging: false
	      });
	    };
	
	    _this.videoClicked = function () {
	      if (_this.getIsVideoSlide() && _this.getVideoIsPlaying()) {
	        _this.stopVideo();
	      }
	    };
	
	    _this.videoEnded = function () {
	      if (_this._videoRefs[_this.state.selectedSlide]) {
	        _this._videoRefs[_this.state.selectedSlide].seekTo(0);
	      }
	      _this.stopVideo();
	    };
	
	    _this.getIsVideoSlide = function () {
	      return _this.props.slickAssets[_this.state.selectedSlide].fileType === "Video";
	    };
	
	    _this.getVideoIsPlaying = function () {
	      return _this.state.videoPlaying[_this.state.selectedSlide];
	    };
	
	    _this.renderCycleButtons = function (blockWidth) {
	      var bdist = _this.props.screen.r16_9.p10 * 0.75;
	      var halflength = _this.props.slickAssets.length * bdist / 2;
	      var leftStart = blockWidth / 2 - halflength; //+ this.props.screen.screenHeight * .0185;
	      var iconStyle = { zIndex: 1000, fontSize: _this.props.screen.screenHeight * .04, color: 'rgba(0,0,0, .5' };
	      var iconStyleActive = { zIndex: 1000, fontSize: _this.props.screen.screenHeight * .04, color: 'rgba(0,0,0, .9' };
	      var spanclass = "fadediv";
	      var iconOffsetY = _this.props.height * .0075;
	      var backdropStyle = {
	        pointerEvents: 'none',
	        borderRadius: _this.props.screen.r16_9.p10 * 0.6,
	        backgroundColor: 'white',
	        opacity: 0.5,
	        display: 'inline-block',
	        position: 'absolute',
	        left: _this.props.width / 4 - (_this.props.slickAssets.length + 2) / 2 * bdist - _this.props.screen.screenHeight * .02,
	        width: (_this.props.slickAssets.length + 2) * bdist, //+ 2 for end arrows
	        height: _this.props.screen.screenHeight * .06
	
	        //TODO: convert this to a component and share with story!!!
	      };if (_this.props.slickAssets.length < 2) {
	        return null;
	      }
	      return _this.props.slickAssets.map(function (row, i) {
	        var _this3 = this;
	
	        var iStyle = iconStyle;
	        if (i === this.state.selectedSlide) {
	          iStyle = iconStyleActive;
	        }
	        // left button and first entry
	        if (i === 0) {
	          return _react2.default.createElement(
	            'span',
	            { key: i, className: spanclass },
	            _react2.default.createElement('span', { style: backdropStyle }),
	            _react2.default.createElement(
	              'span',
	              { onMouseDown: function onMouseDown() {
	                  return _this3.lastSlide();
	                }, style: { textAlign: 'center', position: 'absolute', left: leftStart + -1 * bdist, top: iconOffsetY } },
	              _react2.default.createElement(
	                'span',
	                { className: 'phand', style: iconStyle },
	                _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-left' })
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { onMouseDown: function onMouseDown() {
	                  return _this3.goToSlide(i);
	                }, style: { textAlign: 'center', position: 'absolute', left: leftStart + i * bdist, top: iconOffsetY } },
	              _react2.default.createElement(
	                'span',
	                { className: 'phand', style: iStyle },
	                _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	              )
	            )
	          );
	        }
	        // second to last and last entry
	        else if (i === this.props.slickAssets.length - 1) {
	            return _react2.default.createElement(
	              'span',
	              { key: i, className: spanclass },
	              _react2.default.createElement(
	                'span',
	                { onMouseDown: function onMouseDown() {
	                    return _this3.goToSlide(i);
	                  }, style: { textAlign: 'center', position: 'absolute', left: leftStart + i * bdist, top: iconOffsetY } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'phand', style: iStyle },
	                  _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { onMouseDown: function onMouseDown() {
	                    return _this3.nextSlide();
	                  }, style: { textAlign: 'center', position: 'absolute', left: leftStart + (i + 1) * bdist, top: iconOffsetY } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'phand', style: iconStyle },
	                  _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-right' })
	                )
	              )
	            );
	          }
	          // middle entry
	          else {
	              return _react2.default.createElement(
	                'span',
	                { key: i, className: spanclass, onMouseDown: function onMouseDown() {
	                    return _this3.goToSlide(i);
	                  }, style: { textAlign: 'center', position: 'absolute', left: leftStart + i * bdist, top: iconOffsetY } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'phand', style: iStyle },
	                  _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                )
	              );
	            }
	      }, _this);
	    };
	
	    _this.state = {
	      selectedSlide: 0,
	      videoPlaying: new Array(_this.props.slickAssets.length),
	      slideChanging: false
	    };
	
	    _this._videoStyle = {
	      preload: 'auto',
	      objectFit: 'contain',
	      width: _this.props.width / 2,
	      height: _this.props.width / 2,
	      loop: '',
	      autoplay: "",
	      muted: "",
	      pointerEvents: "none"
	    };
	
	    _this._imageStyle = {
	      objectFit: 'contain',
	      width: _this.props.width / 2,
	      height: _this.props.width / 2
	    };
	
	    _this._videoRefs = new Array(_this.props.slickAssets.length);
	    _this._slickRef = null;
	
	    _this._quoteClass = _this.props.fontClass ? _this.props.fontClass + " aligner" : "aligner aleo-bolditalic";
	    _this._bodyClass = _this.props.fontClass ? _this.props.fontClass : "aleo-light";
	    _this._subtitleClass = _this.props.fontClass ? _this.props.fontClass : "ostrich-medium";
	    _this._headlineClass = _this.props.fontClass ? _this.props.fontClass : "ostrich";
	    _this._contextualHeaderClass = _this.props.fontClass ? _this.props.fontClass + " valigner" : "ostrich-medium valigner";
	
	    return _this;
	  }
	
	  _createClass(StoryChicago, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'contextualheader',
	    value: function contextualheader() {
	      var contextualheaderOuter = {
	        borderRadius: this.props.screen.r16_9.p10 * 0.6,
	        marginLeft: this.props.width / 40,
	        backgroundColor: '#E5F5F6',
	        height: this.props.height * 0.05,
	        display: 'inline-flex',
	        alignItems: "center"
	      };
	
	      var contextualheaderInner = {
	        marginLeft: this.props.screen.r16_9.p10 * 0.2,
	        marginRight: this.props.screen.r16_9.p10 * 0.1,
	        color: "#424958",
	        fontSize: this.props.height * 0.03, //this.props.width / 60,
	        letterSpacing: 2
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: contextualheaderOuter, className: this._contextualHeaderClass },
	        _react2.default.createElement(
	          'span',
	          { style: contextualheaderInner, className: 'valigner-item' },
	          _react2.default.createElement(
	            'b',
	            null,
	            this.props.contextualheader
	          )
	        ),
	        ' :'
	      );
	    }
	
	    //String(this.props.screen.r16_9.p10*.6) + "px"
	
	  }, {
	    key: 'headline',
	    value: function headline() {
	      return _react2.default.createElement(
	        'div',
	        { className: this._headlineClass, style: { color: "#424958", lineHeight: String(this.props.screen.r16_9.p10 * .6) + "px", fontSize: this.props.screen.r16_9.p10 * .6, paddingLeft: this.props.width / 40, width: this.props.width / 2.2 } },
	        _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.headline })
	      );
	    }
	  }, {
	    key: 'subtitle',
	    value: function subtitle() {
	      return _react2.default.createElement(
	        'div',
	        { className: this._subtitleClass, style: { color: "#424958", letterSpacing: 2, fontSize: this.props.width / 60, paddingLeft: this.props.width / 40, width: this.props.width / 2.2 } },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.subtitle })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'body',
	    value: function body() {
	      if (this.props.useWYSIWYG) {
	        var bodyClass = this._bodyClass + " ql-editor";
	        return _react2.default.createElement('div', { className: bodyClass, dangerouslySetInnerHTML: { __html: this.props.body }, style: { fontSize: this.props.screen.r16_9.p10 * .18, paddingLeft: this.props.width / 40, columnCount: 2, color: "#424958", lineHeight: String(this.props.screen.r16_9.p10 * .25) + "px", position: 'absolute', width: this.props.width / 2.2 } });
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: this._bodyClass, style: { fontSize: this.props.screen.r16_9.p10 * .18, paddingLeft: this.props.width / 40, columnCount: 2, color: "#424958", lineHeight: String(this.props.screen.r16_9.p10 * .25) + "px", position: 'absolute', width: this.props.width / 2.2 } },
	          this.props.body ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.body })
	          ) : _react2.default.createElement('span', null)
	        );
	      }
	    }
	  }, {
	    key: 'quote',
	    value: function quote() {
	      var divStyle = { display: 'flex', justifyContent: 'center', fontSize: this.props.screen.r16_9.p10 * .2, lineHeight: String(this.props.screen.r16_9.p10 * .3) + "px", color: "#424958", width: this.props.width / 3, height: this.props.height * .10, fontWeight: 'bold', textAlign: 'center' };
	      if (this.props.showQuotes === true) {
	        divStyle.backgroundImage = "url(img/chicago/quotes.png)";
	        divStyle.backgroundSize = '100% 100%';
	        divStyle.backgroundRepeat = 'no-repeat';
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.quote ? _react2.default.createElement(
	          'div',
	          { style: { width: '100%', textAlign: 'center' } },
	          _react2.default.createElement(
	            'div',
	            { className: this._quoteClass, style: divStyle },
	            _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.quote })
	          )
	        ) : _react2.default.createElement('span', null)
	      );
	    }
	  }, {
	    key: 'navarea',
	    value: function navarea() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', width: this.props.width, height: this.props.height - this.props.width / 2, bottom: 0, backgroundColor: '#424958' } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'inline-flex', alignItems: "center", width: '100%', height: '100%' } },
	          _react2.default.createElement(
	            'span',
	            { style: { width: '50%' } },
	            _react2.default.createElement('img', { alt: 'back', onClick: function onClick() {
	                return _this4.props.cycleStory("backward");
	              }, style: { marginLeft: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .024 }, src: backSvg }),
	            _react2.default.createElement('img', { alt: 'forward', onClick: function onClick() {
	                return _this4.props.cycleStory("forward");
	              }, style: { marginLeft: this.props.width * .03, width: this.props.width * .024, height: this.props.width * .024 }, src: forwardSvg })
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { width: '50%', textAlign: 'right' } },
	            _react2.default.createElement('img', { alt: 'close', onClick: function onClick() {
	                return _this4.close();
	              }, style: { marginRight: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .04 }, src: closeSvg })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.props.closeStory();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      // let contextualheader = this.contextualheader()
	      // let headline = this.headline()
	      // let subtitle = this.subtitle()
	      // let body = this.body()
	      var navarea = this.navarea();
	      // let quote = this.quote()
	
	      // var settings = {
	      //   dots: false,
	      //   arrows: false,
	      //   infinite: false,
	      //   speed: 500,
	      //   slidesToShow: 1,
	      //   slidesToScroll: 1,
	      //   centerMode: false,
	      //   useCSS: true,
	      //   afterChange: (currentSlide) => {
	      //     this.slideChanged(currentSlide);
	      //   },
	      // };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { pointerEvents: 'auto', position: 'absolute', left: this.props.left, width: this.props.width, height: this.props.height, top: this.props.top, backgroundColor: 'white' } },
	        _react2.default.createElement(
	          'div',
	          { style: { position: "relative", width: this.props.width, height: this.props.height, backgroundColor: 'white' } },
	          _react2.default.createElement('div', { style: { background: "url(" + this.props.mainimage + ")", height: "96%", width: "100%", backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" } }),
	          _react2.default.createElement(
	            'div',
	            { style: { zIndex: 500, position: 'absolute', top: 0, left: 0, width: this.props.width / 2, height: this.props.width / 2 } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'relative' } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: this.props.width / 2, height: this.props.height * .075, position: 'absolute', bottom: this.props.height * .01 } },
	                this.renderCycleButtons(this.props.width / 2)
	              )
	            )
	          )
	        ),
	        navarea
	      );
	    }
	  }]);
	
	  return StoryChicago;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(StoryChicago);

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _display = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuOmaha = function (_Component) {
	  _inherits(MenuOmaha, _Component);
	
	  function MenuOmaha(props) {
	    _classCallCheck(this, MenuOmaha);
	
	    var _this = _possibleConstructorReturn(this, (MenuOmaha.__proto__ || Object.getPrototypeOf(MenuOmaha)).call(this, props));
	
	    _this.handleNav = function (route) {
	      _this.props.switchModule(route.module.id);
	      _this.props.navRoute(route.navLocation, route.module);
	    };
	
	    _this.initializeNavRefs = function () {
	      if (_this.state.initializedRefs === false) {
	        var _loop = function _loop(a) {
	          _this._navRefs[a].el.addEventListener("click", function () {
	            return _this.handleNav(_this._navRefs[a].data);
	          });
	        };
	
	        for (var a = 0; a < _this._navRefs.length; a++) {
	          _loop(a);
	        }
	        _this.setState({
	          initializedRefs: true
	        });
	      }
	    };
	
	    _this.getItems = function () {
	      var items = [];
	      var location = [];
	      var modules = [];
	      var activeModules = _lodash2.default.filter(_this.props.content.dm_active, function (dm) {
	        return dm.module_contents.in_navigation;
	      });
	      var currentModuleId = _this.props.active_module;
	
	      items = activeModules.map(function (row, i) {
	        var active = false;
	        if (currentModuleId === row.id) {
	          active = true;
	        }
	
	        var folderId = _lodash2.default.get(row, "contents.folder", null);
	
	        if (folderId !== null) {
	          var childStories = _this.props.content.folder_modules.filter(function (fm) {
	            return fm.folder === Number(folderId) && fm.model === "story";
	          });
	          var childStoryCategories = _this.props.content.story_categories.filter(function (sc) {
	            return sc.parent_category === Number(folderId);
	          });
	          var totalItems = childStories.length + childStoryCategories.length;
	          if (totalItems === 1) {
	            if (childStories.length === 1) {
	              location[i] = "/omaha/story?id=" + childStories[0].id;
	            } else {
	              location[i] = "/omaha/recognition_list";
	            }
	          } else if (totalItems > 1) {
	            location[i] = "/omaha/stories";
	          }
	          modules[i] = row;
	        }
	
	        var buttonStyle = {
	          width: "5.76vh",
	          height: "5.5vh",
	          float: "left"
	        };
	
	        buttonStyle["backgroundColor"] = "#8c827a";
	        if (active) {
	          buttonStyle["backgroundColor"] = "#7a6e66";
	          buttonStyle["transform"] = "scale(1.15, 1.15) translate(0, -0.364583333vh)";
	          if (i !== 0) {
	            buttonStyle["marginLeft"] = "0.416666667vh";
	          }
	        }
	
	        return _react2.default.createElement(
	          "div",
	          {
	            ref: function ref(el) {
	              return _this._navRefs[i] = {
	                el: el,
	                data: { navLocation: location[i], module: modules[i], active: active }
	              };
	            },
	            key: i,
	            style: Object.assign({}, buttonStyle)
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { display: "block" } },
	            _react2.default.createElement("img", {
	              style: { maxWidth: "90%", marginTop: "0.27vh" },
	              src: (0, _shared.dp)(_this.props.screen, row.module_contents.icon),
	              alt: ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { display: "block", fontSize: "0.78vh", marginTop: "-0.27vh" } },
	            _react2.default.createElement(
	              "span",
	              null,
	              row.name.toUpperCase()
	            )
	          )
	        );
	      });
	
	      return items;
	    };
	
	    _this._goHomeRef = null;
	    _this._navRefs = [];
	
	    _this.state = {
	      initializedRefs: false
	    };
	    return _this;
	  }
	
	  _createClass(MenuOmaha, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.initializeNavRefs();
	      if (this._goHomeRef) {
	        this._goHomeRef.addEventListener("click", function () {
	          return _this2.props.navRoute("/omaha/nav", null);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var items = this.getItems();
	
	      return _react2.default.createElement(
	        "div",
	        { style: { backgroundColor: "#b5ada5", height: "5.5vh", width: "100%", position: "absolute", bottom: "0vh" } },
	        _react2.default.createElement(
	          "div",
	          { ref: function ref(el) {
	              return _this3._goHomeRef = el;
	            }, style: { width: "5.5vh", float: "left", paddingTop: "1vh" } },
	          _react2.default.createElement("img", {
	            style: { height: "3.5vh" },
	            src: (0, _shared.dp)(this.props.screen, null, { path: "/img/ui/", file_name: "handicon-03.png" }),
	            alt: ""
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { width: "53.73vh" } },
	          items
	        )
	      );
	    }
	  }]);
	
	  return MenuOmaha;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var active_module = state.active_module;
	  var idle = _shared2.default.parseStringParam(window.location.href, "idle");
	  var namedmodule = _shared2.default.parseStringParam(window.location.href, "name");
	
	  var idleActive = true;
	  if (state.content.idle_delay === 0 || idle === "false") {
	    idleActive = false;
	  }
	
	  if (namedmodule) {
	    active_module = _lodash2.default.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
	  }
	
	  return {
	    active_module: active_module,
	    content: state.content,
	    contentHasErrored: state.contentHasErrored,
	    contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    donorsHasErrored: state.donorsHasErrored,
	    donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    options: state.options,
	    screensNumber: state.screensNumber,
	    idleActive: idleActive
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    switchModule: function switchModule(id) {
	      return dispatch((0, _display.switchModule)(id));
	    },
	    setOptions: function setOptions(data) {
	      return dispatch((0, _display.setOptions)(data));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MenuOmaha);

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconArrow = __webpack_require__(785);
	
	var BackButtonTampa = function (_Component) {
	  _inherits(BackButtonTampa, _Component);
	
	  function BackButtonTampa() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BackButtonTampa);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BackButtonTampa.__proto__ || Object.getPrototypeOf(BackButtonTampa)).call.apply(_ref, [this].concat(args))), _this), _this.renderBackButton = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", marginLeft: '.3vh', top: 0, height: "2vh", width: "100%" } },
	          _react2.default.createElement(
	            'span',
	            { style: { position: "absolute", top: "0.208333333vh", fontSize: '.96vh', color: '#143e77', right: "0.91145833333333333333vh" } },
	            'BACK'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", marginLeft: '.3vh', marginTop: "0.5vh", left: ".231481481481481481vh", width: "100%", top: "1.5vh" } },
	          _react2.default.createElement('img', { className: 'fliph', alt: 'back', style: { position: "absolute", width: '1.5vh', height: '1.5vh', right: "1.5625vh" }, src: iconArrow })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BackButtonTampa, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.mode === "video" ? _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left } },
	          this.renderBackButton()
	        ) : _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderBackButton()
	          )
	        )
	      );
	    }
	  }]);
	
	  return BackButtonTampa;
	}(_react.Component);
	
	exports.default = BackButtonTampa;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBlock = function (_Component) {
		_inherits(InfoBlock, _Component);
	
		function InfoBlock(props) {
			_classCallCheck(this, InfoBlock);
	
			var _this = _possibleConstructorReturn(this, (InfoBlock.__proto__ || Object.getPrototypeOf(InfoBlock)).call(this, props));
	
			_this._containerStyle = {
				width: _this.props.width,
				height: _this.props.imageHeight + _this.props.infoHeight,
				fontFamily: _this.props.fontFamily,
				fontSize: _this.props.fontSize,
				display: 'inline-block',
				position: 'relative'
			};
	
			_this._imageStyle = {
				display: 'block',
				width: _this.props.width,
				height: _this.props.imageHeight,
				borderTopLeftRadius: _this.props.unit * 0.15,
				borderTopRightRadius: _this.props.unit * 0.15,
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center"
			};
	
			_this._infoBlockStyle = {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				color: _this.props.infoColor,
				backgroundColor: _this.props.infoBackgroundColor,
				height: _this.props.infoHeight,
				minHeight: _this.props.infoHeight,
				borderBottomLeftRadius: _this.props.unit * 0.15,
				borderBottomRightRadius: _this.props.unit * 0.15,
				width: _this.props.width
			};
	
			return _this;
		}
	
		_createClass(InfoBlock, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ style: this._containerStyle },
					_react2.default.createElement('div', { style: Object.assign({}, this._imageStyle, { backgroundImage: 'url(' + this.props.imgsrc + ')' }) }),
					_react2.default.createElement(
						'div',
						{ style: this._infoBlockStyle },
						_react2.default.createElement(
							'span',
							{ style: { marginLeft: "0.625vh", maxWidth: "78%" } },
							this.props.text
						),
						_react2.default.createElement(
							'span',
							{ style: { marginRight: "0.625vh" } },
							_react2.default.createElement('img', { alt: 'Forward', src: "/img/tampa/ui/icon-arrow-forward.png", style: { display: 'inline-block', textAlign: 'right', width: "1.25vh" } })
						)
					)
				);
			}
		}]);
	
		return InfoBlock;
	}(_react.Component);
	
	module.exports = InfoBlock;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(97);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StoryTampa = function (_Component) {
	  _inherits(StoryTampa, _Component);
	
	  function StoryTampa(props) {
	    _classCallCheck(this, StoryTampa);
	
	    var _this = _possibleConstructorReturn(this, (StoryTampa.__proto__ || Object.getPrototypeOf(StoryTampa)).call(this, props));
	
	    _this.redirect = function () {
	      if (_this._subscribeModule !== null && _this._subscribeModule !== undefined) {
	        _this.props.navRoute('/tampa/subscribe', _this._subscribeModule);
	      }
	    };
	
	    _this._subscribeModule = null;
	    _this._showBackground = true;
	
	    if (_this.props.showBackground !== undefined) {
	      _this._showBackground = _this.props.showBackground;
	    }
	
	    _this.state = {
	      image: null,
	      dimensions: null
	    };
	    return _this;
	  }
	
	  _createClass(StoryTampa, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var imageObj, imagePath, dimensions;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                imageObj = new Image();
	                imagePath = _shared2.default.dp(this.props.screen, this.props.story.contents.images[0]);
	
	                imageObj.src = imagePath;
	                _context.next = 5;
	                return new Promise(function (resolve, reject) {
	                  imageObj.onload = function () {
	                    return resolve({ width: this.width, height: this.height });
	                  };
	                });
	
	              case 5:
	                dimensions = _context.sent;
	
	                this.setState({
	                  image: imagePath,
	                  dimensions: dimensions
	                });
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var backgroundImage = null;
	      var unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
	      var maxAbsoluteBlockWidth = this.props.screen.screenWidth / this.props.screensNumber * 0.85 - this.props.screen.screenHeight * 0.0268 * 2;
	
	      var imageStyle = {
	        height: '33vh',
	        width: '85%',
	        borderTopLeftRadius: "3.125vh",
	        borderTopRightRadius: "3.125vh",
	        margin: "auto",
	        overflow: "hidden"
	        // backgroundSize: "cover",
	        // backgroundPosition:"center",
	        // backgroundRepeat: "no-repeat"
	      };
	
	      var imagePath = _shared2.default.dp(this.props.screen, this.props.story.contents.images[0]);
	      if (this.props.showBackground) {
	        backgroundImage = this.props.backgroundImage;
	      }
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	      var bodyOps = _lodash2.default.get(this.props.story, 'contents.custom_fields.body.val.ops', _lodash2.default.get(this.props.story, 'contents.custom_fields.body.default.ops', null));
	      var bodyRichText = new QuillDeltaToHtmlConverter(bodyOps, {}).convert();
	      // let titleOps = _.get(this.props.story, 'contents.custom_fields.title.val.ops', _.get(this.props.story, 'contents.custom_fields.title.default.ops', null));
	      // let titleRichText = new QuillDeltaToHtmlConverter(titleOps, {}).convert();
	
	      var maxWidth = 0,
	          maxHeight = 0,
	          verticalAlign = "middle";
	      if (this.state.dimensions) {
	        var ratio = this.state.dimensions.width / this.state.dimensions.height;
	        if (this.state.dimensions.width > this.state.dimensions.height) {
	          verticalAlign = "bottom";
	          maxWidth = this.state.dimensions.width;
	          maxHeight = this.state.dimensions.height;
	          if (this.state.dimensions.width > this.props.screen.screenWidth * .85) {
	            maxWidth = this.props.screen.screenWidth * .85;
	            maxHeight = maxWidth / ratio;
	          }
	        } else {
	          maxHeight = this.props.screen.screenHeight * .33;
	          maxWidth = maxHeight * ratio;
	        }
	      }
	
	      var imageHeight = maxHeight > this.props.screen.screenHeight * .33 ? maxHeight : this.props.screen.screenHeight * .33;
	      var bodyHeight = 100 - (5 + imageHeight / this.props.screen.screenHeight * 100 + 5);
	      return _react2.default.createElement(
	        'div',
	        { style: { width: this.props.screen.screenWidth / this.props.screensNumber, height: this.props.screen.screenHeight, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	        _react2.default.createElement(
	          'div',
	          { style: { top: "5vh", position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber, height: "100vh" } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "block", margin: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, imageStyle, { backgroundColor: "white", textAlign: "center", display: "table" }) },
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table-cell", verticalAlign: verticalAlign } },
	                _react2.default.createElement('img', { src: imagePath, style: { width: maxWidth, height: maxHeight, margin: "auto" }, alt: '' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block', margin: "auto", height: bodyHeight + "vh", width: '85%', backgroundColor: 'white', borderBottomLeftRadius: "3.125vh", borderBottomRightRadius: "3.125vh" } },
	            _react2.default.createElement('div', { style: { fontSize: '2.25vh', textAlign: "left", marginLeft: unit * .5, fontFamily: "opensans-bold", color: '#404040' } }),
	            _react2.default.createElement('div', { style: { height: "1.12vh" } }),
	            _react2.default.createElement(
	              'div',
	              { style: { height: "39vh", paddingTop: "0.4921875vh", paddingLeft: "2.68vh", paddingRight: "2.68vh", paddingBottom: "1.68vh", display: "table", textAlign: "justify", position: "absolute", width: maxAbsoluteBlockWidth } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "100%", position: "relative", marginBottom: "1vh" } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ql-editor', style: { fontSize: "2vh", overflowY: 'hidden', lineHeight: "2.5vh", color: "#0f3464" } },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    this.props.story.name
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { width: "100%", position: "relative" } },
	                _react2.default.createElement('div', { className: 'ql-editor', style: { maxHeight: "38.5vh", fontSize: '1vh', overflowY: 'hidden', lineHeight: "1.302083333vh", color: "#404040" }, dangerouslySetInnerHTML: { __html: bodyRichText } })
	              )
	            ),
	            _react2.default.createElement('br', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoryTampa;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    stories: state.content.stories,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(StoryTampa);

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var recent_interaction_timeout = 5000;
	
	var IdleLoop = function (_Component) {
	  _inherits(IdleLoop, _Component);
	
	  function IdleLoop(props) {
	    _classCallCheck(this, IdleLoop);
	
	    var _this = _possibleConstructorReturn(this, (IdleLoop.__proto__ || Object.getPrototypeOf(IdleLoop)).call(this, props));
	
	    _this.pageClick = function () {
	      _this.lastInteraction = new Date();
	      _this.props.resume();
	      _this.checkRecentInteraction();
	      _this.checkIdleTimeout();
	    };
	
	    _this.checkRecentInteraction = function () {
	      var msPassed = new Date().getTime() - _this.lastInteraction.getTime();
	
	      if (msPassed > recent_interaction_timeout) {
	        _this.props.goIdle("recentInteraction");
	      } else {
	        clearTimeout(_this._recentInteractionTimeout);
	        _this._recentInteractionTimeout = setTimeout(function () {
	          _this.checkRecentInteraction();
	        }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
	      }
	    };
	
	    _this.checkIdleTimeout = function () {
	      var msPassed = new Date().getTime() - _this.lastInteraction.getTime();
	
	      if (msPassed > _this._idleDelay) {
	        _this.props.goIdle("idle");
	      } else {
	        clearTimeout(_this._idleTimeout);
	        _this._idleTimeout = setTimeout(function () {
	          _this.checkIdleTimeout();
	        }, _this._idleDelay - msPassed); //avoids extra settings of timeout below interval check
	      }
	    };
	
	    _this._recentInteractionTimeout = null;
	
	    if (_this.props.idle_delay) {
	      _this._idleDelay = _this.props.idle_delay * 1000;
	    } else {
	      _this._idleDelay = 120000;
	    }
	
	    _this._idleTimeout = null;
	    _this.lastInteraction = new Date();
	    return _this;
	  }
	
	  _createClass(IdleLoop, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.idle_delay !== 0) {
	        window.addEventListener("mousedown", this.pageClick, false);
	        this.checkRecentInteraction();
	        this.checkIdleTimeout();
	        this.props.goIdle("idle");
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("mousedown", this.pageClick, false);
	      clearTimeout(this._idleTimeout);
	      clearTimeout(this._recentInteractionTimeout);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("span", null);
	    }
	  }]);
	
	  return IdleLoop;
	}(_react.Component);
	
	exports.default = IdleLoop;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(518);


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(40);
	var Emitter = __webpack_require__(52);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(569);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(104);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(102),
	    getRawTag = __webpack_require__(592),
	    objectToString = __webpack_require__(613);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(590);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(585);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(103),
	    isObjectLike = __webpack_require__(178);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InlineGroup = (function () {
	    function InlineGroup(ops) {
	        this.ops = ops;
	    }
	    return InlineGroup;
	}());
	exports.InlineGroup = InlineGroup;
	var VideoItem = (function () {
	    function VideoItem(op) {
	        this.op = op;
	    }
	    return VideoItem;
	}());
	exports.VideoItem = VideoItem;
	var BlockGroup = (function () {
	    function BlockGroup(op, ops) {
	        this.op = op;
	        this.ops = ops;
	    }
	    return BlockGroup;
	}());
	exports.BlockGroup = BlockGroup;
	var ListGroup = (function () {
	    function ListGroup(items) {
	        this.items = items;
	    }
	    return ListGroup;
	}());
	exports.ListGroup = ListGroup;
	var ListItem = (function () {
	    function ListItem(item, innerList) {
	        if (innerList === void 0) { innerList = null; }
	        this.item = item;
	        this.innerList = innerList;
	    }
	    return ListItem;
	}());
	exports.ListItem = ListItem;


/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function preferSecond(arr) {
	    if (arr.length === 0) {
	        return null;
	    }
	    return arr.length >= 2 ? arr[1] : arr[0];
	}
	exports.preferSecond = preferSecond;
	;
	function flatten(arr) {
	    return arr.reduce(function (pv, v) {
	        return pv.concat(Array.isArray(v) ? flatten(v) : v);
	    }, []);
	}
	exports.flatten = flatten;
	;
	function groupConsecutiveElementsWhile(arr, predicate) {
	    var groups = [];
	    var currElm, currGroup;
	    for (var i = 0; i < arr.length; i++) {
	        currElm = arr[i];
	        if (i > 0 && predicate(currElm, arr[i - 1])) {
	            currGroup = groups[groups.length - 1];
	            currGroup.push(currElm);
	        }
	        else {
	            groups.push([currElm]);
	        }
	    }
	    return groups.map(function (g) { return g.length === 1 ? g[0] : g; });
	}
	exports.groupConsecutiveElementsWhile = groupConsecutiveElementsWhile;
	;
	function sliceFromReverseWhile(arr, startIndex, predicate) {
	    var result = {
	        elements: [],
	        sliceStartsAt: -1
	    };
	    for (var i = startIndex; i >= 0; i--) {
	        if (!predicate(arr[i])) {
	            break;
	        }
	        result.sliceStartsAt = i;
	        result.elements.unshift(arr[i]);
	    }
	    return result;
	}
	exports.sliceFromReverseWhile = sliceFromReverseWhile;
	;
	function intersperse(arr, item) {
	    return arr.reduce(function (pv, v, index) {
	        pv.push(v);
	        if (index < (arr.length - 1)) {
	            pv.push(item);
	        }
	        return pv;
	    }, []);
	}
	exports.intersperse = intersperse;


/***/ },
/* 111 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function assign(target) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    if (target == null) {
	        throw new TypeError('Cannot convert undefined or null to object');
	    }
	    var to = Object(target);
	    for (var index = 0; index < sources.length; index++) {
	        var nextSource = sources[index];
	        if (nextSource != null) {
	            for (var nextKey in nextSource) {
	                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	                    to[nextKey] = nextSource[nextKey];
	                }
	            }
	        }
	    }
	    return to;
	}
	exports.assign = assign;
	;


/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function sanitize(str) {
	    var val = str;
	    val = val.replace(/^\s*/gm, '');
	    var whiteList = /^\s*((|https?|s?ftp|file|blob|mailto|tel):|#|\/|data:image\/)/;
	    if (whiteList.test(val)) {
	        return val;
	    }
	    return 'unsafe:' + val;
	}
	exports.sanitize = sanitize;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(43);
	var Danger = __webpack_require__(641);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(23);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(122);
	var setInnerHTML = __webpack_require__(80);
	var setTextContent = __webpack_require__(331);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactErrorUtils = __webpack_require__(120);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(670);
	var propTypesFactory = __webpack_require__(306);
	
	var React = __webpack_require__(47);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactInstanceMap = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(26);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(10);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(81);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Player = function (_Component) {
	  _inherits(Player, _Component);
	
	  function Player() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Player);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
	      if (!_this.player) return null;
	      return _this.player[key];
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player && _this.isReady) {
	        var playedSeconds = _this.getCurrentTime() || 0;
	        var loadedSeconds = _this.getSecondsLoaded();
	        var duration = _this.getDuration();
	        if (duration) {
	          var progress = {
	            playedSeconds: playedSeconds,
	            played: playedSeconds / duration
	          };
	          if (loadedSeconds !== null) {
	            progress.loadedSeconds = loadedSeconds;
	            progress.loaded = loadedSeconds / duration;
	          }
	          // Only call onProgress if values have changed
	          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
	            _this.props.onProgress(progress);
	          }
	          _this.prevPlayed = progress.played;
	          _this.prevLoaded = progress.loaded;
	        }
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
	    }, _this.onReady = function () {
	      if (!_this.mounted) return;
	      _this.isReady = true;
	      _this.isLoading = false;
	      var _this$props = _this.props,
	          onReady = _this$props.onReady,
	          playing = _this$props.playing,
	          volume = _this$props.volume,
	          muted = _this$props.muted;
	
	      onReady();
	      if (!muted && volume !== null) {
	        _this.player.setVolume(volume);
	      }
	      if (_this.loadOnReady) {
	        _this.player.load(_this.loadOnReady, true);
	        _this.loadOnReady = null;
	      } else if (playing) {
	        _this.player.play();
	      }
	      _this.onDurationCheck();
	    }, _this.onPlay = function () {
	      _this.isPlaying = true;
	      _this.isLoading = false;
	      var _this$props2 = _this.props,
	          onStart = _this$props2.onStart,
	          onPlay = _this$props2.onPlay,
	          playbackRate = _this$props2.playbackRate;
	
	      if (_this.startOnPlay) {
	        if (_this.player.setPlaybackRate) {
	          _this.player.setPlaybackRate(playbackRate);
	        }
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      _this.onDurationCheck();
	    }, _this.onPause = function (e) {
	      _this.isPlaying = false;
	      if (!_this.isLoading) {
	        _this.props.onPause(e);
	      }
	    }, _this.onEnded = function () {
	      var _this$props3 = _this.props,
	          activePlayer = _this$props3.activePlayer,
	          loop = _this$props3.loop,
	          onEnded = _this$props3.onEnded;
	
	      if (activePlayer.loopOnEnded && loop) {
	        _this.seekTo(0);
	      }
	      if (!loop) {
	        _this.isPlaying = false;
	        onEnded();
	      }
	    }, _this.onDurationCheck = function () {
	      clearTimeout(_this.durationCheckTimeout);
	      var duration = _this.getDuration();
	      if (duration) {
	        if (!_this.onDurationCalled) {
	          _this.props.onDuration(duration);
	          _this.onDurationCalled = true;
	        }
	      } else {
	        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
	      }
	    }, _this.onLoaded = function () {
	      // Sometimes we know loading has stopped but onReady/onPlay are never called
	      // so this provides a way for players to avoid getting stuck
	      _this.isLoading = false;
	    }, _this.ref = function (player) {
	      if (player) {
	        _this.player = player;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  } // Track playing state internally to prevent bugs
	  // Use isLoading to prevent onPause when switching URL
	
	
	  _createClass(Player, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.player.load(this.props.url);
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	      clearTimeout(this.durationCheckTimeout);
	      if (this.isReady) {
	        this.player.stop();
	      }
	      if (this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // Invoke player methods based on incoming props
	      var _props = this.props,
	          url = _props.url,
	          playing = _props.playing,
	          volume = _props.volume,
	          muted = _props.muted,
	          playbackRate = _props.playbackRate,
	          pip = _props.pip;
	
	      if (!(0, _utils.isEqual)(url, nextProps.url)) {
	        if (this.isLoading) {
	          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
	          this.loadOnReady = nextProps.url;
	          return;
	        }
	        this.isLoading = true;
	        this.startOnPlay = true;
	        this.onDurationCalled = false;
	        this.player.load(nextProps.url, this.isReady);
	      }
	      if (!playing && nextProps.playing && !this.isPlaying) {
	        this.player.play();
	      }
	      if (playing && !nextProps.playing && this.isPlaying) {
	        this.player.pause();
	      }
	      if (!pip && nextProps.pip && this.player.enablePIP) {
	        this.player.enablePIP();
	      } else if (pip && !nextProps.pip && this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	      if (volume !== nextProps.volume && nextProps.volume !== null) {
	        this.player.setVolume(nextProps.volume);
	      }
	      if (muted !== nextProps.muted) {
	        if (nextProps.muted) {
	          this.player.mute();
	        } else {
	          this.player.unmute();
	          if (nextProps.volume !== null) {
	            // Set volume next tick to fix a bug with DailyMotion
	            setTimeout(function () {
	              return _this2.player.setVolume(nextProps.volume);
	            });
	          }
	        }
	      }
	      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
	        this.player.setPlaybackRate(nextProps.playbackRate);
	      }
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      if (!this.isReady) return null;
	      return this.player.getCurrentTime();
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      if (!this.isReady) return null;
	      return this.player.getSecondsLoaded();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(amount) {
	      var _this3 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && amount !== 0) {
	        this.seekOnPlay = amount;
	        setTimeout(function () {
	          _this3.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	        return;
	      }
	      if (amount > 0 && amount < 1) {
	        // Convert fraction to seconds based on duration
	        var duration = this.player.getDuration();
	        if (!duration) {
	          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
	          return;
	        }
	        this.player.seekTo(duration * amount);
	        return;
	      }
	      this.player.seekTo(amount);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Player = this.props.activePlayer;
	      if (!Player) {
	        return null;
	      }
	      return _react2['default'].createElement(Player, _extends({}, this.props, {
	        ref: this.ref,
	        onReady: this.onReady,
	        onPlay: this.onPlay,
	        onPause: this.onPause,
	        onEnded: this.onEnded,
	        onLoaded: this.onLoaded
	      }));
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	Player.displayName = 'Player';
	Player.propTypes = _props2.propTypes;
	Player.defaultProps = _props2.defaultProps;
	exports['default'] = Player;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DailyMotion = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://api.dmcdn.net/all.js';
	var SDK_GLOBAL = 'DM';
	var SDK_GLOBAL_READY = 'dmAsyncInit';
	var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
	
	var DailyMotion = exports.DailyMotion = function (_Component) {
	  _inherits(DailyMotion, _Component);
	
	  function DailyMotion() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DailyMotion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
	      var duration = _this.getDuration();
	      _this.props.onDuration(duration);
	    }, _this.mute = function () {
	      _this.callPlayer('setMuted', true);
	    }, _this.unmute = function () {
	      _this.callPlayer('setMuted', false);
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DailyMotion, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props = this.props,
	          controls = _props.controls,
	          config = _props.config,
	          onError = _props.onError,
	          playing = _props.playing;
	
	      var _url$match = url.match(MATCH_URL),
	          _url$match2 = _slicedToArray(_url$match, 2),
	          id = _url$match2[1];
	
	      if (this.player) {
	        this.player.load(id, {
	          start: (0, _utils.parseStartTime)(url),
	          autoplay: playing
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
	        return DM.player;
	      }).then(function (DM) {
	        if (!_this2.container) return;
	        var Player = DM.player;
	        _this2.player = new Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          video: id,
	          params: _extends({
	            controls: controls,
	            autoplay: _this2.props.playing,
	            mute: _this2.props.muted,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }, config.dailymotion.params),
	          events: {
	            apiready: _this2.props.onReady,
	            seeked: function seeked() {
	              return _this2.props.onSeek(_this2.player.currentTime);
	            },
	            video_end: _this2.props.onEnded,
	            durationchange: _this2.onDurationChange,
	            pause: _this2.props.onPause,
	            playing: _this2.props.onPlay,
	            waiting: _this2.props.onBuffer,
	            error: function error(event) {
	              return onError(event);
	            }
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.player.duration || null;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.player.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.player.bufferedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      }, this.props.style);
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }]);
	
	  return DailyMotion;
	}(_react.Component);
	
	DailyMotion.displayName = 'DailyMotion';
	
	DailyMotion.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	DailyMotion.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SoundCloud = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://w.soundcloud.com/player/api.js';
	var SDK_GLOBAL = 'SC';
	var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;
	
	var SoundCloud = exports.SoundCloud = function (_Component) {
	  _inherits(SoundCloud, _Component);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
	      _this.setVolume(0);
	    }, _this.unmute = function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
	        if (!_this2.iframe) return;
	        var _SC$Widget$Events = SC.Widget.Events,
	            PLAY = _SC$Widget$Events.PLAY,
	            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
	            PAUSE = _SC$Widget$Events.PAUSE,
	            FINISH = _SC$Widget$Events.FINISH,
	            ERROR = _SC$Widget$Events.ERROR;
	
	        if (!isReady) {
	          _this2.player = SC.Widget(_this2.iframe);
	          _this2.player.bind(PLAY, _this2.props.onPlay);
	          _this2.player.bind(PAUSE, _this2.props.onPause);
	          _this2.player.bind(PLAY_PROGRESS, function (e) {
	            _this2.currentTime = e.currentPosition / 1000;
	            _this2.fractionLoaded = e.loadedProgress;
	          });
	          _this2.player.bind(FINISH, function () {
	            return _this2.props.onEnded();
	          });
	          _this2.player.bind(ERROR, function (e) {
	            return _this2.props.onError(e);
	          });
	        }
	        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
	          callback: function callback() {
	            _this2.player.getDuration(function (duration) {
	              _this2.duration = duration / 1000;
	              _this2.props.onReady();
	            });
	          }
	        }));
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seekTo', seconds * 1000);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.fractionLoaded * this.duration;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%'
	      }, this.props.style);
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
	        style: style,
	        frameBorder: 0
	      });
	    }
	  }]);
	
	  return SoundCloud;
	}(_react.Component);
	
	SoundCloud.displayName = 'SoundCloud';
	
	SoundCloud.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	SoundCloud.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vimeo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.vimeo.com/api/player.js';
	var SDK_GLOBAL = 'Vimeo';
	var MATCH_URL = /vimeo\.com\/.+/;
	var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;
	
	var Vimeo = exports.Vimeo = function (_Component) {
	  _inherits(Vimeo, _Component);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      _this.setVolume(0);
	    }, _this.unmute = function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      this.duration = null;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
	        if (!_this2.container) return;
	        _this2.player = new Vimeo.Player(_this2.container, _extends({}, _this2.props.config.vimeo.playerOptions, {
	          url: url,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          loop: _this2.props.loop
	        }));
	        _this2.player.ready().then(function () {
	          var iframe = _this2.container.querySelector('iframe');
	          iframe.style.width = '100%';
	          iframe.style.height = '100%';
	        })['catch'](_this2.props.onError);
	        _this2.player.on('loaded', function () {
	          _this2.props.onReady();
	          _this2.refreshDuration();
	        });
	        _this2.player.on('play', function () {
	          _this2.props.onPlay();
	          _this2.refreshDuration();
	        });
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('seeked', function (e) {
	          return _this2.props.onSeek(e.seconds);
	        });
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref2) {
	          var seconds = _ref2.seconds;
	
	          _this2.currentTime = seconds;
	        });
	        _this2.player.on('progress', function (_ref3) {
	          var seconds = _ref3.seconds;
	
	          _this2.secondsLoaded = seconds;
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'refreshDuration',
	    value: function refreshDuration() {
	      var _this3 = this;
	
	      this.player.getDuration().then(function (duration) {
	        _this3.duration = duration;
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('unload');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%',
	        overflow: 'hidden',
	        backgroundColor: 'black'
	      }, this.props.style);
	      return _react2['default'].createElement('div', {
	        key: this.props.url,
	        ref: this.ref,
	        style: style
	      });
	    }
	  }]);
	
	  return Vimeo;
	}(_react.Component);
	
	Vimeo.displayName = 'Vimeo';
	
	Vimeo.canPlay = function (url) {
	  if (MATCH_FILE_URL.test(url)) {
	    return false;
	  }
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YouTube = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;
	var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;
	
	function parsePlaylist(url) {
	  if (MATCH_PLAYLIST.test(url)) {
	    var _url$match = url.match(MATCH_PLAYLIST),
	        _url$match2 = _slicedToArray(_url$match, 2),
	        playlistId = _url$match2[1];
	
	    console.log(playlistId);
	    return {
	      listType: 'playlist',
	      list: playlistId
	    };
	  }
	  return {};
	}
	
	var YouTube = exports.YouTube = function (_Component) {
	  _inherits(YouTube, _Component);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props,
	          onPlay = _this$props.onPlay,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer,
	          onEnded = _this$props.onEnded,
	          onReady = _this$props.onReady,
	          loop = _this$props.loop;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) {
	        var isPlaylist = !!_this.callPlayer('getPlaylist');
	        if (loop && !isPlaylist) {
	          _this.play(); // Only loop manually if not playing a playlist
	        }
	        onEnded();
	      }
	      if (data === CUED) onReady();
	    }, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unMute');
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playing = _props.playing,
	          muted = _props.muted,
	          playsinline = _props.playsinline,
	          controls = _props.controls,
	          loop = _props.loop,
	          config = _props.config,
	          _onError = _props.onError;
	      var playerVars = config.youtube.playerVars;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
	          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
	        return YT.loaded;
	      }).then(function (YT) {
	        if (!_this2.container) return;
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({
	            autoplay: playing ? 1 : 0,
	            mute: muted ? 1 : 0,
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            end: (0, _utils.parseEndTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, parsePlaylist(url), playerVars),
	          events: {
	            onReady: _this2.props.onReady,
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	        if (loop) {
	          _this2.player.setLoop(true); // Enable playlist looping
	        }
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('playVideo');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pauseVideo');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!document.body.contains(this.callPlayer('getIframe'))) return;
	      this.callPlayer('stopVideo');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(amount) {
	      this.callPlayer('seekTo', amount);
	      if (!this.props.playing) {
	        this.pause();
	      }
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%'
	      }, this.props.style);
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }]);
	
	  return YouTube;
	}(_react.Component);
	
	YouTube.displayName = 'YouTube';
	
	YouTube.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ },
/* 134 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(136);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(305);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(353);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(361);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(767);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(766);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(765);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(360);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(362);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//////////////////////////////////////////////////////////////////////////////////////
	 //                                                                                //
	 //  ███████╗ █████╗ ██╗██╗     ███████╗   ██╗ ██████╗         ██╗███████╗         //
	 //  ██╔════╝██╔══██╗██║██║     ██╔════╝   ██║██╔═══██╗        ██║██╔════╝         //
	 //  ███████╗███████║██║██║     ███████╗   ██║██║   ██║        ██║███████╗         //
	 //  ╚════██║██╔══██║██║██║     ╚════██║   ██║██║   ██║   ██   ██║╚════██║         //
	 //  ███████║██║  ██║██║███████╗███████║██╗██║╚██████╔╝██╗╚█████╔╝███████║         //
	 //  ╚══════╝╚═╝  ╚═╝╚═╝╚══════╝╚══════╝╚═╝╚═╝ ╚═════╝ ╚═╝ ╚════╝ ╚══════╝         //
	 //                                                                                //
	 //   ╦╔═╗╦  ╦╔═╗╔═╗╔═╗╦═╗╦╔═╗╔╦╗  ╔═╗╦  ╦╔═╗╔╗╔╔╦╗  ╔═╗╔╦╗╦╔═                     //
	 //   ║╠═╣╚╗╔╝╠═╣╚═╗║  ╠╦╝║╠═╝ ║   ║  ║  ║║╣ ║║║ ║   ╚═╗ ║║╠╩╗                     //
	 //  ╚╝╩ ╩ ╚╝ ╩ ╩╚═╝╚═╝╩╚═╩╩   ╩   ╚═╝╩═╝╩╚═╝╝╚╝ ╩   ╚═╝═╩╝╩ ╩                     //
	 //  ┌─┐┌─┐┬─┐  ┌┐┌┌─┐┌┬┐┌─┐  ┬┌─┐  ┌─┐┌┐┌┌┬┐  ┌┬┐┬ ┬┌─┐  ┌┐ ┬─┐┌─┐┬ ┬┌─┐┌─┐┬─┐    //
	 //  ├┤ │ │├┬┘  ││││ │ ││├┤   │└─┐  ├─┤│││ ││   │ ├─┤├┤   ├┴┐├┬┘│ ││││└─┐├┤ ├┬┘    //
	 //  └  └─┘┴└─  ┘└┘└─┘─┴┘└─┘o└┘└─┘  ┴ ┴┘└┘─┴┘   ┴ ┴ ┴└─┘  └─┘┴└─└─┘└┴┘└─┘└─┘┴└─    //
	 //                                                                                //
	//////////////////////////////////////////////////////////////////////////////////////
	
	/**
	 * sails.io.js
	 * ------------------------------------------------------------------------
	 * JavaScript Client (SDK) for communicating with Sails.
	 *
	 * Note that this script is completely optional, but it is handy if you're
	 * using WebSockets from the browser to talk to your Sails server.
	 *
	 * For tips and documentation, visit:
	 * http://sailsjs.com/documentation/reference/web-sockets/socket-client
	 * ------------------------------------------------------------------------
	 *
	 * This file allows you to send and receive socket.io messages to & from Sails
	 * by simulating a REST client interface on top of socket.io. It models its API
	 * after the $.ajax pattern from jQuery you might already be familiar with.
	 *
	 * So if you're switching from using AJAX to sockets, instead of:
	 *    `$.post( url, [data], [cb] )`
	 *
	 * You would use:
	 *    `socket.post( url, [data], [cb] )`
	 */
	
	
	(function() {
	
	
	  //   ██████╗ ██████╗ ███╗   ██╗███████╗████████╗ █████╗ ███╗   ██╗████████╗███████╗
	  //  ██╔════╝██╔═══██╗████╗  ██║██╔════╝╚══██╔══╝██╔══██╗████╗  ██║╚══██╔══╝██╔════╝
	  //  ██║     ██║   ██║██╔██╗ ██║███████╗   ██║   ███████║██╔██╗ ██║   ██║   ███████╗
	  //  ██║     ██║   ██║██║╚██╗██║╚════██║   ██║   ██╔══██║██║╚██╗██║   ██║   ╚════██║
	  //  ╚██████╗╚██████╔╝██║ ╚████║███████║   ██║   ██║  ██║██║ ╚████║   ██║   ███████║
	  //   ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚══════╝
	  //
	
	
	  /**
	   * Constant containing the names of all available options
	   * for individual sockets.
	   *
	   * @type {Array}
	   */
	  var SOCKET_OPTIONS = [
	    'useCORSRouteToGetCookie',
	    'url',
	    'multiplex',
	    'transports',
	    'query',
	    'path',
	    'headers',
	    'initialConnectionHeaders',
	    'reconnection',
	    'reconnectionAttempts',
	    'reconnectionDelay',
	    'reconnectionDelayMax',
	    'rejectUnauthorized',
	    'randomizationFactor',
	    'timeout'
	  ];
	
	
	  /**
	   * Constant containing the names of properties on `io.sails` which
	   * may be configured using HTML attributes on the script tag which
	   * loaded this file.
	   *
	   * @type {Array}
	   *
	   * (this is unused if loading from node.js)
	   */
	  var CONFIGURABLE_VIA_HTML_ATTR = [
	    'autoConnect',
	    'reconnection',
	    'environment',
	    'headers',
	    'url',
	    'transports',
	    'path'
	  ];
	
	
	
	
	  /**
	   * Constant containing the names of querystring
	   * parameters sent when connecting any SailsSocket.
	   *
	   * @type {Dictionary}
	   */
	  var CONNECTION_METADATA_PARAMS = {
	    version: '__sails_io_sdk_version',
	    platform: '__sails_io_sdk_platform',
	    language: '__sails_io_sdk_language'
	  };
	
	
	  /**
	   * Constant containing metadata about the platform, language, and
	   * current version of this SDK.
	   *
	   * @type {Dictionary}
	   */
	  var SDK_INFO = {
	    version: '1.2.1', // <-- pulled automatically from package.json, do not change!
	    language: 'javascript',
	    platform: (function (){
	      if (typeof module === 'object' && typeof module.exports !== 'undefined') {
	        return 'node';
	      }
	      else {
	        return 'browser';
	      }
	    })()
	  };
	
	  // Build `versionString` (a querystring snippet) by
	  // combining SDK_INFO and CONNECTION_METADATA_PARAMS.
	  SDK_INFO.versionString =
	    CONNECTION_METADATA_PARAMS.version + '=' + SDK_INFO.version + '&' +
	    CONNECTION_METADATA_PARAMS.platform + '=' + SDK_INFO.platform + '&' +
	    CONNECTION_METADATA_PARAMS.language + '=' + SDK_INFO.language;
	
	
	
	
	  //   █████╗ ██████╗ ███████╗ ██████╗ ██████╗ ██████╗     ██╗  ██╗████████╗███╗   ███╗██╗
	  //  ██╔══██╗██╔══██╗██╔════╝██╔═══██╗██╔══██╗██╔══██╗    ██║  ██║╚══██╔══╝████╗ ████║██║
	  //  ███████║██████╔╝███████╗██║   ██║██████╔╝██████╔╝    ███████║   ██║   ██╔████╔██║██║
	  //  ██╔══██║██╔══██╗╚════██║██║   ██║██╔══██╗██╔══██╗    ██╔══██║   ██║   ██║╚██╔╝██║██║
	  //  ██║  ██║██████╔╝███████║╚██████╔╝██║  ██║██████╔╝    ██║  ██║   ██║   ██║ ╚═╝ ██║███████╗
	  //  ╚═╝  ╚═╝╚═════╝ ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝     ╚═╝  ╚═╝   ╚═╝   ╚═╝     ╚═╝╚══════╝
	  //
	  //   █████╗ ████████╗████████╗██████╗ ██╗██████╗ ██╗   ██╗████████╗███████╗███████╗
	  //  ██╔══██╗╚══██╔══╝╚══██╔══╝██╔══██╗██║██╔══██╗██║   ██║╚══██╔══╝██╔════╝██╔════╝
	  //  ███████║   ██║      ██║   ██████╔╝██║██████╔╝██║   ██║   ██║   █████╗  ███████╗
	  //  ██╔══██║   ██║      ██║   ██╔══██╗██║██╔══██╗██║   ██║   ██║   ██╔══╝  ╚════██║
	  //  ██║  ██║   ██║      ██║   ██║  ██║██║██████╔╝╚██████╔╝   ██║   ███████╗███████║
	  //  ╚═╝  ╚═╝   ╚═╝      ╚═╝   ╚═╝  ╚═╝╚═╝╚═════╝  ╚═════╝    ╚═╝   ╚══════╝╚══════╝
	  //
	  //  ███████╗██████╗  ██████╗ ███╗   ███╗      ██╗███████╗ ██████╗██████╗ ██╗██████╗ ████████╗██╗
	  //  ██╔════╝██╔══██╗██╔═══██╗████╗ ████║     ██╔╝██╔════╝██╔════╝██╔══██╗██║██╔══██╗╚══██╔══╝╚██╗
	  //  █████╗  ██████╔╝██║   ██║██╔████╔██║    ██╔╝ ███████╗██║     ██████╔╝██║██████╔╝   ██║    ╚██╗
	  //  ██╔══╝  ██╔══██╗██║   ██║██║╚██╔╝██║    ╚██╗ ╚════██║██║     ██╔══██╗██║██╔═══╝    ██║    ██╔╝
	  //  ██║     ██║  ██║╚██████╔╝██║ ╚═╝ ██║     ╚██╗███████║╚██████╗██║  ██║██║██║        ██║   ██╔╝
	  //  ╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚═╝     ╚═╝      ╚═╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝╚═╝        ╚═╝   ╚═╝
	  //
	  //
	  // If available, grab the DOM element for the script tag which imported this file.
	  // (skip this if this SDK is being used outside of the DOM, i.e. in a Node process)
	  //
	  // This is used below to parse client-side sails.io.js configuration encoded as
	  // HTML attributes, as well as grabbing hold of the URL from whence the SDK was fetched.
	  var thisScriptTag = (function() {
	    if (
	      typeof window !== 'object' ||
	      typeof window.document !== 'object' ||
	      typeof window.document.getElementsByTagName !== 'function'
	    ) {
	      return null;
	    }
	
	    // Return the URL of the last script loaded (i.e. this one)
	    // (this must run before nextTick; see http://stackoverflow.com/a/2976714/486547)
	    var allScriptsCurrentlyInDOM = window.document.getElementsByTagName('script');
	    return allScriptsCurrentlyInDOM[allScriptsCurrentlyInDOM.length - 1];
	  })();
	
	
	  // Variables to contain src URL and other script tag config (for use below).
	  var urlThisScriptWasFetchedFrom = '';
	  var scriptTagConfig = {};
	
	
	  if (thisScriptTag) {
	    // Save the URL that this script was fetched from.
	    urlThisScriptWasFetchedFrom = thisScriptTag.src;
	
	    // Now parse the most common client-side configuration settings
	    // from the script tag where they may be encoded as HTML attributes.
	    //
	    // Any configuration which may be provided as an HTML attribute may
	    // also be provided prefixed with `data-`.  This is for folks who
	    // need to support browsers that have issues with nonstandard
	    // HTML attributes (or if the idea of using nonstandard HTML attributes
	    // just creeps you out)
	    //
	    // If a `data-` prefixed attr is provided, it takes precedence.
	    // (this is so that if you are already using one of these HTML
	    //  attrs for some reason, you can keep it as-is and override
	    //  it using `data-`. If you are using the `data-` prefixed version
	    //  for some other purpose... well, in that case you'll just have to
	    //  configure programmatically using `io.sails` instead.)
	    CONFIGURABLE_VIA_HTML_ATTR.forEach(function (configKey){
	
	      scriptTagConfig[configKey] = (function (){
	
	        // Support 'data-' prefixed or normal attributes.
	        // (prefixed versions take precedence if provided)
	        var htmlAttrVal = thisScriptTag.getAttribute( 'data-'+configKey );
	        if (!htmlAttrVal) {
	          htmlAttrVal = thisScriptTag.getAttribute( configKey );
	        }
	
	        // The HTML attribute value should always be a string or `null`.
	        // We'll try to parse it as JSON and use that, but worst case fall back
	        // to the default situation of it being a string.
	        if (typeof htmlAttrVal === 'string') {
	          try { return JSON.parse(htmlAttrVal); } catch (e) { return htmlAttrVal; }
	        }
	        // If `null` was returned from getAttribute(), it means that the HTML attribute
	        // was not specified, so we treat it as undefined (which will cause the property
	        // to be removed below)
	        else if (htmlAttrVal === null) {
	          return undefined;
	        }
	        // Any other contingency shouldn't be possible:
	        // - if no quotes are used in the HTML attribute, it still comes in as a string.
	        // - if no RHS is provided for the attribute, it still comes in as "" (empty string)
	        // (but we still handle this with an explicit error just in case--for debugging and support purposes)
	        else throw new Error('sails.io.js :: Unexpected/invalid script tag configuration for `'+configKey+'`: `'+htmlAttrVal+'` (a `'+typeof htmlAttrVal+'`). Should be a string.');
	      })();
	
	      if (scriptTagConfig[configKey] === undefined){
	        delete scriptTagConfig[configKey];
	      }
	    });
	
	
	
	    // Now that they've been parsed, do an extremely lean version of
	    // logical type validation/coercion of provided values.
	    //////////////////////////////////////////////////////////////////
	
	    // `autoConnect`
	    if (typeof scriptTagConfig.autoConnect !== 'undefined') {
	      if (scriptTagConfig.autoConnect === '') {
	        // Special case for empty string.  It means `true` (see above).
	        scriptTagConfig.autoConnect = true;
	      }
	      else if (typeof scriptTagConfig.autoConnect !== 'boolean') {
	        throw new Error('sails.io.js :: Unexpected/invalid configuration for `autoConnect` provided in script tag: `'+scriptTagConfig.autoConnect+'` (a `'+typeof scriptTagConfig.autoConnect+'`). Should be a boolean.');
	      }
	    }
	
	
	    // `environment`
	    if (typeof scriptTagConfig.environment !== 'undefined') {
	      if (typeof scriptTagConfig.environment !== 'string') {
	        throw new Error('sails.io.js :: Unexpected/invalid configuration for `environment` provided in script tag: `'+scriptTagConfig.environment+'` (a `'+typeof scriptTagConfig.environment+'`). Should be a string.');
	      }
	    }
	
	
	    // `headers`
	    if (typeof scriptTagConfig.headers !== 'undefined') {
	      if (typeof scriptTagConfig.headers !== 'object' || Array.isArray(scriptTagConfig.headers)) {
	        throw new Error('sails.io.js :: Unexpected/invalid configuration for `headers` provided in script tag: `'+scriptTagConfig.headers+'` (a `'+typeof scriptTagConfig.headers+'`). Should be a JSON-compatible dictionary (i.e. `{}`).  Don\'t forget those double quotes (""), even on key names!  Use single quotes (\'\') to wrap the HTML attribute value; e.g. `headers=\'{"X-Auth": "foo"}\'`');
	      }
	    }
	
	
	    // `url`
	    if (typeof scriptTagConfig.url !== 'undefined') {
	      if (typeof scriptTagConfig.url !== 'string') {
	        throw new Error('sails.io.js :: Unexpected/invalid configuration for `url` provided in script tag: `'+scriptTagConfig.url+'` (a `'+typeof scriptTagConfig.url+'`). Should be a string.');
	      }
	    }
	
	    // OTHER `io.sails` options are NOT CURRENTLY SUPPORTED VIA HTML ATTRIBUTES.
	  }
	
	
	
	
	  // Grab a reference to the global socket.io client (if one is available).
	  // This is used via closure below to determine which `io` to use when the
	  // socket.io client instance (`io`) is augmented to become the Sails client
	  // SDK instance (still `io`).
	  var _existingGlobalSocketIO = (typeof io !== 'undefined') ? io : undefined;
	
	
	
	
	  //////////////////////////////////////////////////////////////
	  /////
	  ///// NOW FOR BUNCHES OF:
	  /////  - PRIVATE FUNCTION DEFINITIONS
	  /////  - CONSTRUCTORS
	  /////  - AND METHODS
	  /////
	  //////////////////////////////////////////////////////////////
	  //
	
	
	
	  //  ███████╗ █████╗ ██╗██╗     ███████╗      ██╗ ██████╗        ██████╗██╗     ██╗███████╗███╗   ██╗████████╗
	  //  ██╔════╝██╔══██╗██║██║     ██╔════╝      ██║██╔═══██╗      ██╔════╝██║     ██║██╔════╝████╗  ██║╚══██╔══╝
	  //  ███████╗███████║██║██║     ███████╗█████╗██║██║   ██║█████╗██║     ██║     ██║█████╗  ██╔██╗ ██║   ██║
	  //  ╚════██║██╔══██║██║██║     ╚════██║╚════╝██║██║   ██║╚════╝██║     ██║     ██║██╔══╝  ██║╚██╗██║   ██║
	  //  ███████║██║  ██║██║███████╗███████║      ██║╚██████╔╝      ╚██████╗███████╗██║███████╗██║ ╚████║   ██║
	  //  ╚══════╝╚═╝  ╚═╝╚═╝╚══════╝╚══════╝      ╚═╝ ╚═════╝        ╚═════╝╚══════╝╚═╝╚══════╝╚═╝  ╚═══╝   ╚═╝
	  //
	
	  /**
	   * SailsIOClient()
	   *
	   * Augment the provided Socket.io client object (`io`) with methods for
	   * talking and listening to one or more Sails backend(s).  If no `io` was
	   * provided (i.e. in a browser setting), then attempt to use the global.
	   *
	   * This absorbs implicit `io.sails` configuration, sets a timer for
	   * automatically connecting a socket (if `io.sails.autoConnect` is enabled)
	   * and returns the augmented `io`.
	   *
	   * Note:
	   * The automatically-connected socket is exposed as `io.socket`.  If this
	   * socket attempts to bind event listeners or send requests before it is
	   * connected, it will be queued up and replayed when the connection is
	   * successfully opened.
	   *
	   * @param {SocketIO} io
	   * @returns {SailsIOClient} [also called `io`]
	   */
	
	  function SailsIOClient(_providedSocketIO) {
	
	    // First, determine which `io` we're augmenting.
	    //
	    // Prefer the passed-in `io` instance, but fall back to the
	    // global one if we've got it.
	    var io;
	    if (_providedSocketIO) {
	      io = _providedSocketIO;
	    }
	    else {
	      io = _existingGlobalSocketIO;
	    }
	    // (note that for readability, we deliberately do not short circuit or use the tertiary operator above)
	
	
	    // If a socket.io client (`io`) is not available, none of this will work.
	    if (!io) {
	      // If node:
	      if (SDK_INFO.platform === 'node') {
	        throw new Error('No socket.io client available.  When requiring `sails.io.js` from Node.js, a socket.io client (`io`) must be passed in; e.g.:\n```\nvar io = require(\'sails.io.js\')( require(\'socket.io-client\') )\n```\n(see https://github.com/balderdashy/sails.io.js/tree/master/test for more examples)');
	      }
	      // Otherwise, this is a web browser:
	      else {
	        throw new Error('The Sails socket SDK depends on the socket.io client, but the socket.io global (`io`) was not available when `sails.io.js` loaded.  Normally, the socket.io client code is bundled with sails.io.js, so something is a little off.  Please check to be sure this version of `sails.io.js` has the minified Socket.io client at the top of the file.');
	      }
	    }
	
	    // If the chosen socket.io client (`io`) has ALREADY BEEN AUGMENTED by this SDK,
	    // (i.e. if it already has a `.sails` property) then throw an error.
	    if (io.sails) {
	      // If node:
	      if (SDK_INFO.platform === 'node') {
	        throw new Error('The provided socket.io client (`io`) has already been augmented into a Sails socket SDK instance (it has `io.sails`).');
	      }
	      // Otherwise, this is a web browser:
	      else {
	        throw new Error('The socket.io client (`io`) has already been augmented into a Sails socket SDK instance.  Usually, this means you are bringing `sails.io.js` onto the page more than once.');
	      }
	    }
	
	
	    /**
	     * A little logger for this library to use internally.
	     * Basically just a wrapper around `console.log` with
	     * support for feature-detection.
	     *
	     * @api private
	     * @factory
	     */
	    function LoggerFactory(options) {
	      options = options || {
	        prefix: true
	      };
	
	      // If `console.log` is not accessible, `log` is a noop.
	      if (
	        typeof console !== 'object' ||
	        typeof console.log !== 'function' ||
	        typeof console.log.bind !== 'function'
	      ) {
	        return function noop() {};
	      }
	
	      return function log() {
	        var args = Array.prototype.slice.call(arguments);
	
	        // All logs are disabled when `io.sails.environment = 'production'`.
	        if (io.sails.environment === 'production') return;
	
	        // Add prefix to log messages (unless disabled)
	        var PREFIX = '';
	        if (options.prefix) {
	          args.unshift(PREFIX);
	        }
	
	        // Call wrapped logger
	        console.log
	          .bind(console)
	          .apply(this, args);
	      };
	    }//</LoggerFactory>
	
	    // Create a private logger instance
	    var consolog = LoggerFactory();
	    consolog.noPrefix = LoggerFactory({
	      prefix: false
	    });
	
	
	
	    /**
	     * What is the `requestQueue`?
	     *
	     * The request queue is used to simplify app-level connection logic--
	     * i.e. so you don't have to wait for the socket to be connected
	     * to start trying to  synchronize data.
	     *
	     * @api private
	     * @param  {SailsSocket}  socket
	     */
	
	    function runRequestQueue (socket) {
	      var queue = socket.requestQueue;
	
	      if (!queue) return;
	      for (var i in queue) {
	
	        // Double-check that `queue[i]` will not
	        // inadvertently discover extra properties attached to the Object
	        // and/or Array prototype by other libraries/frameworks/tools.
	        // (e.g. Ember does this. See https://github.com/balderdashy/sails.io.js/pull/5)
	        var isSafeToDereference = ({}).hasOwnProperty.call(queue, i);
	        if (isSafeToDereference) {
	          // Get the arguments that were originally made to the "request" method
	          var requestArgs = queue[i];
	          // Call the request method again in the context of the socket, with the original args
	          socket.request.apply(socket, requestArgs);
	        }
	      }
	
	      // Now empty the queue to remove it as a source of additional complexity.
	      socket.requestQueue = null;
	    }
	
	
	
	    /**
	     * Send a JSONP request.
	     *
	     * @param  {Object}   opts [optional]
	     * @param  {Function} cb
	     * @return {XMLHttpRequest}
	     */
	
	    function jsonp(opts, cb) {
	      opts = opts || {};
	
	      if (typeof window === 'undefined') {
	        // FUTURE: refactor node usage to live in here
	        return cb();
	      }
	
	      var scriptEl = document.createElement('script');
	      window._sailsIoJSConnect = function(response) {
	        // In rare circumstances our script may have been vaporised.
	        // Remove it, but only if it still exists
	        // https://github.com/balderdashy/sails.io.js/issues/92
	        if (scriptEl && scriptEl.parentNode) {
	            scriptEl.parentNode.removeChild(scriptEl);
	        }
	
	        cb(response);
	      };
	      scriptEl.src = opts.url;
	      document.getElementsByTagName('head')[0].appendChild(scriptEl);
	
	    }
	
	
	
	
	    //       ██╗███████╗ ██████╗ ███╗   ██╗      ██╗    ██╗███████╗██████╗ ███████╗ ██████╗  ██████╗██╗  ██╗███████╗████████╗
	    //       ██║██╔════╝██╔═══██╗████╗  ██║      ██║    ██║██╔════╝██╔══██╗██╔════╝██╔═══██╗██╔════╝██║ ██╔╝██╔════╝╚══██╔══╝
	    //       ██║███████╗██║   ██║██╔██╗ ██║█████╗██║ █╗ ██║█████╗  ██████╔╝███████╗██║   ██║██║     █████╔╝ █████╗     ██║
	    //  ██   ██║╚════██║██║   ██║██║╚██╗██║╚════╝██║███╗██║██╔══╝  ██╔══██╗╚════██║██║   ██║██║     ██╔═██╗ ██╔══╝     ██║
	    //  ╚█████╔╝███████║╚██████╔╝██║ ╚████║      ╚███╔███╔╝███████╗██████╔╝███████║╚██████╔╝╚██████╗██║  ██╗███████╗   ██║
	    //   ╚════╝ ╚══════╝ ╚═════╝ ╚═╝  ╚═══╝       ╚══╝╚══╝ ╚══════╝╚═════╝ ╚══════╝ ╚═════╝  ╚═════╝╚═╝  ╚═╝╚══════╝   ╚═╝
	    //
	    //  ██████╗ ███████╗███████╗██████╗  ██████╗ ███╗   ██╗███████╗███████╗     ██╗     ██╗██╗    ██╗██████╗ ██╗
	    //  ██╔══██╗██╔════╝██╔════╝██╔══██╗██╔═══██╗████╗  ██║██╔════╝██╔════╝    ██╔╝     ██║██║    ██║██╔══██╗╚██╗
	    //  ██████╔╝█████╗  ███████╗██████╔╝██║   ██║██╔██╗ ██║███████╗█████╗      ██║      ██║██║ █╗ ██║██████╔╝ ██║
	    //  ██╔══██╗██╔══╝  ╚════██║██╔═══╝ ██║   ██║██║╚██╗██║╚════██║██╔══╝      ██║ ██   ██║██║███╗██║██╔══██╗ ██║
	    //  ██║  ██║███████╗███████║██║     ╚██████╔╝██║ ╚████║███████║███████╗    ╚██╗╚█████╔╝╚███╔███╔╝██║  ██║██╔╝
	    //  ╚═╝  ╚═╝╚══════╝╚══════╝╚═╝      ╚═════╝ ╚═╝  ╚═══╝╚══════╝╚══════╝     ╚═╝ ╚════╝  ╚══╝╚══╝ ╚═╝  ╚═╝╚═╝
	    //
	
	    /**
	     * The JWR (JSON WebSocket Response) received from a Sails server.
	     *
	     * @api public
	     * @param  {Object}  responseCtx
	     *         => :body
	     *         => :statusCode
	     *         => :headers
	     *
	     * @constructor
	     */
	
	    function JWR(responseCtx) {
	      this.body = responseCtx.body;
	      this.headers = responseCtx.headers || {};
	      this.statusCode = (typeof responseCtx.statusCode === 'undefined') ? 200 : responseCtx.statusCode;
	      // FUTURE: Replace this typeof short-circuit with an assertion (statusCode should always be set)
	
	      if (this.statusCode < 200 || this.statusCode >= 400) {
	        // Determine the appropriate error message.
	        var msg;
	        if (this.statusCode === 0) {
	          msg = 'The socket request failed.';
	        }
	        else {
	          msg = 'Server responded with a ' + this.statusCode + ' status code';
	          msg += ':\n```\n' + JSON.stringify(this.body, null, 2) + '\n```';
	          // (^^Note that we should always be able to rely on socket.io to give us
	          // non-circular data here, so we don't have to worry about wrapping the
	          // above in a try...catch)
	        }
	
	        // Now build and attach Error instance.
	        this.error = new Error(msg);
	      }
	    }
	    JWR.prototype.toString = function() {
	      return '[ResponseFromSails]' + '  -- ' +
	        'Status: ' + this.statusCode + '  -- ' +
	        'Headers: ' + this.headers + '  -- ' +
	        'Body: ' + this.body;
	    };
	    JWR.prototype.toPOJO = function() {
	      return {
	        body: this.body,
	        headers: this.headers,
	        statusCode: this.statusCode
	      };
	    };
	    JWR.prototype.pipe = function() {
	      // FUTURE: look at substack's stuff
	      return new Error('Client-side streaming support not implemented yet.');
	    };
	
	
	
	
	    //          ███████╗███╗   ███╗██╗████████╗███████╗██████╗  ██████╗ ███╗   ███╗ ██╗██╗
	    //          ██╔════╝████╗ ████║██║╚══██╔══╝██╔════╝██╔══██╗██╔═══██╗████╗ ████║██╔╝╚██╗
	    //          █████╗  ██╔████╔██║██║   ██║   █████╗  ██████╔╝██║   ██║██╔████╔██║██║  ██║
	    //          ██╔══╝  ██║╚██╔╝██║██║   ██║   ██╔══╝  ██╔══██╗██║   ██║██║╚██╔╝██║██║  ██║
	    //  ███████╗███████╗██║ ╚═╝ ██║██║   ██║   ██║     ██║  ██║╚██████╔╝██║ ╚═╝ ██║╚██╗██╔╝
	    //  ╚══════╝╚══════╝╚═╝     ╚═╝╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚═╝     ╚═╝ ╚═╝╚═╝
	    //
	
	    /**
	     * @api private
	     * @param  {SailsSocket} socket  [description]
	     * @param  {Object} requestCtx [description]
	     */
	
	    function _emitFrom(socket, requestCtx) {
	
	      if (!socket._raw) {
	        throw new Error('Failed to emit from socket- raw SIO socket is missing.');
	      }
	
	      // Since callback is embedded in requestCtx,
	      // retrieve it and delete the key before continuing.
	      var cb = requestCtx.cb;
	      delete requestCtx.cb;
	
	      // Name of the appropriate socket.io listener on the server
	      // ( === the request method or "verb", e.g. 'get', 'post', 'put', etc. )
	      var sailsEndpoint = requestCtx.method;
	
	      socket._raw.emit(sailsEndpoint, requestCtx, function serverResponded(responseCtx) {
	
	        // Send back (emulatedHTTPBody, jsonWebSocketResponse)
	        if (cb && !requestCtx.calledCb) {
	          cb(responseCtx.body, new JWR(responseCtx));
	          // Set flag indicating that callback was called, to avoid duplicate calls.
	          requestCtx.calledCb = true;
	          // Remove the callback from the list.
	          socket._responseCbs.splice(socket._responseCbs.indexOf(cb), 1);
	          // Remove the context from the list.
	          socket._requestCtxs.splice(socket._requestCtxs.indexOf(requestCtx), 1);
	        }
	      });
	    }
	
	
	
	
	
	
	
	    //  ███████╗ █████╗ ██╗██╗     ███████╗███████╗ ██████╗  ██████╗██╗  ██╗███████╗████████╗
	    //  ██╔════╝██╔══██╗██║██║     ██╔════╝██╔════╝██╔═══██╗██╔════╝██║ ██╔╝██╔════╝╚══██╔══╝
	    //  ███████╗███████║██║██║     ███████╗███████╗██║   ██║██║     █████╔╝ █████╗     ██║
	    //  ╚════██║██╔══██║██║██║     ╚════██║╚════██║██║   ██║██║     ██╔═██╗ ██╔══╝     ██║
	    //  ███████║██║  ██║██║███████╗███████║███████║╚██████╔╝╚██████╗██║  ██╗███████╗   ██║
	    //  ╚══════╝╚═╝  ╚═╝╚═╝╚══════╝╚══════╝╚══════╝ ╚═════╝  ╚═════╝╚═╝  ╚═╝╚══════╝   ╚═╝
	    //
	
	    /**
	     * SailsSocket
	     *
	     * A wrapper for an underlying Socket instance that communicates directly
	     * to the Socket.io server running inside of Sails.
	     *
	     * If no `socket` option is provied, SailsSocket will function as a mock. It will queue socket
	     * requests and event handler bindings, replaying them when the raw underlying socket actually
	     * connects. This is handy when we don't necessarily have the valid configuration to know
	     * WHICH SERVER to talk to yet, etc.  It is also used by `io.socket` for your convenience.
	     *
	     * @constructor
	     * @api private
	     *
	     * ----------------------------------------------------------------------
	     * Note: This constructor should not be used directly. To obtain a `SailsSocket`
	     * instance of your very own, run:
	     * ```
	     * var mySocket = io.sails.connect();
	     * ```
	     * ----------------------------------------------------------------------
	     */
	    function SailsSocket (opts){
	      var self = this;
	      opts = opts||{};
	
	      // Initialize private properties
	      self._isConnecting = false;
	      self._mightBeAboutToAutoConnect = false;
	
	      // Set up connection options so that they can only be changed when socket is disconnected.
	      var _opts = {};
	      SOCKET_OPTIONS.forEach(function(option) {
	        // Okay to change global headers while socket is connected
	        if (option == 'headers') {return;}
	        Object.defineProperty(self, option, {
	          get: function() {
	            if (option == 'url') {
	              return _opts[option] || (self._raw && self._raw.io && self._raw.io.uri);
	            }
	            return _opts[option];
	          },
	          set: function(value) {
	            // Don't allow value to be changed while socket is connected
	            if (self.isConnected() && io.sails.strict !== false && value != _opts[option]) {
	              throw new Error('Cannot change value of `' + option + '` while socket is connected.');
	            }
	            // If socket is attempting to reconnect, stop it.
	            if (self._raw && self._raw.io && self._raw.io.reconnecting && !self._raw.io.skipReconnect) {
	              self._raw.io.skipReconnect = true;
	              consolog('Stopping reconnect; use .reconnect() to connect socket after changing options.');
	            }
	            _opts[option] = value;
	          }
	        });
	      });
	
	      // Absorb opts into SailsSocket instance
	      // See http://sailsjs.com/documentation/reference/web-sockets/socket-client/sails-socket/properties
	      // for description of options
	      SOCKET_OPTIONS.forEach(function(option) {
	        self[option] = opts[option];
	      });
	
	      // Set up "eventQueue" to hold event handlers which have not been set on the actual raw socket yet.
	      self.eventQueue = {};
	
	      // Listen for special `parseError` event sent from sockets hook on the backend
	      // if an error occurs but a valid callback was not received from the client
	      // (i.e. so the server had no other way to send back the error information)
	      self.on('sails:parseError', function (err){
	        consolog('Sails encountered an error parsing a socket message sent from this client, and did not have access to a callback function to respond with.');
	        consolog('Error details:',err);
	      });
	
	      // FUTURE:
	      // Listen for a special private message on any connected that allows the server
	      // to set the environment (giving us 100% certainty that we guessed right)
	      // However, note that the `console.log`s called before and after connection
	      // are still forced to rely on our existing heuristics (to disable, tack #production
	      // onto the URL used to fetch this file.)
	
	    }//</SailsSocket>
	
	
	    /**
	     * `SailsSocket.prototype._connect()`
	     *
	     * Begin connecting this socket to the server.
	     *
	     * @api private
	     */
	    SailsSocket.prototype._connect = function (){
	      var self = this;
	
	      self._isConnecting = true;
	
	      // Apply `io.sails` config as defaults
	      // (now that at least one tick has elapsed)
	      // See http://sailsjs.com/documentation/reference/web-sockets/socket-client/sails-socket/properties
	      // for description of options and default values
	      SOCKET_OPTIONS.forEach(function(option) {
	        if ('undefined' == typeof self[option]) {
	          self[option] = io.sails[option];
	        }
	      });
	
	      // Headers that will be sent with the initial request to /socket.io (Node.js only)
	      self.extraHeaders = self.initialConnectionHeaders || {};
	
	      // For browser usage (currently works with "polling" transport only)
	      self.transportOptions = self.transportOptions || {};
	      self.transports.forEach(function(transport) {
	        self.transportOptions[transport] = self.transportOptions[transport] || {};
	        self.transportOptions[transport].extraHeaders = self.initialConnectionHeaders || {};
	      });
	
	      // Log a warning if non-Node.js platform attempts to use `initialConnectionHeaders` for anything other than `polling`.
	      if (self.initialConnectionHeaders && SDK_INFO.platform !== 'node' && self.transports.indexOf('polling') === -1 || self.transports.length > 1) {
	        if (typeof console === 'object' && typeof console.warn === 'function') {
	          console.warn('When running in browser, `initialConnectionHeaders` option is only available for the `polling` transport.');
	        }
	      }
	
	      // Ensure URL has no trailing slash
	      self.url = self.url ? self.url.replace(/(\/)$/, '') : undefined;
	
	      // Mix the current SDK version into the query string in
	      // the connection request to the server:
	      if (typeof self.query === 'string') {
	        // (If provided as a string, trim leading question mark,
	        // just in case one was provided.)
	        self.query = self.query.replace(/^\?/, '');
	        self.query += '&' + SDK_INFO.versionString;
	      }
	      else if (self.query && typeof self.query === 'object') {
	        throw new Error('`query` setting does not currently support configuration as a dictionary (`{}`).  Instead, it must be specified as a string like `foo=89&bar=hi`');
	      }
	      else if (!self.query) {
	        self.query = SDK_INFO.versionString;
	      }
	      else {
	        throw new Error('Unexpected data type provided for `query` setting: '+self.query);
	      }
	
	      // Determine whether this is a cross-origin socket by examining the
	      // hostname and port on the `window.location` object.  If it's cross-origin,
	      // we'll attempt to get a cookie for the domain so that a Sails session can
	      // be established.
	      var isXOrigin = (function (){
	
	        // If `window` doesn't exist (i.e. being used from Node.js), then
	        // we won't bother attempting to get a cookie.  If you're using sockets
	        // from Node.js and find you need to share a session between multiple
	        // socket connections, you'll need to make an HTTP request to the /__getcookie
	        // endpoint of the Sails server (or any endpoint that returns a set-cookie header)
	        // and then use the cookie value in the `initialConnectionHeaders` option to
	        // io.sails.connect()
	        if (typeof window === 'undefined' || typeof window.location === 'undefined') {
	          return false;
	        }
	
	        // If `self.url` (aka "target") is falsy, then we don't need to worry about it.
	        if (typeof self.url !== 'string') { return false; }
	
	        // Get information about the "target" (`self.url`)
	        var targetProtocol = (function (){
	          try {
	            targetProtocol = self.url.match(/^([a-z]+:\/\/)/i)[1].toLowerCase();
	          }
	          catch (e) {}
	          targetProtocol = targetProtocol || 'http://';
	          return targetProtocol;
	        })();
	        var isTargetSSL = !!self.url.match('^https');
	        var targetPort = (function (){
	          try {
	            return self.url.match(/^[a-z]+:\/\/[^:]*:([0-9]*)/i)[1];
	          }
	          catch (e){}
	          return isTargetSSL ? '443' : '80';
	        })();
	        var targetAfterProtocol = self.url.replace(/^([a-z]+:\/\/)/i, '');
	
	
	        // If target protocol is different than the actual protocol,
	        // then we'll consider this cross-origin.
	        if (targetProtocol.replace(/[:\/]/g, '') !== window.location.protocol.replace(/[:\/]/g,'')) {
	          return true;
	        }
	
	
	        // If target hostname is different than actual hostname, we'll consider this cross-origin.
	        var hasSameHostname = targetAfterProtocol.search(window.location.hostname) === 0;
	        if (!hasSameHostname) {
	          return true;
	        }
	
	        // If no actual port is explicitly set on the `window.location` object,
	        // we'll assume either 80 or 443.
	        var isLocationSSL = window.location.protocol.match(/https/i);
	        var locationPort = (window.location.port+'') || (isLocationSSL ? '443' : '80');
	
	        // Finally, if ports don't match, we'll consider this cross-origin.
	        if (targetPort !== locationPort) {
	          return true;
	        }
	
	        // Otherwise, it's the same origin.
	        return false;
	
	      })();
	
	
	      // Prepare to start connecting the socket
	      (function selfInvoking (cb){
	
	        // If this is an attempt at a cross-origin or cross-port
	        // socket connection via a browswe, send a JSONP request
	        // first to ensure that a valid cookie is available.
	        // This can be disabled by setting `io.sails.useCORSRouteToGetCookie`
	        // to false.
	        //
	        // Otherwise, skip the stuff below.
	        //
	        if (!(self.useCORSRouteToGetCookie && isXOrigin)) {
	          return cb();
	        }
	
	        // Figure out the x-origin CORS route
	        // (Sails provides a default)
	        var xOriginCookieURL = self.url;
	        if (typeof self.useCORSRouteToGetCookie === 'string') {
	          xOriginCookieURL += self.useCORSRouteToGetCookie;
	        }
	        else {
	          xOriginCookieURL += '/__getcookie';
	        }
	
	        // Make the AJAX request (CORS)
	        jsonp({
	          url: xOriginCookieURL,
	          method: 'GET'
	        }, cb);
	
	      })(function goAheadAndActuallyConnect() {
	
	        // Now that we're ready to connect, create a raw underlying Socket
	        // using Socket.io and save it as `_raw` (this will start it connecting)
	        self._raw = io(self.url, self);
	
	        // If the low-level transport throws an error _while connecting_, then set the _isConnecting flag
	        // to false (since we're no longer connecting with any chance of success anyway).
	        // Also, in this case (and in dev mode only) log a helpful message.
	        self._raw.io.engine.transport.on('error', function(err){
	          if (!self._isConnecting) { return; }
	
	          self._isConnecting = false;
	
	          // Track this timestamp for use in reconnection messages
	          // (only relevant if reconnection is enabled.)
	          self.connectionErrorTimestamp = (new Date()).getTime();
	
	          // Development-only message:
	          consolog('====================================');
	          consolog('The socket was unable to connect.');
	          consolog('The server may be offline, or the');
	          consolog('socket may have failed authorization');
	          consolog('based on its origin or other factors.');
	          consolog('You may want to check the values of');
	          consolog('`sails.config.sockets.onlyAllowOrigins`');
	          consolog('or (more rarely) `sails.config.sockets.beforeConnect`');
	          consolog('in your app.');
	          consolog('More info: https://sailsjs.com/config/sockets');
	          consolog('For help: https://sailsjs.com/support');
	          consolog('');
	          consolog('Technical details:');
	          consolog(err);
	          consolog('====================================');
	        });
	
	        // Replay event bindings from the eager socket
	        self.replay();
	
	
	        /**
	         * 'connect' event is triggered when the socket establishes a connection
	         *  successfully.
	         */
	        self.on('connect', function socketConnected() {
	          self._isConnecting = false;
	          consolog.noPrefix(
	            '\n' +
	            '\n' +
	            // '    |>    ' + '\n' +
	            // '  \\___/  '+️
	            // '\n'+
	             '  |>    Now connected to '+(self.url ? self.url : 'Sails')+'.' + '\n' +
	            '\\___/   For help, see: http://bit.ly/2q0QDpf' + '\n' +
	             '        (using sails.io.js '+io.sails.sdk.platform+' SDK @v'+io.sails.sdk.version+')'+ '\n' +
	            '         Connected at: '+(new Date())+'\n'+
	            '\n'+
	            '\n'+
	            // '\n'+
	            ''
	            // ' ⚓︎ (development mode)'
	            // 'e.g. to send a GET request to Sails via WebSockets, run:'+ '\n' +
	            // '`io.socket.get("/foo", function serverRespondedWith (body, jwr) { console.log(body); })`'+ '\n' +
	          );
	        });
	
	        self.on('disconnect', function() {
	
	          // Get a timestamp of when the disconnect was detected.
	          self.connectionLostTimestamp = (new Date()).getTime();
	
	          // Get a shallow clone of the internal array of response callbacks, in case any of the callbacks mutate it.
	          var responseCbs = [].concat(self._responseCbs || []);
	          // Wipe the internal array of response callbacks before executing them, in case a callback happens to add
	          // a new request to the queue.
	          self._responseCbs = [];
	
	          // Do the same for the internal request context list.
	          var requestCtxs = [].concat(self._requestCtxs || []);
	          self._requestCtxs = [];
	
	          // Loop through the callbacks for all in-progress requests, and call them each with an error indicating the disconnect.
	          if (responseCbs.length) {
	            responseCbs.forEach(function(responseCb) {
	              responseCb(new Error('The socket disconnected before the request completed.'), {
	                body: null,
	                statusCode: 0,
	                headers: {}
	              });
	            });
	          }
	
	          // If there is a list of request contexts, indicate that their callbacks have been
	          // called and then wipe the list.  This prevents errors in the edge case of a response
	          // somehow coming back after the socket reconnects.
	          if (requestCtxs.length) {
	            requestCtxs.forEach(function(requestCtx) {
	              requestCtx.calledCb = true;
	            });
	          }
	
	          consolog('====================================');
	          consolog('Socket was disconnected from Sails.');
	          consolog('Usually, this is due to one of the following reasons:' + '\n' +
	            ' -> the server ' + (self.url ? self.url + ' ' : '') + 'was taken down' + '\n' +
	            ' -> your browser lost internet connectivity');
	          consolog('====================================');
	        });
	
	        self.on('reconnecting', function(numAttempts) {
	          consolog(
	            '\n'+
	            '        Socket is trying to reconnect to '+(self.url ? self.url : 'Sails')+'...\n'+
	            '_-|>_-  (attempt #' + numAttempts + ')'+'\n'+
	            '\n'
	          );
	        });
	
	        self.on('reconnect', function(transport, numAttempts) {
	          if (!self._isConnecting) {
	            self.on('connect', runRequestQueue.bind(self, self));
	          }
	
	          var msSinceLastOffline;
	          var numSecsOffline;
	          if (self.connectionLostTimestamp){
	            msSinceLastOffline = ((new Date()).getTime() - self.connectionLostTimestamp);
	            numSecsOffline = (msSinceLastOffline / 1000);
	          }
	          else if (self.connectionErrorTimestamp) {
	            msSinceLastOffline = ((new Date()).getTime() - self.connectionErrorTimestamp);
	            numSecsOffline = (msSinceLastOffline / 1000);
	          }
	          else {
	            msSinceLastOffline = '???';
	            numSecsOffline = '???';
	          }
	
	          consolog(
	            '\n'+
	             '  |>    Socket reconnected successfully after'+'\n'+
	            '\\___/   being offline at least ' + numSecsOffline + ' seconds.'+'\n'+
	            '\n'
	          );
	        });
	
	        // 'error' event is triggered if connection can not be established.
	        // (usually because of a failed authorization, which is in turn
	        // usually due to a missing or invalid cookie)
	        self.on('error', function failedToConnect(err) {
	          self._isConnecting = false;
	          ////////////////////////////////////////////////////////////////////////////////////
	          // Note:
	          // In the future, we could provide a separate event for when a socket cannot connect
	          // due to a failed `beforeConnect` (aka "authorization" if you're old school).
	          // this could probably be implemented by emitting a special event from the server.
	          ////////////////////////////////////////////////////////////////////////////////////
	
	          consolog(
	            'Failed to connect socket (possibly due to failed `beforeConnect` on server)',
	            'Error:', err
	          );
	        });
	      });
	
	    };
	
	    /**
	     * Reconnect the underlying socket.
	     *
	     * @api public
	     */
	    SailsSocket.prototype.reconnect = function (){
	      if (this._isConnecting) {
	        throw new Error('Cannot connect- socket is already connecting');
	      }
	      if (this.isConnected()) {
	        throw new Error('Cannot connect- socket is already connected');
	      }
	      return this._connect();
	    };
	
	    /**
	     * Disconnect the underlying socket.
	     *
	     * @api public
	     */
	    SailsSocket.prototype.disconnect = function (){
	      this._isConnecting = false;
	      if (!this.isConnected()) {
	        throw new Error('Cannot disconnect- socket is already disconnected');
	      }
	      return this._raw.disconnect();
	    };
	
	
	
	    /**
	     * isConnected
	     *
	     * @return {Boolean} whether the socket is connected and able to
	     *                   communicate w/ the server.
	     */
	
	    SailsSocket.prototype.isConnected = function () {
	      if (!this._raw) {
	        return false;
	      }
	
	      return !!this._raw.connected;
	    };
	
	
	    /**
	     * isConnecting
	     *
	     * @return {Boolean} whether the socket is in the process of connecting
	     *                   to the server.
	     */
	
	    SailsSocket.prototype.isConnecting = function () {
	      return this._isConnecting;
	    };
	
	    /**
	     * isConnecting
	     *
	     * @return {Boolean} flag that is `true` after a SailsSocket instance is
	     *                   initialized but before one tick of the event loop
	     *                   has passed (so that it hasn't attempted to connect
	     *                   yet, if autoConnect ends up being configured `true`)
	     */
	    SailsSocket.prototype.mightBeAboutToAutoConnect = function() {
	      return this._mightBeAboutToAutoConnect;
	    };
	
	    /**
	     * [replay description]
	     * @return {[type]} [description]
	     */
	    SailsSocket.prototype.replay = function (){
	      var self = this;
	
	      // Pass events and a reference to the request queue
	      // off to the self._raw for consumption
	      for (var evName in self.eventQueue) {
	        for (var i in self.eventQueue[evName]) {
	          self._raw.on(evName, self.eventQueue[evName][i]);
	        }
	      }
	
	      // Bind a one-time function to run the request queue
	      // when the self._raw connects.
	      if ( !self.isConnected() ) {
	        self._raw.once('connect', runRequestQueue.bind(self, self));
	      }
	      // Or run it immediately if self._raw is already connected
	      else {
	        runRequestQueue(self);
	      }
	
	      return self;
	    };
	
	
	    /**
	     * Chainable method to bind an event to the socket.
	     *
	     * @param  {String}   evName [event name]
	     * @param  {Function} fn     [event handler function]
	     * @return {SailsSocket}
	     */
	    SailsSocket.prototype.on = function (evName, fn){
	
	      // Bind the event to the raw underlying socket if possible.
	      if (this._raw) {
	        this._raw.on(evName, fn);
	        return this;
	      }
	
	      // Otherwise queue the event binding.
	      if (!this.eventQueue[evName]) {
	        this.eventQueue[evName] = [fn];
	      }
	      else {
	        this.eventQueue[evName].push(fn);
	      }
	
	      return this;
	    };
	
	    /**
	     * Chainable method to unbind an event from the socket.
	     *
	     * @param  {String}   evName [event name]
	     * @param  {Function} fn     [event handler function]
	     * @return {SailsSocket}
	     */
	    SailsSocket.prototype.off = function (evName, fn){
	
	      // Bind the event to the raw underlying socket if possible.
	      if (this._raw) {
	        this._raw.off(evName, fn);
	        return this;
	      }
	
	      // Otherwise queue the event binding.
	      if (this.eventQueue[evName] && this.eventQueue[evName].indexOf(fn) > -1) {
	        this.eventQueue[evName].splice(this.eventQueue[evName].indexOf(fn), 1);
	      }
	
	      return this;
	    };
	
	
	    /**
	     * Chainable method to unbind all events from the socket.
	     *
	     * @return {SailsSocket}
	     */
	    SailsSocket.prototype.removeAllListeners = function (){
	
	      // Bind the event to the raw underlying socket if possible.
	      if (this._raw) {
	        this._raw.removeAllListeners();
	        return this;
	      }
	
	      // Otherwise queue the event binding.
	      this.eventQueue = {};
	
	      return this;
	    };
	
	    /**
	     * Simulate a GET request to sails
	     * e.g.
	     *    `socket.get('/user/3', Stats.populate)`
	     *
	     * @api public
	     * @param {String} url    ::    destination URL
	     * @param {Object} data   ::    parameters to send with the request [optional]
	     * @param {Function} cb   ::    callback function to call when finished [optional]
	     */
	
	    SailsSocket.prototype.get = function(url, data, cb) {
	
	      // `data` is optional
	      if (typeof data === 'function') {
	        cb = data;
	        data = {};
	      }
	
	      return this.request({
	        method: 'get',
	        params: data,
	        url: url
	      }, cb);
	    };
	
	
	
	    /**
	     * Simulate a POST request to sails
	     * e.g.
	     *    `socket.post('/event', newMeeting, $spinner.hide)`
	     *
	     * @api public
	     * @param {String} url    ::    destination URL
	     * @param {Object} data   ::    parameters to send with the request [optional]
	     * @param {Function} cb   ::    callback function to call when finished [optional]
	     */
	
	    SailsSocket.prototype.post = function(url, data, cb) {
	
	      // `data` is optional
	      if (typeof data === 'function') {
	        cb = data;
	        data = {};
	      }
	
	      return this.request({
	        method: 'post',
	        data: data,
	        url: url
	      }, cb);
	    };
	
	
	
	    /**
	     * Simulate a PUT request to sails
	     * e.g.
	     *    `socket.post('/event/3', changedFields, $spinner.hide)`
	     *
	     * @api public
	     * @param {String} url    ::    destination URL
	     * @param {Object} data   ::    parameters to send with the request [optional]
	     * @param {Function} cb   ::    callback function to call when finished [optional]
	     */
	
	    SailsSocket.prototype.put = function(url, data, cb) {
	
	      // `data` is optional
	      if (typeof data === 'function') {
	        cb = data;
	        data = {};
	      }
	
	      return this.request({
	        method: 'put',
	        params: data,
	        url: url
	      }, cb);
	    };
	
	
	    /**
	     * Simulate a PATCH request to sails
	     * e.g.
	     *    `socket.patch('/event/3', changedFields, $spinner.hide)`
	     *
	     * @api public
	     * @param {String} url    ::    destination URL
	     * @param {Object} data   ::    parameters to send with the request [optional]
	     * @param {Function} cb   ::    callback function to call when finished [optional]
	     */
	
	    SailsSocket.prototype.patch = function(url, data, cb) {
	
	      // `data` is optional
	      if (typeof data === 'function') {
	        cb = data;
	        data = {};
	      }
	
	      return this.request({
	        method: 'patch',
	        params: data,
	        url: url
	      }, cb);
	    };
	
	    /**
	     * Simulate a DELETE request to sails
	     * e.g.
	     *    `socket.delete('/event', $spinner.hide)`
	     *
	     * @api public
	     * @param {String} url    ::    destination URL
	     * @param {Object} data   ::    parameters to send with the request [optional]
	     * @param {Function} cb   ::    callback function to call when finished [optional]
	     */
	
	    SailsSocket.prototype['delete'] = function(url, data, cb) {
	
	      // `data` is optional
	      if (typeof data === 'function') {
	        cb = data;
	        data = {};
	      }
	
	      return this.request({
	        method: 'delete',
	        params: data,
	        url: url
	      }, cb);
	    };
	
	
	
	    /**
	     * Simulate an HTTP request to sails
	     * e.g.
	     * ```
	     * socket.request({
	     *   url:'/user',
	     *   params: {},
	     *   method: 'POST',
	     *   headers: {}
	     * }, function (responseBody, JWR) {
	     *   // ...
	     * });
	     * ```
	     *
	     * @api public
	     * @option {String} url    ::    destination URL
	     * @option {Object} params ::    parameters to send with the request [optional]
	     * @option {Object} headers::    headers to send with the request [optional]
	     * @option {Function} cb   ::    callback function to call when finished [optional]
	     * @option {String} method ::    HTTP request method [optional]
	     */
	
	    SailsSocket.prototype.request = function(options, cb) {
	
	      var usage =
	      'Usage:\n'+
	      'socket.request( options, [fnToCallWhenComplete] )\n\n'+
	      'options.url :: e.g. "/foo/bar"'+'\n'+
	      'options.method :: e.g. "get", "post", "put", or "delete", etc.'+'\n'+
	      'options.params :: e.g. { emailAddress: "mike@example.com" }'+'\n'+
	      'options.headers :: e.g. { "x-my-custom-header": "some string" }';
	      // Old usage:
	      // var usage = 'Usage:\n socket.'+(options.method||'request')+'('+
	      //   ' destinationURL, [dataToSend], [fnToCallWhenComplete] )';
	
	
	      // Validate options and callback
	      if (typeof cb !== 'undefined' && typeof cb !== 'function') {
	        throw new Error('Invalid callback function!\n' + usage);
	      }
	      if (typeof options !== 'object' || typeof options.url !== 'string') {
	        throw new Error('Invalid or missing URL!\n' + usage);
	      }
	      if (options.method && typeof options.method !== 'string') {
	        throw new Error('Invalid `method` provided (should be a string like "post" or "put")\n' + usage);
	      }
	      if (options.headers && typeof options.headers !== 'object') {
	        throw new Error('Invalid `headers` provided (should be a dictionary with string values)\n' + usage);
	      }
	      if (options.params && typeof options.params !== 'object') {
	        throw new Error('Invalid `params` provided (should be a dictionary with JSON-serializable values)\n' + usage);
	      }
	      if (options.data && typeof options.data !== 'object') {
	        throw new Error('Invalid `data` provided (should be a dictionary with JSON-serializable values)\n' + usage);
	      }
	
	      // Accept either `params` or `data` for backwards compatibility (but not both!)
	      if (options.data && options.params) {
	        throw new Error('Cannot specify both `params` and `data`!  They are aliases of each other.\n' + usage);
	      }
	      else if (options.data) {
	        options.params = options.data;
	        delete options.data;
	      }
	
	
	      // If this socket is not connected yet, queue up this request
	      // instead of sending it.
	      // (so it can be replayed when the socket comes online.)
	      if ( ! this.isConnected() ) {
	
	        // If no queue array exists for this socket yet, create it.
	        this.requestQueue = this.requestQueue || [];
	        this.requestQueue.push([options, cb]);
	        return;
	      }
	
	      // Otherwise, our socket is connected, so continue prepping
	      // the request.
	
	      // Default headers to an empty object
	      options.headers = options.headers || {};
	
	      // Build a simulated request object
	      // (and sanitize/marshal options along the way)
	      var requestCtx = {
	
	        method: (options.method || 'get').toLowerCase(),
	
	        headers: options.headers,
	
	        data: options.params || options.data || {},
	
	        // Remove trailing slashes and spaces to make packets smaller.
	        url: options.url.replace(/^(.+)\/*\s*$/, '$1'),
	
	        cb: cb
	      };
	
	      // Get a reference to the callback list, or create a new one.
	      this._responseCbs = this._responseCbs || [];
	
	      // Get a reference to the request context list, or create a new one.
	      this._requestCtxs = this._requestCtxs || [];
	
	      // Add this callback to the list.  If the socket disconnects, we'll call
	      // each cb in the list with an error and reset the list.  Otherwise the
	      // cb will be removed from the list when the server responds.
	      // Also add the request context to the list.  It will be removed once
	      // the response comes back, or if the socket disconnects.
	      if (cb) {
	        this._responseCbs.push(cb);
	        this._requestCtxs.push(requestCtx);
	      }
	
	      // Merge global headers in, if there are any.
	      if (this.headers && 'object' === typeof this.headers) {
	        for (var header in this.headers) {
	          if (!options.headers.hasOwnProperty(header)) {
	            options.headers[header] = this.headers[header];
	          }
	        }
	      }
	
	      // Send the request.
	      _emitFrom(this, requestCtx);
	    };
	
	
	
	    /**
	     * Socket.prototype._request
	     *
	     * Simulate HTTP over Socket.io.
	     *
	     * @api private
	     * @param  {[type]}   options [description]
	     * @param  {Function} cb      [description]
	     */
	    SailsSocket.prototype._request = function(options, cb) {
	      throw new Error('`_request()` was a private API deprecated as of v0.11 of the sails.io.js client. Use `.request()` instead.');
	    };
	
	
	
	
	
	
	
	    //  ██╗ ██████╗    ███████╗ █████╗ ██╗██╗     ███████╗
	    //  ██║██╔═══██╗   ██╔════╝██╔══██╗██║██║     ██╔════╝
	    //  ██║██║   ██║   ███████╗███████║██║██║     ███████╗
	    //  ██║██║   ██║   ╚════██║██╔══██║██║██║     ╚════██║
	    //  ██║╚██████╔╝██╗███████║██║  ██║██║███████╗███████║
	    //  ╚═╝ ╚═════╝ ╚═╝╚══════╝╚═╝  ╚═╝╚═╝╚══════╝╚══════╝
	    //
	    // Set an `io.sails` object that may be used for configuration before the
	    // first socket connects (i.e. to allow auto-connect behavior to be
	    // prevented by setting `io.sails.autoConnect` in an inline script
	    // directly after the script tag which loaded this file).
	
	
	    //  ┌─┐┌─┐┌┬┐  ┬ ┬┌─┐  ╔╦╗╔═╗╔═╗╔═╗╦ ╦╦ ╔╦╗╔═╗  ┌─┐┌─┐┬─┐  ┬┌─┐ ┌─┐┌─┐┬┬  ┌─┐
	    //  └─┐├┤  │   │ │├─┘   ║║║╣ ╠╣ ╠═╣║ ║║  ║ ╚═╗  ├┤ │ │├┬┘  ││ │ └─┐├─┤││  └─┐
	    //  └─┘└─┘ ┴   └─┘┴    ═╩╝╚═╝╚  ╩ ╩╚═╝╩═╝╩ ╚═╝  └  └─┘┴└─  ┴└─┘o└─┘┴ ┴┴┴─┘└─┘
	    io.sails = {
	
	      // Whether to automatically connect a socket and save it as `io.socket`.
	      autoConnect: true,
	
	      // Whether to automatically try to reconnect after connection is lost
	      reconnection: false,
	
	      // The route (path) to hit to get a x-origin (CORS) cookie
	      // (or true to use the default: '/__getcookie')
	      useCORSRouteToGetCookie: true,
	
	      // The environment we're running in.
	      // (logs are not displayed when this is set to 'production')
	      //
	      // Defaults to "development" unless this script was fetched from a URL
	      // that ends in `*.min.js` or '#production', or if the conventional
	      // `SAILS_LOCALS` global is set with an `_environment` of "production"
	      // or "staging".  (This setting may also be manually overridden.)
	      environment: (
	        urlThisScriptWasFetchedFrom.match(/(\#production|\.min\.js)/g) ||
	        (
	          typeof window === 'object' && window &&
	          typeof window.SAILS_LOCALS === 'object' && window.SAILS_LOCALS &&
	          (window.SAILS_LOCALS._environment === 'staging' || window.SAILS_LOCALS._environment === 'production')
	        )
	      )? 'production' : 'development',
	
	      // The version of this sails.io.js client SDK
	      sdk: SDK_INFO,
	
	      // Transports to use when communicating with the server, in the order they will be tried
	      transports: ['websocket']
	    };
	
	
	
	    //  ┌─┐─┐ ┬┌┬┐┌─┐┌┐┌┌┬┐  ┬┌─┐ ┌─┐┌─┐┬┬  ┌─┐  ┌┬┐┌─┐┌─┐┌─┐┬ ┬┬ ┌┬┐┌─┐
	    //  ├┤ ┌┴┬┘ │ ├┤ │││ ││  ││ │ └─┐├─┤││  └─┐   ││├┤ ├┤ ├─┤│ ││  │ └─┐
	    //  └─┘┴ └─ ┴ └─┘┘└┘─┴┘  ┴└─┘o└─┘┴ ┴┴┴─┘└─┘  ─┴┘└─┘└  ┴ ┴└─┘┴─┘┴ └─┘
	    //  ┬ ┬┬┌┬┐┬ ┬  ┌┬┐┬ ┬┌─┐  ╦ ╦╔╦╗╔╦╗╦    ╔═╗╔╦╗╔╦╗╦═╗╦╔╗ ╦ ╦╔╦╗╔═╗╔═╗
	    //  ││││ │ ├─┤   │ ├─┤├┤   ╠═╣ ║ ║║║║    ╠═╣ ║  ║ ╠╦╝║╠╩╗║ ║ ║ ║╣ ╚═╗
	    //  └┴┘┴ ┴ ┴ ┴   ┴ ┴ ┴└─┘  ╩ ╩ ╩ ╩ ╩╩═╝  ╩ ╩ ╩  ╩ ╩╚═╩╚═╝╚═╝ ╩ ╚═╝╚═╝
	    //  ┌─┐┬─┐┌─┐┌┬┐  ┌┬┐┬ ┬┌─┐  ┌─┐┌─┐┬─┐┬┌─┐┌┬┐  ┌┬┐┌─┐┌─┐
	    //  ├┤ ├┬┘│ ││││   │ ├─┤├┤   └─┐│  ├┬┘│├─┘ │    │ ├─┤│ ┬
	    //  └  ┴└─└─┘┴ ┴   ┴ ┴ ┴└─┘  └─┘└─┘┴└─┴┴   ┴    ┴ ┴ ┴└─┘
	    //
	    // Now fold in config provided as HTML attributes on the script tag:
	    // (note that if `io.sails.*` is changed after this script, those changes
	    //  will still take precedence)
	    CONFIGURABLE_VIA_HTML_ATTR.forEach(function (configKey){
	      if (typeof scriptTagConfig[configKey] !== 'undefined') {
	        io.sails[configKey] = scriptTagConfig[configKey];
	      }
	    });
	    //////////////////////////////////////////////////////////////////////////////
	    // Note that the new HTML attribute configuration style may eventually
	    // completely replace the original approach of setting `io.sails` properties,
	    // since the new strategy is easier to reason about.  Also, it would allow us
	    // to remove the timeout below someday.
	    //////////////////////////////////////////////////////////////////////////////
	
	
	
	
	    //  ┬┌─┐ ┌─┐┌─┐┬┬  ┌─┐ ╔═╗╔═╗╔╗╔╔╗╔╔═╗╔═╗╔╦╗  /  \
	    //  ││ │ └─┐├─┤││  └─┐ ║  ║ ║║║║║║║║╣ ║   ║  /   /
	    //  ┴└─┘o└─┘┴ ┴┴┴─┘└─┘o╚═╝╚═╝╝╚╝╝╚╝╚═╝╚═╝ ╩  \  /
	
	    /**
	     * Add `io.sails.connect` function as a wrapper for the built-in `io()` aka `io.connect()`
	     * method, returning a SailsSocket. This special function respects the configured io.sails
	     * connection URL, as well as sending other identifying information (most importantly, the
	     * current version of this SDK).
	     *
	     * @param  {String} url  [optional]
	     * @param  {Object} opts [optional]
	     * @return {Socket}
	     */
	    io.sails.connect = function(url, opts) {
	
	      // Make URL optional
	      if ('object' === typeof url) {
	        opts = url;
	        url = null;
	      }
	
	      // Default opts to empty object
	      opts = opts || {};
	
	      // If explicit connection url is specified, save it to options
	      opts.url = url || opts.url || undefined;
	
	      // Instantiate and return a new SailsSocket- and try to connect immediately.
	      var socket = new SailsSocket(opts);
	      socket._connect();
	      return socket;
	    };
	
	
	
	
	
	
	    //  ██╗ ██████╗    ███████╗ ██████╗  ██████╗██╗  ██╗███████╗████████╗
	    //  ██║██╔═══██╗   ██╔════╝██╔═══██╗██╔════╝██║ ██╔╝██╔════╝╚══██╔══╝
	    //  ██║██║   ██║   ███████╗██║   ██║██║     █████╔╝ █████╗     ██║
	    //  ██║██║   ██║   ╚════██║██║   ██║██║     ██╔═██╗ ██╔══╝     ██║
	    //  ██║╚██████╔╝██╗███████║╚██████╔╝╚██████╗██║  ██╗███████╗   ██║
	    //  ╚═╝ ╚═════╝ ╚═╝╚══════╝ ╚═════╝  ╚═════╝╚═╝  ╚═╝╚══════╝   ╚═╝
	    //
	    // io.socket
	    //
	    // The eager instance of Socket which will automatically try to connect
	    // using the host that this js file was served from.
	    //
	    // This can be disabled or configured by setting properties on `io.sails.*` within the
	    // first cycle of the event loop.
	    //
	
	
	    // Build `io.socket` so it exists
	    // (note that this DOES NOT start the connection process)
	    io.socket = new SailsSocket();
	    //
	    // This socket is not connected yet, and has not even _started_ connecting.
	    //
	    // But in the mean time, this eager socket will be queue events bound by the user
	    // before the first cycle of the event loop (using `.on()`), which will later
	    // be rebound on the raw underlying socket.
	
	
	    //  ┌─┐┌─┐┌┬┐  ┌─┐┬ ┬┌┬┐┌─┐   ┌─┐┌─┐┌┐┌┌┐┌┌─┐┌─┐┌┬┐  ┌┬┐┬┌┬┐┌─┐┬─┐
	    //  └─┐├┤  │   ├─┤│ │ │ │ │───│  │ │││││││├┤ │   │    │ ││││├┤ ├┬┘
	    //  └─┘└─┘ ┴   ┴ ┴└─┘ ┴ └─┘   └─┘└─┘┘└┘┘└┘└─┘└─┘ ┴    ┴ ┴┴ ┴└─┘┴└─
	    // If configured to do so, start auto-connecting after the first cycle of the event loop
	    // has completed (to allow time for this behavior to be configured/disabled
	    // by specifying properties on `io.sails`)
	
	    // Indicate that the autoConnect timer has started.
	    io.socket._mightBeAboutToAutoConnect = true;
	
	    setTimeout(function() {
	
	      // Indicate that the autoConect timer fired.
	      io.socket._mightBeAboutToAutoConnect = false;
	
	      // If autoConnect is disabled, delete the eager socket (io.socket) and bail out.
	      if (io.sails.autoConnect === false || io.sails.autoconnect === false) {
	        delete io.socket;
	        return;
	      }
	
	      // consolog('Eagerly auto-connecting socket to Sails... (requests will be queued in the mean-time)');
	      io.socket._connect();
	
	
	    }, 0); // </setTimeout>
	
	
	    // Return the `io` object.
	    return io;
	  } //</SailsIOClient>
	
	  //
	  /////////////////////////////////////////////////////////////////////////////////
	  ///// </bunches of private function definitions, constructors, and methods>
	  /////////////////////////////////////////////////////////////////////////////////
	
	
	
	
	  //  ███████╗██╗  ██╗██████╗  ██████╗ ███████╗███████╗    ███████╗██████╗ ██╗  ██╗
	  //  ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔════╝██╔════╝    ██╔════╝██╔══██╗██║ ██╔╝
	  //  █████╗   ╚███╔╝ ██████╔╝██║   ██║███████╗█████╗      ███████╗██║  ██║█████╔╝
	  //  ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║╚════██║██╔══╝      ╚════██║██║  ██║██╔═██╗
	  //  ███████╗██╔╝ ██╗██║     ╚██████╔╝███████║███████╗    ███████║██████╔╝██║  ██╗
	  //  ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚══════╝╚══════╝    ╚══════╝╚═════╝ ╚═╝  ╚═╝
	  //
	
	
	  // Add CommonJS support to allow this client SDK to be used from Node.js.
	  if (SDK_INFO.platform === 'node') {
	    module.exports = SailsIOClient;
	  }
	  // Add AMD support, registering this client SDK as an anonymous module.
	  else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return SailsIOClient;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  else {
	    // Otherwise, try to instantiate the client using the global `io`:
	    SailsIOClient();
	
	    // Note:
	    // If you are modifying this file manually to wrap an existing socket.io client
	    // (e.g. to prevent pollution of the global namespace), you can replace the global
	    // `io` with your own `io` instance above.
	  }
	
	})();


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(770);
	var parser = __webpack_require__(142);
	var Manager = __webpack_require__(363);
	var debug = __webpack_require__(82)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(363);
	exports.Socket = __webpack_require__(365);


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(775)('socket.io-parser');
	var json = __webpack_require__(578);
	var Emitter = __webpack_require__(774);
	var binary = __webpack_require__(773);
	var isBuf = __webpack_require__(366);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(789);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(574);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)))

/***/ },
/* 144 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(373);

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	var settle = __webpack_require__(379);
	var buildURL = __webpack_require__(382);
	var parseHeaders = __webpack_require__(388);
	var isURLSameOrigin = __webpack_require__(386);
	var createError = __webpack_require__(149);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(381);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(384);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(378);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InfoBlockMiami = __webpack_require__(62);
	
	var _InfoBlockMiami2 = _interopRequireDefault(_InfoBlockMiami);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TestMin2 = function (_Component) {
	  _inherits(TestMin2, _Component);
	
	  function TestMin2(props) {
	    _classCallCheck(this, TestMin2);
	
	    var _this = _possibleConstructorReturn(this, (TestMin2.__proto__ || Object.getPrototypeOf(TestMin2)).call(this, props));
	
	    _this.state = {
	      test: 1
	    };
	    return _this;
	  }
	
	  _createClass(TestMin2, [{
	    key: 'render',
	    value: function render() {
	
	      var unit = this.props.screen.r9_16.p10;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 1000, width: 1000, backgroundColor: 'green', display: 'flex', alignItems: 'flex-start' } },
	        'Hey',
	        _react2.default.createElement(_InfoBlockMiami2.default, {
	          imgsrc: '/img/ui/default-user.png',
	          imageHeight: unit * 1,
	          infoHeight: unit * .5,
	          width: unit * 3,
	          unit: unit,
	          text: "Some text here",
	          infoColor: "red",
	          infoBackgroundColor: '#223954',
	          fontFamily: 'opensans-regular'
	        }),
	        _react2.default.createElement(_InfoBlockMiami2.default, {
	          imgsrc: '/img/ui/default-user.png' //{shared.dpath(this.props.mode, this.props.image.path, this.props.image.file_name, this.props.webkey)}
	          , imageHeight: unit * 1.5,
	          infoHeight: unit * 1,
	          width: unit * 3,
	          unit: unit,
	          text: "Some text here that is longer. Maybe goes on two lines I don't know. What about if it is too long well see.",
	          infoColor: "white",
	          infoBackgroundColor: '#223954',
	          fontFamily: 'opensans-regular'
	        })
	      );
	    }
	  }]);
	
	  return TestMin2;
	}(_react.Component);
	
	exports.default = TestMin2;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var donorStyle = {
	  fontSize: '1.5vh',
	  fontFamily: 'Lato',
	  color: "#000000",
	  opacity: 0,
	  position: "absolute",
	  paddingBottom: '4vh',
	  overflow: 'hidden'
	};
	
	var DenverDonorList = function (_Component) {
	  _inherits(DenverDonorList, _Component);
	
	  function DenverDonorList(props) {
	    _classCallCheck(this, DenverDonorList);
	
	    var _this = _possibleConstructorReturn(this, (DenverDonorList.__proto__ || Object.getPrototypeOf(DenverDonorList)).call(this, props));
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "c":
	          console.log("a c");
	          _this.cycleDonorIndex();
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.getCategoryStyle = function (category, field) {
	      var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      style.fontSize = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.fontSize', 3) + "vh";
	      style.fontStyle = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.fontStyle', "Normal").toLowerCase();
	      style.fontFamily = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.fontFamily', "Lato");
	      style.fontWeight = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.fontWeight', "100");
	      style.paddingBottom = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.height', 5) + "vh";
	      style.lineHeight = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.lineHeight', 3.5) + "vh";
	      style.textAlign = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.justification', 'left').toLowerCase();
	      style.fontColor = _lodash2.default.get(category, 'contents.custom_fields.' + field + '.fontColor', '#000000').toLowerCase();
	
	      return style;
	    };
	
	    _this.preRenderDonors = function () {
	      var flatDonors = [];
	      _this._donorCategories.map(function (category) {
	        var columns = _lodash2.default.get(category, 'contents.custom_fields.columns.val', 3);
	        var columnWidth = _this.props.listWidth / columns;
	        category.donors.map(function (donor) {
	          var donorStyleCopy = _lodash2.default.cloneDeep(donorStyle);
	          donorStyleCopy.opacity = 0;
	          donor.style = _this.getCategoryStyle(category, "donor_name_style", donorStyleCopy);
	          donor.style.width = columnWidth * .9;
	          flatDonors.push(donor);
	          return null;
	        });
	        return null;
	      });
	      return flatDonors.map(function (donor, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, ref: function ref(el) {
	              return _this._donorRefs[i] = el;
	            }, style: Object.assign({}, donor.style) },
	          _react2.default.createElement(_BRSpan2.default, { str: donor.name })
	        );
	      });
	    };
	
	    _this.getAllDonorsHeight = function () {
	      console.log('this._donorCategories', _this._donorCategories);
	    };
	
	    _this.startCycle = function () {
	      var donorCategory = _this._donorCategories[_this._categoryIndex];
	      var timeout = _lodash2.default.get(donorCategory, 'contents.custom_fields.cycle_timeout.val', 10);
	      clearTimeout(_this._donorCycleIntervalHandler);
	      _this._donorCycleIntervalHandler = setTimeout(function () {
	        _this.cycleDonorIndex();
	        _this.startCycle();
	      }, timeout * 1000);
	    };
	
	    _this.cycleDonorIndex = function () {
	      if (_this._donorIndex + _this._lastPageCount >= _this._donorCategories[_this._categoryIndex].donors.length) {
	        _this._donorIndex = 0;
	        _this._categoryIndex++;
	        if (_this._categoryIndex >= _this._donorCategories.length) {
	          if (_this.props.allCategoriesLooped) {
	            _this.props.allCategoriesLooped();
	          }
	          _this._categoryIndex = 0;
	        }
	      } else {
	        _this._donorIndex += _this._lastPageCount;
	      }
	
	      var cat = _this._donorCategories[_this._categoryIndex];
	      var mainHeader = _lodash2.default.get(cat, 'contents.custom_fields.main_header.val', '');
	      var subcategoryName = _lodash2.default.get(cat, 'contents.custom_fields.subcategory_name.val', '');
	      var fontSize = _lodash2.default.get(cat, 'contents.custom_fields.font_size.val.value');
	
	      // const subheadOps = _.get(cat, 'contents.custom_fields.subhead.val.ops');
	      // const subheadOpsInstance = new QuillDeltaToHtmlConverter(subheadOps, {});
	      // const subheadOpsRichText = subheadOpsInstance.convert();
	      var description = _lodash2.default.get(cat, 'contents.custom_fields.subhead_text.val', "");
	      _this.setState({
	        donorData: {
	          name: name,
	          mainHeader: mainHeader,
	          subcategoryName: subcategoryName,
	          description: description,
	          fontSize: fontSize
	        }
	      });
	    };
	
	    _this.renderNames = function () {
	      var category = _this._donorCategories[_this._categoryIndex];
	      var columns = _lodash2.default.get(category, 'contents.custom_fields.columns.val', 3);
	      var currentHeight = 0;
	      var currentColumn = 1;
	      var drawDonors = [];
	      var columnWidth = _this._container.width / columns;
	      _this._lastPageCount = 0;
	
	      for (var a = _this._donorIndex; a < _this._donorCategories[_this._categoryIndex].donors.length; a++) {
	        var donor = _this._donorCategories[_this._categoryIndex].donors[a];
	        //fits in column
	        if (currentHeight + donor.height > _this._container.height) {
	          if (currentColumn < columns) {
	            //reset for new column
	            currentHeight = 0;
	            currentColumn++;
	          } else {
	            break;
	          }
	        }
	
	        donor.top = currentHeight;
	        donor.column = currentColumn;
	        currentHeight += donor.height;
	        drawDonors.push(donor);
	        _this._lastPageCount++;
	      }
	
	      var clonedDonorStyle = _lodash2.default.cloneDeep(donorStyle);
	      clonedDonorStyle = _this.getCategoryStyle(category, 'donor_name_style', clonedDonorStyle);
	
	      return drawDonors.map(function (item, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: Object.assign({}, clonedDonorStyle, { maxWidth: columnWidth, top: item.top, left: (item.column - 1) * columnWidth, opacity: 1, width: columnWidth * .9 }) },
	          _react2.default.createElement(_BRSpan2.default, { str: item.name }),
	          _react2.default.createElement('br', null)
	        );
	      });
	    };
	
	    _this.state = {
	      donorData: {
	        donors: [],
	        name: '',
	        categoryName: '',
	        description: '',
	        cycleIndex: 0
	      },
	      timestamp: null,
	      finishedPreRender: false
	    };
	
	    _this._donorCycleIntervalHandler = null;
	
	    _this._donorCategories = _lodash2.default.cloneDeep(_this.props.donorCategories);
	    _this._donorRefs = [];
	    _this._containerRef = null;
	    _this._underlineRef = null;
	    _this._container = {
	      height: 0,
	      width: 0
	
	      // this._donorListCycleSeconds = 0;
	    };_this._donorIndex = 0;
	    _this._categoryIndex = 0;
	    _this._lastPageCount = 0;
	
	    // this._endOfDonorLoop = true;
	
	    // this._donorCols = 2;
	    // this._donorRows = 6;
	    // this._verticalSpace = 1;
	    // this._horizontalSpace = 1;
	
	    // this._donors = [];
	
	    return _this;
	  }
	
	  _createClass(DenverDonorList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      try {
	        document.addEventListener("keydown", this.handleKeyDown);
	        setTimeout(function () {
	          // console.log("timeout done");
	          // console.log("this._donorRefs.length", this._donorRefs.length);
	          // console.log("this.state.finishedPreRender", this.state.finishedPreRender);
	          //calls after one full render
	          if (_this2._donorRefs.length > 0 && _this2.state.finishedPreRender === false) {
	            var counter = -1;
	            _this2._donorCategories.map(function (cat) {
	              cat.donors.map(function (donor) {
	                counter++;
	                donor.height = _this2._donorRefs[counter].offsetHeight;
	                donor.width = _this2._donorRefs[counter].offsetWidth;
	                return null;
	              });
	              return null;
	            });
	
	            _this2._container = {
	              width: _this2._containerRef.offsetWidth,
	              height: _this2._containerRef.offsetHeight
	              // console.log("refs", this._donorRefs);
	              // console.log("this._donorCategories", this._donorCategories);
	              // console.log("this._container", this._container);
	
	            };_this2.setState({
	              finishedPreRender: true
	            });
	          }
	
	          var cat = _this2._donorCategories[_this2._categoryIndex];
	          var mainHeader = _lodash2.default.get(cat, 'contents.custom_fields.main_header.val', '');
	          var subcategoryName = _lodash2.default.get(cat, 'contents.custom_fields.subcategory_name.val', '');
	          var fontSize = _lodash2.default.get(cat, 'contents.custom_fields.font_size.val.value');
	          var description = _lodash2.default.get(cat, 'contents.custom_fields.subhead_text.val', "");
	
	          // const subheadOps = _.get(cat, 'contents.custom_fields.subhead.val.ops');
	          // const subheadOpsInstance = new QuillDeltaToHtmlConverter(subheadOps, {});
	          // const subheadOpsRichText = subheadOpsInstance.convert();
	          _this2.setState({
	            donorData: {
	              name: name,
	              mainHeader: mainHeader,
	              subcategoryName: subcategoryName,
	              description: description,
	              fontSize: fontSize
	            }
	          });
	
	          _this2.startCycle();
	        }, 1000);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._donorCycleIntervalHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var sDims = {
	        height: this.props.height,
	        width: this.props.width
	      };
	      sDims.fsTitle = sDims.height * this.props.fsTitleModifier || 0.045;
	      sDims.fsTitleSub = sDims.height * 0.0275;
	      if (this.props.content.settings.custom_vars) {
	        if (this.props.content.settings.custom_vars.ParentGroupFontSize) {
	          sDims.fsTitle = sDims.height * this.props.content.settings.custom_vars.ParentGroupFontSize * .01;
	        }
	        if (this.props.content.settings.custom_vars.GroupFontSize) {
	          sDims.fsTitleSub = sDims.height * this.props.content.settings.custom_vars.GroupFontSize * .01;
	        }
	      }
	
	      sDims.fsSubheader = sDims.height * this.props.fsSubheaderModifier;
	
	      var customFsNames = this.state.donorData.fontSize && !isNaN(this.state.donorData.fontSize) ? this.state.donorData.fontSize : 20;
	
	      sDims.fsNames = customFsNames / this.props.targetHeight * sDims.height;
	
	      sDims.yOffsetTitle = sDims.height * this.props.yOffsetTitleModifier;
	      sDims.yOffsetSubheader = sDims.height * this.props.yOffsetSubheaderModifier;
	      sDims.yOffsetSubheaderUnderline = sDims.height * this.props.yOffsetSubheaderUnderlineModifier;
	      sDims.yOffsetNames = sDims.height * this.props.yOffsetNamesModifier;
	      // return null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'denver-donor-list', style: { position: "absolute", width: this.props.width, height: this.props.height, left: this.props.left } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: 'header-' + this._categoryIndex },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this.props.style, { top: sDims.yOffsetTitle, width: this.props.width * .9, height: this.props.height * .05 }) },
	              this.state.donorData && this.state.donorData.mainHeader ? _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontFamily: 'Lato Bold', width: this.props.titleWidthModifier * this.props.width, letterSpacing: '2.2px', fontSize: sDims.fsTitle } },
	                  this.state.donorData.mainHeader
	                ),
	                this.props.hideDonorListName ? '' : _react2.default.createElement(
	                  'span',
	                  { style: { marginLeft: '1.75vw', letterSpacing: '1.7px', fontWeight: 'bold', fontSize: sDims.fsTitleSub } },
	                  " " + this.state.donorData.subcategoryName
	                )
	              ) : _react2.default.createElement('span', null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: 'description-' + this.state.donorData.cycleIndex, style: { position: "absolute", top: sDims.yOffsetSubheader } },
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-donor-list__description-container', style: Object.assign({}, this.props.style, { fontSize: sDims.fsSubheader, opacity: 1, width: this.props.width * this.props.descriptionWidthModifier /* * .75*/, maxHeight: this.props.height * .1, lineHeight: 1.5, position: "relative", marginBottom: "1.38vh", overflow: "hidden", height: "auto" }) },
	              this.state.donorData.description ? _react2.default.createElement(
	                'span',
	                { style: { fontSize: this.props.subHeaderFontSize, fontFamily: "Lato" } },
	                this.state.donorData.description
	              ) : _react2.default.createElement('span', null)
	            ),
	            _react2.default.createElement('div', { style: Object.assign({}, this.props.style, { backgroundColor: 'black', opacity: 1, width: this.props.width * this.props.subheaderUnderlineWidthModifier, height: '1px', position: "relative" }) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(el) {
	              return _this3._containerRef = el;
	            }, style: Object.assign({}, this.props.style, { zIndex: 100, top: this.props.listTopOffset, opacity: 1, height: this.props.listHeight, width: this.props.listWidth }) },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfade',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            this.state.finishedPreRender ? _react2.default.createElement(
	              'div',
	              { key: "donor-index" + this._donorIndex + "-category-index-" + this._categoryIndex },
	              this.renderNames()
	            ) : this.preRenderDonors()
	          )
	        )
	      );
	    }
	  }]);
	
	  return DenverDonorList;
	}(_react.Component);
	
	exports.default = DenverDonorList;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(97);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DenverSlideshow = function (_Component) {
	  _inherits(DenverSlideshow, _Component);
	
	  function DenverSlideshow(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, DenverSlideshow);
	
	    var _this = _possibleConstructorReturn(this, (DenverSlideshow.__proto__ || Object.getPrototypeOf(DenverSlideshow)).call(this, props));
	
	    _this.timedCycle = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(_this.props.images.length <= 1)) {
	                _context.next = 2;
	                break;
	              }
	
	              return _context.abrupt('return', null);
	
	            case 2:
	              _this._slideshowCycleSeconds--;
	
	              if (!(_this._slideshowCycleSeconds < 1)) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 6;
	              return _this.cycleSlideshowIndex();
	
	            case 6:
	              _this._slideshowCycleSeconds = _this.getCycleTime();
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getCycleTime = function () {
	      return _this.props.cycleOverrides[_this.state.slideshowIndex] || _this.props.defaultCycleTime;
	    };
	
	    _this.cycleSlideshowIndex = function () {
	      return new Promise(function (resolve, reject) {
	        _this.setState(function (prevState) {
	          var slideshowIndex = 0;
	          if (prevState.slideshowIndex < _this.props.images.length - 1) {
	            slideshowIndex = prevState.slideshowIndex + 1;
	          }
	          return { slideshowIndex: slideshowIndex };
	        }, resolve);
	      });
	    };
	
	    _this.state = {
	      slideshowIndex: 0
	    };
	    _this._slideshowCycleSeconds = 0;
	    return _this;
	  }
	
	  _createClass(DenverSlideshow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._slideshowCycleSeconds = this.getCycleTime();
	    }
	
	    // Get the cycle time *for the current image*
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var slideshowImage = this.props.images[this.state.slideshowIndex];
	      var backgroundImage = 'none';
	      if (slideshowImage) {
	        var dpImage = (0, _shared.dp)(this.props.screen, slideshowImage, { path: '/img/ui/', file_name: 'image_default.png' });
	        backgroundImage = 'url(' + dpImage + ')';
	      }
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: 'div',
	          transitionName: 'slowfadedelay',
	          transitionEnterTimeout: 0,
	          transitionLeaveTimeout: 0 },
	        _react2.default.createElement(
	          'div',
	          { key: this.props.images[this.state.slideshowIndex] },
	          _react2.default.createElement('div', { style: { left: this.props.screenOffset, backgroundImage: backgroundImage, backgroundSize: 'cover', position: 'absolute', height: this.props.height, width: this.props.width, top: 0 } })
	        )
	      );
	    }
	  }]);
	
	  return DenverSlideshow;
	}(_react.Component);
	
	exports.default = DenverSlideshow;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavButtonMiami = function (_Component) {
	  _inherits(NavButtonMiami, _Component);
	
	  function NavButtonMiami() {
	    _classCallCheck(this, NavButtonMiami);
	
	    return _possibleConstructorReturn(this, (NavButtonMiami.__proto__ || Object.getPrototypeOf(NavButtonMiami)).apply(this, arguments));
	  }
	
	  _createClass(NavButtonMiami, [{
	    key: 'render',
	
	
	    // constructor(props) {
	    //   super(props);
	    // }
	
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.mode === "video" ? _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.unit * .5, left: this.props.left, right: this.props.right } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.children
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.unit * .15, borderBottomRightRadius: this.props.unit * .15 } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavButtonMiami;
	}(_react.Component);
	
	exports.default = NavButtonMiami;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowButtonMiami = function (_Component) {
		_inherits(RowButtonMiami, _Component);
	
		function RowButtonMiami(props) {
			_classCallCheck(this, RowButtonMiami);
	
			var _this = _possibleConstructorReturn(this, (RowButtonMiami.__proto__ || Object.getPrototypeOf(RowButtonMiami)).call(this, props));
	
			_this._buttonRef = null;
			return _this;
		}
	
		_createClass(RowButtonMiami, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				var _this2 = this;
	
				if (this._buttonRef && typeof this.props.buttonEvent === "function") {
					this._buttonRef.addEventListener("tap", function () {
						return _this2.props.buttonEvent();
					});
				}
			}
		}, {
			key: "render",
			value: function render() {
				var _this3 = this;
	
				return _react2.default.createElement(
					"div",
					{ onClick: this.props.onClick, style: { marginTop: '3.9375vh', marginBottom: '2.8125vh', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch' } },
					_react2.default.createElement(
						"div",
						{ style: { fontSize: '2.1875vh', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-bold", color: '#ffffff', width: '84.375vh' } },
						this.props.header,
						_react2.default.createElement("br", null),
						_react2.default.createElement(
							"span",
							{ style: { fontSize: '1.2375vh', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' } },
							this.props.message
						)
					),
					_react2.default.createElement(
						"div",
						{ style: { textAlign: 'right', width: '100%' } },
						_react2.default.createElement("img", { ref: function ref(el) {
								return _this3._buttonRef = el;
							}, alt: "Story", src: this.props.button, style: { width: '12.9375vh' } })
					)
				);
			}
		}]);
	
		return RowButtonMiami;
	}(_react.Component);
	
	exports.default = RowButtonMiami;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _quillDeltaToHtml = __webpack_require__(16);
	
	var _quillDeltaToHtml2 = _interopRequireDefault(_quillDeltaToHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	
	  var opsInstance = new _quillDeltaToHtml2.default(props.ops, {});
	  var opsRichText = opsInstance.convert();
	  return _react2.default.createElement('div', { className: 'ql-editor horizontal-screen-any', dangerouslySetInnerHTML: { __html: opsRichText } });
	};

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var slideWidth = exports.slideWidth = '23vw';
	var slideEdgePadding = exports.slideEdgePadding = '15.5vw';

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyboardKey = function (_Component) {
	    _inherits(KeyboardKey, _Component);
	
	    function KeyboardKey(props) {
	        _classCallCheck(this, KeyboardKey);
	
	        var _this = _possibleConstructorReturn(this, (KeyboardKey.__proto__ || Object.getPrototypeOf(KeyboardKey)).call(this, props));
	
	        _this.state = {
	            pressed: false,
	            canpress: true
	        };
	
	        return _this;
	    }
	
	    _createClass(KeyboardKey, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeout) {
	                clearTimeout(this.timeout);
	                this.timeout = null;
	            }
	        }
	    }, {
	        key: 'handlePress',
	        value: function handlePress() {
	            var _this2 = this;
	
	            if (this.state.canpress === true) {
	                this.props.handleKeyPress(this.props.keyval[this.props.virtual_keyboard_mode]);
	                this.setState({
	                    pressed: true,
	                    canpress: false
	                });
	                this.timeout = setTimeout(function () {
	                    _this2.setState({
	                        pressed: false,
	                        canpress: true
	                    });
	                    _this2.timeout = null;
	                }, 125);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var classes = "pressin keyopacity";
	            if (this.state.pressed === true) {
	                classes += " active";
	            }
	            if (this.props.contents[this.props.virtual_keyboard_mode] === null) {
	                classes += " keyhide";
	                return (
	                    // <div style={{display: 'hidden'}}><div style={this.props.mainstyle[1]} className={classes}><span className="kspn">&nbsp;</span></div></div>
	                    _react2.default.createElement(
	                        'div',
	                        { style: this.props.mainstyle, className: classes },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'kspn' },
	                            '\xA0'
	                        )
	                    )
	                );
	            }
	            classes += " phand";
	            var innercontent = void 0;
	            switch (this.props.contents[this.props.virtual_keyboard_mode]) {
	                case "UPCASE":
	                    innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-o-up' }); //<Icon type="up-circle-o" />
	                    break;
	                case "DOWNCASE":
	                    innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-o-down' }); //<Icon type="down-circle-o" />
	                    break;
	                case "DELETE":
	                    innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-o-left' }); //<Icon type="left" />
	                    break;
	                default:
	                    innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	                    break;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { onMouseDown: function onMouseDown(e) {
	                        return _this3.handlePress(e);
	                    }, style: this.props.mainstyle, className: classes },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'kspn' },
	                    innercontent
	                )
	            );
	        }
	    }]);
	
	    return KeyboardKey;
	}(_react.Component);
	
	exports.default = KeyboardKey;

/***/ },
/* 159 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.percent1080pixel = percent1080pixel;
	exports.bestFitOld = bestFitOld;
	exports.bestFit = bestFit;
	//import logger from './logger';
	
	function percent1080pixel(actual, pixels) {
	    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "height";
	
	    switch (type) {
	        case "width":
	            var wPercent = pixels / 1920;
	            return wPercent * actual;
	        case "height":
	            var hPercent = pixels / 1080;
	            return hPercent * actual;
	        default:
	            window.logger.warning("percent1080p type must be width or height", {});
	    }
	}
	
	function bestFitOld(ratio, w_max, h_max) {
	    var mxW = { width: w_max, height: w_max / ratio };
	    var mxH = { width: h_max * ratio, height: h_max };
	    if (mxW.w * mxW.h < mxH.w * mxW.h) {
	        return mxW;
	    } else {
	        return mxH;
	    }
	}
	
	function bestFit(ratio_w, ratio_h, container_width, container_height) {
	
	    var width_compare = container_width / ratio_w;
	    var height_compare = container_height / ratio_h;
	
	    var width = container_width;
	    var height = container_height;
	
	    if (width_compare < height_compare) {
	        height = width * (ratio_h / ratio_w);
	    } else {
	        width = height * (ratio_w / ratio_h);
	    }
	    return { width: width, height: height };
	}

/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var emptyObject = __webpack_require__(69);
	var _invariant = __webpack_require__(7);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(99);
	var XHR = __webpack_require__(539);
	var JSONP = __webpack_require__(538);
	var websocket = __webpack_require__(540);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(98);
	var parseqs = __webpack_require__(108);
	var parser = __webpack_require__(40);
	var inherit = __webpack_require__(67);
	var yeast = __webpack_require__(367);
	var debug = __webpack_require__(68)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(99);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/back.68625d1d.svg";

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/close.93a24585.svg";

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/forward.699765ee.svg";

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(568);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 173 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 174 */
/***/ function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 175 */
/***/ function(module, exports) {

	module.exports = {
		"name": "pdgclient",
		"version": "0.1.26",
		"private": true,
		"jest": {
			"collectCoverage": true
		},
		"dependencies": {
			"archiver": "^1.3.0",
			"axios": "^0.18.0",
			"eslint-plugin-flowtype": "^2.49.3",
			"eslint-plugin-import": "^2.12.0",
			"eslint-plugin-jsx-a11y": "^2.2.3",
			"eslint-plugin-react": "^6.10.3",
			"fuse.js": "^3.0.5",
			"install": "^0.10.1",
			"intercept-stdout": "^0.1.2",
			"iscroll": "^5.2.0",
			"jquery": "^3.3.1",
			"md5-file": "^3.2.3",
			"moment": "^2.22.1",
			"node-sass": "^4.11.0",
			"npm": "^4.5.0",
			"prop-types": "^15.6.1",
			"quill-delta-to-html": "^0.9.6",
			"react": "^15.6.1",
			"react-dom": "^15.6.1",
			"react-fontawesome": "^1.6.1",
			"react-icons": "^2.2.5",
			"react-iscroll": "^1.1.4",
			"react-lazyload": "^2.3.0",
			"react-moment": "^0.7.0",
			"react-player": "^1.5.0",
			"react-redux": "^5.0.5",
			"react-router": "^4.1.1",
			"react-router-dom": "^4.1.1",
			"react-slick": "^0.14.11",
			"react-transition-group": "^1.1.3",
			"redux": "^3.7.2",
			"redux-thunk": "^2.2.0",
			"rimraf": "^2.6.2",
			"sails.io.js": "^1.1.13",
			"serve": "^5.2.2",
			"signale": "^1.2.1",
			"simple-git": "^1.95.0",
			"socket.io-client": "^1.7.4",
			"source-map": "^0.6.1",
			"superagent": "^3.5.2",
			"video-react": "^0.8.6",
			"whatwg-fetch": "^2.0.3",
			"winston": "^2.4.0",
			"winston-papertrail": "^1.0.5",
			"electron": "^4.1.4"
		},
		"devDependencies": {
			"enzyme": "^3.3.0",
			"enzyme-adapter-react-15": "^1.0.5",
			"react-scripts": "0.9.5",
			"react-test-renderer": "^15.6.1"
		},
		"main": "src/electronHandler.js",
		"scripts": {
			"dev-server": "react-scripts start",
			"build": "node ./scripts/removeSymlinks.js && react-scripts build && node ./scripts/createSymlinks.js",
			"test": "react-scripts test --env=jsdom --coverage --colors",
			"eject": "react-scripts eject",
			"start": "./node_modules/.bin/serve -s build -c 3500 -p 3002 &",
			"get-data": " node scripts/updateFiles.js -- isnpm -- md5",
			"get-data-force": " node scripts/updateFiles.js -- isnpm -- md5 -- clearjson",
			"get-data-only": " node scripts/updateFiles.js -- isnpm -- skipfiles -- clearjson",
			"setup-project": "node scripts/setupProject.js",
			"electron": "electron .",
			"watch-sass": "./node_modules/.bin/node-sass --watch src/style/scss --output src/style"
		}
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(586),
	    getValue = __webpack_require__(593);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(103),
	    getPrototype = __webpack_require__(591),
	    isObjectLike = __webpack_require__(178);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(624)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(627);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var value_types_1 = __webpack_require__(42);
	var InsertData_1 = __webpack_require__(309);
	var DeltaInsertOp = (function () {
	    function DeltaInsertOp(insertVal, attributes) {
	        if (typeof insertVal === 'string') {
	            insertVal = new InsertData_1.InsertDataQuill(value_types_1.DataType.Text, insertVal + '');
	        }
	        this.insert = insertVal;
	        this.attributes = attributes || {};
	    }
	    DeltaInsertOp.createNewLineOp = function () {
	        return new DeltaInsertOp(value_types_1.NewLine);
	    };
	    DeltaInsertOp.prototype.isContainerBlock = function () {
	        var attrs = this.attributes;
	        return !!(attrs.blockquote || attrs.list || attrs['code-block'] ||
	            attrs.header || attrs.align || attrs.direction || attrs.indent);
	    };
	    DeltaInsertOp.prototype.isBlockquote = function () {
	        return !!this.attributes.blockquote;
	    };
	    DeltaInsertOp.prototype.isHeader = function () {
	        return !!this.attributes.header;
	    };
	    DeltaInsertOp.prototype.isSameHeaderAs = function (op) {
	        return op.attributes.header === this.attributes.header && this.isHeader();
	    };
	    DeltaInsertOp.prototype.hasSameAdiAs = function (op) {
	        return this.attributes.align === op.attributes.align
	            && this.attributes.direction === op.attributes.direction
	            && this.attributes.indent === op.attributes.indent;
	    };
	    DeltaInsertOp.prototype.hasSameIndentationAs = function (op) {
	        return this.attributes.indent === op.attributes.indent;
	    };
	    DeltaInsertOp.prototype.hasHigherIndentThan = function (op) {
	        return (Number(this.attributes.indent) || 0) > (Number(op.attributes.indent) || 0);
	    };
	    DeltaInsertOp.prototype.isInline = function () {
	        return !(this.isContainerBlock() || this.isVideo());
	    };
	    DeltaInsertOp.prototype.isCodeBlock = function () {
	        return !!this.attributes['code-block'];
	    };
	    DeltaInsertOp.prototype.isJustNewline = function () {
	        return this.insert.value === value_types_1.NewLine;
	    };
	    DeltaInsertOp.prototype.isList = function () {
	        return (this.isOrderedList() ||
	            this.isBulletList() ||
	            this.isCheckedList() ||
	            this.isUncheckedList());
	    };
	    DeltaInsertOp.prototype.isOrderedList = function () {
	        return this.attributes.list === value_types_1.ListType.Ordered;
	    };
	    DeltaInsertOp.prototype.isBulletList = function () {
	        return this.attributes.list === value_types_1.ListType.Bullet;
	    };
	    DeltaInsertOp.prototype.isCheckedList = function () {
	        return this.attributes.list === value_types_1.ListType.Checked;
	    };
	    DeltaInsertOp.prototype.isUncheckedList = function () {
	        return this.attributes.list === value_types_1.ListType.Unchecked;
	    };
	    DeltaInsertOp.prototype.isACheckList = function () {
	        return this.attributes.list == value_types_1.ListType.Unchecked ||
	            this.attributes.list === value_types_1.ListType.Checked;
	    };
	    DeltaInsertOp.prototype.isSameListAs = function (op) {
	        return !!op.attributes.list && (this.attributes.list === op.attributes.list ||
	            op.isACheckList() && this.isACheckList());
	    };
	    DeltaInsertOp.prototype.isText = function () {
	        return this.insert.type === value_types_1.DataType.Text;
	    };
	    DeltaInsertOp.prototype.isImage = function () {
	        return this.insert.type === value_types_1.DataType.Image;
	    };
	    DeltaInsertOp.prototype.isFormula = function () {
	        return this.insert.type === value_types_1.DataType.Formula;
	    };
	    DeltaInsertOp.prototype.isVideo = function () {
	        return this.insert.type === value_types_1.DataType.Video;
	    };
	    DeltaInsertOp.prototype.isLink = function () {
	        return this.isText() && !!this.attributes.link;
	    };
	    DeltaInsertOp.prototype.isCustom = function () {
	        return this.insert instanceof InsertData_1.InsertDataCustom;
	    };
	    DeltaInsertOp.prototype.isMentions = function () {
	        return this.isText() && !!this.attributes.mentions;
	    };
	    return DeltaInsertOp;
	}());
	exports.DeltaInsertOp = DeltaInsertOp;


/***/ },
/* 309 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InsertDataQuill = (function () {
	    function InsertDataQuill(type, value) {
	        this.type = type;
	        this.value = value;
	    }
	    return InsertDataQuill;
	}());
	exports.InsertDataQuill = InsertDataQuill;
	;
	var InsertDataCustom = (function () {
	    function InsertDataCustom(type, value) {
	        this.type = type;
	        this.value = value;
	    }
	    return InsertDataCustom;
	}());
	exports.InsertDataCustom = InsertDataCustom;
	;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var value_types_1 = __webpack_require__(42);
	var MentionSanitizer_1 = __webpack_require__(635);
	var url = __webpack_require__(112);
	var OpAttributeSanitizer = (function () {
	    function OpAttributeSanitizer() {
	    }
	    OpAttributeSanitizer.sanitize = function (dirtyAttrs) {
	        var cleanAttrs = {};
	        if (!dirtyAttrs || typeof dirtyAttrs !== 'object') {
	            return cleanAttrs;
	        }
	        var booleanAttrs = [
	            'bold', 'italic', 'underline', 'strike', 'code',
	            'blockquote', 'code-block'
	        ];
	        var colorAttrs = ['background', 'color'];
	        var font = dirtyAttrs.font, size = dirtyAttrs.size, link = dirtyAttrs.link, script = dirtyAttrs.script, list = dirtyAttrs.list, header = dirtyAttrs.header, align = dirtyAttrs.align, direction = dirtyAttrs.direction, indent = dirtyAttrs.indent, mentions = dirtyAttrs.mentions, mention = dirtyAttrs.mention, width = dirtyAttrs.width, target = dirtyAttrs.target;
	        var sanitizedAttrs = booleanAttrs.concat(colorAttrs, ['font', 'size', 'link', 'script', 'list', 'header', 'align',
	            'direction', 'indent', 'mentions', 'mention', 'width']);
	        booleanAttrs.forEach(function (prop) {
	            var v = dirtyAttrs[prop];
	            if (v) {
	                cleanAttrs[prop] = !!v;
	            }
	        });
	        colorAttrs.forEach(function (prop) {
	            var val = dirtyAttrs[prop];
	            if (val && (OpAttributeSanitizer.IsValidHexColor(val + '') ||
	                OpAttributeSanitizer.IsValidColorLiteral(val + ''))) {
	                cleanAttrs[prop] = val;
	            }
	        });
	        if (font && OpAttributeSanitizer.IsValidFontName(font + '')) {
	            cleanAttrs.font = font;
	        }
	        if (size && OpAttributeSanitizer.IsValidSize(size + '')) {
	            cleanAttrs.size = size;
	        }
	        if (width && OpAttributeSanitizer.IsValidWidth(width + '')) {
	            cleanAttrs.width = width;
	        }
	        if (link) {
	            cleanAttrs.link = url.sanitize(link + '');
	        }
	        if (target && OpAttributeSanitizer.isValidTarget(target)) {
	            cleanAttrs.target = target;
	        }
	        if (script === value_types_1.ScriptType.Sub || value_types_1.ScriptType.Super === script) {
	            cleanAttrs.script = script;
	        }
	        if (list === value_types_1.ListType.Bullet || list === value_types_1.ListType.Ordered || list === value_types_1.ListType.Checked || list === value_types_1.ListType.Unchecked) {
	            cleanAttrs.list = list;
	        }
	        if (Number(header)) {
	            cleanAttrs.header = Math.min(Number(header), 6);
	        }
	        if (align === value_types_1.AlignType.Center || align === value_types_1.AlignType.Right || align === value_types_1.AlignType.Justify) {
	            cleanAttrs.align = align;
	        }
	        if (direction === value_types_1.DirectionType.Rtl) {
	            cleanAttrs.direction = direction;
	        }
	        if (indent && Number(indent)) {
	            cleanAttrs.indent = Math.min(Number(indent), 30);
	        }
	        if (mentions && mention) {
	            var sanitizedMention = MentionSanitizer_1.MentionSanitizer.sanitize(mention);
	            if (Object.keys(sanitizedMention).length > 0) {
	                cleanAttrs.mentions = !!mentions;
	                cleanAttrs.mention = mention;
	            }
	        }
	        return Object.keys(dirtyAttrs).reduce(function (cleaned, k) {
	            if (sanitizedAttrs.indexOf(k) === -1) {
	                cleaned[k] = dirtyAttrs[k];
	            }
	            ;
	            return cleaned;
	        }, cleanAttrs);
	    };
	    OpAttributeSanitizer.IsValidHexColor = function (colorStr) {
	        return !!colorStr.match(/^#([0-9A-F]{6}|[0-9A-F]{3})$/i);
	    };
	    OpAttributeSanitizer.IsValidColorLiteral = function (colorStr) {
	        return !!colorStr.match(/^[a-z]{1,50}$/i);
	    };
	    OpAttributeSanitizer.IsValidFontName = function (fontName) {
	        return !!fontName.match(/^[a-z\s0-9\- ]{1,30}$/i);
	    };
	    OpAttributeSanitizer.IsValidSize = function (size) {
	        return !!size.match(/^[a-z0-9\-]{1,20}$/i);
	    };
	    OpAttributeSanitizer.IsValidWidth = function (width) {
	        return !!width.match(/^[0-9]*(px|em|%)?$/);
	    };
	    OpAttributeSanitizer.isValidTarget = function (target) {
	        return !!target.match(/^[_a-zA-Z0-9\-]{1,50}$/);
	    };
	    return OpAttributeSanitizer;
	}());
	exports.OpAttributeSanitizer = OpAttributeSanitizer;


/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EncodeTarget;
	(function (EncodeTarget) {
	    EncodeTarget[EncodeTarget["Html"] = 0] = "Html";
	    EncodeTarget[EncodeTarget["Url"] = 1] = "Url";
	})(EncodeTarget || (EncodeTarget = {}));
	function makeStartTag(tag, attrs) {
	    if (attrs === void 0) { attrs = undefined; }
	    if (!tag) {
	        return '';
	    }
	    var attrsStr = '';
	    if (attrs) {
	        var arrAttrs = [].concat(attrs);
	        attrsStr = arrAttrs.map(function (attr) {
	            return attr.key + (attr.value ? '="' + attr.value + '"' : '');
	        }).join(' ');
	    }
	    var closing = '>';
	    if (tag === 'img' || tag === 'br') {
	        closing = '/>';
	    }
	    return attrsStr ? "<" + tag + " " + attrsStr + closing : "<" + tag + closing;
	}
	exports.makeStartTag = makeStartTag;
	function makeEndTag(tag) {
	    if (tag === void 0) { tag = ''; }
	    return tag && "</" + tag + ">" || '';
	}
	exports.makeEndTag = makeEndTag;
	function decodeHtml(str) {
	    return encodeMappings(EncodeTarget.Html).reduce(decodeMapping, str);
	}
	exports.decodeHtml = decodeHtml;
	function encodeHtml(str, preventDoubleEncoding) {
	    if (preventDoubleEncoding === void 0) { preventDoubleEncoding = true; }
	    if (preventDoubleEncoding) {
	        str = decodeHtml(str);
	    }
	    return encodeMappings(EncodeTarget.Html).reduce(encodeMapping, str);
	}
	exports.encodeHtml = encodeHtml;
	function encodeLink(str) {
	    var linkMaps = encodeMappings(EncodeTarget.Url);
	    var decoded = linkMaps.reduce(decodeMapping, str);
	    return linkMaps.reduce(encodeMapping, decoded);
	}
	exports.encodeLink = encodeLink;
	function encodeMappings(mtype) {
	    var maps = [
	        ['&', '&amp;'],
	        ['<', '&lt;'],
	        ['>', '&gt;'],
	        ['"', '&quot;'],
	        ["'", "&#x27;"],
	        ['\\/', '&#x2F;'],
	        ['\\(', '&#40;'],
	        ['\\)', '&#41;']
	    ];
	    if (mtype === EncodeTarget.Html) {
	        return maps.filter(function (_a) {
	            var v = _a[0], _ = _a[1];
	            return v.indexOf('(') === -1 && v.indexOf(')') === -1;
	        });
	    }
	    else {
	        return maps.filter(function (_a) {
	            var v = _a[0], _ = _a[1];
	            return v.indexOf('/') === -1;
	        });
	    }
	}
	function encodeMapping(str, mapping) {
	    return str.replace(new RegExp(mapping[0], 'g'), mapping[1]);
	}
	function decodeMapping(str, mapping) {
	    return str.replace(new RegExp(mapping[1], 'g'), mapping[0].replace('\\', ''));
	}


/***/ },
/* 312 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(37);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(23);
	
	var quoteAttributeValueForBrowser = __webpack_require__(697);
	var warning = __webpack_require__(10);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 315 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var LinkedValueUtils = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(26);
	
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(657);
	
	var containsNode = __webpack_require__(554);
	var focusNode = __webpack_require__(167);
	var getActiveElement = __webpack_require__(168);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(43);
	var DOMProperty = __webpack_require__(44);
	var React = __webpack_require__(47);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMContainerInfo = __webpack_require__(651);
	var ReactDOMFeatureFlags = __webpack_require__(653);
	var ReactFeatureFlags = __webpack_require__(318);
	var ReactInstanceMap = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMarkupChecksum = __webpack_require__(667);
	var ReactReconciler = __webpack_require__(45);
	var ReactUpdateQueue = __webpack_require__(121);
	var ReactUpdates = __webpack_require__(26);
	
	var emptyObject = __webpack_require__(69);
	var instantiateReactComponent = __webpack_require__(329);
	var invariant = __webpack_require__(7);
	var setInnerHTML = __webpack_require__(80);
	var shouldUpdateReactComponent = __webpack_require__(127);
	var warning = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(47);
	
	var invariant = __webpack_require__(7);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 323 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(322);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var ReactCompositeComponent = __webpack_require__(648);
	var ReactEmptyComponent = __webpack_require__(317);
	var ReactHostComponent = __webpack_require__(319);
	
	var getNextDebugID = __webpack_require__(760);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	var escapeTextContentForBrowser = __webpack_require__(79);
	var setInnerHTML = __webpack_require__(80);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var REACT_ELEMENT_TYPE = __webpack_require__(663);
	
	var getIteratorFn = __webpack_require__(694);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(117);
	var warning = __webpack_require__(10);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(700);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(703);
	
	var _scrollParent = __webpack_require__(704);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(702);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(705);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(701);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(2),__webpack_require__(1)):"function"==typeof define&&define.amd?define(["moment","react"],t):"object"==typeof exports?exports["react-moment"]=t(require("moment"),require("react")):e["react-moment"]=t(e.moment,e.react)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(13),f=r(c),s=n(11),p=r(s),d=n(12),m=r(d),y=n(6),v=[p.default.string,p.default.number,p.default.array,p.default.object],b=[p.default.string,p.default.array],h=[p.default.object,p.default.bool],g=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.setTimer=function(){n.clearTimer();var e=n.props.interval;t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props)},e))},n.clearTimer=function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(n)},t.globalMoment||(t.globalMoment=m.default),n.state={content:""},n.timer=null,n}return a(t,e),l(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update()})},e)}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[])}},{key:"pushPooledElement",value:function(e){return e instanceof t?void(t.pooledElements.indexOf(e)===-1&&t.pooledElements.push(e)):void console.error("Element not an instance of Moment.")}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);n!==-1&&t.pooledElements.splice(n,1)}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,u=e.tz;o=o||e.children,a=a||t.globalParse,u=u||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var l=null;return l=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),u&&(l=l.tz(u)),l}}]),l(t,[{key:"componentWillMount",value:function(){this.update(this.props)}},{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this)}},{key:"componentWillReceiveProps",value:function(e){this.update(e)}},{key:"componentDidUpdate",value:function(e){e.interval!==this.props.interval&&this.setTimer()}},{key:"componentWillUnmount",value:function(){this.clearTimer()}},{key:"update",value:function(e){var n=this;e=e||this.props;var r=e,o=r.fromNow,i=r.fromNowDuring,a=r.from,u=r.add,l=r.subtract,c=r.toNow,f=r.to,s=r.ago,p=r.calendar,d=r.diff,y=r.unit,v=r.decimal,b=e,h=b.format;h=h||t.globalFormat;var g=t.getDatetime(e);u&&g.add(u),l&&g.subtract(l);var O=Boolean(i)&&-g.diff((0,m.default)())<i,T="";T=h&&!O?g.format(h):a?g.from(a,s):o||O?g.fromNow(s):f?g.to(f,s):c?g.toNow(s):p?g.calendar(null,p):d?g.diff(d,y,v):g.toString();var w=t.globalFilter||this.props.filter;T=w(T),this.setState({content:T},function(){n.props.onChange(T)})}},{key:"render",value:function(){var e=(0,y.objectKeyFilter)(this.props,t.propTypes);return f.default.createElement(t.globalElement||this.props.element,u({dateTime:t.getDatetime(this.props)},e),this.state.content)}}]),t}(f.default.Component);g.propTypes={element:p.default.any,date:p.default.oneOfType(v),parse:p.default.oneOfType(b),format:p.default.string,add:p.default.object,subtract:p.default.object,ago:p.default.bool,fromNow:p.default.bool,fromNowDuring:p.default.number,from:p.default.oneOfType(v),toNow:p.default.bool,to:p.default.oneOfType(v),calendar:p.default.oneOfType(h),unix:p.default.bool,utc:p.default.bool,tz:p.default.string,locale:p.default.string,interval:p.default.number,diff:p.default.oneOfType(v),unit:p.default.string,decimal:p.default.bool,filter:p.default.func,onChange:p.default.func},g.defaultProps={element:"time",fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,unit:null,decimal:!1,interval:6e4,filter:function(e){return e},onChange:function(){}},g.globalMoment=null,g.globalLocale=null,g.globalFormat=null,g.globalParse=null,g.globalFilter=null,g.globalElement=null,g.globalTimezone=null,g.pooledElements=[],g.pooledTimer=null,t.default=g},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function i(e){if(s===clearTimeout)return clearTimeout(e);if((s===r||!s)&&clearTimeout)return s=clearTimeout,clearTimeout(e);try{return s(e)}catch(t){try{return s.call(null,e)}catch(t){return s.call(this,e)}}}function a(){y&&d&&(y=!1,d.length?m=d.concat(m):v=-1,m.length&&u())}function u(){if(!y){var e=o(a);y=!0;for(var t=m.length;t;){for(d=m,m=[];++v<t;)d&&d[v].run();v=-1,t=m.length}d=null,y=!1,i(e)}}function l(e,t){this.fun=e,this.array=t}function c(){}var f,s,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{s="function"==typeof clearTimeout?clearTimeout:r}catch(e){s=r}}();var d,m=[],y=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];m.push(new l(e,t)),1!==m.length||y||o(u)},l.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){(function(t){"use strict";function n(e,t,n,o,i,a,u,l){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[n,o,i,a,u,l],s=0;c=new Error(t.replace(/%s/g,function(){return f[s++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(1))},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){"use strict";var r=n(2),o=r;if("production"!==t.env.NODE_ENV){var i=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=0,i="Warning: "+e.replace(/%s/g,function(){return n[o++]});"undefined"!=typeof console&&console.error(i);try{throw new Error(i)}catch(e){}};o=function(e,t){if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==t.indexOf("Failed Composite propType: ")&&!e){for(var n=arguments.length,r=Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];i.apply(void 0,[t].concat(r))}}}e.exports=o}).call(t,n(1))},function(e,t){"use strict";function n(e,t){var n=Object.keys(t),r=Object.assign({},e);return Object.keys(r).filter(function(e){return n.indexOf(e)!==-1}).forEach(function(e){return delete r[e]}),r}Object.defineProperty(t,"__esModule",{value:!0}),t.objectKeyFilter=n},function(e,t){/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,u,l=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var f in r)i.call(r,f)&&(l[f]=r[f]);if(o){u=o(r);for(var s=0;s<u.length;s++)a.call(r,u[s])&&(l[u[s]]=r[u[s]])}}return l}},function(e,t,n){(function(t){"use strict";function r(e,n,r,l,c){if("production"!==t.env.NODE_ENV)for(var f in e)if(e.hasOwnProperty(f)){var s;try{o("function"==typeof e[f],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",l||"React class",r,f,typeof e[f]),s=e[f](n,f,l,r,null,a)}catch(e){s=e}if(i(!s||s instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",l||"React class",r,f,typeof s),s instanceof Error&&!(s.message in u)){u[s.message]=!0;var p=c?c():"";i(!1,"Failed %s type: %s%s",r,s.message,null!=p?p:"")}}}if("production"!==t.env.NODE_ENV)var o=n(3),i=n(5),a=n(4),u={};e.exports=r}).call(t,n(1))},function(e,t,n){"use strict";var r=n(2),o=n(3),i=n(4);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){(function(t){"use strict";var r=n(2),o=n(3),i=n(5),a=n(7),u=n(4),l=n(8);e.exports=function(e,n){function c(e){var t=e&&(R&&e[R]||e[I]);if("function"==typeof t)return t}function f(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function s(e){this.message=e,this.stack=""}function p(e){function r(r,c,f,p,d,m,y){if(p=p||S,m=m||f,y!==u)if(n)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var v=p+":"+f;!a[v]&&l<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",m,p),a[v]=!0,l++)}return null==c[f]?r?new s(null===c[f]?"The "+d+" `"+m+"` is marked as required "+("in `"+p+"`, but its value is `null`."):"The "+d+" `"+m+"` is marked as required in "+("`"+p+"`, but its value is `undefined`.")):null:e(c,f,p,d,m)}if("production"!==t.env.NODE_ENV)var a={},l=0;var c=r.bind(null,!1);return c.isRequired=r.bind(null,!0),c}function d(e){function t(t,n,r,o,i,a){var u=t[n],l=P(u);if(l!==e){var c=N(u);return new s("Invalid "+o+" `"+i+"` of type "+("`"+c+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return p(t)}function m(){return p(r.thatReturnsNull)}function y(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var a=t[n];if(!Array.isArray(a)){var l=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var c=0;c<a.length;c++){var f=e(a,c,r,o,i+"["+c+"]",u);if(f instanceof Error)return f}return null}return p(t)}function v(){function t(t,n,r,o,i){var a=t[n];if(!e(a)){var u=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return p(t)}function b(e){function t(t,n,r,o,i){if(!(t[n]instanceof e)){var a=e.name||S,u=_(t[n]);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+a+"`."))}return null}return p(t)}function h(e){function n(t,n,r,o,i){for(var a=t[n],u=0;u<e.length;u++)if(f(a,e[u]))return null;var l=JSON.stringify(e);return new s("Invalid "+o+" `"+i+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return Array.isArray(e)?p(n):("production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOf, expected an instance of array."):void 0,r.thatReturnsNull)}function g(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var c in a)if(a.hasOwnProperty(c)){var f=e(a,c,r,o,i+"."+c,u);if(f instanceof Error)return f}return null}return p(t)}function O(e){function n(t,n,r,o,i){for(var a=0;a<e.length;a++){var l=e[a];if(null==l(t,n,r,o,i,u))return null}return new s("Invalid "+o+" `"+i+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0,r.thatReturnsNull;for(var o=0;o<e.length;o++){var a=e[o];if("function"!=typeof a)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",k(a),o),r.thatReturnsNull}return p(n)}function T(){function e(e,t,n,r,o){return j(e[t])?null:new s("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return p(e)}function w(e){function t(t,n,r,o,i){var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var c in e){var f=e[c];if(f){var p=f(a,c,r,o,i+"."+c,u);if(p)return p}}return null}return p(t)}function E(e){function t(t,n,r,o,i){var l=t[n],c=P(l);if("object"!==c)return new s("Invalid "+o+" `"+i+"` of type `"+c+"` "+("supplied to `"+r+"`, expected `object`."));var f=a({},t[n],e);for(var p in f){var d=e[p];if(!d)return new s("Invalid "+o+" `"+i+"` key `"+p+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(t[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(l,p,r,o,i+"."+p,u);if(m)return m}return null}return p(t)}function j(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(j);if(null===t||e(t))return!0;var n=c(t);if(!n)return!1;var r,o=n.call(t);if(n!==t.entries){for(;!(r=o.next()).done;)if(!j(r.value))return!1}else for(;!(r=o.next()).done;){var i=r.value;if(i&&!j(i[1]))return!1}return!0;default:return!1}}function x(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function P(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":x(t,e)?"symbol":t}function N(e){if("undefined"==typeof e||null===e)return""+e;var t=P(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function k(e){var t=N(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function _(e){return e.constructor&&e.constructor.name?e.constructor.name:S}var R="function"==typeof Symbol&&Symbol.iterator,I="@@iterator",S="<<anonymous>>",D={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:m(),arrayOf:y,element:v(),instanceOf:b,node:T(),objectOf:g,oneOf:h,oneOfType:O,shape:w,exact:E};return s.prototype=Error.prototype,D.checkPropTypes=l,D.PropTypes=D,D}}).call(t,n(1))},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,o=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},i=!0;e.exports=n(10)(o,i)}else e.exports=n(9)()}).call(t,n(1))},function(t,n){t.exports=e},function(e,n){e.exports=t}])});

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilePlayer = exports.Mixcloud = exports.DailyMotion = exports.Twitch = exports.Wistia = exports.Streamable = exports.Facebook = exports.Vimeo = exports.SoundCloud = exports.YouTube = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _YouTube = __webpack_require__(133);
	
	Object.defineProperty(exports, 'YouTube', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YouTube)['default'];
	  }
	});
	
	var _SoundCloud = __webpack_require__(131);
	
	Object.defineProperty(exports, 'SoundCloud', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SoundCloud)['default'];
	  }
	});
	
	var _Vimeo = __webpack_require__(132);
	
	Object.defineProperty(exports, 'Vimeo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Vimeo)['default'];
	  }
	});
	
	var _Facebook = __webpack_require__(337);
	
	Object.defineProperty(exports, 'Facebook', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Facebook)['default'];
	  }
	});
	
	var _Streamable = __webpack_require__(340);
	
	Object.defineProperty(exports, 'Streamable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Streamable)['default'];
	  }
	});
	
	var _Wistia = __webpack_require__(342);
	
	Object.defineProperty(exports, 'Wistia', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Wistia)['default'];
	  }
	});
	
	var _Twitch = __webpack_require__(341);
	
	Object.defineProperty(exports, 'Twitch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitch)['default'];
	  }
	});
	
	var _DailyMotion = __webpack_require__(130);
	
	Object.defineProperty(exports, 'DailyMotion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DailyMotion)['default'];
	  }
	});
	
	var _Mixcloud = __webpack_require__(339);
	
	Object.defineProperty(exports, 'Mixcloud', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mixcloud)['default'];
	  }
	});
	
	var _FilePlayer = __webpack_require__(338);
	
	Object.defineProperty(exports, 'FilePlayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FilePlayer)['default'];
	  }
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(81);
	
	var _utils = __webpack_require__(21);
	
	var _players = __webpack_require__(707);
	
	var _players2 = _interopRequireDefault(_players);
	
	var _Player4 = __webpack_require__(129);
	
	var _Player5 = _interopRequireDefault(_Player4);
	
	var _Preview = __webpack_require__(706);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _preload = __webpack_require__(708);
	
	var _preload2 = _interopRequireDefault(_preload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
	
	var customPlayers = [];
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.state = {
	      showPreview: !!_this.props.light
	    }, _this.onClickPreview = function () {
	      _this.setState({ showPreview: false });
	    }, _this.getDuration = function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    }, _this.getCurrentTime = function () {
	      if (!_this.player) return null;
	      return _this.player.getCurrentTime();
	    }, _this.getSecondsLoaded = function () {
	      if (!_this.player) return null;
	      return _this.player.getSecondsLoaded();
	    }, _this.getInternalPlayer = function () {
	      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	
	      if (!_this.player) return null;
	      return _this.player.getInternalPlayer(key);
	    }, _this.seekTo = function (fraction) {
	      if (!_this.player) return null;
	      _this.player.seekTo(fraction);
	    }, _this.onReady = function () {
	      _this.props.onReady(_this);
	    }, _this.wrapperRef = function (wrapper) {
	      _this.wrapper = wrapper;
	    }, _this.activePlayerRef = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.progressFrequency) {
	        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
	        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
	    }
	  }, {
	    key: 'getActivePlayer',
	    value: function getActivePlayer(url) {
	      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var _Player = _arr[_i];
	        if (_Player.canPlay(url)) {
	          return _Player;
	        }
	      }
	      // Fall back to FilePlayer if nothing else can play the URL
	      return _FilePlayer.FilePlayer;
	    }
	  }, {
	    key: 'renderActivePlayer',
	    value: function renderActivePlayer(url, activePlayer) {
	      if (!url) return null;
	      return _react2['default'].createElement(_Player5['default'], _extends({}, this.props, {
	        key: activePlayer.displayName,
	        ref: this.activePlayerRef,
	        config: this.config,
	        activePlayer: activePlayer,
	        onReady: this.onReady
	      }));
	    }
	  }, {
	    key: 'sortPlayers',
	    value: function sortPlayers(a, b) {
	      // Retain player order to prevent weird iframe behaviour when switching players
	      if (a && b) {
	        return a.key < b.key ? -1 : 1;
	      }
	      return 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          style = _props.style,
	          width = _props.width,
	          height = _props.height,
	          light = _props.light,
	          Wrapper = _props.wrapper;
	      var showPreview = this.state.showPreview;
	
	      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
	      var activePlayer = this.getActivePlayer(url);
	      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
	      var preloadPlayers = (0, _preload2['default'])(url, this.config);
	      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
	      if (showPreview && url) {
	        return _react2['default'].createElement(_Preview2['default'], {
	          url: url,
	          light: light,
	          onClick: this.onClickPreview
	        });
	      }
	      return _react2['default'].createElement(
	        Wrapper,
	        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.addCustomPlayer = function (player) {
	  customPlayers.push(player);
	};
	
	ReactPlayer.removeCustomPlayers = function () {
	  customPlayers = [];
	};
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props2.propTypes;
	ReactPlayer.defaultProps = _props2.defaultProps;
	
	ReactPlayer.canPlay = function (url) {
	  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var _Player2 = _arr2[_i2];
	    if (_Player2.canPlay(url)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	ReactPlayer.canEnablePIP = function (url) {
	  var _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
	    var _Player3 = _arr3[_i3];
	    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	exports['default'] = ReactPlayer;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Facebook = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
	var SDK_GLOBAL = 'FB';
	var SDK_GLOBAL_READY = 'fbAsyncInit';
	var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
	var PLAYER_ID_PREFIX = 'facebook-player-';
	
	var Facebook = exports.Facebook = function (_Component) {
	  _inherits(Facebook, _Component);
	
	  function Facebook() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Facebook);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Facebook, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      if (isReady) {
	        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	          return FB.XFBML.parse();
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	        FB.init({
	          appId: _this2.props.config.facebook.appId,
	          xfbml: true,
	          version: 'v2.5'
	        });
	        FB.Event.subscribe('xfbml.render', function (msg) {
	          // Here we know the SDK has loaded, even if onReady/onPlay
	          // is not called due to a video that cannot be embedded
	          _this2.props.onLoaded();
	        });
	        FB.Event.subscribe('xfbml.ready', function (msg) {
	          if (msg.type === 'video' && msg.id === _this2.playerID) {
	            _this2.player = msg.instance;
	            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
	            _this2.player.subscribe('paused', _this2.props.onPause);
	            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
	            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
	            _this2.player.subscribe('error', _this2.props.onError);
	            if (!_this2.props.muted) {
	              // Player is muted by default
	              _this2.callPlayer('unmute');
	            }
	            _this2.props.onReady();
	
	            // For some reason Facebook have added `visibility: hidden`
	            // to the iframe when autoplay fails, so here we set it back
	            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentPosition');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      };
	      return _react2['default'].createElement('div', {
	        style: style,
	        id: this.playerID,
	        className: 'fb-video',
	        'data-href': this.props.url,
	        'data-autoplay': this.props.playing ? 'true' : 'false',
	        'data-allowfullscreen': 'true',
	        'data-controls': this.props.controls ? 'true' : 'false'
	      });
	    }
	  }]);
	
	  return Facebook;
	}(_react.Component);
	
	Facebook.displayName = 'Facebook';
	
	Facebook.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	Facebook.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilePlayer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
	var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
	var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
	var HLS_GLOBAL = 'Hls';
	var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
	var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
	var DASH_GLOBAL = 'dashjs';
	var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
	
	function canPlay(url) {
	  if (url instanceof Array) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var item = _step.value;
	
	        if (typeof item === 'string' && canPlay(item)) {
	          return true;
	        }
	        if (canPlay(item.src)) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return false;
	  }
	  if ((0, _utils.isMediaStream)(url)) {
	    return true;
	  }
	  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
	}
	
	function canEnablePIP(url) {
	  return canPlay(url) && !!document.pictureInPictureEnabled && !AUDIO_EXTENSIONS.test(url);
	}
	
	var FilePlayer = exports.FilePlayer = function (_Component) {
	  _inherits(FilePlayer, _Component);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onDisablePIP = function (e) {
	      var _this$props = _this.props,
	          onDisablePIP = _this$props.onDisablePIP,
	          playing = _this$props.playing;
	
	      onDisablePIP(e);
	      if (playing) {
	        _this.play();
	      }
	    }, _this.onSeek = function (e) {
	      _this.props.onSeek(e.target.currentTime);
	    }, _this.mute = function () {
	      _this.player.muted = true;
	    }, _this.unmute = function () {
	      _this.player.muted = false;
	    }, _this.renderSourceElement = function (source, index) {
	      if (typeof source === 'string') {
	        return _react2['default'].createElement('source', { key: index, src: source });
	      }
	      return _react2['default'].createElement('source', _extends({ key: index }, source));
	    }, _this.renderTrack = function (track, index) {
	      return _react2['default'].createElement('track', _extends({ key: index }, track));
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	      if (IOS) {
	        this.player.load();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
	        this.removeListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
	        this.addListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _props = this.props,
	          onReady = _props.onReady,
	          onPlay = _props.onPlay,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded,
	          onError = _props.onError,
	          playsinline = _props.playsinline,
	          onEnablePIP = _props.onEnablePIP;
	
	      this.player.addEventListener('canplay', onReady);
	      this.player.addEventListener('play', onPlay);
	      this.player.addEventListener('pause', onPause);
	      this.player.addEventListener('seeked', this.onSeek);
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      this.player.addEventListener('enterpictureinpicture', onEnablePIP);
	      this.player.addEventListener('leavepictureinpicture', this.onDisablePIP);
	      if (playsinline) {
	        this.player.setAttribute('playsinline', '');
	        this.player.setAttribute('webkit-playsinline', '');
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      var _props2 = this.props,
	          onReady = _props2.onReady,
	          onPlay = _props2.onPlay,
	          onPause = _props2.onPause,
	          onEnded = _props2.onEnded,
	          onError = _props2.onError,
	          onEnablePIP = _props2.onEnablePIP;
	
	      this.player.removeEventListener('canplay', onReady);
	      this.player.removeEventListener('play', onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('seeked', this.onSeek);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	      this.player.removeEventListener('enterpictureinpicture', onEnablePIP);
	      this.player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
	    }
	  }, {
	    key: 'shouldUseAudio',
	    value: function shouldUseAudio(props) {
	      if (props.config.file.forceVideo) {
	        return false;
	      }
	      if (props.config.file.attributes.poster) {
	        return false; // Use <video> so that poster is shown
	      }
	      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
	    }
	  }, {
	    key: 'shouldUseHLS',
	    value: function shouldUseHLS(url) {
	      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
	    }
	  }, {
	    key: 'shouldUseDASH',
	    value: function shouldUseDASH(url) {
	      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props$config$file = this.props.config.file,
	          hlsVersion = _props$config$file.hlsVersion,
	          dashVersion = _props$config$file.dashVersion;
	
	      if (this.shouldUseHLS(url)) {
	        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
	          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
	          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
	            _this2.props.onError(e, data, _this2.hls, Hls);
	          });
	          _this2.hls.loadSource(url);
	          _this2.hls.attachMedia(_this2.player);
	        });
	      }
	      if (this.shouldUseDASH(url)) {
	        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
	          _this2.dash = dashjs.MediaPlayer().create();
	          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
	          _this2.dash.getDebug().setLogToBrowserConsole(false);
	        });
	      }
	
	      if (url instanceof Array) {
	        // When setting new urls (<source>) on an already loaded video,
	        // HTMLMediaElement.load() is needed to reset the media element
	        // and restart the media resource. Just replacing children source
	        // dom nodes is not enough
	        this.player.load();
	      } else if ((0, _utils.isMediaStream)(url)) {
	        try {
	          this.player.srcObject = url;
	        } catch (e) {
	          this.player.src = window.URL.createObjectURL(url);
	        }
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var promise = this.player.play();
	      if (promise) {
	        promise['catch'](this.props.onError);
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	      if (this.hls) {
	        this.hls.destroy();
	      }
	      if (this.dash) {
	        this.dash.reset();
	      }
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.player.currentTime = seconds;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'enablePIP',
	    value: function enablePIP() {
	      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
	        this.player.requestPictureInPicture();
	      }
	    }
	  }, {
	    key: 'disablePIP',
	    value: function disablePIP() {
	      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
	        document.exitPictureInPicture();
	      }
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.player) return null;
	      var _player = this.player,
	          duration = _player.duration,
	          seekable = _player.seekable;
	      // on iOS, live streams return Infinity for the duration
	      // so instead we use the end of the seekable timerange
	
	      if (duration === Infinity && seekable.length > 0) {
	        return seekable.end(seekable.length - 1);
	      }
	      return duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      if (!this.player) return null;
	      return this.player.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      if (!this.player) return null;
	      var buffered = this.player.buffered;
	
	      if (buffered.length === 0) {
	        return 0;
	      }
	      var end = buffered.end(buffered.length - 1);
	      var duration = this.getDuration();
	      if (end > duration) {
	        return duration;
	      }
	      return end;
	    }
	  }, {
	    key: 'getSource',
	    value: function getSource(url) {
	      var useHLS = this.shouldUseHLS(url);
	      var useDASH = this.shouldUseDASH(url);
	      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
	        return undefined;
	      }
	      if (MATCH_DROPBOX_URL.test(url)) {
	        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
	      }
	      return url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          url = _props3.url,
	          playing = _props3.playing,
	          loop = _props3.loop,
	          controls = _props3.controls,
	          muted = _props3.muted,
	          config = _props3.config,
	          width = _props3.width,
	          height = _props3.height;
	
	      var useAudio = this.shouldUseAudio(this.props);
	      var Element = useAudio ? 'audio' : 'video';
	      var style = {
	        width: width === 'auto' ? width : '100%',
	        height: height === 'auto' ? height : '100%'
	      };
	      return _react2['default'].createElement(
	        Element,
	        _extends({
	          ref: this.ref,
	          src: this.getSource(url),
	          style: style,
	          preload: 'auto',
	          autoPlay: playing || undefined,
	          controls: controls,
	          muted: muted,
	          loop: loop
	        }, config.file.attributes),
	        url instanceof Array && url.map(this.renderSourceElement),
	        config.file.tracks.map(this.renderTrack)
	      );
	    }
	  }]);
	
	  return FilePlayer;
	}(_react.Component);
	
	FilePlayer.displayName = 'FilePlayer';
	FilePlayer.canPlay = canPlay;
	FilePlayer.canEnablePIP = canEnablePIP;
	exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Mixcloud = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
	var SDK_GLOBAL = 'Mixcloud';
	var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;
	
	var Mixcloud = exports.Mixcloud = function (_Component) {
	  _inherits(Mixcloud, _Component);
	
	  function Mixcloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Mixcloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      // No volume support
	    }, _this.unmute = function () {
	      // No volume support
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Mixcloud, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
	        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
	        _this2.player.ready.then(function () {
	          _this2.player.events.play.on(_this2.props.onPlay);
	          _this2.player.events.pause.on(_this2.props.onPause);
	          _this2.player.events.ended.on(_this2.props.onEnded);
	          _this2.player.events.error.on(_this2.props.error);
	          _this2.player.events.progress.on(function (seconds, duration) {
	            _this2.currentTime = seconds;
	            _this2.duration = duration;
	          });
	          _this2.props.onReady();
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      // No volume support
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          config = _props.config;
	
	      var id = url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
	        feed: '/' + id + '/'
	      }));
	      // We have to give the iframe a key here to prevent a
	      // weird dialog appearing when loading a new track
	      return _react2['default'].createElement('iframe', {
	        key: id,
	        ref: this.ref,
	        style: style,
	        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
	        frameBorder: '0'
	      });
	    }
	  }]);
	
	  return Mixcloud;
	}(_react.Component);
	
	Mixcloud.displayName = 'Mixcloud';
	
	Mixcloud.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Streamable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
	var SDK_GLOBAL = 'playerjs';
	var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;
	
	var Streamable = exports.Streamable = function (_Component) {
	  _inherits(Streamable, _Component);
	
	  function Streamable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Streamable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Streamable, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
	        if (!_this2.iframe) return;
	        _this2.player = new playerjs.Player(_this2.iframe);
	        _this2.player.setLoop(_this2.props.loop);
	        _this2.player.on('ready', _this2.props.onReady);
	        _this2.player.on('play', _this2.props.onPlay);
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('seeked', _this2.props.onSeek);
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref2) {
	          var duration = _ref2.duration,
	              seconds = _ref2.seconds;
	
	          _this2.duration = duration;
	          _this2.currentTime = seconds;
	        });
	        _this2.player.on('buffered', function (_ref3) {
	          var percent = _ref3.percent;
	
	          if (_this2.duration) {
	            _this2.secondsLoaded = _this2.duration * percent;
	          }
	        });
	        if (_this2.props.muted) {
	          _this2.player.mute();
	        }
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.props.url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        src: 'https://streamable.com/o/' + id,
	        frameBorder: '0',
	        scrolling: 'no',
	        style: style,
	        allowFullScreen: true
	      });
	    }
	  }]);
	
	  return Streamable;
	}(_react.Component);
	
	Streamable.displayName = 'Streamable';
	
	Streamable.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
	var SDK_GLOBAL = 'Twitch';
	var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
	var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
	var PLAYER_ID_PREFIX = 'twitch-player-';
	
	var Twitch = exports.Twitch = function (_Component) {
	  _inherits(Twitch, _Component);
	
	  function Twitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Twitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
	      _this.callPlayer('setMuted', true);
	    }, _this.unmute = function () {
	      _this.callPlayer('setMuted', false);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Twitch, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playsinline = _props.playsinline,
	          onError = _props.onError,
	          config = _props.config;
	
	      var isChannel = MATCH_CHANNEL_URL.test(url);
	      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
	      if (isReady) {
	        if (isChannel) {
	          this.player.setChannel(id);
	        } else {
	          this.player.setVideo('v' + id);
	        }
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
	        _this2.player = new Twitch.Player(_this2.playerID, _extends({
	          video: isChannel ? '' : id,
	          channel: isChannel ? id : '',
	          height: '100%',
	          width: '100%',
	          playsinline: playsinline,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted
	        }, config.twitch.options));
	        var _Twitch$Player = Twitch.Player,
	            READY = _Twitch$Player.READY,
	            PLAYING = _Twitch$Player.PLAYING,
	            PAUSE = _Twitch$Player.PAUSE,
	            ENDED = _Twitch$Player.ENDED;
	
	        _this2.player.addEventListener(READY, _this2.props.onReady);
	        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
	        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
	        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('div', { style: style, id: this.playerID });
	    }
	  }]);
	
	  return Twitch;
	}(_react.Component);
	
	Twitch.displayName = 'Twitch';
	
	Twitch.canPlay = function (url) {
	  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
	};
	
	Twitch.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Wistia = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(21);
	
	var _singlePlayer = __webpack_require__(27);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
	
	var Wistia = exports.Wistia = function (_Component) {
	  _inherits(Wistia, _Component);
	
	  function Wistia() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Wistia);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Wistia, [{
	    key: 'getID',
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[1];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playing = _props.playing,
	          muted = _props.muted,
	          controls = _props.controls,
	          _onReady = _props.onReady,
	          onPlay = _props.onPlay,
	          onPause = _props.onPause,
	          onSeek = _props.onSeek,
	          onEnded = _props.onEnded,
	          config = _props.config;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
	        window._wq = window._wq || [];
	        window._wq.push({
	          id: _this2.getID(url),
	          options: _extends({
	            autoPlay: playing,
	            silentAutoPlay: 'allow',
	            muted: muted,
	            controlsVisibleOnLoad: controls
	          }, config.wistia.options),
	          onReady: function onReady(player) {
	            _this2.player = player;
	            _this2.player.bind('play', onPlay);
	            _this2.player.bind('pause', onPause);
	            _this2.player.bind('seek', onSeek);
	            _this2.player.bind('end', onEnded);
	            _onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('remove');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('time', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('volume', fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('playbackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('duration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('time');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = 'wistia_embed wistia_async_' + id;
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('div', { key: id, className: className, style: style });
	    }
	  }]);
	
	  return Wistia;
	}(_react.Component);
	
	Wistia.displayName = 'Wistia';
	
	Wistia.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	Wistia.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(144));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(368));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(83));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(84));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(573));
	
	var _invariant = _interopRequireDefault(__webpack_require__(25));
	
	var _react = __webpack_require__(1);
	
	var _reactIs = __webpack_require__(333);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(716));
	
	var _PropTypes = __webpack_require__(345);
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(346));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(717));
	
	var _warning = _interopRequireDefault(__webpack_require__(134));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(349);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(137);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(305);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(372);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58),
	    _assign = __webpack_require__(8);
	
	var ReactNoopUpdateQueue = __webpack_require__(358);
	
	var canDefineProperty = __webpack_require__(359);
	var emptyObject = __webpack_require__(69);
	var invariant = __webpack_require__(7);
	var lowPriorityWarning = __webpack_require__(761);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var ReactCurrentOwner = __webpack_require__(31);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 357 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(10);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 360 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(179);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(780);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 362 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(535);
	var Socket = __webpack_require__(365);
	var Emitter = __webpack_require__(52);
	var parser = __webpack_require__(142);
	var on = __webpack_require__(364);
	var bind = __webpack_require__(160);
	var debug = __webpack_require__(82)('socket.io-client:manager');
	var indexOf = __webpack_require__(174);
	var Backoff = __webpack_require__(520);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ },
/* 364 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(142);
	var Emitter = __webpack_require__(52);
	var toArray = __webpack_require__(782);
	var on = __webpack_require__(364);
	var bind = __webpack_require__(160);
	var debug = __webpack_require__(82)('socket.io-client:socket');
	var hasBin = __webpack_require__(172);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ },
/* 366 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 367 */
/***/ function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ },
/* 368 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 369 */
/***/ function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ },
/* 372 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	var bind = __webpack_require__(150);
	var Axios = __webpack_require__(375);
	var defaults = __webpack_require__(85);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(147);
	axios.CancelToken = __webpack_require__(374);
	axios.isCancel = __webpack_require__(148);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(389);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(147);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(85);
	var utils = __webpack_require__(22);
	var InterceptorManager = __webpack_require__(376);
	var dispatchRequest = __webpack_require__(377);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	var transformData = __webpack_require__(380);
	var isCancel = __webpack_require__(148);
	var defaults = __webpack_require__(85);
	var isAbsoluteURL = __webpack_require__(385);
	var combineURLs = __webpack_require__(383);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 378 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(149);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 381 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 383 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 385 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(22);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _DisplayContainer = __webpack_require__(503);
	
	var _DisplayContainer2 = _interopRequireDefault(_DisplayContainer);
	
	var _MiamiContainer = __webpack_require__(437);
	
	var _MiamiContainer2 = _interopRequireDefault(_MiamiContainer);
	
	var _TampaContainer = __webpack_require__(494);
	
	var _TampaContainer2 = _interopRequireDefault(_TampaContainer);
	
	var _OmahaContainer = __webpack_require__(462);
	
	var _OmahaContainer2 = _interopRequireDefault(_OmahaContainer);
	
	var _NewarkContainer = __webpack_require__(450);
	
	var _NewarkContainer2 = _interopRequireDefault(_NewarkContainer);
	
	var _SeattleContainer = __webpack_require__(478);
	
	var _SeattleContainer2 = _interopRequireDefault(_SeattleContainer);
	
	var _DenverDonorListsContainer = __webpack_require__(427);
	
	var _DenverDonorListsContainer2 = _interopRequireDefault(_DenverDonorListsContainer);
	
	var _DenverStoriesContainer = __webpack_require__(429);
	
	var _DenverStoriesContainer2 = _interopRequireDefault(_DenverStoriesContainer);
	
	var _PreviewContainer = __webpack_require__(403);
	
	var _PreviewContainer2 = _interopRequireDefault(_PreviewContainer);
	
	var _AlbuquerqueContainer = __webpack_require__(414);
	
	var _AlbuquerqueContainer2 = _interopRequireDefault(_AlbuquerqueContainer);
	
	var _dc2x = __webpack_require__(509);
	
	var _dc2x2 = _interopRequireDefault(_dc2x);
	
	var _dc3x = __webpack_require__(510);
	
	var _dc3x2 = _interopRequireDefault(_dc3x);
	
	var _DonorSeaContainer = __webpack_require__(505);
	
	var _DonorSeaContainer2 = _interopRequireDefault(_DonorSeaContainer);
	
	var _DonorContainer = __webpack_require__(504);
	
	var _DonorContainer2 = _interopRequireDefault(_DonorContainer);
	
	var _QuoteContainer = __webpack_require__(507);
	
	var _QuoteContainer2 = _interopRequireDefault(_QuoteContainer);
	
	var _DebugContainer = __webpack_require__(502);
	
	var _DebugContainer2 = _interopRequireDefault(_DebugContainer);
	
	var _QuoteShort = __webpack_require__(404);
	
	var _QuoteShort2 = _interopRequireDefault(_QuoteShort);
	
	var _VerticalVideoSync = __webpack_require__(508);
	
	var _VerticalVideoSync2 = _interopRequireDefault(_VerticalVideoSync);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _content = __webpack_require__(500);
	
	var _donors = __webpack_require__(501);
	
	var _display = __webpack_require__(28);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _package = __webpack_require__(175);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App(props) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	        _this.fetchDisplayContent = function () {
	            if (_this._mode === "preview") {
	                _this.props.fetchContent(_config2.default.WEB_SERVER + '/display/fetchDisplayContents?mode=prvw&localLastUpdate=0&display=' + _this._displayId, 0, _this._webkey);
	            } else if (_this._mode === "web") {
	                //live web version
	                _this.props.fetchContent(_config2.default.WEB_SERVER + '/display/fetchDisplayContents?mode=web&localLastUpdate=0&display=' + _this._displayId, 0, _this._webkey);
	            } else if (_this._mode === "module") {
	                _this.props.fetchModuleContent(_config2.default.WEB_SERVER + '/display/fetchModuleContents?mode=prvw&module=' + _this._module + '&project=' + _this._project + '&module_id=' + _this._module_id, _this._webkey);
	            } else {
	                //form offline file
	                if (typeof _config2.default.DISPLAY === "number") {
	                    _this.props.fetchContent(_this._baseURL + '/data/displayContents.json', 0, _this._mode);
	                } else {
	                    _this.props.fetchContent(_this._baseURL + '/data/display_' + _this._displayId + '_contents/displayContents.json', 0, _this._mode);
	                }
	            }
	        };
	
	        _this.fetchDonorContent = function () {
	            if (_this._mode === "preview") {
	                _this.props.fetchDonors(_config2.default.WEB_SERVER + '/display/fetchDonorContents?mode=prvw&localLastUpdate=0&display=' + _this._displayId, 0, _this._webkey);
	            } else if (_this._mode === "web") {
	                //live web version
	                _this.props.fetchDonors(_config2.default.WEB_SERVER + '/display/fetchDonorContents?mode=web&localLastUpdate=0&display=' + _this._displayId, 0, _this._webkey);
	            } else {
	                //form offline file
	                _this.props.fetchDonors(_this._baseURL + '/data/donorContents.json', 0);
	            }
	        };
	
	        _this.state = {
	            contentInit: false,
	            displayInit: false
	        };
	        _this._mode = "local";
	        _this._module_id = null;
	        _this._module = null;
	        _this._project = null;
	        _this._displayId = 1;
	        _this._baseURL = "";
	        _this._webkey = null;
	        _this._initialRender = false;
	        _this._entrySuccessful = false;
	
	        if (_this.props.clearLocal === 'true') {
	            console.log("clearing local storage for window name");
	            localStorage.removeItem('entryPoint_' + self.window.name);
	        }
	
	        return _this;
	    }
	
	    _createClass(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            //window.addEventListener('beforeunload', this.handleWindowClose);
	
	            this._baseURL = window.location.origin;
	
	            console.log("pdg-digital-cms client v" + _package2.default.version + " running in: " + ("production") + " ENV");
	            window.onerror = function (msg, url, lineNo, columnNo, error) {
	                console.log("-----WINDOW ONERROR-----");
	                console.log(JSON.stringify({
	                    msg: msg,
	                    url: url,
	                    lineNo: lineNo,
	                    columnNo: columnNo,
	                    error: error
	                }));
	                var refreshPage = false;
	                switch (msg) {
	                    case "ResizeObserver loop limit exceeded":
	                        break;
	                    default:
	                        refreshPage = true;
	
	                }
	                if (refreshPage === true) {
	                    _shared2.default.checkData(null, _this2.props.content.entry_point || "");
	                }
	
	                return false;
	            };
	
	            var fetchInterval = 25000; //once per minute
	            if (false) {
	                fetchInterval = 25000;
	            }
	
	            var modeParam = _shared2.default.parseStringParam(window.location.href, "mode");
	            var displayId = _shared2.default.parseStringParam(window.location.href, "display");
	            var webkey = _shared2.default.parseStringParam(window.location.href, "webkey");
	            var module = _shared2.default.parseStringParam(window.location.href, "module");
	            var module_id = _shared2.default.parseStringParam(window.location.href, "module_id");
	            var project = _shared2.default.parseStringParam(window.location.href, "project");
	
	            if (displayId) {
	                this._displayId = displayId;
	            } else {
	                if (typeof _config2.default.DISPLAY !== 'number') {
	                    this._displayId = _config2.default.DISPLAY[0];
	                }
	            }
	            if (webkey) {
	                this._webkey = webkey;
	            }
	
	            if (modeParam === "prvw") {
	                this._mode = "preview";
	            }
	            if (modeParam === "web") {
	                this._mode = "web";
	            }
	            if (modeParam === "module") {
	                this._project = project;
	                this._module = module;
	                this._module_id = module_id;
	                this._mode = "module";
	            }
	
	            this.firstDisplayContent = setTimeout(function () {
	                _this2.fetchDisplayContent();
	            }, 1000);
	            this.firstDonorContent = setTimeout(function () {
	                _this2.fetchDonorContent();
	            }, 2000);
	
	            if (this._mode !== "preview") {
	                //only fetch once for preview
	                this._contentInterval = setInterval(function () {
	                    _this2.fetchDisplayContent();
	                }, fetchInterval);
	
	                this._donorsInterval = setInterval(function () {
	                    _this2.fetchDonorContent();
	                }, fetchInterval);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	            clearInterval(this._contentInterval);
	            clearInterval(this._donorsInterval);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (!this.props.content || !this.props.donors) {
	                return;
	            }
	            if (_lodash2.default.isEmpty(this.props.content)) {
	                return;
	            }
	            if (this.state.displayInit === false) {
	                var blocks = _lodash2.default.get(this.props, 'content.settings.display_blocks', []);
	                this.props.fetchDisplay({ screenHeight: window.innerHeight, screenWidth: window.innerWidth, mode: this._mode, webkey: this._webkey, blocks: blocks, entry_point: this.props.content.entry_point });
	                this.setState({
	                    displayInit: true
	                });
	            }
	            if (this.props.content.last_update !== prevProps.content.last_update) {
	                if (this.state.contentInit === true) {
	                    _shared2.default.checkData(null, this.props.content.entry_point || "");
	                } else {
	                    this.setState({
	                        contentInit: true
	                    });
	                }
	            }
	            if (this.props.donors.last_update !== prevProps.donors.last_update) {
	                if (this.state.donorsInit === true) {
	                    //console.log("content updated, re-init");
	                    _shared2.default.checkData(null);
	                } else {
	                    //console.log("donor init complete");
	                    this.setState({
	                        donorsInit: true
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.entryforce === true && this._entrySuccessful === false) {
	                //first try local storage (better support for multi displays);
	                var entry_point = localStorage.getItem('entryPoint_' + self.window.name);
	                console.log("getting local storage entry point", entry_point);
	                if (!entry_point) {
	                    entry_point = window.location.href;
	                    //remove clear local from future refreshes
	                    entry_point = entry_point.replace('&clearLocal=true', '');
	                    console.log("setting local storage entry", entry_point);
	                    self.window.name = new Date().getTime();
	                    localStorage.setItem('entryPoint_' + self.window.name, entry_point);
	                } else {
	                    this._entrySuccessful = true;
	                    if (entry_point !== window.location.href && entry_point !== window.location.href.replace('&clearLocal=true', '')) {
	                        console.log("local storage redirection", entry_point);
	                        window.location = entry_point;
	                    }
	                }
	            }
	
	            if ((!this.props.content.last_update || !this.props.donors.last_update || !this.props.screen) && this._mode !== "module") {
	                var errStr = "Waiting on data:";
	                if (!this.props.content.last_update) {
	                    errStr += " Content...";
	                }
	                if (!this.props.donors.last_update) {
	                    errStr += " Donor Content...";
	                }
	                if (!this.props.screen) {
	                    errStr += " Screen Content...";
	                }
	                console.log(errStr);
	
	                return _react2.default.createElement(
	                    'span',
	                    { style: { color: '#777777' } },
	                    'Loading...'
	                );
	            }
	            if (!this._initialRender) {
	                console.log("All app content recieved, proceeding.");
	                this._initialRender = true;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _reactRouterDom.BrowserRouter,
	                    null,
	                    _react2.default.createElement(
	                        _reactRouterDom.Switch,
	                        null,
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/VerticalVideoSync', component: _VerticalVideoSync2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/dc2x1', component: _dc2x2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/dc3x1', component: _dc3x2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/DonorSeaContainer', component: _DonorSeaContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/DonorContainer', component: _DonorContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/QuoteContainer', component: _QuoteContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/QuoteShort', component: _QuoteShort2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/Debug', component: _DebugContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/tampa', component: _TampaContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/miami', component: _MiamiContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/omaha', component: _OmahaContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/seattle', component: _SeattleContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/newark', component: _NewarkContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/preview', component: _PreviewContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/denver', component: _DenverDonorListsContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/denver-stories', component: _DenverStoriesContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/albuquerque', component: _AlbuquerqueContainer2.default }),
	                        _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _DisplayContainer2.default })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    var entryforce = _shared2.default.parseStringParam(window.location.href, "entryforce") || true;
	    var clearLocal = _shared2.default.parseStringParam(window.location.href, "clearLocal") || false;
	
	    return {
	        content: state.content,
	        donors: state.donors,
	        screen: state.screen,
	        entryforce: entryforce,
	        clearLocal: clearLocal
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchContent: function fetchContent(url, contentLastUpdated, webkey) {
	            return dispatch((0, _content.fetchContent)(url, contentLastUpdated, webkey));
	        },
	        fetchDonors: function fetchDonors(url, contentLastUpdated, webkey) {
	            return dispatch((0, _donors.fetchDonors)(url, contentLastUpdated, webkey));
	        },
	        fetchModuleContent: function fetchModuleContent(url, module, module_id, webkey) {
	            return dispatch((0, _content.fetchModuleContent)(url, module, module_id, webkey));
	        },
	        fetchDisplay: function fetchDisplay(data) {
	            return dispatch((0, _display.fetchDisplay)(data));
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonorCategoriesSide = function (_Component) {
	    _inherits(DonorCategoriesSide, _Component);
	
	    function DonorCategoriesSide(props) {
	        _classCallCheck(this, DonorCategoriesSide);
	
	        var _this = _possibleConstructorReturn(this, (DonorCategoriesSide.__proto__ || Object.getPrototypeOf(DonorCategoriesSide)).call(this, props));
	
	        _this.navroute = _this.navroute.bind(_this);
	        _this.prepareModules = _this.prepareModules.bind(_this);
	        return _this;
	    }
	
	    _createClass(DonorCategoriesSide, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'navroute',
	        value: function navroute(donorCatId) {
	            this.props.handleSlideCategoryChange(donorCatId);
	        }
	    }, {
	        key: 'prepareModules',
	        value: function prepareModules() {
	            if (this.props.donorCats.length === 0) {
	                return _react2.default.createElement('div', null);
	            }
	            //onMouseDown={this.route(row.id, row.display_module_type)}
	            return this.props.donorCats.map(function (row, i) {
	                var _this2 = this;
	
	                return _react2.default.createElement(
	                    'div',
	                    { key: row.id, onMouseDown: function onMouseDown() {
	                            return _this2.navroute(row.id);
	                        }, className: 'phand' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        row.name
	                    )
	                );
	            }, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var modules = this.prepareModules();
	
	            return _react2.default.createElement(
	                'div',
	                { style: { color: 'black', height: '100vh', textAlign: 'vertical', fontSize: this.props.screen.r16_9.p10 * .325 } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'outerC' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'middleC' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { textAlign: 'left', display: 'inline-block', lineHeight: '2' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Categories'
	                                )
	                            ),
	                            modules
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DonorCategoriesSide;
	}(_react.Component);
	
	exports.default = DonorCategoriesSide;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _DonorCategoriesSide = __webpack_require__(391);
	
	var _DonorCategoriesSide2 = _interopRequireDefault(_DonorCategoriesSide);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iScroll = __webpack_require__(72);
	
	
	var scrollMultiplier = 10;
	var scrollDelay = 3000;
	
	//var requestId;
	
	var DonorList = function (_Component) {
	  _inherits(DonorList, _Component);
	
	  function DonorList(props) {
	    _classCallCheck(this, DonorList);
	
	    console.log("donor-list");
	
	    var _this = _possibleConstructorReturn(this, (DonorList.__proto__ || Object.getPrototypeOf(DonorList)).call(this, props));
	
	    _this.onScrollStart = function () {
	      _this.setState({
	        userScrolling: true
	      });
	      if (_this.scrollTimeout) {
	        clearTimeout(_this.scrollTimeout);
	        _this.scrollTimeout = null;
	      }
	      _this.resetTimer(scrollDelay);
	    };
	
	    _this.onScrollEnd = function (e) {
	      _this.props.resume();
	      if (e.y === e.maxScrollY && _this.state.userScrolling === false) {
	        _this.scrollRef[0].withIScroll(function (iScroll) {
	          iScroll.scrollTo(0, 0);
	          _this.resetTimer(500);
	        });
	      }
	      _this.setState({
	        userScrolling: false
	      });
	    };
	
	    _this.refDict = {};
	    _this.scrollRef = {};
	    _this.prepareDonors = _this.prepareDonors.bind(_this);
	    _this.outputDonors = _this.outputDonors.bind(_this);
	    _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	    _this.resetTimer = _this.resetTimer.bind(_this);
	    _this.handleCategoriesSlide = _this.handleCategoriesSlide.bind(_this);
	    _this.toggleSlideOn = _this.toggleSlideOn.bind(_this);
	    _this.toggleSlideOff = _this.toggleSlideOff.bind(_this);
	    _this.setInitialLocation = _this.setInitialLocation.bind(_this);
	    _this.handleSlideCategoryChange = _this.handleSlideCategoryChange.bind(_this);
	    _this.donorlines = [];
	    _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
	    _this.state = {
	      selectedCategory: null,
	      donorsGrouped: null,
	      displayCategories: false,
	      userScrolling: true,
	      initialLocationSet: false
	
	    };
	    _this.scrollTimeout = null; //for auto scrolling
	
	    //this.newScroll = Scroll.animateScroll
	    return _this;
	  }
	
	  _createClass(DonorList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _shared2.default.checkData(this.props.module);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.prepareDonors();
	      // this.resetTimer(1000);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // if (this.state.userScrolling===true){
	      // this.resetTimer(scrollDelay);
	      // }
	      //  if (this.state.donorsGrouped!==null){
	
	      //   }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      //window.cancelAnimationFrame(requestId);
	      //requestId = undefined;
	      clearTimeout(this.scrollTimeout);
	      this.scrollTimeout = null;
	      //     Events.scrollEvent.remove('begin');
	      //     Events.scrollEvent.remove('end');
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if (_shared2.default.shallowEqual(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'setInitialLocation',
	    value: function setInitialLocation() {
	      var _this2 = this;
	
	      if (this.state.initialLocationSet === false) {
	        if (this.scrollRef[0]) {
	          var jumptodonor = _shared2.default.parseStringParam(this.props.history.location.search, "donor");
	          if (jumptodonor) {
	            _lodash2.default.forEach(this.donorlines, function (donor) {
	              if (donor.id === jumptodonor) {
	                _this2.scrollRef[0].withIScroll(function (iScroll) {
	                  iScroll.scrollToElement(donor, null, 0, -_this2.props.screen.r16_9.p10, false);
	                  return true;
	                });
	              }
	            });
	            this.setState({
	              initialLocationSet: true
	            });
	          } else {
	            this.scrollRef[0].withIScroll(function (iScroll) {
	              iScroll.scrollTo(0, -_this2.props.screen.r16_9.p10 * 6);
	            });
	            this.setState({
	              initialLocationSet: true
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'scrollToBottom',
	    value: function scrollToBottom() {
	      var max = Math.abs(this.scrollRef[0]._iScrollInstance.maxScrollY);
	      var current = Math.abs(this.scrollRef[0]._iScrollInstance.y);
	      var remaining = max - current;
	      var seconds = remaining / 1000 * 5000 * scrollMultiplier; //5 seconds per 1000 pixels
	      var customEase = iScroll.utils.ease.quadratic;
	      customEase.style = "cubic-bezier(0, 0, 1, 1)";
	      //0.250, 0.250, 0.750, 0.750
	      this.scrollRef[0].withIScroll(function (iScroll) {
	        //iScroll.scrollTo(0, -max, seconds, customEase);
	        iScroll.scrollTo(0, -max, seconds, customEase);
	      });
	
	      this.setState({
	        userScrolling: false
	      });
	    }
	  }, {
	    key: 'resetTimer',
	    value: function resetTimer(time) {
	      var _this3 = this;
	
	      if (this.scrollTimeout) {
	        clearTimeout(this.scrollTimeout);
	        this.scrollTimeout = null;
	      }
	
	      this.scrollTimeout = setTimeout(function () {
	        _this3.scrollToBottom();
	        _this3.scrollTimeout = null;
	      }, time);
	    }
	  }, {
	    key: 'handleCategoriesSlide',
	    value: function handleCategoriesSlide() {
	      if (this.state.displayCategories === false) {
	        this.toggleSlideOn();
	      } else {
	        this.toggleSlideOff();
	      }
	    }
	  }, {
	    key: 'toggleSlideOff',
	    value: function toggleSlideOff() {
	      this.setState({
	        displayCategories: false
	      });
	    }
	  }, {
	    key: 'toggleSlideOn',
	    value: function toggleSlideOn() {
	      this.setState({
	        displayCategories: true
	      });
	    }
	  }, {
	    key: 'handleDonorClick',
	    value: function handleDonorClick(e, row) {
	      //e.target.scrollTop = 0;
	      //console.log(e.target.top);
	      //var elemRect = e.target.getBoundingClientRect();
	      //var elemViewportOffset = elemRect.top;
	      //console.log(elemViewportOffset);
	      //e.target.scrollIntoView({ block: 'end', behavior: 'smooth' });
	      //  this.refs.test.scrollTop = elemViewportOffset;
	    }
	  }, {
	    key: 'jumpToCategory',
	    value: function jumpToCategory(e) {
	      // e.target.scrollIntoView({ block: 'end', behavior: 'smooth' });
	
	    }
	  }, {
	    key: 'handleSlideCategoryChange',
	    value: function handleSlideCategoryChange(categoryId) {
	      this.toggleSlideOff();
	      this.handleCategoryChange({ value: categoryId });
	    }
	  }, {
	    key: 'handleCategoryChange',
	    value: function handleCategoryChange(val) {
	      var _this4 = this;
	
	      this.setState({
	        selectedCategory: val.value
	      });
	      var jumpTo = null;
	      for (var i = 0; i < this.state.donorsGrouped.length; i++) {
	        if (val.value === this.state.donorsGrouped[i].id) {
	          jumpTo = i;
	        }
	      }
	      if (jumpTo !== null) {
	        this.scrollRef[0].withIScroll(function (iScroll) {
	          iScroll.disable();
	          iScroll.enable();
	          iScroll.scrollToElement(_this4.refDict[jumpTo], null, 0, -_this4.props.screen.r16_9.p10, false);
	        });
	      }
	    }
	  }, {
	    key: 'prepareDonors',
	    value: function prepareDonors() {
	      var _this5 = this;
	
	      if (this.props.donors.donorCategories.length === 0) {
	        this.setState({
	          donorsGrouped: []
	        });
	        return;
	      }
	      var donorsGrouped = [];
	
	      // if (!this.props.module.contents.donor_view_category){
	
	      // } 
	
	      //console.log("include categories", this.props.module.contents.include_categories);
	
	      _lodash2.default.forEach(this.props.donors.donorCategories, function (category) {
	        if (category.donors.length > 0) {
	          _lodash2.default.forEach(_this5.props.module.contents.include_categories, function (icat) {
	            if (icat === category.id) {
	              var pushGroup = { id: category.id, name: category.name, subheader: category.subheader, donors: [] };
	              _lodash2.default.forEach(category.donors, function (dnr) {
	                pushGroup.donors.push(dnr);
	              });
	              donorsGrouped.push(pushGroup);
	            }
	          });
	        }
	      });
	      this.setState({
	        donorsGrouped: donorsGrouped
	      });
	    }
	  }, {
	    key: 'outputName',
	    value: function outputName(donorCat, i) {
	      var _this6 = this;
	
	      var style = {
	        fontSize: this.props.screen.r16_9.p10 * .6,
	        lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px"
	      };
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(el) {
	            return _this6.refDict[i] = el;
	          }, onMouseDown: function onMouseDown(e) {
	            return _this6.jumpToCategory(e);
	          }, style: style },
	        _react2.default.createElement(
	          'b',
	          null,
	          donorCat.name
	        )
	      );
	    }
	  }, {
	    key: 'outputSubheader',
	    value: function outputSubheader(donorCat, i) {
	      var style = {
	        fontSize: this.props.screen.r16_9.p10 * .4,
	        lineHeight: String(this.props.screen.r16_9.p10 * .4 * .78) + "px",
	        pointerEvents: 'auto',
	        zIndex: 100
	      };
	      if (donorCat.subheader) {
	        return _react2.default.createElement(
	          'div',
	          { style: style },
	          _react2.default.createElement(
	            'b',
	            null,
	            donorCat.subheader
	          )
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }, {
	    key: 'outputDonorInfo',
	    value: function outputDonorInfo(donorCat) {
	      return donorCat.donors.map(function (row, i) {
	        var _this7 = this;
	
	        //if row.id===param scroll
	        //check if SET ABOVE specific donor id param, if so if its a match render the ref to a different ref??
	        return _react2.default.createElement(
	          'span',
	          { id: row.id, ref: function ref(el) {
	              _this7.donorlines.push(el);
	            }, onMouseDown: function onMouseDown(e) {
	              return _this7.handleDonorClick(e);
	            }, style: { width: '100%', marginBottom: this.props.screen.r16_9.p10 * .125, marginTop: this.props.screen.r16_9.p10 * .125, fontSize: this.props.screen.r16_9.p10 * .3, display: "inline-block" }, key: i },
	          row.name
	        );
	      }, this);
	    }
	  }, {
	    key: 'outputDonors',
	    value: function outputDonors(donorCat) {
	      return donorCat.map(function (row, i) {
	        var title = this.outputName(row, i);
	        var subheader = this.outputSubheader(row, i);
	        var donors = this.outputDonorInfo(row);
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: { width: '100%' } },
	          _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .35 } }),
	          title,
	          _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .175 } }),
	          subheader,
	          _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .35 } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'threecolumn' },
	            donors
	          )
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var navClass = "";
	      var backDropClass = "backdropOff";
	      if (this.state.displayCategories === true) {
	        navClass += " on";
	        backDropClass = "backdropOn";
	      }
	
	      var navButtonStyle = {
	        color: 'white',
	        position: 'fixed',
	        height: this.props.screen.screenHeight * .065,
	        width: this.props.screen.screenHeight * .065,
	        fontSize: this.props.screen.screenHeight * .025,
	        left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10,
	        bottom: this.props.screen.r16_9.p10 * 2,
	        zIndex: 99,
	        textAlign: 'left'
	      };
	
	      var headlineText = {
	        textAlign: 'vertical',
	        display: 'inline-block',
	        color: 'black',
	        fontSize: this.props.screen.r16_9.p10 * .6,
	        lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
	        position: 'absolute',
	        width: this.props.screen.r16_9.screenWidth
	      };
	
	      if (this.state.donorsGrouped === null) {
	        return _react2.default.createElement('div', null);
	      }
	      var donorCats = this.state.donorsGrouped;
	      var donorsOutput = this.outputDonors(donorCats);
	
	      var options = [];
	
	      _lodash2.default.forEach(donorCats, function (dc) {
	        options.push({ value: dc.id, label: dc.name });
	      });
	
	      var u10 = this.props.screen.r16_9.p10;
	      var leftWidth = this.props.screen.r16_9.left + this.props.screen.r16_9.width / 6;
	      var innerRightWidth = this.props.screen.r16_9.width - this.props.screen.r16_9.width / 6;
	      var rightWidth = this.props.screen.screenWidth - leftWidth;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '100vw', height: '100vh', position: 'absolute' } },
	        _react2.default.createElement('div', { onMouseDown: this.toggleSlideOff, className: backDropClass }),
	        _react2.default.createElement('div', { style: { position: 'fixed', top: 0, left: leftWidth, width: rightWidth, height: this.props.screen.screenHeight, backgroundColor: 'white', color: 'black', pointerEvents: 'none' } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'phand', style: { color: 'black', position: 'fixed', left: leftWidth + u10, top: 0, height: u10 * 2, width: rightWidth, backgroundColor: 'white' } },
	          _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: 'white', position: 'absolute', top: u10, fontSize: u10 * 2, width: '100%' } },
	            _react2.default.createElement(
	              'span',
	              { style: headlineText },
	              _react2.default.createElement(
	                'b',
	                null,
	                this.props.module.contents.headline ? this.props.module.contents.headline : "Donor Headline"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 7, backgroundColor: 'white', color: 'black', pointerEvents: 'auto' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'phand', style: { lineHeight: '1.25', height: u10 * 7, width: innerRightWidth - u10 * 2, touchAction: "none" } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this8.scrollRef[0] = el;
	                }, iScroll: iScroll,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.015,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false
	                }, onScrollStart: this.onScrollStart,
	                onScrollEnd: this.onScrollEnd,
	                onRefresh: this.setInitialLocation
	              },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: { height: u10 * 7 } }),
	                donorsOutput,
	                _react2.default.createElement('div', { style: { height: u10 * 7 } })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'topgrad', style: { pointerEvents: 'none', position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1 } }),
	        _react2.default.createElement('div', { className: 'bottomgrad', style: { pointerEvents: 'none', position: 'fixed', top: u10 * 8, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1.1 } }),
	        _react2.default.createElement('br', { style: { clear: 'both' } }),
	        _react2.default.createElement(
	          'div',
	          { id: 'slideout', className: navClass },
	          _react2.default.createElement(_DonorCategoriesSide2.default, { handleSlideCategoryChange: this.handleSlideCategoryChange, donorCats: donorCats, screen: this.props.screen })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'phand', onMouseDown: this.handleCategoriesSlide, style: navButtonStyle },
	          _react2.default.createElement(
	            'span',
	            { style: { position: 'absolute', bottom: 0 } },
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'sitemap', size: '2x' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DonorList;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  var mod = state.content.dm_active[state.active_module];
	  var isIdle = _shared2.default.parseStringParam(window.location.href, "idle");
	  //console.log("is idle is this", isIdle)
	  if (isIdle === 'true') {
	    mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data    
	  }
	  //console.log("found this mod: ", mod)
	  return {
	    screen: state.screen,
	    module: mod,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DonorList);

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _DonorFullPage = __webpack_require__(60);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import VerticalVideoSync from '../../containers/VerticalVideoSync';
	var DonorListPassive = function (_Component) {
	  _inherits(DonorListPassive, _Component);
	
	  function DonorListPassive(props) {
	    _classCallCheck(this, DonorListPassive);
	
	    var _this = _possibleConstructorReturn(this, (DonorListPassive.__proto__ || Object.getPrototypeOf(DonorListPassive)).call(this, props));
	
	    _this.setOffset = function (setVar, styleObj, margin) {
	      if (styleObj.visible === true) {
	        setVar.val = _this._sumH + margin * .01 * _this.props.screen.screenHeight;
	        _this._sumH += styleObj.height * .01 * _this.props.screen.screenHeight;
	      }
	    };
	
	    _this.setFontAttributes = function (styleObj, rootObj) {
	      styleObj.color = rootObj.fontColor;
	      styleObj.fontWeight = rootObj.fontWeight;
	      styleObj.textAlign = rootObj.justification.toLowerCase();
	      styleObj.fontStyle = rootObj.fontStyle.toLowerCase();
	      styleObj.fontFamily = rootObj.font;
	      styleObj.fontSize = rootObj.fontSize * _this.props.screen.screenHeight * .01;
	    };
	
	    _this.handleKeyDown = function (e) {
	      switch (e.key) {
	        case '1':
	          _this.metaCycle(true);
	          break;
	        case '6':
	          clearTimeout(_this._metaCycleTimeout);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.metaCycle = function (cycleIndex) {
	      if (cycleIndex) {
	        _this.cycleIndex();
	      }
	
	      if (_this._ni_options.interstitial === false) {
	
	        _this.cycleDonorIndex();
	        _this.setState({
	          showDonors: true,
	          showSlides: false
	        });
	        _this.setMetaCycleTimeout(_this._listCycleTime, true);
	      } else {
	        if (_this._ni_options.auto_interstitial === true) {
	          //TODO: Implement
	          //insert per number of screens
	          //this._ni_options.screensBetween;
	        } else if (_this._resetLoopOnStart === true && _this._manualSlidesIndex > _this._ni_options.manualSlides.length - 1) {
	          _this.setState({
	            showDonors: true,
	            showSlides: false
	          });
	          _this.cycleDonorIndex();
	          _this.setMetaCycleTimeout(_this._listCycleTime, true);
	        } else {
	          _this._manualSlidesInnerIndex++;
	          var slideData = _this._ni_options.manualSlides[_this._manualSlidesIndex];
	          var totalSteps = slideData.screens + slideData.end - slideData.start;
	          if (_this._manualSlidesInnerIndex < slideData.screens) {
	            _this.cycleDonorIndex();
	            _this.setState({
	              showDonors: true,
	              showSlides: false
	            });
	            _this.setMetaCycleTimeout(_this._listCycleTime, true);
	          } else if (_this._manualSlidesInnerIndex <= totalSteps) {
	            //cycle through and show slides
	            var currentSlideIndex = slideData.start - 1 + (_this._manualSlidesInnerIndex - slideData.screens);
	            var dd = _this.state.donorData || {};
	            dd.name = "";
	            _this.clearDonorData();
	            _this.setState({
	              slideImage: (0, _shared.dpath)(_this.props.screen.mode, _this._ni_options.slideshow_module.contents.images[currentSlideIndex].path, _this._ni_options.slideshow_module.contents.images[currentSlideIndex].file_name, _this.props.screen.webkey),
	              donorData: dd
	            });
	            var slideTimeOut = _this._listCycleTime;
	            if (_lodash2.default.has(_this._ni_options, 'slideshow_module.contents.cycle_overrides[' + currentSlideIndex + ']')) {
	              slideTimeOut = _this._ni_options.slideshow_module.contents.cycle_overrides[currentSlideIndex] * 1000;
	            }
	            _this.setMetaCycleTimeout(slideTimeOut, true);
	          } else {
	            _this._manualSlidesIndex++;
	            //if not resetLoopOnStart end of loop cycle slides
	            if (_this._resetLoopOnStart === false && _this._manualSlidesIndex > _this._ni_options.manualSlides.length - 1) {
	              _this._manualSlidesIndex = 0;
	            }
	            _this._manualSlidesInnerIndex = -1;
	            _this.metaCycle(false); //end of loop recursive
	          }
	        }
	      }
	    };
	
	    _this.clearDonorData = function () {
	      _this.setState({
	        showSlides: true,
	        showDonors: false,
	        parentCategoryName: "",
	        subCategoryName: "",
	        subCategorySubheader: "",
	        subCategoryDescription: ""
	      });
	    };
	
	    _this.initDonors = function () {
	      var includes = [];
	      if (_lodash2.default.has(_this.props.module, 'contents.include_categories')) {
	        includes = _this.props.module.contents.include_categories;
	      }
	      _this._donors = (0, _donorHelpers.donorsIncluded)(_this.props.donors.donorCategories, includes);
	      var cat = _this._donors[0];
	      var parent = _lodash2.default.find(_this.props.donors.donorCategories, { id: Number(cat.parent_category) });
	
	      if (parent) {
	        _this._parentCategoryName = parent.name;
	        _this.setState({
	          parentCategoryName: parent.name,
	          subCategoryName: cat.name,
	          subCategorySubheader: cat.subheader,
	          subCategoryDescription: cat.description
	        });
	      }
	    };
	
	    _this.cycleIndex = function () {
	      var cycleIndex = _this.state.cycleIndex;
	      if (cycleIndex === 100) {
	        cycleIndex = 0;
	      }
	      _this.setState({
	        cycleIndex: ++cycleIndex
	      });
	    };
	
	    _this.cycleSlideIndex = function () {
	      var dd = _this.state.donorData;
	      dd.name = "";
	      _this.clearDonorData();
	      _this.setState({
	        donorData: dd
	      });
	    };
	
	    _this.cycleDonorIndex = function () {
	
	      if (_this._endOfDonorLoop === true) {
	        _this._categoryCurrent++;
	        _this._donorIndex = 0;
	        if (_this._categoryCurrent === _this._donors.length) {
	          //end of donor categories, reset entire loop
	          _this._categoryCurrent = 0;
	          if (_this._resetLoopOnStart === true) {
	            _this._manualSlidesIndex = 0; //which manual slide entry
	            _this._manualSlidesInnerIndex = -1; //which manual slide within entry
	            //console.log("EXTRA LOOP");
	            _this._endOfDonorLoop = false;
	            return _this.metaCycle(false);
	          }
	        }
	      }
	
	      var total = _this._columns * _this._rows;
	      var start = _this._donorIndex * total;
	      // USE THIS LOGIC FOR PARENT CATEGORY NAME
	      var cat = _this._donors[_this._categoryCurrent];
	      //set to static parent category name
	      _this.setState({
	        parentCategoryName: _this._parentCategoryName,
	        subCategoryName: cat.name,
	        subCategorySubheader: cat.subheader,
	        subCategoryDescription: cat.description
	      });
	
	      if (!cat.donors[start]) {
	        start = 0;
	        _this._donorIndex = 0;
	      }
	
	      _this._endOfDonorLoop = false;
	      var end = start + total;
	      if (!cat.donors[end]) {
	        end = cat.donors.length;
	        _this._endOfDonorLoop = true;
	        _this._donorIndex = 0;
	      } else {
	        _this._donorIndex++;
	      }
	
	      var donorsSliced = cat.donors.slice(start, end);
	      var perColumn = 0;
	
	      //distribute end page logic for empty units in last row
	      if (_this._endOfDonorLoop === true) {
	        var dLength = donorsSliced.length;
	        var extraSpaces = 0; //default to 0
	        perColumn = Math.ceil(dLength / _this._columns);
	        if (perColumn * _this._columns > dLength) {
	          //extra spaces on last row required
	          extraSpaces = perColumn * _this._columns - dLength;
	        }
	        var normalSpaces = _this._rows - perColumn; //spaces to add on each normal row
	        var lastSpaces = normalSpaces + extraSpaces; //spaces to add on last row
	
	        for (var i = 0; i < _this._columns; i++) {
	          if (i < _this._columns - 1) {
	            //rows prior to last
	            for (var a = 0; a < normalSpaces; a++) {
	              donorsSliced.splice(i * _this._rows + perColumn, 0, { name: "" });
	            }
	          } else {
	            for (var b = 0; b < lastSpaces; b++) {
	              donorsSliced.splice(i * _this._rows + perColumn, 0, { name: "" });
	            }
	          }
	        }
	      }
	      _this.setState({
	        donorData: {
	          donors: donorsSliced,
	          name: cat.name
	        }
	      });
	    };
	
	    _this.state = {
	      donorData: null,
	      cycleIndex: 0,
	      showDonors: true,
	      showSlides: false,
	      slideImage: "",
	      parentCategoryName: "", //state based to support setting to empty string on fades
	      subCategoryname: "",
	      subCategorySubheader: "",
	      subCategoryDescription: ""
	    };
	    _this._categoryCurrent = -1;
	    _this._endOfDonorLoop = true;
	    _this._donors = null;
	    _this._manualSlidesIndex = 0; //which manual slide entry
	    _this._manualSlidesInnerIndex = -1; //which manual slide within entry
	
	    //defaults
	    _this._columns = 3;
	    _this._rows = 8;
	    _this._fontColor = "#ffffff";
	    _this._backdropColor = "#000000";
	    _this._footerText = "";
	    _this._parentCategoryName = ""; //used to stash name so state can switch to empty string
	    _this._ni_options = {};
	    _this._metaCycleTimeout = null;
	    _this._listCycleTime = 8000;
	    _this._marginRight = _this.props.screen.sv.width * 0.0375;
	
	    _this._parentCategoryNameStyle = {};
	    _this._subCategoryNameStyle = {};
	    _this._subCategorySubheaderStyle = {};
	    _this._subCategoryDescriptionStyle = {};
	    _this._nameListStyle = {};
	    _this._footerTextStyle = {};
	
	    _this._parentCategoryNameOffset = {};
	    _this._subCategoryNameOffset = {};
	    _this._subCategorySubheaderOffset = {};
	    _this._subCategoryDescriptionOffset = {};
	    _this._nameListOffset = {};
	    _this._footerTextOffset = {};
	    _this._titleDividerLineOffset = {};
	    _this._nameListHeight = 0;
	    _this._resetLoopOnStart = true;
	
	    //safe overrides
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options')) {
	      _this._ni_options = _this.props.module.contents.ni_options;
	      _this._resetLoopOnStart = _this._ni_options.resetInsertLoop;
	      _this.setFontAttributes(_this._parentCategoryNameStyle, _this.props.module.contents.ni_options.format.parent_category_name);
	      _this.setFontAttributes(_this._subCategoryNameStyle, _this.props.module.contents.ni_options.format.sub_category_name);
	      _this.setFontAttributes(_this._subCategorySubheaderStyle, _this.props.module.contents.ni_options.format.sub_category_subheader);
	      _this.setFontAttributes(_this._subCategoryDescriptionStyle, _this.props.module.contents.ni_options.format.sub_category_description);
	      _this.setFontAttributes(_this._nameListStyle, _this.props.module.contents.ni_options.format.name_list);
	      _this.setFontAttributes(_this._footerTextStyle, _this.props.module.contents.ni_options.format.footer_text);
	      _this._sumH = _this.props.module.contents.ni_options.topMargin * .01 * _this.props.screen.screenHeight; //adjust for base offset
	      _this.setOffset(_this._parentCategoryNameOffset, _this.props.module.contents.ni_options.format.parent_category_name, 0);
	      _this.setOffset(_this._subCategoryNameOffset, _this.props.module.contents.ni_options.format.sub_category_name, 0);
	      _this.setOffset(_this._subCategorySubheaderOffset, _this.props.module.contents.ni_options.format.sub_category_subheader, 0);
	      _this.setOffset(_this._subCategoryDescriptionOffset, _this.props.module.contents.ni_options.format.sub_category_description, 0);
	      _this._titleDividerLineOffset.val = _this._sumH;
	      _this.setOffset(_this._nameListOffset, _this.props.module.contents.ni_options.format.name_list, _this.props.module.contents.ni_options.dividerLineMargin);
	      _this._footerTextOffset.val = _this.props.screen.screenHeight - _this.props.module.contents.ni_options.format.footer_text.height * .01 * _this.props.screen.screenHeight;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options.columns')) {
	      _this._columns = _this.props.module.contents.ni_options.columns;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options.rows')) {
	      _this._rows = _this.props.module.contents.ni_options.rows;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options.fontColor')) {
	      _this._fontColor = _this.props.module.contents.ni_options.fontColor;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options.rows')) {
	      _this._backdropColor = _this.props.module.contents.ni_options.backdropColor;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options.footerText')) {
	      _this._footerText = _this.props.module.contents.ni_options.footerText;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.cycle_time')) {
	      _this._listCycleTime = _this.props.module.contents.cycle_time * 1000;
	    }
	    if (_lodash2.default.has(_this.props.module, 'contents.ni_options.columnMargin')) {
	      _this._marginRight = _this.props.module.contents.ni_options.columnMargin * 0.01 * _this.props.screen.r16_9.width;
	    }
	    return _this;
	  }
	
	  _createClass(DonorListPassive, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      //checkData(this.props.module);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initDonors();
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.metaCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      clearTimeout(this._metaCycleTimeout);
	      this._metaCycleTimeout = null;
	    }
	  }, {
	    key: 'setMetaCycleTimeout',
	    value: function setMetaCycleTimeout(time, cycleIndex) {
	      var _this2 = this;
	
	      if (this._metaCycleTimeout) {
	        clearTimeout(this._metaCycleTimeout);
	        this._metaCycleTimeout = null;
	      }
	
	      this._metaCycleTimeout = setTimeout(function () {
	        _this2.metaCycle(cycleIndex);
	      }, time);
	    }
	
	    //called for every cycle to determine action
	
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if ((0, _shared.shallowEqual)(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	
	    //for unique transition keys
	
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.donorData) {
	        return null;
	      }
	      var sDims = {
	        height: this.props.screen.sv.height, //1080,
	        width: this.props.screen.sv.width //1920
	      };
	      var modifier = .6;
	      sDims.fsTitle = sDims.height * 0.05556 * modifier; //60
	      sDims.fsSubheader = sDims.height * 0.03333 * modifier; //36
	      sDims.left = this.props.screen.sv.left;
	
	      // let debugBoxStyle = {
	      //     position: 'absolute', 
	      //     backgroundColor: 'black',
	      //     opacity: .5,
	      //     width: this.props.screen.screenWidth,
	      //     height: this.props.screen.screenHeight / 2,
	      //     top: 0,
	      //     left: 0
	      //  }
	
	      return _react2.default.createElement(
	        'div',
	        { className: this._fontClass, style: { width: '100vw', height: '100vh', position: 'relative', color: this._fontColor } },
	        _react2.default.createElement('div', { style: { position: 'absolute', left: sDims.left, top: 0, opacity: this._ni_options.backdropOpacity * .01, backgroundColor: this._backdropColor, width: sDims.width, height: sDims.height } }),
	        this._ni_options.showTitleDivider ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showDonors },
	            this.state.showDonors ? _react2.default.createElement('div', { style: { position: 'absolute', left: sDims.width * .05 + sDims.left, top: this._titleDividerLineOffset.val, backgroundColor: this._fontColor, opacity: 1, width: sDims.width * .9, height: sDims.height * .0025 } }) : null
	          )
	        ) : null,
	        this._ni_options.format.parent_category_name.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.parentCategoryName },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._parentCategoryNameStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._parentCategoryNameOffset.val, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.parentCategoryName
	              )
	            )
	          )
	        ) : null,
	        this._ni_options.format.sub_category_name.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.subCategoryName },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._subCategoryNameStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryNameOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.subCategoryName
	              )
	            )
	          )
	        ) : null,
	        this._ni_options.format.sub_category_subheader.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.subCategorySubheader },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._subCategorySubheaderStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategorySubheaderOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.subCategorySubheader
	              )
	            )
	          )
	        ) : null,
	        this._ni_options.format.sub_category_description.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.subCategoryDescription },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._subCategoryDescriptionStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryDescriptionOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.subCategoryDescription
	              )
	            )
	          )
	        ) : null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.cycleIndex },
	            this.state.showSlides ? _react2.default.createElement(
	              'div',
	              { style: { position: 'absolute', left: sDims.left, top: 0, opacity: 1, width: sDims.width, height: sDims.height } },
	              _react2.default.createElement('img', { alt: "Slide", src: this.state.slideImage, style: { width: sDims.width, height: sDims.height } })
	            ) : null
	          )
	        ),
	        this._ni_options.format.name_list.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.cycleIndex },
	            this.state.showDonors ? _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._nameListStyle, { position: 'absolute', left: 0, top: 0, opacity: 1, width: sDims.width, height: sDims.height }) },
	              _react2.default.createElement(
	                'div',
	                { style: { position: 'absolute', left: sDims.left + sDims.width * .05, top: this._nameListOffset.val, width: sDims.width * .9, height: sDims.height * .8 } },
	                this.state.donorData ? _react2.default.createElement(_DonorFullPage2.default, {
	                  fontclass: this._ni_options.format.name_list.font,
	                  height: this.props.module.contents.ni_options.format.name_list.height * .01 * this.props.screen.screenHeight,
	                  width: sDims.width * .9,
	                  rows: this._rows,
	                  columns: this._columns,
	                  donorData: this.state.donorData.donors,
	                  screen: this.props.screen,
	                  sort: 'column',
	                  overrideFontSize: this._nameListStyle.fontSize,
	                  overrideMarginRight: this._marginRight,
	                  custom1x2: this.props.content.settings.custom_vars.custom1x2 ? true : false
	                }) : _react2.default.createElement('span', null)
	              ),
	              this.props.module.contents.ni_options.format.footer_text.visible ? _react2.default.createElement(
	                'span',
	                { style: Object.assign({}, this._footerTextStyle, { left: sDims.width * .05 + sDims.left, marginRight: 0, position: 'absolute', width: sDims.width * .9, top: this._footerTextOffset.val }) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this._footerText
	                )
	              ) : null
	            ) : null
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return DonorListPassive;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var mod = state.content.dm_active[state.active_module];
	  var isIdle = (0, _shared.parseStringParam)(window.location.href, "idle");
	  if (isIdle === 'true') {
	    mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data
	    mod = _lodash2.default.find(state.content.dm_active, { id: mod.id }); //TODO: should populate the module loop?
	  }
	  return {
	    screen: state.screen,
	    module: mod,
	    donors: state.donors,
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DonorListPassive);

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonorName = function (_Component) {
	    _inherits(DonorName, _Component);
	
	    function DonorName(props) {
	        _classCallCheck(this, DonorName);
	
	        var _this = _possibleConstructorReturn(this, (DonorName.__proto__ || Object.getPrototypeOf(DonorName)).call(this, props));
	
	        _this.handleRemove = function (timeout) {
	            clearTimeout(_this._fadeOut);
	            _this._fadeOut = setTimeout(function () {
	                if (!_this._inRemoveQueue) {
	                    _this._inRemoveQueue = true;
	                    _this.props.removeQueueAdd(_this._id);
	                }
	                if (_this.props.allowRemoveRequest(_this._id) === true) {
	                    // this.props.releaseGridPoint(this.props.id); //send index!!!
	                    // this.setState({
	                    //     fadeState: 3
	                    // })
	                    // this._removeCurrentNameTimeout = setTimeout(() => {
	                    //     this.props.removeCurrentName(this.props.id)
	                    // }, 3000) //allow time for fadeout
	                    _this.removeName();
	                } else {
	                    _this.handleRemove(1000);
	                }
	            }, timeout);
	        };
	
	        _this.removeName = function () {
	            _this.props.releaseGridPoint(_this.props.id); //send index!!!
	            _this.setState({
	                fadeState: 3
	            });
	            _this._removeCurrentNameTimeout = setTimeout(function () {
	                _this.props.removeCurrentName(_this.props.id);
	            }, 3000); //allow time for fadeout
	        };
	
	        _this.handleGridCheck = function () {
	            clearTimeout(_this._checkGridTimeout);
	            _this._checkGridTimeout = setTimeout(function () {
	
	                var width = _this._nameRef[0].getBoundingClientRect().width;
	                var height = _this._nameRef[0].getBoundingClientRect().height;
	
	                var rX = void 0,
	                    rY = void 0;
	
	                if (_this.props.avoidBezel === true) {
	                    var hQ = void 0,
	                        vQ = void 0;
	                    if (_this.props.allowedScreens.enabled === true) {
	                        // console.log('allowedScreens', this.props.allowedScreens);
	                        hQ = _this.props.allowedScreens.allowedH[Math.floor(Math.random() * _this.props.allowedScreens.allowedH.length)];
	                        vQ = _this.props.allowedScreens.allowedV[Math.floor(Math.random() * _this.props.allowedScreens.allowedV.length)];
	                        // console.log('hQ', hQ);
	                        // console.log('vQ', vQ);
	                    } else {
	                        hQ = (0, _shared.getRandomInt)(0, _this.props.hScreens - 1);
	                        vQ = (0, _shared.getRandomInt)(0, _this.props.vScreens - 1);
	                    }
	                    var minX = hQ / _this.props.hScreens * _this.props.width;
	                    var minY = vQ / _this.props.vScreens * _this.props.height;
	
	                    rX = (0, _shared.randomRangeFloat)(minX + _this.props.edgeMargin, minX + _this.props.width / _this.props.hScreens - _this.props.edgeMargin - width);
	                    rY = (0, _shared.randomRangeFloat)(minY + _this.props.edgeMargin, minY + _this.props.height / _this.props.vScreens - _this.props.edgeMargin - height);
	                } else {
	                    rX = (0, _shared.randomRangeFloat)(_this.props.edgeMargin, _this.props.width - _this.props.edgeMargin - width);
	                    rY = (0, _shared.randomRangeFloat)(_this.props.edgeMargin, _this.props.height - _this.props.edgeMargin - height);
	                }
	
	                _this._rectInfo = {
	                    top: rY,
	                    left: rX,
	                    right: rX + width,
	                    bottom: rY + height
	                };
	
	                var trySetGrid = _this.props.trySetGrid(_this.props.id, _this._rectInfo);
	                if (trySetGrid.success === true) {
	                    _this._gridIndex = trySetGrid.gridIndex;
	                    _this.setState({
	                        offScreen: false,
	                        top: _this._rectInfo.top,
	                        right: _this._rectInfo.left,
	                        fadeState: 1
	                    });
	                    _this._cycleTimeout = setTimeout(function () {
	                        _this.props.createDonorName(); //creates next donor name
	                    }, _this.props.cycleTime);
	                    _this._startFadeIn = setTimeout(function () {
	                        //timeout used so fade class is not added on first frame
	                        _this.setState({
	                            fadeState: 2
	                        });
	                    }, 10);
	                } else {
	                    _this._checkCount++;
	                    _this.handleGridCheck();
	                }
	            }, 20);
	        };
	
	        _this.state = {
	            offScreen: true,
	            top: 0,
	            right: 0,
	            fadeState: 0,
	            contentStage: 0 //0 ready to fade out, 1 fade out and go to 2, 2 ready to fade in
	        };
	        _this._nameRef = [];
	        _this._checkGridTimeout = null;
	        _this._removeCurrentNameTimeout = null;
	        _this._startFadeIn = null;
	        _this._checkCount = 0;
	        _this._rectInfo = null;
	        _this._gridIndex = null; //for proper removal from grid
	        _this._id = Math.floor(Math.random() * 10000);
	        _this._inRemoveQueue = false;
	        return _this;
	    }
	
	    _createClass(DonorName, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleGridCheck();
	            this.handleRemove(this.props.fadeOutTime);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.forceFadeOut !== this.props.forceFadeOut && this.props.forceFadeOut === true) {
	
	                clearTimeout(this._checkGridTimeout);
	                clearTimeout(this._fadeOut);
	                clearTimeout(this._startFadeIn);
	                clearTimeout(this._cycleTimeout);
	                clearTimeout(this._removeCurrentNameTimeout);
	                this._checkGridTimeout = null;
	                this._fadeOut = null;
	                this._startFadeIn = null;
	                this._cycleTimeout = null;
	                this._removeCurrentNameTimeout = null;
	                this.removeName();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.setState({
	                offScreen: true //necessary?
	            });
	            clearTimeout(this._checkGridTimeout);
	            clearTimeout(this._fadeOut);
	            clearTimeout(this._startFadeIn);
	            clearTimeout(this._cycleTimeout);
	            clearTimeout(this._removeCurrentNameTimeout);
	            this._checkGridTimeout = null;
	            this._fadeOut = null;
	            this._startFadeIn = null;
	            this._cycleTimeout = null;
	            this._removeCurrentNameTimeout = null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var style = {
	                position: 'absolute',
	                whiteSpace: 'nowrap',
	                top: this.state.top,
	                left: this.state.right,
	                fontSize: this.props.fontSize,
	                fontFamily: 'Roboto'
	            };
	            var className = "";
	            switch (this.state.fadeState) {
	                case 0:
	                    className = "opacity0";
	                    break;
	                case 1:
	                    className = "opacity0small";
	                    break;
	                case 2:
	                    className = "fadeablein";
	                    break;
	                case 3:
	                    className = "fadeableout";
	                    break;
	                default:
	                    break;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: className, ref: function ref(el) {
	                        return _this2._nameRef[0] = el;
	                    }, style: style },
	                _react2.default.createElement(
	                    'span',
	                    { style: { margin: this.props.margin } },
	                    _react2.default.createElement(_BRSpan2.default, { str: this.props.name })
	                )
	            );
	        }
	    }]);
	
	    return DonorName;
	}(_react.Component);
	
	exports.default = DonorName;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux';
	
	
	// import { loopIndex } from '../../utils/shared';
	
	var DonorName = function (_Component) {
	    _inherits(DonorName, _Component);
	
	    function DonorName(props) {
	        _classCallCheck(this, DonorName);
	
	        var _this = _possibleConstructorReturn(this, (DonorName.__proto__ || Object.getPrototypeOf(DonorName)).call(this, props));
	
	        _this.switchNameStatus = function (status) {
	            _this.setState({
	                show: status
	            });
	        };
	
	        _this.state = {
	            show: false
	        };
	        return _this;
	    }
	
	    _createClass(DonorName, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _CSSTransitionGroup2.default,
	                {
	                    component: 'div',
	                    transitionName: 'slowfadedelay',
	                    transitionEnterTimeout: 0,
	                    transitionLeaveTimeout: 0 },
	                _react2.default.createElement(
	                    'div',
	                    { key: this.state.show },
	                    this.state.show ? _react2.default.createElement(
	                        'span',
	                        { style: Object.assign({}, this.props.style, { fontSize: this.props.style.fontSize + 'vh', fontFamily: 'Roboto' }) },
	                        _react2.default.createElement(_BRSpan2.default, { str: this.props.name })
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return DonorName;
	}(_react.Component);
	
	exports.default = DonorName;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _DonorName = __webpack_require__(394);
	
	var _DonorName2 = _interopRequireDefault(_DonorName);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import donorData from '../../test/donorData';
	
	
	var DonorSea = function (_Component) {
	    _inherits(DonorSea, _Component);
	
	    function DonorSea(props) {
	        _classCallCheck(this, DonorSea);
	
	        var _this = _possibleConstructorReturn(this, (DonorSea.__proto__ || Object.getPrototypeOf(DonorSea)).call(this, props));
	
	        _this.handleKeyDown = function (event) {
	            switch (event.key) {
	                default:
	                    break;
	            }
	        };
	
	        _this.removeQueueAdd = function (id) {
	            _this._removeQueue.push(id);
	        };
	
	        _this.allowRemoveRequest = function (id) {
	            if (_this._allowRemove === true) {
	                if (id === _this._removeQueue[0]) {
	                    //only allow first item in queue to dequeue
	                    _this._removeQueue.shift();
	                    _this._allowRemove = false;
	                    clearTimeout(_this._allowRemoveTimeout);
	                    _this._allowRemoveTimeout = setTimeout(function () {
	                        _this._allowRemove = true;
	                    }, 500);
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                return false;
	            }
	        };
	
	        _this.prepareDonors = function () {
	
	            var sortedCategories = (0, _donorHelpers.donorsIncluded)(_this.props.donors.donorCategories, _this.props.active_module_obj.contents.include_categories);
	            var currentRank = _this.props.config.ranks[0];
	
	            //add rank to each donor so it can be referenced for sizing and duration
	            _lodash2.default.forEach(sortedCategories, function (sc) {
	
	                //back fill any missing rank configurations
	                if (currentRank.rank !== sc.rank) {
	                    //!_.find(ranks, {rank: sc.rank})
	                    if (_lodash2.default.find(_this.props.config.ranks, { rank: sc.rank })) {
	
	                        currentRank = _lodash2.default.find(_this.props.config.ranks, { rank: sc.rank });
	                    }
	                }
	                _lodash2.default.forEach(sc.donors, function (donor) {
	                    donor.rank = sc.rank;
	                    donor.fontSize = currentRank.fontSize;
	                    donor.duration = currentRank.duration;
	                });
	            });
	
	            var donorArray = [];
	
	            _lodash2.default.forEach(sortedCategories, function (category, key) {
	                category.donors = _lodash2.default.orderBy(category.donors, ['sorting_name'], ['asc']);
	                //initialize array with the lowest level category
	                if (key === 0) {
	                    donorArray = category.donors;
	                } else {
	                    //distribute donors from category into full array
	                    donorArray = _this.distributeArrayToArray(category.donors, donorArray);
	                }
	            });
	
	            _this._donors = donorArray;
	        };
	
	        _this.distributeArrayToArray = function (arrA, arrB) {
	            var comboLength = arrB.length + arrA.length;
	            var span = comboLength / arrA.length;
	
	            for (var i = 0; i < arrA.length; i++) {
	                arrB.splice(Math.floor(span * i), 0, arrA[i]);
	            }
	
	            return arrB;
	        };
	
	        _this.createDonorName = function () {
	
	            if (_this._donorIndex > _this._donors.length - 1) {
	                _this._donorIndex = 0;
	            }
	
	            var donor = _this._donors[_this._donorIndex];
	            var currentNames = _this.state.currentNames;
	
	            currentNames.push({
	                id: donor.id,
	                name: donor.name,
	                rank: donor.rank,
	                duration: donor.duration,
	                fontSize: _this.props.height * donor.fontSize
	            });
	            _this._namesDisplayed++;
	            _this.setState({
	                currentNames: currentNames
	            });
	            _this._donorIndex = _this._donorIndex + 1;
	            if (_this._init === true) {
	                _this._initbuffer = _this._initbuffer + _this.props.config.cycleTime; //pad name fadeout
	            }
	        };
	
	        _this.releaseGridPoint = function (id) {
	            // let gridPoints = this._gridPoints;
	            var index = _lodash2.default.findIndex(_this._gridPoints, { id: id });
	            if (index > -1) {
	                _this._gridPoints.splice(index, 1);
	            } else {}
	            //console.log("debug: grid point release failed.", id);
	
	            //   console.log("Grid Point Length", this._gridPoints.length)
	            // this.setState({
	            //     gridPoints: gridPoints
	            // })
	        };
	
	        _this.removeCurrentName = function (id) {
	            var currentNames = _this.state.currentNames;
	            var index = _lodash2.default.findIndex(currentNames, { id: id });
	            if (index > -1) {
	                currentNames.splice(index, 1);
	            } else {
	                //console.log("debug: current name destroy failed.", index, id)
	            }
	            _this.setState({
	                currentNames: currentNames
	            });
	            //   console.log("Current Names: ", currentNames.length);
	        };
	
	        _this.trySetGrid = function (id, rect) {
	            var overlap = false;
	            _lodash2.default.forEach(_this._gridPoints, function (gp) {
	                if (_this.intersectRect(rect, gp.rect)) {
	                    overlap = true;
	                }
	            });
	            if (overlap === true) {
	                return { success: false, gridIndex: null };
	            }
	            //at this point the space is available
	            // let gridPoints = this.state.gridPoints;
	            _this._gridPoints.push({ id: id, rect: rect });
	            // this.setState({
	            //     gridPoints: gridPoints
	            // })
	            return { success: true, gridIndex: _this._gridPoints.length - 1 };
	        };
	
	        _this.intersectRect = function (r1, r2) {
	            return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
	        };
	
	        _this.renderDonorNames = function () {
	            return _this.state.currentNames.map(function (row, i) {
	                return _react2.default.createElement(_DonorName2.default, {
	                    key: row.id,
	                    id: row.id,
	                    fontSize: row.fontSize,
	                    trySetGrid: this.trySetGrid,
	                    createDonorName: this.createDonorName,
	                    height: this.props.height,
	                    width: this.props.width,
	                    name: row.name,
	                    cycleTime: this._init === true ? this.props.config.cycleTimeInit : this.props.config.cycleTime,
	                    fadeOutTime: this._init === true ? row.duration * 1000 : row.duration * 1000,
	                    edgeMargin: this.props.height * this.props.config.edgeMargin,
	                    margin: this.props.config.nameMargin * this.props.height,
	                    debug: this.debugCount,
	                    releaseGridPoint: this.releaseGridPoint,
	                    removeCurrentName: this.removeCurrentName,
	                    rank: row.rank,
	                    avoidBezel: true,
	                    hScreens: this.props.screensH,
	                    vScreens: this.props.screensV,
	                    allowRemoveRequest: this.allowRemoveRequest,
	                    removeQueueAdd: this.removeQueueAdd,
	                    allowedScreens: this.props.allowedScreens,
	                    forceFadeOut: this.props.contentStage === 1 ? true : false
	                });
	            }, _this);
	        };
	
	        _this.state = {
	            currentNames: [],
	            preparedDonors: []
	        };
	        _this._donorIndex = 0;
	        _this._donorsTotal = 0;
	        _this._ranks = null;
	        _this._init = true;
	        _this._namesDisplayed = 0;
	        _this._initbuffer = 0;
	        _this._allowRemove = true;
	        _this._removeQueue = [];
	        _this._gridPoints = [];
	        return _this;
	    }
	
	    _createClass(DonorSea, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.prepareDonors();
	            // this.createDonorName();
	            this._initTimeout = setTimeout(function () {
	                _this2._init = false;
	            }, this.props.config.initDuration);
	            document.addEventListener("keydown", this.handleKeyDown);
	            this._debugInterval = setInterval(function () {
	                _this2.props.handleStats(_this2.state.currentNames.length, _this2._namesDisplayed);
	            }, 1000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	            clearTimeout(this._initTimeout);
	            this._initTimeout = null;
	            this._allowRemoveTimeout = null;
	            clearInterval(this._debugInterval);
	            this._debugInterval = null;
	        }
	
	        // shouldComponentUpdate(prevProps){
	
	        // }
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.props.contentStage === 0) {
	                if (prevProps.contentStage === 2) {
	                    this.createDonorName();
	                }
	            } else if (this.props.contentStage === 1) {
	                if (prevProps.contentStage === 0) {
	                    this._removeQueue = []; //clear remove queue
	                    //console.log("CLEARING REMOVE QUEUE")
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { style: { color: this.props.config.textColor, position: 'absolute', top: this.props.top, left: this.props.left, width: this.props.width, height: this.props.height } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'relative' } },
	                    this.renderDonorNames()
	                )
	            );
	        }
	    }]);
	
	    return DonorSea;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var active_module_obj = state.content.dm_active[state.active_module];
	    if (!active_module_obj) {
	        console.log("No active donor sea module found");
	    }
	    return {
	        donors: state.donors,
	        active_module: state.active_module,
	        active_module_obj: active_module_obj
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DonorSea);

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _shared = __webpack_require__(4);
	
	var _DonorName = __webpack_require__(395);
	
	var _DonorName2 = _interopRequireDefault(_DonorName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonorSeaComponent = function (_Component) {
	  _inherits(DonorSeaComponent, _Component);
	
	  function DonorSeaComponent(props) {
	    _classCallCheck(this, DonorSeaComponent);
	
	    var _this = _possibleConstructorReturn(this, (DonorSeaComponent.__proto__ || Object.getPrototypeOf(DonorSeaComponent)).call(this, props));
	
	    _this.componentWillUnmount = function () {
	      clearTimeout(_this._fadeInTimeOutHandler);
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "l":
	          _this.setState({
	            showLines: !_this.state.showLines
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.setupDonors = function () {
	      try {
	        var donors = [];
	        var parentActive = {};
	        var rootFolder = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	        if (rootFolder !== null) {
	          rootFolder = Number(rootFolder);
	          parentActive = _lodash2.default.find(_this.props.content.story_categories, { id: rootFolder });
	        } else {
	          parentActive = _lodash2.default.find(_this.props.content.story_categories, function (folder) {
	            var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	            return type === "active";
	          });
	        }
	        var attractLoop = _lodash2.default.find(_this.props.content.story_categories, function (folder) {
	          var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	          return folder.parent_category === parentActive.id && type === "attract_loop_donor_lists";
	        });
	        var donorSeaFolder = _lodash2.default.find(_this.props.content.story_categories, function (folder) {
	          var type = _lodash2.default.get(folder.contents, 'custom_fields.folder_type.val.value', null);
	          return folder.parent_category === attractLoop.id && type === 'donor_lists';
	        });
	        var donorLists = _lodash2.default.filter(_this.props.content.story_categories, { parent_category: donorSeaFolder.id });
	
	        _lodash2.default.forEach(_this.props.donors.donorCategories, function (donorCategory) {
	          _lodash2.default.forEach(donorLists, function (dl) {
	            var folderModules = _lodash2.default.uniqBy(_lodash2.default.filter(_this.props.content.folder_modules, { folder: dl.id, model: "donor" }), 'module_id');
	            var folderModulesIds = _lodash2.default.map(folderModules, 'module_id');
	            var foundDonors = (0, _lodash2.default)(donorCategory.donors).filter(function (donor) {
	              return folderModulesIds.indexOf(donor.id) > -1;
	            }).map(function (dn) {
	              var folder = _lodash2.default.find(donorLists, { id: _lodash2.default.get(_lodash2.default.find(folderModules, { module_id: dn.id }), 'folder', null) });
	              // let folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	              var fontSize = _lodash2.default.get(folder, 'contents.custom_fields.font_size.val', 1);
	              dn.style = { fontSize: fontSize, position: "absolute" };
	              return dn;
	            }).value();
	            donors = donors.concat(foundDonors);
	          });
	        });
	
	        _this._sortedDonors = _lodash2.default.orderBy(donors, [function (donor) {
	          return donor.sorting_name.toLowerCase();
	        }], ['asc']);
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this.setupRegions = function () {
	      var _this$props = _this.props,
	          screensH = _this$props.screensH,
	          screensV = _this$props.screensV,
	          allowedScreens = _this$props.allowedScreens;
	
	      var regionWidth = _this.props.screen.screenWidth / screensH;
	      var regionHeight = _this.props.screen.screenHeight / screensV;
	      var totalRegions = screensH * screensV;
	
	      _this._regionWidth = regionWidth - regionWidth * _this._regionMarginFromEdges * 2;
	      _this._regionHeight = regionHeight - regionHeight * _this._regionMarginFromTopAndBottom * 2;
	
	      for (var i = 0; i < totalRegions; i++) {
	        // Verify for enabled and disabled display regions.
	        if (allowedScreens.enabled && allowedScreens.enabled === true) {
	          var horizontalRegion = Math.floor(i / screensV);
	          var verticalRegion = i % screensV;
	          if (allowedScreens.allowedH.indexOf(horizontalRegion) === -1) {
	            continue;
	          }
	
	          if (allowedScreens.allowedV.indexOf(verticalRegion) === -1) {
	            continue;
	          }
	        }
	
	        var top = i % screensV * regionHeight + regionHeight * _this._regionMarginFromTopAndBottom;
	        var left = Math.floor(i / screensV) * regionWidth + regionWidth * _this._regionMarginFromEdges;
	        _this._screenRegions.push({
	          style: {
	            position: "absolute",
	            left: left,
	            top: top,
	            width: _this._regionWidth,
	            height: _this._regionHeight
	          }
	        });
	      }
	
	      // console.log(this._screenRegions);
	    };
	
	    _this.setupDonorRows = function () {
	      try {
	        var donors = _this._sortedDonors;
	        var totalRegions = _this._screenRegions.length;
	        var rowDonors = [];
	        var rows = [];
	        var index = _this._lastCheckedDonor;
	        var regions = [];
	
	        var rowHeight = 0;
	        var rowWidth = 0;
	        var rowWidthCondition = 0;
	        var totalRowHeight = 0;
	        var tmpRow = [];
	
	        for (var i = 0; i < totalRegions; i++) {
	          do {
	            // if (donors[index].width > this._regionWidth) {
	            //   this._donorsLeftBehind.push(donors[index]);
	            //   index = loopIndex(index, 0, donors.length - 1, "forward");
	            //   continue;
	            // }
	
	            if (rowWidthCondition + donors[index].width > _this._regionWidth) {
	              totalRowHeight += rowHeight + _this._regionHeight * _this._minMarginBetweenNamesVertically;
	              // let totalRowHeightMinusLastMargin = totalRowHeight - (this._regionHeight * this._minMarginBetweenNamesVertically);
	
	              // Row Width Correction.
	              // rowWidth = rowWidth - (this._regionWidth * this._minMarginBetweenNamesHorizontally);
	              if (totalRowHeight < _this._regionHeight) {
	                var marginFromTop = rows.length === 0 ? 0 : _this._regionHeight * _this._minMarginBetweenNamesVertically;
	                rows.push({
	                  donors: rowDonors,
	                  height: rowHeight,
	                  width: rowWidth,
	                  marginFromTop: marginFromTop
	                });
	              }
	
	              tmpRow = [{
	                donors: rowDonors,
	                height: rowHeight,
	                width: rowWidth,
	                marginFromTop: 0
	              }];
	              rowDonors = [];
	              rowWidth = 0;
	              rowWidthCondition = 0;
	              rowHeight = totalRowHeight < _this._regionHeight ? 0 : rowHeight;
	            } else {
	              donors[index].actual_index = index;
	              rowDonors.push(_lodash2.default.cloneDeep(donors[index]));
	              _this._allDonorsPushed.push(_lodash2.default.cloneDeep(donors[index]));
	              rowHeight = rowHeight > donors[index].height ? rowHeight : donors[index].height;
	              rowWidth += donors[index].width;
	              rowWidthCondition += donors[index].width * (1 + _this._longDonorFactor) + _this._regionWidth * _this._minMarginBetweenNamesHorizontally;
	              index = (0, _shared.loopIndex)(index, 0, donors.length - 1, "forward");
	            }
	          } while (totalRowHeight < _this._regionHeight);
	
	          regions[i] = {
	            rows: rows,
	            style: Object.assign({}, _this._screenRegions[i].style)
	          };
	
	          totalRowHeight = tmpRow && tmpRow.length > 0 ? tmpRow[0].height : 0;
	          rows = tmpRow && tmpRow.length > 0 ? tmpRow : [];
	
	          // If there's a temp row and there are no more regions availables,
	          // Set the lastCheckedDonor equal to the current donor index (last index checked)
	          // Minus the length of the donors contained in the temp row which will be wasted
	          if (i === totalRegions - 1 && tmpRow.length > 0) {
	            if (index < tmpRow[0].donors.length) {
	              _this._lastCheckedDonor = tmpRow[0].donors[0].actual_index;
	            } else {
	              _this._lastCheckedDonor = index - tmpRow[0].donors.length;
	            }
	          } else {
	            _this._lastCheckedDonor = index;
	          }
	
	          // console.log("last donor index", index);
	          // console.log("converted", this._lastCheckedDonor);
	
	          rowWidth = 0;
	          rowHeight = 0;
	          tmpRow = [];
	        }
	        // console.log("Last Checked Donor Index", this._lastCheckedDonor);
	        // console.log("Donors Left Behind", this._donorsLeftBehind);
	        return regions;
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this.setupRegionRows = function (rows) {
	      var height = 0;
	      var regions = _this._screenRegions;
	      var rIndex = 0;
	
	      for (var i = 0; i < regions.length; i++) {
	        height = 0;
	        regions[i]['rows'] = [];
	        do {
	          height += rows[rIndex].height;
	          if (rIndex + 1 >= rows.length) {
	            break;
	          }
	
	          regions[i].rows.push(rows[rIndex]);
	
	          if (height + rows[rIndex + 1].height > _this._regionHeight) {
	            break;
	          }
	
	          rIndex++;
	        } while (height < _this._regionHeight);
	      }
	
	      return regions;
	    };
	
	    _this.randomizeDonorPositions = function (regions) {
	      try {
	        var donors = [];
	        for (var i = 0; i < regions.length; i++) {
	          var rowTopAccum = 0;
	          for (var j = 0; j < regions[i].rows.length; j++) {
	            var donorLeftAccum = 0;
	            var occupiedSpace = 0;
	
	            var marginFromTop = regions[i].rows[j].marginFromTop;
	            // console.log('margin from top', marginFromTop);
	            var totalEmptyRowSpace = _this._regionWidth - regions[i].rows[j].width;
	            var emptyRowSpaceLeft = totalEmptyRowSpace;
	            for (var k = 0; k < regions[i].rows[j].donors.length; k++) {
	              // Top
	              var maxTopPadding = regions[i].rows[j].height - regions[i].rows[j].donors[k].height;
	              var minTopPadding = 0;
	              var randomTopPadding = 0;
	              if (maxTopPadding > 0) {
	                randomTopPadding = Math.random() * (maxTopPadding - minTopPadding) + minTopPadding;
	              }
	              var top = regions[i].style.top + rowTopAccum + randomTopPadding + marginFromTop * j;
	
	              // Left
	              var max = emptyRowSpaceLeft / (regions[i].rows[j].donors.length - k);
	              var min = _this._minMarginBetweenNamesHorizontally * _this._regionWidth >= max ? max : _this._minMarginBetweenNamesHorizontally * _this._regionWidth;
	              var randomLeft = Math.random() * (max - min) + min;
	              occupiedSpace += randomLeft;
	              emptyRowSpaceLeft -= randomLeft;
	              var left = regions[i].style.left + donorLeftAccum + occupiedSpace;
	              donorLeftAccum += regions[i].rows[j].donors[k].width;
	
	              var newStyle = Object.assign({}, regions[i].rows[j].donors[k].style);
	              newStyle.top = top;
	              newStyle.left = left;
	              regions[i].rows[j].donors[k].style = newStyle;
	              donors.push(Object.assign({}, regions[i].rows[j].donors[k]));
	            }
	            rowTopAccum += regions[i].rows[j].height;
	          }
	        }
	
	        // console.log('randomized donors', donors);
	        return donors;
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this.renderLines = function () {
	      var rows = Array.apply(null, { length: _this._rowsPerRegion }).map(Number.call, Number);
	      var renderedRows = rows.map(function (i) {
	        var style = {
	          top: i * _this._rowsHeight,
	          border: "blue 5px solid",
	          position: "absolute",
	          width: "100%"
	        };
	
	        return _react2.default.createElement('div', { key: i, style: Object.assign({}, style) });
	      });
	
	      return renderedRows;
	    };
	
	    _this.renderWave = function () {
	      return _this._waveDonors.map(function (donor, i) {
	        return _react2.default.createElement(
	          'span',
	          { key: i, style: Object.assign({}, donor.style, { fontSize: donor.style.fontSize + 'vh' }) },
	          _react2.default.createElement(_BRSpan2.default, { str: donor.name })
	        );
	      });
	    };
	
	    _this.setupFadeInDonors = function (keepCurrentWave) {
	      for (var i = 0; i < _this._sortedDonors.length; i++) {
	        if (_this._sortedDonors[i].width > _this._regionWidth) {
	          _this._donorsLeftBehind.push(_this._sortedDonors[i]);
	        }
	      }
	
	      console.log(_this._donorsLeftBehind);
	
	      var shuffledDonors = [];
	      if (keepCurrentWave) {
	        if (_this._shuffledDonors.length > 0) {
	          _this._donorFadeInIndex = 0;
	          shuffledDonors = _this._shuffledDonors;
	        } else {
	          _this._donorFadeInIndex = 0;
	          var regions = _this.setupDonorRows();
	          var donors = _this.randomizeDonorPositions(regions);
	          shuffledDonors = _lodash2.default.shuffle(donors);
	          _this._shuffledDonors = shuffledDonors;
	        }
	      } else {
	        _this._donorFadeInIndex = 0;
	        var _regions = _this.setupDonorRows();
	        var _donors = _this.randomizeDonorPositions(_regions);
	        shuffledDonors = _lodash2.default.shuffle(_donors);
	        _this._shuffledDonors = shuffledDonors;
	        _this._haveDonorsBeenRendered = false;
	      }
	
	      _this.setState({
	        shuffledDonors: shuffledDonors
	      });
	
	      _this.setupFadeInInterval();
	    };
	
	    _this.setupFadeInInterval = function () {
	      try {
	        var shuffledDonors = _this._shuffledDonors;
	        var groupDonorNumber = Math.ceil(shuffledDonors.length / 20);
	
	        clearTimeout(_this._fadeInTimeOutHandler);
	        var timeout = _this._haveDonorsBeenRendered ? _this._timeToFadeDonorsIn / _this._shuffledDonors.length : 50;
	        // console.log("Fade In Timeout is", timeout);
	        _this._fadeInTimeOutHandler = setTimeout(function () {
	          if (_this._haveDonorsBeenRendered) {
	            if (shuffledDonors.length - _this._donorFadeInIndex < groupDonorNumber) {
	              groupDonorNumber = shuffledDonors.length - _this._donorFadeInIndex;
	            }
	            // let donorName = this._donorFadeInIndex;
	            try {
	              _this._donorComponentRef[_this._donorFadeInIndex].switchNameStatus(true);
	              // console.log("Fade Name In");
	            } catch (e) {
	              console.log(e);
	            }
	            // console.log("Fading in", this._donorFadeInIndex);
	            _this._donorFadeInIndex++;
	
	            if (_this._donorFadeInIndex <= _this._shuffledDonors.length - 1) {
	              _this.setupFadeInInterval();
	            } else {
	              _this._donorFadeInIndex = 0;
	              // this.setupFadeOutInterval();
	            }
	          } else {
	            _this.setupFadeInInterval();
	          }
	        }, timeout);
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this.setupFadeOutInterval = function () {
	      clearTimeout(_this._fadeOutTimeOutHandler);
	      _this._fadeOutTimeOutHandler = setTimeout(function () {
	        _this.setupFadeOutDonors();
	      }, _this._timeToKeepDonorsOnScreens);
	    };
	
	    _this.setupFadeOutDonors = function () {
	      clearTimeout(_this._fadeOutDonorsTimeoutHandler);
	      _this._fadeOutDonorsTimeoutHandler = setTimeout(function () {
	        try {
	          if (_this._donorComponentRef[_this._donorFadeInIndex]) {
	            _this._donorComponentRef[_this._donorFadeInIndex].switchNameStatus(false);
	          }
	          // console.log("Fade Out");
	        } catch (e) {
	          console.log(e);
	        }
	
	        // console.log("Fading out", this._donorFadeInIndex);
	        _this._donorFadeInIndex++;
	
	        if (_this._donorFadeInIndex < _this._shuffledDonors.length) {
	          _this.setupFadeOutDonors();
	        }
	      }, _this._timeToFadeDonorsOut / _this._shuffledDonors.length);
	    };
	
	    _this.preRenderDonors = function () {
	      var renderedDonors = _this._sortedDonors.map(function (donor, i) {
	        var donorStyle = {
	          fontSize: donor.style.fontSize + 'vh',
	          fontFamily: 'Roboto',
	          color: "#000000",
	          opacity: 0,
	          position: "absolute"
	        };
	        return _react2.default.createElement(
	          'span',
	          { key: i, ref: function ref(el) {
	              return _this._donorRefs[i] = el;
	            }, style: Object.assign({}, donorStyle) },
	          _react2.default.createElement(_BRSpan2.default, { str: donor.name })
	        );
	      });
	
	      return renderedDonors;
	    };
	
	    _this._donorRefs = [];
	    _this._sortedDonors = [];
	    _this._screenRegions = [];
	    _this._currentWave = [];
	    _this._timeToFadeDonors = _lodash2.default.get(_this.props, 'timeToFadeDonors', 5000);
	    _this._timeToKeepDonorsOnScreens = 25000;
	    _this._regionMargin = 0.5;
	    _this._regionWidth = null;
	    _this._regionHeight = null;
	    _this._highestDonorFound = 0;
	    _this._narrowestDonorFound = 1000;
	    _this._widestDonorFound = 0;
	    _this._rowsPerRegion = 0;
	    _this._rowsHeight = 0;
	    _this._waveDonors = [];
	    _this._preparedDonors = [];
	    _this._donorsToFade = [];
	    _this._donorFadeInIndex = 0;
	    _this._lastCheckedDonor = 0;
	    _this._fadeInTimeOutHandler = null;
	    _this._shuffledDonors = [];
	    _this._renderedDonors = [];
	    _this._donorComponentRef = [];
	    _this._haveDonorsBeenRendered = false;
	    _this._timeToFadeDonorsIn = _lodash2.default.get(_this.props, 'timeToFadeDonorsIn', 3000);
	    _this._timeToFadeDonorsOut = _lodash2.default.get(_this.props, 'timeToFadeDonorsOut', 3000);
	
	    // Margin Percentage
	    var regionMarginFromEdges = _lodash2.default.get(_this.props, 'regionMarginFromEdges', 2);
	    var regionMarginFromTopAndBottom = _lodash2.default.get(_this.props, 'regionMarginFromTopAndBottom', 2);
	    var minMarginBetweenNamesHorizontally = _lodash2.default.get(_this.props, 'minMarginBetweenNamesHorizontally', 5);
	    var minMarginBetweenNamesVertically = _lodash2.default.get(_this.props, 'minMarginBetweenNamesVertically', 3);
	    _this._regionMarginFromEdges = regionMarginFromEdges / 100;
	    _this._regionMarginFromTopAndBottom = regionMarginFromTopAndBottom / 100;
	    _this._minMarginBetweenNamesHorizontally = minMarginBetweenNamesHorizontally / 100;
	    _this._minMarginBetweenNamesVertically = minMarginBetweenNamesVertically / 100;
	    _this._longDonorFactor = 0.025;
	
	    _this._allDonorsPushed = [];
	    _this._donorsLeftBehind = [];
	
	    _this.setupDonors();
	    _this.state = {
	      finishedPreRender: false,
	      showLines: false,
	      shuffledDonors: []
	    };
	    return _this;
	  }
	
	  _createClass(DonorSeaComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      try {
	        document.addEventListener("keydown", this.handleKeyDown);
	        setTimeout(function () {
	          if (_this2._donorRefs.length > 0 && _this2.state.finishedPreRender === false) {
	            for (var i = 0; i < _this2._donorRefs.length; i++) {
	              _this2._sortedDonors[i].height = _this2._donorRefs[i].offsetHeight;
	              _this2._sortedDonors[i].width = _this2._donorRefs[i].offsetWidth;
	              _this2._highestDonorFound = _this2._sortedDonors[i].height > _this2._highestDonorFound ? _this2._sortedDonors[i].height : _this2._highestDonorFound;
	              _this2._widestDonorFound = _this2._sortedDonors[i].width > _this2._widestDonorFound ? _this2._sortedDonors[i].width : _this2._widestDonorFound;
	              _this2._narrowestDonorFound = _this2._sortedDonors[i].width < _this2._narrowestDonorFound ? _this2._sortedDonors[i].width : _this2._narrowestDonorFound;
	            }
	
	            _this2.setupRegions();
	            // console.log("sorted donors", this._sortedDonors);
	            // console.log("refs", this._donorRefs);
	            // console.log("references", this._donorComponentRef);
	            // let regions = this.setupDonorRows();
	            // let donors = this.randomizeDonorPositions(regions);
	            // let shuffledDonors = _.shuffle(donors);
	            // this._shuffledDonors = shuffledDonors;
	
	            _this2.setState({
	              finishedPreRender: true,
	              shuffledDonors: []
	            });
	          }
	          _this2.props.setDonorsReady(true);
	        }, 2500);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // console.log("component updated");
	      // console.log("All Donors Pushed", JSON.stringify(this._allDonorsPushed));
	      // console.log("All Donors Pushed", this._allDonorsPushed);
	      if (this._donorComponentRef.length > 0 && this._haveDonorsBeenRendered === false) {
	        this._haveDonorsBeenRendered = true;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      try {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.state.finishedPreRender ? null : this.preRenderDonors(),
	          this.state.showLines ? this.renderLines() : null,
	          this.state.shuffledDonors.map(function (donor, i) {
	            return _react2.default.createElement(_DonorName2.default, {
	              key: i,
	              ref: function ref(el) {
	                return _this3._donorComponentRef[i] = el;
	              },
	              name: donor.name,
	              visible: donor.visible,
	              changed: donor.changed,
	              style: donor.style
	            });
	          })
	        );
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }]);
	
	  return DonorSeaComponent;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screen: state.screen,
	    donors: state.donors,
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, { withRef: true })(DonorSeaComponent);

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _ReactPlayerWrapper = __webpack_require__(88);
	
	var _ReactPlayerWrapper2 = _interopRequireDefault(_ReactPlayerWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ReactPlayer from 'react-player';
	
	var RecentDonors = function (_Component) {
	  _inherits(RecentDonors, _Component);
	
	  function RecentDonors(props) {
	    _classCallCheck(this, RecentDonors);
	
	    var _this = _possibleConstructorReturn(this, (RecentDonors.__proto__ || Object.getPrototypeOf(RecentDonors)).call(this, props));
	
	    _this.setupDonors = function () {
	      var donorCategories = _this.props.module.contents.recent_donors_configuration;
	      var selectedDonors = [];
	      if (donorCategories.length > 0) {
	        donorCategories.forEach(function (category, index) {
	          var donorsFound = _lodash2.default.find(_this.props.donors.donorCategories, { id: Number(category.donor_category) });
	          // console.log("donors Founds", donorsFound);
	
	          if (donorsFound) {
	            // First let's find donors that have at least one image.
	            var donorsWithImages = _lodash2.default.filter(donorsFound.donors, function (o) {
	              return o.contents.images.length > 0;
	            });
	
	            // console.log("Donors With Images", donorsWithImages);
	
	            if (donorsWithImages.length > 0) {
	              var sortedDonorsWithImages = _lodash2.default.sortBy(donorsWithImages, ['createdAt']);
	              // console.log("sortedDonorsWithImages", sortedDonorsWithImages)
	
	              // Select last Donors based on CreatedAt field.
	              var quantity = Number(category.donors_qty);
	              if (category.donors_qty > sortedDonorsWithImages.length) {
	                quantity = sortedDonorsWithImages.length;
	              }
	              for (var i = sortedDonorsWithImages.length - 1; i >= sortedDonorsWithImages.length - quantity; i--) {
	                //sortedDonorsWithImages[i];
	                selectedDonors.push({
	                  id: sortedDonorsWithImages[i].id,
	                  name: sortedDonorsWithImages[i].name,
	                  image: sortedDonorsWithImages[i].contents.images[0],
	                  cycleTime: category.cycle_time
	                });
	              }
	
	              // console.log("selectedDonors", selectedDonors);
	            }
	          }
	        });
	      }
	
	      _this._donors = selectedDonors;
	    };
	
	    _this.handleKeyDown = function (e) {
	      switch (e.keyCode) {
	        // Left Arrow (Previous)
	        case 37:
	          console.log('left arrow');
	          _this.clearCycleTimeout();
	          _this.prevSlide();
	          break;
	        // Right Arrow (Next)
	        case 39:
	          console.log('right arrow');
	          _this.clearCycleTimeout();
	          _this.nextSlide();
	          break;
	        // Space (Pause)
	        case 32:
	          _this.clearCycleTimeout();
	          var fileType = (0, _fileHelpers.getFileType)(_this._donors[_this.state.activeSlide].image.file_name);
	          if (fileType !== "Image") {
	            _this._paused = !_this._paused;
	            _this.toggleVideoReproduction(_this._paused);
	          }
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.clearCycleTimeout = function () {
	      clearTimeout(_this._cycleTimeout);
	      _this._cycleTimeout = null;
	    };
	
	    _this.nextSlide = function () {
	      var currentSlide = _this.state.activeSlide;
	      var nextSlide = 0;
	
	      if (currentSlide < _this._totalElements - 1) {
	        nextSlide = currentSlide + 1;
	      }
	
	      _this.slideChanged(nextSlide);
	    };
	
	    _this.prevSlide = function () {
	      var currentSlide = _this.state.activeSlide;
	      var nextSlide = currentSlide - 1;
	
	      if (currentSlide === 0) {
	        nextSlide = _this._totalElements - 1;
	      }
	
	      _this.slideChanged(nextSlide);
	    };
	
	    _this.toggleVideoReproduction = function (paused) {
	      if (paused === true) {
	        console.log('Pause');
	        _this._pausedOn = new Date().getTime();
	
	        _this.setState({
	          activeSlide: _this.state.activeSlide,
	          videoVolumes: _this.state.videoVolumes
	        });
	      } else {
	        console.log('Resume');
	        var timeLeftToReproduce = _this._currentDuration - (_this._pausedOn - _this._startSlideTime);
	
	        _this._currentDuration = timeLeftToReproduce;
	        _this._startSlideTime = new Date().getTime();
	
	        _this.clearCycleTimeout();
	        _this._cycleTimeout = setTimeout(function () {
	          _this.nextSlide();
	        }, timeLeftToReproduce);
	
	        _this.setState({
	          activeSlide: _this.state.activeSlide,
	          videoVolumes: _this.state.videoVolumes
	        });
	      }
	    };
	
	    _this.slideChanged = function (slide) {
	      if (slide) {
	        var timeout = _this._donors[slide].cycleTime;
	        _this._paused = false;
	        _this._startSlideTime = new Date().getTime();
	
	        var fileType = (0, _fileHelpers.getFileType)(_this._donors[slide].image.file_name);
	        if (fileType === "Image") {
	          _this.clearCycleTimeout();
	          _this._cycleTimeout = setTimeout(function () {
	            _this.nextSlide();
	          }, timeout * 1000);
	        }
	
	        _this.setState({
	          videoRefsPulled: true,
	          activeSlide: slide
	        });
	      }
	    };
	
	    _this.handleVideoDuration = function (duration, delay) {
	      //set our timeout for next slide
	      _this.clearCycleTimeout();
	      _this._currentDuration = (duration - delay) * 1000;
	      _this._cycleTimeout = setTimeout(function () {
	        _this.nextSlide();
	      }, _this._currentDuration);
	    };
	
	    _this.getSlide = function (slide) {
	      var volume = 1;
	
	      if (_this.props.idle) {
	        volume = 0;
	      }
	
	      if (_this._donors.length > 0) {
	        var innerTile = { width: _this.props.screen.screenWidth, height: _this.props.screen.screenHeight };
	        var fileType = (0, _fileHelpers.getFileType)(_this._donors[slide].image.file_name);
	
	        if (fileType === "Image") {
	          return _react2.default.createElement('img', { alt: 'Slide', onMouseDown: _this.preventDrag, className: 'nodrag', style: innerTile, src: _shared2.default.dp(_this.props.screen, _this._donors[slide].image) });
	        } else {
	          return _react2.default.createElement(_ReactPlayerWrapper2.default, {
	            playing: !_this._paused,
	            handleVideoDuration: _this.handleVideoDuration,
	            volume: volume,
	            onEnded: _this.videoEnded,
	            key: slide,
	            url: _shared2.default.dpath(_this.props.screen.mode, _this._donors[slide].image.path, _this._donors[slide].image.file_name, _this.props.screen.webkey), width: _this.props.screen.screenWidth, height: _this.props.screen.screenHeight
	          });
	        }
	      }
	    };
	
	    _this._donors = null;
	
	    _this.setupDonors();
	
	    _this._totalElements = _this._donors.length;
	    // this._cycleOverrides = this.props.module.contents.cycle_overrides;
	    _this._currentDuration = 0;
	    _this._startSlideTime = 0;
	    _this._paused = false;
	
	    _this.state = {
	      activeSlide: 0,
	      videoVolumes: Array.from(Array(_this._donors.length), function () {
	        return 0;
	      }),
	      module: _this.props.module
	    };
	    return _this;
	  }
	
	  _createClass(RecentDonors, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _shared2.default.checkData(this.props.module);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.slideChanged(0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearCycleTimeout();
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	
	    // componentDidUpdate(prevProps, prevState){
	    // 	if (this.prevProps.idle!==this.props.idle){
	    // 		//if video timeout.
	    // 	}
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, pointerEvents: "none" }, className: 'nodrag' },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.activeSlide, style: { position: 'absolute', left: 0, top: 0 } },
	            this.getSlide(this.state.activeSlide)
	          )
	        )
	      );
	    }
	  }]);
	
	  return RecentDonors;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var dm = void 0;
	  if (state.options.idleModule === undefined) {
	    dm = state.content.dm_active[state.active_module];
	  } else {
	    dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data;
	  }
	  return {
	    screen: state.screen,
	    donors: state.donors,
	    module: dm
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(RecentDonors);

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StretchImage = function (_Component) {
	  _inherits(StretchImage, _Component);
	
	  function StretchImage() {
	    _classCallCheck(this, StretchImage);
	
	    return _possibleConstructorReturn(this, (StretchImage.__proto__ || Object.getPrototypeOf(StretchImage)).apply(this, arguments));
	  }
	
	  _createClass(StretchImage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', top: this.props.top, left: this.props.left } },
	        _react2.default.createElement('img', { alt: 'Stretched', style: { width: this.props.width, height: this.props.height }, src: this.props.src })
	      );
	    }
	  }]);
	
	  return StretchImage;
	}(_react.Component);
	
	exports.default = StretchImage;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InteractBottomFixed = function (_Component) {
	    _inherits(InteractBottomFixed, _Component);
	
	    function InteractBottomFixed(props) {
	        _classCallCheck(this, InteractBottomFixed);
	
	        var _this = _possibleConstructorReturn(this, (InteractBottomFixed.__proto__ || Object.getPrototypeOf(InteractBottomFixed)).call(this, props));
	
	        _this.customDateString = function (date) {
	            var monthNumber = String(date.getMonth() + 1);
	            var fullYear = String(date.getFullYear());
	            var day = String(date.getDate());
	            return monthNumber + '/' + day + '/' + fullYear;
	        };
	
	        _this.tickTime = function () {
	            _this.setState({
	                date: _this.customDateString(new Date()), //new Date().toLocaleDateString().replace(/-0+/g, '-'),
	                time: new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
	            });
	        };
	
	        _this.state = {
	            date: _this.customDateString(new Date()), //new Date().toLocaleDateString(),
	            time: new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
	        };
	        _this._timeInterval = null;
	        return _this;
	    }
	
	    _createClass(InteractBottomFixed, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this._timeInterval = setInterval(function () {
	                _this2.tickTime();
	            }, 1000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this._timeInterval);
	            this._timeInterval = null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'fixed', width: this.props.screen.r16_9.width, height: this.props.screen.r16_9.p10, bottom: 0 } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: "center", width: this.props.screen.r16_9.width, height: '100%' } },
	                    _react2.default.createElement(
	                        'span',
	                        { style: {
	                                textAlign: 'center',
	                                position: 'absolute',
	                                top: this.props.screen.r16_9.p10 * .51,
	                                width: this.props.screen.r16_9.p10 * 2,
	                                left: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3,
	                                fontFamily: 'Ostrich',
	                                fontSize: this.props.screen.r16_9.p10 * .32,
	                                color: '#496778' } },
	                        this.state.date
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: {
	                                textAlign: 'center',
	                                position: 'absolute',
	                                top: this.props.screen.r16_9.p10 * .21,
	                                width: this.props.screen.r16_9.p10 * 2,
	                                left: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3,
	                                fontFamily: 'Ostrich',
	                                fontSize: this.props.screen.r16_9.p10 * .32,
	                                color: '#496778' } },
	                        this.state.time
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InteractBottomFixed;
	}(_react.Component);
	
	exports.default = InteractBottomFixed;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBottomFixed = function (_Component) {
	  _inherits(NavBottomFixed, _Component);
	
	  function NavBottomFixed(props) {
	    _classCallCheck(this, NavBottomFixed);
	
	    var _this = _possibleConstructorReturn(this, (NavBottomFixed.__proto__ || Object.getPrototypeOf(NavBottomFixed)).call(this, props));
	
	    _this.setNavigationData = function (parent, data, useFolders) {
	      var obj = {};
	      var type = "";
	      if (useFolders) {
	        obj = { parent: parent, name: data.name, activeIndex: _lodash2.default.findIndex(_this.props.content.story_categories, { id: data.id }), hasContent: true };
	        type = "story";
	      } else {
	        obj = { parent: parent, name: data.name, activeIndex: _lodash2.default.findIndex(_this.props.content.dm_active, { id: data.id }), hasContent: false };
	        type = _lodash2.default.find(_this.props.content.display_module_types, { id: Number(data.display_module_type) }).name;
	      }
	
	      obj.display_module_type = type;
	      switch (type) {
	        case "Timeline":
	          if (_lodash2.default.has(_this.props.content, 'dm_active[' + obj.activeIndex + '].contents.events') && _this.props.content.dm_active[obj.activeIndex].contents.events.length > 0) {
	            obj.hasContent = true;
	          }
	          break;
	        case "Donor List":
	          if (_lodash2.default.has(_this.props.content, 'dm_active[' + obj.activeIndex + '].contents.include_categories')) {
	            var includes = _this.props.content.dm_active[obj.activeIndex].contents.include_categories;
	            for (var i = 0; i < includes.length; i++) {
	              var category = _lodash2.default.find(_this.props.donors.donorCategories, { id: includes[i] });
	              if (category && category.donors && category.donors.length > 0) {
	                obj.hasContent = true;
	              }
	            }
	          }
	          break;
	        default:
	          break;
	      }
	      return obj;
	    };
	
	    _this.handleNavGroupChange = function (row, index) {
	      _this.setState({
	        activeNode: index
	      });
	    };
	
	    _this.handleNavIndex = function (name) {
	      var item = _lodash2.default.find(_this._indexData, { parent: { name: name } });
	      if (item) {
	        if (item.hasContent === true) {
	          return item.activeIndex;
	        } else {
	          return -1;
	        }
	      }
	      return -1;
	    };
	
	    _this.handleNav = function (name, row, index) {
	      var activeIndex = -1;
	      activeIndex = row.dm_active_ref;
	      var options = { type: _lodash2.default.get(_this.props.content, 'dm_active[' + row.dm_active_ref + '].contents.custom_fields.type.val.value', "avatar"), useFolders: _this._useFolders };
	      if (activeIndex > -1) {
	        _this.props.navroute(activeIndex, row.display_module_type, "bottomFixed", options);
	      }
	      if (activeIndex !== -1) {
	        _this.setState({
	          activeSubNode: row.name
	        });
	      }
	    };
	
	    _this.tryNav = function (activeIndex, type, options) {
	      if (activeIndex >= 0) {
	        _this.props.navroute(activeIndex, type, "bottomFixed", options);
	      }
	    };
	
	    _this.prepareInnerNav = function (name, modules, config, index) {
	      var margin = _this.props.screen.r16_9.p10 * .1;
	      return modules.map(function (row, i) {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'span',
	          { onClick: function onClick() {
	              return _this2.handleNav(name, row, i);
	            }, key: i, style: { display: 'inline-block', fontFamily: this._navItemFont, letterSpacing: "1px", height: config.height, fontSize: config.fontSizeInner, paddingLeft: config.padding, paddingRight: config.padding } },
	          _react2.default.createElement(
	            'span',
	            { className: this.state.activeNode === index ? "slideOut" : "slideIn", style: { display: 'inline-block', paddingTop: config.unit * .42 } },
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              row.name === this.state.activeSubNode ? _react2.default.createElement(
	                'span',
	                { key: this.state.activeSubNode, style: { marginLeft: -margin, marginRight: -margin, paddingTop: margin + this.props.screen.r16_9.p10 * .02, paddingBottom: margin, paddingLeft: margin, paddingRight: margin, position: 'absolute', top: this.props.screen.r16_9.p10 * .3, color: 'white', backgroundColor: '#496778', borderRadius: 7 } },
	                row.name
	              ) : _react2.default.createElement(
	                'span',
	                { key: this.state.activeSubNode, style: { marginLeft: -margin, marginRight: -margin, paddingTop: margin + this.props.screen.r16_9.p10 * .02, paddingBottom: margin, paddingLeft: margin, paddingRight: margin, position: 'absolute', top: this.props.screen.r16_9.p10 * .3, color: '#496778' } },
	                row.name
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { opacity: 0 } },
	              row.name
	            )
	          )
	        );
	      }, _this);
	    };
	
	    _this.prepareNavGroups = function (config) {
	      var pointerEvents = "none";
	      if (!_this.props.idle) {
	        pointerEvents = "auto";
	      }
	      return _this.nav_groups.map(function (row, i) {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	          'span',
	          { key: i, style: { pointerEvents: pointerEvents } },
	          _react2.default.createElement(
	            'span',
	            { key: i, style: { verticalAlign: 'bottom', display: 'table-cell', backgroundColor: '#a4bcc2', letterSpacing: '1px', color: '#496778', fontFamily: this._navGroupFont, fontSize: config.fontSize, paddingLeft: config.padding, paddingRight: config.padding, height: config.height }, onClick: function onClick() {
	                return _this3.handleNavGroupChange(row, i);
	              } },
	            _react2.default.createElement(
	              'span',
	              { style: { display: 'inline-block', paddingBottom: config.unit * .25 } },
	              row.name
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: this.state.activeNode === i ? "slideOut" : "slideIn", style: { position: 'relative', verticalAlign: 'bottom', display: 'table-cell', backgroundColor: '#a4bcc2', color: "#496778", height: config.height } },
	            _react2.default.createElement('span', { style: { pointerEvents: 'none', position: 'absolute', left: 0, top: this.props.screen.r16_9.p10 * .2, backgroundColor: '#fcfcfc', width: '100%', height: config.height - this.props.screen.r16_9.p10 * .4, borderRadius: 15 } }),
	            _react2.default.createElement(
	              'span',
	              { style: { zIndex: 51 } },
	              this.prepareInnerNav(row.name, row.modules, config, i)
	            )
	          )
	        );
	      }, _this);
	    };
	
	    try {
	
	      _this.state = {
	        activeNode: -1, //no active node
	        activeSubNode: -1 //no active subnode 
	      };
	      _this._indexData = [];
	
	      _this._module = _lodash2.default.find(_this.props.content.dm_active, { display_module_type: "Module Grouping" });
	      if (!_this._module) {
	        console.log("Expecting a Grouping Module for navigation to be added to display");
	      }
	      _this._navigation = _this._module.contents.module_tree.children;
	      _this._useFolders = _lodash2.default.get(_this._module, 'contents.useFolders', false);
	      _this._fontClass = _lodash2.default.get(_this._module, 'contents.custom_fields.font_family.val.value', null);
	      _this._navItemFont = _lodash2.default.get(_this._module, 'contents.custom_fields.override_font_family.val', "Ostrich");
	      _this._navGroupFont = _lodash2.default.get(_this._module, 'contents.custom_fields.override_font_family.val', "Ostrich");
	
	      for (var a = 0; a < _this._navigation.length; a++) {
	        for (var b = 0; b < _this._navigation[a].modules.length; b++) {
	          //exactly 1 nestings
	          _this._indexData.push(_this.setNavigationData(_this._navigation[a], _this._navigation[a].modules[b], _this._useFolders));
	        }
	      }
	      _this._folderTypeAlias = [{
	        name: "Stories Folders",
	        types: ['families', 'babies']
	      }];
	      _this.nav_groups = [];
	      for (var c = 0; c < _this._navigation.length; c++) {
	        var mod = { name: _this._navigation[c].name, modules: [] };
	        for (var d = 0; d < _this._navigation[c].modules.length; d++) {
	          if (_this._useFolders) {
	            var index = void 0,
	                foundType = void 0,
	                type = void 0;
	            for (var i = 0; i < _this._folderTypeAlias.length; i++) {
	              index = _lodash2.default.findIndex(_this.props.content.story_categories, { id: _this._navigation[c].modules[d].id });
	              foundType = _lodash2.default.get(_this.props.content.story_categories[index], 'contents.custom_fields.folder_type.val.value', "Stories");
	              if (_this._folderTypeAlias[i].types.indexOf(foundType) > -1) {
	                type = _this._folderTypeAlias[i].name;
	                break;
	              }
	            }
	            mod.modules.push({
	              name: _this._navigation[c].modules[d].name,
	              display_module_type: type,
	              dm_active_ref: index
	            });
	          } else {
	            mod.modules.push({
	              name: _this._navigation[c].modules[d].name,
	              display_module_type: _lodash2.default.find(_this.props.content.display_module_types, { id: Number(_this._navigation[c].modules[d].display_module_type) }).name,
	              dm_active_ref: _lodash2.default.findIndex(_this.props.content.dm_active, { id: _this._navigation[c].modules[d].id })
	            });
	          }
	        }
	        _this.nav_groups.push(mod);
	      }
	    } catch (e) {
	      console.log(e);
	    }
	
	    return _this;
	  }
	
	  _createClass(NavBottomFixed, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.idle !== this.props.idle) {
	        this.setState({
	          activeNode: -1, //no active node
	          activeSubNode: -1 //no active subnode 
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var config = {
	        height: this.props.screen.r16_9.p10,
	        fontSize: this.props.screen.r16_9.p10 * .4,
	        fontSizeInner: this.props.screen.r16_9.p10 * .2,
	        padding: this.props.screen.r16_9.p10 * .2,
	        unit: this.props.screen.r16_9.p10
	      };
	
	      var navGroups = this.prepareNavGroups(config);
	
	      return _react2.default.createElement(
	        'div',
	        { style: { zIndex: 50, margin: 'auto', position: 'absolute', bottom: 0, backgroundColor: '#a4bcc2', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: config.height } },
	        navGroups
	      );
	    }
	  }]);
	
	  return NavBottomFixed;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  return {
	    content: state.content,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(NavBottomFixed);

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationSide = function (_Component) {
	    _inherits(NavigationSide, _Component);
	
	    function NavigationSide(props) {
	        _classCallCheck(this, NavigationSide);
	
	        var _this = _possibleConstructorReturn(this, (NavigationSide.__proto__ || Object.getPrototypeOf(NavigationSide)).call(this, props));
	
	        _this.displayModuleIcon = _this.displayModuleIcon.bind(_this);
	        _this.prepareModules = _this.prepareModules.bind(_this);
	        return _this;
	    }
	
	    _createClass(NavigationSide, [{
	        key: 'displayModuleIcon',
	        value: function displayModuleIcon(type) {
	            var fAwesomeName = void 0;
	            switch (type) {
	                case "Story":
	                    fAwesomeName = 'newspaper-o';
	                    break;
	                case "Stories":
	                    fAwesomeName = 'book';
	                    break;
	                case "Donor List":
	                    fAwesomeName = 'user';
	                    break;
	                case "User Input":
	                    fAwesomeName = 'commenting-o';
	                    break;
	                case "Search":
	                    fAwesomeName = 'search';
	                    break;
	                default:
	                    fAwesomeName = 'newspaper-o';
	                    break;
	            }
	            return _react2.default.createElement(
	                'span',
	                { style: { display: 'inline-block', width: this.props.screen.r16_9.p10 * 0.5 } },
	                _react2.default.createElement(_reactFontawesome2.default, { name: fAwesomeName })
	            );
	        }
	    }, {
	        key: 'prepareModules',
	        value: function prepareModules() {
	            return this.props.modules.map(function (row, i) {
	                var _this2 = this;
	
	                if (row.include_in_navigation && row.display_module_type !== "Attract Loop") {
	                    return _react2.default.createElement(
	                        'div',
	                        { onMouseDown: function onMouseDown() {
	                                return _this2.props.navroute(i, row.display_module_type, "sidemenu", {});
	                            }, className: 'phand', key: row.id },
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.displayModuleIcon(row.display_module_type),
	                            ' ',
	                            row.name
	                        )
	                    );
	                }
	                return null;
	            }, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var modules = this.prepareModules();
	
	            return _react2.default.createElement(
	                'div',
	                { style: { color: 'black', height: '100vh', textAlign: 'vertical', fontSize: this.props.screen.r16_9.p10 * .325 } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'outerC' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'middleC' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { textAlign: 'left', display: 'inline-block', lineHeight: '2' } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    'Menu'
	                                )
	                            ),
	                            modules
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NavigationSide;
	}(_react.Component);
	
	exports.default = NavigationSide;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _StoryAnnouncement = __webpack_require__(90);
	
	var _StoryAnnouncement2 = _interopRequireDefault(_StoryAnnouncement);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouterDom = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import shared from '../../utils/shared.js';
	
	
	var NO_REDUX = "NO_REDUX";
	
	var PreviewContainer = function (_Component) {
	  _inherits(PreviewContainer, _Component);
	
	  function PreviewContainer(props) {
	    _classCallCheck(this, PreviewContainer);
	
	    var _this = _possibleConstructorReturn(this, (PreviewContainer.__proto__ || Object.getPrototypeOf(PreviewContainer)).call(this, props));
	
	    _this.prepareContent = function () {
	      var mainModule = _lodash2.default.get(_this.props, 'content.module', {});
	      var secondaryModules = _lodash2.default.get(_this.props, 'content.dm_active', []);
	
	      _this.setState({
	        module: mainModule,
	        secondaryModules: secondaryModules
	      });
	    };
	
	    _this.state = {
	      module: {},
	      secondaryModules: []
	    };
	    return _this;
	  }
	
	  _createClass(PreviewContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.prepareContent();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevstate) {
	      if (this.props !== prevProps) {
	        this.prepareContent();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	
	      var key = this.props.location.pathname + this.props.location.search;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            { key: key, location: location },
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/preview/Chicago/story/baby_announcement', render: function render(props) {
	                return _react2.default.createElement(_StoryAnnouncement2.default, { mode: NO_REDUX, story: _this2.state.module, otherModules: _this2.state.secondaryModules, screen: _this2.props.screen });
	              } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return PreviewContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return Object.assign({}, state);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(PreviewContainer);

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _timeHelpers = __webpack_require__(39);
	
	var _timeHelpers2 = _interopRequireDefault(_timeHelpers);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared3 = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sailsIo = __webpack_require__(140);
	
	var _sailsIo2 = _interopRequireDefault(_sailsIo);
	
	var _socket = __webpack_require__(141);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _videoStyle = {
	  preload: 'auto',
	  position: 'relative',
	  minWidth: '100%',
	  minHeight: '100%',
	  width: '100%',
	  height: '100%',
	  loop: '',
	  autoplay: "",
	  muted: "",
	  pointerEvents: "none"
	};
	
	var QuoteShort = function (_Component) {
	  _inherits(QuoteShort, _Component);
	
	  function QuoteShort(props) {
	    _classCallCheck(this, QuoteShort);
	
	    var _this = _possibleConstructorReturn(this, (QuoteShort.__proto__ || Object.getPrototypeOf(QuoteShort)).call(this, props));
	
	    _this.handleImageLoaded = function () {
	      if (_this.state.showModal) {
	        var height = _this._imageModalRef.getBoundingClientRect().height;
	        var width = _this._imageModalRef.getBoundingClientRect().width;
	        var offsetX = _this.props.screen.screenWidth / 2 - width / 2;
	        var offsetY = _this.props.screen.screenHeight / 2 - height / 2;
	
	        _this._imageModalRef.style['left'] = offsetX + 'px';
	        _this._imageModalRef.style['top'] = offsetY + 'px';
	      }
	    };
	
	    _this.websocketHandler = function () {
	      var displayId = _this.props.content.id;
	      _this._io = (0, _sailsIo2.default)(_socket2.default);
	
	      _this._io.sails.autoConnect = true;
	      _this._io.sails.url = _config2.default.WEB_SERVER;
	
	      _this._io.socket.on('email_announcement', function (event) {
	        // console.log("Event triggered");
	        _this.setupAsset(event);
	      });
	
	      _this._io.socket.on('connect', function () {
	        _this._io.socket.get('/feed/subscribe?display=' + displayId, function serverResponded(body, JWR) {
	          // console.log('loaded');
	        });
	      });
	
	      _this._io.socket.on('error', function (e) {
	        // console.log('error');
	      });
	
	      _this._io.socket.on('disconnect', function () {
	        _this._io.socket._raw.io._reconnection = true;
	      });
	    };
	
	    _this.setupAsset = function (event) {
	      var data = JSON.parse(event);
	      if (data.subject && _this.props.content.settings.announcement_modules) {
	        var module = _lodash2.default.find(_this.props.content.settings.announcement_modules, { subject: data.subject });
	        if (module) {
	          var announcementModule = _lodash2.default.find(_this.props.content.dm_active, { id: module.id });
	          if (announcementModule) {
	            var asset = _lodash2.default.get(announcementModule.contents, "images[0]", null);
	            if (asset) {
	              _this._assetFile = asset.file_name;
	              var announcementAudioAsset = _lodash2.default.get(announcementModule.contents, "images[1]", null);
	              if (announcementAudioAsset) {
	                _this._audioAssetFile = announcementAudioAsset.file_name;
	              }
	
	              _this._announcementAsset = _shared2.default.dp(_this.props.screen, asset);
	              _this._announcementAudioAsset = _shared2.default.dp(_this.props.screen, announcementAudioAsset);
	              _this._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
	
	              var timeout = 0;
	              if (data.schedule_for) {
	                timeout = Number(data.schedule_for) - Date.now();
	              }
	              if (timeout <= 0) {
	                _this.showModal();
	              } else {
	                setTimeout(function () {
	                  _this.showModal();
	                }, timeout);
	              }
	            }
	          }
	        }
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "s":
	          console.log(_this.props);
	          break;
	        case "d":
	          var newDebug = _this.state.showDebug + 1;
	          if (newDebug > 2) {
	            newDebug = 0;
	          }
	          _this.setState({
	            showDebug: newDebug
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.setupIntervalHandler = function () {
	      clearTimeout(_this._intervalTimeout);
	      _this._intervalTimeout = null;
	      _this._intervalTimeout = setTimeout(function () {
	        _this._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._elementsIntervals);
	        if (_this._intervalTimeoutMS > 500) {
	          var elementIndex = _shared2.default.loopIndex(_this.state.elementIndex, 0, _this._elementStates.length - 1, "forward");
	          _this.setState({
	            elementIndex: elementIndex
	          });
	        }
	
	        _this.setupIntervalHandler();
	      }, _this._intervalTimeoutMS);
	    };
	
	    _this.setupQuoteIndexHandler = function () {
	      clearTimeout(_this._quoteIndexTimeout);
	      _this._quoteIndexTimeout = null;
	      _this._quoteIndexTimeout = setTimeout(function () {
	        var quotes = _this._elementStates[_this.state.elementIndex].quotes;
	        var pairLength = null;
	
	        if (_this._elementStates[_this.state.elementIndex].storyType && _this._elementStates[_this.state.elementIndex].storyType === "slideshow") {
	          var wordPairs = _lodash2.default.get(_this._elementStates[_this.state.elementIndex], 'arrays.words_pair', null);
	          var wordsPairsValues = _lodash2.default.get(_this._elementStates[_this.state.elementIndex], 'arraysValues.words_pair', null);
	
	          if (wordPairs) {
	            pairLength = wordPairs.values.length;
	            for (var i = 0; i < pairLength; i++) {
	              wordPairs.values[i].main_word['value'] = _lodash2.default.get(wordsPairsValues, '[' + i + '].main_word.val', null);
	            }
	            _this._selectedWordIndex = _timeHelpers2.default.indexFromInterval(_this._elementStates[_this.state.elementIndex].quoteCycleTime, wordPairs.values.length);
	            quotes[0] = wordPairs.values[_this._selectedWordIndex].main_word.value;
	          }
	        }
	
	        // These times are for the whole slide cycle.
	        var timeIntervalRemainderMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._elementsIntervals);
	        var elementIntervalMS = _this._elementStates[_this.state.elementIndex].cycleTime;
	        var currentMoment = elementIntervalMS - timeIntervalRemainderMS;
	        var quoteOverlayOffsetDuration = _this._elementStates[_this.state.elementIndex].quoteOverlayOffsetDuration * 1000;
	
	        // Check current quote index based on duration of each of the quotes.
	        // These times are for the Quote Cycle (Could be multiple quotes per Slide Cycle)
	        var quoteCycleTime = _this._elementStates[_this.state.elementIndex].quoteCycleTime;
	        var currentMomentInQuoteTransitionMS = currentMoment % quoteCycleTime;
	        var timeQuoteRemainderMS = quoteCycleTime - currentMomentInQuoteTransitionMS;
	        var currentQuoteIndex = Math.floor(currentMoment / quoteCycleTime) % quotes.length;
	        if (currentQuoteIndex + 1 > quotes.length) {
	          currentQuoteIndex = 0;
	        }
	
	        if (timeIntervalRemainderMS > 500) {
	          var nextIndex = _this.state.elementIndex;
	          if (timeIntervalRemainderMS <= timeQuoteRemainderMS - quoteOverlayOffsetDuration) {
	            nextIndex = _shared2.default.loopIndex(_this.state.elementIndex, 0, _this._elementStates.length - 1, "forward");
	          }
	
	          if (_this._elementStates[_this.state.elementIndex].overlayText) {
	            // Show when the video is starting
	            if (currentMomentInQuoteTransitionMS >= quoteOverlayOffsetDuration && currentMomentInQuoteTransitionMS < quoteCycleTime - quoteOverlayOffsetDuration) {
	              _this._intervalQuoteMS = timeQuoteRemainderMS - quoteOverlayOffsetDuration;
	              // console.log('showing at', currentMoment);
	              _this.setState({
	                showOverlay: true,
	                currentQuoteIndex: currentQuoteIndex
	              });
	              // Hide when the video is ending
	            } else if (currentMomentInQuoteTransitionMS >= quoteCycleTime - quoteOverlayOffsetDuration) {
	              // console.log('hiding at', currentMoment);
	              _this._intervalQuoteMS = timeQuoteRemainderMS + _this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000;
	              _this.setState({
	                showOverlay: false,
	                currentQuoteIndex: currentQuoteIndex
	              });
	            }
	          } else {
	            _this.setState({
	              showOverlay: false,
	              currentQuoteIndex: currentQuoteIndex
	            });
	            _this._intervalQuoteMS = timeIntervalRemainderMS + _this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000;
	          }
	        }
	
	        _this.setupQuoteIndexHandler();
	      }, _this._intervalQuoteMS);
	    };
	
	    _this.setVideoSeekTimeInterval = function () {
	      clearTimeout(_this._intervalSeekTimeout);
	      _this._intervalSeekTimeout = null;
	      _this._intervalSeekTimeout = setTimeout(function () {
	        var fileType = (0, _shared3.getFileType)(_this._elementStates[_this.state.elementIndex].backgroundMedia);
	        if (fileType === "video") {
	          if (!_this._currentVideoRef) {
	            _this.setVideoSeekTimeInterval();
	          } else {
	            _this._currentVideoRef.currentTime = _this.state.currentTimeInterval / 1000;
	            clearTimeout(_this._intervalSeekTimeout);
	          }
	        }
	      }, 30);
	    };
	
	    _this.loadedMetadata = function (event) {
	      var videoHeight = _this._videoModalRef.getBoundingClientRect().height;
	      var videoWidth = _this._videoModalRef.getBoundingClientRect().width;
	      var videoMaxHeight = 0;
	      var videoMaxWidth = 0;
	      var videoOffsetX = 0;
	      var videoOffsetY = 0;
	      var videoRatio = videoWidth / videoHeight;
	      // let screenRatio = this.props.screen.screenWidth / this.props.screen.screenHeight;
	      var isHorizontal = videoWidth > videoHeight;
	
	      if (isHorizontal) {
	        videoMaxWidth = _this.props.screen.screenWidth;
	        videoMaxHeight = videoMaxWidth / videoRatio;
	      } else {
	        videoMaxHeight = _this.props.screen.screenHeight;
	        videoMaxWidth = videoMaxHeight * videoRatio;
	      }
	
	      videoOffsetX = videoMaxWidth < _this.props.screen.screenWidth ? _this.props.screen.screenWidth / 2 - videoMaxWidth / 2 : 0;
	      videoOffsetY = videoMaxHeight < _this.props.screen.screenHeight ? _this.props.screen.screenHeight / 2 - videoMaxHeight / 2 : 0;
	
	      var videoControlsOffset = videoOffsetY + videoHeight / 2;
	
	      // console.log("Loaded Metadata");
	
	      if (_this._videoModalRef !== undefined && _this._videoModalRef !== null) {
	        var duration = _this._videoModalRef.duration;
	        // console.log("1- Setting a duration of", duration);
	        _this._modalCycle = setTimeout(function () {
	          // console.log("Closing Modal");
	          _this.setState({
	            showModalVideo: false
	          });
	        }, duration * 1000);
	      } else {
	        _this.handleVideoDuration();
	      }
	
	      _this.setState({
	        duration: event.target.duration,
	        videoOffsetY: videoOffsetY,
	        videoOffsetX: videoOffsetX,
	        videoControlsOffset: videoControlsOffset,
	        videoMaxHeight: videoMaxHeight,
	        videoMaxWidth: videoMaxWidth,
	        videoFile: _this.props.content.file_path
	      });
	    };
	
	    try {
	      _this._elementStates = [];
	      _this._elementsIntervals = [];
	      _this._elementIntervalMS = _this.props.cycleTime;
	
	      _this.setupElements();
	      var currentTimeInterval = _timeHelpers2.default.currentSeekTimeArray(_this._elementsIntervals);
	      var elementIndex = _timeHelpers2.default.indexFromIntervalArray(_this._elementsIntervals);
	      var timeIntervalRemainderMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._elementsIntervals);
	      _this._intervalQuoteMS = 0;
	
	      _this._intervalTimeoutMS = timeIntervalRemainderMS;
	
	      _this.state = {
	        elementIndex: elementIndex,
	        secondsPassed: 0,
	        showDebug: 0,
	        quoteState: 0,
	        currentTimeInterval: currentTimeInterval,
	        showOverlay: true,
	        showModal: false,
	        showModalVideo: false
	      };
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(QuoteShort, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        var socketsEnabled = _lodash2.default.get(_config2.default, 'sockets.enabled', false);
	        if (socketsEnabled) {
	          this.websocketHandler();
	        }
	        this.setupIntervalHandler();
	        this.setupQuoteIndexHandler(); //rework to use the element index instead, becoase video will cycle with quotes.
	        this.setVideoSeekTimeInterval();
	        document.addEventListener("keydown", this.handleKeyDown);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal() {
	      var _this2 = this;
	
	      var fileType = (0, _shared3.getFileType)(this._assetFile);
	      if (fileType === "video") {
	        if (!this.state.showModalVideo) {
	          this.setState({
	            showModalVideo: true
	          });
	        }
	      } else {
	        if (!this.state.showModal) {
	          this.setState({
	            showModal: true
	          });
	
	          this._modalCycle = setTimeout(function () {
	            _this2.setState({
	              showModal: false
	            });
	          }, this._announcementTimeout);
	        }
	      }
	
	      // Check for the audio asset
	      if (this._audioAssetFile) {
	        var audioFileType = (0, _shared3.getFileType)(this._audioAssetFile);
	        // console.log("2.- Filetype", audioFileType);
	        if (audioFileType === "audio") {
	          if (!this.state.playAudio) {
	            this.setState({
	              playAudio: true
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var fileType = (0, _shared3.getFileType)(this._announcementAsset);
	      if (fileType === "video") {
	        if (this.state.showModalVideo) {
	          this.setState({
	            showModalVideo: false
	          });
	          clearTimeout(this._modalCycle);
	        }
	      } else {
	        if (this.state.showModal) {
	          this.setState({
	            showModal: false
	          });
	          clearTimeout(this._modalCycle);
	        }
	      }
	    }
	  }, {
	    key: 'setupElements',
	    value: function setupElements() {
	      var _this3 = this;
	
	      try {
	        var parentActive = {};
	        var rootFolder = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	        if (rootFolder !== null) {
	          rootFolder = Number(rootFolder);
	          parentActive = _lodash2.default.find(this.props.content.story_categories, { id: rootFolder });
	        } else {
	          parentActive = _lodash2.default.find(this.props.content.story_categories, function (folder) {
	            var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	            return type === "active";
	          });
	        }
	        var storyBoardFolder = _lodash2.default.find(this.props.content.story_categories, function (folder) {
	          var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	          return type === 'attract_loop_stories' && folder.parent_category === parentActive.id;
	        });
	        var modules = _shared2.default.getAllFolderModules(this.props.content.folder_modules, null, this.props.content.stories, storyBoardFolder.id);
	
	        if (modules && modules.length > 0) {
	          _lodash2.default.forEach(modules, function (module, key) {
	            module = _lodash2.default.cloneDeep(module);
	            var backgroundMediaName = _lodash2.default.get(module, 'contents.images[0].file_name', 'empty.png');
	            var backgroundMedia = (0, _shared3.dp)(_this3.props.screen, _lodash2.default.get(module, 'contents.images[0]', null));
	            var backgroundType = (0, _shared3.getFileType)(backgroundMediaName);
	
	            if (!backgroundMedia) {
	              console.log("No background has been found for this story");
	            }
	
	            var cycleTime = Number(_lodash2.default.get(module.contents.custom_fields, 'cycle_time.val', 60));
	            var quoteCycleTime = Number(_lodash2.default.get(module.contents.custom_fields, 'cycle_time.val', 20));
	            cycleTime *= 1000;
	            quoteCycleTime *= 1000;
	            _this3._elementsIntervals.push(cycleTime);
	            var backgroundDropOpacity = _lodash2.default.has(module.contents, "custom_fields.short_quote_background_opacity.val") ? module.contents.custom_fields.short_quote_background_opacity.val * .01 : 0;
	
	            var quote = [_lodash2.default.get(module.contents, 'headline', ""), _lodash2.default.get(module.contents, "custom_fields.short_quote_language_2.val", ""), _lodash2.default.get(module.contents, "custom_fields.short_quote_language_3.val", "")];
	
	            _this3._elementStates.push({
	              storyType: _lodash2.default.get(module.contents.custom_fields, 'story_type.val.value', null),
	              quotes: quote,
	              quoteCycleTime: quoteCycleTime,
	              cycleTime: cycleTime,
	              backgroundMedia: backgroundMedia,
	              backgroundMediaName: backgroundMediaName,
	              backgroundDropOpacity: backgroundDropOpacity,
	              backgroundType: backgroundType,
	              overlayText: true,
	              quoteOverlayOffsetDuration: 2,
	              arrays: _lodash2.default.get(module.contents, 'arrays', {}),
	              arraysValues: _lodash2.default.get(module.contents, 'arrays_values', {}),
	              shortQuoteSettings: {
	                backgroundColor: _lodash2.default.get(module.contents.custom_fields, "short_quote_background_color.val", "#FFFFFF"),
	                quote: _lodash2.default.get(module.contents, "headline", ""),
	                style: _lodash2.default.get(module.contents.custom_fields, "main_word_style", {}),
	                checkerBoardStyle: _lodash2.default.get(module.contents.custom_fields, 'main_word_style', {})
	              }
	            });
	          });
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      try {
	        var sectionWidth = this.props.screen.screenWidth;
	        var sectionHeight = this.props.screen.screenHeight / 4;
	
	        var imageDivStyle = {
	          backgroundImage: "url(" + this._elementStates[this.state.elementIndex].backgroundMedia + ")",
	          backgroundSize: "cover",
	          position: "absolute",
	          height: this.props.screen.screenHeight,
	          width: this.props.screen.screenWidth,
	          top: 0,
	          left: 0,
	          zIndex: 9997
	        };
	
	        var quoteDivStyle = {
	          backgroundColor: this._elementStates[this.state.elementIndex].shortQuoteSettings.backgroundColor,
	          opacity: this._elementStates[this.state.elementIndex].backgroundDropOpacity,
	          position: "absolute",
	          height: sectionHeight,
	          width: sectionWidth
	          // zIndex:9998
	        };
	
	        var cssStyle = {
	          position: 'absolute',
	          display: "table",
	          height: sectionHeight,
	          width: sectionWidth
	          // zIndex: 9999
	        };
	
	        var centeredDiv = {
	          display: "table-cell",
	          verticalAlign: "middle",
	          textAlign: "center",
	          paddingLeft: this.props.screen.screenWidth * 0.09,
	          paddingRight: this.props.screen.screenWidth * 0.09
	        };
	
	        var modalStyle = {
	          position: 'absolute',
	          height: this.props.screen.screenHeight,
	          width: this.props.screen.screenWidth,
	          zIndex: 9999
	        };
	
	        var _announcementVideoStyle = {
	          preload: 'auto',
	          position: 'absolute',
	          muted: "",
	          objectFit: "fill",
	          width: this.state.videoMaxWidth,
	          height: this.state.videoMaxHeight
	        };
	
	        var _btnStyle = {
	          color: 'white',
	          position: 'absolute',
	          fontSize: this.props.screen.screenHeight * 0.05,
	          fontStyle: 'normal',
	          fontWeight: 'bold',
	          textDecoration: 'none',
	          zIndex: 9999
	        };
	
	        var cType = "";
	        if (this.state.showModalVideo) {
	          cType = (0, _shared3.videoType)(this._announcementAsset);
	        }
	
	        var spanQuoteTextStyle = {
	          fontSize: this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontSize > 0 ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontSize * this.props.screen.screenHeight / 100 : this.props.screen.screenHeight * 0.026,
	          fontStyle: "font" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontStyle : "normal",
	          textAlign: "font" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.justification : "left",
	          font: "font" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.font : "Roboto",
	          fontWeight: "fontWeight" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.fontWeight : "bold",
	          lineHeight: "lineHeight" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.lineHeight + "%" : "185%",
	          marginTop: "height" in this._elementStates[this.state.elementIndex].shortQuoteSettings.style ? this._elementStates[this.state.elementIndex].shortQuoteSettings.style.height + "%" : "0%",
	          display: this._elementStates[this.state.elementIndex].shortQuoteSettings.style.visible ? "block" : "none",
	          color: _lodash2.default.get(this._elementStates[this.state.elementIndex].shortQuoteSettings.style, 'fontColor', "#000000"),
	          zIndex: 9999
	        };
	
	        var fileType = this._elementStates[this.state.elementIndex].backgroundType;
	        var content = "";
	
	        if (fileType === "video") {
	          var _cType = (0, _shared3.videoType)(this._elementStates[this.state.elementIndex].backgroundMedia);
	          content = _react2.default.createElement(
	            'div',
	            { className: 'vid', style: { position: 'absolute', top: 0, left: 0, width: "100%", maxWidth: "100%" }, key: this.state.elementIndex },
	            _react2.default.createElement(
	              'video',
	              { style: _videoStyle, ref: function ref(el) {
	                  return _this4._currentVideoRef = el;
	                }, id: 'background-video', loop: true, autoPlay: true, muted: true },
	              _react2.default.createElement('source', { src: this._elementStates[this.state.elementIndex].backgroundMedia, type: _cType }),
	              'Your browser does not support the video tag.'
	            )
	          );
	        } else {
	          content = _react2.default.createElement('div', { style: Object.assign({}, imageDivStyle) });
	        }
	
	        var bezel = null;
	        if (this.props.showBezel) {
	          bezel = _react2.default.createElement('div', { style: { position: "absolute", height: "100vh", background: "black", width: this.props.bezelSize, right: 0, zIndex: 9999 } });
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundColor: "white", zIndex: -9999 } },
	          bezel,
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.elementIndex },
	              content
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showOverlay },
	              this.state.showOverlay ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: Object.assign({}, quoteDivStyle) }),
	                _react2.default.createElement(
	                  'div',
	                  { style: Object.assign({}, cssStyle) },
	                  _react2.default.createElement(
	                    'div',
	                    { style: Object.assign({}, centeredDiv) },
	                    _react2.default.createElement(
	                      'span',
	                      { style: Object.assign({}, spanQuoteTextStyle) },
	                      this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex]
	                    )
	                  )
	                )
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showModal },
	              this.state.showModal ? _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, modalStyle) },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#', onClick: function onClick() {
	                      _this4.closeModal();
	                    }, ref: function ref(el) {
	                      return _this4._closeModalRef = el;
	                    }, style: Object.assign({}, _btnStyle, { top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }) },
	                  'X'
	                ),
	                _react2.default.createElement('img', { alt: "Announcement Modal", style: { position: 'absolute' }, src: this._announcementAsset, ref: function ref(el) {
	                    return _this4._imageModalRef = el;
	                  }, onLoad: this.handleImageLoaded.bind(this) })
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showModalVideo },
	              this.state.showModalVideo ? _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, modalStyle, { backgroundColor: "black" }) },
	                _react2.default.createElement(
	                  'video',
	                  { style: Object.assign({}, _announcementVideoStyle, { top: this.state.videoOffsetY, left: this.state.videoOffsetX }), ref: function ref(el) {
	                      return _this4._videoModalRef = el;
	                    }, onLoadedMetadata: this.loadedMetadata.bind(this), autoPlay: true },
	                  _react2.default.createElement('source', { src: this._announcementAsset, type: cType }),
	                  'Your browser does not support the video tag.'
	                )
	              ) : null
	            )
	          )
	        );
	      } catch (e) {
	        console.log(e);
	        return _react2.default.createElement(
	          'div',
	          null,
	          e
	        );
	      }
	    }
	  }]);
	
	  return QuoteShort;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var cycleTime = 81000;
	  var showBezel = _shared2.default.parseStringParam(window.location.href, "showBezel");
	  var bezelSize = _shared2.default.parseStringParam(window.location.href, "bezelSize");
	
	  if (_lodash2.default.has(state, 'content.settings.custom_vars.cycletime')) {
	    cycleTime = Number(state.content.settings.custom_vars.cycletime);
	  }
	
	  if (!showBezel) {
	    showBezel = false;
	  }
	
	  if (!bezelSize) {
	    bezelSize = "17px";
	  } else {
	    bezelSize += "px";
	  }
	
	  return {
	    screen: state.screen,
	    content: state.content,
	    cycleTime: cycleTime,
	    showBezel: showBezel,
	    bezelSize: bezelSize
	    // element: this._elementStates[state.elementIndex],
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuoteShort);

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _timeHelpers = __webpack_require__(39);
	
	var _timeHelpers2 = _interopRequireDefault(_timeHelpers);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RANDOM_MODE = "random";
	var LAYOUT_MODE = "layout";
	var LAYOUT_A = "a";
	var LAYOUT_B = "b";
	var SHOWING = "showing";
	var HIDDEN = "hidden";
	var SLIDES_DELAY = 3000;
	var PHRASE = "phrase";
	var WORD = "word";
	
	var QuoteSlideshow = function (_Component) {
	  _inherits(QuoteSlideshow, _Component);
	
	  function QuoteSlideshow(props) {
	    _classCallCheck(this, QuoteSlideshow);
	
	    var _this = _possibleConstructorReturn(this, (QuoteSlideshow.__proto__ || Object.getPrototypeOf(QuoteSlideshow)).call(this, props));
	
	    _this.setupSlidesIntervalHandler = function () {
	      var slidesLeft = [];
	      var screensLeft = [];
	      var wordsLeft = [];
	
	      var intervalTimeout = setTimeout(function () {
	
	        slidesLeft = _this._slidesIndex.diff(_this._pulledSlidesIndex);
	        screensLeft = _this._screenNumbers.diff(_this._pulledScreens);
	
	        // console.log("Screens Left", screensLeft);
	        // console.log("Slides Left", slidesLeft);
	
	        var chosenSlideIndex = _shared2.default.getRandomInt(0, slidesLeft.length - 1);
	        var chosenScreenIndex = _shared2.default.getRandomInt(0, screensLeft.length - 1);
	
	        // console.log('Randomly chosen screen', chosenScreenIndex);
	        // console.log('Randomly chosen slide index', chosenSlideIndex);
	
	        _this._pulledSlidesIndex.push(slidesLeft[chosenSlideIndex]);
	        _this._pulledScreens.push(screensLeft[chosenScreenIndex]);
	
	        // console.log("Slide Pushed", slidesLeft[chosenSlideIndex]);
	
	        _this.setState({
	          currentSlideIndex: chosenSlideIndex,
	          chosenScreenIndex: chosenScreenIndex
	        });
	
	        _this._intervalWordsTimeout = null;
	        clearTimeout(_this._invervalWordsTimeout);
	        _this._intervalWordsTimeout = setTimeout(function () {
	          wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	          var chosenWordIndex = _shared2.default.getRandomInt(0, wordsLeft.length - 1);
	          _this._pulledWordsIndex.push(wordsLeft[chosenWordIndex]);
	
	          _this.setState({
	            chosenWordIndex: chosenWordIndex
	          });
	        }, _this._slideWordCycleTimeout);
	
	        if (_this._pulledSlidesIndex.length < _this._totalScreens) {
	          _this.setupSlidesIntervalHandler();
	        }
	      }, _this._slideCycleTimeout);
	
	      _this._invervalTimeoutArr.push(intervalTimeout);
	    };
	
	    _this.setupSlidesIntervalHandlerB = function () {
	      // console.log("Entering");
	      var slidesLeft = [];
	
	      var calculatedSlideCycleTimeout = _this._currentStatus === SHOWING ? _this._slideCycleTimeout : SLIDES_DELAY;
	      if (_this._chosenSlidesIndexes.length < 3 && _this._chosenSlidesIndexes.length > 0) {
	        calculatedSlideCycleTimeout = 1000;
	      }
	
	      var intervalTimeout = setTimeout(function () {
	        // console.log("executing cycle");
	
	        if (_this._currentStatus === HIDDEN) {
	          if (_this._currentLayout === LAYOUT_A) {
	            if (_this._slideScreens.length === 0) {
	              _this._slideScreens = _lodash2.default.shuffle([0, 4, 2]);
	              // this._wordsScreens = _.shuffle([3, 1, 5]);
	            }
	          } else {
	            if (_this._slideScreens.length === 0) {
	              _this._slideScreens = _lodash2.default.shuffle([3, 1, 5]);
	              // this._wordsScreens = _.shuffle([0, 4 ,2]);
	            }
	          }
	
	          // Number of images to pull is hardcoded
	          // Future change for dynamic selecting this
	          slidesLeft = _this._slidesIndex.diff(_this._pulledSlidesIndex);
	          if (slidesLeft.length === 0) {
	            _this._pulledSlidesIndex = [];
	            slidesLeft = _this._slidesIndex.diff(_this._pulledSlidesIndex);
	          }
	          var randomSlideIndex = _shared2.default.getRandomInt(0, slidesLeft.length - 1);
	          _this._chosenSlidesIndexes.push(slidesLeft[randomSlideIndex]);
	          _this._pulledSlidesIndex.push(slidesLeft[randomSlideIndex]);
	          _this._pulledSlidesCount++;
	
	          // console.log("Slides Count", this._pulledSlidesCount);
	
	          _this._iterator++;
	          _this.setState({
	            chosenSlidesIndexes: _this._chosenSlidesIndexes,
	            chosenScreens: _this._slideScreens,
	            iterator: _this._iterator,
	            showWords: false,
	            showSlides: true
	          });
	
	          if (_this._pulledSlidesCount >= 3) {
	            _this.setupWordsInterval();
	            _this._pulledSlidesCount = 0;
	            // console.log("screen count", this._screenCount)
	
	            if (_this._screenCount < 3) {
	              // console.log("Execute again");
	              _this._screenCount++;
	              _this._currentLayout = _this._currentLayout === LAYOUT_A ? LAYOUT_B : LAYOUT_A;
	              _this._currentStatus = SHOWING;
	            }
	          }
	
	          if (_this._screenCount < 3) {
	            _this.setupSlidesIntervalHandlerB();
	          }
	        } else {
	          _this._iterator++;
	          _this.setState({
	            iterator: _this._iterator,
	            showWords: false,
	            showSlides: false
	          });
	
	          _this._currentStatus = HIDDEN;
	          _this._chosenSlidesIndexes = [];
	          _this._chosenWordsIndexes = [];
	          _this._slideScreens = [];
	          _this._pulledSlidesCount = 0;
	          _this.setupSlidesIntervalHandlerB();
	        }
	      }, calculatedSlideCycleTimeout);
	
	      _this._invervalTimeoutArr.push(intervalTimeout);
	    };
	
	    _this.setupWordsInterval = function () {
	      var wordsTimeout = 1000;
	      var wordsLeft = [];
	
	      if (_this._currentWordsLayout === LAYOUT_A) {
	        if (_this._wordsScreens.length === 0) {
	          if (_this._useMain) {
	            _this._wordsScreens = [].concat([1], _lodash2.default.shuffle([3, 5]));
	          } else {
	            _this._wordsScreens = _lodash2.default.shuffle([3, 1, 5]);
	          }
	        }
	      } else {
	        if (_this._wordsScreens.length === 0) {
	          if (_this._useMain) {
	            _this._wordsScreens = [].concat([4], _lodash2.default.shuffle([0, 2]));
	          } else {
	            _this._wordsScreens = _lodash2.default.shuffle([0, 4, 2]);
	          }
	        }
	      }
	
	      if (_this._chosenWordsIndexes.length === 0) {
	        wordsTimeout = _this._slideWordCycleTimeout;
	      }
	
	      // clearTimeout(this._invervalWordsTimeout);
	      var intervalWordsTimeout = setTimeout(function () {
	        wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	
	        if (_this._currentWordMode === PHRASE) {
	          wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	            var splitedWords = _this._slidesWords[o].split(" ");
	            return splitedWords.length > 1;
	          });
	        } else {
	          wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	            var splitedWords = _this._slidesWords[o].split(" ");
	            return splitedWords.length === 1;
	          });
	        }
	
	        if (wordsLeft.length === 0 || wordsLeft.length < 3) {
	          _this._pulledWordsIndex = [];
	          wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	
	          _this._chosenWordsIndexes = [];
	          if (_this._currentWordMode === PHRASE) {
	            wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	              var splitedWords = _this._slidesWords[o].split(" ");
	              return splitedWords.length > 1;
	            });
	            if (wordsLeft.length === 0 || wordsLeft.length < 3) {
	              wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	              wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	                var splitedWords = _this._slidesWords[o].split(" ");
	                return splitedWords.length === 1;
	              });
	              _this._currentWordMode = WORD;
	            }
	          } else {
	            wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	              var splitedWords = _this._slidesWords[o].split(" ");
	              return splitedWords.length === 1;
	            });
	            if (wordsLeft.length === 0 || wordsLeft.length < 3) {
	              wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	              wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	                var splitedWords = _this._slidesWords[o].split(" ");
	                return splitedWords.length > 1;
	              });
	              _this._currentWordMode = PHRASE;
	            }
	          }
	        }
	
	        if (wordsLeft.length > 0) {
	          var chosenWordIndex = _shared2.default.getRandomInt(0, wordsLeft.length - 1);
	
	          _this._chosenWordsIndexes.push(wordsLeft[chosenWordIndex]);
	          _this._pulledWordsIndex.push(wordsLeft[chosenWordIndex]);
	        }
	
	        _this._iterator++;
	        _this.setState({
	          chosenWordsIndexes: _this._chosenWordsIndexes,
	          wordsScreens: _this._wordsScreens,
	          iterator: _this._iterator,
	          showWords: true
	        });
	
	        if (_this._chosenWordsIndexes.length < 3) {
	          _this.setupWordsInterval();
	        } else {
	          _this._currentWordsLayout = _this._currentWordsLayout === LAYOUT_A ? LAYOUT_B : LAYOUT_A;
	          _this._currentWordMode = _this._currentWordMode === PHRASE ? WORD : PHRASE;
	          _this._pulledWordsIndex = [];
	          _this._wordsScreens = [];
	        }
	      }, wordsTimeout);
	      _this._invervalWordsTimeoutArr.push(intervalWordsTimeout);
	    };
	
	    _this.renderSlides = function () {
	      var images = [];
	
	      _this._pulledSlidesIndex.forEach(function (value, index) {
	        images.push({
	          background: _this._slides[value].image,
	          screen: _this._pulledScreens[index]
	        });
	      });
	
	      var slideStyle = {
	        position: "absolute",
	        width: _this.props.screen.screenWidth / _this.props.xScreens,
	        height: _this.props.screen.screenHeight / _this.props.yScreens
	      };
	
	      var renderedImages = images.map(function (row, i) {
	        var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	        var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	
	        return _react2.default.createElement('div', { key: i, style: Object.assign({}, slideStyle, { left: slideLeft, top: slideTop, backgroundImage: "url(" + row.background + ")", backgroundSize: "cover" }) });
	      });
	
	      return renderedImages;
	    };
	
	    _this.renderWords = function () {
	      var words = [];
	      _this._pulledWordsIndex.forEach(function (value, index) {
	        words.push({
	          word: _this._slidesWords[value],
	          screen: _this._pulledScreens[index]
	        });
	      });
	
	      var slideStyle = {
	        position: "absolute",
	        width: _this.props.screen.screenWidth / _this.props.xScreens,
	        height: _this.props.screen.screenHeight / _this.props.yScreens,
	        display: "table"
	      };
	
	      var textShadow = Math.ceil(_this.props.screen.screenWidth * 0.001041667);
	
	      var centeredDiv = {
	        display: "table-cell",
	        verticalAlign: "middle",
	        textAlign: "center"
	      };
	
	      if (_this.props.textShadow) {
	        centeredDiv.textShadow = textShadow + "px " + textShadow + "px 3px rgba(0,0,0,1)";
	      }
	
	      var mainFontColor = _lodash2.default.get(_this.props.element, 'customFields.main_word_style.fontColor', '#FFFFFF');
	      var style = {
	        font: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.font', 'Roboto'),
	        color: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontColor', '#FFFFFF'),
	        fontSize: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontSize', "6.5") + "vh",
	        fontStyle: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontStyle', "Normal"),
	        fontWeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontWeight', 100),
	        lineHeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.lineHeight', null),
	        justification: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.justification', null),
	        display: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.display', true) ? 'block' : 'none'
	      };
	
	      var renderedWords = words.map(function (row, i) {
	        var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	        var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	        // let fontSize = row.word.split(" ").length > 1 ? "5.78vh" : "8.10vh";
	        if (_this._useMain && [1, 4].indexOf(row.screen) > -1) {
	          style.color = mainFontColor;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: Object.assign({}, style, slideStyle, { left: slideLeft, top: slideTop }) },
	          _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, centeredDiv) },
	            _react2.default.createElement(
	              'span',
	              { style: { color: "white" } },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: row.word })
	            )
	          )
	        );
	      });
	
	      return renderedWords;
	    };
	
	    _this.renderLayoutSlides = function () {
	      // console.log("Slides Indexes", this.state);
	      // console.log("Chosen Screens", this.state);
	
	      var renderedImages = null;
	      var images = [];
	
	      if (_lodash2.default.has(_this.state, "chosenSlidesIndexes")) {
	        _this.state.chosenSlidesIndexes.forEach(function (index, i) {
	          images.push({
	            background: _this._slides[index].image,
	            screen: _this.state.chosenScreens[i]
	          });
	        });
	
	        var slideStyle = {
	          position: "absolute",
	          width: _this.props.screen.screenWidth / _this.props.xScreens,
	          height: _this.props.screen.screenHeight / _this.props.yScreens
	        };
	
	        renderedImages = images.map(function (row, i) {
	          var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	          var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	
	          return _react2.default.createElement('div', { key: i, style: Object.assign({}, slideStyle, { left: slideLeft, top: slideTop, backgroundImage: "url(" + row.background + ")", backgroundSize: "cover" }) });
	        });
	      }
	
	      return renderedImages;
	    };
	
	    _this.renderLayoutWords = function () {
	      var renderedWords = null;
	      var words = [];
	
	      if (_lodash2.default.has(_this.state, "chosenWordsIndexes")) {
	        if (_this.state.chosenWordsIndexes) {
	          _this.state.chosenWordsIndexes.forEach(function (index, i) {
	            var word = _this._slidesWords[index];
	            if (_this._useMain && [1, 4].indexOf(_this.state.wordsScreens[i]) > -1) {
	              word = _this._mainWord.toUpperCase();
	            }
	            words.push({
	              word: word,
	              screen: _this.state.wordsScreens[i]
	            });
	          });
	        }
	
	        var slideStyle = {
	          position: "absolute",
	          width: _this.props.screen.screenWidth / _this.props.xScreens,
	          height: _this.props.screen.screenHeight / _this.props.yScreens,
	          display: "table"
	        };
	
	        var textShadow = Math.ceil(_this.props.screen.screenWidth * 0.001041667);
	
	        var centeredDiv = {
	          display: "table-cell",
	          verticalAlign: "middle",
	          textAlign: "center"
	        };
	
	        if (_this.props.textShadow) {
	          centeredDiv.textShadow = textShadow + "px " + textShadow + "px 3px rgba(0,0,0,1)";
	        }
	
	        var mainFontColor = _lodash2.default.get(_this.props.element, 'customFields.main_word_style.fontColor', '#FFFFFF');
	        var style = {
	          font: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.font', 'Roboto'),
	          fontColor: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontColor', '#FFFFFF'),
	          fontSize: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontSize', "6.5") + "vh",
	          fontStyle: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontStyle', "Normal"),
	          fontWeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontWeight', 100),
	          lineHeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.lineHeight', null),
	          justification: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.justification', null),
	          display: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.display', true) ? 'table' : 'none'
	        };
	
	        if (words.length > 0) {
	          renderedWords = words.map(function (row, i) {
	            var color = style.fontColor;
	            var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	            var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	            if (_this._useMain && [1, 4].indexOf(row.screen) > -1) {
	              color = mainFontColor;
	            }
	
	            return _react2.default.createElement(
	              'div',
	              { key: i, style: Object.assign({}, style, slideStyle, { left: slideLeft, top: slideTop }) },
	              _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, centeredDiv) },
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: color } },
	                  _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: row.word })
	                )
	              )
	            );
	          });
	        }
	      }
	
	      return renderedWords;
	    };
	
	    try {
	      _this._currentBackground = null;
	      _this._currentLayout = LAYOUT_A;
	      _this._currentWordsLayout = LAYOUT_A;
	      _this._currentWordMode = Math.floor(Math.random() * 10 + 1) % 2 === 0 ? PHRASE : WORD;
	      _this._currentMode = LAYOUT_MODE;
	      _this._currentStatus = HIDDEN;
	
	      _this._finishCycle = false;
	      _this._chosenMode = false;
	      _this._iterator = 0;
	      _this._screenCount = 0;
	      _this._pulledSlidesCount = 0;
	      _this._quoteCycleTime = 0;
	      _this._slides = [];
	      _this._slidesWords = [];
	      _this._slideScreens = [];
	      _this._wordsScreens = [];
	      _this._selectedWordIndex = null;
	      _this._slideCycleTimeout = _this.props.communitiesSlideCycleTime;
	      _this._slideWordCycleTimeout = _this.props.communitiesWordCycleTime;
	      _this._wordsStyle = null;
	
	      _this.setupElements();
	
	      _this._slidesIndex = _this._slides.map(function (x, index) {
	        return index;
	      });
	      _this._wordsIndex = _this._slidesWords.map(function (x, index) {
	        return index;
	      });
	
	      _this._pulledSlidesIndex = [];
	      _this._pulledImages = [];
	      _this._pulledScreens = [];
	      _this._pulledWordsIndex = [];
	      _this._chosenSlidesIndexes = [];
	      _this._chosenWordsIndexes = [];
	
	      _this._invervalTimeoutArr = [];
	      _this._invervalWordsTimeoutArr = [];
	      _this._totalScreens = _this.props.yScreens * _this.props.xScreens;
	      _this._screenNumbers = Array.apply(null, { length: _this._totalScreens }).map(Number.call, Number);
	      _this._spanStyle = Array.apply(null, { length: _this._totalScreens }).map(function (value) {
	        return {};
	      });
	
	      /*eslint no-extend-native: ["warn", { "exceptions": ["Array"] }]*/
	      Array.prototype.diff = function (a) {
	        if (this.filter) {
	          return this.filter(function (i) {
	            return a.indexOf(i) < 0;
	          });
	        }
	      };
	
	      _this.state = {
	        background: _this._currentBackground,
	        slides: _this._slides
	      };
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(QuoteSlideshow, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // console.log("Slideshow component mounted");
	      try {
	        if (this._currentMode === LAYOUT_MODE) {
	          this.setupSlidesIntervalHandlerB();
	        } else if (this._currentMode === RANDOM_MODE) {
	          this.setupSlidesIntervalHandler();
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._invervalTimeoutArr.map(function (timeoutHandler) {
	        return clearTimeout(timeoutHandler);
	      });
	
	      this._invervalWordsTimeoutArr.map(function (timeoutHandler) {
	        return clearTimeout(timeoutHandler);
	      });
	    }
	  }, {
	    key: 'setupElements',
	    value: function setupElements() {
	      var _this2 = this;
	
	      var rawSlides = _lodash2.default.get(this.props.element, 'customFields.slides.val', []);
	      var rawBackgrounds = _lodash2.default.get(this.props.element, 'customFields.backgrounds.val', []);
	      var slides = rawSlides.map(function (slide) {
	        return {
	          image: _shared2.default.dp(_this2.props.screen, slide)
	        };
	      });
	      var backgrounds = rawBackgrounds.map(function (background) {
	        return {
	          image: _shared2.default.dp(_this2.props.screen, background)
	        };
	      });
	
	      var pairLength = 0;
	
	      // Checking words Array
	      var wordPairs = _lodash2.default.get(this.props.element, 'arrays.words_pair', null);
	      var wordsPairsValues = _lodash2.default.get(this.props.element, 'arraysValues.words_pair', null);
	      this._quoteCycleTime = _lodash2.default.get(this.props.element, 'customFields.cycle_time.val', 20000);
	
	      if (wordPairs) {
	        pairLength = wordPairs.values.length;
	        for (var i = 0; i < pairLength; i++) {
	          wordPairs.values[i].main_word['value'] = _lodash2.default.get(wordsPairsValues, '[' + i + '].main_word.val', null);
	          wordPairs.values[i].words['value'] = _lodash2.default.get(wordsPairsValues, '[' + i + '].words.val', null);
	        }
	
	        var wordPairsLength = 0;
	        if (wordPairs.values && wordPairs.values instanceof Array) {
	          wordPairsLength = wordPairs.values.length;
	        }
	
	        this._selectedWordIndex = _timeHelpers2.default.indexFromInterval(this._quoteCycleTime, wordPairsLength);
	        this._slidesWords = wordPairs.values[this._selectedWordIndex].words.value.split(",");
	        this._mainWord = wordPairs.values[this._selectedWordIndex].main_word.value;
	        this._slidesWords = _lodash2.default.map(this._slidesWords, function (word) {
	          var trimmedWord = word.trim();
	          return trimmedWord;
	        });
	      }
	
	      var backgroundIndex = _shared2.default.getRandomInt(0, backgrounds.length - 1);
	      this._currentBackground = backgrounds[backgroundIndex];
	      this._slides = slides;
	      this._useMain = _lodash2.default.get(this.props.element, 'customFields.use_main.val', false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var slides = null;
	      var words = null;
	
	      if (this._currentMode === LAYOUT_MODE) {
	        // console.log("Got in layout mode");
	        slides = this.renderLayoutSlides();
	        words = this.renderLayoutWords();
	      } else {
	        // console.log("Got in random mode");
	        slides = this.renderSlides();
	        words = this.renderWords();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "absolute", top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundSize: "cover", backgroundImage: "url(" + this.state.background.image + ")" } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.iterator },
	            this.state.showSlides ? slides : null,
	            this.state.showWords ? words : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return QuoteSlideshow;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var textShadow = _shared2.default.parseStringParam(window.location.href, "textShadow");
	  var communitiesSlideCycleTime = Number(_lodash2.default.get(state.content.settings.custom_vars, 'slidescycletime', 27000));
	  var communitiesWordCycleTime = Number(_lodash2.default.get(state.content.settings.custom_vars, 'wordscycletime', 3000));
	
	  if (!textShadow) {
	    textShadow = false;
	  }
	
	  return {
	    screen: state.screen,
	    content: state.content,
	    communitiesSlideCycleTime: communitiesSlideCycleTime,
	    communitiesWordCycleTime: communitiesWordCycleTime,
	    textShadow: textShadow
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuoteSlideshow);

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _videoStyle = {
	  preload: 'auto',
	  position: 'relative',
	  minWidth: '100%',
	  minHeight: '100%',
	  width: '100%',
	  height: '100%',
	  loop: '',
	  autoplay: "",
	  muted: "",
	  pointerEvents: "none"
	};
	
	var QuoteStory = function (_Component) {
	  _inherits(QuoteStory, _Component);
	
	  function QuoteStory(props) {
	    _classCallCheck(this, QuoteStory);
	
	    var _this = _possibleConstructorReturn(this, (QuoteStory.__proto__ || Object.getPrototypeOf(QuoteStory)).call(this, props));
	
	    try {
	      _this._element = _this.props.element;
	      _this._horizontalScreens = _lodash2.default.get(_this.props, 'horizontalScreens', 3);
	      _this._verticalScreens = _lodash2.default.get(_this.props, 'verticalScreens', 2);
	      _this._fullscreen = _lodash2.default.get(_this.props, 'fullscreen', false);
	
	      _this.state = {
	        element: _this.props.element,
	        currentStage: _this.props.stage
	      };
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(QuoteStory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // console.log("Mounted")
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      try {
	        if (!this.state.element) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            'No element present in the props'
	          );
	        }
	
	        var sectionWidth = this.props.screen.screenWidth / this._horizontalScreens;
	        var sectionHeight = this.props.screen.screenHeight / this._verticalScreens;
	        var fileType = this.state.element.backgroundType;
	        var backgroundOffsetX = this.state.element.bodyCopy.section === "right" ? 0 : sectionWidth;
	        var quoteOffsetX = this.state.element.bodyCopy.section === "right" ? sectionWidth * 2 : 0;
	
	        var mediaStyle = {
	          left: backgroundOffsetX,
	          top: 0,
	          width: sectionWidth * 2,
	          maxWidth: sectionWidth * 2,
	          height: this.props.screen.screenHeight
	        };
	
	        if (this._fullscreen) {
	          mediaStyle.left = 0;
	          mediaStyle.width = this.props.screen.screenWidth;
	          mediaStyle.maxWidth = this.props.screen.screenWidth;
	          mediaStyle.height = this.props.screen.screenHeight;
	        }
	
	        // Content (Media or Video)
	        var content = "";
	
	        if (fileType === "video") {
	          var cType = (0, _shared.videoType)(this.state.element.backgroundImageDonorSea);
	          content = _react2.default.createElement(
	            'div',
	            { className: 'vid', style: { position: 'absolute', top: 0, left: backgroundOffsetX, width: sectionWidth * 2, maxWidth: sectionWidth * 2 } },
	            _react2.default.createElement(
	              'video',
	              { style: _videoStyle, ref: function ref(el) {
	                  return _this2._currentVideoRef = el;
	                }, id: 'background-video', loop: true, autoPlay: true, muted: true },
	              _react2.default.createElement('source', { src: this.state.element.backgroundImageDonorSea, type: cType }),
	              'Your browser does not support the video tag.'
	            )
	          );
	        } else {
	          content = _react2.default.createElement('div', { style: Object.assign({}, mediaStyle, { position: 'absolute', backgroundSize: "cover", backgroundImage: "url(" + this.state.element.backgroundImageDonorSea + ")" }) });
	        }
	
	        // QuoteArea
	        var quoteArea = "";
	        if (!this._fullscreen) {
	          quoteArea = _react2.default.createElement('div', { style: { backgroundColor: this.state.element.bodyCopy.quoteBackdrop, width: sectionWidth, height: sectionHeight * this._verticalScreens, left: quoteOffsetX, position: "fixed" } });
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          content,
	          quoteArea
	        );
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }]);
	
	  return QuoteStory;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screen: state.screen,
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuoteStory);

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuoteText = function (_Component) {
	  _inherits(QuoteText, _Component);
	
	  function QuoteText(props) {
	    _classCallCheck(this, QuoteText);
	
	    var _this = _possibleConstructorReturn(this, (QuoteText.__proto__ || Object.getPrototypeOf(QuoteText)).call(this, props));
	
	    _this.state = {
	      elementIndex: _this.props.elementIndex
	    };
	    return _this;
	  }
	
	  _createClass(QuoteText, [{
	    key: 'render',
	    value: function render() {
	
	      var section = {
	        width: this.props.screenWidth / this.props.xScreens,
	        height: this.props.screenHeight / this.props.yScreens
	      };
	
	      var margins = {
	        left: section.width * 0.09,
	        right: section.width * 0.09
	      };
	
	      var cssStyle = {
	        position: 'absolute',
	        top: 0,
	        width: this.props.screenWidth / this.props.sections,
	        height: '100%',
	        backgroundColor: this.props.bodyCopy.quoteBackdrop
	      };
	
	      var spanStyle = {
	        position: 'relative',
	        width: '100%',
	        height: '100%'
	      };
	
	      var spanSignature = {
	        fontSize: this.props.screenHeight * 0.03125,
	        fontWeight: 'bold',
	        lineHeight: '150%'
	      };
	
	      spanSignature.fontSize = this.props.bodyCopy.signatureStyle.fontSize > 0 ? this.props.bodyCopy.signatureStyle.fontSize * this.props.screenHeight / 100 : this.props.screenHeight * 0.03125;
	      spanSignature.fontStyle = _lodash2.default.get(this.props, 'bodyCopy.signatureStyle.fontStyle', 'normal');
	      spanSignature.justification = _lodash2.default.get(this.props, 'bodyCopy.signatureStyle.justification', 'left');
	      spanSignature.font = _lodash2.default.get(this.props, 'bodyCopy.signatureStyle.font', 'Roboto');
	      spanSignature.fontWeight = _lodash2.default.get(this.props, 'bodyCopy.signatureStyle.fontWeight', 'bold');
	      spanSignature.lineHeight = _lodash2.default.get(this.props, 'bodyCopy.signatureStyle.justification', '150') + '%';
	      spanSignature.display = this.props.bodyCopy.signatureStyle.visible ? "block" : "none";
	      spanSignature.color = _lodash2.default.get(this.props.bodyCopy.signatureStyle, 'fontColor', "#000000");
	
	      var spanBodyTextStyle = {
	        position: 'absolute',
	        textAlign: 'justify',
	        fontSize: this.props.screenHeight * 0.025,
	        lineHeight: '185%'
	      };
	
	      spanBodyTextStyle.fontSize = this.props.bodyCopy.longQuoteStyle.fontSize > 0 ? this.props.bodyCopy.longQuoteStyle.fontSize * this.props.screenHeight / 100 : this.props.screenHeight * 0.025;
	      spanBodyTextStyle.fontStyle = _lodash2.default.get(this.props, 'bodyCopy.longQuoteStyle.fontStyle', 'normal');
	      spanBodyTextStyle.justification = _lodash2.default.get(this.props, 'bodyCopy.longQuoteStyle.justification', 'left');
	      spanBodyTextStyle.font = _lodash2.default.get(this.props, 'bodyCopy.longQuoteStyle.font', 'Roboto');
	      spanBodyTextStyle.fontWeight = _lodash2.default.get(this.props, 'bodyCopy.longQuoteStyle.fontWeight', 'bold');
	      spanBodyTextStyle.lineHeight = _lodash2.default.get(this.props, 'bodyCopy.longQuoteStyle.lineHeight', '185') + '%';
	      spanBodyTextStyle.display = this.props.bodyCopy.longQuoteStyle.visible ? "block" : "none";
	      spanBodyTextStyle.color = _lodash2.default.get(this.props.bodyCopy.longQuoteStyle, 'fontColor', "#000000");
	
	      var longQuoteCenterOffset = Number(this.props.bodyCopy.longQuoteCenterOffset) + 50 + "%";
	      var leftBodyCopy = 0;
	
	      switch (this.props.bodyCopy.section) {
	        case "left":
	          leftBodyCopy = 0;
	          break;
	        case "middle":
	          leftBodyCopy = this.props.screenWidth / 3;
	          break;
	        case "right":
	          leftBodyCopy = this.props.screenWidth / 3 * 2;
	          break;
	        default:
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: Object.assign({}, cssStyle, { left: leftBodyCopy }) },
	        _react2.default.createElement(
	          'div',
	          { style: spanStyle },
	          _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, spanBodyTextStyle, { bottom: longQuoteCenterOffset, marginLeft: margins.left, marginRight: margins.right }) },
	            _react2.default.createElement('div', { className: 'ql-editor', dangerouslySetInnerHTML: { __html: this.props.upperText } }),
	            this.props.lowerText.length === 0 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { style: { display: 'inline-block', width: '100%', height: this.props.screenHeight * 0.06 } }),
	              _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, spanSignature) },
	                _react2.default.createElement('div', { className: 'ql-editor', dangerouslySetInnerHTML: { __html: this.props.signature } })
	              )
	            ) : null
	          ),
	          this.props.lowerText.length > 0 ? _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, spanBodyTextStyle, { top: longQuoteCenterOffset, marginLeft: margins.left, marginRight: margins.right }) },
	            _react2.default.createElement('div', { className: 'ql-editor', dangerouslySetInnerHTML: { __html: this.props.lowerText } }),
	            _react2.default.createElement('div', { style: { display: 'inline-block', width: '100%', height: this.props.screenHeight * 0.06 } }),
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, spanSignature) },
	              _react2.default.createElement('div', { className: 'ql-editor', dangerouslySetInnerHTML: { __html: this.props.signature } })
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return QuoteText;
	}(_react.Component);
	
	exports.default = QuoteText;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Results = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _fuse = __webpack_require__(567);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ops = {
	  shouldSort: true,
	  threshold: 0.2,
	  location: 0,
	  distance: 1000,
	  maxPatternLength: 32,
	  minMatchCharLength: 1,
	  findAllMatches: true,
	  keys: ["q1", "q2"],
	  id: 'uuid'
	};
	
	var Results = exports.Results = function (_Component) {
	  _inherits(Results, _Component);
	
	  function Results(props) {
	    _classCallCheck(this, Results);
	
	    var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));
	
	    _this.state = {
	      normalizedData: [],
	      initialLocationSet: false,
	      query: _shared2.default.parseStringParam(_this.props.history.location.search, "query")
	    };
	    _this.scrollRef = {};
	    _this.storyRefs = [];
	    _this.donorRefs = [];
	    _this.normalizeSearchData = _this.normalizeSearchData.bind(_this);
	    _this.setInitialLocation = _this.setInitialLocation.bind(_this);
	    return _this;
	  }
	
	  _createClass(Results, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _shared2.default.checkData(this.props.screen);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.normalizeSearchData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var _loop = function _loop(i) {
	        _this2.storyRefs[i].removeEventListener("tap", function () {
	          return _this2.handleTap(_this2.storyRefs[i]);
	        });
	      };
	
	      for (var i = 0; i < this.storyRefs.length; i++) {
	        _loop(i);
	      }
	
	      var _loop2 = function _loop2(a) {
	        _this2.donorRefs[a].removeEventListener("tap", function () {
	          return _this2.handleTap(_this2.donorRefs[a]);
	        });
	      };
	
	      for (var a = 0; a < this.donorRefs.length; a++) {
	        _loop2(a);
	      }
	    }
	  }, {
	    key: 'setInitialLocation',
	    value: function setInitialLocation() {
	      var _this3 = this;
	
	      if (this.state.initialLocationSet === false) {
	        var _loop3 = function _loop3(i) {
	          _this3.storyRefs[i].addEventListener("tap", function () {
	            return _this3.handleTap(_this3.storyRefs[i]);
	          });
	        };
	
	        for (var i = 0; i < this.storyRefs.length; i++) {
	          _loop3(i);
	        }
	
	        var _loop4 = function _loop4(a) {
	          _this3.donorRefs[a].addEventListener("tap", function () {
	            return _this3.handleTap(_this3.donorRefs[a]);
	          });
	        };
	
	        for (var a = 0; a < this.donorRefs.length; a++) {
	          _loop4(a);
	        }
	        this.setState({
	          initialLocationSet: true
	        });
	      }
	    }
	
	    //consider caching all this data on start, or delivering from server in this fasion.
	
	  }, {
	    key: 'normalizeSearchData',
	    value: function normalizeSearchData() {
	      var normalizedData = [];
	      var uuid = 0;
	      for (var i = 0; i < this.props.donors.donorCategories.length; i++) {
	        if (this.props.donors.donorCategories[i].donors.length > 0) {
	          for (var a = 0; a < this.props.donors.donorCategories[i].donors.length; a++) {
	            normalizedData.push({
	              uuid: uuid++,
	              q1: this.props.donors.donorCategories[i].donors[a].name,
	              q2: "",
	              q3: "",
	              type: "donor",
	              id: this.props.donors.donorCategories[i].donors[a].id,
	              ref1: i,
	              ref2: a
	            });
	          }
	        }
	      }
	
	      for (var b = 0; b < this.props.content.dm_active.length; b++) {
	        if (this.props.content.dm_active[b].display_module_type === "Story") {
	          normalizedData.push({
	            uuid: uuid++,
	            q1: this.props.content.dm_active[b].stories[0].name,
	            q2: this.props.content.dm_active[b].stories[0].contents.headline,
	            q3: this.props.content.dm_active[b].stories[0].contents.story,
	            type: "story",
	            id: this.props.content.dm_active[b].stories[0].id,
	            ref1: b,
	            ref2: 0
	          });
	        }
	        if (this.props.content.dm_active[b].display_module_type === "Stories") {
	          for (var c = 0; c < this.props.content.dm_active[b].stories.length; c++) {
	            if (!_lodash2.default.find(normalizedData, { id: this.props.content.dm_active[b].stories[c].id, type: "story" })) {
	              normalizedData.push({
	                uuid: uuid++,
	                q1: this.props.content.dm_active[b].stories[c].name,
	                q2: this.props.content.dm_active[b].stories[c].contents.headline,
	                q3: this.props.content.dm_active[b].stories[c].contents.story,
	                type: "stories",
	                id: this.props.content.dm_active[b].stories[c].id,
	                ref1: b,
	                ref2: c
	              });
	            }
	          }
	          // _.forEach(this.props.content.dm_active[b].stories, (story, index) => {
	          //   if (!_.find(normalizedData, { id: story.id, type: "story" })) {
	          //     normalizedData.push({
	          //       uuid: uuid++,
	          //       q1: story.name,
	          //       q2: story.contents.headline,
	          //       q3: story.contents.story,
	          //       type: "stories",
	          //       id: story.id,
	          //       ref1: b,
	          //       ref2: index
	          //     });
	          //   }
	          // })
	        }
	      }
	      this.setState({
	        normalizedData: normalizedData
	      });
	    }
	  }, {
	    key: 'renderDonorResults',
	    value: function renderDonorResults(donorResults) {
	      return donorResults.map(function (row, i) {
	        var _this4 = this;
	
	        return _react2.default.createElement(
	          'div',
	          { className: "phand donorlist?activeRef=" + row.activeRef + "&donorid=" + row.donor_id, style: { fontSize: this.props.screen.r16_9.p10 * .3 }, ref: function ref(el) {
	              return _this4.donorRefs[i] = el;
	            }, key: i },
	          row.dm_name,
	          ' | ',
	          row.name
	        );
	      }, this);
	    }
	  }, {
	    key: 'renderStoryResults',
	    value: function renderStoryResults(storyResults) {
	      return storyResults.map(function (row, i) {
	        var _this5 = this;
	
	        return _react2.default.createElement(
	          'div',
	          { id: row.story_id, className: "phand story?selectedModule=" + row.dmActiveRef, ref: function ref(el) {
	              return _this5.storyRefs[i] = el;
	            }, key: i, style: { fontSize: this.props.screen.r16_9.p10 * .3 } },
	          row.name,
	          ' | ',
	          row.headline
	        );
	      }, this);
	    }
	  }, {
	    key: 'handleTap',
	    value: function handleTap(e) {
	      var fullClass = String(e.className);
	      if (e.className.includes("story")) {
	        var selectedModule = _shared2.default.parseStringParam(fullClass, "selectedModule");
	        //console.log("logging: ", selectedModule, e.id);
	        //console.log(this.props.content.dm_active[selectedModule].display_module_type)
	        if (this.props.content.dm_active[selectedModule].display_module_type === "Story") {
	          this.props.navroute(selectedModule, "Story", "Search", null);
	        } else if (this.props.content.dm_active[selectedModule].display_module_type === "Stories") {
	          for (var i = 0; i < this.props.content.dm_active[selectedModule].stories.length; i++) {
	            if (Number(this.props.content.dm_active[selectedModule].stories[i].id) === Number(e.id)) {
	              this.props.navroute(selectedModule, "Story", "Stories", { storyIndex: i });
	            }
	          }
	        }
	        //SHOULD LIST STORIES MODULE | STORIES, if result is from a stories module... 
	        //NEED TO SET NULL TO THE MODULE REF OF THE STORY, OR THE STORIES MODULE IT BELONGS TO?
	        //May return id of story, might need to loop through actives for id match, if so set as story
	        //If not loop through stories modules module, better would be to pass "stories module id (or null) and then active module idref or stories ref"
	
	
	        // this.props.navroute(selectedModule, Number(e.id), "Story", false);
	      }
	      if (e.className.includes("donor")) {
	        var donorId = _shared2.default.parseStringParam(fullClass, "donorid");
	        var activeRef = _shared2.default.parseStringParam(fullClass, "activeRef");
	        var donorlistmodule = this.props.content.dm_active[activeRef];
	
	        if (donorlistmodule !== null) {
	          this.props.navroute(activeRef, "Donor List", "Results", { donorId: donorId });
	        }
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this6 = this;
	
	      if (this.state.normalizedData.length > 0) {
	
	        var fuse = new _fuse2.default(this.state.normalizedData, ops);
	        var results = fuse.search(this.state.query);
	        var donorResults = [];
	        var storyResults = [];
	        var story = void 0;
	        _lodash2.default.forEach(results, function (result) {
	          var rref = _lodash2.default.find(_this6.state.normalizedData, { uuid: result });
	          //TODO: 
	          // updating too often, handle dont update
	          //    console.log("*********RREF RESULSTS***********");
	          //     console.log(rref);
	          //      console.log("*********END RESULTS************");
	          switch (rref.type) {
	            case "donor":
	              var donor = _this6.props.donors.donorCategories[rref.ref1].donors[rref.ref2];
	              _lodash2.default.forEach(_this6.props.content.dm_active, function (dm, index) {
	                if (dm.display_module_type === "Donor List" || dm.display_module_type === "Donor Sea") {
	                  _lodash2.default.forEach(dm.contents.include_categories, function (catId) {
	                    if (catId === donor.donor_category) {
	                      donorResults.push({ dmActiveRef: rref.ref1, name: donor.name, donor_id: donor.id, dm_name: dm.name, activeRef: index });
	                    }
	                  });
	                }
	              });
	              break;
	            case "story":
	              story = _this6.props.content.dm_active[rref.ref1].stories[0];
	              storyResults.push({ dmActiveRef: rref.ref1, story_id: story.id, name: story.name, headline: story.contents.headline });
	              break;
	            case "stories":
	              story = _this6.props.content.dm_active[rref.ref1].stories[rref.ref2];
	              storyResults.push({ dmActiveRef: rref.ref1, story_id: story.id, name: _this6.props.content.dm_active[rref.ref1].name + " | " + story.name, headline: story.contents.headline });
	              break;
	            default:
	              break;
	          }
	        });
	        var renderDonors = this.renderDonorResults(donorResults);
	        var renderStories = this.renderStoryResults(storyResults);
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: this.props.screen.r16_9.p10 * .6 } },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Donors'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          renderDonors,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: this.props.screen.r16_9.p10 * .6 } },
	            _react2.default.createElement(
	              'b',
	              null,
	              'Stories'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          renderStories
	        );
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var results = this.renderResults();
	      var u10 = this.props.screen.r16_9.p10;
	
	      var headlineText = {
	        textAlign: 'vertical',
	        display: 'inline-block',
	        color: 'black',
	        fontSize: this.props.screen.r16_9.p10 * .6,
	        lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
	        position: 'absolute',
	        width: this.props.screen.r16_9.screenWidth
	      };
	
	      var leftWidth = this.props.screen.r16_9.left + this.props.screen.r16_9.width / 6;
	      var innerRightWidth = this.props.screen.r16_9.width - this.props.screen.r16_9.width / 6;
	      var rightWidth = this.props.screen.screenWidth - leftWidth;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '100vw', height: '100vh', position: 'absolute' } },
	        _react2.default.createElement('div', { style: { position: 'fixed', top: 0, left: leftWidth, width: rightWidth, height: this.props.screen.screenHeight, backgroundColor: 'white', color: 'black', pointerEvents: 'none' } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'phand', style: { color: 'black', position: 'fixed', left: leftWidth + u10, top: 0, height: u10 * 2, width: rightWidth, backgroundColor: 'white' } },
	          _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: 'red', position: 'absolute', top: u10, width: '100%' } },
	            _react2.default.createElement(
	              'span',
	              { style: headlineText },
	              _react2.default.createElement(
	                'b',
	                null,
	                'Search Results'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 7, color: 'black', pointerEvents: 'auto', touchAction: "none" } },
	          _react2.default.createElement(
	            _reactIscroll2.default,
	            { ref: function ref(el) {
	                return _this7.scrollRef[0] = el;
	              }, iScroll: _iscroll2.default,
	              options: {
	                mouseWheel: true,
	                scrollbars: false,
	                scrollX: false,
	                scrollY: true,
	                probeType: 2,
	                bounce: false,
	                momentum: true,
	                deceleration: 0.015,
	                useTransition: true,
	                disableTouch: false,
	                disablePointer: false,
	                disableMouse: false,
	                tap: true
	                //deceleration: .01
	              },
	              onRefresh: this.setInitialLocation
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { style: { height: u10 * .5 } }),
	              results,
	              _react2.default.createElement('div', { style: { height: u10 * 7 } })
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'topgrad', style: { position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1 } }),
	        _react2.default.createElement('div', { className: 'bottomgrad', style: { position: 'fixed', top: u10 * 8, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1.1 } }),
	        _react2.default.createElement('br', { style: { clear: 'both' } })
	      );
	    }
	  }]);
	
	  return Results;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    screen: state.screen,
	    donors: state.donors,
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Results);

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _KeyboardKey = __webpack_require__(158);
	
	var _KeyboardKey2 = _interopRequireDefault(_KeyboardKey);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { switchVirtualKeyboardMode } from '../../actions/displayDataActions';
	// import {Results} from './Results'
	
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.state = {
	      text: "",
	      virtual_keyboard_mode: 0
	    };
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.deleteText = _this.deleteText.bind(_this);
	    _this.normalMode = _this.normalMode.bind(_this);
	    _this.capitalMode = _this.capitalMode.bind(_this);
	    _this.submitText = _this.submitText.bind(_this);
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(val) {
	      if (typeof val === "function") {
	        val();
	      } else {
	        var str = this.state.text + val;
	        if (str.length < 40) {
	          this.setState({
	            text: str
	          });
	        }
	      }
	    }
	  }, {
	    key: 'normalMode',
	    value: function normalMode() {
	      this.setState({
	        virtual_keyboard_mode: 0
	      });
	    }
	  }, {
	    key: 'capitalMode',
	    value: function capitalMode() {
	      this.setState({
	        virtual_keyboard_mode: 1
	      });
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText() {
	      if (this.state.text.length > 0) {
	        var str = this.state.text.substring(0, this.state.text.length - 1);
	        this.setState({
	          text: str
	        });
	      }
	    }
	  }, {
	    key: 'submitText',
	    value: function submitText() {
	      this.props.history.push('/results?query=' + this.state.text);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var headerStyle = {
	        color: 'white',
	        fontSize: this.props.screen.r16_9.p10 * 0.35,
	        lineHeight: String(this.props.screen.r16_9.p10 * 0.6 * 0.78) + "px"
	      };
	
	      var textStyle = {
	        color: 'white',
	        fontSize: this.props.screen.r16_9.p10 * 0.35
	      };
	
	      var keystd = {
	        width: this.props.screen.r16_9.p10 * .8, // this.props.screen.sizes.s4,
	        height: this.props.screen.r16_9.p10 * .8, // this.props.screen.sizes.s4,
	        margin: this.props.screen.r16_9.p10 * .04, // this.props.screen.sizes.marginTiny,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	      };
	
	      var keyspace = {
	        width: this.props.screen.r16_9.p10 * 1.6, //this.props.screen.sizes.s24,
	        height: this.props.screen.r16_9.p10 * .8, //this.props.screen.sizes.s4,
	        margin: this.props.screen.r16_9.p10 * .04, // this.props.screen.sizes.marginTiny,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	      };
	
	      var keycom = {
	        width: this.props.screen.r16_9.p10 * 1.6, //this.props.screen.sizes.s8,
	        height: this.props.screen.r16_9.p10 * .8, //this.props.screen.sizes.s4,
	        margin: this.props.screen.r16_9.p10 * .04, // this.props.screen.sizes.marginTiny,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	
	        //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.
	
	      };return _react2.default.createElement(
	        'div',
	        { style: { position: 'fixed', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: '100vh', fontSize: this.props.screen.r16_9.p10 * 0.35, color: 'black' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'helem velem', style: { position: 'relative' } },
	          _react2.default.createElement(
	            'span',
	            { style: headerStyle },
	            this.props.module.name
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { style: textStyle },
	            this.props.module.contents.header
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'inline-block', width: '30vw', height: this.props.screen.r16_9.p10 * 1, backgroundColor: "#c5dae7" } },
	            _react2.default.createElement(
	              'span',
	              { style: { height: this.props.screen.r16_9.p10 * 1, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
	              '\xA0',
	              this.state.text,
	              '\xA0'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [1, 1, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [1, 1, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [2, 2, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [2, 2, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [3, 3, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [3, 3, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [4, 4, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [4, 4, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [5, 5, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [5, 5, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [6, 6, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [6, 6, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [7, 7, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [7, 7, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [8, 8, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [8, 8, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [9, 9, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [9, 9, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [0, 0, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [0, 0, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [this.deleteText, this.deleteText, this.deleteText], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['DELETE', 'DELETE', 'DELETE'] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['q', 'Q', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['q', 'Q', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['w', 'W', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['w', 'W', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['e', 'E', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['e', 'E', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['r', 'R', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['r', 'R', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['t', 'T', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['t', 'T', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['y', 'Y', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['y', 'Y', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['u', 'U', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['u', 'U', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['i', 'I', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['i', 'I', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['o', 'O', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['o', 'O', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['p', 'P', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['p', 'P', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['@', null, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['@', '@', null] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['a', 'A', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['a', 'A', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['s', 'S', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['s', 'S', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['d', 'D', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['d', 'D', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['f', 'F', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['f', 'F', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['g', 'G', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['g', 'G', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['h', 'H', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['h', 'H', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['j', 'J', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['j', 'J', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['k', 'K', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['k', 'K', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['l', 'L', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['l', 'L', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['_', '_', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['_', '_', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['&', '&', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['&', '&', null] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['z', 'Z', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['z', 'Z', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['x', 'X', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['x', 'X', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['c', 'C', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['c', 'C', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['v', 'V', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['v', 'V', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['b', 'B', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['b', 'B', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['n', 'N', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['n', 'N', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['m', 'M', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['m', 'M', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['.', '.', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['.', '.', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['-', '-', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['-', '-', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['*', '*', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['*', '*', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['?', '?', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['?', '?', null] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { style: keystd },
	            _react2.default.createElement(
	              'span',
	              { className: 'kspn' },
	              '=/#'
	            )
	          ),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [this.capitalMode, this.normalMode, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['UPCASE', 'DOWNCASE', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [' ', ' ', ' '], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keyspace, contents: ['SPACE', 'SPACE', 'SPACE'] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['.com', '.com', '.com'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keycom, contents: ['.com', '.com', '.com'] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['Submit', 'Submit', 'Submit'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.submitText, mainstyle: keycom, contents: ['Submit', 'Submit', 'Submit'] })
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    screen: state.screen,
	    content: state.content,
	    module: state.content.dm_active[state.active_module]
	  };
	};
	
	// const mapDispatchToProps = (dispatch, ownProps) => {
	//   return {
	//     switchVirtualKeyboardMode: (data) => {
	//       dispatch(switchVirtualKeyboardMode(data))
	//     },
	//   }
	// }
	
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Search);

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ReactPlayerWrapper from './ReactPlayerWrapper';
	// import ReactPlayer from 'react-player';
	
	var Slideshow = function (_Component) {
	  _inherits(Slideshow, _Component);
	
	  function Slideshow(props) {
	    _classCallCheck(this, Slideshow);
	
	    var _this = _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call(this, props));
	
	    _this.loadedData = function () {
	      // console.log("loaded data");
	      if (_this._videoRef !== undefined && _this._videoRef !== null) {
	        var duration = _this._videoRef.duration;
	        _this.handleVideoDuration(duration, 0);
	      } else {
	        _this._loadedDataTimeout = setTimeout(function () {
	          _this.loadedData();
	        }, 50);
	      }
	    };
	
	    _this.handleKeyDown = function (e) {
	      switch (e.keyCode) {
	        // Left Arrow (Previous)
	        case 37:
	          _this.clearCycleTimeout();
	          _this.prevSlide();
	          break;
	        // Right Arrow (Next)
	        case 39:
	          _this.clearCycleTimeout();
	          _this.nextSlide();
	          break;
	        // Space (Pause)
	        case 32:
	          if (_this._videoRef) {
	            _this.clearCycleTimeout();
	            var fileType = (0, _fileHelpers.getFileType)(_this.state.module.contents.images[_this.state.activeSlide].file_name);
	            if (fileType !== "Image") {
	              _this._paused = !_this._paused;
	              _this.toggleVideoReproduction(_this._paused);
	            }
	          }
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.clearCycleTimeout = function () {
	      clearTimeout(_this._cycleTimeout);
	      _this._cycleTimeout = null;
	    };
	
	    _this.nextSlide = function () {
	      var currentSlide = _this.state.activeSlide;
	      var nextSlide = 0;
	
	      if (currentSlide < _this._totalElements - 1) {
	        nextSlide = currentSlide + 1;
	      }
	
	      _this.slideChanged(nextSlide);
	    };
	
	    _this.prevSlide = function () {
	      var currentSlide = _this.state.activeSlide;
	      var nextSlide = currentSlide - 1;
	
	      if (currentSlide === 0) {
	        nextSlide = _this._totalElements - 1;
	      }
	
	      _this.slideChanged(nextSlide);
	    };
	
	    _this.toggleVideoReproduction = function (paused) {
	      if (paused === true) {
	        console.log('Pause');
	        _this._videoRef.pause();
	        _this._pausedOn = new Date().getTime();
	
	        _this.setState({
	          activeSlide: _this.state.activeSlide,
	          videoVolumes: _this.state.videoVolumes
	        });
	      } else {
	        console.log('Resume');
	        _this._videoRef.play();
	        var timeLeftToReproduce = _this._currentDuration - (_this._pausedOn - _this._startSlideTime);
	
	        _this._currentDuration = timeLeftToReproduce;
	        _this._startSlideTime = new Date().getTime();
	
	        _this.clearCycleTimeout();
	        _this._cycleTimeout = setTimeout(function () {
	          _this.nextSlide();
	        }, timeLeftToReproduce);
	
	        _this.setState({
	          activeSlide: _this.state.activeSlide,
	          videoVolumes: _this.state.videoVolumes
	        });
	      }
	    };
	
	    _this.slideChanged = function (slide) {
	      var timeout = 5000;
	      _this._paused = false;
	      _this._startSlideTime = new Date().getTime();
	
	      try {
	        if (_this._cycleOverrides[slide] !== undefined) {
	          timeout = _this._cycleOverrides[slide] * 1000;
	        }
	      } catch (error) {
	        console.log(error);
	      }
	
	      var fileType = (0, _fileHelpers.getFileType)(_this.state.module.contents.images[slide].file_name);
	      if (fileType === "Image") {
	        _this.clearCycleTimeout();
	        _this._cycleTimeout = setTimeout(function () {
	          _this.nextSlide();
	        }, timeout);
	      }
	      _this.setState({
	        videoRefsPulled: true,
	        activeSlide: slide,
	        slideChangeTime: _this._startSlideTime
	      });
	    };
	
	    _this.handleVideoDuration = function (duration, delay) {
	      //set our timeout for next slide
	
	      _this.clearCycleTimeout();
	      _this._currentDuration = (duration - delay) * 1000;
	      _this._cycleTimeout = setTimeout(function () {
	        _this.nextSlide();
	      }, _this._currentDuration);
	    };
	
	    _this.getSlide = function (slide) {
	      var volume = true;
	
	      if (_this.props.idle) {
	        volume = false;
	      }
	
	      var innerTile = { width: _this.props.screen.screenWidth, height: _this.props.screen.screenHeight };
	      var fileType = (0, _fileHelpers.getFileType)(_this.state.module.contents.images[slide].file_name);
	
	      if (fileType === "Image") {
	        return _react2.default.createElement('img', { alt: 'Slide', onMouseDown: _this.preventDrag, className: 'nodrag', style: innerTile, src: _shared2.default.dpath(_this.props.screen.mode, _this.state.module.contents.images[slide].path, _this.state.module.contents.images[slide].file_name, _this.props.screen.webkey) });
	      } else {
	        var videoSrc = _shared2.default.dpath(_this.props.screen.mode, _this.state.module.contents.images[slide].path, _this.state.module.contents.images[slide].file_name, _this.props.screen.webkey);
	        // let videoType = shared.videoType(this.state.module.contents.images[slide].file_name);
	        // return (<ReactPlayerWrapper
	        //   playing={!this._paused}
	        //   volume={volume}
	        //   handleVideoDuration={this.handleVideoDuration}
	        //   onEnded={this.videoEnded}
	        //   key={slide}
	        //   url={"/" + shared.dpath(this.props.screen.mode, this.state.module.contents.images[slide].path, this.state.module.contents.images[slide].file_name, this.props.screen.webkey)} width={this.props.screen.screenWidth} height={this.props.screen.screenHeight}
	        // />)
	
	        return _react2.default.createElement('video', { src: videoSrc, key: slide, style: { width: _this.props.screen.screenWidth, height: _this.props.screen.screenHeight }, ref: function ref(el) {
	            return _this._videoRef = el;
	          }, onLoadedData: _this.loadedData, autoPlay: true, muted: !volume });
	      }
	    };
	
	    _this._totalElements = _this.props.module.contents.images.length;
	    _this._cycleOverrides = _this.props.module.contents.cycle_overrides;
	    _this._currentDuration = 0;
	    _this._startSlideTime = 0;
	    _this._paused = false;
	    _this._videoRef = null;
	    _this.state = {
	      activeSlide: 0,
	      videoVolumes: Array.from(Array(_this.props.module.contents.images.length), function () {
	        return 0;
	      }),
	      module: _this.props.module
	    };
	    _this._loadedDataTimeout = null;
	    return _this;
	  }
	
	  _createClass(Slideshow, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _shared2.default.checkData(this.props.module);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.slideChanged(0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearCycleTimeout();
	      clearTimeout(this._loadedDataTimeout);
	      this._loadedDataTimeout = null;
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	
	    // componentDidUpdate(prevProps, prevState){
	    // 	if (this.prevProps.idle!==this.props.idle){
	    // 		//if video timeout.
	    // 	}
	    // }
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, pointerEvents: "none" }, className: 'nodrag' },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.slideChangeTime, style: { position: 'absolute', left: 0, top: 0 } },
	            this.getSlide(this.state.activeSlide)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Slideshow;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var dm = void 0;
	  if (state.options.idleModule === undefined) {
	    dm = state.content.dm_active[state.active_module];
	  } else {
	    dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data;
	  }
	  return {
	    screen: state.screen,
	    module: dm
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Slideshow);

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactSlick = __webpack_require__(46);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stories = function (_Component) {
	    _inherits(Stories, _Component);
	
	    function Stories(props) {
	        _classCallCheck(this, Stories);
	
	        var _this = _possibleConstructorReturn(this, (Stories.__proto__ || Object.getPrototypeOf(Stories)).call(this, props));
	
	        _this.populateStories = function (selected_category) {
	            var stories = [];
	            var filterByCategory = false;
	
	            if (_this.props.categories.length > 0) {
	                if (selected_category != null) {
	                    filterByCategory = true;
	                }
	            }
	            _lodash2.default.forEach(_this.props.module.stories, function (story, index) {
	                if (filterByCategory === false || selected_category === Number(story.folder)) {
	                    //|| (this.state && Number(this.state.selectedCategoryId)==Number(story.story_category))
	                    var preparedStory = story;
	                    preparedStory.index = index;
	                    preparedStory.iconPath = "url(img/ui/image_default.png?rev=" + _this.props.screen.timeStamp + ")";
	                    if (_lodash2.default.has(story, "contents.images[0].path")) {
	                        preparedStory.iconPath = "url(" + _shared2.default.dpath(_this.props.screen.mode, story.contents.images[0].path, story.contents.images[0].file_name, _this.props.screen.webkey) + ")";
	                        // preparedStory.iconPath = "url(" + this.props.screen.dpath + story.contents.images[0].path + story.contents.images[0].file_name + ")";
	                    }
	                    //console.log(preparedStory.iconPath);  
	                    stories.push(preparedStory);
	                }
	            });
	            if (stories.length < 6) {
	                while (stories.length < 6) {
	                    stories.push({ id: -1 }); //fill for blank spaces
	                }
	            }
	
	            while (stories.length % 2 !== 0) {
	                stories.push({ id: -1 }); //ensure even slide count
	            }
	
	            _this.setState({
	                stories: stories
	            });
	
	            if (_this.state.categories.length === 0) {
	                //only run once
	                var cats = [];
	
	                _lodash2.default.forEach(_this.props.categories, function (cat) {
	                    if (_lodash2.default.find(stories, { folder: cat.id })) {
	                        cats.push(cat);
	                    }
	                });
	
	                _this.setState({
	                    categories: cats
	                });
	            }
	        };
	
	        _this.prepareModules = function () {
	
	            if (_this.state.stories.length === 0) {
	                return _react2.default.createElement('div', null);
	            }
	
	            if (_this.props.screen.orientation === "horizontal") {
	                //horizontal mode
	
	                if (_this.state.stories.length === 0) {
	                    return _react2.default.createElement(
	                        'div',
	                        null,
	                        'No Stories Found'
	                    );
	                }
	
	                //code to map an array of evens instead of all to fix console error.
	                var evenRefIds = [];
	                for (var i = 0; i < _this.state.stories.length; i++) {
	                    if (i % 2 === 0) {
	                        evenRefIds.push({ value: i });
	                    }
	                }
	
	                return evenRefIds.map(function (row, i) {
	
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i },
	                        this.prepareModule(this.state.stories[row.value], row.value),
	                        this.prepareModule(this.state.stories[row.value + 1], row.value + 1)
	                    );
	                }, _this);
	            } else {
	                //vertical mode
	                return _react2.default.createElement('span', null);
	            }
	        };
	
	        var dimensions = null;
	        var pWidth = void 0;
	        if (_this.props.screen.orientation === "horizontal") {
	            pWidth = _this.props.screen.screenHeight / 3;
	            dimensions = {
	                padWidth: pWidth,
	                slideWidth: pWidth * 0.90,
	                sliderWidth: pWidth * 2 * 1.25,
	                bdist: _this.props.screen.r16_9.p10 * 0.6
	            };
	        }
	        _this.state = {
	            stories: [],
	            selectedCategoryId: null,
	            groupCycle: 0,
	            mouseX: 0,
	            mouseY: 0,
	            dim: dimensions,
	            module: _this.props.module,
	            categories: []
	        };
	        _this.goToSlide = _this.goToSlide.bind(_this);
	        _this.nextSlide = _this.nextSlide.bind(_this);
	        _this.lastSlide = _this.lastSlide.bind(_this);
	        _this.prepareCycleButtons = _this.prepareCycleButtons.bind(_this);
	        _this.refDict = {};
	        _this.handleCategorySwitch = _this.handleCategorySwitch.bind(_this);
	        _this.prepareStoryCategories = _this.prepareStoryCategories.bind(_this);
	        _this.handleStoryNavDown = _this.handleStoryNavDown.bind(_this);
	        _this.handleStoryNavUp = _this.handleStoryNavUp.bind(_this);
	        return _this;
	    }
	
	    _createClass(Stories, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _shared2.default.checkData(this.props.module);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            //let date1 = new Date();
	            this.populateStories(null);
	            //let date2 = new Date();
	            //let diff = date2.getTime()-date1.getTime();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(prevProps, prevState) {
	            if (_shared2.default.shallowEqual(this.state, prevState)) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'goToSlide',
	        value: function goToSlide(slide) {
	            this.refDict[0].slickGoTo(slide);
	        }
	    }, {
	        key: 'nextSlide',
	        value: function nextSlide() {
	            this.refDict[0].slickNext();
	        }
	    }, {
	        key: 'lastSlide',
	        value: function lastSlide() {
	            this.refDict[0].slickPrev();
	        }
	    }, {
	        key: 'slideChanged',
	        value: function slideChanged(slide) {
	            this.setState({
	                groupCycle: Math.floor(slide / 3)
	            });
	        }
	    }, {
	        key: 'handleStoryNavDown',
	        value: function handleStoryNavDown(e) {
	            if (e.preventDefault) e.preventDefault();
	            this.setState({
	                mouseX: e.nativeEvent.clientX,
	                mouseY: e.nativeEvent.clientY
	            });
	        }
	    }, {
	        key: 'handleStoryNavUp',
	        value: function handleStoryNavUp(e, index) {
	            var deltaX = Math.abs(e.nativeEvent.clientX - this.state.mouseX);
	            var deltaY = Math.abs(e.nativeEvent.clientY - this.state.mouseY);
	            var total = deltaX + deltaY;
	
	            if (total < this.props.screen.r16_9.p10 * 0.5) {
	                //adjust for swipe vs click/tap
	                //console.log("navigating from stories: ", index);
	                //console.log("navigating to: ", index);
	                this.props.navroute(null, "Story", "Stories", { storyIndex: index });
	                //this.props.switchDisplayModule({ id: this.props.displayData.selectedModuleId, story: Number(story_id), prevModule: this.props.displayData.selectedModuleId, navtype: "stories", selectedModuleType: "Story", prevModuleType: this.props.displayData.selectedModuleType }); //module id story lastmodule
	                //this.props.navroute(this.props.displayData.selectedModuleId, Number(story_id), "Story", false)
	            }
	        }
	    }, {
	        key: 'prepareModule',
	        value: function prepareModule(story, i) {
	            var _this2 = this;
	
	            if (Number(story.id) === -1) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'phand', style: { display: 'inline-block', width: this.state.dim.padWidth, height: this.state.dim.padWidth, padding: 0 } },
	                    _react2.default.createElement(
	                        'div',
	                        { id: story.id, style: { fontSize: this.props.screen.r16_9.p10 * 0.2625, display: 'inline-block', marginTop: this.state.dim.slideWidth * .05, width: this.state.dim.slideWidth, height: this.state.dim.slideWidth } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: this.state.dim.slideWidth, height: '100%' }, className: 'aligner' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { width: this.state.dim.slideWidth, backgroundColor: 'rgba(0,0,0,0)', padding: this.props.screen.r16_9.p10 * .15 }, className: 'aligner-item--bottom' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    '\xA0'
	                                )
	                            )
	                        )
	                    )
	                )
	                // <span style={{ display: 'inline-block', width: this.state.dim.padWidth, height: this.state.dim.padWidth, padding: 0 }}>
	                //     <span style={{ display: 'inline-block', width: this.state.dim.slideWidth, height: this.state.dim.slideWidth }}>&nbsp;</span>
	                // </span>
	                ;
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'phand', style: { display: 'inline-block', width: this.state.dim.padWidth, height: this.state.dim.padWidth, padding: 0 } },
	                    _react2.default.createElement(
	                        'div',
	                        { id: story.id, onMouseDown: this.handleStoryNavDown, onMouseUp: function onMouseUp(e) {
	                                return _this2.handleStoryNavUp(e, story.index);
	                            }, style: { fontSize: this.props.screen.r16_9.p10 * .2625, display: 'inline-block', marginTop: this.state.dim.slideWidth * .05, width: this.state.dim.slideWidth, height: this.state.dim.slideWidth, backgroundImage: story.iconPath, backgroundSize: 'cover' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: this.state.dim.slideWidth, height: '100%' }, className: 'aligner' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { width: this.state.dim.slideWidth, backgroundColor: 'rgba(0,0,0,.5)', padding: this.props.screen.r16_9.p10 * .15 }, className: 'aligner-item--bottom' },
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    story.name
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'prepareStoryCategories',
	        value: function prepareStoryCategories() {
	
	            //console.log("CATEGORIES", this.props.categories);
	
	            return this.state.categories.map(function (row, i) {
	                var classes = "phand cScale";
	                var sty = { left: this.props.screen.r16_9.left, textAlign: 'left', fontSize: this.props.screen.r16_9.p10 * .325 };
	                if (i === 0 && this.state.selectedCategoryId === null) {
	                    //classes += " active";
	                    sty = { left: this.props.screen.r16_9.left, textAlign: 'left', fontSize: this.props.screen.r16_9.p10 * 0.5 };
	                } else if (Number(this.state.selectedCategoryId) === Number(row.id)) {
	                    //classes += " active";
	                    sty = { left: this.props.screen.r16_9.left, textAlign: 'left', fontSize: this.props.screen.r16_9.p10 * 0.5 };
	                }
	                return _react2.default.createElement(
	                    'div',
	                    { id: row.id, style: sty, onMouseDown: this.handleCategorySwitch, className: classes, key: i },
	                    row.name
	                );
	            }, this);
	        }
	    }, {
	        key: 'prepareCycleButtons',
	        value: function prepareCycleButtons() {
	            var _this3 = this;
	
	            var iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' };
	            var iconStyleActive = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .75' };
	
	            var spanclass = "phand fadediv";
	            // return (<div style={{position:'absolute', left: blockWidth/2}}>HI THERE</div>)
	            if (this.props.screen.idle === true) {
	                spanclass += " fadeout";
	            }
	
	            var divBlocks = [];
	            for (var i = 0; i < this.state.stories.length; i++) {
	                if (i % 6 === 0) {
	                    divBlocks.push({ slide: i / 2 });
	                }
	            }
	
	            if (divBlocks.length <= 1) {
	                return _react2.default.createElement('div', null);
	            }
	
	            return divBlocks.map(function (row, i) {
	                var iStyle = iconStyle;
	                if (i === _this3.state.groupCycle) {
	                    iStyle = iconStyleActive;
	                }
	                if (i === 0) {
	                    return _react2.default.createElement(
	                        'span',
	                        { className: spanclass, key: i },
	                        _react2.default.createElement(
	                            'div',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this3.lastSlide();
	                                }, style: { textAlign: 'center', position: 'inline-block', top: -1 * _this3.state.dim.bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: spanclass, style: iconStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-up' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this3.goToSlide(row.slide);
	                                }, style: { textAlign: 'center', position: 'inline-block', top: i * _this3.state.dim.bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: spanclass, style: iStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                            )
	                        )
	                    );
	                } else if (i === divBlocks.length - 1) {
	                    return _react2.default.createElement(
	                        'span',
	                        { className: spanclass, key: i },
	                        _react2.default.createElement(
	                            'div',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this3.goToSlide(row.slide);
	                                }, style: { textAlign: 'center', position: 'inline-block', top: i * _this3.state.dim.bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: spanclass, style: iStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this3.nextSlide();
	                                }, style: { textAlign: 'center', position: 'inline-block', top: (i + 1) * _this3.state.dim.bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: spanclass, style: iconStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-down' })
	                            )
	                        )
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: spanclass, onMouseDown: function onMouseDown() {
	                                return _this3.goToSlide(row.slide);
	                            }, key: i, style: { textAlign: 'center', position: 'inline-block', top: i * _this3.state.dim.bdist } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: spanclass, style: iStyle },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                        )
	                    );
	                }
	            });
	        }
	    }, {
	        key: 'handleCategorySwitch',
	        value: function handleCategorySwitch(e) {
	            if (Number(e.target.id) !== Number(this.state.selectedCategoryId)) {
	                this.setState({
	                    selectedCategoryId: e.target.id
	                });
	                this.populateStories(Number(e.target.id));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            if (!this.props.module) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    'Loading...'
	                );
	            }
	            var settings = {
	                dots: false,
	                infinite: true,
	                speed: 250,
	                slidesToShow: 3,
	                slidesToScroll: 3,
	                centerMode: false,
	                swipeToSlide: false,
	                arrows: false,
	                afterChange: function afterChange(currentSlide) {
	                    _this4.slideChanged(currentSlide);
	                }
	            };
	            if (this.props.screen.orientation === "horizontal") {
	                //horizontal mode
	                settings.vertical = true;
	                settings.verticalSwiping = true;
	            }
	
	            var storyCategories = this.prepareStoryCategories();
	            var modules = this.prepareModules();
	
	            if (this.state.stories.length === 0) {
	                return _react2.default.createElement('div', null);
	            }
	
	            var sliderButtons = this.prepareCycleButtons();
	
	            return _react2.default.createElement(
	                'div',
	                { style: { left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: '100vh', position: 'absolute' } },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'content' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'left', style: { float: 'left', width: '65%', height: '100vh' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { position: 'absolute', left: this.props.screen.r16_9.p10 * 3 } },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'absolute', height: this.props.screen.screenHeight, width: this.state.dim.sliderWidth, textAlign: 'center' } },
	                                _react2.default.createElement(
	                                    _reactSlick2.default,
	                                    Object.assign({ ref: function ref(el) {
	                                            return _this4.refDict[0] = el;
	                                        } }, settings),
	                                    modules
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { height: this.props.screen.screenHeight, position: 'absolute' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { height: '100%' }, className: 'aligner' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'aligner-item' },
	                                        sliderButtons
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'right', style: { float: 'right', width: '35%', height: '100vh' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { lineHeight: '2', fontSize: this.props.screen.r16_9.p10 * .6 }, className: 'velem helem' },
	                            storyCategories
	                        )
	                    ),
	                    _react2.default.createElement('br', { style: { clear: 'both' } })
	                )
	            );
	        }
	    }]);
	
	    return Stories;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        screen: state.screen,
	        module: state.content.dm_active[state.active_module],
	        categories: state.content.story_categories
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Stories);

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(46);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Story = function (_Component) {
	    _inherits(Story, _Component);
	
	    function Story(props) {
	        _classCallCheck(this, Story);
	
	        var _this = _possibleConstructorReturn(this, (Story.__proto__ || Object.getPrototypeOf(Story)).call(this, props));
	
	        _this.refDict = {};
	        _this.goBack = _this.goBack.bind(_this);
	        //      this.prepareBackButton = this.prepareBackButton.bind(this);
	        _this.goToSlide = _this.goToSlide.bind(_this);
	        _this.nextSlide = _this.nextSlide.bind(_this);
	        _this.lastSlide = _this.lastSlide.bind(_this);
	        _this.slideChanged = _this.slideChanged.bind(_this);
	        //   this.activeModule = _.find(this.props.displayContent.dm_active, { id: this.props.displayData.selectedModuleId });
	        //   this.lastModule = _.find(this.props.displayContent.dm_active, { id: this.props.displayData.prevModule });
	        // if (!this.lastModule) {
	        //     this.lastModule = this.activeModule;
	        // }
	        var index = 0;
	        //console.log(this.props.options);
	        if (_this.props.options) {
	            //console.log("had options", this.props.options);
	            if (_this.props.options.storyIndex) {
	                index = _this.props.options.storyIndex; //this should be 0
	            }
	        }
	
	        _this.state = {
	            selectedImage: 0,
	            index: index
	        };
	        _this._validImages = [];
	        for (var i = 0; i < _this.props.story.contents.images.length; i++) {
	            if (_this.props.story.contents.images[i]) {
	                _this._validImages.push(_this.props.story.contents.images[i]);
	            }
	        }
	
	        return _this;
	    }
	
	    _createClass(Story, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _shared2.default.checkData(this.props.story);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(prevProps, prevState) {
	            if (_shared2.default.shallowEqual(this.state, prevState)) {
	                return false;
	            }
	            return true;
	        }
	
	        // componentDidUpdate(prevProps, prevState) {
	        //     // if (!this.props.displayData.selectedModuleId) { //data not yet recieved
	        //     //     return null;
	        //     // }
	        //     if (this.props.displayData.selectedModuleId !== prevProps.displayData.selectedModuleId) { //data first recieved
	        //         this.activeModule =  _.find(this.props.displayContent.dm_active, { id: this.props.displayData.selectedModuleId });
	        //         this.lastModule = _.find(this.props.displayContent.dm_active, { id: this.props.displayData.prevModule });
	        //         if (!this.state.story.id){
	        //             this.populateStory();
	        //         }
	        //     }
	        // }
	
	    }, {
	        key: 'goBack',
	        value: function goBack(goRoute, e) {
	            //browserHistory.push(goRoute);
	        }
	    }, {
	        key: 'goToSlide',
	        value: function goToSlide(slide) {
	            this.refDict[0].slickGoTo(slide);
	        }
	    }, {
	        key: 'nextSlide',
	        value: function nextSlide() {
	            this.refDict[0].slickNext();
	        }
	    }, {
	        key: 'lastSlide',
	        value: function lastSlide() {
	            this.refDict[0].slickPrev();
	        }
	    }, {
	        key: 'prepareCycleButtons',
	        value: function prepareCycleButtons(blockWidth) {
	            var bdist = this.props.screen.r16_9.p10 * 0.75;
	            var halflength = this._validImages.length * bdist / 2;
	            var leftStart = blockWidth / 2 - halflength + this.props.screen.screenHeight * .0185;
	            var iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' };
	            var iconStyleActive = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .75' };
	            var spanclass = "fadediv";
	            if (this.props.screen.idle === true) {
	                spanclass += " fadeout";
	            }
	
	            return this._validImages.map(function (row, i) {
	                var _this2 = this;
	
	                var iStyle = iconStyle;
	                if (i === this.state.selectedImage) {
	                    iStyle = iconStyleActive;
	                }
	                if (i === 0) {
	                    return _react2.default.createElement(
	                        'span',
	                        { className: spanclass, key: i },
	                        _react2.default.createElement(
	                            'span',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this2.lastSlide();
	                                }, style: { textAlign: 'center', position: 'absolute', left: leftStart + -1 * bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'phand', style: iconStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-left' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this2.goToSlide(i);
	                                }, style: { textAlign: 'center', position: 'absolute', left: leftStart + i * bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'phand', style: iStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                            )
	                        )
	                    );
	                } else if (i === this._validImages.length - 1) {
	                    return _react2.default.createElement(
	                        'span',
	                        { className: spanclass, key: i },
	                        _react2.default.createElement(
	                            'span',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this2.goToSlide(i);
	                                }, style: { textAlign: 'center', position: 'absolute', left: leftStart + i * bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'phand', style: iStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { onMouseDown: function onMouseDown() {
	                                    return _this2.nextSlide();
	                                }, style: { textAlign: 'center', position: 'absolute', left: leftStart + (i + 1) * bdist } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'phand', style: iconStyle },
	                                _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-right' })
	                            )
	                        )
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'span',
	                        { className: spanclass, onMouseDown: function onMouseDown() {
	                                return _this2.goToSlide(i);
	                            }, key: i, style: { textAlign: 'center', position: 'absolute', left: leftStart + i * bdist } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'phand', style: iStyle },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                        )
	                    );
	                }
	            }, this);
	        }
	    }, {
	        key: 'prepareModules',
	        value: function prepareModules(width) {
	            var tileStyle = { textAlign: 'center' };
	            var innerTile = { margin: '0 auto', textAlign: 'center', width: width, height: width, backgroundColor: 'white' };
	            //console.log("images length here: ", this.props.story.contents.images.length);
	            if (this._validImages.length < 1) {
	                return _react2.default.createElement('div', null);
	            }
	
	            if (this._validImages.length === 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: tileStyle },
	                    _react2.default.createElement('div', { style: innerTile })
	                );
	            }
	
	            return this._validImages.map(function (row, i) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: i, style: tileStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: innerTile },
	                        _react2.default.createElement('img', { alt: 'Story', onMouseDown: this.preventDrag, className: 'nodrag', style: innerTile, src: _shared2.default.dpath(this.props.screen.mode, this._validImages[i].path, this._validImages[i].file_name, this.props.screen.webkey) })
	                    )
	                );
	            }, this);
	        }
	    }, {
	        key: 'preventDrag',
	        value: function preventDrag(e) {
	            if (e.preventDefault) e.preventDefault();
	        }
	    }, {
	        key: 'prepareBackButton',
	        value: function prepareBackButton() {
	            var _this3 = this;
	
	            //60, 60
	
	            if (!this.lastModule) {
	                return _react2.default.createElement('span', null);
	            }
	
	            var goRoute = false;
	            switch (this.lastModule.display_module_type) {
	                case "Stories":
	                    //goRoute = "/stories?id=" + this.props.displayData.prevModule;
	                    break;
	                default:
	                    break;
	            }
	
	            if (goRoute !== false) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'phand', style: { width: this.props.screen.r16_9.p10, height: this.props.screen.r16_9.p10 }, onClick: function onClick(e) {
	                            return _this3.goBack(goRoute, e);
	                        } },
	                    'ICON'
	                );
	            }
	            return _react2.default.createElement('span', null);
	        }
	    }, {
	        key: 'slideChanged',
	        value: function slideChanged(slide) {
	            this.setState({
	                selectedImage: slide
	            });
	        }
	    }, {
	        key: 'handleOrientation',
	        value: function handleOrientation() {
	            var _this4 = this;
	
	            var blockWidth = void 0;
	            if (this.props.screen.orientation === "horizontal") {
	                blockWidth = this.props.screen.r16_9.half - this.props.screen.r16_9.p10 * 2;
	                blockWidth = 2 * Math.round(blockWidth / 2);
	            } else {
	                blockWidth = this.props.screen.r16_9.half - this.props.screen.r16_9.p10 * 2;
	            }
	            var settings = {
	                dots: false,
	                arrows: false,
	                infinite: true,
	                speed: 500,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                centerMode: false,
	                useCSS: true,
	                afterChange: function afterChange(currentSlide) {
	                    _this4.slideChanged(currentSlide);
	                }
	            };
	
	            var modules = this.prepareModules(blockWidth);
	
	            var headlineText = {
	                textAlign: 'vertical',
	                display: 'inline-block',
	                color: 'white',
	                fontSize: this.props.screen.r16_9.p10 * .6,
	                lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
	                letterSpacing: 2,
	                position: 'absolute'
	
	                // lineHeight: this.props.displayData.sizes.fntLarge*.68, 
	                // height: this.props.displayData.sizes.fntLarge*.68, 
	
	
	            };var bodyText = { color: 'white', fontSize: this.props.screen.r16_9.p10 * 0.3
	                //let backbutton = this.prepareBackButton();");
	            };var cycleButtons = this.prepareCycleButtons(blockWidth);
	
	            if (this.props.screen.orientation === "horizontal") {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'fixed', textAlign: 'left', left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10, top: this.props.screen.r16_9.p10, width: blockWidth } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'pnormal', style: headlineText },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                this.props.story.contents.headline
	                            )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .75 } }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'pnormal', style: bodyText },
	                            this.props.story.contents.story
	                        ),
	                        _react2.default.createElement('br', null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'fixed', textAlign: 'left', left: this.props.screen.r16_9.left + this.props.screen.r16_9.h10 * 5 + this.props.screen.r16_9.p10, top: this.props.screen.r16_9.p10, width: blockWidth, height: blockWidth } },
	                        _react2.default.createElement(
	                            _reactSlick2.default,
	                            Object.assign({ ref: function ref(el) {
	                                    return _this4.refDict[0] = el;
	                                } }, settings),
	                            modules
	                        ),
	                        _react2.default.createElement('div', { style: { width: '100%', height: this.props.screen.screenHeight * .045 } }),
	                        cycleButtons
	                    )
	                )
	                /*<div style={{position: 'absolute', width: '100vw', height: '100vh'}}>
	                    <div style={{ position: 'absolute', textAlign: 'left', left: '5vw', top: '5vw', width: '40vw' }}>
	                        <span className="pnormal" style={headlineText}>{props.story.contents.headline}</span><br />
	                        <br />
	                        <span className="pnormal" style={bodyText}>{props.story.contents.story}</span><br />
	                    </div>
	                    <div style={{ position: 'absolute', textAlign: 'right', right: '5vw', top: '5vw', width: blockWidth, height: blockWidth }}>
	                        <Slider {...settings}>
	                            {modules}
	                        </Slider>
	                    </div>
	                </div>*/
	                /*<Col span={24}>
	                    <Col span={10}>
	                        <span className="pnormal" style={headlineText}>{props.story.contents.headline}</span><br />
	                        <span className="pnormal" style={bodyText}>{props.story.contents.story}</span><br />
	                        {backbutton}
	                    </Col>
	                    <Col span={2} />
	                    <Col span={12}>
	                        <div style={{ width: imageWidth, height: imageWidth }}>
	                            <Slider {...settings}>
	                                {modules}
	                            </Slider>
	                        </div>
	                    </Col>
	                 </Col>*/
	                ;
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: blockWidth, textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { margin: "0 auto", textAlign: 'center', width: blockWidth, height: blockWidth } },
	                            _react2.default.createElement(
	                                _reactSlick2.default,
	                                settings,
	                                modules
	                            )
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'span',
	                            { style: headlineText },
	                            this.props.story.contents.headline
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'span',
	                            { style: bodyText },
	                            this.props.story.contents.story
	                        ),
	                        _react2.default.createElement('br', null)
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            // if (this.props.displayData.selectedModuleId === -1 || !this.props.story.id) {          
	            //         return (<div />)
	            // }
	            var content = this.handleOrientation();
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'absolute' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { zIndex: 10, width: '100vw', height: '100vh' } },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return Story;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var dm = void 0,
	        story = void 0;
	    if (state.options.id) {
	        story = _lodash2.default.find(state.content.stories, { id: state.options.id });
	    } else if (state.options.idleModule || state.options.idleModule === 0) {
	        dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data;
	        if (dm) ;
	        story = dm.stories[0];
	    } else {
	        dm = state.content.dm_active[state.active_module];
	        story = dm.stories[0];
	    }
	
	    return {
	        screen: state.screen,
	        options: state.options,
	        story: story
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Story);

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared = __webpack_require__(4);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	var _AlbuquerqueDonor = __webpack_require__(415);
	
	var _AlbuquerqueDonor2 = _interopRequireDefault(_AlbuquerqueDonor);
	
	var _AlbuquerqueDonorList = __webpack_require__(416);
	
	var _AlbuquerqueDonorList2 = _interopRequireDefault(_AlbuquerqueDonorList);
	
	var _AlbuquerqueStoryDoubleImage = __webpack_require__(417);
	
	var _AlbuquerqueStoryDoubleImage2 = _interopRequireDefault(_AlbuquerqueStoryDoubleImage);
	
	var _AlbuquerqueStoryFullscreen = __webpack_require__(418);
	
	var _AlbuquerqueStoryFullscreen2 = _interopRequireDefault(_AlbuquerqueStoryFullscreen);
	
	var _AlbuquerqueStorySingleImage = __webpack_require__(419);
	
	var _AlbuquerqueStorySingleImage2 = _interopRequireDefault(_AlbuquerqueStorySingleImage);
	
	var _AlbuquerqueStoryTextOnly = __webpack_require__(420);
	
	var _AlbuquerqueStoryTextOnly2 = _interopRequireDefault(_AlbuquerqueStoryTextOnly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueAttractLoop = function (_Component) {
	  _inherits(AlbuquerqueAttractLoop, _Component);
	
	  function AlbuquerqueAttractLoop(props) {
	    _classCallCheck(this, AlbuquerqueAttractLoop);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueAttractLoop.__proto__ || Object.getPrototypeOf(AlbuquerqueAttractLoop)).call(this, props));
	
	    _this.handleCicleKeyDown = function (e) {
	      var cycleKey = _lodash2.default.get(_this.props.tree, 'contents.custom_fields.cycle_key.val', null);
	      if (e.key === cycleKey) {
	        _this.cycle();
	      }
	    };
	
	    _this.cycle = function (forceNextModule) {
	      var module = _this.props.tree.children[_this.state.currentIndex];
	      var type = _lodash2.default.get(module, 'contents.custom_fields.folder_type.val.value', null);
	      var donorListsTypes = [_AlbuquerqueConstants.FOLDER_TWO_COLUMN_DONOR_LIST, _AlbuquerqueConstants.FOLDER_THREE_COLUMN_DONOR_LIST, _AlbuquerqueConstants.FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL, _AlbuquerqueConstants.FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE, _AlbuquerqueConstants.FOLDER_DONOR_LIST];
	
	      if (donorListsTypes.indexOf(type) > -1 && !forceNextModule) {
	        _this.setState({ donorListCycleIndex: _this.state.donorListCycleIndex + 1 });
	      } else {
	        var max = _this.props.tree.children.length - 1;
	        var nextIndex = (0, _shared.loopIndex)(_this.state.currentIndex, 0, max, "forward");
	        _this.setState({ currentIndex: nextIndex, donorListCycleIndex: 0 });
	      }
	    };
	
	    _this.getCurrentRenderedModule = function () {
	      var module = _this.props.tree.children[_this.state.currentIndex];
	      var renderedModule = null;
	      switch (module.node_type) {
	        case _AlbuquerqueConstants.STORY:
	          renderedModule = _this.getRenderedStory(module);
	          break;
	        case _AlbuquerqueConstants.FOLDER:
	          renderedModule = _this.getRenderedFolder(module);
	          break;
	        default:
	          break;
	      }
	      return renderedModule;
	    };
	
	    _this.getRenderedStory = function (module) {
	      var type = _lodash2.default.get(module, 'contents.custom_fields.story_type.val.value', null);
	      switch (type) {
	        case _AlbuquerqueConstants.STORY_SINGLE_IMAGE:
	          return _react2.default.createElement(_AlbuquerqueStorySingleImage2.default, {
	            module: module,
	            cycle: _this.cycle,
	            width: _this.props.width,
	            height: _this.props.height,
	            screen: _this.props.screen
	          });
	        case _AlbuquerqueConstants.STORY_DOUBLE_IMAGE:
	          return _react2.default.createElement(_AlbuquerqueStoryDoubleImage2.default, {
	            module: module,
	            cycle: _this.cycle,
	            width: _this.props.width,
	            height: _this.props.height,
	            screen: _this.props.screen
	          });
	        case _AlbuquerqueConstants.STORY_TEXT_ONLY:
	          return _react2.default.createElement(_AlbuquerqueStoryTextOnly2.default, {
	            module: module,
	            cycle: _this.cycle,
	            width: _this.props.width,
	            height: _this.props.height,
	            screen: _this.props.screen
	          });
	        case _AlbuquerqueConstants.STORY_FULLSCREEN:
	          return _react2.default.createElement(_AlbuquerqueStoryFullscreen2.default, {
	            module: module,
	            cycle: _this.cycle,
	            width: _this.props.width,
	            height: _this.props.height,
	            screen: _this.props.screen
	          });
	        case _AlbuquerqueConstants.DONOR:
	          return _react2.default.createElement(_AlbuquerqueDonor2.default, {
	            module: module,
	            cycle: _this.cycle,
	            width: _this.props.width,
	            height: _this.props.height,
	            screen: _this.props.screen
	          });
	        default:
	          return null;
	      }
	    };
	
	    _this.getRenderedFolder = function (module) {
	      var type = _lodash2.default.get(module, 'contents.custom_fields.folder_type.val.value', null);
	      switch (type) {
	        case _AlbuquerqueConstants.FOLDER_ONE_COLUMN_DONOR_LIST:
	          return _react2.default.createElement(_AlbuquerqueDonor2.default, {
	            module: module,
	            content: _this.props.content,
	            cycle: _this.cycle,
	            donors: _this.props.donors,
	            width: _this.props.width,
	            height: _this.props.height,
	            screen: _this.props.screen
	          });
	        case _AlbuquerqueConstants.FOLDER_TWO_COLUMN_DONOR_LIST:
	        case _AlbuquerqueConstants.FOLDER_THREE_COLUMN_DONOR_LIST:
	        case _AlbuquerqueConstants.FOLDER_THREE_COLUMN_DONOR_LIST_CAPITAL:
	        case _AlbuquerqueConstants.FOLDER_THREE_COLUMN_DONOR_LIST_CUMULATIVE:
	        case _AlbuquerqueConstants.FOLDER_DONOR_LIST:
	          return _react2.default.createElement(_AlbuquerqueDonorList2.default, {
	            key: module.id,
	            module: module,
	            content: _this.props.content,
	            donors: _this.props.donors,
	            cycle: _this.cycle,
	            cycleIndex: _this.state.donorListCycleIndex,
	            width: _this.props.width,
	            height: _this.props.height
	          });
	        default:
	          return null;
	      }
	    };
	
	    _this.getBackground = function () {
	      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var module = _this.props.tree;
	      var imgObj = _lodash2.default.get(module, 'contents.images[' + i + ']', null);
	      if (imgObj) {
	        return (0, _shared.dp)(_this.props.screen, imgObj, null);
	      }
	      return null;
	    };
	
	    _this.state = { currentIndex: 0, donorListCycleIndex: 0 };
	    return _this;
	  }
	
	  _createClass(AlbuquerqueAttractLoop, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.handleCicleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.handleCicleKeyDown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var videoStyle = {
	        preload: 'auto',
	        width: this.props.width,
	        minHeight: '100%',
	        zIndex: 0,
	        loop: '',
	        autoplay: "",
	        muted: "",
	        pointerEvents: "none"
	      };
	      var renderedModule = this.getCurrentRenderedModule();
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height;
	
	      var style = { position: "absolute", width: width, height: height, top: 0 };
	      var index = this.state.currentIndex;
	
	      var background = this.getBackground();
	      var type = (0, _shared.videoType)(background);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { style: { position: "absolute", width: "100%", height: "100%", opacity: _AlbuquerqueConstants.OPACITY_PERCENTAGE, backgroundColor: _AlbuquerqueConstants.OPACITY_COLOR } }),
	        _react2.default.createElement(
	          'div',
	          { style: { width: width, height: height, pointerEvents: "none", left: 0, top: 0 } },
	          _react2.default.createElement(
	            'video',
	            { className: 'nodrag', style: videoStyle, id: 'background-video', loop: true, autoPlay: true, muted: true },
	            _react2.default.createElement('source', { src: background, type: type }),
	            'Your browser does not support the video tag.'
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: index, style: style },
	            renderedModule
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbuquerqueAttractLoop;
	}(_react.Component);
	
	exports.default = AlbuquerqueAttractLoop;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _AlbuquerqueAttractLoop = __webpack_require__(413);
	
	var _AlbuquerqueAttractLoop2 = _interopRequireDefault(_AlbuquerqueAttractLoop);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueContainer = function (_Component) {
	  _inherits(AlbuquerqueContainer, _Component);
	
	  function AlbuquerqueContainer(props) {
	    _classCallCheck(this, AlbuquerqueContainer);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueContainer.__proto__ || Object.getPrototypeOf(AlbuquerqueContainer)).call(this, props));
	
	    _this.getRenderedContent = function () {
	      var content = void 0;
	      switch (_this.state.type) {
	        case _AlbuquerqueConstants.FULLSCREEN:
	          content = _this.getRenderedScreens();
	          break;
	        case _AlbuquerqueConstants.SCREEN:
	          content = _this.getRenderedAttractLoop();
	          break;
	        default:
	          break;
	      }
	
	      return content;
	    };
	
	    _this.getRenderedAttractLoop = function () {
	      try {
	        var attractLoop = _this.state.tree.find(function (c) {
	          return _lodash2.default.get(c, 'contents.custom_fields.folder_type.val.value', null) === "attract_loop";
	        });
	        attractLoop.children = _lodash2.default.orderBy(attractLoop.children, ['rank'], ['asc']);
	        return _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: _this.props.screen.screenWidth, height: _this.props.screen.screenHeight } },
	          _react2.default.createElement(_AlbuquerqueAttractLoop2.default, {
	            tree: attractLoop,
	            content: _this.props.content,
	            donors: _this.props.donors,
	            width: _this.props.screen.screenWidth,
	            height: _this.props.screen.screenHeight,
	            screen: _this.props.screen
	          }),
	          ';'
	        );
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this.getRenderedScreens = function () {
	      try {
	        var screens = [];
	        for (var i in _this.state.tree) {
	          var left = _this.props.screen.screenWidth / _AlbuquerqueConstants.SCREENS_NUMBER * i;
	          var attractLoop = _this.state.tree[i].children.find(function (c) {
	            return _lodash2.default.get(c, 'contents.custom_fields.folder_type.val.value', null) === "attract_loop";
	          });
	          attractLoop.children = _lodash2.default.orderBy(attractLoop.children, ['rank'], ['asc']);
	          if (attractLoop) {
	            screens.push(_react2.default.createElement(
	              'div',
	              { key: i, style: { position: "absolute", width: _this.props.screen.screenWidth / 3, height: _this.props.screen.screenHeight, left: left } },
	              _react2.default.createElement(_AlbuquerqueAttractLoop2.default, {
	                tree: attractLoop,
	                content: _this.props.content,
	                donors: _this.props.donors,
	                width: _this.props.screen.screenWidth / _AlbuquerqueConstants.SCREENS_NUMBER,
	                height: _this.props.screen.screenHeight,
	                screen: _this.props.screen
	              })
	            ));
	          }
	        }
	        return screens;
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    try {
	
	      var type = _lodash2.default.get(props.rootFolder, 'contents.custom_fields.folder_type.val.value', "fullscreen");
	      var rootFolderId = _lodash2.default.get(props, 'rootFolder.id', null);
	      var tree = _shared2.default.createFolderTree(_this.props.content.story_categories, _this.props.content.folder_modules, _this.props.rootFolder, _this.props.content.stories, _this.props.content.dm_active, rootFolderId, 'rank', 'desc');
	
	      // const attractLoop = tree.children.find(c => _.get(c, 'contents.custom_fields.folder_type.val.value', null) === "attract_loop");
	      _this.state = { tree: tree, type: type };
	    } catch (e) {
	      console.log(e);
	    }
	
	    return _this;
	  }
	
	  _createClass(AlbuquerqueContainer, [{
	    key: 'render',
	    value: function render() {
	      var renderedContent = this.getRenderedContent();
	      try {
	        return _react2.default.createElement(
	          'div',
	          null,
	          renderedContent
	        );
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }]);
	
	  return AlbuquerqueContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var rootFolderId = _lodash2.default.get(state.content, 'settings.selected_root_folder', null);
	  var rootFolder = state.content.story_categories.find(function (f) {
	    return f.id === Number(rootFolderId);
	  });
	  return {
	    content: state.content,
	    donors: state.donors,
	    screen: state.screen,
	    rootFolder: rootFolder
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(AlbuquerqueContainer);

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _shared = __webpack_require__(4);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueDonor = function (_Component) {
	  _inherits(AlbuquerqueDonor, _Component);
	
	  function AlbuquerqueDonor(props) {
	    _classCallCheck(this, AlbuquerqueDonor);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueDonor.__proto__ || Object.getPrototypeOf(AlbuquerqueDonor)).call(this, props));
	
	    _this.cycleDonorIndex = function () {
	      var time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      if (_this._totalDonors - 1 === _this.state.index) {
	        _this.setupCycle();
	      } else {
	        _this._cycleTimeoutHandler = setTimeout(function () {
	          _this.setState({ index: _this.state.index + 1 });
	          _this.cycleDonorIndex();
	        }, time * 1000);
	      }
	    };
	
	    _this.setupCycle = function () {
	      var time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      _this._cycleTimeoutHandler = setTimeout(function () {
	        _this.props.cycle();
	      }, time * 1000);
	    };
	
	    _this._cycleTimeoutHandler = null;
	    _this._donors = [];
	    _this._totalDonors = [];
	
	    _this.state = { index: 0 };
	    return _this;
	  }
	
	  _createClass(AlbuquerqueDonor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var donors = (0, _donorHelpers.getDonorsFromFolder)(this.props.donors, this.props.content.folder_modules, this.props.module.id);
	      this._donors = _lodash2.default.orderBy(donors, [function (donor) {
	        return donor.sorting_name.toLowerCase();
	      }], ['asc']);
	      this._totalDonors = this._donors.length;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.cycleDonorIndex();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._cycleTimeoutHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var nameStyleObj = _lodash2.default.get(this.props.module, 'contents.custom_fields.donor_name_style', null);
	      var nameStyle = (0, _shared.parseTextStyling)(nameStyleObj);
	      var titleStyleObj = _lodash2.default.get(this.props.module, 'contents.custom_fields.header_style', null);
	      var titleStyle = (0, _shared.parseTextStyling)(titleStyleObj);
	      var subheaderStyleObj = _lodash2.default.get(this.props.module, 'contents.custom_fields.subheader_style', null);
	      var subheaderStyle = (0, _shared.parseTextStyling)(subheaderStyleObj);
	      var header = _lodash2.default.get(this.props.module, 'name', null);
	      var subheader = _lodash2.default.get(this.props.module, 'contents.custom_fields.subheader.val', null);
	      var underline = _lodash2.default.get(this.props.module, 'contents.custom_fields.horizontal_line.val', _lodash2.default.get(this.props.module, 'contents.custom_fields.horizontal_line.default', false));
	      var deceased = _lodash2.default.get(this.props.module, 'contents.custom_fields.deceased.val', false);
	      var index = this.state.index;
	
	      var donorName = _lodash2.default.get(this._donors[index], 'name', '');
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", top: "7.5vh", left: "10vh" } },
	              _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, titleStyle, { fontFamily: "legacysans-bold" }) },
	                header
	              ),
	              underline ? _react2.default.createElement('div', { style: { backgroundColor: 'white', opacity: 1, width: this.props.width * .8875, height: '1px', position: "relative", top: "1.54vh" } }) : _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, subheaderStyle, { fontFamily: "legacysans-book" }) },
	                subheader
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", width: "100%", height: "100%", display: "table" } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "45%", display: "table-cell", verticalAlign: "middle", paddingLeft: "25%", paddingRight: "25%" } },
	                _react2.default.createElement(
	                  'div',
	                  { style: Object.assign({}, nameStyle) },
	                  donorName
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", right: "10vh", bottom: "4.62vh" } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfade',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            deceased ? _react2.default.createElement(
	              'div',
	              { key: 'header-' + this._categoryIndex, style: { fontFamily: "legacysans-book", color: "white", fontSize: "2.46vh" } },
	              _react2.default.createElement(
	                'span',
	                null,
	                '*Deceased'
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbuquerqueDonor;
	}(_react.Component);
	
	exports.default = AlbuquerqueDonor;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _screenUtils = __webpack_require__(159);
	
	var _shared = __webpack_require__(4);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueDonorList = function (_Component) {
	  _inherits(AlbuquerqueDonorList, _Component);
	
	  function AlbuquerqueDonorList(props) {
	    _classCallCheck(this, AlbuquerqueDonorList);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueDonorList.__proto__ || Object.getPrototypeOf(AlbuquerqueDonorList)).call(this, props));
	
	    _this.setDonorListStateData = function () {
	      var title = _lodash2.default.get(_this._donorList, 'name', '');
	      var category = _lodash2.default.get(_this._donorList, 'contents.custom_fields.subheader.val', '');
	      var description = _lodash2.default.get(_this._donorList, 'contents.custom_fields.description.val', '');
	
	      _this.setState({
	        listData: {
	          title: title,
	          category: category,
	          description: description
	        }
	      });
	    };
	
	    _this.handlePreRender = function () {
	      if (_this._donorRefs.length > 0 && _this.state.finishedPreRender === false) {
	
	        var counter = -1;
	
	        _this._donorList.donors.forEach(function (donor) {
	          counter++;
	          donor.height = _this._donorRefs[counter].offsetHeight;
	          donor.width = _this._donorRefs[counter].offsetWidth;
	        });
	
	        _this._donorContainer = {
	          width: _this._donorContainerRef.offsetWidth,
	          height: _this._donorContainerRef.offsetHeight
	        };
	        _this.setState({
	          finishedPreRender: true
	        });
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "c":
	          _this.cycleDonorIndex();
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.getCategoryStyle = function () {
	      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      style.fontSize = _this.state.height * .026;
	      style.fontStyle = "Normal";
	      style.fontFamily = "Lato";
	      style.fontWeight = "100";
	      style.paddingBottom = _this.state.height * .008;
	      style.lineHeight = 2.75;
	      style.textAlign = 'left';
	      style.fontColor = '#000000';
	
	      return style;
	    };
	
	    _this.preRenderDonors = function () {
	      var flatDonors = [];
	
	      var columns = _lodash2.default.get(_this._donorList, 'contents.custom_fields.columns.val', _lodash2.default.get(_this._donorList, 'contents.custom_fields.columns.default', 3));
	      var columnWidth = _this.state.width * .8 / columns;
	      var styleObj = _lodash2.default.get(_this._donorList, 'contents.custom_fields.donor_name_style', null);
	      var style = (0, _shared.parseTextStyling)(styleObj);
	      style.lineHeight = "4vh";
	      _this._donorList.donors.forEach(function (donor) {
	        // let donorStyleCopy = {};
	        donor.style = style;
	        // delete donor.style.lineHeight;
	        donor.style.width = columnWidth * .9;
	        flatDonors.push(donor);
	      });
	
	      return flatDonors.map(function (donor, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, ref: function ref(el) {
	              return _this._donorRefs[i] = el;
	            }, style: Object.assign({}, donor.style, { opacity: 0 }) },
	          _react2.default.createElement(_BRSpan2.default, { str: donor.name })
	        );
	      });
	    };
	
	    _this.cycleNameSet = function () {
	      _this._cycle_time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      clearTimeout(_this._donorCycleTimeout);
	      _this._donorCycleTimeout = setTimeout(function () {
	        var endOfLoop = _this.cycleDonorIndex();
	        if (!endOfLoop) {
	          _this.setState({});
	          _this.cycleNameSet();
	        } else {
	          if (_this.props.cycle) {
	            _this.props.cycle();
	          } else {
	            _this._donorIndex = 0;
	            _this.cycleNameSet();
	          }
	        }
	      }, _this._cycle_time * 1000);
	    };
	
	    _this.cycleDonorIndex = function () {
	      if (_this._donorIndex + _this._lastPageCount >= _this._donorList.donors.length) {
	        return true;
	      } else {
	        _this._donorIndex += _this._lastPageCount;
	        return false;
	      }
	    };
	
	    _this.renderNames = function () {
	      var donorCategory = _this._donorList;
	      var columns = _lodash2.default.get(donorCategory, 'contents.custom_fields.columns.val', _lodash2.default.get(donorCategory, 'contents.custom_fields.columns.default', 3));
	      var currentHeight = 0;
	      var currentColumn = 1;
	      var drawDonors = [];
	      var columnWidth = _this._donorContainer.width / columns;
	      _this._lastPageCount = 0;
	
	      for (var a = _this._donorIndex; a < _this._donorList.donors.length; a++) {
	        var donor = _this._donorList.donors[a];
	        //fits in column
	        if (currentHeight + donor.height > _this._donorContainer.height - _this._layout.margin_bottom * _this.state.height) {
	          if (currentColumn < columns) {
	            //reset for new column
	            currentHeight = 0;
	            currentColumn++;
	          } else {
	            break;
	          }
	        }
	
	        donor.top = currentHeight;
	        donor.column = currentColumn;
	        // console.log(donor.height);
	        var verticalOffset = _lodash2.default.get(_this.props.module, 'contents.custom_fields.donor_vertical_offset.val', _lodash2.default.get(_this.props.module, 'contents.custom_fields.donor_vertical_offset.default', 5));
	        currentHeight += donor.height + _this.props.height * Number(verticalOffset) / 100;
	        drawDonors.push(donor);
	        _this._lastPageCount++;
	      }
	
	      // const modifiedDonorStyle = this.getCategoryStyle(donorStyle);
	      var styleObj = _lodash2.default.get(_this._donorList, 'contents.custom_fields.donor_name_style', null);
	      var style = (0, _shared.parseTextStyling)(styleObj);
	      style.lineHeight = "4vh";
	
	      return drawDonors.map(function (item, i) {
	        var left = (item.column - 1) * columnWidth * (1 + _this._layout.donor_margin_left);
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: Object.assign({}, style, { position: "absolute", overflow: "hidden", top: item.top, left: left, opacity: 1, width: columnWidth * .9 }) },
	          _react2.default.createElement(
	            'div',
	            { className: 'empty-br' },
	            _react2.default.createElement(_BRSpan2.default, { className: 'empty-br', str: item.name })
	          )
	        );
	      });
	    };
	
	    var dims = (0, _screenUtils.bestFit)(1920, 1080, props.width || 1920, props.height || 1080);
	
	    _this.state = {
	      listData: {
	        donors: [],
	        title: '',
	        category: '',
	        description: '',
	        cycleIndex: 0
	      },
	      timestamp: null,
	      finishedPreRender: false,
	      fadeIn: true,
	      width: dims.width,
	      height: dims.height
	    };
	
	    _this._donorCycleTimeout = null;
	    _this.donorList = null;
	    _this._donorRefs = [];
	    _this._underlineRef = null;
	    _this._donorContainerRef = null;
	    _this._donorContainer = {
	      height: 0,
	      width: 0
	    };
	    _this._donorIndex = 0;
	    _this._categoryIndex = 0;
	    _this._lastPageCount = 0;
	    _this._cycle_time = 5000;
	
	    _this._layout = {
	      margin_left: .05,
	      margin_bottom: .1,
	      title_offset: .025,
	      description_offset: .10,
	      names_offset: .125
	    };
	    return _this;
	  }
	
	  _createClass(AlbuquerqueDonorList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var donors = (0, _donorHelpers.getDonorsFromFolder)(this.props.donors, this.props.content.folder_modules, this.props.module.id);
	      donors = _lodash2.default.orderBy(donors, [function (d) {
	        return d.sorting_name.toLowerCase();
	      }], ['asc']);
	      this._donorList = Object.assign({}, this.props.module, { donors: donors });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var columns = _lodash2.default.get(this._donorList, 'contents.custom_fields.columns.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.columns.default', 2));
	      var marginLeft = _lodash2.default.get(this._donorList, 'contents.custom_fields.margin_left.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.margin_left.default', 10));
	      var donorMarginLeft = _lodash2.default.get(this._donorList, 'contents.custom_fields.donor_margin_left.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.donor_margin_left.default', 10));
	      var topOffset = _lodash2.default.get(this._donorList, 'contents.custom_fields.top_offset.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.top_offset.default', 12.5));
	      var titleOffset = _lodash2.default.get(this._donorList, 'contents.custom_fields.title_offset.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.title_offset.default', 2.5));
	      var descriptionOffset = _lodash2.default.get(this._donorList, 'contents.custom_fields.description_offset.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.description_offset.default', 10));
	
	      this._layout.columns = columns / 100;
	      this._layout.margin_left = marginLeft / 100;
	      this._layout.donor_margin_left = donorMarginLeft / 100;
	      this._layout.names_offset = topOffset / 100;
	      this._layout.title_offset = titleOffset / 100;
	      this._layout.description_offset = descriptionOffset / 100;
	
	      this._layout.title_offset = 0.075;
	      this._layout.description_offset = 0.1;
	
	      this._background = "";
	      try {
	        document.addEventListener("keydown", this.handleKeyDown);
	
	        setTimeout(function () {
	          _this2.handlePreRender();
	          _this2.setDonorListStateData();
	          _this2.cycleNameSet();
	        }, 500);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
	        var dims = (0, _screenUtils.bestFit)(1920, 1080, this.props.width, this.props.height);
	        this.setState({
	          width: dims.width,
	          height: dims.height
	        });
	      }
	
	      if (prevProps.cycleIndex !== this.props.cycleIndex && this.props.cycleIndex > 0) {
	        var endOfLoop = this.cycleDonorIndex();
	        if (endOfLoop) {
	          this.props.cycle(true);
	        } else {
	          this.setState({});
	          this.cycleNameSet();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._donorCycleTimeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (!this._donorList || !this._donorList.donors || !this._donorList.donors.length) {
	        return null;
	      }
	      // const description_font_size = this.state.height * .03;
	      var margin_left = this.state.width * this._layout.margin_left;
	      var title_offset = this.state.height * this._layout.title_offset;
	      // const description_offset = this.state.height * this._layout.description_offset
	      var names_offset = this.state.height * this._layout.names_offset;
	
	      var titleStyleObj = _lodash2.default.get(this._donorList, 'contents.custom_fields.header_style', null);
	      var titleStyle = (0, _shared.parseTextStyling)(titleStyleObj);
	      var subheaderStyleObj = _lodash2.default.get(this._donorList, 'contents.custom_fields.subheader_style', null);
	      var subheaderStyle = (0, _shared.parseTextStyling)(subheaderStyleObj);
	      var deceased = _lodash2.default.get(this._donorList, 'contents.custom_fields.deceased.val', false);
	      var underline = _lodash2.default.get(this._donorList, 'contents.custom_fields.horizontal_line.val', _lodash2.default.get(this._donorList, 'contents.custom_fields.horizontal_line.default', false));
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.state.width, height: this.state.height, background: 'url(' + this._background + ')', backgroundSize: "cover" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'denver-donor-list', style: { position: 'absolute', width: this.state.width, height: this.state.height, left: margin_left } },
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: 'header-' + this._categoryIndex, style: { position: "absolute", top: title_offset, width: this.state.width * .9, height: this.state.height * .05 } },
	                this.state.listData && this.state.listData.title ? _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { style: titleStyle },
	                    this.state.listData.title
	                  ),
	                  underline ? _react2.default.createElement('div', { style: { backgroundColor: 'white', opacity: 1, width: this.props.width * .8875, height: '1px', position: "relative", top: "1.54vh" } }) : _react2.default.createElement(
	                    'div',
	                    { style: subheaderStyle },
	                    this.state.listData.category
	                  )
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { ref: function ref(el) {
	                  return _this3._donorContainerRef = el;
	                }, style: { position: 'absolute', width: this.state.width * .8, height: this.state.height * .8, zIndex: 1, top: names_offset, opacity: 1 } },
	              _react2.default.createElement(
	                _CSSTransitionGroup2.default,
	                {
	                  component: 'div',
	                  transitionName: 'slowfade',
	                  transitionEnterTimeout: 0,
	                  transitionLeaveTimeout: 0 },
	                this.state.finishedPreRender ? _react2.default.createElement(
	                  'div',
	                  { key: "donor-index" + this._donorIndex + "-category-index-" + this._categoryIndex },
	                  this.renderNames()
	                ) : this.preRenderDonors()
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", right: "24.69vh", bottom: "4.62vh" } },
	              _react2.default.createElement(
	                _CSSTransitionGroup2.default,
	                {
	                  component: 'div',
	                  transitionName: 'slowfade',
	                  transitionEnterTimeout: 0,
	                  transitionLeaveTimeout: 0 },
	                deceased ? _react2.default.createElement(
	                  'div',
	                  { key: 'header-' + this._categoryIndex, style: { fontFamily: "legacysans-book", color: "white", fontSize: "2.46vh" } },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '*Deceased'
	                  )
	                ) : null
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbuquerqueDonorList;
	}(_react.Component);
	
	exports.default = AlbuquerqueDonorList;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueStoryDoubleImage = function (_Component) {
	  _inherits(AlbuquerqueStoryDoubleImage, _Component);
	
	  function AlbuquerqueStoryDoubleImage(props) {
	    _classCallCheck(this, AlbuquerqueStoryDoubleImage);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueStoryDoubleImage.__proto__ || Object.getPrototypeOf(AlbuquerqueStoryDoubleImage)).call(this, props));
	
	    _this.setupCycle = function () {
	      var time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      _this._cycleTimeoutHandler = setTimeout(function () {
	        _this.props.cycle();
	      }, time * 1000);
	    };
	
	    _this.getBackground = function () {
	      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var imgObj = _lodash2.default.get(_this.props.module, 'contents.images[' + i + ']', null);
	      if (imgObj) {
	        return (0, _shared.dp)(_this.props.screen, imgObj, null);
	      }
	      return null;
	    };
	
	    _this._cycleTimeoutHandler = null;
	    return _this;
	  }
	
	  _createClass(AlbuquerqueStoryDoubleImage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._cycleTimeoutHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var headline = _lodash2.default.get(this.props.module, 'contents.custom_fields.headline.val', "Headline");
	      var body = _lodash2.default.get(this.props.module, 'contents.custom_fields.body.val', _AlbuquerqueConstants.LOREM_IPSUM);
	      var headlineRawStyle = _lodash2.default.get(this.props.module, 'contents.custom_fields.headline_style', null);
	      var bodyRawStyle = _lodash2.default.get(this.props.module, 'contents.custom_fields.body_style', null);
	      var headlineStyle = (0, _shared.parseTextStyling)(headlineRawStyle);
	      var bodyStyle = (0, _shared.parseTextStyling)(bodyRawStyle);
	      var imageLeft = this.getBackground(0);
	      var imageRight = this.getBackground(1);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: "100%", height: "50vh", top: "26vh", display: "flex", flexDirection: 'column', justifyContent: 'center' } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "flex", padding: "0 10% 0 10%", flexDirection: "row" } },
	            _react2.default.createElement(
	              'div',
	              { style: { flex: '0 1 39vh', height: '52vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', padding: '0% 2% 0 4%' } },
	              _react2.default.createElement('img', { style: { maxHeight: '100%', maxWidth: '100%' }, src: imageLeft, role: 'presentation' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { flex: '0 1 39vh', height: '52vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', paddingRight: '4%', paddingLeft: '2%' } },
	              _react2.default.createElement('img', { style: { maxHeight: '100%', maxWidth: '100%' }, src: imageRight, role: 'presentation' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { flex: '1 0 50%' } },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { style: Object.assign({}, headlineStyle, { fontFamily: "legacysans-bold" }) },
	                  headline
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { style: Object.assign({}, bodyStyle, { fontFamily: "legacysans-book" }) },
	                  body
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbuquerqueStoryDoubleImage;
	}(_react.Component);
	
	exports.default = AlbuquerqueStoryDoubleImage;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueStoryFullScreen = function (_Component) {
	  _inherits(AlbuquerqueStoryFullScreen, _Component);
	
	  function AlbuquerqueStoryFullScreen(props) {
	    _classCallCheck(this, AlbuquerqueStoryFullScreen);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueStoryFullScreen.__proto__ || Object.getPrototypeOf(AlbuquerqueStoryFullScreen)).call(this, props));
	
	    _this.setupCycle = function () {
	      var time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      _this._cycleTimeoutHandler = setTimeout(function () {
	        if (_this.props.cycle) {
	          _this.props.cycle();
	        }
	      }, time * 1000);
	    };
	
	    _this.getBackground = function () {
	      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var imgObj = _lodash2.default.get(_this.props.module, 'contents.images[' + i + ']', null);
	      if (imgObj) {
	        return (0, _shared.dp)(_this.props.screen, imgObj, null);
	      }
	      return null;
	    };
	
	    _this._cycleTimeoutHandler = null;
	    return _this;
	  }
	
	  _createClass(AlbuquerqueStoryFullScreen, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._cycleTimeoutHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var background = this.getBackground();
	      return _react2.default.createElement('div', { style: { position: "absolute", width: "100%", height: "100%", backgroundImage: 'url(' + background + ')', backgroundSize: "cover", backgroundRepeat: "none", backgroundPosition: "center" } });
	    }
	  }]);
	
	  return AlbuquerqueStoryFullScreen;
	}(_react.Component);
	
	exports.default = AlbuquerqueStoryFullScreen;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueStorySingleImage = function (_Component) {
	  _inherits(AlbuquerqueStorySingleImage, _Component);
	
	  function AlbuquerqueStorySingleImage(props) {
	    _classCallCheck(this, AlbuquerqueStorySingleImage);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueStorySingleImage.__proto__ || Object.getPrototypeOf(AlbuquerqueStorySingleImage)).call(this, props));
	
	    _this.setupCycle = function () {
	      var time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      _this._cycleTimeoutHandler = setTimeout(function () {
	        _this.props.cycle();
	      }, time * 1000);
	    };
	
	    _this.getBackground = function () {
	      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var imgObj = _lodash2.default.get(_this.props.module, 'contents.images[' + i + ']', null);
	      if (imgObj) {
	        return (0, _shared.dp)(_this.props.screen, imgObj, null);
	      }
	      return null;
	    };
	
	    _this._cycleTimeoutHandler = null;
	    return _this;
	  }
	
	  _createClass(AlbuquerqueStorySingleImage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._cycleTimeoutHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var headline = _lodash2.default.get(this.props.module, 'contents.custom_fields.headline.val', "Headline");
	      var body = _lodash2.default.get(this.props.module, 'contents.custom_fields.body.val', _AlbuquerqueConstants.LOREM_IPSUM);
	      var headlineRawStyle = _lodash2.default.get(this.props.module, 'contents.custom_fields.headline_style', null);
	      var bodyRawStyle = _lodash2.default.get(this.props.module, 'contents.custom_fields.body_style', null);
	      var headlineStyle = (0, _shared.parseTextStyling)(headlineRawStyle);
	      var bodyStyle = (0, _shared.parseTextStyling)(bodyRawStyle);
	      var image = this.getBackground();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: "100%", height: "50vh", top: "25vh", display: "table" } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "table-cell", padding: "0 10% 0 10%", verticalAlign: "middle" } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: "table-cell", width: "50%", padding: "0 4% 0 4%" } },
	              _react2.default.createElement(
	                'div',
	                { style: { height: '52vh', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-end' } },
	                _react2.default.createElement('img', { style: { maxHeight: '100%', maxWidth: '100%' }, src: image, role: 'presentation' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: "table-cell", width: "50%", verticalAlign: "top" } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table-cell" } },
	                _react2.default.createElement(
	                  'div',
	                  { style: Object.assign({}, headlineStyle, { fontFamily: "legacysans-bold" }) },
	                  headline
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  { style: Object.assign({}, bodyStyle, { fontFamily: "legacysans-book" }) },
	                  body
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbuquerqueStorySingleImage;
	}(_react.Component);
	
	exports.default = AlbuquerqueStorySingleImage;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _AlbuquerqueConstants = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlbuquerqueStoryTextOnly = function (_Component) {
	  _inherits(AlbuquerqueStoryTextOnly, _Component);
	
	  function AlbuquerqueStoryTextOnly(props) {
	    _classCallCheck(this, AlbuquerqueStoryTextOnly);
	
	    var _this = _possibleConstructorReturn(this, (AlbuquerqueStoryTextOnly.__proto__ || Object.getPrototypeOf(AlbuquerqueStoryTextOnly)).call(this, props));
	
	    _this.setupCycle = function () {
	      var time = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", _AlbuquerqueConstants.DEFAULT_CYCLE);
	      _this._cycleTimeoutHandler = setTimeout(function () {
	        _this.props.cycle();
	      }, time * 1000);
	    };
	
	    _this._cycleTimeoutHandler = null;
	    return _this;
	  }
	
	  _createClass(AlbuquerqueStoryTextOnly, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._cycleTimeoutHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var headline = _lodash2.default.get(this.props.module, 'contents.custom_fields.headline.val', "Headline");
	      var body = _lodash2.default.get(this.props.module, 'contents.custom_fields.body.val', _AlbuquerqueConstants.LOREM_IPSUM);
	      var headlineRawStyle = _lodash2.default.get(this.props.module, 'contents.custom_fields.headline_style', null);
	      var bodyRawStyle = _lodash2.default.get(this.props.module, 'contents.custom_fields.body_style', null);
	
	      var headlineStyle = (0, _shared.parseTextStyling)(headlineRawStyle);
	      var bodyStyle = (0, _shared.parseTextStyling)(bodyRawStyle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: "100%", height: "100%", display: "table" } },
	          _react2.default.createElement(
	            'div',
	            { style: { width: "45%", display: "table-cell", verticalAlign: "middle", paddingLeft: "25%", paddingRight: "25%" } },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, headlineStyle, { fontFamily: "legacysans-bold" }) },
	              headline
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, bodyStyle, { fontFamily: "legacysans-book" }) },
	              body
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AlbuquerqueStoryTextOnly;
	}(_react.Component);
	
	exports.default = AlbuquerqueStoryTextOnly;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _StoryAnnouncement = __webpack_require__(90);
	
	var _StoryAnnouncement2 = _interopRequireDefault(_StoryAnnouncement);
	
	var _FamilyStory = __webpack_require__(424);
	
	var _FamilyStory2 = _interopRequireDefault(_FamilyStory);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _NewarkDonorListsPassive = __webpack_require__(455);
	
	var _NewarkDonorListsPassive2 = _interopRequireDefault(_NewarkDonorListsPassive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttractLoopContainer = function (_Component) {
	  _inherits(AttractLoopContainer, _Component);
	
	  function AttractLoopContainer(props) {
	    _classCallCheck(this, AttractLoopContainer);
	
	    var _this = _possibleConstructorReturn(this, (AttractLoopContainer.__proto__ || Object.getPrototypeOf(AttractLoopContainer)).call(this, props));
	
	    _this.setupModules = function () {
	      var background = "white";
	      var modules = _this.props.tree.children.map(function (mod, i) {
	        _this._keys[i] = mod.id;
	        var nodeType = mod.node_type;
	        var type = void 0;
	        switch (nodeType) {
	          case "folder":
	            type = _lodash2.default.get(mod, 'contents.custom_fields.folder_type.val.value', null);
	            switch (type) {
	              case 'donor_lists_hv':
	                background = null;
	                return _this.setupDonorListsHV(mod);
	              default:
	                return {};
	            }
	          case "story":
	            type = _lodash2.default.get(mod, 'contents.custom_fields.story_type.val.value', null);
	            switch (type) {
	              case 'baby_announcement':
	                return _this.setupBabyAnnouncement(mod);
	              case 'family_story':
	                return _this.setupFamilyStory(mod);
	              default:
	                return {};
	            }
	          default:
	            return {};
	        }
	      });
	
	      _this.setState({
	        modules: modules,
	        background: background
	      });
	    };
	
	    _this.setupDonorListsHV = function (module) {
	      var customFields = _lodash2.default.get(module, "contents.custom_fields", {});
	      var slideshows = [];
	      var otherModules = [];
	      for (var field in customFields) {
	        if (customFields[field].type === "module" && customFields[field].module === "slideshow") {
	          var id = _lodash2.default.get(customFields[field], 'val.value', null);
	          if (id) {
	            slideshows = _lodash2.default.filter(_this.props.content.dm_active, { id: id, display_module_type: "Slideshow" });
	          }
	        }
	      }
	      otherModules = otherModules.concat(slideshows);
	      return { otherModules: otherModules, folder: module, modal: false, screen: _this.props.screen, background: null, type: "donor_lists_hv", node_type: "folder" };
	    };
	
	    _this.setupBabyAnnouncement = function (module) {
	      var customFields = _lodash2.default.get(module, "contents.custom_fields", {});
	      var backgroundObj = _lodash2.default.get(module, "contents.images[0]", null);
	      var backgroundImg = _this.getBackground(backgroundObj);
	      var otherModules = [];
	      var slideshows = [];
	
	      for (var field in customFields) {
	        if (customFields[field].type === "module" && customFields[field].module === "slideshow") {
	          var id = _lodash2.default.get(customFields[field], 'val.value', null);
	          if (id) {
	            slideshows = _lodash2.default.filter(_this.props.content.dm_active, { id: id, display_module_type: "Slideshow" });
	          }
	        }
	      }
	
	      otherModules = otherModules.concat(slideshows);
	      return { otherModules: otherModules, story: module, modal: false, screen: _this.props.screen, background: backgroundImg, type: "baby_announcement", node_type: "story" };
	    };
	
	    _this.setupFamilyStory = function (module) {
	      var backgroundObj = _lodash2.default.get(module, "contents.images[0]", null);
	      var backgroundImg = _this.getBackground(backgroundObj);
	      return { story: module, screen: _this.props.screen, background: backgroundImg, type: "family_story", node_type: "story" };
	    };
	
	    _this.getRenderedModules = function () {
	      var renderedModules = _this.state.modules.map(function (mod, i) {
	        switch (mod.node_type) {
	          case "story":
	            switch (mod.type) {
	              case 'baby_announcement':
	                return _react2.default.createElement(_StoryAnnouncement2.default, Object.assign({ key: i }, mod));
	              case 'family_story':
	                return _react2.default.createElement(_FamilyStory2.default, Object.assign({ key: i }, mod));
	              default:
	                return _react2.default.createElement('span', null);
	            }
	          case "folder":
	            switch (mod.type) {
	              case 'donor_lists_hv':
	                return _react2.default.createElement(_NewarkDonorListsPassive2.default, Object.assign({ key: i }, mod));
	              default:
	                return _react2.default.createElement('span', null);
	            }
	          default:
	            return _react2.default.createElement('span', null);
	
	        }
	      });
	
	      return renderedModules;
	    };
	
	    _this.getBackground = function (displayImage) {
	      if (displayImage) {
	        return _shared2.default.dp(_this.props.screen, displayImage, null);
	      }
	      return null;
	    };
	
	    _this._background = null;
	    _this._keys = [];
	    _this.state = {
	      story: null,
	      ref: null,
	      background: null,
	      randomStr: null,
	      modules: []
	    };
	    return _this;
	  }
	
	  _createClass(AttractLoopContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupModules();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderedModules = this.getRenderedModules();
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundColor: this.state.background } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this._keys[this.props.attractLoopRef], style: { position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight } },
	            renderedModules[this.props.attractLoopRef]
	          )
	        )
	      );
	    }
	  }]);
	
	  return AttractLoopContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(AttractLoopContainer);

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _LinkListChicago = __webpack_require__(89);
	
	var _LinkListChicago2 = _interopRequireDefault(_LinkListChicago);
	
	var _CircleImageInfoBlock = __webpack_require__(86);
	
	var _CircleImageInfoBlock2 = _interopRequireDefault(_CircleImageInfoBlock);
	
	var _InfoBlock = __webpack_require__(87);
	
	var _InfoBlock2 = _interopRequireDefault(_InfoBlock);
	
	var _StoryChicagoModal = __webpack_require__(91);
	
	var _StoryChicagoModal2 = _interopRequireDefault(_StoryChicagoModal);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iScroll = __webpack_require__(72);
	
	
	var config = {
		showTitle: true,
		showName: true,
		showSubheader: false,
		columns: 2,
		cycle_all_groups: true
	};
	
	var DonorListChicago = function (_Component) {
		_inherits(DonorListChicago, _Component);
	
		function DonorListChicago(props) {
			_classCallCheck(this, DonorListChicago);
	
			var _this = _possibleConstructorReturn(this, (DonorListChicago.__proto__ || Object.getPrototypeOf(DonorListChicago)).call(this, props));
	
			_this.handleTap = function (data) {
				_this.handleDonorClick(data.innerrow, data.donorGroupIndex);
			};
	
			_this.prepareDonors = function () {
				_this.setState({
					donorsGrouped: (0, _donorHelpers.donorsIncluded)(_this.props.donors.donorCategories, _this.props.module.contents.include_categories)
				});
			};
	
			_this.switchCategory = function (ref) {
				_this.setState({
					selectedLinkIndex: ref
				});
				_this.scrollRef[0].withIScroll(function (iScroll) {
					iScroll.disable();
					iScroll.enable();
					iScroll.scrollToElement(_this.refDict[ref], 500, 0, 0, false); //-this.props.screen.r16_9.p10
				});
			};
	
			_this.onScrollEnd = function (e) {
				_this.props.resume();
				var selectedLinkIndex = 0;
				//select the last element that is scrolled past screen top
				for (var i = 0; i < _this.refDict.length; i++) {
					var eY = _this.refDict[i].getBoundingClientRect().top;
					if (eY <= 5) {
						selectedLinkIndex = i; //this is the category link on the left being selected when at or above top ofscreen 0
					}
				}
	
				// Check if there are more than 1 categories
				var currentCategoryHeight = _this.refDict[selectedLinkIndex].clientHeight;
				var currentEy = Math.abs(_this.refDict[selectedLinkIndex].getBoundingClientRect().top);
	
				if (_this.refDict.length > 0) {
					// If current visible category has more than two donors, change left link
					// in between the two categories.
					if (_this.state.donorsGrouped[selectedLinkIndex].donors.length > 2) {
						if (currentEy > currentCategoryHeight - _this._donorRowHeight * 2) {
							selectedLinkIndex++;
						}
					}
				}
	
				if (_this.state.selectedLinkIndex !== selectedLinkIndex) {
					_this.setState({
						selectedLinkIndex: selectedLinkIndex
					});
				}
			};
	
			_this.initializeDonorRefs = function () {
				if (_this.state.initializedRefs === false) {
					if (_this.donorRefs.length > 0) {
						_this._donorRowHeight = _this.donorRefs[0].el.clientHeight;
	
						var _loop = function _loop(a) {
							_this.donorRefs[a].el.addEventListener("tap", function () {
								return _this.handleTap(_this.donorRefs[a].data);
							});
						};
	
						for (var a = 0; a < _this.donorRefs.length; a++) {
							_loop(a);
						}
						_this.setState({
							initializedRefs: true
						});
					}
				}
			};
	
			_this.renderDonors = function (donors, donorGroupIndex) {
				var fData = {
					unit: _this._avatarList.width * 0.12 / config.columns,
					counter: 0,
					h_spacing: _this._avatarList.width / config.columns - _this._avatarList.width * .025,
					v_spacing: _this._avatarList.height / _this.state.donorsGrouped[0].donors.length / config.columns
				};
	
				var donorGroupRow = [];
				var rowCounter = 0;
	
				for (var i = 0; i < donors.length; i++) {
					if (!donorGroupRow[rowCounter]) {
						donorGroupRow[rowCounter] = [];
					}
					donorGroupRow[rowCounter].push(donors[i]);
					if ((i + 1) % config.columns === 0) {
						rowCounter++;
					};
				}
	
				return donorGroupRow.map(function (row, i) {
					return _react2.default.createElement(
						'span',
						{ key: i },
						this.renderDonorRow(row, i, fData, donorGroupIndex)
					);
				}, _this);
			};
	
			_this.padLastCategory = function (category) {
				//logic to check numbe rof names and add padding if < 8 and add the right amount for instance 6 names needs less padding then 2.
				//multiple of this.props.screen.r16_9.p10 for height of a single cell.
	
				var padding = 0;
				if (category.donors.length < 7) {
					padding = _this._donorRowHeight;
				}
	
				if (category.donors.length < 5) {
					padding = _this._donorRowHeight * 2;
				}
	
				if (category.donors.length < 3) {
					padding = _this._donorRowHeight * 3;
				}
	
				return _react2.default.createElement('div', { style: { width: '100%', height: padding + 'px' } });
			};
	
			_this.renderDonorCategories = function () {
				return _this.state.donorsGrouped.map(function (row, i) {
					var _this2 = this;
	
					return _react2.default.createElement(
						'div',
						{ className: this._fontClass, ref: function ref(el) {
								return _this2.refDict[i] = el;
							}, key: i },
						i === 0 && config.showTitle ? _react2.default.createElement(
							'span',
							{ style: { display: "inline-block", height: this._titleHorizontalRule.top + this._titleHorizontalRule.height } },
							_react2.default.createElement(
								'span',
								{ style: this._titleStyle },
								this.props.module.contents.headline ? this.props.module.contents.headline : _react2.default.createElement(
									'span',
									null,
									'Donors'
								)
							),
							_react2.default.createElement('span', { style: this._titleHorizontalRule })
						) : _react2.default.createElement('span', null),
						config.showName ? _react2.default.createElement(
							'div',
							{ style: this._subheaderStyle },
							_react2.default.createElement('span', { style: this._titleSpacer }),
							_react2.default.createElement(
								'span',
								{ style: { letterSpacing: 2 } },
								_react2.default.createElement(
									'b',
									null,
									row.name
								)
							),
							_react2.default.createElement('span', { style: this._titleSpacer })
						) : _react2.default.createElement('span', null),
						config.showSubheader ? _react2.default.createElement(
							'div',
							null,
							row.subheader
						) : _react2.default.createElement('span', null),
						this.renderDonors(row.donors, i),
						i === this.state.donorsGrouped.length - 1 && this.state.donorsGrouped.length > 1 ? this.padLastCategory(row) : null
					);
				}, _this);
			};
	
			_this.renderDonorRow = function (row, i, fData, donorGroupIndex) {
				return row.map(function (innerrow, ii) {
					var _this3 = this;
	
					var desc = "";
					var iref = null;
					if (_lodash2.default.has(innerrow, 'contents.texts[0].text')) {
						desc = innerrow.contents.texts[0].text;
					}
					if (_lodash2.default.has(innerrow, 'contents.images[0]')) {
						iref = innerrow.contents.images[0];
					}
					return _react2.default.createElement(
						'div',
						{ className: this._fontClass, ref: function ref(el) {
								return _this3.donorRefs[_this3._refCounter++] = { el: el, data: { innerrow: innerrow, donorGroupIndex: donorGroupIndex } };
							}, style: { marginTop: this.props.screen.r16_9.p10 * .3, display: 'inline-block', width: fData.h_spacing }, key: ii },
						_react2.default.createElement('span', { style: { width: this.props.screen.r16_9.p10 * 0.7, display: "inline-block" } }),
						_react2.default.createElement(_InfoBlock2.default, { unit: fData.unit, header: innerrow.name, text: desc, headerColor: '#223954', fontClass: this._fontClass }),
						_react2.default.createElement(_CircleImageInfoBlock2.default, { mode: this.props.screen.mode, webkey: this.props.screen.webkey, image: iref, size: fData.unit * 2, screen: this.props.screen, name: innerrow.name })
					);
				}, _this);
			};
	
			_this.closeStory = function () {
				_this.props.toggleShowClock(true);
				_this.setState({
					showStory: false,
					story: {
						id: -1
					}
				});
			};
	
			_this.handleDonorClick = function (data, donorGroupIndex) {
	
				var slickAssets = [];
				for (var i = 0; i < data.contents.images.length; i++) {
					if (data.contents.images[i]) {
						var fileType = (0, _fileHelpers.getFileType)(data.contents.images[i].file_name);
						var vType = null;
						if (fileType === "Video") {
							vType = (0, _fileHelpers.videoType)(data.contents.images[i].file_name);
						}
						slickAssets.push({ fileType: fileType, videoType: vType, path: _shared2.default.dpath(_this.props.screen.mode, data.contents.images[i].path, data.contents.images[i].file_name, _this.props.screen.webkey) });
					}
				}
				//first image is thumbnail unless only one image
				if (slickAssets.length >= 2) {
					slickAssets = slickAssets.slice(1);
				}
				_this._donorGroupIndex = donorGroupIndex;
				_this._selectDonorId = data.id;
				if (_lodash2.default.has(data, 'contents.showDetails') && data.contents.showDetails === true) {
					var mainimage = "img/ui/image_default.png"; //"url(img/ui/image_default.png"
					if (data.contents && data.contents.images[1]) {
						mainimage = _shared2.default.dpath(_this.props.screen.mode, data.contents.images[1].path, data.contents.images[1].file_name, _this.props.screen.webkey); //"url(" + shared.dpath(this.props.screen.mode, data.contents.images[1].path, data.contents.images[1].file_name, this.props.screen.webkey) + ")";
					} else if (data.contents && data.contents.images[0]) {
						mainimage = _shared2.default.dpath(_this.props.screen.mode, data.contents.images[0].path, data.contents.images[0].file_name, _this.props.screen.webkey); //"url(" + shared.dpath(this.props.screen.mode, data.contents.images[0].path, data.contents.images[0].file_name, this.props.screen.webkey) + ")";
					}
					var showQuotes = false;
					if (_lodash2.default.has(data, 'contents.custom_fields.show_quotes.val')) {
						showQuotes = data.contents.custom_fields.show_quotes.val;
					}
					_this.props.toggleShowClock(false);
					_this.setState({
						showStory: true,
						story: {
							contextualheader: _this.state.donorsGrouped[_this._donorGroupIndex].name, //this.props.module.contents.headline,
							headline: data.name, //_.has(data, 'contents.texts[1].text') ? data.contents.texts[1].text : "",
							subtitle: _lodash2.default.has(data, 'contents.texts[0].text') ? data.contents.texts[0].text : "",
							body: _lodash2.default.has(data, 'contents.texts[1].text') ? data.contents.texts[1].text : "",
							quote: _lodash2.default.has(data, 'contents.texts[2].text') ? data.contents.texts[2].text : "",
							mainimage: mainimage,
							id: data.id ? data.id : "",
							slickAssets: slickAssets,
							showQuotes: showQuotes
						}
					});
				}
			};
	
			_this.cycleStory = function (direction) {
				var donorSelect = _lodash2.default.findIndex(_this.state.donorsGrouped[_this._donorGroupIndex].donors, { id: _this._selectDonorId });
				if (donorSelect !== undefined) {
	
					if (direction === "forward") {
						donorSelect++;
						if (donorSelect >= _this.state.donorsGrouped[_this._donorGroupIndex].donors.length) {
							donorSelect = 0;
							//cycle group
							if (config.cycle_all_groups === true) {
								_this._donorGroupIndex++;
								if (_this._donorGroupIndex >= _this.state.donorsGrouped.length) {
									_this._donorGroupIndex = 0;
								}
							}
						}
					} else {
						donorSelect--;
						if (donorSelect < 0) {
							if (config.cycle_all_groups === true) {
								_this._donorGroupIndex--;
								if (_this._donorGroupIndex < 0) {
									_this._donorGroupIndex = _this.state.donorsGrouped.length - 1;
								}
							}
							donorSelect = _this.state.donorsGrouped[_this._donorGroupIndex].donors.length - 1;
						}
					}
					var newDonor = _this.state.donorsGrouped[_this._donorGroupIndex].donors[donorSelect];
					_this._selectDonorId = newDonor.id;
	
					if (_lodash2.default.has(newDonor, 'contents.showDetails')) {
						if (_this.state.donorsGrouped[_this._donorGroupIndex].donors[donorSelect].contents.showDetails === true) {
							_this.handleDonorClick(_this.state.donorsGrouped[_this._donorGroupIndex].donors[donorSelect], _this._donorGroupIndex);
							return;
						}
					}
					_this.cycleStory(direction);
				}
			};
	
			_this.navarea = function (width, height) {
				return _react2.default.createElement('div', { style: { position: 'absolute', width: width, height: height - width / 2, bottom: 0, left: 0, backgroundColor: '#424958', zIndex: 99 } });
			};
	
			_this.state = {
				donorsGrouped: [],
				selectedLinkIndex: 0,
				showStory: false,
				story: {
					contextualheader: null,
					headline: null,
					subtitle: null,
					body: null,
					quote: null,
					mainimage: null,
					id: null,
					slickAssets: null
				},
				initializedRefs: false
			};
			_this.refDict = [];
			_this.scrollRef = {};
	
			// this._fontClass = null;
			// if (_.has(this.props.module.contents, 'custom_fields.override_font_family')) {
			// 	if (this.props.module.contents.custom_fields.override_font_family.val) {
			// 		this._fontClass = this.props.module.contents.custom_fields.font_family.val.value;
			// 	}
			// }
	
			_this._fontClass = _lodash2.default.get(_this.props, 'module.contents.custom_fields.font_family.val.value', null);
	
			var titleFont = _this._fontClass ? null : "aleo-bolditalic";
			_this._titleStyle = {
				fontFamily: titleFont,
				fontSize: _this.props.screen.r16_9.p10,
				marginLeft: _this.props.screen.r16_9.p10 * 0.7
			};
			_this._titleHorizontalRule = {
				width: '89.5%',
				height: _this.props.screen.r16_9.p10 * 0.15,
				backgroundColor: '#223954',
				display: 'inline-block',
				position: 'absolute',
				top: _this.props.screen.r16_9.p10 * 1.25,
				left: 0,
				marginLeft: _this.props.screen.r16_9.p10 * 0.7
			};
	
			var subheaderFont = _this._fontClass ? null : "ostrich-medium";
			_this._subheaderStyle = {
				fontFamily: subheaderFont,
				fontSize: _this.props.screen.r16_9.p10 * 0.5,
				marginLeft: _this.props.screen.r16_9.p10 * 0.7
			};
			_this._titleSpacer = {
				width: '100%',
				height: _this.props.screen.r16_9.p10 * 0.3,
				display: 'inline-block'
			};
	
			_this._avatarList = {
				width: _this.props.screen.r16_9.width - _this.props.screen.r16_9.p10 * 3,
				height: _this.props.screen.r16_9.height
	
				// Check for fonts attached to the module.
				// if (_.has(this.props.module.contents, "custom_fields.font_family")) {
	
				// }
	
			};_this._donorGroupIndex = 0;
			_this._selectDonorId = 0;
			_this.donorRefs = [];
			_this._refCounter = 0;
			_this._donorRowHeight = 0;
	
			return _this;
		}
	
		_createClass(DonorListChicago, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				(0, _shared.checkData)(this.props.module);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var _this4 = this;
	
				var _loop2 = function _loop2(a) {
					//let count = 0;
					if (_this4.donorRefs[a].el) {
						_this4.donorRefs[a].el.removeEventListener("tap", function () {
							return _this4.handleTap(_this4.donorRefs[a].data);
						});
						//count++;
					}
				};
	
				for (var a = 0; a < this.donorRefs.length; a++) {
					_loop2(a);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.prepareDonors();
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(prevProps, prevState) {
				if ((0, _shared.shallowEqual)(this.state, prevState)) {
					return false;
				}
				return true;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var links = [];
				var viewConfig = {
					list_offset: this.props.screen.r16_9.left + this.props.screen.r16_9.p10 * 3,
					list_width: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3
				};
				_lodash2.default.map(this.state.donorsGrouped, function (group) {
					links.push({ name: group.name, navroute: null });
				});
	
				var modalBorderV = .035 * this.props.screen.screenHeight;
				var modalBorderH = .02 * this.props.screen.r16_9.width;
				var navarea = this.navarea(this.props.screen.r16_9.width - modalBorderH * 2, this.props.screen.screenHeight - modalBorderV * 2);
	
				this._refCounter = 0;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ style: { position: 'absolute' } },
						_react2.default.createElement(
							'div',
							{ style: { zIndex: 10, width: '100vw', height: '100vh' } },
							_react2.default.createElement('div', { style: { position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 } }),
							_react2.default.createElement(
								'div',
								{ style: { position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 } },
								_react2.default.createElement(_LinkListChicago2.default, { fontClass: this._fontClass, selectedLinkIndex: this.state.selectedLinkIndex, screen: this.props.screen, links: links, switchCategory: this.switchCategory, colorInactive: '#496778' })
							),
							_react2.default.createElement(
								'div',
								{ style: { position: 'absolute', left: viewConfig.list_offset, backgroundColor: '#496778', width: viewConfig.list_width, height: this.props.screen.screenHeight, touchAction: "none" } },
								this.state.donorsGrouped.length > 0 ? _react2.default.createElement(
									_reactIscroll2.default,
									{ ref: function ref(el) {
											return _this5.scrollRef[0] = el;
										}, iScroll: iScroll,
										options: {
											scrollX: false,
											scrollY: true,
											probeType: 2,
											disableTouch: false,
											disablePointer: false,
											disableMouse: false,
											momentum: true,
											deceleration: 0.01,
											tap: true,
											mouseWheel: true,
											useTransition: true
										},
										onScrollEnd: this.onScrollEnd,
										onRefresh: this.initializeDonorRefs
									},
									_react2.default.createElement(
										'div',
										null,
										this.renderDonorCategories(),
										_react2.default.createElement('div', { style: { display: 'inline-block', width: '100%', height: this.props.screen.screenHeight * .15 } })
									)
								) : null
							)
						)
					),
					_react2.default.createElement(
						_CSSTransitionGroup2.default,
						{
							component: 'div',
							transitionName: 'example',
							transitionEnterTimeout: 0,
							transitionLeaveTimeout: 0 },
						_react2.default.createElement(
							'div',
							{ key: this.state.showStory },
							this.state.showStory ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('div', { style: { position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 } }),
								_react2.default.createElement(
									'div',
									{ style: { pointerEvents: 'none', position: 'absolute', left: modalBorderH + this.props.screen.r16_9.left, width: this.props.screen.r16_9.width - modalBorderH * 2, height: this.props.screen.screenHeight - modalBorderV * 2, top: modalBorderV, backgroundColor: 'white', zIndex: 100 } },
									navarea
								)
							) : _react2.default.createElement('span', null)
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { zIndex: 100, position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height } },
						_react2.default.createElement(
							_CSSTransitionGroup2.default,
							{
								component: 'div',
								transitionName: 'example',
								transitionEnterTimeout: 0,
								transitionLeaveTimeout: 0 },
							_react2.default.createElement(
								'div',
								{ key: this.state.story.id },
								this.state.showStory ? _react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(_StoryChicagoModal2.default, {
										fontClass: this._fontClass,
										closeStory: this.closeStory,
										contextualheader: this.state.story.contextualheader,
										headline: this.state.story.headline,
										subtitle: this.state.story.subtitle,
										body: this.state.story.body,
										quote: this.state.story.quote,
										mainimage: this.state.story.mainimage,
										slickAssets: this.state.story.slickAssets,
										left: modalBorderH,
										top: modalBorderV,
										width: this.props.screen.r16_9.width - modalBorderH * 2,
										height: this.props.screen.screenHeight - modalBorderV * 2,
										zIndex: 100,
										cycleStory: this.cycleStory,
										showQuotes: this.state.story.showQuotes
									})
								) : _react2.default.createElement('span', null)
							)
						)
					)
				);
			}
		}]);
	
		return DonorListChicago;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			module: state.content.dm_active[state.active_module],
			screen: state.screen,
			donors: state.donors
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DonorListChicago);

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _reactRedux = __webpack_require__(5);
	
	var _LinkListChicago = __webpack_require__(89);
	
	var _LinkListChicago2 = _interopRequireDefault(_LinkListChicago);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iScroll = __webpack_require__(72);
	
	
	var scrollDelay = 30000;
	
	var DonorListChicagoSimple = function (_Component) {
	    _inherits(DonorListChicagoSimple, _Component);
	
	    function DonorListChicagoSimple(props) {
	        _classCallCheck(this, DonorListChicagoSimple);
	
	        var _this = _possibleConstructorReturn(this, (DonorListChicagoSimple.__proto__ || Object.getPrototypeOf(DonorListChicagoSimple)).call(this, props));
	
	        _this.setInitialLocation = function () {
	            if (_this.state.initialLocationSet === false) {
	                if (_this.scrollRef[0]) {
	                    var jumptodonor = _shared2.default.parseStringParam(_this.props.history.location.search, "donor");
	                    if (jumptodonor) {
	                        _lodash2.default.forEach(_this.donorlines, function (donor) {
	                            if (donor.id === jumptodonor) {
	                                _this.scrollRef[0].withIScroll(function (iScroll) {
	                                    iScroll.scrollToElement(donor, 500, 0, -_this.props.screen.r16_9.p10, false);
	                                    return true;
	                                });
	                            }
	                        });
	                        _this.setState({
	                            initialLocationSet: true
	                        });
	                    } else {
	                        _this.scrollRef[0].withIScroll(function (iScroll) {
	                            iScroll.scrollTo(0, -_this.props.screen.r16_9.p10 * 6);
	                        });
	                        _this.setState({
	                            initialLocationSet: true
	                        });
	                    }
	                }
	            }
	        };
	
	        _this.scrollToBottom = function () {
	            var max = Math.abs(_this.scrollRef[0]._iScrollInstance.maxScrollY);
	            var current = Math.abs(_this.scrollRef[0]._iScrollInstance.y);
	            var remaining = max - current;
	            var seconds = remaining / 1000 * 5000 * _this._scrollMultiplier; //5 seconds per 1000 pixels
	            var customEase = iScroll.utils.ease.quadratic;
	            customEase.style = "cubic-bezier(0, 0, 1, 1)";
	            //0.250, 0.250, 0.750, 0.750
	            _this.scrollRef[0].withIScroll(function (iScroll) {
	                //iScroll.scrollTo(0, -max, seconds, customEase);
	                iScroll.scrollTo(0, -max, seconds, customEase);
	            });
	
	            _this.setState({
	                userScrolling: false
	            });
	        };
	
	        _this.onScrollStart = function () {
	            _this.setState({
	                userScrolling: true
	            });
	            if (_this.scrollTimeout) {
	                clearTimeout(_this.scrollTimeout);
	                _this.scrollTimeout = null;
	            }
	            _this.resetTimer(scrollDelay);
	        };
	
	        _this.onScrollEnd = function (e) {
	            _this.props.resume();
	            if (e.y === e.maxScrollY && _this.state.userScrolling === false) {
	                _this.scrollRef[0].withIScroll(function (iScroll) {
	                    iScroll.scrollTo(0, 0);
	                    _this.resetTimer(500);
	                });
	            }
	            _this.setState({
	                userScrolling: false
	            });
	            var selectedLinkIndex = 0;
	
	            //select the last element that is scrolled past screen top
	            for (var i = 0; i < _this.catRefs.length; i++) {
	                var eY = _this.catRefs[i].getBoundingClientRect().top - _this.props.screen.r16_9.p10 * 2;
	                if (eY <= 0 + _this.props.screen.r16_9.p10 * 1.5) {
	                    selectedLinkIndex = i;
	                }
	            }
	            if (_this.state.selectedLinkIndex !== selectedLinkIndex) {
	                _this.setState({
	                    selectedLinkIndex: selectedLinkIndex
	                });
	            }
	        };
	
	        _this.resetTimer = function (time) {
	            if (_this.scrollTimeout) {
	                clearTimeout(_this.scrollTimeout);
	                _this.scrollTimeout = null;
	            }
	
	            _this.scrollTimeout = setTimeout(function () {
	                _this.scrollToBottom();
	                _this.scrollTimeout = null;
	            }, time);
	        };
	
	        _this.handleCategoriesSlide = function () {
	            if (_this.state.displayCategories === false) {
	                _this.toggleSlideOn();
	            } else {
	                _this.toggleSlideOff();
	            }
	        };
	
	        _this.toggleSlideOff = function () {
	            _this.setState({
	                displayCategories: false
	            });
	        };
	
	        _this.toggleSlideOn = function () {
	            _this.setState({
	                displayCategories: true
	            });
	        };
	
	        _this.switchCategory = function (ref) {
	            _this.setState({
	                selectedLinkIndex: ref
	            });
	            _this.scrollRef[0].withIScroll(function (iScroll) {
	                iScroll.disable();
	                iScroll.enable();
	                iScroll.scrollToElement(_this.catRefs[ref], 500, 0, -_this.props.screen.r16_9.p10, false);
	            });
	        };
	
	        _this.prepareDonors = function () {
	            if (_this.props.donors.donorCategories.length === 0) {
	                _this.setState({
	                    donorsGrouped: []
	                });
	                return;
	            }
	            var donorsGrouped = [];
	            _lodash2.default.forEach(_this.props.donors.donorCategories, function (category) {
	                if (category.donors.length > 0) {
	                    _lodash2.default.forEach(_this.props.module.contents.include_categories, function (icat) {
	                        if (icat === category.id) {
	                            var pushGroup = { id: category.id, name: category.name, subheader: category.subheader, donors: [] };
	                            _lodash2.default.forEach(category.donors, function (dnr) {
	                                pushGroup.donors.push(dnr);
	                            });
	                            donorsGrouped.push(pushGroup);
	                        }
	                    });
	                }
	            });
	            _this.setState({
	                donorsGrouped: donorsGrouped
	            });
	        };
	
	        _this.outputDonors = function (donorCat) {
	            return donorCat.map(function (row, i) {
	                var title = this.outputName(row, i);
	                var subheader = this.outputSubheader(row, i);
	                var donors = this.outputDonorInfo(row);
	                return _react2.default.createElement(
	                    'div',
	                    { key: i, style: { width: '100%' } },
	                    _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .35 } }),
	                    title,
	                    _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .175 } }),
	                    subheader,
	                    _react2.default.createElement('div', { style: { height: this.props.screen.r16_9.p10 * .35 } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'threecolumn' },
	                        donors
	                    )
	                );
	            }, _this);
	        };
	
	        _this.donorRefs = {};
	        _this.catRefs = [];
	        _this.scrollRef = {};
	
	        _this._scrollMultiplier = 10;
	        _this.handleSlideCategoryChange = _this.handleSlideCategoryChange.bind(_this);
	        _this.donorlines = [];
	        _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
	        _this.state = {
	            selectedCategory: null,
	            donorsGrouped: null,
	            displayCategories: false,
	            userScrolling: true,
	            initialLocationSet: false,
	            selectedLinkIndex: 0
	        };
	        _this.scrollTimeout = null; //for auto scrolling
	        if (_lodash2.default.has(_this.props.module, 'contents.cycle_time')) {
	            _this._scrollMultiplier = _this.props.module.contents.cycle_time;
	        }
	        return _this;
	    }
	
	    _createClass(DonorListChicagoSimple, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _shared2.default.checkData(this.props.module);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.prepareDonors();
	            this.resetTimer(scrollDelay);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.scrollTimeout);
	            this.scrollTimeout = null;
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(prevProps, prevState) {
	            if (_shared2.default.shallowEqual(this.state, prevState)) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'handleDonorClick',
	        value: function handleDonorClick(e, row) {
	            //e.target.scrollTop = 0;
	            //var elemRect = e.target.getBoundingClientRect();
	            //var elemViewportOffset = elemRect.top;
	            //e.target.scrollIntoView({ block: 'end', behavior: 'smooth' });
	            //  this.refs.test.scrollTop = elemViewportOffset;
	        }
	    }, {
	        key: 'jumpToCategory',
	        value: function jumpToCategory(e) {
	            // e.target.scrollIntoView({ block: 'end', behavior: 'smooth' });
	
	        }
	    }, {
	        key: 'handleSlideCategoryChange',
	        value: function handleSlideCategoryChange(categoryId) {
	            this.toggleSlideOff();
	            this.handleCategoryChange({ value: categoryId });
	        }
	    }, {
	        key: 'handleCategoryChange',
	        value: function handleCategoryChange(val) {
	            var _this2 = this;
	
	            this.setState({
	                selectedCategory: val.value
	            });
	            var jumpTo = null;
	            for (var i = 0; i < this.state.donorsGrouped.length; i++) {
	                if (val.value === this.state.donorsGrouped[i].id) {
	                    jumpTo = i;
	                }
	            }
	            if (jumpTo !== null) {
	                this.scrollRef[0].withIScroll(function (iScroll) {
	                    iScroll.disable();
	                    iScroll.enable();
	                    iScroll.scrollToElement(_this2.donorRefs[jumpTo], 500, 0, -_this2.props.screen.r16_9.p10, false);
	                });
	            }
	        }
	    }, {
	        key: 'outputName',
	        value: function outputName(donorCat, i) {
	            var _this3 = this;
	
	            var style = {
	                fontSize: this.props.screen.r16_9.p10 * .6,
	                lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px"
	            };
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(el) {
	                        return _this3.catRefs[i] = el;
	                    }, style: style },
	                _react2.default.createElement(
	                    'b',
	                    null,
	                    donorCat.name
	                )
	            );
	        }
	    }, {
	        key: 'outputSubheader',
	        value: function outputSubheader(donorCat, i) {
	            var style = {
	                fontSize: this.props.screen.r16_9.p10 * .4,
	                lineHeight: String(this.props.screen.r16_9.p10 * .4 * .78) + "px",
	                pointerEvents: 'auto',
	                zIndex: 100
	            };
	            if (donorCat.subheader) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: style },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        donorCat.subheader
	                    )
	                );
	            }
	            return _react2.default.createElement('div', null);
	        }
	    }, {
	        key: 'outputDonorInfo',
	        value: function outputDonorInfo(donorCat) {
	            return donorCat.donors.map(function (row, i) {
	                var _this4 = this;
	
	                //if row.id===param scroll
	                //check if SET ABOVE specific donor id param, if so if its a match render the ref to a different ref??
	                return _react2.default.createElement(
	                    'span',
	                    { id: row.id, ref: function ref(el) {
	                            _this4.donorlines.push(el);
	                        }, onMouseDown: function onMouseDown(e) {
	                            return _this4.handleDonorClick(e);
	                        }, style: { width: '100%', marginBottom: this.props.screen.r16_9.p10 * .125, marginTop: this.props.screen.r16_9.p10 * .125, fontSize: this.props.screen.r16_9.p10 * .3, display: "inline-block" }, key: i },
	                    row.name
	                );
	            }, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            //let navClass = "";
	            var backDropClass = "backdropOff";
	            if (this.state.displayCategories === true) {
	                //navClass += " on";
	                backDropClass = "backdropOn";
	            }
	
	            // let navButtonStyle = {
	            //     color: 'white',
	            //     position: 'fixed',
	            //     height: this.props.screen.screenHeight * .065,
	            //     width: this.props.screen.screenHeight * .065,
	            //     fontSize: this.props.screen.screenHeight * .025,
	            //     left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10,
	            //     bottom: this.props.screen.r16_9.p10 * 2,
	            //     zIndex: 99,
	            //     textAlign: 'left'
	            // }
	
	            var headlineText = {
	                textAlign: 'vertical',
	                display: 'inline-block',
	                color: 'white',
	                fontSize: this.props.screen.r16_9.p10 * .6,
	                lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
	                position: 'absolute',
	                width: this.props.screen.r16_9.screenWidth
	            };
	
	            if (this.state.donorsGrouped === null) {
	                return _react2.default.createElement('div', null);
	            }
	            var donorCats = this.state.donorsGrouped;
	            var donorsOutput = this.outputDonors(donorCats);
	
	            var options = [];
	
	            _lodash2.default.forEach(donorCats, function (dc) {
	                options.push({ value: dc.id, label: dc.name });
	            });
	
	            var u10 = this.props.screen.r16_9.p10;
	            var leftWidth = this.props.screen.r16_9.left + this.props.screen.r16_9.width / 6;
	            var innerRightWidth = this.props.screen.r16_9.width - this.props.screen.r16_9.width / 6;
	            var rightWidth = this.props.screen.screenWidth - leftWidth;
	
	            var links = [];
	            _lodash2.default.map(this.state.donorsGrouped, function (group) {
	                links.push({ name: group.name, navroute: null });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { style: { width: '100vw', height: '100vh', position: 'absolute' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 } },
	                    _react2.default.createElement(_LinkListChicago2.default, { selectedLinkIndex: this.state.selectedLinkIndex, screen: this.props.screen, links: links, switchCategory: this.switchCategory, colorInactive: '#496778' })
	                ),
	                _react2.default.createElement('div', { onMouseDown: this.toggleSlideOff, className: backDropClass }),
	                _react2.default.createElement('div', { style: { position: 'fixed', top: 0, left: leftWidth, width: rightWidth, height: this.props.screen.screenHeight, backgroundColor: '#496778', color: 'white', pointerEvents: 'none' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'phand', style: { color: 'white', position: 'fixed', left: leftWidth + u10, top: 0, height: u10 * 2, width: rightWidth, backgroundColor: '#496778' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { backgroundColor: '#496778', position: 'absolute', top: u10, fontSize: u10 * 2, width: '100%' } },
	                        _react2.default.createElement(
	                            'span',
	                            { style: headlineText },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                this.props.module.contents.headline ? this.props.module.contents.headline : "Donor Headline"
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 7, backgroundColor: '#496778', color: 'white', pointerEvents: 'auto' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'phand', style: { lineHeight: '1.25', height: u10 * 7, width: innerRightWidth - u10 * 2, touchAction: "none" } },
	                        _react2.default.createElement(
	                            _reactIscroll2.default,
	                            { ref: function ref(el) {
	                                    return _this5.scrollRef[0] = el;
	                                }, iScroll: iScroll,
	                                options: {
	                                    mouseWheel: true,
	                                    scrollbars: false,
	                                    scrollX: false,
	                                    scrollY: true,
	                                    probeType: 2,
	                                    bounce: false,
	                                    momentum: true,
	                                    deceleration: 0.015,
	                                    useTransition: true,
	                                    disableTouch: false,
	                                    disablePointer: false,
	                                    disableMouse: false
	                                }, onScrollStart: this.onScrollStart,
	                                onScrollEnd: this.onScrollEnd,
	                                onRefresh: this.setInitialLocation
	                            },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('div', { style: { height: u10 * 7 } }),
	                                donorsOutput,
	                                _react2.default.createElement('div', { style: { height: u10 * 7 } })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'topgrad496778', style: { pointerEvents: 'none', position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1 } }),
	                _react2.default.createElement('div', { className: 'bottomgrad496778', style: { pointerEvents: 'none', position: 'fixed', top: u10 * 8, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1.1 } }),
	                _react2.default.createElement('br', { style: { clear: 'both' } })
	            );
	        }
	    }]);
	
	    return DonorListChicagoSimple;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    var mod = state.content.dm_active[state.active_module];
	    var isIdle = _shared2.default.parseStringParam(window.location.href, "idle");
	    if (isIdle === 'true') {
	        mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data    
	    }
	    return {
	        screen: state.screen,
	        module: mod,
	        donors: state.donors
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DonorListChicagoSimple);

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FamilyStory = function (_Component) {
	  _inherits(FamilyStory, _Component);
	
	  function FamilyStory(props) {
	    _classCallCheck(this, FamilyStory);
	
	    var _this = _possibleConstructorReturn(this, (FamilyStory.__proto__ || Object.getPrototypeOf(FamilyStory)).call(this, props));
	
	    _this.setupStory = function () {
	      var backgroundImage = null;
	      var backgroundObj = _lodash2.default.get(_this.props.story, 'contents.images[0]', null);
	
	      if (backgroundObj) {
	        backgroundImage = _this.getBackground(backgroundObj);
	      }
	
	      _this.setState({
	        background: backgroundImage
	      });
	    };
	
	    _this.getBackground = function (displayImage) {
	      if (displayImage) {
	        return _shared2.default.dp(_this.props.screen, displayImage, null);
	      }
	      return null;
	    };
	
	    _this.state = {
	      background: null
	    };
	    return _this;
	  }
	
	  _createClass(FamilyStory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupStory();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props !== prevProps) {
	        this.setupStory();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var type = _lodash2.default.get(this.props.story, 'contents.custom_fields.story_type.val.value', null);
	      if (!type || type !== 'family_story') {
	        return _react2.default.createElement('span', null);
	      }
	      // let backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
	      if (this.state.background === undefined || this.state.background === null) {
	        return _react2.default.createElement('span', null);
	      }
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, top: -this.props.screen.r16_9.p10 } },
	        _react2.default.createElement('img', { src: this.state.background, style: { maxHeight: this.props.screen.screenHeight, maxWidth: this.props.screen.screenWidth, position: "absolute", bottom: 0 }, alt: '' })
	      );
	    }
	  }]);
	
	  return FamilyStory;
	}(_react.Component);
	
	exports.default = FamilyStory;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _LinkListChicago = __webpack_require__(89);
	
	var _LinkListChicago2 = _interopRequireDefault(_LinkListChicago);
	
	var _CircleImageInfoBlock = __webpack_require__(86);
	
	var _CircleImageInfoBlock2 = _interopRequireDefault(_CircleImageInfoBlock);
	
	var _InfoBlock = __webpack_require__(87);
	
	var _InfoBlock2 = _interopRequireDefault(_InfoBlock);
	
	var _StoryChicagoModal = __webpack_require__(91);
	
	var _StoryChicagoModal2 = _interopRequireDefault(_StoryChicagoModal);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _StoryAnnouncement = __webpack_require__(90);
	
	var _StoryAnnouncement2 = _interopRequireDefault(_StoryAnnouncement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iScroll = __webpack_require__(72);
	// import { donorsIncluded } from '../../../utils/donorHelpers';
	
	
	var config = {
		showTitle: true,
		showName: true,
		showSubheader: false,
		columns: 2,
		cycle_all_groups: true
	};
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StoriesFoldersChicago = function (_Component) {
		_inherits(StoriesFoldersChicago, _Component);
	
		function StoriesFoldersChicago(props) {
			_classCallCheck(this, StoriesFoldersChicago);
	
			var _this = _possibleConstructorReturn(this, (StoriesFoldersChicago.__proto__ || Object.getPrototypeOf(StoriesFoldersChicago)).call(this, props));
	
			_this.handleTap = function (data, i) {
				console.log("Clicked here", data);
				_this.handleDonorClick(data.innerrow, i);
			};
	
			_this.prepareStories = function () {
				var folder = _this.props.content.story_categories[Number(_this.props.folder)];
				var stories = _this.props.content.folder_modules.filter(function (fm) {
					return fm.folder === Number(folder.id) && fm.model === 'story';
				}).map(function (fm) {
					return _this.props.content.stories.find(function (story) {
						return story.id === fm.module_id;
					});
				}).filter(function (fm) {
					return fm !== undefined;
				});
	
				_this.setState({
					stories: stories
					// donorsGrouped: donorsIncluded(this.props.donors.donorCategories, this.props.module.contents.include_categories)
				});
			};
	
			_this.switchCategory = function (ref) {
				_this.setState({
					selectedLinkIndex: ref
				});
				_this.scrollRef[0].withIScroll(function (iScroll) {
					iScroll.disable();
					iScroll.enable();
					iScroll.scrollToElement(_this.refDict[ref], 500, 0, 0, false); //-this.props.screen.r16_9.p10
				});
			};
	
			_this.initializeDonorRefs = function () {
				if (_this.state.initializedRefs === false) {
					if (_this.donorRefs.length > 0) {
						_this._donorRowHeight = _this.donorRefs[0].el.clientHeight;
	
						var _loop = function _loop(a) {
							_this.donorRefs[a].el.addEventListener("tap", function () {
								return _this.handleTap(_this.donorRefs[a].data, a);
							});
						};
	
						for (var a = 0; a < _this.donorRefs.length; a++) {
							_loop(a);
						}
						_this.setState({
							initializedRefs: true
						});
					}
				}
			};
	
			_this.padLastCategory = function (category) {
				//logic to check numbe rof names and add padding if < 8 and add the right amount for instance 6 names needs less padding then 2.
				//multiple of this.props.screen.r16_9.p10 for height of a single cell.
	
				var padding = 0;
				if (category.donors.length < 7) {
					padding = _this._donorRowHeight;
				}
	
				if (category.donors.length < 5) {
					padding = _this._donorRowHeight * 2;
				}
	
				if (category.donors.length < 3) {
					padding = _this._donorRowHeight * 3;
				}
	
				return _react2.default.createElement('div', { style: { width: '100%', height: padding + 'px' } });
			};
	
			_this.renderStories = function () {
				var storiesLength = _this.state.stories ? _this.state.stories.length : 0;
				var fData = {
					unit: _this._avatarList.width * 0.12 / config.columns,
					counter: 0,
					h_spacing: _this._avatarList.width / config.columns - _this._avatarList.width * .025,
					v_spacing: _this._avatarList.height / storiesLength / config.columns
				};
				var rows = [];
				var row = [];
	
				var sortedStories = _lodash2.default.orderBy(_this.state.stories, ['sorting_name', 'asc']);
				if (sortedStories && sortedStories.length > 0) {
					for (var i = 0; i < sortedStories.length; i++) {
						row.push(sortedStories[i]);
						if (row.length === 2 || i === sortedStories.length - 1) {
							rows.push(row);
							row = [];
						}
					}
				}
				var folder = _this.props.content.story_categories[Number(_this.props.folder)];
				if (sortedStories && sortedStories.length > 0) {
					return _react2.default.createElement(
						'div',
						{ className: _this._fontClass, ref: function ref(el) {
								return _this.refDict = el;
							} },
						_react2.default.createElement(
							'span',
							{ style: { display: "inline-block", height: _this._titleHorizontalRule.top + _this._titleHorizontalRule.height } },
							_react2.default.createElement(
								'span',
								{ style: _this._titleStyle },
								folder.name ? folder.name : _react2.default.createElement(
									'span',
									null,
									'Donors'
								)
							),
							_react2.default.createElement('span', { style: _this._titleHorizontalRule })
						),
						rows.map(function (row, i) {
							return _react2.default.createElement(
								'div',
								{ key: i },
								row.map(function (story, j) {
									var desc = "";
									var iref = null;
									if (_lodash2.default.has(story, 'contents.texts[0].text')) {
										desc = story.contents.texts[0].text;
									}
									if (_lodash2.default.has(story, 'contents.images[0]')) {
										iref = story.contents.images[0];
									}
									return _react2.default.createElement(
										'div',
										{ className: _this._fontClass, ref: function ref(el) {
												return _this.donorRefs[_this._refCounter++] = { el: el, data: { innerrow: story, groupIndex: i } };
											}, style: { marginTop: _this.props.screen.r16_9.p10 * .3, display: 'inline-block', width: fData.h_spacing }, key: j },
										_react2.default.createElement('span', { style: { width: _this.props.screen.r16_9.p10 * 0.7, display: "inline-block" } }),
										_react2.default.createElement(_InfoBlock2.default, { unit: fData.unit, header: story.name, text: desc, headerColor: '#223954', fontClass: _this._fontClass }),
										_react2.default.createElement(_CircleImageInfoBlock2.default, { mode: _this.props.screen.mode, webkey: _this.props.screen.webkey, image: iref, size: fData.unit * 2, screen: _this.props.screen, name: story.name })
									);
								})
							);
						})
					);
				}
			};
	
			_this.closeStory = function () {
				_this.props.toggleShowClock(true);
				_this.setState({
					showStory: false,
					story: {
						id: -1
					}
				});
			};
	
			_this.handleDonorClick = function (data, storyIndex) {
				var slickAssets = [];
				var type = _lodash2.default.get(data, 'contents.custom_fields.story_type.val.value', null);
	
				if (type === "baby_announcement") {
					var sortedStories = _lodash2.default.orderBy(_this.state.stories, ['sorting_name', 'asc']);
					var story = sortedStories[storyIndex];
					var customFields = _lodash2.default.get(story, 'contents.custom_fields', {});
					var slideshows = [];
					var otherModules = [];
	
					for (var field in customFields) {
						if (customFields[field].type === "module" && customFields[field].module === "slideshow") {
							var id = _lodash2.default.get(customFields[field], 'val.value', null);
							if (id) {
								slideshows = _lodash2.default.filter(_this.props.content.dm_active, { id: id, display_module_type: "Slideshow" });
							}
						}
					}
	
					otherModules = otherModules.concat(slideshows);
					_this.props.toggleShowClock(false);
					_this.setState({
						type: type,
						storyModule: story,
						otherModules: otherModules,
						showStory: true,
						selectedStoryIndex: storyIndex
					});
				} else {
					for (var i = 0; i < data.contents.images.length; i++) {
						if (data.contents.images[i]) {
							var fileType = (0, _fileHelpers.getFileType)(data.contents.images[i].file_name);
							var vType = null;
							if (fileType === "Video") {
								vType = (0, _fileHelpers.videoType)(data.contents.images[i].file_name);
							}
							slickAssets.push({ fileType: fileType, videoType: vType, path: _shared2.default.dpath(_this.props.screen.mode, data.contents.images[i].path, data.contents.images[i].file_name, _this.props.screen.webkey) });
						}
					}
					//first image is thumbnail unless only one image
					if (slickAssets.length >= 2) {
						slickAssets = slickAssets.slice(1);
					}
					// this._donorGroupIndex = donorGroupIndex;
					_this._selectDonorId = data.id;
					var mainimage = "img/ui/image_default.png";
					if (data.contents && data.contents.images[1]) {
						mainimage = _shared2.default.dpath(_this.props.screen.mode, data.contents.images[1].path, data.contents.images[1].file_name, _this.props.screen.webkey);
					} else if (data.contents && data.contents.images[0]) {
						mainimage = _shared2.default.dpath(_this.props.screen.mode, data.contents.images[0].path, data.contents.images[0].file_name, _this.props.screen.webkey);
					}
					var showQuotes = false;
					if (_lodash2.default.has(data, 'contents.custom_fields.show_quotes.val')) {
						showQuotes = data.contents.custom_fields.show_quotes.val;
					}
					_this.props.toggleShowClock(false);
					var textOps = _lodash2.default.get(data.contents.custom_fields, 'line_1.val.ops', {});
					console.log(data);
					var converter = new QuillDeltaToHtmlConverter(textOps, {});
					var richText = converter.convert();
					_this.setState({
						showStory: true,
						selectedStoryIndex: storyIndex,
						story: {
							type: type,
							contextualheader: "",
							headline: data.name,
							subtitle: _lodash2.default.has(data, 'contents.texts[0].text') ? data.contents.texts[0].text : "",
							body: richText,
							quote: _lodash2.default.has(data, 'contents.texts[2].text') ? data.contents.texts[2].text : "",
							mainimage: mainimage,
							id: data.id ? data.id : "",
							slickAssets: slickAssets,
							showQuotes: showQuotes
						}
					});
				}
			};
	
			_this.cycleStory = function (direction) {
				var newIndex = _shared2.default.loopIndex(_this.state.selectedStoryIndex, 0, _this.state.stories.length - 1, direction);
				var selectedStory = _this.state.stories[newIndex];
	
				_this.handleDonorClick(selectedStory, newIndex);
			};
	
			_this.navarea = function (width, height) {
				return _react2.default.createElement('div', { style: { position: 'absolute', width: width, height: height - width / 2, bottom: 0, left: 0, backgroundColor: '#424958', zIndex: 99 } });
			};
	
			_this.state = {
				donorsGrouped: [],
				selectedLinkIndex: 0,
				selectedStoryIndex: 0,
				showStory: false,
				story: {
					contextualheader: null,
					headline: null,
					subtitle: null,
					body: null,
					quote: null,
					mainimage: null,
					id: null,
					slickAssets: null
				},
				initializedRefs: false,
				stories: []
			};
			_this.refDict = null;
			_this.scrollRef = {};
	
			// this._fontClass = null;
			// if (_.has(this.props.module.contents, 'custom_fields.override_font_family')) {
			// 	if (this.props.module.contents.custom_fields.override_font_family.val) {
			// 		this._fontClass = this.props.module.contents.custom_fields.font_family.val.value;
			// 	}
			// }
	
			_this._fontClass = _lodash2.default.get(_this.props, 'module.contents.custom_fields.font_family.val.value', null);
	
			var titleFont = _this._fontClass ? null : "aleo-bolditalic";
			_this._titleStyle = {
				fontFamily: titleFont,
				fontSize: _this.props.screen.r16_9.p10,
				marginLeft: _this.props.screen.r16_9.p10 * 0.7
			};
			_this._titleHorizontalRule = {
				width: '89.5%',
				height: _this.props.screen.r16_9.p10 * 0.15,
				backgroundColor: '#223954',
				display: 'inline-block',
				position: 'absolute',
				top: _this.props.screen.r16_9.p10 * 1.25,
				left: 0,
				marginLeft: _this.props.screen.r16_9.p10 * 0.7
			};
	
			var subheaderFont = _this._fontClass ? null : "ostrich-medium";
			_this._subheaderStyle = {
				fontFamily: subheaderFont,
				fontSize: _this.props.screen.r16_9.p10 * 0.5,
				marginLeft: _this.props.screen.r16_9.p10 * 0.7
			};
			_this._titleSpacer = {
				width: '100%',
				height: _this.props.screen.r16_9.p10 * 0.3,
				display: 'inline-block'
			};
	
			_this._avatarList = {
				width: _this.props.screen.r16_9.width - _this.props.screen.r16_9.p10 * 3,
				height: _this.props.screen.r16_9.height
			};
	
			_this._donorGroupIndex = 0;
			_this._selectDonorId = 0;
			_this.donorRefs = [];
			_this._refCounter = 0;
			_this._donorRowHeight = 0;
	
			return _this;
		}
	
		_createClass(StoriesFoldersChicago, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				// checkData(this.props.module);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var _this2 = this;
	
				var _loop2 = function _loop2(a) {
					//let count = 0;
					if (_this2.donorRefs[a].el) {
						_this2.donorRefs[a].el.removeEventListener("tap", function () {
							return _this2.handleTap(_this2.donorRefs[a].data);
						});
					}
				};
	
				for (var a = 0; a < this.donorRefs.length; a++) {
					_loop2(a);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.prepareStories();
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(prevProps, prevState) {
				if ((0, _shared.shallowEqual)(this.state, prevState)) {
					return false;
				}
				return true;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				// return (<span/>);
				var links = [];
				var renderedStories = this.renderStories();
				var viewConfig = {
					list_offset: this.props.screen.r16_9.left + this.props.screen.r16_9.p10 * 3,
					list_width: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3
					// _.map(this.state.donorsGrouped, (group) => {
					// 	links.push({ name: group.name, navroute: null })
					// })
	
				};var folder = this.props.content.story_categories[Number(this.props.folder)];
				links = [{ name: folder.name, navroute: null }];
	
				var modalBorderV = .035 * this.props.screen.screenHeight;
				var modalBorderH = .02 * this.props.screen.r16_9.width;
				var navarea = this.navarea(this.props.screen.r16_9.width - modalBorderH * 2, this.props.screen.screenHeight - modalBorderV * 2);
	
				this._refCounter = 0;
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ style: { position: 'absolute' } },
						_react2.default.createElement(
							'div',
							{ style: { zIndex: 10, width: '100vw', height: '100vh' } },
							_react2.default.createElement('div', { style: { position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 } }),
							_react2.default.createElement(
								'div',
								{ style: { position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 } },
								_react2.default.createElement(_LinkListChicago2.default, { fontClass: this._fontClass, selectedLinkIndex: this.state.selectedLinkIndex, screen: this.props.screen, links: links, switchCategory: this.switchCategory, colorInactive: '#496778' })
							),
							_react2.default.createElement(
								'div',
								{ style: { position: 'absolute', left: viewConfig.list_offset, backgroundColor: '#496778', width: viewConfig.list_width, height: this.props.screen.screenHeight, touchAction: "none" } },
								_react2.default.createElement(
									_reactIscroll2.default,
									{ ref: function ref(el) {
											return _this3.scrollRef[0] = el;
										}, iScroll: iScroll,
										options: {
											scrollX: false,
											scrollY: true,
											probeType: 2,
											disableTouch: false,
											disablePointer: false,
											disableMouse: false,
											momentum: true,
											deceleration: 0.01,
											tap: true,
											mouseWheel: true,
											useTransition: true
										},
										onRefresh: this.initializeDonorRefs
									},
									_react2.default.createElement(
										'div',
										null,
										renderedStories,
										_react2.default.createElement('div', { style: { display: 'inline-block', width: '100%', height: this.props.screen.screenHeight * .15 } })
									)
								)
							)
						)
					),
					_react2.default.createElement(
						_CSSTransitionGroup2.default,
						{
							component: 'div',
							transitionName: 'example',
							transitionEnterTimeout: 0,
							transitionLeaveTimeout: 0 },
						_react2.default.createElement(
							'div',
							{ key: this.state.showStory },
							this.state.showStory ? _react2.default.createElement(
								'div',
								null,
								_react2.default.createElement('div', { style: { position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 } }),
								_react2.default.createElement(
									'div',
									{ style: { pointerEvents: 'none', position: 'absolute', left: modalBorderH + this.props.screen.r16_9.left, width: this.props.screen.r16_9.width - modalBorderH * 2, height: this.props.screen.screenHeight - modalBorderV * 2, top: modalBorderV, backgroundColor: 'white', zIndex: 100 } },
									navarea
								)
							) : _react2.default.createElement('span', null)
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { zIndex: 9999, position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height } },
						_react2.default.createElement(
							_CSSTransitionGroup2.default,
							{
								component: 'div',
								transitionName: 'example',
								transitionEnterTimeout: 0,
								transitionLeaveTimeout: 0 },
							_react2.default.createElement(
								'div',
								{ style: { width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }, key: this.state.story.id },
								this.state.showStory ? _react2.default.createElement(
									'div',
									{ style: { width: "100%", height: "100%" } },
									this.state.type === "baby_announcement" ?
									// <span/>
									_react2.default.createElement(_StoryAnnouncement2.default, {
										screen: this.props.screen,
										story: this.state.storyModule,
										otherModules: this.state.otherModules,
										idle: this.state.idle,
										closeStory: this.closeStory,
										left: modalBorderH,
										top: modalBorderV,
										width: this.props.screen.r16_9.width - modalBorderH * 2,
										height: this.props.screen.screenHeight - modalBorderV * 2,
										cycleStory: this.cycleStory,
										modal: true
									}) : _react2.default.createElement(_StoryChicagoModal2.default, {
										fontClass: this._fontClass,
										closeStory: this.closeStory,
										contextualheader: this.state.story.contextualheader,
										headline: this.state.story.headline,
										subtitle: this.state.story.subtitle,
										body: this.state.story.body,
										quote: this.state.story.quote,
										mainimage: this.state.story.mainimage,
										slickAssets: this.state.story.slickAssets,
										left: modalBorderH,
										top: modalBorderV,
										width: this.props.screen.r16_9.width - modalBorderH * 2,
										height: this.props.screen.screenHeight - modalBorderV * 2,
										zIndex: 100,
										cycleStory: this.cycleStory,
										showQuotes: this.state.story.showQuotes,
										useWYSIWYG: true
									})
								) : _react2.default.createElement('span', null)
							)
						)
					)
				);
			}
		}]);
	
		return StoriesFoldersChicago;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		var folder = _shared2.default.parseStringParam(window.location.href, "id");
		return {
			module: state.content.dm_active[state.active_module],
			screen: state.screen,
			content: state.content,
			donors: state.donors,
			folder: folder
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(StoriesFoldersChicago);

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _CircleImageInfoBlock = __webpack_require__(86);
	
	var _CircleImageInfoBlock2 = _interopRequireDefault(_CircleImageInfoBlock);
	
	var _InfoBlock = __webpack_require__(87);
	
	var _InfoBlock2 = _interopRequireDefault(_InfoBlock);
	
	var _StoryChicagoModal = __webpack_require__(91);
	
	var _StoryChicagoModal2 = _interopRequireDefault(_StoryChicagoModal);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import SwipeableViews from 'react-swipeable-views';
	// import { View, ScrollView, StyleSheet } from 'react-native'
	
	
	var spacialEvents;
	var config = {
	    events_on_screen: 4,
	    line_thickness: 0.05
	};
	
	var Timeline = function (_Component) {
	    _inherits(Timeline, _Component);
	
	    function Timeline(props) {
	        _classCallCheck(this, Timeline);
	
	        var _this = _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, props));
	
	        _this.initializeTimelineRefs = function () {
	            if (_this.state.initializedRefs === false) {
	                var _loop = function _loop(a) {
	                    _this.timelineRefs[a].el.addEventListener("tap", function () {
	                        return _this.handleEventSelection(_this.timelineRefs[a].data);
	                    });
	                };
	
	                for (var a = 0; a < _this.timelineRefs.length; a++) {
	                    _loop(a);
	                }
	                _this.setState({
	                    initializedRefs: true
	                });
	            }
	        };
	
	        _this.closeStory = function () {
	            _this.props.toggleShowClock(true);
	            _this.setState({
	                showStory: false,
	                story: {
	                    id: -1
	                }
	            });
	        };
	
	        _this.parseDate = function (date) {
	
	            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var monthName = monthNames[date.getMonth()];
	            var monthNumber = String(date.getMonth() + 1);
	            var fullYear = String(date.getFullYear());
	            var shortYear = fullYear.substring(2);
	            var day = String(date.getDate());
	            switch (_this.state.module.contents.date_format) {
	                case "yyyy":
	                    return fullYear;
	                case "mmm-yyyy":
	                    return monthName + "-" + fullYear;
	                case "mm-dd-yyyy":
	                    return monthNumber + "-" + day + "-" + fullYear;
	                case "yy":
	                    return shortYear;
	                case "mmm-yy":
	                    return monthName + "-" + shortYear;
	                case "mm-dd-yy":
	                default:
	                    return monthNumber + "-" + day + "-" + shortYear;
	            }
	        };
	
	        _this.onScrollEnd = function (e) {
	            _this.props.resume();
	            // let yVal = Math.abs(e.y);
	            // let tempCurrentEvent = 0;
	            // let closestDist = null; //always pinning first to zero
	
	            // for (var i = 0; i < spacialEvents.length; i++) {
	            //     let dist = Math.abs(spacialEvents[i].raw - yVal);
	            //     if (closestDist === null) {
	            //         tempCurrentEvent = i;
	            //         closestDist = dist;
	            //     }
	            //     else {
	            //         if (dist < closestDist) {
	            //             tempCurrentEvent = i;
	            //             closestDist = dist;
	            //         }
	            //     }
	            // }
	
	            // this.refDict[0].withIScroll(function (iScroll) {
	            //     iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
	            // })
	            // this.setState({
	            //     currentEvent: tempCurrentEvent
	            // })
	        };
	
	        _this.cycleDate = function (mode, index) {
	            var tempCurrentEvent = _this.state.currentEvent;
	            if (mode === 0) {
	                //backward
	                tempCurrentEvent--;
	                if (tempCurrentEvent < 0) {
	                    tempCurrentEvent = spacialEvents.length - 1;
	                }
	            } else if (mode === 1) {
	                //forward
	                tempCurrentEvent++;
	                if (tempCurrentEvent > spacialEvents.length - 1) {
	                    tempCurrentEvent = 0;
	                }
	            } else {
	                //to specific index
	                tempCurrentEvent = index;
	            }
	            _this.refDict[0].withIScroll(function (iScroll) {
	                iScroll.scrollTo(-spacialEvents[tempCurrentEvent].raw, 0, 1000);
	            });
	            _this.setState({
	                currentEvent: tempCurrentEvent
	            });
	        };
	
	        _this.handleEventSelection = function (story_id) {
	            //console.log("event selecting");
	            if (story_id) {
	                _this._eventIndex = _lodash2.default.findIndex(_this.state.module.contents.events, { story: String(story_id) });
	
	                if (_this._eventIndex !== undefined) {
	                    var story = _lodash2.default.find(_this.props.content.stories, { id: Number(story_id) });
	                    if (story) {
	
	                        var slickAssets = [];
	                        for (var i = 0; i < story.contents.images.length; i++) {
	                            if (story.contents.images[i]) {
	                                var fileType = (0, _fileHelpers.getFileType)(story.contents.images[i].file_name);
	                                var vType = null;
	                                if (fileType === "Video") {
	                                    vType = (0, _fileHelpers.videoType)(story.contents.images[i].file_name);
	                                }
	                                slickAssets.push({ fileType: fileType, videoType: vType, path: _shared2.default.dpath(_this.props.screen.mode, story.contents.images[i].path, story.contents.images[i].file_name, _this.props.screen.webkey) });
	                            }
	                        }
	
	                        var mainimage = 'img/ui/image_default.png'; //"url(img/ui/image_default.png"
	                        if (story.contents.images[0]) {
	                            mainimage = _shared2.default.dpath(_this.props.screen.mode, story.contents.images[0].path, story.contents.images[0].file_name, _this.props.screen.webkey);
	                        } else if (story.contents.images[1]) {
	                            mainimage = _shared2.default.dpath(_this.props.screen.mode, story.contents.images[1].path, story.contents.images[1].file_name, _this.props.screen.webkey);
	                        } else if (_lodash2.default.has(_this.state.module.contents.events[_this._eventIndex], 'images[0]')) {
	                            var timelineFallback = _this.state.module.contents.events[_this._eventIndex].images[0];
	                            mainimage = _shared2.default.dpath(_this.props.screen.mode, timelineFallback.path, timelineFallback.file_name, _this.props.screen.webkey);
	                        }
	                        var showQuotes = false;
	                        if (_lodash2.default.has(story, 'contents.custom_fields.show_quotes.val')) {
	                            showQuotes = story.contents.custom_fields.show_quotes.val;
	                        }
	                        _this.props.toggleShowClock(false);
	                        _this.setState({
	                            showStory: true,
	                            story: {
	                                contextualheader: _this.props.module.name,
	                                headline: story.name,
	                                subtitle: story.contents.headline,
	                                body: story.contents.story,
	                                quote: story.contents.text1,
	                                mainimage: mainimage,
	                                id: story.id,
	                                showQuotes: showQuotes,
	                                slickAssets: slickAssets
	                            }
	                        });
	                    }
	                }
	            }
	        };
	
	        _this.cycleStory = function (direction) {
	            if (direction === "forward") {
	                _this._eventIndex += 1;
	                if (_this._eventIndex >= _this.state.module.contents.events.length) {
	                    _this._eventIndex = 0;
	                }
	            } else {
	                _this._eventIndex -= 1;
	                if (_this._eventIndex < 0) {
	                    _this._eventIndex = _this.state.module.contents.events.length - 1;
	                }
	            }
	            if (!_this.state.module.contents.events[_this._eventIndex].story || isNaN(Number(_this.state.module.contents.events[_this._eventIndex].story))) {
	                _this.cycleStory(direction);
	            } else {
	                _this.handleEventSelection(_this.state.module.contents.events[_this._eventIndex].story);
	            }
	        };
	
	        _this.navarea = function (width, height) {
	            return _react2.default.createElement('div', { style: { position: 'absolute', width: width, height: height - width / 2, bottom: 0, left: 0, backgroundColor: '#424958', zIndex: 99 } });
	        };
	
	        _this.refDict = {};
	        _this.state = {
	            spacialEvents: null,
	            sideMargin: null,
	            totalHeight: null,
	            currentEvent: 0,
	            showStory: false,
	            story: {
	                contextualheader: null, //use name of timeline
	                headline: null,
	                subtitle: null,
	                body: null,
	                quote: null,
	                mainimage: null,
	                story_id: null,
	                slickAssets: null
	            },
	            initializedRefs: false,
	            module: _this.props.module
	        };
	        _this._baseInset = _this.props.screen.r16_9.p10 * 1.25;
	        _this._eventIndex = 0;
	        _this._titleStyle = {
	            position: 'absolute',
	            fontFamily: 'aleo-bolditalic', fontSize: _this.props.screen.r16_9.p10,
	            left: _this.props.screen.r16_9.width * .05
	        };
	        _this._titleHorizontalRule = {
	            width: '90%',
	            height: _this.props.screen.r16_9.p10 * 0.15,
	            backgroundColor: '#223954',
	            display: 'inline-block',
	            position: 'absolute',
	            top: _this.props.screen.r16_9.p10 * 1.25,
	            left: 0,
	            marginLeft: _this.props.screen.r16_9.width * .05
	        };
	        _this._bottomNavOffset = 0;
	        if (_this.props.content.settings.custom_vars && _this.props.content.settings.custom_vars.bottomnav === "true") {
	            _this._bottomNavOffset = _this.props.screen.r16_9.p10;
	        }
	        _this.timelineRefs = [];
	        // this.exiting = false;
	        return _this;
	    }
	
	    _createClass(Timeline, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _shared2.default.checkData(this.props.module);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var _this2 = this;
	
	            var _loop2 = function _loop2(a) {
	                if (_this2.timelineRefs[a].el) {
	                    _this2.timelineRefs[a].el.removeEventListener("tap", function () {
	                        return _this2.handleEventSelection(_this2.timelineRefs[a].data);
	                    });
	                }
	            };
	
	            for (var a = 0; a < this.timelineRefs.length; a++) {
	                _loop2(a);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var totalHeight = (this.state.module.contents.events.length + 1) * (this.props.screen.sv.height / config.events_on_screen); // + this.props.screen.sv.height * 2;
	            this.getRelativeLocations(this.state.module.contents.events, totalHeight, 0);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	
	        // shouldComponentUpdate(){
	        //     return false;
	        // }
	
	    }, {
	        key: 'getRelativeLocations',
	        value: function getRelativeLocations(events, totalHeight, topMargin) {
	            var _this3 = this;
	
	            spacialEvents = [];
	
	            //  if (this.state.module.contents.event_spacing === "even") {
	            var eventInc = this.props.screen.sv.height / config.events_on_screen;
	            events = _lodash2.default.orderBy(events, 'rank', 'desc');
	            _lodash2.default.forEach(events, function (event, index) {
	                var raw = eventInc * index;
	                var span = raw + eventInc;
	                spacialEvents.push({ header: event.header, date: _this3.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story });
	            });
	            this.setState({
	                spacialEvents: spacialEvents,
	                // sideMargin: topMargin,
	                totalHeight: totalHeight
	            });
	            // Relative spacing not yet supported
	            //    }
	            // else { //relative spacing 
	            // console.log("relative spacing, what the")
	            // let fullTimeSpan = events[events.length - 1].date - events[0].date;
	            // _.forEach(events, (event) => {
	            //     let raw = (((event.date - events[0].date) / fullTimeSpan) * totalHeight)
	            //     let span = raw + topMargin;
	            //     spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story })
	            // });
	            // this.setState({
	            //     spacialEvents: spacialEvents,
	            //     //     sideMargin: topMargin,
	            //     totalHeight: totalHeight
	            // })
	            //  }
	        }
	    }, {
	        key: 'renderSpacialEvents',
	        value: function renderSpacialEvents() {
	
	            var circleRadius = this.props.screen.r16_9.p10 * 0.4;
	
	            var circle = {
	                width: circleRadius,
	                height: circleRadius,
	                WebkitBorderRadius: circleRadius / 2,
	                MozBorderRadius: circleRadius / 2,
	                borderRadius: circleRadius / 2,
	                backgroundColor: '#a4bcc2',
	                position: 'absolute',
	                left: this.props.screen.r16_9.p10 * 3 - circleRadius / 2 + this._baseInset
	            };
	
	            if (this.state.spacialEvents.length === 0) {
	                return _react2.default.createElement('span', null);
	            }
	
	            return this.state.spacialEvents.map(function (row, i) {
	                var _this4 = this;
	
	                var inset = this.props.screen.r16_9.p10 * 3;
	                var unitSize = this.props.screen.r16_9.p10 * 0.9;
	
	                var iref = null;
	                if (_lodash2.default.has(row, 'images[0]')) {
	                    iref = row.images[0];
	                    //console.log("in timeline is: ", row.images[0]);
	                }
	                //inset every other
	                if (i % 2 === 0) {
	                    inset = this.props.screen.r16_9.p10 * 5;
	                }
	                return _react2.default.createElement(
	                    'div',
	                    { key: i, style: { position: 'absolute', top: row.offset, zIndex: 0 } },
	                    _react2.default.createElement('div', { style: { position: 'absolute', backgroundColor: 'white', top: circleRadius / 2, left: this.props.screen.r16_9.p10 * 3 + this._baseInset, width: inset, height: this.props.screen.r16_9.p10 * config.line_thickness } }),
	                    _react2.default.createElement('span', { style: Object.assign({}, circle) }),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { textAlign: 'right', width: this.props.screen.r16_9.p10 * 2, fontSize: this.props.screen.r16_9.p10 * .35, position: 'absolute', left: this.props.screen.r16_9.p10 * .5 + this._baseInset } },
	                        row.date
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { ref: function ref(el) {
	                                return _this4.timelineRefs[i] = { el: el, data: row.story };
	                            }, style: { position: 'absolute', left: this.props.screen.r16_9.p10 * 2.5 + inset + this._baseInset, top: -this.props.screen.r16_9.p10 * .7 } },
	                        _react2.default.createElement(_InfoBlock2.default, { unit: unitSize, header: row.header, text: row.text, headerColor: '#223954' }),
	                        _react2.default.createElement(_CircleImageInfoBlock2.default, { mode: this.props.screen.mode, webkey: this.props.screen.webkey, image: iref, size: unitSize * 2, screen: this.props.screen, name: row.header })
	                    )
	                );
	            }, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            if (!this.state.spacialEvents) {
	                return _react2.default.createElement('div', null);
	            }
	
	            var modalBorderV = .035 * this.props.screen.screenHeight;
	            var modalBorderH = .02 * this.props.screen.r16_9.width;
	
	            var spacialEvents = this.renderSpacialEvents();
	            var navarea = this.navarea(this.props.screen.r16_9.width - modalBorderH * 2, this.props.screen.screenHeight - modalBorderV * 2);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: { position: 'absolute', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: '#496778', opacity: 1 } }),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'example',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.showStory },
	                        this.state.showStory ? _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('div', { style: { position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 } }),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { pointerEvents: 'none', position: 'absolute', left: modalBorderH + this.props.screen.r16_9.left, width: this.props.screen.r16_9.width - modalBorderH * 2, height: this.props.screen.screenHeight - modalBorderV * 2, top: modalBorderV, backgroundColor: 'white', zIndex: 100 } },
	                                navarea
	                            )
	                        ) : _react2.default.createElement('span', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, touchAction: "none" } },
	                    _react2.default.createElement(
	                        _reactIscroll2.default,
	                        { ref: function ref(el) {
	                                return _this5.refDict[0] = el;
	                            }, iScroll: _iscroll2.default,
	                            onScrollEnd: this.onScrollEnd,
	                            options: {
	                                mouseWheel: true,
	                                scrollbars: false,
	                                scrollX: false,
	                                scrollY: true,
	                                probeType: 2,
	                                bounce: false,
	                                momentum: true,
	                                deceleration: 0.015,
	                                useTransition: true,
	                                disableTouch: false,
	                                disablePointer: false,
	                                disableMouse: false,
	                                tap: true
	                            },
	                            onRefresh: this.initializeTimelineRefs
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: this.props.screen.r16_9.width * .6, height: this.state.totalHeight, minHeight: '100%' } },
	                            _react2.default.createElement('div', { style: { position: 'absolute', top: this._titleHorizontalRule.top + this._titleHorizontalRule.height, backgroundColor: 'white', left: this.props.screen.r16_9.p10 * 3 + this._baseInset, width: this.props.screen.sv.p10 * config.line_thickness, height: '100%' } }),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'absolute', width: this.props.screen.r16_9.width, height: this._titleHorizontalRule.top + this._titleHorizontalRule.height } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: this._titleStyle },
	                                    this.state.module.contents.header ? this.state.module.contents.header : _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        'Timeline'
	                                    )
	                                ),
	                                _react2.default.createElement('span', { style: this._titleHorizontalRule })
	                            ),
	                            spacialEvents
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { zIndex: 100, position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: 'example',
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        _react2.default.createElement(
	                            'div',
	                            { key: this.state.story.id },
	                            this.state.showStory ? _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(_StoryChicagoModal2.default, {
	                                    backgroundEnabled: true,
	                                    closeStory: this.closeStory,
	                                    contextualheader: this.state.story.contextualheader //use parent category name
	                                    , headline: this.state.story.headline //use name of story
	                                    , subtitle: this.state.story.subtitle //use subtitle
	                                    , body: this.state.story.body,
	                                    quote: this.state.story.quote,
	                                    mainimage: this.state.story.mainimage,
	                                    left: modalBorderH,
	                                    top: modalBorderV, width: this.props.screen.r16_9.width - modalBorderH * 2,
	                                    height: this.props.screen.screenHeight - modalBorderV * 2,
	                                    zIndex: 100,
	                                    cycleStory: this.cycleStory,
	                                    slickAssets: this.state.story.slickAssets //temporary TODO: see donorlist pass through
	                                    , showQuotes: this.state.story.showQuotes
	                                })
	                            ) : _react2.default.createElement('span', null)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Timeline;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	
	    var dm = void 0;
	    if (state.options && (state.options.idleModule || state.options.idleModule === 0)) {
	        dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data;
	    } else if (state.content) {
	        dm = state.content.dm_active[state.active_module];
	    }
	
	    return {
	        content: state.content,
	        screen: state.screen,
	        module: dm
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Timeline);

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DenverSlideshow = __webpack_require__(153);
	
	var _DenverSlideshow2 = _interopRequireDefault(_DenverSlideshow);
	
	var _DenverDonorList = __webpack_require__(152);
	
	var _DenverDonorList2 = _interopRequireDefault(_DenverDonorList);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DONOR_LIST_CYCLE_SECONDS_DEFAULT = 10;
	var SLIDESHOW_CYCLE_SECONDS_DEFAULT = 15;
	
	var DenverContainer = function (_Component) {
	  _inherits(DenverContainer, _Component);
	
	  function DenverContainer(props) {
	    _classCallCheck(this, DenverContainer);
	
	    var _this = _possibleConstructorReturn(this, (DenverContainer.__proto__ || Object.getPrototypeOf(DenverContainer)).call(this, props));
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "s":
	          //console.log(this.props);
	          //console.log('donors', this.props.donors);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.timedCycle = function () {
	
	      //this._leftDonorListRef.timedCycle();
	      //this._rightDonorListRef.timedCycle();
	
	      //this._leftSlideshowRef.timedCycle();
	      //this._rightSlideshowRef.timedCycle();
	    };
	
	    _this.state = {
	      donorsLeft: [],
	      donorsRight: [],
	      slideshowImagesLeft: [],
	      slideshowImagesRight: []
	    };
	
	    _this._leftDonorListRef = null;
	    _this._rightDonorListRef = null;
	
	    _this._leftSlideshowRef = null;
	    _this._rightSlideshowRef = null;
	    return _this;
	  }
	
	  _createClass(DenverContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timedCycle();
	      this._cycleInterval = setInterval(function () {
	        _this2.timedCycle();
	      }, 1000);
	
	      document.addEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var height = window.innerHeight;
	      var width = window.innerWidth / 2;
	
	      var donorListCommonProps = {
	        defaultCycleTime: DONOR_LIST_CYCLE_SECONDS_DEFAULT,
	        width: width,
	        height: height,
	        content: this.props.content,
	        screen: this.props.screen,
	
	        fsTitleModifier: 0.045,
	        fsSubheaderModifier: 0.023,
	        fsNamesModifier: 1,
	        yOffsetTitleModifier: 0.033,
	        yOffsetSubheaderModifier: 0.12,
	        yOffsetSubheaderUnderlineModifier: 0.22,
	        subheaderUnderlineWidthModifier: 0.9,
	
	        yOffsetNamesModifier: 0.27,
	        titleWidthModifier: 0.42,
	        descriptionWidthModifier: 0.82,
	        descriptionLineHeightModifier: 0.0034,
	
	        targetHeight: 1080
	
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DenverSlideshow2.default, {
	          images: this.props.slideshowImagesLeft,
	          cycleOverrides: [],
	          defaultCycleTime: SLIDESHOW_CYCLE_SECONDS_DEFAULT,
	          ref: function ref(_ref) {
	            return _this3._leftSlideshowRef = _ref;
	          },
	          height: height,
	          width: width,
	          screen: this.props.screen,
	          screenOffset: 0
	        }),
	        _react2.default.createElement(_DenverDonorList2.default, Object.assign({}, donorListCommonProps, {
	          ref: function ref(_ref2) {
	            return _this3._leftDonorListRef = _ref2;
	          },
	          style: { position: 'absolute', height: '70vh', left: width * .04125, width: width - width * .04125 * 2, float: "left" },
	          left: 0,
	          donorCategories: this.props.donorsLeft,
	          listTopOffset: window.innerHeight * .26,
	          listWidth: window.innerWidth * .45,
	          listHeight: window.innerHeight * .7,
	          subHeaderFontSize: "2.3vh"
	        })),
	        _react2.default.createElement(_DenverSlideshow2.default, {
	          images: this.props.slideshowImagesRight,
	          cycleOverrides: [],
	          defaultCycleTime: SLIDESHOW_CYCLE_SECONDS_DEFAULT,
	          ref: function ref(_ref3) {
	            return _this3._rightSlideshowRef = _ref3;
	          },
	          height: height,
	          width: width,
	          screenOffset: width,
	          screen: this.props.screen
	        }),
	        _react2.default.createElement(_DenverDonorList2.default, Object.assign({}, donorListCommonProps, {
	          donorCategories: this.props.donorsRight,
	          ref: function ref(_ref4) {
	            return _this3._rightDonorListRef = _ref4;
	          },
	          left: width,
	          style: { position: 'absolute', height: '70vh', left: width * .04125, width: width - width * .04125 * 2, float: "none" },
	          listTopOffset: window.innerHeight * .26,
	          listWidth: window.innerWidth * .45,
	          listHeight: window.innerHeight * .7,
	          subHeaderFontSize: "2.3vh"
	        }))
	      );
	    }
	  }]);
	
	  return DenverContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var getFolder = function getFolder(type) {
	    return state.content.story_categories.find(function (cat) {
	      return _lodash2.default.get(cat, 'contents.custom_fields.folder_type.val.value') === type;
	    });
	  };
	
	  var attractLoopLeft = getFolder('attract_loop_donor_wall_left');
	  var attractLoopRight = getFolder('attract_loop_donor_wall_right');
	
	  var createTree = function createTree(attractLoop) {
	    var folderTree = (0, _shared.createFolderTree)(state.content.story_categories, state.content.folder_modules, null, state.content.stories, state.content.dm_active, attractLoop.name, 'sorting_name');
	    folderTree.children.map(function (x) {
	      var folder_module = _lodash2.default.find(state.content.folder_modules, { id: x.folder_module_id });
	      x.folder_module_rank = folder_module.rank;
	      return null;
	    });
	
	    folderTree.children = _lodash2.default.orderBy(folderTree.children, "folder_module_rank", "asc");
	    return folderTree;
	  };
	
	  var attractLoopTreeLeft = createTree(attractLoopLeft);
	  var attractLoopTreeRight = createTree(attractLoopRight);
	
	  var getDonors = function getDonors(attractLoopTree) {
	    return attractLoopTree.children.map(function (child) {
	      return Object.assign({}, child, {
	        donors: (0, _donorHelpers.getDonorsFromFolder)(state.donors, state.content.folder_modules, child.id)
	      });
	    });
	  };
	
	  var donorsLeft = getDonors(attractLoopTreeLeft);
	  var donorsRight = getDonors(attractLoopTreeRight);
	
	  _lodash2.default.forEach(donorsLeft, function (cat) {
	    cat.donors = _lodash2.default.orderBy(cat.donors, 'sorting_name');
	  });
	  _lodash2.default.forEach(donorsRight, function (cat) {
	    cat.donors = _lodash2.default.orderBy(cat.donors, 'sorting_name');
	  });
	
	  var donorWall = getFolder('donor_wall');
	  var slideshowImagesLeft = [];
	  var slideshowImagesRight = [];
	
	  if (Array.isArray(donorWall.contents.images)) {
	    if (donorWall.contents.images[0]) {
	      slideshowImagesLeft.push(donorWall.contents.images[0]);
	    }
	    if (donorWall.contents.images[1]) {
	      slideshowImagesRight.push(donorWall.contents.images[1]);
	    }
	  }
	
	  return {
	    // active_module: active_module,
	    content: state.content,
	    // contentHasErrored: state.contentHasErrored,
	    // contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    // donorsHasErrored: state.donorsHasErrored,
	    // donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    options: state.options,
	    screensNumber: state.screensNumber,
	    donorsLeft: donorsLeft,
	    donorsRight: donorsRight,
	    slideshowImagesLeft: slideshowImagesLeft,
	    slideshowImagesRight: slideshowImagesRight
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DenverContainer);

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _DenverStory = __webpack_require__(430);
	
	var _DenverStory2 = _interopRequireDefault(_DenverStory);
	
	var _DenverStory3 = __webpack_require__(431);
	
	var _DenverStory4 = _interopRequireDefault(_DenverStory3);
	
	var _DenverStory5 = __webpack_require__(432);
	
	var _DenverStory6 = _interopRequireDefault(_DenverStory5);
	
	var _DenverStory7 = __webpack_require__(433);
	
	var _DenverStory8 = _interopRequireDefault(_DenverStory7);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _DenverDonorList = __webpack_require__(152);
	
	var _DenverDonorList2 = _interopRequireDefault(_DenverDonorList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	  _inherits(_class, _Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	    _this.handleKeyDown = function (event) {
	      switch (event.keyCode) {
	        // Start/stop: spacebar
	        case 32:
	          _this._paused = !_this._paused;
	          break;
	        // Pause and show prev story: left arrow
	        case 37:
	          _this._paused = true;
	          _this.setState(function (prevState) {
	            return prevState.storyIndex - 1 >= 0 ? { storyIndex: prevState.storyIndex - 1 } : { storyIndex: _this.props.stories.length - 1 };
	          }, _this.timedCycle);
	          break;
	        // Pause and show next story: right arrow
	        case 39:
	          _this._paused = true;
	          _this.setState(function (prevState) {
	            return prevState.storyIndex < _this.props.stories.length - 1 ? { storyIndex: prevState.storyIndex + 1 } : { storyIndex: 0 };
	          }, _this.timedCycle);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.timedCycle = function () {
	      if (_this._paused) {
	        console.log(_this._paused);
	        return null;
	      }
	      _this._templateCycleSeconds--;
	      if (_this._templateCycleSeconds < 0) {
	        var folderType = _this.getFolderType();
	        //do not auto cycle the 
	        if (folderType === 'donor_list') {
	          return null;
	        }
	        _this.performCycle();
	      }
	    };
	
	    _this.performCycle = function () {
	      _this.setState(function (prevState) {
	        var storyIndex = 0;
	        if (prevState.storyIndex < _this.props.stories.length - 1) {
	          storyIndex = prevState.storyIndex + 1;
	        }
	        var cycleTime = _lodash2.default.get(_this.props.stories[storyIndex], 'contents.custom_fields.cycle_timeout.val');
	        _this._templateCycleSeconds = cycleTime || _this.props.defaultCycleTime;
	        return Object.assign({}, prevState, { storyIndex: storyIndex });
	      });
	    };
	
	    _this.getFolderType = function () {
	      var story = _this.props.stories[_this.state.storyIndex];
	      var folderType = _lodash2.default.get(story, 'contents.custom_fields.folder_type.val.value');
	      return folderType;
	    };
	
	    _this.getTemplate = function () {
	      var story = _this.props.stories[_this.state.storyIndex];
	      if (!story) {
	        return null;
	      }
	
	      var storyType = _lodash2.default.get(story, 'contents.custom_fields.story_type.val.value');
	      var folderType = _lodash2.default.get(story, 'contents.custom_fields.folder_type.val.value');
	      var customFields = _lodash2.default.get(story, 'contents.custom_fields');
	      var images = _lodash2.default.get(story, 'contents.images', []);
	
	      var commonProps = {
	        screen: _this.props.screen,
	        headline: customFields.headline,
	        body: customFields.body,
	        quote: customFields.quote,
	        images: images
	      };
	
	      if (storyType) {
	
	        switch (storyType) {
	          case 'template_1':
	            return _react2.default.createElement(_DenverStory2.default, commonProps);
	
	          case 'template_2':
	            return _react2.default.createElement(_DenverStory4.default, Object.assign({}, commonProps, {
	              subhead: customFields.subhead,
	              lower_right_image_caption: customFields.lower_right_image_caption,
	              upper_left_image_caption: customFields.upper_left_image_caption,
	              upper_right_image_caption: customFields.upper_right_image_caption
	            }));
	
	          case 'template_3':
	            return _react2.default.createElement(_DenverStory6.default, Object.assign({}, commonProps, {
	              subhead: customFields.subhead,
	              upper_left_image_caption: customFields.upper_left_image_caption,
	              upper_right_image_caption: customFields.upper_right_image_caption
	            }));
	
	          case 'template_4':
	            return _react2.default.createElement(_DenverStory8.default, Object.assign({}, commonProps, {
	              subhead: customFields.subhead,
	              center_image_caption: customFields.center_image_caption
	            }));
	          default:
	            return null;
	        }
	      } else if (folderType === 'donor_list') {
	        var donorCategories = [Object.assign({}, story, {
	          donors: (0, _donorHelpers.getDonorsFromFolder)(_this.props.donors, _this.props.folder_modules, story.id)
	        })];
	        console.log("passing in categories", donorCategories);
	
	        return _react2.default.createElement(_DenverDonorList2.default, {
	          defaultCycleTime: _this.props.defaultCycleTime,
	          width: window.innerWidth,
	          height: window.innerHeight,
	          content: _this.props.content,
	          screen: _this.props.screen // ?
	          , donorCategories: donorCategories,
	          ref: function ref(_ref) {
	            return _this._donorListRef = _ref;
	          },
	          style: { position: 'absolute', left: window.innerWidth * 0.085, height: '100vh', width: '100vw' },
	          columns: 2,
	          rows: 22,
	          allCategoriesLooped: _this.performCycle,
	          fsTitleModifier: 0.029,
	          fsSubheaderModifier: 0.014,
	          fsNamesModifier: 0.57,
	          yOffsetTitleModifier: 0.02,
	          yOffsetSubheaderModifier: 0.065,
	          yOffsetSubheaderUnderlineModifier: 0.2,
	          subheaderUnderlineWidthModifier: 0.83,
	
	          yOffsetNamesModifier: 0.225,
	          titleWidthModifier: 1,
	          descriptionWidthModifier: 0.84,
	          descriptionLineHeightModifier: 0.002,
	          hideDonorListName: true,
	
	          targetHeight: 1920,
	          listTopOffset: window.innerHeight * .24,
	          listHeight: window.innerHeight * .7,
	          listWidth: window.innerWidth * .83,
	          subHeaderFontSize: "1.45vh"
	        });
	      }
	    };
	
	    _this.state = {
	      storyIndex: -1
	    };
	    _this._templateCycleSeconds = 0;
	    _this._donorListRef = null;
	    _this._paused = false;
	    return _this;
	  }
	
	  _createClass(_class, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Only run if donor list mounted
	      if (this._donorListRef) {
	        //this._donorListRef.timedCycle();
	      }
	    }
	  }, {
	    key: 'getCycleTime',
	    value: function getCycleTime() {
	      return this.props.cycleTime || this.props.defaultCycleTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: 'div',
	          transitionName: 'slowfade',
	          transitionEnterTimeout: 0,
	          transitionLeaveTimeout: 0 },
	        _react2.default.createElement(
	          'div',
	          { key: this.state.storyIndex },
	          this.getTemplate()
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react.Component);
	
	exports.default = _class;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DenverSlideshow = __webpack_require__(153);
	
	var _DenverSlideshow2 = _interopRequireDefault(_DenverSlideshow);
	
	var _DenverStories = __webpack_require__(428);
	
	var _DenverStories2 = _interopRequireDefault(_DenverStories);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SLIDESHOW_CYCLE_SECONDS_DEFAULT = 5;
	var STORIES_CYCLE_SECONDS_DEFAULT = 5;
	
	var DenverContainer = function (_Component) {
	  _inherits(DenverContainer, _Component);
	
	  function DenverContainer(props) {
	    _classCallCheck(this, DenverContainer);
	
	    var _this = _possibleConstructorReturn(this, (DenverContainer.__proto__ || Object.getPrototypeOf(DenverContainer)).call(this, props));
	
	    _this.timedCycle = function () {
	      _this._slideshowRef.timedCycle();
	      _this._storiesRef.timedCycle();
	    };
	
	    _this.state = {
	      slideshowImages: [],
	      stories: []
	    };
	    _this._slideshowRef = null;
	    _this._storiesRef = null;
	    return _this;
	  }
	
	  _createClass(DenverContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._cycleInterval = setInterval(function () {
	        _this2.timedCycle();
	      }, 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var height = window.innerHeight;
	      var width = window.innerWidth;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'denver-stories__container vertical-screen-x1' },
	        _react2.default.createElement(_DenverSlideshow2.default, {
	          ref: function ref(_ref) {
	            return _this3._slideshowRef = _ref;
	          },
	          images: this.props.slideshowImages,
	          cycleOverrides: [],
	          defaultCycleTime: SLIDESHOW_CYCLE_SECONDS_DEFAULT,
	          height: height,
	          width: width,
	          screenOffset: 0,
	          screen: this.props.screen
	        }),
	        _react2.default.createElement(_DenverStories2.default, {
	          ref: function ref(_ref2) {
	            return _this3._storiesRef = _ref2;
	          },
	          cycleTime: 7,
	          screen: this.props.screen,
	          stories: this.props.stories
	          //donors={this.state.donors}
	          , story_categories: this.props.content.story_categories,
	          folder_modules: this.props.content.folder_modules,
	          donors: this.props.donors,
	          content: this.props.content,
	          defaultCycleTime: STORIES_CYCLE_SECONDS_DEFAULT
	        })
	      );
	    }
	  }]);
	
	  return DenverContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var rootFolderId = _lodash2.default.get(state.content, 'settings.selected_root_folder', null);
	  var rootFolder = state.content.story_categories.find(function (folder) {
	    return folder.id === Number(rootFolderId);
	  });
	
	  var attractLoopFolder = state.content.story_categories.find(function (folder) {
	    return folder.parent_category === Number(rootFolderId) && folder.contents.custom_fields.folder_type.val.value === 'attract_loop_donor_stories';
	  });
	
	  var folderTree = (0, _shared.createFolderTree)(state.content.story_categories, state.content.folder_modules, null, state.content.stories, state.content.dm_active, attractLoopFolder.name, null);
	
	  folderTree.children.map(function (x) {
	    var folder_module = _lodash2.default.find(state.content.folder_modules, { id: x.folder_module_id });
	    x.folder_module_rank = folder_module.rank;
	    return x;
	  });
	
	  folderTree.children = _lodash2.default.orderBy(folderTree.children, "folder_module_rank", "asc");
	
	  var slideshowImages = [];
	  if (Array.isArray(rootFolder.contents.images)) {
	    if (rootFolder.contents.images[0]) {
	      slideshowImages.push(rootFolder.contents.images[0]);
	    }
	  }
	
	  return {
	    // active_module: active_module,
	    content: state.content,
	    // contentHasErrored: state.contentHasErrored,
	    // contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    // donorsHasErrored: state.donorsHasErrored,
	    // donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    options: state.options,
	    screensNumber: state.screensNumber,
	    slideshowImages: slideshowImages,
	    stories: folderTree.children
	    //slideshowImages: tempSlideshowImages
	    // idleActive: idleActive
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DenverContainer);

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _quillDeltaToHtml = __webpack_require__(16);
	
	var _quillDeltaToHtml2 = _interopRequireDefault(_quillDeltaToHtml);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	
	  var headlineOps = _lodash2.default.get(props.headline, 'val.ops');
	  var headlineOpsInstance = new _quillDeltaToHtml2.default(headlineOps, {});
	  var headlineOpsRichText = headlineOpsInstance.convert();
	
	  var quoteOps = _lodash2.default.get(props.quote, 'val.ops');
	  var quoteOpsInstance = new _quillDeltaToHtml2.default(quoteOps, {});
	  var quoteOpsRichText = quoteOpsInstance.convert();
	
	  var bodyOps = _lodash2.default.get(props.body, 'val.ops');
	  var bodyOpsInstance = new _quillDeltaToHtml2.default(bodyOps, {});
	  var bodyOpsRichText = bodyOpsInstance.convert();
	
	  var imgSrc = (0, _shared.dp)(props.screen, props.images[0], { path: '/img/ui/', file_name: 'image_default.png' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'denver-stories__content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'denver-stories__story-1' },
	      _react2.default.createElement('img', { src: imgSrc, style: { height: '27.6vh', marginBottom: '1.75vh', maxWidth: "100%" }, alt: '' }),
	      _react2.default.createElement('div', { className: 'denver-stories__heading ql-editor', dangerouslySetInnerHTML: { __html: headlineOpsRichText } }),
	      _react2.default.createElement('blockquote', { className: 'denver-stories__quote ql-editor', dangerouslySetInnerHTML: { __html: quoteOpsRichText } }),
	      _react2.default.createElement('div', { className: 'denver-stories__main-copy', dangerouslySetInnerHTML: { __html: bodyOpsRichText } })
	    )
	  );
	};

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _quillDeltaToHtml = __webpack_require__(16);
	
	var _quillDeltaToHtml2 = _interopRequireDefault(_quillDeltaToHtml);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var headlineOps = _lodash2.default.get(props.headline, 'val.ops');
	  var headlineOpsInstance = new _quillDeltaToHtml2.default(headlineOps, {});
	  var headlineOpsRichText = headlineOpsInstance.convert();
	
	  var subheadOps = _lodash2.default.get(props.subhead, 'val.ops');
	  var subheadOpsInstance = new _quillDeltaToHtml2.default(subheadOps, {});
	  var subheadOpsRichText = subheadOpsInstance.convert();
	
	  var bodyOps = _lodash2.default.get(props.body, 'val.ops');
	  var bodyOpsInstance = new _quillDeltaToHtml2.default(bodyOps, {});
	  var bodyOpsRichText = bodyOpsInstance.convert();
	
	  var upperLeftImageSrc = (0, _shared.dp)(props.screen, props.images[0], { path: '/img/ui/', file_name: 'image_default.png' });
	  var upperRightImageSrc = (0, _shared.dp)(props.screen, props.images[1], { path: '/img/ui/', file_name: 'image_default.png' });
	  var lowerRightImageSrc = (0, _shared.dp)(props.screen, props.images[2], { path: '/img/ui/', file_name: 'image_default.png' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'denver-stories__content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'denver-stories__story-2' },
	      _react2.default.createElement('div', { className: 'denver-stories__heading ql-editor', dangerouslySetInnerHTML: { __html: headlineOpsRichText } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'denver-stories__two-cols' },
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'denver-stories__image-container' },
	            _react2.default.createElement('div', { className: 'denver-stories__image-container-background' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-stories__image-container-table' },
	              _react2.default.createElement(
	                'div',
	                { className: 'denver-stories__image-container-table-cell' },
	                _react2.default.createElement('img', { src: upperLeftImageSrc, alt: '', className: 'denver-stories__image-container-image' })
	              )
	            ),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'denver-stories__image-container-caption' },
	              props.upper_left_image_caption.val
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'denver-stories__image-container' },
	            _react2.default.createElement('div', { className: 'denver-stories__image-container-background' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-stories__image-container-table' },
	              _react2.default.createElement(
	                'div',
	                { className: 'denver-stories__image-container-table-cell' },
	                _react2.default.createElement('img', { src: upperRightImageSrc, alt: '', className: 'denver-stories__image-container-image' })
	              )
	            ),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'denver-stories__image-container-caption' },
	              props.upper_right_image_caption.val
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'denver-stories__two-cols' },
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement('div', { className: 'denver-stories__subhead ql-editor', dangerouslySetInnerHTML: { __html: subheadOpsRichText } }),
	          _react2.default.createElement('div', { className: 'denver-stories__body ql-editor', dangerouslySetInnerHTML: { __html: bodyOpsRichText } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'denver-stories__image-container' },
	            _react2.default.createElement('div', { className: 'denver-stories__image-container-background' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-stories__image-container-table' },
	              _react2.default.createElement(
	                'div',
	                { className: 'denver-stories__image-container-table-cell' },
	                _react2.default.createElement('img', { src: lowerRightImageSrc, alt: '', className: 'denver-stories__image-container-image' })
	              )
	            ),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'denver-stories__image-container-caption' },
	              props.lower_right_image_caption.val
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _quillDeltaToHtml = __webpack_require__(16);
	
	var _quillDeltaToHtml2 = _interopRequireDefault(_quillDeltaToHtml);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var headlineOps = _lodash2.default.get(props.headline, 'val.ops');
	  var headlineOpsInstance = new _quillDeltaToHtml2.default(headlineOps, {});
	  var headlineOpsRichText = headlineOpsInstance.convert();
	
	  var subheadOps = _lodash2.default.get(props.subhead, 'val.ops');
	  var subheadOpsInstance = new _quillDeltaToHtml2.default(subheadOps, {});
	  var subheadOpsRichText = subheadOpsInstance.convert();
	
	  var bodyOps = _lodash2.default.get(props.body, 'val.ops');
	  var bodyOpsInstance = new _quillDeltaToHtml2.default(bodyOps, {});
	  var bodyOpsRichText = bodyOpsInstance.convert();
	
	  var upperLeftImageSrc = (0, _shared.dp)(props.screen, props.images[0], { path: '/img/ui/', file_name: 'image_default.png' });
	  var upperRightImageSrc = (0, _shared.dp)(props.screen, props.images[1], { path: '/img/ui/', file_name: 'image_default.png' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'denver-stories__content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'denver-stories__story-3' },
	      _react2.default.createElement('div', { className: 'denver-stories__heading ql-editor', dangerouslySetInnerHTML: { __html: headlineOpsRichText } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'denver-stories__two-cols' },
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'denver-stories__image-container' },
	            _react2.default.createElement('div', { className: 'denver-stories__image-container-background' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-stories__image-container-table' },
	              _react2.default.createElement(
	                'div',
	                { className: 'denver-stories__image-container-table-cell' },
	                _react2.default.createElement('img', { src: upperLeftImageSrc, alt: '', className: 'denver-stories__image-container-image' })
	              )
	            ),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'denver-stories__image-container-caption' },
	              props.upper_left_image_caption.val
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'denver-stories__image-container' },
	            _react2.default.createElement('div', { className: 'denver-stories__image-container-background' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-stories__image-container-table' },
	              _react2.default.createElement(
	                'div',
	                { className: 'denver-stories__image-container-table-cell' },
	                _react2.default.createElement('img', { src: upperRightImageSrc, alt: '', className: 'denver-stories__image-container-image' })
	              )
	            ),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'denver-stories__image-container-caption' },
	              props.upper_right_image_caption.val
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'denver-stories__subhead ql-editor', dangerouslySetInnerHTML: { __html: subheadOpsRichText } }),
	      _react2.default.createElement('div', { className: 'denver-stories__body ql-editor', dangerouslySetInnerHTML: { __html: bodyOpsRichText } })
	    )
	  );
	};

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _quillDeltaToHtml = __webpack_require__(16);
	
	var _quillDeltaToHtml2 = _interopRequireDefault(_quillDeltaToHtml);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var headlineOps = _lodash2.default.get(props.headline, 'val.ops');
	  var headlineOpsInstance = new _quillDeltaToHtml2.default(headlineOps, {});
	  var headlineOpsRichText = headlineOpsInstance.convert();
	
	  var subheadOps = _lodash2.default.get(props.subhead, 'val.ops');
	  var subheadOpsInstance = new _quillDeltaToHtml2.default(subheadOps, {});
	  var subheadOpsRichText = subheadOpsInstance.convert();
	
	  var bodyOps = _lodash2.default.get(props.body, 'val.ops');
	  var bodyOpsInstance = new _quillDeltaToHtml2.default(bodyOps, {});
	  var bodyOpsRichText = bodyOpsInstance.convert();
	
	  var upperLeftImageSrc = (0, _shared.dp)(props.screen, props.images[0], { path: '/img/ui/', file_name: 'image_default.png' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'denver-stories__content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'denver-stories__story-4' },
	      _react2.default.createElement('div', { className: 'denver-stories__heading ql-editor', dangerouslySetInnerHTML: { __html: headlineOpsRichText } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'denver-stories__centered-col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'denver-stories__col' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'denver-stories__image-container' },
	            _react2.default.createElement('div', { className: 'denver-stories__image-container-background' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'denver-stories__image-container-table' },
	              _react2.default.createElement(
	                'div',
	                { className: 'denver-stories__image-container-table-cell' },
	                _react2.default.createElement('img', { src: upperLeftImageSrc, alt: '', className: 'denver-stories__image-container-image' })
	              )
	            ),
	            _react2.default.createElement(
	              'figcaption',
	              { className: 'denver-stories__image-container-caption' },
	              props.center_image_caption.val
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'denver-stories__subhead ql-editor', dangerouslySetInnerHTML: { __html: subheadOpsRichText } }),
	      _react2.default.createElement('div', { className: 'denver-stories__body ql-editor', dangerouslySetInnerHTML: { __html: bodyOpsRichText } })
	    )
	  );
	};

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyboardKey = function (_Component) {
	    _inherits(KeyboardKey, _Component);
	
	    function KeyboardKey(props) {
	        _classCallCheck(this, KeyboardKey);
	
	        var _this = _possibleConstructorReturn(this, (KeyboardKey.__proto__ || Object.getPrototypeOf(KeyboardKey)).call(this, props));
	
	        _this.state = {
	            pressed: false,
	            canpress: true
	        };
	        return _this;
	    }
	
	    _createClass(KeyboardKey, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeout) {
	                clearTimeout(this.timeout);
	                this.timeout = null;
	            }
	        }
	    }, {
	        key: 'handlePress',
	        value: function handlePress() {
	            var _this2 = this;
	
	            if (this.state.canpress === true) {
	                this.props.handleKeyPress(this.props.keyval[this.props.virtual_keyboard_mode]);
	                this.setState({
	                    pressed: true,
	                    canpress: false
	                });
	                this.timeout = setTimeout(function () {
	                    _this2.setState({
	                        pressed: false,
	                        canpress: true
	                    });
	                    _this2.timeout = null;
	                }, 125);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var className = "kspn";
	            if (this.props.colorPallette === "adaptive") {
	                className = "kspn-primary";
	            }
	            var classes = "pressin keyopacity";
	            if (this.state.pressed === true) {
	                classes += " active";
	            }
	            if (this.props.contents[this.props.virtual_keyboard_mode] === null) {
	                classes += " keyhide";
	                return (
	                    // <div style={{display: 'hidden'}}><div style={this.props.mainstyle[1]} className={classes}><span className="kspn">&nbsp;</span></div></div>
	                    _react2.default.createElement(
	                        'div',
	                        { style: this.props.mainstyle, className: classes },
	                        _react2.default.createElement(
	                            'span',
	                            { className: className },
	                            '\xA0'
	                        )
	                    )
	                );
	            }
	            classes += " phand";
	            var innercontent = void 0;
	            switch (this.props.contents[this.props.virtual_keyboard_mode]) {
	                case "UPCASE":
	                    innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-up' }); //<Icon type="up-circle-o" />
	                    break;
	                case "DOWNCASE":
	                    innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-down' }); //<Icon type="down-circle-o" />
	                    break;
	                case "DELETE":
	                    innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-left' }); //<Icon type="left" />
	                    break;
	                case "Submit":
	                    classes += " primaryButton primaryButton-keyboardSearch";
	                    if (this.props.colorPallette === "adaptive") {
	                        classes += " primaryButton-primary primaryButton-keyboardSearch";
	                    }
	                    innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	                    break;
	                default:
	                    innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	                    break;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { onMouseDown: function onMouseDown(e) {
	                        return _this3.handlePress(e);
	                    }, style: this.props.mainstyle, className: classes },
	                _react2.default.createElement(
	                    'span',
	                    { className: className },
	                    innercontent,
	                    this.props.contents[this.props.virtual_keyboard_mode] === "Submit" ? _react2.default.createElement(
	                        'div',
	                        { style: { display: "inline-block" } },
	                        '\xA0\xA0',
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-right' })
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return KeyboardKey;
	}(_react.Component);
	
	exports.default = KeyboardKey;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconMenu = __webpack_require__(565);
	var iconMenuPrimary = __webpack_require__(564);
	
	var MenuButtonMiami = function (_Component) {
	  _inherits(MenuButtonMiami, _Component);
	
	  function MenuButtonMiami() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuButtonMiami);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuButtonMiami.__proto__ || Object.getPrototypeOf(MenuButtonMiami)).call.apply(_ref, [this].concat(args))), _this), _this.renderBackButton = function () {
	      var icon = iconMenu;
	      var textColor = "#95268e";
	      if (_this.props.colorPallette === "adaptive") {
	        textColor = "#006699";
	        icon = iconMenuPrimary;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", marginLeft: '.3vh', top: 0, height: "2vh", width: "100%" } },
	          _react2.default.createElement(
	            'span',
	            { style: { position: "absolute", top: "1.2vh", fontSize: '.96vh', color: textColor, right: "0.65104166666666666667vh" } },
	            'MENU'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: "2.5vh", marginLeft: '.3vh', marginTop: "0.5vh", width: "100%", height: "2vh" } },
	          _react2.default.createElement('img', { className: 'fliph', alt: 'back', style: { position: "absolute", width: '2vh', height: '1.2vh', marginLeft: "0.208333333vh", right: "1.04166666666666666667vh" }, src: icon })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuButtonMiami, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.mode === "video" ? _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left } },
	          this.renderBackButton()
	        ) : _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderBackButton()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MenuButtonMiami;
	}(_react.Component);
	
	exports.default = MenuButtonMiami;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavButtonMiami = __webpack_require__(154);
	
	var _NavButtonMiami2 = _interopRequireDefault(_NavButtonMiami);
	
	var _BackButtonMiami = __webpack_require__(61);
	
	var _BackButtonMiami2 = _interopRequireDefault(_BackButtonMiami);
	
	var _MiamiConstants = __webpack_require__(49);
	
	var _MiamiConstants2 = _interopRequireDefault(_MiamiConstants);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var MessageMiami = function (_Component) {
	  _inherits(MessageMiami, _Component);
	
	  function MessageMiami(props) {
	    _classCallCheck(this, MessageMiami);
	
	    var _this = _possibleConstructorReturn(this, (MessageMiami.__proto__ || Object.getPrototypeOf(MessageMiami)).call(this, props));
	
	    _this.getBackgroundImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	      if (_this.props.screensNumber === 2) {
	        defaultImg.file_name = 'default_double_screen.jpg';
	      }
	      var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      var rootFolder = _this.props.content.story_categories.find(function (folder) {
	        return folder.id === Number(rootFolderId);
	      });
	      _this._logo = _shared2.default.dp(_this.props.screen, _lodash2.default.get(rootFolder, 'contents.images[0]', null), null);
	      return _shared2.default.dp(_this.props.screen, _lodash2.default.get(_this.props.module, 'contents.images[1]', null), null);
	    };
	
	    _this.getSubscribeModule = function () {
	      var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      var rootFolder = _this.props.content.story_categories.find(function (folder) {
	        return folder.id === Number(rootFolderId);
	      });
	      var menu = _this.props.content.story_categories.find(function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return folder.parent_category === Number(rootFolderId) && type === "menu";
	      });
	      _this._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	      _this._backButton = (0, _shared.dp)(_this.props.screen, _lodash2.default.get(menu, 'contents.custom_fields.images[0]', null), null);
	      var subscribeModule = _this.props.content.story_categories.find(function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return folder.parent_category === Number(menu.id) && type === "be_the_change";
	      });
	      _this._subscribeModule = subscribeModule;
	    };
	
	    _this.renderBackButton = function () {
	      if (_this.props.mode === "story") {
	        return _react2.default.createElement(_BackButtonMiami2.default, {
	          colorPallette: _this._colorPallette,
	          backButton: _this._backButton,
	          unit: _this.props.screen.r9_16.p10,
	          width: '3.90625vh',
	          height: _MiamiConstants2.default.backButtonHeight,
	          top: _this.props.screen.screenHeight / 2 + _this.props.screen.r9_16.p10 * 1.15,
	          clickAction: _this.handleBack,
	          text: 'back',
	          mode: _this.props.mode });
	      } else {
	        return _react2.default.createElement(
	          _NavButtonMiami2.default,
	          { unit: _this.props.screen.r9_16.p10, width: _this.props.screen.r9_16.p10 * .7, height: _this.props.screen.r9_16.p10 * .7, clickAction: _this.handleBack, text: 'back', mode: _this.props.mode, left: '90%', top: '95%' },
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center', marginTop: _this.props.screen.r9_16.p10 * 0.041666667 } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: _this.props.screen.r9_16.p10 * .5, color: 'white', fontWeight: 'bold' } },
	              'X'
	            )
	          )
	        );
	      }
	    };
	
	    _this.redirect = function () {
	      if (_this._subscribeModule !== null && _this._subscribeModule !== undefined) {
	        _this.props.navRoute('/miami/subscribe', _this._subscribeModule);
	      }
	    };
	
	    _this._subscribeModule = null;
	    _this._backButton = null;
	    _this._colorPallette = null;
	    _this.getSubscribeModule();
	
	    _this._logo = null;
	    // this._story = _.find(this.props.module.stories, { contents: { custom_fields: { story_type: { val: "message" } } } });
	    _this._story = _lodash2.default.get(_this.props.module, 'children[0]', null);
	    return _this;
	  }
	
	  _createClass(MessageMiami, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setMenuBtn(2, 1, '/miami/nav');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var helpButton = "/img/miami/general/help_button.png";
	      var uiStrip = "/img/miami/general/rainbowuistrip.png";
	      if (this._colorPallette === "adaptive") {
	        helpButton = "/img/miami/general/help_button_green.png";
	        uiStrip = "/img/miami/general/rainbowuistrip_green.png";
	      }
	      var backgroundImage = this.getBackgroundImage();
	      var storyImage = _shared2.default.dp(this.props.screen, this._story.contents.images[0]);
	      // const storyImage = shared.presetDp("cfo", _.get(this._story, 'contents.images[0]', {path: '/img/ui/', file_name: 'image_default.png'}), this.props.screen);
	      var unit = this.props.screen.r9_16.p10;
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	      var subtitleRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(this._story, 'contents.custom_fields.subtitle.val.ops', _lodash2.default.get(this._story, 'contents.custom_fields.subtitle.default.ops', null)), {}).convert();
	      var bodyRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(this._story, 'contents.custom_fields.body.val.ops', _lodash2.default.get(this._story, 'contents.custom_fields.body.default.ops', null)), {}).convert();
	      var quoteRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(this._story, 'contents.custom_fields.quote.val.ops', _lodash2.default.get(this._story, 'contents.custom_fields.body.default.ops', null)), {}).convert();
	
	      return _react2.default.createElement(
	        'div',
	        { style: { height: this.props.screen.r9_16.height, width: '100%', backgroundSize: backgroundSize, backgroundImage: "url(" + backgroundImage + ")" } },
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	          _react2.default.createElement(
	            'div',
	            { style: { height: "26.979166667vh", position: "absolute", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" } },
	            _react2.default.createElement('img', { alt: 'Logo', src: this._logo, style: { display: 'block', margin: 'auto', width: '35vw' } })
	          ),
	          _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: unit * .25, top: "26.979166667vh" } }),
	          _react2.default.createElement('div', { style: { height: "2.29vh" } }),
	          _react2.default.createElement(
	            'div',
	            { style: { display: "flex", justifyContent: "center", fontFamily: "opensans-regular", position: "absolute", top: "29.5vh" } },
	            _react2.default.createElement(
	              'div',
	              { style: { color: "#4A4A4A", borderRadius: "3.125vh", backgroundColor: 'white', height: "58.333333333vh", maxHeight: "58.333333333vh", padding: "4.166666667vh", width: "70%", overflowY: "scroll" } },
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: "2.135416667vh", fontWeight: "bold", color: '#4A4A4A', fontFamily: "opensans-bold" } },
	                this._story.name
	              ),
	              _react2.default.createElement('div', { style: { height: "1.5vh" } }),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: "1.458333333vh" }, className: 'no-margin' },
	                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: subtitleRichText } })
	              ),
	              _react2.default.createElement('div', { style: { height: "1.5vh" } }),
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table", textAlign: "left", width: "100%", justifyContent: "center" } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: "table-row" } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: "table-cell", width: "65%" } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { lineHeight: "1.302083333vh", overflowY: "hidden", maxHeight: "47.0vh", color: "#404040", fontSize: "0.833333333vh" } },
	                      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: bodyRichText } })
	                    ),
	                    _react2.default.createElement('div', { style: { height: "4vh" } })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth / 2, left: this.props.screen.screenWidth / 2, position: "absolute", color: "#4A4A4A", top: "3.5vh" } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'center', width: '100%' } },
	            _react2.default.createElement(
	              'div',
	              { style: { backgroundColor: "white", borderRadius: "3.125vh", height: "91vh", paddingBottom: "2vh", width: "86%" } },
	              _react2.default.createElement('div', { style: { width: "100%", backgroundImage: "url(" + storyImage + ")", backgroundSize: "cover", height: "70vh", backgroundPosition: "center", borderTopRightRadius: "3.125vh", borderTopLeftRadius: "3.125vh" } }),
	              _react2.default.createElement(
	                'div',
	                { style: { display: "table", height: "21vh" } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: "table-cell", verticalAlign: "middle", paddingRight: "1%", paddingLeft: "3%", width: "52%" } },
	                  _react2.default.createElement('img', { alt: 'Stripe', style: { display: "block", margin: "auto", height: this.props.screen.screenHeight * .002, width: "85%" }, src: uiStrip }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'no-margin', style: { color: '#4A4A4A', paddingTop: "1.5625vh", paddingBottom: "1.5625vh", width: "85%", margin: "0 auto", textAlign: "center", lineHeight: "1.3020vh" } },
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: quoteRichText } })
	                  ),
	                  _react2.default.createElement('img', { alt: 'Stripe', style: { display: "block", margin: "auto", height: this.props.screen.screenHeight * .002, width: "85%" }, src: uiStrip })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: "table-cell", verticalAlign: "middle", paddingRight: "5%", paddingLeft: "3%", width: "36%" } },
	                  _react2.default.createElement('img', { alt: 'Be The Change', onClick: this.redirect, style: { backgroundColor: 'white', display: "block", margin: "auto", width: "80%", textAlign: "center" }, src: helpButton })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MessageMiami;
	}(_react.Component);
	
	exports.default = MessageMiami;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _display = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(5);
	
	var _SlideshowMiami = __webpack_require__(441);
	
	var _SlideshowMiami2 = _interopRequireDefault(_SlideshowMiami);
	
	var _StoryMiami = __webpack_require__(50);
	
	var _StoryMiami2 = _interopRequireDefault(_StoryMiami);
	
	var _StoriesSimpleMiami = __webpack_require__(443);
	
	var _StoriesSimpleMiami2 = _interopRequireDefault(_StoriesSimpleMiami);
	
	var _StoriesMiami = __webpack_require__(442);
	
	var _StoriesMiami2 = _interopRequireDefault(_StoriesMiami);
	
	var _MessageMiami = __webpack_require__(436);
	
	var _MessageMiami2 = _interopRequireDefault(_MessageMiami);
	
	var _NavMiami = __webpack_require__(440);
	
	var _NavMiami2 = _interopRequireDefault(_NavMiami);
	
	var _TimelineMiami = __webpack_require__(444);
	
	var _TimelineMiami2 = _interopRequireDefault(_TimelineMiami);
	
	var _MiamiRecognitionList = __webpack_require__(438);
	
	var _MiamiRecognitionList2 = _interopRequireDefault(_MiamiRecognitionList);
	
	var _UserInputMiami = __webpack_require__(446);
	
	var _UserInputMiami2 = _interopRequireDefault(_UserInputMiami);
	
	var _MenuButtonMiami = __webpack_require__(435);
	
	var _MenuButtonMiami2 = _interopRequireDefault(_MenuButtonMiami);
	
	var _MiamiConstants = __webpack_require__(49);
	
	var _MiamiConstants2 = _interopRequireDefault(_MiamiConstants);
	
	var _TouchGestureMiami = __webpack_require__(445);
	
	var _TouchGestureMiami2 = _interopRequireDefault(_TouchGestureMiami);
	
	var _TestMin = __webpack_require__(151);
	
	var _TestMin2 = _interopRequireDefault(_TestMin);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _IdleLoop = __webpack_require__(96);
	
	var _IdleLoop2 = _interopRequireDefault(_IdleLoop);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiamiContainer = function (_Component) {
	  _inherits(MiamiContainer, _Component);
	
	  function MiamiContainer(props) {
	    _classCallCheck(this, MiamiContainer);
	
	    var _this = _possibleConstructorReturn(this, (MiamiContainer.__proto__ || Object.getPrototypeOf(MiamiContainer)).call(this, props));
	
	    _this.startFadeInterval = function (status) {
	      var newStatus = !status;
	      if (newStatus) {
	        clearTimeout(_this._intervalFade);
	        _this._intervalFadeA = setTimeout(function () {
	          if (_this.state.idle === true) {
	            _this.setState({
	              showButton: newStatus
	            });
	            _this.animateStartButton(newStatus);
	            _this.startFadeInterval(newStatus);
	          }
	        }, 5000);
	      } else {
	        clearTimeout(_this._intervalFade);
	        _this._intervalFadeB = setTimeout(function () {
	          if (_this.state.idle === true) {
	            _this.animateStartButton(newStatus);
	            setTimeout(function () {
	              if (_this.state.idle === true) {
	                _this.setState({
	                  showButton: newStatus
	                });
	              }
	              _this.startFadeInterval(newStatus);
	            }, 2000);
	          }
	        }, 5000);
	      }
	    };
	
	    _this.animateStartButton = function (show) {
	      if (_this._startButtonRef) {
	        if (show) {
	          _this._startButtonRef.animate([{
	            transform: "scale(1)"
	          }, {
	            transform: "scale(1.25)"
	          }], {
	            fill: "forwards",
	            duration: 2000
	          });
	        } else {
	          _this._startButtonRef.animate([{
	            transform: "scale(1.25)"
	          }, {
	            transform: "scale(0.75)"
	          }], {
	            fill: "forwards",
	            duration: 2000
	          });
	        }
	      }
	    };
	
	    _this.handleSwipeAnimation = function (wrapperHeight, contentHeight) {
	      if (contentHeight > wrapperHeight && _this._isSwipeAnimationActive) {
	        clearTimeout(_this._swipeAnimationTimerHandler);
	        _this._swipeAnimationTimerHandler = setTimeout(function () {
	          var pathName = _this.props.location.pathname;
	          if (["/miami/nav/slideshow", "/miami/message", "/miami/nav"].indexOf(pathName) === -1) {
	            _this.setState({
	              showGesture: true
	            });
	          }
	          setTimeout(function () {
	            _this.setState({
	              showGesture: false
	            });
	          }, 3500);
	
	          if (_this._isSwipeAnimationActive) {
	            _this._swipeTimeout = 20000;
	            _this.handleSwipeAnimation(wrapperHeight, contentHeight);
	          }
	        }, _this._swipeTimeout);
	      } else {
	        clearTimeout(_this._swipeAnimationTimerHandler);
	      }
	    };
	
	    _this.activateSwipeAnimation = function () {
	      _this._isSwipeAnimationActive = true;
	      clearTimeout(_this._swipeAnimationTimerHandler);
	    };
	
	    _this.cancelSwipeAnimation = function () {
	      _this.setState({
	        showGesture: false
	      });
	      _this._isSwipeAnimationActive = false;
	      clearTimeout(_this._swipeAnimationTimerHandler);
	    };
	
	    _this.toggleShowNav = function (toggleOn) {
	      _this.setState({
	        showNavButton: toggleOn
	      });
	    };
	
	    _this.setMenuBtn = function (x, y, url) {
	      _this.setState({
	        xScreens: x,
	        yScreens: y,
	        menuUrl: url
	      });
	    };
	
	    _this.navRoute = function (route, module) {
	      _this.setState({
	        module: module
	      });
	      _this.props.history.replace(route);
	    };
	
	    _this.openNav = function () {
	      _this.setState({
	        showGesture: false
	      });
	      _this.props.history.replace(_this.state.menuUrl);
	    };
	
	    _this.getScreensNumber = function () {
	      try {
	        return _this.props.content.settings.display_blocks[0].screens.length;
	      } catch (e) {
	        return 1;
	      }
	    };
	
	    _this.goIdle = function (type) {
	      if (type === "recentInteraction") {
	        _this.setState({
	          recentInteraction: false
	        });
	      } else {
	        clearTimeout(_this._intervalFadeA);
	        clearTimeout(_this._intervalFadeB);
	        _this.setState({
	          idle: true,
	          showButton: true
	        });
	        _this.startFadeInterval(true);
	        setTimeout(function () {
	          return _this.animateStartButton(true);
	        }, 500);
	        _this._attractLoopFolder = _this.getAttractLoopFolder();
	        if (_this._attractLoopFolder !== undefined && _this._attractLoopFolder !== null) {
	          _this._attractLoopModules = _this.getAttractLoopFolderModules(_this._attractLoopFolder);
	          _this.cycleIdle();
	          // this.cycleIdleLoop();
	        }
	      }
	    };
	
	    _this.getAttractLoopFolder = function () {
	      var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      var attractLoopFolder = _this.props.content.story_categories.find(function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return type === "attract_loop" && folder.parent_category === Number(rootFolderId);
	      });
	      return attractLoopFolder;
	    };
	
	    _this.getAttractLoopFolderModules = function (attractLoopFolder) {
	      return _this.props.content.folder_modules.filter(function (fm) {
	        return fm.folder === attractLoopFolder.id;
	      }).map(function (fm) {
	        var displayModule = _this.props.content.dm_active.find(function (dm) {
	          return dm.id === fm.module_id;
	        });
	        displayModule.rank = fm.rank;
	        return displayModule;
	      }).sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	    };
	
	    _this.resume = function () {
	      _this._isSwipeAnimationActive = true;
	      if (_this.state.idle === true) {
	        clearTimeout(_this._idleLoopTimeout);
	        clearTimeout(_this._intervalFadeA);
	        clearTimeout(_this._intervalFadeB);
	        _this.setState({
	          idle: false,
	          showButton: false
	        });
	        _this.props.history.replace('/miami/nav');
	      }
	      if (_this.state.recentInteraction === false) {
	        _this.setState({
	          recentInteraction: true
	        });
	      }
	    };
	
	    _this.cycleIdle = function () {
	      _this.idleRef++;
	
	      if (_this.idleRef >= _this._attractLoopModules.length) {
	        _this.idleRef = 0;
	      }
	
	      var selectedModule = _this._attractLoopModules[_this.idleRef];
	      //const displayModuleType = this.props.content.display_module_types.find(dmt => dmt.id === selectedModule.display_module_type);
	      //console.log("before nav route", selectedModule);
	      _this.navRoute('/miami/nav/slideshow?id=' + selectedModule.id, selectedModule);
	    };
	
	    _this.cycleIdleLoop = function () {
	      clearTimeout(_this._idleLoopTimeout);
	      _this._idleLoopTimeout = setTimeout(function () {
	        _this.cycleIdle();
	        _this.cycleIdleLoop();
	      }, 2000);
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "s":
	          console.log(_this.props);
	          break;
	        case "n":
	          _this.openNav();
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.showNavButton = function (show) {
	      _this.setState({
	        showNavButton: show
	      });
	    };
	
	    _this._screensNumber = _this.getScreensNumber();
	    _this._idleLoopTimeout = null;
	    _this.idleRef = 0;
	    _this.state = {
	      idle: false,
	      xScreens: 1,
	      yScreens: 1,
	      menuUrl: '/miami/nav',
	      showNavButton: false,
	      module: null,
	      showGesture: false,
	      showButton: false
	    };
	    _this._attractLoopFolder = null;
	    _this._attractLoopModules = null;
	    _this._swipeAnimationTimerHandler = null;
	    _this._isSwipeAnimationActive = true;
	    _this._startButtonRef = null;
	    _this._swipeTimeout = 5000;
	    _this._intervalFadeA = null;
	    _this._intervalFadeB = null;
	    return _this;
	  }
	
	  _createClass(MiamiContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	
	      var key = this.props.location.pathname + this.props.location.search;
	      var rootFolderId = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	      var rootFolder = this.props.content.story_categories.find(function (folder) {
	        return folder.id === Number(rootFolderId);
	      });
	      var colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	      var className = this.props.content.font_class + " horizontal-screen-any";
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: { color: this.props.content.settings.main_font_color } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            { key: key, location: location },
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/nav/slideshow', render: function render(props) {
	                return _react2.default.createElement(_SlideshowMiami2.default, Object.assign({}, props, { module: _this2.state.module, idle: _this2.state.idle }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/nav', render: function render(props) {
	                return _react2.default.createElement(_NavMiami2.default, Object.assign({}, props, { toggleShowNav: _this2.toggleShowNav, navRoute: _this2.navRoute, content: _this2.props.content, screen: _this2.props.screen, screensNumber: _this2._screensNumber, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/message', render: function render(props) {
	                return _react2.default.createElement(_MessageMiami2.default, Object.assign({}, props, { content: _this2.props.content, module: _this2.state.module, toggleShowNav: _this2.toggleShowNav, navRoute: _this2.navRoute, screen: _this2.props.screen, setMenuBtn: _this2.setMenuBtn, screensNumber: _this2._screensNumber }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/story', render: function render(props) {
	                return _react2.default.createElement(_StoryMiami2.default, Object.assign({}, props, { backgroundEnabled: true, module: _this2.state.module, content: _this2.props.content, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/stories', render: function render(props) {
	                return _react2.default.createElement(_StoriesSimpleMiami2.default, Object.assign({}, props, { module: _this2.state.module, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/storypills', render: function render(props) {
	                return _react2.default.createElement(_StoriesMiami2.default, Object.assign({}, props, { module: _this2.state.module, navRoute: _this2.navRoute, screen: _this2.props.screen, mode: 'story', showNavButton: _this2.showNavButton, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/storiespictures', render: function render(props) {
	                return _react2.default.createElement(_StoriesSimpleMiami2.default, Object.assign({}, props, { module: _this2.state.module, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/videopills', render: function render(props) {
	                return _react2.default.createElement(_StoriesMiami2.default, Object.assign({}, props, { navRoute: _this2.navRoute, screen: _this2.props.screen, mode: 'video', showNavButton: _this2.showNavButton, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/timeline', render: function render(props) {
	                return _react2.default.createElement(_TimelineMiami2.default, Object.assign({}, props, { content: _this2.props.content, module: _this2.state.module, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/recognitionlist', render: function render(props) {
	                return _react2.default.createElement(_MiamiRecognitionList2.default, Object.assign({}, props, { module: _this2.state.module, content: _this2.props.content, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/subscribe', render: function render(props) {
	                return _react2.default.createElement(_UserInputMiami2.default, Object.assign({}, props, { navRoute: _this2.navRoute, content: _this2.props.content, module: _this2.state.module, screen: _this2.props.screen, screensNumber: _this2._screensNumber, handleSwipeAnimation: _this2.handleSwipeAnimation, cancelSwipeAnimation: _this2.cancelSwipeAnimation, activateSwipeAnimation: _this2.activateSwipeAnimation }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/miami/test', render: function render(props) {
	                return _react2.default.createElement(_TestMin2.default, Object.assign({}, props, { navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber }));
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showNavButton },
	            this.state.showNavButton && !this.state.idle ? _react2.default.createElement(_MenuButtonMiami2.default, {
	              unit: this.props.screen.r9_16.p10 / this.props.screensNumber,
	              width: '3.90625vh',
	              height: _MiamiConstants2.default.menuButtonHeight,
	              top: '50vh',
	              border: '0.84375vh',
	              clickAction: this.openNav,
	              text: 'menu',
	              colorPallette: colorPallette
	            }) : null
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 2000,
	            transitionLeaveTimeout: 2000 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showButton },
	            this.state.showButton ? _react2.default.createElement(
	              'div',
	              { ref: function ref(el) {
	                  return _this2._startButtonRef = el;
	                }, style: { position: "absolute", top: "43.356510416vh", width: this.props.screen.screenWidth / this._screensNumber, height: "5vh", textAlign: "center" } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "100%" } },
	                _react2.default.createElement('img', { style: { maxWidth: "12vh", maxHeight: "12vh" }, src: '/img/miami/ui/start.png', alt: '' })
	              )
	            ) : null
	          )
	        ),
	        this.props.idleActive === true ? _react2.default.createElement(_IdleLoop2.default, {
	          idle_delay: this.props.content.idle_delay,
	          goIdle: this.goIdle,
	          resume: this.resume
	        }) : null,
	        _react2.default.createElement(_TouchGestureMiami2.default, {
	          screen: this.props.screen,
	          regionWidth: this.props.screen.screenWidth / this._screensNumber,
	          regionHeight: this.props.screen.screenHeight,
	          contentX: 20,
	          contentY: 20,
	          show: this.state.showGesture
	        })
	      );
	    }
	  }]);
	
	  return MiamiContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var active_module = state.active_module;
	  var idle = _shared2.default.parseStringParam(window.location.href, "idle");
	  var namedmodule = _shared2.default.parseStringParam(window.location.href, "name");
	
	  var idleActive = true;
	  if (state.content.idle_delay === 0 || idle === "false") {
	    idleActive = false;
	  }
	
	  if (namedmodule) {
	    active_module = _lodash2.default.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
	  }
	
	  return {
	    active_module: active_module,
	    content: state.content,
	    contentHasErrored: state.contentHasErrored,
	    contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    donorsHasErrored: state.donorsHasErrored,
	    donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    options: state.options,
	    screensNumber: state.screensNumber,
	    idleActive: idleActive
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    switchModule: function switchModule(id) {
	      return dispatch((0, _display.switchModule)(id));
	    },
	    setOptions: function setOptions(data) {
	      return dispatch((0, _display.setOptions)(data));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MiamiContainer);

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _ScrollSpacer = __webpack_require__(63);
	
	var _ScrollSpacer2 = _interopRequireDefault(_ScrollSpacer);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _DonorFullPage = __webpack_require__(65);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	var _util = __webpack_require__(143);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _donorHelpers = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import donorDataCategories from '../../../test/donorDataCategories';
	
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var MiamiRecognitionList = function (_Component) {
	  _inherits(MiamiRecognitionList, _Component);
	
	  function MiamiRecognitionList(props) {
	    _classCallCheck(this, MiamiRecognitionList);
	
	    var _this = _possibleConstructorReturn(this, (MiamiRecognitionList.__proto__ || Object.getPrototypeOf(MiamiRecognitionList)).call(this, props));
	    //defaults
	
	
	    _initialiseProps.call(_this);
	
	    _this._subscribeModule = null;
	    _this._rowWrapperRef = null;
	    // this.getSubscribeModule();
	
	    _this._columns = 2;
	    _this._rows = 6;
	    _this._fontColor = "#ffffff";
	    _this._backdropColor = "#000000";
	    _this._footerText = "";
	    _this._parentCategoryName = ""; //used to stash name so state can switch to empty string
	    _this._ni_options = {};
	    _this._metaCycleTimeout = null;
	    _this._listCycleTime = 8000;
	    _this._marginRight = _this.props.screen.sv.width * 0.0375;
	    _this._fontClass = 'gfont_roboto';
	    _this._donorCategories = null;
	    _this._recognitionOptionsRef = null;
	
	    _this._donorGroups = _this.props.module.children;
	    var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	    var rootFolder = _this.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(rootFolderId);
	    });
	    _this._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	
	    _this.state = {
	      donorGroup: 0
	    };
	    return _this;
	  }
	
	  _createClass(MiamiRecognitionList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkSwipeAnimation();
	      this.getSubscribeModule();
	    }
	  }, {
	    key: 'switchDonorGroup',
	    value: function switchDonorGroup(groupRef) {
	      this.setState({
	        donorGroup: groupRef
	      });
	      this.iScroller.withIScroll(function (iScroll) {
	        iScroll.scrollTo(0, 0);
	      });
	      this._donorCategories = null;
	    }
	  }, {
	    key: 'renderGroupInputs',
	    value: function renderGroupInputs() {
	      var _this2 = this;
	
	      var optionsClass = "recognitionOptions";
	      if (this._colorPallette === "adaptive") {
	        optionsClass = "recognitionOptionsPrimary";
	      }
	
	      var recognitionOptionsLabel = {
	        width: this.props.screen.screenWidth * 0.222222222,
	        fontSize: this.props.screen.screenWidth * 0.016666667,
	        paddingTop: this.props.screen.screenHeight * 0.0078125,
	        paddingBottom: this.props.screen.screenHeight * 0.0078125,
	        paddingLeft: this.props.screen.screenWidth * 0.010416667,
	        paddingRight: this.props.screen.screenWidth * 0.010416667
	      };
	
	      switch (this._donorGroups.length) {
	        case 2:
	          return _react2.default.createElement(
	            'div',
	            { className: optionsClass, style: { left: this.state.recognitionOffsetX }, ref: function ref(recognitionOptionsRef) {
	                return _this2._recognitionOptionsRef = recognitionOptionsRef;
	              } },
	            _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(0);
	                }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[0].name
	            ),
	            _react2.default.createElement('input', { id: 'switch_right', name: 'donorOptions', type: 'radio', value: 'campaign_donors' }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(1);
	                }, htmlFor: 'switch_right', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[1].name
	            )
	          );
	        case 3:
	          return _react2.default.createElement(
	            'div',
	            { className: optionsClass, style: { left: this.state.recognitionOffsetX }, ref: function ref(recognitionOptionsRef) {
	                return _this2._recognitionOptionsRef = recognitionOptionsRef;
	              } },
	            _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(0);
	                }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[0].name
	            ),
	            _react2.default.createElement('input', { id: 'switch_middle', name: 'donorOptions', type: 'radio', value: 'middle_donors' }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(1);
	                }, htmlFor: 'switch_middle', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[1].name
	            ),
	            _react2.default.createElement('input', { id: 'switch_right', name: 'donorOptions', type: 'radio', value: 'campaign_donors' }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(2);
	                }, htmlFor: 'switch_right', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[2].name
	            )
	          );
	        case 4:
	          return _react2.default.createElement(
	            'div',
	            { className: optionsClass, style: { left: this.state.recognitionOffsetX }, ref: function ref(recognitionOptionsRef) {
	                return _this2._recognitionOptionsRef = recognitionOptionsRef;
	              } },
	            _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(0);
	                }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[0].name
	            ),
	            _react2.default.createElement('input', { id: 'switch_middle', name: 'donorOptions', type: 'radio', value: 'middle_donors' }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(1);
	                }, htmlFor: 'switch_middle', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[1].name
	            ),
	            _react2.default.createElement('input', { id: 'switch_middle1', name: 'donorOptions', type: 'radio', value: 'middle_donors' }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(2);
	                }, htmlFor: 'switch_middle1', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[2].name
	            ),
	            _react2.default.createElement('input', { id: 'switch_right', name: 'donorOptions', type: 'radio', value: 'campaign_donors' }),
	            _react2.default.createElement(
	              'label',
	              { onMouseDown: function onMouseDown() {
	                  return _this2.switchDonorGroup(3);
	                }, htmlFor: 'switch_right', style: Object.assign({}, recognitionOptionsLabel) },
	              this._donorGroups[3].name
	            )
	          );
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // return (<div/>)
	      var background = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	
	      if ((0, _util.isNull)(this._donorCategories)) {
	        this.renderCategories();
	      }
	      var unit = this.props.screen.r9_16.p10;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: "contain", backgroundImage: "url(" + background + ")" } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	            _react2.default.createElement('div', { style: { height: "5vw" } }),
	            _react2.default.createElement('img', { alt: 'Donor Recognition', src: iconImage, style: { width: '24vw' } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '6.3vw' } },
	            this.props.module.name.toUpperCase()
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center", paddingRight: "1vh", paddingLeft: "1vh" } },
	            this.props.module.description
	          ),
	          _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: unit * .25, top: "26.8518vh" } }),
	          _react2.default.createElement(
	            'div',
	            { style: { width: "100%", display: "flex", justifyContent: "center", marginTop: "3.25vh" } },
	            this.renderGroupInputs()
	          ),
	          _react2.default.createElement('div', { style: { height: "4.62962962962962962963vh" } }),
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this3._wrapperDiv = el;
	              }, style: { display: 'block', color: 'black', width: '85%', height: '73%', marginLeft: "auto", marginRight: "auto", touchAction: "none" } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this3.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                onScrollStart: this.handleScrollStart,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.005,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                },
	                onRefresh: this.initializeIScroll
	              },
	              _react2.default.createElement(
	                _CSSTransitionGroup2.default,
	                {
	                  component: 'div',
	                  transitionName: 'example',
	                  transitionEnterTimeout: 0,
	                  transitionLeaveTimeout: 0 },
	                _react2.default.createElement(
	                  'div',
	                  { ref: function ref(el) {
	                      return _this3._innerDivRef = el;
	                    }, key: this.state.donorGroup },
	                  _react2.default.createElement('div', { style: { height: "2.5vh" } }),
	                  this._donorCategories,
	                  _react2.default.createElement(_ScrollSpacer2.default, { unit: unit })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MiamiRecognitionList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.checkSwipeAnimation = function () {
	    var wrapperHeight = _this4._wrapperDiv.getBoundingClientRect().height;
	    var contentHeight = _this4._innerDivRef.getBoundingClientRect().height;
	
	    _this4.props.handleSwipeAnimation(wrapperHeight, contentHeight);
	  };
	
	  this.handleScrollStart = function () {
	    _this4.props.cancelSwipeAnimation();
	  };
	
	  this.beTheChange = function (obj) {
	    var learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
	    if (_this4._colorPallette === "adaptive") {
	      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
	    }
	    return _react2.default.createElement(
	      'div',
	      { key: 'be the change', style: { marginTop: '7vw', marginBottom: '5vw', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch', width: "44.2708vh", marginRight: "auto", marginLeft: "auto" }, onClick: _this4.redirect },
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: '3.5vw', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-semibold", color: '#ffffff', width: '150vw' } },
	        'Be the Change',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { style: { fontSize: '2.2vw', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' } },
	          'Help make a difference by becoming a donor.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right', width: '100%' }, onClick: _this4.redirect },
	        _react2.default.createElement('img', { ref: function ref(el) {
	            return _this4._rowWrapperRef = el;
	          }, alt: 'Story', src: learnMoreButton, style: { width: '23vw' } })
	      )
	    );
	  };
	
	  this.getBackgroundImage = function () {
	    var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	
	    if (_this4.props.screensNumber === 2) {
	      defaultImg.file_name = 'default_double_screen.jpg';
	    }
	    return (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, 'contents.images[2]', null), defaultImg);
	  };
	
	  this.getIconImage = function () {
	    return (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, 'contents.images[1]', null), null);
	  };
	
	  this.getSubscribeModule = function () {
	    var rootFolderId = _lodash2.default.get(_this4.props.content, 'settings.selected_root_folder', null);
	    var menu = _this4.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	      return folder.parent_category === Number(rootFolderId) && type === "menu";
	    });
	    var rootFolder = _this4.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(rootFolderId);
	    });
	    _this4._arrowIcon = (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(menu, 'contents.images[0]', null), null);
	    _this4._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	    var subscribeModule = _this4.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	      return folder.parent_category === Number(menu.id) && type === "be_the_change";
	    });
	    _this4._subscribeModule = subscribeModule;
	  };
	
	  this.renderCategories = function () {
	    if ((0, _util.isNull)(_this4._donorCategories)) {
	      var categoryWrapStyle = {
	        boxSizing: 'border-box',
	        width: _this4.props.screen.screenWidth * 0.78838174273858921162,
	        background: "white",
	        // height: this.props.screen.r9_16.height * .5,
	        paddingBottom: _this4.props.screen.screenHeight * 0.01875,
	        paddingTop: _this4.props.screen.screenHeight * 0.02893518518518518519,
	        borderRadius: 10,
	        paddingLeft: _this4.props.screen.screenWidth * 0.074074074,
	        paddingRight: _this4.props.screen.screenWidth * 0.074074074,
	        marginBottom: _this4.props.screen.screenHeight * 0.03125
	      };
	      console.log(_this4._donorGroups[_this4.state.donorGroup]);
	      var descriptionRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(_this4._donorGroups[_this4.state.donorGroup], 'contents.custom_fields.description.val.ops', _lodash2.default.get(_this4._donorGroups[_this4.state.donorGroup], 'contents.custom_fields.description.default.ops', null)), {}).convert();
	
	      _this4._donorCategories = _this4._donorGroups[_this4.state.donorGroup].children.map(function (row, i) {
	        var donors = (0, _donorHelpers.getDonorsFromFolder)(this.props.donors, this.props.content.folder_modules, row.id);
	        var orderedDonors = _lodash2.default.orderBy(donors, ['sorting_name', 'asc']);
	        var donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - this.props.screen.screenWidth * 0.074074074 * 2;
	        var beTheChange = this.beTheChange({ width: donorFullPageWidth });
	        var hideTitle = _lodash2.default.get(row, 'contents.custom_fields.hide_title.val', false);
	
	        var donorList = _react2.default.createElement(
	          'div',
	          { key: i, style: { display: "flex", alignItems: "center", justifyContent: "center" } },
	          _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, categoryWrapStyle), className: 'opensans-regular' },
	            i === 0 ? _react2.default.createElement('div', { style: { lineHeight: "1.5625vh", paddingRight: this.props.screen.screenHeight * .01562, paddingLeft: this.props.screen.screenHeight * .01562 }, dangerouslySetInnerHTML: { __html: descriptionRichText } }) : null,
	            hideTitle !== true ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h1',
	                { style: { paddingRight: this.props.screen.screenHeight * .01562, paddingLeft: this.props.screen.screenHeight * .01562, fontSize: this.props.screen.screenHeight * 0.021875 } },
	                row.name
	              )
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_DonorFullPage2.default, {
	                height: this.props.screen.screenHeight * 0.115,
	                width: donorFullPageWidth,
	                columns: this._columns,
	                rows: this._rows,
	                fontClass: this._fontclass,
	                donorData: orderedDonors,
	                screen: this.props.screen,
	                sort: 'column',
	                overrideFontSize: 0,
	                overridePadding: this.props.screen.screenHeight * .01562,
	                overrideMarginRight: 0,
	                custom1x2: '<span />' })
	            )
	          )
	        );
	
	        if (i === 1) {
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            beTheChange,
	            donorList
	          );
	        }
	
	        return donorList;
	      }, _this4);
	    }
	  };
	
	  this.redirect = function () {
	    if (_this4._subscribeModule !== null && _this4._subscribeModule !== undefined) {
	      _this4.props.navRoute('/miami/subscribe', _this4._subscribeModule);
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  return {
	    content: state.content,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(MiamiRecognitionList);

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBlockMiami = function (_Component) {
	  _inherits(NavBlockMiami, _Component);
	
	  function NavBlockMiami() {
	    _classCallCheck(this, NavBlockMiami);
	
	    return _possibleConstructorReturn(this, (NavBlockMiami.__proto__ || Object.getPrototypeOf(NavBlockMiami)).apply(this, arguments));
	  }
	
	  _createClass(NavBlockMiami, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', justifyContent: 'center', width: '100%' } },
	        _react2.default.createElement(
	          'div',
	          { style: { width: '78%', height: '15%', minHeight: '15%', borderRadius: '1vh', backgroundColor: 'white', padding: '3.72%' } },
	          _react2.default.createElement(
	            'div',
	            { style: { color: 'black', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around' } },
	            _react2.default.createElement(
	              'div',
	              { style: { width: '26%', height: '18.72%' } },
	              _react2.default.createElement('img', { alt: 'Donor Stories', src: this.props.icon, style: { display: 'block', margin: 'auto', marginLeft: "-1.822916667vh", height: "7.291666667vh" } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: "54%" } },
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: this.props.containerWidth * 0.037222222, textAlign: "left", fontFamily: "opensans-bold", color: '#404040', float: "left" } },
	                this.props.title,
	                _react2.default.createElement('div', { style: { height: "0.5vh" } }),
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: "block", fontSize: this.props.containerWidth * 0.025, color: '#404040', lineHeight: '1.5vh', textAlign: "left", fontFamily: "opensans-regular" } },
	                  this.props.description
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: "7%" } },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('img', { alt: 'Forward', src: this.props.arrow, style: { display: 'block', margin: 'auto', width: this.props.containerWidth * 0.059990741, float: "left" } })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavBlockMiami;
	}(_react.Component);
	
	exports.default = NavBlockMiami;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavBlockMiami = __webpack_require__(439);
	
	var _NavBlockMiami2 = _interopRequireDefault(_NavBlockMiami);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavMiami = function (_Component) {
	  _inherits(NavMiami, _Component);
	
	  function NavMiami(props) {
	    _classCallCheck(this, NavMiami);
	
	    var _this = _possibleConstructorReturn(this, (NavMiami.__proto__ || Object.getPrototypeOf(NavMiami)).call(this, props));
	
	    _this.handleNav = function (route) {
	      _this.props.navRoute(route.navLocation, route.module);
	    };
	
	    _this.initializeNavRefs = function () {
	      if (_this.state.initializedRefs === false) {
	        var _loop = function _loop(a) {
	          _this.navRefs[a].el.addEventListener("tap", function () {
	            return _this.handleNav(_this.navRefs[a].data);
	          });
	        };
	
	        for (var a = 0; a < _this.navRefs.length; a++) {
	          _loop(a);
	        }
	        _this.setState({
	          initializedRefs: true
	        });
	      }
	    };
	
	    _this.initializeAssets = function () {
	      var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      if (rootFolderId !== null && rootFolderId !== undefined) {
	        rootFolderId = Number(rootFolderId);
	      }
	      var rootFolder = _this.props.content.story_categories.find(function (folder) {
	        return folder.id === rootFolderId;
	      });
	      var menu = _this.props.content.story_categories.find(function (folder) {
	        var folderType = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return folder.parent_category === rootFolderId && folderType === "menu";
	      });
	
	      if (menu) {
	        var navTree = (0, _shared.createFolderTree)(_this.props.content.story_categories, _this.props.content.folder_modules, null, _this.props.content.stories, _this.props.content.dm_active, menu.id, 'sorting_name');
	        _this.setState({
	          navTree: navTree
	        });
	      }
	
	      _this._arrow = (0, _shared.dp)(_this.props.screen, _lodash2.default.get(menu, 'contents.images[0]', null));
	      _this._logo = (0, _shared.dp)(_this.props.screen, _lodash2.default.get(rootFolder, 'contents.images[0]', null));
	      _this._background = (0, _shared.dp)(_this.props.screen, _lodash2.default.get(rootFolder, 'contents.images[1]', null));
	    };
	
	    _this._background = null;
	    _this._arrow = null;
	    _this._logo = null;
	
	    _this.state = {
	      initializedRefs: false,
	      navTree: null
	    };
	    _this.navRefs = [];
	    return _this;
	  }
	
	  _createClass(NavMiami, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initializeAssets();
	      this.props.toggleShowNav(false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var _loop2 = function _loop2(a) {
	        if (_this2.navRefs[a].el) {
	          _this2.navRefs[a].el.removeEventListener("tap", function () {
	            return _this2.handleNav(_this2.navRefs[a].data);
	          });
	        }
	      };
	
	      for (var a = 0; a < this.navRefs.length; a++) {
	        _loop2(a);
	      }
	      this.props.toggleShowNav(true);
	    }
	  }, {
	    key: 'prepareMenuNavigation',
	    value: function prepareMenuNavigation() {
	      var _this3 = this;
	
	      if (!this.state.navTree) {
	        return null;
	      }
	      var location = [];
	      return this.state.navTree.children.map(function (row, i) {
	        var type = _lodash2.default.get(row, 'contents.custom_fields.folder_type.val.value', null);
	        row.modalEnabled = false;
	        switch (type) {
	          case "message_cfo":
	            location[i] = "/miami/message";
	            break;
	          case "donor_stories_text_block_picture":
	            location[i] = "/miami/storiespictures";
	            row.modalEnabled = true;
	            break;
	          case "donor_stories_text_block":
	            location[i] = "/miami/stories";
	            break;
	          case "donor_stories_pill":
	            location[i] = "/miami/storypills";
	            row.modalEnabled = true;
	            row.isGrouped = false;
	            break;
	          case "videos":
	            location[i] = "/miami/storypills";
	            row.modalEnabled = true;
	            row.isGrouped = false;
	            break;
	          case "timeline":
	            location[i] = "/miami/timeline";
	            break;
	          case "be_the_change":
	            location[i] = "/miami/subscribe";
	            break;
	          case "search":
	            location[i] = "/miami/subscribe";
	            break;
	          case "donor_lists_wrapper":
	            location[i] = "/miami/recognitionlist";
	            break;
	          default:
	            break;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: i },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this3.navRefs[i] = { el: el, data: { navLocation: location[i], module: row } };
	              } },
	            _react2.default.createElement(_NavBlockMiami2.default, {
	              handleNav: _this3.handleNav,
	              title: row.name,
	              description: row.description,
	              screen: _this3.props.screen,
	              containerWidth: _this3.props.screen.screenWidth / _this3.props.screensNumber,
	              icon: (0, _shared.dp)(_this3.props.screen, _lodash2.default.get(row, 'contents.images[0]', null)),
	              arrow: _this3._arrow })
	          ),
	          _react2.default.createElement('div', { style: { height: '0.7vh' } })
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	      return _react2.default.createElement(
	        'div',
	        { style: { height: this.props.screen.r9_16.height, textAlign: 'center', width: '100%', backgroundSize: backgroundSize, backgroundImage: "url(" + this._background + ")" } },
	        _react2.default.createElement('div', { style: { height: '5vh' } }),
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth / this.props.screensNumber } },
	          _react2.default.createElement('img', { alt: 'Logo', src: this._logo, style: { display: 'block', margin: 'auto', width: '39vh' } }),
	          _react2.default.createElement('div', { style: { height: '4vh' } }),
	          _react2.default.createElement(
	            'div',
	            { style: { width: this.props.screen.screenWidth, height: '100vh', touchAction: "none" } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this4.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.005,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                },
	                onScrollStart: this.onScrollStart,
	                onRefresh: this.initializeNavRefs
	              },
	              _react2.default.createElement(
	                'div',
	                { style: { width: this.props.screen.screenWidth / this.props.screensNumber } },
	                this.prepareMenuNavigation()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavMiami;
	}(_react.Component);
	
	exports.default = NavMiami;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _ReactPlayerWrapper = __webpack_require__(88);
	
	var _ReactPlayerWrapper2 = _interopRequireDefault(_ReactPlayerWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ReactPlayer from 'react-player';
	
	var SlideshowMiami = function (_Component) {
	  _inherits(SlideshowMiami, _Component);
	
	  function SlideshowMiami(props) {
	    _classCallCheck(this, SlideshowMiami);
	
	    var _this = _possibleConstructorReturn(this, (SlideshowMiami.__proto__ || Object.getPrototypeOf(SlideshowMiami)).call(this, props));
	
	    _this.handleKeyDown = function (e) {
	      switch (e.keyCode) {
	        // Left Arrow (Previous)
	        // case 37:
	        //   this.clearCycleTimeout();
	        //   this.prevSlide();
	        //   break;
	        // Right Arrow (Next)
	        // case 39:
	        //   this.clearCycleTimeout();
	        //   this.nextSlide();
	        //   break;
	        // Space (Pause)
	        case 32:
	          _this.clearCycleTimeout();
	          var fileType = (0, _fileHelpers.getFileType)(_this.state.module.contents.images[_this.state.activeSlide].file_name);
	          if (fileType !== "Image") {
	            // this._paused = !this._paused;
	            // this.toggleVideoReproduction(this._paused);
	          }
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.clearCycleTimeout = function () {
	      clearTimeout(_this._cycleTimeout);
	      _this._cycleTimeout = null;
	    };
	
	    _this.slidesChanged = function () {
	      var timeout = 5000;
	      var hScreens = _this.props.module.contents.hScreens;
	      var vScreens = _this.props.module.contents.vScreens;
	      if (hScreens && Number(hScreens) !== 0) {
	        hScreens = Number(hScreens);
	      } else {
	        hScreens = 1;
	      }
	      if (vScreens && Number(vScreens) !== 0) {
	        vScreens = Number(vScreens);
	      } else {
	        vScreens = 1;
	      }
	
	      _this._nextGroup = [];
	
	      // default to all slides clone array
	      var slidePool = _this.props.module.contents.images.slice(0);
	      if (_this.props.module.contents.bool0s) {
	        // clear slidePool to use active inactive bools
	        slidePool = [];
	        // push active slides into pool
	        _this.props.module.contents.images.forEach(function (image, index) {
	          if (_this.props.module.contents.bool0s && _this.props.module.contents.bool0s[index] === true) {
	            slidePool.push(image);
	          }
	        });
	      }
	
	      _this._totalElements = slidePool.length;
	
	      var returnModule = _lodash2.default.cloneDeep(_this.props.module);
	      returnModule.contents.images = slidePool;
	
	      var totalImagesNeeded = hScreens * vScreens;
	
	      if (totalImagesNeeded > slidePool.length) {
	        return null;
	      }
	
	      var index = 0;
	
	      var imageHeight = _this.props.screen.screenHeight / vScreens;
	      var imageWidth = _this.props.screen.screenWidth / hScreens;
	
	      for (var i = 0; i < totalImagesNeeded; i++) {
	        index = (i + _this._lastTakenSlideIndex + 1) % _this._totalElements;
	
	        var imageStyle = {
	          top: Math.floor(i / hScreens) * imageHeight,
	          left: i % hScreens * imageWidth,
	          maxHeight: imageHeight,
	          maxWidth: imageWidth
	          // width: imageHeight,
	          // height: imageWidth
	        };
	
	        _this._nextGroup.push({
	          index: index,
	          style: imageStyle
	        });
	
	        if (i === totalImagesNeeded - 1) {
	          if (_this._cycleOverrides[index]) {
	            timeout = _this._cycleOverrides[index] * 1000;
	          }
	          _this._lastTakenSlideIndex = index;
	        }
	      }
	
	      _this.clearCycleTimeout();
	      _this._cycleTimeout = setTimeout(function () {
	        _this.slidesChanged();
	      }, timeout);
	
	      _this.setState({
	        group: _this._nextGroup,
	        module: returnModule,
	        lastTakenSlideIndex: _this._lastTakenSlideIndex
	      });
	    };
	
	    _this.getSlides = function () {
	
	      var volume = 1;
	
	      if (_this.props.idle) {
	        volume = 0;
	      }
	      return _this._nextGroup.map(function (slide, row) {
	        var fileType = (0, _fileHelpers.getFileType)(_this.state.module.contents.images[slide.index].file_name);
	        if (fileType === "Image") {
	          return _react2.default.createElement('img', { key: row, alt: 'Slide', onMouseDown: _this.preventDrag, className: 'nodrag', style: slide.style, src: _shared2.default.dp(_this.props.screen, _this.state.module.contents.images[slide.index]) });
	        } else {
	          return _react2.default.createElement(_ReactPlayerWrapper2.default, {
	            playing: !_this._paused,
	            handleVideoDuration: _this.handleVideoDuration,
	            volume: volume,
	            onEnded: _this.videoEnded,
	            key: slide.index,
	            url: _shared2.default.dp(_this.props.screen, _this.state.module.contents.images[slide.index]),
	            width: _this.props.screen.screenWidth,
	            height: _this.props.screen.screenHeight
	          });
	        }
	      });
	    };
	
	    _this._totalElements = _this.props.module.contents.images.length;
	    _this._cycleOverrides = _this.props.module.contents.cycle_overrides;
	    _this._currentDuration = 0;
	    _this._startSlideTime = 0;
	    _this._lastTakenSlideIndex = -1;
	    _this._nextGroup = [];
	    _this._paused = false;
	    _this.state = {
	      videoVolumes: Array.from(Array(_this.props.module.contents.images.length), function () {
	        return 0;
	      }),
	      module: _this.props.module
	    };
	    return _this;
	  }
	
	  _createClass(SlideshowMiami, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _shared2.default.checkData(this.props.module);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.slidesChanged();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearCycleTimeout();
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, pointerEvents: "none" }, className: 'nodrag' },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.lastTakenSlideIndex, style: { position: 'absolute', left: 0, top: 0 } },
	            this.getSlides()
	          )
	        )
	      );
	    }
	  }]);
	
	  return SlideshowMiami;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(SlideshowMiami);

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _InfoBlockMiami = __webpack_require__(62);
	
	var _InfoBlockMiami2 = _interopRequireDefault(_InfoBlockMiami);
	
	var _StoryMiami = __webpack_require__(50);
	
	var _StoryMiami2 = _interopRequireDefault(_StoryMiami);
	
	var _RowButtonMiami = __webpack_require__(155);
	
	var _RowButtonMiami2 = _interopRequireDefault(_RowButtonMiami);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _NavButtonMiami = __webpack_require__(154);
	
	var _NavButtonMiami2 = _interopRequireDefault(_NavButtonMiami);
	
	var _BackButtonMiami = __webpack_require__(61);
	
	var _BackButtonMiami2 = _interopRequireDefault(_BackButtonMiami);
	
	var _MiamiConstants = __webpack_require__(49);
	
	var _MiamiConstants2 = _interopRequireDefault(_MiamiConstants);
	
	var _ScrollSpacer = __webpack_require__(63);
	
	var _ScrollSpacer2 = _interopRequireDefault(_ScrollSpacer);
	
	var _VideoMiami = __webpack_require__(447);
	
	var _VideoMiami2 = _interopRequireDefault(_VideoMiami);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _reactMoment = __webpack_require__(335);
	
	var _reactMoment2 = _interopRequireDefault(_reactMoment);
	
	var _shared2 = __webpack_require__(4);
	
	var _shared3 = _interopRequireDefault(_shared2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoriesMiami = function (_Component) {
	  _inherits(StoriesMiami, _Component);
	
	  function StoriesMiami(props) {
	    _classCallCheck(this, StoriesMiami);
	
	    var _this = _possibleConstructorReturn(this, (StoriesMiami.__proto__ || Object.getPrototypeOf(StoriesMiami)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      showModal: false,
	      iScrollInitialized: false,
	      story: null
	    };
	
	    var type = _lodash2.default.get(_this.props.module.contents, 'custom_fields.folder_type.val.value', null);
	    _this._model = type;
	    if (type === "videos") {
	      _this._mode = "video";
	    }
	
	    // this._mode = this.props.module.contents.custom_fields.stories_type.val;
	    _this._modalTimeout = null;
	
	    _this._subscribeModule = null;
	    _this._rowWrapper = null;
	    _this._arrowIcon = null;
	    _this._colorPallette = null;
	
	    _this.getSubscribeModule();
	
	    // this._dataContent = _.filter(this.props.content.stories, { folder: Number(this.props.module.contents.story_category) })
	
	    _this._dataContent = _lodash2.default.orderBy(_this.props.module.children, function (story) {
	      return story.sorting_name.toLowerCase();
	    });
	
	    for (var i = 0; i < _this._dataContent.length; i++) {
	      _this._dataContent[i].index = i;
	    }
	
	    _this.storyRefs = [];
	    return _this;
	  }
	
	  _createClass(StoriesMiami, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkSwipeAnimation();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var _loop = function _loop(i) {
	        _this2.storyRefs[i].removeEventListener("tap", function () {
	          return _this2.handleTap(i);
	        });
	      };
	
	      for (var i = 0; i < this.storyRefs.length; i++) {
	        _loop(i);
	      }
	      clearTimeout(this._modalTimeout);
	      this._modalTimeout = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // return null;
	      var unit = this.props.screen.r9_16.p10 * .25;
	      var backgroundImage = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
	      var modalStyle = {
	        position: "absolute",
	        width: this.props.screen.screenWidth / this.props.screensNumber,
	        left: this.props.screensNumber === 1 ? 0 : this.props.screen.screenWidth / this.props.screensNumber
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	              _react2.default.createElement(
	                'div',
	                { style: { position: "absolute", display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	                _react2.default.createElement('div', { style: { height: "4vh" } }),
	                _react2.default.createElement('img', { alt: this.props.module.name, src: iconImage, style: { width: '16vh' } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { position: "absolute", top: "16vh", fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '3.6vh', width: "100%", overflow: "hidden" } },
	                this.props.module.name.toUpperCase()
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { width: "100%", position: "absolute", top: "21vh", display: "flex", justifyContent: "center", overflow: "hidden", minHeight: "2.6041666666666666666vh", maxHeight: "5.20833333333333333333vh" } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center", width: "85%" } },
	                  this.props.module.description
	                )
	              ),
	              _react2.default.createElement('div', { style: { height: '4.8109375vh' } }),
	              _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: "2.8125vh", top: "26.979166667vh" } }),
	              _react2.default.createElement(
	                'div',
	                { style: { width: "100%", display: "flex", justifyContent: "center" } },
	                _react2.default.createElement(
	                  'div',
	                  { ref: function ref(el) {
	                      return _this3._wrapperDiv = el;
	                    }, style: { position: "absolute", top: "28.64583333333333333333vh", color: 'black', width: '85%', height: "73vh", display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "-1.6875vh", touchAction: "none" } },
	                  _react2.default.createElement(
	                    _reactIscroll2.default,
	                    { ref: function ref(el) {
	                        return _this3.iScroller = el;
	                      }, iScroll: _iscroll2.default,
	                      onScrollStart: this.handleScrollStart,
	                      options: {
	                        mouseWheel: true,
	                        scrollbars: false,
	                        scrollX: false,
	                        scrollY: true,
	                        probeType: 2,
	                        bounce: false,
	                        momentum: true,
	                        deceleration: 0.005,
	                        useTransition: true,
	                        disableTouch: false,
	                        disablePointer: false,
	                        disableMouse: false,
	                        tap: true
	                      },
	                      onRefresh: this.initializeIScroll
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      { ref: function ref(el) {
	                          return _this3._innerDivRef = el;
	                        } },
	                      _react2.default.createElement('div', { style: { height: "3.5vh" } }),
	                      this.props.module.isGrouped ? this.renderGroupedStories() : this.renderStories(),
	                      _react2.default.createElement(_ScrollSpacer2.default, { unit: unit })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, modalStyle) },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'containerFade',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showModal },
	              this.state.showModal ? this.getModalContent() : null,
	              this.state.showModal ? this.renderBackButton() : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoriesMiami;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.initializeIScroll = function () {
	    if (_this4.state.iScrollInitialized === false) {
	      var _loop2 = function _loop2(i) {
	        _this4.storyRefs[i].addEventListener("tap", function () {
	          return _this4.handleTap(i);
	        });
	      };
	
	      for (var i = 0; i < _this4.storyRefs.length; i++) {
	        _loop2(i);
	      }
	
	      _this4.setState({
	        iScrollInitialized: true
	      });
	    }
	  };
	
	  this.checkSwipeAnimation = function () {
	    var wrapperHeight = _this4._wrapperDiv.getBoundingClientRect().height;
	    var contentHeight = _this4._innerDivRef.getBoundingClientRect().height;
	    if (_this4._dataContent.length > 12) {
	      _this4.props.handleSwipeAnimation(wrapperHeight, contentHeight);
	    }
	  };
	
	  this.handleScrollStart = function () {
	    _this4.props.cancelSwipeAnimation();
	  };
	
	  this.handleTap = function (index) {
	    _this4.props.cancelSwipeAnimation();
	    if (_this4._mode === "video") {
	      if (_this4.props.screensNumber <= 1) {
	        _this4.props.showNavButton(false);
	      }
	      _this4.setState({
	        contentIndex: index,
	        content: _this4._dataContent[index],
	        showModal: true
	      });
	    } else {
	      if (_this4.state.showModal) {
	        _this4.setState({
	          showModal: false
	        });
	
	        clearTimeout(_this4._modalTimeout);
	        _this4._modalTimeout = null;
	        _this4._modalTimeout = setTimeout(function () {
	          _this4.setState({
	            contentIndex: index,
	            content: _this4._dataContent[index],
	            showModal: true
	          });
	        }, 500);
	      } else {
	        _this4.setState({
	          contentIndex: index,
	          content: _this4._dataContent[index],
	          showModal: true
	        });
	      }
	    }
	  };
	
	  this.handleNext = function () {
	    var nextIndex = _shared3.default.loopIndex(_this4.state.contentIndex, 0, _this4._dataContent.length - 1, 'forward');
	    _this4.setState({
	      contentIndex: nextIndex,
	      content: _this4._dataContent[nextIndex],
	      showModal: true
	    });
	  };
	
	  this.handlePrevious = function () {
	    var previousIndex = _shared3.default.loopIndex(_this4.state.contentIndex, 0, _this4._dataContent.length - 1, 'backward');
	    _this4.setState({
	      contentIndex: previousIndex,
	      content: _this4._dataContent[previousIndex],
	      showModal: true
	    });
	  };
	
	  this.handleBack = function () {
	    _this4.props.showNavButton(true);
	    _this4.setState({
	      showModal: false
	    });
	  };
	
	  this.renderStories = function () {
	    var learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
	    if (_this4._colorPallette === "adaptive") {
	      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
	    }
	    var storySets = [];
	    var setCount = 0;
	    for (var i = 0; i < _this4._dataContent.length; i++) {
	      if (!storySets[setCount]) {
	        storySets[setCount] = [];
	      }
	      storySets[setCount].push(_this4._dataContent[i]);
	      if ((i + 1) % 3 === 0 && i !== 0) {
	        setCount++;
	      }
	      if (i === 2) {
	        storySets[setCount++] = []; //empty entry for spacer row
	      }
	    }
	    var renderedStorySets = storySets.map(function (row, i) {
	      if (i === 1) {
	        return _react2.default.createElement(
	          'div',
	          { key: i },
	          _react2.default.createElement(_RowButtonMiami2.default, {
	            buttonEvent: _this4.redirect,
	            header: 'Be the Change',
	            message: 'Help make a difference by becoming a donor.',
	            button: learnMoreButton
	          })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { key: i },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: _this4.props.screen.r9_16.p10 * .17, display: 'flex', alignItems: 'flex-start' } },
	          _this4.renderRow(row, i)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          storySets.length <= 1 ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_RowButtonMiami2.default, {
	              buttonEvent: _this4.redirect,
	              header: 'Get Involved',
	              message: 'Learn about the many ways you can help.',
	              button: learnMoreButton
	            })
	          ) : null
	        )
	      );
	    });
	
	    return renderedStorySets;
	  };
	
	  this.renderGroupedStories = function () {
	    // First get common dates 
	    var groupedStories = (0, _lodash2.default)(_this4._dataContent).groupBy(function (x) {
	      return x.contents.custom_fields.group_by.val;
	    }).map(function (value, key) {
	      return { group_by: key, stories: value };
	    }).orderBy(function (y) {
	      return y.group_by;
	    }, ['desc']).value();
	
	    var rowButtonMiamiInserted = false;
	
	    return groupedStories.map(function (group, groupIndex) {
	      var storySets = [];
	      var setCount = 0;
	
	      for (var i = 0; i < group.stories.length; i++) {
	        if (!storySets[setCount]) {
	          storySets[setCount] = [];
	        }
	        storySets[setCount].push(group.stories[i]);
	        if ((i + 1) % 3 === 0 && i !== 0) {
	          setCount++;
	        }
	        if (i === 2) {
	          storySets[setCount++] = []; //empty entry for spacer row
	        }
	      }
	
	      var header = _react2.default.createElement(
	        'div',
	        { style: { marginLeft: "auto", marginRight: "auto", width: "100%" } },
	        _react2.default.createElement(
	          'span',
	          { style: { color: "white", fontWeight: "bold", fontSize: "1.35vh", width: "100%" } },
	          _react2.default.createElement(
	            _reactMoment2.default,
	            { format: 'MMMM YYYY' },
	            group.group_by
	          )
	        ),
	        _react2.default.createElement('hr', { style: { backgroundColor: "white" } })
	      );
	
	      var renderedStorySets = storySets.map(function (row, i) {
	        if (i === 1 && rowButtonMiamiInserted === false) {
	          rowButtonMiamiInserted = true;
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(_RowButtonMiami2.default, {
	              buttonEvent: _this4.redirect,
	              header: 'Be the Change',
	              message: 'Help make a difference by becoming a donor.',
	              button: '/img/miami/general/learnmore_grad_button.png'
	            })
	          );
	        }
	
	        var renderedStoryset = _react2.default.createElement(
	          'div',
	          { key: i },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: _this4.props.screen.r9_16.p10 * .17, display: 'flex', alignItems: 'flex-start' } },
	            _this4.renderRow(row, i)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            storySets.length <= 1 && rowButtonMiamiInserted === false ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_RowButtonMiami2.default, {
	                buttonEvent: _this4.redirect,
	                header: 'Get Involved',
	                message: 'Learn about the many ways you can help.',
	                button: '/img/miami/general/learnmore_grad_button.png'
	              })
	            ) : null
	          )
	        );
	
	        if (storySets.length <= 1) {
	          rowButtonMiamiInserted = true;
	        }
	
	        return renderedStoryset;
	      });
	      return _react2.default.createElement(
	        'div',
	        { key: groupIndex },
	        header,
	        renderedStorySets
	      );
	    });
	  };
	
	  this.renderRow = function (row) {
	    if (row.length === 0) {
	      return null;
	    }
	    return row.map(function (innerrow, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i, style: { display: 'inline-block' } },
	        _this4.renderStory(innerrow, i)
	      );
	    });
	  };
	
	  this.renderStory = function (row, i) {
	    var unit = _this4.props.screen.r9_16.p10 / _this4.props.screensNumber;
	    var image = (0, _shared.presetDp)("story_pill_thumbnail", _lodash2.default.get(row, 'contents.images[0]', { path: '/img/ui/', file_name: 'image_default.png' }), _this4.props.screen);
	    var mult = .8;
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(el) {
	          return _this4.storyRefs[row.index] = el;
	        }, style: { marginRight: unit * .175, display: 'inline-block' } },
	      _react2.default.createElement(_InfoBlockMiami2.default, {
	        imgsrc: image,
	        imageHeight: unit * 2 * mult,
	        infoHeight: "4.6875vh",
	        width: "15vh",
	        unit: unit * mult,
	        text: row.name,
	        infoColor: "black",
	        infoBackgroundColor: 'white',
	        fontFamily: 'opensans-regular',
	        fontSize: unit * 0.15,
	        arrowIcon: _this4._arrowIcon
	      })
	    );
	  };
	
	  this.renderBackButton = function () {
	    if (_this4._mode === "video") {
	      return _react2.default.createElement(
	        _NavButtonMiami2.default,
	        { unit: _this4.props.screen.r9_16.p10, width: _this4.props.screen.r9_16.p10 * .7, height: _this4.props.screen.r9_16.p10 * .7, clickAction: _this4.handleBack, text: 'back', mode: _this4._mode, right: '1.69270833333333333333vh', top: '92%' },
	        _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center', marginTop: _this4.props.screen.r9_16.p10 * 0.041666667 } },
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: "2.8125vh", color: 'white', fontWeight: 'bold' } },
	            'X'
	          )
	        )
	      );
	    } else {
	      if (_this4.props.screensNumber === 1) {
	        return _react2.default.createElement(_BackButtonMiami2.default, {
	          colorPallette: _this4._colorPallette,
	          backButton: _this4._arrowIcon,
	          unit: _this4.props.screen.r9_16.p10 / _this4.props.screensNumber,
	          width: '3.90625vh',
	          height: _MiamiConstants2.default.backButtonHeight,
	          top: '56.46875vh',
	          border: '0.84375vh',
	          clickAction: _this4.handleBack,
	          text: 'back',
	          mode: _this4._mode });
	      }
	
	      return null;
	    }
	  };
	
	  this.getBackgroundImage = function () {
	    var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	    if (_this4.props.screensNumber === 2) {
	      defaultImg.file_name = 'default_double_screen.jpg';
	    }
	    return (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, 'contents.images[2]', null));
	  };
	
	  this.getIconImage = function () {
	    var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	    if (_this4.props.screensNumber === 2) {
	      defaultImg.file_name = 'default_double_screen.jpg';
	    }
	    return (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, 'contents.images[1]', null));
	  };
	
	  this.getModalContent = function () {
	    if (_this4._mode === "video") {
	      return _react2.default.createElement(_VideoMiami2.default, {
	        key: _this4.state.contentIndex,
	        screen: _this4.props.screen,
	        screensNumber: _this4.props.screensNumber,
	        content: _this4.state.content,
	        clickAction: _this4.handleBack,
	        tapAction: _this4.handleTap,
	        contentIndex: _this4.state.contentIndex,
	        donorsData: _this4._dataContent,
	        module: _this4.props.module,
	        handlePrevious: _this4.handlePrevious,
	        handleNext: _this4.handleNext
	      });
	    } else {
	      var showBackground = _this4.props.screensNumber > 1 ? false : true;
	      return _react2.default.createElement(_StoryMiami2.default, {
	        showBackground: showBackground,
	        screen: _this4.props.screen,
	        screensNumber: _this4.props.screensNumber,
	        navRoute: _this4.props.navRoute,
	        stories: _this4._dataContent,
	        background: _this4.getBackgroundImage(),
	        mode: _this4._mode,
	        clickAction: _this4.handleBack,
	        contentIndex: _this4.state.contentIndex
	      });
	    }
	  };
	
	  this.getSubscribeModule = function () {
	    var rootFolderId = _lodash2.default.get(_this4.props.content, 'settings.selected_root_folder', null);
	    var menu = _this4.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	      return folder.parent_category === Number(rootFolderId) && type === "menu";
	    });
	    var rootFolder = _this4.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(rootFolderId);
	    });
	    _this4._arrowIcon = (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(menu, 'contents.images[0]', null), null);
	    _this4._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	    var subscribeModule = _this4.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	      return folder.parent_category === Number(menu.id) && type === "be_the_change";
	    });
	    _this4._subscribeModule = subscribeModule;
	  };
	
	  this.redirect = function () {
	    if (_this4._subscribeModule !== null && _this4._subscribeModule !== undefined) {
	      _this4.props.navRoute('/miami/subscribe', _this4._subscribeModule);
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  return {
	    content: state.content,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(StoriesMiami);

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _ScrollSpacer = __webpack_require__(63);
	
	var _ScrollSpacer2 = _interopRequireDefault(_ScrollSpacer);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _shared3 = __webpack_require__(4);
	
	var _StoryMiami = __webpack_require__(50);
	
	var _StoryMiami2 = _interopRequireDefault(_StoryMiami);
	
	var _RowButtonMiami = __webpack_require__(155);
	
	var _RowButtonMiami2 = _interopRequireDefault(_RowButtonMiami);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StoriesSimpleMiami = function (_Component) {
	  _inherits(StoriesSimpleMiami, _Component);
	
	  function StoriesSimpleMiami(props) {
	    _classCallCheck(this, StoriesSimpleMiami);
	
	    var _this = _possibleConstructorReturn(this, (StoriesSimpleMiami.__proto__ || Object.getPrototypeOf(StoriesSimpleMiami)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.navRefs = [];
	    _this._currentStory = {};
	    _this._subscribeModule = null;
	    _this.getSubscribeModule();
	    _this._rowWrapperRef = null;
	    _this._colorPallette = null;
	
	    _this._includePictures = false;
	    _this._modalIsOnScreen = false;
	    var type = _lodash2.default.get(_this.props.module, 'contents.custom_fields.folder_type.val.value', null);
	    if (type === "donor_stories_text_block_picture") {
	      _this._includePictures = true;
	    }
	
	    _this._showStoryCycle = null;
	    _this._modalEnabled = _this.props.module.modalEnabled === undefined ? false : _this.props.module.modalEnabled;
	
	    _this.state = {
	      initializedRefs: false,
	      contentIndex: 0
	    };
	    _this._stories = _lodash2.default.orderBy(_this.props.module.children, function (story) {
	      return story.sorting_name.toLowerCase();
	    });
	    return _this;
	  }
	
	  _createClass(StoriesSimpleMiami, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.checkSwipeAnimation();
	      if (this._rowWrapperRef) {
	        this._rowWrapperRef.addEventListener("tap", function () {
	          return _this2.redirect();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var unit = this.props.screen.r9_16.p10;
	      var backgroundImage = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	              _react2.default.createElement('div', { style: { height: "4vh" } }),
	              _react2.default.createElement('img', { alt: 'icon', src: iconImage, style: { width: '16vh' } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '3.6vh' } },
	              this.props.module.name.toUpperCase()
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center", paddingRight: "9.375vh", paddingLeft: "9.375vh" } },
	              this.props.module.description
	            ),
	            _react2.default.createElement('div', { style: { height: '3.088541667vh' } }),
	            this._includePictures ? _react2.default.createElement('div', { style: { height: "1.82291666666666666667vh" } }) : null,
	            _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: unit * .25, top: "26.979166667vh", left: 0 } }),
	            _react2.default.createElement(
	              'div',
	              { ref: function ref(el) {
	                  return _this3._wrapperDiv = el;
	                }, style: { color: 'black', width: '85%', height: "72.91vh", maxHeight: "72.91vh", display: "block", marginLeft: "auto", marginRight: "auto", touchAction: "none" } },
	              _react2.default.createElement(
	                _reactIscroll2.default,
	                { ref: function ref(el) {
	                    return _this3.iScroller = el;
	                  }, iScroll: _iscroll2.default,
	                  onScrollStart: this.handleScrollStart,
	                  options: {
	                    mouseWheel: true,
	                    scrollbars: false,
	                    scrollX: false,
	                    scrollY: true,
	                    probeType: 2,
	                    bounce: false,
	                    momentum: true,
	                    deceleration: 0.005,
	                    useTransition: true,
	                    disableTouch: false,
	                    disablePointer: false,
	                    disableMouse: false,
	                    tap: true
	                  },
	                  onRefresh: this.initializeNavRefs
	                },
	                _react2.default.createElement(
	                  'div',
	                  { ref: function ref(el) {
	                      return _this3._innerDivRef = el;
	                    } },
	                  _react2.default.createElement('div', { style: { height: "3vh" } }),
	                  this.renderStories(),
	                  _react2.default.createElement(_ScrollSpacer2.default, { unit: unit })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber, left: this.props.screen.screenWidth / this.props.screensNumber } },
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                className: 'containerFade',
	                style: { minHeight: '100%' },
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: this.state.showStory },
	                this.state.showStory ? _react2.default.createElement(_StoryMiami2.default, {
	                  showBackground: false,
	                  stories: this._stories,
	                  screen: this.props.screen,
	                  mode: this.props.mode,
	                  contentIndex: this.state.contentIndex,
	                  screensNumber: this.props.screensNumber
	                }) : null
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoriesSimpleMiami;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.initializeNavRefs = function () {
	    if (_this4.state.initializedRefs === false) {
	      var _loop = function _loop(a) {
	        if (_this4._modalEnabled) {
	          _this4.navRefs[a].el.addEventListener("tap", function () {
	            return _this4.handleNav(a);
	          });
	        }
	      };
	
	      for (var a = 0; a < _this4.navRefs.length; a++) {
	        _loop(a);
	      }
	      _this4.setState({
	        initializedRefs: true
	      });
	    }
	  };
	
	  this.checkSwipeAnimation = function () {
	    var wrapperHeight = _this4._wrapperDiv.getBoundingClientRect().height;
	    var contentHeight = _this4._innerDivRef.getBoundingClientRect().height;
	
	    _this4.props.handleSwipeAnimation(wrapperHeight, contentHeight);
	  };
	
	  this.handleScrollStart = function () {
	    _this4.props.cancelSwipeAnimation();
	  };
	
	  this.handleNav = function (a) {
	    _this4.setState({
	      contentIndex: a,
	      showStory: false
	    });
	
	    if (_this4._modalIsOnScreen) {
	      setTimeout(function () {
	        _this4._modalIsOnScreen = true;
	        _this4.setState({
	          showStory: true
	        });
	      }, 500);
	    } else {
	      _this4._modalIsOnScreen = true;
	      _this4.setState({
	        showStory: true
	      });
	    }
	
	    clearTimeout(_this4._showStoryCycle);
	    _this4._showStoryCycle = null;
	    _this4._showStoryCycle = setTimeout(function () {
	      _this4._modalIsOnScreen = false;
	      _this4.setState({
	        showStory: false
	      });
	    }, 60000);
	  };
	
	  this.getBackgroundImage = function () {
	    var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	    if (_this4.props.screensNumber === 2) {
	      defaultImg.file_name = 'default_double_screen.jpg';
	    }
	    return (0, _shared3.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, 'contents.images[2]', null), null);
	  };
	
	  this.getIconImage = function () {
	    return (0, _shared3.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, 'contents.images[1]', null), null);
	  };
	
	  this.getSubscribeModule = function () {
	    var rootFolderId = _lodash2.default.get(_this4.props.content, 'settings.selected_root_folder', null);
	    var menu = _this4.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	      return folder.parent_category === Number(rootFolderId) && type === "menu";
	    });
	    var rootFolder = _this4.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(rootFolderId);
	    });
	    _this4._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	    var subscribeModule = _this4.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	      return folder.parent_category === Number(menu.id) && type === "be_the_change";
	    });
	    _this4._subscribeModule = subscribeModule;
	  };
	
	  this.renderStory = function (row, i) {
	    var rootFolderId = _lodash2.default.get(_this4.props.content, 'settings.selected_root_folder', null);
	    var rootFolder = _this4.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(rootFolderId);
	    });
	    _this4._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	    var uiStrip = "/img/miami/general/rainbowuistrip_dark.png";
	    if (_this4._colorPallette === "adaptive") {
	      uiStrip = "/img/miami/general/rainbowuistrip_dark_green.png";
	    }
	    var unit = _this4.props.screen.r9_16.p10;
	
	    var imageWidth = 0;
	    var textWidth = 41;
	    var totalWidth = 47.5;
	
	    var boxStyle = {
	      paddingLeft: '3.375vh',
	      paddingRight: '3.375vh',
	      paddingTop: '1.96875vh',
	      paddingBottom: '1.96875vh',
	      width: textWidth + 'vh'
	    };
	
	    if (_this4._includePictures) {
	      imageWidth = 14;
	      textWidth = totalWidth - imageWidth - 5;
	      boxStyle = {
	        paddingLeft: '2.5vh',
	        paddingRight: '2.5vh',
	        paddingTop: '1.5vh',
	        paddingBottom: '1.5vh',
	        width: textWidth + 'vh'
	      };
	    }
	
	    var richTextWrapper = {
	      width: textWidth + 'vh',
	      overflowY: 'hidden',
	      verticalAlign: 'top'
	    };
	
	    if (_this4._includePictures) {
	      richTextWrapper.height = '8vh';
	    }
	
	    // let backgroundImage = shared.dp(this.props.screen, row.contents.images[0]);
	    var backgroundImage = _shared2.default.presetDp("story_text_block_picture", _lodash2.default.get(row, 'contents.images[0]', { path: '/img/ui/', file_name: 'image_default.png' }), _this4.props.screen);
	    var bodyRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(row, 'contents.custom_fields.body.val.ops', _lodash2.default.get(row, 'contents.custom_fields.body.default.ops', null)), {}).convert();
	    return _react2.default.createElement(
	      'div',
	      { key: i, ref: function ref(el) {
	          return _this4.navRefs[i] = { el: el, module: row };
	        }, style: { width: totalWidth + 'vh', height: '15vh', display: "table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 } },
	      _this4._includePictures ? _react2.default.createElement('div', { style: { width: imageWidth + 'vh', display: "table-cell", backgroundImage: "url(" + backgroundImage + ")", backgroundSize: "cover", backgroundPosition: "center", borderTopLeftRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08 } }) : null,
	      _react2.default.createElement(
	        'div',
	        { style: Object.assign({}, boxStyle, { display: "table-cell" }) },
	        _react2.default.createElement(
	          'div',
	          { className: 'fullEllipsis', style: { width: textWidth + 'vh', position: 'relative', fontSize: "2.1875vh", textOverflow: 'ellipsis' } },
	          row.name
	        ),
	        _react2.default.createElement('hr', { style: { backgroundImage: "url(" + uiStrip + ")", backgroundSize: "cover", backgroundPosition: "center", height: "0.098958333vh" } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'no-margin', style: richTextWrapper },
	          _react2.default.createElement('div', { style: { lineHeight: '65%', touchAction: "none" }, dangerouslySetInnerHTML: { __html: bodyRichText } })
	        )
	      )
	    );
	  };
	
	  this.renderStories = function () {
	    var learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
	    if (_this4._colorPallette === "adaptive") {
	      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
	    }
	    return _this4._stories.map(function (row, i) {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { key: i },
	        _react2.default.createElement(
	          'div',
	          { className: 'miami-bullet' },
	          this.renderStoryWithSpacer(row, i)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this._stories.length <= 1 && this._includePictures ? _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this5._rowWrapperRef = el;
	              } },
	            _react2.default.createElement(_RowButtonMiami2.default, {
	              header: 'Be the change',
	              message: 'Help make a difference by becoming a donor.',
	              button: learnMoreButton
	            })
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this._stories.length <= 2 && !this._includePictures && i >= 1 ? _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this5._rowWrapperRef = el;
	              } },
	            _react2.default.createElement(_RowButtonMiami2.default, {
	              header: 'Get Involved',
	              message: 'Learn about the many ways you can help',
	              button: learnMoreButton
	            })
	          ) : null
	        )
	      );
	    }, _this4);
	  };
	
	  this.renderStoryWithSpacer = function (row, i) {
	    var learnMoreButton = "/img/miami/general/learnmore_grad_button.png";
	    if (_this4._colorPallette === "adaptive") {
	      learnMoreButton = "/img/miami/general/learnmore_grad_button_green.png";
	    }
	    var story = _this4.renderStory(row, i);
	    var insertRowAt = _this4._includePictures ? 1 : 2;
	    var RowButtonProperty = {};
	
	    if (_this4._includePictures) {
	      // let insertSpacerAt = 1;
	      RowButtonProperty = {
	        header: "Be the change",
	        message: "Help make a difference by becoming a donor.",
	        button: learnMoreButton
	      };
	    } else {
	      // let insertSpacerAt = 2;
	      RowButtonProperty = {
	        header: "Get Involved",
	        message: "Learn about the many ways you can help",
	        button: learnMoreButton
	      };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: i },
	      i === insertRowAt ? _react2.default.createElement(
	        'div',
	        { ref: function ref(el) {
	            return _this4._rowWrapperRef = el;
	          } },
	        _react2.default.createElement(_RowButtonMiami2.default, {
	          header: RowButtonProperty.header,
	          message: RowButtonProperty.message,
	          button: RowButtonProperty.button
	        })
	      ) : null,
	      story
	    );
	  };
	
	  this.redirect = function () {
	    if (_this4._subscribeModule !== null && _this4._subscribeModule !== undefined) {
	      _this4.props.navRoute('/miami/subscribe', _this4._subscribeModule);
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(StoriesSimpleMiami);

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _InfoBlockMiami = __webpack_require__(62);
	
	var _InfoBlockMiami2 = _interopRequireDefault(_InfoBlockMiami);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _iconTimelineBullet = __webpack_require__(566);
	
	var _iconTimelineBullet2 = _interopRequireDefault(_iconTimelineBullet);
	
	var _StoryMiami = __webpack_require__(50);
	
	var _StoryMiami2 = _interopRequireDefault(_StoryMiami);
	
	var _BackButtonMiami = __webpack_require__(61);
	
	var _BackButtonMiami2 = _interopRequireDefault(_BackButtonMiami);
	
	var _MiamiConstants = __webpack_require__(49);
	
	var _MiamiConstants2 = _interopRequireDefault(_MiamiConstants);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var spacialEvents;
	var config = {
		events_on_screen: 10,
		line_thickness: 0.02
	};
	
	var Timeline = function (_Component) {
		_inherits(Timeline, _Component);
	
		function Timeline(props) {
			_classCallCheck(this, Timeline);
	
			var _this = _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, props));
	
			_this.initializeTimelineRefs = function () {
				if (_this.state.initializedRefs === false) {
					var _loop = function _loop(a) {
						_this.timelineRefs[a].el.addEventListener("tap", function () {
							return _this.handleEventSelection(_this.timelineRefs[a].data);
						});
					};
	
					for (var a = 0; a < _this.timelineRefs.length; a++) {
						_loop(a);
					}
					_this.setState({
						initializedRefs: true
					});
				}
			};
	
			_this.handleBack = function () {
				_this.setState({
					showStoryModal: false
				});
			};
	
			_this.parseDate = function (date) {
	
				var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
				var monthName = monthNames[date.getMonth()];
				// let monthNumber = String(date.getMonth() + 1);
				var fullYear = String(date.getFullYear());
				// let shortYear = fullYear.substring(2);
				var day = String(date.getDate());
				var unit = _this.props.screen.r9_16.p10;
				return _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'b',
						null,
						_react2.default.createElement(
							'span',
							{ style: { fontSize: unit * .2 } },
							monthName,
							' ',
							day
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'span',
							{ style: { fontSize: unit * .35 } },
							fullYear
						)
					)
				);
			};
	
			_this.handleEventSelection = function (story_id) {
				// let story = _.find(this._stories, {id: Number(story_id)});
				var contentIndex = _lodash2.default.findIndex(_this.props.content.stories, { id: Number(story_id) });
				if (contentIndex > -1) {
					_this.setState({
						// story: story,
						showStoryModal: true,
						contentIndex: contentIndex
					});
				}
			};
	
			_this.cycleStory = function (direction) {
				if (direction === "forward") {
					_this._eventIndex += 1;
					if (_this._eventIndex >= _this.props.module.contents.events.length) {
						_this._eventIndex = 0;
					}
				} else {
					_this._eventIndex -= 1;
					if (_this._eventIndex < 0) {
						_this._eventIndex = _this.props.module.contents.events.length - 1;
					}
				}
				if (!_this.props.module.contents.events[_this._eventIndex].story || isNaN(Number(_this.props.module.contents.events[_this._eventIndex].story))) {
					_this.cycleStory(direction);
				} else {
					_this.handleEventSelection(_this.props.module.contents.events[_this._eventIndex].story);
				}
			};
	
			_this.getBackgroundImage = function () {
				var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	
				if (_this.props.screensNumber === 2) {
					defaultImg.file_name = 'default_double_screen.jpg';
				}
	
				try {
					var backgroundReference = _this.props.module.contents.custom_fields.background_reference.val;
					var assetsSlideShow = _lodash2.default.find(_this.props.content.dm_active, function (o) {
						return o.name.includes("Assets - ");
					});
					var asset = _lodash2.default.indexOf(assetsSlideShow.contents.names, backgroundReference);
	
					if (!asset || asset === undefined) {
						return (0, _shared.dp)(_this.props.screen, defaultImg);
					}
	
					return (0, _shared.dp)(_this.props.screen, assetsSlideShow.contents.images[asset]);
				} catch (e) {
					return (0, _shared.dp)(_this.props.screen, defaultImg);
				}
			};
	
			_this.getIconImage = function () {
				try {
					var iconReference = _this.props.module.contents.custom_fields.icon_reference.val;
					var assetsSlideShow = _lodash2.default.find(_this.props.content.dm_active, function (o) {
						return o.name.includes("Assets - ");
					});
					var asset = _lodash2.default.indexOf(assetsSlideShow.contents.names, iconReference);
	
					if (!asset || asset === undefined) {
						return (0, _shared.dp)(_this.props.screen, null);
					}
	
					return (0, _shared.dp)(_this.props.screen, assetsSlideShow.contents.images[asset]);
				} catch (e) {
					return (0, _shared.dp)(_this.props.screen, null);
				}
			};
	
			_this.getSubscribeModule = function () {
				var rootFolderId = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
				var menu = _this.props.content.story_categories.find(function (folder) {
					var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
					return folder.parent_category === Number(rootFolderId) && type === "menu";
				});
				var rootFolder = _this.props.content.story_categories.find(function (folder) {
					return folder.id === Number(rootFolderId);
				});
				_this._arrowIcon = (0, _shared.dp)(_this.props.screen, _lodash2.default.get(menu, 'contents.images[0]', null), null);
				_this._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
				var subscribeModule = _this.props.content.story_categories.find(function (folder) {
					var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
					return folder.parent_category === Number(menu.id) && type === "be_the_change";
				});
				_this._subscribeModule = subscribeModule;
			};
	
			_this.beTheChange = function () {
				return _react2.default.createElement(
					'div',
					{ style: { marginTop: '7vw', marginBottom: '5vw', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch' } },
					_react2.default.createElement(
						'div',
						{ style: { fontSize: '3.5vw', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-semibold", color: '#ffffff', width: '150vw' } },
						'Be the Change',
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'span',
							{ style: { fontSize: '2.2vw', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' } },
							'Help make a difference by becoming a donor.'
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'right', width: '100%' } },
						_react2.default.createElement('img', { onClick: function onClick() {
								return _this.redirect();
							}, alt: 'Story', src: "/img/miami/general/learnmore_grad_button.png", style: { width: '23vw' } })
					)
				);
			};
	
			_this.redirect = function () {
				if (_this._subscribeModule !== null && _this._subscribeModule !== undefined) {
					_this.props.navRoute('/miami/subscribe', _this._subscribeModule);
				}
			};
	
			_this.refDict = {};
			_this.cycleDate = _this.cycleDate.bind(_this);
			_this.onScrollEnd = _this.onScrollEnd.bind(_this);
			_this.state = {
				spacialEvents: null,
				sideMargin: null,
				totalHeight: null,
				currentEvent: 0,
				showStoryModal: false,
				initializedRefs: false,
				contentIndex: 0
			};
			_this._subscribeModule = null;
			_this._buttonBinded = false;
			_this.getSubscribeModule();
			_this._baseInset = _this.props.screen.screenWidth * .5;
			_this._eventIndex = 0;
			_this._rowWrapperRef = null;
			_this._titleStyle = {
				position: 'absolute',
				fontFamily: 'aleo-bolditalic', fontSize: _this.props.screen.r16_9.p10,
				left: _this.props.screen.r16_9.width * .05
			};
			_this._titleHorizontalRule = {
				width: '90%',
				height: _this.props.screen.r16_9.p10 * 0.15,
				backgroundColor: '#223954',
				display: 'inline-block',
				position: 'absolute',
				top: _this.props.screen.r16_9.p10 * 1.25,
				left: 0,
				marginLeft: _this.props.screen.r16_9.width * .05
			};
			_this._bottomNavOffset = 0;
			if (_this.props.content.settings.custom_vars && _this.props.content.settings.custom_vars.bottomnav === "true") {
				_this._bottomNavOffset = _this.props.screen.r16_9.p10;
			}
			_this.timelineRefs = [];
			return _this;
		}
	
		_createClass(Timeline, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var _this2 = this;
	
				var _loop2 = function _loop2(a) {
					if (_this2.timelineRefs[a].el) {
						_this2.timelineRefs[a].el.removeEventListener("tap", function () {
							return _this2.handleEventSelection(_this2.timelineRefs[a].data);
						});
					}
				};
	
				for (var a = 0; a < this.timelineRefs.length; a++) {
					_loop2(a);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var totalHeight = (this.props.module.contents.events.length + 1) * (this.props.screen.sv.height / config.events_on_screen); // + this.props.screen.sv.height * 2;
				this.getRelativeLocations(this.props.module.contents.events, totalHeight, 0);
	
				// if (this._rowWrapperRef) {
				// 	this._rowWrapperRef.addEventListener("tap", () => this.redirect());
				// }
			}
		}, {
			key: 'getRelativeLocations',
			value: function getRelativeLocations(events, totalHeight, topMargin) {
				var _this3 = this;
	
				//console.log("relative locations", events);
				//console.log("totalHieght", totalHeight)
				spacialEvents = [];
	
				if (this.props.module.contents.event_spacing === "even") {
					var eventInc = this.props.screen.sv.height / config.events_on_screen;
					//console.log("eventInc", eventInc);
					_lodash2.default.forEach(events, function (event, index) {
						var raw = eventInc * index;
						var span = raw + eventInc;
						spacialEvents.push({ header: event.header, date: _this3.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story });
					});
					this.setState({
						spacialEvents: spacialEvents,
						// sideMargin: topMargin,
						totalHeight: totalHeight
					});
				} else {
					//relative spacing
					var fullTimeSpan = events[events.length - 1].date - events[0].date;
					_lodash2.default.forEach(events, function (event) {
						var raw = (event.date - events[0].date) / fullTimeSpan * totalHeight;
						var span = raw + topMargin;
						spacialEvents.push({ header: event.header, date: _this3.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story });
					});
					this.setState({
						spacialEvents: spacialEvents,
						//     sideMargin: topMargin,
						totalHeight: totalHeight
					});
				}
			}
		}, {
			key: 'onScrollEnd',
			value: function onScrollEnd(e) {
				// let yVal = Math.abs(e.y);
				// let tempCurrentEvent = 0;
				// let closestDist = null; //always pinning first to zero
	
				// for (var i = 0; i < spacialEvents.length; i++) {
				//     let dist = Math.abs(spacialEvents[i].raw - yVal);
				//     if (closestDist === null) {
				//         tempCurrentEvent = i;
				//         closestDist = dist;
				//     }
				//     else {
				//         if (dist < closestDist) {
				//             tempCurrentEvent = i;
				//             closestDist = dist;
				//         }
				//     }
				// }
	
				// this.refDict[0].withIScroll(function (iScroll) {
				//     iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
				// })
				// this.setState({
				//     currentEvent: tempCurrentEvent
				// })
			}
		}, {
			key: 'cycleDate',
			value: function cycleDate(mode, index) {
				var tempCurrentEvent = this.state.currentEvent;
				if (mode === 0) {
					//backward
					tempCurrentEvent--;
					if (tempCurrentEvent < 0) {
						tempCurrentEvent = spacialEvents.length - 1;
					}
				} else if (mode === 1) {
					//forward
					tempCurrentEvent++;
					if (tempCurrentEvent > spacialEvents.length - 1) {
						tempCurrentEvent = 0;
					}
				} else {
					//to specific index
					tempCurrentEvent = index;
				}
				this.refDict[0].withIScroll(function (iScroll) {
					iScroll.scrollTo(-spacialEvents[tempCurrentEvent].raw, 0, 1000);
				});
				this.setState({
					currentEvent: tempCurrentEvent
				});
			}
		}, {
			key: 'renderSpacialEvents',
			value: function renderSpacialEvents() {
	
				// timeline circle
	
				var circleRadius = this.props.screen.r16_9.p10 * 0.15;
	
				// let circle = {
				//     width: circleRadius,
				//     height: circleRadius,
				//     WebkitBorderRadius: circleRadius / 2,
				//     MozBorderRadius: circleRadius / 2,
				//     borderRadius: circleRadius / 2,
				//     backgroundColor: '#ffffff',
				//     borderColor: '#FDC700',
				//     border: '1vw',
				//     position: 'absolute',
				//     left: - circleRadius / 2 + this._baseInset
				// }
	
				if (this.state.spacialEvents.length === 0) {
					return _react2.default.createElement('span', null);
				}
	
				var unit = this.props.screen.r9_16.p10;
				var infoBlockWidth = unit * 3.35 * .8;
				var insetAmount = unit * 1.55;
				var leftInset = -insetAmount - infoBlockWidth;
				var rightInset = insetAmount;
				var imageHeight = unit * 2 * .8;
				var infoHeight = unit * .85 * .8;
				var fullHeight = imageHeight + infoHeight;
				var iconWidth = unit * .25;
				// const dateInset = unit * .1;
				// const dateWidth = unit * .25;
	
				return this.state.spacialEvents.map(function (row, i) {
					var _this4 = this;
	
					// let iref = null;
					// if (_.has(row, 'images[0]')) {
					//     iref = row.images[0];
					// }
	
					//assume left
					var inset = leftInset;
					var dateInset = -insetAmount / 6 - unit * .6;
					var horizontalLineInset = -insetAmount + this._baseInset;
	
					//offset for right scenario
					if (i % 2 === 0) {
						inset = rightInset;
						horizontalLineInset = this._baseInset + unit * 1.1;
						dateInset = insetAmount / 6;
					}
					// console.log("THE ROW", row);
					// console.log("THE GET", _.get(row, 'images[0]', null));
					// let image = "/img/ui/default-user.png";
					// if (_.has(row, 'images[0]')){
					//     image = shared.dpath(this.props.screen.mode, "/" + row.images[0].path, row.images[0].file_name, this.props.screen.webkey)
					// }
					return _react2.default.createElement(
						'div',
						{ key: i, style: { position: 'absolute', top: row.offset, zIndex: 0 } },
						_react2.default.createElement('div', { style: {
								position: 'absolute',
								backgroundColor: 'white',
								top: circleRadius / 2,
								left: horizontalLineInset,
								width: unit * .55,
								height: unit * config.line_thickness
							} }),
						_react2.default.createElement(
							'div',
							{ style: { position: 'absolute', left: this._baseInset - iconWidth / 2 } },
							_react2.default.createElement('img', { alt: 'timlineicon', style: { width: iconWidth, height: iconWidth }, src: _iconTimelineBullet2.default })
						),
						_react2.default.createElement(
							'span',
							{ style: { fontSize: unit * .35, position: 'absolute', left: dateInset + this._baseInset, width: unit * 5, top: -unit * .275 } },
							row.date
						),
						_react2.default.createElement(
							'span',
							{ ref: function ref(el) {
									return _this4.timelineRefs[i] = { el: el, data: row.story };
								}, style: { position: 'absolute', left: inset + this._baseInset, top: -fullHeight / 2 + circleRadius / 2 } },
							_react2.default.createElement(_InfoBlockMiami2.default, {
								imgsrc: (0, _shared.dp)(this.props.screen, _lodash2.default.get(row, 'images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' }),
								imageHeight: imageHeight,
								infoHeight: infoHeight,
								width: infoBlockWidth,
								unit: unit * .8,
								text: row.header,
								infoColor: "black",
								infoBackgroundColor: 'white',
								fontFamily: 'opensans-regular',
								fontSize: unit * 0.15
							})
						)
					);
				}, this);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var backgroundImage = this.getBackgroundImage();
				var iconImage = this.getIconImage();
				var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
				// let iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' }
				if (!this.state.spacialEvents) {
					return _react2.default.createElement('div', null);
				}
				// let cycleDateStyle = {
				//     color: 'white',
				//     height: this.props.screen.screenHeight * .06,
				//     fontSize: this.props.screen.screenHeight * .06,
				//     zIndex: 99,
				// }
	
				// let modalBorderV = .035 * this.props.screen.screenHeight;
				// let modalBorderH = .02 * this.props.screen.r16_9.width;
	
				var spacialEvents = this.renderSpacialEvents();
				//let quickJumps = this.renderQuickJumps();
				var unit = this.props.screen.r9_16.p10;
				// let mult = .8
				var scrollableArea = this.props.screen.r9_16.height * .58;
	
				return _react2.default.createElement(
					'div',
					{ style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: backgroundSize, backgroundImage: "url(" + backgroundImage + ")" } },
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'center', position: 'absolute' } },
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement('img', { alt: 'Campaign', src: iconImage, style: { display: 'block', margin: 'auto', width: '25vw' } }),
						_react2.default.createElement(
							'div',
							{ style: { fontFamily: 'opensans-extrabold', fontSize: '6vw' } },
							this.props.module.contents.header.toUpperCase()
						),
						_react2.default.createElement(
							'div',
							{ style: { fontFamily: 'opensans-regular', fontSize: '3vw', paddingRight: "8.333333333vh", paddingLeft: "8.333333333vh" } },
							_lodash2.default.get(this.props.module.contents, 'custom_fields.headline.val', null)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', justifyContent: 'center', width: '100%' } },
							_react2.default.createElement(
								'div',
								{ style: { width: '80vw', height: '15vw', borderRadius: '2vw', padding: '5vw' } },
								_react2.default.createElement('div', { style: { color: 'black', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around' } })
							)
						)
					),
					_react2.default.createElement('div', { style: { position: 'absolute', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height } }),
					_react2.default.createElement(
						'div',
						{ style: {
								position: 'absolute',
								top: unit * 4.8,
								left: 0,
								width: this.props.screen.screenWidth,
								height: scrollableArea,
								touchAction: "none"
							} },
						_react2.default.createElement(
							_reactIscroll2.default,
							{ ref: function ref(el) {
									return _this5.refDict[0] = el;
								}, iScroll: _iscroll2.default,
								onScrollEnd: this.onScrollEnd,
								options: {
									mouseWheel: true,
									scrollbars: false,
									scrollX: false,
									scrollY: true,
									probeType: 2,
									bounce: false,
									momentum: true,
									deceleration: 0.005,
									useTransition: true,
									disableTouch: false,
									disablePointer: false,
									disableMouse: false,
									tap: true
								},
								onRefresh: this.initializeTimelineRefs
							},
							_react2.default.createElement(
								'div',
								{ style: { width: this.props.screen.r16_9.width * .6, height: this.state.totalHeight, minHeight: '100%' } },
								_react2.default.createElement('div', { style: {
										position: 'absolute',
										top: 0,
										backgroundColor: 'white',
										left: this._baseInset,
										width: this.props.screen.sv.p10 * config.line_thickness,
										height: '100%'
									} }),
								_react2.default.createElement('div', { style: {
										position: 'absolute',
										width: this.props.screen.r16_9.width,
										height: this._titleHorizontalRule.top
									} }),
								spacialEvents
							)
						),
						_react2.default.createElement('div', { className: 'bottomgradblackP25', style: { position: 'absolute', width: '100%', height: unit * .25, bottom: 0 } }),
						_react2.default.createElement('div', { className: 'topgradblackP25', style: { position: 'absolute', width: '100%', height: unit * .25, bottom: '56.6vh' } })
					),
					_react2.default.createElement(
						'div',
						{ style: { display: "flex", justifyContent: "center" } },
						_react2.default.createElement(
							'div',
							{ style: {
									position: 'absolute',
									top: "85vh",
									width: this.props.screen.screenWidth * 0.8,
									height: this.props.screen.r9_16.height * .35,
									fontSize: '4vw',
									fontFamily: 'opensans-bold',
									paddingLeft: "2.6vh",
									paddingRight: "2.6vh"
								} },
							this.beTheChange()
						)
					),
					_react2.default.createElement(
						'div',
						{ style: { position: 'absolute' } },
						_react2.default.createElement(
							_CSSTransitionGroup2.default,
							{
								component: 'div',
								className: 'containerFade',
								style: { minHeight: '100%' },
								transitionName: 'example',
								transitionEnterTimeout: 0,
								transitionLeaveTimeout: 0 },
							_react2.default.createElement(
								'div',
								{ key: this.state.showStoryModal, style: { position: 'absolute' } },
								this.state.showStoryModal ? _react2.default.createElement(_StoryMiami2.default, { backgroundEnabled: true, content: this.props.content, screensNumber: this.props.screensNumber, contentIndex: this.state.contentIndex, screen: this.props.screen }) : null,
								this.state.showStoryModal ? _react2.default.createElement(_BackButtonMiami2.default, {
									colorPallette: this._colorPallette,
									backButton: this._arrowIcon,
									unit: this.props.screen.r9_16.p10 / this.props.screensNumber,
									width: '3.375vh',
									height: _MiamiConstants2.default.backButtonHeight,
									top: '56.46875vh',
									border: '0.84375vh',
									clickAction: this.handleBack,
									text: 'back',
									mode: this._mode }) : null
							)
						)
					)
				);
			}
		}]);
	
		return Timeline;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
		return {
			content: state.content,
			screen: state.screen
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Timeline);

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TouchGestureMiami = function (_Component) {
	  _inherits(TouchGestureMiami, _Component);
	
	  function TouchGestureMiami(props) {
	    _classCallCheck(this, TouchGestureMiami);
	
	    var _this = _possibleConstructorReturn(this, (TouchGestureMiami.__proto__ || Object.getPrototypeOf(TouchGestureMiami)).call(this, props));
	
	    _this.animateIcon = function () {
	      var distance = .08733 * _this.props.regionWidth;
	      if (_this._iconRef) {
	        _this._iconRef.animate([{
	          transform: "scale(1.0)"
	        }, {
	          transform: "scale(0.7)"
	        }, {
	          transform: 'scale(0.7) translate(0px, -' + distance + 'px)'
	        }, {
	          transform: 'scale(1.0) translate(0px, -' + distance + 'px)'
	        }], {
	          direction: "alternate",
	          easing: "ease-in",
	          fill: "both",
	          duration: 1500,
	          iterations: 2
	        });
	      }
	    };
	
	    _this.startInterval = function () {
	      _this.setState({
	        show: true
	      });
	      setTimeout(function () {
	        _this.animateIcon();
	      }, 1000);
	    };
	
	    var radius = _this.props.regionWidth;
	    var top = (_this.props.regionHeight - radius) / 2;
	    var right = -(_this.props.regionWidth / 100 * 36.45);
	
	    _this._iconRef = null;
	
	    _this.state = {
	      radius: radius,
	      top: top,
	      right: right,
	      show: false
	    };
	    return _this;
	  }
	
	  _createClass(TouchGestureMiami, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.startInterval();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps !== this.props) {
	        if (this.props.show) {
	          this.startInterval();
	        } else {
	          this.setState({
	            show: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "absolute", top: this.props.contentY, left: this.props.contentX } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.show },
	            this.state.show ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: { position: "absolute", left: this.props.regionWidth * .9027, top: 1.62 * this.props.regionWidth } },
	                _react2.default.createElement('img', { ref: function ref(el) {
	                    return _this2._iconRef = el;
	                  }, src: '/img/seattle/general/hand.png', alt: '', style: { width: .03472 * this.props.regionWidth, zIndex: 9999 } })
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return TouchGestureMiami;
	}(_react.Component);
	
	exports.default = TouchGestureMiami;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeyboardKeyMiami = __webpack_require__(434);
	
	var _KeyboardKeyMiami2 = _interopRequireDefault(_KeyboardKeyMiami);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _donorHelpers2 = _interopRequireDefault(_donorHelpers);
	
	var _dataHelpers = __webpack_require__(51);
	
	var _dataHelpers2 = _interopRequireDefault(_dataHelpers);
	
	var _StoryMiami = __webpack_require__(50);
	
	var _StoryMiami2 = _interopRequireDefault(_StoryMiami);
	
	var _InfoBlockMiami = __webpack_require__(62);
	
	var _InfoBlockMiami2 = _interopRequireDefault(_InfoBlockMiami);
	
	var _BackButtonMiami = __webpack_require__(61);
	
	var _BackButtonMiami2 = _interopRequireDefault(_BackButtonMiami);
	
	var _MiamiConstants = __webpack_require__(49);
	
	var _MiamiConstants2 = _interopRequireDefault(_MiamiConstants);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _DonorFullPage = __webpack_require__(65);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	var _axios = __webpack_require__(145);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserInputMiami = function (_Component) {
	  _inherits(UserInputMiami, _Component);
	
	  function UserInputMiami(props) {
	    _classCallCheck(this, UserInputMiami);
	
	    var _this = _possibleConstructorReturn(this, (UserInputMiami.__proto__ || Object.getPrototypeOf(UserInputMiami)).call(this, props));
	
	    _this.checkSwipeAnimation = function () {
	      var wrapperHeight = _this._wrapperDiv.getBoundingClientRect().height;
	      var contentHeight = _this._innerDivRef.getBoundingClientRect().height;
	
	      _this.props.handleSwipeAnimation(wrapperHeight, contentHeight);
	    };
	
	    _this.handleScrollStart = function () {
	      _this.props.cancelSwipeAnimation();
	    };
	
	    _this.getBackgroundImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	      if (_this.props.screensNumber === 2) {
	        defaultImg.file_name = 'default_double_screen.jpg';
	      }
	      return (0, _shared.dp)(_this.props.screen, _lodash2.default.get(_this.props.module, 'contents.images[2]'), null);
	    };
	
	    _this.getIconImage = function () {
	      return (0, _shared.dp)(_this.props.screen, _lodash2.default.get(_this.props.module, 'contents.images[1]'), null);
	    };
	
	    _this.getTimelineModule = function () {
	      _this._menuModules = _lodash2.default.filter(_this.props.content.dm_active, { module_contents: { in_navigation: true } });
	      _this._menuModules.forEach(function (module, row) {
	        if (module.display_module_type === "Timeline") {
	          _this._timelineModule = module;
	        }
	      });
	    };
	
	    _this.removeInputText = function () {
	      _this.props.cancelSwipeAnimation();
	      _this.setState({
	        text: "",
	        search: false
	      });
	    };
	
	    _this.initializeIScroll = function () {
	      if (_this.state.iScrollInitialized === false) {
	        var _loop = function _loop(i) {
	          if (_this._storyPillsRefs[i] && _this._storyPillsRefs[i].el) {
	            _this._storyPillsRefs[i].el.addEventListener("tap", function () {
	              return _this.handleTap(_this._storyPillsRefs[i].moduleIndex, _this._storyPillsRefs[i].storySetIndex, _this._storyPillsRefs[i].pillIndex);
	            });
	          }
	        };
	
	        for (var i = 0; i < _this._storyPillsRefs.length; i++) {
	          _loop(i);
	        }
	
	        _this.setState({
	          iScrollInitialized: true
	        });
	      }
	    };
	
	    _this.handleTap = function (moduleIndex, storySetIndex, pillIndex) {
	      var storyId = _this._pillsStorySetsByModules[moduleIndex][storySetIndex][pillIndex].id;
	      var propsStoryIndex = _lodash2.default.findIndex(_this.props.content.stories, { id: storyId });
	
	      _this.setState({
	        storyIndex: propsStoryIndex,
	        showModal: true
	      });
	    };
	
	    _this.handleBack = function () {
	      _this.setState({
	        showModal: false
	      });
	    };
	
	    _this.beTheChange = function () {
	      return _react2.default.createElement(
	        'div',
	        { style: { margin: "auto", width: _this.props.screen.screenWidth / _this.props.screensNumber * .80, marginTop: '7vw', marginBottom: '5vw', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch' } },
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: '3.5vw', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-semibold", color: '#ffffff', width: '150vw' } },
	          'Explore Our Story',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '2.2vw', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' } },
	            'Learn how our facility came to be through generous donations'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'right', width: '100%' } },
	          _react2.default.createElement('img', { onClick: function onClick() {
	              return _this.redirect();
	            }, alt: 'Story', src: "/img/miami/general/learnmore_grad_button.png", style: { width: '23vw' } })
	        )
	      );
	    };
	
	    _this.redirect = function () {
	      if (_this._timelineModule !== null && _this._timelineModule !== undefined) {
	        _this.props.navRoute('/miami/timeline', _this._timelineModule);
	      }
	    };
	
	    _this.renderPills = function (results) {
	      var renderedPills = results.map(function (module, moduleIndex) {
	        // Organizing stories in sets of 3
	        var storySets = [];
	        var setCount = 0;
	        if (module.stories.length > 0) {
	          for (var i = 0; i < module.stories.length; i++) {
	            if (!storySets[setCount]) {
	              storySets[setCount] = [];
	            }
	            storySets[setCount].push(module.stories[i]);
	            if ((i + 1) % 3 === 0 && i !== 0) {
	              setCount++;
	            }
	            if (i === 2) {
	              storySets[setCount++] = []; //empty entry for spacer row
	            }
	          }
	
	          _this._pillsStorySetsByModules[moduleIndex] = storySets;
	
	          var renderedStories = storySets.map(function (row, storySetIndex) {
	            return _react2.default.createElement(
	              'div',
	              { key: "module" + moduleIndex + "storySet" + storySetIndex, style: { marginBottom: _this.props.screen.r9_16.p10 * .17, display: 'flex', alignItems: 'center', justifyContent: "center" } },
	              _this.renderPillsRow(row, moduleIndex, storySetIndex)
	            );
	          });
	
	          var header = _react2.default.createElement(
	            'div',
	            { style: { marginLeft: "auto", marginRight: "auto", width: "95%" } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: "bold", fontSize: "1.35vh" } },
	              module.folder.name
	            ),
	            _react2.default.createElement('hr', { style: { backgroundColor: "white" } })
	          );
	
	          var pills = _react2.default.createElement(
	            'div',
	            { key: "module" + moduleIndex },
	            header,
	            renderedStories
	          );
	          return pills;
	        } else {
	          return _react2.default.createElement('div', { key: moduleIndex });
	        }
	      });
	
	      return renderedPills;
	    };
	
	    _this.renderPillsRow = function (row, moduleIndex, storySetIndex) {
	      var dummyStories = [];
	
	      if (row.length === 0) {
	        return null;
	      }
	      var storySet = row.map(function (innerrow, pillIndex) {
	        _this._renderPillCount = _this._renderPillCount + 1;
	        var myCount = _this._renderPillCount;
	        return _react2.default.createElement(
	          'div',
	          { key: "pill" + pillIndex, ref: function ref(el) {
	              return _this._storyPillsRefs[myCount] = { moduleIndex: moduleIndex, pillIndex: pillIndex, storySetIndex: storySetIndex, el: el };
	            }, style: { display: 'inline-block' } },
	          _this.renderPillsStory(innerrow, pillIndex, moduleIndex, storySetIndex)
	        );
	      });
	
	      if (row.length < 3) {
	        var itemsLeft = 3 - row.length;
	        var unit = _this.props.screen.r9_16.p10 / _this.props.screensNumber;
	        for (var i = 0; i < itemsLeft; i++) {
	          var marginRight = i === itemsLeft - 1 ? 0 : unit * .175;
	          dummyStories.push(_react2.default.createElement('div', { key: row.length - i, style: { display: "inline-block", width: "15.416666667vh", marginRight: marginRight } }));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        storySet,
	        dummyStories
	      );
	    };
	
	    _this.renderPillsStory = function (row, pillIndex, moduleIndex, storySetIndex) {
	      var unit = _this.props.screen.r9_16.p10 / _this.props.screensNumber;
	      var marginRight = pillIndex === 2 ? 0 : unit * .175;
	      var mult = .8;
	      return _react2.default.createElement(
	        'div',
	        { style: { marginRight: marginRight, display: 'inline-block' } },
	        _react2.default.createElement(_InfoBlockMiami2.default, {
	          arrowIcon: _this._backButton,
	          imgsrc: (0, _shared.dp)(_this.props.screen, _lodash2.default.get(row, 'contents.images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' }),
	          imageHeight: unit * 2 * mult,
	          infoHeight: "4.6875vh",
	          width: "15.416666667vh",
	          unit: unit * mult,
	          text: row.name,
	          infoColor: "black",
	          infoBackgroundColor: 'white',
	          fontFamily: 'opensans-regular',
	          fontSize: unit * 0.15
	        })
	      );
	    };
	
	    _this.renderSimple = function (results) {
	      var renderedSimple = results.map(function (module, i) {
	        if (module.stories.length > 0) {
	          var header = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: "bold", fontSize: "1.35vh" } },
	              module.display_module.name
	            ),
	            _react2.default.createElement('hr', { style: { backgroundColor: "white" } })
	          );
	
	          var renderedStories = module.stories.map(function (row, j) {
	            var unit = _this.props.screen.r9_16.p10;
	
	            var boxStyle = {
	              paddingLeft: '3.375vh',
	              paddingRight: '3.375vh',
	              paddingTop: '1.96875vh',
	              paddingBottom: '1.96875vh',
	              width: "100%"
	            };
	
	            return _react2.default.createElement(
	              'div',
	              { key: j, style: { display: "table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 } },
	              _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, boxStyle, { display: "table-cell" }) },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginTop: '1.125vh', position: 'relative', fontSize: "2.1875vh" } },
	                  row.name
	                ),
	                _react2.default.createElement('hr', { style: { backgroundImage: "url(/img/miami/general/rainbowuistrip_dark.png)", backgroundSize: "cover", backgroundPosition: "center", height: "0.098958333vh" } }),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '.9vh', lineHeight: '140%', fontFamily: "opensans" } },
	                  row.contents.story
	                )
	              ),
	              _react2.default.createElement('br', null)
	            );
	          });
	
	          var pills = _react2.default.createElement(
	            'div',
	            { key: i },
	            header,
	            renderedStories
	          );
	
	          return pills;
	        }
	
	        return null;
	      });
	
	      return renderedSimple;
	    };
	
	    _this.renderSimpleWithPictures = function () {
	      return null;
	    };
	
	    _this.renderVideos = function () {
	      return null;
	    };
	
	    _this.renderResults = function (results) {
	      _this._renderPillCount = -1;
	      _this._pills = [];
	      _this._simple = [];
	      _this._simpleWithPictures = [];
	      _this._videos = [];
	
	      for (var property in results) {
	
	        switch (property) {
	          case "donor_stories_pill":
	            _this._pills.push(_this.renderPills(results[property]));
	            break;
	          case "donor_stories_text_block":
	            _this._simple.push(_this.renderSimple(results[property]));
	            break;
	          case "donor_stories_text_block_picture":
	            _this._simpleWithPictures.push(_this.renderSimpleWithPictures(results[property]));
	            break;
	          case "videos":
	            _this._videos.push(_this.renderVideos(results[property]));
	            break;
	          default:
	            console.log("Not Found");
	            break;
	        }
	      }
	    };
	
	    _this.renderDonors = function (donorGroups) {
	      var columns = 2;
	      var rows = 6;
	      var fontClass = 'gfont_roboto';
	
	      var categoryWrapStyle = {
	        boxSizing: 'border-box',
	        width: _this.props.screen.screenWidth * 0.78838174273858921162,
	        color: "black",
	        background: "white",
	        // height: this.props.screen.r9_16.height * .5,
	        paddingBottom: _this.props.screen.screenHeight * 0.01875,
	        paddingTop: _this.props.screen.screenHeight * 0.02893518518518518519,
	        borderRadius: 10,
	        paddingLeft: _this.props.screen.screenWidth * 0.074074074,
	        paddingRight: _this.props.screen.screenWidth * 0.074074074,
	        marginBottom: _this.props.screen.screenHeight * 0.03125
	      };
	
	      var renderedDonors = donorGroups.map(function (donorsByModule, k) {
	        var header = null;
	        var donorFullPageWidth = _this.props.screen.screenWidth * 0.78838174273858921162 - _this.props.screen.screenWidth * 0.074074074 * 2;
	        if (donorsByModule.group.length > 0) {
	          header = _react2.default.createElement(
	            'div',
	            { style: { marginLeft: "auto", marginRight: "auto", width: "95%" } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontWeight: "bold", fontSize: "1.35vh", width: "95%" } },
	              donorsByModule.name
	            ),
	            _react2.default.createElement('hr', { style: { backgroundColor: "white" } })
	          );
	        }
	
	        var donorGroups = donorsByModule.group.map(function (group, i) {
	          // let height = (Math.ceil(group.donors.length / columns) * this.props.screen.screenHeight * 0.115 / rows) + (this.props.screen.screenHeight * 0.021875) + categoryWrapStyle.paddingTop * 2 + categoryWrapStyle.paddingBottom * 2;
	          // let donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - (this.props.screen.screenWidth * 0.074074074 * 2);
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { display: "flex", alignItems: "center", justifyContent: "center" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'opensans-regular', style: Object.assign({}, categoryWrapStyle) },
	              donorsByModule.hideTitle === false ? _react2.default.createElement(
	                'div',
	                { style: { paddingLeft: _this.props.screen.screenHeight * .01562, fontSize: _this.props.screen.screenHeight * 0.021875 } },
	                _react2.default.createElement(
	                  'h1',
	                  { style: { fontSize: _this.props.screen.screenHeight * 0.021875 } },
	                  group.name
	                )
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_DonorFullPage2.default, {
	                  height: _this.props.screen.screenHeight * 0.115,
	                  width: donorFullPageWidth,
	                  columns: columns,
	                  rows: rows,
	                  fontClass: fontClass,
	                  donorData: group.donors,
	                  screen: _this.props.screen,
	                  sort: 'row',
	                  overrideFontSize: 0,
	                  overridePadding: _this.props.screen.screenHeight * .01562,
	                  overrideMarginRight: 0,
	                  custom1x2: '<span />' })
	              )
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { key: k },
	          header,
	          donorGroups
	        );
	      });
	
	      _this._donors = renderedDonors;
	    };
	
	    _this.renderBackButton = function () {
	      return _react2.default.createElement(_BackButtonMiami2.default, {
	        colorPallette: _this._colorPallette,
	        backButton: _this._backButton,
	        unit: _this.props.screen.r9_16.p10 / _this.props.screensNumber,
	        width: '3.375vh',
	        height: _MiamiConstants2.default.backButtonHeight,
	        top: '56.46875vh',
	        border: '0.84375vh',
	        clickAction: _this.handleBack,
	        text: 'back',
	        mode: _this._mode });
	    };
	
	    _this.state = {
	      text: "",
	      module: _this.props.module,
	      virtual_keyboard_mode: 0,
	      iScrollInitialized: false,
	      scrollContainerHeight: "50vh",
	      storyRefs: [],
	      hideKeyboard: false,
	      emailSent: false,
	      showInvalidEmail: false,
	      search: false
	    };
	
	    _this._simple = null;
	    _this._simpleWithPictures = null;
	    _this._videos = null;
	    _this._donors = null;
	    _this._pills = null;
	    _this._resultsContainer = null;
	    _this._emailSentTimeout = null;
	    _this._clearInvalidEmailTimeout = null;
	    _this._pillsStorySetsByModules = [];
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.deleteText = _this.deleteText.bind(_this);
	    _this.normalMode = _this.normalMode.bind(_this);
	    _this.capitalMode = _this.capitalMode.bind(_this);
	    _this.submitText = _this.submitText.bind(_this);
	    _this._colorPallette = "golisano";
	    _this._backButton = null;
	
	    _this.getTimelineModule();
	
	    //Refs
	    _this._storyPillsRefs = [];
	    return _this;
	  }
	
	  _createClass(UserInputMiami, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.search === false && this.state.search === true) {
	        this.props.activateSwipeAnimation();
	        this.checkSwipeAnimation();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.cancelSwipeAnimation();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _shared.checkData)(this.props.module, this.props.screen.entry_point);
	      this._emailSentTimeout = null;
	      clearTimeout(this._emailSentTimeout);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if ((0, _shared.shallowEqual)(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._emailSentTimeout);
	      clearTimeout(this._clearInvalidEmailTimeout);
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(val) {
	      if (typeof val === "function") {
	        val();
	      } else {
	        var str = this.state.text + val;
	        if (str.length < 40) {
	          this.setState({
	            text: str
	          });
	        }
	      }
	    }
	  }, {
	    key: 'normalMode',
	    value: function normalMode() {
	      this.setState({
	        virtual_keyboard_mode: 0
	      });
	    }
	  }, {
	    key: 'capitalMode',
	    value: function capitalMode() {
	      this.setState({
	        virtual_keyboard_mode: 1
	      });
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText() {
	      if (this.state.text.length > 0) {
	        var str = this.state.text.substring(0, this.state.text.length - 1);
	        this.setState({
	          text: str
	        });
	      }
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(email) {
	      // eslint-disable-next-line
	      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(email);
	    }
	  }, {
	    key: 'submitText',
	    value: function submitText() {
	      var _this2 = this;
	
	      this.setState({
	        iScrollInitialized: false
	      });
	
	      var type = _lodash2.default.get(this.props.module, 'contents.custom_fields.folder_type.val.value', null);
	      if (type === "be_the_change") {
	        if (!this.validateEmail(this.state.text)) {
	          this.setState({
	            showInvalidEmail: true
	          });
	          clearTimeout(this._clearInvalidEmailTimeout);
	          this._clearInvalidEmailTimeout = null;
	          this._clearInvalidEmailTimeout = setTimeout(function () {
	            _this2.setState({
	              showInvalidEmail: false
	            });
	          }, 2000);
	          return;
	        }
	        _axios2.default.get(_config2.default.WEB_SERVER + "/display/submituserinput", {
	          params: {
	            display: this.props.content.id,
	            text: this.state.text,
	            authkey: _config2.default.AUTHKEY
	          }
	        }).then(function (response) {
	          _this2.setState({
	            hideKeyboard: true
	          });
	
	          _this2._emailSentTimeout = null;
	          clearTimeout(_this2._emailSentTimeout);
	          _this2._emailSentTimeout = setTimeout(function () {
	            _this2.setState({
	              emailSent: true
	            });
	          }, 500);
	        }).catch(function (error) {
	          _this2.setState({
	            emailSent: false,
	            hideKeyboard: false
	          });
	        });
	      } else if (type === "search") {
	        (function () {
	          _this2._pillsStorySetsByModules = [];
	          _this2._storyPillsRefs = [];
	          _this2._storyPillsRefs.length = 0;
	
	          var rootFolderId = _lodash2.default.get(_this2.props.content, 'settings.selected_root_folder', null);
	          var donorSearchResults = _donorHelpers2.default.searchInFolderDonorLists(_this2.props.content.story_categories, _this2.props.donors, _this2.state.text, Number(rootFolderId));
	          var storiesResult = _dataHelpers2.default.searchStory(_this2.props.content, _this2.state.text, []);
	          var orderedStoriesResult = _lodash2.default.orderBy(storiesResult, ['sorting_name', 'asc']);
	          var menu = _this2.props.content.story_categories.find(function (folder) {
	            var folderType = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	            return folder.parent_category === Number(rootFolderId) && folderType === "menu";
	          });
	          var menuItems = _this2.props.content.story_categories.filter(function (folder) {
	            return folder.parent_category === menu.id;
	          });
	          var results = {};
	
	          var _loop2 = function _loop2(j) {
	            var type = _lodash2.default.get(menuItems[j], 'contents.custom_fields.folder_type.val.value', null);
	            if (type === "donor_stories_pill") {
	              if (!results[type]) {
	                results[type] = [];
	              }
	              var folderModules = _this2.props.content.folder_modules.filter(function (fm) {
	                return fm.folder === menuItems[j].id;
	              }).map(function (fm) {
	                return fm.module_id;
	              });
	              var foundStories = orderedStoriesResult.filter(function (story) {
	                return folderModules.indexOf(story.id) > -1;
	              });
	              if (foundStories.length) {
	                results[type].push({
	                  folder: menuItems[j],
	                  stories: foundStories
	                });
	              }
	            }
	          };
	
	          for (var j = 0; j < menuItems.length; j++) {
	            _loop2(j);
	          }
	
	          var donorResults = [];
	
	          var _loop3 = function _loop3(i) {
	            var folder = _this2.props.content.story_categories.find(function (folder) {
	              return folder.id === donorSearchResults.foundFolders[i];
	            });
	            var parent = _this2.props.content.story_categories.find(function (fParent) {
	              return fParent.id === folder.parent_category;
	            });
	            var donors = donorSearchResults.foundDonors.filter(function (donor) {
	              return donor.folder_module.folder === folder.id;
	            });
	            var index = donorResults.findIndex(function (r) {
	              return r.id === parent.id;
	            });
	            var hideTitle = _lodash2.default.get(folder, 'contents.custom_fields.hide_title.val', false);
	            if (index > -1) {
	              donorResults[index].group.push({ name: folder.name, rank: folder.rank, donors: donors, hideTitle: hideTitle });
	            } else {
	              donorResults.push({
	                id: parent.id,
	                name: parent.name,
	                rank: parent.rank,
	                hideTitle: hideTitle,
	                group: [{
	                  name: folder.name,
	                  rank: folder.rank,
	                  donors: donors
	                }]
	              });
	            }
	          };
	
	          for (var i = 0; i < donorSearchResults.foundFolders.length; i++) {
	            _loop3(i);
	          }
	
	          _this2.renderResults(results);
	          _this2.renderDonors(donorResults);
	
	          var countResults = donorResults.length;
	          for (var storyType in results) {
	            if (results[storyType] && results[storyType].length > 0) {
	              countResults++;
	            }
	          }
	
	          _this2.setState({
	            search: true,
	            pills: _this2._pills,
	            simpleWithPictures: _this2._simpleWithPictures,
	            simple: _this2._simple,
	            videos: _this2._videos,
	            donors: _this2._donors,
	            searchHasResults: countResults > 0 ? true : false
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var backgroundImage = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	      var rootFolderId = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	      var rootFolder = this.props.content.story_categories.find(function (folder) {
	        return folder.id === Number(rootFolderId);
	      });
	      var menu = this.props.content.story_categories.find(function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return folder.parent_category === Number(rootFolderId) && type === "menu";
	      });
	      this._backButton = (0, _shared.dp)(this.props.screen, _lodash2.default.get(menu, 'contents.images[0]', null), null);
	      this._colorPallette = _lodash2.default.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
	      var colorPallette = this._colorPallette;
	      var fontColor = "#95268E";
	      var className = "kspn";
	      if (this._colorPallette === "adaptive") {
	        className = "kspn-primary";
	        fontColor = "#000";
	      }
	
	      var mod = .6;
	
	      var keystd = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.9 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: ".98vh"
	      };
	
	      var keyspace = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: ".98vh"
	      };
	
	      var keycom = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: ".98vh"
	      };
	
	      var keysubmit = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.5 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	      };
	
	      var unit = this.props.screen.r9_16.p10;
	      var textAlign = this.state.text.length > 0 ? "center" : "left";
	
	      var boxStyle = {
	        paddingLeft: '3.375vh',
	        paddingRight: '3.375vh',
	        paddingTop: '1.96875vh',
	        paddingBottom: '1.96875vh',
	        width: "100%"
	        // const horizontalRadius = this.props.screen.screenHeight * .00520833333333333333;
	        // const verticalRadius = this.props.screen.screenHeight * .00651041666666666667;
	      };var margins = {
	        descriptionTop: this.props.screen.screenHeight * .00651041666666666667
	
	        //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.
	
	      };var type = _lodash2.default.get(this.props.module, 'contents.custom_fields.folder_type.val.value', null);
	      if (!this.props.module) {
	        return _react2.default.createElement('span', null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showModal, style: { zIndex: 99999 } },
	            this.state.showModal ? _react2.default.createElement(_StoryMiami2.default, {
	              screen: this.props.screen,
	              screensNumber: this.props.screensNumber,
	              navRoute: this.props.navRoute,
	              stories: this.props.content.stories,
	              background: this.getBackgroundImage(),
	              backgroundEnabled: true,
	              mode: 'image',
	              clickAction: this.handleBack,
	              contentIndex: this.state.storyIndex }) : null,
	            this.state.showModal ? this.renderBackButton() : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	              _react2.default.createElement('div', { style: { height: "4vh" } }),
	              _react2.default.createElement('img', { alt: 'icon', src: iconImage, style: { width: '16vh' } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '3.6vh' } },
	              this.props.module.name.toUpperCase()
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center" } },
	              this.props.module.description
	            ),
	            _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: unit * .25, top: "26.979166667vh", left: 0 } }),
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                className: 'containerFade',
	                style: { minHeight: '100%' },
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: this.state.showInvalidEmail, style: { zIndex: 99999 } },
	                this.state.showInvalidEmail ? _react2.default.createElement(
	                  'div',
	                  { style: { height: '100vh', width: '56vh', display: "flex", justifyContent: "center" } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: '3vh', display: 'inline-block', width: '35vh', height: "3vh", border: "0.3125vh", borderStyle: "solid", opacity: .9, borderColor: "#FFFFFF", backgroundColor: '#FFFFFF', borderRadius: this.props.screen.r9_16.p10 * 0.8 } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { height: "3vh", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "1.6vh", color: "red" } },
	                      'Please enter a valid email address.'
	                    )
	                  )
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: this.state.hideKeyboard },
	                !this.state.hideKeyboard ? _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('div', { style: { height: '8.3vh' } }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: "flex", justifyContent: "center" } },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'inline-block', width: '45vh', height: "5.83vh", border: "0.3125vh", borderStyle: "solid", borderColor: "#FFFFFF", borderRadius: this.props.screen.r9_16.p10 * 0.8 } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: "6.16667vh", display: 'flex', alignItems: 'center', justifyContent: textAlign, fontSize: "1.6vh", color: "white", float: "left", width: "90%" } },
	                        this.state.text.length > 0 ? _react2.default.createElement(
	                          'div',
	                          null,
	                          '\xA0',
	                          this.state.text,
	                          '\xA0'
	                        ) : _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: "2.5vh", fontWeight: "bold" } },
	                          type === "be_the_change" ? _react2.default.createElement(
	                            'div',
	                            { style: { marginLeft: "2.34vh" } },
	                            'Enter your Email Address'
	                          ) : _react2.default.createElement(
	                            'div',
	                            { style: { marginLeft: "6vh" } },
	                            'Enter a donor name'
	                          )
	                        ),
	                        type === "search" ? _react2.default.createElement(_reactFontawesome2.default, { style: { fontSize: "2.5vh", position: "absolute", left: "7.8125vh" }, name: 'search' }) : null
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { onClick: this.removeInputText, style: { height: "4.166666667vh", display: 'flex', fontSize: "2vh", color: "white", float: "right", paddingTop: "1.9375vh", paddingRight: "2vh", fontWeight: "bold" } },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { color: 'black', width: '85%', height: "30vh", display: "block", marginLeft: "auto", marginRight: "auto" } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'helem', style: { position: "relative", paddingTop: "2vh" } },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [1, 1, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [1, 1, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [2, 2, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [2, 2, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [3, 3, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [3, 3, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [4, 4, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [4, 4, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [5, 5, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [5, 5, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [6, 6, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [6, 6, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [7, 7, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [7, 7, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [8, 8, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [8, 8, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [9, 9, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [9, 9, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [0, 0, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [0, 0, null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [this.deleteText, this.deleteText, this.deleteText], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['DELETE', 'DELETE', 'DELETE'] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['q', 'Q', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['q', 'Q', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['w', 'W', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['w', 'W', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['e', 'E', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['e', 'E', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['r', 'R', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['r', 'R', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['t', 'T', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['t', 'T', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['y', 'Y', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['y', 'Y', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['u', 'U', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['u', 'U', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['i', 'I', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['i', 'I', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['o', 'O', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['o', 'O', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['p', 'P', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['p', 'P', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['@', null, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['@', '@', null] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['a', 'A', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['a', 'A', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['s', 'S', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['s', 'S', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['d', 'D', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['d', 'D', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['f', 'F', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['f', 'F', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['g', 'G', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['g', 'G', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['h', 'H', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['h', 'H', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['j', 'J', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['j', 'J', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['k', 'K', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['k', 'K', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['l', 'L', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['l', 'L', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['_', '_', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['_', '_', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['&', '&', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['&', '&', null] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['z', 'Z', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['z', 'Z', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['x', 'X', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['x', 'X', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['c', 'C', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['c', 'C', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['v', 'V', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['v', 'V', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['b', 'B', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['b', 'B', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['n', 'N', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['n', 'N', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['m', 'M', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['m', 'M', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['.', '.', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['.', '.', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['-', '-', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['-', '-', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['*', '*', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['*', '*', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['?', '?', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['?', '?', null] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          { style: keystd },
	                          _react2.default.createElement(
	                            'span',
	                            { className: className },
	                            '=/#'
	                          )
	                        ),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [this.capitalMode, this.normalMode, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['UPCASE', 'DOWNCASE', null] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: [' ', ' ', ' '], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keyspace, contents: ['Space', 'Space', 'Space'] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, keyval: ['.com', '.com', '.com'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keycom, contents: ['.com', '.com', '.com'] }),
	                        _react2.default.createElement(_KeyboardKeyMiami2.default, { colorPallette: colorPallette, searchStr: this.searchStr, keyval: ['Submit', 'Submit', 'Submit'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.submitText, mainstyle: keysubmit, contents: ['Submit', 'Submit', 'Submit'] })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                      component: 'div',
	                      className: 'containerFade',
	                      style: { minHeight: '100%' },
	                      transitionName: 'example',
	                      transitionEnterTimeout: 0,
	                      transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                      'div',
	                      { ref: function ref(el) {
	                          return _this3._wrapperDiv = el;
	                        }, key: this.state.search, style: { width: "90%", marginLeft: "auto", marginRight: "auto", position: "relative", height: "39.2vh", touchAction: "none" } },
	                      this.state.search ? _react2.default.createElement(
	                        _reactIscroll2.default,
	                        { ref: function ref(el) {
	                            return _this3.iScroller = el;
	                          }, iScroll: _iscroll2.default,
	                          onScrollStart: this.handleScrollStart,
	                          options: {
	                            mouseWheel: true,
	                            scrollbars: false,
	                            scrollX: false,
	                            scrollY: true,
	                            probeType: 2,
	                            bounce: false,
	                            momentum: true,
	                            deceleration: 0.005,
	                            useTransition: true,
	                            disableTouch: false,
	                            disablePointer: false,
	                            disableMouse: false,
	                            tap: true
	                          },
	                          onRefresh: this.initializeIScroll
	                        },
	                        _react2.default.createElement(
	                          'div',
	                          { ref: function ref(el) {
	                              return _this3._innerDivRef = el;
	                            } },
	                          this.state.searchHasResults ? _react2.default.createElement(
	                            'div',
	                            null,
	                            this.state.donors,
	                            this.state.pills,
	                            this.state.simple
	                          ) : _react2.default.createElement(
	                            'div',
	                            { key: this.state.searchHasResults, style: { height: "6vh", backgroundColor: "white", position: "relative", top: "5vh", width: "85%", margin: "0 auto", borderRadius: this.props.screen.screenWidth * .03472222222222222222, paddingTop: "3vh", paddingBottom: "3vh", display: "table", verticalAlign: "middle" } },
	                            _react2.default.createElement(
	                              'div',
	                              { style: { fontFamily: "open-sans-regular", fontSize: this.props.screen.screenHeight * .02199074074074074074, textAlign: "center", width: "100%", color: fontColor, display: "table-row" } },
	                              'Sorry, no results for "',
	                              this.state.text,
	                              '".'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'opensans-regular', style: { display: "table-row", fontFamily: "open-sans-regular", fontSize: this.props.screen.screenHeight * .02199074074074074074, maxHeight: "6vh", overflow: "hidden", textAlign: "center", width: "100%", marginTop: margins.descriptionTop, WebkitLineClamp: 3, WebkitBoxOrient: "vertical", color: fontColor } },
	                              'Click the "X" in the text box to start a new search.'
	                            )
	                          ),
	                          _react2.default.createElement('div', { style: { height: "9vh" } })
	                        )
	                      ) : null
	                    )
	                  )
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              this.state.emailSent ? _react2.default.createElement(
	                'div',
	                { key: this.state.emailSent },
	                _react2.default.createElement('div', { style: { height: "11vh" } }),
	                _react2.default.createElement(
	                  'div',
	                  { style: { margin: "auto", width: this.props.screen.screenWidth / this.props.screensNumber * 0.85, display: "table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: Object.assign({}, boxStyle, { display: "table-cell" }) },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { marginTop: '1.125vh', position: 'relative', fontSize: "2.1875vh" } },
	                      'Thank you'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { style: { fontSize: '.9vh', lineHeight: '140%', fontFamily: "opensans" } },
	                      'We have received your email and will be in touch. Thank you for your interest'
	                    )
	                  ),
	                  _react2.default.createElement('div', { style: { height: "2vh" } }),
	                  _react2.default.createElement('br', null)
	                ),
	                this.beTheChange()
	              ) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserInputMiami;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(UserInputMiami);

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoMiami = function (_Component) {
	  _inherits(VideoMiami, _Component);
	
	  function VideoMiami(props) {
	    _classCallCheck(this, VideoMiami);
	
	    var _this = _possibleConstructorReturn(this, (VideoMiami.__proto__ || Object.getPrototypeOf(VideoMiami)).call(this, props));
	
	    _this.unbindEvents = function () {
	      _this._videoRef.removeEventListener('loadedmetadata', _this.loadedMetadata);
	      _this._videoRef.removeEventListener('loadeddata', _this.loadedData);
	      _this._videoRef.removeEventListener('ended', _this.props.clickAction);
	    };
	
	    _this.initPlayer = function () {
	      var player = _this._videoRef;
	      player.addEventListener('loadedmetadata', _this.loadedMetadata);
	      player.addEventListener('loadeddata', _this.loadedData);
	      player.addEventListener('ended', _this.props.clickAction);
	    };
	
	    _this.getBackgroundImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	
	      if (_this.props.screensNumber === 2) {
	        defaultImg.file_name = 'default_double_screen.jpg';
	      }
	      var folderModule = _this.props.content.folder_modules.find(function (fm) {
	        return fm.id === _this.state.content.folder_module_id;
	      });
	      var parentFolder = _this.props.content.story_categories.find(function (folder) {
	        return folder.id === folderModule.folder;
	      });
	      var backgroundObj = _lodash2.default.get(parentFolder, 'contents.images[2]', null);
	      return _shared2.default.dp(_this.props.screen, backgroundObj, null);
	    };
	
	    _this.loadedMetadata = function () {
	      _this._metadataLoaded = true;
	      _this.checkIfAllDataLoaded();
	    };
	
	    _this.loadedData = function () {
	      _this._dataLoaded = true;
	      _this.checkIfAllDataLoaded();
	    };
	
	    _this.checkIfAllDataLoaded = function () {
	      if (_this._metadataLoaded && _this._dataLoaded) {
	        _this.setState({
	          showVideo: true
	        });
	        _this.positionVideo();
	      }
	    };
	
	    _this.positionVideo = function () {
	      if (!_this._videoRef) {
	        setTimeout(function () {
	          _this.positionVideo();
	        }, 100);
	        return;
	      }
	
	      var videoHeight = _this._videoRef.getBoundingClientRect().height;
	      var videoWidth = _this._videoRef.getBoundingClientRect().width;
	
	      var videoOffsetY = _this.props.screen.screenHeight / 2 - videoHeight / 2;
	      var videoOffsetX = _this.props.screen.screenWidth / 2 - videoWidth / 2;
	
	      if (_this.props.screensNumber === 2) {
	        videoOffsetX = (_this.props.screen.screenWidth / 2 - videoWidth) / 2;
	      }
	
	      var videoControlsOffset = videoOffsetY + videoHeight / 2;
	
	      _this.setState({
	        videoOffsetY: videoOffsetY,
	        videoOffsetX: videoOffsetX,
	        videoControlsOffset: videoControlsOffset,
	        videoFile: _this.props.content.file_path
	      });
	    };
	
	    _this._videoPaused = false;
	    _this._videoRef = null;
	    _this._videoLengthTimeout = null;
	    _this._videoTimeout = null;
	    _this._metadataLoaded = false;
	    _this._dataLoaded = false;
	    _this._currentVideoLength = 0;
	
	    _this.state = {
	      contentIndex: _this.props.contentIndex,
	      content: _this.props.donorsData[_this.props.contentIndex],
	      videoOffsetY: 0,
	      videoOffsetX: 0,
	      showVideo: false
	    };
	    return _this;
	  }
	
	  _createClass(VideoMiami, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initPlayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.contentIndex !== prevProps.contentIndex) {
	        this.unbindEvents();
	        this.setState({
	          contentIndex: this.props.contentIndex,
	          content: this.props.donorsData[this.props.contentIndex],
	          videoOffsetY: 0,
	          videoOffsetX: 0,
	          showVideo: false
	        });
	        this.initPlayer();
	      }
	    }
	  }, {
	    key: 'handleNext',
	    value: function handleNext() {
	      // let nextIndex = shared.loopIndex(this.state.contentIndex, 0, this.props.donorsData.length - 1, 'forward');
	      this.props.handleNext();
	      // this.setState({
	      //   contentIndex: nextIndex,
	      //   content: this.props.donorsData[nextIndex]
	      // });
	    }
	  }, {
	    key: 'handlePrevious',
	    value: function handlePrevious() {
	      // let previousIndex = shared.loopIndex(this.state.contentIndex, 0, this.props.donorsData.length - 1, 'backward');
	      this.props.handlePrevious();
	      // this.setState({
	      //   contentIndex: previousIndex,
	      //   content: this.props.donorsData[previousIndex]
	      // });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _videoStyle = {
	        preload: 'auto',
	        position: 'absolute',
	        maxWidth: '80%',
	        maxHeight: '85%',
	        muted: ""
	      };
	
	      var background = this.getBackgroundImage();
	      var cType = (0, _shared.videoType)(this.state.content.contents.images[1].file_name);
	      var videoSrc = _shared2.default.dp(this.props.screen, this.state.content.contents.images[1]);
	      if (this.props.screensNumber === 2) {
	        _videoStyle.maxWidth = '40%';
	        background = null;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'slowfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.contentIndex, className: 'miami-video', style: { display: this.state.showVideo ? 'block' : 'none' } },
	            _react2.default.createElement(
	              'video',
	              { key: this.state.contentIndex, className: 'videopills', style: Object.assign({}, _videoStyle, { top: this.state.videoOffsetY, left: this.state.videoOffsetX }), ref: function ref(el) {
	                  return _this2._videoRef = el;
	                }, autoPlay: true, controls: true, controlsList: 'nodownload' },
	              _react2.default.createElement('source', { key: this.state.contentIndex, src: videoSrc, type: cType }),
	              'Your browser does not support the video tag.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'relative', top: this.state.videoControlsOffset, display: this.state.showVideo ? 'block' : 'none' }, ref: 'videoControls' },
	          _react2.default.createElement('div', { onMouseDown: function onMouseDown() {
	              return _this2.handlePrevious();
	            }, style: { position: "absolute", left: '0.3vh', width: "5vh", height: "15vh", top: "-5.2083vh" } }),
	          _react2.default.createElement('div', { onMouseDown: function onMouseDown() {
	              return _this2.handleNext();
	            }, style: { position: "absolute", left: '51vh', width: "5vh", height: "15vh", top: "-5.2083vh" } }),
	          _react2.default.createElement(
	            'span',
	            { onMouseDown: function onMouseDown() {
	                return _this2.handlePrevious();
	              }, style: { position: 'absolute', left: '0.7812vh', fontSize: "4vh", fontWeight: 'bold' } },
	            '<'
	          ),
	          _react2.default.createElement(
	            'span',
	            { onMouseDown: function onMouseDown() {
	                return _this2.handleNext();
	              }, style: { position: 'absolute', left: '52.3437vh', fontSize: "4vh", fontWeight: 'bold' } },
	            '>'
	          )
	        ),
	        _react2.default.createElement('div', { style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: "cover", backgroundImage: 'url(' + background + ')' }, onMouseDown: this.props.clickAction })
	      );
	    }
	  }]);
	
	  return VideoMiami;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  return {
	    content: state.content,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(VideoMiami);

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BGWrapper = function (_Component) {
	  _inherits(BGWrapper, _Component);
	
	  function BGWrapper() {
	    _classCallCheck(this, BGWrapper);
	
	    return _possibleConstructorReturn(this, (BGWrapper.__proto__ || Object.getPrototypeOf(BGWrapper)).apply(this, arguments));
	  }
	
	  _createClass(BGWrapper, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { style: { backgroundImage: "url(" + this.props.background + ")", width: this.props.width, height: this.props.height, position: "absolute", backgroundSize: "cover" } });
	    }
	  }]);
	
	  return BGWrapper;
	}(_react.Component);
	
	exports.default = BGWrapper;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewarkRichTextOuput = __webpack_require__(156);
	
	var _NewarkRichTextOuput2 = _interopRequireDefault(_NewarkRichTextOuput);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'newark__ambassador-story-container', style: { backgroundImage: 'url(' + props.backgroundImage + ')' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'newark__ambassador-story-left' },
	      _react2.default.createElement(
	        'div',
	        { className: 'newark__ambassador-story-image-container' },
	        _react2.default.createElement('img', { role: 'presentation', src: props.image, className: 'newark__ambassador-story-image' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'newark__ambassador-story-right' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'newark__ambassador-story-heading-1' },
	        _react2.default.createElement(_BRSpan2.default, { str: props.headline })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'newark__ambassador-story-content' },
	        _react2.default.createElement(_NewarkRichTextOuput2.default, { ops: props.bodyOps })
	      )
	    )
	  );
	};

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _NewarkAmbassadorStory = __webpack_require__(449);
	
	var _NewarkAmbassadorStory2 = _interopRequireDefault(_NewarkAmbassadorStory);
	
	var _NewarkDonorLists = __webpack_require__(454);
	
	var _NewarkDonorLists2 = _interopRequireDefault(_NewarkDonorLists);
	
	var _NewarkFullScreenImage = __webpack_require__(456);
	
	var _NewarkFullScreenImage2 = _interopRequireDefault(_NewarkFullScreenImage);
	
	var _NewarkThankYouMessage = __webpack_require__(457);
	
	var _NewarkThankYouMessage2 = _interopRequireDefault(_NewarkThankYouMessage);
	
	var _NewarkWelcomeMessage = __webpack_require__(458);
	
	var _NewarkWelcomeMessage2 = _interopRequireDefault(_NewarkWelcomeMessage);
	
	var _NewarkDonorList = __webpack_require__(452);
	
	var _NewarkDonorList2 = _interopRequireDefault(_NewarkDonorList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DONOR_LIST_BACKGROUND = "donor_list_background";
	
	var NewarkContainer = function (_Component) {
	  _inherits(NewarkContainer, _Component);
	
	  function NewarkContainer(props) {
	    _classCallCheck(this, NewarkContainer);
	
	    var _this = _possibleConstructorReturn(this, (NewarkContainer.__proto__ || Object.getPrototypeOf(NewarkContainer)).call(this, props));
	
	    _this.startAttractLoopCycle = function () {
	      clearTimeout(_this._cycleTimeoutHandler);
	      var cycleTime = _this._cycles[_this.state.currentIndex];
	      var attractLoopChild = _this._attractLoopTree.children[_this.state.currentIndex];
	      var type = _lodash2.default.get(attractLoopChild, 'contents.custom_fields.folder_type.val.value', null);
	      if (type !== DONOR_LIST_BACKGROUND) {
	        _this._cycleTimeoutHandler = setTimeout(function () {
	          _this.cycle();
	        }, cycleTime * 1000);
	      }
	    };
	
	    _this.cycle = function () {
	      _this.setState(function (prevState) {
	        return {
	          currentIndex: _shared2.default.loopIndex(prevState.currentIndex, 0, _this._cycles.length - 1, "forward")
	        };
	      }, function () {
	        _this.startAttractLoopCycle();
	      });
	    };
	
	    _this.getSlideshowImageObj = function (customFields, attractLoopChild) {
	      var slideshow = Object.keys(customFields).map(function (fieldName) {
	        return customFields[fieldName];
	      }).find(function (_ref) {
	        var type = _ref.type,
	            module = _ref.module;
	        return type === 'module' && module === 'slideshow';
	      });
	
	      if (slideshow) {
	        var moduleId = _lodash2.default.get(slideshow, 'val.value');
	        var slideshowModule = _this.props.content.dm_active.find(function (m) {
	          return m.id === moduleId && m.display_module_type === 'Slideshow';
	        });
	        var slideshowIndex = _lodash2.default.get(attractLoopChild, 'contents.custom_fields.background.child_val.value', 0);
	        var imageObj = _lodash2.default.get(slideshowModule, 'contents.images[' + slideshowIndex + ']');
	        return (0, _shared.dp)(_this.props.screen, imageObj, { path: '/img/ui/', file_name: 'image_default.png' });
	      }
	      return null;
	    };
	
	    _this.getRenderedContent = function () {
	      if (!_this._attractLoopTree) {
	        return null;
	      }
	
	      var attractLoopChild = _this._attractLoopTree.children[_this.state.currentIndex];
	      var customFields = _lodash2.default.get(attractLoopChild, 'contents.custom_fields', {});
	
	      if (attractLoopChild.node_type === "folder") {
	        // Donor lists
	        var useOnlyInnerCycle = _this._attractLoopTree.children.length === 1;
	        var type = _lodash2.default.get(attractLoopChild, 'contents.custom_fields.folder_type.val.value', null);
	        if (type === DONOR_LIST_BACKGROUND) {
	          return _react2.default.createElement(_NewarkDonorList2.default, {
	            key: attractLoopChild.id,
	            module: attractLoopChild,
	            content: _this.props.content,
	            screen: _this.props.screen,
	            donors: _this.props.donors,
	            width: _this.props.screen.screenWidth,
	            height: _this.props.screen.screenHeight,
	            cycle: _this.cycle,
	            useOnlyInnerCycle: useOnlyInnerCycle
	          });
	        } else {
	          var donorListCategories = _this.props.content.story_categories.filter(function (dl) {
	            return dl.parent_category === attractLoopChild.id;
	          }).sort(function (a, b) {
	            return a.rank - b.rank;
	          });
	          var donorLists = donorListCategories.map(function (donorList) {
	            return Object.assign({}, donorList, {
	              donors: _lodash2.default.orderBy((0, _donorHelpers.getDonorsFromFolder)(_this.props.donors, _this.props.content.folder_modules, donorList.id), ['sorting_name'], ['asc'])
	            });
	          });
	          var title = _lodash2.default.get(customFields, 'title.val');
	          var subtitle = _lodash2.default.get(customFields, 'subtitle.val');
	
	          return _react2.default.createElement(_NewarkDonorLists2.default, { donorLists: donorLists, title: title, subtitle: subtitle });
	        }
	      } else {
	        // Stories
	        var storyType = _lodash2.default.get(customFields, 'story_type.val.value', null);
	        var headline = _lodash2.default.get(customFields, 'headline.val');
	        var body = _lodash2.default.get(customFields, 'body.val');
	        var images = _lodash2.default.get(attractLoopChild, 'contents.images', []).map(function (image) {
	          return (0, _shared.dp)(_this.props.screen, image, { path: '/img/ui/', file_name: 'image_default.png' });
	        });
	
	        var bodyOps = _lodash2.default.get(body, 'ops', []);
	        var backgroundImage = _this.getSlideshowImageObj(customFields, attractLoopChild);
	
	        switch (storyType) {
	          case "welcome_message":
	            return _react2.default.createElement(_NewarkWelcomeMessage2.default, { headline: headline, bodyOps: bodyOps, image: images[0], backgroundImage: backgroundImage });
	
	          case "ambassador_story":
	            return _react2.default.createElement(_NewarkAmbassadorStory2.default, { headline: headline, bodyOps: bodyOps, image: images[0], backgroundImage: backgroundImage });
	
	          case "thank_you_message":
	            return _react2.default.createElement(_NewarkThankYouMessage2.default, { image: images[0], backgroundImage: backgroundImage });
	
	          case "fullscreen_image":
	            return _react2.default.createElement(_NewarkFullScreenImage2.default, { image: images[0] });
	
	          default:
	            return null;
	        }
	      }
	    };
	
	    _this._cycles = [];
	    _this._cycleTimeoutHandler = null;
	    _this.state = {
	      currentIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(NewarkContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var rootFolderId = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	      if (rootFolderId !== null && rootFolderId !== undefined) {
	        rootFolderId = Number(rootFolderId);
	      }
	
	      var rootFolder = this.props.content.story_categories.find(function (f) {
	        return f.id === rootFolderId;
	      });
	      this._attractLoopTree = _shared2.default.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, rootFolder.name, 'rank');
	      var children = this._attractLoopTree.children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        var cycleTime = _lodash2.default.get(child, 'contents.custom_fields.cycle_timeout.val', 10);
	        this._cycles.push(Number(cycleTime));
	      }
	
	      this.startAttractLoopCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._cycleTimeoutHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: 'div',
	          transitionName: 'slowfadedelay',
	          transitionEnterTimeout: 0,
	          transitionLeaveTimeout: 0 },
	        _react2.default.createElement(
	          'div',
	          { key: this.state.currentIndex, className: 'newark__outer-container' },
	          this.getRenderedContent()
	        )
	      );
	    }
	  }]);
	
	  return NewarkContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    screen: state.screen,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(NewarkContainer);

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewarkDonorListItem = __webpack_require__(453);
	
	var _NewarkDonorListItem2 = _interopRequireDefault(_NewarkDonorListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'li',
	    { className: 'newark__donor-list-container' },
	    _react2.default.createElement(
	      'h3',
	      { className: 'newark__donor-list-heading-3' },
	      props.listHeading
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'newark__donor-list' },
	      props.donors.map(function (donor, i) {
	        return _react2.default.createElement(_NewarkDonorListItem2.default, { donor: donor, key: 'donor-list-item-' + i });
	      })
	    )
	  );
	};

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _screenUtils = __webpack_require__(159);
	
	var _shared = __webpack_require__(4);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _BGWrapper = __webpack_require__(448);
	
	var _BGWrapper2 = _interopRequireDefault(_BGWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_CYCLE = 10;
	
	var NewarkDonorList2 = function (_Component) {
	  _inherits(NewarkDonorList2, _Component);
	
	  function NewarkDonorList2(props) {
	    _classCallCheck(this, NewarkDonorList2);
	
	    var _this = _possibleConstructorReturn(this, (NewarkDonorList2.__proto__ || Object.getPrototypeOf(NewarkDonorList2)).call(this, props));
	
	    _this.getBackground = function () {
	      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var module = _this.props.module;
	
	      var imgObj = _lodash2.default.get(module, "contents.images[" + i + "]", null);
	      if (imgObj) {
	        return (0, _shared.dp)({ mode: _this.props.screen.mode }, imgObj, null);
	      }
	      return null;
	    };
	
	    _this.setDonorListStateData = function () {
	      var title = _lodash2.default.get(_this._donorList, "contents.custom_fields.main_header.val", "");
	      var category = _lodash2.default.get(_this._donorList, "description", "");
	      var description = _lodash2.default.get(_this._donorList, "contents.custom_fields.description.val", "");
	
	      _this.setState({
	        listData: {
	          title: title,
	          category: category,
	          description: description
	        }
	      });
	    };
	
	    _this.handlePreRender = function () {
	      if (_this._donorRefs.length > 0 && _this.state.finishedPreRender === false) {
	        var counter = -1;
	        _this._donorList.donors.forEach(function (donor) {
	          counter++;
	          donor.height = _this._donorRefs[counter].offsetHeight;
	          donor.width = _this._donorRefs[counter].offsetWidth;
	        });
	
	        _this._donorContainer = {
	          width: _this._donorContainerRef.offsetWidth,
	          height: _this._donorContainerRef.offsetHeight
	        };
	        _this.setState({
	          finishedPreRender: true
	        });
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "c":
	          _this.cycleDonorIndex();
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.getCategoryStyle = function () {
	      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      style.fontSize = _this.state.height * 0.026;
	      style.fontStyle = "Normal";
	      style.fontFamily = "Lato";
	      style.fontWeight = "100";
	      style.paddingBottom = _this.state.height * 0.008;
	      style.lineHeight = 2.75;
	      style.textAlign = "left";
	      style.fontColor = "#000000";
	
	      return style;
	    };
	
	    _this.preRenderDonors = function () {
	      var flatDonors = [];
	      var columns = _lodash2.default.get(_this._donorList, "contents.custom_fields.columns.val", _lodash2.default.get(_this._donorList, "contents.custom_fields.columns.default", 3));
	      var columnWidth = _this.state.width * 0.8 / columns;
	      var styleObj = _lodash2.default.get(_this._donorList, "contents.custom_fields.donor_name_style", null);
	      var style = (0, _shared.parseTextStyling)(styleObj);
	      // style.lineHeight = "4vh";
	      _this._donorList.donors.forEach(function (donor) {
	        donor.style = style;
	        donor.style.width = columnWidth * 0.9;
	        flatDonors.push(donor);
	      });
	
	      return flatDonors.map(function (donor, i) {
	        return _react2.default.createElement(
	          "div",
	          {
	            key: i,
	            ref: function ref(el) {
	              return _this._donorRefs[i] = el;
	            },
	            style: Object.assign({}, donor.style, { opacity: 0 })
	          },
	          _react2.default.createElement(_BRSpan2.default, { str: donor.name })
	        );
	      });
	    };
	
	    _this.cycleNameSet = function (cycleTimeOverride) {
	      var interstitial = _lodash2.default.get(_this._donorList, "contents.custom_fields.interstitial.val", _lodash2.default.get(_this._donorList, "contents.custom_fields.interstitial.default", false));
	      var cycleTime = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
	
	      if (cycleTimeOverride) {
	        cycleTime = cycleTimeOverride;
	      }
	
	      clearTimeout(_this._donorCycleTimeout);
	
	      if (interstitial && _this._manualSlides && _this._manualSlides.length) {
	        _this.handleInterstitial();
	      } else {
	        _this._background = _this.getBackground();
	        _this.setState({ showDonors: true });
	        _this._donorCycleTimeout = setTimeout(function () {
	          var endOfLoop = _this.cycleDonorIndex();
	          if (!endOfLoop) {
	            _this._background = _this.getBackground();
	            _this.setState({ showDonors: true, showSlides: false });
	            _this.cycleNameSet();
	          } else {
	            if (_this.props.cycle && !_this.props.useOnlyInnerCycle) {
	              _this.props.cycle();
	            } else {
	              _this._donorIndex = 0;
	              _this.cycleNameSet();
	            }
	          }
	        }, cycleTime * 1000);
	      }
	    };
	
	    _this.cycleDonorIndex = function () {
	      if (_this._donorIndex + _this._lastPageCount >= _this._donorList.donors.length) {
	        return true;
	      } else {
	        _this._donorIndex += _this._lastPageCount;
	        return false;
	      }
	    };
	
	    _this.handleInterstitial = function () {
	      var slideTimeout = DEFAULT_CYCLE;
	      var currentSlide = _this._manualSlides.find(function (s) {
	        return s.page === _this._manualSlidesIndex;
	      });
	      var totalSteps = _lodash2.default.get(currentSlide, "page", 0) + _lodash2.default.get(currentSlide, "end", 0) - _lodash2.default.get(currentSlide, "start", 0) + 1;
	      var stepsLeft = totalSteps - _this._manualSlidesInnerIndex;
	
	      if (currentSlide && stepsLeft > 0) {
	        var slidePath = (0, _shared.dpath)(_this.props.screen.mode, _this._slideshowModule.contents.images[_this._manualSlidesInnerIndex].path, _this._slideshowModule.contents.images[_this._manualSlidesInnerIndex].file_name, _this.props.screen.webkey);
	
	        slideTimeout = DEFAULT_CYCLE;
	        var hasCycleOverride = _lodash2.default.has(_this._slideshowModule, "contents.cycle_overrides[" + _this._manualSlidesInnerIndex + "]");
	        if (hasCycleOverride) {
	          slideTimeout = _this._slideshowModule.contents.cycle_overrides[_this._manualSlidesInnerIndex];
	        }
	
	        _this._manualSlidesInnerIndex++;
	        _this._donorCounter++;
	        _this._background = slidePath;
	        _this.setState({
	          showSlides: true,
	          showDonors: false
	        });
	        clearTimeout(_this._interstitialTimeoutHandler);
	        _this._interstitialTimeoutHandler = setTimeout(function () {
	          _this.handleInterstitial();
	        }, slideTimeout * 1000);
	      } else {
	        _this._manualSlidesIndex++;
	        var cycleTime = _lodash2.default.get(_this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
	        _this._background = _this.getBackground();
	        _this._donorCounter++;
	        _this.setState({
	          showDonors: true,
	          showSlides: false
	        });
	        clearTimeout(_this._interstitialTimeoutHandler);
	        _this._interstitialTimeoutHandler = setTimeout(function () {
	          var endOfLoop = _this.cycleDonorIndex();
	          if (endOfLoop) {
	            if (_this.props.cycle) {
	              _this.props.cycle();
	            } else {
	              _this._donorIndex = 0;
	              _this.handleInterstitial();
	            }
	          } else {
	            _this.handleInterstitial();
	          }
	        }, cycleTime * 1000);
	      }
	    };
	
	    _this.renderNames = function () {
	      var donorCategory = _this._donorList;
	      var columns = _lodash2.default.get(donorCategory, "contents.custom_fields.columns.val", _lodash2.default.get(donorCategory, "contents.custom_fields.columns.default", 3));
	      var currentHeight = 0;
	      var currentColumn = 1;
	      var drawDonors = [];
	      var columnWidth = _this._donorContainer.width / columns;
	      _this._lastPageCount = 0;
	
	      for (var a = _this._donorIndex; a < _this._donorList.donors.length; a++) {
	        var donor = _this._donorList.donors[a];
	        //fits in column
	        if (currentHeight + donor.height > _this._donorContainer.height - _this._layout.margin_bottom * _this.state.height) {
	          if (currentColumn < columns) {
	            //reset for new column
	            currentHeight = 0;
	            currentColumn++;
	          } else {
	            break;
	          }
	        }
	
	        donor.top = currentHeight;
	        donor.column = currentColumn;
	        var verticalOffset = _lodash2.default.get(_this.props.module, "contents.custom_fields.donor_vertical_offset.val", _lodash2.default.get(_this.props.module, "contents.custom_fields.donor_vertical_offset.default", 5));
	        currentHeight += donor.height + _this.props.height * Number(verticalOffset) / 100;
	        drawDonors.push(donor);
	        _this._lastPageCount++;
	      }
	
	      var styleObj = _lodash2.default.get(_this._donorList, "contents.custom_fields.donor_name_style", null);
	      var style = (0, _shared.parseTextStyling)(styleObj);
	      // style.lineHeight = "4vh";
	
	      return drawDonors.map(function (item, i) {
	        var left = (item.column - 1) * columnWidth * (1 + _this._layout.donor_margin_left);
	        return _react2.default.createElement(
	          "div",
	          {
	            key: i,
	            style: Object.assign({}, style, {
	              position: "absolute",
	              overflow: "hidden",
	              top: item.top,
	              left: left,
	              opacity: 1,
	              width: columnWidth * 0.9
	            })
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "empty-br" },
	            _react2.default.createElement(_BRSpan2.default, { className: "empty-br", str: item.name })
	          )
	        );
	      });
	    };
	
	    var dims = (0, _screenUtils.bestFit)(1920, 1080, props.width || 1920, props.height || 1080);
	
	    _this.state = {
	      listData: {
	        donors: [],
	        title: "",
	        category: "",
	        description: "",
	        cycleIndex: 0
	      },
	      slide: "",
	      background: "",
	      timestamp: null,
	      finishedPreRender: false,
	      fadeIn: true,
	      width: dims.width,
	      height: dims.height,
	      showDonors: false,
	      showSlides: false
	    };
	
	    _this._background = null;
	    _this._interstitialTimeoutHandler = null;
	    _this._donorCounter = 0;
	    _this._manualSlidesIndex = 0;
	    _this._manualSlidesInnerIndex = 0;
	    _this._donorCycleTimeout = null;
	    _this.donorList = null;
	    _this._donorRefs = [];
	    _this._underlineRef = null;
	    _this._donorContainerRef = null;
	    _this._donorContainer = {
	      height: 0,
	      width: 0
	    };
	    _this._donorIndex = 0;
	    _this._categoryIndex = 0;
	    _this._lastPageCount = 0;
	    // this._cycle_time = 5000;
	
	    _this._layout = {
	      margin_left: 0.05,
	      margin_bottom: 0.1,
	      title_offset: 0.025,
	      description_offset: 0.1,
	      names_offset: 0.125
	    };
	    return _this;
	  }
	
	  _createClass(NewarkDonorList2, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var donors = (0, _donorHelpers.getDonorsFromFolder)(this.props.donors, this.props.content.folder_modules, this.props.module.id);
	      donors = _lodash2.default.orderBy(donors, [function (d) {
	        return d.sorting_name.toLowerCase();
	      }], ["asc"]);
	      this._donorList = Object.assign({}, this.props.module, { donors: donors });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var columns = _lodash2.default.get(this._donorList, "contents.custom_fields.columns.val", _lodash2.default.get(this._donorList, "contents.custom_fields.columns.default", 2));
	      var marginLeft = _lodash2.default.get(this._donorList, "contents.custom_fields.margin_left.val", _lodash2.default.get(this._donorList, "contents.custom_fields.margin_left.default", 0));
	      var donorMarginLeft = _lodash2.default.get(this._donorList, "contents.custom_fields.donor_margin_left.val", _lodash2.default.get(this._donorList, "contents.custom_fields.donor_margin_left.default", 0));
	      var topOffset = _lodash2.default.get(this._donorList, "contents.custom_fields.top_offset.val", _lodash2.default.get(this._donorList, "contents.custom_fields.top_offset.default", 0));
	      var titleOffset = _lodash2.default.get(this._donorList, "contents.custom_fields.title_offset.val", _lodash2.default.get(this._donorList, "contents.custom_fields.title_offset.default", 2.5));
	      var descriptionOffset = _lodash2.default.get(this._donorList, "contents.custom_fields.description_offset.val", _lodash2.default.get(this._donorList, "contents.custom_fields.description_offset.default", 0));
	      var containerWidth = _lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_width.val", _lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_width.default", 80));
	      var containerHeight = _lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_height.val", _lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_height.default", 65));
	
	      var slides = _lodash2.default.get(this._donorList, "contents.arrays_values.slides", []);
	      var slideshowModuleId = _lodash2.default.get(this._donorList, "contents.custom_fields.slideshow.val.value", null);
	      if (slideshowModuleId) {
	        var slideshowModule = this.props.content.dm_active.find(function (dm) {
	          return dm.id === slideshowModuleId;
	        });
	        if (slideshowModule) {
	          this._slideshowModule = slideshowModule;
	          var manualSlides = slides.map(function (s) {
	            return {
	              page: Number(s.page.val),
	              start: Number(s.start_slide.val),
	              end: Number(s.end_slide.val)
	            };
	          });
	          this._manualSlides = manualSlides;
	        }
	      }
	
	      this._layout.columns = columns / 100;
	      this._layout.margin_left = marginLeft / 100;
	      this._layout.donor_margin_left = donorMarginLeft / 100;
	      this._layout.names_offset = topOffset / 100;
	      this._layout.title_offset = titleOffset / 100;
	      this._layout.description_offset = descriptionOffset / 100;
	      this._layout.container_width = containerWidth / 100;
	      this._layout.container_height = containerHeight / 100;
	
	      try {
	        document.addEventListener("keydown", this.handleKeyDown);
	        setTimeout(function () {
	          _this2.handlePreRender();
	          _this2.setDonorListStateData();
	          _this2.cycleNameSet();
	        }, 500);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
	        var dims = (0, _screenUtils.bestFit)(1920, 1080, this.props.width, this.props.height);
	        this.setState({
	          width: dims.width,
	          height: dims.height
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this._donorCycleTimeout);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      if (!this._donorList || !this._donorList.donors || !this._donorList.donors.length) {
	        return null;
	      }
	      var margin_left = this.state.width * this._layout.margin_left;
	      var title_offset = this.state.height * this._layout.title_offset;
	      var description_offset = this.state.height * this._layout.description_offset;
	      var names_offset = this.state.height * this._layout.names_offset;
	
	      var titleStyleObj = _lodash2.default.get(this._donorList, "contents.custom_fields.parent_category_name", null);
	      var titleStyle = (0, _shared.parseTextStyling)(titleStyleObj);
	      var subheaderStyleObj = _lodash2.default.get(this._donorList, "contents.custom_fields.subcategory_name", null);
	      var subheaderStyle = (0, _shared.parseTextStyling)(subheaderStyleObj);
	      // const deceased = _.get(this._donorList, 'contents.custom_fields.deceased.val', false);
	      // const underline = _.get(this._donorList, 'contents.custom_fields.horizontal_line.val', _.get(this._donorList, 'contents.custom_fields.horizontal_line.default', false));
	      var containerWidth = this.state.width * Number(_lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_width.val", _lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_width.default", 80))) / 100;
	      var containerHeight = this.state.height * Number(_lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_height.val", _lodash2.default.get(this._donorList, "contents.custom_fields.donor_container_height.default", 65))) / 100;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: "div",
	            transitionName: "slowfade",
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0
	          },
	          _react2.default.createElement(
	            "div",
	            { key: this._donorCounter },
	            _react2.default.createElement(_BGWrapper2.default, {
	              width: this.state.width,
	              height: this.state.height,
	              background: this._background
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              position: "absolute",
	              width: this.state.width,
	              height: this.state.height,
	              left: margin_left
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              ref: function ref(el) {
	                return _this3._donorContainerRef = el;
	              },
	              style: {
	                position: "absolute",
	                width: containerWidth,
	                height: containerHeight,
	                zIndex: 1,
	                top: names_offset,
	                opacity: 1
	              }
	            },
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: "div",
	                transitionName: "slowfade",
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0
	              },
	              this.state.finishedPreRender && this.state.showDonors ? _react2.default.createElement(
	                "div",
	                {
	                  key: "donor-index" + this._donorIndex + "-category-index-" + this._categoryIndex
	                },
	                this.renderNames()
	              ) : this.preRenderDonors()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: "div",
	            transitionName: "slowfade",
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0
	          },
	          _react2.default.createElement(
	            "div",
	            { key: this._donorCounter },
	            this.state.showDonors ? _react2.default.createElement(
	              "div",
	              {
	                key: this._donorCounter,
	                style: {
	                  position: "absolute",
	                  width: this.state.width,
	                  height: this.state.height,
	                  left: margin_left
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    position: "absolute",
	                    top: title_offset,
	                    width: this.state.width * 0.9,
	                    height: this.state.height * 0.05
	                  }
	                },
	                this.state.listData && this.state.listData.title ? _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { style: titleStyle },
	                    this.state.listData.title
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      style: Object.assign({}, subheaderStyle, {
	                        position: "absolute",
	                        top: description_offset
	                      })
	                    },
	                    this.state.listData.category
	                  )
	                ) : null
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewarkDonorList2;
	}(_react.Component);
	
	exports.default = NewarkDonorList2;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'newark__donor-list-item', key: 'donor-list-item-' + props.donor.id },
	    _react2.default.createElement(_BRSpan2.default, { str: props.donor.name })
	  );
	};

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewarkDonorList = __webpack_require__(451);
	
	var _NewarkDonorList2 = _interopRequireDefault(_NewarkDonorList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'newark__container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'newark__header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'newark__heading-1-container' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'newark__heading-1' },
	          props.title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'newark__subheading-container' },
	        _react2.default.createElement(
	          'p',
	          { className: 'newark__subheading' },
	          props.subtitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'newark__donor-lists-container' },
	      props.donorLists.map(function (donorList, i) {
	        return _react2.default.createElement(_NewarkDonorList2.default, { donors: donorList.donors, listHeading: donorList.name, key: 'donor-list-' + i });
	      })
	    )
	  );
	};

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _DonorFullPage = __webpack_require__(60);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import VerticalVideoSync from '../../containers/VerticalVideoSync';
	var NewarkDonorListPassive = function (_Component) {
	  _inherits(NewarkDonorListPassive, _Component);
	
	  function NewarkDonorListPassive(props) {
	    _classCallCheck(this, NewarkDonorListPassive);
	
	    var _this = _possibleConstructorReturn(this, (NewarkDonorListPassive.__proto__ || Object.getPrototypeOf(NewarkDonorListPassive)).call(this, props));
	
	    _this.setOffset = function (setVar, styleObj, margin) {
	      if (styleObj.visible === true) {
	        setVar.val = _this._sumH + margin * .01 * _this.props.screen.screenHeight;
	        _this._sumH += styleObj.height * .01 * _this.props.screen.screenHeight;
	      }
	    };
	
	    _this.setFontAttributes = function (styleObj, rootObj) {
	      styleObj.color = _lodash2.default.get(rootObj, 'fontColor', null);
	      styleObj.fontWeight = _lodash2.default.get(rootObj, 'fontWeight', null);
	      styleObj.textAlign = _lodash2.default.get(rootObj, 'justification', "left").toLowerCase();
	      styleObj.fontStyle = _lodash2.default.get(rootObj, 'fontStyle', "normal").toLowerCase();
	      styleObj.fontFamily = _lodash2.default.get(rootObj, 'font', "");
	      styleObj.fontSize = _lodash2.default.get(rootObj, 'fontSize', 0) * _this.props.screen.screenHeight * .01;
	    };
	
	    _this.handleKeyDown = function (e) {
	      switch (e.key) {
	        case '1':
	          _this.metaCycle(true);
	          break;
	        case '6':
	          clearTimeout(_this._metaCycleTimeout);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.metaCycle = function (cycleIndex) {
	      if (cycleIndex) {
	        _this.cycleIndex();
	      }
	
	      if (_this._ni_options.interstitial.val === false) {
	        _this.cycleDonorIndex();
	        _this.setState({
	          showDonors: true,
	          showSlides: false
	        });
	        _this.setMetaCycleTimeout(_this._listCycleTime, true);
	      } else {
	        if (_this._ni_options.auto_interstitial.val === true) {
	          //TODO: Implement
	          //insert per number of screens
	          //this._ni_options.screensBetween;
	        } else if (_this._resetLoopOnStart === true && _this._manualSlidesIndex > _this._ni_options.manualSlides.length - 1) {
	          _this.setState({
	            showDonors: true,
	            showSlides: false
	          });
	          _this.cycleDonorIndex();
	          _this.setMetaCycleTimeout(_this._listCycleTime, true);
	        } else {
	          _this._manualSlidesInnerIndex++;
	          var slideData = _this._ni_options.manualSlides[_this._manualSlidesIndex];
	          var totalSteps = slideData.screens + slideData.end - slideData.start;
	          if (_this._manualSlidesInnerIndex < slideData.screens) {
	            _this.cycleDonorIndex();
	            _this.setState({
	              showDonors: true,
	              showSlides: false
	            });
	            _this.setMetaCycleTimeout(_this._listCycleTime, true);
	          } else if (_this._manualSlidesInnerIndex <= totalSteps) {
	            //cycle through and show slides
	            var currentSlideIndex = slideData.start - 1 + (_this._manualSlidesInnerIndex - slideData.screens);
	            var dd = _this.state.donorData || {};
	            dd.name = "";
	            _this.clearDonorData();
	            _this.setState({
	              slideImage: (0, _shared.dpath)(_this.props.screen.mode, _this._ni_options.slideshow_module.contents.images[currentSlideIndex].path, _this._ni_options.slideshow_module.contents.images[currentSlideIndex].file_name, _this.props.screen.webkey),
	              donorData: dd
	            });
	            var slideTimeOut = _this._listCycleTime;
	            if (_lodash2.default.has(_this._ni_options, 'slideshow_module.contents.cycle_overrides[' + currentSlideIndex + ']')) {
	              slideTimeOut = _this._ni_options.slideshow_module.contents.cycle_overrides[currentSlideIndex] * 1000;
	            }
	            _this.setMetaCycleTimeout(slideTimeOut, true);
	          } else {
	            _this._manualSlidesIndex++;
	            //if not resetLoopOnStart end of loop cycle slides
	            if (_this._resetLoopOnStart === false && _this._manualSlidesIndex > _this._ni_options.manualSlides.length - 1) {
	              _this._manualSlidesIndex = 0;
	            }
	            _this._manualSlidesInnerIndex = -1;
	            _this.metaCycle(false); //end of loop recursive
	          }
	        }
	      }
	    };
	
	    _this.clearDonorData = function () {
	      _this.setState({
	        showSlides: true,
	        showDonors: false,
	        parentCategoryName: "",
	        subCategoryName: "",
	        subCategorySubheader: "",
	        subCategoryDescription: ""
	      });
	    };
	
	    _this.initDonors = function () {
	      var children = _this.props.content.story_categories.filter(function (f) {
	        return f.parent_category === _this.props.folder.id;
	      });
	      var sortedChildren = children.sort(function (a, b) {
	        return a.rank - b.rank;
	      });
	      var grouppedDonors = sortedChildren.map(function (c) {
	        var donors = (0, _donorHelpers.getDonorsFromFolder)(_this.props.donors, _this.props.content.folder_modules, c.id);
	        c.donors = _lodash2.default.orderBy(donors, [function (donor) {
	          return donor.sorting_name.toLowerCase();
	        }], ['asc']);
	        return c;
	      });
	
	      _this._donors = grouppedDonors;
	      var cat = _this._donors[0];
	      var parent = _this.props.folder;
	      if (parent) {
	        _this._parentCategoryName = parent.description;
	        _this.setState({
	          parentCategoryName: parent.description,
	          subCategoryName: cat.description,
	          subCategorySubheader: cat.subheader,
	          subCategoryDescription: cat.description
	        });
	      }
	    };
	
	    _this.cycleIndex = function () {
	      var cycleIndex = _this.state.cycleIndex;
	      if (cycleIndex === 100) {
	        cycleIndex = 0;
	      }
	      _this.setState({
	        cycleIndex: ++cycleIndex
	      });
	    };
	
	    _this.cycleSlideIndex = function () {
	      var dd = _this.state.donorData;
	      dd.name = "";
	      _this.clearDonorData();
	      _this.setState({
	        donorData: dd
	      });
	    };
	
	    _this.cycleDonorIndex = function () {
	      if (_this._endOfDonorLoop === true) {
	        _this._categoryCurrent++;
	        _this._donorIndex = 0;
	        if (_this._categoryCurrent === _this._donors.length) {
	          //end of donor categories, reset entire loop
	          _this._categoryCurrent = 0;
	          if (_this._resetLoopOnStart === true) {
	            _this._manualSlidesIndex = 0; //which manual slide entry
	            _this._manualSlidesInnerIndex = -1; //which manual slide within entry
	            //console.log("EXTRA LOOP");
	            _this._endOfDonorLoop = false;
	            return _this.metaCycle(false);
	          }
	        }
	      }
	
	      var total = _this._columns * _this._rows;
	      var start = _this._donorIndex * total;
	      // USE THIS LOGIC FOR PARENT CATEGORY NAME
	      var cat = _this._donors[_this._categoryCurrent];
	      //set to static parent category name
	      _this.setState({
	        parentCategoryName: _this._parentCategoryName,
	        subCategoryName: cat.description,
	        subCategorySubheader: cat.subheader,
	        subCategoryDescription: cat.description
	      });
	
	      if (!cat.donors[start]) {
	        start = 0;
	        _this._donorIndex = 0;
	      }
	
	      _this._endOfDonorLoop = false;
	      var end = start + total;
	      if (!cat.donors[end]) {
	        end = cat.donors.length;
	        _this._endOfDonorLoop = true;
	        _this._donorIndex = 0;
	      } else {
	        _this._donorIndex++;
	      }
	
	      var donorsSliced = cat.donors.slice(start, end);
	      var perColumn = 0;
	
	      //distribute end page logic for empty units in last row
	      if (_this._endOfDonorLoop === true) {
	        var dLength = donorsSliced.length;
	        var extraSpaces = 0; //default to 0
	        perColumn = Math.ceil(dLength / _this._columns);
	        if (perColumn * _this._columns > dLength) {
	          //extra spaces on last row required
	          extraSpaces = perColumn * _this._columns - dLength;
	        }
	        var normalSpaces = _this._rows - perColumn; //spaces to add on each normal row
	        var lastSpaces = normalSpaces + extraSpaces; //spaces to add on last row
	
	        for (var i = 0; i < _this._columns; i++) {
	          if (i < _this._columns - 1) {
	            //rows prior to last
	            for (var a = 0; a < normalSpaces; a++) {
	              donorsSliced.splice(i * _this._rows + perColumn, 0, { name: "" });
	            }
	          } else {
	            for (var b = 0; b < lastSpaces; b++) {
	              donorsSliced.splice(i * _this._rows + perColumn, 0, { name: "" });
	            }
	          }
	        }
	      }
	      _this.setState({
	        donorData: {
	          donors: donorsSliced,
	          name: cat.name
	        }
	      });
	    };
	
	    _this.state = {
	      donorData: null,
	      cycleIndex: 0,
	      showDonors: true,
	      showSlides: false,
	      slideImage: "",
	      parentCategoryName: "", //state based to support setting to empty string on fades
	      subCategoryname: "",
	      subCategorySubheader: "",
	      subCategoryDescription: ""
	    };
	    _this._categoryCurrent = -1;
	    _this._endOfDonorLoop = true;
	    _this._donors = null;
	    _this._manualSlidesIndex = 0; //which manual slide entry
	    _this._manualSlidesInnerIndex = -1; //which manual slide within entry
	
	    //defaults
	    _this._columns = 3;
	    _this._rows = 8;
	    _this._fontColor = "#ffffff";
	    _this._backdropColor = "#000000";
	    _this._footerText = "";
	    _this._parentCategoryName = ""; //used to stash name so state can switch to empty string
	    _this._ni_options = {};
	    _this._metaCycleTimeout = null;
	    _this._listCycleTime = 8000;
	    _this._marginRight = _this.props.screen.sv.width * 0.0375;
	
	    _this._parentCategoryNameStyle = {};
	    _this._subCategoryNameStyle = {};
	    _this._subCategorySubheaderStyle = {};
	    _this._subCategoryDescriptionStyle = {};
	    _this._nameListStyle = {};
	    _this._footerTextStyle = {};
	
	    _this._parentCategoryNameOffset = {};
	    _this._subCategoryNameOffset = {};
	    _this._subCategorySubheaderOffset = {};
	    _this._subCategoryDescriptionOffset = {};
	    _this._nameListOffset = {};
	    _this._footerTextOffset = {};
	    _this._titleDividerLineOffset = {};
	    _this._nameListHeight = 0;
	    _this._resetLoopOnStart = true;
	
	    try {
	      //safe overrides
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields')) {
	        _this._ni_options = _this.props.folder.contents.custom_fields;
	        var slides = _lodash2.default.get(_this.props.folder.contents, 'arrays_values.slides', []);
	        var manualSlides = slides.map(function (s) {
	          return {
	            screens: Number(s.screens.val),
	            start: Number(s.start_slide.val),
	            end: Number(s.end_slide.val)
	          };
	        });
	        _this._ni_options.manualSlides = manualSlides;
	        _this._ni_options.slideshow_module = _this.props.otherModules[0];
	        _this._resetLoopOnStart = _this._ni_options.reset_insertation_schedule_loop.val;
	        _this.setFontAttributes(_this._parentCategoryNameStyle, _this.props.folder.contents.custom_fields.parent_category_name);
	        _this.setFontAttributes(_this._subCategoryNameStyle, _this.props.folder.contents.custom_fields.subcategory_name);
	        _this.setFontAttributes(_this._subCategorySubheaderStyle, _this.props.folder.contents.custom_fields.subcategory_subheader);
	        _this.setFontAttributes(_this._subCategoryDescriptionStyle, _this.props.folder.contents.custom_fields.subcategory_description);
	        _this.setFontAttributes(_this._nameListStyle, _this.props.folder.contents.custom_fields.name_list);
	        _this.setFontAttributes(_this._footerTextStyle, _this.props.folder.contents.custom_fields.footer_text);
	        _this._sumH = Number(_lodash2.default.get(_this.props.folder, 'contents.custom_fields.top_margin.val', 0)) * .01 * _this.props.screen.screenHeight; //adjust for base offset
	        _this.setOffset(_this._parentCategoryNameOffset, _this.props.folder.contents.custom_fields.parent_category_name, 0);
	        _this.setOffset(_this._subCategoryNameOffset, _this.props.folder.contents.custom_fields.subcategory_name, 0);
	        _this.setOffset(_this._subCategorySubheaderOffset, _this.props.folder.contents.custom_fields.subcategory_subheader, 0);
	        _this.setOffset(_this._subCategoryDescriptionOffset, _this.props.folder.contents.custom_fields.subcategory_description, 0);
	        _this._titleDividerLineOffset.val = _this._sumH;
	        _this.setOffset(_this._nameListOffset, _this.props.folder.contents.custom_fields.name_list, Number(_this.props.folder.contents.custom_fields.divide_line_margin.val));
	        _this._footerTextOffset.val = _this.props.screen.screenHeight - Number(_lodash2.default.get(_this.props.folder.contents.custom_fields, 'footer_text.val', 0)) * .01 * _this.props.screen.screenHeight;
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.columns.val')) {
	        _this._columns = Number(_this.props.folder.contents.custom_fields.columns.val);
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.rows.val')) {
	        _this._rows = Number(_this.props.folder.contents.custom_fields.rows.val);
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.fontColor.val')) {
	        _this._fontColor = _this.props.folder.contents.custom_fields.fontColor.val;
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.background_color.val')) {
	        _this._backdropColor = _this.props.folder.contents.custom_fields.background_color.val;
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.footer_text.val')) {
	        _this._footerText = _this.props.folder.contents.custom_fields.footer_text.val;
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.cycle_timeout.val')) {
	        _this._listCycleTime = Number(_this.props.folder.contents.custom_fields.cycle_timeout.val) * 1000;
	      }
	      if (_lodash2.default.has(_this.props.folder, 'contents.custom_fields.column_spacing.val')) {
	        _this._marginRight = Number(_this.props.folder.contents.custom_fields.column_spacing.val) * 0.01 * _this.props.screen.r16_9.width;
	      }
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(NewarkDonorListPassive, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initDonors();
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.metaCycle();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      clearTimeout(this._metaCycleTimeout);
	      this._metaCycleTimeout = null;
	    }
	  }, {
	    key: 'setMetaCycleTimeout',
	    value: function setMetaCycleTimeout(time, cycleIndex) {
	      var _this2 = this;
	
	      if (this._metaCycleTimeout) {
	        clearTimeout(this._metaCycleTimeout);
	        this._metaCycleTimeout = null;
	      }
	
	      this._metaCycleTimeout = setTimeout(function () {
	        _this2.metaCycle(cycleIndex);
	      }, time);
	    }
	
	    //called for every cycle to determine action
	
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if ((0, _shared.shallowEqual)(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	
	    //for unique transition keys
	
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.donorData) {
	        return null;
	      }
	      var sDims = {
	        height: this.props.screen.sv.height, //1080,
	        width: this.props.screen.sv.width //1920
	      };
	      var modifier = .6;
	      sDims.fsTitle = sDims.height * 0.05556 * modifier; //60
	      sDims.fsSubheader = sDims.height * 0.03333 * modifier; //36
	      sDims.left = this.props.screen.sv.left;
	
	      // let debugBoxStyle = {
	      //     position: 'absolute', 
	      //     backgroundColor: 'black',
	      //     opacity: .5,
	      //     width: this.props.screen.screenWidth,
	      //     height: this.props.screen.screenHeight / 2,
	      //     top: 0,
	      //     left: 0
	      //  }
	
	      return _react2.default.createElement(
	        'div',
	        { className: this._fontClass, style: { width: '100vw', height: '100vh', position: 'relative', color: this._fontColor, zIndex: 9999 } },
	        _react2.default.createElement('div', { style: { position: 'absolute', left: sDims.left, top: 0, opacity: this._ni_options.background_opacity.val * .01, backgroundColor: this._backdropColor, width: sDims.width, height: sDims.height } }),
	        this._ni_options.showTitleDivider ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showDonors },
	            this.state.showDonors ? _react2.default.createElement('div', { style: { position: 'absolute', left: sDims.width * .05 + sDims.left, top: this._titleDividerLineOffset.val, backgroundColor: this._fontColor, opacity: 1, width: sDims.width * .9, height: sDims.height * .0025 } }) : null
	          )
	        ) : null,
	        this._ni_options.parent_category_name.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.parentCategoryName },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._parentCategoryNameStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._parentCategoryNameOffset.val, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.parentCategoryName
	              )
	            )
	          )
	        ) : null,
	        this._ni_options.subcategory_name.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.subCategoryName },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._subCategoryNameStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryNameOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.subCategoryName
	              )
	            )
	          )
	        ) : null,
	        this._ni_options.subcategory_subheader.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.subCategorySubheader },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._subCategorySubheaderStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategorySubheaderOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.subCategorySubheader
	              )
	            )
	          )
	        ) : null,
	        this._ni_options.subcategory_description.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.subCategoryDescription },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._subCategoryDescriptionStyle, { position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryDescriptionOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }) },
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.subCategoryDescription
	              )
	            )
	          )
	        ) : null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.cycleIndex },
	            this.state.showSlides ? _react2.default.createElement(
	              'div',
	              { style: { position: 'absolute', left: sDims.left, top: 0, opacity: 1, width: sDims.width, height: sDims.height } },
	              _react2.default.createElement('img', { alt: "Slide", src: this.state.slideImage, style: { width: sDims.width, height: sDims.height } })
	            ) : null
	          )
	        ),
	        this._ni_options.name_list.visible ? _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfade',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.cycleIndex },
	            this.state.showDonors ? _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, this._nameListStyle, { position: 'absolute', left: 0, top: 0, opacity: 1, width: sDims.width, height: sDims.height }) },
	              _react2.default.createElement(
	                'div',
	                { style: { position: 'absolute', left: sDims.left + sDims.width * .05, top: this._nameListOffset.val, width: sDims.width * .9, height: sDims.height * .8 } },
	                this.state.donorData ? _react2.default.createElement(_DonorFullPage2.default, {
	                  fontclass: this._ni_options.name_list.font,
	                  height: this._ni_options.name_list.height * .01 * this.props.screen.screenHeight,
	                  width: sDims.width * .9,
	                  rows: this._rows,
	                  columns: this._columns,
	                  donorData: this.state.donorData.donors,
	                  screen: this.props.screen,
	                  sort: 'column',
	                  overrideFontSize: this._nameListStyle.fontSize,
	                  overrideMarginRight: this._marginRight,
	                  custom1x2: this.props.content.settings.custom_vars.custom1x2 ? true : false,
	                  evenVerticalSpace: false
	                }) : _react2.default.createElement('span', null)
	              ),
	              this._ni_options.footer_text.visible ? _react2.default.createElement(
	                'span',
	                { style: Object.assign({}, this._footerTextStyle, { left: sDims.width * .05 + sDims.left, marginRight: 0, position: 'absolute', width: sDims.width * .9, top: this._footerTextOffset.val }) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this._footerText
	                )
	              ) : null
	            ) : null
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return NewarkDonorListPassive;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var mod = state.content.dm_active[state.active_module];
	  var isIdle = (0, _shared.parseStringParam)(window.location.href, "idle");
	  if (isIdle === 'true') {
	    mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data
	    mod = _lodash2.default.find(state.content.dm_active, { id: mod.id }); //TODO: should populate the module loop?
	  }
	  return {
	    screen: state.screen,
	    module: mod,
	    donors: state.donors,
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(NewarkDonorListPassive);

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  console.log('wc props', props);
	  return _react2.default.createElement('div', { className: 'newark__full-screen-image-container', style: { backgroundImage: 'url(' + props.image + ')' } });
	};

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "newark__thank-you-message-container", style: { backgroundImage: "url(" + props.backgroundImage + ")" } },
	    _react2.default.createElement("div", { className: "newark__thank-you-message-left" }),
	    _react2.default.createElement(
	      "div",
	      { className: "newark__thank-you-message-right" },
	      _react2.default.createElement(
	        "div",
	        { className: "newark__thank-you-message-image-container" },
	        _react2.default.createElement("img", { role: "presentation", src: props.image, className: "newark__thank-you-message-image" })
	      )
	    )
	  );
	};

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewarkRichTextOuput = __webpack_require__(156);
	
	var _NewarkRichTextOuput2 = _interopRequireDefault(_NewarkRichTextOuput);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'newark__welcome-message-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'newark__welcome-message-left' },
	      _react2.default.createElement('img', { role: 'presentation', src: props.image, className: 'newark__welcome-message-image' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'newark__welcome-message-right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'newark__welcome-message-content' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'newark__welcome-message-heading-1' },
	          _react2.default.createElement(_BRSpan2.default, { str: props.headline })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'newark__welcome-message-body' },
	          _react2.default.createElement(_NewarkRichTextOuput2.default, { ops: props.bodyOps })
	        )
	      )
	    )
	  );
	};

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SlideshowOmaha = __webpack_require__(464);
	
	var _SlideshowOmaha2 = _interopRequireDefault(_SlideshowOmaha);
	
	var _TouchGestureOmaha = __webpack_require__(468);
	
	var _TouchGestureOmaha2 = _interopRequireDefault(_TouchGestureOmaha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttractLoopOmaha = function (_Component) {
	  _inherits(AttractLoopOmaha, _Component);
	
	  function AttractLoopOmaha() {
	    _classCallCheck(this, AttractLoopOmaha);
	
	    return _possibleConstructorReturn(this, (AttractLoopOmaha.__proto__ || Object.getPrototypeOf(AttractLoopOmaha)).apply(this, arguments));
	  }
	
	  _createClass(AttractLoopOmaha, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { style: { width: '100vw', height: '100vh', position: 'absolute' } },
	        _react2.default.createElement(_SlideshowOmaha2.default, this.props),
	        _react2.default.createElement(_TouchGestureOmaha2.default, {
	          screen: this.props.screen,
	          contentX: 20,
	          contentY: 20
	        })
	      );
	    }
	  }]);
	
	  return AttractLoopOmaha;
	}(_react.Component);
	
	exports.default = AttractLoopOmaha;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBlockOmaha = function (_Component) {
	  _inherits(NavBlockOmaha, _Component);
	
	  function NavBlockOmaha() {
	    _classCallCheck(this, NavBlockOmaha);
	
	    return _possibleConstructorReturn(this, (NavBlockOmaha.__proto__ || Object.getPrototypeOf(NavBlockOmaha)).apply(this, arguments));
	  }
	
	  _createClass(NavBlockOmaha, [{
	    key: "render",
	    value: function render() {
	      var boxStyle = {
	        border: "1px",
	        backgroundColor: _lodash2.default.get(this.props, "background", "#8c827a"),
	        height: "19.52vh",
	        width: "20vh",
	        float: "left",
	        marginLeft: this.props.marginLeft,
	        boxShadow: "3px 3px 20px 0px rgba(0,0,0,0.75)"
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, boxStyle) },
	        _react2.default.createElement(
	          "div",
	          { style: { display: "block", marginTop: "2.11vh" } },
	          _react2.default.createElement("img", { style: { height: "7.902777778vh" }, src: this.props.icon, alt: "" })
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              justifyContent: "center",
	              alignItems: "center",
	              fontSize: "2.2vh",
	              marginLeft: "2vh",
	              marginRight: "2vh",
	              height: "6.507222222vh"
	            }
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            this.props.title.toUpperCase()
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavBlockOmaha;
	}(_react.Component);
	
	exports.default = NavBlockOmaha;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _display = __webpack_require__(28);
	
	var _shared = __webpack_require__(4);
	
	var _NavBlockOmaha = __webpack_require__(460);
	
	var _NavBlockOmaha2 = _interopRequireDefault(_NavBlockOmaha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavOmaha = function (_Component) {
	  _inherits(NavOmaha, _Component);
	
	  function NavOmaha(props) {
	    _classCallCheck(this, NavOmaha);
	
	    var _this = _possibleConstructorReturn(this, (NavOmaha.__proto__ || Object.getPrototypeOf(NavOmaha)).call(this, props));
	
	    _this.handleNav = function (route) {
	      _this.props.switchModule(route.module.id);
	      _this.props.navRoute(route.navLocation, route.module);
	    };
	
	    _this.initializeNavRefs = function () {
	      if (_this.state.initializedRefs === false) {
	        var _loop = function _loop(a) {
	          _this.navRefs[a].el.addEventListener("click", function () {
	            return _this.handleNav(_this.navRefs[a].data);
	          });
	        };
	
	        for (var a = 0; a < _this.navRefs.length; a++) {
	          _loop(a);
	        }
	        _this.setState({
	          initializedRefs: true
	        });
	      }
	    };
	
	    _this.initializeAssets = function () {
	      var assets = _lodash2.default.find(_this.props.content.dm_active, function (o) {
	        return o.name.includes("Assets");
	      });
	      if (!assets) {
	        console.log("assets Slideshow Module was not found");
	      }
	      var backgroundIndex = _lodash2.default.indexOf(assets.contents.names, "Main Screen");
	      var backgroundImage = assets.contents.images[backgroundIndex];
	
	      var defaultBackground = { path: "/img/omaha/general/", file_name: "main-background.jpg" };
	      _this._background = (0, _shared.dp)(_this.props.screen, backgroundImage, defaultBackground);
	    };
	
	    _this.animateHandInterval = function () {
	      clearTimeout(_this._animateHandIntervalHandler);
	      _this._animateHandIntervalHandler = setTimeout(function () {
	        _this._handIconRef.animate([{
	          transform: "translateY(0%)"
	        }, {
	          transform: "translateY(-25%)"
	        }, {
	          transform: "translateY(-75%)"
	        }, {
	          transform: "translateY(-25%)"
	        }, {
	          transform: "translateY(0%)"
	        }, {
	          transform: "translateY(-25%)"
	        }, {
	          transform: "translateY(0%)"
	        }], {
	          fill: "forwards",
	          duration: 500
	        });
	        _this.animateHandInterval();
	      }, 15000);
	    };
	
	    _this._menuModules = _lodash2.default.filter(_this.props.content.dm_active, function (dm) {
	      return dm.module_contents.in_navigation;
	    });
	
	    _this._background = null;
	    _this._arrow = null;
	    _this._logo = null;
	    _this._handIconRef = null;
	    _this._animateHandIntervalHandler = null;
	
	    _this.initializeAssets();
	
	    _this.state = {
	      initializedRefs: false,
	      animationName: ""
	    };
	    _this.navRefs = [];
	    return _this;
	  }
	
	  _createClass(NavOmaha, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initializeNavRefs();
	      this.animateHandInterval();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      clearTimeout(this._animateHandIntervalHandler);
	
	      var _loop2 = function _loop2(a) {
	        if (_this2.navRefs[a].el) {
	          _this2.navRefs[a].el.removeEventListener("click", function () {
	            return _this2.handleNav(_this2.navRefs[a].data);
	          });
	        }
	      };
	
	      for (var a = 0; a < this.navRefs.length; a++) {
	        _loop2(a);
	      }
	    }
	  }, {
	    key: "prepareMenuNavigation",
	    value: function prepareMenuNavigation() {
	      var _this3 = this;
	
	      var location = [];
	      var modules = [];
	
	      return this._menuModules.map(function (row, i) {
	        // Check the number of story modules attached
	        var storyModules = _this3.props.content.folder_modules.filter(function (fm) {
	          return fm.model === "story" && Number(fm.folder) === Number(row.contents.folder);
	        }).map(function (fm) {
	          var story = _this3.props.content.stories.find(function (st) {
	            return st.id === Number(fm.module_id);
	          });
	          return Object.assign({}, story, {
	            folder_module_id: fm.id
	          });
	        });
	
	        // Attempt to get story_categories (folders) children of the one associated with the module
	        var storyCategories = _this3.props.content.story_categories.filter(function (sc) {
	          return Number(sc.parent_category) === Number(row.contents.folder);
	        });
	
	        var storyCategoriesAndStoriesCount = storyCategories.length + storyModules.length;
	
	        if (storyCategoriesAndStoriesCount > 1) {
	          location[i] = "/omaha/stories";
	          row.currentSlide = 0;
	          modules[i] = row;
	
	          if (_this3._handIconRef) {
	            _this3._handIconRef.addEventListener("click", function () {
	              return _this3.handleNav({
	                navLocation: location[i],
	                module: modules[i],
	                stories: storyModules,
	                categories: storyCategories
	              });
	            });
	          }
	        } else if (storyCategoriesAndStoriesCount === 1) {
	          if (storyCategories.length === 1) {
	            location[i] = "/omaha/recognition_list";
	            modules[i] = storyModules[0];
	            modules[i].display_module_id = row.id;
	          } else {
	            location[i] = "/omaha/story?id=" + storyModules[0].folder_module_id;
	            modules[i] = row;
	            modules[i].display_module_id = row.id;
	          }
	        }
	
	        var marginLeft = i === 0 ? "0px" : "1.2vh";
	        if (_this3._menuModules.length === 1) {
	          marginLeft = _this3.props.screen.screenWidth / 2 - _this3.props.screen.screenHeight * 7.52344 / 100 - _this3.props.screen.screenHeight * 20 / 100 / 2;
	        }
	        var background = "#8c827a";
	        if (i === 0 || i % 2 === 0) {
	          background = "#7a6e66";
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { key: i },
	          _react2.default.createElement(
	            "div",
	            {
	              ref: function ref(el) {
	                return _this3.navRefs[i] = {
	                  el: el,
	                  data: { navLocation: location[i], module: modules[i], stories: storyModules }
	                };
	              }
	            },
	            _react2.default.createElement(_NavBlockOmaha2.default, {
	              background: background,
	              handleNav: _this3.handleNav,
	              icon: (0, _shared.dp)(_this3.props.screen, row.module_contents.icon),
	              marginLeft: marginLeft,
	              title: row.name
	            })
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
	      var backgroundSize = this.props.screen.screenWidth + "px " + this.props.screen.screenHeight + "px";
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            height: this.props.screen.r9_16.height,
	            textAlign: "center",
	            width: "100%",
	            backgroundSize: backgroundSize,
	            backgroundImage: "url(" + this._background + ")"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            ref: function ref(el) {
	              return _this4._handIconRef = el;
	            },
	            style: { position: "absolute", top: "92vh", width: "100%", height: "5vh" }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { width: "100%", height: "2vh", bottom: "47vh", position: "absolute" } },
	            _react2.default.createElement(
	              "span",
	              { style: { textShadow: textShadow, fontSize: "2.5vh", fontWeight: "bold" } },
	              "FIND OUT MORE"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", width: "100%", height: "16.58vh", bottom: "28vh" } },
	            _react2.default.createElement("img", {
	              className: "shadowed-image",
	              style: { width: "16.58vh", height: "16.58vh" },
	              src: (0, _shared.dp)(this.props.screen, null, { path: "/img/ui/", file_name: "handicon-03.png" }),
	              alt: ""
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { left: "7.5234375vh", position: "absolute", bottom: "4.82vh", height: "20vh", width: "100%" } },
	          this.prepareMenuNavigation()
	        )
	      );
	    }
	  }]);
	
	  return NavOmaha;
	}(_react.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    switchModule: function switchModule(id) {
	      return dispatch((0, _display.switchModule)(id));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(NavOmaha);

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _display = __webpack_require__(28);
	
	var _IdleLoop = __webpack_require__(96);
	
	var _IdleLoop2 = _interopRequireDefault(_IdleLoop);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _AttractLoopOmaha = __webpack_require__(459);
	
	var _AttractLoopOmaha2 = _interopRequireDefault(_AttractLoopOmaha);
	
	var _NavOmaha = __webpack_require__(461);
	
	var _NavOmaha2 = _interopRequireDefault(_NavOmaha);
	
	var _OmahaRecognitionList = __webpack_require__(463);
	
	var _OmahaRecognitionList2 = _interopRequireDefault(_OmahaRecognitionList);
	
	var _StoriesOmaha = __webpack_require__(466);
	
	var _StoriesOmaha2 = _interopRequireDefault(_StoriesOmaha);
	
	var _StoryOmaha = __webpack_require__(467);
	
	var _StoryOmaha2 = _interopRequireDefault(_StoryOmaha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OmahaContainer = function (_Component) {
	  _inherits(OmahaContainer, _Component);
	
	  function OmahaContainer(props) {
	    _classCallCheck(this, OmahaContainer);
	
	    var _this = _possibleConstructorReturn(this, (OmahaContainer.__proto__ || Object.getPrototypeOf(OmahaContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._screensNumber = _this.getScreensNumber();
	    _this.idleRef = 0;
	    _this._module = null;
	
	    var attractLoopSlideshowModule = _this.getAttractLoopFolderModule();
	
	    _this.state = {
	      idle: false,
	      menuUrl: "/omaha/nav",
	      showNavButton: false,
	      module: null,
	      attractLoopSlideshowModule: attractLoopSlideshowModule
	    };
	    return _this;
	  }
	
	  _createClass(OmahaContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	
	      var key = this.props.location.pathname + this.props.location.search;
	      return _react2.default.createElement(
	        "div",
	        { className: this.props.content.font_class, style: { color: this.props.content.settings.main_font_color } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: "div",
	            className: "containerFade",
	            transitionName: "fastfadedelay",
	            style: { minHeight: "100%" },
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0
	          },
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            { key: key, location: location },
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/omaha/slideshow",
	              render: function render(props) {
	                return _react2.default.createElement(_AttractLoopOmaha2.default, Object.assign({}, props, {
	                  module: _this2.state.attractLoopSlideshowModule,
	                  navRoute: _this2.navRoute,
	                  screen: _this2.props.screen,
	                  screensNumber: _this2._screensNumber
	                }));
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/omaha/nav",
	              render: function render(props) {
	                return _react2.default.createElement(_NavOmaha2.default, Object.assign({}, props, {
	                  toggleShowNav: _this2.toggleShowNav,
	                  navRoute: _this2.navRoute,
	                  content: _this2.props.content,
	                  screen: _this2.props.screen,
	                  screensNumber: _this2._screensNumber
	                }));
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/omaha/story",
	              render: function render(props) {
	                return _react2.default.createElement(_StoryOmaha2.default, Object.assign({}, props, {
	                  backgroundEnabled: true,
	                  module: _this2.state.module,
	                  content: _this2.props.content,
	                  navRoute: _this2.navRoute,
	                  screen: _this2.props.screen,
	                  screensNumber: _this2._screensNumber
	                }));
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/omaha/stories",
	              render: function render(props) {
	                return _react2.default.createElement(_StoriesOmaha2.default, Object.assign({}, props, {
	                  module: _this2.state.module,
	                  navRoute: _this2.navRoute,
	                  screen: _this2.props.screen,
	                  content: _this2.props.content,
	                  screensNumber: _this2._screensNumber
	                }));
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/omaha/stories_story",
	              render: function render(props) {
	                return _react2.default.createElement(_StoryOmaha2.default, Object.assign({}, props, {
	                  backgroundEnabled: true,
	                  module: _this2.state.module,
	                  content: _this2.props.content,
	                  navRoute: _this2.navRoute,
	                  screen: _this2.props.screen,
	                  screensNumber: _this2._screensNumber
	                }));
	              }
	            }),
	            _react2.default.createElement(_reactRouterDom.Route, {
	              path: "/omaha/recognition_list",
	              render: function render(props) {
	                return _react2.default.createElement(_OmahaRecognitionList2.default, Object.assign({}, props, {
	                  content: _this2.props.content,
	                  module: _this2.state.module,
	                  navRoute: _this2.navRoute,
	                  screen: _this2.props.screen,
	                  screensNumber: _this2._screensNumber
	                }));
	              }
	            })
	          )
	        ),
	        this.props.idleActive === true ? _react2.default.createElement(_IdleLoop2.default, { idle_delay: this.props.content.idle_delay, goIdle: this.goIdle, resume: this.resume }) : null
	      );
	    }
	  }]);
	
	  return OmahaContainer;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.getAttractLoopFolderModule = function () {
	    var attractLoopFolder = _this3.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, "contents.custom_fields.folder_type.val.value", null);
	      return type === "attract_loop";
	    });
	    if (!attractLoopFolder) return null;
	    var childAttractLoopFolderModule = _this3.props.content.folder_modules.find(function (fm) {
	      return fm.folder === attractLoopFolder.id;
	    });
	    var attractLoopSlideshowModule = _this3.props.content.dm_active.find(function (dm) {
	      return dm.id === childAttractLoopFolderModule.module_id;
	    });
	    return attractLoopSlideshowModule;
	  };
	
	  this.toggleShowNav = function (toggleOn) {
	    _this3.setState({
	      showNavButton: toggleOn
	    });
	  };
	
	  this.navRoute = function (route, module) {
	    if (module) {
	      _this3.setState({
	        module: module
	      });
	    }
	    _this3.props.history.replace(route);
	  };
	
	  this.getScreensNumber = function () {
	    try {
	      return _this3.props.content.settings.display_blocks[0].screens.length;
	    } catch (e) {
	      return 1;
	    }
	  };
	
	  this.goIdle = function (type) {
	    if (type === 'idle') {
	      if (!_this3.state.idle) {
	        _this3.setState({
	          idle: true
	        });
	        if (_this3.state.attractLoopSlideshowModule) {
	          _this3.navRoute("/omaha/slideshow");
	        } else {
	          _this3.navRoute("/omaha/nav");
	        }
	      }
	    }
	  };
	
	  this.resume = function () {
	    var newIdle = _this3.state.idle ? false : _this3.state.idle;
	    if (newIdle !== _this3.state.idle) {
	      _this3.setState({
	        idle: newIdle
	      }, function () {
	        _this3.navRoute("/omaha/nav");
	      });
	    }
	  };
	
	  this.handleKeyDown = function (event) {
	    switch (event.key) {
	      case "s":
	        console.log(_this3.props);
	        break;
	      case "n":
	        _this3.props.history.replace(_this3.state.menuUrl);
	        break;
	      default:
	        break;
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var active_module = state.active_module;
	  var idle = _shared2.default.parseStringParam(window.location.href, "idle");
	  var namedmodule = _shared2.default.parseStringParam(window.location.href, "name");
	
	  var idleActive = true;
	  if (state.content.idle_delay === 0 || idle === "false") {
	    idleActive = false;
	  }
	
	  if (namedmodule) {
	    active_module = _lodash2.default.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
	  }
	
	  return {
	    active_module: active_module,
	    content: state.content,
	    contentHasErrored: state.contentHasErrored,
	    contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    donorsHasErrored: state.donorsHasErrored,
	    donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    options: state.options,
	    screensNumber: state.screensNumber,
	    idleActive: idleActive
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    switchModule: function switchModule(id) {
	      return dispatch((0, _display.switchModule)(id));
	    },
	    setOptions: function setOptions(data) {
	      return dispatch((0, _display.setOptions)(data));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OmahaContainer);

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _util = __webpack_require__(143);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _shared = __webpack_require__(4);
	
	var _DonorFullPage = __webpack_require__(65);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	var _MenuOmaha = __webpack_require__(92);
	
	var _MenuOmaha2 = _interopRequireDefault(_MenuOmaha);
	
	var _get = __webpack_require__(105);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var OmahaRecognitionList = function (_Component) {
	  _inherits(OmahaRecognitionList, _Component);
	
	  function OmahaRecognitionList(props) {
	    _classCallCheck(this, OmahaRecognitionList);
	
	    var _this = _possibleConstructorReturn(this, (OmahaRecognitionList.__proto__ || Object.getPrototypeOf(OmahaRecognitionList)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._subscribeModule = null;
	    _this._rowWrapperRef = null;
	    _this._backButtonRef = null;
	
	    _this._columns = 2;
	    _this._rows = 6;
	    _this._fontColor = "#ffffff";
	    _this._backdropColor = "#000000";
	    _this._footerText = "";
	    _this._parentCategoryName = ""; //used to stash name so state can switch to empty string
	    _this._ni_options = {};
	    _this._metaCycleTimeout = null;
	    _this._listCycleTime = 8000;
	    _this._marginRight = _this.props.screen.sv.width * 0.0375;
	    _this._fontClass = "gfont_roboto";
	    _this._donorCategories = null;
	    _this._recognitionOptionsRef = null;
	    _this._descriptionRef = null;
	
	    _this._donorGroups = [];
	
	    var urlParams = new URLSearchParams(window.location.search);
	    var id = urlParams.get("id");
	
	    // const rootFolderId = _.get(this.props.content, "settings.selected_root_folder", null);
	    var rootFolder = _this.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(id);
	    });
	    _this._colorPallette = _lodash2.default.get(rootFolder, "contents.custom_fields.color_pallette.val.value", "golisano");
	
	    var descriptionRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(rootFolder, "contents.custom_fields.description.val.ops", {}), {}).convert();
	
	    var description = descriptionRichText === "<p><br/></p>" ? null : descriptionRichText;
	
	    _this.state = {
	      rootFolder: rootFolder,
	      description: description,
	      donorGroup: 0,
	      listWrapperHeight: 80
	    };
	    return _this;
	  }
	
	  _createClass(OmahaRecognitionList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setRefs();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.setRefs();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var background = this.getBackgroundImage();
	      var backButton = (0, _shared.dp)(this.props.screen, null, { path: "/img/omaha/general/", file_name: "back_grey.png" });
	      var unit = this.props.screen.r9_16.p10;
	      var textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
	      var headlineFontSize = "3.5vh";
	      if (this.state.changeHeadlineFontSize) {
	        headlineFontSize = this.state.headlineFontSize;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              position: "absolute",
	              width: this.props.screen.screenWidth,
	              height: this.props.screen.r9_16.height,
	              backgroundSize: "contain",
	              backgroundImage: "url(" + background + ")"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                backgroundColor: "#8c827a",
	                height: "7.16vh",
	                width: "100%",
	                position: "relative",
	                display: "flex",
	                alignItems: "center",
	                justifyContent: "center"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                ref: function ref(el) {
	                  return _this2._headlineRef = el;
	                },
	                style: {
	                  textShadow: textShadow,
	                  fontSize: headlineFontSize,
	                  fontWeight: "bold",
	                  marginTop: "1.83vh",
	                  marginBottom: "1.83vh"
	                }
	              },
	              this.props.module.name.toUpperCase()
	            ),
	            _react2.default.createElement("img", {
	              className: "shadowed-image",
	              style: { position: "absolute", maxHeight: "5.3vh", right: "1vh", top: "1vh" },
	              src: this._icon,
	              alt: ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "relative", height: "87.34vh", width: "100%" } },
	            this.state.description && _react2.default.createElement(
	              "div",
	              {
	                ref: function ref(el) {
	                  return _this2._descriptionRef = el;
	                },
	                style: {
	                  position: "relative",
	                  // fontSize: "2.3vh",
	                  color: "#6f6259",
	                  width: "100%",
	                  maxHeight: "15vh",
	                  marginBottom: "3vh",
	                  marginTop: "3.84vh",
	                  // textAlign: "left",
	                  // fontWeight: "bold",
	                  overflow: "hidden"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { position: "relative", width: "39.37vh", margin: "auto" } },
	                _react2.default.createElement("div", { className: "ql-editor", dangerouslySetInnerHTML: { __html: this.state.description } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { position: "relative", height: "100%", width: " 100%" } },
	              this.state.description && _react2.default.createElement("div", {
	                className: "topgradblackP25",
	                style: { position: "relative", width: "100%", height: unit * 0.25, top: "1.4vh" }
	              }),
	              _react2.default.createElement("div", { style: { position: "absolute", height: "100%", width: "100%", backdropFilter: "blur(6px)" } }),
	              _react2.default.createElement(
	                "div",
	                {
	                  ref: function ref(el) {
	                    return _this2._wrapperDiv = el;
	                  },
	                  style: {
	                    display: "block",
	                    color: "black",
	                    width: "85%",
	                    height: !this.state.description ? "100%" : this.state.listWrapperHeight * 1.035 + "%",
	                    marginLeft: "auto",
	                    marginRight: "auto",
	                    touchAction: "none"
	                  }
	                },
	                _react2.default.createElement(
	                  _reactIscroll2.default,
	                  {
	                    ref: function ref(el) {
	                      return _this2.iScroller = el;
	                    },
	                    iScroll: _iscroll2.default,
	                    onScrollStart: this.handleScrollStart,
	                    options: {
	                      mouseWheel: true,
	                      scrollbars: false,
	                      scrollX: false,
	                      scrollY: true,
	                      probeType: 2,
	                      bounce: false,
	                      momentum: true,
	                      deceleration: 0.005,
	                      useTransition: true,
	                      disableTouch: false,
	                      disablePointer: false,
	                      disableMouse: false,
	                      tap: true
	                    },
	                    onRefresh: this.initializeIScroll
	                  },
	                  _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                      component: "div",
	                      transitionName: "example",
	                      transitionEnterTimeout: 0,
	                      transitionLeaveTimeout: 0
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { ref: function ref(el) {
	                          return _this2._innerDivRef = el;
	                        }, key: this.state.donorGroup },
	                      _react2.default.createElement("div", { style: { height: "2.5vh" } }),
	                      this.renderCategories()
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("img", {
	              ref: function ref(el) {
	                return _this2._backButtonRef = el;
	              },
	              src: backButton,
	              style: { position: "absolute", left: "1.3vh", bottom: "8vh", width: "2.8vh" },
	              alt: ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", bottom: "0vh", width: "100%", textAlign: "center" } },
	            _react2.default.createElement(_MenuOmaha2.default, { navRoute: this.props.navRoute, currentModuleId: this.props.module.display_module_id })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OmahaRecognitionList;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.checkSwipeAnimation = function () {
	    var wrapperHeight = _this3._wrapperDiv.getBoundingClientRect().height;
	    var contentHeight = _this3._innerDivRef.getBoundingClientRect().height;
	
	    if (_this3.props.handleSwipeAnimation) {
	      _this3.props.handleSwipeAnimation(wrapperHeight, contentHeight);
	    }
	  };
	
	  this.handleScrollStart = function () {
	    if (_this3.props.cancelSwipeAnimation) {
	      _this3.props.cancelSwipeAnimation();
	    }
	  };
	
	  this.setRefs = function () {
	    if (!_this3._backButtonRef) {
	      setTimeout(function () {
	        _this3.setRefs();
	      }, 100);
	    } else {
	      _this3._backButtonRef.addEventListener("click", _this3.goBack);
	    }
	
	    if (_this3._descriptionRef) {
	      // Get the height of the description
	      var descriptionHeight = _this3._descriptionRef.getBoundingClientRect().height;
	      var headerHeight = _this3.props.screen.screenHeight * 0.0716;
	      var footerHeight = _this3.props.screen.screenHeight * 0.055;
	      var listWrapperHeight = (_this3.props.screen.screenHeight - descriptionHeight - headerHeight - footerHeight) / _this3.props.screen.screenHeight * 100;
	      if (listWrapperHeight !== _this3.state.listWrapperHeight) {
	        _this3.setState({
	          listWrapperHeight: listWrapperHeight
	        });
	      }
	    }
	  };
	
	  this.goBack = function () {
	    var displayModuleId = _this3.props.module.id;
	    var displayModule = _this3.props.content.dm_active.find(function (dm) {
	      return dm.id === displayModuleId;
	    });
	    var folderId = (0, _get2.default)(displayModule, "contents.folder", null);
	
	    if (folderId !== null) {
	      var childStories = _this3.props.content.folder_modules.filter(function (fm) {
	        return fm.folder === Number(folderId) && fm.model === "story";
	      });
	      var childStoryCategories = _this3.props.content.story_categories.filter(function (sc) {
	        return sc.parent_category === Number(folderId);
	      });
	
	      var totalItems = childStories.length + childStoryCategories.length;
	      if (totalItems === 1) {
	        // Redirect to home
	        _this3.props.navRoute("/omaha/nav", null);
	      } else {
	        // Redirect to stories
	        _this3.props.navRoute("/omaha/stories", displayModule);
	      }
	    }
	  };
	
	  this.getBackgroundImage = function () {
	    var defaultImg = { path: "/img/omaha/general/", file_name: "story-background.jpg" };
	
	    if (_this3.props.screensNumber === 2) {
	      defaultImg.file_name = "default_double_screen.jpg";
	    }
	
	    try {
	      var backgroundReference = _this3.props.module.contents.custom_fields.background_reference_recognition_list_view.val;
	      var assetsSlideShow = _lodash2.default.find(_this3.props.content.dm_active, function (o) {
	        return o.name.includes("Assets");
	      });
	      var asset = _lodash2.default.indexOf(assetsSlideShow.contents.names, backgroundReference);
	
	      if (!asset || asset === undefined) {
	        return (0, _shared.dp)(_this3.props.screen, defaultImg);
	      }
	
	      return (0, _shared.dp)(_this3.props.screen, assetsSlideShow.contents.images[asset]);
	    } catch (e) {
	      return (0, _shared.dp)(_this3.props.screen, defaultImg);
	    }
	  };
	
	  this.getIconImage = function () {
	    // return dp(this.props.screen, _.get(this.props.module, "contents.images[1]", null), null);
	    var category = _this3.props.module.folder;
	    var foundDm = _lodash2.default.filter(_this3.props.content.dm_active, function (dm) {
	      return Number(dm.contents.story_category) === category;
	    });
	
	    var icon = null;
	    if (foundDm.length > 0) {
	      icon = foundDm[0].module_contents.icon;
	    }
	
	    return (0, _shared.dp)(_this3.props.screen, icon);
	  };
	
	  this.getSubscribeModule = function () {
	    var rootFolderId = _lodash2.default.get(_this3.props.content, "settings.selected_root_folder", null);
	    var menu = _this3.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, "contents.custom_fields.folder_type.val.value", null);
	      return folder.parent_category === Number(rootFolderId) && type === "menu";
	    });
	    var rootFolder = _this3.props.content.story_categories.find(function (folder) {
	      return folder.id === Number(rootFolderId);
	    });
	    _this3._arrowIcon = (0, _shared.dp)(_this3.props.screen, _lodash2.default.get(menu, "contents.images[0]", null), null);
	    _this3._colorPallette = _lodash2.default.get(rootFolder, "contents.custom_fields.color_pallette.val.value", "golisano");
	    var subscribeModule = _this3.props.content.story_categories.find(function (folder) {
	      var type = _lodash2.default.get(folder, "contents.custom_fields.folder_type.val.value", null);
	      return folder.parent_category === Number(menu.id) && type === "be_the_change";
	    });
	    _this3._subscribeModule = subscribeModule;
	  };
	
	  this.renderCategories = function () {
	    if ((0, _util.isNull)(_this3._donorCategories)) {
	      var categoryWrapStyle = {
	        boxSizing: "border-box",
	        width: _this3.props.screen.screenWidth * 0.78838174273858921162,
	        background: "white",
	        paddingBottom: _this3.props.screen.screenHeight * 0.01875,
	        paddingTop: _this3.props.screen.screenHeight * 0.02893518518518518519,
	        borderRadius: 10,
	        paddingLeft: _this3.props.screen.screenWidth * 0.074074074,
	        paddingRight: _this3.props.screen.screenWidth * 0.074074074,
	        marginBottom: _this3.props.screen.screenHeight * 0.03125
	      };
	
	      // Find child story_categories aka folders
	      var donorGroups = _this3.props.content.story_categories.filter(function (sc) {
	        return sc.parent_category === Number(_this3.state.rootFolder.id);
	      });
	
	      var descriptionRichText = new QuillDeltaToHtmlConverter(_lodash2.default.get(_this3._donorGroups[_this3.state.donorGroup], "contents.custom_fields.description.val.ops", _lodash2.default.get(_this3._donorGroups[_this3.state.donorGroup], "contents.custom_fields.description.default.ops", null)), {}).convert();
	
	      var donorGroupsWithChildren = donorGroups.map(function (group, i) {
	        var donors = (0, _donorHelpers.getDonorsFromFolder)(_this3.props.donors, _this3.props.content.folder_modules, group.id);
	        var orderedDonors = _lodash2.default.orderBy(donors, ["sorting_name", "asc"]);
	        var donorFullPageWidth = _this3.props.screen.screenWidth * 0.78838174273858921162 - _this3.props.screen.screenWidth * 0.074074074 * 2;
	        var hideTitle = _lodash2.default.get(group, "contents.custom_fields.hide_title.val", false);
	
	        var donorList = _react2.default.createElement(
	          "div",
	          { key: i, style: { display: "flex", alignItems: "center", justifyContent: "center" } },
	          _react2.default.createElement(
	            "div",
	            { style: Object.assign({}, categoryWrapStyle), className: "opensans-regular" },
	            i === 0 ? _react2.default.createElement("div", {
	              style: {
	                lineHeight: "1.5625vh",
	                paddingRight: _this3.props.screen.screenHeight * 0.01562,
	                paddingLeft: _this3.props.screen.screenHeight * 0.01562
	              },
	              dangerouslySetInnerHTML: { __html: descriptionRichText }
	            }) : null,
	            hideTitle !== true ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "h1",
	                {
	                  style: {
	                    paddingRight: _this3.props.screen.screenHeight * 0.01562,
	                    paddingLeft: _this3.props.screen.screenHeight * 0.01562,
	                    fontSize: _this3.props.screen.screenHeight * 0.021875
	                  }
	                },
	                group.name
	              )
	            ) : null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_DonorFullPage2.default, {
	                columns: _this3._columns,
	                custom1x2: "<span />",
	                donorData: orderedDonors,
	                fontClass: _this3._fontclass,
	                height: _this3.props.screen.screenHeight * 0.115,
	                overrideFontSize: 0,
	                overrideMarginRight: 0,
	                overridePadding: _this3.props.screen.screenHeight * 0.01562,
	                rows: _this3._rows,
	                screen: _this3.props.screen,
	                sort: "column",
	                width: donorFullPageWidth
	              })
	            )
	          )
	        );
	
	        return _react2.default.createElement(
	          "div",
	          { key: i },
	          donorList
	        );
	      });
	      return donorGroupsWithChildren;
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(OmahaRecognitionList);

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _fileHelpers = __webpack_require__(35);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _ReactPlayerWrapper = __webpack_require__(88);
	
	var _ReactPlayerWrapper2 = _interopRequireDefault(_ReactPlayerWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlideshowOmaha = function (_Component) {
	  _inherits(SlideshowOmaha, _Component);
	
	  function SlideshowOmaha(props) {
	    _classCallCheck(this, SlideshowOmaha);
	
	    var _this = _possibleConstructorReturn(this, (SlideshowOmaha.__proto__ || Object.getPrototypeOf(SlideshowOmaha)).call(this, props));
	
	    _this.clearCycleTimeout = function () {
	      clearTimeout(_this._cycleTimeout);
	      _this._cycleTimeout = null;
	    };
	
	    _this.slidesChanged = function () {
	      var timeout = 5000;
	      var hScreens = _this.props.module.contents.hScreens;
	      var vScreens = _this.props.module.contents.vScreens;
	      if (hScreens && Number(hScreens) !== 0) {
	        hScreens = Number(hScreens);
	      } else {
	        hScreens = 1;
	      }
	      if (vScreens && Number(vScreens) !== 0) {
	        vScreens = Number(vScreens);
	      } else {
	        vScreens = 1;
	      }
	
	      _this._nextGroup = [];
	
	      // default to all slides clone array
	      var slidePool = _this.props.module.contents.images.slice(0);
	      if (_this.props.module.contents.bool0s) {
	        // clear slidePool to use active inactive bools
	        slidePool = [];
	        // push active slides into pool
	        _this.props.module.contents.images.forEach(function (image, index) {
	          if (_this.props.module.contents.bool0s && _this.props.module.contents.bool0s[index] === true) {
	            slidePool.push(image);
	          }
	        });
	      }
	
	      _this._totalElements = slidePool.length;
	
	      var returnModule = _lodash2.default.cloneDeep(_this.props.module);
	      returnModule.contents.images = slidePool;
	
	      var totalImagesNeeded = hScreens * vScreens;
	
	      if (totalImagesNeeded > slidePool.length) {
	        return null;
	      }
	
	      var index = 0;
	
	      var imageHeight = _this.props.screen.screenHeight / vScreens;
	      var imageWidth = _this.props.screen.screenWidth / hScreens;
	
	      for (var i = 0; i < totalImagesNeeded; i++) {
	        index = (i + _this._lastTakenSlideIndex + 1) % _this._totalElements;
	
	        var imageStyle = {
	          top: Math.floor(i / hScreens) * imageHeight,
	          left: i % hScreens * imageWidth,
	          maxHeight: imageHeight,
	          maxWidth: imageWidth
	        };
	
	        _this._nextGroup.push({
	          index: index,
	          style: imageStyle
	        });
	
	        if (i === totalImagesNeeded - 1) {
	          if (_this._cycleOverrides[index]) {
	            timeout = _this._cycleOverrides[index] * 1000;
	          }
	          _this._lastTakenSlideIndex = index;
	        }
	      }
	
	      _this.clearCycleTimeout();
	      _this._cycleTimeout = setTimeout(function () {
	        _this.slidesChanged();
	      }, timeout);
	
	      _this.setState({
	        group: _this._nextGroup,
	        module: returnModule,
	        lastTakenSlideIndex: _this._lastTakenSlideIndex
	      });
	    };
	
	    _this.getSlides = function () {
	      var volume = 1;
	
	      if (_this.props.idle) {
	        volume = 0;
	      }
	      return _this._nextGroup.map(function (slide, row) {
	        var fileType = (0, _fileHelpers.getFileType)(_this.state.module.contents.images[slide.index].file_name);
	        if (fileType === "Image") {
	          return _react2.default.createElement("img", {
	            key: row,
	            alt: "Slide",
	            onMouseDown: _this.preventDrag,
	            className: "nodrag",
	            style: Object.assign({}, slide.style, { backgroundSize: 'cover' }),
	            src: _shared2.default.dp(_this.props.screen, _this.state.module.contents.images[slide.index])
	          });
	        } else {
	          return _react2.default.createElement(_ReactPlayerWrapper2.default, {
	            playing: !_this._paused,
	            handleVideoDuration: _this.handleVideoDuration,
	            volume: volume,
	            onEnded: _this.videoEnded,
	            key: slide.index,
	            url: _shared2.default.dp(_this.props.screen, _this.state.module.contents.images[slide.index]),
	            width: _this.props.screen.screenWidth,
	            height: _this.props.screen.screenHeight
	          });
	        }
	      });
	    };
	
	    _this._totalElements = _this.props.module.contents.images.length;
	    _this._cycleOverrides = _this.props.module.contents.cycle_overrides;
	    _this._currentDuration = 0;
	    _this._startSlideTime = 0;
	    _this._lastTakenSlideIndex = -1;
	    _this._nextGroup = [];
	    _this._paused = false;
	    _this.state = {
	      videoVolumes: Array.from(Array(_this.props.module.contents.images.length), function () {
	        return 0;
	      }),
	      module: _this.props.module
	    };
	    return _this;
	  }
	
	  _createClass(SlideshowOmaha, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _shared2.default.checkData(this.props.module);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.slidesChanged();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearCycleTimeout();
	      document.removeEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            position: "absolute",
	            top: 0,
	            left: 0,
	            width: this.props.screen.screenWidth,
	            height: this.props.screen.screenHeight,
	            pointerEvents: "none"
	          },
	          className: "nodrag"
	        },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: "div",
	            transitionName: "fastfadedelay",
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0
	          },
	          _react2.default.createElement(
	            "div",
	            { key: this.state.lastTakenSlideIndex, style: { position: "absolute", left: 0, top: 0 } },
	            this.getSlides()
	          )
	        )
	      );
	    }
	  }]);
	
	  return SlideshowOmaha;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(SlideshowOmaha);

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shared = __webpack_require__(4);
	
	var _OmahaConstants = __webpack_require__(157);
	
	var _get = __webpack_require__(105);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoriesButtonOmaha = function (_Component) {
	  _inherits(StoriesButtonOmaha, _Component);
	
	  function StoriesButtonOmaha() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StoriesButtonOmaha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StoriesButtonOmaha.__proto__ || Object.getPrototypeOf(StoriesButtonOmaha)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (el) {
	      var module = _this.props.story;
	      module.overrideStoryName = _lodash2.default.get(_this.props, "overrideStoryName", module.name);
	      module.currentSlide = _this.props.currentSlide;
	      module.categoryIcon = _this.props.categoryIcon;
	
	      var folderType = (0, _get2.default)(module, "contents.custom_fields.folder_type.val.value", "story");
	
	      var url = "/omaha/stories_story?id=" + _this.props.story.folder_module_id;
	      if (folderType !== "story") {
	        url = "/omaha/recognition_list?id=" + _this.props.story.id;
	      }
	      _this.props.setRefs(_this.props.refIndex, {
	        el: el,
	        data: { navLocation: url, module: module }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StoriesButtonOmaha, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          background = _props.background,
	          tint = _props.tint; //icon,
	
	      var backgroundUrl = (0, _shared.dp)(this.props.screen, background);
	
	      return _react2.default.createElement(
	        "div",
	        {
	          ref: function ref(el) {
	            return _this2.setRef(el);
	          },
	          style: {
	            position: "relative",
	            float: "left",
	            width: _OmahaConstants.slideWidth,
	            height: _OmahaConstants.slideWidth,
	            marginTop: 0
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              position: "absolute",
	              width: "20.37vw",
	              height: "20.37vw",
	              marginLeft: 0,
	              marginRight: 0,
	              left: 0, //this.props.marginLeft,
	              top: 0, //this.props.marginTop + "vh",
	              backgroundImage: "url(" + backgroundUrl + ")",
	              backgroundSize: "cover",
	              boxShadow: "3px 3px 20px 0px rgba(0,0,0,0.75)",
	              display: "flex",
	              alignItems: "center",
	              justifyContent: "center"
	            }
	          },
	          _react2.default.createElement("div", {
	            style: {
	              backgroundColor: tint,
	              position: "absolute",
	              top: 0,
	              left: 0,
	              width: "100%",
	              height: "100%",
	              opacity: 0.75
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                position: "relative",
	                fontSize: "1.3vh",
	                fontWeight: "bold",
	                width: "80%",
	                height: "80%",
	                overflowX: "hidden",
	                overflowY: "hidden",
	                wordBreak: "break-word",
	                display: "flex",
	                alignItems: "center",
	                justifyContent: "center"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              null,
	              name.toUpperCase()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoriesButtonOmaha;
	}(_react.Component);
	
	exports.default = StoriesButtonOmaha;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactSlick = __webpack_require__(46);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _MenuOmaha = __webpack_require__(92);
	
	var _MenuOmaha2 = _interopRequireDefault(_MenuOmaha);
	
	var _OmahaConstants = __webpack_require__(157);
	
	var _StoriesButtonOmaha = __webpack_require__(465);
	
	var _StoriesButtonOmaha2 = _interopRequireDefault(_StoriesButtonOmaha);
	
	var _get = __webpack_require__(105);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var itemsPerRowActual = 3;
	var itemsPerRow = itemsPerRowActual + 2; // includes 2 dummies
	
	var totalSlidesPerPageActual = itemsPerRowActual * 2;
	var totalSlidesPerPage = itemsPerRow * 2; // includes 4 dummies
	
	var StoriesOmaha = function (_Component) {
	  _inherits(StoriesOmaha, _Component);
	
	  function StoriesOmaha(props) {
	    _classCallCheck(this, StoriesOmaha);
	
	    /*eslint no-extend-native: ["warn", { "exceptions": ["Array"] }]*/
	    var _this = _possibleConstructorReturn(this, (StoriesOmaha.__proto__ || Object.getPrototypeOf(StoriesOmaha)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    Array.prototype.diff = function (a) {
	      return this.filter(function (i) {
	        return a.indexOf(i) < 0;
	      });
	    };
	
	    var currentSlide = _lodash2.default.get(_this.props, "module.currentSlide", 0);
	    _this._storiesRefs = [];
	    _this._stories = null;
	    _this._colors = ["#8e7d96", "#d2b78c", "#7088a1", "#aeb17c", "#cc7370", "#fdbc48"];
	    _this._handIconRef = null;
	    _this._headline = null;
	    _this._background = null;
	    _this._icon = null;
	
	    _this.setupElements();
	    _this.getSlides();
	
	    _this.state = {
	      initializedRefs: false,
	      handPositionX: 0,
	      handPositionY: 0,
	      handOpacity: 0,
	      changeHeadlineFontSize: false,
	      currentSlide: currentSlide,
	      headline: _this.props.module.name.toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(StoriesOmaha, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (prevProps.module !== this.props.module) {
	        if (this.props.module.display_module_type && this.props.module.display_module_type === "Stories") {
	          this.removeRefsEvents();
	          this._storiesRefs = [];
	          this.setupElements();
	          this.getSlides();
	          this.setState({
	            initializedRefs: false
	          });
	          this.initializeSwipeHandIcon();
	          setTimeout(function () {
	            _this2.initializeStoriesRefs();
	          }, 250);
	          this.setState({
	            headline: this.props.module.name.toUpperCase()
	          });
	          this._icon = this.getIcon();
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initializeStoriesRefs();
	      this.checkHeadlineSize();
	      this.initializeSwipeHandIcon();
	      this._background = this.getBackgroundImage();
	      this._icon = this.getIcon();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeRefsEvents();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings = {
	        arrows: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        dots: true,
	        dotsClass: "story-slick",
	        initialSlide: this.state.currentSlide,
	        afterChange: function afterChange(current) {
	          return _this3.setState({ currentSlide: current });
	        }
	      };
	      var slides = this.getSlides();
	      var grouppedSlides = this.getGrouppedSlides(slides);
	      var backgroundSize = this.props.screen.screenWidth + "px " + this.props.screen.screenHeight + "px";
	      var textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
	      var headlineFontSize = "3.5vh";
	      if (this.state.changeHeadlineFontSize) {
	        headlineFontSize = this.state.headlineFontSize;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              height: this.props.screen.screenHeight,
	              width: this.props.screen.screenWidth,
	              textAlign: "center",
	              backgroundSize: backgroundSize,
	              backgroundImage: "url(" + this._background + ")"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                backgroundColor: "#8c827a",
	                height: "7.16vh",
	                width: "100%",
	                position: "absolute",
	                display: "flex",
	                justifyContent: "center",
	                alignItems: "center"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                ref: function ref(el) {
	                  return _this3._headlineRef = el;
	                },
	                style: {
	                  textShadow: textShadow,
	                  fontSize: headlineFontSize,
	                  fontWeight: "bold",
	                  marginTop: "1.83vh",
	                  marginBottom: "1.83vh"
	                }
	              },
	              this.state.headline
	            ),
	            _react2.default.createElement("img", {
	              className: "shadowed-image",
	              style: { position: "absolute", maxHeight: "5.3vh", right: "1vh", top: "1vh" },
	              src: this._icon,
	              alt: ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", width: "100%", height: "16.58vh", top: "37vh" } },
	            _react2.default.createElement(
	              "span",
	              { style: { fontSize: "3vh", color: "#51544c" } },
	              "Touch a story to"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { fontSize: "3vh", color: "#51544c" } },
	              "learn more."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", width: "100%", height: "16.58vh", top: "45vh" } },
	            _react2.default.createElement("img", {
	              style: { width: "7.017vh", height: "7.017vh" },
	              src: (0, _shared.dp)(this.props.screen, null, { path: "/img/ui/", file_name: "handicon-04.png" }),
	              alt: ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "omaha-stories-slider",
	              style: { position: "absolute", bottom: "10vh", width: "100vw", maxWidth: "100vw", height: "32.2925vh" }
	            },
	            _react2.default.createElement(
	              _reactSlick2.default,
	              Object.assign({ ref: function ref(el) {
	                  return _this3._slickRef = el;
	                } }, settings),
	              grouppedSlides
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", bottom: "0vh", width: "100%" } },
	            _react2.default.createElement(_MenuOmaha2.default, { navRoute: this.props.navRoute, currentModuleId: this.props.module.id })
	          ),
	          grouppedSlides.length > 1 ? _react2.default.createElement("img", {
	            alt: "handicon",
	            ref: function ref(el) {
	              return _this3._handIconRef = el;
	            },
	            src: this._handIcon,
	            style: {
	              opacity: this.state.handOpacity,
	              left: this.state.handPositionX,
	              top: this.state.handPositionY,
	              position: "absolute",
	              width: "2.4vh"
	            }
	          }) : null
	        )
	      );
	    }
	  }]);
	
	  return StoriesOmaha;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.removeRefsEvents = function () {
	    if (_this4._storiesRefs.length > 0) {
	      var _loop = function _loop(a) {
	        if (_this4._storiesRefs[a].el) {
	          _this4._storiesRefs[a].el.removeEventListener("click", function () {
	            return _this4.handleNav(_this4._storiesRefs[a].data);
	          });
	        }
	      };
	
	      for (var a = 0; a < _this4._storiesRefs.length; a++) {
	        _loop(a);
	      }
	    }
	  };
	
	  this.checkHeadlineSize = function () {
	    if (!_this4._headlineRef) {
	      setTimeout(function () {
	        _this4.checkHeadlineSize();
	      }, 100);
	    } else {
	      var maxAllowed = _this4.props.screen.screenHeight * 37.83 / 100;
	      var width = _this4._headlineRef.getBoundingClientRect().width;
	
	      if (width > maxAllowed) {
	        _this4.setState({
	          changeHeadlineFontSize: true,
	          headlineFontSize: _this4.props.screen.screenHeight * 3 / 100
	        });
	      }
	    }
	  };
	
	  this.getBackgroundImage = function () {
	    var defaultImg = { path: "/img/omaha/general/", file_name: "story-background.jpg" };
	
	    if (_this4.props.screensNumber === 2) {
	      defaultImg.file_name = "default_double_screen.jpg";
	    }
	
	    try {
	      var backgroundReference = _this4.props.module.contents.custom_fields.background_reference.val;
	      var assetsSlideShow = _lodash2.default.find(_this4.props.content.dm_active, function (o) {
	        return o.name.includes("Assets");
	      });
	      var asset = _lodash2.default.indexOf(assetsSlideShow.contents.names, backgroundReference);
	
	      if (!asset || asset === undefined) {
	        return (0, _shared.dp)(_this4.props.screen, defaultImg);
	      }
	
	      return (0, _shared.dp)(_this4.props.screen, assetsSlideShow.contents.images[asset]);
	    } catch (e) {
	      return (0, _shared.dp)(_this4.props.screen, defaultImg);
	    }
	  };
	
	  this.getIcon = function () {
	    return (0, _shared.dp)(_this4.props.screen, _lodash2.default.get(_this4.props.module, "module_contents.icon", null));
	  };
	
	  this.initializeStoriesRefs = function () {
	    if (_this4.state.initializedRefs === false && _this4._storiesRefs.length > 0) {
	      var _loop2 = function _loop2(a) {
	        if (_this4._storiesRefs[a] && _this4._storiesRefs[a].el) {
	          _this4._storiesRefs[a].el.addEventListener("click", function () {
	            return _this4.handleNav(_this4._storiesRefs[a].data);
	          });
	        }
	      };
	
	      for (var a = 0; a < _this4._storiesRefs.length; a++) {
	        _loop2(a);
	      }
	      _this4.setState({
	        initializedRefs: true
	      });
	    }
	  };
	
	  this.initializeSwipeHandIcon = function () {
	    var storySlick = _reactDom2.default.findDOMNode(_this4._slickRef).getElementsByClassName("story-slick");
	    _this4._domeTimeHandler = setTimeout(function () {
	      if (storySlick.length > 0 && _this4._handIconRef) {
	        if (storySlick[0].childNodes[0]) {
	          var firstBullet = storySlick[0].childNodes[0].getBoundingClientRect();
	          _this4.setState({
	            handPositionX: firstBullet.x - _this4.props.screen.screenHeight * 0.03 * 1.25,
	            handPositionY: firstBullet.y + _this4._handIconRef.getBoundingClientRect().height * 0.25,
	            handOpacity: 1
	          });
	        }
	      }
	    }, 150);
	  };
	
	  this.handleNav = function (route) {
	    _this4.props.navRoute(route.navLocation);
	  };
	
	  this.setupElements = function () {
	    var stories = (0, _lodash2.default)(_this4.props.content.folder_modules).filter({ folder: Number(_this4.props.module.contents.folder), model: "story" }).map(function (fm) {
	      return Object.assign({}, _lodash2.default.find(_this4.props.content.stories, { id: Number(fm.module_id) }), {
	        folder_module_id: fm.id
	      });
	    }).compact().value();
	
	    var moduleAssociatedFolder = (0, _get2.default)(_this4.props.module, "contents.folder", null);
	    // console.log('this.props.module', this.props.module);
	
	    var storyCategories = _this4.props.content.story_categories.filter(function (sc) {
	      return Number(sc.parent_category) === Number(moduleAssociatedFolder) && (0, _get2.default)(sc, "contents.custom_fields.folder_type.val.value", null) === "donor_lists";
	    });
	
	    var handIcon = (0, _shared.dp)(_this4.props.screen, null, { path: "/img/ui/", file_name: "handIconSwipe.png" });
	    _this4._stories = stories;
	    _this4._donorLists = storyCategories;
	    _this4._handIcon = handIcon;
	  };
	
	  this.setRefs = function (i, data) {
	    _this4._storiesRefs[i] = data;
	  };
	
	  this.getSlides = function () {
	    var slides = [];
	    var separationFromAbove = 1.48;
	    var count = 0;
	
	    var storiesAndDonorLists = _lodash2.default.orderBy(_this4._stories.concat(_this4._donorLists), ["sorting_name", "name", "createdAt"], ["asc", "desc"]);
	
	    slides = storiesAndDonorLists.map(function (story, i) {
	      count++;
	      var marginLeft = "1.75vh";
	      var marginTop = 0;
	      var storyObj = Object.assign({}, story);
	      storyObj.display_module_id = _this4.props.module.id;
	
	      if (i === 0 || i % itemsPerRowActual === 0) {
	        marginLeft = 0;
	      }
	
	      if (count > itemsPerRowActual) {
	        marginTop = separationFromAbove;
	      }
	
	      if (count === totalSlidesPerPageActual) {
	        count = 0;
	      }
	
	      var currentSlide = _lodash2.default.get(_this4.state, "currentSlide", 0);
	
	      return _react2.default.createElement(
	        "div",
	        { key: i + 100 },
	        _react2.default.createElement(_StoriesButtonOmaha2.default, {
	          background: _lodash2.default.get(story.contents, "images[0]", null),
	          categoryIcon: _lodash2.default.get(_this4.props.module, "module_contents.icon", null),
	          currentSlide: currentSlide,
	          icon: _lodash2.default.get(story.contents, "images[0]", null),
	          marginLeft: marginLeft,
	          marginTop: marginTop,
	          name: story.name,
	          overrideStoryName: _this4.props.module.name.toUpperCase(),
	          refIndex: i,
	          screen: _this4.props.screen,
	          setRefs: _this4.setRefs,
	          story: storyObj,
	          tint: _this4._colors[i % _this4._colors.length]
	        })
	      );
	    });
	
	    return slides;
	  };
	
	  this.getGrouppedSlides = function (slides) {
	    var slidesToGroup = [];
	    var grouppedSlides = [];
	    var grouppedSlidesV2 = [];
	    var groups = [];
	    var count = 0;
	    var lineCounter = 0;
	    var slideIndex = 0;
	    var pageCount = Math.ceil(slides.length / totalSlidesPerPageActual);
	    var slideCountWithDummies = pageCount * totalSlidesPerPage;
	
	    var slideDataWithDummies = [];
	
	    count = 0;
	
	    // console.log("______________________________--");
	    // pad for 2 on each side
	    for (var ii = 0; ii < slideCountWithDummies; ii++) {
	      if (lineCounter === 0 || lineCounter === itemsPerRow - 1) {
	        // console.log("lineCounter:", lineCounter, "dummy side");
	        slideDataWithDummies.push(_this4.getDummyBlock(ii, true));
	      } else if (slideIndex < slides.length) {
	        // console.log("lineCounter:", lineCounter, "slide: " + slideIndex);
	        slideDataWithDummies.push(slides[slideIndex]);
	        slideIndex++;
	      } else {
	        // console.log("lineCounter:", lineCounter, "dummy regular");
	        slideDataWithDummies.push(_this4.getDummyBlock(ii, false));
	      }
	      lineCounter++;
	      if (lineCounter > itemsPerRow - 1) {
	        lineCounter = 0;
	      }
	    }
	
	    // console.log("slideDataWithDummies", slideDataWithDummies);
	
	    slideDataWithDummies.forEach(function (preparedSlide, i) {
	      if (count === 0) {
	        slidesToGroup = [];
	      }
	      slidesToGroup.push(preparedSlide);
	      count++;
	      if (count >= totalSlidesPerPage) {
	        grouppedSlidesV2.push(slidesToGroup);
	        count = 0;
	      }
	    });
	
	    groups = grouppedSlidesV2.map(function (group, i) {
	      //TODO: should have some left / centering?
	      var left = 100 * i + "vw";
	      return _react2.default.createElement(
	        "div",
	        { key: i, style: { position: "absolute", left: left, fontSize: "100px" } },
	        group
	      );
	    });
	
	    return groups;
	  };
	
	  this.getDummyBlock = function (i, isPadding) {
	    var ww = isPadding ? _OmahaConstants.slideEdgePadding : _OmahaConstants.slideWidth;
	    return _react2.default.createElement("div", {
	      key: i,
	      style: {
	        position: "relative",
	        float: "left",
	        width: ww,
	        height: _OmahaConstants.slideWidth
	      }
	    });
	  };
	
	  this.getRandomUnrepeatedColors = function () {
	    var storiesLength = _this4._stories.length;
	    var pulledColors = [];
	
	    for (var i = 0; i < storiesLength; i++) {
	      var colorsLeft = _this4._colorsIndexes.diff(pulledColors);
	
	      if (colorsLeft.length === 0) {
	        colorsLeft = _this4._colorsIndexes;
	      }
	
	      var index = _shared2.default.getRandomInt(0, colorsLeft.length - 1);
	      pulledColors.push(colorsLeft[index]);
	    }
	
	    return pulledColors;
	  };
	};
	
	exports.default = StoriesOmaha;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shared = __webpack_require__(4);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _reactSlick = __webpack_require__(46);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _MenuOmaha = __webpack_require__(92);
	
	var _MenuOmaha2 = _interopRequireDefault(_MenuOmaha);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var StoryOmaha = function (_Component) {
	  _inherits(StoryOmaha, _Component);
	
	  function StoryOmaha(props) {
	    _classCallCheck(this, StoryOmaha);
	
	    var _this = _possibleConstructorReturn(this, (StoryOmaha.__proto__ || Object.getPrototypeOf(StoryOmaha)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._story = null;
	    _this._background = null;
	    _this._slickRef = null;
	    _this._slides = [];
	    _this._imagesStatus = [];
	    _this._imagesVerificationInitialized = false;
	    _this._totalSlides = 0;
	    _this._handIconRef = null;
	    _this._headlineRef = null;
	    _this._backButtonRef = null;
	    _this._background = null;
	    _this._icon = null;
	
	    var urlParams = new URLSearchParams(window.location.search);
	    var id = urlParams.get('id');
	    var rootFolderModule = _this.props.content.folder_modules.find(function (s) {
	      return s.id === Number(id);
	    });
	    var rootFolder = _this.props.content.stories.find(function (s) {
	      return s.id === rootFolderModule.module_id;
	    });
	
	    _this.setupElements(rootFolder);
	    _this.getSlides();
	
	    _this.state = {
	      rootFolder: rootFolder,
	      rootFolderModule: rootFolderModule,
	      handOpacity: 0,
	      handPositionX: 0,
	      handPositionY: 0,
	      imagesLoaded: false,
	      changeHeadlineFontSize: false
	    };
	    return _this;
	  }
	
	  _createClass(StoryOmaha, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._background = this.getBackgroundImage();
	      this._icon = this.getIcon();
	      if (this._totalSlides > 0) {
	        this.verifyThatImagesAreLoaded();
	      }
	
	      this.checkHeadlineSize();
	      this.setRefs();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      try {
	        var settings = {
	          arrows: false,
	          infinite: false,
	          speed: 500,
	          slidesToShow: 1,
	          slidesToScroll: 1,
	          centerMode: false,
	          useCSS: true,
	          dots: true,
	          dotsClass: "story-slick"
	        };
	
	        var slides = this._slides;
	        if (slides.length <= 1) {
	          settings.dots = false;
	        }
	
	        // const icon = this.getIcon();
	        var backgroundSize = this.props.screen.screenWidth + "px " + this.props.screen.screenHeight + "px";
	        // const backgroundImage = this.getBackgroundImage();
	        var textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
	        var backButton = (0, _shared.dp)(this.props.screen, null, { path: "/img/omaha/general/", file_name: "back_grey.png" });
	        var headlineFontSize = "3.5vh";
	        if (this.state.changeHeadlineFontSize) {
	          headlineFontSize = this.state.headlineFontSize;
	        }
	
	        var textOps = _lodash2.default.get(this._story.contents.custom_fields, "body.val.ops", {});
	        var converter = new QuillDeltaToHtmlConverter(textOps, {});
	        var richText = converter.convert();
	
	        return _react2.default.createElement(
	          "div",
	          {
	            style: {
	              height: this.props.screen.r9_16.height,
	              textAlign: "center",
	              width: "100%",
	              backgroundSize: backgroundSize,
	              backgroundImage: "url(" + this._background + ")"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                backgroundColor: "#8c827a",
	                height: "7.16vh",
	                width: "100%",
	                position: "absolute",
	                display: "flex",
	                alignItems: "center",
	                justifyContent: "center"
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              {
	                ref: function ref(el) {
	                  return _this2._headlineRef = el;
	                },
	                style: {
	                  textShadow: textShadow,
	                  fontSize: headlineFontSize,
	                  fontWeight: "bold",
	                  marginTop: "1.83vh",
	                  marginBottom: "1.83vh"
	                }
	              },
	              this._headLine
	            ),
	            _react2.default.createElement("img", {
	              className: "shadowed-image",
	              style: { position: "absolute", maxHeight: "5.3vh", right: "1vh", top: "1vh" },
	              src: this._icon,
	              alt: ""
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            slides.length > 1 && this.state.imagesLoaded ? _react2.default.createElement("img", {
	              ref: function ref(el) {
	                return _this2._handIconRef = el;
	              },
	              src: this._handIcon,
	              style: {
	                opacity: this.state.handOpacity,
	                left: this.state.handPositionX,
	                top: this.state.handPositionY,
	                position: "absolute",
	                width: "2.4vh"
	              },
	              alt: "hand-icon"
	            }) : null
	          ),
	          this._story.contents.headline && this._story.contents.headline.length > 0 ? _react2.default.createElement(
	            "div",
	            {
	              style: {
	                position: "absolute",
	                fontSize: "2.3vh",
	                color: "#6f6259",
	                width: "100%",
	                height: "20vh",
	                top: "11vh",
	                textTransform: "uppercase",
	                textAlign: "left",
	                fontWeight: "bold"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              { style: { position: "relative", width: "39.37vh", margin: "auto" } },
	              _react2.default.createElement(
	                "span",
	                null,
	                this._story.contents.headline
	              )
	            )
	          ) : null,
	          slides.length === 0 ? null : _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", width: "100%", height: "46.73vh", top: "20vh" } },
	            _react2.default.createElement(
	              "div",
	              { style: { position: "relative", width: "39.37vh", margin: "auto" } },
	              _react2.default.createElement(
	                _reactSlick2.default,
	                Object.assign({ ref: function ref(el) {
	                    return _this2._slickRef = el;
	                  } }, settings),
	                slides
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "gradient",
	              style: { position: "absolute", top: "54vh", height: "40.7vh", width: "100%", touchAction: "none" }
	            },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              {
	                ref: function ref(el) {
	                  return _this2.iScroller = el;
	                },
	                iScroll: _iscroll2.default,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.015,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { position: "relative", display: "flex", justifyContent: "center" } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { width: "39.37vh", display: "flex" } },
	                  _react2.default.createElement(
	                    "span",
	                    { style: { fontSize: "1.5vh", textAlign: "left", lineHeight: "3vh", color: "#6f6259" } },
	                    _react2.default.createElement("div", { className: "ql-editor", dangerouslySetInnerHTML: { __html: richText } }),
	                    "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement("img", {
	            ref: function ref(el) {
	              return _this2._backButtonRef = el;
	            },
	            src: backButton,
	            style: { position: "absolute", left: "1.3vh", bottom: "8vh", width: "2.8vh" },
	            alt: ""
	          }),
	          _react2.default.createElement(
	            "div",
	            { style: { position: "absolute", bottom: "0vh", width: "100%" } },
	            _react2.default.createElement(_MenuOmaha2.default, { navRoute: this.props.navRoute, currentModuleId: this._story.display_module_id })
	          )
	        );
	      } catch (e) {
	        console.log(e);
	        return _react2.default.createElement("div", null);
	      }
	    }
	  }]);
	
	  return StoryOmaha;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.setRefs = function () {
	    if (!_this3._backButtonRef) {
	      setTimeout(function () {
	        _this3.setRefs();
	      }, 100);
	    } else {
	      _this3._backButtonRef.addEventListener("click", _this3.goBack);
	    }
	  };
	
	  this.goBack = function () {
	    var parentFolderId = _this3.state.rootFolderModule.folder;
	
	    var stories = _this3.props.content.folder_modules.filter(function (fm) {
	      return fm.folder === Number(parentFolderId);
	    });
	    var childStoryCategories = _this3.props.content.story_categories.filter(function (sc) {
	      return sc.parent_category === Number(parentFolderId);
	    });
	    var activeModules = _lodash2.default.filter(_this3.props.content.dm_active, function (dm) {
	      return dm.module_contents.in_navigation;
	    });
	
	    var displayModule = _lodash2.default.find(activeModules, {
	      display_module_type: "Stories",
	      contents: { story_category: parentFolderId.toString() }
	    });
	
	    var total = stories.length + childStoryCategories.length;
	
	    if (total === 1) {
	      if (stories.length === 1) {
	        _this3.props.navRoute("/omaha/nav");
	      } else {
	        _this3.props.navRoute("/omaha/stories", displayModule);
	      }
	    } else {
	      _this3.props.navRoute("/omaha/stories", displayModule);
	    }
	  };
	
	  this.checkHeadlineSize = function () {
	    if (!_this3._headlineRef) {
	      setTimeout(function () {
	        _this3.checkHeadlineSize();
	      }, 100);
	    } else {
	      var maxAllowed = _this3.props.screen.screenHeight * 37.83 / 100;
	      var width = _this3._headlineRef.getBoundingClientRect().width;
	
	      if (width > maxAllowed) {
	        _this3.setState({
	          changeHeadlineFontSize: true,
	          headlineFontSize: _this3.props.screen.screenHeight * 3 / 100
	        });
	      }
	    }
	  };
	
	  this.verifyThatImagesAreLoaded = function () {
	    if (!_this3._imagesVerificationInitialized) {
	      _this3._imagesStatus = Array.apply(null, { length: _this3._totalSlides }).map(function (value) {
	        return null;
	      });
	      _this3._imagesVerificationInitialized = true;
	    }
	
	    var hasLoaded = true;
	    for (var i = 0; i < _this3._totalSlides; i++) {
	      if (_this3._imagesStatus[i] === null) {
	        hasLoaded = false;
	        break;
	      }
	    }
	
	    if (!hasLoaded) {
	      _this3._handleImageVerificationTimeout = setTimeout(function () {
	        _this3.verifyThatImagesAreLoaded();
	      }, 100);
	    } else {
	      _this3._imagesLoaded = true;
	      _this3.initializeHandPosition();
	    }
	  };
	
	  this.initializeHandPosition = function () {
	    var storySlick = _reactDom2.default.findDOMNode(_this3._slickRef).getElementsByClassName("story-slick");
	    if (storySlick.length > 0) {
	      if (storySlick[0].childNodes[0]) {
	        var firstBullet = storySlick[0].childNodes[0].getBoundingClientRect();
	        _this3.setState({
	          handPositionX: firstBullet.x - _this3.props.screen.screenHeight * 0.03 * 1.25,
	          handPositionY: firstBullet.y * 1.0212,
	          handOpacity: 1,
	          imagesLoaded: true
	        });
	      }
	    }
	  };
	
	  this.setupElements = function (rootFolder) {
	    var background = (0, _shared.dp)(_this3.props.screen, null, { path: "/img/omaha/general/", file_name: "story-background.jpg" });
	    _this3._story = rootFolder;
	    _this3._background = background;
	    _this3._headLine = _this3.props.module.name.toUpperCase();
	    if (_lodash2.default.has(_this3.props.module, "overrideStoryName")) {
	      _this3._headLine = _this3.props.module.overrideStoryName;
	    }
	    var handIcon = (0, _shared.dp)(_this3.props.screen, null, { path: "/img/ui/", file_name: "handIconSwipe.png" });
	    _this3._handIcon = handIcon;
	
	    _this3.setState({ rootFolder: rootFolder });
	  };
	
	  this.getSlides = function () {
	    var images = _this3._story.contents.images;
	    var occupiedSlots = _lodash2.default.filter(images, function (img) {
	      return img !== null;
	    });
	    var slides = [];
	
	    for (var i = 0; i < occupiedSlots.length; i++) {
	      if (occupiedSlots[i]) {
	        _this3._totalSlides++;
	      }
	    }
	
	    if (occupiedSlots.length > 0) {
	      slides = occupiedSlots.map(function (media, i) {
	        if (media) {
	          return _react2.default.createElement(
	            "div",
	            { key: i, style: { display: "table" } },
	            _react2.default.createElement(
	              "div",
	              { style: { display: "table-cell", verticalAlign: "middle", height: "28vh" } },
	              _react2.default.createElement("img", {
	                style: {
	                  maxWidth: "38vh",
	                  maxHeight: "28vh",
	                  display: "table-cell",
	                  verticalAlign: "middle",
	                  margin: "auto"
	                },
	                src: (0, _shared.dp)(_this3.props.screen, media, null),
	                onLoad: function onLoad() {
	                  return _this3._imagesStatus[i] = true;
	                },
	                onError: function onError() {
	                  return _this3._imagesStatus[i] = false;
	                },
	                alt: ""
	              })
	            )
	          );
	        }
	
	        return _react2.default.createElement("span", null);
	      });
	    }
	
	    _this3._slides = slides;
	  };
	
	  this.getBackgroundImage = function () {
	    var defaultImg = { path: "/img/omaha/general/", file_name: "story-background.jpg" };
	
	    if (_this3.props.screensNumber === 2) {
	      defaultImg.file_name = "default_double_screen.jpg";
	    }
	
	    try {
	      var backgroundReference = _this3.props.module.contents.custom_fields.background_reference_story_view.val;
	      var assetsSlideShow = _lodash2.default.find(_this3.props.content.dm_active, function (o) {
	        return o.name.includes("Assets");
	      });
	      var asset = _lodash2.default.indexOf(assetsSlideShow.contents.names, backgroundReference);
	
	      if (!asset || asset === undefined) {
	        return (0, _shared.dp)(_this3.props.screen, defaultImg);
	      }
	
	      return (0, _shared.dp)(_this3.props.screen, assetsSlideShow.contents.images[asset]);
	    } catch (e) {
	      return (0, _shared.dp)(_this3.props.screen, defaultImg);
	    }
	  };
	
	  this.getIcon = function () {
	    var category = _this3.props.module.folder;
	    var foundDm = _lodash2.default.filter(_this3.props.content.dm_active, function (dm) {
	      return Number(dm.contents.story_category) === category;
	    });
	
	    var icon = null;
	    if (foundDm.length > 0) {
	      icon = foundDm[0].module_contents.icon;
	    }
	
	    return (0, _shared.dp)(_this3.props.screen, icon);
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var active_module = state.active_module;
	  return {
	    active_module: active_module,
	    content: state.content
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(StoryOmaha);

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TouchGestureOmaha = function (_Component) {
	  _inherits(TouchGestureOmaha, _Component);
	
	  function TouchGestureOmaha(props) {
	    _classCallCheck(this, TouchGestureOmaha);
	
	    var _this = _possibleConstructorReturn(this, (TouchGestureOmaha.__proto__ || Object.getPrototypeOf(TouchGestureOmaha)).call(this, props));
	
	    _this.animateStartButton = function (show) {
	      if (_this._startButtonRef) {
	        if (show) {
	          _this._startButtonRef.animate([{
	            transform: "scale(1)"
	          }, {
	            transform: "scale(1.25)"
	          }], {
	            fill: "forwards",
	            duration: 2000
	          });
	        } else {
	          _this._startButtonRef.animate([{
	            transform: "scale(1.25)"
	          }, {
	            transform: "scale(0.75)"
	          }], {
	            fill: "forwards",
	            duration: 2000
	          });
	        }
	      }
	    };
	
	    _this.startFadeInterval = function (status) {
	      var newStatus = !status;
	      if (newStatus) {
	        clearTimeout(_this._intervalFade);
	        _this._intervalFadeA = setTimeout(function () {
	          _this.setState({
	            showButton: newStatus
	          });
	          _this.animateStartButton(newStatus);
	          _this.startFadeInterval(newStatus);
	        }, 5000);
	      } else {
	        clearTimeout(_this._intervalFade);
	        _this._intervalFadeB = setTimeout(function () {
	          _this.animateStartButton(newStatus);
	          setTimeout(function () {
	            _this.setState({
	              showButton: newStatus
	            });
	            _this.startFadeInterval(newStatus);
	          }, 2000);
	        }, 5000);
	      }
	    };
	
	    _this._startButtonRef = null;
	    _this._intervalFadeA = null;
	    _this._intervalFadeB = null;
	    _this._screensNumber = 1;
	
	    _this.state = {
	      showButton: true
	    };
	    return _this;
	  }
	
	  _createClass(TouchGestureOmaha, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startFadeInterval(this.state.showButton);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this._intervalFadeA);
	      clearTimeout(this._intervalFadeB);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { style: { position: "absolute", top: this.props.contentY, left: this.props.contentX } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: "div",
	            className: "containerFade",
	            style: { minHeight: "100%" },
	            transitionName: "example",
	            transitionEnterTimeout: 2000,
	            transitionLeaveTimeout: 2000
	          },
	          _react2.default.createElement(
	            "div",
	            { key: this.state.showButton },
	            this.state.showButton ? _react2.default.createElement(
	              "div",
	              {
	                ref: function ref(el) {
	                  return _this2._startButtonRef = el;
	                },
	                style: {
	                  position: "absolute",
	                  top: "43.356510416vh",
	                  width: this.props.screen.screenWidth / this._screensNumber,
	                  height: "5vh",
	                  textAlign: "center"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { style: { width: "100%" } },
	                _react2.default.createElement("img", { style: { maxWidth: "12vh", maxHeight: "12vh" }, src: "/img/miami/ui/start.png", alt: "" })
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return TouchGestureOmaha;
	}(_react.Component);
	
	exports.default = TouchGestureOmaha;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import timeHelpers from '../../../utils/timeHelpers.js';
	
	
	// const RANDOM_MODE = "random";
	var LAYOUT_MODE = "layout";
	var LAYOUT_A = "a";
	var LAYOUT_B = "b";
	var SHOWING = "showing";
	var HIDDEN = "hidden";
	var SLIDES_DELAY = 3000;
	var PHRASE = "phrase";
	var WORD = "word";
	
	var CheckerboardSeattle = function (_Component) {
	  _inherits(CheckerboardSeattle, _Component);
	
	  function CheckerboardSeattle(props) {
	    _classCallCheck(this, CheckerboardSeattle);
	
	    var _this = _possibleConstructorReturn(this, (CheckerboardSeattle.__proto__ || Object.getPrototypeOf(CheckerboardSeattle)).call(this, props));
	
	    _this.setupSlidesIntervalHandlerB = function () {
	      // console.log("Entering");
	      var slidesLeft = [];
	
	      var calculatedSlideCycleTimeout = _this._currentStatus === SHOWING ? _this._slideCycleTimeout : SLIDES_DELAY;
	      if (_this._chosenSlidesIndexes.length < 3 && _this._chosenSlidesIndexes.length > 0) {
	        calculatedSlideCycleTimeout = 1000;
	      }
	
	      var intervalTimeout = setTimeout(function () {
	        if (_this._currentStatus === HIDDEN) {
	          if (_this._currentLayout === LAYOUT_A) {
	            if (_this._slideScreens.length === 0) {
	              _this._slideScreens = _lodash2.default.shuffle([0, 4, 2]);
	              // this._wordsScreens = _.shuffle([3, 1, 5]);
	            }
	          } else {
	            if (_this._slideScreens.length === 0) {
	              _this._slideScreens = _lodash2.default.shuffle([3, 1, 5]);
	              // this._wordsScreens = _.shuffle([0, 4 ,2]);
	            }
	          }
	
	          // Number of images to pull is hardcoded
	          // Future change for dynamic selecting this
	          slidesLeft = _this._slidesIndex.diff(_this._pulledSlidesIndex);
	          if (slidesLeft.length === 0) {
	            _this._pulledSlidesIndex = [];
	            slidesLeft = _this._slidesIndex.diff(_this._pulledSlidesIndex);
	          }
	          var randomSlideIndex = _shared2.default.getRandomInt(0, slidesLeft.length - 1);
	          _this._chosenSlidesIndexes.push(slidesLeft[randomSlideIndex]);
	          _this._pulledSlidesIndex.push(slidesLeft[randomSlideIndex]);
	          _this._pulledSlidesCount++;
	
	          // console.log("Slides Count", this._pulledSlidesCount);
	
	          _this._iterator++;
	          _this.setState({
	            chosenSlidesIndexes: _this._chosenSlidesIndexes,
	            chosenScreens: _this._slideScreens,
	            iterator: _this._iterator,
	            showWords: false,
	            showSlides: true
	          });
	
	          if (_this._pulledSlidesCount >= 3) {
	            // this.setupWordsInterval();
	            _this._pulledSlidesCount = 0;
	            // console.log("screen count", this._screenCount)
	
	            // if (this._screenCount < 3) {
	            //   // console.log("Execute again");
	            //   this._screenCount++;
	            // }
	            _this._currentLayout = _this._currentLayout === LAYOUT_A ? LAYOUT_B : LAYOUT_A;
	            _this._currentStatus = SHOWING;
	          }
	
	          _this.setupSlidesIntervalHandlerB();
	          // if (this._screenCount < 3) {
	          // }
	        } else {
	          _this._iterator++;
	          _this.setState({
	            iterator: _this._iterator,
	            showWords: false,
	            showSlides: false
	          });
	
	          _this._currentStatus = HIDDEN;
	          _this._chosenSlidesIndexes = [];
	          _this._chosenWordsIndexes = [];
	          _this._slideScreens = [];
	          _this._pulledSlidesCount = 0;
	          _this.setupSlidesIntervalHandlerB();
	        }
	      }, calculatedSlideCycleTimeout);
	
	      _this._invervalTimeoutArr.push(intervalTimeout);
	    };
	
	    _this.setupWordsInterval = function () {
	      var wordsTimeout = 1000;
	      var wordsLeft = [];
	
	      if (_this._currentWordsLayout === LAYOUT_A) {
	        if (_this._wordsScreens.length === 0) {
	          _this._wordsScreens = _lodash2.default.shuffle([3, 1, 5]);
	        }
	      } else {
	        if (_this._wordsScreens.length === 0) {
	          _this._wordsScreens = _lodash2.default.shuffle([0, 4, 2]);
	        }
	      }
	
	      if (_this._chosenWordsIndexes.length === 0) {
	        wordsTimeout = _this._slideWordCycleTimeout;
	      }
	
	      // clearTimeout(this._invervalWordsTimeout);
	      var intervalWordsTimeout = setTimeout(function () {
	        wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	
	        if (_this._currentWordMode === PHRASE) {
	          wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	            var splitedWords = _this._slidesWords[o].split(" ");
	            return splitedWords.length > 1;
	          });
	        } else {
	          wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	            var splitedWords = _this._slidesWords[o].split(" ");
	            return splitedWords.length === 1;
	          });
	        }
	
	        if (wordsLeft.length === 0 || wordsLeft.length < 3) {
	          _this._pulledWordsIndex = [];
	          wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	
	          _this._chosenWordsIndexes = [];
	          if (_this._currentWordMode === PHRASE) {
	            wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	              var splitedWords = _this._slidesWords[o].split(" ");
	              return splitedWords.length > 1;
	            });
	            if (wordsLeft.length === 0 || wordsLeft.length < 3) {
	              wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	              wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	                var splitedWords = _this._slidesWords[o].split(" ");
	                return splitedWords.length === 1;
	              });
	              _this._currentWordMode = WORD;
	            }
	          } else {
	            wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	              var splitedWords = _this._slidesWords[o].split(" ");
	              return splitedWords.length === 1;
	            });
	            if (wordsLeft.length === 0 || wordsLeft.length < 3) {
	              wordsLeft = _this._wordsIndex.diff(_this._pulledWordsIndex);
	              wordsLeft = _lodash2.default.filter(wordsLeft, function (o) {
	                var splitedWords = _this._slidesWords[o].split(" ");
	                return splitedWords.length > 1;
	              });
	              _this._currentWordMode = PHRASE;
	            }
	          }
	        }
	
	        if (wordsLeft.length > 0) {
	          var chosenWordIndex = _shared2.default.getRandomInt(0, wordsLeft.length - 1);
	
	          _this._chosenWordsIndexes.push(wordsLeft[chosenWordIndex]);
	          _this._pulledWordsIndex.push(wordsLeft[chosenWordIndex]);
	        }
	
	        _this._iterator++;
	        _this.setState({
	          chosenWordsIndexes: _this._chosenWordsIndexes,
	          wordsScreens: _this._wordsScreens,
	          iterator: _this._iterator,
	          showWords: true
	        });
	
	        if (_this._chosenWordsIndexes.length < 3) {
	          _this.setupWordsInterval();
	        } else {
	          _this._currentWordsLayout = _this._currentWordsLayout === LAYOUT_A ? LAYOUT_B : LAYOUT_A;
	          _this._currentWordMode = _this._currentWordMode === PHRASE ? WORD : PHRASE;
	          _this._pulledWordsIndex = [];
	          _this._wordsScreens = [];
	        }
	      }, wordsTimeout);
	      _this._invervalWordsTimeoutArr.push(intervalWordsTimeout);
	    };
	
	    _this.renderSlides = function () {
	      var images = [];
	
	      _this._pulledSlidesIndex.forEach(function (value, index) {
	        images.push({
	          background: _this._slides[value].image,
	          screen: _this._pulledScreens[index]
	        });
	      });
	
	      var slideStyle = {
	        position: "absolute",
	        width: _this.props.screen.screenWidth / _this.props.xScreens,
	        height: _this.props.screen.screenHeight / _this.props.yScreens
	      };
	
	      var renderedImages = images.map(function (row, i) {
	        var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	        var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	
	        return _react2.default.createElement('div', { key: i, style: Object.assign({}, slideStyle, { left: slideLeft, top: slideTop, backgroundImage: "url(" + row.background + ")", backgroundSize: "cover" }) });
	      });
	
	      return renderedImages;
	    };
	
	    _this.renderWords = function () {
	      var words = [];
	
	      _this._pulledWordsIndex.forEach(function (value, index) {
	        words.push({
	          word: _this._slidesWords[value],
	          screen: _this._pulledScreens[index]
	        });
	      });
	
	      var slideStyle = {
	        position: "absolute",
	        width: _this.props.screen.screenWidth / _this.props.xScreens,
	        height: _this.props.screen.screenHeight / _this.props.yScreens,
	        display: "table"
	      };
	
	      var textShadow = Math.ceil(_this.props.screen.screenWidth * 0.001041667);
	
	      var centeredDiv = {
	        display: "table-cell",
	        verticalAlign: "middle",
	        textAlign: "center"
	      };
	
	      if (_this.props.textShadow) {
	        centeredDiv.textShadow = textShadow + "px " + textShadow + "px 3px rgba(0,0,0,1)";
	      }
	
	      var style = {
	        font: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.font', 'Roboto'),
	        color: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontColor', '#FFFFFF'),
	        fontSize: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontSize', "6.5") + "vh",
	        fontStyle: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontStyle', "Normal"),
	        fontWeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontWeight', 100),
	        lineHeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.lineHeight', null),
	        justification: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.justification', null),
	        display: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.display', true) ? 'block' : 'none'
	      };
	
	      var renderedWords = words.map(function (row, i) {
	        var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	        var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	        // let fontSize = row.word.split(" ").length > 1 ? "5.78vh" : "8.10vh";
	
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: Object.assign({}, style, slideStyle, { left: slideLeft, top: slideTop }) },
	          _react2.default.createElement(
	            'div',
	            { style: Object.assign({}, centeredDiv) },
	            _react2.default.createElement(
	              'span',
	              { style: { color: "white" } },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: row.word })
	            )
	          )
	        );
	      });
	
	      return renderedWords;
	    };
	
	    _this.renderLayoutSlides = function () {
	      // console.log("Slides Indexes", this.state);
	      // console.log("Chosen Screens", this.state);
	      try {
	
	        var renderedImages = null;
	        var images = [];
	
	        if (_lodash2.default.has(_this.state, "chosenSlidesIndexes")) {
	          _this.state.chosenSlidesIndexes.forEach(function (index, i) {
	            images.push({
	              background: _this._slides[index].image,
	              screen: _this.state.chosenScreens[i]
	            });
	          });
	
	          var slideStyle = {
	            position: "absolute",
	            width: _this.props.screen.screenWidth / _this.props.xScreens,
	            height: _this.props.screen.screenHeight / _this.props.yScreens
	          };
	
	          renderedImages = images.map(function (row, i) {
	            var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	            var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	
	            return _react2.default.createElement('div', { key: i, style: Object.assign({}, slideStyle, { left: slideLeft, top: slideTop, backgroundImage: "url(" + row.background + ")", backgroundSize: "cover" }) });
	          });
	        }
	
	        return renderedImages;
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this.renderLayoutWords = function () {
	      var renderedWords = null;
	      var words = [];
	
	      if (_lodash2.default.has(_this.state, "chosenWordsIndexes")) {
	        // console.log("Chosen Words Indexes", JSON.stringify(this.state.chosenWordsIndexes));
	        if (_this.state.chosenWordsIndexes) {
	          _this.state.chosenWordsIndexes.forEach(function (index, i) {
	            words.push({
	              word: _this._slidesWords[index],
	              screen: _this.state.wordsScreens[i]
	            });
	          });
	        }
	
	        var slideStyle = {
	          position: "absolute",
	          width: _this.props.screen.screenWidth / _this.props.xScreens,
	          height: _this.props.screen.screenHeight / _this.props.yScreens,
	          display: "table"
	        };
	
	        var textShadow = Math.ceil(_this.props.screen.screenWidth * 0.001041667);
	
	        var centeredDiv = {
	          display: "table-cell",
	          verticalAlign: "middle",
	          textAlign: "center"
	        };
	
	        if (_this.props.textShadow) {
	          centeredDiv.textShadow = textShadow + "px " + textShadow + "px 3px rgba(0,0,0,1)";
	        }
	
	        var style = {
	          font: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.font', 'Roboto'),
	          fontColor: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontColor', '#FFFFFF'),
	          fontSize: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontSize', "6.5") + "vh",
	          fontStyle: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontStyle', "Normal"),
	          fontWeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.fontWeight', 100),
	          lineHeight: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.lineHeight', null),
	          justification: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.justification', null),
	          display: _lodash2.default.get(_this.props.element, 'customFields.related_words_style.display', true) ? 'table' : 'none'
	        };
	
	        if (words.length > 0) {
	          renderedWords = words.map(function (row, i) {
	            var slideLeft = row.screen % _this.props.xScreens * slideStyle.width;
	            var slideTop = Math.floor(row.screen / _this.props.xScreens) * slideStyle.height;
	
	            return _react2.default.createElement(
	              'div',
	              { key: i, style: Object.assign({}, style, slideStyle, { left: slideLeft, top: slideTop }) },
	              _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, centeredDiv) },
	                _react2.default.createElement(
	                  'span',
	                  { style: { color: style.fontColor } },
	                  _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: row.word })
	                )
	              )
	            );
	          });
	        }
	      }
	
	      return renderedWords;
	    };
	
	    try {
	      _this._currentBackground = null;
	      _this._currentLayout = LAYOUT_A;
	      _this._currentWordsLayout = LAYOUT_A;
	      _this._currentWordMode = Math.floor(Math.random() * 10 + 1) % 2 === 0 ? PHRASE : WORD;
	      _this._currentMode = LAYOUT_MODE;
	      _this._currentStatus = HIDDEN;
	
	      _this._finishCycle = false;
	      _this._chosenMode = false;
	      _this._iterator = 0;
	      _this._screenCount = 0;
	      _this._pulledSlidesCount = 0;
	      _this._quoteCycleTime = 0;
	      _this._slides = [];
	      _this._slidesWords = [];
	      _this._slideScreens = [];
	      _this._wordsScreens = [];
	      _this._selectedWordIndex = null;
	      _this._slideCycleTimeout = _this.props.communitiesSlideCycleTime;
	      _this._slideWordCycleTimeout = _this.props.communitiesWordCycleTime;
	      _this._wordsStyle = null;
	
	      if (_this.props.id !== undefined && _this.props.id !== null) {
	        if (_this.props.id === 0 || _this.props.id % 2 === 0) {
	          _this._currentLayout = LAYOUT_A;
	        } else {
	          _this._currentLayout = LAYOUT_B;
	        }
	      }
	
	      _this.setupElements();
	
	      _this._slidesIndex = _this._slides.map(function (x, index) {
	        return index;
	      });
	      _this._wordsIndex = _this._slidesWords.map(function (x, index) {
	        return index;
	      });
	
	      _this._pulledSlidesIndex = [];
	      _this._pulledImages = [];
	      _this._pulledScreens = [];
	      _this._pulledWordsIndex = [];
	      _this._chosenSlidesIndexes = [];
	      _this._chosenWordsIndexes = [];
	
	      _this._invervalTimeoutArr = [];
	      _this._invervalWordsTimeoutArr = [];
	      _this._totalScreens = _this.props.yScreens * _this.props.xScreens;
	      _this._screenNumbers = Array.apply(null, { length: _this._totalScreens }).map(Number.call, Number);
	      _this._spanStyle = Array.apply(null, { length: _this._totalScreens }).map(function (value) {
	        return {};
	      });
	
	      /*eslint no-extend-native: ["warn", { "exceptions": ["Array"] }]*/
	      Array.prototype.diff = function (a) {
	        return this.filter(function (i) {
	          return a.indexOf(i) < 0;
	        });
	      };
	
	      if (_this.props.setCurrentBackground) {
	        _this.props.setCurrentBackground(_this._currentBackground.image);
	      }
	
	      _this.state = {
	        background: _this._currentBackground,
	        slides: _this._slides
	      };
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(CheckerboardSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        this.setupSlidesIntervalHandlerB();
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._invervalTimeoutArr.map(function (timeoutHandler) {
	        return clearTimeout(timeoutHandler);
	      });
	    }
	  }, {
	    key: 'setupElements',
	    value: function setupElements() {
	      var _this2 = this;
	
	      var rawSlides = _lodash2.default.get(this.props.module, 'contents.custom_fields.slides_images.val', []);
	      var rawBackgrounds = _lodash2.default.get(this.props.module, 'contents.custom_fields.backgrounds_images.val', []);
	      var slides = rawSlides.map(function (slide) {
	        return {
	          image: _shared2.default.dp(_this2.props.screen, slide)
	        };
	      });
	      if (rawSlides.length < 3) {
	        for (var i = 0; i < 3 - rawSlides.length; i++) {
	          slides.push({
	            image: _shared2.default.dp(this.props.screen, { path: "public/img/seattle/general", file_name: "transparent.png" })
	          });
	        }
	      }
	      var backgrounds = rawBackgrounds.map(function (background) {
	        return {
	          image: _shared2.default.dp(_this2.props.screen, background)
	        };
	      });
	
	      // let slides = [];
	      // let backgrounds = [];
	      // // let pairLength = 0;
	
	      // let element = this.props.module;
	      // let slideshowSlidesModuleId = _.get(element.contents, 'custom_fields.slides.val.value', null);
	      // let slideshowBackgroundModuleId = _.get(element.contents, 'custom_fields.backgrounds.val.value', null);
	
	      // let slideshowSlidesModule = _.find(this.props.content.dm_active, { id: slideshowSlidesModuleId });
	      // let slideshowBackgroundsModule = _.find(this.props.content.dm_active, { id: slideshowBackgroundModuleId });
	
	      // if (slideshowSlidesModule.contents.images.length > 0) {
	      //   for (let i = 0; i < slideshowSlidesModule.contents.images.length; i++) {
	      //     if (slideshowSlidesModule.contents.images[i]) {
	      //       slides.push({ image: shared.dp(this.props.screen, slideshowSlidesModule.contents.images[i])});
	      //     }
	      //   }
	      // }
	
	      // if (slideshowBackgroundsModule.contents.images.length > 0) {
	      //   for (let i = 0; i < slideshowBackgroundsModule.contents.images.length; i++) {
	      //     if (slideshowBackgroundsModule.contents.images[i]) {
	      //       backgrounds.push({ image: shared.dp(this.props.screen, slideshowBackgroundsModule.contents.images[i])});
	      //     }
	      //   }
	      // }
	
	      // console.log("Backgrounds", backgrounds);
	      // console.log("slides", slides);
	
	      // Checking words Array
	      // let wordPairs = _.get(this.props.element, 'arrays.words_pair', null);
	      // let wordsPairsValues = _.get(this.props.element, 'arraysValues.words_pair', null);
	      // this._quoteCycleTime = _.get(this.props.element, 'customFields.language_quote_cycle_time.val', 20000);
	
	      // if (wordPairs) {
	      //   pairLength = wordPairs.values.length;
	      //   for (let i = 0; i < pairLength; i++) {
	      //     wordPairs.values[i].main_word['value'] = _.get(wordsPairsValues, '[' + i + '].main_word.val', null);
	      //     wordPairs.values[i].words['value'] = _.get(wordsPairsValues, '[' + i + '].words.val', null);
	      //   }
	      // }
	
	      // this._selectedWordIndex = timeHelpers.indexFromInterval(this._quoteCycleTime, wordPairs.values.length);
	      // this._slidesWords = wordPairs.values[this._selectedWordIndex].words.value.split(",");
	      // this._slidesWords = _.map(this._slidesWords, (word) => {
	      //   let trimmedWord = word.trim();
	      //   return trimmedWord;
	      // });
	
	      var backgroundIndex = _shared2.default.getRandomInt(0, backgrounds.length - 1);
	      this._currentBackground = backgrounds[backgroundIndex];
	      this._slides = slides;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      try {
	        var slides = null;
	        // let words = null;
	
	        if (this._currentMode === LAYOUT_MODE) {
	          // console.log("Got in layout mode");
	          slides = this.renderLayoutSlides();
	          // words = this.renderLayoutWords();
	        } else {
	          // console.log("Got in random mode");
	          slides = this.renderSlides();
	          // words = this.renderWords();
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundSize: "cover", backgroundImage: "url(" + this.state.background.image + ")" } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.iterator },
	              this.state.showSlides ? slides : null
	            )
	          )
	        );
	      } catch (e) {
	        console.log(e);
	        return _react2.default.createElement('div', null);
	      }
	    }
	  }]);
	
	  return CheckerboardSeattle;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var textShadow = _shared2.default.parseStringParam(window.location.href, "textShadow");
	  var id = _shared2.default.parseStringParam(window.location.href, "id");
	  var communitiesSlideCycleTime = Number(_lodash2.default.get(state.content.settings.custom_vars, 'slidescycletime', 27000));
	  var communitiesWordCycleTime = Number(_lodash2.default.get(state.content.settings.custom_vars, 'wordscycletime', 3000));
	
	  if (!textShadow) {
	    textShadow = false;
	  }
	
	  var dm = void 0;
	  if (state.options.idleModule === undefined) {
	    dm = state.content.dm_active[state.active_module];
	  } else {
	    dm = _lodash2.default.find(state.content.stories, { id: state.options.idleModule });
	  }
	
	  return {
	    id: id,
	    module: dm,
	    screen: state.screen,
	    content: state.content,
	    communitiesSlideCycleTime: communitiesSlideCycleTime,
	    communitiesWordCycleTime: communitiesWordCycleTime,
	    textShadow: textShadow
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CheckerboardSeattle);

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _StorySeattle = __webpack_require__(64);
	
	var _StorySeattle2 = _interopRequireDefault(_StorySeattle);
	
	var _VideoSeattle = __webpack_require__(484);
	
	var _VideoSeattle2 = _interopRequireDefault(_VideoSeattle);
	
	var _StoriesSeattle = __webpack_require__(480);
	
	var _StoriesSeattle2 = _interopRequireDefault(_StoriesSeattle);
	
	var _TimelineSeattle = __webpack_require__(481);
	
	var _TimelineSeattle2 = _interopRequireDefault(_TimelineSeattle);
	
	var _DonorListSeattle = __webpack_require__(471);
	
	var _DonorListSeattle2 = _interopRequireDefault(_DonorListSeattle);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _UserInputSeattle = __webpack_require__(483);
	
	var _UserInputSeattle2 = _interopRequireDefault(_UserInputSeattle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import shared from '../../../utils/shared.js';
	
	// import { dp } from '../../../utils/shared.js';
	
	
	var STORY = "Story";
	var VIDEO = "Video";
	var DONOR_LIST = "Donor List";
	var TIMELINE = "Timeline";
	var USER_INPUT = "User Input";
	
	var ContentSeattle = function (_Component) {
	  _inherits(ContentSeattle, _Component);
	
	  function ContentSeattle(props) {
	    _classCallCheck(this, ContentSeattle);
	
	    var _this = _possibleConstructorReturn(this, (ContentSeattle.__proto__ || Object.getPrototypeOf(ContentSeattle)).call(this, props));
	
	    _this.setupContent = function () {
	      if (_this.props.content && _this.props.content.children) {
	        // Check the length first.
	        if (_this.props.content.children.length === 1) {
	          var type = _this.determineContentType(_this.props.content.children[0]);
	          if (type.name === DONOR_LIST) {
	            _this.renderDonorList(_this.props.content.children, _this.props.content);
	          } else {
	            _this.renderContent(_this.props.content.children[0], type.name);
	          }
	        } else if (_this.props.content.children.length > 0) {
	          var _type = _this.determineContentType(_this.props.content.children[0]);
	          switch (_type.name) {
	            case STORY:
	              _this.renderStories(_this.props.content.children, _this.props.content);
	              break;
	            case TIMELINE:
	              _this.renderTimeline(_this.props.content.children, _this.props.content);
	              break;
	            case DONOR_LIST:
	              _this.renderDonorList(_this.props.content.children, _this.props.content);
	              break;
	            default:
	              break;
	          }
	        }
	      }
	    };
	
	    _this.determineContentType = function (item) {
	      if (item.folder_module.display_module_type === 0) {
	        if (item.folder_module.model === "story") {
	          var type = _lodash2.default.get(item, 'contents.custom_fields.story_type.val.value', 'single_story');
	          switch (type) {
	            case 'single_story':
	              return { name: "Story" };
	            case 'timeline':
	              return { name: "Timeline" };
	            case "video":
	              return { name: "Video" };
	            default:
	              break;
	          }
	        } else if (item.folder_module.model === "donor") {
	          return { name: DONOR_LIST };
	        }
	      }
	
	      var categories = _this.props.stateContent.display_module_types;
	      var itemCategory = _lodash2.default.find(categories, { id: item.folder_module.display_module_type });
	
	      return itemCategory;
	    };
	
	    _this.renderContent = function (content, type) {
	      var renderedContent = null;
	      switch (type) {
	        case STORY:
	          renderedContent = _react2.default.createElement(_StorySeattle2.default, { item: content, screen: _this.props.screen, regionWidth: _this.props.regionWidth, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	          break;
	        case VIDEO:
	          renderedContent = _react2.default.createElement(_VideoSeattle2.default, { item: content, screen: _this.props.screen, regionWidth: _this.props.regionWidth, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	          break;
	        case TIMELINE:
	          renderedContent = _react2.default.createElement(_TimelineSeattle2.default, { items: [content], screen: _this.props.screen, regionWidth: _this.props.regionWidth, regionHeight: _this.props.regionHeight, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	          break;
	        case USER_INPUT:
	          renderedContent = _react2.default.createElement(_UserInputSeattle2.default, { item: content, regionWidth: _this.props.regionWidth, regionHeight: _this.props.regionHeight, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	          break;
	        default:
	          renderedContent = null;
	          break;
	      }
	
	      _this.setState({
	        renderedContent: renderedContent
	      });
	    };
	
	    _this.renderStories = function (content, contentParent) {
	      var renderedContent = _react2.default.createElement(_StoriesSeattle2.default, { items: content, screen: _this.props.screen, parent: contentParent, rows: 3, columns: 3, regionWidth: _this.props.regionWidth, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	      _this.setState({
	        renderedContent: renderedContent
	      });
	    };
	
	    _this.renderTimeline = function (content, contentParent) {
	      var renderedContent = _react2.default.createElement(_TimelineSeattle2.default, { items: content, screen: _this.props.screen, parent: contentParent, regionWidth: _this.props.regionWidth, regionHeight: _this.props.regionHeight, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	      _this.setState({
	        renderedContent: renderedContent
	      });
	    };
	
	    _this.renderDonorList = function (content, contentParent) {
	      var renderedContent = _react2.default.createElement(_DonorListSeattle2.default, { items: content, parent: contentParent, regionWidth: _this.props.regionWidth, handleSwipeAnimation: _this.props.handleSwipeAnimation, cancelSwipeAnimation: _this.props.cancelSwipeAnimation });
	      _this.setState({
	        renderedContent: renderedContent
	      });
	    };
	
	    var radius = _this.props.regionWidth;
	    var top = (_this.props.regionHeight - radius) / 2;
	    var right = -(_this.props.regionWidth / 100 * 36.45);
	    _this.state = {
	      radius: radius,
	      top: top,
	      right: right,
	      content: null
	    };
	    return _this;
	  }
	
	  _createClass(ContentSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupContent();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps !== this.props) {
	        this.setupContent();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderedContent = this.state.renderedContent;
	      var style = {
	        position: "absolute",
	        top: this.state.top,
	        right: this.state.right,
	        background: this.props.backgroundColor,
	        borderBottomLeftRadius: "50%",
	        borderTopLeftRadius: "50%",
	        height: this.state.radius,
	        width: this.state.radius
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", height: this.props.regionHeight, width: this.props.regionWidth, overflow: "hidden", top: this.props.contentY, left: this.props.contentX } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement('div', { key: this.props.backgroundColor, style: Object.assign({}, style) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", height: this.props.regionHeight, width: this.props.regionWidth, top: this.props.contentY, left: this.props.contentX } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", top: 0.01305 * this.props.regionWidth, width: 0.4141 * this.props.regionWidth, left: 0.5693 * this.props.regionWidth, height: 0.5287 * this.props.regionWidth }, key: this.props.content ? this.props.content.id : null },
	              this.props.content ? renderedContent : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ContentSeattle;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    stateContent: state.content,
	    screen: state.screen,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(ContentSeattle);

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonorListSeattle = function (_Component) {
	  _inherits(DonorListSeattle, _Component);
	
	  function DonorListSeattle(props) {
	    _classCallCheck(this, DonorListSeattle);
	
	    var _this = _possibleConstructorReturn(this, (DonorListSeattle.__proto__ || Object.getPrototypeOf(DonorListSeattle)).call(this, props));
	
	    _this.intervalCheckSwipeAnimation = function () {
	      if (!_this._contentRef) {
	        setTimeout(function () {
	          _this.intervalCheckSwipeAnimation();
	        }, 100);
	      } else {
	        _this.checkSwipeAnimation();
	      }
	    };
	
	    _this.checkSwipeAnimation = function () {
	      var scrollWrapperHeight = .28 * _this.props.regionWidth;
	      var contentHeight = _this._contentRef.getBoundingClientRect().height;
	      _this.props.handleSwipeAnimation(scrollWrapperHeight, contentHeight);
	    };
	
	    _this.renderDonors = function () {
	      var orderedDonors = _lodash2.default.orderBy(_this.props.items, [function (item) {
	        return item.sorting_name.toLowerCase();
	      }], ['asc']);
	      var columnOne = [];
	      var columnTwo = [];
	      var hasTributes = false;
	      var renderedColumns = "";
	
	      for (var i = 0; i < orderedDonors.length; i++) {
	        if (orderedDonors[i].contents.arrays_values && orderedDonors[i].contents.arrays_values.acknowledgment_text_options) {
	          hasTributes = true;
	        }
	        if (i === 0 || i % 2 === 0) {
	          columnOne.push(orderedDonors[i]);
	        } else {
	          columnTwo.push(orderedDonors[i]);
	        }
	      }
	
	      if (hasTributes) {
	        var renderedColumnDonors = orderedDonors.map(function (donor, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this.props.regionWidth, display: "block", paddingTop: .0052 * _this.props.regionWidth } },
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { maxWidth: "85%", fontSize: 0.009 * _this.props.regionWidth } },
	              donor.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * _this.props.regionWidth } },
	              _this.getTributes(donor)
	            )
	          );
	        });
	
	        renderedColumns = _react2.default.createElement(
	          'div',
	          { style: { position: "relative", display: "flex" }, ref: function ref(el) {
	              return _this._contentRef = el;
	            } },
	          _react2.default.createElement(
	            'div',
	            { style: { width: 0.168 * _this.props.regionWidth } },
	            renderedColumnDonors
	          )
	        );
	      } else {
	        var renderedColumnOneDonors = columnOne.map(function (donor, i) {
	          var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .002 * _this.props.regionWidth : 0;
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this.props.regionWidth, display: "block", paddingTop: .0052 * _this.props.regionWidth } },
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { maxWidth: "85%", fontSize: 0.009 * _this.props.regionWidth, marginBottom: marginBottom } },
	              donor.name
	            )
	          );
	        });
	
	        var renderedColumnTwoDonors = columnTwo.map(function (donor, i) {
	          var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .002 * _this.props.regionWidth : 0;
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this.props.regionWidth, display: "block", paddingTop: .0052 * _this.props.regionWidth } },
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { maxWidth: "85%", fontSize: 0.009 * _this.props.regionWidth, marginBottom: marginBottom } },
	              donor.name
	            )
	          );
	        });
	
	        renderedColumns = _react2.default.createElement(
	          'div',
	          { style: { position: "relative", display: "flex" }, ref: function ref(el) {
	              return _this._contentRef = el;
	            } },
	          _react2.default.createElement(
	            'div',
	            { style: { width: 0.168 * _this.props.regionWidth, float: "left" } },
	            renderedColumnOneDonors
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: 0.168 * _this.props.regionWidth } },
	            renderedColumnTwoDonors
	          )
	        );
	      }
	
	      _this.setState({
	        hasTributes: hasTributes,
	        renderedColumns: renderedColumns
	      });
	    };
	
	    _this.getTributes = function (donor) {
	      var renderedTributes = [];
	      if (donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options) {
	        renderedTributes = donor.contents.arrays_values.acknowledgment_text_options.map(function (opt, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { paddingTop: _this.props.regionWidth * .00175, paddingBottom: _this.props.regionWidth * .0035 } },
	              opt.acknowledgment_text_options.val.title + ' ' + opt.donor_name.val
	            )
	          );
	        });
	      }
	
	      return renderedTributes;
	    };
	
	    _this.state = {
	      renderedColumns: null,
	      hasTributes: false
	    };
	    _this.iScroller = null;
	    _this._contentRef = null;
	    return _this;
	  }
	
	  _createClass(DonorListSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderDonors();
	      this.intervalCheckSwipeAnimation();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps !== this.props) {
	        this.renderDonors();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var justified = this.state.hasTributes ? "center" : "";
	      return _react2.default.createElement(
	        'div',
	        { style: { width: "100%", height: "100%", display: "table" } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: "table-cell", verticalAlign: "middle", marginLeft: "auto", marginRight: "auto", position: "relative" } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: "85%", minHeight: 0.024 * this.props.regionWidth, maxHeight: .090 * this.props.regionWidth, textAlign: "center", overflow: "hidden", marginLeft: "auto", marginRight: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { fontSize: 0.020 * this.props.regionWidth } },
	              _react2.default.createElement(_BRSpan2.default, { className: 'noselect', preWrap: true, str: this.props.parent.name.toUpperCase() })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: "85%", minHeight: .026 * this.props.regionWidth, maxHeight: 0.084 * this.props.regionWidth, textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", marginLeft: "auto", marginRight: "auto", marginTop: .0086 * this.props.regionWidth } },
	            _react2.default.createElement(
	              'div',
	              { className: 'noselect', style: { fontSize: 0.011 * this.props.regionWidth, fontStyle: "italic" } },
	              _react2.default.createElement(_BRSpan2.default, { className: 'noselect', preWrap: true, str: this.props.parent.description })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: .3038 * this.props.regionWidth, height: 0.28 * this.props.regionWidth, position: "relative", left: .07638 * this.props.regionWidth, touchAction: "none", marginTop: .0086 * this.props.regionWidth } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this2.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.015,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { style: { position: "relative", display: "flex", justifyContent: justified } },
	                this.state.renderedColumns
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DonorListSeattle;
	}(_react.Component);
	
	exports.default = DonorListSeattle;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBlock = function (_Component) {
		_inherits(InfoBlock, _Component);
	
		function InfoBlock(props) {
			_classCallCheck(this, InfoBlock);
	
			var _this = _possibleConstructorReturn(this, (InfoBlock.__proto__ || Object.getPrototypeOf(InfoBlock)).call(this, props));
	
			_this._containerStyle = {
				width: _this.props.width,
				height: _this.props.imageHeight,
				fontFamily: _this.props.fontFamily,
				fontSize: _this.props.fontSize,
				display: 'inline-block',
				position: 'relative'
			};
	
			_this._imageStyle = {
				display: 'block',
				width: _this.props.imageHeight,
				height: _this.props.imageHeight,
				borderTopLeftRadius: _this.props.unit * 0.15,
				borderTopRightRadius: _this.props.unit * 0.15,
				borderBottomLeftRadius: _this.props.unit * 0.15,
				borderBottomRightRadius: _this.props.unit * 0.15,
				zIndex: 1,
				overflow: "hidden"
			};
	
			_this._infoBlockStyle = {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				color: _this.props.infoColor,
				backgroundColor: _this.props.infoBackgroundColor,
				height: _this.props.imageHeight,
				borderBottomLeftRadius: _this.props.unit * 0.15,
				borderBottomRightRadius: _this.props.unit * 0.15,
				width: _this.props.width
			};
			return _this;
		}
	
		_createClass(InfoBlock, [{
			key: 'render',
			value: function render() {
				var float = this.props.floatRight ? "right" : "inherited";
				return _react2.default.createElement('div', { style: Object.assign({}, this._imageStyle, { backgroundImage: 'url(' + this.props.imgsrc + ')', backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", float: float }) });
				// return (
				// 	<div style={this._containerStyle}>
				// 		<img style={this._imageStyle} src={this.props.imgsrc} alt={name} />
				// 		{/* <div style={this._infoBlockStyle}>
				// 			<span style={{ marginRight: "0.625vh" }}>
				// 				<img alt="Forward" src={"/img/miami/ui/icon-arrow-forward.png"} style={{ display: 'inline-block', textAlign: 'right', width: "1.25vh" }} />
				// 			</span>
				// 		</div> */}
				// 	</div>
				// )
			}
		}]);
	
		return InfoBlock;
	}(_react.Component);
	
	module.exports = InfoBlock;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyboardKeySeattle = function (_Component) {
	  _inherits(KeyboardKeySeattle, _Component);
	
	  function KeyboardKeySeattle(props) {
	    _classCallCheck(this, KeyboardKeySeattle);
	
	    var _this = _possibleConstructorReturn(this, (KeyboardKeySeattle.__proto__ || Object.getPrototypeOf(KeyboardKeySeattle)).call(this, props));
	
	    _this.state = {
	      pressed: false,
	      canpress: true
	    };
	    return _this;
	  }
	
	  _createClass(KeyboardKeySeattle, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'handlePress',
	    value: function handlePress() {
	      var _this2 = this;
	
	      if (this.state.canpress === true) {
	        this.props.handleKeyPress(this.props.keyval[this.props.virtual_keyboard_mode]);
	        this.setState({
	          pressed: true,
	          canpress: false
	        });
	        this.timeout = setTimeout(function () {
	          _this2.setState({
	            pressed: false,
	            canpress: true
	          });
	          _this2.timeout = null;
	        }, 125);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var classes = "pressin keyopacity";
	      if (this.state.pressed === true) {
	        classes += " active";
	      }
	      if (this.props.contents[this.props.virtual_keyboard_mode] === null) {
	        classes += " keyhide";
	        return _react2.default.createElement(
	          'div',
	          { style: this.props.mainstyle, className: classes },
	          _react2.default.createElement(
	            'span',
	            { className: 'kspn-seattle' },
	            '\xA0'
	          )
	        );
	      }
	      classes += " phand";
	      var innercontent = void 0;
	      switch (this.props.contents[this.props.virtual_keyboard_mode]) {
	        case "UPCASE":
	          innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-up' }); //<Icon type="up-circle-o" />
	          break;
	        case "DOWNCASE":
	          innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-down' }); //<Icon type="down-circle-o" />
	          break;
	        case "DELETE":
	          innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-left' }); //<Icon type="left" />
	          break;
	        case "Submit":
	          innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	          break;
	        default:
	          innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { onMouseDown: function onMouseDown(e) {
	            return _this3.handlePress(e);
	          }, style: this.props.mainstyle, className: classes },
	        _react2.default.createElement(
	          'span',
	          { className: 'kspn-seattle' },
	          innercontent,
	          this.props.contents[this.props.virtual_keyboard_mode] === "Submit" ? _react2.default.createElement(
	            'div',
	            { style: { display: "inline-block" } },
	            '\xA0\xA0',
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-right' })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return KeyboardKeySeattle;
	}(_react.Component);
	
	exports.default = KeyboardKeySeattle;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListMenuSeattle = function (_Component) {
	  _inherits(ListMenuSeattle, _Component);
	
	  function ListMenuSeattle(props) {
	    _classCallCheck(this, ListMenuSeattle);
	
	    var _this = _possibleConstructorReturn(this, (ListMenuSeattle.__proto__ || Object.getPrototypeOf(ListMenuSeattle)).call(this, props));
	
	    _this.setupRefs = function () {
	      if (!_this._refsSetup) {
	        if (_this._itemsRefs.length > 0) {
	          var _loop = function _loop(i) {
	            if (_this._itemsRefs[i] && _this._itemsRefs[i].el) {
	              _this._itemsRefs[i].el.addEventListener('tap', function () {
	                return _this.handleClick(i);
	              }, { passive: true });
	              if (_this._itemsRefs[i].children && _this._itemsRefs[i].children.length > 0) {
	                var _loop2 = function _loop2(j) {
	                  if (_this._itemsRefs[i].children[j]) {
	                    _this._itemsRefs[i].children[j].addEventListener('tap', function () {
	                      return _this.handleChildClick(i, j);
	                    }, { passive: true });
	                  }
	                };
	
	                for (var j = 0; j < _this._itemsRefs[i].children.length; j++) {
	                  _loop2(j);
	                }
	              }
	            }
	          };
	
	          for (var i = 0; i < _this._itemsRefs.length; i++) {
	            _loop(i);
	          }
	        }
	        _this._refsSetup = true;
	      }
	    };
	
	    _this.removeRefs = function () {
	      try {
	        if (_this._itemsRefs.length > 0) {
	          var _loop3 = function _loop3(i) {
	            _this._itemsRefs[i].el.removeEventListener('tap', function () {
	              return _this.handleClick(i);
	            }, { passive: true });
	            if (_this._itemsRefs[i].children && _this._itemsRefs[i].children.length > 0) {
	              var _loop4 = function _loop4(j) {
	                _this._itemsRefs[i].children[j].removeEventListener('tap', function () {
	                  return _this.handleChildClick(i, j);
	                }, { passive: true });
	              };
	
	              for (var j = 0; j < _this._itemsRefs[i].children.length; j++) {
	                _loop4(j);
	              }
	            }
	          };
	
	          for (var i = 0; i < _this._itemsRefs.length; i++) {
	            _loop3(i);
	          }
	        }
	      } catch (e) {}
	      _this._refsSetup = false;
	    };
	
	    _this.handleClick = function (i) {
	      _this.props.click(_this.props.parentId, i);
	      if (_this.props.items[i].children && _this.props.items[i].children.length > 0) {
	        _this.renderElements(i, 0);
	      } else {
	        _this.renderElements(i, null);
	      }
	    };
	
	    _this.handleChildClick = function (i, j) {
	      _this.props.click(_this.props.parentId, i, j);
	      _this.renderElements(i, j);
	    };
	
	    _this.renderElements = function (activeElementId, activeSubElementId) {
	      var ulStyle = {
	        WebkitPaddingStart: 0.0086625 * _this.props.regionWidth,
	        WebkitMarginBefore: 0,
	        WebkitMarginAfter: 0,
	        listStyle: "none",
	        textAlign: "right",
	        borderRight: 'solid ' + 0.0028125 * _this.props.regionWidth + 'px white'
	      };
	      var liStyle = {
	        paddingTop: 0.0050625 * _this.props.regionWidth,
	        paddingBottom: 0.0050625 * _this.props.regionWidth,
	        paddingRight: 0.0068625 * _this.props.regionWidth
	      };
	      var subUlStyle = {
	        WebkitPaddingStart: 0.0225 * _this.props.regionWidth,
	        listStyle: "none",
	        textAlign: "right"
	      };
	
	      var menuFontSize = 0.009984 * _this.props.regionWidth + "px";
	      var submenuFontSize = 0.0078 * _this.props.regionWidth + "px";
	
	      var itemsRaw = _lodash2.default.orderBy(_this.props.items, "rank", "asc");
	      var items = itemsRaw.map(function (item, i) {
	        _this._itemsRefs[i] = { children: [], el: null };
	        if (item.children && item.children.length > 0 && !item.children[0].folder_module) {
	          var childrenSorted = _lodash2.default.orderBy(item.children, "rank", "asc");
	
	          var subitems = childrenSorted.map(function (subitem, j) {
	            var background = null;
	            if (activeElementId === i && activeSubElementId === j) {
	              background = _this.props.listSubMenuSelectedBackground;
	            }
	            return _react2.default.createElement(
	              'li',
	              { className: 'noselect', key: j, ref: function ref(el) {
	                  return _this._itemsRefs[i].children[j] = el;
	                }, style: Object.assign({}, liStyle, { fontSize: submenuFontSize, background: background, WebkitPaddingStart: 0.0181125 * _this.props.regionWidth }) },
	              ' ',
	              _react2.default.createElement(_BRSpan2.default, { className: 'noselect', preWrap: true, str: subitem.name.toUpperCase() })
	            );
	          });
	
	          var background = activeElementId === i ? _this.props.listMenuSelectedBackground : null;
	          var display = activeElementId === i ? "block" : "none";
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(
	              'li',
	              { style: Object.assign({}, liStyle, { fontSize: menuFontSize, paddingRight: 0 }) },
	              _react2.default.createElement(
	                'div',
	                { className: 'noselect', style: { paddingRight: 0.0068625 * _this.props.regionWidth, background: background, paddingTop: 0.0050625 * _this.props.regionWidth, paddingBottom: 0.0050625 * _this.props.regionWidth }, ref: function ref(el) {
	                    return _this._itemsRefs[i].el = el;
	                  } },
	                ' ',
	                _react2.default.createElement(_BRSpan2.default, { className: 'noselect', preWrap: true, str: item.name.toUpperCase() }),
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { style: Object.assign({}, subUlStyle, { display: display }) },
	              subitems
	            )
	          );
	        } else {
	          var backgroundColor = activeElementId === i ? _this.props.listMenuSelectedBackground : null;
	          return _react2.default.createElement(
	            'li',
	            { className: 'noselect', key: i, ref: function ref(el) {
	                return _this._itemsRefs[i] = { el: el, children: [] };
	              }, style: Object.assign({}, liStyle, { fontSize: menuFontSize, background: backgroundColor }) },
	            ' ',
	            _react2.default.createElement(_BRSpan2.default, { className: 'noselect', preWrap: true, str: item.name.toUpperCase() })
	          );
	        }
	      });
	
	      var elements = _react2.default.createElement(
	        'ul',
	        { style: Object.assign({}, ulStyle) },
	        items
	      );
	
	      _this.setState({
	        showMenu: true,
	        elements: elements
	      });
	    };
	
	    _this._itemsRefs = [];
	    _this._subItemsRefs = [];
	    _this.iScroller = null;
	    _this._refsSetup = false;
	
	    _this.state = {
	      elements: null,
	      activeElementId: null,
	      showMenu: false
	    };
	    return _this;
	  }
	
	  _createClass(ListMenuSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.renderElements(0, 0);
	      setTimeout(function () {
	        _this2.setupRefs();
	      }, 500);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this3 = this;
	
	      if (this.props.parentId !== prevProps.parentId) {
	        this.setState({
	          activeElementId: null,
	          showMenu: false
	        });
	        this.renderElements(0, 0);
	        setTimeout(function () {
	          _this3.setupRefs();
	        }, 500);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.props.parentId !== nextProps.parentId) {
	        this.setState({
	          showMenu: false
	        });
	        this.removeRefs();
	      }
	
	      return true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 0.2287125 * this.props.regionWidth, touchAction: "none" } },
	        _react2.default.createElement(
	          _reactIscroll2.default,
	          { ref: function ref(el) {
	              return _this4.iScroller = el;
	            }, iScroll: _iscroll2.default,
	            options: {
	              mouseWheel: true,
	              scrollbars: false,
	              scrollX: false,
	              scrollY: true,
	              probeType: 2,
	              bounce: false,
	              momentum: true,
	              deceleration: 0.015,
	              useTransition: true,
	              disableTouch: false,
	              disablePointer: false,
	              disableMouse: false,
	              tap: true
	            }
	          },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showMenu },
	              this.state.showMenu ? this.state.elements : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ListMenuSeattle;
	}(_react.Component);
	
	exports.default = ListMenuSeattle;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _SmallBubbleSeattle = __webpack_require__(479);
	
	var _SmallBubbleSeattle2 = _interopRequireDefault(_SmallBubbleSeattle);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MENU_WIDTH_PERCENT = 9.20;
	var CONTENT_COMPONENT_OFFSET_PERCENT = 36.45;
	var MENU_WIDTH_ADJUSTMENT_PERCENT = 25;
	var ELEMENTS_PER_GROUP = 5;
	var DISTANCE_BETWEEN_BUBBLES_PERCENT = 1.2;
	var BUBBLE_DIAMETER_PERCENT = 8.32;
	var ARROW_SIZE_PERCENT = 6;
	
	var MenuBubbleSeattle = function (_Component) {
	  _inherits(MenuBubbleSeattle, _Component);
	
	  function MenuBubbleSeattle(props) {
	    _classCallCheck(this, MenuBubbleSeattle);
	
	    var _this = _possibleConstructorReturn(this, (MenuBubbleSeattle.__proto__ || Object.getPrototypeOf(MenuBubbleSeattle)).call(this, props));
	
	    _this.setupRefs = function () {
	      if (_this._nextButtonRef === null || _this._previousButtonRef === null) {
	        clearTimeout(_this._setupRefsTimeout);
	        _this._setupRefsTimeout = setTimeout(function () {
	          _this.setupRefs();
	        }, 100);
	      } else {
	        _this._nextButtonRef.addEventListener('click', _this.handleNextClick);
	        _this._previousButtonRef.addEventListener('click', _this.handlePreviousClick);
	      }
	    };
	
	    _this.setupGroups = function (activeId) {
	      var groups = [];
	      var group = [];
	
	      if (_this.props.items.length > 0) {
	
	        var items = _this.props.items;
	        items = _lodash2.default.orderBy(items, "rank", "asc");
	
	        for (var i = 0; i < items.length; i++) {
	          var item = items[i];
	          item.active = false;
	          if (activeId !== undefined && item.id === activeId) {
	            item.active = true;
	          }
	
	          group.push(item);
	          if ((i % (ELEMENTS_PER_GROUP - 1) === 0 || i === items.length - 1) && (i > 0 || items.length === 1)) {
	            groups.push(group);
	            group = [];
	          }
	        }
	      }
	
	      return groups;
	    };
	
	    _this.handlePreviousClick = function () {
	      var index = (0, _shared.loopIndex)(_this.state.currentGroup, 0, _this._groups.length - 1, "forward");
	      _this.renderElements(_this._groups, index);
	    };
	
	    _this.handleNextClick = function () {
	      var index = (0, _shared.loopIndex)(_this.state.currentGroup, 0, _this._groups.length - 1, "backward");
	      _this.renderElements(_this._groups, index);
	    };
	
	    _this.handleBubbleClick = function (id) {
	      var groups = _this.setupGroups(id);
	      _this.props.click(_this.props.itemId, id);
	      _this.renderElements(groups, _this.state.currentGroup);
	    };
	
	    _this.renderElements = function (groups, index, activateBubble, bubbleId) {
	      var renderedElements = [];
	      if (groups.length > 0) {
	        var groupQty = groups[index].length;
	        var bubbleDiameter = BUBBLE_DIAMETER_PERCENT * _this.props.regionWidth / 100;
	        var distanceBetweenBubbles = DISTANCE_BETWEEN_BUBBLES_PERCENT * _this.props.regionWidth / 100;
	        var sumDistanceBetweenBubbles = distanceBetweenBubbles * (groupQty - 1);
	        var sumDiameterBubbles = groupQty * bubbleDiameter;
	        var firstElementTop = (_this.props.regionHeight - sumDistanceBetweenBubbles - sumDiameterBubbles) / 2;
	
	        renderedElements = groups[index].map(function (item, key) {
	          var top = firstElementTop + distanceBetweenBubbles * key + bubbleDiameter * key;
	          var left = (_this.props.regionWidth * MENU_WIDTH_PERCENT / 100 - _this.props.regionWidth * BUBBLE_DIAMETER_PERCENT / 100) / 2;
	
	          if (activateBubble) {
	            item.active = item.id === bubbleId ? true : false;
	          }
	
	          if (item.display_module_type === "User Input") {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { key: key },
	            _react2.default.createElement(
	              _SmallBubbleSeattle2.default,
	              {
	                id: item.id,
	                index: key,
	                active: item.active,
	                regionWidth: _this.props.regionWidth,
	                screen: _this.props.screen,
	                primaryColor: _this.props.primaryColor,
	                secondaryColor: _this.props.secondaryColor,
	                handleClick: _this.handleBubbleClick,
	                top: top,
	                left: left
	              },
	              item.name
	            )
	          );
	        });
	      }
	
	      _this.setState({
	        items: renderedElements,
	        currentGroup: index
	      });
	    };
	
	    _this._slickRef = null;
	    _this._previousButtonRef = null;
	    _this._nextButtonRef = null;
	    _this._setupRefsTimeout = null;
	
	    _this._regionRendered = false;
	    _this._groups = [];
	    _this._contentComponentRightOffset = _this.props.regionWidth / 100 * CONTENT_COMPONENT_OFFSET_PERCENT;
	
	    _this.state = {
	      currentGroup: 0,
	      items: []
	    };
	    return _this;
	  }
	
	  _createClass(MenuBubbleSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.items && this.props.items.length > 0) {
	        this._groups = this.setupGroups();
	        if (this.props.bubbleId !== undefined && this.props.bubbleId !== null) {
	          this.renderElements(this._groups, 0, true, this.props.bubbleId);
	        } else {
	          this.renderElements(this._groups, 0);
	        }
	      }
	
	      this.setupRefs();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!_lodash2.default.isEqual(prevProps, this.props)) {
	        this._groups = this.setupGroups();
	        if (this.props.bubbleId !== undefined && this.props.bubbleId !== null) {
	          this.renderElements(this._groups, 0, true, this.props.bubbleId);
	        } else {
	          this.renderElements(this._groups, 0);
	        }
	      }
	
	      this.setupRefs();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._setupRefsTimeout);
	      if (this._nextButtonRef) {
	        this._nextButtonRef.removeEventListener('click', this.handleNextClick);
	      }
	
	      if (this._previousButtonRef) {
	        this._previousButtonRef.removeEventListener('click', this.handlePreviousClick);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var width = MENU_WIDTH_PERCENT * this.props.regionWidth / 100;
	      var left = this.props.regionWidth - (this.props.regionWidth - this._contentComponentRightOffset) - width * (MENU_WIDTH_ADJUSTMENT_PERCENT / 100);
	      var upIcon = (0, _shared.dp)(this.props.screen, null, { path: "/img/ui/", file_name: "up.png" });
	      var downIcon = (0, _shared.dp)(this.props.screen, null, { path: "/img/ui/", file_name: "down.png" });
	      var arrowSize = ARROW_SIZE_PERCENT * this.props.regionWidth / 100;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "absolute", width: width, height: this.props.regionHeight, top: 0, left: left } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.items },
	            this.props.items.length > 5 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { alt: 'prevbutton', ref: function ref(el) {
	                  return _this2._previousButtonRef = el;
	                }, src: upIcon, style: { position: "absolute", width: arrowSize, height: arrowSize, left: (width - arrowSize) / 2, top: 0 } })
	            ) : null,
	            this.state.items,
	            this.props.items.length > 5 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { alt: 'nextbutton', ref: function ref(el) {
	                  return _this2._nextButtonRef = el;
	                }, src: downIcon, style: { position: "absolute", width: arrowSize, height: arrowSize, left: (width - arrowSize) / 2, bottom: 0 } })
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return MenuBubbleSeattle;
	}(_react.Component);
	
	exports.default = MenuBubbleSeattle;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuItemSeattle = function (_Component) {
	  _inherits(MenuItemSeattle, _Component);
	
	  function MenuItemSeattle(props) {
	    _classCallCheck(this, MenuItemSeattle);
	
	    var _this = _possibleConstructorReturn(this, (MenuItemSeattle.__proto__ || Object.getPrototypeOf(MenuItemSeattle)).call(this, props));
	
	    _this.handleClick = function () {
	      if (!_this.state.active) {
	        _this.props.handleClick(_this.props.elementId, _this.props.id, _this._itemRef, _this.changeItemStatus);
	      }
	    };
	
	    _this.changeItemStatus = function (status) {
	      _this.setState({
	        active: status
	      });
	    };
	
	    _this.activate = function () {
	      _this._itemRef.animate([{
	        transform: "scale(1.0)"
	      }, {
	        transform: "scale(1.25)"
	      }], {
	        fill: "forwards",
	        duration: 300
	      });
	      _this.setState({
	        main: true,
	        active: true,
	        animated: true
	      });
	    };
	
	    _this.deactivate = function () {
	      _this._itemRef.animate([{
	        transform: "scale(1.25)"
	      }, {
	        transform: "scale(1.0)"
	      }], {
	        fill: "forwards",
	        duration: 300
	      });
	      _this.setState({
	        main: false,
	        active: false,
	        animated: true
	      });
	    };
	
	    _this.getCircleRef = function () {
	      return _this._itemRef;
	    };
	
	    _this._itemRef = null;
	
	    var itemDiameter = 0;
	    var outerItemDiameter = 0;
	    var shadowItemDiameter = 0;
	    var itemOffset = 0;
	    var outerItemOffset = 0;
	
	    var _this$props = _this.props,
	        activeOuterItemDiameterPercentage = _this$props.activeOuterItemDiameterPercentage,
	        activeShadowItemDiameterPercentage = _this$props.activeShadowItemDiameterPercentage,
	        active = _this$props.active,
	        main = _this$props.main;
	
	
	    itemDiameter = _this.props.width / 100 * _this.props.nonActiveItemDiameterPercentage;
	    outerItemDiameter = _this.props.width / 100 * activeOuterItemDiameterPercentage;
	    shadowItemDiameter = _this.props.width / 100 * activeShadowItemDiameterPercentage;
	    outerItemOffset = (shadowItemDiameter - outerItemDiameter) / 2;
	    itemOffset = (shadowItemDiameter - itemDiameter) / 2;
	
	    _this.state = {
	      itemDiameter: itemDiameter,
	      outerItemDiameter: outerItemDiameter,
	      shadowItemDiameter: shadowItemDiameter,
	      itemOffset: itemOffset,
	      outerItemOffset: outerItemOffset,
	      active: active,
	      main: main,
	      left: _this.props.left,
	      top: _this.props.top,
	      animated: false
	    };
	    return _this;
	  }
	
	  _createClass(MenuItemSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._itemRef.addEventListener('click', this.handleClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._itemRef.removeEventListener('click', this.handleClick);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.active !== this.props.active) {
	        if (this.props.active) {
	          this.activate();
	        } else {
	          this.deactivate();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          shadowItemDiameter = _state.shadowItemDiameter,
	          outerItemDiameter = _state.outerItemDiameter,
	          active = _state.active,
	          animated = _state.animated;
	      var itemDiameter = this.state.itemDiameter;
	
	
	      var outerItemPosition = {
	        left: this.state.left - (outerItemDiameter - itemDiameter) / 2,
	        top: this.state.top - (outerItemDiameter - itemDiameter) / 2
	      };
	
	      var shadowItemPosition = {
	        left: this.state.left - (shadowItemDiameter - itemDiameter) / 2,
	        top: this.state.top - (shadowItemDiameter - itemDiameter) / 2
	      };
	
	      var borderRadius = "50%";
	      var zIndex = this.state.main ? 9999 : 1;
	      itemDiameter = active && !animated ? itemDiameter * 1.2 : itemDiameter;
	      var top = active && !animated ? this.state.top - (outerItemDiameter - itemDiameter) / 2 : this.state.top;
	      var left = active && !animated ? this.state.left - (outerItemDiameter - itemDiameter) / 2 : this.state.left;
	
	      var fontSize = 12.5 / 100 * itemDiameter;
	      if (active && !animated) {
	        fontSize = 14 / 100 * itemDiameter;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: active },
	            active ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { style: Object.assign({ zIndex: zIndex, position: "absolute", backgroundColor: "white", width: shadowItemDiameter, height: shadowItemDiameter, borderRadius: borderRadius, opacity: 0.5 }, shadowItemPosition) }),
	              _react2.default.createElement('div', { style: Object.assign({ zIndex: zIndex, position: "absolute", backgroundColor: this.props.secondaryColor, width: outerItemDiameter, height: outerItemDiameter, borderRadius: borderRadius }, outerItemPosition) })
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(el) {
	              return _this2._itemRef = el;
	            }, style: { zIndex: zIndex, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", backgroundColor: this.props.color, width: itemDiameter, height: itemDiameter, borderRadius: borderRadius, top: top, left: left } },
	          _react2.default.createElement(
	            'span',
	            { className: 'noselect', style: { fontSize: fontSize, textTransform: "uppercase", textAlign: "center" } },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return MenuItemSeattle;
	}(_react.Component);
	
	exports.default = MenuItemSeattle;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MenuItemSeattle = __webpack_require__(476);
	
	var _MenuItemSeattle2 = _interopRequireDefault(_MenuItemSeattle);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _MenuBubbleSeattle = __webpack_require__(475);
	
	var _MenuBubbleSeattle2 = _interopRequireDefault(_MenuBubbleSeattle);
	
	var _ListMenuSeattle = __webpack_require__(474);
	
	var _ListMenuSeattle2 = _interopRequireDefault(_ListMenuSeattle);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_MENU_ELEMENTS = 7;
	
	var MenuSeattle = function (_Component) {
	  _inherits(MenuSeattle, _Component);
	
	  function MenuSeattle(props) {
	    _classCallCheck(this, MenuSeattle);
	
	    var _this = _possibleConstructorReturn(this, (MenuSeattle.__proto__ || Object.getPrototypeOf(MenuSeattle)).call(this, props));
	
	    _this.loopTestAnimateMenu = function () {
	      _this._timeoutAnimateMenu = setTimeout(function () {
	        var id = void 0;
	        var randomIndex = void 0;
	        do {
	          randomIndex = Math.floor(Math.random() * (_this._items.length - 1));
	          id = _lodash2.default.get(_this._items, '[' + randomIndex + '].id', null);
	        } while (_this._currentElementId === id || id === null);
	        _this.menuElementTouch(id);
	        _this.loopTestAnimateMenu();
	      }, 4000);
	    };
	
	    _this.animateBubbles = function (elementsWCoordinates) {
	      for (var i = 0; i < elementsWCoordinates.length; i++) {
	        var x = elementsWCoordinates[i].coordinates.x;
	        var y = elementsWCoordinates[i].coordinates.y;
	
	        _this._itemsRefs[i].el.animate([{
	          transform: "translate(0px, 0px)"
	        }, {
	          transform: 'translate(' + x + 'px, ' + y + 'px)'
	        }], {
	          fill: "forwards",
	          duration: 500
	        });
	      }
	
	      _this._bubblesAnimated = true;
	    };
	
	    _this.animateBubblesActive = function (prevElementId, newElementId) {
	      if (prevElementId !== undefined && prevElementId !== null && newElementId !== undefined && newElementId !== null) {
	        var prevElementRef = _lodash2.default.filter(_this._itemsRefs, { data: { id: prevElementId } });
	        var newElementRef = _lodash2.default.filter(_this._itemsRefs, { data: { id: newElementId } });
	
	        _this._menuBubbleTranslationMap[prevElementId] = Object.assign({}, _this._menuBubbleTranslationMap[newElementId]);
	        prevElementRef = prevElementRef[0];
	        newElementRef = newElementRef[0];
	
	        var movePrevX = -_this._menuBubbleTranslationMap[newElementId].distanceX;
	        var movePrevY = -_this._menuBubbleTranslationMap[newElementId].distanceY;
	
	        prevElementRef.el.animate([{
	          transform: "translate(0px, 0px)"
	        }, {
	          transform: 'translate(' + movePrevX + 'px, ' + movePrevY + 'px)'
	        }], {
	          fill: "forwards",
	          duration: 500
	        });
	
	        var moveNewX = _this._menuBubbleTranslationMap[newElementId].distanceX;
	        var moveNewY = _this._menuBubbleTranslationMap[newElementId].distanceY;
	        newElementRef.el.animate([{
	          transform: "translate(0px, 0px)"
	        }, {
	          transform: 'translate(' + moveNewX + 'px, ' + moveNewY + 'px)'
	        }], {
	          fill: "forwards",
	          duration: 500
	        });
	        var newElementMenuRef = _lodash2.default.find(_this._menuItemsRefs, function (ref) {
	          return ref.data.id === newElementId;
	        });
	        newElementMenuRef.el.activate();
	        _lodash2.default.forEach(_this._itemsRefs, function (ref, i) {
	          if (ref.data.id === newElementId) {
	            ref.el.style.zIndex = 9999;
	          } else {
	            ref.el.style.zIndex = i;
	          }
	        });
	
	        setTimeout(function () {
	          _this.reOrganizeElements(newElementId, prevElementId);
	          _this.renderElements(_this._allElements, true);
	        }, 700);
	      }
	    };
	
	    _this.reOrganizeElements = function (newElementId, prevElementId) {
	      var coordinatesForNewElement = {};
	      var coordinatesForPrevElement = {};
	      var newIndex = void 0;
	      var prevIndex = void 0;
	      for (var i = 0; i < _this._allElements.length; i++) {
	        if (_this._allElements[i].id === newElementId) {
	          _this._allElements[i] = Object.assign({}, _this._allElements[i]);
	          _this._allElements[i].active = true;
	          _this._allElements[i].main = true;
	          newIndex = i;
	          coordinatesForPrevElement = Object.assign({}, _this._allElements[i].coordinates);
	        } else {
	          _this._allElements[i] = Object.assign({}, _this._allElements[i]);
	          if (_this._allElements[i].id === prevElementId) {
	            prevIndex = i;
	            coordinatesForNewElement = Object.assign({}, _this._allElements[i].coordinates);
	          }
	          _this._allElements[i].active = false;
	          _this._allElements[i].main = false;
	        }
	      }
	
	      _this._allElements[newIndex].coordinates = coordinatesForNewElement;
	      _this._allElements[prevIndex].coordinates = coordinatesForPrevElement;
	    };
	
	    _this.handleItemClick = function (id, elementKey) {
	      if (elementKey !== undefined && elementKey !== null) {
	        _this.menuElementTouch(id);
	      }
	    };
	
	    _this.handleBubbleClick = function (parentId, bubbleItemId) {
	      var item = _lodash2.default.find(_this._items, { id: parentId });
	      var bubbleItem = _lodash2.default.find(item.children, { id: bubbleItemId });
	      var showMenu = false;
	      if (bubbleItem.children && bubbleItem.children.length > 0) {
	        if (bubbleItem.children[0].folder_module) {
	          _this.props.changeContent(parentId, bubbleItemId);
	        } else {
	          //navigation
	          _this.props.changeContent(parentId, bubbleItemId, 0, 0);
	          showMenu = true;
	        }
	      }
	
	      // console.log(JSON.stringify(bubbleItem));
	      if (showMenu) {
	        _this.setState({
	          listMenuActive: true,
	          listMenuItems: bubbleItem.children,
	          listMenuParentId: bubbleItem.id,
	          listMenuItemBackground: _lodash2.default.get(item.contents, 'custom_fields.secondary_color.val', null),
	          listMenuSelectedBackground: _lodash2.default.get(_this._mainElement.contents, 'custom_fields.list_menu_selected_background.val', null),
	          listSubMenuSelectedBackground: _lodash2.default.get(_this._mainElement.contents, 'custom_fields.list_submenu_selected_background.val', null)
	        });
	      } else {
	        _this.setState({
	          listMenuActive: false
	        });
	      }
	    };
	
	    _this.handleListItemClick = function (bubbleId, parentListItemId, childListItemId) {
	      _this.props.changeContent(_this.state.mainElementId, bubbleId, parentListItemId, childListItemId);
	    };
	
	    _this.menuElementTouch = function (id) {
	      var subItems = [];
	      // let elementsWCoordinates = this.setupItemsCoordinates(true, id);
	      var activeBubbleId = null;
	      var activeListItemId = null;
	      var activeChildListItemId = null;
	
	      // this._allElements = elementsWCoordinates;
	      if (!_this.state.menuActive) {
	        _this.setupItemsCoordinates(true, id);
	        _this.animateBubbles(_this._allElements);
	        _lodash2.default.forEach(_this._menuItemsRefs, function (ref) {
	          if (ref.data.id === id) {
	            ref.el.activate();
	          }
	        });
	
	        _lodash2.default.forEach(_this._itemsRefs, function (ref, i) {
	          if (ref.data.id === id) {
	            ref.el.style.zIndex = 9999;
	          } else {
	            ref.el.style.zIndex = i;
	          }
	        });
	      } else {
	        if (_this._secondSetupHasNotRunYet) {
	          _this.setupItemsCoordinates(true, _this._currentElementId, true);
	          _this._secondSetupHasNotRunYet = false;
	        }
	
	        if (_this._currentElementId === null) {
	          _this.renderElements(_this._allElements, true);
	        } else {
	          _this.renderElements(_this._allElements);
	        }
	        _this.animateBubblesActive(_this._currentElementId, id);
	      }
	
	      _this._currentElementId = id;
	      _this._mainElement = _lodash2.default.find(_this._allElements, { id: id });
	
	      _this.props.storeMenuStatus(true, id);
	      if (_this._mainElement.children && _this._mainElement.children.length > 0) {
	        if (_this._mainElement.children[0].folder_module) {
	          _this.props.changeContent(id, null, null, null);
	        } else {
	          subItems = _lodash2.default.orderBy(_this._mainElement.children, ['rank'], ['asc']);
	
	          if (subItems && subItems.length > 0) {
	            if (!subItems[0].folder_module) {
	              activeListItemId = 0;
	              if (subItems[0].children && subItems[0].children.length > 0) {
	                if (!subItems[0].children[0].folder_module) {
	                  activeChildListItemId = 0;
	                }
	              }
	            }
	          }
	
	          activeBubbleId = subItems && subItems.length > 0 ? subItems[0].id : null;
	          setTimeout(function () {
	            _this.handleBubbleClick(id, subItems[0].id);
	            setTimeout(function () {
	              _this.handleListItemClick(subItems[0].id, activeListItemId, activeChildListItemId);
	            }, 250);
	          }, 500);
	        }
	      }
	
	      _this.setState({
	        menuActive: true,
	        mainElementId: id,
	        activeBubbleId: activeBubbleId,
	        bubblePrimaryColor: _lodash2.default.get(_this._mainElement.contents, 'custom_fields.sub_menu_primary.val', null),
	        bubbleSecondaryColor: _lodash2.default.get(_this._mainElement.contents, 'custom_fields.sub_menu_secondary.val', null),
	        subItems: subItems,
	        listMenuActive: false
	      });
	    };
	
	    _this.setupItemsCoordinates = function (active, activeElement, secondRender) {
	      var elementsAround = [];
	      var mainElement = {};
	      var mainElementOriginalIndex = null;
	
	      if (activeElement === undefined || activeElement === null) {
	        _this._mainElementIndex = _lodash2.default.findIndex(_this._items, { main: true });
	        mainElement = _this._items[_this._mainElementIndex];
	        mainElementOriginalIndex = _this._mainElementIndex;
	        // this._currentElementId = mainElement.id;
	      } else {
	        for (var i = 0; i < _this._items.length; i++) {
	          if (_this._items[i].id === activeElement) {
	            _this._items[i].main = true;
	            _this._items[i].active = true;
	            mainElement = Object.assign({}, _this._items[i]);
	            mainElementOriginalIndex = i;
	            // this._currentElementId = mainElement.id;
	          } else {
	            _this._items[i].main = false;
	            _this._items[i].active = false;
	          }
	        }
	      }
	
	      for (var j = 0; j < _this._items.length; j++) {
	        if (!_this._items[j].main) {
	          elementsAround.push({
	            element: _this._items[j],
	            originalIndex: j
	          });
	        }
	      }
	
	      var itemRadius = _this._nonActiveItemDiameterPercentage / 100 * _this.props.regionWidth;
	      if (active) {
	        itemRadius *= 1.18;
	      }
	
	      if (active && !secondRender) {
	        if (_this._originalCoordinatesElements.length > 0) {
	          mainElement.coordinates = {
	            x: _this.props.mainItemCoordinates.x - _this._originalCoordinatesElements[mainElementOriginalIndex].coordinates.x,
	            y: _this.props.mainItemCoordinates.y - _this._originalCoordinatesElements[mainElementOriginalIndex].coordinates.y
	          };
	        } else {
	          mainElement.coordinates = {
	            x: _this.props.mainItemCoordinates.x,
	            y: _this.props.mainItemCoordinates.y
	          };
	        }
	      } else {
	        mainElement.coordinates = {
	          x: _this.props.mainItemCoordinates.x,
	          y: _this.props.mainItemCoordinates.y
	        };
	      }
	
	      var offset = Math.PI / 2;
	      var theta = Math.PI * 2 / (MAX_MENU_ELEMENTS - 1);
	
	      if (active) {
	        theta = Math.PI * 2 / (MAX_MENU_ELEMENTS + 1);
	        offset = Math.PI / 2 + theta;
	      }
	
	      var allElements = [];
	      var elementsWithTranslateDistances = [];
	      for (var _i = 0; _i < elementsAround.length; _i++) {
	        var element = elementsAround[_i].element;
	        var elementWithDistance = elementsAround[_i].element;
	        var index = elementsAround[_i].originalIndex;
	        var angle = theta * _i;
	
	        var x = 0;
	        var y = 0;
	
	        var newOriginalPosX = 0;
	        var newOriginalPosY = 0;
	        if (active && !secondRender) {
	          if (_this._originalCoordinatesElements.length > 0) {
	            newOriginalPosX = itemRadius * 0.85 * Math.cos(angle + offset) + _this.props.mainItemCoordinates.x;
	            newOriginalPosY = _this.props.mainItemCoordinates.y - itemRadius * 0.85 * Math.sin(angle + offset);
	            x = -(_this._originalCoordinatesElements[index].coordinates.x - newOriginalPosX);
	            y = -(_this._originalCoordinatesElements[index].coordinates.y - newOriginalPosY);
	
	            _this._menuBubbleTranslationMap[element.id] = {
	              distanceX: _this.props.mainItemCoordinates.x - newOriginalPosX,
	              distanceY: _this.props.mainItemCoordinates.y - newOriginalPosY
	            };
	          } else {
	            x = itemRadius * 0.85 * Math.cos(angle + offset) + _this.props.mainItemCoordinates.x;
	            y = _this.props.mainItemCoordinates.y - itemRadius * 0.85 * Math.sin(angle + offset);
	          }
	        } else {
	          x = itemRadius * 0.85 * Math.cos(angle + offset) + _this.props.mainItemCoordinates.x;
	          y = _this.props.mainItemCoordinates.y - itemRadius * 0.85 * Math.sin(angle + offset);
	
	          _this._menuBubbleTranslationMap[element.id] = {
	            distanceX: _this.props.mainItemCoordinates.x - x,
	            distanceY: _this.props.mainItemCoordinates.y - y
	          };
	        }
	
	        element.coordinates = {
	          x: x,
	          y: y
	        };
	
	        elementWithDistance.coordinates = {
	          x: x,
	          y: y
	        };
	        allElements.push(element);
	        elementsWithTranslateDistances.push(elementWithDistance);
	      }
	
	      allElements.push(mainElement);
	      elementsWithTranslateDistances.push(mainElement);
	      allElements = _lodash2.default.sortBy(allElements, ['rank']);
	      _this._allElements = allElements;
	      if (_this._originalCoordinatesElements.length === 0) {
	        _this._originalCoordinatesElements = _lodash2.default.cloneDeep(allElements);
	      }
	
	      _this._mainElement = mainElement;
	      return elementsWithTranslateDistances;
	    };
	
	    _this.renderElements = function (elementsCoordinates, active) {
	      var renderedElements = [];
	      var mainElementIndex = null;
	      var randomKey = (0, _shared.getRandomStr)();
	
	      var _loop = function _loop(i) {
	        if (elementsCoordinates[i].main) {
	          mainElementIndex = i;
	          return 'continue';
	        }
	
	        var x = elementsCoordinates[i].coordinates.x;
	        var y = elementsCoordinates[i].coordinates.y;
	        var renderedElement = _react2.default.createElement(
	          'div',
	          { key: randomKey + i, style: { position: "absolute", left: x, top: y }, ref: function ref(el) {
	              return _this._itemsRefs[i] = { el: el, data: { id: elementsCoordinates[i].id } };
	            } },
	          _react2.default.createElement(
	            _MenuItemSeattle2.default,
	            {
	              id: i,
	              ref: function ref(el) {
	                return _this._menuItemsRefs[i] = { el: el, data: { id: elementsCoordinates[i].id } };
	              },
	              elementId: elementsCoordinates[i].id,
	              width: _this.props.regionWidth,
	              height: _this.props.regionHeight,
	              active: elementsCoordinates[i].active,
	              main: elementsCoordinates[i].main,
	              left: 0,
	              top: 0,
	              color: elementsCoordinates[i].contents.custom_fields.background_color.val,
	              secondaryColor: elementsCoordinates[i].contents.custom_fields.secondary_color.val,
	              handleClick: _this.handleItemClick,
	              setActive: _this.setItemActive,
	              nonActiveItemDiameterPercentage: _this._nonActiveItemDiameterPercentage,
	              activeInnerItemDiameterPercentage: _this._activeInnerItemDiameterPercentage,
	              activeOuterItemDiameterPercentage: _this._activeOuterItemDiameterPercentage,
	              activeShadowItemDiameterPercentage: _this._activeShadowItemDiameterPercentage
	            },
	            elementsCoordinates[i].name
	          )
	        );
	        renderedElements.push(renderedElement);
	      };
	
	      for (var i = 0; i < elementsCoordinates.length; i++) {
	        var _ret = _loop(i);
	
	        if (_ret === 'continue') continue;
	      }
	
	      var x = elementsCoordinates[mainElementIndex].coordinates.x;
	      var y = elementsCoordinates[mainElementIndex].coordinates.y;
	      var mainElement = _react2.default.createElement(
	        'div',
	        { key: randomKey + mainElementIndex, style: { position: "absolute", left: x, top: y }, ref: function ref(el) {
	            return _this._itemsRefs[mainElementIndex] = { el: el, data: { id: elementsCoordinates[mainElementIndex].id } };
	          } },
	        _react2.default.createElement(
	          _MenuItemSeattle2.default,
	          {
	            id: mainElementIndex,
	            ref: function ref(el) {
	              return _this._menuItemsRefs[mainElementIndex] = { el: el, data: { id: elementsCoordinates[mainElementIndex].id } };
	            },
	            elementId: elementsCoordinates[mainElementIndex].id,
	            width: _this.props.regionWidth,
	            height: _this.props.regionHeight,
	            left: 0,
	            top: 0,
	            color: elementsCoordinates[mainElementIndex].contents.custom_fields.background_color.val,
	            main: true,
	            active: active,
	            secondaryColor: elementsCoordinates[mainElementIndex].contents.custom_fields.secondary_color.val,
	            handleClick: _this.handleItemClick,
	            setActive: _this.setItemActive,
	            nonActiveItemDiameterPercentage: _this._nonActiveItemDiameterPercentage,
	            activeInnerItemDiameterPercentage: _this._activeInnerItemDiameterPercentage,
	            activeOuterItemDiameterPercentage: _this._activeOuterItemDiameterPercentage,
	            activeShadowItemDiameterPercentage: _this._activeShadowItemDiameterPercentage
	          },
	          elementsCoordinates[mainElementIndex].name
	        )
	      );
	      renderedElements.push(mainElement);
	
	      _this.setState({
	        items: renderedElements,
	        mainElementId: _this._mainElement.id
	      });
	    };
	
	    _this._nonActiveItemDiameterPercentage = 13.75;
	    _this._activeInnerItemDiameterPercentage = 17.45;
	    _this._activeOuterItemDiameterPercentage = 19.45;
	    _this._activeShadowItemDiameterPercentage = 21.21;
	    _this._items = _this.props.items;
	    _this._menuItemsRefs = [];
	    _this._mainElement = null;
	    _this._currentElementId = null;
	    _this._itemsRefs = [];
	    _this._originalCoordinatesElements = [];
	    _this._allElements = [];
	    _this._itemsRefsSet = false;
	    _this._bubblesAnimated = false;
	    _this._secondSetupHasNotRunYet = true;
	    _this._distanceFromOriginalPosition = [];
	    _this._distancesFromMain = [];
	    _this._menuBubbleTranslationMap = {};
	
	    _this.state = {
	      mainElement: null,
	      menuActive: _this.props.menuActive,
	      activeBubbleId: null,
	      listMenuActive: false,
	      mainElementId: null,
	      items: [],
	      subItems: []
	    };
	    return _this;
	  }
	
	  _createClass(MenuSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      for (var i = 0; i < this._items.length; i++) {
	        this._items[i].rank = i;
	      }
	      this.setupItemsCoordinates(this.props.menuActive);
	      this.renderElements(this._allElements);
	      if (this.props.activateBubble !== undefined) {
	        var mainElement = _lodash2.default.find(this.props.items, { active: true });
	        if (mainElement) {
	          this.menuElementTouch(mainElement.id);
	        }
	      }
	
	      // this.loopTestAnimateMenu();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // console.log("Menu Seattle Will Unmount");
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.menuActive && prevState.mainElementId !== this.state.mainElementId) {
	        var mainElement = _lodash2.default.find(this.props.items, { id: this.state.mainElementId });
	        if (this.state.subItems.length === 0) {
	          if (mainElement.children && mainElement.children.length > 0) {
	            this.setState({
	              subItems: mainElement.children,
	              bubblePrimaryColor: _lodash2.default.get(mainElement.contents, 'custom_fields.sub_menu_primary.val', null),
	              bubbleSecondaryColor: _lodash2.default.get(mainElement.contents, 'custom_fields.sub_menu_secondary.val', null)
	            });
	          }
	        }
	      } else {
	        if (!this.state.menuActive && prevState.mainElementId === this.state.mainElementId) {
	          // this.animateBubbles(this._allElements);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: this.props.screenY, left: this.props.screenX } },
	          this.state.items
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: this.props.contentY, left: this.props.contentX } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.menuActive },
	              this.state.menuActive ? _react2.default.createElement(_MenuBubbleSeattle2.default, {
	                itemId: this.state.mainElementId,
	                items: this.state.subItems,
	                screen: this.props.screen,
	                regionWidth: this.props.regionWidth,
	                regionHeight: this.props.regionHeight,
	                contentY: this.props.contentY,
	                regionX: this.props.regionX,
	                regionY: this.props.regionY,
	                click: this.handleBubbleClick,
	                bubbleId: this.state.activeBubbleId,
	                primaryColor: this.state.bubblePrimaryColor,
	                secondaryColor: this.state.bubbleSecondaryColor
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.listMenuActive, style: { width: 0.13185 * this.props.regionWidth, position: "absolute", left: 0.433125 * this.props.regionWidth, top: 0.185625 * this.props.regionWidth } },
	              this.state.listMenuActive ? _react2.default.createElement(_ListMenuSeattle2.default, {
	                regionWidth: this.props.regionWidth,
	                parentId: this.state.listMenuParentId,
	                items: this.state.listMenuItems,
	                screen: this.props.screen,
	                color: this.state.listMenuItemBackground,
	                listMenuSelectedBackground: this.state.listMenuSelectedBackground,
	                listSubMenuSelectedBackground: this.state.listSubMenuSelectedBackground,
	                click: this.handleListItemClick
	              }) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MenuSeattle;
	}(_react.Component);
	
	exports.default = MenuSeattle;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _display = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _MenuSeattle = __webpack_require__(477);
	
	var _MenuSeattle2 = _interopRequireDefault(_MenuSeattle);
	
	var _ContentSeattle = __webpack_require__(470);
	
	var _ContentSeattle2 = _interopRequireDefault(_ContentSeattle);
	
	var _IdleLoop = __webpack_require__(96);
	
	var _IdleLoop2 = _interopRequireDefault(_IdleLoop);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CheckerboardSeattle = __webpack_require__(469);
	
	var _CheckerboardSeattle2 = _interopRequireDefault(_CheckerboardSeattle);
	
	var _TouchGestureSeattle = __webpack_require__(482);
	
	var _TouchGestureSeattle2 = _interopRequireDefault(_TouchGestureSeattle);
	
	var _reactRouterDom = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const TOUCH_START_BUBBLE_DIAMETER = 8.77;
	var STAGE_ONE_LOCKED = "stage_one_locked";
	var STAGE_TWO_LOCKED = "stage_two_locked";
	var RELEASED = "released";
	
	var SeattleContainer = function (_Component) {
	  _inherits(SeattleContainer, _Component);
	
	  function SeattleContainer(props) {
	    _classCallCheck(this, SeattleContainer);
	
	    var _this = _possibleConstructorReturn(this, (SeattleContainer.__proto__ || Object.getPrototypeOf(SeattleContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    window.addEventListener('contextmenu', function (e) {
	      e.preventDefault();
	    });
	    _this._screensNumber = _this.getScreensNumber();
	    _this._menuActive = false;
	    _this._idleLoopTimeout = null;
	    _this.idleRef = 0;
	    _this._xScreens = _this.props.displayLayout.horizontal;
	    _this._yScreens = _this.props.displayLayout.vertical;
	    _this._startButtonRef = null;
	    _this._touchToStartTextRef = null;
	    _this._handIconRef = null;
	    _this._swipeAnimationTimerHandler = null;
	    _this._clickLocked = RELEASED;
	    _this._attractLoopTree = {};
	    _this._isSwipeAnimationActive = true;
	    _this._swipeTimeout = 5000;
	
	    var regionWidth = _this.props.screen.screenWidth / _this._xScreens;
	    _this._menuOriginalCoordinates = {
	      x: 7.5 / 100 * regionWidth, // based on % of total width
	      y: 11.25 / 100 * regionWidth // based on % of total height
	    };
	
	    var initialImage = _this.getBackground(null);
	    _this.setupElements();
	    _this.state = {
	      idle: false,
	      showNavButton: false,
	      module: null,
	      showDebug: false,
	      menuOnScreen: false,
	      menuActive: _this._menuActive,
	      regionChanged: false,
	      attractLoopBackground: null,
	      buttonPressed: false,
	      content: null,
	      background: initialImage,
	      activateBubble: false,
	      activateListMenu: false,
	      showGesture: false
	    };
	    return _this;
	  }
	
	  _createClass(SeattleContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setupElements();
	      var topAttractLoop = _lodash2.default.filter(this.props.content.story_categories, { parent_category: null, contents: { custom_fields: { folder_type: { val: { value: "attract_loop" } } } } });
	      var allDonors = _shared2.default.getAllDonors(this.props.donors);
	      this._allDonors = allDonors;
	      if (topAttractLoop && topAttractLoop[0]) {
	        this._attractLoopTree = _shared2.default.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, topAttractLoop[0].name, 'sorting_name');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("keydown", this.handleKeyDown);
	      document.addEventListener("click", this.handleTouch);
	
	      this.startButtonAnimationLoop();
	      this.setupElements();
	      this._isSwipeAnimationActive = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      document.removeEventListener("click", this.handleTouch);
	      window.removeEventListener('contextmenu', function (e) {
	        e.preventDefault();
	      });
	    }
	
	    // cycleIdle = () => {
	    //   if (this.idleRef >= this.props.content.display_module_loops[0].display_module_loop_units.length) {
	    //     this.idleRef = 0
	    //   }
	
	    //   this.navroute(this.idleRef, this.props.content.display_module_loops[0].display_module_loop_units[this.idleRef].data.display_module_type, "idle", { idleModule: this.idleRef });
	    // }
	
	    // cycleIdleLoop = () => {
	    //   clearTimeout(this._idleLoopTimeout);
	    //   this._idleLoopTimeout = setTimeout(() => {
	    //     this.cycleIdle();
	    //     this.cycleIdleLoop();
	    //   }, this.props.content.display_module_loops[0].display_module_loop_units[this.idleRef].cycle_time_seconds * 1000);
	    //   this.idleRef++;
	    // }
	
	    // navroute = (ref, type, source, options) => {
	    //   //console.log("NAVROUTE", ref, type, source, options);
	    //   if (ref === null) {
	    //     if (this.props.active_module !== undefined) {
	    //       ref = this.props.active_module //maintain module if not changed
	    //     }
	    //   }
	    //   if (type === null) {
	    //     type = this.getActiveModuleType();
	    //   }
	    //   // this.toggleSlideOff();
	    //   this.setState({
	    //     displayNav: false,
	    //     options: options
	    //   });
	    //   this.props.setOptions(options);
	    //   this.props.switchModule(ref);
	    //   switch (type) {
	    //     case "Story":
	    //       this.setState({ showNav: true });
	    //       if (source === "idle") {
	    //         let url = "/seattle/checkerboard?id=" + options.idleModule; //ensures unique path
	    //         this.props.history.replace(url);
	    //       }
	    //       else {
	    //         this.props.history.replace("/seattle/checkerboard?id=" + ref);
	    //       }
	    //       break;
	    //     default:
	    //       break;
	    //   }
	
	    //   if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
	    //     this.props.history.replace(options.routeoverride);
	    //   }
	    // }
	
	  }, {
	    key: 'getMenuPathType',
	    value: function getMenuPathType(item, count) {
	      if (item.children && item.children.length > 0) {
	        var children = _lodash2.default.orderBy(item.children, ['rank'], ['asc']);
	        if (children[0].folder_module) {
	          return count;
	        } else {
	          count++;
	          return this.getMenuPathType(children[0], count);
	        }
	      } else {
	        return count;
	      }
	    }
	  }, {
	    key: 'isContent',
	    value: function isContent(obj) {
	      if (obj && obj.children && obj.children.length > 0 && obj.children[0].folder_module) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	
	      var key = this.props.location.pathname + this.props.location.search;
	      // let buttonPressedStyle = {}
	      // if (this.state.buttonPressed) {
	      //   buttonPressedStyle = {
	      //     boxShadow: "inset 0 4px 35px rgba(0, 0, 0, 1)"
	      //   }
	      // }
	
	      // let bubbleDiameter = this.props.screen.screenWidth * TOUCH_START_BUBBLE_DIAMETER / 100;
	      // let touchToStartStyle = {
	      //   width: bubbleDiameter,
	      //   height: bubbleDiameter,
	      //   borderRadius: "50%",
	      //   backgroundColor: "white",
	      //   opacity: 0.65
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          !this.state.idle ? _react2.default.createElement('div', { key: this.state.background, style: { position: "absolute", backgroundImage: 'url(' + this.state.background + ')', backgroundSize: this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px', height: this.props.screen.screenHeight, width: this.props.screen.screenWidth } }) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.content.font_class, style: { color: this.props.content.settings.main_font_color, backgroundColor: "white", height: this.props.screen.screenHeight, width: this.props.screen.screenWidth } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'fastfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              _reactRouterDom.Switch,
	              { key: key, location: location },
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/seattle/checkerboard', render: function render(props) {
	                  return _react2.default.createElement(_CheckerboardSeattle2.default, Object.assign({}, props, { xScreens: 3, yScreens: 2, idle: _this2.state.idle, setCurrentBackground: _this2.setAttractLoopBackground }));
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.contentOnScreen },
	              this.state.contentOnScreen ? _react2.default.createElement(_ContentSeattle2.default, {
	                screen: this.props.screen,
	                backgroundColor: this.state.contentBackgroundColor,
	                regionWidth: this.props.screen.screenWidth / this._xScreens,
	                regionHeight: this.props.screen.screenHeight / this._yScreens,
	                contentX: this.state.contentX,
	                contentY: this.state.contentY,
	                content: this.state.content,
	                handleSwipeAnimation: this.handleSwipeAnimation,
	                cancelSwipeAnimation: this.cancelSwipeAnimation
	              }) : null
	            )
	          ),
	          this.state.contentOnScreen ? _react2.default.createElement(_TouchGestureSeattle2.default, {
	            screen: this.props.screen,
	            regionWidth: this.props.screen.screenWidth / this._xScreens,
	            regionHeight: this.props.screen.screenHeight / this._yScreens,
	            contentX: this.state.contentX,
	            contentY: this.state.contentY,
	            show: this.state.showGesture
	          }) : null,
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'fastfadedelay',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.menuOnScreen },
	              this.state.menuOnScreen ? _react2.default.createElement(_MenuSeattle2.default, {
	                screenX: this.state.touchScreenX,
	                screenY: this.state.touchScreenY,
	                screen: this.props.screen,
	                mainItemCoordinates: this._menuOriginalCoordinates,
	                regionWidth: this.props.screen.screenWidth / this._xScreens,
	                regionHeight: this.props.screen.screenHeight / this._yScreens,
	                items: this._items,
	                storeMenuStatus: this.storeMenuStatus,
	                menuActive: this._menuActive,
	                contentX: this.state.contentX,
	                contentY: this.state.contentY,
	                regionX: this.state.regionX,
	                regionY: this.state.regionY,
	                changeContent: this.handleContentChange,
	                activateBubble: this.state.activateBubble,
	                activateListMenu: this.state.activateListMenu
	              }) : null
	            )
	          ),
	          this.state.idle ? _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", height: this.props.screen.screenHeight, width: this.props.screen.screenWidth, top: 0, left: 0, display: "flex", alignItems: "center", justifyContent: "center" } },
	            _react2.default.createElement('img', { ref: function ref(el) {
	                return _this2._startButtonRef = el;
	              }, src: '/img/seattle/general/start.png', style: { opacity: "0.65", width: "25vh" }, alt: '' })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showDebug },
	            this.showBezelHandle(this._xScreens, this._yScreens)
	          ),
	          this.props.idleActive === true && this._attractLoopTree.children && this._attractLoopTree.children.length > 0 ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_IdleLoop2.default, {
	              idle_delay: this.props.content.idle_delay,
	              goIdle: this.goIdle,
	              resume: this.resume
	            })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return SeattleContainer;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleSwipeAnimation = function (wrapperHeight, contentHeight) {
	    if (contentHeight > wrapperHeight && _this3._isSwipeAnimationActive) {
	      clearTimeout(_this3._swipeAnimationTimerHandler);
	      _this3._swipeAnimationTimerHandler = setTimeout(function () {
	        _this3.setState({
	          showGesture: true
	        });
	        setTimeout(function () {
	          _this3.setState({
	            showGesture: false
	          });
	        }, 3500);
	
	        if (_this3._isSwipeAnimationActive) {
	          _this3._swipeTimeout = 20000;
	          _this3.handleSwipeAnimation(wrapperHeight, contentHeight);
	        }
	      }, _this3._swipeTimeout);
	    } else {
	      clearTimeout(_this3._swipeAnimationTimerHandler);
	    }
	  };
	
	  this.cancelSwipeAnimation = function () {
	    _this3._isSwipeAnimationActive = false;
	    clearTimeout(_this3._swipeAnimationTimerHandler);
	  };
	
	  this.setupElements = function () {
	    var folderCategories = _this3.props.content.story_categories;
	    var mainItem = _this3.createFolderTree(folderCategories);
	    var items = mainItem.children;
	    for (var i = 0; i < items.length; i++) {
	      items[i].active = false;
	      items[i].main = false;
	      if (i === Math.ceil(items.length / 2)) {
	        items[i].main = true;
	      }
	    }
	
	    _this3._items = items;
	  };
	
	  this.createFolderTree = function (categories, parent) {
	    if (_shared2.default.nullOrUndefined(parent)) {
	      var main = _lodash2.default.find(categories, { name: "Main" });
	      var children = _this3.createFolderTree(categories, main);
	      main.children = children;
	      return main;
	    } else {
	      var _children = _lodash2.default.filter(categories, { parent_category: parent.id });
	      if (_children.length > 0) {
	        for (var i = 0; i < _children.length; i++) {
	          _children[i].children = _this3.createFolderTree(categories, _children[i]);
	        }
	        return _children;
	      } else {
	        var modules = [];
	        var folderFolderModules = _lodash2.default.filter(_this3.props.content.folder_modules, { folder: parent.id });
	        var stories = [];
	        var displayModules = [];
	        var donors = [];
	
	        _lodash2.default.forEach(folderFolderModules, function (fm) {
	          switch (fm.model) {
	            case "display_module":
	              var dm = _lodash2.default.find(_this3.props.content.dm_active, { id: fm.module_id });
	              if (dm) {
	                dm.folder_module = fm;
	                displayModules.push(dm);
	              }
	              break;
	            case "story":
	              var story = _lodash2.default.find(_this3.props.content.stories, { id: fm.module_id });
	              if (story) {
	                story.folder_module = fm;
	                stories.push(story);
	              }
	              break;
	            case "donor":
	              var donor = _lodash2.default.find(_this3._allDonors, { id: fm.module_id });
	              if (donor) {
	                donor.folder_module = fm;
	                donors.push(donor);
	              }
	              break;
	            default:
	              break;
	          }
	        });
	
	        if (donors.length > 0) {
	          modules = modules.concat(donors);
	        }
	
	        if (stories.length > 0) {
	          modules = modules.concat(stories);
	        }
	
	        if (displayModules.length > 0) {
	          modules = modules.concat(displayModules);
	        }
	
	        return modules;
	      }
	    }
	  };
	
	  this.getScreensNumber = function () {
	    try {
	      return _this3.props.content.settings.display_blocks[0].screens.length;
	    } catch (e) {
	      return 1;
	    }
	  };
	
	  this.showBezelHandle = function (xScreens, yScreens) {
	    if (_this3.state.showDebug === false) {
	      return null;
	    }
	
	    var debugBoxStyle = {
	      position: 'absolute',
	      opacity: .7,
	      backgroundColor: "black"
	
	      // Determine Horizontal Lines based on amount of V Screens.
	    };var hLines = Array.apply(null, { length: yScreens + 1 }).map(Number.call, Number);
	    var vLines = Array.apply(null, { length: xScreens + 1 }).map(Number.call, Number);
	
	    var regionHeight = _this3.props.screen.screenHeight / yScreens;
	    var regionWidth = _this3.props.screen.screenWidth / xScreens;
	    var bezel = _this3.props.screen.screenHeight * .005;
	
	    var renderedHlines = hLines.map(function (lNumber, key) {
	      var bezelOffset = lNumber > 0 ? bezel / 2 : 0;
	      bezelOffset = lNumber === hLines.length - 1 ? bezel : bezelOffset;
	      var style = {
	        top: lNumber * regionHeight - bezelOffset,
	        left: 0,
	        height: bezel,
	        width: _this3.props.screen.screenWidth
	      };
	
	      return _react2.default.createElement('div', { key: key, style: Object.assign({}, debugBoxStyle, style) });
	    });
	
	    var renderedVlines = vLines.map(function (lNumber, key) {
	      var bezelOffset = lNumber > 0 ? bezel / 2 : 0;
	      bezelOffset = lNumber === vLines.length - 1 ? bezel : bezelOffset;
	      var style = {
	        left: lNumber * regionWidth - bezelOffset,
	        top: 0,
	        width: bezel,
	        height: _this3.props.screen.screenHeight
	      };
	
	      return _react2.default.createElement('div', { key: key, style: Object.assign({}, debugBoxStyle, style) });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      renderedVlines,
	      renderedHlines
	    );
	  };
	
	  this.goIdle = function (type) {
	    if (type === "recentInteraction") {
	      _this3.setState({
	        recentInteraction: false
	      });
	    } else {
	      _this3.setupElements();
	      if (_this3._attractLoopTree.children[0]) {
	        _this3._menuActive = false;
	        _this3.setState({
	          idle: true,
	          contentOnScreen: false,
	          menuOnScreen: false
	        });
	        _this3.cycleIdle();
	        _this3.cycleIdleLoop();
	      }
	    }
	  };
	
	  this.getMenuCoordinates = function (x, y) {
	    var regionWidth = _this3.props.screen.screenWidth / _this3._xScreens;
	    var regionHeight = _this3.props.screen.screenHeight / _this3._yScreens;
	    var regionX = Math.floor(x / regionWidth);
	    var regionY = Math.floor(y / regionHeight);
	
	    var coordinates = {
	      x: _this3._menuOriginalCoordinates.x + regionWidth * regionX,
	      y: _this3._menuOriginalCoordinates.y + regionHeight * regionY
	    };
	
	    return coordinates;
	  };
	
	  this.getContentCoordinates = function (x, y) {
	    var regionWidth = _this3.props.screen.screenWidth / _this3._xScreens;
	    var regionHeight = _this3.props.screen.screenHeight / _this3._yScreens;
	    var regionX = Math.floor(x / regionWidth);
	    var regionY = Math.floor(y / regionHeight);
	
	    var coordinates = {
	      x: regionWidth * regionX,
	      y: regionHeight * regionY,
	      regionX: regionX,
	      regionY: regionY
	    };
	
	    return coordinates;
	  };
	
	  this.resume = function () {
	    if (_this3.state.idle === true) {
	      _this3._startButtonRef.animate([{
	        transform: "scale(1.0)"
	      }, {
	        transform: "scale(0.9)"
	      }], {
	        fill: "forwards",
	        duration: 25
	      });
	      _this3.setState({
	        buttonPressed: true
	      });
	
	      setTimeout(function () {
	        _this3._swipeTimeout = 5000;
	        _this3._isSwipeAnimationActive = true;
	        _this3.props.history.replace('/seattle');
	        _this3.setState({
	          idle: false,
	          buttonPressed: false
	        });
	        clearTimeout(_this3._idleLoopTimeout);
	      }, 250);
	    }
	    if (_this3.state.recentInteraction === false) {
	      _this3.setState({
	        recentInteraction: true
	      });
	    }
	  };
	
	  this.cycleIdle = function () {
	    if (_this3._attractLoopTree && _this3._attractLoopTree.children.length > 0) {
	      try {
	
	        if (_this3.idleRef >= _this3._attractLoopTree.children.length) {
	          _this3.idleRef = 0;
	        }
	
	        var type = _lodash2.default.get(_this3._attractLoopTree.children[_this3.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
	        var moduleId = _this3._attractLoopTree.children[_this3.idleRef].id;
	        _this3.navroute(_this3.idleRef, type, "idle", { idleModule: moduleId, idleRef: _this3.idleRef });
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  };
	
	  this.cycleIdleLoop = function () {
	    try {
	      clearTimeout(_this3._idleLoopTimeout);
	      var timeout = Number(_lodash2.default.get(_this3._attractLoopTree.children[_this3.idleRef].contents, 'custom_fields.slide_cycle_time.val', 30));
	      _this3._idleLoopTimeout = setTimeout(function () {
	        _this3.cycleIdle();
	        _this3.cycleIdleLoop();
	      }, timeout * 1000);
	      _this3.idleRef++;
	    } catch (e) {
	      console.log(e);
	    }
	  };
	
	  this.manualCycle = function (direction) {
	    clearTimeout(_this3._idleLoopTimeout);
	    _this3.idleRef = _shared2.default.loopIndex(_this3.idleRef - 1, 0, _this3._attractLoopTree.children.length - 1, direction);
	    var type = _lodash2.default.get(_this3._attractLoopTree.children[_this3.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
	    var moduleId = _this3._attractLoopTree.children[_this3.idleRef].id;
	    _this3.navroute(_this3.idleRef, type, "idle", { idleModule: moduleId, idleRef: _this3.idleRef });
	    _this3.cycleIdleLoop();
	  };
	
	  this.navroute = function (ref, type, source, options) {
	    //console.log("NAVROUTE", ref, type, source, options);
	    if (ref === null) {
	      if (_this3.props.active_module !== undefined) {
	        ref = _this3.props.active_module; //maintain module if not changed
	      }
	    }
	    if (type === null) {
	      type = _this3.getActiveModuleType();
	    }
	    // this.toggleSlideOff();
	    _this3.setState({
	      displayNav: false,
	      options: options
	    });
	    _this3.props.setOptions(options);
	    _this3.props.switchModule(ref);
	    switch (type) {
	      case "checkerboard":
	        _this3.setState({ showNav: true });
	        if (source === "idle") {
	          var url = "/seattle/checkerboard?id=" + options.idleRef; //ensures unique path
	          _this3.props.history.replace(url);
	        } else {
	          _this3.props.history.replace("/seattle/checkerboard?id=" + ref);
	        }
	        break;
	      default:
	        break;
	    }
	
	    if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
	      _this3.props.history.replace(options.routeoverride);
	    }
	  };
	
	  this.handleKeyDown = function (event) {
	    switch (event.key) {
	      case "ArrowLeft":
	        if (_this3.props.screen.mode === "preview") {
	          _this3.manualCycle("backward");
	        }
	        break;
	      case "ArrowRight":
	        if (_this3.props.screen.mode === "preview") {
	          _this3.manualCycle("forward");
	        }
	        break;
	      case "s":
	        console.log(_this3.props);
	        break;
	      case "n":
	        _this3.openNav();
	        break;
	      case "d":
	        _this3.setState({
	          showDebug: !_this3.state.showDebug
	        });
	        break;
	      default:
	        break;
	    }
	  };
	
	  this.isEventOnSameRegion = function (newCoordX, newCoordY, lastCoordX, lastCoordY) {
	    var regionWidth = _this3.props.screen.screenWidth / _this3._xScreens;
	    var regionHeight = _this3.props.screen.screenHeight / _this3._yScreens;
	    var newRegionX = Math.floor(newCoordX / regionWidth);
	    var newRegionY = Math.floor(newCoordY / regionHeight);
	    var lastRegionX = Math.floor(lastCoordX / regionWidth);
	    var lastRegionY = Math.floor(lastCoordY / regionHeight);
	
	    return newRegionX === lastRegionX && newRegionY === lastRegionY;
	  };
	
	  this.handleTouch = function (event, regionChanged) {
	    if (regionChanged === undefined) {
	      regionChanged = false;
	    }
	
	    if (!_this3.state.idle) {
	      if (_this3.state.menuOnScreen) {
	        // If menu is already on screen
	        var clientX = event.clientX,
	            clientY = event.clientY;
	
	        if (!_this3.isEventOnSameRegion(clientX, clientY, _this3.state.touchScreenX, _this3.state.touchScreenY)) {
	          _this3._clickLocked = STAGE_ONE_LOCKED;
	          _this3.setState({
	            menuOnScreen: false,
	            contentOnScreen: false,
	            content: null
	          });
	          clearTimeout(_this3._menuTimeoutHandler);
	          _this3._menuTimeoutHandler = null;
	          _this3._menuTimeoutHandler = setTimeout(function () {
	            _this3._clickLocked = STAGE_TWO_LOCKED;
	            _this3.handleTouch(event, true);
	          }, 500);
	        }
	      } else {
	        if (_this3._clickLocked === STAGE_TWO_LOCKED || _this3._clickLocked === RELEASED) {
	          var _clientX = event.clientX,
	              _clientY = event.clientY;
	
	          var contentOnScreen = _this3._menuActive;
	          var coordinates = _this3.getMenuCoordinates(_clientX, _clientY);
	          var contentCoordinates = _this3.getContentCoordinates(_clientX, _clientY);
	          var activateBubble = false;
	          var activateListMenu = false;
	          _this3._clickLocked = RELEASED;
	
	          var activeItem = _lodash2.default.find(_this3._items, { active: true });
	          if (activeItem) {
	            if (activeItem.children && activeItem.children.length > 0) {
	              if (activeItem.children[0].folder_module) {
	                _this3.handleContentChange(activeItem.id, null, null, null);
	              } else {
	                var menuPathType = _this3.getMenuPathType(activeItem, 0);
	
	                if (menuPathType === 1) {
	                  activateBubble = true;
	                  _this3.handleContentChange(activeItem.id, activeItem.children[0].id);
	                }
	
	                if (menuPathType >= 2) {
	                  activateBubble = true;
	                  activateListMenu = true;
	                  _this3.handleContentChange(activeItem.id, activeItem.children[0].id, 0, 0);
	                }
	              }
	            }
	          }
	
	          _this3.setState({
	            menuOnScreen: true,
	            activateBubble: activateBubble,
	            activateListMenu: activateListMenu,
	            contentOnScreen: contentOnScreen,
	            touchScreenX: coordinates.x,
	            touchScreenY: coordinates.y,
	            contentX: contentCoordinates.x,
	            contentY: contentCoordinates.y,
	            regionX: _this3.state.regionX,
	            regionY: _this3.state.regionY
	          });
	        }
	      }
	    } else {
	      setTimeout(function () {
	        _this3.handleTouch(event, null);
	      }, 750);
	    }
	  };
	
	  this.handleContentChange = function (mainItemId, bubbleId, listItemArrayIndex, listItemChildIndex) {
	    try {
	      var mainItem = _lodash2.default.find(_this3._items, { id: mainItemId });
	      var content = null;
	      if (mainItem.children[0].folder_module) {
	        content = mainItem;
	      } else {
	        var bubbleItem = _lodash2.default.find(mainItem.children, { id: bubbleId });
	        var sortedItems = _lodash2.default.orderBy(bubbleItem.children, 'rank', 'asc');
	        var listItem = sortedItems[listItemArrayIndex];
	
	        var listItemChild = void 0;
	        if (_this3.isContent(listItem)) {
	          content = listItem;
	        }
	
	        if (!_shared2.default.nullOrUndefined(listItemChildIndex)) {
	          if (bubbleItem.children && bubbleItem.children.length > 0) {
	            var childrenSorted = _lodash2.default.orderBy(listItem.children, 'rank', 'asc');
	            listItemChild = childrenSorted[listItemChildIndex];
	            if (_this3.isContent(listItemChild)) {
	              content = listItemChild;
	            }
	          }
	        } else if (!_shared2.default.nullOrUndefined(listItemArrayIndex)) {
	          if (listItem.children && listItem.children.length > 0) {
	            var _childrenSorted = _lodash2.default.orderBy(listItem.children, 'rank', 'asc');
	            listItemChild = _childrenSorted[0];
	            if (_this3.isContent(listItemChild)) {
	              content = listItemChild;
	            }
	          }
	        } else {
	          if (_this3.isContent(bubbleItem)) {
	            content = bubbleItem;
	          }
	        }
	      }
	
	      _this3.setState({
	        content: content
	      });
	    } catch (e) {
	      console.log(e);
	    }
	  };
	
	  this.storeMenuStatus = function (status, id) {
	    _this3._menuActive = status;
	    var activeElement = _lodash2.default.find(_this3._items, { id: id });
	    for (var i = 0; i < _this3._items.length; i++) {
	      if (_this3._items[i].id === id) {
	        _this3._items[i].main = true;
	        _this3._items[i].active = true;
	      } else {
	        _this3._items[i].main = false;
	        _this3._items[i].active = false;
	      }
	    }
	    var background = _this3.getBackground(activeElement);
	    _this3.setState({
	      content: null,
	      contentOnScreen: _this3._menuActive,
	      contentBackgroundColor: activeElement.contents.custom_fields.background_color.val,
	      background: background
	    });
	  };
	
	  this.startButtonAnimationLoop = function () {
	    clearTimeout(_this3._startButtonTimeout);
	    _this3._startButtonTimeout = setTimeout(function () {
	      if (_this3._startButtonRef) {
	        _this3._startButtonRef.animate([{
	          transform: "scale(1)"
	        }, {
	          transform: "scale(1.1)"
	        }, {
	          transform: "scale(1)"
	        }], {
	          fill: "forwards",
	          duration: 750
	        });
	      }
	      _this3.startButtonAnimationLoop();
	    }, 6000);
	  };
	
	  this.getBackground = function (activeElement) {
	    if (!activeElement) {
	      var displayImage = _lodash2.default.get(_this3.props.content.settings, 'lower_layer_file', null);
	      return _shared2.default.dp(_this3.props.screen, displayImage, null);
	    }
	
	    var slideshowName = _lodash2.default.get(_this3.props.content.settings, 'custom_vars.Slideshow', null);
	    var background = null;
	    if (slideshowName) {
	      var slideshow = _lodash2.default.find(_this3.props.content.dm_active, { name: slideshowName });
	      if (slideshow) {
	        var slideIndex = _lodash2.default.findIndex(slideshow.contents.names, function (name) {
	          return name === activeElement.name;
	        });
	        if (slideIndex > -1) {
	          var img = slideshow.contents.images[slideIndex];
	          background = _shared2.default.dp(_this3.props.screen, img, null);
	        }
	      }
	    }
	
	    return background;
	  };
	
	  this.setAttractLoopBackground = function (backgroundUrl) {
	    _this3.setState({
	      attractLoopBackground: backgroundUrl
	    });
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var active_module = state.active_module;
	  var idle = _shared2.default.parseStringParam(window.location.href, "idle");
	  var namedmodule = _shared2.default.parseStringParam(window.location.href, "name");
	  var hScreens = _shared2.default.parseStringParam(window.location.href, "hscreens");
	  var vScreens = _shared2.default.parseStringParam(window.location.href, "vscreens");
	
	  // let idleActive = false;
	  var idleActive = true;
	  if (state.content.idle_delay === 0 || idle === "false") {
	    idleActive = false;
	  }
	
	  if (namedmodule) {
	    active_module = _lodash2.default.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
	  }
	
	  if (hScreens === undefined || hScreens === null) {
	    hScreens = 3;
	  }
	
	  if (vScreens === undefined || vScreens === null) {
	    vScreens = 2;
	  }
	
	  return {
	    active_module: active_module,
	    content: state.content,
	    contentHasErrored: state.contentHasErrored,
	    contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    donorsHasErrored: state.donorsHasErrored,
	    donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    options: state.options,
	    screensNumber: state.screensNumber,
	    idleActive: idleActive,
	    displayLayout: {
	      horizontal: hScreens,
	      vertical: vScreens
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    switchModule: function switchModule(id) {
	      return dispatch((0, _display.switchModule)(id));
	    },
	    setOptions: function setOptions(data) {
	      return dispatch((0, _display.setOptions)(data));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SeattleContainer);

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import shared from '../../../utils/shared.js';
	
	
	var BUBBLE_DIAMETER_PERCENT = 8.71416;
	var BUBBLE_MAIN_ACTIVE_DIAMETER = 7.6692;
	var BUBBLE_WHITE_OPAQUE_DIAMETER = 9.20;
	
	var SmallBubbleSeattle = function (_Component) {
	  _inherits(SmallBubbleSeattle, _Component);
	
	  function SmallBubbleSeattle(props) {
	    _classCallCheck(this, SmallBubbleSeattle);
	
	    var _this = _possibleConstructorReturn(this, (SmallBubbleSeattle.__proto__ || Object.getPrototypeOf(SmallBubbleSeattle)).call(this, props));
	
	    _this.setupRefs = function () {
	      if (_this._bubbleRef === null) {
	        clearTimeout(_this._bubbleRefTimeout);
	        _this._bubbleRefTimeout = setTimeout(function () {
	          _this.setupRefs();
	        }, 100);
	      } else {
	        _this._bubbleRef.addEventListener('click', _this.handleClick);
	      }
	    };
	
	    _this.handleClick = function () {
	      _this.props.handleClick(_this.props.id);
	    };
	
	    _this._bubbleRef = null;
	    _this._bubbleRefTimeout = null;
	    return _this;
	  }
	
	  _createClass(SmallBubbleSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupRefs();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this._bubbleRef) {
	        this._bubbleRef.addEventListener('click', this.handleClick);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      if (this._bubbleRef) {
	        this._bubbleRef.removeEventListener('click', this.handleClick);
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._bubbleRefTimeout);
	      if (this._bubbleRef) {
	        this._bubbleRef.removeEventListener('click', this.handleClick);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var diameter = this.props.regionWidth * BUBBLE_DIAMETER_PERCENT / 100;
	      var whiteBubbleDiameter = this.props.regionWidth * BUBBLE_WHITE_OPAQUE_DIAMETER / 100;
	      var mainActiveBubbleDiameter = this.props.regionWidth * BUBBLE_MAIN_ACTIVE_DIAMETER / 100;
	      var fontSize = 10 / 100 * diameter;
	
	      var activeMainTop = (whiteBubbleDiameter - mainActiveBubbleDiameter) / 2 + this.props.top;
	      var activeBlueTop = (whiteBubbleDiameter - diameter) / 2 + this.props.top;
	      var activeMainLeft = (whiteBubbleDiameter - mainActiveBubbleDiameter) / 2;
	      var activeBlueLeft = (whiteBubbleDiameter - diameter) / 2;
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: 'div',
	          className: 'fastfadedelay',
	          style: { minHeight: '100%' },
	          transitionName: 'example',
	          transitionEnterTimeout: 0,
	          transitionLeaveTimeout: 0 },
	        _react2.default.createElement(
	          'div',
	          { key: this.props.active },
	          this.props.active ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { style: { position: "absolute", height: whiteBubbleDiameter, width: whiteBubbleDiameter, borderRadius: "50%", backgroundColor: "white", opacity: 0.5, top: this.props.top } }),
	            _react2.default.createElement('div', { style: { position: "absolute", height: diameter, width: diameter, borderRadius: "50%", backgroundColor: this.props.secondaryColor, top: activeBlueTop, left: activeBlueLeft } }),
	            _react2.default.createElement(
	              'div',
	              { style: { height: mainActiveBubbleDiameter, width: mainActiveBubbleDiameter, borderRadius: "50%", backgroundColor: this.props.primaryColor, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", top: activeMainTop, left: activeMainLeft } },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "95%", height: "85%", display: "flex", alignItems: "center", justifyContent: "center" } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'noselect', style: { overflow: "hidden", wordBreak: "break-word", maxWidth: this.props.regionWidth * 0.07291666666666666667, fontSize: fontSize, textTransform: "uppercase", textAlign: "center", width: "100%" } },
	                  this.props.children
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this2._bubbleRef = el;
	              }, style: { height: diameter, width: diameter, borderRadius: "50%", backgroundColor: this.props.primaryColor, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", top: this.props.top, left: this.props.left } },
	            _react2.default.createElement(
	              'span',
	              { className: 'noselect', style: { overflow: "hidden", wordBreak: "break-word", maxWidth: this.props.regionWidth * 0.07291666666666666667, fontSize: fontSize, textTransform: "uppercase", textAlign: "center" } },
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SmallBubbleSeattle;
	}(_react.Component);
	
	exports.default = SmallBubbleSeattle;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _StorySeattle = __webpack_require__(64);
	
	var _StorySeattle2 = _interopRequireDefault(_StorySeattle);
	
	var _reactSlick = __webpack_require__(46);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactIScroll from 'react-iscroll';
	// import iScroll from 'iscroll';
	
	
	var StoriesSeattle = function (_Component) {
	  _inherits(StoriesSeattle, _Component);
	
	  function StoriesSeattle(props) {
	    _classCallCheck(this, StoriesSeattle);
	
	    var _this = _possibleConstructorReturn(this, (StoriesSeattle.__proto__ || Object.getPrototypeOf(StoriesSeattle)).call(this, props));
	
	    _this.componentWillUnmount = function () {
	      if (_this._itemRefs.length > 0) {
	        var _loop = function _loop(i) {
	          if (_this._itemRefs[i]) {
	            // this._itemRefs[i].el.removeEventListener('click', () => this.handleClick(this._itemRefs[i].data));
	            if (_this._itemRefs[i].length > 0) {
	              var _loop2 = function _loop2(j) {
	                if (_this._itemRefs[i][j] && _this._itemRefs[i][j].el) {
	                  _this._itemRefs[i][j].el.removeEventListener('click', function () {
	                    return _this.handleClick(_this._itemRefs[i][j].data);
	                  });
	                }
	              };
	
	              for (var j = 0; j < _this._itemRefs[i].length; j++) {
	                _loop2(j);
	              }
	            }
	          }
	        };
	
	        for (var i = 0; i < _this._itemRefs.length; i++) {
	          _loop(i);
	        }
	      }
	    };
	
	    _this.checkSwipeAnimation = function () {
	      _this.props.handleSwipeAnimation(9, _this.props.items.length);
	    };
	
	    _this.setupRefs = function () {
	      if (_this._itemRefs.length > 0) {
	        var _loop3 = function _loop3(i) {
	          if (_this._itemRefs[i]) {
	            // this._itemRefs[i].el.addEventListener('click', () => this.handleClick(this._itemRefs[i].data));
	            if (_this._itemRefs[i].length > 0) {
	              var _loop4 = function _loop4(j) {
	                if (_this._itemRefs[i][j] && _this._itemRefs[i][j].el) {
	                  _this._itemRefs[i][j].el.addEventListener('click', function () {
	                    return _this.handleClick(_this._itemRefs[i][j].data);
	                  });
	                }
	              };
	
	              for (var j = 0; j < _this._itemRefs[i].length; j++) {
	                _loop4(j);
	              }
	            }
	          }
	        };
	
	        for (var i = 0; i < _this._itemRefs.length; i++) {
	          _loop3(i);
	        }
	      }
	    };
	
	    _this.setupBackButtonRef = function () {
	      if (_this._backButtonRef) {
	        _this._backButtonRef.addEventListener('click', function () {
	          return _this.handleBackButtonClick();
	        });
	      } else {
	        setTimeout(function () {
	          _this.setupBackButtonRef();
	        }, 100);
	      }
	    };
	
	    _this.handleBackButtonClick = function () {
	      if (_this._backButtonRef) {
	        _this._backButtonRef.removeEventListener('click', function () {
	          return _this.handleBackButtonClick();
	        });
	      }
	      _this._backButtonRef = null;
	      _this.setState({
	        showStory: false,
	        story: null
	      });
	      setTimeout(function () {
	        _this.setState({
	          hideStories: false
	        });
	        setTimeout(function () {
	          _this.setState({
	            showSlick: true
	          });
	        }, 300);
	        _this.setupRefs();
	      }, 450);
	    };
	
	    _this.handleClick = function (data) {
	      var story = _lodash2.default.find(_this.props.items, { id: data.id });
	      _this.setState({
	        hideStories: true
	      });
	      setTimeout(function () {
	        _this.setState({
	          showStory: true,
	          story: story
	        });
	        _this.setupBackButtonRef();
	      }, 450);
	    };
	
	    _this.setupElements = function () {
	      var groups = [];
	      var groupSlides = [];
	      var items = _lodash2.default.orderBy(_this.props.items, [function (item) {
	        return item.sorting_name.toLowerCase();
	      }], ['asc']);
	      for (var i = 0; i < items.length; i++) {
	        if (i !== 0 && (i + 1) % _this._elementsPerSlide === 0 || i === items.length - 1) {
	          groupSlides.push(items[i]);
	          if (groupSlides.length < _this._elementsPerSlide) {
	            for (var j = groupSlides.length; j < _this._elementsPerSlide; j++) {
	              groupSlides.push(null);
	            }
	          }
	          groups.push(groupSlides);
	          groupSlides = [];
	        } else {
	          groupSlides.push(items[i]);
	        }
	      }
	
	      _this.renderSlides(groups);
	    };
	
	    _this.renderSlides = function (groups) {
	      try {
	        var renderedItems = groups.map(function (group, i) {
	          _this._itemRefs[i] = [];
	          // let topRatio = 0;
	          var row = [];
	          var rows = [];
	
	          var _loop5 = function _loop5(j) {
	            var slide = group[j];
	            var marginLeft = 0;
	
	            if (j > 0 && j % _this.props.columns !== 0) {
	              marginLeft = 0.0225 * _this.props.regionWidth;
	            } else {
	              marginLeft = 0;
	            }
	
	            var image = (0, _shared.presetDp)('stories', _lodash2.default.get(slide, 'contents.images[0]', null), _this.props.screen);
	
	            if (slide) {
	              var renderedSlide = _react2.default.createElement(
	                'div',
	                { key: j, ref: function ref(el) {
	                    return _this._itemRefs[i][j] = { el: el, data: { id: slide.id } };
	                  }, style: { position: "relative", marginLeft: marginLeft, float: "left", height: 0.09 * _this.props.regionWidth, display: "flex", justifyContent: "center", alignItems: "flex-end", minWidth: "25%", maxWidth: "25%" } },
	                _react2.default.createElement('img', { src: image, style: { maxWidth: 0.10125 * _this.props.regionWidth, maxHeight: 0.074925 * _this.props.regionWidth }, alt: '' }),
	                _react2.default.createElement(
	                  'div',
	                  { style: { position: "absolute", bottom: -(0.0468 * _this.props.regionWidth), width: 0.10125 * _this.props.regionWidth, textAlign: "center", display: "flex", justifyContent: "center", minHeight: 0.04166666666666666667 * _this.props.regionWidth, maxHeight: 0.04166666666666666667 * _this.props.regionWidth, overflow: "hidden" } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'noselect', style: { fontSize: 0.0084 * _this.props.regionWidth } },
	                    _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: slide.name.toUpperCase() })
	                  )
	                )
	              );
	              row.push(renderedSlide);
	            }
	
	            if ((j + 1) % _this.props.columns === 0 && j > 0) {
	              // if (rows.length > 0) {
	              //   topRatio = 0.027 * this.props.regionWidth;
	              // }
	              var renderedRow = _react2.default.createElement(
	                'div',
	                { style: { position: "relative", display: "flex", alignItems: "center", justifyContent: "center", width: 0.36 * _this.props.regionWidth, height: 0.10125 * _this.props.regionWidth, marginBottom: 0.044 * _this.props.regionWidth } },
	                row
	              );
	              rows.push(renderedRow);
	              row = [];
	            }
	          };
	
	          for (var j = 0; j < group.length; j++) {
	            _loop5(j);
	          }
	
	          return rows;
	        });
	
	        var slideGroup = [];
	        var rows = [];
	        for (var i = 0; i < renderedItems.length; i++) {
	          rows.push(renderedItems[i]);
	          if ((i + 1) % _this._elementsPerSlide || i === _this._elementsPerSlide.length - 1) {
	            slideGroup.push(_react2.default.createElement(
	              'div',
	              { style: { position: "relative" }, key: i },
	              rows
	            ));
	            rows = [];
	          }
	        }
	
	        _this.setState({
	          renderedItems: slideGroup
	        });
	
	        setTimeout(function () {
	          _this.setState({
	            showSlick: true
	          });
	        }, 300);
	      } catch (e) {
	        console.log(e);
	      }
	    };
	
	    _this._itemRefs = [];
	    _this._backButtonRef = null;
	    _this._elementsPerSlide = _this.props.rows * _this.props.columns;
	
	    _this.state = {
	      renderedItems: [],
	      showStory: false,
	      hideStories: false,
	      story: null,
	      showSlick: false,
	      currentSlide: 0
	    };
	    return _this;
	  }
	
	  _createClass(StoriesSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setupElements();
	      this.checkSwipeAnimation();
	      setTimeout(function () {
	        _this2.setupRefs();
	      }, 250);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props !== prevProps) {
	        this.setupElements();
	        this.setupRefs();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var dots = this.state.renderedItems.length > 1 ? true : false;
	      var settings = {
	        arrows: false,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        centerMode: false,
	        useCSS: true,
	        dots: dots,
	        dotsClass: "story-seattle-slick-vertical",
	        verticalSwiping: true,
	        vertical: true,
	        initialSlide: this.state.currentSlide,
	        afterChange: function afterChange(current) {
	          _this3.props.cancelSwipeAnimation();
	          _this3.setState({ currentSlide: current });
	        }
	      };
	      var backButton = (0, _shared.dp)(this.props.screen, null, { path: '/img/seattle/general/', file_name: 'back.png' });
	      var displayStories = this.state.hideStories ? "none" : "table-cell";
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", display: "table", left: 0, width: "100%", height: 0.52 * this.props.regionWidth }, key: this.state.hideStories },
	            !this.state.hideStories ? _react2.default.createElement(
	              'div',
	              { style: { position: "relative", width: "90%", height: 0.41 * this.props.regionWidth, textAlign: "center", display: displayStories, marginLeft: "auto", marginRight: "auto", verticalAlign: "middle" } },
	              _react2.default.createElement(
	                'div',
	                { style: { maxHeight: .0902 * this.props.regionWidth, overflow: "hidden" } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'noselect', style: { fontSize: 0.020 * this.props.regionWidth } },
	                  _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.parent.name.toUpperCase() })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { height: 0.3958 * this.props.regionWidth, display: "flex", justifyContent: "center", alignItems: "center", marginTop: .017 * this.props.regionWidth } },
	                this.state.renderedItems && this.state.renderedItems.length > 0 ? _react2.default.createElement(
	                  'div',
	                  { style: { maxWidth: 0.36 * this.props.regionWidth } },
	                  _react2.default.createElement(
	                    _reactSlick2.default,
	                    Object.assign({ ref: function ref(el) {
	                        return _this3._slickRef = el;
	                      } }, settings),
	                    this.state.renderedItems
	                  )
	                ) : null
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showStory },
	            this.state.showStory ? _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", left: 0, width: "100%", height: "100%" } },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_StorySeattle2.default, {
	                  item: this.state.story,
	                  screen: this.props.screen,
	                  regionWidth: this.props.regionWidth,
	                  handleSwipeAnimation: this.props.handleSwipeAnimation,
	                  cancelSwipeAnimation: this.props.cancelSwipeAnimation
	                })
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          this.state.showStory ? _react2.default.createElement(
	            'div',
	            { key: this.state.showStory, ref: function ref(reactComponent) {
	                return _this3._backButtonRef = reactComponent;
	              } },
	            _react2.default.createElement('img', { src: backButton, style: { position: "absolute", left: 0, bottom: .02777777777777777778 * this.props.regionWidth, width: 0.050 * this.props.regionWidth }, alt: '' })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return StoriesSeattle;
	}(_react.Component);
	
	exports.default = StoriesSeattle;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _InfoBlockSeattle = __webpack_require__(472);
	
	var _InfoBlockSeattle2 = _interopRequireDefault(_InfoBlockSeattle);
	
	var _StorySeattle = __webpack_require__(64);
	
	var _StorySeattle2 = _interopRequireDefault(_StorySeattle);
	
	var _reactLazyload = __webpack_require__(334);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineSeattle = function (_Component) {
	  _inherits(TimelineSeattle, _Component);
	
	  function TimelineSeattle(props) {
	    _classCallCheck(this, TimelineSeattle);
	
	    var _this = _possibleConstructorReturn(this, (TimelineSeattle.__proto__ || Object.getPrototypeOf(TimelineSeattle)).call(this, props));
	
	    _this.intervalCheckSwipeAnimation = function () {
	      if (!_this._contentRef) {
	        setTimeout(function () {
	          _this.intervalCheckSwipeAnimation();
	        }, 100);
	      } else {
	        _this.checkSwipeAnimation();
	      }
	    };
	
	    _this.checkSwipeAnimation = function () {
	      var scrollWrapperHeight = 0.438 * _this.props.regionWidth;
	      _this.props.handleSwipeAnimation(scrollWrapperHeight, _this._totalHeight);
	    };
	
	    _this.parseDate = function (date) {
	      // let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
	      //   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	      // ];
	      // let monthName = monthNames[date.getMonth()]
	      // let monthNumber = String(date.getMonth() + 1);
	      var fullYear = String(date.getFullYear());
	      // let shortYear = fullYear.substring(2);
	      // let day = String(date.getDate());
	      // let unit = this.props.screen.r9_16.p10
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          _react2.default.createElement(
	            'span',
	            { style: { overflow: 'visible', fontSize: 0.0225 * _this.props.regionWidth } },
	            fullYear
	          )
	        )
	      );
	    };
	
	    _this.handleBackButtonClick = function () {
	      _this.setState({
	        showStory: false,
	        story: null,
	        hideTimeline: false
	      });
	      // setTimeout(() => {
	      //   this.setState({
	      //     hideTimeline: false
	      //   });
	      //   this.setupRefs();
	      // }, 450)
	    };
	
	    _this.initializeTimelineRefs = function () {
	      if (_this.state.initializedRefs === false) {
	        var _loop = function _loop(a) {
	          _this.timelineRefs[a].el.addEventListener("tap", function () {
	            return _this.handleEventSelection(_this.timelineRefs[a].data);
	          });
	        };
	
	        for (var a = 0; a < _this.timelineRefs.length; a++) {
	          _loop(a);
	        }
	        _this.setState({
	          initializedRefs: true
	        });
	      }
	    };
	
	    _this.handleEventSelection = function (data) {
	      _this.setState({
	        hideTimeline: true,
	        showStory: true,
	        story: data.story
	      });
	    };
	
	    _this.onScrollStart = function () {
	      (0, _reactLazyload.forceCheck)();
	    };
	
	    _this.onScrollEnd = function () {
	      (0, _reactLazyload.forceCheck)();
	    };
	
	    _this.refDict = [];
	    _this.timelineRefs = [];
	    _this._events = [];
	    _this._contentRef = null;
	    _this._events_on_screen = 20;
	    _this._screenWidth = _this.props.regionWidth;
	    _this._centerline = _this._screenWidth * .17;
	    var eventInc = _this.props.regionHeight / _this._events_on_screen * 2;
	
	    var items = _this.props.items;
	
	    items = items.sort(function compare(a, b) {
	      var adate = new Date(_lodash2.default.get(a, 'contents.sorting_date', '2000-01-01'));
	      var bdate = new Date(_lodash2.default.get(b, 'contents.sorting_date', '2000-01-01'));
	      return adate - bdate;
	    });
	
	    _lodash2.default.forEach(items, function (event, index) {
	      var raw = eventInc * index;
	      var span = raw + eventInc;
	      var strDate = _lodash2.default.get(event, 'contents.sorting_date', '2000-01-01');
	      var rawDate = new Date(strDate.split('-')[0], Number(strDate.split('-')[1]) - 1, strDate.split('-')[2], 0, 0, 0);
	      _this._events.push({ header: event.header, rawDate: rawDate, date: _this.parseDate(rawDate), offset: span, raw: raw, text: _lodash2.default.get(event, 'contents.text0', ''), images: _lodash2.default.get(event, 'contents.images', []), story: event });
	    });
	
	    _this._totalHeight = (_this._events.length + 2) * (_this.props.regionHeight / _this._events_on_screen * 2);
	    _this.state = {
	      showStory: false,
	      hideTimeline: false,
	      initializedRefs: false,
	      story: null
	    };
	    return _this;
	  }
	
	  _createClass(TimelineSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.intervalCheckSwipeAnimation();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var _loop2 = function _loop2(a) {
	        if (_this2.timelineRefs[a].el) {
	          _this2.timelineRefs[a].el.removeEventListener("tap", function () {
	            return _this2.handleEventSelection(_this2.timelineRefs[a].data);
	          });
	        }
	      };
	
	      for (var a = 0; a < this.timelineRefs.length; a++) {
	        _loop2(a);
	      }
	    }
	  }, {
	    key: 'randomDiv',
	    value: function randomDiv() {
	      var r = Math.random().toString(36).substring(7);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        r
	      );
	    }
	
	    // setupBackButtonRef = () => {
	    //     console.log("setting up nack ref");
	    //     console.log(this._backButtonRef);
	    //     if (this._backButtonRef) {
	    //       this._backButtonRef.addEventListener('click', () => this.handleBackButtonClick());
	    //     } else {
	    //       setTimeout(() => {
	    //         this.setupBackButtonRef();
	    //       }, 100)
	    //     }
	    //   }
	
	  }, {
	    key: 'renderSpacialEvents',
	    value: function renderSpacialEvents() {
	      // timeline circle
	      var unit = this.props.regionWidth * 0.3;
	      var circleRadius = unit * 0.15;
	
	      if (this._events.length === 0) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var infoBlockWidth = unit * 3.35 * .1;
	      var imageHeight = unit * 2 * .1;
	      var infoHeight = unit * .85 * .1;
	
	      // const insetAmount = unit * 1.55
	      // const leftInset = -insetAmount - infoBlockWidth;
	      // const rightInset = insetAmount;
	
	      // const fullHeight = imageHeight + infoHeight
	      // const iconWidth = unit * .25;
	      var h_width = unit * .15;
	
	      return this._events.map(function (row, i) {
	        var _this3 = this;
	
	        var thumbImage = (0, _shared.presetDp)('thumbnail', _lodash2.default.get(row, 'images[0]', null), this.props.screen);
	
	        //assume right
	        var h_inset = this._centerline;
	
	        var c_inset = this._centerline + h_width - circleRadius / 2;
	        var t_inset = c_inset + this._screenWidth * .07;
	        var floatRight = false;
	
	        //offset for left scenario
	        if (i % 2 === 0) {
	          floatRight = true;
	          h_inset = this._centerline - h_width;
	          // c_inset = this._centerline - h_width - this._screenWidth * .05
	          c_inset = 0;
	          // t_inset = c_inset - this._screenWidth * .07
	          t_inset = this.props.regionWidth * .01736;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: { position: 'absolute', top: row.offset, zIndex: 0 } },
	          _react2.default.createElement('div', { style: {
	              position: 'absolute',
	              backgroundColor: 'white',
	              top: 0,
	              left: h_inset,
	              width: h_width,
	              height: 0.0039 * this.props.regionWidth,
	              zIndex: 0
	            } }),
	          _react2.default.createElement(
	            'span',
	            { className: 'noselect', ref: function ref(el) {
	                return _this3.timelineRefs[i] = { el: el, data: row };
	              }, style: { width: .14322 * this.props.regionWidth, top: -0.025 * this.props.regionWidth, position: 'absolute', left: c_inset, zIndex: 9999 } },
	            _react2.default.createElement(
	              _reactLazyload2.default,
	              { once: true, offset: this.props.regionWidth * 0.5 },
	              _react2.default.createElement(_InfoBlockSeattle2.default, {
	                imgsrc: thumbImage,
	                imageHeight: imageHeight,
	                infoHeight: infoHeight,
	                width: infoBlockWidth,
	                unit: unit * .8,
	                text: row.header,
	                infoColor: "black",
	                infoBackgroundColor: 'white',
	                fontFamily: 'opensans-regular',
	                fontSize: unit * 0.15,
	                floatRight: floatRight
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'noselect', style: { overflow: 'visible', fontSize: 5, top: -(0.0012 * this.props.regionWidth), position: 'absolute', left: t_inset, zIndex: 1 } },
	            row.date
	          )
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var events = this.renderSpacialEvents();
	      var backButton = (0, _shared.dp)(this.props.screen, null, { path: '/img/seattle/general/', file_name: 'back.png' });
	
	      var containerClass = "gradiant fadediv";
	      if (this.state.hideTimeline === true) {
	        containerClass += " fadeout";
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: containerClass, style: { position: "absolute", top: .035 * this.props.regionWidth, left: .039 * this.props.regionWidth, height: 0.438 * this.props.regionWidth, width: "100%", touchAction: "none" } },
	          _react2.default.createElement(
	            _reactIscroll2.default,
	            { ref: function ref(el) {
	                return _this4.refDict[0] = el;
	              }, iScroll: _iscroll2.default,
	              options: {
	                mouseWheel: true,
	                scrollbars: false,
	                scrollX: false,
	                scrollY: true,
	                probeType: 2,
	                bounce: false,
	                momentum: true,
	                deceleration: 0.015,
	                useTransition: true,
	                disableTouch: false,
	                disablePointer: false,
	                disableMouse: false,
	                tap: true
	              },
	              onRefresh: this.initializeTimelineRefs,
	              onScrollStart: this.onScrollStart,
	              onScrollEnd: this.onScrollEnd
	            },
	            _react2.default.createElement(
	              'div',
	              { style: { width: 0.303 * this.props.regionWidth, height: this._totalHeight, minHeight: '100%' } },
	              _react2.default.createElement('div', { style: {
	                  position: 'absolute',
	                  top: 0,
	                  backgroundColor: 'white',
	                  left: this._centerline,
	                  width: 0.0039 * this.props.regionWidth,
	                  height: '100%'
	                } }),
	              _react2.default.createElement('div', { style: {
	                  position: 'absolute',
	                  width: 0.3712 * this.props.regionWidth,
	                  height: 0.5625 * this.props.regionWidth
	                } }),
	              events
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showStory },
	            this.state.showStory ? _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", left: 0, width: "100%", height: "100%" } },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_StorySeattle2.default, {
	                  item: this.state.story,
	                  screen: this.props.screen,
	                  regionWidth: this.props.regionWidth,
	                  handleSwipeAnimation: this.props.handleSwipeAnimation,
	                  cancelSwipeAnimation: this.props.cancelSwipeAnimation
	                })
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          this.state.showStory ? _react2.default.createElement(
	            'div',
	            { key: this.state.showStory, onClick: function onClick() {
	                return _this4.handleBackButtonClick();
	              } },
	            _react2.default.createElement('img', { src: backButton, style: { position: "absolute", left: 0, bottom: .02777777777777777778 * this.props.regionWidth, width: 0.050 * this.props.regionWidth }, alt: '' })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return TimelineSeattle;
	}(_react.Component);
	
	exports.default = TimelineSeattle;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TouchGestureSeattle = function (_Component) {
	  _inherits(TouchGestureSeattle, _Component);
	
	  function TouchGestureSeattle(props) {
	    _classCallCheck(this, TouchGestureSeattle);
	
	    var _this = _possibleConstructorReturn(this, (TouchGestureSeattle.__proto__ || Object.getPrototypeOf(TouchGestureSeattle)).call(this, props));
	
	    _this.animateIcon = function () {
	      var distance = .08733 * _this.props.regionWidth;
	      if (_this._iconRef) {
	        _this._iconRef.animate([{
	          transform: "scale(1.0)"
	        }, {
	          transform: "scale(0.7)"
	        }, {
	          transform: 'scale(0.7) translate(0px, -' + distance + 'px)'
	        }, {
	          transform: 'scale(1.0) translate(0px, -' + distance + 'px)'
	        }], {
	          direction: "alternate",
	          easing: "ease-in",
	          fill: "both",
	          duration: 1500,
	          iterations: 2
	        });
	      }
	    };
	
	    _this.startInterval = function () {
	      _this.setState({
	        show: true
	      });
	      setTimeout(function () {
	        _this.animateIcon();
	      }, 1000);
	    };
	
	    var radius = _this.props.regionWidth;
	    var top = (_this.props.regionHeight - radius) / 2;
	    var right = -(_this.props.regionWidth / 100 * 36.45);
	
	    _this._iconRef = null;
	
	    _this.state = {
	      radius: radius,
	      top: top,
	      right: right,
	      show: false
	    };
	    return _this;
	  }
	
	  _createClass(TouchGestureSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.startInterval();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps !== this.props) {
	        if (this.props.show) {
	          this.startInterval();
	        } else {
	          this.setState({
	            show: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: "absolute", top: this.props.contentY, left: this.props.contentX } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'fastfadedelay',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.show },
	            this.state.show ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { style: { position: "absolute", left: this.props.regionWidth * .9475, top: .4366 * this.props.regionWidth } },
	                _react2.default.createElement('img', { ref: function ref(el) {
	                    return _this2._iconRef = el;
	                  }, src: '/img/seattle/general/hand.png', alt: '', style: { width: .021 * this.props.regionWidth, zIndex: 9999 } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { color: "FFFFFF", position: "absolute", fontSize: .013 * this.props.regionWidth, width: .2751 * this.props.regionWidth, height: .0366 * this.props.regionWidth, top: .5065 * this.props.regionWidth, left: .7205 * this.props.regionWidth, fontWeight: "bold" } },
	                'SWIPE TO SEE MORE'
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return TouchGestureSeattle;
	}(_react.Component);
	
	exports.default = TouchGestureSeattle;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeyboardKeySeattle = __webpack_require__(473);
	
	var _KeyboardKeySeattle2 = _interopRequireDefault(_KeyboardKeySeattle);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _donorHelpers2 = _interopRequireDefault(_donorHelpers);
	
	var _dataHelpers = __webpack_require__(51);
	
	var _dataHelpers2 = _interopRequireDefault(_dataHelpers);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _StorySeattle = __webpack_require__(64);
	
	var _StorySeattle2 = _interopRequireDefault(_StorySeattle);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserInputSeattle = function (_Component) {
	  _inherits(UserInputSeattle, _Component);
	
	  function UserInputSeattle(props) {
	    _classCallCheck(this, UserInputSeattle);
	
	    var _this = _possibleConstructorReturn(this, (UserInputSeattle.__proto__ || Object.getPrototypeOf(UserInputSeattle)).call(this, props));
	
	    _this.getTimelineModule = function () {
	      _this._menuModules = _lodash2.default.filter(_this.props.content.dm_active, { module_contents: { in_navigation: true } });
	      _this._menuModules.forEach(function (module, row) {
	        if (module.display_module_type === "Timeline") {
	          _this._timelineModule = module;
	        }
	      });
	    };
	
	    _this.setupDonorListsNames = function () {
	      var folders = _lodash2.default.filter(_this.props.content.story_categories, { contents: { custom_fields: { folder_type: { val: { value: "donor_list" } } } } });
	      var names = [];
	      if (folders && folders.length > 0) {
	        for (var i = 0; i < folders.length; i++) {
	          var searchable = _lodash2.default.get(folders[i], 'contents.custom_fields.searchable.val', false);
	          if (searchable) {
	            var folder = folders[i];
	            var folderTree = _this.getFolderTree(folder, 0);
	            var name = "";
	            var subName = "";
	            var parentId = null;
	            var parent = void 0;
	
	            if (folderTree.count <= 4) {
	              var child = folderTree.child;
	              while (child) {
	                if (child.child) {
	                  child = child.child;
	                  parent = Object.assign({}, child);
	                } else {
	                  name = child.name;
	                  parentId = parent.parent_category;
	                  child = null;
	                }
	              }
	
	              names.push({
	                id: folder.id,
	                name: name,
	                subName: null,
	                parentId: parentId
	              });
	            }
	
	            if (folderTree.count === 5) {
	              var _child = folderTree.child;
	              while (_child) {
	                if (_child.child) {
	                  name = _child.name;
	                  _child = _child.child;
	                  parent = Object.assign({}, _child);
	                } else {
	                  subName = _child.name;
	                  parentId = parent.parent_category;
	                  _child = null;
	                }
	              }
	
	              names.push({
	                id: folder.id,
	                name: name,
	                subName: subName,
	                parentId: parentId
	              });
	            }
	          }
	        }
	      }
	
	      return names;
	    };
	
	    _this.getFolderTree = function (folder, count) {
	      count++;
	      if (folder.parent_category === undefined || folder.parent_category === null) {
	        folder.count = count;
	        return folder;
	      } else {
	        var parentFolder = _lodash2.default.find(_this.props.content.story_categories, { id: folder.parent_category });
	        parentFolder.child = folder;
	        return _this.getFolderTree(parentFolder, count);
	      }
	    };
	
	    _this.removeInputText = function () {
	      _this.setState({
	        text: "",
	        search: false
	      });
	      setTimeout(function () {
	        _this.setState({
	          hideKeyboard: false
	        });
	      }, 500);
	    };
	
	    _this.initializeIScroll = function () {
	      if (_this.state.iScrollInitialized === false) {
	        var _loop = function _loop(i) {
	          if (_this._storiesRefs[i] && _this._storiesRefs[i].el) {
	            _this._storiesRefs[i].el.addEventListener("tap", function () {
	              return _this.handleTap(_this._storiesRefs[i].data.id);
	            });
	          }
	        };
	
	        for (var i = 0; i < _this._storiesRefs.length; i++) {
	          _loop(i);
	        }
	
	        _this.setState({
	          iScrollInitialized: true
	        });
	      }
	    };
	
	    _this.setupBackButtonRef = function () {
	      if (_this._backButtonRef) {
	        _this._backButtonRef.addEventListener('click', function () {
	          return _this.handleBackButtonClick();
	        });
	      } else {
	        setTimeout(function () {
	          _this.setupBackButtonRef();
	        }, 100);
	      }
	    };
	
	    _this.handleBackButtonClick = function () {
	      if (_this._backButtonRef) {
	        _this._backButtonRef.removeEventListener('click', function () {
	          return _this.handleBackButtonClick();
	        });
	      }
	      _this._storiesRefs = [];
	      _this._backButtonRef = null;
	      _this.setState({
	        showStory: false,
	        story: null,
	        iScrollInitialized: false
	      });
	    };
	
	    _this.handleTap = function (storyId) {
	      var story = _lodash2.default.find(_this.props.content.stories, { id: storyId });
	      _this.setState({
	        story: story,
	        showStory: true
	      });
	      setTimeout(function () {
	        _this.setupBackButtonRef();
	      }, 200);
	    };
	
	    _this.getDonorListName = function (folder) {
	      var name = _lodash2.default.find(_this._donorListNames, { id: folder.id });
	      return name;
	    };
	
	    _this.getGrouppedDonorFolders = function (folders) {
	      var parents = [];
	      for (var i = 0; i < folders.length; i++) {
	        var name = _this.getDonorListName(folders[i]);
	        if (name && parents.indexOf(name.parentId) === -1) {
	          parents.push(name.parentId);
	        }
	      }
	
	      return parents;
	    };
	
	    _this.getTributes = function (donor) {
	      var renderedTributes = [];
	      if (donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options) {
	        renderedTributes = donor.contents.arrays_values.acknowledgment_text_options.map(function (opt, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(
	              'div',
	              { style: { paddingTop: _this.props.regionWidth * .0035, paddingBottom: _this.props.regionWidth * .0035 } },
	              opt.acknowledgment_text_options.val.title + ' ' + opt.donor_name.val
	            )
	          );
	        });
	      }
	
	      return renderedTributes;
	    };
	
	    _this.renderStories = function (stories) {
	      if (stories.length === 0) {
	        _this.setState({
	          renderedStories: []
	        });
	        return;
	      }
	
	      var rows = [];
	      var row = [];
	
	      var _loop2 = function _loop2(i) {
	        var slide = stories[i];
	        var image = (0, _shared.presetDp)('stories', _lodash2.default.get(slide, 'contents.images[0]', null), _this.props.screen);
	        var marginLeft = 0;
	
	        if (i > 0 && i % 3 !== 0) {
	          marginLeft = 0.0225 * _this.props.regionWidth;
	        } else {
	          marginLeft = 0;
	        }
	
	        if (i % 3 === 0 && i > 0) {
	          rows.push(row);
	          row = [];
	        }
	
	        var story = _react2.default.createElement(
	          'div',
	          { key: i, ref: function ref(el) {
	              return _this._storiesRefs[i] = { el: el, data: { id: slide.id } };
	            }, style: { position: "relative", marginLeft: marginLeft, float: "left", height: 0.09 * _this.props.regionWidth, display: "flex", justifyContent: "center", alignItems: "flex-end", minWidth: "25%", maxWidth: "25%" } },
	          _react2.default.createElement('img', { src: image, style: { maxWidth: 0.10125 * _this.props.regionWidth, maxHeight: 0.074925 * _this.props.regionWidth }, alt: '' }),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", bottom: -(0.0468 * _this.props.regionWidth), width: 0.10125 * _this.props.regionWidth, textAlign: "center", display: "flex", justifyContent: "center", minHeight: 0.04166666666666666667 * _this.props.regionWidth, maxHeight: 0.04166666666666666667 * _this.props.regionWidth, overflow: "hidden" } },
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: 0.0084 * _this.props.regionWidth } },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: slide.name.toUpperCase() })
	            )
	          )
	        );
	
	        row.push(story);
	        if (i === stories.length - 1) {
	          rows.push(row);
	        }
	      };
	
	      for (var i = 0; i < stories.length; i++) {
	        _loop2(i);
	      }
	
	      var renderedRows = rows.map(function (row, j) {
	        var marginTop = j === 0 ? 0 : _this.props.regionWidth * 0.017;
	        return _react2.default.createElement(
	          'div',
	          { key: j, style: { position: "relative", display: "flex", alignItems: "center", justifyContent: "center", width: "89%", height: 0.10125 * _this.props.regionWidth, marginTop: marginTop, left: _this.props.regionWidth * 0.041 } },
	          row
	        );
	      });
	
	      _this.setState({
	        renderedStories: renderedRows
	      });
	    };
	
	    _this.renderDonors = function (results) {
	      var renderedDonors = [];
	      var renderedSubDonors = [];
	      var count = 0;
	      var marginTop = 0;
	
	      var foundFolders = _lodash2.default.filter(_this.props.content.story_categories, function (fl) {
	        return results.foundFolders.indexOf(Number(fl.id)) > -1;
	      });
	      var parents = _this.getGrouppedDonorFolders(foundFolders);
	      var parentFolders = _lodash2.default.filter(_this.props.content.story_categories, function (fl) {
	        return parents.indexOf(Number(fl.id)) > -1;
	      });
	
	      for (var i = 0; i < parentFolders.length; i++) {
	        var children = _lodash2.default.filter(foundFolders, { parent_category: parentFolders[i].id });
	        for (var j = 0; j < children.length; j++) {
	          var folder = children[j];
	          var searchable = _lodash2.default.get(folder, 'contents.custom_fields.searchable.val', false);
	          if (searchable) {
	            var categoryMatchedDonors = _lodash2.default.orderBy(_lodash2.default.filter(results.foundDonors, { folder_module: { folder: folder.id } }), [function (donor) {
	              return donor.sorting_name.toLowerCase();
	            }], ['asc']);
	            var matchedColumnOne = [];
	            var matchedColumnTwo = [];
	
	            // Highlighted Donors (matched)
	            for (var k = 0; k < categoryMatchedDonors.length; k++) {
	              if (k === 0 || k % 2 === 0) {
	                matchedColumnOne.push(categoryMatchedDonors[k]);
	              } else {
	                matchedColumnTwo.push(categoryMatchedDonors[k]);
	              }
	            }
	
	            var renderedMatchedColumnOneDonors = matchedColumnOne.map(function (donor, i) {
	              var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * _this.props.regionWidth : 0;
	              return _react2.default.createElement(
	                'div',
	                { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this.props.regionWidth, display: "block", paddingTop: .0052 * _this.props.regionWidth } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { maxWidth: "85%", fontSize: 0.009 * _this.props.regionWidth, marginBottom: marginBottom } },
	                  donor.name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * _this.props.regionWidth } },
	                  _this.getTributes(donor)
	                )
	              );
	            });
	
	            var renderedMatchedColumnTwoDonors = matchedColumnTwo.map(function (donor, i) {
	              var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * _this.props.regionWidth : 0;
	              return _react2.default.createElement(
	                'div',
	                { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this.props.regionWidth, display: "block", paddingTop: .0052 * _this.props.regionWidth } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { maxWidth: "85%", fontSize: 0.009 * _this.props.regionWidth, marginBottom: marginBottom } },
	                  donor.name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * _this.props.regionWidth } },
	                  _this.getTributes(donor)
	                )
	              );
	            });
	
	            var donorCategoryName = _this.getDonorListName(folder);
	            var subName = donorCategoryName.subName;
	
	            if (count > 0) {
	              marginTop = .026 * _this.props.regionWidth;
	            }
	
	            renderedSubDonors[j] = _react2.default.createElement(
	              'div',
	              { key: j },
	              subName ? _react2.default.createElement(
	                'div',
	                { style: { fontSize: _this.props.regionWidth * 0.009, paddingTop: 0.00347222222222222222 * _this.props.regionWidth, paddingBottom: 0.00694444444444444444 * _this.props.regionWidth } },
	                _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: subName.toUpperCase() })
	              ) : null,
	              _react2.default.createElement('div', { style: { position: "absolute", height: _this.props.regionWidth * 0.0017, background: "white", width: "90%" } }),
	              _react2.default.createElement(
	                'div',
	                { style: { position: "relative", width: "100%", display: "flex", marginTop: .004 * _this.props.regionWidth, marginBottom: 0.0086 * _this.props.regionWidth } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: 0.16875 * _this.props.regionWidth, float: "left" } },
	                  renderedMatchedColumnOneDonors
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: 0.16875 * _this.props.regionWidth } },
	                  renderedMatchedColumnTwoDonors
	                )
	              )
	            );
	          }
	        }
	
	        renderedDonors[i] = _react2.default.createElement(
	          'div',
	          { key: i, style: { position: "relative", left: _this.props.regionWidth * 0.060, marginTop: marginTop } },
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: _this.props.regionWidth * 0.015625 } },
	            _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: parentFolders[i].name.toUpperCase() })
	          ),
	          renderedSubDonors
	        );
	        renderedSubDonors = [];
	      }
	
	      _this.setState({
	        renderedDonors: renderedDonors
	      });
	    };
	
	    _this.state = {
	      text: "",
	      module: _this.props.item,
	      virtual_keyboard_mode: 0,
	      iScrollInitialized: false,
	      scrollContainerHeight: 0.5625 * _this.props.regionWidth,
	      storyRefs: [],
	      hideKeyboard: false,
	      emailSent: false,
	      showStory: false,
	      renderedStories: [],
	      renderedDonors: []
	    };
	
	    _this._donorListNames = [];
	    _this._storiesRefs = [];
	    _this._backButtonRef = null;
	    _this.iScroller = null;
	    _this._simple = null;
	    _this._simpleWithPictures = null;
	    _this._videos = null;
	    _this._donors = null;
	    _this._pills = null;
	    _this._resultsContainer = null;
	    _this._emailSentTimeout = null;
	    _this._pillsStorySetsByModules = [];
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.deleteText = _this.deleteText.bind(_this);
	    _this.normalMode = _this.normalMode.bind(_this);
	    _this.capitalMode = _this.capitalMode.bind(_this);
	    _this.submitText = _this.submitText.bind(_this);
	
	    _this.getTimelineModule();
	
	    //Refs
	    _this._storyPillsRefs = [];
	    return _this;
	  }
	
	  // componentWillMount() {
	  //   checkData(this.props.item, this.props.screen.entry_point);
	  //   this._emailSentTimeout = null;
	  //   clearTimeout(this._emailSentTimeout);
	  // }
	
	  _createClass(UserInputSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2._donorListNames = _this2.setupDonorListsNames();
	      }, 2500);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if ((0, _shared.shallowEqual)(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(val) {
	      if (typeof val === "function") {
	        val();
	      } else {
	        var str = this.state.text + val;
	        if (str.length < 40) {
	          this.setState({
	            text: str
	          });
	        }
	      }
	    }
	  }, {
	    key: 'normalMode',
	    value: function normalMode() {
	      this.setState({
	        virtual_keyboard_mode: 0
	      });
	    }
	  }, {
	    key: 'capitalMode',
	    value: function capitalMode() {
	      this.setState({
	        virtual_keyboard_mode: 1
	      });
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText() {
	      if (this.state.text.length > 0) {
	        var str = this.state.text.substring(0, this.state.text.length - 1);
	        this.setState({
	          text: str
	        });
	      }
	    }
	  }, {
	    key: 'submitText',
	    value: function submitText() {
	      var _this3 = this;
	
	      this.setState({
	        iScrollInitialized: false
	      });
	
	      this._pillsStorySetsByModules = [];
	      this._storyPillsRefs = [];
	      this._storyPillsRefs.length = 0;
	
	      var donorResults = _donorHelpers2.default.searchInFolderDonorLists(this.props.content.story_categories, this.props.donors, this.state.text);
	      var storiesResult = _dataHelpers2.default.searchStory(this.props.content, this.state.text, ['attract_loop']);
	      this.renderStories(storiesResult);
	      this.renderDonors(donorResults);
	
	      this.setState({
	        stories: storiesResult,
	        donors: this._donors,
	        hideKeyboard: true
	      });
	
	      setTimeout(function () {
	        _this3.setState({
	          search: true
	        });
	        setTimeout(function () {
	          _this3.iScroller._iScrollInstance.refresh();
	        }, 500);
	      }, 500);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var iconImage = (0, _shared.dp)(this.props.screen, null, { path: '/img/seattle/general/', file_name: 'icon-search-header.png' });
	
	      var keystd = {
	        width: this.props.regionWidth * 0.0260,
	        height: this.props.regionWidth * 0.0260,
	        margin: this.props.regionWidth * 0.0015,
	        borderRadius: this.props.regionWidth * 0.005,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: this.props.regionWidth * 0.015,
	        color: "black"
	      };
	
	      var keyspace = {
	        width: this.props.regionWidth * 0.0950,
	        height: this.props.regionWidth * 0.0260,
	        margin: this.props.regionWidth * 0.0015,
	        borderRadius: this.props.regionWidth * 0.005,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: this.props.regionWidth * 0.015
	      };
	
	      var keycom = {
	        width: this.props.regionWidth * 0.0430,
	        height: this.props.regionWidth * 0.0260,
	        margin: this.props.regionWidth * 0.0015,
	        borderRadius: this.props.regionWidth * 0.005,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: this.props.regionWidth * 0.015
	      };
	
	      var keysubmit = {
	        width: this.props.regionWidth * 0.11,
	        height: this.props.regionWidth * 0.0260,
	        margin: this.props.regionWidth * 0.0015,
	        borderRadius: this.props.regionWidth * 0.005,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: this.props.regionWidth * 0.015
	      };
	
	      var textAlign = this.state.text.length > 0 ? "center" : "left";
	
	      // let boxStyle = {
	      //   paddingLeft: '3.375vh',
	      //   paddingRight: '3.375vh',
	      //   paddingTop: '1.96875vh',
	      //   paddingBottom: '1.96875vh',
	      //   width: "100%"
	      // }
	
	      //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.
	
	      if (!this.props.item) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var backButton = (0, _shared.dp)(this.props.screen, null, { path: '/img/seattle/general/', file_name: 'back.png' });
	      var hasMatchedResults = this.state.renderedStories.length > 0 || this.state.renderedDonors.length > 0;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: "100%", height: "100%" } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'containerFade',
	              style: { minHeight: '45%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showStory },
	              !this.state.showStory ? _react2.default.createElement(
	                'div',
	                { style: { position: "absolute", left: this.props.regionWidth * .038 } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	                  _react2.default.createElement('img', { alt: this.props.item.contents.header, src: iconImage, style: { width: 0.18 * this.props.regionWidth } })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { textAlign: "center", fontSize: this.props.regionWidth * 0.034 } },
	                  this.props.item.contents.header.toUpperCase()
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: this.props.regionWidth * 0.014, textAlign: "center" } },
	                  this.props.item.contents.text
	                ),
	                _react2.default.createElement('div', { style: { height: this.props.regionWidth * 0.02 } }),
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: "flex", justifyContent: "center", alignItems: "center" } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', width: this.props.regionWidth * 0.3246, height: 0.04 * this.props.regionWidth, border: .0035 * this.props.regionWidth, borderStyle: "solid", borderColor: "#FFFFFF", justifyContent: "center", alignItems: "center" } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { height: this.props.regionWidth * 0.041, display: 'flex', alignItems: 'center', justifyContent: textAlign, fontSize: 0.018 * this.props.regionWidth, color: "white", float: "left", width: "90%" } },
	                      this.state.text.length > 0 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        '\xA0',
	                        this.state.text,
	                        '\xA0'
	                      ) : _react2.default.createElement('div', { style: { fontSize: 0.028 * this.props.regionWidth, fontWeight: "bold" } })
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { onClick: this.removeInputText, style: { height: .027 * this.props.regionWidth, fontSize: this.props.regionWidth * .0225, color: "white", fontWeight: "bold" } },
	                      _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
	                    )
	                  )
	                )
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.hideKeyboard },
	              !this.state.hideKeyboard && !this.state.showStory ? _react2.default.createElement(
	                'div',
	                { style: { color: 'black', width: '85%', height: .3375 * this.props.regionWidth, display: "block", marginLeft: "auto", marginRight: "auto" } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'helem', style: { position: "relative", paddingTop: .0225 * this.props.regionWidth } },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [1, 1, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [1, 1, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [2, 2, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [2, 2, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [3, 3, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [3, 3, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [4, 4, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [4, 4, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [5, 5, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [5, 5, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [6, 6, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [6, 6, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [7, 7, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [7, 7, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [8, 8, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [8, 8, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [9, 9, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [9, 9, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [0, 0, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [0, 0, null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [this.deleteText, this.deleteText, this.deleteText], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['DELETE', 'DELETE', 'DELETE'] }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['q', 'Q', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['q', 'Q', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['w', 'W', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['w', 'W', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['e', 'E', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['e', 'E', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['r', 'R', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['r', 'R', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['t', 'T', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['t', 'T', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['y', 'Y', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['y', 'Y', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['u', 'U', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['u', 'U', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['i', 'I', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['i', 'I', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['o', 'O', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['o', 'O', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['p', 'P', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['p', 'P', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['@', null, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['@', '@', null] }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['a', 'A', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['a', 'A', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['s', 'S', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['s', 'S', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['d', 'D', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['d', 'D', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['f', 'F', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['f', 'F', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['g', 'G', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['g', 'G', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['h', 'H', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['h', 'H', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['j', 'J', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['j', 'J', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['k', 'K', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['k', 'K', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['l', 'L', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['l', 'L', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['_', '_', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['_', '_', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['&', '&', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['&', '&', null] }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['z', 'Z', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['z', 'Z', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['x', 'X', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['x', 'X', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['c', 'C', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['c', 'C', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['v', 'V', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['v', 'V', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['b', 'B', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['b', 'B', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['n', 'N', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['n', 'N', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['m', 'M', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['m', 'M', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['.', '.', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['.', '.', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['-', '-', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['-', '-', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['*', '*', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['*', '*', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['?', '?', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['?', '?', null] }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                      'div',
	                      { style: keystd },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'kspn-seattle' },
	                        '=/#'
	                      )
	                    ),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [this.capitalMode, this.normalMode, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['UPCASE', 'DOWNCASE', null] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: [' ', ' ', ' '], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keyspace, contents: ['Space', 'Space', 'Space'] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { keyval: ['.com', '.com', '.com'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keycom, contents: ['.com', '.com', '.com'] }),
	                    _react2.default.createElement(_KeyboardKeySeattle2.default, { searchStr: this.searchStr, keyval: ['Submit', 'Submit', 'Submit'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.submitText, mainstyle: keysubmit, contents: ['Submit', 'Submit', 'Submit'] })
	                  )
	                )
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'containerFade',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.search, style: { position: "absolute", width: "90%", marginLeft: "auto", marginRight: "auto", height: .27225 * this.props.regionWidth, touchAction: "none", top: 0.017 * this.props.regionWidth } },
	              this.state.search && !this.state.showStory ? _react2.default.createElement(
	                _reactIscroll2.default,
	                { ref: function ref(el) {
	                    return _this4.iScroller = el;
	                  }, iScroll: _iscroll2.default,
	                  options: {
	                    mouseWheel: true,
	                    scrollbars: false,
	                    scrollX: false,
	                    scrollY: true,
	                    probeType: 2,
	                    bounce: false,
	                    momentum: true,
	                    deceleration: 0.015,
	                    useTransition: true,
	                    disableTouch: false,
	                    disablePointer: false,
	                    disableMouse: false,
	                    tap: true
	                  },
	                  onRefresh: this.initializeIScroll
	                },
	                _react2.default.createElement(
	                  'div',
	                  { style: { position: "relative" } },
	                  this.state.renderedStories && this.state.renderedStories.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { style: { height: this.props.regionWidth * 0.0347 } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { marginLeft: this.props.regionWidth * 0.046875, fontSize: this.props.regionWidth * 0.015625 } },
	                      'STORIES'
	                    ),
	                    _react2.default.createElement('div', { style: { position: "absolute", height: this.props.regionWidth * 0.0017, background: "white", width: "90%", left: this.props.regionWidth * 0.039 } })
	                  ) : null,
	                  this.state.renderedStories && this.state.renderedStories.length > 0 ? this.state.renderedStories : null,
	                  this.state.renderedStories && this.state.renderedStories.length > 0 && this.state.renderedDonors && this.state.renderedDonors.length > 0 ? _react2.default.createElement('div', { style: { width: "100%", height: this.props.regionWidth * 0.034 } }) : null,
	                  this.state.renderedDonors && this.state.renderedDonors.length > 0 ? _react2.default.createElement(
	                    'div',
	                    { style: { height: this.props.regionWidth * 0.0347 } },
	                    _react2.default.createElement(
	                      'span',
	                      { style: { marginLeft: this.props.regionWidth * 0.046875, fontSize: this.props.regionWidth * 0.015625 } },
	                      'DONOR LIST'
	                    ),
	                    _react2.default.createElement('div', { style: { position: "absolute", height: this.props.regionWidth * 0.0017, background: "white", width: "90%", left: this.props.regionWidth * 0.039 } })
	                  ) : null,
	                  this.state.renderedDonors && this.state.renderedDonors.length > 0 ? this.state.renderedDonors : null,
	                  !hasMatchedResults ? _react2.default.createElement(
	                    'div',
	                    { style: { width: "100%", height: "100%", textAlign: "center", marginTop: this.props.regionWidth * .021, paddingLeft: this.props.regionWidth * .013 } },
	                    'Sorry, no results matching ',
	                    _react2.default.createElement('br', null),
	                    ' "',
	                    '<' + this.state.text + '>',
	                    '"',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('img', { onClick: function onClick() {
	                        return _this4.removeInputText();
	                      }, src: '/img/seattle/general/search.png', style: { width: this.props.regionWidth * .086 }, alt: '' })
	                  ) : null,
	                  _react2.default.createElement('div', { style: { height: .03375 * this.props.regionWidth } })
	                )
	              ) : null
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          this.state.showStory ? _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", left: 0, width: "100%", height: .52 * this.props.regionWidth } },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_StorySeattle2.default, {
	                item: this.state.story,
	                screen: this.props.screen,
	                regionWidth: this.props.regionWidth,
	                handleSwipeAnimation: this.props.handleSwipeAnimation,
	                cancelSwipeAnimation: this.props.cancelSwipeAnimation
	              }),
	              _react2.default.createElement('img', { ref: function ref(reactComponent) {
	                  return _this4._backButtonRef = reactComponent;
	                }, src: backButton, style: { position: "absolute", left: 0, top: .45138888888888888889 * this.props.regionWidth, width: 0.050625 * this.props.regionWidth }, alt: '' })
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return UserInputSeattle;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screen: state.screen,
	    content: state.content,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(UserInputSeattle);

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var VideoSeattle = function (_Component) {
	  _inherits(VideoSeattle, _Component);
	
	  function VideoSeattle(props) {
	    _classCallCheck(this, VideoSeattle);
	
	    var _this = _possibleConstructorReturn(this, (VideoSeattle.__proto__ || Object.getPrototypeOf(VideoSeattle)).call(this, props));
	
	    _this.intervalCheckSwipeAnimation = function () {
	      if (!_this._contentRef) {
	        setTimeout(function () {
	          _this.intervalCheckSwipeAnimation();
	        }, 100);
	      } else {
	        _this.checkSwipeAnimation();
	      }
	    };
	
	    _this.checkSwipeAnimation = function () {
	      var scrollWrapperHeight = 0.14625 * _this.props.regionWidth;
	      var contentHeight = _this._textContentRef.getBoundingClientRect().height;
	      _this.props.handleSwipeAnimation(scrollWrapperHeight, contentHeight);
	    };
	
	    _this.handleScrollStart = function () {
	      _this.props.cancelSwipeAnimation();
	    };
	
	    _this.initPlayer = function () {
	      _this._videoRef.addEventListener('loadedmetadata', _this.loadedMetadata);
	      _this._videoRef.addEventListener('loadeddata', _this.loadedData);
	      _this._videoRef.addEventListener('ended', _this.videoEnded);
	    };
	
	    _this.handleVideoPlay = function () {
	      if (_this.state.paused) {
	        _this._videoRef.play();
	      } else {
	        _this._videoRef.pause();
	      }
	      _this.setState({
	        paused: !_this.state.paused
	      });
	    };
	
	    _this.loadedMetadata = function () {
	      _this._metadataLoaded = true;
	      _this.checkIfAllDataLoaded();
	    };
	
	    _this.loadedData = function () {
	      _this._dataLoaded = true;
	      _this.checkIfAllDataLoaded();
	    };
	
	    _this.videoEnded = function () {
	      _this.setState({
	        paused: true
	      });
	    };
	
	    _this.checkIfAllDataLoaded = function () {
	      if (_this._metadataLoaded && _this._dataLoaded) {
	        _this.positionVideo();
	        _this._playerInitialized = true;
	        _this.setState({
	          showVideo: 1
	        });
	      }
	    };
	
	    _this.positionVideo = function () {
	      if (!_this._videoRef) {
	        setTimeout(function () {
	          _this.positionVideo();
	        }, 100);
	        return;
	      }
	
	      var videoHeight = _this._videoRef.getBoundingClientRect().height;
	      var videoWidth = _this._videoRef.getBoundingClientRect().width;
	      var videoOffsetX = (_this._contentRef.getBoundingClientRect().width - videoWidth) / 2;
	
	      _this.setState({
	        videoHeight: videoHeight,
	        videoWidth: videoWidth,
	        videoOffsetX: videoOffsetX
	      });
	    };
	
	    _this._imagesStatus = [];
	    _this._contentRef = null;
	    _this._textContentRef = null;
	    _this._videoOverlay = null;
	    _this._videoRef = null;
	    _this._playerInitialized = false;
	
	    _this.state = {
	      videoOffsetY: 0,
	      videoOffsetX: 0,
	      showVideo: 0,
	      paused: true
	    };
	    return _this;
	  }
	
	  _createClass(VideoSeattle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.intervalCheckSwipeAnimation();
	      this.initPlayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this._playerInitialized) {
	        var videoHeight = this._videoRef.getBoundingClientRect().height;
	        var videoWidth = this._videoRef.getBoundingClientRect().width;
	
	        this.setState({
	          videoHeight: videoHeight,
	          videoWidth: videoWidth
	        });
	        this._playerInitialized = false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _videoStyle = {
	        preload: 'auto',
	        position: 'absolute',
	        maxWidth: '80%',
	        maxHeight: '70%',
	        muted: ""
	      };
	
	      if (this.props.screensNumber === 2) {
	        _videoStyle.maxWidth = '40%';
	      }
	
	      var cType = _shared2.default.videoType(this.props.item.contents.images[0].file_name);
	      var videoSrc = _shared2.default.dp(this.props.screen, this.props.item.contents.images[0]);
	      var showVideo = this.state.showVideo ? 1 : 0;
	      var showPlayButton = this.state.paused && this.state.showVideo ? 1 : 0;
	      var textOps = _lodash2.default.get(this.props.item.contents, 'custom_fields.body.val.ops', {});
	      var converter = new QuillDeltaToHtmlConverter(textOps, {});
	      var richText = converter.convert();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(el) {
	            return _this2._contentRef = el;
	          }, style: { position: "absolute", display: "table", height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: "table-cell", verticalAlign: "middle" } },
	          _react2.default.createElement(
	            'div',
	            { style: { width: "100%", alignItems: "center", display: "flex", justifyContent: "center", textAlign: "center", minHeight: .027 * this.props.regionWidth, maxHeight: .10 * this.props.regionWidth, overflow: "hidden", marginBottom: 0.015625 * this.props.regionWidth } },
	            _react2.default.createElement(
	              'span',
	              { className: 'noselect', style: { fontSize: 0.016875 * this.props.regionWidth, width: "65%" } },
	              _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.props.item.name.toUpperCase() })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { height: this.state.videoHeight } },
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                className: 'slowfadedelay',
	                style: { minHeight: '100%' },
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { className: 'seattle-video' },
	                _react2.default.createElement(
	                  'video',
	                  { className: 'videopills', style: Object.assign({}, _videoStyle, { left: this.state.videoOffsetX, opacity: showVideo }), ref: function ref(el) {
	                      return _this2._videoRef = el;
	                    } },
	                  _react2.default.createElement('source', { src: videoSrc, type: cType }),
	                  'Your browser does not support the video tag.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { onClick: function onClick() {
	                      return _this2.handleVideoPlay();
	                    }, ref: function ref(el) {
	                      return _this2._videoOverlay = el;
	                    }, style: { position: "absolute", width: this.state.videoWidth, height: this.state.videoHeight, left: this.state.videoOffsetX, display: "flex", justifyContent: "center", alignItems: "center", opacity: showPlayButton } },
	                  _react2.default.createElement('img', { src: '/img/ui/play.png', style: { width: 0.1041 * this.props.regionWidth, height: 0.1041 * this.props.regionWidth }, alt: '' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'gradient', style: { position: "relative", height: 0.14625 * this.props.regionWidth, width: "100%", touchAction: "none", marginTop: .009 * this.props.regionWidth } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this2.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                onScrollStart: this.handleScrollStart,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.015,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { style: { position: "relative", display: "flex", justifyContent: "center" }, ref: function ref(el) {
	                    return _this2._textContentRef = el;
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { width: 0.30375 * this.props.regionWidth, display: "flex" } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { fontSize: 0.01125 * this.props.regionWidth, textAlign: "left", lineHeight: 0.0225 * this.props.regionWidth + "px", color: "white" } },
	                    _react2.default.createElement('div', { className: 'ql-editor noselect', dangerouslySetInnerHTML: { __html: richText } }),
	                    '\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VideoSeattle;
	}(_react.Component);
	
	exports.default = VideoSeattle;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _QuoteTampa = __webpack_require__(491);
	
	var _QuoteTampa2 = _interopRequireDefault(_QuoteTampa);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _start = __webpack_require__(788);
	
	var _start2 = _interopRequireDefault(_start);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttractLoopTampa = function (_Component) {
	  _inherits(AttractLoopTampa, _Component);
	
	  function AttractLoopTampa(props) {
	    _classCallCheck(this, AttractLoopTampa);
	
	    var _this = _possibleConstructorReturn(this, (AttractLoopTampa.__proto__ || Object.getPrototypeOf(AttractLoopTampa)).call(this, props));
	
	    _this.startButtonAnimationLoop = function () {
	      clearTimeout(_this._startButtonTimeout);
	      _this._startButtonTimeout = setTimeout(function () {
	        if (_this._startButtonRef) {
	          _this._startButtonRef.animate([{
	            transform: "scale(1)"
	          }, {
	            transform: "scale(1.1)"
	          }, {
	            transform: "scale(1)"
	          }], {
	            fill: "forwards",
	            duration: 750
	          });
	        }
	        _this.startButtonAnimationLoop();
	      }, 6000);
	    };
	
	    _this.getRenderedModules = function () {
	      var renderedModules = null;
	      if (_this.props.tree !== undefined && _this.props.tree !== null) {
	        renderedModules = _this.props.tree.children.map(function (mod, i) {
	          _this._keys[i] = mod.id;
	          return _react2.default.createElement(_QuoteTampa2.default, { key: i, story: mod, useBackground: false, screen: _this.props.screen });
	        });
	      }
	
	      return renderedModules;
	    };
	
	    _this.getBackground = function (displayImage) {
	      if (displayImage) {
	        return _shared2.default.dp(_this.props.screen, displayImage, null);
	      }
	      return null;
	    };
	
	    _this._background = null;
	    _this._startButtonRef = null;
	    _this._keys = [];
	    return _this;
	  }
	
	  _createClass(AttractLoopTampa, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.startButtonAnimationLoop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      try {
	        var renderedModules = this.getRenderedModules();
	        return _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundColor: "white" } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              transitionName: 'fastfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this._keys[this.props.attractLoopRef], style: { position: "absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight } },
	              renderedModules[this.props.attractLoopRef]
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", bottom: .01302083333333333333 * this.props.screen.screenHeight, display: "flex", justifyContent: "center", width: "100%" } },
	              _react2.default.createElement('img', { src: _start2.default, ref: function ref(el) {
	                  return _this2._startButtonRef = el;
	                }, alt: 'startIcon', style: { width: .09765625 * this.props.screen.screenHeight, height: .09765625 * this.props.screen.screenHeight } })
	            )
	          )
	        );
	      } catch (e) {
	        console.log(e);
	        return _react2.default.createElement('span', null);
	      }
	    }
	  }]);
	
	  return AttractLoopTampa;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    screen: state.screen
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(AttractLoopTampa);

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _ScrollSpacer = __webpack_require__(492);
	
	var _ScrollSpacer2 = _interopRequireDefault(_ScrollSpacer);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _DonorFullPage = __webpack_require__(65);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	var _util = __webpack_require__(143);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _donorHelpers2 = _interopRequireDefault(_donorHelpers);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import donorDataCategories from '../../../test/donorDataCategories';
	
	// import DonorFullPage from '../../Donor/DonorFullPage';
	
	
	var DonorLists = function (_Component) {
	  _inherits(DonorLists, _Component);
	
	  function DonorLists(props) {
	    _classCallCheck(this, DonorLists);
	
	    var _this = _possibleConstructorReturn(this, (DonorLists.__proto__ || Object.getPrototypeOf(DonorLists)).call(this, props));
	    //defaults
	
	
	    _this.getBackgroundImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	      var backgroundObj = _lodash2.default.get(_this.props.module, 'contents.images[0]', null);
	      return (0, _shared.dp)(_this.props.screen, backgroundObj, defaultImg);
	    };
	
	    _this.getIconImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	      var iconObj = _lodash2.default.get(_this.props.module, 'contents.images[2]', null);
	      return (0, _shared.dp)(_this.props.screen, iconObj, defaultImg);
	    };
	
	    _this.renderCategories = function () {
	      var columns = _this._columns;
	      if ((0, _util.isNull)(_this._donorCategories)) {
	        var categoryWrapStyle = {
	          boxSizing: 'border-box',
	          width: _this.props.screen.screenWidth * 0.78838174273858921162,
	          background: "white",
	          // height: this.props.screen.r9_16.height * .5,
	          paddingBottom: _this.props.screen.screenHeight * 0.01875,
	          paddingTop: _this.props.screen.screenHeight * 0.02893518518518518519,
	          borderRadius: 10,
	          paddingLeft: _this.props.screen.screenWidth * 0.074074074,
	          paddingRight: _this.props.screen.screenWidth * 0.074074074,
	          marginBottom: _this.props.screen.screenHeight * 0.03125
	        };
	
	        var donorCategories = _this.props.module.children[_this.state.donorGroup].children;
	        var enablePalqueText = _lodash2.default.get(_this.props.module.children[_this.state.donorGroup], 'contents.custom_fields.enable_palque_text.val', false);
	        if (enablePalqueText) {
	          columns = 1;
	        }
	        _this._donorCategories = donorCategories.map(function (row, i) {
	          var donors = _donorHelpers2.default.getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, row.id);
	          var sortedDonors = _lodash2.default.orderBy(donors, ['sorting_name'], ['asc']);
	          var donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - this.props.screen.screenWidth * 0.074074074 * 2;
	          // let height = (Math.ceil(donors.length / this._columns) * this.props.screen.screenHeight * 0.115 / this._rows) + (this.props.screen.screenHeight * 0.021875) + categoryWrapStyle.paddingTop * 2 + categoryWrapStyle.paddingBottom * 2;
	
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { display: "flex", alignItems: "center" } },
	            _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, categoryWrapStyle), className: 'opensans-regular' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'opensans-semibold', style: { marginBottom: .00520833333333333333 * this.props.screen.screenHeight, color: "#694f28", fontSize: this.props.screen.screenHeight * 0.021875 } },
	                  row.name
	                ),
	                _react2.default.createElement('div', { style: { backgroundColor: "#694f28", height: .00260416666666666667 * this.props.screen.screenHeight, marginBottom: .01041666666666666667 * this.props.screen.screenHeight } })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_DonorFullPage2.default, {
	                  height: this.props.screen.screenHeight * 0.115,
	                  width: donorFullPageWidth,
	                  columns: columns,
	                  rows: this._rows,
	                  fontClass: this._fontclass,
	                  donorData: sortedDonors,
	                  screen: this.props.screen,
	                  sort: 'column',
	                  overrideFontSize: 0,
	                  overrideMarginRight: 0,
	                  text1: enablePalqueText,
	                  custom1x2: '<span />' })
	              )
	            )
	          );
	        }, _this);
	      }
	    };
	
	    _this._subscribeModule = null;
	    _this._rowWrapperRef = null;
	    // this.getSubscribeModule();
	
	    _this._columns = 2;
	    _this._rows = 6;
	    _this._fontColor = "#ffffff";
	    _this._backdropColor = "#000000";
	    _this._footerText = "";
	    _this._parentCategoryName = ""; //used to stash name so state can switch to empty string
	    _this._ni_options = {};
	    _this._metaCycleTimeout = null;
	    _this._listCycleTime = 8000;
	    _this._marginRight = _this.props.screen.sv.width * 0.0375;
	    _this._fontClass = 'gfont_roboto';
	    _this._donorCategories = null;
	    _this._recognitionOptionsRef = null;
	    _this._groupSwitched = false;
	
	    _this._donorGroups = _lodash2.default.filter(_this.props.donors.donorCategories, { parent_category: Number(_this.props.module.contents.donor_view_category) });
	
	    // _.forEach(this._donorGroups, group => {
	    //   group.donorCategories = _.filter(this.props.donors.donorCategories, { parent_category: group.id });
	    // })
	
	    _this.state = {
	      donorGroup: 0
	    };
	    return _this;
	  }
	
	  _createClass(DonorLists, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.renderCategories();
	      var recogWidth = this._recognitionOptionsRef.getBoundingClientRect().width;
	      this.setState({
	        recognitionOffsetX: (this.props.screen.screenWidth - recogWidth) / 2
	      });
	
	      if (this._rowWrapperRef) {
	        this._rowWrapperRef.addEventListener("tap", function () {
	          return _this2.redirect();
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this3 = this;
	
	      this._groupSwitched = false;
	      setTimeout(function () {
	        if (_this3.iScroller) {
	          _this3.iScroller._iScrollInstance.refresh();
	        }
	      }, 500);
	    }
	  }, {
	    key: 'switchDonorGroup',
	    value: function switchDonorGroup(groupRef) {
	      this._groupSwitched = true;
	      this.setState({
	        donorGroup: groupRef
	      });
	      this._donorCategories = null;
	    }
	  }, {
	    key: 'renderGroupInputs',
	    value: function renderGroupInputs() {
	      var _this4 = this;
	
	      var recognitionOptions = {
	        // marginTop: this.props.screen.screenHeight * 0.02604166666666666667
	      };
	
	      var recognitionOptionsLabel = {
	        width: this.props.screen.screenWidth * 0.18518518518518518519,
	        fontSize: this.props.screen.screenWidth * 0.016666667
	      };
	
	      switch (this.props.module.children.length) {
	        case 1:
	          return _react2.default.createElement(
	            'div',
	            { style: { display: "flex", alignItems: "center", justifyContent: "center", height: "5vh" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'recognitionOptionsTampa', style: Object.assign({}, recognitionOptions), ref: function ref(recognitionOptionsRef) {
	                  return _this4._recognitionOptionsRef = recognitionOptionsRef;
	                } },
	              _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(0);
	                  }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[0].name.toUpperCase()
	              )
	            )
	          );
	        case 2:
	          return _react2.default.createElement(
	            'div',
	            { style: { display: "flex", alignItems: "center", justifyContent: "center", height: "5vh" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'recognitionOptionsTampa', style: Object.assign({}, recognitionOptions), ref: function ref(recognitionOptionsRef) {
	                  return _this4._recognitionOptionsRef = recognitionOptionsRef;
	                } },
	              _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(0);
	                  }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[0].name.toUpperCase()
	              ),
	              _react2.default.createElement('input', { id: 'switch_right', name: 'donorOptions', type: 'radio', value: 'campaign_donors' }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(1);
	                  }, htmlFor: 'switch_right', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[1].name.toUpperCase()
	              )
	            )
	          );
	        case 3:
	          return _react2.default.createElement(
	            'div',
	            { style: { display: "flex", alignItems: "center", justifyContent: "center", height: "5vh" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'recognitionOptionsTampa', style: Object.assign({}, recognitionOptions), ref: function ref(recognitionOptionsRef) {
	                  return _this4._recognitionOptionsRef = recognitionOptionsRef;
	                } },
	              _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(0);
	                  }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[0].name.toUpperCase()
	              ),
	              _react2.default.createElement('input', { id: 'switch_middle', name: 'donorOptions', type: 'radio', value: 'middle_donors' }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(1);
	                  }, htmlFor: 'switch_middle', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[1].name.toUpperCase()
	              ),
	              _react2.default.createElement('input', { id: 'switch_right', name: 'donorOptions', type: 'radio', value: 'campaign_donors' }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(2);
	                  }, htmlFor: 'switch_right', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[2].name.toUpperCase()
	              )
	            )
	          );
	        case 4:
	          return _react2.default.createElement(
	            'div',
	            { style: { display: "flex", alignItems: "center", justifyContent: "center", height: "5vh" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'recognitionOptionsTampa', style: Object.assign({}, recognitionOptions), ref: function ref(recognitionOptionsRef) {
	                  return _this4._recognitionOptionsRef = recognitionOptionsRef;
	                } },
	              _react2.default.createElement('input', { id: 'switch_left', name: 'donorOptions', type: 'radio', value: 'cumulative_donors', defaultChecked: true }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(0);
	                  }, htmlFor: 'switch_left', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[0].name.toUpperCase()
	              ),
	              _react2.default.createElement('input', { id: 'swit ch_middle', name: 'donorOptions', type: 'radio', value: 'middle_donors' }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(1);
	                  }, htmlFor: 'switch_middle', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[1].name.toUpperCase()
	              ),
	              _react2.default.createElement('input', { id: 'switch_middle1', name: 'donorOptions', type: 'radio', value: 'middle_donors' }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(2);
	                  }, htmlFor: 'switch_middle1', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[2].name.toUpperCase()
	              ),
	              _react2.default.createElement('input', { id: 'switch_right', name: 'donorOptions', type: 'radio', value: 'campaign_donors' }),
	              _react2.default.createElement(
	                'label',
	                { onClick: function onClick() {
	                    return _this4.switchDonorGroup(3);
	                  }, htmlFor: 'switch_right', style: Object.assign({}, recognitionOptionsLabel) },
	                this.props.module.children[3].name.toUpperCase()
	              )
	            )
	          );
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var background = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
	      var textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
	      var textShadow = textShadowSize + 'px ' + textShadowSize + 'px ' + textShadowSize + 'px black';
	
	      if ((0, _util.isNull)(this._donorCategories)) {
	        this.renderCategories();
	      }
	      var unit = this.props.screen.r9_16.p10;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: backgroundSize, backgroundImage: "url(" + background + ")" } },
	          _react2.default.createElement(
	            'div',
	            { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	            _react2.default.createElement('div', { style: { height: "5vw" } }),
	            _react2.default.createElement('img', { alt: 'Donor Recognition', src: iconImage, style: { width: '14vh' } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'crimson-semi-bold', style: { textShadow: textShadow, textAlign: "center", fontSize: '4vh', fontWeight: "bold" } },
	            this.props.module.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'crimson-regular', style: { textShadow: textShadow, fontSize: '2vh', textAlign: "center", paddingRight: "1vh", paddingLeft: "1vh", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" } },
	            this.props.module.description
	          ),
	          _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: unit * .25, top: "26.979166667vh" } }),
	          _react2.default.createElement('div', { style: { height: this.props.screen.screenWidth * .15934065934065934066 } }),
	          _react2.default.createElement(
	            'div',
	            { style: { color: 'black', width: '85%', marginLeft: "auto", marginRight: "auto", touchAction: "none", height: "72.91666666666666666667vh" } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { key: this.state.groupRef, ref: function ref(el) {
	                  return _this5.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.005,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                },
	                onRefresh: this.initializeIScroll
	              },
	              _react2.default.createElement(
	                'div',
	                { style: { width: "100%", display: "flex", justifyContent: "center" } },
	                _react2.default.createElement(
	                  _CSSTransitionGroup2.default,
	                  {
	                    component: 'div',
	                    transitionName: 'example',
	                    transitionEnterTimeout: 0,
	                    transitionLeaveTimeout: 0 },
	                  _react2.default.createElement('div', { style: { height: "3vh" } }),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    this.renderGroupInputs()
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { key: this.state.donorGroup },
	                    _react2.default.createElement('div', { style: { height: "2.5vh" } }),
	                    this._donorCategories,
	                    _react2.default.createElement(_ScrollSpacer2.default, { unit: unit })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DonorLists;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	  return {
	    content: state.content,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DonorLists);

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyboardKey = function (_Component) {
	  _inherits(KeyboardKey, _Component);
	
	  function KeyboardKey(props) {
	    _classCallCheck(this, KeyboardKey);
	
	    var _this = _possibleConstructorReturn(this, (KeyboardKey.__proto__ || Object.getPrototypeOf(KeyboardKey)).call(this, props));
	
	    _this.state = {
	      pressed: false,
	      canpress: true
	    };
	    return _this;
	  }
	
	  _createClass(KeyboardKey, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'handlePress',
	    value: function handlePress() {
	      var _this2 = this;
	
	      if (this.state.canpress === true) {
	        this.props.handleKeyPress(this.props.keyval[this.props.virtual_keyboard_mode]);
	        this.setState({
	          pressed: true,
	          canpress: false
	        });
	        this.timeout = setTimeout(function () {
	          _this2.setState({
	            pressed: false,
	            canpress: true
	          });
	          _this2.timeout = null;
	        }, 125);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var classes = "pressin keyopacity";
	      if (this.state.pressed === true) {
	        classes += " active";
	      }
	      if (this.props.contents[this.props.virtual_keyboard_mode] === null) {
	        classes += " keyhide";
	        return (
	          // <div style={{display: 'hidden'}}><div style={this.props.mainstyle[1]} className={classes}><span className="kspn">&nbsp;</span></div></div>
	          _react2.default.createElement(
	            'div',
	            { style: this.props.mainstyle, className: classes },
	            _react2.default.createElement(
	              'span',
	              { className: 'kspn-tampa' },
	              '\xA0'
	            )
	          )
	        );
	      }
	      classes += " phand";
	      var innercontent = void 0;
	      var spanClass = "kspn-tampa";
	      switch (this.props.contents[this.props.virtual_keyboard_mode]) {
	        case "UPCASE":
	          innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-up' }); //<Icon type="up-circle-o" />
	          break;
	        case "DOWNCASE":
	          innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-down' }); //<Icon type="down-circle-o" />
	          break;
	        case "DELETE":
	          innercontent = _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-left' }); //<Icon type="left" />
	          break;
	        case "Submit":
	          spanClass = "kspn";
	          classes += " primaryButton-tampa primaryButton-keyboardSearch";
	          innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	          break;
	        default:
	          innercontent = this.props.contents[this.props.virtual_keyboard_mode];
	          break;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { onMouseDown: function onMouseDown(e) {
	            return _this3.handlePress(e);
	          }, style: this.props.mainstyle, className: classes },
	        _react2.default.createElement(
	          'span',
	          { className: spanClass },
	          innercontent,
	          this.props.contents[this.props.virtual_keyboard_mode] === "Submit" ? _react2.default.createElement(
	            'div',
	            { style: { display: "inline-block" } },
	            '\xA0\xA0',
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-right' })
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return KeyboardKey;
	}(_react.Component);
	
	exports.default = KeyboardKey;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconMenu = __webpack_require__(786);
	
	var MenuButtonTampa = function (_Component) {
	  _inherits(MenuButtonTampa, _Component);
	
	  function MenuButtonTampa() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuButtonTampa);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuButtonTampa.__proto__ || Object.getPrototypeOf(MenuButtonTampa)).call.apply(_ref, [this].concat(args))), _this), _this.renderBackButton = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", marginLeft: '.3vh', top: 0, height: "2vh", width: "100%" } },
	          _react2.default.createElement(
	            'span',
	            { style: { position: "absolute", top: "0.5vh", fontSize: '.96vh', color: '#143e77', right: "1.15740740740740740741vw" } },
	            'MENU'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", marginLeft: '.3vh', marginTop: "0.5vh", top: "1.8vh", width: "100%", height: "2vh" } },
	          _react2.default.createElement('img', { className: 'fliph', alt: 'back', style: { position: "absolute", width: '2vh', height: '1.2vh', marginLeft: "0.208333333vh", right: "1.85185185185185185185vw" }, src: iconMenu })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuButtonTampa, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.mode === "video" ? _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left } },
	          this.renderBackButton()
	        ) : _react2.default.createElement(
	          'div',
	          { onMouseDown: function onMouseDown() {
	              return _this2.props.clickAction();
	            }, style: { position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border } },
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderBackButton()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MenuButtonTampa;
	}(_react.Component);
	
	exports.default = MenuButtonTampa;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DARK = "#71532c";
	
	var NavBlockTampa = function (_Component) {
	  _inherits(NavBlockTampa, _Component);
	
	  function NavBlockTampa() {
	    _classCallCheck(this, NavBlockTampa);
	
	    return _possibleConstructorReturn(this, (NavBlockTampa.__proto__ || Object.getPrototypeOf(NavBlockTampa)).apply(this, arguments));
	  }
	
	  _createClass(NavBlockTampa, [{
	    key: 'render',
	    value: function render() {
	      var widths = {
	        box: this.props.screen.screenHeight * .48068669527896995708
	      };
	      var heights = {
	        box: this.props.screen.screenHeight * .11587982832618025751
	      };
	      var sizes = {
	        title: this.props.screen.screenHeight * .02199074074074074074,
	        description: this.props.screen.screenHeight * .01388888888888888889
	      };
	      var margins = {
	        descriptionTop: this.props.screen.screenHeight * .00651041666666666667
	      };
	      var horizontalRadius = this.props.screen.screenHeight * .00520833333333333333;
	      var verticalRadius = this.props.screen.screenHeight * .00651041666666666667;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', justifyContent: 'center', width: '100%' } },
	        _react2.default.createElement(
	          'div',
	          { style: { width: widths.box, height: heights.box, borderRadius: this.props.screen.screenWidth * .02314814814814814815, backgroundColor: 'white', boxShadow: horizontalRadius + 'px ' + verticalRadius + 'px ' + verticalRadius + 'px 0px rgba(0,0,0,0.85)' } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: widths.box * .25, height: "100%", float: "left", display: "flex", alignItems: "center", justifyContent: "center" } },
	            _react2.default.createElement('img', { alt: 'Donor Stories', src: this.props.icon, style: { height: "7.291666667vh" } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: widths.box * .60, height: "100%", float: "left", display: "table" } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: "table-cell", verticalAlign: "middle" } },
	              _react2.default.createElement(
	                'div',
	                { style: { fontSize: sizes.title, float: "left", textAlign: "center", width: "100%", color: DARK }, className: 'crimson-semi-bold' },
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  this.props.title
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'opensans-regular', style: { fontSize: sizes.description, float: "left", maxHeight: "6vh", overflow: "hidden", textAlign: "center", width: "100%", marginTop: margins.descriptionTop, display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", color: DARK } },
	                this.props.description
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", width: widths.box * .15, height: "100%", float: "left", display: "flex", alignItems: "center", justifyContent: "center" } },
	            _react2.default.createElement('img', { alt: 'Forward', src: this.props.arrow, style: { height: "3vh" } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavBlockTampa;
	}(_react.Component);
	
	exports.default = NavBlockTampa;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavBlockTampa = __webpack_require__(489);
	
	var _NavBlockTampa2 = _interopRequireDefault(_NavBlockTampa);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavTampa = function (_Component) {
	  _inherits(NavTampa, _Component);
	
	  function NavTampa(props) {
	    _classCallCheck(this, NavTampa);
	
	    var _this = _possibleConstructorReturn(this, (NavTampa.__proto__ || Object.getPrototypeOf(NavTampa)).call(this, props));
	
	    _this.handleNav = function (route) {
	      _this.props.navRoute(route.navLocation, route.module);
	    };
	
	    _this.initializeNavRefs = function () {
	      if (_this.state.initializedRefs === false) {
	        var _loop = function _loop(a) {
	          _this.navRefs[a].el.addEventListener("tap", function () {
	            return _this.handleNav(_this.navRefs[a].data);
	          });
	        };
	
	        for (var a = 0; a < _this.navRefs.length; a++) {
	          _loop(a);
	        }
	        _this.setState({
	          initializedRefs: true
	        });
	      }
	    };
	
	    _this.initializeAssets = function () {
	      var menuFolder = _this.props.content.story_categories.find(function (folder) {
	        var folderType = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        if (folderType !== null) {
	          return folder.parent_category === Number(_this.props.content.settings.selected_root_folder) && folderType === "menu";
	        }
	
	        return false;
	      });
	      var backgroundImage = _lodash2.default.get(menuFolder.contents, 'images[0]', null);
	      var logoImage = _lodash2.default.get(menuFolder.contents, 'images[1]', null);
	      var arrowImage = _lodash2.default.get(menuFolder.contents, 'images[2]', null);
	
	      var defaultBackground = { path: '/img/miami/general/', file_name: "default_single_screen.jpg" };
	      if (_this.props.screensNumber === 2) {
	        defaultBackground.file_name = 'default_double_screen.jpg';
	      }
	
	      _this._background = (0, _shared.dp)(_this.props.screen, backgroundImage, defaultBackground);
	      _this._arrow = (0, _shared.dp)(_this.props.screen, arrowImage);
	      _this._logo = (0, _shared.dp)(_this.props.screen, logoImage);
	    };
	
	    _this._menuModules = _lodash2.default.filter(_this.props.content.dm_active, { module_contents: { in_navigation: true } });
	
	    _this._background = null;
	    _this._arrow = null;
	    _this._logo = null;
	
	    _this.initializeAssets();
	
	    _this.state = {
	      initializedRefs: false
	    };
	    _this.navRefs = [];
	    return _this;
	  }
	
	  _createClass(NavTampa, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.toggleShowNav(false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var _loop2 = function _loop2(a) {
	        if (_this2.navRefs[a].el) {
	          _this2.navRefs[a].el.removeEventListener("tap", function () {
	            return _this2.handleNav(_this2.navRefs[a].data);
	          });
	        }
	      };
	
	      for (var a = 0; a < this.navRefs.length; a++) {
	        _loop2(a);
	      }
	      this.props.toggleShowNav(true);
	    }
	  }, {
	    key: 'prepareMenuNavigation',
	    value: function prepareMenuNavigation() {
	      var _this3 = this;
	
	      var location = [];
	      var menuFolder = this.props.content.story_categories.find(function (folder) {
	        var folderType = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        if (folderType !== null) {
	          return folder.parent_category === Number(_this3.props.content.settings.selected_root_folder) && folderType === "menu";
	        }
	        return false;
	      });
	
	      var menu = (0, _shared.createFolderTree)(this.props.content.story_categories, this.props.content.folder_modules, menuFolder, this.props.content.stories, this.props.content.dm_active, null, null);
	
	      return menu.map(function (row, i) {
	        var type = _lodash2.default.get(row, 'contents.custom_fields.folder_type.val.value', null);
	
	        switch (type) {
	          case 'donor_lists_wrapper':
	            location[i] = "/tampa/donor_lists";
	            break;
	          case 'donor_stories':
	            location[i] = "/tampa/stories";
	            break;
	          case 'timeline':
	            location[i] = "/tampa/timeline";
	            break;
	          case 'search':
	            location[i] = "/tampa/search";
	            break;
	          default:
	            break;
	        }
	
	        var description = _lodash2.default.get(row.contents, 'custom_fields.menu_description.val', null);
	        return _react2.default.createElement(
	          'div',
	          { key: i },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this3.navRefs[i] = { el: el, data: { navLocation: location[i], module: row } };
	              } },
	            _react2.default.createElement(_NavBlockTampa2.default, {
	              title: row.name,
	              description: description,
	              screen: _this3.props.screen,
	              containerWidth: _this3.props.screen.screenWidth / _this3.props.screensNumber,
	              icon: (0, _shared.dp)(_this3.props.screen, _lodash2.default.get(row, 'contents.images[1]', null)),
	              arrow: _this3._arrow })
	          ),
	          _react2.default.createElement('div', { style: { height: '1.71673819742489270386vh' } })
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { height: this.props.screen.r9_16.height, textAlign: 'center', width: '100%', backgroundSize: "cover", backgroundImage: "url(" + this._background + ")" } },
	        _react2.default.createElement('div', { style: { height: '5vh' } }),
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth / this.props.screensNumber } },
	          _react2.default.createElement('img', { alt: 'Logo', src: this._logo, style: { display: 'block', margin: 'auto', width: '39vh' } }),
	          _react2.default.createElement('div', { style: { height: '4vh' } }),
	          _react2.default.createElement(
	            'div',
	            { style: { width: this.props.screen.screenWidth, height: '125vw', touchAction: "none" } },
	            _react2.default.createElement(
	              _reactIscroll2.default,
	              { ref: function ref(el) {
	                  return _this4.iScroller = el;
	                }, iScroll: _iscroll2.default,
	                options: {
	                  mouseWheel: true,
	                  scrollbars: false,
	                  scrollX: false,
	                  scrollY: true,
	                  probeType: 2,
	                  bounce: false,
	                  momentum: true,
	                  deceleration: 0.015,
	                  useTransition: true,
	                  disableTouch: false,
	                  disablePointer: false,
	                  disableMouse: false,
	                  tap: true
	                },
	                onScrollStart: this.onScrollStart,
	                onRefresh: this.initializeNavRefs
	              },
	              _react2.default.createElement(
	                'div',
	                { style: { width: this.props.screen.screenWidth / this.props.screensNumber } },
	                this.prepareMenuNavigation()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavTampa;
	}(_react.Component);
	
	exports.default = NavTampa;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { connect } from 'react-redux';
	// import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
	
	
	var LIGHT = "#f7f1e6";
	var DARK_BACKGROUND = "#a6946c";
	var DARK = "#71532c";
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var QuoteTampa = function (_Component) {
	  _inherits(QuoteTampa, _Component);
	
	  function QuoteTampa() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, QuoteTampa);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuoteTampa.__proto__ || Object.getPrototypeOf(QuoteTampa)).call.apply(_ref, [this].concat(args))), _this), _this.getRenderedContent = function () {
	      var renderedContent = null;
	      var story = _this.props.story;
	      var quoteType = _lodash2.default.get(_this.props, 'story.contents.custom_fields.story_type.val.value', null);
	      var quoteOps = _lodash2.default.get(_this.props.story.contents, 'custom_fields.quote.val.ops', _lodash2.default.get(_this.props.story.contents, 'custom_fields.quote.default.ops', null));
	      var attributionOps = _lodash2.default.get(_this.props.story.contents, 'custom_fields.attribution.val.ops', _lodash2.default.get(_this.props.story.contents, 'custom_fields.attribution.default.ops', null));
	      var quotePrepend = _lodash2.default.get(_this.props.story.contents, 'custom_fields.quote.prepend', null);
	      var quoteAppend = _lodash2.default.get(_this.props.story.contents, 'custom_fields.quote.append', null);
	
	      if (quotePrepend || quoteAppend) {
	        quoteOps = _shared2.default.appendPrependQuillOps(quoteOps.slice(), quotePrepend, quoteAppend);
	      }
	
	      var attributionInstance = new QuillDeltaToHtmlConverter(attributionOps, {});
	      var quoteOpsInstance = new QuillDeltaToHtmlConverter(quoteOps, {});
	      var quoteOpsRichText = quoteOpsInstance.convert();
	      var attributionOpsRichText = attributionInstance.convert();
	
	      switch (quoteType) {
	        case 'message_ceo':
	          renderedContent = _this.getMessageFromCeo(quoteOpsRichText, attributionOpsRichText, story);
	          break;
	        case "quote_type_a":
	          renderedContent = _this.getRenderedQuoteTypeA(quoteOpsRichText, attributionOpsRichText, story);
	          break;
	        case "quote_type_b":
	          renderedContent = _this.getRenderedQuoteTypeB(quoteOpsRichText, attributionOpsRichText, story);
	          break;
	        case "quote_type_c":
	          renderedContent = _this.getRenderedQuoteTypeC(quoteOpsRichText, attributionOpsRichText, story);
	          break;
	        case "quote_type_d":
	          renderedContent = _this.getRenderedQuoteTypeD(quoteOpsRichText, attributionOpsRichText, story);
	          break;
	        default:
	          break;
	      }
	
	      return renderedContent;
	    }, _this.getMessageFromCeo = function () {
	      var screenWidth = _this.props.screen.screenWidth;
	      var pictureObj = _lodash2.default.get(_this.props.story.contents, 'images[0]', null);
	      var middlePictureObj = _lodash2.default.get(_this.props.story.contents, 'images[1]', null);
	      var bottomPictureObj = _lodash2.default.get(_this.props.story.contents, 'images[2]', null);
	      var salutationName = _lodash2.default.get(_this.props.story.contents, 'custom_fields.salutation_name.val', null);
	      var salutationTitle = _lodash2.default.get(_this.props.story.contents, 'custom_fields.salutation_title.val', null);
	      var pictureBackground = _this.getBackground(pictureObj);
	      var middlePictureBackground = _this.getBackground(middlePictureObj);
	      var bottomPictureBackground = _this.getBackground(bottomPictureObj);
	
	      // QuillJS Text
	      var bodySectionAOps = _lodash2.default.get(_this.props.story.contents, 'custom_fields.body_left.val.ops', _lodash2.default.get(_this.props.story.contents, 'custom_fields.body_left.default.ops', null));
	      // let bodySectionBOps = _.get(this.props.story.contents, 'custom_fields.body_right.val.ops', _.get(this.props.story.contents, 'custom_fields.body_right.default.ops', null));
	      // let greetingsOps = _.get(this.props.story.contents, 'custom_fields.greeting.val.ops', _.get(this.props.story.contents, 'custom_fields.greeting.default.ops', null));
	      var bodySectionARichText = new QuillDeltaToHtmlConverter(bodySectionAOps, {}).convert();
	      // let bodySectionBRichText = new QuillDeltaToHtmlConverter(bodySectionBOps, {}).convert();
	      // let greetingRichText = new QuillDeltaToHtmlConverter(greetingsOps, {}).convert();
	      var greeting = _lodash2.default.get(_this.props.story.contents, 'custom_fields.greeting.val', null);
	      var greetingColor = _lodash2.default.get(_this.props.story.contents, 'custom_fields.greeting_color.val', "#FFFFFF");
	      var bodyColor = _lodash2.default.get(_this.props.story.contents, 'custom_fields.body_color.val', "#FFFFFF");
	
	      var heights = {
	        pictureSection: screenWidth * .54907407407407407407,
	        emptySpace: screenWidth * .21018518518518518519,
	        bodySection: screenWidth * .78754578754578754579,
	        bodySectionB: screenWidth * .57407407407407407407,
	        innerBodySection: screenWidth * 0.53663003663003663004,
	        leftInnerBodySection: screenWidth * .54945054945054945055,
	        emptySpaceBottom: screenWidth * .23333333333333333333,
	        signature: screenWidth * .13425925925925925926
	      };
	      var widths = {
	        pictureSection: screenWidth * .49074074074074074074,
	        nameTitleSection: screenWidth * .50925925925925925926,
	        bodySection: screenWidth * .41666666666666666667,
	        innerBodySection: screenWidth * .85185185185185185185,
	        individualSection: screenWidth * .41666666666666666667
	      };
	      var tops = {
	        name: screenWidth * .22037037037037037037,
	        title: screenWidth * .26574074074074074074,
	        bodySection: screenWidth * .75925925925925925926,
	        bodySectionText: screenWidth * .21111111111111111111,
	        bodySectionTextRelative: screenWidth * .08611111111111111111,
	        greeting: screenWidth * .03086419753086419753,
	        signature: screenWidth * .09589041095890410959,
	        middlePictureSection: screenWidth * .54938271604938271605
	      };
	      var lefts = {
	        innerBodySection: screenWidth * .07407407407407407407,
	        bodySectionA: screenWidth * .07407407407407407407,
	        bodySectionB: screenWidth * .51481481481481481481,
	        nameTitle: screenWidth * .04351851851851851852,
	        individualBodySeparation: screenWidth * .02407407407407407407,
	        signature: screenWidth * .51481481481481481481
	      };
	      var sizes = {
	        name: screenWidth * .03935185185185185185,
	        title: screenWidth * .02407407407407407407,
	        lineHeight: screenWidth * .02057613168724279835,
	        signature: screenWidth * .01876931506849315068,
	        signatureName: screenWidth * .02054794520547945205,
	        signatureTitle: screenWidth * .01689497716894977169
	      };
	      var mainPictureSize = widths.pictureSection + 'px ' + heights.pictureSection + 'px';
	      var middlePictureSize = _this.props.screen.screenWidth + 'px ' + heights.emptySpace + 'px';
	      var bottomPictureSize = _this.props.screen.screenWidth + 'px ' + heights.emptySpaceBottom + 'px';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { style: { position: "absolute", height: heights.pictureSection, width: widths.pictureSection, backgroundSize: mainPictureSize, backgroundImage: 'url(' + pictureBackground + ')' } }),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", height: heights.pictureSection, width: widths.nameTitleSection, left: widths.pictureSection, backgroundColor: LIGHT } },
	          _react2.default.createElement(
	            'div',
	            { style: { color: DARK, top: tops.name, position: "absolute", left: lefts.nameTitle, fontFamily: "serif", fontWeight: "bolder", fontSize: sizes.name } },
	            _this.props.story.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { color: DARK, top: tops.title, position: "absolute", left: lefts.nameTitle, fontFamily: "serif", fontSize: sizes.title } },
	            _this.props.story.contents.headline
	          )
	        ),
	        _react2.default.createElement('div', { style: { position: "absolute", height: heights.emptySpace, width: "100%", backgroundSize: middlePictureSize, backgroundImage: 'url(' + middlePictureBackground + ')', top: tops.middlePictureSection } }),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", height: heights.bodySection, width: "100%", top: tops.bodySection, backgroundColor: LIGHT } },
	          _react2.default.createElement(
	            'div',
	            { className: 'gfont_zapfino p-without-margin ql-size-125px', style: { position: "relative", top: tops.greeting, width: "100%", color: greetingColor } },
	            greeting
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", top: 0, width: widths.innerBodySection, height: heights.innerBodySection, maxHeight: heights.innerBodySection, left: lefts.innerBodySection, color: bodyColor } },
	            _react2.default.createElement('div', { className: 'tampa-ceo-body', style: { WebkitColumnCount: 2, columnFill: "auto", position: "relative", color: DARK, textAlign: "left", lineHeight: sizes.lineHeight + "px", maxHeight: heights.leftInnerBodySection, overflow: "hidden" }, dangerouslySetInnerHTML: { __html: bodySectionARichText } }),
	            _react2.default.createElement(
	              'div',
	              { style: { float: "right", width: screenWidth * .41391941391941391941, textAlign: "left", marginTop: .003663003663003663 * _this.props.screen.screenWidth } },
	              _react2.default.createElement(
	                'strong',
	                { className: 'ql-font-crimson-semi-bold ql-size-30px' },
	                salutationName
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                { className: 'ql-font-crimson-regular ql-size-22px' },
	                salutationTitle
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { style: { position: "absolute", width: "100%", height: heights.emptySpaceBottom, backgroundSize: bottomPictureSize, backgroundImage: 'url(' + bottomPictureBackground + ')', bottom: 0 } })
	      );
	    }, _this.getRenderedQuoteTypeA = function (quote, attribution) {
	      var height = _this.props.screen.screenHeight / 3;
	      var quoteHeight = height / 3 * 2;
	      var attributionHeight = height / 3;
	      // let quoteFontColor = _.get(this.props.story, 'contents.custom_fields.quote_color.val', "#FFFFFF");
	      // let attributionFontColor = _.get(this.props.story, 'contents.custom_fields.attribution_color.val', "#FFFFFF");
	
	      var topBackgroundObj = _lodash2.default.get(_this.props.story, 'contents.images[0]', null);
	      var topBackgroundImage = _this.getBackground(topBackgroundObj);
	      var bottomBackgroundObj = _lodash2.default.get(_this.props.story, 'contents.images[1]', null);
	      var bottomBackgroundImage = _this.getBackground(bottomBackgroundObj);
	      var backgroundSize = _this.props.screen.screenWidth + 'px ' + height + 'px';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { style: { position: "absolute", top: 0, width: _this.props.screen.screenWidth, height: height, backgroundSize: backgroundSize, backgroundImage: 'url(' + topBackgroundImage + ')' } }),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: height, height: height, backgroundColor: LIGHT, display: "table", width: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", height: "100%", display: "table-cell", verticalAlign: "middle", marginLeft: "auto", marginRight: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: quoteHeight, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "80%", color: "#71532c" }, dangerouslySetInnerHTML: { __html: quote } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: attributionHeight, justifyContent: "center", width: "100%", display: "flex" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "85%", color: "#71532c" }, dangerouslySetInnerHTML: { __html: attribution } })
	            )
	          )
	        ),
	        _react2.default.createElement('div', { style: { position: "absolute", top: height * 2, width: _this.props.screen.screenWidth, height: height, backgroundSize: backgroundSize, backgroundImage: 'url(' + bottomBackgroundImage + ')' } })
	      );
	    }, _this.getRenderedQuoteTypeB = function (quote, attribution) {
	      var height = _this.props.screen.screenHeight / 3;
	      var bottomPicObj = _lodash2.default.get(_this.props.story, 'contents.images[0]', null);
	      var middlePicObj = _lodash2.default.get(_this.props.story, 'contents.images[1]', null);
	      var quoteHeight = height / 3 * 2;
	      var middlePicture = _this.getBackground(middlePicObj);
	      var middlePicSize = _this.props.screen.screenWidth + 'px ' + height + 'px';
	      var bottomPicture = _this.getBackground(bottomPicObj);
	      var bottomPicSize = _this.props.screen.screenWidth + 'px ' + height + 'px';
	      var attributionHeight = height / 3;
	      // let quoteFontColor = _.get(this.props.story, 'contents.custom_fields.quote_color.val', "#FFFFFF");
	      // let attributionFontColor = _.get(this.props.story, 'contents.custom_fields.attribution_color.val', "#FFFFFF");
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: 0, height: height, backgroundColor: DARK_BACKGROUND, display: "table", width: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", height: "100%", display: "table-cell", verticalAlign: "middle", marginLeft: "auto", marginRight: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: quoteHeight, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "80%", color: "#FFFFFF" }, dangerouslySetInnerHTML: { __html: quote } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: attributionHeight, justifyContent: "center", width: "100%", display: "flex" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "85%", color: "#FFFFFF" }, dangerouslySetInnerHTML: { __html: attribution } })
	            )
	          )
	        ),
	        _react2.default.createElement('div', { style: { position: "absolute", top: height, width: "100%", height: height, backgroundImage: 'url(' + middlePicture + ')', backgroundSize: middlePicSize } }),
	        _react2.default.createElement('div', { style: { position: "absolute", top: height * 2, width: "100%", height: height, backgroundImage: 'url(' + bottomPicture + ')', backgroundSize: bottomPicSize } })
	      );
	    }, _this.getRenderedQuoteTypeC = function (quote, attribution) {
	      var height = _this.props.screen.screenHeight / 3;
	      var middlePicObj = _lodash2.default.get(_this.props.story, 'contents.images[0]', null);
	      var quoteHeight = height / 3 * 2;
	      var middlePicture = _this.getBackground(middlePicObj);
	      var middlePicSize = _this.props.screen.screenWidth + 'px ' + height * 2 + 'px';
	      var attributionHeight = height / 3;
	      // let quoteFontColor = _.get(this.props.story, 'contents.custom_fields.quote_color.val', "#FFFFFF");
	      // let attributionFontColor = _.get(this.props.story, 'contents.custom_fields.attribution_color.val', "#FFFFFF");
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { style: { position: "absolute", top: 0, width: "100%", height: height * 2, backgroundImage: 'url(' + middlePicture + ')', backgroundSize: middlePicSize } }),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: height * 2, height: height, backgroundColor: LIGHT, display: "table", width: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", height: "100%", display: "table-cell", verticalAlign: "middle", marginLeft: "auto", marginRight: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: quoteHeight, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "80%", color: "#71532c" }, dangerouslySetInnerHTML: { __html: quote } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: attributionHeight, justifyContent: "center", width: "100%", display: "flex" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "85%", color: "#71532c" }, dangerouslySetInnerHTML: { __html: attribution } })
	            )
	          )
	        )
	      );
	    }, _this.getRenderedQuoteTypeD = function (quote, attribution) {
	      var height = _this.props.screen.screenHeight / 3;
	      var middlePicObj = _lodash2.default.get(_this.props.story, 'contents.images[0]', null);
	      var quoteHeight = height / 3 * 2;
	      var middlePicture = _this.getBackground(middlePicObj);
	      var middlePicSize = _this.props.screen.screenWidth + 'px ' + height * 2 + 'px';
	      var attributionHeight = height / 3;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { style: { position: "absolute", top: height, width: "100%", height: height * 2, backgroundImage: 'url(' + middlePicture + ')', backgroundSize: middlePicSize } }),
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", top: 0, height: height, backgroundColor: DARK_BACKGROUND, display: "table", width: "100%" } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "relative", height: "100%", display: "table-cell", verticalAlign: "middle", marginLeft: "auto", marginRight: "auto" } },
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: quoteHeight, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "80%", color: "#FFFFFF" }, dangerouslySetInnerHTML: { __html: quote } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { position: "relative", height: attributionHeight, justifyContent: "center", width: "100%", display: "flex" } },
	              _react2.default.createElement('div', { className: 'ql-editor', style: { position: "relative", textAlign: "center", overflow: "hidden", width: "85%", color: "#FFFFFF" }, dangerouslySetInnerHTML: { __html: attribution } })
	            )
	          )
	        )
	      );
	    }, _this.getBackground = function (displayImage) {
	      if (displayImage) {
	        return _shared2.default.dp(_this.props.screen, displayImage, null);
	      }
	      return null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(QuoteTampa, [{
	    key: 'render',
	    value: function render() {
	      try {
	        var content = this.getRenderedContent();
	        // let backgroundObj = _.get(this.props.story, 'contents.images[0]', null);
	        // let background = this.getBackground(backgroundObj);
	        // let backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
	
	        var style = {
	          display: "table",
	          height: this.props.screen.r9_16.height,
	          textAlign: 'center',
	          width: '100%'
	          // backgroundSize: backgroundSize, 
	          // backgroundImage: "url(" + background + ")"
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: style },
	          content
	        );
	      } catch (e) {
	        console.log(e);
	        return _react2.default.createElement('span', null);
	      }
	    }
	  }]);
	
	  return QuoteTampa;
	}(_react.Component);
	
	exports.default = QuoteTampa;

/***/ },
/* 492 */
63,
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StoryTampa = __webpack_require__(95);
	
	var _StoryTampa2 = _interopRequireDefault(_StoryTampa);
	
	var _BackButtonTampa = __webpack_require__(93);
	
	var _BackButtonTampa2 = _interopRequireDefault(_BackButtonTampa);
	
	var _ScrollSpacer = __webpack_require__(63);
	
	var _ScrollSpacer2 = _interopRequireDefault(_ScrollSpacer);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _InfoBlockTampa = __webpack_require__(94);
	
	var _InfoBlockTampa2 = _interopRequireDefault(_InfoBlockTampa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import RowButtonTampa from './RowButtonTampa';
	// import NavButtonTampa from './NavButtonTampa';
	
	// import Moment from 'react-moment';
	
	
	// const QuillDeltaToHtmlConverter = require('quill-delta-to-html');
	
	var StoriesTampa = function (_Component) {
	  _inherits(StoriesTampa, _Component);
	
	  function StoriesTampa(props) {
	    _classCallCheck(this, StoriesTampa);
	
	    var _this = _possibleConstructorReturn(this, (StoriesTampa.__proto__ || Object.getPrototypeOf(StoriesTampa)).call(this, props));
	
	    _this.initializeIScroll = function () {
	      if (_this.state.iScrollInitialized === false) {
	        var _loop = function _loop(id) {
	          _this.storyRefs[id].addEventListener("tap", function () {
	            return _this.handleTap(id);
	          });
	        };
	
	        for (var id in _this.storyRefs) {
	          _loop(id);
	        }
	
	        _this.setState({
	          iScrollInitialized: true
	        });
	      }
	    };
	
	    _this.handleTap = function (id) {
	      var story = _this.props.module.children.find(function (st) {
	        return st.folder_module_id === Number(id);
	      });
	
	      if (_this.state.showModal) {
	        _this.setState({
	          showModal: false
	        });
	
	        clearTimeout(_this._modalTimeout);
	        _this._modalTimeout = null;
	        _this._modalTimeout = setTimeout(function () {
	          _this.setState({
	            story: story,
	            showModal: true
	          });
	        }, 500);
	      } else {
	        _this.setState({
	          story: story,
	          showModal: true
	        });
	      }
	    };
	
	    _this.handleBack = function () {
	      _this.props.showNavButton(true);
	      _this.setState({
	        showModal: false
	      });
	    };
	
	    _this.renderStories = function () {
	      var storySets = [];
	      var setCount = 0;
	      var stories = _lodash2.default.sortBy(_this.props.module.children, function (s) {
	        return s.sorting_name.toLowerCase();
	      });
	      for (var i = 0; i < stories.length; i++) {
	        if (!storySets[setCount]) {
	          storySets[setCount] = [];
	        }
	        storySets[setCount].push(stories[i]);
	        if (stories.length - 1 === i && storySets[setCount].length === 1) {
	          storySets[setCount].push(null);
	        }
	        if ((i + 1) % 2 === 0 && i !== 0) {
	          setCount++;
	        }
	      }
	      return storySets.map(function (row, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: { marginBottom: _this.props.screen.screenHeight * .01953125, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around' } },
	          _this.renderRow(row, i)
	        );
	      });
	    };
	
	    _this.renderRow = function (row) {
	      if (row.length === 0) {
	        return null;
	      }
	      return row.map(function (innerrow, i) {
	        if (innerrow === null) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { display: "inline-block" } },
	            _react2.default.createElement('div', { style: { width: "15vh" } })
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: { display: 'inline-block' } },
	          _this.renderStory(innerrow, i)
	        );
	      });
	    };
	
	    _this.renderStory = function (row, i) {
	      var unit = _this.props.screen.r9_16.p10 / _this.props.screensNumber;
	      var backgroundObj = _lodash2.default.get(_this.props.menu, 'contents.images[0]', null);
	      var backgroundImage = (0, _shared.presetDp)(null, backgroundObj, _this.props.screen);
	      var mult = .8;
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(el) {
	            return _this.storyRefs[row.folder_module_id] = el;
	          }, style: { marginRight: unit * .175, display: 'inline-block' } },
	        _react2.default.createElement(_InfoBlockTampa2.default, {
	          imgsrc: (0, _shared.dp)(_this.props.screen, _lodash2.default.get(row, 'contents.images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' }),
	          imageHeight: unit * 2 * mult,
	          infoHeight: "4.6875vh",
	          width: "15vh",
	          unit: unit * mult,
	          text: row.name,
	          infoColor: "black",
	          infoBackgroundColor: 'white',
	          backgroundImage: backgroundImage,
	          fontFamily: 'opensans-regular',
	          fontSize: unit * 0.15
	        })
	      );
	    };
	
	    _this.renderBackButton = function () {
	      return _react2.default.createElement(_BackButtonTampa2.default, {
	        unit: _this.props.screen.r9_16.p10 / _this.props.screensNumber,
	        width: '3.90625vh',
	        height: '4.5vh',
	        top: '56.46875vh',
	        border: '0.84375vh',
	        clickAction: _this.handleBack,
	        text: 'back',
	        mode: _this._mode });
	    };
	
	    _this.getBackgroundImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	
	      if (_this.props.screensNumber === 2) {
	        defaultImg.file_name = 'default_double_screen.jpg';
	      }
	
	      try {
	        var backgroundObj = _lodash2.default.get(_this.props.module, 'contents.images[0]', null);
	        return (0, _shared.dp)(_this.props.screen, backgroundObj, defaultImg);
	      } catch (e) {
	        return (0, _shared.dp)(_this.props.screen, defaultImg);
	      }
	    };
	
	    _this.getIconImage = function () {
	      var iconObj = _lodash2.default.get(_this.props.module, 'contents.images[2]', null);
	      return (0, _shared.dp)(_this.props.screen, iconObj, null);
	    };
	
	    _this.getModalContent = function () {
	      var menuFolder = _this.props.content.story_categories.find(function (folder) {
	        var folderType = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        if (folderType !== null) {
	          return folder.parent_category === Number(_this.props.content.settings.selected_root_folder) && folderType === "menu";
	        }
	
	        return false;
	      });
	      var backgroundObj = _lodash2.default.get(menuFolder.contents, 'images[0]', null);
	      var backgroundImage = (0, _shared.dp)(_this.props.screen, backgroundObj);
	      var showBackground = true;
	      return _react2.default.createElement(_StoryTampa2.default, {
	        backgroundImage: backgroundImage,
	        showBackground: showBackground,
	        screen: _this.props.screen,
	        screensNumber: _this.props.screensNumber,
	        navRoute: _this.props.navRoute,
	        story: _this.state.story,
	        background: _this.getBackgroundImage(),
	        mode: _this._mode,
	        clickAction: _this.handleBack,
	        contentIndex: _this.state.contentIndex
	      });
	    };
	
	    _this.getSubscribeModule = function () {
	      _this._menuModules = _lodash2.default.filter(_this.props.content.dm_active, { module_contents: { in_navigation: true } });
	      var type = "";
	      _this._menuModules.forEach(function (module, row) {
	        if (module.display_module_type === "User Input") {
	          if (_lodash2.default.has(module, 'contents.custom_fields.user_input_type.val')) {
	            type = module.contents.custom_fields.user_input_type.val;
	
	            if (type === "subscribe") {
	              _this._subscribeModule = module;
	              return;
	            }
	          }
	        }
	      });
	    };
	
	    _this.redirect = function () {
	      if (_this._subscribeModule !== null && _this._subscribeModule !== undefined) {
	        _this.props.navRoute('/miami/subscribe', _this._subscribeModule);
	      }
	    };
	
	    _this.state = {
	      story: null,
	      showModal: false,
	      iScrollInitialized: false
	    };
	
	    _this.storyRefs = {};
	    return _this;
	  }
	
	  _createClass(StoriesTampa, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var _loop2 = function _loop2(id) {
	        _this2.storyRefs[id].removeEventListener("tap", function () {
	          return _this2.handleTap(id);
	        });
	      };
	
	      for (var id in this.storyRefs) {
	        _loop2(id);
	      }
	      clearTimeout(this._modalTimeout);
	      this._modalTimeout = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var unit = this.props.screen.r9_16.p10;
	      var backgroundImage = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
	      var textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
	      var textShadow = textShadowSize + 'px ' + textShadowSize + 'px ' + textShadowSize + 'px black';
	
	      // let headerOps = _.get(this.props.module, 'contents.custom_fields.title.val.ops', _.get(this.props.module, 'contents.custom_fields.title.default.ops', null));
	      // let headerRichText = new QuillDeltaToHtmlConverter(headerOps, {}).convert();
	
	      // let bodyOps = _.get(this.props.module, 'contents.custom_fields.body.val.ops', _.get(this.props.module, 'contents.custom_fields.body.default.ops', null));
	      // let bodyRichText = new QuillDeltaToHtmlConverter(bodyOps, {}).convert();
	
	      var modalStyle = {
	        position: "absolute",
	        width: this.props.screen.screenWidth / this.props.screensNumber,
	        left: this.props.screensNumber === 1 ? 0 : this.props.screen.screenWidth / this.props.screensNumber
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	        _react2.default.createElement(
	          'div',
	          { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	              _react2.default.createElement(
	                'div',
	                { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	                _react2.default.createElement('div', { style: { height: "2.5vh" } }),
	                _react2.default.createElement('img', { role: 'presentation', src: iconImage, style: { width: '14vh' } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'crimson-semi-bold', style: { textShadow: textShadow, textAlign: "center", fontSize: '4vh' } },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.module.name
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'crimson-regular', style: { textShadow: textShadow, fontSize: '2vh', textAlign: "center", paddingRight: "7vh", paddingLeft: "7vh", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" } },
	                this.props.module.description
	              ),
	              _react2.default.createElement('div', { style: { height: '8.6vh' } }),
	              _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: "2.8125vh", top: "26.979166667vh" } }),
	              _react2.default.createElement(
	                'div',
	                { style: { display: "flex", justifyContent: "center" } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { color: 'black', width: '85%', height: "73.0468vh", display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "-1.6875vh", touchAction: "none", position: "absolute", top: "28.7760vh" } },
	                  _react2.default.createElement(
	                    _reactIscroll2.default,
	                    { ref: function ref(el) {
	                        return _this3.iScroller = el;
	                      }, iScroll: _iscroll2.default,
	                      options: {
	                        mouseWheel: true,
	                        scrollbars: false,
	                        scrollX: false,
	                        scrollY: true,
	                        probeType: 2,
	                        bounce: false,
	                        momentum: true,
	                        deceleration: 0.005,
	                        useTransition: true,
	                        disableTouch: false,
	                        disablePointer: false,
	                        disableMouse: false,
	                        tap: true
	                      },
	                      onRefresh: this.initializeIScroll
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement('div', { style: { height: "3.5vh" } }),
	                      this.renderStories(),
	                      _react2.default.createElement(_ScrollSpacer2.default, { unit: unit })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, modalStyle) },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'containerFade',
	              style: { minHeight: '100%' },
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showModal },
	              this.state.showModal ? this.getModalContent() : null,
	              this.state.showModal ? this.renderBackButton() : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StoriesTampa;
	}(_react.Component);
	
	exports.default = StoriesTampa;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _AttractLoopTampa = __webpack_require__(485);
	
	var _AttractLoopTampa2 = _interopRequireDefault(_AttractLoopTampa);
	
	var _NavTampa = __webpack_require__(490);
	
	var _NavTampa2 = _interopRequireDefault(_NavTampa);
	
	var _DonorListsTampa = __webpack_require__(486);
	
	var _DonorListsTampa2 = _interopRequireDefault(_DonorListsTampa);
	
	var _StoriesTampa = __webpack_require__(493);
	
	var _StoriesTampa2 = _interopRequireDefault(_StoriesTampa);
	
	var _MenuButtonTampa = __webpack_require__(488);
	
	var _MenuButtonTampa2 = _interopRequireDefault(_MenuButtonTampa);
	
	var _TimelineTampa = __webpack_require__(495);
	
	var _TimelineTampa2 = _interopRequireDefault(_TimelineTampa);
	
	var _UserInputTampa = __webpack_require__(496);
	
	var _UserInputTampa2 = _interopRequireDefault(_UserInputTampa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var recent_interaction_timeout = 5000;
	
	var TampaContainer = function (_Component) {
	  _inherits(TampaContainer, _Component);
	
	  function TampaContainer(props) {
	    _classCallCheck(this, TampaContainer);
	
	    var _this = _possibleConstructorReturn(this, (TampaContainer.__proto__ || Object.getPrototypeOf(TampaContainer)).call(this, props));
	
	    _this.toggleShowNav = function (toggleOn) {
	      _this.setState({
	        showNavButton: toggleOn
	      });
	    };
	
	    _this.showNavButton = function (show) {
	      _this.setState({
	        showNavButton: show
	      });
	    };
	
	    _this.openNav = function () {
	      _this.props.history.replace(_this.state.menuUrl);
	    };
	
	    _this.getScreensNumber = function () {
	      try {
	        return _this.props.content.settings.display_blocks[0].screens.length;
	      } catch (e) {
	        return 1;
	      }
	    };
	
	    _this.folderGoIdle = function (type) {
	      if (type === "recentInteraction") {
	        _this.setState({
	          recentInteraction: false
	        });
	      } else {
	        _this.setState({
	          idle: true
	        });
	
	        _this.folderCycleIdle();
	        _this.folderCycleIdleLoop();
	      }
	    };
	
	    _this.folderNavroute = function (ref, type, source, options) {
	      if (ref === null) {
	        if (_this.props.active_module !== undefined) {
	          ref = _this.props.active_module; //maintain module if not changed
	        }
	      }
	      if (type === null) {
	        type = _this.getActiveModuleType();
	      }
	
	      var module = void 0;
	      module = _this._attractLoopTree.children[ref];
	
	      _this.setState({
	        displayNav: false,
	        options: options,
	        showNav: true,
	        attractLoopModule: module,
	        attractLoopRef: ref
	      });
	      _this.props.history.replace("/tampa");
	    };
	
	    _this.folderCycleIdle = function () {
	      if (_this.idleRef >= _this._attractLoopTree.children.length) {
	        _this.idleRef = 0;
	      }
	      var type = _lodash2.default.get(_this._attractLoopTree.children[_this.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
	      _this.folderNavroute(_this.idleRef, type, "idle", { idleModule: _this.idleRef });
	    };
	
	    _this.folderCycleIdleLoop = function () {
	      clearTimeout(_this._idleLoopTimeout);
	      var timeout = Number(_lodash2.default.get(_this._attractLoopTree.children[_this.idleRef].contents, 'custom_fields.cycle_timeout.val', 30));
	      _this._idleLoopTimeout = setTimeout(function () {
	        _this.folderCycleIdle();
	        _this.folderCycleIdleLoop();
	      }, timeout * 1000);
	      _this.idleRef++;
	    };
	
	    _this.folderCheckRecentInteraction = function () {
	      var msPassed = new Date().getTime() - _this.lastInteraction.getTime();
	      if (msPassed > recent_interaction_timeout) {
	        _this.folderGoIdle("recentInteraction");
	      } else {
	        clearTimeout(_this._recentInteractionTimeout);
	        _this._recentInteractionTimeout = setTimeout(function () {
	          _this.folderCheckRecentInteraction();
	        }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
	      }
	    };
	
	    _this.checkIdleTimeout = function () {
	      var msPassed = new Date().getTime() - _this.lastInteraction.getTime();
	      if (msPassed > _this._idleDelay) {
	        _this.folderGoIdle("idle");
	      } else {
	        clearTimeout(_this._idleTimeout);
	        _this._idleTimeout = setTimeout(function () {
	          _this.checkIdleTimeout();
	        }, _this._idleDelay - msPassed); //avoids extra settings of timeout below interval check
	      }
	    };
	
	    _this.resume = function () {
	      _this.idleRef = 0;
	      _this.lastInteraction = new Date();
	      _this.checkIdleTimeout();
	
	      if (_this.state.idle === true) {
	        _this.props.history.replace('/tampa/nav');
	        _this.setState({
	          idle: false,
	          attractLoopRef: _this.idleRef
	        });
	        clearTimeout(_this._idleLoopTimeout);
	      }
	      if (_this.state.recentInteraction === false) {
	        _this.setState({
	          recentInteraction: true
	        });
	      }
	    };
	
	    _this.pageClick = function () {
	      _this.resume();
	    };
	
	    _this.navRoute = function (route, module) {
	      if (module) {
	        _this.setState({
	          module: module
	        });
	      }
	      _this.props.history.replace(route);
	    };
	
	    _this._screensNumber = _this.getScreensNumber();
	    _this._attractLoopTree = [];
	    _this.lastInteraction = new Date();
	    _this.idleRef = 0;
	
	    _this.state = {
	      attractLoopRef: null,
	      showNavButton: false,
	      menuUrl: '/tampa/nav'
	    };
	    return _this;
	  }
	
	  _createClass(TampaContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        document.addEventListener("keydown", this.handleKeyDown);
	        //Setting Up Attract Loop    
	        if (this.props.content.idle_delay) {
	          this._idleDelay = this.props.content.idle_delay * 1000;
	        } else {
	          this._idleDelay = 120000;
	        }
	
	        // Get Display Root Folder
	        var rootFolder = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	        if (rootFolder !== null && rootFolder !== undefined) {
	          rootFolder = Number(rootFolder);
	        }
	
	        // Idle interaction Attract Loop.
	        if (this.props.idleActive) {
	          if (this.props.content.idle_delay > 0) {
	            if (!this.props.content.settings.disallowInteraction) {
	              window.addEventListener('mousedown', this.pageClick, false);
	            }
	            // Check if folder Attract Loop or Legacy
	            var folderAttractLoop = _lodash2.default.get(this.props.content.settings, 'folderAttractLoop', false);
	            if (folderAttractLoop) {
	              var topAttractLoop = _lodash2.default.filter(this.props.content.story_categories, { parent_category: rootFolder, contents: { custom_fields: { folder_type: { val: { value: "attract_loop" } } } } });
	              if (topAttractLoop && topAttractLoop[0]) {
	                this._attractLoopTree = _shared2.default.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, topAttractLoop[0].name, 'sorting_name');
	
	                // this.props.setOptions({
	                //   attractLoopTree: this._attractLoopTree
	                // });
	
	                // this.folderCheckRecentInteraction();
	                // this.checkIdleTimeout();
	                this.folderGoIdle("idle");
	              }
	            }
	          }
	        }
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	
	      var key = this.props.location.pathname + this.props.location.search;
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.content.font_class, style: { color: this.props.content.settings.main_font_color } },
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            { key: key, location: location },
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/tampa/nav', render: function render(props) {
	                return _react2.default.createElement(_NavTampa2.default, Object.assign({}, props, { toggleShowNav: _this2.toggleShowNav, navRoute: _this2.navRoute, content: _this2.props.content, screen: _this2.props.screen, screensNumber: _this2._screensNumber }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/tampa/stories', render: function render(props) {
	                return _react2.default.createElement(_StoriesTampa2.default, Object.assign({}, props, { module: _this2.state.module, navRoute: _this2.navRoute, screen: _this2.props.screen, content: _this2.props.content, screensNumber: _this2._screensNumber, showNavButton: _this2.showNavButton }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/tampa/donor_lists', render: function render(props) {
	                return _react2.default.createElement(_DonorListsTampa2.default, Object.assign({}, props, { module: _this2.state.module, content: _this2.props.content, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/tampa/timeline', render: function render(props) {
	                return _react2.default.createElement(_TimelineTampa2.default, Object.assign({}, props, { content: _this2.props.content, module: _this2.state.module, navRoute: _this2.navRoute, screen: _this2.props.screen, screensNumber: _this2._screensNumber }));
	              } }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/tampa/search', render: function render(props) {
	                return _react2.default.createElement(_UserInputTampa2.default, Object.assign({}, props, { navRoute: _this2.navRoute, content: _this2.props.content, module: _this2.state.module, screen: _this2.props.screen, screensNumber: _this2._screensNumber, showNavButton: _this2.showNavButton }));
	              } })
	          ),
	          this.state.idle ? _react2.default.createElement(_AttractLoopTampa2.default, { key: this.state.attractLoopRef, tree: this._attractLoopTree, attractLoopRef: this.state.attractLoopRef }) : null
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'fastfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showNavButton },
	            this.state.showNavButton && !this.state.idle ? _react2.default.createElement(_MenuButtonTampa2.default, {
	              unit: this.props.screen.r9_16.p10 / this.props.screensNumber,
	              width: '3.90625vh',
	              height: '5.625vh',
	              top: '50vh',
	              border: '0.84375vh',
	              clickAction: this.openNav,
	              text: 'menu'
	            }) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return TampaContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var idleActive = true;
	  var idle = _shared2.default.parseStringParam(window.location.href, "idle");
	  if (state.content.idle_delay === 0 || idle === "false") {
	    idleActive = false;
	  }
	  return {
	    content: state.content,
	    screen: state.screen,
	    idleActive: idleActive
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TampaContainer);

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _InfoBlockTampa = __webpack_require__(94);
	
	var _InfoBlockTampa2 = _interopRequireDefault(_InfoBlockTampa);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _iconTimelineBullet = __webpack_require__(787);
	
	var _iconTimelineBullet2 = _interopRequireDefault(_iconTimelineBullet);
	
	var _StoryTampa = __webpack_require__(95);
	
	var _StoryTampa2 = _interopRequireDefault(_StoryTampa);
	
	var _BackButtonTampa = __webpack_require__(93);
	
	var _BackButtonTampa2 = _interopRequireDefault(_BackButtonTampa);
	
	var _shared = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import BRSpan from '../../General/BRSpan'
	
	var spacialEvents;
	var config = {
		events_on_screen: 10,
		line_thickness: 0.02
	};
	
	var TimelineTampa = function (_Component) {
		_inherits(TimelineTampa, _Component);
	
		function TimelineTampa(props) {
			_classCallCheck(this, TimelineTampa);
	
			var _this = _possibleConstructorReturn(this, (TimelineTampa.__proto__ || Object.getPrototypeOf(TimelineTampa)).call(this, props));
	
			_this.getMainMenuBackground = function () {
				var menuFolder = _this.props.content.story_categories.find(function (folder) {
					var folderType = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
					if (folderType !== null) {
						return folder.parent_category === Number(_this.props.content.settings.selected_root_folder) && folderType === "menu";
					}
	
					return false;
				});
				var backgroundObj = _lodash2.default.get(menuFolder.contents, 'images[0]', null);
				return (0, _shared.dp)(_this.props.screen, backgroundObj);
			};
	
			_this.initializeTimelineRefs = function () {
				if (_this.state.initializedRefs === false) {
					var _loop = function _loop(a) {
						_this.timelineRefs[a].el.addEventListener("tap", function () {
							return _this.handleEventSelection(_this.timelineRefs[a].data.folder_module_id);
						});
					};
	
					for (var a = 0; a < _this.timelineRefs.length; a++) {
						_loop(a);
					}
					_this.setState({
						initializedRefs: true
					});
				}
			};
	
			_this.handleBack = function () {
				_this.setState({
					showStoryModal: false
				});
			};
	
			_this.parseDate = function (date) {
				var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
				var monthName = monthNames[date.getMonth()];
				// let monthNumber = String(date.getMonth() + 1);
				var fullYear = String(date.getFullYear());
				// let shortYear = fullYear.substring(2);
				var day = String(date.getDate());
				var unit = _this.props.screen.r9_16.p10;
				return _react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'b',
						null,
						_react2.default.createElement(
							'div',
							{ style: { textAlign: "right", fontSize: unit * .2, maxWidth: _this.props.screen.screenWidth * .11574074074074074074 } },
							monthName,
							' ',
							day
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ style: { textAlign: "right", fontSize: unit * .35, maxWidth: _this.props.screen.screenWidth * .11574074074074074074 } },
							fullYear
						)
					)
				);
			};
	
			_this.onScrollEnd = function () {
				var evt = new MouseEvent('mousedown', {
					bubbles: true,
					cancelable: false,
					view: window
				});
				window.dispatchEvent(evt);
			};
	
			_this.handleEventSelection = function (story_id) {
				var story = _this.props.module.children.find(function (st) {
					return st.folder_module_id === Number(story_id);
				});
				if (story) {
					_this.setState({
						showStoryModal: true,
						story: story
					});
				}
			};
	
			_this.cycleStory = function (direction) {
				if (direction === "forward") {
					_this._eventIndex += 1;
					if (_this._eventIndex >= _this.props.module.children.length) {
						_this._eventIndex = 0;
					}
				} else {
					_this._eventIndex -= 1;
					if (_this._eventIndex < 0) {
						_this._eventIndex = _this.props.module.children.length - 1;
					}
				}
				if (!_this.props.module.children[_this._eventIndex].story || isNaN(Number(_this.props.module.children[_this._eventIndex].story))) {
					_this.cycleStory(direction);
				} else {
					_this.handleEventSelection(_this.props.module.children[_this._eventIndex].story);
				}
			};
	
			_this.getBackgroundImage = function () {
				var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
				var backgroundObj = _lodash2.default.get(_this.props.module, 'contents.images[0]', null);
				return (0, _shared.dp)(_this.props.screen, backgroundObj, defaultImg);
			};
	
			_this.getIconImage = function () {
				var iconObj = _lodash2.default.get(_this.props.module, 'contents.images[2]', null);
				return (0, _shared.dp)(_this.props.screen, iconObj);
			};
	
			_this.refDict = {};
			// this.cycleDate = this.cycleDate.bind(this);
			// this.onScrollEnd = this.onScrollEnd.bind(this);
			_this.state = {
				spacialEvents: null,
				sideMargin: null,
				totalHeight: null,
				currentEvent: 0,
				showStoryModal: false,
				initializedRefs: false,
				contentIndex: 0
			};
			_this._subscribeModule = null;
			_this._buttonBinded = false;
			_this._baseInset = _this.props.screen.screenWidth * .5;
			_this._eventIndex = 0;
			_this._rowWrapperRef = null;
			_this._titleStyle = {
				position: 'absolute',
				fontFamily: 'aleo-bolditalic', fontSize: _this.props.screen.r16_9.p10,
				left: _this.props.screen.r16_9.width * .05
			};
			_this._titleHorizontalRule = {
				width: '90%',
				height: _this.props.screen.r16_9.p10 * 0.15,
				backgroundColor: '#223954',
				display: 'inline-block',
				position: 'absolute',
				top: _this.props.screen.r16_9.p10 * 1.25,
				left: 0,
				marginLeft: _this.props.screen.r16_9.width * .05
			};
			_this._bottomNavOffset = 0;
			if (_this.props.content.settings.custom_vars && _this.props.content.settings.custom_vars.bottomnav === "true") {
				_this._bottomNavOffset = _this.props.screen.r16_9.p10;
			}
			_this.timelineRefs = [];
			_this._mainMenuBackground = _this.getMainMenuBackground();
			return _this;
		}
	
		_createClass(TimelineTampa, [{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var _this2 = this;
	
				var _loop2 = function _loop2(a) {
					if (_this2.timelineRefs[a].el) {
						_this2.timelineRefs[a].el.removeEventListener("tap", function () {
							return _this2.handleEventSelection(_this2.timelineRefs[a].data);
						});
					}
				};
	
				for (var a = 0; a < this.timelineRefs.length; a++) {
					_loop2(a);
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var totalHeight = (this.props.module.children.length + 1) * (this.props.screen.sv.height / config.events_on_screen);
				this.getRelativeLocations(this.props.module.children, totalHeight, 0);
			}
		}, {
			key: 'getRelativeLocations',
			value: function getRelativeLocations(events, totalHeight, topMargin) {
				spacialEvents = [];
				var spacing = _lodash2.default.get(this.props.module, 'contents.custom_fields.event_spacing.val.value', "even");
				var sortedEvents = events.sort(function (a, b) {
					var aDate = new Date(_lodash2.default.get(a, 'contents.sorting_date', 0));
					var bDate = new Date(_lodash2.default.get(b, 'contents.sorting_date', 0));
					return aDate.getTime() - bDate.getTime();
				});
				if (spacing === "even") {
					var eventInc = this.props.screen.sv.height / config.events_on_screen;
					_lodash2.default.forEach(sortedEvents, function (event, index) {
						var raw = eventInc * index;
						var span = raw + eventInc;
						// let date = _.get(event, 'contents.sorting_date', "2000-01-01");
						var date = _lodash2.default.get(event, 'contents.headline', "2000-01-01");
						spacialEvents.push({
							header: event.name,
							date: date,
							offset: span,
							raw: raw,
							text: "Event Text",
							images: event.contents.images,
							story: event });
					});
					this.setState({
						spacialEvents: spacialEvents,
						totalHeight: totalHeight
					});
				} else {
					//relative spacing
					var fullTimeSpan = events[events.length - 1].date - events[0].date;
					_lodash2.default.forEach(sortedEvents, function (event) {
						var date = _lodash2.default.get(event, 'contents.headline', "2000-01-01");
						var raw = (event.date - events[0].date) / fullTimeSpan * totalHeight;
						var span = raw + topMargin;
						spacialEvents.push({
							header: event.name,
							date: date,
							offset: span,
							raw: raw,
							text: "Event Text",
							images: event.images,
							story: "Event Story" });
					});
					this.setState({
						spacialEvents: spacialEvents,
						totalHeight: totalHeight
					});
				}
			}
		}, {
			key: 'cycleDate',
			value: function cycleDate(mode, index) {
				var tempCurrentEvent = this.state.currentEvent;
				if (mode === 0) {
					//backward
					tempCurrentEvent--;
					if (tempCurrentEvent < 0) {
						tempCurrentEvent = spacialEvents.length - 1;
					}
				} else if (mode === 1) {
					//forward
					tempCurrentEvent++;
					if (tempCurrentEvent > spacialEvents.length - 1) {
						tempCurrentEvent = 0;
					}
				} else {
					//to specific index
					tempCurrentEvent = index;
				}
				this.refDict[0].withIScroll(function (iScroll) {
					iScroll.scrollTo(-spacialEvents[tempCurrentEvent].raw, 0, 1000);
				});
				this.setState({
					currentEvent: tempCurrentEvent
				});
			}
		}, {
			key: 'renderSpacialEvents',
			value: function renderSpacialEvents() {
				var circleRadius = this.props.screen.r16_9.p10 * 0.15;
				if (this.state.spacialEvents.length === 0) {
					return _react2.default.createElement('span', null);
				}
	
				var unit = this.props.screen.r9_16.p10;
				var infoBlockWidth = unit * 3.35 * .8;
				var insetAmount = unit * 1.55;
				var leftInset = -insetAmount - infoBlockWidth * .95;
				var rightInset = insetAmount;
				var imageHeight = unit * 2 * .8;
				var infoHeight = unit * .85 * .8;
				var fullHeight = imageHeight + infoHeight;
				var iconWidth = unit * .25;
	
				return this.state.spacialEvents.map(function (row, i) {
					var _this3 = this;
	
					//assume left
					var inset = leftInset;
					var dateInset = -insetAmount / 6 - unit;
					// let horizontalLineInset = -insetAmount + this._baseInset;
	
					var splittedStr = [];
					var date = "";
					if (row.date.includes('<BR>')) {
						splittedStr = row.date.split("<BR>");
						date = splittedStr.map(function (date, j) {
							if (i % 2 !== 0) {
								return _react2.default.createElement(
									'div',
									{ style: { textAlign: "right", width: _this3.props.screen.screenWidth * .10416666666666666667 }, key: j },
									date
								);
							} else {
								return _react2.default.createElement(
									'div',
									{ style: { textAlign: "left", width: _this3.props.screen.screenWidth * .10416666666666666667 }, key: j },
									date
								);
							}
						});
					} else if (row.date.includes('<br>')) {
						splittedStr = row.date.split("<br>");
						date = splittedStr.map(function (date, j) {
							if (i % 2 !== 0) {
								return _react2.default.createElement(
									'div',
									{ style: { textAlign: "right", width: _this3.props.screen.screenWidth * .10416666666666666667 }, key: j },
									date
								);
							} else {
								return _react2.default.createElement(
									'div',
									{ style: { textAlign: "left", width: _this3.props.screen.screenWidth * .10416666666666666667 }, key: j },
									date
								);
							}
						});
					} else {
						if (i % 2 !== 0) {
							date = _react2.default.createElement(
								'div',
								{ style: { textAlign: "right", width: this.props.screen.screenWidth * .10416666666666666667 } },
								row.date
							);
						} else {
							date = _react2.default.createElement(
								'div',
								{ style: { textAlign: "left", width: this.props.screen.screenWidth * .10416666666666666667 } },
								row.date
							);
						}
					}
	
					//offset for right scenario
					if (i % 2 === 0) {
						inset = rightInset;
						// horizontalLineInset = this._baseInset + unit * 1.1
						dateInset = insetAmount / 6;
					}
	
					return _react2.default.createElement(
						'div',
						{ key: i, style: { position: 'absolute', top: row.offset, zIndex: 0 } },
						_react2.default.createElement(
							'div',
							{ style: { position: 'absolute', left: this._baseInset - iconWidth / 2 } },
							_react2.default.createElement('img', { alt: 'timelineicon', style: { width: iconWidth, height: iconWidth }, src: _iconTimelineBullet2.default })
						),
						_react2.default.createElement(
							'span',
							{ className: 'crimson-regular', style: { color: '#143e77', fontSize: unit * .35, position: 'absolute', left: dateInset + this._baseInset, width: unit * 5, top: -unit * .275 } },
							_react2.default.createElement(
								'b',
								null,
								date
							)
						),
						_react2.default.createElement(
							'span',
							{ ref: function ref(el) {
									return _this3.timelineRefs[i] = { el: el, data: row.story };
								}, style: { position: 'absolute', left: inset + this._baseInset, top: -fullHeight / 2 + circleRadius / 2 } },
							_react2.default.createElement(_InfoBlockTampa2.default, {
								imgsrc: (0, _shared.dp)(this.props.screen, _lodash2.default.get(row, 'images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' }),
								imageHeight: imageHeight,
								infoHeight: infoHeight,
								width: infoBlockWidth,
								unit: unit * .8,
								text: row.header,
								infoColor: "#143e77",
								infoBackgroundColor: 'white',
								fontFamily: 'opensans-regular',
								fontSize: unit * 0.15
							})
						)
					);
				}, this);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				var backgroundImage = this.getBackgroundImage();
				var iconImage = this.getIconImage();
				var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
				var textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
				var textShadow = textShadowSize + 'px ' + textShadowSize + 'px ' + textShadowSize + 'px black';
	
				if (!this.state.spacialEvents) {
					return _react2.default.createElement('div', null);
				}
	
				var spacialEvents = this.renderSpacialEvents();
				//let quickJumps = this.renderQuickJumps();
				var unit = this.props.screen.r9_16.p10;
				// let mult = .8
				var scrollableArea = this.props.screen.screenHeight * .72916666666666666667;
	
				return _react2.default.createElement(
					'div',
					{ style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: backgroundSize, backgroundImage: "url(" + backgroundImage + ")" } },
					_react2.default.createElement(
						'div',
						{ style: { textAlign: 'center', position: 'absolute', width: "100%" } },
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement('img', { alt: 'Timeline', src: iconImage, style: { display: 'block', margin: 'auto', width: '8vh' } }),
						_react2.default.createElement(
							'div',
							{ className: 'crimson-semi-bold', style: { textShadow: textShadow, fontSize: '4vh' } },
							this.props.module.name
						),
						_react2.default.createElement(
							'div',
							{ className: 'crimson-regular', style: { textShadow: textShadow, fontSize: '2vh', paddingRight: "8.333333333vh", paddingLeft: "8.333333333vh", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" } },
							_lodash2.default.get(this.props.module, 'description', null)
						),
						_react2.default.createElement(
							'div',
							{ style: { display: 'flex', justifyContent: 'center', width: '100%' } },
							_react2.default.createElement(
								'div',
								{ style: { width: '80vw', height: '15vw', borderRadius: '2vw', padding: '5vw' } },
								_react2.default.createElement('div', { style: { color: 'black', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around' } })
							)
						)
					),
					_react2.default.createElement('div', { style: { position: 'absolute', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height } }),
					_react2.default.createElement(
						'div',
						{ style: {
								position: 'absolute',
								top: "26.96759259259259259259vh",
								left: 0,
								width: this.props.screen.screenWidth,
								height: scrollableArea,
								touchAction: "none"
							} },
						_react2.default.createElement(
							_reactIscroll2.default,
							{ ref: function ref(el) {
									return _this4.refDict[0] = el;
								}, iScroll: _iscroll2.default,
								onScrollEnd: this.onScrollEnd,
								options: {
									mouseWheel: true,
									scrollbars: false,
									scrollX: false,
									scrollY: true,
									probeType: 2,
									bounce: false,
									momentum: true,
									deceleration: 0.005,
									useTransition: true,
									disableTouch: false,
									disablePointer: false,
									disableMouse: false,
									tap: true
								},
								onRefresh: this.initializeTimelineRefs
							},
							_react2.default.createElement(
								'div',
								{ style: { width: this.props.screen.r16_9.width * .6, height: this.state.totalHeight, minHeight: '100%' } },
								_react2.default.createElement('div', { style: {
										position: 'absolute',
										top: 0,
										backgroundColor: 'white',
										left: this._baseInset,
										width: this.props.screen.sv.p10 * config.line_thickness,
										height: '100%'
									} }),
								_react2.default.createElement('div', { style: {
										position: 'absolute',
										width: this.props.screen.r16_9.width,
										height: this._titleHorizontalRule.top
									} }),
								spacialEvents
							)
						),
						_react2.default.createElement('div', { className: 'topgradblackP25', style: { position: 'absolute', width: '100%', height: unit * .25, bottom: '71.5vh' } })
					),
					_react2.default.createElement(
						'div',
						{ style: { position: 'absolute' } },
						_react2.default.createElement(
							_CSSTransitionGroup2.default,
							{
								component: 'div',
								className: 'containerFade',
								style: { minHeight: '100%' },
								transitionName: 'example',
								transitionEnterTimeout: 0,
								transitionLeaveTimeout: 0 },
							_react2.default.createElement(
								'div',
								{ key: this.state.showStoryModal, style: { position: 'absolute' } },
								this.state.showStoryModal ? _react2.default.createElement(_StoryTampa2.default, {
									backgroundImage: this._mainMenuBackground,
									showBackground: true,
									screen: this.props.screen,
									screensNumber: this.props.screensNumber,
									story: this.state.story,
									content: this.props.content,
									clickAction: this.handleBack,
									contentIndex: this.state.contentIndex
								}) : null,
								this.state.showStoryModal ? _react2.default.createElement(_BackButtonTampa2.default, {
									unit: this.props.screen.r9_16.p10 / this.props.screensNumber,
									width: '3.90625vh',
									height: '4.5vh',
									top: '56.46875vh',
									border: '0.84375vh',
									clickAction: this.handleBack,
									text: 'back',
									mode: this._mode }) : null
							)
						)
					)
				);
			}
		}]);
	
		return TimelineTampa;
	}(_react.Component);
	
	exports.default = TimelineTampa;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeyboardKeyTampa = __webpack_require__(487);
	
	var _KeyboardKeyTampa2 = _interopRequireDefault(_KeyboardKeyTampa);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactRedux = __webpack_require__(5);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _donorHelpers2 = _interopRequireDefault(_donorHelpers);
	
	var _dataHelpers = __webpack_require__(51);
	
	var _dataHelpers2 = _interopRequireDefault(_dataHelpers);
	
	var _StoryTampa = __webpack_require__(95);
	
	var _StoryTampa2 = _interopRequireDefault(_StoryTampa);
	
	var _BackButtonTampa = __webpack_require__(93);
	
	var _BackButtonTampa2 = _interopRequireDefault(_BackButtonTampa);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	var _InfoBlockTampa = __webpack_require__(94);
	
	var _InfoBlockTampa2 = _interopRequireDefault(_InfoBlockTampa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import InfoBlockTampa from './InfoBlockTampa';
	
	
	var DARK = "#71532c";
	// import axios from 'axios'
	// import config from '../../../../config';
	
	// const SUBSCRIBE = "subscribe";
	// const SEARCH = "search";
	
	var UserInputTampa = function (_Component) {
	  _inherits(UserInputTampa, _Component);
	
	  function UserInputTampa(props) {
	    _classCallCheck(this, UserInputTampa);
	
	    var _this = _possibleConstructorReturn(this, (UserInputTampa.__proto__ || Object.getPrototypeOf(UserInputTampa)).call(this, props));
	
	    _this.setupDonorListsNames = function () {
	      var folders = _lodash2.default.filter(_this.props.content.story_categories, { contents: { custom_fields: { folder_type: { val: { value: "donor_list" } } } } });
	      folders = _this.filterNonDescendant(folders);
	      var names = [];
	      if (folders && folders.length > 0) {
	        for (var i = 0; i < folders.length; i++) {
	          var searchable = _lodash2.default.get(folders[i], 'contents.custom_fields.searchable.val', true);
	          if (searchable) {
	            var folder = folders[i];
	            var folderTree = _this.getFolderTree(folder, 0);
	            var name = "";
	            var subName = "";
	            var parentId = null;
	            var parent = void 0;
	
	            if (folderTree.count <= 4) {
	              var child = folderTree.child;
	              parent = Object.assign({}, child);
	              while (child) {
	                if (child.child) {
	                  child = child.child;
	                  parent = Object.assign({}, child);
	                } else {
	                  name = child.name;
	                  parentId = parent.parent_category;
	                  child = null;
	                }
	              }
	
	              names.push({
	                id: folder.id,
	                name: name,
	                subName: null,
	                parentId: parentId
	              });
	            }
	
	            if (folderTree.count === 5) {
	              var _child = folderTree.child;
	              while (_child) {
	                if (_child.child) {
	                  name = _child.name;
	                  _child = _child.child;
	                  parent = Object.assign({}, _child);
	                } else {
	                  subName = _child.name;
	                  parentId = parent.parent_category;
	                  _child = null;
	                }
	              }
	
	              names.push({
	                id: folder.id,
	                name: name,
	                subName: subName,
	                parentId: parentId
	              });
	            }
	          }
	        }
	      }
	
	      return names;
	    };
	
	    _this.getFolderTree = function (folder, count) {
	      count++;
	      if (folder.parent_category === undefined || folder.parent_category === null) {
	        folder.count = count;
	        return folder;
	      } else {
	        var parentFolder = _lodash2.default.find(_this.props.content.story_categories, { id: folder.parent_category });
	        parentFolder.child = folder;
	        return _this.getFolderTree(parentFolder, count);
	      }
	    };
	
	    _this.getBackgroundImage = function () {
	      var defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' };
	      var backgroundObj = _lodash2.default.get(_this.props.module, 'contents.images[0]', null);
	      return (0, _shared.dp)(_this.props.screen, backgroundObj, defaultImg);
	    };
	
	    _this.getIconImage = function () {
	      var iconObj = _lodash2.default.get(_this.props.module, 'contents.images[2]', null);
	      return (0, _shared.dp)(_this.props.screen, iconObj);
	    };
	
	    _this.getTimelineModule = function () {
	      _this._menuModules = _lodash2.default.filter(_this.props.content.dm_active, { module_contents: { in_navigation: true } });
	      _this._menuModules.forEach(function (module, row) {
	        if (module.display_module_type === "Timeline") {
	          _this._timelineModule = module;
	        }
	      });
	    };
	
	    _this.removeInputText = function () {
	      _this.setState({
	        text: "",
	        search: false,
	        hideKeyboard: false
	      });
	    };
	
	    _this.initializeIScroll = function () {
	      if (_this.state.iScrollInitialized === false) {
	        var _loop = function _loop(i) {
	          if (_this._storiesRefs[i] && _this._storiesRefs[i].el) {
	            _this._storiesRefs[i].el.addEventListener("tap", function () {
	              return _this.handleTap(_this._storiesRefs[i].data.id);
	            });
	          }
	        };
	
	        for (var i = 0; i < _this._storiesRefs.length; i++) {
	          _loop(i);
	        }
	
	        _this.setState({
	          iScrollInitialized: true
	        });
	      }
	    };
	
	    _this.handleTap = function (id) {
	      var story = _this.props.content.stories.find(function (st) {
	        return st.id === id;
	      });
	
	      if (_this.state.showModal) {
	        _this.setState({
	          showModal: false
	        });
	
	        clearTimeout(_this._modalTimeout);
	        _this._modalTimeout = null;
	        _this._modalTimeout = setTimeout(function () {
	          _this.setState({
	            story: story,
	            showModal: true
	          });
	        }, 500);
	      } else {
	        _this.setState({
	          story: story,
	          showModal: true
	        });
	      }
	    };
	
	    _this.handleBack = function () {
	      _this.props.showNavButton(true);
	      _this.setState({
	        showModal: false
	      });
	    };
	
	    _this.handleSearchBack = function () {
	      _this.setState({
	        hideKeyboard: false,
	        search: false,
	        text: ""
	      });
	    };
	
	    _this.redirect = function () {
	      if (_this._timelineModule !== null && _this._timelineModule !== undefined) {
	        _this.props.navRoute('/miami/timeline', _this._timelineModule);
	      }
	    };
	
	    _this.getDonorListName = function (folder) {
	      var name = _lodash2.default.find(_this._donorListNames, { id: folder.id });
	      return name;
	    };
	
	    _this.getGrouppedDonorFolders = function (folders) {
	      var parents = [];
	      for (var i = 0; i < folders.length; i++) {
	        var name = _this.getDonorListName(folders[i]);
	        if (name && parents.indexOf(name.parentId) === -1) {
	          parents.push(name.parentId);
	        }
	      }
	
	      return parents;
	    };
	
	    _this.getTributes = function (donor) {
	      var renderedTributes = [];
	      if (donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options) {
	        renderedTributes = donor.contents.arrays_values.acknowledgment_text_options.map(function (opt, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(
	              'div',
	              { style: { paddingTop: _this._regionWidth * .0035, paddingBottom: _this._regionWidth * .0035 } },
	              opt.acknowledgment_text_options.val.title + ' ' + opt.donor_name.val
	            )
	          );
	        });
	      }
	
	      return renderedTributes;
	    };
	
	    _this.filterNonDescendant = function (folders) {
	      var rootFolder = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      var filteredFolders = [];
	      if (!rootFolder) {
	        return folders;
	      }
	
	      var _loop2 = function _loop2(i) {
	        if (folders[i].parent_category === null || folders[i].parent_category === undefined) {
	          return 'continue';
	        }
	
	        var parent = folders[i].parent_category;
	        while (parent !== null && parent !== undefined) {
	          if (Number(parent) === Number(rootFolder)) {
	            filteredFolders.push(folders[i]);
	            break;
	          }
	          // eslint-disable-next-line 
	          var parentsParent = _this.props.content.story_categories.find(function (st) {
	            return Number(st.id) === Number(parent);
	          });
	          parent = parentsParent.parent_category;
	        }
	      };
	
	      for (var i = 0; i < folders.length; i++) {
	        var _ret2 = _loop2(i);
	
	        if (_ret2 === 'continue') continue;
	      }
	
	      return filteredFolders;
	    };
	
	    _this.renderStories = function (stories) {
	      if (stories.length === 0) {
	        _this.setState({
	          renderedStories: []
	        });
	        return;
	      }
	
	      var rows = [];
	      var row = [];
	      for (var i = 0; i < stories.length; i++) {
	        var slide = stories[i];
	        // let image = presetDp('stories', _.get(slide, 'contents.images[0]', null), this.props.screen);
	        // let marginLeft = 0;
	
	        // if (i > 0 && (i % 3 !== 0)) {
	        //   marginLeft = 0.0225 * this._regionWidth;
	        // } else {
	        //   marginLeft = 0;
	        // }
	
	        if (i % 3 === 0 && i > 0) {
	          rows.push(row);
	          row = [];
	        }
	
	        var story = _this.renderStory(slide, i);
	
	        // let story = (
	        //   <div key={i} ref={el => this._storiesRefs[i] = { el: el, data: { id: slide.id } }} style={{ position:"relative", marginLeft: marginLeft, float:"left", height:0.09 * this._regionWidth, display:"flex", justifyContent:"center", alignItems:"flex-end", minWidth:"25%", maxWidth:"25%" }}>
	        //     <img src={image} style={{ maxWidth:0.10125 * this._regionWidth, maxHeight:0.074925 * this._regionWidth }} alt=""/>
	        //     <div style={{ position: "absolute", bottom: -(0.0468 * this._regionWidth), width: 0.10125 * this._regionWidth, textAlign: "center", display: "flex", justifyContent: "center", minHeight: 0.04166666666666666667 * this._regionWidth, maxHeight: 0.04166666666666666667 * this._regionWidth, overflow: "hidden" }}>
	        //       <div style={{ fontSize: 0.0084 * this._regionWidth }}><BRSpan preWrap str={slide.name.toUpperCase()}/></div>
	        //     </div>
	        //   </div>
	        // );
	
	        row.push(story);
	        if (i === stories.length - 1) {
	          rows.push(row);
	        }
	      }
	
	      var renderedRows = rows.map(function (row, j) {
	        var marginTop = j === 0 ? 0 : _this._regionWidth * 0.017;
	        return _react2.default.createElement(
	          'div',
	          { key: j, style: { position: "relative", display: "flex", alignItems: "center", justifyContent: "center", width: "89%", height: "15.0462962962962962963vh", marginTop: marginTop, margin: "0 auto" } },
	          row
	        );
	      });
	      _this.setState({
	        renderedStories: renderedRows
	      });
	    };
	
	    _this.renderStory = function (row, i) {
	      var unit = _this.props.screen.r9_16.p10 / _this.props.screensNumber;
	      var backgroundObj = _lodash2.default.get(_this.props.menu, 'contents.images[0]', null);
	      var backgroundImage = (0, _shared.presetDp)(null, backgroundObj, _this.props.screen);
	      var mult = .8;
	      return _react2.default.createElement(
	        'div',
	        { key: i, ref: function ref(el) {
	            return _this._storiesRefs[i] = { el: el, data: { id: row.id } };
	          }, style: { marginRight: unit * .175, display: 'inline-block' } },
	        _react2.default.createElement(_InfoBlockTampa2.default, {
	          imgsrc: (0, _shared.presetDp)('stories', _lodash2.default.get(row, 'contents.images[0]', null), _this.props.screen),
	          imageHeight: unit * 2 * mult,
	          infoHeight: "4.6875vh",
	          width: "15vh",
	          unit: unit * mult,
	          text: row.name,
	          infoColor: "black",
	          infoBackgroundColor: 'white',
	          backgroundImage: backgroundImage,
	          fontFamily: 'opensans-regular',
	          fontSize: unit * 0.15
	        })
	      );
	    };
	
	    _this.renderDonors = function (results) {
	      var renderedDonors = [];
	      var renderedSubDonors = [];
	      var count = 0;
	      var marginTop = 0;
	
	      var foundFolders = _lodash2.default.filter(_this.props.content.story_categories, function (fl) {
	        return results.foundFolders.indexOf(Number(fl.id)) > -1;
	      });
	      var parents = _this.getGrouppedDonorFolders(foundFolders);
	      var parentFolders = _lodash2.default.filter(_this.props.content.story_categories, function (fl) {
	        return parents.indexOf(Number(fl.id)) > -1;
	      });
	
	      for (var i = 0; i < parentFolders.length; i++) {
	        var enablePalqueText = _lodash2.default.get(parentFolders[i], 'contents.custom_fields.enable_palque_text.val', false);
	        var children = _lodash2.default.filter(foundFolders, { parent_category: parentFolders[i].id });
	        for (var j = 0; j < children.length; j++) {
	          var folder = children[j];
	          var donorCategoryName = _this.getDonorListName(folder);
	          var subName = donorCategoryName.subName;
	
	          var searchable = _lodash2.default.get(folder, 'contents.custom_fields.searchable.val', true);
	          if (searchable) {
	            var categoryMatchedDonors = _lodash2.default.orderBy(_lodash2.default.filter(results.foundDonors, { folder_module: { folder: folder.id } }), [function (donor) {
	              return donor.sorting_name.toLowerCase();
	            }], ['asc']);
	
	            if (enablePalqueText) {
	              var columnDonors = categoryMatchedDonors.map(function (donor, i) {
	                var palqueText = _lodash2.default.get(donor, 'contents.texts[0].text', null);
	                var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * _this._regionWidth : 0;
	                return _react2.default.createElement(
	                  'div',
	                  { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this._regionWidth, display: "block", paddingTop: .0052 * _this._regionWidth } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: "85%", fontSize: 0.0075 * _this._regionWidth, marginBottom: marginBottom } },
	                    donor.name
	                  ),
	                  palqueText ? _react2.default.createElement(
	                    'div',
	                    { style: { marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * _this._regionWidth } },
	                    palqueText
	                  ) : null
	                );
	              });
	
	              renderedSubDonors[j] = _react2.default.createElement(
	                'div',
	                { key: j, style: {
	                    background: "white",
	                    margin: "0 auto",
	                    width: _this.props.screen.screenWidth * 0.6687242798353909465,
	                    paddingBottom: _this.props.screen.screenHeight * 0.01875,
	                    paddingTop: _this.props.screen.screenHeight * 0.02893518518518518519,
	                    borderRadius: 10,
	                    paddingLeft: _this.props.screen.screenWidth * 0.074074074,
	                    paddingRight: _this.props.screen.screenWidth * 0.074074074,
	                    marginBottom: _this.props.screen.screenWidth * .06172839506172839506
	                  }
	                },
	                subName ? _react2.default.createElement(
	                  'div',
	                  { className: 'opensans-bold', style: { fontSize: "1.85185185185185185185vh", paddingTop: 0.00347222222222222222 * _this._regionWidth, paddingBottom: 0.00694444444444444444 * _this._regionWidth, color: "#694f28" } },
	                  _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: subName.toUpperCase() })
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { style: { position: "relative", width: "100%", display: "flex", marginTop: .004 * _this._regionWidth, marginBottom: 0.0086 * _this._regionWidth } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'opensans-regular', style: { width: "100%", float: "left", color: "black" } },
	                    columnDonors
	                  )
	                )
	              );
	            } else {
	              var matchedColumnOne = [];
	              var matchedColumnTwo = [];
	              // Highlighted Donors (matched)
	              for (var k = 0; k < categoryMatchedDonors.length; k++) {
	                if (k === 0 || k % 2 === 0) {
	                  matchedColumnOne.push(categoryMatchedDonors[k]);
	                } else {
	                  matchedColumnTwo.push(categoryMatchedDonors[k]);
	                }
	              }
	
	              var renderedMatchedColumnOneDonors = matchedColumnOne.map(function (donor, i) {
	                var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * _this._regionWidth : 0;
	                return _react2.default.createElement(
	                  'div',
	                  { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this._regionWidth, display: "block", paddingTop: .0052 * _this._regionWidth } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: "85%", fontSize: 0.009 * _this._regionWidth, marginBottom: marginBottom } },
	                    donor.name
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * _this._regionWidth } },
	                    _this.getTributes(donor)
	                  )
	                );
	              });
	
	              var renderedMatchedColumnTwoDonors = matchedColumnTwo.map(function (donor, i) {
	                var marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .004 * _this._regionWidth : 0;
	                return _react2.default.createElement(
	                  'div',
	                  { key: i, style: { width: "100%", textAlign: "left", minHeight: 0.013 * _this._regionWidth, display: "block", paddingTop: .0052 * _this._regionWidth } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { maxWidth: "85%", fontSize: 0.009 * _this._regionWidth, marginBottom: marginBottom } },
	                    donor.name
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { marginLeft: "5%", maxWidth: "80%", fontSize: 0.0075 * _this._regionWidth } },
	                    _this.getTributes(donor)
	                  )
	                );
	              });
	              if (count > 0) {
	                marginTop = .026 * _this._regionWidth;
	              }
	
	              renderedSubDonors[j] = _react2.default.createElement(
	                'div',
	                { key: j, style: {
	                    background: "white",
	                    margin: "0 auto",
	                    width: _this.props.screen.screenWidth * 0.6687242798353909465,
	                    paddingBottom: _this.props.screen.screenHeight * 0.01875,
	                    paddingTop: _this.props.screen.screenHeight * 0.02893518518518518519,
	                    borderRadius: 10,
	                    paddingLeft: _this.props.screen.screenWidth * 0.074074074,
	                    paddingRight: _this.props.screen.screenWidth * 0.074074074,
	                    marginBottom: _this.props.screen.screenWidth * .06172839506172839506
	                  }
	                },
	                subName ? _react2.default.createElement(
	                  'div',
	                  { className: 'opensans-bold', style: { fontSize: "1.85185185185185185185vh", paddingTop: 0.00347222222222222222 * _this._regionWidth, paddingBottom: 0.00694444444444444444 * _this._regionWidth, color: "#694f28" } },
	                  _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: subName.toUpperCase() })
	                ) : null,
	                _react2.default.createElement(
	                  'div',
	                  { style: { position: "relative", width: "100%", display: "flex", marginTop: .004 * _this._regionWidth, marginBottom: 0.0086 * _this._regionWidth } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'opensans-regular', style: { width: 0.16875 * _this._regionWidth, float: "left", color: "black" } },
	                    renderedMatchedColumnOneDonors
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'opensans-regular', style: { width: 0.16875 * _this._regionWidth, color: "black" } },
	                    renderedMatchedColumnTwoDonors
	                  )
	                )
	              );
	            }
	          }
	        }
	
	        renderedDonors[i] = _react2.default.createElement(
	          'div',
	          { key: i, style: { position: "relative", width: "100%", marginTop: marginTop } },
	          renderedSubDonors
	        );
	        renderedSubDonors = [];
	      }
	
	      _this.setState({
	        renderedDonors: renderedDonors
	      });
	    };
	
	    _this.renderBackButton = function () {
	      return _react2.default.createElement(_BackButtonTampa2.default, {
	        unit: _this.props.screen.r9_16.p10 / _this.props.screensNumber,
	        width: '3.90625vh',
	        height: '4.5vh',
	        top: '56.46875vh',
	        border: '0.84375vh',
	        clickAction: _this.handleBack,
	        text: 'back',
	        mode: _this._mode });
	    };
	
	    _this.renderBackSearchButton = function () {
	      return _react2.default.createElement(_BackButtonTampa2.default, {
	        unit: _this.props.screen.r9_16.p10 / _this.props.screensNumber,
	        width: '3.90625vh',
	        height: '4.5vh',
	        top: '56.46875vh',
	        border: '0.84375vh',
	        clickAction: _this.handleSearchBack,
	        text: 'back',
	        mode: _this._mode });
	    };
	
	    _this.state = {
	      text: "",
	      module: _this.props.module,
	      virtual_keyboard_mode: 0,
	      iScrollInitialized: false,
	      scrollContainerHeight: "50vh",
	      storyRefs: [],
	      hideKeyboard: false,
	      emailSent: false,
	      showStory: false,
	      renderedStories: [],
	      renderedDonors: []
	    };
	
	    _this._regionWidth = _this.props.screen.screenWidth * 2.25;
	    _this._storiesRefs = [];
	    _this._donorListNames = [];
	    _this._simple = null;
	    _this._simpleWithPictures = null;
	    _this._videos = null;
	    _this._donors = null;
	    _this._pills = null;
	    _this._resultsContainer = null;
	    _this._emailSentTimeout = null;
	    _this._pillsStorySetsByModules = [];
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.deleteText = _this.deleteText.bind(_this);
	    _this.normalMode = _this.normalMode.bind(_this);
	    _this.capitalMode = _this.capitalMode.bind(_this);
	    _this.submitText = _this.submitText.bind(_this);
	
	    _this.getTimelineModule();
	
	    //Refs
	    _this._storyPillsRefs = [];
	    return _this;
	  }
	
	  _createClass(UserInputTampa, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._donorListNames = this.setupDonorListsNames();
	    }
	
	    // componentWillMount(){
	    //   checkData(this.props.module, this.props.screen.entry_point);
	    //   this._emailSentTimeout = null;
	    //   clearTimeout(this._emailSentTimeout);
	    // }
	
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if ((0, _shared.shallowEqual)(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(val) {
	      if (typeof val === "function") {
	        val();
	      } else {
	        var str = this.state.text + val;
	        if (str.length < 40) {
	          this.setState({
	            text: str
	          });
	        }
	      }
	    }
	  }, {
	    key: 'normalMode',
	    value: function normalMode() {
	      this.setState({
	        virtual_keyboard_mode: 0
	      });
	    }
	  }, {
	    key: 'capitalMode',
	    value: function capitalMode() {
	      this.setState({
	        virtual_keyboard_mode: 1
	      });
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText() {
	      if (this.state.text.length > 0) {
	        var str = this.state.text.substring(0, this.state.text.length - 1);
	        this.setState({
	          text: str
	        });
	      }
	    }
	  }, {
	    key: 'submitText',
	    value: function submitText() {
	      var _this2 = this;
	
	      this.setState({
	        iScrollInitialized: false
	      });
	
	      this._pillsStorySetsByModules = [];
	      this._storyPillsRefs = [];
	      this._storyPillsRefs.length = 0;
	
	      var donorResults = _donorHelpers2.default.searchInFolderDonorLists(this.props.content.story_categories, this.props.donors, this.state.text);
	      var storiesResult = _dataHelpers2.default.searchStory(this.props.content, this.state.text, ['attract_loop']);
	      this.renderStories(storiesResult);
	      this.renderDonors(donorResults);
	
	      this.setState({
	        stories: storiesResult,
	        donors: this._donors,
	        hideKeyboard: true
	      });
	
	      setTimeout(function () {
	        _this2.setState({
	          search: true
	        });
	        setTimeout(function () {
	          if (_this2.iScroller) {
	            _this2.iScroller._iScrollInstance.refresh();
	          }
	        }, 500);
	      }, 500);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var backgroundImage = this.getBackgroundImage();
	      var iconImage = this.getIconImage();
	      var backgroundSize = this.props.screen.screenWidth + 'px ' + this.props.screen.screenHeight + 'px';
	
	      var textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
	      var textShadow = textShadowSize + 'px ' + textShadowSize + 'px ' + textShadowSize + 'px black';
	
	      var mod = .6;
	
	      var keystd = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.9 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: ".98vh"
	      };
	
	      var keyspace = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: ".98vh"
	      };
	
	      var keycom = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center',
	        fontSize: ".98vh"
	      };
	
	      var keysubmit = {
	        width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
	        height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
	        margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
	        borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.5 * mod,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	      };
	
	      var unit = this.props.screen.r9_16.p10;
	      var textAlign = this.state.text.length > 0 ? "center" : "left";
	
	      var hasMatchedResults = this.state.renderedStories.length > 0 || this.state.renderedDonors.length > 0;
	      var horizontalRadius = this.props.screen.screenHeight * .00520833333333333333;
	      var verticalRadius = this.props.screen.screenHeight * .00651041666666666667;
	      var margins = {
	        descriptionTop: this.props.screen.screenHeight * .00651041666666666667
	      };
	      var sizes = {
	        title: this.props.screen.screenHeight * .02199074074074074074,
	        description: this.props.screen.screenHeight * .01388888888888888889
	
	        //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.
	
	      };if (!this.props.module) {
	        return _react2.default.createElement('span', null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            className: 'containerFade',
	            style: { minHeight: '100%' },
	            transitionName: 'example',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.hideKeyboard, style: { zIndex: 9999 } },
	            this.state.hideKeyboard && !this.state.showModal ? this.renderBackSearchButton() : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showModal, style: { zIndex: 99999 } },
	            this.state.showModal ? _react2.default.createElement(_StoryTampa2.default, {
	              backgroundImage: backgroundImage,
	              showBackground: true,
	              screen: this.props.screen,
	              screensNumber: this.props.screensNumber,
	              navRoute: this.props.navRoute,
	              story: this.state.story,
	              mode: 'image',
	              clickAction: this.handleBack,
	              contentIndex: this.state.storyIndex
	            }) : null,
	            this.state.showModal ? this.renderBackButton() : null
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize } },
	          _react2.default.createElement(
	            'div',
	            { style: { position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber } },
	            _react2.default.createElement(
	              'div',
	              { style: { display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' } },
	              _react2.default.createElement('div', { style: { height: "4vh" } }),
	              _react2.default.createElement('img', { alt: this.props.module.name, src: iconImage, style: { width: '14vh' } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'crimson-semi-bold', style: { textShadow: textShadow, textAlign: "center", fontSize: '4vh' } },
	              this.props.module.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: "100%", display: "flex", justifyContent: "center" } },
	              _react2.default.createElement(
	                'div',
	                { className: 'crimson-regular', style: { textShadow: textShadow, fontSize: '2vh', textAlign: "center", width: "85%", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" } },
	                this.props.module.description
	              )
	            ),
	            _react2.default.createElement('div', { className: 'topgradblackP25', style: { position: "absolute", width: '100%', height: unit * .25, top: "26.979166667vh", left: 0 } }),
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: this.state.hideKeyboard },
	                !this.state.hideKeyboard ? _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('div', { style: { height: '12vh' } }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: "flex", justifyContent: "center" } },
	                    _react2.default.createElement(
	                      'div',
	                      { style: { display: 'inline-block', width: '45vh', height: "5.83vh", border: "0.3125vh", borderStyle: "solid", borderColor: "#FFFFFF", borderRadius: this.props.screen.r9_16.p10 * 0.8, backgroundColor: "#153f7e" } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: { height: "6.16667vh", display: 'flex', alignItems: 'center', justifyContent: textAlign, fontSize: "1.6vh", color: "white", float: "left", width: "90%" } },
	                        this.state.text.length > 0 ? _react2.default.createElement(
	                          'div',
	                          null,
	                          '\xA0',
	                          this.state.text,
	                          '\xA0'
	                        ) : _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: "2.5vh", fontWeight: "bold" } },
	                          _react2.default.createElement(
	                            'div',
	                            { style: { marginLeft: "6vh" } },
	                            'Enter a donor name'
	                          )
	                        ),
	                        _react2.default.createElement(_reactFontawesome2.default, { style: { fontSize: "2.5vh", position: "absolute", left: "7.8125vh" }, name: 'search' })
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { onClick: this.removeInputText, style: { height: "4.166666667vh", display: 'flex', fontSize: "2vh", color: "white", float: "right", paddingTop: "1.9375vh", paddingRight: "2vh", fontWeight: "bold" } },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: { color: 'black', width: '85%', height: "30vh", display: "block", marginLeft: "auto", marginRight: "auto" } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'helem', style: { position: "relative", paddingTop: "2vh" } },
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [1, 1, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [1, 1, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [2, 2, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [2, 2, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [3, 3, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [3, 3, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [4, 4, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [4, 4, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [5, 5, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [5, 5, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [6, 6, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [6, 6, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [7, 7, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [7, 7, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [8, 8, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [8, 8, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [9, 9, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [9, 9, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [0, 0, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [0, 0, null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [this.deleteText, this.deleteText, this.deleteText], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['DELETE', 'DELETE', 'DELETE'] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['q', 'Q', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['q', 'Q', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['w', 'W', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['w', 'W', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['e', 'E', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['e', 'E', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['r', 'R', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['r', 'R', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['t', 'T', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['t', 'T', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['y', 'Y', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['y', 'Y', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['u', 'U', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['u', 'U', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['i', 'I', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['i', 'I', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['o', 'O', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['o', 'O', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['p', 'P', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['p', 'P', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['@', null, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['@', '@', null] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['a', 'A', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['a', 'A', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['s', 'S', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['s', 'S', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['d', 'D', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['d', 'D', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['f', 'F', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['f', 'F', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['g', 'G', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['g', 'G', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['h', 'H', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['h', 'H', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['j', 'J', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['j', 'J', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['k', 'K', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['k', 'K', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['l', 'L', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['l', 'L', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['_', '_', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['_', '_', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['&', '&', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['&', '&', null] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['z', 'Z', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['z', 'Z', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['x', 'X', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['x', 'X', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['c', 'C', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['c', 'C', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['v', 'V', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['v', 'V', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['b', 'B', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['b', 'B', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['n', 'N', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['n', 'N', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['m', 'M', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['m', 'M', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['.', '.', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['.', '.', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['-', '-', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['-', '-', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['*', '*', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['*', '*', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['?', '?', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['?', '?', null] }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                          'div',
	                          { style: keystd },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'kspn-tampa' },
	                            '=/#'
	                          )
	                        ),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [this.capitalMode, this.normalMode, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['UPCASE', 'DOWNCASE', null] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: [' ', ' ', ' '], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keyspace, contents: ['Space', 'Space', 'Space'] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { keyval: ['.com', '.com', '.com'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keycom, contents: ['.com', '.com', '.com'] }),
	                        _react2.default.createElement(_KeyboardKeyTampa2.default, { searchStr: this.searchStr, keyval: ['Submit', 'Submit', 'Submit'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.submitText, mainstyle: keysubmit, contents: ['Submit', 'Submit', 'Submit'] })
	                      )
	                    )
	                  )
	                ) : null,
	                _react2.default.createElement(
	                  _CSSTransitionGroup2.default,
	                  {
	                    component: 'div',
	                    className: 'containerFade',
	                    style: { minHeight: '100%' },
	                    transitionName: 'example',
	                    transitionEnterTimeout: 0,
	                    transitionLeaveTimeout: 0 },
	                  _react2.default.createElement(
	                    'div',
	                    { key: this.state.search, style: { width: "90%", marginLeft: "auto", marginRight: "auto", position: "relative", height: "73.046875vh", touchAction: "none", top: "7.71604938271604938272vh" } },
	                    this.state.search && !this.state.showStory ? _react2.default.createElement(
	                      _reactIscroll2.default,
	                      { ref: function ref(el) {
	                          return _this3.iScroller = el;
	                        }, iScroll: _iscroll2.default,
	                        options: {
	                          mouseWheel: true,
	                          scrollbars: false,
	                          scrollX: false,
	                          scrollY: true,
	                          probeType: 2,
	                          bounce: false,
	                          momentum: true,
	                          deceleration: 0.005,
	                          useTransition: true,
	                          disableTouch: false,
	                          disablePointer: false,
	                          disableMouse: false,
	                          tap: true
	                        },
	                        onRefresh: this.initializeIScroll
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { style: { position: "relative" } },
	                        this.state.renderedStories && this.state.renderedStories.length > 0 ? _react2.default.createElement(
	                          'div',
	                          { style: { width: "89%", margin: "0 auto" } },
	                          _react2.default.createElement('div', { style: { height: "5vh" } }),
	                          _react2.default.createElement(
	                            'div',
	                            { style: { height: this._regionWidth * 0.0347 } },
	                            _react2.default.createElement(
	                              'span',
	                              { style: { textShadow: textShadow, fontSize: this._regionWidth * 0.015625 } },
	                              'STORIES'
	                            ),
	                            _react2.default.createElement('div', { style: { boxShadow: textShadow, position: "absolute", height: this._regionWidth * 0.0017, background: "white", width: "90%" } })
	                          )
	                        ) : null,
	                        this.state.renderedStories && this.state.renderedStories.length > 0 ? this.state.renderedStories : null,
	                        this.state.renderedStories && this.state.renderedStories.length > 0 && this.state.renderedDonors && this.state.renderedDonors.length > 0 ? _react2.default.createElement('div', { style: { width: "100%", height: this._regionWidth * 0.034 } }) : null,
	                        this.state.renderedDonors.length > 0 && this.state.renderedStories.length === 0 ? _react2.default.createElement('div', { style: { height: "5vh" } }) : null,
	                        this.state.renderedDonors && this.state.renderedDonors.length > 0 ? _react2.default.createElement(
	                          'div',
	                          { style: { width: "89%", margin: "0 auto" } },
	                          _react2.default.createElement(
	                            'div',
	                            { style: { height: this._regionWidth * 0.0347 } },
	                            _react2.default.createElement(
	                              'span',
	                              { style: { textShadow: textShadow, fontSize: this._regionWidth * 0.015625 } },
	                              'DONOR LIST'
	                            ),
	                            _react2.default.createElement('div', { style: { boxShadow: textShadow, position: "absolute", height: this._regionWidth * 0.0017, background: "white", width: "90%" } })
	                          )
	                        ) : null,
	                        this.state.renderedDonors && this.state.renderedDonors.length > 0 ? this.state.renderedDonors : null,
	                        !hasMatchedResults ? _react2.default.createElement(
	                          'div',
	                          { style: { height: "6vh", backgroundColor: "white", position: "relative", top: "10vh", width: "85%", margin: "0 auto", boxShadow: horizontalRadius + 'px ' + verticalRadius + 'px ' + verticalRadius + 'px 0px rgba(0,0,0,0.85)', borderRadius: this.props.screen.screenWidth * .03472222222222222222, paddingTop: "3vh", paddingBottom: "3vh" } },
	                          _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: sizes.title, float: "left", textAlign: "center", width: "100%", color: DARK }, className: 'crimson-semi-bold' },
	                            _react2.default.createElement(
	                              'b',
	                              null,
	                              'Sorry, no results...'
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'opensans-regular', style: { fontSize: sizes.description, float: "left", maxHeight: "6vh", overflow: "hidden", textAlign: "center", width: "100%", marginTop: margins.descriptionTop, display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", color: DARK } },
	                            'Use the Back button to perform a new search'
	                          )
	                        ) : null,
	                        _react2.default.createElement('div', { style: { height: .03375 * this._regionWidth } })
	                      )
	                    ) : null
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserInputTampa;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    content: state.content,
	    donors: state.donors
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(UserInputTampa);

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactIscroll = __webpack_require__(11);
	
	var _reactIscroll2 = _interopRequireDefault(_reactIscroll);
	
	var _iscroll = __webpack_require__(13);
	
	var _iscroll2 = _interopRequireDefault(_iscroll);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import SwipeableViews from 'react-swipeable-views';
	// import { View, ScrollView, StyleSheet } from 'react-native'
	
	
	var spacialEvents;
	
	var Timeline = function (_Component) {
	    _inherits(Timeline, _Component);
	
	    function Timeline(props) {
	        _classCallCheck(this, Timeline);
	
	        var _this = _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, props));
	
	        _this.parseDate = function (date) {
	
	            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	            var monthName = monthNames[date.getMonth()];
	            var monthNumber = String(date.getMonth() + 1);
	            var fullYear = String(date.getFullYear());
	            var shortYear = fullYear.substring(2);
	            var day = String(date.getDate());
	            switch (_this.props.module.contents.date_format) {
	                case "yyyy":
	                    return fullYear;
	                case "mmm-yyyy":
	                    return monthName + "-" + fullYear;
	                case "mm-dd-yyyy":
	                    return monthNumber + "-" + day + "-" + fullYear;
	                case "yy":
	                    return shortYear;
	                case "mmm-yy":
	                    return monthName + "-" + shortYear;
	                case "mm-dd-yy":
	                default:
	                    return monthNumber + "-" + day + "-" + shortYear;
	            }
	        };
	
	        _this.refDict = {};
	        _this.cycleDate = _this.cycleDate.bind(_this);
	        _this.onScrollEnd = _this.onScrollEnd.bind(_this);
	        _this.state = {
	            spacialEvents: null,
	            sideMargin: null,
	            totalWidth: null,
	            currentEvent: 0
	        };
	        return _this;
	    }
	
	    _createClass(Timeline, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _shared2.default.checkData(this.props.module);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var totalWidth = this.props.module.contents.events.length * (this.props.screen.r16_9.width / 10) + this.props.screen.r16_9.width; //better mechanism for full width, # of points?
	            this.getRelativeLocations(this.props.module.contents.events, totalWidth, this.props.screen.r16_9.width / 2);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	
	        // shouldComponentUpdate(){
	        //     return false;
	        // }
	
	    }, {
	        key: 'getRelativeLocations',
	        value: function getRelativeLocations(events, totalWidth, sideMargin) {
	            var _this2 = this;
	
	            spacialEvents = [];
	
	            if (this.props.module.contents.event_spacing === "even") {
	                var iWidth = totalWidth - sideMargin * 2;
	                var eventInc = iWidth / events.length;
	                _lodash2.default.forEach(events, function (event, index) {
	                    var raw = eventInc * index;
	                    var span = raw + sideMargin;
	                    spacialEvents.push({ header: event.header, date: _this2.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images });
	                });
	                this.setState({
	                    spacialEvents: spacialEvents,
	                    sideMargin: sideMargin,
	                    totalWidth: totalWidth
	                });
	            } else {
	                //relative spacing
	                var _iWidth = totalWidth - sideMargin * 2;
	                var fullTimeSpan = events[events.length - 1].date - events[0].date;
	                _lodash2.default.forEach(events, function (event) {
	                    var raw = (event.date - events[0].date) / fullTimeSpan * _iWidth;
	                    var span = raw + sideMargin;
	                    spacialEvents.push({ header: event.header, date: _this2.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images });
	                });
	                this.setState({
	                    spacialEvents: spacialEvents,
	                    sideMargin: sideMargin,
	                    totalWidth: totalWidth
	                });
	            }
	        }
	    }, {
	        key: 'onScrollEnd',
	        value: function onScrollEnd(e) {
	            var xVal = Math.abs(e.x);
	            var tempCurrentEvent = 0;
	            var closestDist = null; //always pinning first to zero
	
	            for (var i = 0; i < spacialEvents.length; i++) {
	                var dist = Math.abs(spacialEvents[i].raw - xVal);
	                if (closestDist === null) {
	                    tempCurrentEvent = i;
	                    closestDist = dist;
	                } else {
	                    if (dist < closestDist) {
	                        tempCurrentEvent = i;
	                        closestDist = dist;
	                    }
	                }
	            }
	
	            this.refDict[0].withIScroll(function (iScroll) {
	                iScroll.scrollTo(-spacialEvents[tempCurrentEvent].raw, 0, 1000);
	            });
	            this.setState({
	                currentEvent: tempCurrentEvent
	            });
	        }
	    }, {
	        key: 'cycleDate',
	        value: function cycleDate(mode, index) {
	            var tempCurrentEvent = this.state.currentEvent;
	            if (mode === 0) {
	                //backward
	                tempCurrentEvent--;
	                if (tempCurrentEvent < 0) {
	                    tempCurrentEvent = spacialEvents.length - 1;
	                }
	            } else if (mode === 1) {
	                //forward
	                tempCurrentEvent++;
	                if (tempCurrentEvent > spacialEvents.length - 1) {
	                    tempCurrentEvent = 0;
	                }
	            } else {
	                //to specific index
	                tempCurrentEvent = index;
	            }
	            this.refDict[0].withIScroll(function (iScroll) {
	                iScroll.scrollTo(-spacialEvents[tempCurrentEvent].raw, 0, 1000);
	            });
	            this.setState({
	                currentEvent: tempCurrentEvent
	            });
	        }
	    }, {
	        key: 'renderSpacialEvents',
	        value: function renderSpacialEvents(tHeight) {
	
	            var circleRadius = this.props.screen.r16_9.p10 * 0.4;
	            var imageWidth = this.props.screen.r16_9.p10 * 1.7;
	
	            var circle = {
	                width: circleRadius,
	                height: circleRadius,
	                WebkitBorderRadius: circleRadius / 2,
	                MozBorderRadius: circleRadius / 2,
	                borderRadius: circleRadius / 2,
	                background: 'white',
	                position: 'absolute',
	                top: tHeight - this.props.screen.r16_9.p10 * 0.75,
	                left: -circleRadius / 2
	            };
	
	            if (this.state.spacialEvents.length === 0) {
	                return _react2.default.createElement('span', null);
	            }
	
	            return this.state.spacialEvents.map(function (row, i) {
	                if (this.state.currentEvent === i) {
	                    //console.log(row); //TODO: this is triggering too often, see on component did update
	                    var rowWidth = this.props.screen.r16_9.p10 * 6;
	                    if (row.text.length > 150) {
	                        rowWidth = this.props.screen.r16_9.p10 * 10;
	                    }
	                    return _react2.default.createElement(
	                        'span',
	                        { key: i, style: { position: 'absolute', left: row.offset, zIndex: 1 } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'fade_on_load' },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { position: 'absolute', left: -rowWidth / 2, fontSize: this.props.screen.r16_9.p10 * 0.45, textAlign: 'center', width: rowWidth } },
	                                row.date
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { position: 'absolute', left: -rowWidth / 2, top: this.props.screen.r16_9.p10 / 2, fontSize: this.props.screen.r16_9.p10 * 0.35, textAlign: 'center', width: rowWidth } },
	                                row.header
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { position: 'absolute', top: this.props.screen.r16_9.p10 * 1.25, left: -rowWidth / 2, fontSize: this.props.screen.r16_9.p10 / 4, display: 'inline-flex', width: rowWidth, height: this.props.screen.r16_9.p10 } },
	                                row.text
	                            ),
	                            _react2.default.createElement('span', { style: { position: 'absolute', top: tHeight - this.props.screen.r16_9.p10 * 1.5, width: this.props.screen.r16_9.p10 * .1, height: this.props.screen.r16_9.p10, left: -this.props.screen.r16_9.p10 * .05, backgroundColor: 'white' } }),
	                            _react2.default.createElement('img', { alt: 'event', src: this.props.screen.dpath + row.images[0].path + row.images[0].file_name, style: { position: 'absolute', top: tHeight - this.props.screen.r16_9.p10 * 3, left: -imageWidth / 2, width: imageWidth, height: imageWidth } })
	                        ),
	                        _react2.default.createElement('span', { style: Object.assign({}, circle) })
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'span',
	                        { key: i, style: { position: 'absolute', left: row.offset, zIndex: 0 } },
	                        _react2.default.createElement(
	                            'span',
	                            { style: { position: 'absolute', fontSize: this.props.screen.r16_9.p10 * 0.45, top: tHeight - this.props.screen.r16_9.p10 * 4, height: this.props.screen.r16_9.p10 * 3, width: 1, textAlign: 'center' } },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { right: this.props.screen.r16_9.p10 * .3, top: 0, width: this.props.screen.r16_9.p10 * 3, textAlign: 'left' }, className: 'rotate90' },
	                                row.date
	                            )
	                        ),
	                        _react2.default.createElement('span', { style: Object.assign({}, circle) })
	                    );
	                }
	            }, this);
	        }
	    }, {
	        key: 'renderQuickJumps',
	        value: function renderQuickJumps() {
	
	            var iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' };
	            var iconStyleActive = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .75' };
	
	            return this.state.spacialEvents.map(function (row, i) {
	                var _this3 = this;
	
	                if (this.state.currentEvent === i) {
	                    return _react2.default.createElement(
	                        'span',
	                        { key: i, style: { display: 'inline-block', width: this.props.screen.r16_9.p10 * .6, position: 'relative', fontSize: this.props.screen.r16_9.p10 } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'phand', style: iconStyleActive },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                        )
	                    );
	                } else {
	                    return _react2.default.createElement(
	                        'span',
	                        { onMouseDown: function onMouseDown(e) {
	                                return _this3.cycleDate(2, i);
	                            }, key: i, style: { display: 'inline-block', width: this.props.screen.r16_9.p10 * .6, position: 'relative', fontSize: this.props.screen.r16_9.p10 / 2 } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'phand', style: iconStyle },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
	                        )
	                    );
	                }
	            }, this);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' };
	            if (!this.state.spacialEvents) {
	                return _react2.default.createElement('div', null);
	            }
	
	            var cycleDateStyle = {
	                color: 'white',
	                height: this.props.screen.screenHeight * .06,
	                fontSize: this.props.screen.screenHeight * .06,
	                zIndex: 99
	            };
	
	            var tTop = this.props.screen.screenHeight * .15;
	            var tHeight = this.props.screen.screenHeight * .6;
	            var relativeLocations = this.renderSpacialEvents(tHeight);
	            var quickJumps = this.renderQuickJumps();
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'fixed', top: tTop, left: this.props.screen.r16_9.left, height: tHeight, width: this.props.screen.r16_9.width, touchAction: "none" } },
	                _react2.default.createElement(
	                    _reactIscroll2.default,
	                    { ref: function ref(el) {
	                            return _this4.refDict[0] = el;
	                        }, iScroll: _iscroll2.default,
	                        onScrollEnd: this.onScrollEnd,
	                        onRefresh: this.onRefresh,
	                        options: {
	                            mouseWheel: true,
	                            scrollbars: false,
	                            scrollX: true,
	                            probeType: 2,
	                            bounce: false,
	                            momentum: true,
	                            deceleration: 0.015,
	                            useTransition: true,
	                            disableTouch: false,
	                            disablePointer: false,
	                            disableMouse: false
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: this.state.totalWidth, height: tHeight } },
	                        relativeLocations
	                    )
	                ),
	                _react2.default.createElement('div', { style: { position: 'absolute', bottom: this.props.screen.r16_9.p10 * .5, backgroundColor: 'white', width: this.props.screen.r16_9.width, height: this.props.screen.r16_9.p10 * .1 } }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: 'center', margin: '0 auto' } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'phand', style: cycleDateStyle },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'phand', onMouseDown: function onMouseDown(e) {
	                                    return _this4.cycleDate(0);
	                                }, style: iconStyle },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-left' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: { dislay: 'inline-block', width: this.props.screen.r16_9.p10 * .1 } },
	                        '\xA0'
	                    ),
	                    quickJumps,
	                    _react2.default.createElement(
	                        'span',
	                        { style: { dislay: 'inline-block', width: this.props.screen.r16_9.p10 * .1 } },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'phand', style: cycleDateStyle },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'phand', onMouseDown: function onMouseDown(e) {
	                                    return _this4.cycleDate(1);
	                                }, style: iconStyle },
	                            _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-circle-right' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Timeline;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	
	    var dm = void 0;
	    if (state.options.idleModule || state.options.idleModule === 0) {
	        dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data;
	    } else {
	        dm = state.content.dm_active[state.active_module];
	    }
	
	    return {
	        content: state.content,
	        screen: state.screen,
	        module: dm
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Timeline);

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputConfirmation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputConfirmation = exports.InputConfirmation = function (_Component) {
	    _inherits(InputConfirmation, _Component);
	
	    function InputConfirmation(props) {
	        _classCallCheck(this, InputConfirmation);
	
	        var _this = _possibleConstructorReturn(this, (InputConfirmation.__proto__ || Object.getPrototypeOf(InputConfirmation)).call(this, props));
	
	        _this.navOutTimeout = null;
	        return _this;
	    }
	
	    _createClass(InputConfirmation, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.navOutTimeout = setTimeout(function () {
	                _this2.navOut();
	                _this2.navOutTimeout = null;
	            }, 10000);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.navOutTimeout);
	            this.navOutTimeout = null;
	        }
	    }, {
	        key: 'navOut',
	        value: function navOut() {
	            this.props.navback();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'fixed', textAlign: 'center', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.screenHeight } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { height: '100%' }, className: 'aligner' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'aligner-item', style: { fontSize: this.props.screen.r16_9.p10 * .6 } },
	                            this.props.module.contents.inputConfirmation
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InputConfirmation;
	}(_react.Component);
	
	exports.default = InputConfirmation;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KeyboardKey = __webpack_require__(158);
	
	var _KeyboardKey2 = _interopRequireDefault(_KeyboardKey);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserInput = function (_Component) {
	  _inherits(UserInput, _Component);
	
	  function UserInput(props) {
	    _classCallCheck(this, UserInput);
	
	    var _this = _possibleConstructorReturn(this, (UserInput.__proto__ || Object.getPrototypeOf(UserInput)).call(this, props));
	
	    _this.state = {
	      text: "",
	      module: _this.props.module,
	      virtual_keyboard_mode: 0
	    };
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.deleteText = _this.deleteText.bind(_this);
	    _this.normalMode = _this.normalMode.bind(_this);
	    _this.capitalMode = _this.capitalMode.bind(_this);
	    _this.submitText = _this.submitText.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserInput, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(prevProps, prevState) {
	      if (_shared2.default.shallowEqual(this.state, prevState)) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(val) {
	      if (typeof val === "function") {
	        val();
	      } else {
	        var str = this.state.text + val;
	        if (str.length < 40) {
	          this.setState({
	            text: str
	          });
	        }
	      }
	    }
	  }, {
	    key: 'normalMode',
	    value: function normalMode() {
	      this.setState({
	        virtual_keyboard_mode: 0
	      });
	    }
	  }, {
	    key: 'capitalMode',
	    value: function capitalMode() {
	      this.setState({
	        virtual_keyboard_mode: 1
	      });
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText() {
	      if (this.state.text.length > 0) {
	        var str = this.state.text.substring(0, this.state.text.length - 1);
	        this.setState({
	          text: str
	        });
	      }
	    }
	  }, {
	    key: 'submitText',
	    value: function submitText() {
	      //this.props.submitUserInput({ text: this.state.text }); TODO: need to setup slim app to handle this
	      this.props.navroute(null, "Input Confirmation", "Input Submit", null);
	      //this.props.history.push('/input_confirmation');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var headerStyle = {
	        color: 'white',
	        fontSize: this.props.screen.r16_9.p10 * 0.35,
	        lineHeight: String(this.props.screen.r16_9.p10 * 0.6 * 0.78) + "px"
	      };
	
	      var textStyle = {
	        color: 'white',
	        fontSize: this.props.screen.r16_9.p10 * 0.35
	      };
	
	      var keystd = {
	        width: this.props.screen.r16_9.p10 * 0.8,
	        height: this.props.screen.r16_9.p10 * 0.8,
	        margin: this.props.screen.r16_9.p10 * 0.04,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	
	        // let keyhide = {
	        //   width: this.props.displayData.sizes.s4,
	        //   height: this.props.displayData.sizes.s4,
	        //   margin: this.props.displayData.sizes.marginTiny,
	        //   display: 'inline-block',
	        //   backgroundColor: 'white',
	        //   textAlign: 'center',
	        // }    
	
	      };var keyspace = {
	        width: this.props.screen.r16_9.p10 * 1.6,
	        height: this.props.screen.r16_9.p10 * 0.8,
	        margin: this.props.screen.r16_9.p10 * 0.04,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	      };
	
	      var keycom = {
	        width: this.props.screen.r16_9.p10 * 1.6,
	        height: this.props.screen.r16_9.p10 * 0.8,
	        margin: this.props.screen.r16_9.p10 * 0.04,
	        display: 'inline-block',
	        backgroundColor: 'white',
	        textAlign: 'center'
	
	        //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.
	
	      };return _react2.default.createElement(
	        'div',
	        { style: { position: 'fixed', left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: '100vh', fontSize: this.props.screen.r16_9.p10 * 0.35, color: 'black' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'helem velem', style: { position: 'relative' } },
	          _react2.default.createElement(
	            'span',
	            { style: headerStyle },
	            this.state.module.contents.header
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { style: textStyle },
	            this.state.module.contents.text
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'inline-block', width: '30vw', height: this.props.screen.r16_9.p10 * 1, backgroundColor: "#c5dae7" } },
	            _react2.default.createElement(
	              'span',
	              { style: { height: this.props.screen.r16_9.p10 * 1, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
	              '\xA0',
	              this.state.text,
	              '\xA0'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [1, 1, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [1, 1, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [2, 2, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [2, 2, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [3, 3, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [3, 3, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [4, 4, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [4, 4, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [5, 5, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [5, 5, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [6, 6, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [6, 6, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [7, 7, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [7, 7, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [8, 8, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [8, 8, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [9, 9, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [9, 9, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [0, 0, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: [0, 0, null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [this.deleteText, this.deleteText, this.deleteText], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['DELETE', 'DELETE', 'DELETE'] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['q', 'Q', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['q', 'Q', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['w', 'W', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['w', 'W', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['e', 'E', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['e', 'E', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['r', 'R', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['r', 'R', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['t', 'T', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['t', 'T', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['y', 'Y', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['y', 'Y', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['u', 'U', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['u', 'U', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['i', 'I', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['i', 'I', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['o', 'O', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['o', 'O', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['p', 'P', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['p', 'P', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['@', null, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['@', '@', null] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['a', 'A', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['a', 'A', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['s', 'S', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['s', 'S', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['d', 'D', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['d', 'D', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['f', 'F', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['f', 'F', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['g', 'G', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['g', 'G', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['h', 'H', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['h', 'H', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['j', 'J', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['j', 'J', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['k', 'K', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['k', 'K', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['l', 'L', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['l', 'L', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['_', '_', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['_', '_', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['&', '&', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['&', '&', null] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['z', 'Z', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['z', 'Z', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['x', 'X', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['x', 'X', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['c', 'C', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['c', 'C', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['v', 'V', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['v', 'V', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['b', 'B', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['b', 'B', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['n', 'N', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['n', 'N', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['m', 'M', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['m', 'M', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['.', '.', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['.', '.', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['-', '-', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['-', '-', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['*', '*', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['*', '*', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['?', '?', null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['?', '?', null] }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { style: keystd },
	            _react2.default.createElement(
	              'span',
	              { className: 'kspn' },
	              '=/#'
	            )
	          ),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [this.capitalMode, this.normalMode, null], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keystd, contents: ['UPCASE', 'DOWNCASE', null] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: [' ', ' ', ' '], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keyspace, contents: ['SPACE', 'SPACE', 'SPACE'] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['.com', '.com', '.com'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.handleKeyPress, mainstyle: keycom, contents: ['.com', '.com', '.com'] }),
	          _react2.default.createElement(_KeyboardKey2.default, { keyval: ['Submit', 'Submit', 'Submit'], virtual_keyboard_mode: this.state.virtual_keyboard_mode, handleKeyPress: this.submitText, mainstyle: keycom, contents: ['Submit', 'Submit', 'Submit'] })
	        )
	      );
	    }
	  }]);
	
	  return UserInput;
	}(_react.Component);
	
	exports.default = UserInput;

/***/ },
/* 500 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.contentHasErrored = contentHasErrored;
	exports.contentIsLoading = contentIsLoading;
	exports.contentFetchSuccess = contentFetchSuccess;
	exports.fetchContent = fetchContent;
	exports.fetchModuleContent = fetchModuleContent;
	function contentHasErrored(bool) {
	    return {
	        type: 'CONTENT_HAS_ERRORED',
	        contentHasErrored: bool
	    };
	}
	
	function contentIsLoading(bool) {
	    return {
	        type: 'CONTENT_IS_LOADING',
	        contentIsLoading: bool
	    };
	}
	
	function contentFetchSuccess(content) {
	    return {
	        type: 'CONTENT_FETCH_SUCCESS',
	        content: content
	    };
	}
	
	function fetchContent(url, lastUpdated, webkey) {
	    return function (dispatch) {
	        var now = new Date();
	        var rev = now.getTime() / 1000;
	        if (url.includes('?')) {
	            url += "&rev=" + rev;
	        } else {
	            url += "?rev=" + rev;
	        }
	        if (webkey) {
	            url += "&webkey=" + webkey;
	        }
	        fetch(url).then(function (response) {
	            if (!response.ok) {
	                throw Error(response.statusText);
	            }
	            return response;
	        }).then(function (response) {
	            return response.json();
	        }).then(function (content) {
	            if (Number(content.last_update) > Number(lastUpdated)) {
	                dispatch(contentFetchSuccess(content));
	            } else {
	                return null;
	            }
	        }).catch(function () {
	            dispatch(contentHasErrored(true));
	        });
	    };
	}
	
	function fetchModuleContent(url, webkey) {
	    return function (dispatch) {
	        if (webkey) {
	            url += "&webkey=" + webkey;
	        }
	        fetch(url).then(function (response) {
	            if (!response.ok) {
	                throw Error(response.statusText);
	            }
	            return response;
	        }).then(function (response) {
	            return response.json();
	        }).then(function (content) {
	            dispatch(contentFetchSuccess(content));
	        }).catch(function () {
	            dispatch(contentHasErrored(true));
	        });
	    };
	}

/***/ },
/* 501 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.donorsHasErrored = donorsHasErrored;
	exports.donorsIsLoading = donorsIsLoading;
	exports.donorsFetchSuccess = donorsFetchSuccess;
	exports.fetchDonors = fetchDonors;
	function donorsHasErrored(bool) {
	    return {
	        type: 'DONORS_HAS_ERRORED',
	        donorsHasErrored: bool
	    };
	}
	
	function donorsIsLoading(bool) {
	    return {
	        type: 'DONORS_IS_LOADING',
	        donorsIsLoading: bool
	    };
	}
	
	function donorsFetchSuccess(donors) {
	    return {
	        type: 'DONORS_FETCH_SUCCESS',
	        donors: donors
	    };
	}
	
	function fetchDonors(url, lastUpdated, webkey) {
	    return function (dispatch) {
	        var now = new Date();
	        var rev = now.getTime() / 1000;
	        if (url.includes('?')) {
	            url += "&rev=" + rev;
	        } else {
	            url += "?rev=" + rev;
	        }
	        if (webkey) {
	            url += "&webkey=" + webkey;
	        }
	        fetch(url).then(function (response) {
	            if (!response.ok) {
	                throw Error(response.statusText);
	            }
	            return response;
	        }).then(function (response) {
	            return response.json();
	        }).then(function (donors) {
	            // console.log("donor response");
	            // console.log(donors);
	            if (Number(donors.last_update) > Number(lastUpdated)) {
	                dispatch(donorsFetchSuccess(donors));
	            } else {
	                return null;
	            }
	        }).catch(function (error) {
	            dispatch(donorsHasErrored(true));
	        });
	    };
	}

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _package = __webpack_require__(175);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DebugContainer = function (_Component) {
	    _inherits(DebugContainer, _Component);
	
	    function DebugContainer(props) {
	        _classCallCheck(this, DebugContainer);
	
	        var _this = _possibleConstructorReturn(this, (DebugContainer.__proto__ || Object.getPrototypeOf(DebugContainer)).call(this, props));
	
	        _this.viewContent = function () {
	            _this.setState({
	                contentArea: JSON.stringify(_this.props.content)
	            });
	        };
	
	        _this.viewDonors = function () {
	            _this.setState({
	                contentArea: JSON.stringify(_this.props.donors)
	            });
	        };
	
	        _this.viewScreen = function () {
	            _this.setState({
	                contentArea: JSON.stringify(_this.props.screen)
	            });
	        };
	
	        _this.handleKeyDown = function (event) {
	            switch (event.key) {
	                case "c":
	                    _this.viewContent();
	                    break;
	                case "d":
	                    _this.viewDonors();
	                    break;
	                case "s":
	                    _this.viewScreen();
	                    break;
	                case "\\":
	                    // this.var.doesnt.exist; //crash the app
	                    break;
	                default:
	                    break;
	            }
	        };
	
	        _this.renderCommands = function () {
	            console.log("render commands");
	            return _this._commands.map(function (row, i) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                        'td',
	                        { style: { border: '1px solid black' } },
	                        row.command
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { style: { border: '1px solid black' } },
	                        row.action
	                    )
	                );
	            });
	        };
	
	        _this.categoryRefs = [];
	
	        _this.state = {
	            contentArea: ""
	        };
	
	        _this._commands = [{ command: 'c', action: 'displays this.props.content' }, { command: 'd', action: 'displays this.props.donors' }, { command: 's', action: 'displays this.props.screen' }, { command: '\\', action: 'crashes the application (test error)' }];
	        return _this;
	    }
	
	    _createClass(DebugContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            console.log("TRYING TO RENDER DEBUG");
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Debug Output ',
	                    _react2.default.createElement('br', null),
	                    'Version: ',
	                    _package2.default.version,
	                    ' ',
	                    _react2.default.createElement('br', null),
	                    'Entry Point: ',
	                    _lodash2.default.get(this.props, 'content.entry_point', "")
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { style: { width: '100%', textAlign: 'left', border: '1px solid black', borderCollapse: 'collapse' } },
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { style: { border: '1px solid black' } },
	                            'Command'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { border: '1px solid black' } },
	                            'Action'
	                        )
	                    ),
	                    this.renderCommands()
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('hr', null),
	                'Debug Content:',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { style: { backgroundColor: '#E8E8EE', height: 300, width: '100%', overflowY: 'scroll' } },
	                    this.state.contentArea
	                )
	            );
	        }
	    }]);
	
	    return DebugContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        content: state.content,
	        donors: state.donors,
	        screen: state.screen
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(DebugContainer);

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(38);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _reactRedux = __webpack_require__(5);
	
	var _display = __webpack_require__(28);
	
	var _shared3 = __webpack_require__(4);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Story = __webpack_require__(412);
	
	var _Story2 = _interopRequireDefault(_Story);
	
	var _Stories = __webpack_require__(411);
	
	var _Stories2 = _interopRequireDefault(_Stories);
	
	var _DonorList = __webpack_require__(392);
	
	var _DonorList2 = _interopRequireDefault(_DonorList);
	
	var _DonorListPassive = __webpack_require__(393);
	
	var _DonorListPassive2 = _interopRequireDefault(_DonorListPassive);
	
	var _UserInput = __webpack_require__(499);
	
	var _UserInput2 = _interopRequireDefault(_UserInput);
	
	var _InputConfirmation = __webpack_require__(498);
	
	var _InputConfirmation2 = _interopRequireDefault(_InputConfirmation);
	
	var _Slideshow = __webpack_require__(410);
	
	var _Slideshow2 = _interopRequireDefault(_Slideshow);
	
	var _RecentDonors = __webpack_require__(398);
	
	var _RecentDonors2 = _interopRequireDefault(_RecentDonors);
	
	var _Timeline = __webpack_require__(497);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _TimelineChicago = __webpack_require__(426);
	
	var _TimelineChicago2 = _interopRequireDefault(_TimelineChicago);
	
	var _Search = __webpack_require__(409);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Results = __webpack_require__(408);
	
	var _Results2 = _interopRequireDefault(_Results);
	
	var _TestMin = __webpack_require__(151);
	
	var _TestMin2 = _interopRequireDefault(_TestMin);
	
	var _NavigationSide = __webpack_require__(402);
	
	var _NavigationSide2 = _interopRequireDefault(_NavigationSide);
	
	var _NavButton = __webpack_require__(506);
	
	var _NavButton2 = _interopRequireDefault(_NavButton);
	
	var _AttractLoopContainer = __webpack_require__(421);
	
	var _AttractLoopContainer2 = _interopRequireDefault(_AttractLoopContainer);
	
	var _DonorListChicago = __webpack_require__(422);
	
	var _DonorListChicago2 = _interopRequireDefault(_DonorListChicago);
	
	var _DonorListChicagoSimple = __webpack_require__(423);
	
	var _DonorListChicagoSimple2 = _interopRequireDefault(_DonorListChicagoSimple);
	
	var _StoriesFoldersChicago = __webpack_require__(425);
	
	var _StoriesFoldersChicago2 = _interopRequireDefault(_StoriesFoldersChicago);
	
	var _NavBottomFixed = __webpack_require__(401);
	
	var _NavBottomFixed2 = _interopRequireDefault(_NavBottomFixed);
	
	var _InteractBottomFixed = __webpack_require__(400);
	
	var _InteractBottomFixed2 = _interopRequireDefault(_InteractBottomFixed);
	
	var _sailsIo = __webpack_require__(140);
	
	var _sailsIo2 = _interopRequireDefault(_sailsIo);
	
	var _socket = __webpack_require__(141);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//components
	
	
	var _videoStyle = {
	  preload: 'auto',
	  position: 'fixed',
	  minWidth: '100%',
	  minHeight: '100%',
	  width: 'auto',
	  height: 'auto',
	  zIndex: -100,
	  loop: '',
	  autoplay: "",
	  muted: "",
	  pointerEvents: "none"
	};
	var recent_interaction_timeout = 5000;
	var FOLDER_ATTRACT = "folder";
	var LEGACY_ATTRACT = "legacy";
	
	var DisplayContainer = function (_Component) {
	  _inherits(DisplayContainer, _Component);
	
	  function DisplayContainer(props) {
	    _classCallCheck(this, DisplayContainer);
	
	    var _this = _possibleConstructorReturn(this, (DisplayContainer.__proto__ || Object.getPrototypeOf(DisplayContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._contentInterval = null;
	    _this._donorsInterval = null;
	    _this._useFolders = false;
	    // this.navroute = this.navroute.bind(this);
	    _this.navback = _this.navback.bind(_this);
	    _this.handleNavigationSlide = _this.handleNavigationSlide.bind(_this);
	    _this.toggleSlideOn = _this.toggleSlideOn.bind(_this);
	    _this.toggleSlideOff = _this.toggleSlideOff.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this._videoModalRef = null;
	    _this._audioRef = null;
	    _this._assetFile = null;
	    _this._audioAssetFile = null;
	    _this._attractLoopMode = null;
	
	    _this.idleRef = 0;
	    _this._idleLoopTimeout = null;
	    _this._announcementAsset = null;
	    _this._announcementAudioAsset = null;
	    _this._announcementTimeout = null;
	    _this._recentInteractionTimeout = null;
	    _this.lastInteraction = new Date();
	    _this._attractLoopTree = {};
	    // this.setupElements();
	
	    _this.state = {
	      displayNav: false,
	      options: {},
	      idle: false,
	      recentInteraction: false,
	      navback: {},
	      showNav: true,
	      donorsInit: false,
	      showModal: false,
	      showModalVideo: false,
	      showClock: true,
	      module: {},
	      otherModules: [],
	      attractLoopRef: 0
	    };
	    return _this;
	  }
	
	  _createClass(DisplayContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Socket Subscribe and event binding.
	      var socketsEnabled = _lodash2.default.get(_config2.default, 'sockets.enabled', false);
	      if (socketsEnabled) {
	        this.websocketHandler();
	      }
	
	      document.addEventListener("keydown", this.handleKeyDown);
	      if (this.props.jumpToModule === true) {
	        this.navroute(null, null, "jumpto", { routeoverride: this.props.routeoverride });
	      }
	
	      if (this.props.content.idle_delay) {
	        this._idleDelay = this.props.content.idle_delay * 1000;
	      } else {
	        this._idleDelay = 120000;
	      }
	
	      // Idle interaction Attract Loop.
	      if (this.props.idleActive) {
	        if (this.props.content.idle_delay > 0) {
	          if (!this.props.content.settings.disallowInteraction) {
	            window.addEventListener('mousedown', this.pageClick, false);
	          }
	          // Check if folder Attract Loop or Legacy
	          var folderAttractLoop = _lodash2.default.get(this.props.content.settings, 'folderAttractLoop', false);
	          var topAttractLoop = _lodash2.default.filter(this.props.content.story_categories, { parent_category: null, contents: { custom_fields: { folder_type: { val: { value: "attract_loop" } } } } });
	          topAttractLoop = topAttractLoop[0];
	          var rootFolderId = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	
	          // console.log(folderAttractLoop);
	          if (folderAttractLoop) {
	            // console.log(rootFolderId);
	            if (rootFolderId) {
	              var rootFolder = this.props.content.story_categories.find(function (f) {
	                return f.id === Number(rootFolderId);
	              });
	              var rootFolderType = _lodash2.default.get(rootFolder, 'contents.custom_fields.folder_type.val.value', null);
	              if (rootFolderType && rootFolderType.includes("attract_loop")) {
	                topAttractLoop = rootFolder;
	              }
	            }
	            this._attractLoopMode = LEGACY_ATTRACT;
	            // console.log(topAttractLoop);
	            if (topAttractLoop) {
	              this._attractLoopMode = FOLDER_ATTRACT;
	              this._attractLoopTree = _shared2.default.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, topAttractLoop.name, 'contents.sorting_date', 'desc');
	
	              // console.log(this._attractLoopTree);
	              this.props.setOptions({
	                attractLoopTree: this._attractLoopTree
	              });
	
	              this.folderCheckRecentInteraction();
	              this.checkIdleTimeout();
	              this.folderGoIdle("idle");
	            }
	          } else {
	            this._attractLoopMode = LEGACY_ATTRACT;
	            this.checkRecentInteraction();
	            this.checkIdleTimeout();
	            this.goIdle("idle");
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      clearInterval(this._contentInterval);
	      clearInterval(this._donorsInterval);
	      window.removeEventListener('mousedown', this.pageClick, false);
	      clearTimeout(this._idleTimeout);
	      clearTimeout(this._recentInteractionTimeout);
	      clearTimeout(this._audioCycle);
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      switch (event.key) {
	        case "s":
	          console.log(this.props);
	          break;
	        case "i":
	          this.goIdle();
	          break;
	        case "m":
	          this.setupAsset(JSON.stringify({ subject: "baby" }));
	          break;
	        case "n":
	          this.setupAsset(JSON.stringify({ subject: "baby_boy" }));
	          break;
	        case "b":
	          this.setupAsset(JSON.stringify({ subject: "baby_girl" }));
	          break;
	        default:
	          break;
	      }
	
	      if (this.state.idle) {
	        clearTimeout(this._idleLoopTimeout);
	        switch (event.keyCode) {
	          case 37:
	            if (this.idleRef < 2) {
	              this.idleRef = this._attractLoopMode.children.length - 1;
	            } else {
	              this.idleRef = this.idleRef - 2;
	            }
	            this.folderCycleIdle();
	            this.folderCycleIdleLoop();
	            break;
	          // Right Arrow (Next)
	          case 39:
	            this.folderCycleIdle();
	            this.folderCycleIdleLoop();
	            break;
	          default:
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'handleNavigationSlide',
	    value: function handleNavigationSlide() {
	      if (this.state.displayNav === false) {
	        this.toggleSlideOn();
	      } else {
	        this.toggleSlideOff();
	      }
	    }
	  }, {
	    key: 'toggleSlideOff',
	    value: function toggleSlideOff() {
	      this.setState({
	        displayNav: false
	      });
	    }
	  }, {
	    key: 'toggleSlideOn',
	    value: function toggleSlideOn() {
	      this.setState({
	        displayNav: true
	      });
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal() {
	      var _this2 = this;
	
	      var fileType = (0, _shared3.getFileType)(this._assetFile);
	      if (fileType === "video") {
	        if (!this.state.showModalVideo) {
	          this.setState({
	            showModalVideo: true
	          });
	        }
	      } else {
	        if (!this.state.showModal) {
	          this.setState({
	            showModal: true
	          });
	
	          this._modalCycle = setTimeout(function () {
	            _this2.setState({
	              showModal: false
	            });
	          }, this._announcementTimeout);
	        }
	      }
	
	      // Check for the audio asset
	      if (this._audioAssetFile) {
	        var audioFileType = (0, _shared3.getFileType)(this._audioAssetFile);
	        // console.log("2.- Filetype", audioFileType);
	        if (audioFileType === "audio") {
	          if (!this.state.playAudio) {
	            this.setState({
	              playAudio: true
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var fileType = (0, _shared3.getFileType)(this._announcementAsset);
	      if (fileType === "video") {
	        if (this.state.showModalVideo) {
	          this.setState({
	            showModalVideo: false
	          });
	          clearTimeout(this._modalCycle);
	        }
	      } else {
	        if (this.state.showModal) {
	          this.setState({
	            showModal: false
	          });
	          clearTimeout(this._modalCycle);
	        }
	      }
	    }
	
	    //pass the module ref as an option, when rendering story pass a story ref (typically 0) to ref which story
	
	  }, {
	    key: 'setNavBack',
	    value: function setNavBack(ref, type, source, options) {
	      this.setState({
	        navback: { ref: ref, type: type, source: source, options: options }
	      });
	    }
	  }, {
	    key: 'navback',
	    value: function navback() {
	      if (!this.state.navback.ref) {
	        //handle case where user has visited no other module that user input
	        this.setState({
	          navback: { ref: 0, type: this.props.content.dm_active[0].display_module_type, source: "navback", options: [] }
	        });
	        this.navroute(0, this.props.content.dm_active[0].display_module_type, "navback", []);
	      } else {
	        this.navroute(this.state.navback.ref, this.state.navback.type, this.state.navback.source, this.state.navback.options);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (!this.props.content.dm_active || !this.props.screen) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading ...'
	        );
	      }
	
	      var location = this.props.location;
	
	      var key = this.props.location.pathname + this.props.location.search;
	      var backgroundFile = this.renderLayer(this.props.content.settings.lower_layer_file, 1, 'background');
	      var foregroundFile = this.renderLayer(this.props.content.settings.upper_layer_file, this.props.content.settings.upper_layer_opacity, 'foreground');
	      var navClass = "";
	      var backDropClass = "backdropOff";
	      if (this.state.displayNav === true) {
	        navClass += " on";
	        backDropClass = "backdropOn";
	      }
	
	      var storiesWithProps = function storiesWithProps(props) {
	        return _react2.default.createElement(_Stories2.default, Object.assign({
	          categories: _this3.props.content.story_categories,
	          navroute: _this3.navroute
	        }, props));
	      };
	
	      var folderStoriesWithProps = function folderStoriesWithProps(props) {
	        // console.log(props);
	        // return (<div></div>);
	        return _react2.default.createElement(_Stories2.default, Object.assign({
	          categories: _this3.props.content.story_categories,
	          navroute: _this3.navroute,
	          useFolders: true
	        }, props));
	      };
	
	      var modalStyle = {
	        position: 'absolute',
	        height: this.props.screen.screenHeight,
	        width: this.props.screen.screenWidth,
	        // backgroundColor:'#a4bcc2',
	        zIndex: 9999
	      };
	
	      var _videoStyle = {
	        preload: 'auto',
	        position: 'absolute',
	        muted: "",
	        objectFit: "fill",
	        width: this.state.videoMaxWidth,
	        height: this.state.videoMaxHeight
	      };
	
	      var _btnStyle = {
	        color: 'white',
	        position: 'absolute',
	        fontSize: this.props.screen.screenHeight * 0.05,
	        fontStyle: 'normal',
	        fontWeight: 'bold',
	        textDecoration: 'none',
	        zIndex: 9999
	      };
	
	      var cType = "";
	      if (this.state.showModalVideo) {
	        cType = (0, _shared3.videoType)(this._announcementAsset);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'noselect' },
	        this.props.content.settings.showNav === undefined || this.props.content.settings.showNav === true ? _react2.default.createElement(_NavButton2.default, { showNav: this.state.showNav, recentInteraction: this.state.recentInteraction, animate: this.props.content.settings.animateNav, screen: this.props.screen, handleNavigationSlide: this.handleNavigationSlide, idle: this.state.idle }) : _react2.default.createElement('span', null),
	        this._attractLoopMode === FOLDER_ATTRACT ? _react2.default.createElement(_AttractLoopContainer2.default, { tree: this._attractLoopTree, attractLoopRef: this.state.attractLoopRef }) : null,
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            transitionName: 'slowfadedelay',
	            transitionEnterTimeout: 0,
	            transitionLeaveTimeout: 0 },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showModal },
	            this.state.showModal ? _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, modalStyle) },
	              _react2.default.createElement(
	                'a',
	                { href: '#', onClick: function onClick() {
	                    _this3.closeModal();
	                  }, ref: function ref(el) {
	                    return _this3._closeModalRef = el;
	                  }, style: Object.assign({}, _btnStyle, { top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }) },
	                'X'
	              ),
	              _react2.default.createElement('img', { alt: "Announcement Modal", style: { position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }, src: this._announcementAsset, ref: function ref(el) {
	                  return _this3._imageModalRef = el;
	                }, onLoad: this.handleImageLoaded.bind(this) })
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showModalVideo },
	            this.state.showModalVideo ? _react2.default.createElement(
	              'div',
	              { style: Object.assign({}, modalStyle, { backgroundColor: "black" }) },
	              _react2.default.createElement(
	                'video',
	                { style: Object.assign({}, _videoStyle, { top: this.state.videoOffsetY, left: this.state.videoOffsetX }), ref: function ref(el) {
	                    return _this3._videoModalRef = el;
	                  }, onLoadedMetadata: this.loadedMetadata.bind(this), autoPlay: true },
	                _react2.default.createElement('source', { src: this._announcementAsset, type: cType }),
	                'Your browser does not support the video tag.'
	              )
	            ) : null
	          )
	        ),
	        this.state.playAudio ? _react2.default.createElement('audio', { ref: function ref(el) {
	            return _this3._audioRef = el;
	          }, src: this._announcementAudioAsset, onLoadedMetadata: this.loadedAudioMetadata.bind(this) }) : null,
	        this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.bottomnav === "true" && !this.props.content.settings.disallowInteraction ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_NavBottomFixed2.default, { content: this.props.content, donors: this.props.donors, idle: this.state.idle, navroute: this.navroute, screen: this.props.screen }),
	          _react2.default.createElement(
	            'div',
	            { style: { left: this.props.screen.r16_9.left, pointerEvents: 'none', position: 'absolute', zIndex: 101, width: this.props.screen.r16_9.width, height: this.props.screen.screenHeight } },
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                className: 'containerFade',
	                style: { minHeight: '100%' },
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: this.state.idle },
	                this.state.idle ? _react2.default.createElement(
	                  'div',
	                  { style: { position: 'fixed', width: this.props.screen.r16_9.width, height: this.props.screen.r16_9.p10, bottom: 0, backgroundColor: '#a4bcc2' } },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { display: 'flex', alignItems: "center", width: this.props.screen.r16_9.width, height: '100%' } },
	                    _react2.default.createElement('img', { alt: 'interact hand', src: '/img/ui/interactbar_hand.png', style: { position: 'absolute', left: this.props.screen.r16_9.p10, height: this.props.screen.r16_9.p10 * .4, width: this.props.screen.r16_9.p10 * .35 } }),
	                    _react2.default.createElement(
	                      'span',
	                      { style: { position: 'absolute', marginTop: this.props.screen.r16_9.p10 * .05, left: this.props.screen.r16_9.p10 * 2, fontFamily: 'Ostrich', fontSize: this.props.screen.r16_9.p10 * .6, color: '#496778' } },
	                      'TOUCH TO BEGIN'
	                    )
	                  )
	                ) : _react2.default.createElement('span', null)
	              )
	            ),
	            _react2.default.createElement(
	              _CSSTransitionGroup2.default,
	              {
	                component: 'div',
	                className: 'containerFade',
	                style: { minHeight: '100%' },
	                transitionName: 'example',
	                transitionEnterTimeout: 0,
	                transitionLeaveTimeout: 0 },
	              _react2.default.createElement(
	                'div',
	                { key: this.state.showClock },
	                this.state.showClock ? _react2.default.createElement(_InteractBottomFixed2.default, { screen: this.props.screen }) : _react2.default.createElement('span', null)
	              )
	            )
	          )
	        ) : _react2.default.createElement('span', null),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.content.font_class, style: { color: this.props.content.settings.main_font_color } },
	          backgroundFile,
	          foregroundFile,
	          _react2.default.createElement('div', { onMouseDown: this.toggleSlideOff, className: backDropClass }),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              className: 'containerFade',
	              transitionName: 'example',
	              style: { minHeight: "100%" },
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              _reactRouterDom.Switch,
	              { key: key, location: location },
	              this.themeSwitch('/story'),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/stories', render: storiesWithProps }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/folder_stories', render: folderStoriesWithProps }),
	              this.themeSwitch('/userinput'),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/userinput', render: function render(props) {
	                  return _react2.default.createElement(_UserInput2.default, Object.assign({}, props, { navroute: _this3.navroute, screen: _this3.props.screen, module: _this3.props.content.dm_active[_this3.props.active_module] }));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/inputconfirmation', render: function render(props) {
	                  return _react2.default.createElement(_InputConfirmation2.default, Object.assign({}, props, { navback: _this3.navback, screen: _this3.props.screen, module: _this3.props.content.dm_active[_this3.props.active_module] }));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/slideshow', render: function render(props) {
	                  return _react2.default.createElement(_Slideshow2.default, Object.assign({}, props, { idle: _this3.state.idle }));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/recentdonors', render: function render(props) {
	                  return _react2.default.createElement(_RecentDonors2.default, Object.assign({}, props, { idle: _this3.state.idle }));
	                } }),
	              this.themeSwitch('/donorlist'),
	              this.themeSwitch('/stories_folders'),
	              this.themeSwitch('/timeline'),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/search', component: _Search2.default }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/results', render: function render(props) {
	                  return _react2.default.createElement(_Results2.default, Object.assign({}, props, { navroute: _this3.navroute }));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/test', component: _TestMin2.default })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'slideout', className: navClass },
	            _react2.default.createElement(_NavigationSide2.default, { modules: this.props.content.dm_active, screen: this.props.screen, navroute: this.navroute })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DisplayContainer;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.setupElements = function () {
	    var announcementModule = _lodash2.default.find(_this4.props.content.dm_active, { display_module_type: "Announcement" });
	    if (announcementModule) {
	      var asset = _lodash2.default.get(announcementModule.contents, "images[0]", null);
	      if (asset) {
	        _this4._assetFile = asset.file_name;
	      }
	
	      var announcementAudioAsset = _lodash2.default.get(announcementModule.contents, "images[1]", null);
	      if (announcementAudioAsset) {
	        _this4._audioAssetFile = announcementAudioAsset.file_name;
	      }
	      _this4._announcementAsset = _shared2.default.dp(_this4.props.screen, asset);
	      _this4._announcementAudioAsset = _shared2.default.dp(_this4.props.screen, announcementAudioAsset);
	
	      _this4._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
	    }
	  };
	
	  this.goIdle = function (type) {
	    if (type === "recentInteraction") {
	      _this4.setState({
	        recentInteraction: false
	      });
	    } else {
	      _this4.toggleShowClock(true);
	      // console.log("Go idle")
	      _this4.setState({
	        idle: true
	      });
	      if (_this4.props.content.display_module_loops[0]) {
	        _this4.cycleIdle();
	        _this4.cycleIdleLoop();
	      }
	    }
	  };
	
	  this.folderGoIdle = function (type) {
	    if (type === "recentInteraction") {
	      _this4.setState({
	        recentInteraction: false
	      });
	    } else {
	      _this4.toggleShowClock(true);
	      _this4.props.history.replace("/");
	      // console.log("Go idle")
	      _this4.setState({
	        idle: true
	      });
	
	      _this4.folderCycleIdle();
	      _this4.folderCycleIdleLoop();
	    }
	  };
	
	  this.websocketHandler = function () {
	    var displayId = _this4.props.content.id;
	    _this4._io = (0, _sailsIo2.default)(_socket2.default);
	
	    _this4._io.sails.autoConnect = true;
	    _this4._io.sails.url = _config2.default.WEB_SERVER;
	
	    _this4._io.socket.on('email_announcement', function (event) {
	      // console.log("Event triggered");
	      _this4.setupAsset(event);
	    });
	
	    _this4._io.socket.on('connect', function () {
	      _this4._io.socket.get('/feed/subscribe?display=' + displayId, function serverResponded(body, JWR) {
	        // console.log('loaded');
	      });
	    });
	
	    _this4._io.socket.on('error', function (e) {
	      // console.log('error');
	    });
	
	    _this4._io.socket.on('disconnect', function () {
	      _this4._io.socket._raw.io._reconnection = true;
	    });
	  };
	
	  this.setupAsset = function (event) {
	    var data = JSON.parse(event);
	    if (data.subject && _this4.props.content.settings.announcement_modules) {
	      var module = _lodash2.default.find(_this4.props.content.settings.announcement_modules, { subject: data.subject });
	      if (module) {
	        var announcementModule = _lodash2.default.find(_this4.props.content.dm_active, { id: module.id });
	        if (announcementModule) {
	          var asset = _lodash2.default.get(announcementModule.contents, "images[0]", null);
	          if (asset) {
	            _this4._assetFile = asset.file_name;
	          }
	
	          var announcementAudioAsset = _lodash2.default.get(announcementModule.contents, "images[1]", null);
	          if (announcementAudioAsset) {
	            _this4._audioAssetFile = announcementAudioAsset.file_name;
	          }
	
	          _this4._announcementAsset = _shared2.default.dp(_this4.props.screen, asset);
	          _this4._announcementAudioAsset = _shared2.default.dp(_this4.props.screen, announcementAudioAsset);
	          _this4._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
	
	          _this4.showModal();
	        }
	      }
	    }
	  };
	
	  this.cycleIdle = function () {
	    if (_this4.idleRef >= _this4.props.content.display_module_loops[0].display_module_loop_units.length) {
	      _this4.idleRef = 0;
	    }
	    _this4.navroute(_this4.idleRef, _this4.props.content.display_module_loops[0].display_module_loop_units[_this4.idleRef].data.display_module_type, "idle", { idleModule: _this4.idleRef });
	  };
	
	  this.cycleIdleLoop = function () {
	    clearTimeout(_this4._idleLoopTimeout);
	    _this4._idleLoopTimeout = setTimeout(function () {
	      _this4.cycleIdle();
	      _this4.cycleIdleLoop();
	    }, _this4.props.content.display_module_loops[0].display_module_loop_units[_this4.idleRef].cycle_time_seconds * 1000);
	    _this4.idleRef++;
	  };
	
	  this.folderCycleIdle = function () {
	    if (_this4.idleRef >= _this4._attractLoopTree.children.length) {
	      _this4.idleRef = 0;
	    }
	    var type = _lodash2.default.get(_this4._attractLoopTree.children[_this4.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
	    _this4.folderNavroute(_this4.idleRef, type, "idle", { idleModule: _this4.idleRef });
	  };
	
	  this.folderCycleIdleLoop = function () {
	    clearTimeout(_this4._idleLoopTimeout);
	    var timeout = Number(_lodash2.default.get(_this4._attractLoopTree.children[_this4.idleRef].contents, 'custom_fields.cycle_timeout.val', 30));
	    _this4._idleLoopTimeout = setTimeout(function () {
	      _this4.folderCycleIdle();
	      _this4.folderCycleIdleLoop();
	    }, timeout * 1000);
	    _this4.idleRef++;
	  };
	
	  this.resume = function () {
	    _this4.lastInteraction = new Date();
	    if (_this4._attractLoopMode === LEGACY_ATTRACT) {
	      _this4.checkRecentInteraction();
	    } else {
	      _this4.folderCheckRecentInteraction();
	    }
	
	    _this4.checkIdleTimeout();
	
	    if (_this4.state.idle === true) {
	      if (_this4._attractLoopMode === FOLDER_ATTRACT) {
	        _this4.props.history.replace('/');
	      }
	      _this4.setState({
	        idle: false
	      });
	      clearTimeout(_this4._idleLoopTimeout);
	    }
	    if (_this4.state.recentInteraction === false) {
	      _this4.setState({
	        recentInteraction: true
	      });
	    }
	  };
	
	  this.handleImageLoaded = function () {
	    if (_this4.state.showModal) {
	      var height = _this4._imageModalRef.getBoundingClientRect().height;
	      var width = _this4._imageModalRef.getBoundingClientRect().width;
	      var offsetX = _this4.props.screen.screenWidth / 2 - width / 2;
	      var offsetY = _this4.props.screen.screenHeight / 2 - height / 2;
	
	      _this4._imageModalRef.style['left'] = offsetX + 'px';
	      _this4._imageModalRef.style['top'] = offsetY + 'px';
	    }
	  };
	
	  this.loadedMetadata = function (event) {
	    var videoHeight = _this4._videoModalRef.getBoundingClientRect().height;
	    var videoWidth = _this4._videoModalRef.getBoundingClientRect().width;
	    var videoMaxHeight = 0;
	    var videoMaxWidth = 0;
	    var videoOffsetX = 0;
	    var videoOffsetY = 0;
	    var videoRatio = videoWidth / videoHeight;
	    // let screenRatio = this.props.screen.screenWidth / this.props.screen.screenHeight;
	    var isHorizontal = videoWidth > videoHeight;
	
	    if (isHorizontal) {
	      videoMaxWidth = _this4.props.screen.screenWidth;
	      videoMaxHeight = videoMaxWidth / videoRatio;
	    } else {
	      videoMaxHeight = _this4.props.screen.screenHeight;
	      videoMaxWidth = videoMaxHeight * videoRatio;
	    }
	
	    videoOffsetX = videoMaxWidth < _this4.props.screen.screenWidth ? _this4.props.screen.screenWidth / 2 - videoMaxWidth / 2 : 0;
	    videoOffsetY = videoMaxHeight < _this4.props.screen.screenHeight ? _this4.props.screen.screenHeight / 2 - videoMaxHeight / 2 : 0;
	
	    var videoControlsOffset = videoOffsetY + videoHeight / 2;
	
	    // console.log("Loaded Metadata");
	
	    if (_this4._videoModalRef !== undefined && _this4._videoModalRef !== null) {
	      var duration = _this4._videoModalRef.duration;
	      // console.log("1- Setting a duration of", duration);
	      _this4._modalCycle = setTimeout(function () {
	        // console.log("Closing Modal");
	        _this4.setState({
	          showModalVideo: false
	        });
	      }, duration * 1000);
	    } else {
	      _this4.handleVideoDuration();
	    }
	
	    _this4.setState({
	      duration: event.target.duration,
	      videoOffsetY: videoOffsetY,
	      videoOffsetX: videoOffsetX,
	      videoControlsOffset: videoControlsOffset,
	      videoMaxHeight: videoMaxHeight,
	      videoMaxWidth: videoMaxWidth,
	      videoFile: _this4.props.content.file_path
	    });
	  };
	
	  this.loadedAudioMetadata = function (event) {
	    if (_this4._audioRef !== undefined && _this4._audioRef !== null) {
	      var audioDuration = _this4._audioRef.duration;
	      // console.log("Audio Duration", audioDuration);
	      _this4._audioRef.volume = 1;
	      clearTimeout(_this4._audioCycle);
	      _this4._audioCycle = setTimeout(function () {
	        _this4.setState({
	          playAudio: false
	        });
	      }, audioDuration * 1000);
	    } else {
	      clearTimeout(_this4._audioCycle);
	      _this4._audioCycle = setTimeout(function () {
	        _this4.loadedAudioMetadata();
	      }, 50);
	    }
	  };
	
	  this.handleVideoDuration = function () {
	    if (_this4._videoRef !== undefined && _this4._videoRef !== null) {
	      var duration = _this4._videoRef.duration;
	      // console.log("2- Setting a duration of", duration);
	      clearTimeout(_this4._modalCycle);
	      _this4._modalCycle = setTimeout(function () {
	        // console.log("Closing Modal 2");
	        _this4.setState({
	          showModalVideo: false
	        }, duration * 1000);
	      });
	    } else {
	      _this4._modalCycle = setTimeout(function () {
	        _this4.handleVideoDuration();
	      }, 50);
	    }
	  };
	
	  this.toggleShowClock = function (on) {
	    _this4.setState({
	      showClock: on
	    });
	  };
	
	  this.getActiveModuleType = function () {
	    return _this4.props.content.dm_active[_this4.props.active_module].display_module_type;
	  };
	
	  this.navroute = function (ref, type, source, options) {
	    // console.log("NAVROUTE", ref, type, source, options);
	    var url = void 0;
	    if (options.useFolders) {
	      _this4._useFolders = true;
	    }
	    if (ref === null) {
	      if (_this4.props.active_module !== undefined) {
	        ref = _this4.props.active_module; //maintain module if not changed
	      }
	    }
	    if (type === null) {
	      type = _this4.getActiveModuleType();
	    }
	    _this4.toggleSlideOff();
	    _this4.setState({
	      displayNav: false,
	      options: options
	    });
	    _this4.props.setOptions(options);
	    _this4.props.switchModule(ref);
	
	    switch (type) {
	      case "Home":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/");
	        break;
	      case "Story":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/story?id=" + ref);
	        _this4.setNavBack(ref, type, source, options);
	        break;
	      case "Stories":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/stories?id=" + ref);
	        _this4.setNavBack(ref, type, source, options);
	        break;
	      case "Stories Folders":
	        url = "/stories_folders";
	        url += "?id=" + ref; //getting set wrong from loop?
	        if (options && options.donorId) {
	          url += "&donor=" + options.donorId;
	        }
	        if (source === "idle") {
	          url += "&idle=true";
	        }
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace(url);
	        _this4.setNavBack(ref, type, source, options);
	        break;
	      case "Donor List":
	        url = "/donorlist";
	        url += "?id=" + ref; //getting set wrong from loop?
	        if (options && options.donorId) {
	          url += "&donor=" + options.donorId;
	        }
	        if (source === "idle") {
	          url += "&idle=true";
	        }
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace(url);
	        _this4.setNavBack(ref, type, source, options);
	        break;
	      case "User Input":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/userinput?id=" + ref);
	        break;
	      case "Input Confirmation":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/inputconfirmation");
	        break;
	      case "Slideshow":
	        _this4.setState({ showNav: true });
	        if (source === "idle") {
	          var _url = "/slideshow?id=" + options.idleModule; //ensures unique path
	          _this4.props.history.replace(_url);
	        } else {
	          _this4.props.history.replace("/slideshow?id=" + ref);
	        }
	        break;
	      case "Search":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/search");
	        break;
	      case "Results":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/results");
	        break;
	      case "Timeline":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/timeline?id=" + ref);
	        break;
	      case "Donor Sea":
	        _this4.setState({ showNav: true });
	        _this4.props.history.replace("/donorsea");
	        break;
	      case "Recent Donors":
	        _this4.setState({ showNav: true });
	        if (source === "idle") {
	          var _url2 = "/recentdonors?id=" + options.idleModule; //ensures unique path
	          _this4.props.history.replace(_url2);
	        } else {
	          _this4.props.history.replace("/recentdonors?id=" + ref);
	        }
	        break;
	      default:
	        break;
	    }
	
	    if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
	      _this4.props.history.replace(options.routeoverride);
	    }
	    // return(
	    // <Redirect to={"/story+id="+ref}/>
	    // )
	  };
	
	  this.folderNavroute = function (ref, type, source, options) {
	    if (ref === null) {
	      if (_this4.props.active_module !== undefined) {
	        ref = _this4.props.active_module; //maintain module if not changed
	      }
	    }
	    if (type === null) {
	      type = _this4.getActiveModuleType();
	    }
	    _this4.toggleSlideOff();
	    _this4.setState({
	      displayNav: false,
	      options: options
	    });
	    // this.props.setOptions(options);
	    _this4.props.switchModule(ref);
	
	    var module = void 0;
	    module = _this4._attractLoopTree.children[ref];
	    _this4.setState({ showNav: true, module: module, attractLoopRef: ref });
	    // this.props.history.replace("/attract_loop?id=" + ref);
	
	    // if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
	    //   this.props.history.replace(options.routeoverride);
	    // }
	  };
	
	  this.renderLayer = function (file, opacity, layer) {
	    var fullPath = void 0;
	    var lower_layer_file_type = void 0;
	    if (file) {
	      lower_layer_file_type = (0, _shared3.getFileType)(file.file_name);
	      //fullPath = this.props.screen.dpath + file.path + file.file_name;
	      fullPath = (0, _shared3.dpath)(_this4.props.screen.mode, file.path, file.file_name, _this4.props.screen.webkey);
	    }
	    switch (lower_layer_file_type) {
	      case "video":
	        var vType = (0, _shared3.videoType)(file.file_name);
	        return _react2.default.createElement(
	          'div',
	          { style: { zIndex: -90, pointerEvents: "none", position: 'absolute', width: '100vw', height: '100vh' } },
	          _react2.default.createElement(
	            'video',
	            { className: 'nodrag', style: _videoStyle, id: 'background-video', loop: true, autoPlay: true, muted: true },
	            _react2.default.createElement('source', { src: fullPath, type: vType }),
	            'Your browser does not support the video tag.'
	          )
	        );
	      case "image":
	        return _react2.default.createElement(
	          'div',
	          { className: 'noselect', style: { zIndex: -90, pointerEvents: "none", position: 'absolute', width: '100vw', height: '100vh' } },
	          _react2.default.createElement('img', { style: { width: '100vw', height: '100vh', opacity: opacity }, src: fullPath, alt: 'Lower Layer Background', className: 'nodrag' })
	        );
	
	      default:
	        if (layer === "background") {
	          return _react2.default.createElement('div', { className: 'noselect', style: { backgroundColor: _this4.props.content.settings.lower_layer_color, zIndex: -90, pointerEvents: "none", position: 'absolute', width: '100vw', height: '100vh' } });
	        }
	        return _react2.default.createElement('span', null);
	
	    }
	  };
	
	  this.themeSwitch = function (route) {
	    switch (route) {
	      case "/timeline":
	        switch (_this4.props.content.project.theme.name) {
	          case "Chicago":
	            return (
	              //<Route path='/timeline' component={TimelineChicago} />
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/timeline', render: function render(props) {
	                  return _react2.default.createElement(_TimelineChicago2.default, Object.assign({}, props, { toggleShowClock: _this4.toggleShowClock, resume: _this4.resume, navroute: _this4.navroute, options: _this4.state.options }));
	                } })
	            );
	          case "Core":
	          default:
	            return _react2.default.createElement(_reactRouterDom.Route, { path: '/timeline', component: _Timeline2.default });
	        }
	      case "/userinput":
	        switch (_this4.props.content.project.theme.name) {
	          case "Core":
	          default:
	            return _react2.default.createElement(_reactRouterDom.Route, { path: '/userinput', render: function render(props) {
	                return _react2.default.createElement(_UserInput2.default, Object.assign({}, props, { navroute: _this4.navroute, screen: _this4.props.screen, module: _this4.props.content.dm_active[_this4.props.active_module] }));
	              } });
	        }
	
	      case "/stories_folders":
	        return _react2.default.createElement(_reactRouterDom.Route, { path: '/stories_folders', render: function render(props) {
	            return _react2.default.createElement(_StoriesFoldersChicago2.default, Object.assign({ resume: _this4.resume }, props, { toggleShowClock: _this4.toggleShowClock, navroute: _this4.navroute, useFolders: _this4._useFolders }));
	          } });
	
	      case "/donorlist":
	        switch (_this4.props.content.project.theme.name) {
	          case "Chicago":
	            if (_this4.state.options.type === "simple") {
	              return _react2.default.createElement(_reactRouterDom.Route, { path: '/donorlist', render: function render(props) {
	                  return _react2.default.createElement(_DonorListChicagoSimple2.default, Object.assign({}, props, { resume: _this4.resume, navroute: _this4.navroute }));
	                } });
	            }
	            return _react2.default.createElement(_reactRouterDom.Route, { path: '/donorlist', render: function render(props) {
	                return _react2.default.createElement(_DonorListChicago2.default, Object.assign({ resume: _this4.resume }, props, { toggleShowClock: _this4.toggleShowClock, navroute: _this4.navroute, useFolders: _this4._useFolders }));
	              } });
	          case "Core":
	          default:
	
	            //need logic here to go with interactive or non interactive
	            var isIdle = (0, _shared3.parseStringParam)(window.location.href, "idle");
	            var mod = _this4.props.content.dm_active[_this4.props.active_module];
	            if (isIdle === 'true') {
	
	              mod = _this4.props.content.display_module_loops[0].display_module_loop_units[_this4.props.active_module].data; //.display_module.data    
	            }
	            if (!mod) {
	
	              return null;
	            }
	            var interactive = true;
	            if (_lodash2.default.has(mod, "contents.interactive")) {
	              interactive = mod.contents.interactive;
	            }
	            if (interactive === true) {
	              return _react2.default.createElement(_reactRouterDom.Route, { path: '/donorlist', render: function render(props) {
	                  return _react2.default.createElement(_DonorList2.default, Object.assign({}, props, { navroute: _this4.navroute }));
	                } });
	            } else {
	              return _react2.default.createElement(_reactRouterDom.Route, { path: '/donorlist', render: function render(props) {
	                  return _react2.default.createElement(_DonorListPassive2.default, Object.assign({}, props, { navroute: _this4.navroute }));
	                } });
	            }
	
	        }
	      case "/story":
	      default:
	        switch (_this4.props.content.project.theme.name) {
	          case "Chicago":
	            return _react2.default.createElement(_reactRouterDom.Route, { path: '/story', component: _Story2.default });
	          case "Core":
	          default:
	            return _react2.default.createElement(_reactRouterDom.Route, { path: '/story', component: _Story2.default });
	        }
	    }
	  };
	
	  this.pageClick = function () {
	    _this4.resume();
	  };
	
	  this.checkRecentInteraction = function () {
	    var msPassed = new Date().getTime() - _this4.lastInteraction.getTime();
	
	    if (msPassed > recent_interaction_timeout) {
	      _this4.goIdle("recentInteraction");
	    } else {
	      clearTimeout(_this4._recentInteractionTimeout);
	      _this4._recentInteractionTimeout = setTimeout(function () {
	        _this4.checkRecentInteraction();
	      }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
	    }
	  };
	
	  this.folderCheckRecentInteraction = function () {
	    var msPassed = new Date().getTime() - _this4.lastInteraction.getTime();
	    if (msPassed > recent_interaction_timeout) {
	      _this4.folderGoIdle("recentInteraction");
	    } else {
	      clearTimeout(_this4._recentInteractionTimeout);
	      _this4._recentInteractionTimeout = setTimeout(function () {
	        _this4.folderCheckRecentInteraction();
	      }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
	    }
	  };
	
	  this.checkIdleTimeout = function () {
	    var msPassed = new Date().getTime() - _this4.lastInteraction.getTime();
	    if (msPassed > _this4._idleDelay) {
	      if (_this4._attractLoopMode === FOLDER_ATTRACT) {
	        _this4.folderGoIdle("idle");
	      } else {
	        _this4.goIdle("idle");
	      }
	    } else {
	      clearTimeout(_this4._idleTimeout);
	      _this4._idleTimeout = setTimeout(function () {
	        _this4.checkIdleTimeout();
	      }, _this4._idleDelay - msPassed); //avoids extra settings of timeout below interval check
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var active_module = state.active_module;
	  var namedmodule = _shared2.default.parseStringParam(window.location.href, "name");
	  var idle = _shared2.default.parseStringParam(window.location.href, "idle");
	  var route = _shared2.default.parseStringParam(window.location.href, "route");
	  var jumpToModule = false;
	  var routeoverride = null;
	
	  if (namedmodule) {
	    active_module = _lodash2.default.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
	    if (active_module === -1) {
	      console.log({ type: 'warning', message: 'A name query was provided but the named module was not found active on the display. Ensure a name match, that it is added to the display, that the display is set live, and that the data has been pulled to the client.' });
	    }
	    jumpToModule = true;
	  }
	  if (route) {
	    routeoverride = route;
	  }
	  var idleActive = true;
	  if (state.content.idle_delay === 0 || idle === "false") {
	    idleActive = false;
	  }
	
	  // console.log(idleActive, jumpToModule, active_module);
	
	  return {
	    content: state.content,
	    contentHasErrored: state.contentHasErrored,
	    contentIsLoading: state.contentIsLoading,
	    donors: state.donors,
	    donorsHasErrored: state.donorsHasErrored,
	    donorsIsLoading: state.donorsIsLoading,
	    screen: state.screen,
	    active_module: active_module,
	    options: state.options,
	    idleActive: idleActive,
	    jumpToModule: jumpToModule,
	    routeoverride: routeoverride
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    switchModule: function switchModule(id) {
	      return dispatch((0, _display.switchModule)(id));
	    },
	    setOptions: function setOptions(data) {
	      return dispatch((0, _display.setOptions)(data));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DisplayContainer);

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DonorSeaComponent = __webpack_require__(397);
	
	var _DonorSeaComponent2 = _interopRequireDefault(_DonorSeaComponent);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataHelpers = __webpack_require__(51);
	
	var _shared = __webpack_require__(4);
	
	var _timeHelpers = __webpack_require__(39);
	
	var _timeHelpers2 = _interopRequireDefault(_timeHelpers);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _display = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import DonorListPlatinum from '../Components/Donor/DonorListPlatinum.jsx';
	
	
	window.tmpLogArray = [];
	var _videoStyle = {
	  preload: 'auto',
	  position: 'fixed',
	  minWidth: '100%',
	  minHeight: '100%',
	  width: '100%',
	  height: '100%',
	  zIndex: -100,
	  loop: '',
	  autoplay: "",
	  muted: "",
	  pointerEvents: "none"
	};
	var FADED_IN = "faded_in";
	var FADED_OUT = "faded_out";
	var FADE_DELAY = 2000;
	
	var DonorContainer = function (_Component) {
	  _inherits(DonorContainer, _Component);
	
	  function DonorContainer(props) {
	    _classCallCheck(this, DonorContainer);
	
	    var _this = _possibleConstructorReturn(this, (DonorContainer.__proto__ || Object.getPrototypeOf(DonorContainer)).call(this, props));
	
	    _this.donorsNameStarter = function () {
	      _this._donorsNameStarterIntervalHandler = setTimeout(function () {
	        if (_this._donorsAreReady) {
	          _this.setupDonorNamesInterval();
	        } else {
	          _this._donorsNameStarterTimeout = 1000;
	          _this.donorsNameStarter();
	        }
	      }, _this._donorsNameStarterTimeout);
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "s":
	          console.log(_this.props);
	          break;
	        case "d":
	          console.log("pressed");
	          _this.setState({
	            showDebug: !_this.state.showDebug
	          });
	          break;
	        //   let newDebug = this.state.showDebug + 1
	        //   if (newDebug > 2) {
	        //     newDebug = 0
	        //   }
	        //   this.setState({
	        //     showDebug: newDebug
	        //   })
	        //   break;
	        // case "n":
	        //   if (this.state.contentStage === 0) { //fade out names
	        //     this.setState({
	        //       contentStage: 1
	        //     })
	        //   }
	        //   else if (this.state.contentStage === 2) { //start names fade in
	        //     this.setState({
	        //       contentStage: 0
	        //     })
	        //   }
	        //   break;
	        default:
	          break;
	      }
	    };
	
	    _this.setDonorsReady = function (status) {
	      _this._donorsAreReady = status;
	    };
	
	    _this.setupIntervalHandler = function () {
	      window.tmpLogArray.push(new Date() + " Creating Timeout");
	      window.tmpLogArray.push(new Date() + " Current index is: " + _this.state.elementIndex);
	      clearTimeout(_this._intervalTimeout);
	      _this._intervalTimeout = setTimeout(function () {
	        _this._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._cycleIntervals, true);
	        window.tmpLogArray.push(new Date() + " Time for the next Cycle: " + _this._intervalTimeoutMS);
	
	        if (_this._intervalTimeoutMS > 500) {
	          var elementIndex = (0, _shared.loopIndex)(_this.state.elementIndex, 0, _this._config.elementStates.length - 1, "forward");
	          var showOverlay = elementIndex === _this._config.elementStates.length - 1 ? false : true;
	
	          // console.log("Next element Index", elementIndex);
	          window.tmpLogArray.push(new Date() + " Next element Index: " + elementIndex);
	          _this.props.logToServer(window.tmpLogArray, 'DonorContainer', _this.props.content.id, _this.props.screen.mode, _this.props.screen.webkey);
	          window.tmpLogArray = [];
	
	          _this.setState({
	            showOverlay: showOverlay,
	            elementIndex: elementIndex
	          });
	          if (elementIndex !== _this._config.elementStates.length - 1) {
	            _this._elemCounter++;
	          }
	          // console.log("Element Counter", this._elemCounter);
	          // console.log("Changing video to", elementIndex);
	          clearTimeout(_this._intervalDonorsTimeoutHandler);
	          _this._intervalDonorsShowTimeoutHandler = setTimeout(function () {
	            if (_this._donorsAreReady) {
	              _this.setupDonorNamesInterval(elementIndex);
	            }
	          }, FADE_DELAY);
	        }
	
	        _this.setupIntervalHandler();
	      }, _this._intervalTimeoutMS);
	    };
	
	    _this.setupDonorNamesInterval = function (elementIndex) {
	      if (elementIndex === undefined || elementIndex === null) {
	        elementIndex = _this.state.elementIndex;
	      }
	
	      var minTimeLeftToShowDonors = _this._timeToFadeDonorsIn + _this._timeToFadeDonorsOut;
	      _this._intervalDonorsTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._cycleIntervals);
	      var timeToCheckDonors = _this._intervalDonorsTimeoutMS - _this._timeToFadeDonorsOut - FADE_DELAY;
	      var showPlatinumAndDiamond = false;
	      var loopWave = false;
	
	      if (elementIndex !== _this._config.elementStates.length - 1 && _this._donorNamesStatus === FADED_OUT) {
	        if (_this._intervalDonorsTimeoutMS > minTimeLeftToShowDonors) {
	          loopWave = elementIndex === 0 ? true : false;
	          _this._donorSeaRef.getWrappedInstance().setupFadeInDonors(loopWave);
	
	          if (elementIndex === _this._config.elementStates.length - 1) {
	            showPlatinumAndDiamond = true;
	          }
	
	          // this.setState({
	          //   showOverlay: !loopWave,
	          // });
	          // console.log("Fading In");
	          _this._donorNamesStatus = FADED_IN;
	        }
	      }
	
	      var showOverlay = !loopWave;
	      if (elementIndex === _this._config.elementStates.length - 1) {
	        showPlatinumAndDiamond = true;
	        showOverlay = false;
	      }
	
	      _this.setState({
	        showPlatinumAndDiamond: showPlatinumAndDiamond,
	        showOverlay: showOverlay
	      });
	
	      // Fade out Platinum donors with a 10% delay
	      clearTimeout(_this._intervalPlatinumHandler);
	      _this._intervalPlatinumHandler = setTimeout(function () {
	        _this.setState({
	          showPlatinumAndDiamond: false
	        });
	      }, timeToCheckDonors * 1.2);
	
	      clearTimeout(_this._intervalDonorsTimeoutHandler);
	      _this._intervalDonorsTimeoutHandler = setTimeout(function () {
	        var nextElement = (0, _shared.loopIndex)(elementIndex, 0, _this._config.elementStates.length - 1, "forward");
	        if (_this._elemCounter === Number(_this._intervalsToKeepOneWaveOfDonorsOnScreen) || nextElement === _this._config.elementStates.length - 1) {
	          _this._donorSeaRef.getWrappedInstance().setupFadeOutDonors();
	          _this._donorNamesStatus = FADED_OUT;
	          _this._elemCounter = 0;
	        }
	      }, timeToCheckDonors);
	    };
	
	    _this.setVideoSeekTimeInterval = function () {
	      clearTimeout(_this._intervalSeekTimeout);
	      _this._intervalSeekTimeout = null;
	      _this._intervalSeekTimeout = setTimeout(function () {
	        var fileType = (0, _shared.getFileType)(_this._config.elementStates[_this.state.elementIndex].file_name);
	        if (fileType === "video") {
	          if (!_this._currentVideoRef) {
	            _this.setVideoSeekTimeInterval();
	          } else {
	            _this._currentVideoRef.currentTime = _this.state.currentTimeInterval / 1000;
	            clearTimeout(_this._intervalSeekTimeout);
	          }
	        }
	      }, 30);
	    };
	
	    _this.showBezelHandle = function (xScreens, yScreens) {
	      if (_this.state.showDebug === false) {
	        return null;
	      }
	
	      var debugBoxStyle = {
	        position: 'absolute',
	        opacity: .7,
	        backgroundColor: "black"
	
	        // Determine Horizontal Lines based on amount of V Screens.
	      };var hLines = Array.apply(null, { length: yScreens + 1 }).map(Number.call, Number);
	      var vLines = Array.apply(null, { length: xScreens + 1 }).map(Number.call, Number);
	
	      var regionHeight = _this.props.screen.screenHeight / yScreens;
	      var regionWidth = _this.props.screen.screenWidth / xScreens;
	      var bezel = _this.props.screen.screenHeight * .005;
	
	      var renderedHlines = hLines.map(function (lNumber, key) {
	        var bezelOffset = lNumber > 0 ? bezel / 2 : 0;
	        bezelOffset = lNumber === hLines.length - 1 ? bezel : bezelOffset;
	        var style = {
	          top: lNumber * regionHeight - bezelOffset,
	          left: 0,
	          height: bezel,
	          width: _this.props.screen.screenWidth
	        };
	
	        return _react2.default.createElement('div', { key: key, style: Object.assign({}, debugBoxStyle, style) });
	      });
	
	      var renderedVlines = vLines.map(function (lNumber, key) {
	        var bezelOffset = lNumber > 0 ? bezel / 2 : 0;
	        bezelOffset = lNumber === vLines.length - 1 ? bezel : bezelOffset;
	        var style = {
	          left: lNumber * regionWidth - bezelOffset,
	          top: 0,
	          width: bezel,
	          height: _this.props.screen.screenHeight
	        };
	
	        return _react2.default.createElement('div', { key: key, style: Object.assign({}, debugBoxStyle, style) });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderedVlines,
	        renderedHlines
	      );
	    };
	
	    try {
	
	      _this._intervalsToKeepOneWaveOfDonorsOnScreen = 2;
	      _this._intervalDonorsTimeoutHandler = null;
	      _this._donorsNameStarterIntervalHandler = null;
	      _this._intervalTimeout = null;
	      _this._intervalDonorsTimeoutMS = 0;
	      _this._donorNamesStatus = FADED_OUT;
	      _this._donorStateElementIndex = null;
	      _this._justFadedNamesOut = false;
	      _this._timeToFadeDonorsIn = 3000;
	      _this._timeToFadeDonorsOut = 3000;
	      _this._donorsAreReady = false;
	      _this._donorsNameStarterTimeout = 0;
	
	      _this._timeToFadeDonors = 5000;
	      _this._elemCounter = 1;
	      _this._seaConfig = null;
	      _this._cycleIntervals = null;
	      _this._donorSeaRef = null;
	      _this._intervalDonorCounter = 0;
	
	      _this._config = {
	        elementIntervalMS: null,
	        elementStates: []
	
	        // Search for a Donor Sea Type of Module
	      };var rootFolder = _lodash2.default.get(_this.props.content, 'settings.selected_root_folder', null);
	      rootFolder = Number(rootFolder);
	      var parentFolder = _lodash2.default.find(_this.props.content.story_categories, function (folder) {
	        var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	        return type === "attract_loop_donor_lists" && folder.parent_category === rootFolder;
	      });
	      var donorListsFolder = _lodash2.default.filter(_this.props.content.story_categories, { contents: { custom_fields: { folder_type: { val: { value: "donor_lists" } } } }, parent_category: parentFolder.id });
	      donorListsFolder = donorListsFolder[0] ? donorListsFolder[0] : null;
	      var platinumDiamondLists = _lodash2.default.filter(_this.props.content.story_categories, function (folder) {
	        var type = _lodash2.default.get(folder.contents, 'custom_fields.folder_type.val.value', null);
	        return folder.parent_category === donorListsFolder.id && type === 'donor_list_turbot';
	      });
	
	      var index = _lodash2.default.findIndex(_this.props.content.dm_active, { display_module_type: "Donor Sea" });
	      _this._donorSeaModuleIndex = index;
	      // this._donorSea = this.props.content.dm_active[index];
	      _this._donorSea = donorListsFolder;
	
	      if (_this._donorSea === undefined || _this._donorSea === null) {
	        console.log("No Donor Sea module was found");
	      } else {
	        var slideshow_module = _lodash2.default.find(_this.props.content.dm_active, { id: Number(_this._donorSea.contents.custom_fields.assets.val.value) });
	        _this._cycleIntervals = [];
	        var cycleIntervals = _lodash2.default.get(slideshow_module, 'contents.cycle_overrides', []).filter(function (v, i) {
	          return i % 2 === 0;
	        });
	        cycleIntervals = cycleIntervals.map(function (interval) {
	          return interval * 1000;
	        });
	
	        var activeSlides = _lodash2.default.get(slideshow_module, 'contents.bool0s', []).filter(function (v, i) {
	          return i % 2 === 0;
	        });
	
	        _this._seaConfig = _this._donorSea.contents;
	        var timeToFadeDonorsIn = _lodash2.default.get(_this._seaConfig, 'custom_fields.timeToFadeDonorsIn.val', 3);
	        var timeToFadeDonorsOut = _lodash2.default.get(_this._seaConfig, 'custom_fields.timeToFadeDonorsOut.val', 3);
	
	        _this._timeToFadeDonorsIn = timeToFadeDonorsIn * 1000;
	        _this._timeToFadeDonorsOut = timeToFadeDonorsOut * 1000;
	        _this._timeToFadeDiamondPlatinumDonorsIn = 3000;
	        _this._timeToFadeDiamondPlatinumDonorsOut = 3000;
	        _this._regionMarginFromEdges = _lodash2.default.get(_this._seaConfig, 'custom_fields.regionMarginFromEdges.val', 2);
	        _this._regionMarginFromTopAndBottom = _lodash2.default.get(_this._seaConfig, 'custom_fields.regionMarginFromTopAndBottom.val', 2);
	        _this._minMarginBetweenNamesHorizontally = _lodash2.default.get(_this._seaConfig, 'custom_fields.minMarginBetweenNamesHorizontally.val', 5);
	        _this._minMarginBetweenNamesVertically = _lodash2.default.get(_this._seaConfig, 'custom_fields.minMarginBetweenNamesVertically.val', 3);
	
	        _this._intervalsToKeepOneWaveOfDonorsOnScreen = _lodash2.default.get(_this._seaConfig, 'custom_fields.intervalsToKeepOneWaveOfDonorsOnScreen.val', 2);
	        var elementStates = slideshow_module.contents.images.filter(function (v, i) {
	          return i % 2 !== 0;
	        });
	        _this._config.elementStates = [];
	
	        //only push active slides to array
	        for (var b = 0; b < elementStates.length; b++) {
	          if (activeSlides[b]) {
	            if (activeSlides[b] === true || activeSlides[b] === 'true') {
	              _this._config.elementStates.push(Object.assign({}, elementStates[b], { cycleInterval: cycleIntervals[b] || 5000 }));
	              if (cycleIntervals[b]) {
	                _this._cycleIntervals.push(cycleIntervals[b]);
	              } else {
	                _this._cycleIntervals.push(5000);
	              }
	            }
	          }
	        }
	
	        // console.log(this._cycleIntervals);
	
	        _this._slideshowConfig = slideshow_module.contents;
	        if (_this._config.elementStates.length === 1) {
	          _this._config.elementStates.push(_this._config.elementStates[0]); //make an array of at least two for the purposes of transitions
	        }
	
	        _this._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._cycleIntervals);
	      }
	
	      var elementIndex = _timeHelpers2.default.indexFromIntervalArray(_this._cycleIntervals, _this._config.elementStates.length);
	      var currentTimeInterval = _timeHelpers2.default.currentSeekTimeArray(_this._cycleIntervals);
	
	      _this.state = {
	        elementIndex: elementIndex,
	        currentTimeInterval: currentTimeInterval,
	        fadeInDonors: false,
	        nameCount: 0,
	        namesDisplayed: 0,
	        secondsPassed: 0,
	        sinceElement: 0,
	        showDebug: false,
	        contentStage: 2,
	        showPlatinumAndDiamond: false,
	        platinumDiamondLists: platinumDiamondLists
	      };
	
	      _this._currentVideoRef = null;
	      _this._intervalTimeout = null;
	      _this._intervalSeekTimeout = null;
	      _this._startTime = new Date();
	      _this._elementCycleTime = new Date();
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(DonorContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.logToServer([new Date() + " Component just mounted"], "DonorContainer", this.props.content.id, this.props.screen.mode, this.props.screen.webkey);
	      this.setupIntervalHandler();
	      this.donorsNameStarter();
	      this.setVideoSeekTimeInterval();
	      document.addEventListener("keydown", this.handleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      clearTimeout(this._intervalTimeout);
	      clearTimeout(this._intervalSeekTimeout);
	      clearTimeout(this._intervalDonorsTimeoutHandler);
	      clearTimeout(this._donorsNameStarterIntervalHandler);
	      this._intervalTimeout = null;
	      this._intervalSeekTimeout = null;
	      this._intervalDonorsTimeoutHandler = null;
	      this._donorsNameStarterIntervalHandler = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      try {
	        var fileType = (0, _shared.getFileType)(this._config.elementStates[this.state.elementIndex].file_name);
	        var cType = "";
	        var content = "";
	
	        var donorSeaBox = {
	          left: 0,
	          top: 0,
	          width: this.props.screen.screenWidth,
	          height: this.props.screen.screenHeight
	
	          // let fullpath = dpath(this.props.screen.mode, this._config.elementStates[this.state.elementIndex].path, this._config.elementStates[this.state.elementIndex].file_name, this.props.screen.webkey);
	        };var fullpath = (0, _shared.dp)(this.props.screen, this._config.elementStates[this.state.elementIndex], null);
	
	        if (fileType === "video") {
	          cType = (0, _shared.videoType)(this._config.elementStates[this.state.elementIndex].file_name);
	          content = _react2.default.createElement(
	            'div',
	            { className: 'vid', style: { position: 'absolute', top: 0, left: 0 }, key: this.state.elementIndex },
	            _react2.default.createElement(
	              'video',
	              { style: _videoStyle, ref: function ref(el) {
	                  return _this2._currentVideoRef = el;
	                }, id: 'background-video', loop: true, autoPlay: true, muted: true },
	              _react2.default.createElement('source', { src: fullpath, type: cType }),
	              'Your browser does not support the video tag.'
	            )
	          );
	        } else {
	          content = _react2.default.createElement('div', { style: Object.assign({}, donorSeaBox, { zIndex: -100, position: 'absolute', backgroundSize: "cover", backgroundImage: "url(" + fullpath + ")" }) });
	        }
	
	        var opacity = Number(_lodash2.default.get(this._slideshowConfig.custom_fields, 'overlay_opacity_horizontal.val', 0));
	        var overlayCss = {
	          backgroundColor: _lodash2.default.get(this._slideshowConfig.custom_fields, 'overlay_color_horizontal.val', '#FFFFFF'),
	          opacity: opacity !== 0 ? opacity / 100 : opacity,
	          position: 'absolute',
	          width: this.props.screen.screenWidth,
	          height: this.props.screen.screenHeight
	        };
	
	        return _react2.default.createElement(
	          'div',
	          { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight } },
	          _react2.default.createElement(
	            'div',
	            { key: this.state.showDebug },
	            this.showBezelHandle(this._seaConfig.custom_fields.screensH.val, this._seaConfig.custom_fields.screensV.val)
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.elementIndex },
	              content
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showOverlay },
	              this.state.showOverlay ? _react2.default.createElement('div', { style: overlayCss }) : null
	            )
	          ),
	          _react2.default.createElement(_DonorSeaComponent2.default, {
	            ref: function ref(el) {
	              return _this2._donorSeaRef = el;
	            },
	            activeModuleIndex: this._donorSeaModuleIndex,
	            screensH: this._seaConfig.custom_fields.screensH.val,
	            screensV: this._seaConfig.custom_fields.screensV.val,
	            allowedScreens: this.props.allowedScreens,
	            timeToFadeDonors: this._timeToFadeDonors,
	            timeToFadeDonorsIn: this._timeToFadeDonorsIn,
	            timeToFadeDonorsOut: this._timeToFadeDonorsOut,
	            fadeDonors: this.state.fadeDonors,
	            regionMarginFromEdges: this._regionMarginFromEdges,
	            regionMarginFromTopAndBottom: this._regionMarginFromTopAndBottom,
	            minMarginBetweenNamesHorizontally: this._minMarginBetweenNamesHorizontally,
	            minMarginBetweenNamesVertically: this._minMarginBetweenNamesVertically,
	            setDonorsReady: this.setDonorsReady })
	        );
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }]);
	
	  return DonorContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var allowedScreens = { enabled: false, allowedH: [], allowedV: [] };
	  if (_lodash2.default.has(state, 'content.settings.custom_vars.allowedH')) {
	    allowedScreens.enabled = true;
	    allowedScreens.allowedH = (0, _dataHelpers.safeJson)(state.content.settings.custom_vars.allowedH) || [];
	  }
	  if (_lodash2.default.has(state, 'content.settings.custom_vars.allowedV')) {
	    allowedScreens.enabled = true;
	    allowedScreens.allowedV = (0, _dataHelpers.safeJson)(state.content.settings.custom_vars.allowedV) || [];
	  }
	
	  return {
	    content: state.content,
	    donors: state.donors,
	    screen: state.screen,
	    active_module: state.active_module,
	    allowedScreens: allowedScreens
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    logToServer: function logToServer(logs, type, display, mode, webkey) {
	      return dispatch((0, _display.logToServer)(logs, type, display, mode, webkey));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { withRef: true })(DonorContainer);

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DonorSea = __webpack_require__(396);
	
	var _DonorSea2 = _interopRequireDefault(_DonorSea);
	
	var _timeHelpers = __webpack_require__(39);
	
	var _timeHelpers2 = _interopRequireDefault(_timeHelpers);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared = __webpack_require__(4);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dataHelpers = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _videoStyle = {
	    preload: 'auto',
	    position: 'fixed',
	    minWidth: '100%',
	    minHeight: '100%',
	    width: '100%',
	    height: '100%',
	    zIndex: -100,
	    loop: '',
	    autoplay: "",
	    muted: "",
	    pointerEvents: "none"
	};
	
	var DonorSeaContainer = function (_Component) {
	    _inherits(DonorSeaContainer, _Component);
	
	    function DonorSeaContainer(props) {
	        _classCallCheck(this, DonorSeaContainer);
	
	        var _this = _possibleConstructorReturn(this, (DonorSeaContainer.__proto__ || Object.getPrototypeOf(DonorSeaContainer)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this._seaConfig = null;
	        _this._cycleIntervals = null;
	        _this._config = {
	            elementIntervalMS: null,
	            elementStates: []
	        };
	        if (_this.props.content.dm_active) {
	            var dm = _this.props.content.dm_active[_this.props.active_module];
	            if (dm) {
	
	                var slideshow_module = _lodash2.default.find(_this.props.content.dm_active, { id: Number(dm.contents.slideshow_module) });
	
	                _this._cycleIntervals = [];
	                var cycleIntervals = _lodash2.default.get(slideshow_module, 'contents.cycle_overrides', []);
	                cycleIntervals = cycleIntervals.map(function (interval) {
	                    return interval * 1000;
	                });
	
	                var activeSlides = _lodash2.default.get(slideshow_module, 'contents.bool0s', []);
	
	                _this._seaConfig = dm.contents;
	                var elementStates = slideshow_module.contents.images;
	                _this._config.elementStates = [];
	
	                //only push active slides to array
	                for (var b = 0; b < elementStates.length; b++) {
	                    if (activeSlides[b]) {
	                        if (activeSlides[b] === true || activeSlides[b] === 'true') {
	                            _this._config.elementStates.push(Object.assign({}, elementStates[b], { cycleInterval: cycleIntervals[b] || 5000 }));
	                            if (cycleIntervals[b]) {
	                                _this._cycleIntervals.push(cycleIntervals[b]);
	                            } else {
	                                _this._cycleIntervals.push(5000);
	                            }
	                        }
	                    }
	                }
	
	                _this._slideshowConfig = slideshow_module.contents;
	                if (_this._config.elementStates.length === 1) {
	                    _this._config.elementStates.push(_this._config.elementStates[0]); //make an array of at least two for the purposes of transitions
	                }
	
	                _this._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._cycleIntervals);
	            } else {
	                console.log('no donor sea module found');
	            }
	        }
	        if (!_this._config.elementIntervalMS) {
	            console.log("There is an issue establishing the cycle length, check that the video slideshow module's first slide has a cycle time");
	        }
	
	        var elementIndex = _timeHelpers2.default.indexFromIntervalArray(_this._cycleIntervals, _this._config.elementStates.length);
	        var currentTimeInterval = _timeHelpers2.default.currentSeekTimeArray(_this._cycleIntervals);
	        _this.state = {
	            elementIndex: elementIndex,
	            nameCount: 0,
	            namesDisplayed: 0,
	            secondsPassed: 0,
	            sinceElement: 0,
	            showDebug: 0,
	            currentTimeInterval: currentTimeInterval,
	            contentStage: 2
	        };
	
	        _this._currentVideoRef = null;
	        _this._intervalTimeout = null;
	        _this._intervalSeekTimeout = null;
	        _this._startTime = new Date();
	        _this._elementCycleTime = new Date();
	
	        for (var i = 0; i < _this._seaConfig.ranks.length; i++) {
	            _this._seaConfig.ranks[i].fontSize = (_this._seaConfig.ranks[i].fontSize / 100).toFixed(5);
	        }
	        _this._seaConfig.initDuration = _this._seaConfig.initDuration * 1000;
	        _this._seaConfig.cycleTimeInit = _this._seaConfig.cycleTimeInit * 1000;
	        _this._seaConfig.cycleTime = _this._seaConfig.cycleTime * 1000;
	        _this._seaConfig.nameMargin = _this._seaConfig.nameMargin / 100;
	        _this._seaConfig.edgeMargin = _this._seaConfig.edgeMargin / 100;
	        _this._loops = 0;
	
	        //temporary
	        _this._fadeOutTime = 50000;
	        _this._fadeOutTimeout = null;
	        return _this;
	    }
	
	    _createClass(DonorSeaContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setupIntervalHandler();
	            this.setVideoSeekTimeInterval();
	            document.addEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.state.contentStage === 1) {
	                this.setState({
	                    contentStage: 2
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	            clearTimeout(this._intervalTimeout);
	            clearTimeout(this._intervalSeekTimeout);
	            clearTimeout(this._fadeOutTimeout);
	            this._intervalTimeout = null;
	            this._intervalSeekTimeout = null;
	            this._fadeOutTimeout = null;
	        }
	        // Setup the interval handler that will loop through the background
	        // every {elementInterval} amount of time and through every element
	        // in this._config.elementStates
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            try {
	                var seaContents = this.props.content.dm_active[this.props.active_module].contents;
	                var fileType = (0, _shared.getFileType)(this._config.elementStates[this.state.elementIndex].file_name);
	                var cType = "";
	                var content = "";
	
	                var donorSeaBox = {
	                    left: 0,
	                    top: 0,
	                    width: this.props.screen.screenWidth,
	                    height: this.props.screen.screenHeight
	                };
	                var fullpath = (0, _shared.dpath)(this.props.screen.mode, this._config.elementStates[this.state.elementIndex].path, this._config.elementStates[this.state.elementIndex].file_name, this.props.screen.webkey);
	                if (fileType === "video") {
	                    cType = (0, _shared.videoType)(this._config.elementStates[this.state.elementIndex].file_name);
	                    content = _react2.default.createElement(
	                        'div',
	                        { className: 'vid', style: { position: 'absolute', top: 0, left: 0 }, key: this.state.elementIndex },
	                        _react2.default.createElement(
	                            'video',
	                            { style: _videoStyle, ref: function ref(el) {
	                                    return _this2._currentVideoRef = el;
	                                }, id: 'background-video', loop: true, autoPlay: true, muted: true },
	                            _react2.default.createElement('source', { src: fullpath, type: cType }),
	                            'Your browser does not support the video tag.'
	                        )
	                    );
	                } else {
	                    content = _react2.default.createElement('div', { style: Object.assign({}, donorSeaBox, { zIndex: -100, position: 'absolute', backgroundSize: "cover", backgroundImage: "url(" + fullpath + ")" }) });
	                }
	
	                var opacity = Number(_lodash2.default.get(this._slideshowConfig.custom_fields, 'overlay_opacity.val', 0));
	                var overlayCss = {
	                    backgroundColor: _lodash2.default.get(this._slideshowConfig.custom_fields, 'overlay_color.val', '#FFFFFF'),
	                    opacity: opacity !== 0 ? opacity / 100 : opacity,
	                    position: 'absolute',
	                    width: this.props.screen.screenWidth,
	                    height: this.props.screen.screenHeight
	                };
	
	                return _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: 'slowfadedelay',
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        _react2.default.createElement(
	                            'div',
	                            { key: this.state.elementIndex },
	                            content
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: 'slowfadedelay',
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        _react2.default.createElement(
	                            'div',
	                            { key: this.state.contentStage },
	                            this.state.contentStage === 0 ? _react2.default.createElement('div', { style: overlayCss }) : null
	                        )
	                    ),
	                    _react2.default.createElement(_DonorSea2.default, {
	                        left: donorSeaBox.left,
	                        top: donorSeaBox.top,
	                        width: donorSeaBox.width,
	                        height: donorSeaBox.height,
	                        screen: this.props.screen,
	                        elementIndex: this.state.elementIndex,
	                        handleStats: this.handleStats,
	                        config: this._seaConfig,
	                        screensH: seaContents.screensH,
	                        screensV: seaContents.screensV,
	                        allowedScreens: this.props.allowedScreens,
	                        contentStage: this.state.contentStage
	                    }),
	                    this.showBezelHandle(seaContents.screensH, seaContents.screensV),
	                    this.state.showDebug === 2 ? _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', color: 'white', top: 0, left: 0, width: this.props.screen.screenWidth / 3, height: this.props.screen.screenHeight / 2, opacity: .9, backgroundColor: 'black' } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { marginLeft: this.props.screen.screenHeight * .01, marginTop: this.props.screen.screenHeight * .02, fontSize: this.props.screen.screenHeight * .0175, width: this.props.screen.screenWidth / 3, height: this.props.screen.screenHeight / 2 } },
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Donors'
	                            ),
	                            _react2.default.createElement('br', null),
	                            'Current Count: ',
	                            this.state.nameCount,
	                            _react2.default.createElement('br', null),
	                            'Total Displayed: ',
	                            this.state.namesDisplayed,
	                            _react2.default.createElement('br', null),
	                            'Elapsed Seconds: ',
	                            this.state.secondsPassed,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'b',
	                                null,
	                                'Config'
	                            ),
	                            _react2.default.createElement('br', null),
	                            'textColor: ',
	                            JSON.stringify(this._seaConfig.textColor),
	                            _react2.default.createElement('br', null),
	                            'cycleTimeInit: ',
	                            JSON.stringify(this._seaConfig.cycleTimeInit),
	                            _react2.default.createElement('br', null),
	                            'initDuration: ',
	                            JSON.stringify(this._seaConfig.initDuration),
	                            _react2.default.createElement('br', null),
	                            'cycleTime: ',
	                            JSON.stringify(this._seaConfig.cycleTime),
	                            _react2.default.createElement('br', null),
	                            'ranks: ',
	                            JSON.stringify(this._seaConfig.ranks),
	                            _react2.default.createElement('br', null),
	                            'nameMargin: ',
	                            JSON.stringify(this._seaConfig.nameMargin),
	                            _react2.default.createElement('br', null),
	                            'edgeMargin: ',
	                            JSON.stringify(this._seaConfig.edgeMargin),
	                            _react2.default.createElement('br', null),
	                            'Seconds Interval: ',
	                            this.state.sinceElement,
	                            _react2.default.createElement('br', null)
	                        )
	                    ) : null
	                );
	            } catch (e) {
	                console.log(e);
	            }
	        }
	    }]);
	
	    return DonorSeaContainer;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.handleKeyDown = function (event) {
	        switch (event.key) {
	            case "s":
	                console.log(_this3.props);
	                break;
	            case "d":
	                var newDebug = _this3.state.showDebug + 1;
	                if (newDebug > 2) {
	                    newDebug = 0;
	                }
	                _this3.setState({
	                    showDebug: newDebug
	                });
	                break;
	            case "n":
	                if (_this3.state.contentStage === 0) {
	                    //fade out names
	                    _this3.setState({
	                        contentStage: 1
	                    });
	                } else if (_this3.state.contentStage === 2) {
	                    //start names fade in
	                    _this3.setState({
	                        contentStage: 0
	                    });
	                }
	                break;
	            default:
	                break;
	        }
	    };
	
	    this.handleStats = function (nameCount, displayed) {
	        if (_this3.state.showDebug) {
	            _this3.setState({
	                nameCount: nameCount,
	                namesDisplayed: displayed,
	                secondsPassed: _timeHelpers2.default.diff(_this3._startTime, new Date(), "seconds"),
	                sinceElement: _timeHelpers2.default.diff(_this3._elementCycleTime, new Date(), "seconds")
	            });
	        }
	    };
	
	    this.setupIntervalHandler = function () {
	        // console.log("A3 Setup Interval", new Date().toTimeString().split(' ')[0]);
	        //video before last
	        if (_this3.state.elementIndex === _this3._config.elementStates.length - 2) {
	            //fade names out a second before end of video
	            _this3._fadeOutTime = _this3._intervalTimeoutMS - 2000; //2 seconds before end of clip proceeding last
	            if (_this3._fadeOutTime < 0) {
	                _this3.setState({
	                    contentStage: 1 //already faded out
	                });
	                _this3._fadeOutTime = 0; //next frame
	            } else {
	                _this3.setState({
	                    contentStage: 0 //normal show names
	                });
	                _this3._fadeOutTimeout = setTimeout(function () {
	                    _this3.setState({
	                        contentStage: 1 //issue fadeout
	                    });
	                }, _this3._fadeOutTime);
	            }
	        } else if (_this3.state.elementIndex === _this3._config.elementStates.length - 1) //handle last video
	            {
	                _this3.setState({
	                    contentStage: 1 //don't show any names
	                });
	            } else {
	            //handle all proceeding videos
	            _this3.setState({
	                contentStage: 0 //normal show names
	            });
	        }
	
	        clearTimeout(_this3._intervalTimeout);
	        _this3._intervalTimeout = null;
	        _this3._intervalTimeout = setTimeout(function () {
	
	            _this3._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this3._cycleIntervals);
	
	            if (_this3._intervalTimeoutMS > 500) {
	                var elementIndex = (0, _shared.loopIndex)(_this3.state.elementIndex, 0, _this3._config.elementStates.length - 1, "forward");
	                _this3.setState({
	                    elementIndex: elementIndex
	                });
	                _this3._elementCycleTime = new Date();
	                console.log("A3 this._intervalTimeoutMS: " + _this3._intervalTimeoutMS, "elementIndex: " + elementIndex, new Date().toTimeString().split(' ')[0]);
	            }
	
	            _this3.setupIntervalHandler();
	        }, _this3._intervalTimeoutMS);
	    };
	
	    this.logDebug = function (obj) {
	        if (_this3.state.showDebug === 2) {
	            console.log(obj);
	        }
	    };
	
	    this.setVideoSeekTimeInterval = function () {
	        clearTimeout(_this3._intervalSeekTimeout);
	        _this3._intervalSeekTimeout = null;
	        _this3._intervalSeekTimeout = setTimeout(function () {
	            var fileType = (0, _shared.getFileType)(_this3._config.elementStates[_this3.state.elementIndex].file_name);
	            if (fileType === "video") {
	                if (!_this3._currentVideoRef) {
	                    _this3.setVideoSeekTimeInterval();
	                } else {
	                    _this3._currentVideoRef.currentTime = _this3.state.currentTimeInterval / 1000;
	                    clearTimeout(_this3._intervalSeekTimeout);
	                }
	            }
	        }, 30);
	    };
	
	    this.showBezelHandle = function (screensH, screensV) {
	        if (_this3.state.showDebug !== 1) {
	            return null;
	        }
	
	        var debugBoxStyle = {
	            position: 'absolute',
	            borderStyle: 'solid',
	            borderWidth: _this3.props.screen.screenHeight * .005,
	            width: _this3.props.screen.screenWidth / screensH,
	            height: _this3.props.screen.screenHeight / screensV,
	            opacity: .7
	        };
	
	        if (screensH === 5 && screensV === 2) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5 * 2, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5 * 3, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5 * 4, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: _this3.props.screen.screenHeight / 2, borderStyle: 'solid' }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5, top: _this3.props.screen.screenHeight / 2 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5 * 2, top: _this3.props.screen.screenHeight / 2 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5 * 3, top: _this3.props.screen.screenHeight / 2 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 5 * 4, top: _this3.props.screen.screenHeight / 2 }) })
	            );
	        }
	        if (screensH === 4 && screensV === 2) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 4, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 4 * 2, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 4 * 3, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: _this3.props.screen.screenHeight / 2, borderStyle: 'solid' }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 4, top: _this3.props.screen.screenHeight / 2 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 4 * 2, top: _this3.props.screen.screenHeight / 2 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 4 * 3, top: _this3.props.screen.screenHeight / 2 }) })
	            );
	        } else if (screensH === 3 && screensV === 2) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 3, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 3 * 2, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: _this3.props.screen.screenHeight / 2, borderStyle: 'solid' }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 3, top: _this3.props.screen.screenHeight / 2 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: _this3.props.screen.screenWidth / 3 * 2, top: _this3.props.screen.screenHeight / 2 }) })
	            );
	        } else if (screensH === 1 && screensV === 2) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: 0 }) }),
	                _react2.default.createElement('div', { style: Object.assign({}, debugBoxStyle, { left: 0, top: _this3.props.screen.screenHeight / 2 }) })
	            );
	        } else {
	            return null;
	        }
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    var allowedScreens = { enabled: false, allowedH: [], allowedV: [] };
	    if (_lodash2.default.has(state, 'content.settings.custom_vars.allowedH')) {
	        allowedScreens.enabled = true;
	        allowedScreens.allowedH = (0, _dataHelpers.safeJson)(state.content.settings.custom_vars.allowedH) || [];
	    }
	    if (_lodash2.default.has(state, 'content.settings.custom_vars.allowedV')) {
	        allowedScreens.enabled = true;
	        allowedScreens.allowedV = (0, _dataHelpers.safeJson)(state.content.settings.custom_vars.allowedV) || [];
	    }
	
	    return {
	        content: state.content,
	        donors: state.donors,
	        screen: state.screen,
	        active_module: state.active_module,
	        allowedScreens: allowedScreens
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DonorSeaContainer);

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(19);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavButton = function (_Component) {
	    _inherits(NavButton, _Component);
	
	    function NavButton() {
	        _classCallCheck(this, NavButton);
	
	        return _possibleConstructorReturn(this, (NavButton.__proto__ || Object.getPrototypeOf(NavButton)).apply(this, arguments));
	    }
	
	    _createClass(NavButton, [{
	        key: 'idleHand',
	        value: function idleHand() {
	            var navClass = "fadediv";
	            if (this.props.idle === false) {
	                navClass += " fadeout";
	            } else {
	                navClass += " jiggleitem";
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: navClass, style: { display: 'inline-block', height: '7vh' } },
	                _react2.default.createElement('img', { alt: 'interact', style: { height: '7vh' }, src: '/img/ui/handicon-02.png' })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (this.props.showNav === false) {
	                return _react2.default.createElement('span', null);
	            }
	
	            var navButtonStyle = void 0;
	            if (this.props.screen.orientation === "horizontal") {
	                navButtonStyle = {
	                    color: 'white',
	                    position: 'fixed',
	                    height: this.props.screen.screenHeight * .065,
	                    width: this.props.screen.screenHeight * .065,
	                    fontSize: this.props.screen.screenHeight * .025,
	                    left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10,
	                    bottom: this.props.screen.r16_9.p10,
	                    zIndex: 99
	                };
	            } else {
	                navButtonStyle = {
	                    color: 'white',
	                    position: 'fixed',
	                    height: this.props.screen.screenHeight * .065,
	                    width: this.props.screen.screenHeight * .065,
	                    fontSize: this.props.screen.screenHeight * .025,
	                    left: this.props.screen.r16_9.p10,
	                    bottom: this.props.screen.r16_9.p10,
	                    zIndex: 99
	                };
	            }
	
	            var navClass = "fadediv";
	            if (this.props.idle === true) {
	                navClass += " fadeout";
	            }
	            if (this.props.animate === true && this.props.idle === false && this.props.recentInteraction === false) {
	                navClass += " jiggleitem";
	            }
	
	            var idleHand = this.idleHand();
	
	            return _react2.default.createElement(
	                'span',
	                { className: 'phand ', onMouseDown: this.props.handleNavigationSlide, style: navButtonStyle },
	                _react2.default.createElement(
	                    'span',
	                    { style: { position: 'absolute', bottom: 0 } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: navClass },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'bars', size: '2x' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { style: { position: 'absolute', bottom: 0 } },
	                    idleHand
	                )
	            );
	        }
	    }]);
	
	    return NavButton;
	}(_react.Component);
	
	exports.default = NavButton;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _QuoteText = __webpack_require__(407);
	
	var _QuoteText2 = _interopRequireDefault(_QuoteText);
	
	var _QuoteSlideshow = __webpack_require__(405);
	
	var _QuoteSlideshow2 = _interopRequireDefault(_QuoteSlideshow);
	
	var _timeHelpers = __webpack_require__(39);
	
	var _timeHelpers2 = _interopRequireDefault(_timeHelpers);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared3 = __webpack_require__(4);
	
	var _QuoteStory = __webpack_require__(406);
	
	var _QuoteStory2 = _interopRequireDefault(_QuoteStory);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _sailsIo = __webpack_require__(140);
	
	var _sailsIo2 = _interopRequireDefault(_sailsIo);
	
	var _socket = __webpack_require__(141);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _config = __webpack_require__(34);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _videoStyle = {
	  preload: 'auto',
	  position: 'relative',
	  minWidth: '100%',
	  minHeight: '100%',
	  width: '100%',
	  height: '100%',
	  loop: '',
	  autoplay: "",
	  muted: "",
	  pointerEvents: "none"
	};
	
	var QUOTE = "image_quote";
	var FULLSCREEN = "fullscreen_image";
	var SLIDESHOW = "slideshow";
	var SLIDESHOW_2 = "slideshow_2";
	var QuillDeltaToHtmlConverter = __webpack_require__(16);
	
	var QuoteContainer = function (_Component) {
	  _inherits(QuoteContainer, _Component);
	
	  function QuoteContainer(props) {
	    _classCallCheck(this, QuoteContainer);
	
	    var _this = _possibleConstructorReturn(this, (QuoteContainer.__proto__ || Object.getPrototypeOf(QuoteContainer)).call(this, props));
	
	    _this.websocketHandler = function () {
	      var displayId = _this.props.content.id;
	      _this._io = (0, _sailsIo2.default)(_socket2.default);
	
	      _this._io.sails.autoConnect = true;
	      _this._io.sails.url = _config2.default.WEB_SERVER;
	
	      _this._io.socket.on('email_announcement', function (event) {
	        // console.log("Event triggered");
	        _this.setupAsset(event);
	      });
	
	      _this._io.socket.on('connect', function () {
	        _this._io.socket.get('/feed/subscribe?display=' + displayId, function serverResponded(body, JWR) {
	          // console.log('loaded');
	        });
	      });
	
	      _this._io.socket.on('error', function (e) {
	        // console.log('error');
	      });
	
	      _this._io.socket.on('disconnect', function () {
	        _this._io.socket._raw.io._reconnection = true;
	      });
	    };
	
	    _this.setupAsset = function (event) {
	      var data = JSON.parse(event);
	      if (data.subject && _this.props.content.settings.announcement_modules) {
	        var module = _lodash2.default.find(_this.props.content.settings.announcement_modules, { subject: data.subject });
	        if (module) {
	          var announcementModule = _lodash2.default.find(_this.props.content.dm_active, { id: module.id });
	          if (announcementModule) {
	            var asset = _lodash2.default.get(announcementModule.contents, "images[0]", null);
	            if (asset) {
	              _this._assetFile = asset.file_name;
	              var announcementAudioAsset = _lodash2.default.get(announcementModule.contents, "images[1]", null);
	              if (announcementAudioAsset) {
	                _this._audioAssetFile = announcementAudioAsset.file_name;
	              }
	
	              _this._announcementAsset = _shared2.default.dp(_this.props.screen, asset);
	              _this._announcementAudioAsset = _shared2.default.dp(_this.props.screen, announcementAudioAsset);
	              _this._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
	
	              var timeout = 0;
	              if (data.schedule_for) {
	                timeout = Number(data.schedule_for) - Date.now();
	              }
	              if (timeout <= 0) {
	                _this.showModal();
	              } else {
	                setTimeout(function () {
	                  _this.showModal();
	                }, timeout);
	              }
	            }
	          }
	        }
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      switch (event.key) {
	        case "s":
	          console.log(_this.props);
	          break;
	        case "d":
	          var newDebug = _this.state.showDebug + 1;
	          if (newDebug > 2) {
	            newDebug = 0;
	          }
	          _this.setState({
	            showDebug: newDebug
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.setupIntervalHandler = function () {
	      // console.log('interval');
	      clearTimeout(_this._intervalTimeout);
	      _this._intervalTimeout = null;
	      _this._intervalTimeout = setTimeout(function () {
	        _this._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._elementsIntervals);
	
	        if (_this._intervalTimeoutMS > 500) {
	          var elementIndex = _shared2.default.loopIndex(_this.state.elementIndex, 0, _this._elementStates.length - 1, "forward");
	          // console.log("current stage index", this.state.currentStage);
	          // let stageIndex = shared.loopIndex(this.state.currentStage, 0, this._stages, "forward");
	          // console.log("new stage index", stageIndex);
	          var currentStoryType = _this._elementStates[elementIndex].bodyCopy.storyType;
	
	          _this.setState({
	            elementIndex: elementIndex,
	            storyType: currentStoryType
	            // currentStage: stageIndex
	          });
	        }
	
	        _this.setupIntervalHandler();
	      }, _this._intervalTimeoutMS);
	    };
	
	    _this.setupQuoteIndexHandler = function () {
	      clearTimeout(_this._quoteIndexTimeout);
	      _this._quoteIndexTimeout = null;
	      _this._quoteIndexTimeout = setTimeout(function () {
	        // let quotes = this._elementStates[this.state.elementIndex].quotes;
	        var quotesLength = 1;
	
	        // These times are for the whole slide cycle.
	        var timeIntervalRemainderMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._elementsIntervals);
	        if (_this.props.debug) {
	          console.log("Time Interval Remainder", timeIntervalRemainderMS);
	        }
	        var elementIntervalMS = _this._elementStates[_this.state.elementIndex].cycleTime;
	        if (_this.props.debug) {
	          console.log("elementIntervalMs", elementIntervalMS);
	        }
	        var currentMoment = elementIntervalMS - timeIntervalRemainderMS;
	        if (_this.props.debug) {
	          console.log("currentMoment", currentMoment);
	        }
	        var quoteOverlayOffsetDuration = _this._elementStates[_this.state.elementIndex].quoteOverlayOffsetDuration * 1000;
	
	        // Check current quote index based on duration of each of the quotes.
	        // These times are for the Quote Cycle (Could be multiple quotes per Slide Cycle)
	        // let quoteCycleTime = this._elementStates[this.state.elementIndex].quoteCycleTime;
	        var quoteCycleTime = elementIntervalMS;
	        var currentMomentInQuoteTransitionMS = currentMoment % quoteCycleTime;
	        var timeQuoteRemainderMS = quoteCycleTime - currentMomentInQuoteTransitionMS;
	        var currentQuoteIndex = Math.floor(currentMoment / quoteCycleTime) % quotesLength;
	        if (_this.props.debug) {
	          console.log("Current Quote Index", currentQuoteIndex);
	        }
	        if (currentQuoteIndex + 1 > quotesLength) {
	          currentQuoteIndex = 0;
	        }
	
	        var nextIndex = _this.state.elementIndex;
	        if (_this.props.debug) {
	          console.log("Next Index", nextIndex);
	        }
	
	        if (timeIntervalRemainderMS > 500) {
	          if (_this.props.debug) {
	            console.log("Time Interval is > than 500");
	          }
	
	          if (timeIntervalRemainderMS <= timeQuoteRemainderMS - quoteOverlayOffsetDuration) {
	            nextIndex = _shared2.default.loopIndex(_this.state.elementIndex, 0, _this._elementStates.length - 1, "forward");
	          }
	
	          if (_this._elementStates[_this.state.elementIndex].overlayText) {
	            // Show when the video is starting
	            // console.log("Has Overlay")
	            if (currentMomentInQuoteTransitionMS >= quoteOverlayOffsetDuration && currentMomentInQuoteTransitionMS < quoteCycleTime - quoteOverlayOffsetDuration) {
	              if (_this.props.debug) {
	                console.log("Show the Quote", currentQuoteIndex, "for element", nextIndex);
	              }
	
	              _this._intervalQuoteMS = timeQuoteRemainderMS - quoteOverlayOffsetDuration;
	              _this.setState({
	                showOverlay: true,
	                currentQuoteIndex: currentQuoteIndex
	              });
	              // Hide when the video is ending
	            } else if (currentMomentInQuoteTransitionMS >= quoteCycleTime - quoteOverlayOffsetDuration) {
	              // console.log('hiding at', currentMoment);
	              if (_this.props.debug) {
	                console.log("Hide the Quote", currentQuoteIndex, "for element", nextIndex);
	              }
	              _this._intervalQuoteMS = timeQuoteRemainderMS + _this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000;
	              _this.setState({
	                showOverlay: false,
	                currentQuoteIndex: currentQuoteIndex
	              });
	            } else {
	              _this._intervalQuoteMS = 100;
	              if (_this.props.debug) {
	                console.log("None of the previous conditions were met, delay next interval 100ms");
	              }
	            }
	          } else {
	            _this.setState({
	              showOverlay: false,
	              currentQuoteIndex: currentQuoteIndex
	            });
	            _this._intervalQuoteMS = timeIntervalRemainderMS + _this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000;
	          }
	        } else {
	          if (_this.props.debug) {
	            console.log("Time Interval is not > than 500");
	          }
	        }
	
	        _this.setupQuoteIndexHandler();
	      }, _this._intervalQuoteMS);
	    };
	
	    _this.setVideoSeekTimeInterval = function () {
	      clearTimeout(_this._intervalSeekTimeout);
	      _this._intervalSeekTimeout = null;
	      _this._intervalSeekTimeout = setTimeout(function () {
	        var fileType = (0, _shared3.getFileType)(_this._elementStates[_this.state.elementIndex].backgroundImageDonorSea);
	        if (fileType === "video") {
	          if (!_this._currentVideoRef) {
	            _this.setVideoSeekTimeInterval();
	          } else {
	            _this._currentVideoRef.currentTime = _this.state.currentTimeInterval / 1000;
	            clearTimeout(_this._intervalSeekTimeout);
	          }
	        }
	      }, 30);
	    };
	
	    _this.loadedMetadata = function (event) {
	      var videoHeight = _this._videoModalRef.getBoundingClientRect().height;
	      var videoWidth = _this._videoModalRef.getBoundingClientRect().width;
	      var videoMaxHeight = 0;
	      var videoMaxWidth = 0;
	      var videoOffsetX = 0;
	      var videoOffsetY = 0;
	      var videoRatio = videoWidth / videoHeight;
	      // let screenRatio = this.props.screen.screenWidth / this.props.screen.screenHeight;
	      var isHorizontal = videoWidth > videoHeight;
	
	      if (isHorizontal) {
	        videoMaxWidth = _this.props.screen.screenWidth;
	        videoMaxHeight = videoMaxWidth / videoRatio;
	      } else {
	        videoMaxHeight = _this.props.screen.screenHeight;
	        videoMaxWidth = videoMaxHeight * videoRatio;
	      }
	
	      videoOffsetX = videoMaxWidth < _this.props.screen.screenWidth ? _this.props.screen.screenWidth / 2 - videoMaxWidth / 2 : 0;
	      videoOffsetY = videoMaxHeight < _this.props.screen.screenHeight ? _this.props.screen.screenHeight / 2 - videoMaxHeight / 2 : 0;
	
	      var videoControlsOffset = videoOffsetY + videoHeight / 2;
	
	      // console.log("Loaded Metadata");
	
	      if (_this._videoModalRef !== undefined && _this._videoModalRef !== null) {
	        var duration = _this._videoModalRef.duration;
	        // console.log("1- Setting a duration of", duration);
	        _this._modalCycle = setTimeout(function () {
	          // console.log("Closing Modal");
	          _this.setState({
	            showModalVideo: false
	          });
	        }, duration * 1000);
	      } else {
	        _this.handleVideoDuration();
	      }
	
	      _this.setState({
	        duration: event.target.duration,
	        videoOffsetY: videoOffsetY,
	        videoOffsetX: videoOffsetX,
	        videoControlsOffset: videoControlsOffset,
	        videoMaxHeight: videoMaxHeight,
	        videoMaxWidth: videoMaxWidth,
	        videoFile: _this.props.content.file_path
	      });
	    };
	
	    try {
	      _this._elementStates = [];
	      _this._elementsIntervals = [];
	      _this._elementIntervalMS = null;
	      _this._checkerboardIndexStorage = null;
	      _this._assetFile = null;
	      _this._announcementAsset = null;
	      _this._announcementAudioAsset = null;
	      _this._announcementTimeout = null;
	      _this._modalCycle = null;
	
	      _this.setupElements();
	
	      var currentTimeInterval = _timeHelpers2.default.elementIndexCurrentSeekTime(_this._elementIntervalMS);
	
	      var elementIndex = _timeHelpers2.default.indexFromIntervalArray(_this._elementsIntervals);
	      var timeIntervalRemainderMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._elementsIntervals);
	
	      _this.state = {
	        storyType: _this._elementStates[elementIndex].bodyCopy.storyType,
	        elementIndex: elementIndex,
	        secondsPassed: 0,
	        showDebug: 0,
	        quoteState: 0,
	        currentStage: 0,
	        currentTimeInterval: currentTimeInterval,
	        showOverlay: false,
	        showModalVideo: false
	      };
	
	      _this._currentVideoRef = null;
	      _this._intervalTimeoutMS = timeIntervalRemainderMS;
	      _this._intervalTimeout = null;
	      _this._intervalCommunityTimeout = null;
	      _this._intervalQuoteMS = 0;
	      _this._currentSlideshow = "quote_slideshow";
	      _this._intervalSeekTimeout = null;
	      _this._startTime = new Date();
	
	      _this._stages = 2;
	    } catch (e) {
	      console.log(e);
	    }
	    return _this;
	  }
	
	  _createClass(QuoteContainer, [{
	    key: 'showModal',
	    value: function showModal() {
	      var _this2 = this;
	
	      var fileType = (0, _shared3.getFileType)(this._assetFile);
	      if (fileType === "video") {
	        if (!this.state.showModalVideo) {
	          this.setState({
	            showModalVideo: true
	          });
	        }
	      } else {
	        if (!this.state.showModal) {
	          this.setState({
	            showModal: true
	          });
	
	          this._modalCycle = setTimeout(function () {
	            _this2.setState({
	              showModal: false
	            });
	          }, this._announcementTimeout);
	        }
	      }
	
	      // Check for the audio asset
	      if (this._audioAssetFile) {
	        var audioFileType = (0, _shared3.getFileType)(this._audioAssetFile);
	        // console.log("2.- Filetype", audioFileType);
	        if (audioFileType === "audio") {
	          if (!this.state.playAudio) {
	            this.setState({
	              playAudio: true
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var fileType = (0, _shared3.getFileType)(this._announcementAsset);
	      if (fileType === "video") {
	        if (this.state.showModalVideo) {
	          this.setState({
	            showModalVideo: false
	          });
	          clearTimeout(this._modalCycle);
	        }
	      } else {
	        if (this.state.showModal) {
	          this.setState({
	            showModal: false
	          });
	          clearTimeout(this._modalCycle);
	        }
	      }
	    }
	  }, {
	    key: 'setupElements',
	    value: function setupElements() {
	      var _this3 = this;
	
	      try {
	        var count = 0;
	        var rootFolder = _lodash2.default.get(this.props.content, 'settings.selected_root_folder', null);
	        var parentActive = {};
	        if (rootFolder !== null) {
	          rootFolder = Number(rootFolder);
	          parentActive = _lodash2.default.find(this.props.content.story_categories, { id: rootFolder });
	        } else {
	          parentActive = _lodash2.default.find(this.props.content.story_categories, function (folder) {
	            var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	            return type === "active";
	          });
	        }
	        var storyBoardFolder = _lodash2.default.find(this.props.content.story_categories, function (folder) {
	          var type = _lodash2.default.get(folder, 'contents.custom_fields.folder_type.val.value', null);
	          return type === 'attract_loop_stories' && folder.parent_category === parentActive.id;
	        });
	        var modules = _shared2.default.getAllFolderModules(this.props.content.folder_modules, this.props.donors, this.props.content.stories, storyBoardFolder.id);
	
	        if (modules && modules.length > 0) {
	          _lodash2.default.forEach(modules, function (module, key) {
	            var section = count === 0 || count % 2 === 0 ? "right" : "left";
	            var fileObj = _lodash2.default.get(module, 'contents.images[1]', null);
	            var backgroundMedia = (0, _shared3.dp)(_this3.props.screen, _lodash2.default.get(module, 'contents.images[1]', null));
	            var backgroundType = fileObj ? (0, _shared3.getFileType)(fileObj.file_name) : "unspported";
	
	            var storyType = _lodash2.default.get(module.contents.custom_fields, "story_type.val.value", QUOTE);
	            var overlay = storyType === FULLSCREEN ? false : true;
	
	            var cycleTime = Number(_lodash2.default.get(module.contents.custom_fields, 'cycle_time.val', 60));
	            var quoteCycleTime = Number(_lodash2.default.get(module.contents.custom_fields, 'cycle_time.val', 20));
	            cycleTime *= 1000;
	            quoteCycleTime *= 1000;
	
	            var upperTextVal = _lodash2.default.get(module.contents, "custom_fields.long_quote_text.val", "");
	            var lowerTextVal = _lodash2.default.get(module.contents, "custom_fields.long_quote_text_part_2.val", "");
	            var signatureVal = _lodash2.default.get(module.contents, "custom_fields.signature.val", "");
	
	            var upperText = "";
	            var lowerText = "";
	            var signatureText = "";
	            var converter = {};
	
	            if (upperTextVal.ops) {
	              converter = new QuillDeltaToHtmlConverter(upperTextVal.ops, {});
	              upperText = converter.convert();
	            }
	            if (lowerTextVal.ops) {
	              converter = new QuillDeltaToHtmlConverter(lowerTextVal.ops, {});
	              lowerText = converter.convert();
	            }
	
	            if (signatureVal.ops) {
	              converter = new QuillDeltaToHtmlConverter(signatureVal.ops, {});
	              signatureText = converter.convert();
	            }
	
	            var quote = [{
	              upperText: upperText,
	              lowerText: lowerText,
	              signatureText: signatureText
	            }, {
	              upperText: upperText,
	              lowerText: lowerText,
	              signatureText: signatureText
	            }, {
	              upperText: upperText,
	              lowerText: lowerText,
	              signatureText: signatureText
	            }];
	
	            _this3._elementsIntervals.push(cycleTime);
	            _this3._elementStates.push({
	              quotes: quote,
	              cycleTime: cycleTime,
	              quoteCycleTime: quoteCycleTime,
	              customFields: module.contents.custom_fields,
	              arrays: _lodash2.default.get(module.contents, 'arrays', {}),
	              arraysValues: _lodash2.default.get(module.contents, 'arrays_values', {}),
	              backgroundImageDonorSea: backgroundMedia,
	              backgroundType: backgroundType,
	              overlayText: overlay,
	              quoteOverlayOffsetDuration: 2,
	              bodyCopy: {
	                storyType: storyType,
	                marginLeft: 5,
	                marginRight: 30,
	                upperText: module.contents.story,
	                lowerText: _lodash2.default.has(module.contents, "custom_fields.long_quote_part_2.val") ? module.contents.custom_fields.long_quote_part_2.val : "",
	                longQuoteStyle: _lodash2.default.has(module.contents, "custom_fields.long_quote_style") ? module.contents.custom_fields.long_quote_style : "",
	                longQuoteCenterOffset: _lodash2.default.get(module.contents, "custom_fields.long_quote_center_offset.val", 5),
	                shortQuoteStyle: _lodash2.default.has(module.contents, "custom_fields.short_quote_style") ? module.contents.custom_fields.short_quote_style : "",
	                signature: _lodash2.default.has(module.contents, "custom_fields.signature") ? module.contents.custom_fields.signature.val : "",
	                signatureStyle: _lodash2.default.has(module.contents, "custom_fields.signature_style") ? module.contents.custom_fields.signature_style : "",
	                section: section,
	                quoteBackdrop: _lodash2.default.get(module.contents.custom_fields, "long_quote_background_color.val", "#FFFFFF")
	              }
	            });
	
	            if (storyType === QUOTE) {
	              count++;
	            }
	          });
	        } else {
	          console.log("No modules were found in the attract loop");
	        }
	      } catch (e) {
	        console.log(e);
	      }
	
	      // console.log(this._elementStates);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      try {
	        var socketsEnabled = _lodash2.default.get(_config2.default, 'sockets.enabled', false);
	        if (socketsEnabled) {
	          this.websocketHandler();
	        }
	        this.setupIntervalHandler();
	        this.setupQuoteIndexHandler(); //rework to use the element index instead, becoase video will cycle with quotes.
	        document.addEventListener("keydown", this.handleKeyDown);
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      clearTimeout(this._intervalTimeout);
	      clearTimeout(this._intervalSeekTimeout);
	      this._intervalTimeout = null;
	      this._intervalSeekTimeout = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var modalStyle = {
	        position: 'absolute',
	        height: this.props.screen.screenHeight,
	        width: this.props.screen.screenWidth,
	        // backgroundColor:'#a4bcc2',
	        zIndex: 9999
	      };
	
	      var _btnStyle = {
	        color: 'white',
	        position: 'absolute',
	        fontSize: this.props.screen.screenHeight * 0.05,
	        fontStyle: 'normal',
	        fontWeight: 'bold',
	        textDecoration: 'none',
	        zIndex: 9999
	      };
	
	      var cType = "";
	      if (this.state.showModalVideo) {
	        cType = (0, _shared3.videoType)(this._announcementAsset);
	      }
	      try {
	        return _react2.default.createElement(
	          'div',
	          { style: { backgroundColor: "white", fontFamily: 'Roboto', position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.elementIndex },
	              this.state.storyType === QUOTE ? _react2.default.createElement(_QuoteStory2.default, {
	                element: this._elementStates[this.state.elementIndex],
	                horizontalScreens: 3,
	                verticalScreens: 2,
	                screen: this.props.screen
	              }) : null,
	              this.state.storyType === FULLSCREEN ? _react2.default.createElement(_QuoteStory2.default, {
	                element: this._elementStates[this.state.elementIndex],
	                horizontalScreens: 3,
	                verticalScreens: 2,
	                screen: this.props.screen,
	                fullscreen: true
	              }) : null,
	              [SLIDESHOW, SLIDESHOW_2].indexOf(this.state.storyType) > -1 ? _react2.default.createElement(_QuoteSlideshow2.default, {
	                element: this._elementStates[this.state.elementIndex],
	                xScreens: 3,
	                yScreens: 2
	              }) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showModal },
	              this.state.showModal ? _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, modalStyle) },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#', onClick: function onClick() {
	                      _this4.closeModal();
	                    }, ref: function ref(el) {
	                      return _this4._closeModalRef = el;
	                    }, style: Object.assign({}, _btnStyle, { top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }) },
	                  'X'
	                ),
	                _react2.default.createElement('img', { alt: "Announcement Modal", style: { position: 'absolute' }, src: this._announcementAsset, ref: function ref(el) {
	                    return _this4._imageModalRef = el;
	                  }, onLoad: this.handleImageLoaded.bind(this) })
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showModalVideo },
	              this.state.showModalVideo ? _react2.default.createElement(
	                'div',
	                { style: Object.assign({}, modalStyle, { backgroundColor: "black" }) },
	                _react2.default.createElement(
	                  'video',
	                  { style: Object.assign({}, _videoStyle, { top: this.state.videoOffsetY, left: this.state.videoOffsetX }), ref: function ref(el) {
	                      return _this4._videoModalRef = el;
	                    }, onLoadedMetadata: this.loadedMetadata.bind(this), autoPlay: true, muted: true },
	                  _react2.default.createElement('source', { src: this._announcementAsset, type: cType }),
	                  'Your browser does not support the video tag.'
	                )
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.showOverlay },
	              this.state.showOverlay && this.state.storyType === QUOTE ? _react2.default.createElement(_QuoteText2.default, {
	                elementIndex: this.state.elementIndex,
	                upperText: this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex].upperText,
	                lowerText: this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex].lowerText,
	                signature: this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex].signatureText,
	                sections: 3,
	                screenWidth: this.props.screen.screenWidth,
	                screenHeight: this.props.screen.screenHeight,
	                bodyCopy: this._elementStates[this.state.elementIndex].bodyCopy,
	                xScreens: 3,
	                yScreens: 2
	              }) : null
	            )
	          )
	        );
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  }]);
	
	  return QuoteContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var debug = _shared2.default.parseStringParam(window.location.href, "debug");
	  if (debug === undefined || debug === null) {
	    debug = false;
	  }
	  return {
	    screen: state.screen,
	    content: state.content,
	    donors: state.donors,
	    debug: debug
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuoteContainer);

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _timeHelpers = __webpack_require__(39);
	
	var _timeHelpers2 = _interopRequireDefault(_timeHelpers);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _shared3 = __webpack_require__(4);
	
	var _display = __webpack_require__(28);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { combinePathFile } from '../utils/dataHelpers';
	
	
	window.tmpLogArray = [];
	var _videoStyle = {
	  preload: 'auto',
	  position: 'fixed',
	  minWidth: '100%',
	  minHeight: '100%',
	  width: '100%',
	  height: '100%',
	  zIndex: -100,
	  loop: '',
	  autoplay: "",
	  muted: "",
	  pointerEvents: "none"
	};
	
	var VerticalVideoSync = function (_Component) {
	  _inherits(VerticalVideoSync, _Component);
	
	  function VerticalVideoSync(props) {
	    _classCallCheck(this, VerticalVideoSync);
	
	    var _this = _possibleConstructorReturn(this, (VerticalVideoSync.__proto__ || Object.getPrototypeOf(VerticalVideoSync)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._currentWordScreen = 1;
	    _this._wordIndex = 0;
	    _this._slidesWords = [];
	    _this._slideshowConfig = {};
	
	    _this._screenWords = {
	      initialDelay: 3,
	      stayTime: 2,
	      delayBetweenWords: .5,
	      screens: 5,
	      topOffset: .05 * (_this.props.screen.screenHeight / 5)
	    };
	    _this._cycleIntervals = [];
	    _this._elementStates = [];
	    _this.setupElements();
	    var elementIndex = _timeHelpers2.default.indexFromIntervalArray(_this._cycleIntervals);
	    var currentTimeInterval = _timeHelpers2.default.currentSeekTimeArray(_this._cycleIntervals);
	
	    var contentStage = 0;
	    if (elementIndex === _this._elementStates.length - 1) {
	      contentStage = 1;
	    }
	
	    _this.state = {
	      elementIndex: elementIndex,
	      wordIndex: 0,
	      showDebug: 0,
	      currentTimeInterval: currentTimeInterval,
	      currentWordScreen: 1,
	      showWord: false,
	      wordFadeStep: 3, //0 fade in, 1 stay in, 2 fade out, 3 stay out,
	      contentStage: contentStage
	    };
	    _this._intervalTimeout = null;
	    _this._intervalSeekTimeout = null;
	    _this._wordsIntervalTimeout = null;
	    _this._currentVideoRef = null;
	    _this._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this._cycleIntervals, true);
	    _this._wordsIntervalTimeoutMS = 0; //run right away for first call
	
	    return _this;
	  }
	
	  _createClass(VerticalVideoSync, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.logToServer([new Date() + " Component just mounted"], "VerticalVideoSync", this.props.content.id, this.props.screen.mode, this.props.screen.webkey);
	      this.setupIntervalHandler();
	      document.addEventListener("keydown", this.handleKeyDown);
	      this.setVideoSeekTimeInterval();
	
	      // this.setupWordsInterval();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.handleKeyDown);
	      clearTimeout(this._intervalTimeout);
	      this._intervalTimeout = null;
	    }
	  }, {
	    key: 'setupElements',
	    value: function setupElements() {
	      var _this2 = this;
	
	      var slides = [];
	      // let slideshowId = null;
	
	      var dm = this.props.content.dm_active[this.props.active_module];
	
	      if (!dm) {
	        console.log("No slide module found with the given name, check the name= url parameter.");
	      }
	
	      this._wordStyle = {
	        position: 'absolute',
	        left: this.props.screen.screenWidth * 0.1,
	        width: this.props.screen.screenWidth * .8,
	        color: '#ffffff',
	        fontSize: this.props.screen.screenHeight * 0.037037037,
	        fontStyle: 'Normal',
	        fontWeight: 400,
	        textAlign: 'left',
	        lineHeight: 1,
	        visible: true
	      };
	
	      var customWordStyle = _lodash2.default.get(dm, 'contents.custom_fields.inspirationalWordsStyling', null);
	      // console.log("CUSTOM WORD STYLE?", customWordStyle);
	      if (customWordStyle !== null) {
	        this._wordStyle.fontSize = customWordStyle.fontSize * .01 * this.props.screen.screenHeight;
	        this._wordStyle.fontStyle = customWordStyle.fontStyle;
	        this._wordStyle.fontFamily = customWordStyle.font;
	        this._wordStyle.fontWeight = Number(customWordStyle.fontWeight);
	        this._wordStyle.textAlign = customWordStyle.justification.toLowerCase();
	        this._wordStyle.lineHeight = customWordStyle.lineHeight * .01;
	        this._wordStyle.visible = customWordStyle.visible;
	        this._screenWords.topOffset = customWordStyle.height * (this.props.screen.screenHeight / 5) * .01;
	      }
	
	      this._slideshowConfig = dm.contents;
	      _lodash2.default.forEach(dm.contents.images, function (img, imgKey) {
	        if (_lodash2.default.get(dm, 'contents.bool0s[' + imgKey + ']', true) === true && imgKey % 2 === 0) {
	          var textColor = _lodash2.default.get(dm, 'contents.color0s[' + imgKey + ']', "#000000");
	          slides.push({
	            "backgroundContent": img,
	            "attributeText": dm.contents.names[imgKey],
	            "showWords": _lodash2.default.get(dm, 'contents.bool1s[' + imgKey + ']', false),
	            "textColor": textColor
	          });
	          _this2._cycleIntervals.push(_lodash2.default.get(dm, 'contents.cycle_overrides[' + imgKey + ']', 5) * 1000);
	        }
	      });
	
	      if (_lodash2.default.has(dm.contents, "custom_fields.words.val") && dm.contents.custom_fields.words.val.length > 0) {
	        this._slidesWords = dm.contents.custom_fields.words.val.split(",");
	      }
	      // console.log("slides", slides);
	      // console.log(this._cycleIntervals, this._cycleIntervals)
	      // let slideshow = _.find(this.props.content.dm_active, function(o) { return o.id === Number(slideshowId) });
	      this._elementStates = slides;
	      if (this._elementStates.length === 0) {
	        console.log("no slides detected, please add a slideshow and confirm the slides are set to active.");
	      }
	    }
	
	    // Setup the interval handler that will loop through the background
	    // every {elementInterval} amount of time and through every element
	    // in this._elementStates
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var fileType = (0, _shared3.getFileType)(this._elementStates[this.state.elementIndex].backgroundContent.file_name);
	      var cSource = _shared2.default.dp(this.props.screen, this._elementStates[this.state.elementIndex].backgroundContent); //combinePathFile(this._elementStates[this.state.elementIndex].backgroundContent);
	      var cType = "";
	      var content = "";
	      // Check if the background is a video or an image.
	      if (fileType === "video") {
	        cType = (0, _shared3.videoType)(this._elementStates[this.state.elementIndex].backgroundContent.file_name);
	        content = _react2.default.createElement(
	          'div',
	          { className: 'vid', style: { position: 'absolute', top: 0, left: 0 } },
	          _react2.default.createElement(
	            'video',
	            { style: _videoStyle, id: 'background-video', loop: true, autoPlay: true, muted: true, ref: function ref(el) {
	                return _this3._currentVideoRef = el;
	              } },
	            _react2.default.createElement('source', { src: cSource, type: cType }),
	            'Your browser does not support the video tag.'
	          )
	        );
	      } else {
	        // Verify if the image has an attribute text that needs to be shown at the bottom
	        var attributeTextStyle = {
	          position: 'absolute',
	          bottom: this.props.screen.screenHeight * 0.018518519,
	          fontSize: this.props.screen.screenHeight * 0.018518519,
	          right: this.props.screen.screenWidth * 0.052083333,
	          color: 'white',
	          fontStyle: 'italic'
	        };
	
	        content = _react2.default.createElement('div', { style: { width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, position: 'absolute', backgroundSize: "100% 100%", backgroundImage: "url(" + cSource + ")" } });
	
	        if (this._elementStates[this.state.elementIndex].showAttributeText) {
	          content = _react2.default.createElement(
	            'div',
	            { style: { width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, position: 'absolute', backgroundSize: "100% 100%", backgroundImage: "url(" + cSource + ")" } },
	            _react2.default.createElement(
	              'span',
	              { style: Object.assign({}, attributeTextStyle) },
	              this._elementStates[this.state.elementIndex].attributeText
	            )
	          );
	        }
	      }
	      var opacity = Number(_lodash2.default.get(this._slideshowConfig.custom_fields, 'overlay_opacity_vertical.val', 0));
	      var overlayCss = {
	        backgroundColor: _lodash2.default.get(this._slideshowConfig.custom_fields, 'overlay_color_vertical.val', '#FFFFFF'),
	        opacity: opacity !== 0 ? opacity / 100 : opacity,
	        position: 'absolute',
	        width: this.props.screen.screenWidth,
	        height: this.props.screen.screenHeight
	
	        //set top
	        //if (this._wordStyle.visible === true) {
	      };var screenHeight = this.props.screen.screenHeight / this._screenWords.screens;
	
	      var top = screenHeight * (this.state.currentWordScreen - 1) + this._screenWords.topOffset;
	
	      this._wordStyle.color = this._wordStyle.color = this._elementStates[this.state.elementIndex].textColor;
	      //  let top = ((screenHeight * this.state.currentWordScreen) - screenHeight) + (screenHeight * .2);
	      //}
	
	      // Check if Words on Screen setting is enabled.
	      // let wordStyle = {};
	      // if (this._wordStyle.visible === true) {
	      //   let screenHeight = this.props.screen.screenHeight / this._screenWords.screens;
	      //   wordStyle = {
	      //     position: 'absolute',
	      //     top: ((screenHeight * this.state.currentWordScreen) - screenHeight) + (screenHeight * .2),
	      //     left: this.props.screen.screenWidth * 0.1,
	      //     fontSize: this.props.screen.screenHeight * 0.037037037
	      //   }
	      // }
	      // console.log("WORD STYLE", this._wordStyle);
	      // console.log("TOP", top);
	      //console.log("WORD?", this._slidesWords[this.state.wordIndex]);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight } },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.elementIndex },
	              content
	            )
	          ),
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'slowfadedelay',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'div',
	              { key: this.state.contentStage },
	              this.state.contentStage === 0 ? _react2.default.createElement('div', { style: overlayCss }) : null
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: Object.assign({}, this._wordStyle, { top: top }) },
	          _react2.default.createElement(
	            _CSSTransitionGroup2.default,
	            {
	              component: 'div',
	              transitionName: 'example',
	              transitionEnterTimeout: 0,
	              transitionLeaveTimeout: 0 },
	            _react2.default.createElement(
	              'span',
	              { key: this.state.showWord },
	              this.state.showWord ? this._slidesWords[this.state.wordIndex] : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VerticalVideoSync;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.handleKeyDown = function (event) {
	    switch (event.key) {
	      case "s":
	        console.log(_this4.props);
	        break;
	      case "m":
	        //testing remove
	        //setupWordsInterval after delay
	        // clearTimeout(this._wordsInvervalTimeout);
	        // this._wordsInvervalTimeout = null;
	        // this._wordsInvervalTimeout = setTimeout(() => {
	        //     this.setupWordsInterval();
	        // }, this._screenWords.initialDelay*1000);
	        // //loop the index
	        // let elementIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");
	
	        // this.setState({
	        //   elementIndex: elementIndex
	        // })
	        // this.setupIntervalHandler();
	        break;
	      default:
	        break;
	    }
	  };
	
	  this.setVideoSeekTimeInterval = function () {
	    clearTimeout(_this4._intervalSeekTimeout);
	    _this4._intervalSeekTimeout = null;
	    _this4._intervalSeekTimeout = setTimeout(function () {
	      var fileType = (0, _shared3.getFileType)(_this4._elementStates[_this4.state.elementIndex].backgroundContent.file_name);
	      if (fileType === "video") {
	        if (!_this4._currentVideoRef) {
	          _this4.setVideoSeekTimeInterval();
	        } else {
	          // Set the current position in which the video should be.
	          _this4._currentVideoRef.currentTime = _this4.state.currentTimeInterval / 1000;
	          clearTimeout(_this4._intervalSeekTimeout);
	        }
	      }
	    }, 30);
	  };
	
	  this.setupWordsInterval = function () {
	    var endCycle = false;
	    switch (_this4.state.wordFadeStep) {
	      case 0:
	        //fade in
	        _this4._wordsIntervalTimeoutMS = 300;
	        _this4.setState({
	          showWord: true,
	          currentWordScreen: _this4._currentWordScreen,
	          wordFadeStep: 1,
	          wordIndex: _this4._wordIndex
	        });
	        break;
	      case 1:
	        //stay in
	        _this4._wordsIntervalTimeoutMS = _this4._screenWords.stayTime * 1000;
	        _this4.setState({
	          wordFadeStep: 2
	        });
	        break;
	      case 2:
	        //fade out
	        _this4._wordsIntervalTimeoutMS = 300;
	        _this4.setState({
	          showWord: false,
	          wordFadeStep: 3
	        });
	        break;
	      case 3:
	        //stay out
	        _this4._wordsIntervalTimeoutMS = _this4._screenWords.delayBetweenWords * 1000;
	        _this4._wordIndex = _shared2.default.loopIndex(_this4._wordIndex, 0, _this4._slidesWords.length - 1, "forward");
	        if (_this4._currentWordScreen === _this4._screenWords.screens) {
	          endCycle = true;
	          _this4._currentWordScreen = 1;
	        } else {
	          _this4._currentWordScreen++;
	        }
	        _this4.setState({
	          wordFadeStep: 0
	        });
	        break;
	      default:
	        break;
	    }
	    clearTimeout(_this4._wordsInvervalTimeout);
	    _this4._wordsInvervalTimeout = null;
	    _this4._wordsInvervalTimeout = setTimeout(function () {
	      if (endCycle !== true) {
	        _this4.setupWordsInterval();
	      }
	    }, _this4._wordsIntervalTimeoutMS);
	  };
	
	  this.setupIntervalHandler = function () {
	    window.tmpLogArray.push(new Date() + " Creating Timeout");
	    window.tmpLogArray.push(new Date() + " Current index is: " + _this4.state.elementIndex);
	    clearTimeout(_this4._intervalTimeout);
	    _this4._intervalTimeout = null;
	    _this4._intervalTimeout = setTimeout(function () {
	      _this4._intervalTimeoutMS = _timeHelpers2.default.timeIntervalRemainderArrayMS(_this4._cycleIntervals, true);
	      window.tmpLogArray.push(new Date() + " Time for the next Cycle: " + _this4._intervalTimeoutMS);
	
	      //handle moment of calculation resulting in a near 0 number and multiple cycles
	      if (_this4._intervalTimeoutMS > 500) {
	        //loop the index
	        var elementIndex = _shared2.default.loopIndex(_this4.state.elementIndex, 0, _this4._elementStates.length - 1, "forward");
	        // console.log("ELEMENT", this._elementStates[elementIndex]);
	        //setupWordsInterval after delay if over the first video
	        if (_this4._elementStates[elementIndex].showWords === true) {
	          clearTimeout(_this4._wordsInvervalTimeout);
	          _this4._wordsInvervalTimeout = null;
	          _this4._wordsInvervalTimeout = setTimeout(function () {
	            _this4.setupWordsInterval();
	          }, _this4._screenWords.initialDelay * 1000);
	        }
	
	        var contentStage = 0;
	        if (elementIndex === _this4._elementStates.length - 1) {
	          contentStage = 1;
	        }
	
	        window.tmpLogArray.push(new Date() + " Next element Index: " + elementIndex);
	        console.log("log to server");
	        _this4.props.logToServer(window.tmpLogArray, 'VerticalVideoSync', _this4.props.content.id, _this4.props.screen.mode, _this4.props.screen.webkey);
	        window.tmpLogArray = [];
	
	        _this4.setState({
	          elementIndex: elementIndex,
	          contentStage: contentStage
	        });
	        // console.log("A1 this._intervalTimeoutMS: " + this._intervalTimeoutMS, "elementIndex: " + elementIndex, new Date().toTimeString().split(' ')[0]);
	      }
	
	      _this4.setupIntervalHandler();
	    }, _this4._intervalTimeoutMS);
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var elementStateOverride = _shared2.default.parseStringParam(window.location.href, "vid");
	  var donorSeaName = _shared2.default.parseStringParam(window.location.href, "name");
	
	  var returnObj = {
	    content: state.content,
	    donors: state.donors,
	    screen: state.screen,
	    active_module: state.active_module
	  };
	  if (elementStateOverride) {
	    returnObj.elementStateOverride = Number(elementStateOverride);
	  }
	  if (donorSeaName) {
	    returnObj.donorSeaName = donorSeaName;
	  }
	  return returnObj;
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    logToServer: function logToServer(logs, type, display, mode, webkey) {
	      return dispatch((0, _display.logToServer)(logs, type, display, mode, webkey));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VerticalVideoSync);

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _StretchImage = __webpack_require__(399);
	
	var _StretchImage2 = _interopRequireDefault(_StretchImage);
	
	var _DonorFullPage = __webpack_require__(60);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	var _shared = __webpack_require__(4);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _BRSpan = __webpack_require__(12);
	
	var _BRSpan2 = _interopRequireDefault(_BRSpan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	    cycleImageTime: 120000, //will cycle in sync with closest slide cycle
	    topBarHeight: 0.08 //as percentage of screen height
	};
	
	var DisplayContainer = function (_Component) {
	    _inherits(DisplayContainer, _Component);
	
	    function DisplayContainer(props) {
	        _classCallCheck(this, DisplayContainer);
	
	        var _this = _possibleConstructorReturn(this, (DisplayContainer.__proto__ || Object.getPrototypeOf(DisplayContainer)).call(this, props));
	
	        _this.clearCycleImageTimeout = function () {
	            clearTimeout(_this._cycleImageTimeout);
	            _this._cycleImageTimeout = null;
	        };
	
	        _this.clearSetLoopTimeout = function () {
	            clearTimeout(_this._loopTimeout);
	            _this._loopTimeout = null;
	        };
	
	        _this.cycleBackgroundTimeout = function () {
	            _this.clearCycleImageTimeout();
	            _this._cycleImageTimeout = setTimeout(function () {
	                if (_this._cycleImageNow === false) {
	                    //prevents double cycling
	                    _this._cycleImageNow = true;
	                    _this._backgroundIndex++;
	                    if (_this._backgroundIndex > _this._backgroundEvents.length - 1) {
	                        _this._backgroundIndex = 0;
	                    }
	                }
	                _this.cycleBackgroundTimeout();
	            }, _this._backgroundEvents[_this._backgroundIndex].cycletime);
	        };
	
	        _this.setLoopTimeout = function (ms) {
	            _this._loopTimeout = setTimeout(function () {
	                _this.loopContent();
	                _this.setLoopTimeout(_this._events[_this.state.eventIndex].delay);
	            }, ms);
	        };
	
	        _this.initList = function (list) {
	
	            var includeCategories = [];
	            var donor_view_category = list.contents.donor_view_category;
	            var category = _lodash2.default.find(_this.props.donors.donorCategories, { id: Number(donor_view_category) });
	            for (var a = 0; a < list.contents.include_categories.length; a++) {
	                if (Number(list.contents.include_categories[a]) !== Number(list.contents.donor_view_category)) {
	                    includeCategories.push(list.contents.include_categories[a]);
	                }
	            }
	
	            var preparedCategories = [];
	            for (var b = 0; b < includeCategories.length; b++) {
	                var _category = _lodash2.default.find(_this.props.donors.donorCategories, { id: includeCategories[b] });
	                preparedCategories.push(_category);
	            }
	            var donors = _lodash2.default.orderBy(preparedCategories, 'rank', 'asc');
	
	            //FONT STYLES
	            var _parentNameStyle = {};
	            // let _parentSubheaderStyle = {};
	            var _parentDescriptionStyle = {};
	            var _subcategoryNameStyle = {};
	            var _subcategorySubheaderStyle = {};
	            var _subcategoryDescriptionStyle = {};
	            var _nameListStyle = {};
	            var _footerStyle = {};
	
	            var _parentNameOffset = {};
	            var _parentSubheaderOffset = {};
	            var _parentDescriptionOffset = {};
	            var _subcategoryNameOffset = {};
	            var _subcategorySubheaderOffset = {};
	            var _subcategoryDescriptionOffset = {};
	            var _nameListOffset = {};
	            var _footerOffset = {};
	
	            var parentNameStyle = list.contents.ni_options.format.parent_category_name;
	            if (list.contents.ni_options.backdropOpacity !== undefined) {
	                _this._panelOpacity = list.contents.ni_options.backdropOpacity * .01;
	                console.log("SET PANEL OPACITY");
	            } else {
	                console.log("NI OPTIONS", list.contents.ni_options);
	                console.log("BACKDROP OPACITY", list.contents.ni_options.backdropOpacity);
	            }
	            //let parentSubheaderStyle = list.contents.ni_options.format.parent_category_subheader;
	            var parentDescriptionStyle = list.contents.ni_options.format.parent_category_description;
	
	            var subcategoryNameStyle = list.contents.ni_options.format.sub_category_name;
	            var subcategorySubheaderStyle = list.contents.ni_options.format.sub_category_subheader;
	            // let subcategoryDescriptionStyle = list.contents.ni_options.format.sub_category_description;
	
	            var nameListStyle = list.contents.ni_options.format.name_list;
	            var footerStyle = list.contents.ni_options.format.footer_text;
	
	            _this.setFontAttributes(_parentNameStyle, parentNameStyle);
	            //this.setFontAttributes(_parentSubheaderStyle, parentSubheaderStyle);
	            _this.setFontAttributes(_parentDescriptionStyle, parentDescriptionStyle);
	
	            _this.setFontAttributes(_subcategoryNameStyle, subcategoryNameStyle);
	            _this.setFontAttributes(_subcategorySubheaderStyle, subcategorySubheaderStyle);
	            // this.setFontAttributes(this._subcategoryDescriptionStyle, subcategoryDescriptionStyle);
	
	            _this.setFontAttributes(_nameListStyle, nameListStyle);
	            _this.setFontAttributes(_footerStyle, footerStyle);
	
	            _this._sumH = list.contents.ni_options.topMargin * .01 * _this.props.screen.screenHeight; //adjust for base offset
	
	            _this.setOffset(_parentNameOffset, parentNameStyle);
	            //this.setOffset(_parentSubheaderOffset, parentSubheaderStyle);
	            _this.setOffset(_parentDescriptionOffset, parentDescriptionStyle);
	            _this.setOffset(_subcategoryNameOffset, subcategoryNameStyle);
	            _this.setOffset(_subcategorySubheaderOffset, subcategorySubheaderStyle);
	            // this.setOffset(_subcategoryDescriptionOffset, subcategoryDescriptionStyle);
	            _this.setOffset(_nameListOffset, nameListStyle);
	
	            _footerOffset = {
	                val: _this.props.screen.screenHeight - footerStyle.height * .01 * _this.props.screen.screenHeight
	            };
	
	            list.category = category;
	            list.donors = donors;
	
	            list.f = {
	                parentName: {
	                    style: _parentNameStyle,
	                    meta: { visible: parentNameStyle.visible, offset: _parentNameOffset.val, height: parentNameStyle.height }
	                },
	                parentDescription: {
	                    style: _parentDescriptionStyle,
	                    meta: { visible: parentDescriptionStyle.visible, offset: _parentDescriptionOffset.val, height: parentDescriptionStyle.height }
	                },
	                subcategoryName: {
	                    style: _subcategoryNameStyle,
	                    meta: { visible: subcategoryNameStyle.visible, offset: _subcategoryNameOffset.val, height: subcategoryNameStyle.height }
	                },
	                subcategorySubheader: {
	                    style: _subcategorySubheaderStyle,
	                    meta: { visible: subcategorySubheaderStyle.visible, offset: _subcategorySubheaderOffset.val, height: subcategorySubheaderStyle.height }
	                },
	                nameList: {
	                    style: _nameListStyle,
	                    meta: { visible: nameListStyle.visible, offset: _nameListOffset.val, height: nameListStyle.height }
	                },
	                footer: {
	                    style: _footerStyle,
	                    meta: { visible: footerStyle.visible, offset: _footerOffset.val, height: footerStyle.height }
	                }
	            };
	        };
	
	        _this.informationalheader = function (height, displayHeader) {
	
	            var aligner = {
	                display: 'flex',
	                alignItems: 'center',
	                minHeight: height
	            };
	
	            var flexStyle = {
	                paddingLeft: _this.props.screen.sv.width / 2 * 0.1,
	                flex: 1,
	                color: 'white',
	                maxWidth: '50%',
	                fontSize: _this.props.screen.sv.height * .045
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { key: _this.state.topBarHeader, className: 'legacyserif-mediumSC', style: { position: 'absolute', width: _this.props.screen.r16_9.width, height: height } },
	                _react2.default.createElement(
	                    'div',
	                    { style: aligner },
	                    displayHeader ? _react2.default.createElement(
	                        'span',
	                        { style: flexStyle },
	                        _this.state.topBarHeader
	                    ) : _react2.default.createElement('span', null)
	                )
	            );
	        };
	
	        _this.goIdle = function (type) {};
	
	        _this.cycleIdle = function () {};
	
	        _this.cycleIdleLoop = function () {};
	
	        _this.resume = function () {};
	
	        _this.cycleDonorIndex = function (columns, rows) {
	            var total = columns * rows;
	            var start = _this._donorIndex * total;
	            //let cat = this._donors[this._categoryCurrent];
	            var cat = _this._donorLists[_this._parentIndex].donors[_this._categoryCurrent];
	            if (!cat.donors[start]) {
	                start = 0;
	                _this._donorIndex = 0;
	            }
	
	            var end_of_loop = false;
	            var end = start + total;
	            if (!cat.donors[end + 1]) {
	                end = cat.donors.length;
	                end_of_loop = true;
	                _this._donorIndex = 0;
	            } else {
	                _this._donorIndex++;
	            }
	
	            return {
	                donors: cat.donors.slice(start, end),
	                end_of_loop: end_of_loop,
	                name: cat.name,
	                subheader: cat.subheader,
	                description: cat.description
	            };
	        };
	
	        _this.cycleEvent = function () {
	
	            var eventInc = _this.state.eventIndex;
	            var renderSides = void 0,
	                renderFull = void 0,
	                renderWhite = void 0;
	            eventInc++;
	
	            if (eventInc > _this._events.length - 1) {
	                eventInc = 0;
	            }
	            switch (_this._events[eventInc].name) {
	                case "Donor List":
	                    //run a cycle
	                    _this._parentIndex++;
	                    if (_this._parentIndex >= _this._donorLists.length) {
	                        _this._parentIndex = 0;
	                    }
	                    // this.initParentCategory();
	                    _this.cycleDonorData(_this._donorLists[_this._parentIndex].contents.ni_options.columns, _this._donorLists[_this._parentIndex].contents.ni_options.rows);
	                    _this.setState({
	                        list: _this._donorLists[_this._parentIndex]
	                    });
	                    renderSides = true;
	                    renderFull = false;
	                    renderWhite = true;
	                    break;
	                default:
	                    break;
	                case "Slide":
	                    renderSides = false;
	                    renderFull = true;
	                    renderWhite = true;
	                    break;
	                case "Background":
	                    renderSides = false;
	                    renderFull = false;
	                    renderWhite = false;
	                    break;
	            }
	            var showTopBar = true;
	
	            if (_this._events[eventInc].title === "") {
	                showTopBar = false;
	            }
	            _this.setState({
	                topBarHeader: _this._events[eventInc].title,
	                eventIndex: eventInc,
	                renderSides: renderSides,
	                renderFull: renderFull,
	                renderWhite: renderWhite,
	                showTopBar: showTopBar
	            });
	        };
	
	        _this.cycleIndex = function () {
	            var index = _this.state.cycleIndex;
	            index++;
	            if (index > 100) {
	                //arbitrary to control total number
	                index = 0;
	            }
	            return index;
	        };
	
	        _this.cycleDonorData = function (columns, rows) {
	            //handle cycling donor content
	            if (_this._categoryCurrent < _this._donorLists[_this._parentIndex].donors.length) {
	                var donorDataLeft = void 0,
	                    donorDataRight = void 0;
	
	                donorDataLeft = _this.cycleDonorIndex(columns, rows);
	
	                if (donorDataLeft.end_of_loop === true) {
	                    _this._categoryCurrent++;
	                }
	                if (_this._categoryCurrent === 0 && _this._donorIndex === 0) {
	                    donorDataRight = { donors: [], end_of_loop: true, name: "", description: "" };
	                } else {
	                    if (_this._categoryCurrent < _this._donorLists[_this._parentIndex].donors.length) {
	                        donorDataRight = _this.cycleDonorIndex(columns, rows);
	                    } else {
	                        donorDataRight = { donors: [], end_of_loop: true, name: "", description: "" };
	                    }
	                    if (donorDataRight.end_of_loop === true) {
	                        _this._categoryCurrent++;
	                    }
	                }
	                _this.setState({
	                    donorData: { left: { name: donorDataLeft.name, subheader: donorDataLeft.subheader, donors: donorDataLeft.donors, description: donorDataLeft.description }, right: { name: donorDataRight.name, subheader: donorDataRight.subheader, donors: donorDataRight.donors, description: donorDataRight.description } },
	                    cycleIndex: _this.cycleIndex()
	                });
	            } else {
	                _this._categoryCurrent = 0;
	                _this._donorIndex = 0;
	                _this.cycleEvent();
	            }
	        };
	
	        _this.loopContent = function () {
	            var event = _this._events[_this.state.eventIndex];
	
	            switch (event.name) {
	                case "Donor List":
	                default:
	                    _this.cycleDonorData(_this._donorLists[_this._parentIndex].contents.ni_options.columns, _this._donorLists[_this._parentIndex].contents.ni_options.rows);
	                    break;
	                case "Slide":
	                    _this.cycleEvent();
	                    break;
	                case "Background":
	                    _this.cycleEvent();
	                    break;
	            }
	            if (_this._cycleImageNow === true) {
	                _this._cycleImageNow = false;
	                _this.setState({
	                    backgroundIndex: _this._backgroundIndex
	                });
	            }
	        };
	
	        _this.handleKeyDown = function (e) {
	            switch (e.key) {
	                case 'd':
	                    console.log(_this.props);
	                    break;
	                case '1':
	                    _this.loopContent();
	                    break;
	                case 'f':
	                    console.log(_this._donors);
	                    break;
	                case 'k':
	                    //this.clearCycleImageTimeout();
	                    //this.clearSetLoopTimeout();
	                    break;
	                default:
	                    break;
	            }
	        };
	
	        _this.setFontAttributes = function (styleObj, rootObj) {
	            //console.log('style', styleObj);
	            //console.log('root', rootObj);
	            styleObj.color = rootObj.fontColor;
	            styleObj.fontWeight = rootObj.fontWeight;
	            styleObj.textAlign = rootObj.justification.toLowerCase();
	            styleObj.fontStyle = rootObj.fontStyle.toLowerCase();
	            styleObj.fontFamily = rootObj.font;
	            styleObj.fontSize = rootObj.fontSize * _this.props.screen.screenHeight * .01;
	            styleObj.lineHeight = String(rootObj.lineHeight) + '%';
	            styleObj.width = '100%';
	            styleObj.display = "inline-block";
	        };
	
	        _this.setOffset = function (setVar, styleObj) {
	            if (styleObj.visible === true) {
	                setVar.val = _this._sumH; // + (margin * .01 * this.props.screen.screenHeight);
	                _this._sumH += styleObj.height * .01 * _this.props.screen.screenHeight;
	            }
	        };
	
	        _this.renderSide = function (width, height, data, side, title) {
	            var parentDescription = "";
	            if (side === "left" && _this.state.list.category.description) {
	                parentDescription = _this.state.list.category.description;
	            }
	            var subcategoryName = side === "left" ? _this.state.donorData.left.name : _this.state.donorData.right.name;
	            var subcategorySubheader = side === "left" ? _this.state.donorData.left.subheader : _this.state.donorData.right.subheader;
	
	            switch (data.type) {
	                case "Donor List":
	                default:
	                    if (_this.state.renderSides === true) {
	                        return _react2.default.createElement(
	                            'div',
	                            { style: { width: width, height: height }, key: _this.state.cycleIndex },
	                            _this.state.list.f.parentDescription.meta.visible ? _react2.default.createElement(
	                                'div',
	                                { style: { position: "absolute", left: width * .1, top: _this.state.list.f.parentDescription.meta.offset, height: height, width: width * .8 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: Object.assign({}, _this.state.list.f.parentDescription.style) },
	                                    _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: parentDescription })
	                                )
	                            ) : null,
	                            _this.state.list.f.subcategoryName.meta.visible ? _react2.default.createElement(
	                                'div',
	                                { style: { position: "absolute", left: width * .1, top: _this.state.list.f.subcategoryName.meta.offset, height: height, width: width * .8 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: Object.assign({}, _this.state.list.f.subcategoryName.style) },
	                                    _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: subcategoryName })
	                                )
	                            ) : null,
	                            _this.state.list.f.subcategorySubheader.meta.visible ? _react2.default.createElement(
	                                'div',
	                                { style: { position: "absolute", left: width * .1, top: _this.state.list.f.subcategorySubheader.meta.offset, height: height, width: width * .8 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: Object.assign({}, _this.state.list.f.subcategorySubheader.style, { letterSpacing: '0px' }) },
	                                    _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: subcategorySubheader })
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                'div',
	                                { style: Object.assign({}, _this.state.list.f.nameList.style, { left: width * .1, position: "absolute", top: _this.state.list.f.nameList.meta.offset, height: height * .6, width: width * .8 }) },
	                                _react2.default.createElement(_DonorFullPage2.default, {
	                                    fontclass: _this.state.list.f.nameList.style.fontFamily,
	                                    height: _this.state.list.f.nameList.meta.height * .01 * _this.props.screen.sv.height,
	                                    width: width * .8,
	                                    rows: _this.state.list.contents.ni_options.rows,
	                                    columns: _this.state.list.contents.ni_options.columns,
	                                    donorData: side === "left" ? _this.state.donorData.left.donors : _this.state.donorData.right.donors,
	                                    screen: _this.props.screen,
	                                    sort: 'column',
	                                    overrideFontSize: _this.state.list.f.nameList.style.fontSize
	                                })
	                            )
	                        );
	                    }
	                    return _react2.default.createElement('span', { key: -1 });
	            }
	        };
	
	        _this.renderFullPage = function () {
	            if (_this.state.renderFull === true) {
	                if (_this._events[_this.state.eventIndex].name === "Slide") {
	                    // let top = 0;
	                    // let height = this.props.screen.sv.height;
	                    // if (this._fullScreenSlides===false){
	                    //     top = this.props.screen.sv.height * config.topBarHeight;
	                    //     height = height-(this.props.screen.sv.height * config.topBarHeight)
	                    // }
	                    return _react2.default.createElement(
	                        'div',
	                        { key: _this.state.eventIndex },
	                        _react2.default.createElement(_StretchImage2.default, { top: _this._slideTop, left: 0, height: _this._slideHeight, width: _this.props.screen.sv.width, src: _this._events[_this.state.eventIndex].image })
	                    );
	                }
	                return _react2.default.createElement('span', null);
	            }
	            return _react2.default.createElement('span', null);
	        };
	
	        _this.state = {
	            renderSides: true,
	            renderFull: false,
	            renderWhite: true,
	            cycleIndex: 0,
	            donorData: { left: null, right: null },
	            backgroundIndex: 0,
	            eventIndex: -1,
	            topBarHeader: "Donors",
	            showTopBar: true,
	            list: null,
	            f: null
	        };
	
	        _this.columns = 2;
	        _this.rows = 16;
	
	        _this.backgroundImages = [];
	        _this.slideImages = [];
	        _this._events = [];
	        _this._backgroundEvents = [];
	        _this._includeCategories = [];
	        _this._donorLists = [];
	        _this._parentIndex = -1;
	        _this._parentCategory = {};
	
	        //CUSTOM VARS
	        _this._fullScreenSlides = false;
	        _this._panelOpacity = 0.5;
	        //this._footer = "* Denotes Deceased **While every effort is made to ensure the accuracy of the information displayed, should you discover an error, please notify the Baylor Scott & White-Central Texas Foundation at 1-800-293-4483.";
	        _this._slideTop = _this.props.screen.sv.height * config.topBarHeight;;
	        _this._slideHeight = _this.props.screen.sv.height - _this.props.screen.sv.height * config.topBarHeight;
	        _this._fadeClass = "slowfade";
	        if (_this.props.content.settings.custom_vars) {
	            if (_shared2.default.flexibleBool(_this.props.content.settings.custom_vars.FullScreenSlides) === true) {
	                _this._fullScreenSlides = true;
	                _this._slideTop = 0;
	                _this._slideHeight = _this.props.screen.sv.height;
	            }
	            if (_this.props.content.settings.custom_vars.BackgroundOpacity) {
	                _this._panelOpacity = Number(_this.props.content.settings.custom_vars.BackgroundOpacity);
	            }
	            // if (this.props.content.settings.custom_vars.Footer) {
	            //     this._footer = this.props.content.settings.custom_vars.Footer;
	            // }
	            if (_this.props.content.settings.custom_vars.DelayFade) {
	                _this._fadeClass = "slowfadedelay";
	            }
	        }
	
	        if (_this.props.content.dm_active) {
	
	            _lodash2.default.forEach(_this.props.content.dm_active, function (dm, index) {
	                if (dm.display_module_type === "Donor List") {
	                    _this._donorLists.push(dm);
	                }
	            });
	            if (_this._donorLists.length === 0) {
	                console.log("Configuration Error: No donor lists detected please add a donor list module to the display.");
	            }
	            var backgroundModule = _lodash2.default.find(_this.props.content.dm_active, { display_module_type: "Slideshow", name: "Background" });
	            if (!backgroundModule) {
	                console.log("Configuration Error: No background module detected, please add a Slideshow module with name Background.");
	            }
	            _lodash2.default.forEach(backgroundModule.contents.images, function (image, index) {
	                var cycletime = 120000;
	                if (_lodash2.default.has(backgroundModule, 'contents.cycle_overrides[' + index + ']')) {
	                    cycletime = backgroundModule.contents.cycle_overrides[index] * 1000;
	                }
	                _this.backgroundImages.push(_shared2.default.dpath(_this.props.screen.mode, image.path, image.file_name, _this.props.screen.webkey));
	                _this._backgroundEvents.push({ cycletime: cycletime, image: _shared2.default.dpath(_this.props.screen.mode, image.path, image.file_name, _this.props.screen.webkey) });
	            });
	
	            var slideModule = _lodash2.default.find(_this.props.content.dm_active, { display_module_type: "Slideshow", name: "Slides" });
	
	            _lodash2.default.forEach(_this._donorLists, function (list) {
	                var donorListCycleTime = void 0;
	                if (_lodash2.default.has(list, 'contents.cycle_time')) {
	                    donorListCycleTime = list.contents.cycle_time;
	                } else {
	                    donorListCycleTime = 5;
	                }
	                _this._events.push({ name: "Donor List", title: "Donors", delay: donorListCycleTime * 1000, image: null });
	                _this.initList(list);
	                //save all style attributes here?
	
	            });
	
	            _lodash2.default.forEach(slideModule.contents.images, function (image, index) {
	                var cycle_time = 25000;
	                var name = "Background";
	                var title = "";
	                var img = null;
	                //cycle times
	                if (_lodash2.default.has(slideModule, 'contents.cycle_overrides[' + index + ']')) {
	                    cycle_time = slideModule.contents.cycle_overrides[index];
	                } else {
	                    console.log("Slide detected with no cycle time using default", cycle_time);
	                }
	                //empty background and slides
	                var isEmpty = false;
	                if (_lodash2.default.has(slideModule, 'contents.empty_slides[' + index + ']')) {
	                    isEmpty = slideModule.contents.empty_slides[index];
	                    if (isEmpty === false) {
	                        name = "Slide";
	                    }
	                } else {
	                    console.log("No variable for empty time, check configuration", isEmpty);
	                }
	
	                if (_lodash2.default.has(slideModule, 'contents.names[' + index + ']')) {
	                    title = slideModule.contents.names[index];
	                }
	
	                if (_lodash2.default.has(slideModule, 'contents.images[' + index + ']')) {
	                    img = slideModule.contents.images[index];
	                }
	                _this._events.push({ name: name, title: title, delay: cycle_time * 1000, image: _shared2.default.dpath(_this.props.screen.mode, img.path, img.file_name, _this.props.screen.webkey) });
	
	                _this.slideImages.push(_shared2.default.dpath(_this.props.screen.mode, image.path, image.file_name, _this.props.screen.webkey));
	            });
	        }
	        //Background image handling
	        if (_this.backgroundImages.length === 0) {
	            //fallback
	            _this.backgroundImages = ['/img/ui/sample_1.jpg', '/img/ui/sample_2.jpg'];
	        }
	
	        _this._cycleImageNow = false;
	        _this._cycleImageTimeout = null;
	        _this._donors = null;
	        _this._categoryCurrent = 0;
	        _this._donorIndex = 0;
	        _this._loopTimeout = null;
	        _this._backgroundIndex = 0;
	        return _this;
	    }
	
	    _createClass(DisplayContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener("keydown", this.handleKeyDown);
	            this.cycleEvent();
	            this.setLoopTimeout();
	            this.cycleBackgroundTimeout();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	            this.clearCycleImageTimeout();
	            this.clearSetLoopTimeout();
	        }
	
	        // initParentCategory = () => {
	        //     this._includeCategories = [];
	        //     let donor_view_category = this._donorLists[this._parentIndex].contents.donor_view_category;
	        //     this._parentCategory = _.find(this.props.donors.donorCategories, { id: Number(donor_view_category) });
	        //     for (var a = 0; a < this._donorLists[this._parentIndex].contents.include_categories.length; a++) {
	        //         if (Number(this._donorLists[this._parentIndex].contents.include_categories[a]) !== Number(this._donorLists[this._parentIndex].contents.donor_view_category)) {
	        //             this._includeCategories.push(this._donorLists[this._parentIndex].contents.include_categories[a])
	        //         }
	        //     }  
	        // }
	
	    }, {
	        key: 'render',
	
	
	        // renderWhitePanel = () => {
	        //     if (this.state.renderWhite === true) {
	        //         return (
	        //             <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height - (config.topBarHeight * this.props.screen.sv.height), opacity: this._panelOpacity, backgroundColor: 'white' }} />
	        //         )
	        //     }
	        //     else {
	        //         return (
	        //             <span />
	        //         )
	        //     }
	        // }
	
	        value: function render() {
	            if (!this.state.donorData.left || !this.state.list) {
	                return _react2.default.createElement('span', null);
	            };
	            var leftModule = this.renderSide(this.props.screen.sv.width / 2, this.props.screen.sv.height, { type: "Donor List" }, "left", this.state.list.category.name); //renderSide this._parentCategory.name
	            var rightModule = this.renderSide(this.props.screen.sv.width / 2, this.props.screen.sv.height, { type: "Donor List" }, "right", this.state.list.category.name);
	
	            var width = this.props.screen.sv.width / 2;
	            var height = this.props.screen.sv.height;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: this._fadeClass,
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        _react2.default.createElement(
	                            'div',
	                            { key: this.state.backgroundIndex },
	                            _react2.default.createElement(_StretchImage2.default, { key: this.state.backgroundIndex, height: this.props.screen.sv.height, width: this.props.screen.sv.width, src: this._backgroundEvents[this.state.backgroundIndex].image })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: this._slideTop, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: 'slowfade',
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        _react2.default.createElement(
	                            'div',
	                            { key: this.state.renderWhite },
	                            this.state.renderWhite ? _react2.default.createElement('div', { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this._slideHeight, opacity: this._panelOpacity, backgroundColor: 'white' } }) : _react2.default.createElement('span', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: this.props.screen.sv.top, left: 0, height: this.props.screen.sv.height, width: this.props.screen.sv.width } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: this._fadeClass,
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        this.renderFullPage()
	                    )
	                ),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.showTopBar },
	                        this.state.showTopBar ? _react2.default.createElement('div', { style: { position: 'absolute', top: 0, left: 0, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height * config.topBarHeight, backgroundColor: '#424958' } }) : _react2.default.createElement('span', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: this.props.screen.sv.top, height: this.props.screen.sv.height, width: this.props.screen.sv.width / 2 } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: 'slowfade',
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        this.informationalheader(this.props.screen.sv.height * config.topBarHeight, true),
	                        _react2.default.createElement(
	                            'div',
	                            { key: this.state.list.category.name + this.state.eventIndex },
	                            this.state.list.f.parentName.meta.visible && this._events[this.state.eventIndex].name === "Donor List" ? _react2.default.createElement(
	                                'div',
	                                { style: { position: "absolute", left: width * .1, top: this.state.list.f.parentName.meta.offset, height: height, width: width * .8 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: { letterSpacing: 2, width: '100%', display: 'inline-block' } },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: Object.assign({}, this.state.list.f.parentName.style) },
	                                        _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.state.list.category.name })
	                                    )
	                                )
	                            ) : null
	                        ),
	                        leftModule
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', top: this.props.screen.sv.top, left: this.props.screen.sv.width / 2, height: this.props.screen.sv.height, width: this.props.screen.sv.width / 2 } },
	                    _react2.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        {
	                            component: 'div',
	                            transitionName: 'slowfade',
	                            transitionEnterTimeout: 0,
	                            transitionLeaveTimeout: 0 },
	                        this.informationalheader(this.props.screen.sv.height * config.topBarHeight, false),
	                        rightModule,
	                        _react2.default.createElement(
	                            'div',
	                            { key: this._events[this.state.eventIndex].name },
	                            this.state.list.f.footer.meta.visible && this._events[this.state.eventIndex].name === "Donor List" ? _react2.default.createElement(
	                                'div',
	                                { style: { position: "absolute", top: this.state.list.f.footer.meta.offset, height: height * .1, marginLeft: width * .1, marginRight: width * .1, width: this.props.screen.sv.width / 2 * .8 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: Object.assign({}, this.state.list.f.footer.style) },
	                                    _react2.default.createElement(_BRSpan2.default, { preWrap: true, str: this.state.list.contents.ni_options.footerText })
	                                )
	                            ) : null
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DisplayContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        content: state.content,
	        donors: state.donors,
	        screen: state.screen
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DisplayContainer);

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CSSTransitionGroup = __webpack_require__(6);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DonorFullPage = __webpack_require__(60);
	
	var _DonorFullPage2 = _interopRequireDefault(_DonorFullPage);
	
	var _shared = __webpack_require__(4);
	
	var _donorHelpers = __webpack_require__(17);
	
	var _slideshowHelpers = __webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactPlayer from 'react-player';
	
	
	var config = {
	    donor_col: 3,
	    donor_row: 8
	};
	
	var videoStyle = {
	    preload: 'auto',
	    position: 'fixed',
	    minWidth: '100%',
	    minHeight: '100%',
	    width: '100vw',
	    height: '100vh',
	    zIndex: 0,
	    loop: '',
	    autoplay: "",
	    muted: "",
	    pointerEvents: "none"
	};
	
	var screen1Backdrop = {
	    opacity: .8,
	    backgroundColor: '#0019e6'
	};
	
	var screen2Backdrop = {
	    opacity: .8,
	    backgroundColor: '#0019e6'
	};
	
	var dc3x1 = function (_Component) {
	    _inherits(dc3x1, _Component);
	
	    function dc3x1(props) {
	        _classCallCheck(this, dc3x1);
	
	        var _this = _possibleConstructorReturn(this, (dc3x1.__proto__ || Object.getPrototypeOf(dc3x1)).call(this, props));
	
	        _this.cycleIndex = function () {
	            var cycleIndex = _this.state.cycleIndex;
	            if (cycleIndex === 100) {
	                cycleIndex = 0;
	            }
	            _this.setState({
	                cycleIndex: ++cycleIndex
	            });
	        };
	
	        _this.initDonors = function () {
	
	            var donorListModule = _lodash2.default.find(_this.props.content.dm_active, { name: "Donors" });
	            var includes = [];
	            if (_lodash2.default.has(donorListModule, 'contents.include_categories')) {
	                includes = donorListModule.contents.include_categories;
	            }
	            _this._donors = (0, _donorHelpers.donorsIncluded)(_this.props.donors.donorCategories, includes);
	        };
	
	        _this.initScreens = function () {
	            var screen1 = _lodash2.default.find(_this.props.content.dm_active, { name: "Screen1" });
	            screen1.contents = (0, _slideshowHelpers.prepareSlides)(screen1.contents);
	            var screen2 = _lodash2.default.find(_this.props.content.dm_active, { name: "Screen2" });
	            screen2.contents = (0, _slideshowHelpers.prepareSlides)(screen2.contents);
	            _this.setState({
	                screen1: screen1,
	                screen2: screen2
	            });
	            var donor_module = _lodash2.default.find(_this.props.content.dm_active, { name: "Donors" });
	
	            _this._cycleScreen1Seconds = screen1.contents.cycle_times[0];
	            _this._cycleScreen2Seconds = screen2.contents.cycle_times[0];
	            _this._cycleScreen3Seconds = donor_module.contents.cycle_time;
	            _this._cycleScreen3SecondsFull = _this._cycleScreen3Seconds;
	        };
	
	        _this.cycleDonorIndex = function (columns, rows) {
	
	            if (_this._endOfDonorLoop === true) {
	                _this._categoryCurrent++;
	                _this._donorIndex = 0;
	                if (_this._categoryCurrent === _this._donors.length) {
	                    _this._categoryCurrent = 0;
	                }
	            }
	
	            var total = columns * rows;
	            var start = _this._donorIndex * total;
	            var cat = _this._donors[_this._categoryCurrent];
	            var parent = _lodash2.default.find(_this.props.donors.donorCategories, { id: Number(cat.parent_category) });
	            if (parent) {
	                _this._description = parent.description;
	                _this._mainCategoryName = parent.name;
	            }
	
	            if (!cat.donors[start]) {
	                start = 0;
	                _this._donorIndex = 0;
	            }
	
	            _this._endOfDonorLoop = false;
	            var end = start + total;
	            if (!cat.donors[end]) {
	                end = cat.donors.length;
	                _this._endOfDonorLoop = true;
	                _this._donorIndex = 0;
	            } else {
	                _this._donorIndex++;
	            }
	
	            var donorsSliced = cat.donors.slice(start, end);
	            var perColumn = 0;
	
	            //distribute end page logic for empty units in last row
	            if (_this._endOfDonorLoop === true) {
	                var dLength = donorsSliced.length;
	                var extraSpaces = 0; //default to 0
	                perColumn = Math.ceil(dLength / columns);
	                if (perColumn * columns > dLength) {
	                    //extra spaces on last row required
	                    extraSpaces = perColumn * columns - dLength;
	                }
	                var normalSpaces = rows - perColumn; //spaces to add on each normal row
	                var lastSpaces = normalSpaces + extraSpaces; //spaces to add on last row
	
	                for (var i = 0; i < columns; i++) {
	                    if (i < columns - 1) {
	                        //rows prior to last
	                        for (var a = 0; a < normalSpaces; a++) {
	                            donorsSliced.splice(i * rows + perColumn, 0, { name: "" });
	                        }
	                    } else {
	                        for (var b = 0; b < lastSpaces; b++) {
	                            donorsSliced.splice(i * rows + perColumn, 0, { name: "" });
	                        }
	                    }
	                }
	
	                // for (var i=0; i<columns; i++){
	                //     let sp = 0
	                //     let adder = 0;
	                //     if (!evenDist){ //handle distributing last row
	                //         adder = 1;
	                //         if (extraDonors>0){
	                //             sp=1
	                //             extraDonors--;
	                //             adder = 0;
	                //         }
	                //     }
	                //     for (var a=0; a<spaces+adder; a++){
	                //         donorsSliced.splice((i*rows)+perColumn+sp, 0, {name: ""});
	                //     }
	                // }
	            }
	
	            //distribute end page logic for even distribution
	            // if (this._endOfDonorLoop===true){
	            //     let dLength = donorsSliced.length;
	
	            //     perColumn = Math.floor(dLength/columns);
	            //     let extraDonors = dLength //default to number
	            //     let evenDist = false;
	            //     if (dLength>=columns){ //if equal or greater then one row, modulo
	            //         extraDonors = dLength%columns;
	            //     }
	            //     if (extraDonors===0){
	            //         evenDist=true;
	            //     }
	
	            //     let spaces = Math.floor((total-dLength)/columns)
	            //     for (var i=0; i<columns; i++){
	            //         let sp = 0
	            //         let adder = 0;
	            //         if (!evenDist){ //handle distributing last row
	            //             adder = 1;
	            //             if (extraDonors>0){
	            //                 sp=1
	            //                 extraDonors--;
	            //                 adder = 0;
	            //             }
	            //         }
	            //         for (var a=0; a<spaces+adder; a++){
	            //             donorsSliced.splice((i*rows)+perColumn+sp, 0, {name: ""});
	            //         }
	            //     }
	            // }
	
	            _this.cycleIndex();
	            _this.setState({
	                donorData: {
	                    donors: donorsSliced,
	                    name: cat.name
	                }
	            });
	        };
	
	        _this.timedCycle = function () {
	            if (_this._cycleScreen1Seconds) {
	                _this._cycleScreen1Seconds--;
	                if (_this._cycleScreen1Seconds === 0) {
	                    //cycle screen 1;
	                    _this.cycleScreen1();
	                }
	            }
	            if (_this._cycleScreen2Seconds) {
	                _this._cycleScreen2Seconds--;
	                if (_this._cycleScreen2Seconds === 0) {
	                    //cycle screen 1;
	                    _this.cycleScreen2();
	                }
	            }
	            if (_this._cycleScreen3Seconds) {
	                _this._cycleScreen3Seconds--;
	                if (_this._cycleScreen3Seconds === 0) {
	                    _this._cycleScreen3Seconds = _this._cycleScreen3SecondsFull;
	                    _this.cycleDonorIndex(config.donor_col, config.donor_row);
	                }
	            }
	        };
	
	        _this.cycleScreen1 = function () {
	            var screen1Slide = _this.state.screen1Slide;
	            if (screen1Slide < _this.state.screen1.contents.images.length - 1) {
	                screen1Slide++;
	            } else {
	                screen1Slide = 0;
	            }
	            _this.setState({
	                screen1Slide: screen1Slide
	            });
	            _this._cycleScreen1Seconds = _this.state.screen1.contents.cycle_times[screen1Slide];
	        };
	
	        _this.cycleScreen2 = function () {
	            var screen2Slide = _this.state.screen2Slide;
	            if (screen2Slide < _this.state.screen2.contents.images.length - 1) {
	                screen2Slide++;
	            } else {
	                screen2Slide = 0;
	            }
	            _this.setState({
	                screen2Slide: screen2Slide
	            });
	            _this._cycleScreen2Seconds = _this.state.screen2.contents.cycle_times[screen2Slide];
	        };
	
	        _this.handleKeyDown = function (e) {
	            switch (e.key) {
	                case 'd':
	                    console.log(_this.props);
	                    break;
	                case '1':
	                    _this.cycleScreen1();
	                    break;
	                case '2':
	                    _this.cycleScreen2();
	                    break;
	                case '3':
	                    _this.cycleDonorIndex(config.donor_col, config.donor_row);
	                    break;
	                default:
	                    break;
	            }
	        };
	
	        _this.renderWhitePanel = function () {
	            if (_this.state.renderWhite === true) {
	                return _react2.default.createElement('div', { style: { position: 'absolute', top: 0, left: 0, width: _this.props.screen.sv.width, height: _this.props.screen.sv.height - config.topBarHeight * _this.props.screen.sv.height, opacity: config.panelOpacity, backgroundColor: 'white' } });
	            } else {
	                return _react2.default.createElement('span', null);
	            }
	        };
	
	        _this._donors = null;
	        _this._categoryCurrent = -1;
	        _this._donorIndex = 0;
	        _this._endOfDonorLoop = true;
	        _this._mainCategoryName = "";
	        _this._description = "";
	        _this._cycleInterval = null;
	
	        _this._cycleScreen1Seconds = null;
	        _this._cycleScreen2Seconds = null;
	        _this._cycleScreen3Seconds = null;
	
	        _this._cycleScreen3SecondsFull = null;
	
	        _this.state = {
	            donorData: null,
	            screen1: null,
	            screen2: null,
	            screen1Slide: 0,
	            screen2Slide: 0,
	            cycleIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(dc3x1, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            document.addEventListener("keydown", this.handleKeyDown);
	            this.initDonors();
	            this.initScreens();
	
	            this._cycleInterval = setInterval(function () {
	                _this2.timedCycle();
	            }, 1000);
	
	            this.cycleDonorIndex(config.donor_col, config.donor_row);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	        }
	
	        //for unique transition keys
	
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (!this.state.screen1 || !this.state.screen2 || !this.state.donorData) {
	                return null;
	            }
	            var sDims = {
	                height: this.props.screen.sv.height, //1080,
	                width: this.props.screen.sv.width / 3 //1920
	
	                //console.log(this.props.block.screens[0].height, this.props.screen.sv.height)
	            };var modifier = .6;
	            sDims.fsTitle = sDims.height * 0.05556 * modifier;
	            sDims.fsTitleSub = sDims.height * 0.05556 * modifier;
	            if (this.props.content.settings.custom_vars) {
	                if (this.props.content.settings.custom_vars.ParentGroupFontSize) {
	                    sDims.fsTitle = sDims.height * this.props.content.settings.custom_vars.ParentGroupFontSize * .01;
	                }
	                if (this.props.content.settings.custom_vars.GroupFontSize) {
	                    sDims.fsTitleSub = sDims.height * this.props.content.settings.custom_vars.GroupFontSize * .01;
	                }
	            }
	
	            sDims.fsSubheader = sDims.height * 0.03333 * modifier;
	            sDims.fsNames = sDims.height * 0.04444 * modifier;
	            sDims.yOffsetTitle = sDims.height * .05;
	            sDims.yOffsetSubheader = sDims.height * .1;
	            sDims.yOffsetSubheaderUnderline = sDims.height * .13;
	            sDims.yOffsetNames = sDims.height * .16;
	            var videoSource = (0, _shared.dpath)(this.props.screen.mode, this.props.content.settings.lower_layer_file.path, this.props.content.settings.lower_layer_file.file_name, this.props.screen.webkey);
	            var vType = (0, _shared.videoType)(this.props.content.settings.lower_layer_file.file_name);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'futura-book', style: { color: 'white' } },
	                vType ? _react2.default.createElement(
	                    'div',
	                    { style: { zIndex: -90, pointerEvents: "none", position: 'absolute', left: 0, top: 0, opacity: 1, width: this.props.screen.sv.width, height: this.props.screen.sv.height } },
	                    _react2.default.createElement(
	                        'video',
	                        { className: 'nodrag', style: videoStyle, id: 'background-video', loop: true, autoPlay: true, muted: true },
	                        _react2.default.createElement('source', { src: videoSource, type: vType }),
	                        'Your browser does not support the video tag.'
	                    )
	                ) : _react2.default.createElement('span', null),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.screen1.contents.empty_slides[this.state.screen1Slide] },
	                        this.state.screen1.contents.empty_slides[this.state.screen1Slide] ? _react2.default.createElement('div', null) : _react2.default.createElement('div', { style: { backgroundColor: screen1Backdrop.backgroundColor, opacity: screen1Backdrop.opacity, position: 'absolute', left: 0, top: 0, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.screen1Slide },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { position: 'absolute', left: 0, top: 0, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height } },
	                            _react2.default.createElement('img', { alt: 'Screen 1 Slide', style: { width: '100%', height: '100%' }, src: (0, _shared.dpath)(this.props.screen.mode, this.state.screen1.contents.images[this.state.screen1Slide].path, this.state.screen1.contents.images[this.state.screen1Slide].file_name, this.props.screen.webkey) })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.screen2.contents.empty_slides[this.state.screen2Slide] },
	                        this.state.screen2.contents.empty_slides[this.state.screen2Slide] ? _react2.default.createElement('div', null) : _react2.default.createElement('div', { style: { backgroundColor: screen2Backdrop.backgroundColor, opacity: screen2Backdrop.opacity, position: 'absolute', left: this.props.screen.sv.width / 3, top: 0, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height } })
	                    )
	                ),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.screen2Slide },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { position: 'absolute', left: this.props.screen.sv.width / 3, top: 0, opacity: 1, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height } },
	                            _react2.default.createElement('img', { alt: 'Screen 2 Slide', style: { width: '100%', height: '100%' }, src: (0, _shared.dpath)(this.props.screen.mode, this.state.screen2.contents.images[this.state.screen2Slide].path, this.state.screen2.contents.images[this.state.screen2Slide].file_name, this.props.screen.webkey) })
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { style: { position: 'absolute', left: sDims.width * 2, top: 0, opacity: .8, backgroundColor: '#0019e6', width: sDims.width, height: sDims.height } }),
	                _react2.default.createElement('div', { style: { position: 'absolute', left: sDims.width * 2.05, top: sDims.yOffsetSubheaderUnderline, backgroundColor: 'white', opacity: 1, width: sDims.width * .9, height: sDims.height * .0025 } }),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this._mainCategoryName + " " + this.state.donorData.name },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'futura-bold', style: { position: 'absolute', left: sDims.width * 2.05, top: sDims.yOffsetTitle, width: sDims.width * .9, height: sDims.height * .05 } },
	                            this.state.donorData && this.state.donorData.name ? _react2.default.createElement(
	                                'span',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: { fontSize: sDims.fsTitle } },
	                                    this._mainCategoryName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: { fontSize: sDims.fsTitleSub } },
	                                    " " + this.state.donorData.name
	                                )
	                            ) : _react2.default.createElement('span', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this._description },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: sDims.fsSubheader, position: 'absolute', left: sDims.width * 2.05, top: sDims.yOffsetSubheader, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 } },
	                            this._description ? _react2.default.createElement(
	                                'span',
	                                null,
	                                this._description
	                            ) : _react2.default.createElement('span', null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _CSSTransitionGroup2.default,
	                    {
	                        component: 'div',
	                        transitionName: 'slowfade',
	                        transitionEnterTimeout: 0,
	                        transitionLeaveTimeout: 0 },
	                    _react2.default.createElement(
	                        'div',
	                        { key: this.state.cycleIndex },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { position: 'absolute', left: sDims.width * 2, top: 0, opacity: 1, width: sDims.width, height: sDims.height } },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'absolute', left: sDims.width * .05, top: sDims.yOffsetNames, width: sDims.width * .9, height: sDims.height * .8 } },
	                                this.state.donorData ? _react2.default.createElement(_DonorFullPage2.default, {
	                                    fontclass: "legacysans-book",
	                                    height: sDims.height * .8,
	                                    width: sDims.width * .9,
	                                    rows: config.donor_row,
	                                    columns: config.donor_col,
	                                    donorData: this.state.donorData.donors,
	                                    screen: this.props.screen,
	                                    sort: 'column',
	                                    overrideFontSize: sDims.fsNames,
	                                    overrideMarginRight: sDims.width * .0375
	                                }) : _react2.default.createElement('span', null)
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: { right: sDims.width * .05, position: 'absolute', width: '100%', textAlign: 'right', bottom: this.props.screen.sv.height * .055, fontSize: sDims.fsNames * .5 } },
	                                this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.barnabasdeceased ? this.props.content.settings.custom_vars.barnabasdeceased : _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    '* Deceased'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return dc3x1;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        content: state.content,
	        donors: state.donors,
	        screen: state.screen,
	        block: state.content.settings.display_blocks[0]
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(dc3x1);

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(390);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _reactRedux = __webpack_require__(5);
	
	var _configureStore = __webpack_require__(516);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	__webpack_require__(550);
	
	__webpack_require__(551);
	
	__webpack_require__(549);
	
	__webpack_require__(548);
	
	__webpack_require__(769);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import * as serviceWorker from '../serviceWorker';
	
	var store = (0, _configureStore2.default)();
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));
	
	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	// serviceWorker.unregister();

/***/ },
/* 512 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.contentHasErrored = contentHasErrored;
	exports.contentIsLoading = contentIsLoading;
	exports.content = content;
	function contentHasErrored() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'CONTENT_HAS_ERRORED':
	            return action.contentHasErrored;
	
	        default:
	            return state;
	    }
	}
	
	function contentIsLoading() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'CONTENT_IS_LOADING':
	            return action.contentIsLoading;
	
	        default:
	            return state;
	    }
	}
	
	function content() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'CONTENT_FETCH_SUCCESS':
	            return action.content;
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 513 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.screen = screen;
	exports.active_module = active_module;
	exports.options = options;
	function screen() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'FETCH_DISPLAY_SUCCESS':
	            return action.screen;
	        default:
	            return state;
	    }
	}
	
	function active_module() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SWITCH_MODULE_SUCCESS':
	            return action.active_module;
	        default:
	            return state;
	    }
	}
	
	function options() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'SET_OPTIONS_SUCCESS':
	            return action.options;
	        default:
	            return state;
	    }
	}

/***/ },
/* 514 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.donorsHasErrored = donorsHasErrored;
	exports.donorsIsLoading = donorsIsLoading;
	exports.donors = donors;
	function donorsHasErrored() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'DONORS_HAS_ERRORED':
	            return action.donorsHasErrored;
	
	        default:
	            return state;
	    }
	}
	
	function donorsIsLoading() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'DONORS_IS_LOADING':
	            return action.donorsIsLoading;
	
	        default:
	            return state;
	    }
	}
	
	function donors() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'DONORS_FETCH_SUCCESS':
	            return action.donors;
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(139);
	
	var _content = __webpack_require__(512);
	
	var _donors = __webpack_require__(514);
	
	var _display = __webpack_require__(513);
	
	exports.default = (0, _redux.combineReducers)({
	    content: _content.content,
	    contentHasErrored: _content.contentHasErrored,
	    contentIsLoading: _content.contentIsLoading,
	    donors: _donors.donors,
	    donorsHasErrored: _donors.donorsHasErrored,
	    donorsIsLoading: _donors.donorsIsLoading,
	    screen: _display.screen,
	    active_module: _display.active_module,
	    options: _display.options
	});

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(139);
	
	var _reduxThunk = __webpack_require__(764);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(515);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	    return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	}

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    prepareSlides: function prepareSlides(contents) {
	        var cycle_times = [];
	        for (var i = 0; i < contents.images.length; i++) {
	            cycle_times[i] = 5; //default
	            if (contents.slide_cycle_time) {
	                cycle_times[i] = contents.slide_cycle_time;
	            }
	            if (_lodash2.default.has(contents, 'cycle_overrides[' + i + ']')) {
	                if (contents.cycle_overrides[i] !== 0) {
	                    cycle_times[i] = contents.cycle_overrides[i];
	                }
	            }
	        }
	        contents.cycle_times = cycle_times;
	        return contents;
	    }
	};

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(519);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 519 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 520 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ },
/* 521 */
/***/ function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ },
/* 522 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 523 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 524 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(161);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(528);
	var isArguments = __webpack_require__(527);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 527 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 528 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = deepmerge(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(531));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 531 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 532 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(162));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(162));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(536);


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(537);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(40);


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(163);
	var Emitter = __webpack_require__(52);
	var debug = __webpack_require__(68)('engine.io-client:socket');
	var index = __webpack_require__(174);
	var parser = __webpack_require__(40);
	var parseuri = __webpack_require__(304);
	var parsejson = __webpack_require__(623);
	var parseqs = __webpack_require__(108);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(98);
	Socket.transports = __webpack_require__(163);
	Socket.parser = __webpack_require__(40);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders,
	    forceNode: this.forceNode,
	    localAddress: this.localAddress
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(164);
	var inherit = __webpack_require__(67);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(99);
	var Polling = __webpack_require__(164);
	var Emitter = __webpack_require__(52);
	var inherit = __webpack_require__(67);
	var debug = __webpack_require__(68)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(98);
	var parser = __webpack_require__(40);
	var parseqs = __webpack_require__(108);
	var inherit = __webpack_require__(67);
	var yeast = __webpack_require__(367);
	var debug = __webpack_require__(68)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	var NodeWebSocket;
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(793);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  WebSocket = NodeWebSocket;
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  if (!this.usingBrowserWebSocket) {
	    WebSocket = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 541 */
[795, 542],
/* 542 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ },
/* 543 */
/***/ function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(546);
	var each = __webpack_require__(165).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(544);
	var Util = __webpack_require__(165);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 546 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(545);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 548 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 549 */
548,
/* 550 */
548,
/* 551 */
548,
/* 552 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(552);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(562);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var createArrayFromMixed = __webpack_require__(555);
	var getMarkupWrap = __webpack_require__(557);
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 558 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 559 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(559);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 561 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(561);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 563 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-menu-primary.31645967.svg";

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-menu.764cdbe6.svg";

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-timelineBullet.88c83f90.svg";

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Fuse.js v3.3.0 - Lightweight fuzzy-search (http://fusejs.io)
	 * 
	 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
	 * All Rights Reserved. Apache Software License 2.0
	 * 
	 * http://www.apache.org/licenses/LICENSE-2.0
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("Fuse", [], factory);
		else if(typeof exports === 'object')
			exports["Fuse"] = factory();
		else
			root["Fuse"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function (obj) {
	  return !Array.isArray ? Object.prototype.toString.call(obj) === '[object Array]' : Array.isArray(obj);
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var bitapRegexSearch = __webpack_require__(5);
	var bitapSearch = __webpack_require__(7);
	var patternAlphabet = __webpack_require__(4);
	
	var Bitap = function () {
	  function Bitap(pattern, _ref) {
	    var _ref$location = _ref.location,
	        location = _ref$location === undefined ? 0 : _ref$location,
	        _ref$distance = _ref.distance,
	        distance = _ref$distance === undefined ? 100 : _ref$distance,
	        _ref$threshold = _ref.threshold,
	        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
	        _ref$maxPatternLength = _ref.maxPatternLength,
	        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
	        _ref$isCaseSensitive = _ref.isCaseSensitive,
	        isCaseSensitive = _ref$isCaseSensitive === undefined ? false : _ref$isCaseSensitive,
	        _ref$tokenSeparator = _ref.tokenSeparator,
	        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
	        _ref$findAllMatches = _ref.findAllMatches,
	        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
	        _ref$minMatchCharLeng = _ref.minMatchCharLength,
	        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;
	
	    _classCallCheck(this, Bitap);
	
	    this.options = {
	      location: location,
	      distance: distance,
	      threshold: threshold,
	      maxPatternLength: maxPatternLength,
	      isCaseSensitive: isCaseSensitive,
	      tokenSeparator: tokenSeparator,
	      findAllMatches: findAllMatches,
	      minMatchCharLength: minMatchCharLength
	    };
	
	    this.pattern = this.options.isCaseSensitive ? pattern : pattern.toLowerCase();
	
	    if (this.pattern.length <= maxPatternLength) {
	      this.patternAlphabet = patternAlphabet(this.pattern);
	    }
	  }
	
	  _createClass(Bitap, [{
	    key: 'search',
	    value: function search(text) {
	      if (!this.options.isCaseSensitive) {
	        text = text.toLowerCase();
	      }
	
	      // Exact match
	      if (this.pattern === text) {
	        return {
	          isMatch: true,
	          score: 0,
	          matchedIndices: [[0, text.length - 1]]
	        };
	      }
	
	      // When pattern length is greater than the machine word length, just do a a regex comparison
	      var _options = this.options,
	          maxPatternLength = _options.maxPatternLength,
	          tokenSeparator = _options.tokenSeparator;
	
	      if (this.pattern.length > maxPatternLength) {
	        return bitapRegexSearch(text, this.pattern, tokenSeparator);
	      }
	
	      // Otherwise, use Bitap algorithm
	      var _options2 = this.options,
	          location = _options2.location,
	          distance = _options2.distance,
	          threshold = _options2.threshold,
	          findAllMatches = _options2.findAllMatches,
	          minMatchCharLength = _options2.minMatchCharLength;
	
	      return bitapSearch(text, this.pattern, this.patternAlphabet, {
	        location: location,
	        distance: distance,
	        threshold: threshold,
	        findAllMatches: findAllMatches,
	        minMatchCharLength: minMatchCharLength
	      });
	    }
	  }]);
	
	  return Bitap;
	}();
	
	// let x = new Bitap("od mn war", {})
	// let result = x.search("Old Man's War")
	// console.log(result)
	
	module.exports = Bitap;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isArray = __webpack_require__(0);
	
	var deepValue = function deepValue(obj, path, list) {
	  if (!path) {
	    // If there's no path left, we've gotten to the object we care about.
	    list.push(obj);
	  } else {
	    var dotIndex = path.indexOf('.');
	    var firstSegment = path;
	    var remaining = null;
	
	    if (dotIndex !== -1) {
	      firstSegment = path.slice(0, dotIndex);
	      remaining = path.slice(dotIndex + 1);
	    }
	
	    var value = obj[firstSegment];
	
	    if (value !== null && value !== undefined) {
	      if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
	        list.push(value.toString());
	      } else if (isArray(value)) {
	        // Search each item in the array.
	        for (var i = 0, len = value.length; i < len; i += 1) {
	          deepValue(value[i], remaining, list);
	        }
	      } else if (remaining) {
	        // An object. Recurse further.
	        deepValue(value, remaining, list);
	      }
	    }
	  }
	
	  return list;
	};
	
	module.exports = function (obj, path) {
	  return deepValue(obj, path, []);
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function () {
	  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var matchedIndices = [];
	  var start = -1;
	  var end = -1;
	  var i = 0;
	
	  for (var len = matchmask.length; i < len; i += 1) {
	    var match = matchmask[i];
	    if (match && start === -1) {
	      start = i;
	    } else if (!match && start !== -1) {
	      end = i - 1;
	      if (end - start + 1 >= minMatchCharLength) {
	        matchedIndices.push([start, end]);
	      }
	      start = -1;
	    }
	  }
	
	  // (i-1 - start) + 1 => i - start
	  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
	    matchedIndices.push([start, i - 1]);
	  }
	
	  return matchedIndices;
	};
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function (pattern) {
	  var mask = {};
	  var len = pattern.length;
	
	  for (var i = 0; i < len; i += 1) {
	    mask[pattern.charAt(i)] = 0;
	  }
	
	  for (var _i = 0; _i < len; _i += 1) {
	    mask[pattern.charAt(_i)] |= 1 << len - _i - 1;
	  }
	
	  return mask;
	};
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var SPECIAL_CHARS_REGEX = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
	
	module.exports = function (text, pattern) {
	  var tokenSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : / +/g;
	
	  var regex = new RegExp(pattern.replace(SPECIAL_CHARS_REGEX, '\\$&').replace(tokenSeparator, '|'));
	  var matches = text.match(regex);
	  var isMatch = !!matches;
	  var matchedIndices = [];
	
	  if (isMatch) {
	    for (var i = 0, matchesLen = matches.length; i < matchesLen; i += 1) {
	      var match = matches[i];
	      matchedIndices.push([text.indexOf(match), match.length - 1]);
	    }
	  }
	
	  return {
	    // TODO: revisit this score
	    score: isMatch ? 0.5 : 1,
	    isMatch: isMatch,
	    matchedIndices: matchedIndices
	  };
	};
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function (pattern, _ref) {
	  var _ref$errors = _ref.errors,
	      errors = _ref$errors === undefined ? 0 : _ref$errors,
	      _ref$currentLocation = _ref.currentLocation,
	      currentLocation = _ref$currentLocation === undefined ? 0 : _ref$currentLocation,
	      _ref$expectedLocation = _ref.expectedLocation,
	      expectedLocation = _ref$expectedLocation === undefined ? 0 : _ref$expectedLocation,
	      _ref$distance = _ref.distance,
	      distance = _ref$distance === undefined ? 100 : _ref$distance;
	
	  var accuracy = errors / pattern.length;
	  var proximity = Math.abs(expectedLocation - currentLocation);
	
	  if (!distance) {
	    // Dodge divide by zero error.
	    return proximity ? 1.0 : accuracy;
	  }
	
	  return accuracy + proximity / distance;
	};
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var bitapScore = __webpack_require__(6);
	var matchedIndices = __webpack_require__(3);
	
	module.exports = function (text, pattern, patternAlphabet, _ref) {
	  var _ref$location = _ref.location,
	      location = _ref$location === undefined ? 0 : _ref$location,
	      _ref$distance = _ref.distance,
	      distance = _ref$distance === undefined ? 100 : _ref$distance,
	      _ref$threshold = _ref.threshold,
	      threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
	      _ref$findAllMatches = _ref.findAllMatches,
	      findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
	      _ref$minMatchCharLeng = _ref.minMatchCharLength,
	      minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;
	
	  var expectedLocation = location;
	  // Set starting location at beginning text and initialize the alphabet.
	  var textLen = text.length;
	  // Highest score beyond which we give up.
	  var currentThreshold = threshold;
	  // Is there a nearby exact match? (speedup)
	  var bestLocation = text.indexOf(pattern, expectedLocation);
	
	  var patternLen = pattern.length;
	
	  // a mask of the matches
	  var matchMask = [];
	  for (var i = 0; i < textLen; i += 1) {
	    matchMask[i] = 0;
	  }
	
	  if (bestLocation !== -1) {
	    var score = bitapScore(pattern, {
	      errors: 0,
	      currentLocation: bestLocation,
	      expectedLocation: expectedLocation,
	      distance: distance
	    });
	    currentThreshold = Math.min(score, currentThreshold);
	
	    // What about in the other direction? (speed up)
	    bestLocation = text.lastIndexOf(pattern, expectedLocation + patternLen);
	
	    if (bestLocation !== -1) {
	      var _score = bitapScore(pattern, {
	        errors: 0,
	        currentLocation: bestLocation,
	        expectedLocation: expectedLocation,
	        distance: distance
	      });
	      currentThreshold = Math.min(_score, currentThreshold);
	    }
	  }
	
	  // Reset the best location
	  bestLocation = -1;
	
	  var lastBitArr = [];
	  var finalScore = 1;
	  var binMax = patternLen + textLen;
	
	  var mask = 1 << patternLen - 1;
	
	  for (var _i = 0; _i < patternLen; _i += 1) {
	    // Scan for the best match; each iteration allows for one more error.
	    // Run a binary search to determine how far from the match location we can stray
	    // at this error level.
	    var binMin = 0;
	    var binMid = binMax;
	
	    while (binMin < binMid) {
	      var _score3 = bitapScore(pattern, {
	        errors: _i,
	        currentLocation: expectedLocation + binMid,
	        expectedLocation: expectedLocation,
	        distance: distance
	      });
	
	      if (_score3 <= currentThreshold) {
	        binMin = binMid;
	      } else {
	        binMax = binMid;
	      }
	
	      binMid = Math.floor((binMax - binMin) / 2 + binMin);
	    }
	
	    // Use the result from this iteration as the maximum for the next.
	    binMax = binMid;
	
	    var start = Math.max(1, expectedLocation - binMid + 1);
	    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
	
	    // Initialize the bit array
	    var bitArr = Array(finish + 2);
	
	    bitArr[finish + 1] = (1 << _i) - 1;
	
	    for (var j = finish; j >= start; j -= 1) {
	      var currentLocation = j - 1;
	      var charMatch = patternAlphabet[text.charAt(currentLocation)];
	
	      if (charMatch) {
	        matchMask[currentLocation] = 1;
	      }
	
	      // First pass: exact match
	      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
	
	      // Subsequent passes: fuzzy match
	      if (_i !== 0) {
	        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
	      }
	
	      if (bitArr[j] & mask) {
	        finalScore = bitapScore(pattern, {
	          errors: _i,
	          currentLocation: currentLocation,
	          expectedLocation: expectedLocation,
	          distance: distance
	        });
	
	        // This match will almost certainly be better than any existing match.
	        // But check anyway.
	        if (finalScore <= currentThreshold) {
	          // Indeed it is
	          currentThreshold = finalScore;
	          bestLocation = currentLocation;
	
	          // Already passed `loc`, downhill from here on in.
	          if (bestLocation <= expectedLocation) {
	            break;
	          }
	
	          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
	          start = Math.max(1, 2 * expectedLocation - bestLocation);
	        }
	      }
	    }
	
	    // No hope for a (better) match at greater error levels.
	    var _score2 = bitapScore(pattern, {
	      errors: _i + 1,
	      currentLocation: expectedLocation,
	      expectedLocation: expectedLocation,
	      distance: distance
	    });
	
	    // console.log('score', score, finalScore)
	
	    if (_score2 > currentThreshold) {
	      break;
	    }
	
	    lastBitArr = bitArr;
	  }
	
	  // console.log('FINAL SCORE', finalScore)
	
	  // Count exact matches (those with a score of 0) to be "almost" exact
	  return {
	    isMatch: bestLocation >= 0,
	    score: finalScore === 0 ? 0.001 : finalScore,
	    matchedIndices: matchedIndices(matchMask, minMatchCharLength)
	  };
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Bitap = __webpack_require__(1);
	var deepValue = __webpack_require__(2);
	var isArray = __webpack_require__(0);
	
	var Fuse = function () {
	  function Fuse(list, _ref) {
	    var _ref$location = _ref.location,
	        location = _ref$location === undefined ? 0 : _ref$location,
	        _ref$distance = _ref.distance,
	        distance = _ref$distance === undefined ? 100 : _ref$distance,
	        _ref$threshold = _ref.threshold,
	        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
	        _ref$maxPatternLength = _ref.maxPatternLength,
	        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
	        _ref$caseSensitive = _ref.caseSensitive,
	        caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
	        _ref$tokenSeparator = _ref.tokenSeparator,
	        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
	        _ref$findAllMatches = _ref.findAllMatches,
	        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
	        _ref$minMatchCharLeng = _ref.minMatchCharLength,
	        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng,
	        _ref$id = _ref.id,
	        id = _ref$id === undefined ? null : _ref$id,
	        _ref$keys = _ref.keys,
	        keys = _ref$keys === undefined ? [] : _ref$keys,
	        _ref$shouldSort = _ref.shouldSort,
	        shouldSort = _ref$shouldSort === undefined ? true : _ref$shouldSort,
	        _ref$getFn = _ref.getFn,
	        getFn = _ref$getFn === undefined ? deepValue : _ref$getFn,
	        _ref$sortFn = _ref.sortFn,
	        sortFn = _ref$sortFn === undefined ? function (a, b) {
	      return a.score - b.score;
	    } : _ref$sortFn,
	        _ref$tokenize = _ref.tokenize,
	        tokenize = _ref$tokenize === undefined ? false : _ref$tokenize,
	        _ref$matchAllTokens = _ref.matchAllTokens,
	        matchAllTokens = _ref$matchAllTokens === undefined ? false : _ref$matchAllTokens,
	        _ref$includeMatches = _ref.includeMatches,
	        includeMatches = _ref$includeMatches === undefined ? false : _ref$includeMatches,
	        _ref$includeScore = _ref.includeScore,
	        includeScore = _ref$includeScore === undefined ? false : _ref$includeScore,
	        _ref$verbose = _ref.verbose,
	        verbose = _ref$verbose === undefined ? false : _ref$verbose;
	
	    _classCallCheck(this, Fuse);
	
	    this.options = {
	      location: location,
	      distance: distance,
	      threshold: threshold,
	      maxPatternLength: maxPatternLength,
	      isCaseSensitive: caseSensitive,
	      tokenSeparator: tokenSeparator,
	      findAllMatches: findAllMatches,
	      minMatchCharLength: minMatchCharLength,
	      id: id,
	      keys: keys,
	      includeMatches: includeMatches,
	      includeScore: includeScore,
	      shouldSort: shouldSort,
	      getFn: getFn,
	      sortFn: sortFn,
	      verbose: verbose,
	      tokenize: tokenize,
	      matchAllTokens: matchAllTokens
	    };
	
	    this.setCollection(list);
	  }
	
	  _createClass(Fuse, [{
	    key: 'setCollection',
	    value: function setCollection(list) {
	      this.list = list;
	      return list;
	    }
	  }, {
	    key: 'search',
	    value: function search(pattern) {
	      this._log('---------\nSearch pattern: "' + pattern + '"');
	
	      var _prepareSearchers2 = this._prepareSearchers(pattern),
	          tokenSearchers = _prepareSearchers2.tokenSearchers,
	          fullSearcher = _prepareSearchers2.fullSearcher;
	
	      var _search2 = this._search(tokenSearchers, fullSearcher),
	          weights = _search2.weights,
	          results = _search2.results;
	
	      this._computeScore(weights, results);
	
	      if (this.options.shouldSort) {
	        this._sort(results);
	      }
	
	      return this._format(results);
	    }
	  }, {
	    key: '_prepareSearchers',
	    value: function _prepareSearchers() {
	      var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var tokenSearchers = [];
	
	      if (this.options.tokenize) {
	        // Tokenize on the separator
	        var tokens = pattern.split(this.options.tokenSeparator);
	        for (var i = 0, len = tokens.length; i < len; i += 1) {
	          tokenSearchers.push(new Bitap(tokens[i], this.options));
	        }
	      }
	
	      var fullSearcher = new Bitap(pattern, this.options);
	
	      return { tokenSearchers: tokenSearchers, fullSearcher: fullSearcher };
	    }
	  }, {
	    key: '_search',
	    value: function _search() {
	      var tokenSearchers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var fullSearcher = arguments[1];
	
	      var list = this.list;
	      var resultMap = {};
	      var results = [];
	
	      // Check the first item in the list, if it's a string, then we assume
	      // that every item in the list is also a string, and thus it's a flattened array.
	      if (typeof list[0] === 'string') {
	        // Iterate over every item
	        for (var i = 0, len = list.length; i < len; i += 1) {
	          this._analyze({
	            key: '',
	            value: list[i],
	            record: i,
	            index: i
	          }, {
	            resultMap: resultMap,
	            results: results,
	            tokenSearchers: tokenSearchers,
	            fullSearcher: fullSearcher
	          });
	        }
	
	        return { weights: null, results: results };
	      }
	
	      // Otherwise, the first item is an Object (hopefully), and thus the searching
	      // is done on the values of the keys of each item.
	      var weights = {};
	      for (var _i = 0, _len = list.length; _i < _len; _i += 1) {
	        var item = list[_i];
	        // Iterate over every key
	        for (var j = 0, keysLen = this.options.keys.length; j < keysLen; j += 1) {
	          var key = this.options.keys[j];
	          if (typeof key !== 'string') {
	            weights[key.name] = {
	              weight: 1 - key.weight || 1
	            };
	            if (key.weight <= 0 || key.weight > 1) {
	              throw new Error('Key weight has to be > 0 and <= 1');
	            }
	            key = key.name;
	          } else {
	            weights[key] = {
	              weight: 1
	            };
	          }
	
	          this._analyze({
	            key: key,
	            value: this.options.getFn(item, key),
	            record: item,
	            index: _i
	          }, {
	            resultMap: resultMap,
	            results: results,
	            tokenSearchers: tokenSearchers,
	            fullSearcher: fullSearcher
	          });
	        }
	      }
	
	      return { weights: weights, results: results };
	    }
	  }, {
	    key: '_analyze',
	    value: function _analyze(_ref2, _ref3) {
	      var key = _ref2.key,
	          _ref2$arrayIndex = _ref2.arrayIndex,
	          arrayIndex = _ref2$arrayIndex === undefined ? -1 : _ref2$arrayIndex,
	          value = _ref2.value,
	          record = _ref2.record,
	          index = _ref2.index;
	      var _ref3$tokenSearchers = _ref3.tokenSearchers,
	          tokenSearchers = _ref3$tokenSearchers === undefined ? [] : _ref3$tokenSearchers,
	          _ref3$fullSearcher = _ref3.fullSearcher,
	          fullSearcher = _ref3$fullSearcher === undefined ? [] : _ref3$fullSearcher,
	          _ref3$resultMap = _ref3.resultMap,
	          resultMap = _ref3$resultMap === undefined ? {} : _ref3$resultMap,
	          _ref3$results = _ref3.results,
	          results = _ref3$results === undefined ? [] : _ref3$results;
	
	      // Check if the texvaluet can be searched
	      if (value === undefined || value === null) {
	        return;
	      }
	
	      var exists = false;
	      var averageScore = -1;
	      var numTextMatches = 0;
	
	      if (typeof value === 'string') {
	        this._log('\nKey: ' + (key === '' ? '-' : key));
	
	        var mainSearchResult = fullSearcher.search(value);
	        this._log('Full text: "' + value + '", score: ' + mainSearchResult.score);
	
	        if (this.options.tokenize) {
	          var words = value.split(this.options.tokenSeparator);
	          var scores = [];
	
	          for (var i = 0; i < tokenSearchers.length; i += 1) {
	            var tokenSearcher = tokenSearchers[i];
	
	            this._log('\nPattern: "' + tokenSearcher.pattern + '"');
	
	            // let tokenScores = []
	            var hasMatchInText = false;
	
	            for (var j = 0; j < words.length; j += 1) {
	              var word = words[j];
	              var tokenSearchResult = tokenSearcher.search(word);
	              var obj = {};
	              if (tokenSearchResult.isMatch) {
	                obj[word] = tokenSearchResult.score;
	                exists = true;
	                hasMatchInText = true;
	                scores.push(tokenSearchResult.score);
	              } else {
	                obj[word] = 1;
	                if (!this.options.matchAllTokens) {
	                  scores.push(1);
	                }
	              }
	              this._log('Token: "' + word + '", score: ' + obj[word]);
	              // tokenScores.push(obj)
	            }
	
	            if (hasMatchInText) {
	              numTextMatches += 1;
	            }
	          }
	
	          averageScore = scores[0];
	          var scoresLen = scores.length;
	          for (var _i2 = 1; _i2 < scoresLen; _i2 += 1) {
	            averageScore += scores[_i2];
	          }
	          averageScore = averageScore / scoresLen;
	
	          this._log('Token score average:', averageScore);
	        }
	
	        var finalScore = mainSearchResult.score;
	        if (averageScore > -1) {
	          finalScore = (finalScore + averageScore) / 2;
	        }
	
	        this._log('Score average:', finalScore);
	
	        var checkTextMatches = this.options.tokenize && this.options.matchAllTokens ? numTextMatches >= tokenSearchers.length : true;
	
	        this._log('\nCheck Matches: ' + checkTextMatches);
	
	        // If a match is found, add the item to <rawResults>, including its score
	        if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
	          // Check if the item already exists in our results
	          var existingResult = resultMap[index];
	          if (existingResult) {
	            // Use the lowest score
	            // existingResult.score, bitapResult.score
	            existingResult.output.push({
	              key: key,
	              arrayIndex: arrayIndex,
	              value: value,
	              score: finalScore,
	              matchedIndices: mainSearchResult.matchedIndices
	            });
	          } else {
	            // Add it to the raw result list
	            resultMap[index] = {
	              item: record,
	              output: [{
	                key: key,
	                arrayIndex: arrayIndex,
	                value: value,
	                score: finalScore,
	                matchedIndices: mainSearchResult.matchedIndices
	              }]
	            };
	
	            results.push(resultMap[index]);
	          }
	        }
	      } else if (isArray(value)) {
	        for (var _i3 = 0, len = value.length; _i3 < len; _i3 += 1) {
	          this._analyze({
	            key: key,
	            arrayIndex: _i3,
	            value: value[_i3],
	            record: record,
	            index: index
	          }, {
	            resultMap: resultMap,
	            results: results,
	            tokenSearchers: tokenSearchers,
	            fullSearcher: fullSearcher
	          });
	        }
	      }
	    }
	  }, {
	    key: '_computeScore',
	    value: function _computeScore(weights, results) {
	      this._log('\n\nComputing score:\n');
	
	      for (var i = 0, len = results.length; i < len; i += 1) {
	        var output = results[i].output;
	        var scoreLen = output.length;
	
	        var currScore = 1;
	        var bestScore = 1;
	
	        for (var j = 0; j < scoreLen; j += 1) {
	          var weight = weights ? weights[output[j].key].weight : 1;
	          var score = weight === 1 ? output[j].score : output[j].score || 0.001;
	          var nScore = score * weight;
	
	          if (weight !== 1) {
	            bestScore = Math.min(bestScore, nScore);
	          } else {
	            output[j].nScore = nScore;
	            currScore *= nScore;
	          }
	        }
	
	        results[i].score = bestScore === 1 ? currScore : bestScore;
	
	        this._log(results[i]);
	      }
	    }
	  }, {
	    key: '_sort',
	    value: function _sort(results) {
	      this._log('\n\nSorting....');
	      results.sort(this.options.sortFn);
	    }
	  }, {
	    key: '_format',
	    value: function _format(results) {
	      var finalOutput = [];
	
	      if (this.options.verbose) {
	        this._log('\n\nOutput:\n\n', JSON.stringify(results));
	      }
	
	      var transformers = [];
	
	      if (this.options.includeMatches) {
	        transformers.push(function (result, data) {
	          var output = result.output;
	          data.matches = [];
	
	          for (var i = 0, len = output.length; i < len; i += 1) {
	            var item = output[i];
	
	            if (item.matchedIndices.length === 0) {
	              continue;
	            }
	
	            var obj = {
	              indices: item.matchedIndices,
	              value: item.value
	            };
	            if (item.key) {
	              obj.key = item.key;
	            }
	            if (item.hasOwnProperty('arrayIndex') && item.arrayIndex > -1) {
	              obj.arrayIndex = item.arrayIndex;
	            }
	            data.matches.push(obj);
	          }
	        });
	      }
	
	      if (this.options.includeScore) {
	        transformers.push(function (result, data) {
	          data.score = result.score;
	        });
	      }
	
	      for (var i = 0, len = results.length; i < len; i += 1) {
	        var result = results[i];
	
	        if (this.options.id) {
	          result.item = this.options.getFn(result.item, this.options.id)[0];
	        }
	
	        if (!transformers.length) {
	          finalOutput.push(result.item);
	          continue;
	        }
	
	        var data = {
	          item: result.item
	        };
	
	        for (var j = 0, _len2 = transformers.length; j < _len2; j += 1) {
	          transformers[j](result, data);
	        }
	
	        finalOutput.push(data);
	      }
	
	      return finalOutput;
	    }
	  }, {
	    key: '_log',
	    value: function _log() {
	      if (this.options.verbose) {
	        var _console;
	
	        (_console = console).log.apply(_console, arguments);
	      }
	    }
	  }]);
	
	  return Fuse;
	}();
	
	module.exports = Fuse;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=fuse.js.map

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 569 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(70);
	
	var _PathUtils = __webpack_require__(53);
	
	var _createTransitionManager = __webpack_require__(101);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(70);
	
	var _PathUtils = __webpack_require__(53);
	
	var _createTransitionManager = __webpack_require__(101);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(71);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(53);
	
	var _LocationUtils = __webpack_require__(70);
	
	var _createTransitionManager = __webpack_require__(101);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(333);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
	        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 574 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 575 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(779);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(791);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module), (function() { return this; }())))

/***/ },
/* 579 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(594),
	    hashDelete = __webpack_require__(595),
	    hashGet = __webpack_require__(596),
	    hashHas = __webpack_require__(597),
	    hashSet = __webpack_require__(598);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(602),
	    listCacheDelete = __webpack_require__(603),
	    listCacheGet = __webpack_require__(604),
	    listCacheHas = __webpack_require__(605),
	    listCacheSet = __webpack_require__(606);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(176),
	    root = __webpack_require__(104);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(607),
	    mapCacheDelete = __webpack_require__(608),
	    mapCacheGet = __webpack_require__(609),
	    mapCacheHas = __webpack_require__(610),
	    mapCacheSet = __webpack_require__(611);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 584 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(588),
	    toKey = __webpack_require__(616);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(619),
	    isMasked = __webpack_require__(601),
	    isObject = __webpack_require__(177),
	    toSource = __webpack_require__(617);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(102),
	    arrayMap = __webpack_require__(584),
	    isArray = __webpack_require__(106),
	    isSymbol = __webpack_require__(107);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(106),
	    isKey = __webpack_require__(599),
	    stringToPath = __webpack_require__(615),
	    toString = __webpack_require__(621);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(104);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 590 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(614);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(102);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 593 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(75);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 595 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(75);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(75);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(75);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(106),
	    isSymbol = __webpack_require__(107);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 600 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(589);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 602 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(73);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(73);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(73);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(73);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(580),
	    ListCache = __webpack_require__(581),
	    Map = __webpack_require__(582);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(74);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(74);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(74);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(74);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(620);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 613 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 614 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(612);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(107);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 617 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 618 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(103),
	    isObject = __webpack_require__(177);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(583);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(587);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 180,
		"./af.js": 180,
		"./ar": 187,
		"./ar-dz": 181,
		"./ar-dz.js": 181,
		"./ar-kw": 182,
		"./ar-kw.js": 182,
		"./ar-ly": 183,
		"./ar-ly.js": 183,
		"./ar-ma": 184,
		"./ar-ma.js": 184,
		"./ar-sa": 185,
		"./ar-sa.js": 185,
		"./ar-tn": 186,
		"./ar-tn.js": 186,
		"./ar.js": 187,
		"./az": 188,
		"./az.js": 188,
		"./be": 189,
		"./be.js": 189,
		"./bg": 190,
		"./bg.js": 190,
		"./bm": 191,
		"./bm.js": 191,
		"./bn": 192,
		"./bn.js": 192,
		"./bo": 193,
		"./bo.js": 193,
		"./br": 194,
		"./br.js": 194,
		"./bs": 195,
		"./bs.js": 195,
		"./ca": 196,
		"./ca.js": 196,
		"./cs": 197,
		"./cs.js": 197,
		"./cv": 198,
		"./cv.js": 198,
		"./cy": 199,
		"./cy.js": 199,
		"./da": 200,
		"./da.js": 200,
		"./de": 203,
		"./de-at": 201,
		"./de-at.js": 201,
		"./de-ch": 202,
		"./de-ch.js": 202,
		"./de.js": 203,
		"./dv": 204,
		"./dv.js": 204,
		"./el": 205,
		"./el.js": 205,
		"./en-au": 206,
		"./en-au.js": 206,
		"./en-ca": 207,
		"./en-ca.js": 207,
		"./en-gb": 208,
		"./en-gb.js": 208,
		"./en-ie": 209,
		"./en-ie.js": 209,
		"./en-il": 210,
		"./en-il.js": 210,
		"./en-nz": 211,
		"./en-nz.js": 211,
		"./eo": 212,
		"./eo.js": 212,
		"./es": 215,
		"./es-do": 213,
		"./es-do.js": 213,
		"./es-us": 214,
		"./es-us.js": 214,
		"./es.js": 215,
		"./et": 216,
		"./et.js": 216,
		"./eu": 217,
		"./eu.js": 217,
		"./fa": 218,
		"./fa.js": 218,
		"./fi": 219,
		"./fi.js": 219,
		"./fo": 220,
		"./fo.js": 220,
		"./fr": 223,
		"./fr-ca": 221,
		"./fr-ca.js": 221,
		"./fr-ch": 222,
		"./fr-ch.js": 222,
		"./fr.js": 223,
		"./fy": 224,
		"./fy.js": 224,
		"./gd": 225,
		"./gd.js": 225,
		"./gl": 226,
		"./gl.js": 226,
		"./gom-latn": 227,
		"./gom-latn.js": 227,
		"./gu": 228,
		"./gu.js": 228,
		"./he": 229,
		"./he.js": 229,
		"./hi": 230,
		"./hi.js": 230,
		"./hr": 231,
		"./hr.js": 231,
		"./hu": 232,
		"./hu.js": 232,
		"./hy-am": 233,
		"./hy-am.js": 233,
		"./id": 234,
		"./id.js": 234,
		"./is": 235,
		"./is.js": 235,
		"./it": 236,
		"./it.js": 236,
		"./ja": 237,
		"./ja.js": 237,
		"./jv": 238,
		"./jv.js": 238,
		"./ka": 239,
		"./ka.js": 239,
		"./kk": 240,
		"./kk.js": 240,
		"./km": 241,
		"./km.js": 241,
		"./kn": 242,
		"./kn.js": 242,
		"./ko": 243,
		"./ko.js": 243,
		"./ku": 244,
		"./ku.js": 244,
		"./ky": 245,
		"./ky.js": 245,
		"./lb": 246,
		"./lb.js": 246,
		"./lo": 247,
		"./lo.js": 247,
		"./lt": 248,
		"./lt.js": 248,
		"./lv": 249,
		"./lv.js": 249,
		"./me": 250,
		"./me.js": 250,
		"./mi": 251,
		"./mi.js": 251,
		"./mk": 252,
		"./mk.js": 252,
		"./ml": 253,
		"./ml.js": 253,
		"./mn": 254,
		"./mn.js": 254,
		"./mr": 255,
		"./mr.js": 255,
		"./ms": 257,
		"./ms-my": 256,
		"./ms-my.js": 256,
		"./ms.js": 257,
		"./mt": 258,
		"./mt.js": 258,
		"./my": 259,
		"./my.js": 259,
		"./nb": 260,
		"./nb.js": 260,
		"./ne": 261,
		"./ne.js": 261,
		"./nl": 263,
		"./nl-be": 262,
		"./nl-be.js": 262,
		"./nl.js": 263,
		"./nn": 264,
		"./nn.js": 264,
		"./pa-in": 265,
		"./pa-in.js": 265,
		"./pl": 266,
		"./pl.js": 266,
		"./pt": 268,
		"./pt-br": 267,
		"./pt-br.js": 267,
		"./pt.js": 268,
		"./ro": 269,
		"./ro.js": 269,
		"./ru": 270,
		"./ru.js": 270,
		"./sd": 271,
		"./sd.js": 271,
		"./se": 272,
		"./se.js": 272,
		"./si": 273,
		"./si.js": 273,
		"./sk": 274,
		"./sk.js": 274,
		"./sl": 275,
		"./sl.js": 275,
		"./sq": 276,
		"./sq.js": 276,
		"./sr": 278,
		"./sr-cyrl": 277,
		"./sr-cyrl.js": 277,
		"./sr.js": 278,
		"./ss": 279,
		"./ss.js": 279,
		"./sv": 280,
		"./sv.js": 280,
		"./sw": 281,
		"./sw.js": 281,
		"./ta": 282,
		"./ta.js": 282,
		"./te": 283,
		"./te.js": 283,
		"./tet": 284,
		"./tet.js": 284,
		"./tg": 285,
		"./tg.js": 285,
		"./th": 286,
		"./th.js": 286,
		"./tl-ph": 287,
		"./tl-ph.js": 287,
		"./tlh": 288,
		"./tlh.js": 288,
		"./tr": 289,
		"./tr.js": 289,
		"./tzl": 290,
		"./tzl.js": 290,
		"./tzm": 292,
		"./tzm-latn": 291,
		"./tzm-latn.js": 291,
		"./tzm.js": 292,
		"./ug-cn": 293,
		"./ug-cn.js": 293,
		"./uk": 294,
		"./uk.js": 294,
		"./ur": 295,
		"./ur.js": 295,
		"./uz": 297,
		"./uz-latn": 296,
		"./uz-latn.js": 296,
		"./uz.js": 297,
		"./vi": 298,
		"./vi.js": 298,
		"./x-pseudo": 299,
		"./x-pseudo.js": 299,
		"./yo": 300,
		"./yo.js": 300,
		"./zh-cn": 301,
		"./zh-cn.js": 301,
		"./zh-hk": 302,
		"./zh-hk.js": 302,
		"./zh-tw": 303,
		"./zh-tw.js": 303
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 622;


/***/ },
/* 623 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 624 */
568,
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(307);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(8);
	
	var ReactPropTypesSecret = __webpack_require__(307);
	var checkPropTypes = __webpack_require__(625);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var value_types_1 = __webpack_require__(42);
	var str = __webpack_require__(634);
	var obj = __webpack_require__(111);
	var InsertOpDenormalizer = (function () {
	    function InsertOpDenormalizer() {
	    }
	    InsertOpDenormalizer.denormalize = function (op) {
	        if (!op || typeof op !== 'object') {
	            return [];
	        }
	        if (typeof op.insert === 'object' || op.insert === value_types_1.NewLine) {
	            return [op];
	        }
	        var newlinedArray = str.tokenizeWithNewLines(op.insert + '');
	        if (newlinedArray.length === 1) {
	            return [op];
	        }
	        var nlObj = obj.assign({}, op, { insert: value_types_1.NewLine });
	        return newlinedArray.map(function (line) {
	            if (line === value_types_1.NewLine) {
	                return nlObj;
	            }
	            return obj.assign({}, op, {
	                insert: line
	            });
	        });
	    };
	    return InsertOpDenormalizer;
	}());
	exports.InsertOpDenormalizer = InsertOpDenormalizer;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DeltaInsertOp_1 = __webpack_require__(308);
	var value_types_1 = __webpack_require__(42);
	var InsertData_1 = __webpack_require__(309);
	var OpAttributeSanitizer_1 = __webpack_require__(310);
	var InsertOpDenormalizer_1 = __webpack_require__(628);
	var InsertOpsConverter = (function () {
	    function InsertOpsConverter() {
	    }
	    InsertOpsConverter.convert = function (deltaOps) {
	        if (!Array.isArray(deltaOps)) {
	            return [];
	        }
	        var denormalizedOps = [].concat.apply([], deltaOps.map(InsertOpDenormalizer_1.InsertOpDenormalizer.denormalize));
	        var results = [];
	        var insertVal, attributes;
	        for (var _i = 0, denormalizedOps_1 = denormalizedOps; _i < denormalizedOps_1.length; _i++) {
	            var op = denormalizedOps_1[_i];
	            if (!op.insert) {
	                continue;
	            }
	            insertVal = InsertOpsConverter.convertInsertVal(op.insert);
	            if (!insertVal) {
	                continue;
	            }
	            attributes = OpAttributeSanitizer_1.OpAttributeSanitizer.sanitize(op.attributes);
	            results.push(new DeltaInsertOp_1.DeltaInsertOp(insertVal, attributes));
	        }
	        return results;
	    };
	    InsertOpsConverter.convertInsertVal = function (insertPropVal) {
	        if (typeof insertPropVal === 'string') {
	            return new InsertData_1.InsertDataQuill(value_types_1.DataType.Text, insertPropVal);
	        }
	        if (!insertPropVal || typeof insertPropVal !== 'object') {
	            return null;
	        }
	        var keys = Object.keys(insertPropVal);
	        if (!keys.length) {
	            return null;
	        }
	        return value_types_1.DataType.Image in insertPropVal ?
	            new InsertData_1.InsertDataQuill(value_types_1.DataType.Image, insertPropVal[value_types_1.DataType.Image])
	            : value_types_1.DataType.Video in insertPropVal ?
	                new InsertData_1.InsertDataQuill(value_types_1.DataType.Video, insertPropVal[value_types_1.DataType.Video])
	                : value_types_1.DataType.Formula in insertPropVal ?
	                    new InsertData_1.InsertDataQuill(value_types_1.DataType.Formula, insertPropVal[value_types_1.DataType.Formula])
	                    : new InsertData_1.InsertDataCustom(keys[0], insertPropVal[keys[0]]);
	    };
	    return InsertOpsConverter;
	}());
	exports.InsertOpsConverter = InsertOpsConverter;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var funcs_html_1 = __webpack_require__(311);
	var value_types_1 = __webpack_require__(42);
	var url = __webpack_require__(112);
	var obj = __webpack_require__(111);
	var arr = __webpack_require__(110);
	var OpAttributeSanitizer_1 = __webpack_require__(310);
	var OpToHtmlConverter = (function () {
	    function OpToHtmlConverter(op, options) {
	        this.op = op;
	        this.options = obj.assign({}, {
	            classPrefix: 'ql',
	            encodeHtml: true,
	            listItemTag: 'li',
	            paragraphTag: 'p'
	        }, options);
	    }
	    OpToHtmlConverter.prototype.prefixClass = function (className) {
	        if (!this.options.classPrefix) {
	            return className + '';
	        }
	        return this.options.classPrefix + '-' + className;
	    };
	    OpToHtmlConverter.prototype.getHtml = function () {
	        var parts = this.getHtmlParts();
	        return parts.openingTag + parts.content + parts.closingTag;
	    };
	    OpToHtmlConverter.prototype.getHtmlParts = function () {
	        if (this.op.isJustNewline() && !this.op.isContainerBlock()) {
	            return { openingTag: '', closingTag: '', content: value_types_1.NewLine };
	        }
	        var tags = this.getTags(), attrs = this.getTagAttributes();
	        if (!tags.length && attrs.length) {
	            tags.push('span');
	        }
	        var beginTags = [], endTags = [];
	        for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
	            var tag = tags_1[_i];
	            beginTags.push(funcs_html_1.makeStartTag(tag, attrs));
	            endTags.push(tag === 'img' ? '' : funcs_html_1.makeEndTag(tag));
	            attrs = [];
	        }
	        endTags.reverse();
	        return {
	            openingTag: beginTags.join(''),
	            content: this.getContent(),
	            closingTag: endTags.join('')
	        };
	    };
	    OpToHtmlConverter.prototype.getContent = function () {
	        if (this.op.isContainerBlock()) {
	            return '';
	        }
	        if (this.op.isMentions()) {
	            return this.op.insert.value;
	        }
	        var content = this.op.isFormula() || this.op.isText() ? this.op.insert.value : '';
	        return this.options.encodeHtml && funcs_html_1.encodeHtml(content) || content;
	    };
	    OpToHtmlConverter.prototype.getCssClasses = function () {
	        var attrs = this.op.attributes;
	        var propsArr = ['indent', 'align', 'direction', 'font', 'size'];
	        if (this.options.allowBackgroundClasses) {
	            propsArr.push('background');
	        }
	        return propsArr
	            .filter(function (prop) { return !!attrs[prop]; })
	            .filter(function (prop) { return prop === 'background' ? OpAttributeSanitizer_1.OpAttributeSanitizer.IsValidColorLiteral(attrs[prop]) : true; })
	            .map(function (prop) { return prop + '-' + attrs[prop]; })
	            .concat(this.op.isFormula() ? 'formula' : [])
	            .concat(this.op.isVideo() ? 'video' : [])
	            .concat(this.op.isImage() ? 'image' : [])
	            .map(this.prefixClass.bind(this));
	    };
	    OpToHtmlConverter.prototype.getCssStyles = function () {
	        var attrs = this.op.attributes;
	        var propsArr = [['color']];
	        if (!this.options.allowBackgroundClasses) {
	            propsArr.push(['background', 'background-color']);
	        }
	        return propsArr
	            .filter(function (item) { return !!attrs[item[0]]; })
	            .map(function (item) { return arr.preferSecond(item) + ':' + attrs[item[0]]; });
	    };
	    OpToHtmlConverter.prototype.getTagAttributes = function () {
	        if (this.op.attributes.code && !this.op.isLink()) {
	            return [];
	        }
	        var makeAttr = function (k, v) { return ({ key: k, value: v }); };
	        var classes = this.getCssClasses();
	        var tagAttrs = classes.length ? [makeAttr('class', classes.join(' '))] : [];
	        if (this.op.isImage()) {
	            this.op.attributes.width && (tagAttrs = tagAttrs.concat(makeAttr('width', this.op.attributes.width)));
	            return tagAttrs.concat(makeAttr('src', url.sanitize(this.op.insert.value + '') + ''));
	        }
	        if (this.op.isACheckList()) {
	            return tagAttrs.concat(makeAttr('data-checked', this.op.isCheckedList() ? 'true' : 'false'));
	        }
	        if (this.op.isFormula() || this.op.isContainerBlock()) {
	            return tagAttrs;
	        }
	        if (this.op.isVideo()) {
	            return tagAttrs.concat(makeAttr('frameborder', '0'), makeAttr('allowfullscreen', 'true'), makeAttr('src', url.sanitize(this.op.insert.value + '') + ''));
	        }
	        if (this.op.isMentions()) {
	            var mention = this.op.attributes.mention;
	            if (mention.class) {
	                tagAttrs = tagAttrs.concat(makeAttr('class', mention.class));
	            }
	            if (mention['end-point'] && mention.slug) {
	                tagAttrs = tagAttrs.concat(makeAttr('href', funcs_html_1.encodeLink(mention['end-point'] + '/' + mention.slug)));
	            }
	            else {
	                tagAttrs = tagAttrs.concat(makeAttr('href', 'about:blank'));
	            }
	            if (mention.target) {
	                tagAttrs = tagAttrs.concat(makeAttr('target', mention.target));
	            }
	            return tagAttrs;
	        }
	        var styles = this.getCssStyles();
	        var styleAttr = styles.length ? [makeAttr('style', styles.join(';'))] : [];
	        tagAttrs = tagAttrs.concat(styleAttr);
	        if (this.op.isLink()) {
	            var target = this.op.attributes.target || this.options.linkTarget;
	            tagAttrs = tagAttrs
	                .concat(makeAttr('href', funcs_html_1.encodeLink(this.op.attributes.link)))
	                .concat(target ? makeAttr('target', target) : []);
	            if (!!this.options.linkRel && OpToHtmlConverter.IsValidRel(this.options.linkRel)) {
	                tagAttrs.push(makeAttr('rel', this.options.linkRel));
	            }
	        }
	        return tagAttrs;
	    };
	    OpToHtmlConverter.prototype.getTags = function () {
	        var attrs = this.op.attributes;
	        if (!this.op.isText()) {
	            return [this.op.isVideo() ? 'iframe'
	                    : this.op.isImage() ? 'img'
	                        : 'span'
	            ];
	        }
	        var positionTag = this.options.paragraphTag || 'p';
	        var blocks = [['blockquote'], ['code-block', 'pre'],
	            ['list', this.options.listItemTag], ['header'],
	            ['align', positionTag], ['direction', positionTag],
	            ['indent', positionTag]];
	        for (var _i = 0, blocks_1 = blocks; _i < blocks_1.length; _i++) {
	            var item = blocks_1[_i];
	            var firstItem = item[0];
	            if (attrs[firstItem]) {
	                return firstItem === 'header' ? ['h' + attrs[firstItem]] : [arr.preferSecond(item)];
	            }
	        }
	        return [['link', 'a'], ['mentions', 'a'], ['script'],
	            ['bold', 'strong'], ['italic', 'em'], ['strike', 's'], ['underline', 'u'],
	            ['code']]
	            .filter(function (item) { return !!attrs[item[0]]; })
	            .map(function (item) {
	            return item[0] === 'script' ?
	                (attrs[item[0]] === value_types_1.ScriptType.Sub ? 'sub' : 'sup')
	                : arr.preferSecond(item);
	        });
	    };
	    OpToHtmlConverter.IsValidRel = function (relStr) {
	        return !!relStr.match(/^[a-z\s]{1,50}$/i);
	    };
	    return OpToHtmlConverter;
	}());
	exports.OpToHtmlConverter = OpToHtmlConverter;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InsertOpsConverter_1 = __webpack_require__(629);
	var OpToHtmlConverter_1 = __webpack_require__(630);
	var Grouper_1 = __webpack_require__(632);
	var group_types_1 = __webpack_require__(109);
	var ListNester_1 = __webpack_require__(633);
	var funcs_html_1 = __webpack_require__(311);
	var obj = __webpack_require__(111);
	var value_types_1 = __webpack_require__(42);
	var BrTag = '<br/>';
	var QuillDeltaToHtmlConverter = (function () {
	    function QuillDeltaToHtmlConverter(deltaOps, options) {
	        this.rawDeltaOps = [];
	        this.callbacks = {};
	        this.options = obj.assign({
	            paragraphTag: 'p',
	            encodeHtml: true,
	            classPrefix: 'ql',
	            multiLineBlockquote: true,
	            multiLineHeader: true,
	            multiLineCodeblock: true,
	            allowBackgroundClasses: false,
	            linkTarget: '_blank'
	        }, options, {
	            orderedListTag: 'ol',
	            bulletListTag: 'ul',
	            listItemTag: 'li'
	        });
	        this.converterOptions = {
	            encodeHtml: this.options.encodeHtml,
	            classPrefix: this.options.classPrefix,
	            listItemTag: this.options.listItemTag,
	            paragraphTag: this.options.paragraphTag,
	            linkRel: this.options.linkRel,
	            linkTarget: this.options.linkTarget,
	            allowBackgroundClasses: this.options.allowBackgroundClasses
	        };
	        this.rawDeltaOps = deltaOps;
	    }
	    QuillDeltaToHtmlConverter.prototype._getListTag = function (op) {
	        return op.isOrderedList() ? this.options.orderedListTag + ''
	            : op.isBulletList() ? this.options.bulletListTag + ''
	                : op.isCheckedList() ? this.options.bulletListTag + ''
	                    : op.isUncheckedList() ? this.options.bulletListTag + ''
	                        : '';
	    };
	    QuillDeltaToHtmlConverter.prototype.getGroupedOps = function () {
	        var deltaOps = InsertOpsConverter_1.InsertOpsConverter.convert(this.rawDeltaOps);
	        var pairedOps = Grouper_1.Grouper.pairOpsWithTheirBlock(deltaOps);
	        var groupedSameStyleBlocks = Grouper_1.Grouper.groupConsecutiveSameStyleBlocks(pairedOps, {
	            blockquotes: !!this.options.multiLineBlockquote,
	            header: !!this.options.multiLineHeader,
	            codeBlocks: !!this.options.multiLineCodeblock
	        });
	        var groupedOps = Grouper_1.Grouper.reduceConsecutiveSameStyleBlocksToOne(groupedSameStyleBlocks);
	        var listNester = new ListNester_1.ListNester();
	        return listNester.nest(groupedOps);
	    };
	    QuillDeltaToHtmlConverter.prototype.convert = function () {
	        var _this = this;
	        return this.getGroupedOps()
	            .map(function (group) {
	            if (group instanceof group_types_1.ListGroup) {
	                return _this._renderWithCallbacks(value_types_1.GroupType.List, group, function () { return _this._renderList(group); });
	            }
	            else if (group instanceof group_types_1.BlockGroup) {
	                var g = group;
	                return _this._renderWithCallbacks(value_types_1.GroupType.Block, group, function () { return _this._renderBlock(g.op, g.ops); });
	            }
	            else if (group instanceof group_types_1.VideoItem) {
	                return _this._renderWithCallbacks(value_types_1.GroupType.Video, group, function () {
	                    var g = group;
	                    var converter = new OpToHtmlConverter_1.OpToHtmlConverter(g.op, _this.converterOptions);
	                    return converter.getHtml();
	                });
	            }
	            else {
	                return _this._renderWithCallbacks(value_types_1.GroupType.InlineGroup, group, function () {
	                    return _this._renderInlines(group.ops);
	                });
	            }
	        })
	            .join("");
	    };
	    QuillDeltaToHtmlConverter.prototype._renderWithCallbacks = function (groupType, group, myRenderFn) {
	        var html = '';
	        var beforeCb = this.callbacks['beforeRender_cb'];
	        html = typeof beforeCb === 'function' ? beforeCb.apply(null, [groupType, group]) : '';
	        if (!html) {
	            html = myRenderFn();
	        }
	        var afterCb = this.callbacks['afterRender_cb'];
	        html = typeof afterCb === 'function' ? afterCb.apply(null, [groupType, html]) : html;
	        return html;
	    };
	    QuillDeltaToHtmlConverter.prototype._renderList = function (list) {
	        var _this = this;
	        var firstItem = list.items[0];
	        return funcs_html_1.makeStartTag(this._getListTag(firstItem.item.op))
	            + list.items.map(function (li) { return _this._renderListItem(li); }).join('')
	            + funcs_html_1.makeEndTag(this._getListTag(firstItem.item.op));
	    };
	    QuillDeltaToHtmlConverter.prototype._renderListItem = function (li) {
	        li.item.op.attributes.indent = 0;
	        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(li.item.op, this.converterOptions);
	        var parts = converter.getHtmlParts();
	        var liElementsHtml = this._renderInlines(li.item.ops, false);
	        return parts.openingTag + (liElementsHtml) +
	            (li.innerList ? this._renderList(li.innerList) : '')
	            + parts.closingTag;
	    };
	    QuillDeltaToHtmlConverter.prototype._renderBlock = function (bop, ops) {
	        var _this = this;
	        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(bop, this.converterOptions);
	        var htmlParts = converter.getHtmlParts();
	        if (bop.isCodeBlock()) {
	            return htmlParts.openingTag +
	                funcs_html_1.encodeHtml(ops.map(function (iop) {
	                    return iop.isCustom() ? _this._renderCustom(iop, bop) : iop.insert.value;
	                }).join(""))
	                + htmlParts.closingTag;
	        }
	        var inlines = ops.map(function (op) { return _this._renderInline(op, bop); }).join('');
	        return htmlParts.openingTag + (inlines || BrTag) + htmlParts.closingTag;
	    };
	    QuillDeltaToHtmlConverter.prototype._renderInlines = function (ops, wrapInParagraphTag) {
	        var _this = this;
	        if (wrapInParagraphTag === void 0) { wrapInParagraphTag = true; }
	        var opsLen = ops.length - 1;
	        var html = ops.map(function (op, i) {
	            if (i > 0 && i === opsLen && op.isJustNewline()) {
	                return '';
	            }
	            return _this._renderInline(op, null);
	        }).join('');
	        if (!wrapInParagraphTag) {
	            return html;
	        }
	        return funcs_html_1.makeStartTag(this.options.paragraphTag) +
	            html + funcs_html_1.makeEndTag(this.options.paragraphTag);
	    };
	    QuillDeltaToHtmlConverter.prototype._renderInline = function (op, contextOp) {
	        if (op.isCustom()) {
	            return this._renderCustom(op, contextOp);
	        }
	        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(op, this.converterOptions);
	        return converter.getHtml().replace(/\n/g, BrTag);
	    };
	    QuillDeltaToHtmlConverter.prototype._renderCustom = function (op, contextOp) {
	        var renderCb = this.callbacks['renderCustomOp_cb'];
	        if (typeof renderCb === 'function') {
	            return renderCb.apply(null, [op, contextOp]);
	        }
	        return "";
	    };
	    QuillDeltaToHtmlConverter.prototype.beforeRender = function (cb) {
	        if (typeof cb === 'function') {
	            this.callbacks['beforeRender_cb'] = cb;
	        }
	    };
	    QuillDeltaToHtmlConverter.prototype.afterRender = function (cb) {
	        if (typeof cb === 'function') {
	            this.callbacks['afterRender_cb'] = cb;
	        }
	    };
	    QuillDeltaToHtmlConverter.prototype.renderCustomWith = function (cb) {
	        this.callbacks['renderCustomOp_cb'] = cb;
	    };
	    return QuillDeltaToHtmlConverter;
	}());
	exports.QuillDeltaToHtmlConverter = QuillDeltaToHtmlConverter;


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DeltaInsertOp_1 = __webpack_require__(308);
	var array_1 = __webpack_require__(110);
	var group_types_1 = __webpack_require__(109);
	var Grouper = (function () {
	    function Grouper() {
	    }
	    Grouper.pairOpsWithTheirBlock = function (ops) {
	        var result = [];
	        var canBeInBlock = function (op) {
	            return !(op.isJustNewline() || op.isVideo() || op.isContainerBlock());
	        };
	        var isInlineData = function (op) { return op.isInline(); };
	        var lastInd = ops.length - 1;
	        var opsSlice;
	        for (var i = lastInd; i >= 0; i--) {
	            var op = ops[i];
	            if (op.isVideo()) {
	                result.push(new group_types_1.VideoItem(op));
	            }
	            else if (op.isContainerBlock()) {
	                opsSlice = array_1.sliceFromReverseWhile(ops, i - 1, canBeInBlock);
	                result.push(new group_types_1.BlockGroup(op, opsSlice.elements));
	                i = opsSlice.sliceStartsAt > -1 ? opsSlice.sliceStartsAt : i;
	            }
	            else {
	                opsSlice = array_1.sliceFromReverseWhile(ops, i - 1, isInlineData);
	                result.push(new group_types_1.InlineGroup(opsSlice.elements.concat(op)));
	                i = opsSlice.sliceStartsAt > -1 ? opsSlice.sliceStartsAt : i;
	            }
	        }
	        result.reverse();
	        return result;
	    };
	    Grouper.groupConsecutiveSameStyleBlocks = function (groups, blocksOf) {
	        if (blocksOf === void 0) { blocksOf = {
	            header: true,
	            codeBlocks: true,
	            blockquotes: true
	        }; }
	        return array_1.groupConsecutiveElementsWhile(groups, function (g, gPrev) {
	            if (!(g instanceof group_types_1.BlockGroup) || !(gPrev instanceof group_types_1.BlockGroup)) {
	                return false;
	            }
	            return blocksOf.codeBlocks && Grouper.areBothCodeblocks(g, gPrev)
	                || blocksOf.blockquotes && Grouper.areBothBlockquotesWithSameAdi(g, gPrev)
	                || blocksOf.header && Grouper.areBothSameHeadersWithSameAdi(g, gPrev);
	        });
	    };
	    Grouper.reduceConsecutiveSameStyleBlocksToOne = function (groups) {
	        var newLineOp = DeltaInsertOp_1.DeltaInsertOp.createNewLineOp();
	        return groups.map(function (elm) {
	            if (!Array.isArray(elm)) {
	                if (elm instanceof group_types_1.BlockGroup && !elm.ops.length) {
	                    elm.ops.push(newLineOp);
	                }
	                return elm;
	            }
	            var groupsLastInd = elm.length - 1;
	            elm[0].ops = array_1.flatten(elm.map(function (g, i) {
	                if (!g.ops.length) {
	                    return [newLineOp];
	                }
	                return g.ops.concat(i < groupsLastInd ? [newLineOp] : []);
	            }));
	            return elm[0];
	        });
	    };
	    Grouper.areBothCodeblocks = function (g1, gOther) {
	        return g1.op.isCodeBlock() && gOther.op.isCodeBlock();
	    };
	    Grouper.areBothSameHeadersWithSameAdi = function (g1, gOther) {
	        return g1.op.isSameHeaderAs(gOther.op) && g1.op.hasSameAdiAs(gOther.op);
	    };
	    Grouper.areBothBlockquotesWithSameAdi = function (g, gOther) {
	        return g.op.isBlockquote() && gOther.op.isBlockquote()
	            && g.op.hasSameAdiAs(gOther.op);
	    };
	    return Grouper;
	}());
	exports.Grouper = Grouper;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var group_types_1 = __webpack_require__(109);
	var array_1 = __webpack_require__(110);
	var ListNester = (function () {
	    function ListNester() {
	    }
	    ListNester.prototype.nest = function (groups) {
	        var _this = this;
	        var listBlocked = this.convertListBlocksToListGroups(groups);
	        var groupedByListGroups = this.groupConsecutiveListGroups(listBlocked);
	        var nested = array_1.flatten(groupedByListGroups.map(function (group) {
	            if (!Array.isArray(group)) {
	                return group;
	            }
	            return _this.nestListSection(group);
	        }));
	        var groupRootLists = array_1.groupConsecutiveElementsWhile(nested, function (curr, prev) {
	            if (!(curr instanceof group_types_1.ListGroup && prev instanceof group_types_1.ListGroup)) {
	                return false;
	            }
	            return curr.items[0].item.op.isSameListAs(prev.items[0].item.op);
	        });
	        return groupRootLists.map(function (v) {
	            if (!Array.isArray(v)) {
	                return v;
	            }
	            var litems = v.map(function (g) { return g.items; });
	            return new group_types_1.ListGroup(array_1.flatten(litems));
	        });
	    };
	    ListNester.prototype.convertListBlocksToListGroups = function (items) {
	        var grouped = array_1.groupConsecutiveElementsWhile(items, function (g, gPrev) {
	            return g instanceof group_types_1.BlockGroup && gPrev instanceof group_types_1.BlockGroup
	                && g.op.isList() && gPrev.op.isList() && g.op.isSameListAs(gPrev.op)
	                && g.op.hasSameIndentationAs(gPrev.op);
	        });
	        return grouped.map(function (item) {
	            if (!Array.isArray(item)) {
	                if (item instanceof group_types_1.BlockGroup && item.op.isList()) {
	                    return new group_types_1.ListGroup([new group_types_1.ListItem(item)]);
	                }
	                return item;
	            }
	            return new group_types_1.ListGroup(item.map(function (g) { return new group_types_1.ListItem(g); }));
	        });
	    };
	    ListNester.prototype.groupConsecutiveListGroups = function (items) {
	        return array_1.groupConsecutiveElementsWhile(items, function (curr, prev) {
	            return curr instanceof group_types_1.ListGroup && prev instanceof group_types_1.ListGroup;
	        });
	    };
	    ListNester.prototype.nestListSection = function (sectionItems) {
	        var _this = this;
	        var indentGroups = this.groupByIndent(sectionItems);
	        Object.keys(indentGroups).map(Number).sort().reverse().forEach(function (indent) {
	            indentGroups[indent].forEach(function (lg) {
	                var idx = sectionItems.indexOf(lg);
	                if (_this.placeUnderParent(lg, sectionItems.slice(0, idx))) {
	                    sectionItems.splice(idx, 1);
	                }
	            });
	        });
	        return sectionItems;
	    };
	    ListNester.prototype.groupByIndent = function (items) {
	        return items.reduce(function (pv, cv) {
	            var indent = cv.items[0].item.op.attributes.indent;
	            if (indent) {
	                pv[indent] = pv[indent] || [];
	                pv[indent].push(cv);
	            }
	            return pv;
	        }, {});
	    };
	    ListNester.prototype.placeUnderParent = function (target, items) {
	        for (var i = items.length - 1; i >= 0; i--) {
	            var elm = items[i];
	            if (target.items[0].item.op.hasHigherIndentThan(elm.items[0].item.op)) {
	                var parent = elm.items[elm.items.length - 1];
	                if (parent.innerList) {
	                    parent.innerList.items = parent.innerList.items.concat(target.items);
	                }
	                else {
	                    parent.innerList = target;
	                }
	                return true;
	            }
	        }
	        return false;
	    };
	    return ListNester;
	}());
	exports.ListNester = ListNester;


/***/ },
/* 634 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function tokenizeWithNewLines(str) {
	    var NewLine = "\n";
	    if (str === NewLine) {
	        return [str];
	    }
	    var lines = str.split(NewLine);
	    if (lines.length === 1) {
	        return lines;
	    }
	    var lastIndex = lines.length - 1;
	    return lines.reduce(function (pv, line, ind) {
	        if (ind !== lastIndex) {
	            if (line !== "") {
	                pv = pv.concat(line, NewLine);
	            }
	            else {
	                pv.push(NewLine);
	            }
	        }
	        else if (line !== "") {
	            pv.push(line);
	        }
	        return pv;
	    }, []);
	}
	exports.tokenizeWithNewLines = tokenizeWithNewLines;
	;


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var url = __webpack_require__(112);
	var MentionSanitizer = (function () {
	    function MentionSanitizer() {
	    }
	    MentionSanitizer.sanitize = function (dirtyObj) {
	        var cleanObj = {};
	        if (!dirtyObj || typeof dirtyObj !== 'object') {
	            return cleanObj;
	        }
	        if (dirtyObj.class && MentionSanitizer.IsValidClass(dirtyObj.class)) {
	            cleanObj.class = dirtyObj.class;
	        }
	        if (dirtyObj.id && MentionSanitizer.IsValidId(dirtyObj.id)) {
	            cleanObj.id = dirtyObj.id;
	        }
	        if (MentionSanitizer.IsValidTarget(dirtyObj.target + '')) {
	            cleanObj.target = dirtyObj.target;
	        }
	        if (dirtyObj.avatar) {
	            cleanObj.avatar = url.sanitize(dirtyObj.avatar + '');
	        }
	        if (dirtyObj['end-point']) {
	            cleanObj['end-point'] = url.sanitize(dirtyObj['end-point'] + '');
	        }
	        if (dirtyObj.slug) {
	            cleanObj.slug = (dirtyObj.slug + '');
	        }
	        return cleanObj;
	    };
	    MentionSanitizer.IsValidClass = function (classAttr) {
	        return !!classAttr.match(/^[a-zA-Z0-9_\-]{1,500}$/i);
	    };
	    MentionSanitizer.IsValidId = function (idAttr) {
	        return !!idAttr.match(/^[a-zA-Z0-9_\-\:\.]{1,500}$/i);
	    };
	    MentionSanitizer.IsValidTarget = function (target) {
	        return ['_self', '_blank', '_parent', '_top'].indexOf(target) > -1;
	    };
	    return MentionSanitizer;
	}());
	exports.MentionSanitizer = MentionSanitizer;


/***/ },
/* 636 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var focusNode = __webpack_require__(167);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(55);
	var ExecutionEnvironment = __webpack_require__(18);
	var FallbackCompositionState = __webpack_require__(644);
	var SyntheticCompositionEvent = __webpack_require__(681);
	var SyntheticInputEvent = __webpack_require__(684);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(312);
	var ExecutionEnvironment = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(23);
	
	var camelizeStyleName = __webpack_require__(553);
	var dangerousStyleValue = __webpack_require__(690);
	var hyphenateStyleName = __webpack_require__(560);
	var memoizeStringOnly = __webpack_require__(563);
	var warning = __webpack_require__(10);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(54);
	var EventPropagators = __webpack_require__(55);
	var ExecutionEnvironment = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(26);
	var SyntheticEvent = __webpack_require__(30);
	
	var inputValueTracking = __webpack_require__(328);
	var getEventTarget = __webpack_require__(125);
	var isEventSupported = __webpack_require__(126);
	var isTextInputElement = __webpack_require__(330);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(43);
	var ExecutionEnvironment = __webpack_require__(18);
	
	var createNodesFromMarkup = __webpack_require__(556);
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(7);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 642 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(15);
	var SyntheticMouseEvent = __webpack_require__(77);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var PooledClass = __webpack_require__(37);
	
	var getTextContentAccessor = __webpack_require__(327);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(44);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(45);
	
	var instantiateReactComponent = __webpack_require__(329);
	var KeyEscapeUtils = __webpack_require__(117);
	var shouldUpdateReactComponent = __webpack_require__(127);
	var traverseAllChildren = __webpack_require__(332);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(356);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(113);
	var ReactDOMIDOperations = __webpack_require__(654);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var React = __webpack_require__(47);
	var ReactComponentEnvironment = __webpack_require__(119);
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactErrorUtils = __webpack_require__(120);
	var ReactInstanceMap = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactNodeTypes = __webpack_require__(322);
	var ReactReconciler = __webpack_require__(45);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(69);
	var invariant = __webpack_require__(7);
	var shallowEqual = __webpack_require__(100);
	var shouldUpdateReactComponent = __webpack_require__(127);
	var warning = __webpack_require__(10);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDefaultInjection = __webpack_require__(662);
	var ReactMount = __webpack_require__(321);
	var ReactReconciler = __webpack_require__(45);
	var ReactUpdates = __webpack_require__(26);
	var ReactVersion = __webpack_require__(675);
	
	var findDOMNode = __webpack_require__(691);
	var getHostComponentFromComposite = __webpack_require__(326);
	var renderSubtreeIntoContainer = __webpack_require__(698);
	var warning = __webpack_require__(10);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var AutoFocusUtils = __webpack_require__(637);
	var CSSPropertyOperations = __webpack_require__(639);
	var DOMLazyTree = __webpack_require__(43);
	var DOMNamespaces = __webpack_require__(114);
	var DOMProperty = __webpack_require__(44);
	var DOMPropertyOperations = __webpack_require__(314);
	var EventPluginHub = __webpack_require__(54);
	var EventPluginRegistry = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactDOMComponentFlags = __webpack_require__(315);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMInput = __webpack_require__(655);
	var ReactDOMOption = __webpack_require__(656);
	var ReactDOMSelect = __webpack_require__(316);
	var ReactDOMTextarea = __webpack_require__(659);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMultiChild = __webpack_require__(668);
	var ReactServerRenderingTransaction = __webpack_require__(673);
	
	var emptyFunction = __webpack_require__(24);
	var escapeTextContentForBrowser = __webpack_require__(79);
	var invariant = __webpack_require__(7);
	var isEventSupported = __webpack_require__(126);
	var shallowEqual = __webpack_require__(100);
	var inputValueTracking = __webpack_require__(328);
	var validateDOMNesting = __webpack_require__(128);
	var warning = __webpack_require__(10);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(128);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var DOMLazyTree = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 653 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var DOMPropertyOperations = __webpack_require__(314);
	var LinkedValueUtils = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(26);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var React = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMSelect = __webpack_require__(316);
	
	var warning = __webpack_require__(10);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	var getNodeForCharacterOffset = __webpack_require__(695);
	var getTextContentAccessor = __webpack_require__(327);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var DOMChildrenOperations = __webpack_require__(113);
	var DOMLazyTree = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(15);
	
	var escapeTextContentForBrowser = __webpack_require__(79);
	var invariant = __webpack_require__(7);
	var validateDOMNesting = __webpack_require__(128);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(8);
	
	var LinkedValueUtils = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(26);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactUpdates = __webpack_require__(26);
	var Transaction = __webpack_require__(78);
	
	var emptyFunction = __webpack_require__(24);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(636);
	var BeforeInputEventPlugin = __webpack_require__(638);
	var ChangeEventPlugin = __webpack_require__(640);
	var DefaultEventPluginOrder = __webpack_require__(642);
	var EnterLeaveEventPlugin = __webpack_require__(643);
	var HTMLDOMPropertyConfig = __webpack_require__(645);
	var ReactComponentBrowserEnvironment = __webpack_require__(647);
	var ReactDOMComponent = __webpack_require__(650);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactDOMEmptyComponent = __webpack_require__(652);
	var ReactDOMTreeTraversal = __webpack_require__(660);
	var ReactDOMTextComponent = __webpack_require__(658);
	var ReactDefaultBatchingStrategy = __webpack_require__(661);
	var ReactEventListener = __webpack_require__(665);
	var ReactInjection = __webpack_require__(666);
	var ReactReconcileTransaction = __webpack_require__(671);
	var SVGDOMPropertyConfig = __webpack_require__(676);
	var SelectEventPlugin = __webpack_require__(677);
	var SimpleEventPlugin = __webpack_require__(678);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 663 */
357,
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(54);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var EventListener = __webpack_require__(166);
	var ExecutionEnvironment = __webpack_require__(18);
	var PooledClass = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(26);
	
	var getEventTarget = __webpack_require__(125);
	var getUnboundedScrollPosition = __webpack_require__(558);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(44);
	var EventPluginHub = __webpack_require__(54);
	var EventPluginUtils = __webpack_require__(116);
	var ReactComponentEnvironment = __webpack_require__(119);
	var ReactEmptyComponent = __webpack_require__(317);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactHostComponent = __webpack_require__(319);
	var ReactUpdates = __webpack_require__(26);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(689);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactComponentEnvironment = __webpack_require__(119);
	var ReactInstanceMap = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactReconciler = __webpack_require__(45);
	var ReactChildReconciler = __webpack_require__(646);
	
	var emptyFunction = __webpack_require__(24);
	var flattenChildren = __webpack_require__(692);
	var invariant = __webpack_require__(7);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 670 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var CallbackQueue = __webpack_require__(313);
	var PooledClass = __webpack_require__(37);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactInputSelection = __webpack_require__(320);
	var ReactInstrumentation = __webpack_require__(23);
	var Transaction = __webpack_require__(78);
	var ReactUpdateQueue = __webpack_require__(121);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(669);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var PooledClass = __webpack_require__(37);
	var Transaction = __webpack_require__(78);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactServerUpdateQueue = __webpack_require__(674);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(121);
	
	var warning = __webpack_require__(10);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 675 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(55);
	var ExecutionEnvironment = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInputSelection = __webpack_require__(320);
	var SyntheticEvent = __webpack_require__(30);
	
	var getActiveElement = __webpack_require__(168);
	var isTextInputElement = __webpack_require__(330);
	var shallowEqual = __webpack_require__(100);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventListener = __webpack_require__(166);
	var EventPropagators = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(15);
	var SyntheticAnimationEvent = __webpack_require__(679);
	var SyntheticClipboardEvent = __webpack_require__(680);
	var SyntheticEvent = __webpack_require__(30);
	var SyntheticFocusEvent = __webpack_require__(683);
	var SyntheticKeyboardEvent = __webpack_require__(685);
	var SyntheticMouseEvent = __webpack_require__(77);
	var SyntheticDragEvent = __webpack_require__(682);
	var SyntheticTouchEvent = __webpack_require__(686);
	var SyntheticTransitionEvent = __webpack_require__(687);
	var SyntheticUIEvent = __webpack_require__(57);
	var SyntheticWheelEvent = __webpack_require__(688);
	
	var emptyFunction = __webpack_require__(24);
	var getEventCharCode = __webpack_require__(123);
	var invariant = __webpack_require__(7);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	
	var getEventCharCode = __webpack_require__(123);
	var getEventKey = __webpack_require__(693);
	var getEventModifierState = __webpack_require__(124);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	
	var getEventModifierState = __webpack_require__(124);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 689 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(312);
	var warning = __webpack_require__(10);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var ReactDOMComponentTree = __webpack_require__(15);
	var ReactInstanceMap = __webpack_require__(56);
	
	var getHostComponentFromComposite = __webpack_require__(326);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(117);
	var traverseAllChildren = __webpack_require__(332);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(356);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(123);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 694 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 695 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(18);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(79);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(321);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 699 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  padding: '0px',
	  margin: '-1px',
	  overflow: 'hidden',
	  clip: 'rect(0px, 0px, 0px, 0px)',
	  border: '0px'
	};
	module.exports = exports['default'];

/***/ },
/* 700 */
/***/ function(module, exports) {

	/** @license React v16.7.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(334);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ },
/* 702 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ },
/* 703 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ },
/* 704 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ },
/* 705 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ICON_SIZE = '64px';
	
	var Preview = function (_Component) {
	  _inherits(Preview, _Component);
	
	  function Preview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Preview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Preview.__proto__ || Object.getPrototypeOf(Preview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Preview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchImage(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.url !== nextProps.url) {
	        this.fetchImage(nextProps);
	      }
	    }
	  }, {
	    key: 'fetchImage',
	    value: function fetchImage(_ref2) {
	      var _this2 = this;
	
	      var url = _ref2.url,
	          light = _ref2.light;
	
	      if (typeof light === 'string') {
	        this.setState({ image: light });
	        return;
	      }
	      this.setState({ image: null });
	      return window.fetch('http://noembed.com/embed?url=' + url).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        if (data.thumbnail_url) {
	          var image = data.thumbnail_url.replace('height=100', 'height=480');
	          _this2.setState({ image: image });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onClick = this.props.onClick;
	      var image = this.state.image;
	
	      var flexCenter = {
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      };
	      var styles = {
	        preview: _extends({
	          width: '100%',
	          height: '100%',
	          backgroundImage: image ? 'url(' + image + ')' : undefined,
	          backgroundSize: 'cover',
	          backgroundPosition: 'center',
	          cursor: 'pointer'
	        }, flexCenter),
	        shadow: _extends({
	          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
	          borderRadius: ICON_SIZE,
	          width: ICON_SIZE,
	          height: ICON_SIZE
	        }, flexCenter),
	        playIcon: {
	          borderStyle: 'solid',
	          borderWidth: '16px 0 16px 26px',
	          borderColor: 'transparent transparent transparent white',
	          marginLeft: '7px'
	        }
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: styles.preview, className: 'react-player__preview', onClick: onClick },
	        _react2['default'].createElement(
	          'div',
	          { style: styles.shadow, className: 'react-player__shadow' },
	          _react2['default'].createElement('div', { style: styles.playIcon, className: 'react-player__play-icon' })
	        )
	      );
	    }
	  }]);
	
	  return Preview;
	}(_react.Component);
	
	exports['default'] = Preview;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _YouTube = __webpack_require__(133);
	
	var _SoundCloud = __webpack_require__(131);
	
	var _Vimeo = __webpack_require__(132);
	
	var _Facebook = __webpack_require__(337);
	
	var _Streamable = __webpack_require__(340);
	
	var _Wistia = __webpack_require__(342);
	
	var _Twitch = __webpack_require__(341);
	
	var _DailyMotion = __webpack_require__(130);
	
	var _Mixcloud = __webpack_require__(339);
	
	var _FilePlayer = __webpack_require__(338);
	
	exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = renderPreloadPlayers;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Player = __webpack_require__(129);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _YouTube = __webpack_require__(133);
	
	var _SoundCloud = __webpack_require__(131);
	
	var _Vimeo = __webpack_require__(132);
	
	var _DailyMotion = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PRELOAD_PLAYERS = [{
	  Player: _YouTube.YouTube,
	  configKey: 'youtube',
	  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
	}, {
	  Player: _SoundCloud.SoundCloud,
	  configKey: 'soundcloud',
	  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
	}, {
	  Player: _Vimeo.Vimeo,
	  configKey: 'vimeo',
	  url: 'https://vimeo.com/300970506'
	}, {
	  Player: _DailyMotion.DailyMotion,
	  configKey: 'dailymotion',
	  url: 'http://www.dailymotion.com/video/xqdpyk'
	}];
	
	function renderPreloadPlayers(url, config) {
	  var players = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var player = _step.value;
	
	      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
	        players.push(_react2['default'].createElement(_Player2['default'], {
	          key: player.Player.displayName,
	          activePlayer: player.Player,
	          url: player.url,
	          playing: true,
	          muted: true,
	          style: { display: 'none' }
	        }));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return players;
	}

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(144));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _PropTypes = __webpack_require__(345);
	
	var _warning = _interopRequireDefault(__webpack_require__(134));
	
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(83));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(84));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(343));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(718));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(711));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(712));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(713));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(714));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(139);
	
	var _wrapMapToProps = __webpack_require__(344);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(344);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(83));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(346));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(84));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(715));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(20);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(134));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 716 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 717 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 718 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(41);
	
	var _Router = __webpack_require__(135);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(41);
	
	var _Router = __webpack_require__(135);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(730);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(348);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(347);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(731);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(732);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(733);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(734);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(350);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(137);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(736);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(41);
	
	var _Router = __webpack_require__(136);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(41);
	
	var _generatePath = __webpack_require__(350);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(41);
	
	var _Router = __webpack_require__(136);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(33);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(137);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 735 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(735);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(349);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(739).enable();
	  window.Promise = __webpack_require__(738);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(740);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(8);


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(351);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(351);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 740 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(66);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(138);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(66);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ },
/* 743 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(745);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(138);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(743);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(352);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(525);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(66);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(747);
	
	var _dots = __webpack_require__(742);
	
	var _arrows = __webpack_require__(741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(353);
	
	var _helpers = __webpack_require__(138);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(744);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(577);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(352);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(523);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(547);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(66);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(530);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(532);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(534);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(533);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(29);
	
	var _PropTypes = __webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(524);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(14);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(750);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(751);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 750 */
71,
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 752 */
117,
/* 753 */
[796, 58],
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(753);
	var ReactElement = __webpack_require__(48);
	
	var emptyFunction = __webpack_require__(24);
	var traverseAllChildren = __webpack_require__(763);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(48);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(48),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(306);
	
	module.exports = factory(isValidElement);

/***/ },
/* 757 */
675,
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(355),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(48),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(358);
	var factory = __webpack_require__(161);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 759 */
694,
/* 760 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var ReactElement = __webpack_require__(48);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var ReactCurrentOwner = __webpack_require__(31);
	var REACT_ELEMENT_TYPE = __webpack_require__(357);
	
	var getIteratorFn = __webpack_require__(759);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(752);
	var warning = __webpack_require__(10);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 764 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(360);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 766 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(361);
	
	var _isPlainObject = __webpack_require__(179);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(362);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 768 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(i){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(576)], __WEBPACK_AMD_DEFINE_FACTORY__ = (i), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(304);
	var debug = __webpack_require__(82)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 771 */
[795, 772],
/* 772 */
542,
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(777);
	var isBuf = __webpack_require__(366);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 774 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(776);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(778);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 777 */
568,
/* 778 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 779 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(781);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(59)(module)))

/***/ },
/* 781 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 782 */
/***/ function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ },
/* 783 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD2CAYAAAD/LppGAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAADyCAAA8ggHyGopsAAAAB3RJTUUH4wUCFwwktzKaXwAABKNJREFUeNrt3TFOw0AQQNFJaLhpzgQX5AihIhQ0CFFaAs9//wTROs+zkpP1jBq9zGNe5mEhml0sQQT5926uO+jajRx20BVBDjvoiiCHHXRFkMMOuiLIYQddEeSwg64IcthBVwQ57KArghx20BVBDjvoiiCHHXRFkMMOuiLIYQddEeSwg64IcthBVwQ57KArghx20BVBDjvoiiCHHXRFkMN+mq6WQLkbk4kueEx20AU77KALdthBF+wCXbALdMEu0GGHXaDDDjvogh120AU77KALdthBF+ywgy7YBbpgF+iCXaDDDrtAhx120AU77KALdthBF+ywgy7YYQddsMMOumAX6IJdoAt20AU77KALdthBF+ywgy7YYQddsMMOumCHHXTBLtAFO+gS7KALdthBF+ywgy7YYQddsMMOumCHHXTBDjvogh120AU76BLsoEuwgy7YYQddsMMOumCHHXTBDjvogh120AV7Djvogj2AHXTBHsAOumAPYAddsAewgy7YA9hBF+wB7KAL9gB20AV7ADvogj2AHXTBHsAOumAPYAddsAewgy7YA9hBF+wB7KAL9gB20AV7ADvogj2AHXTBHsAOumAPYAddsAewgy7YA9hBF+wB7KAL9gB20AV7ADvogj2A/eqbolP3hebdzclEV2Oy32fm2WQHXbBnsYMu2APYQRfsAeygC/YAdtAFewA76NqO3XN20AV7A/vllIsgFToQu1/GSYGdCOhSADvoUgA76FIAO+hSADvoUgA76FIAO+hSADvoUgA76FIAO+hSADvoUgA76FIAO+hSADvoUgA76FIg0KVt/XJgBejScuSgSwHkoEsB5KBLAeSgSwHkoEsB5KBLAeSgSwHkoEsB5KBLAeSgSwHkoEsB5KBLAeSgSwHkM3Psy9alf9mBrx8+I3LQBXkAOeiCPIAcdEEeQA66IA8gB12QB5CDLsgDyEEX5AHkoAvyAHLQBXkAOeiCPIAcdEEeQA66IA8gB12QB5CDLsgDyEEX5AHkoAvyAHLQBXkAOeiCPIAcdEEeQA66IA8gB12QB5CDLsgDyGec667/g/wOuYmu/cifIQddkEMOuiCHHHRBHkYOuiAPIAddkAeQgy7IA8hBF+QB5KAL8gBy0AV5ADnogjyAHHRBHkAOuiAPIAddkAeQgy7Ibw0DoAty0CXIQZcgB12QQw66IIccdEEOOeiCHHLQBTnkoAty0CXIQRfkkIMuyCEHXZBDDroghxx0QQ456IJcoAty0AU55KALcshBF+SQgy7IIQddkEMOuo5E/jjdZ4YcdEEu0AW5QIccctAFOeSgC3LIQRfkkIMuyCEHXZALdEEu0CGHXKBDDjnoghxy0AU55KALcshBF+QCXZALdMghF+iQQy7QIYccdEEOOeiCHHLQBTnkoAty/W1XSyDIQZcgt3VXevsOOehajh1y0LUcO+Sgazl2yEHXcuyQg67l2CE/dR6vnanbXOZtniCXiV7oMZd5nQ/IBTrskAt02CEHXW3skIOu5dghB13LsUMOupZjhxx0LccOOehajh1y0LUcO+Sgazl2yEHXsn7+GQZyaTH2M54uq0P6BBTv15sP5vldAAAAAElFTkSuQmCC"

/***/ },
/* 784 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA8CAYAAADVPrJMAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gQGEQcwM8+GGQAAA2lJREFUaN7l2k1PE0EYB/D/M2XTDyBGLY2t0QMepMaXaGKUADEmfqHlomw9dT+BnwTxBSGYGCUm2OJBDh7QVCTRu8Gh+3io3d3SfamFnZmFuWy63XTnt/9520kBDUUuVh35vNrASSlyserIpQrLpQrrggvVYAheCM6wrQMutIGpd2RbvlQLF3rBocQVwinrG/CzS6f3IT+BcCYS3HekunV/28l90vTwy88OiWkAP5LBAMhbkMvnG7lPulf2XlQnBfMKCOeiwRyulWvNfZvPPdqHIwrOUTXKDK50yio+2N7yQLP9TT0CTAAItlzNpqkrRftw7sFjwMExE7hytA/3aBbAbuqITmzLtXIjt306so+PeasAzkbDOTyXu9Z0ez73aADYW61OCo6C82DyfDRw7WgfjjA8Ahw8DNe6ezi4MAFdnNne8iBmQNhNBgMgsuXbw/VxI5L2E1+rXBbwVvqaeuxAx651Z7TEhUno4vTXzx7EbDfxeDCBQQRbvhstcaPQPpxFdzqLAfc+E0aDEwwte2/KU4LoNQjjUeBwzVnAtW4N39SFqejivfamxzwH4FcSGAQQw5brwydubNJ+4u/LU4UO+hKP6+8s4Fo30xMXpqOLt9ubnQLmwN3EEwc4Zlt+KDVyn3Sv/FmfqAmPlgGMpy1Zmdi1buzM5x7twzkKPtjfGfHwXKF9OMLw+AGOORpOcrHyKranU8yj8UeC0A1FzOP0v+f4R04HTomEZWh34+ECCBfTl6wAM9Wt623nALrKodc3pG/ejXBt+mYB0qalxNfOlGuZ2bWuBYmL4w4GGCRgy2YwqovjDvaXrBTAhVFgZAPuHUUBv/ubtwlgyg5MAk7hyk49aN4nCAwAYyAsD/wYZzwtMQBBidcEdfAG78/4N2Wlgxmoj4XA+VycbEzUBGOoVdnBhHPzwjEyGNHgfL1w/C+4Fg3ODfoowblAHzXYeHQWYKPRWYGNRWcJNhKdNdg4tAqwUWhVYGPQKsFGoFWDtaN1gLWidYG1oXWCtaB1g5WjTQArRZsCVrZzMhQYasBKkuZmeaLT4RaAU4lg6m7iWbUdJ+s6Zf8n96vt78x4mgYmwFEBVtqn5cbEEyI8igNn3aS1jd6yWaoT8FgnWEuRH0vOfrPE+60Sd1qlBZyUIlslR7ZKjq77/wVojNo7E0AIkwAAAABJRU5ErkJggg=="

/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAEgwAABIMBkak3lQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAx6SURBVHic7Z1rcBvVGYbfb1exI5uQ2JbjQBM7Fyi0bjudpgXSSIrl3CAXbkUtExgo/IAplCnQEDnQ6ag/CI6STFpunWFoaYFpmQYY7tMAtmXZSjK0aUtKS0KAWMZQ3xMgthxHu6c/7BAn+Crvnt3Nfs9Pa3XeM55nvvPt7tkVgRmTwsWRckXBw9DFdZ3J2CdWz8cJKFZPwO4ULan6nqqiHoQKeKjWt3jDuVbPyQmwWKPgW7IhRELUCKAIACBwAcs1PlisEfAtiayFoNcATDvlA5ZrXLBYw+ALRtZB4DkAU4c9QOACqFTHco0Mi3UaRcHI7QCeAjBljEO/CpVqfIF7z5EwLcfBYg3BF6i6i4CHMP7/y4UgLc6V68uQ1ROwC74lkbshsC3Lr78HTYT4UsRJWCwAxYHIHYLw4KQGIRxARlSyXAO4XixfcMPlAD0PQDVguIPC4wl11d7/sQFjORpXi1W4ZOMiRei1GOnsLzt4WYSLxZruryrwKOIfBMw1YXjXVy7XnhXmKNhuklQAcD5lMnVFlfd9xaTxbY9rxRIQQZMjXC2Xa8UCxJ0AhMkhrpXLiDMhR9KbSh7InxvIBRAwOaoIun719HmBF482NR4xOcs2uLhiAR31U38Bwgtm5xAw97gu6mZVVM01O8suuFosIKpP7e9fB+Ats5PcJpdrLzcMxRe49xyQtgdAqelhglIeFRWt8eom07MshMUapHBxpFxRkQQw3fQwF8jl8qXwJN3Jzf9RBH4EIGN6GImyjIZ4SXD9PNOzLMK1Z4XD0dOc/MA7199JwGrTwwgzBJS1uXP8L/Q1Jz81PU8yLNZppFPJv+eX+acC8EuIK1BAV0+be8mLPaldZ9SlCO6xhoeKgpHHCbhZSpqglEqZUFti6yEpeRLgHmt4RFfJh7fIuMYFACBRpkE9o3ouFmskduzQBq5xiaSkxNIzSS5eCsdg2tKNRbnH9QYAX5MU2azqFGprrP5QUp4psFjjoLBiw2xFxy6A5kiKdLxcvBSOg+54rEVTPKsAHJYUWaopoq7EXzVfUp7hsFjj5HB80zsEXAmgT1Kko+VisSZAR2JzQkBcB0CTFFmqEWqdeOOaxZogXYnY84LETTB/k+AAJMoyup6YWXnPAil5BsFX3rMgnUruyy/1d4NwmZxEmi50XHXWgu+/1HNol6w+b1KwWFnS25x8y1vqzyEyfQfqIM6Si8WaBOnmZK23zF9AwCVyEp0jF/dYk6Qr4b0bhGfkJdIcPUN1du+5WKxJE9U7jx6+ARCvycsckKu4ouo8eZkTg8Uygr2PHc/pyQtLvK8IgOYIXa+1a+XiWzoGUrAsMl3tRy2A70iMbSGFQh3x6vclZo4Ji2UwswIbizOK3gCBCyTG2k4uXgoNprXhgQ4P0aUAWiTGzha6sFXPxRXLJIqD95wvoDQAKJEY2yogKrsSsXclZg4LVyyT6EhsOajoWAl5OyIAYBaBaouCG2TtHRsRFstE2hs3v62TshrAUYmxtpCLxTKZ7voHdguFrgJwTGLsLALVFgY2fl1i5imwWBLoile/KYS4FjIehj3JLIV0y+RisSTR1RB7QZC4GYAuMbbEKrn4JrRE0qnkPm+Zv4uAVRJjzyIS10wtDb6Wbm7skBXKYkkmnUr+La90sQ6ikMRY6XKxWBbQ25xM5JX680BYLDFWqlwslkX0Nidr8sr8swB8V2KsNLm4ebcO0Znw3gYh/iw5d6ChXxwpNzOExbKUqN7Ze+RGEL0iObhEUVFjplwsltXsfez41P5jP4RAXHJyiaLCtMrFYtmAlt3b06pXWyN3oyAAYKZZcvHuBhsxo+LOGR49tw7AtyVHt2uKuvRwfNM7Rg3IFctGHIn/+oia0VaCcEBy9ExV12oKKu79hlEDslg2o23X1nZdeJZDUEpytKFy8VJoUyzaKAgYtCxyxbIpHYktBxWhrYDcjYKAQZWLxbIx7Q1b91mwURAYlKskGPlmtgOwWDbHoo2CADBTA7KWi8VyABZtFASA4mzlYrEcgkUbBYEs5eLdDQ7Coo2CAJAvgGumlfn/2pNKto/nC1QUrIqYPSvGWAjixwAutCC6QwWWtiU2/3usA8kXjMh55SFzptChCG1Ze8PWfaMdxD0WM1GKdVLfnBlY/63RDmKxmGwo1kmN+/xVC0c6gMVisqUAinhjJLlYLGYyjCgXi8VMlgG5Kjac8lAIi8UYQQF0en2oXCwWYxSnyMXXsRijOQJFLOeKxRjNDOhU7bF6FswZBuHtHMpcyxWLMY4BqZZ9Et/WyWIxBkH7TkgF8FkhYwi0L0c5vvSEVACLxUyed0nRVg6VCmCxmMmxnxS9siO+pfX0D1gsJlv2k6KHhpMKYLGY7BhVKoDFYibOfgh12OVvKB4Q3SprRowxCIECgvgVgFzJ0f9VpqiV7TWb2sY6kN/d4DAGfxPxdQAXSQ0mHICuhjobNv1vPIfzUuggBqXaCZtLNfAVxhEMkepiqcGEA8iIys5k7JOJfI0fWHUAhRdHz/ZQZieASyRHvwdt4lIBXLFsT+HF0bPV3PROYY1UoWykArhi2ZqSFevzAe1VQOovWACTlArg5t22lKxYn6/1eV4FEJQcfXCyUgEsli0pWbE+X0urrwBiieTog8LjmbRUAPdYtuMLqQgVkqMPCo8n1FV7/8dGDMY9lo04d2E0L0Paq06XCuCKZRvOXRjN689PvwJA5u8YQgBNmidTcaR2m6Gv/+YeywZYJRUEpaYoFDJaKoDFspxBqV6GBVJ5VFS0xqubzBiel0ILGSJVpdRgk6UCuHm3jNmL7vIemypeBrBUarCglEqZUFt9rMnMGK5YFjB70V3ePk/OSyAskxzdrEKraEtsPWR2EPdYkjnvsjty+6bk7DiTpQK4YknlvMvuyD3Sk/ccgNWSo6VKBXCPJY/yaI7ioedhhVQ6hdoaYtKkAngplEN5NMfn67OmUukUamus/lByLi+FpnNCKiHWyA0WH6m6UmGFVAAvheZSHs3xFaWfBbBWbrD4SPGIUHt9zBKpAF4KzaM8muMr6tsBq6Sq3fKB3NxT4aXQDL6QSlwuN9geUgEslvFYvfzZQCqAeyxjWXjLFN8Mz18AXCE5uYUUpbKjLmYLqQAWyzjKozm+6Z4dAK6UnNxCCoU64tXvS84dFRbLCE5WKpZqED4rnCzhsOo7q+BJCNlSiY/sKhXAFWtyhMOqr33+0xC4Vm7wQKNup57qdLhiZUs4rPpa5z1llVR2OfsbCb7ckA3hsOprm/8kgHVyg50hFcAVa+JYJhWanSIVwD3WxAiHVV/bgj8CuE5ycrOqk6X3/iYKV6zxMtCo/wEQlkhl1S6FbOEfaRoPJ6QSuF5y8sDOz0Z5Oz+NgivWWITDqq91wRPSpRKUkr2d2Ej4rHA0wmG1uG3+7wVwg9TcE49oOVQqgJv3UYgqxb5pT7BU2cFL4bBEleJgnyWVyqPCscvfUFisL0O+YPpRAXGjzFABNJn92LtMuMc6hahSFEg/ToSbJAcf1BVR2R2PtUjONQ2uWCchX7D3EelSEQ4Ijyd0JkkFcMU6AfkCkUdA+Ink3P3QxFIj3vlpN7hiWSfVuxBqVi/ndwJuF4uKg1UPWyDVv3KUTHAiv03jNNy8FFJxsOphAXGb5Nx/HpuiLP+85oEuyblScatYVByMPCSA2+WmYm9/f/+Kz3Zv75aaawFuXAqpOFj1oGypBLBL7/NWukEqwH0Va1Aq8VOpqQKN0MWqzmTsc6m5FuIqsYqCVZUEUSM1VCCuerU1ba9v7ZGaazGuugmdTjUeyitd/CmILpWTSPWkete212xylVSAy8QCgN7m5J680sBnIKw0M0cAO73H+9e2Nlb3mpljV1wnFgD0NjfuySsLHAWwwqSIFwvye3/QVPebPpPGtz2uFAsAelONu02pXIRnOnsOr+tO/Lbf0HEdhmvFAgYrl5FyEZ7uJO+N2L0tY8h4DsbVYgHGyUWgRzsT3lvQFNWMmpuTcb1YwKBcc/2fY6DnmvAlGCGwqbNh88+BuDB+ds6ExRqkN5XcnVfmbwWwChOSS0S7GmK/NGteToXFGkJvKrk3vyzQAmANxr7dJUjgZ50NsZiEqTkOV115Hy9FgcgVRPgTgLwRDtEI4taOROx3MuflJFisEShcsnGRIvSXAPhO++gYCXF9R0PsWSvm5RRYrFEoDN43R0HmWQAXDf7pqE7i6u762BtWzssJcI81CulUw2cz5y1/ul8c9wKUpynq6sP11XusnpcT+D9qLtD9f5J8owAAAABJRU5ErkJggg=="

/***/ },
/* 786 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAVCAYAAAAnzezqAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wEWDDo7ia4sRgAAACxJREFUSMdjFLEr/88wgICJYYDBgDtgFIyCUcA4WhCNJoJRMApGC6IRXxABAJxkBWiDgd2eAAAAAElFTkSuQmCC"

/***/ },
/* 787 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAYAAABxlTA0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wQDAA0XjUwxKAAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAACIUlEQVR42u3dy3HDMAwEUC07SCHuLyWkPxeSEuRTLhlrTOFHgFgcnYv4sgNKYws8DpZrIdsFned5qhYEgMBGmBXQsStqFmx0gV0FjW6w0dDoChsFje6w3tCogPv1+H77+e/zJz0yssFeYc6WJboFNDLgalE9sbXIWInrBWsNrUHGCtwoWEtoKTIicVfBWkFLkBGBmwXWAvouMrriRiHDCzc7rBZ6FhnE9UUeUU9dFcrj2mGZ3sq40iR/SjGI64s8urcF7zVBm94dcSVJvkrxOFiuBabXN8XiBHfB1a51WDwOs67tBtPru+bB9PqmeDC9vmvnbVrUbdpMe+ic3ru3bX+3bEywc00DM70yCyY4S4JZik3u0wbH9iDb7ACACWaLIDCLwImBucHpbJhgtggCswhM4L7AXq9KdXhUZoLZIgjMIvDamv7Sk4/M9zY4funJFtEMmPfDMgsmOGqTm9nouNnd+1UPE5xxk+vciyVrH1fRZgl77j/DEfWf7Jjet8BMsV16VZtcpxSrRtFc/YHvyt3D5ZueGR40mGLb9JoleMd+bLUmDuRQ4qoGcnREtsR12eQqtwuPa+dYLyGu6VgvKXIF6DSD6XZETjdaUYOcCTr1cFAt8kroMuNtLZAjoUsOaLZC9oQuP2LcEtkKe7sh+V7QM+htjnmIQI6q1AeVVIYuc9RONeiyh0Vlh97muLNs0Nse2LcSu9WRk97o/F1Hs3oBuTJLjwQuUesAAAAASUVORK5CYII="

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/start.3bcb938e.png";

/***/ },
/* 789 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 790 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 791 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module), (function() { return this; }())))

/***/ },
/* 793 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.dfdf4fb1.js